(function ()
{
    'use strict';

    angular
        .module('app.store.users', ['angularQFileUpload'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, msApiProvider)
    {
        // State
        var store_id = msApiProvider.getCookies('store_id');
        var error_url = msApiProvider.getErrorUrl();
        $stateProvider.state('app.store.users', {
            abstract: true,
            url     : '/users'
        })
        .state('app.store.users.list', {//用户列表
            url      : '/list',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/users/users.html',
                    controller : 'UsersController as vm'
                }
            },
            resolve: {
                Roles: function (msApi)
                {
                    var store_id = msApiProvider.getCookies('store_id');
                    return msApi.resolve('store.users.roles@get', {'store_id': store_id});
                }
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_user', 'admin_user_list'],
                    redirectTo: error_url
                }
            }
            //bodyClass: 'teachers'
        });

        // Navigation 菜单管理
        msNavigationServiceProvider.saveItem('store.users', {//用户管理组
            title : '用户管理',
            icon  : 'icon-account-outline',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('store.users.list', {//用户列表菜单
            title : '用户列表',
            icon  : 'icon-account-multiple-outline',
            state : 'app.store.users.list',
            weight: 1
        });

        //Apis
        msApiProvider.register('store.users.list', [msApiProvider.getApiUrl() + 'users']);
        msApiProvider.register('store.users.stores', [msApiProvider.getApiUrl() + 'stores']);
        msApiProvider.register('store.users.roles', [msApiProvider.getApiUrl() + 'roles']);

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.users')
        .controller('UserDialogController', UserDialogController);

    /** @ngInject */
    function UserDialogController($rootScope, $timeout, $mdDialog, $filter, User, Users, event, msApi, $cookies, role_id, $http, $qupload)
    {
        //console.log($filter("date")(new Date(), "yyyy-MM-dd HH:mm:ss"));
        var vm = this;
        // Data
        vm.title = '编辑';
        vm.user = angular.copy(User);
        vm.users = Users;
        vm.newUser = false;
        if ( !vm.user )
        {
            vm.user = {
                'id'                : '',
                'username'          : '',
                'name'              : '',
                'mobile'            : '',
                'email'             : '',
                'sex'               : '',
                'store_id'          : $cookies.get('store_id'),
                'role_id'           : role_id,
                'avatar'            : 'assets/images/avatars/profile.jpg'
            };
            vm.title = '添加';
            vm.newUser = true;
        }
        //console.log(vm.user);
        // Methods
        vm.addNewUser = addNewUser;
        vm.saveUser = saveUser;
        vm.deleteUser = deleteUser;
        vm.closeDialog = closeDialog;
        msApi.request('store.users.list@get', {'act': 'timezone'}).then(
            // Success
            function (response)
            {
                // Load new threads
                vm.timezone = response.data;
                console.log(vm.timezone);
            }
        );
        //////////

        /**
         * Add new task
         */
        function addNewUser()
        {
            var data = vm.user;
            vm.loadingThreads = true;
            //console.log(typeof angular.toJson(data));
            $http({
                method:'POST',
                url: msApi.getApiUrl('users'),
                data: data
            }).success(function(req){
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);

                vm.user.id = req.id;
                vm.users.data.unshift(req);
                closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }

        /**
         * Save task
         */
        function saveUser()
        {
            var data = vm.user;
            $http({
                method:'PUT',
                url: msApi.getApiUrl('users/' +data.id),
                data:data
            }).success(function(req){
                // Dummy save action
                for ( var i = 0; i < vm.users.data.length; i++ )
                {
                    if ( vm.users.data[i].id === vm.user.id )
                    {
                        vm.users.data[i] = angular.copy(req);
                        break;
                    }
                }
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }

        /**
         * Delete task
         */
        function deleteUser()
        {
            var confirm = $mdDialog.confirm()
                .title('删除确认操作?')
                .content('确认要删除此用户吗.')
                .ariaLabel('删除用户')
                .ok('删除')
                .cancel('取消');
                //.targetEvent(event);

            $mdDialog.show(confirm).then(function ()
            {
                angular.forEach(vm.user.StoreHasUser, function (v, k) {
                    v.id = k;
                    //v.role_id = role_id;
                });
                var data = vm.user;
                data.status = 0;
                //console.log(typeof angular.toJson(data));
                $http({
                    method:'PUT',
                    url: msApi.getApiUrl('users/' +data.id),
                    data:data,
                }).success(function(req){
                    vm.users.data.splice(vm.users.data.indexOf(vm.user), 1);
                    $rootScope.message_success = '操作成功!';
                    $timeout(function(){$rootScope.message_success = '';},5000);
                }).error(function(data) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function(){$rootScope.message_danger = '';},5000);
                });
            }, function ()
            {
                // Cancel Action
            });
        }
        
        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }


        // https://github.com/icattlecoder/angularQFileUpload
        // 七牛 文件上传 >>>>>>>>>>>>>>>>>>
        msApi.request('store.users.list@get', {'act': 'upToken'}).then(
            function (response){
                vm.upToken = response.data.upToken;
                vm.upHost  = response.data.upHost;
            });
        vm.selectFiles = [];
        var start = function (index) {
            vm.selectFiles[index].progress = {
                p: 0
            };
            vm.selectFiles[index].upload = $qupload.upload({
                key: 'avatar/'+$filter("date")(new Date(), "yyyyMMdd")+'/'+$filter("date")(new Date(), "HHmmss")+'.jpg',
                file: vm.selectFiles[index].file,
                token: vm.upToken
            });
            vm.selectFiles[index].upload.then(function (response) {
                // upload success
                //$log.info(response);
                //console.log("upload success");
                //console.log(response);
                vm.user.avatar = vm.upHost+response.key;
            }, function (response) {
                // upload failure
                //$log.info(response);
                //console.log("upload failure");
                //console.log(response);
            }, function (evt) {
                // progress
                vm.selectFiles[index].progress.p = Math.floor(100 * evt.loaded / evt.totalSize);
            });
        };
        vm.abort = function (index) {
            vm.selectFiles[index].upload.abort();
            vm.selectFiles.splice(index, 1);
        };
        vm.onFileSelect = function ($files) {
            var offsetx = vm.selectFiles.length;
            for (var i = 0; i < $files.length; i++) {
                vm.selectFiles[i + offsetx] = {
                    file: $files[i]
                };
                start(i + offsetx);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.users')
        .controller('SetStoreDialogController', SetStoreDialogController);

    /** @ngInject */
    function SetStoreDialogController($rootScope, $timeout, $mdDialog, $filter, User, Users, event, msApi, $cookies, role_id, $http, $qupload)
    {
        //console.log($filter("date")(new Date(), "yyyy-MM-dd HH:mm:ss"));
        var vm = this;
        // Data
        vm.title = '设置门店';
        vm.user = angular.copy(User);
        vm.users = Users;
        vm.selected = [];
        // 门店
        msApi.request('store.users.stores@get').then(
            function (response) {
                vm.stores = response.data;
                if (vm.user.StoreHasUser) {
                    angular.forEach(vm.user.StoreHasUser, function (v, k) {
                        for (var i = 0; i < vm.stores.length; i++) {
                            if (vm.stores[i].id == v.id) {
                                vm.selected.push(vm.stores[i]);
                                break;
                            }
                        }
                    });
                }
            });
        vm.toggle = function (item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
                angular.forEach(vm.user.StoreHasUser, function (v, k) {
                    if(v.id == item.id){
                        v.user_store_checkbox = false;
                        //v.role_id = role_id;
                        v.id = k;
                    }
                });
            }
            else {
                list.push(item);
                angular.forEach(vm.user.StoreHasUser, function (v, k) {
                    if(v.id == item.id){
                        v.user_store_checkbox = true;
                        //v.role_id = role_id;
                        v.id = k;
                    }
                });
            }
        };

        vm.exists = function (item, list) {
            return list.indexOf(item) > -1;
        };
        vm.saveUser = saveUser;
        vm.closeDialog = closeDialog;

        /**
         * Save task
         */
        function saveUser()
        {
            angular.forEach(vm.user.StoreHasUser, function (v, k) {
                v.id = k;
                //v.role_id = role_id;
            });
            if(!vm.user.StoreHasUser){
                alert('请选择门店');
            }
            var data = vm.user;
            data.role = role_id;
            $http({
                method:'PUT',
                url: msApi.getApiUrl('users/' +data.id),
                data:data
            }).success(function(req){
                vm.user = req;
                // Dummy save action
                for ( var i = 0; i < vm.users.data.length; i++ )
                {
                    if ( vm.users.data[i].id === vm.user.id )
                    {
                        vm.users.data[i] = angular.copy(vm.user);
                        break;
                    }
                }
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }

        
        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.teachers',
            [
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, msApiProvider)
    {
        var store_id = msApiProvider.getCookies('store_id');
        //console.log(msApiProvider.getCookies('store_name'));
        var error_url = msApiProvider.getErrorUrl();

        // State

        $stateProvider.state('app.store.teachers', {
            abstract: true,
            url     : '/teachers'
        })
        .state('app.store.teachers.list', {//老师列表
            url      : '/list',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/teachers/teachers.html',
                    controller : 'TeachersController as vm'
                }
            },
            resolve: {
                /*Teachers: function (msApi)
                {
                    return msApi.resolve('store.teachers.list@get', {'store_id':store_id, 'role_id': 3});
                }*/
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_teacher', 'admin_teacher_list'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'teachers'
        }).state('app.store.teachers.detail', {//课程列表
            url      : '/detail/:id',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/teachers/teacher-detail.html',
                    controller : 'TeacherDetailController as vm'
                }
            },
            resolve: {

            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_teacher', 'admin_use_cud'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'customers'
        }).state('app.store.teachers.courses', {//课程列表
            url      : '/courses',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/teachers/courses.html',
                    controller : 'TeacherCoursesController as vm'
                }
            },
            resolve: {

            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_teacher', 'admin_use_cud'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'customers'
        }).state('app.store.teachers.report', {//老师统计
            url      : '/report',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/teachers/report.html',
                    controller : 'TeachersReportController as vm'
                }
            },
            resolve  : {
                /*Teachers: function (msApi){
                 return msApi.resolve('store.reports.teachers@get', {'store_id': store_id});
                 }*/
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_report', 'admin_report_teacher_list'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'reports'

        });

        // Navigation 菜单管理
        msNavigationServiceProvider.saveItem('store.teachers', {//老师管理组
            title : '老师管理',
            icon  : 'icon-person-box',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('store.teachers.list', {//老师列表菜单
            title : '老师列表',
            icon  : 'icon-people',
            state : 'app.store.teachers.list',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('store.teachers.courses', {//老师绩效总结
            title : '老师课程明细',
            icon  : 'icon-view-dashboard',
            state : 'app.store.teachers.courses',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('store.teachers.report', {//老师绩效总结
            title : '老师绩效总结',
            icon  : 'icon-view-dashboard',
            state : 'app.store.teachers.report',
            weight: 1
        });
        //Apis

        msApiProvider.register('store.reports.teachers', [msApiProvider.getApiUrl() + 'teachers/reports']);
        msApiProvider.register('store.teachers.list', [msApiProvider.getApiUrl() + 'users']);// 老师
        msApiProvider.register('store.courses.list', [msApiProvider.getApiUrl() + 'courses']);// 课程
        msApiProvider.register('store.signups.list', [msApiProvider.getApiUrl() + 'signups']);// 报名

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.teachers')
        .controller('TeacherResetpwdController', TeacherResetpwdController);

    /** @ngInject */
    function TeacherResetpwdController($rootScope, $timeout, $mdDialog, Teacher, Teachers, msUtils, msApi, $http, $cookies)
    {
        var vm = this;
        // Data
        vm.title = '重置密码';
        vm.teacher = angular.copy(Teacher);
        vm.teachers = Teachers;
        vm.data = {
            'pwd':'',
            'confpwd':''
        };
        // Methods
        vm.saveResetPwd = function(){
            msApi.request('store.teachers.list@get', {act:'resetpwd', id: vm.teacher.id, pwd:vm.data.pwd, confpwd:vm.data.confpwd}).then(function(response){
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
            });
            closeDialog();
        }

        vm.closeDialog = closeDialog;
        //////////



        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.teachers')
        .controller('TeacherDialogController', TeacherDialogController);

    /** @ngInject */
    function TeacherDialogController($rootScope, $timeout, $mdDialog, Teacher, Teachers, msUtils, msApi, $http, $cookies)
    {
        var vm = this;
        // Data
        vm.title = '修改';
        vm.types = [
            {'name': '全职'},
            {'name': '兼职'}
            ];
        vm.teacher = angular.copy(Teacher);
        vm.teachers = Teachers;
        vm.newTeacher = false;

        if ( !vm.teacher )
        {
            vm.teacher = {
                'id'      : '',
                'name'    : '',
                'username': '',
                'avatar'  : 'assets/images/avatars/profile.jpg',
                'mobile': '',
                'email' : '',
                'skype' : '',
                'timezone':'',
                'sex': '',
                'store_id'   : $cookies.get('store_id'),
                'role_id'   : 3,
                'type': '全职'
            };

            vm.title = '新增';
            vm.newTeacher = true;
        }

        // Methods
        vm.addNewTeacher = addNewTeacher;
        vm.saveTeacher = saveTeacher;
        vm.deleteTeacher = deleteTeacher;
        vm.closeDialog = closeDialog;
        //////////
        msApi.request('store.teachers.list@get', {'act': 'timezone'}).then(
            // Success
            function (response)
            {
                // Load new threads
                vm.timezone = response.data;
                console.log(vm.timezone);
            }
        );

        /**
         * Add new contact
         */
        function addNewTeacher()
        {
            var data = vm.teacher;
            delete data['store_name'];
            delete data['sex_text'];
            delete data['avatar'];
            delete data['id'];
            //var data = angular.toJson(data)
            //console.log(typeof data);
            $http({
                method:'post',
                url: msApi.getApiUrl('users'),
                data:data/*,
                headers:{'Content-Type':'application/x-www-form-urlencoded'},
                transformRequest:function(obj){
                    //console.log(obj);
                    var str = [];
                    for(var p in obj){
                        str.push(encodeURIComponent(p) + "=" +encodeURIComponent(obj[p]));
                    }
                    return str.join("&");
                }*/
            }).success(function(req){
                vm.teacher.sex_text = vm.teacher.sex==1?'男':'女';
                vm.teacher.store_name = $cookies.get('store_name');
                vm.teacher.id = req.id;
                vm.teachers.data.unshift(vm.teacher);
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }

        /**
         * Save contact
         */
        function saveTeacher()
        {
            var data = vm.teacher;
            delete data['store_name'];
            //delete data['sex_text'];
            //delete data['avatar'];
            //console.log(typeof angular.toJson(data));
            $http({
                method:'PUT',
                url: msApi.getApiUrl('users/' +data.id),
                data:data/*,
                headers:{'Content-Type':'application/x-www-form-urlencoded'},
                transformRequest:function(obj){
                    //console.log(obj);
                    var str = [];
                    for(var p in obj){
                        str.push(encodeURIComponent(p) + "=" +encodeURIComponent(obj[p]));
                    }
                    return str.join("&");
                }*/
            }).success(function(req){
                // Dummy save action
                for ( var i = 0; i < vm.teachers.data.length; i++ )
                {
                    if ( vm.teachers.data[i].id == vm.teacher.id )
                    {
                        if(!vm.teacher.avatar){
                            vm.teacher.avatar = 'assets/images/avatars/profile.jpg';
                        }
                        vm.teacher.sex_text = vm.teacher.sex == 0 ? '女' : '男';
                        vm.teachers.data[i] = angular.copy(vm.teacher);
                        break;
                    }
                }
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data;
            });
        }

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteTeacher(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('删除确认操作?')
                .content('确认要删除此用户吗.')
                .ariaLabel('删除用户')
                .ok('删除')
                .cancel('取消');
                //.targetEvent(event);

            $mdDialog.show(confirm).then(function ()
            {
                var data = vm.teacher;
                delete data['store_name'];
                delete data['sex_text'];
                delete data['avatar'];
                data.status = 0;
                //console.log(typeof angular.toJson(data));
                $http({
                    method:'PUT',
                    url: msApi.getApiUrl('users/' +data.id),
                    data:data,
                }).success(function(req){
                    vm.teachers.data.splice(vm.teachers.data.indexOf(Teacher), 1);
                    $rootScope.message_success = '操作成功!';
                    $timeout(function(){$rootScope.message_success = '';},5000);
                }).error(function(data, state) {
                    vm.error_arr = data;
                });
            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.users')
        .controller('SetRoleDialogController', SetRoleDialogController);

    /** @ngInject */
    function SetRoleDialogController($rootScope, $timeout, $mdDialog, User, Users, event, msApi, $cookies, role_id, $http, $qupload)
    {
        //console.log($filter("date")(new Date(), "yyyy-MM-dd HH:mm:ss"));
        var vm = this;
        var store_id = $cookies.get('store_id');
        vm.store_id = store_id;
        // Data
        vm.title = '设置角色';
        vm.user = angular.copy(User);
        vm.users = Users;
        vm.selected = [];

        // 角色
        msApi.request('store.users.roles@get').then(
            function (response) {
                vm.roles = response.data;
                if (vm.user.RoleHasUser) {
                    angular.forEach(vm.user.RoleHasUser[store_id], function (v, k) {
                        for (var i = 0; i < vm.roles.length; i++) {
                            if (vm.roles[i].id == v.role_id && store_id == v.store_id) {
                                vm.selected.push(vm.roles[i]);
                                break;
                            }
                        }
                    });
                }
            });
        vm.toggle = function (item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
                angular.forEach(vm.user.RoleHasUser[store_id], function (v, k) {
                    if(v.role_id == item.id && store_id == v.store_id){
                        v.user_role_checkbox = false;
                        v.store_id = store_id;
                        v.role_id = k;
                    }
                });
            }
            else {
                list.push(item);
                angular.forEach(vm.user.RoleHasUser[store_id], function (v, k) {
                    if(v.role_id == item.id && store_id == v.store_id){
                        v.user_role_checkbox = true;
                        v.store_id = store_id;
                        v.role_id = k;
                    }
                });
            }
        };

        vm.exists = function (item, list) {
            return list.indexOf(item) > -1;
        };
        //console.log(vm.selected );
        vm.saveUser = saveUser;
        vm.closeDialog = closeDialog;

        /**
         * Save task
         */
        function saveUser()
        {
            angular.forEach(vm.user.RoleHasUser[store_id], function (v, k) {
                v.role_id = k;
                v.store_id = store_id;
            });
            if(!vm.user.RoleHasUser){
                alert('请选择角色');
            }
            var data = vm.user;
            data.store = store_id;
            $http({
                method:'PUT',
                url: msApi.getApiUrl('users/' +data.id),
                data:data
            }).success(function(req){
                vm.user = req;
                // Dummy save action
                for ( var i = 0; i < vm.users.data.length; i++ )
                {
                    if ( vm.users.data[i].id === vm.user.id )
                    {
                        vm.users.data[i] = angular.copy(vm.user);
                        break;
                    }
                }
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }
        
        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.users')
        .controller('ResetpwdDialogController', ResetpwdDialogController);

    /** @ngInject */
    function ResetpwdDialogController($rootScope, $timeout, $mdDialog, $filter, User, Users, event, msApi, $cookies, role_id, $http, $qupload)
    {
        //console.log($filter("date")(new Date(), "yyyy-MM-dd HH:mm:ss"));
        var vm = this;
        // Data
        vm.title = '重置密码';
        vm.user = angular.copy(User);
        vm.users = Users;

        vm.saveUser = saveUser;
        vm.closeDialog = closeDialog;
        vm.conf_password = ''
        //////////

        /**
         * Save task
         */
        function saveUser()
        {
            if(vm.conf_password != vm.user.password){
                $rootScope.message_success = '两次密码输入不一致';
                return false;
            }
            msApi.request("store.users.list@get", {'act':'changepwd', 'id': vm.user.id, 'password': vm.user.password}).then(
                // Success
                function (response)
                {
                    $rootScope.message_success = response.data.notice_message;
                    $timeout(function(){$rootScope.message_success = '';},5000);
                    if (response.data.status == 1)
                        closeDialog();
                }
            );
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.system', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider,msNavigationServiceProvider, $translatePartialLoaderProvider)
    {
        var store_id = msApiProvider.getCookies('store_id');
        var error_url = msApiProvider.getErrorUrl();
        $stateProvider.state('app.store.system', {
            abstract: true,
            url  : '/system'
        }).state('app.store.system.room', {
            url      : '/room',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/system/room.html',
                    controller : 'RoomController as vm'
                }
            },
            resolve  : {
            },
            bodyClass: 'plans'
        }).state('app.store.system.room.detail', {
            url: '/detail/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/store/system/dialogs/room/room-dialog.html',
                    controller: 'RoomDialogController as vm'
                }
            },
            resolve: {
                Room: function (msApi, $stateParams)//课程
                {
                    msApiProvider.register('store.system.rooms.detail', [msApiProvider.getApiUrl() + 'rooms/' + $stateParams.id]);
                    return msApi.resolve('store.system.rooms.detail@get');
                }
            },
            data: {}
        }).state('app.store.system.categories',{
            url      : '/categories',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/store/system/categories.html',
                    controller : 'CategoriesController as vm'
                }
            },
            resolve: {
                /*Categories: function (msApi)
                {
                    return msApi.resolve('store.system.categories@get',{'store_id': store_id, 'type':1});
                },*/
                CategoryTypes: function (msApi)
                {
                    return msApi.resolve('store.system.categories@get', {'act':'types'});
                }
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_system', 'admin_system_categories', 'admin_system_categories_list'],
                    redirectTo: error_url
                }
            }
        }).state('app.store.system.config',{
            url      : '/config',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/store/system/config.html',
                    controller : 'ConfigController as vm'
                }
            },
            resolve: {
                /*Configs: function (msApi)
                {
                    return msApi.resolve('store.system.configsys@get', {'act': 'get', 'store_id': store_id});
                }*/
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_system', 'admin_system_set'],
                    redirectTo: error_url
                }
            }
        }).state('app.store.system.smssendlogs',{
            url      : '/smssendlogs',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/store/system/sms-send-logs.html',
                    controller : 'SmssendlogsController as vm'
                }
            },
            resolve: {
                /*Smssendlogs: function (msApi)
                {
                    return msApi.resolve('store.system.smssendlogs@get', {'store_id': store_id});
                }*/
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_system', 'admin_system_logs'],
                    redirectTo: error_url
                }
            }
        }).state('app.store.system.smstemplates',{
            url      : '/smstemplates',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/store/system/sms-templates.html',
                    controller : 'SmstemplatesController as vm'
                }
            },
            resolve: {
                Smstemplates: function (msApi)
                {
                    return msApi.resolve('store.system.smstemplates@get');
                }
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_system', 'admin_system_logs'],
                    redirectTo: error_url
                }
            }
        }).state('app.store.system.wechatsendlogs',{
            url      : '/wechatsendlogs',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/store/system/wechat-send-logs.html',
                    controller : 'WechatsendlogsController as vm'
                }
            },
            resolve: {
                Wechatsendlogs: function (msApi)
                {
                    var store_id = msApiProvider.getCookies('store_id');
                    return msApi.resolve('store.system.wechatsendlogs@get', {'store_id': store_id});
                }
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_system', 'admin_system_logs'],
                    redirectTo: error_url
                }
            }
        }).state('app.store.system.setstore',{
            url      : '/setstore',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/store/system/setstore.html',
                    controller : 'SetStoreController as vm'
                }
            },
            resolve: {
                Store: function (msApi)
                {
                    var store_id = msApiProvider.getCookies('store_id');
                    msApiProvider.register('store.courses.stores', [msApiProvider.getApiUrl() + 'stores/'+store_id]);

                    return msApi.resolve('store.courses.stores@get');
                    //return msApi.resolve('store.system.store@get');
                }
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_system', 'admin_system_set', 'admin_store', 'admin_store_cud'],
                    redirectTo: error_url
                }
            }
        }).state('app.store.system.ctime',{
            url      : '/setctime',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/store/system/ctime.html',
                    controller : 'CtimeController as vm'
                }
            },
            resolve: {
                Store: function (msApi)
                {
                    var store_id = msApiProvider.getCookies('store_id');
                    msApiProvider.register('store.courses.stores', [msApiProvider.getApiUrl() + 'stores/'+store_id]);
                    return msApi.resolve('store.courses.stores@get');
                    //return msApi.resolve('store.system.store@get');
                }
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_system', 'admin_system_set', 'admin_store', 'admin_store_cud'],
                    redirectTo: error_url
                }
            }
        }).state('app.store.system.ctime.dialog', {
            url: '/detail/:index',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/store/system/dialogs/ctime/ctime-dialog.html',
                    controller: 'CtimeDialogController as vm'
                }
            },
            resolve: {
            },
            data: {}
        }).state('app.store.system.wechattemp',{
            url      : '/wechat-temp',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/store/system/wechat-temp.html',
                    controller : 'WechatTempController as vm'
                }
            },
            resolve: {
                Store: function (msApi)
                {
                    var store_id = msApiProvider.getCookies('store_id');
                    msApiProvider.register('store.courses.stores', [msApiProvider.getApiUrl() + 'stores/'+store_id]);

                    return msApi.resolve('store.courses.stores@get');
                    //return msApi.resolve('store.system.store@get');
                }
            }, /*data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_system', 'admin_system_set', 'admin_store', 'admin_store_cud'],
                    redirectTo: error_url
                }
            }*/
        }).state('app.store.system.onduty', {
            url      : '/onduty',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/system/onduty.html',
                    controller : 'OndutyController as vm'
                }
            },
            //bodyClass: 'calendar'
        });;
        //$translatePartialLoaderProvider.addPart('app/main/apps/calendar');
        // Api
        msApiProvider.register('store.system.configsys', [msApiProvider.getApiUrl() + 'configsys']);
        msApiProvider.register('store.system.rooms', [msApiProvider.getApiUrl() + 'rooms']);
        msApiProvider.register('store.system.roles', [msApiProvider.getApiUrl() + 'roles']);
        msApiProvider.register('store.system.categories', [msApiProvider.getApiUrl() + 'categories']);
        msApiProvider.register('store.system.smssendlogs', [msApiProvider.getApiUrl() + 'smssendlogs']);
        msApiProvider.register('store.system.smstemplates', [msApiProvider.getApiUrl() + 'smstemplates']);
        msApiProvider.register('store.system.users', [msApiProvider.getApiUrl() + 'users']);
        msApiProvider.register('store.system.wechatsendlogs', [msApiProvider.getApiUrl() + 'wechatsendlogs']);
        msApiProvider.register('store.system.stores', [msApiProvider.getApiUrl() + 'stores']);
        msApiProvider.register('store.system.kuadians', [msApiProvider.getApiUrl() + 'kudiankeshus']);
        msApiProvider.register('store.system.ondutys', [msApiProvider.getApiUrl() + 'ondutys']);
        // Navigation 系统管理
        msNavigationServiceProvider.saveItem('store.system', {//系统管理组
            title : '系统管理',
            icon  : 'icon-cog',
            weight: 3
        });
        msNavigationServiceProvider.saveItem('store.system.room', {//分类列表菜单
            title : '房间管理',
            icon  : 'icon-view-dashboard',
            state : 'app.store.system.room',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('store.system.ctime', {//分类列表菜单
            title : '开课时间管理',
            icon  : 'icon-view-dashboard',
            state : 'app.store.system.ctime',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('store.system.categories', {//分类列表菜单
            title : '分类管理',
            icon  : 'icon-view-dashboard',
            state : 'app.store.system.categories',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('store.system.onduty', {
            title : '值班表',
            icon  : 'icon-calendar-today',
            state : 'app.store.system.onduty',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('store.system.config', {//系统配置菜单
            title : '系统配置',
            icon  : 'icon-monitor',
            state : 'app.store.system.config',
            weight: 2
        });
        msNavigationServiceProvider.saveItem('store.system.smssendlogs', {//系统配置菜单
            title : '短信发送日志',
            icon  : 'icon-timetable',
            state : 'app.store.system.smssendlogs',
            weight: 2
        });
        msNavigationServiceProvider.saveItem('store.system.smstemplates', {//系统配置菜单
            title : '短信模板',
            icon  : 'icon-content-copy',
            state : 'app.store.system.smstemplates',
            weight: 2
        });

        msNavigationServiceProvider.saveItem('store.system.wechatsendlogs', {//系统配置菜单
            title : '微信发送日志',
            icon  : 'icon-timetable',
            state : 'app.store.system.wechatsendlogs',
            weight: 2
        });
        msNavigationServiceProvider.saveItem('store.system.wechattemp', {//系统配置菜单
            title : '微信模板消息',
            icon  : 'icon-content-copy',
            state : 'app.store.system.wechattemp',
            weight: 2
        });
        msNavigationServiceProvider.saveItem('store.system.setstore', {//系统配置菜单
            /*title : '系统配置',
            icon  : 'icon-monitor',
            state : 'app.store.system.config',
            weight: 2*/
        });
    }

})();
(function () {
    'use strict';

    angular
        .module('app.store.system')
        .controller('KuadianDialogController', KuadianDialogController);

    /** @ngInject */
    function KuadianDialogController($rootScope, $timeout, $mdDialog, $filter, Categorie, Categories, type, is_kd, event, msApi, $http, $cookies) {
        var vm = this;
        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00') return new Date(str);
        }

        // Data
        vm.title = '跨店设置';
        vm.is_kd = is_kd;
        //合同
        vm.categories = Categorie;
        //vm.contract = angular.copy(Contract);
        vm.categorie = Categorie;
        //console.log(vm.customers);
        vm.type = type
        vm.selected = [];

        var store_id = $cookies.get('store_id');
        var store_city = $cookies.get('store_city');
        vm.closeDialog = closeDialog;
        vm.save = save;

        //所有门店
        msApi.request('store.system.stores@get', {'city': store_city, 'noid': store_id}).then(
            function (response) {
                vm.stores = response.data;
                msApi.request('store.system.kuadians@get', {'categories_id': vm.categorie.id, 'store_id': store_id}).then(
                    function (res) {
                        if (res.data) {
                            vm.kuadians = [];
                            angular.forEach(res.data, function (v, k) {
                                vm.kuadians[v.to_store_id] = v;
                            });
                            angular.forEach(vm.kuadians, function (v, k) {
                                for (var i = 0; i < vm.stores.length; i++) {
                                    if (vm.stores[i].id == v.to_store_id) {
                                        vm.selected.push(vm.stores[i]);
                                        break;
                                    }
                                }
                            });
                        }
                });

            });

        function save() {
            angular.forEach(vm.kuadians, function (v, k) {
                v.categories_id = vm.categorie.id;
                v.store_id = store_id;
            });
            if(vm.kuadians.length ==0){
                alert('请选择门店');
                return false;
            }
            vm.categorie.kuadians = vm.kuadians;
            vm.categorie.type = vm.categorie.type+'';
            var data = vm.categorie;
            $http({
                method:'PUT',
                url: msApi.getApiUrl('categories/' +data.id),
                data:data
            }).success(function(req){
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }
        function closeDialog() {
            $mdDialog.hide().then(function(){
            });
        }
        vm.toggle = function (item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
                angular.forEach(vm.kuadians, function (v, k) {
                    if(v.to_store_id == item.id){
                        v.store_checkbox = false;
                    }
                });
            }
            else {
                list.push(item);
                angular.forEach(vm.kuadians, function (v, k) {
                    if(v.to_store_id == item.id){
                        v.store_checkbox = true;
                    }
                });
            }
        };

        vm.exists = function (item, list) {
            return list.indexOf(item) > -1;
        };
    }
})();
/**
 * Created by guyue on 2019/10/14.
 */
(function () {
    'use strict';

    angular
        .module('app.store.system')
        .controller('RoomDialogController', RoomDialogController);

    /** @ngInject */
    function RoomDialogController($rootScope, $timeout, $mdDialog, $filter,  event, msApi, $cookies, $http, Rooms, Room) {
        var vm = this;
        vm.title = '编辑';
        vm.rooms = Rooms;
        vm.room = Room;
        var store_id = $cookies.get('store_id');

        vm.newRoom = false;
        if (!vm.room) {
            vm.room = {
                'id': '',
                'store_id': store_id,
                'name': '',
                'status': 1,
            };
            vm.title = '添加';
            vm.newRoom = true;
        } else {
        }

        // Methods
        vm.closeDialog = closeDialog;
        function closeDialog() {
            $mdDialog.hide().then(function(){
            });
        }
        //////////

        /**
         * Add new task
         */
        vm.addNewRoom = addNewRoom;
        function addNewRoom() {
            var data = angular.copy(vm.room);
            //console.log(typeof angular.toJson(data));
            $http({
                method: 'POST',
                url: msApi.getApiUrl('rooms'),
                data: data
            }).success(function (req) {
                vm.room.id = req.id;
                if (vm.rooms){
                  vm.rooms.push(vm.room);
                }


                $rootScope.message_success = '操作成功!';
                $timeout(function () {
                    $rootScope.message_success = '';
                }, 5000);
                closeDialog();
            }).error(function (data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function () {
                    $rootScope.message_danger = '';
                }, 5000);
            });
        }

        /**
         * Save task
         */
        vm.saveRoom = saveRoom;
        function saveRoom() {
            //console.log(typeof angular.toJson(data));
            var data = angular.copy(vm.room);
            $http({
                method: 'PUT',
                url: msApi.getApiUrl('rooms/' + data.id),
                data: data
            }).success(function (req) {
                // Dummy save action
                for (var i = 0; i < vm.rooms.length; i++) {
                    if (vm.rooms[i].id === vm.room.id) {
                        vm.rooms[i] = angular.copy(vm.room);
                        break;
                    }
                }
                $rootScope.message_success = '操作成功!';
                $timeout(function () {
                    $rootScope.message_success = '';
                }, 5000);
                closeDialog();
            }).error(function (data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function () {
                    $rootScope.message_danger = '';
                }, 5000);
            });
        }
        vm.onFileSelect = function ($files) {
            var offsetx = vm.selectFiles.length;
            for (var i = 0; i < $files.length; i++) {
                vm.selectFiles[i + offsetx] = {
                    file: $files[i]
                };
                start(i + offsetx);
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular.module('app.store.system')
    .controller('EventFormDialogController', EventFormDialogController);

    /** @ngInject */
    function EventFormDialogController($mdDialog, dialogData, $cookies, msApi, $http, $rootScope, $timeout)
    {
        var vm = this;
        vm.curr_user = $cookies.getObject('curr_user');
        var store_id = $cookies.get('store_id');
        // Data
        vm.dialogData = dialogData;
        vm.notifications = ['15 minutes before', '30 minutes before', '1 hour before'];

        // Methods
        vm.saveEvent = saveEvent;
        vm.removeEvent = removeEvent;
        vm.closeDialog = closeDialog;
        vm.onduty = {number:0,date: vm.dialogData.start.format("YYYY-MM-DD"), store_id: store_id, creater:vm.curr_user.id};
        init();

        //老师
        msApi.resolve('store.users.list@get', {
            status:10,
            store_id: store_id,
            role_id: 3,
        }).then(function(users){
            vm.teachers = users.data;
        });
        //前台
        msApi.resolve('store.users.list@get', {
            status:10,
            store_id: store_id,
            role_id: 4,
        }).then(function(users){
            vm.qiantais = users.data;
        });
        //销售
        msApi.resolve('store.users.list@get', {
            status:10,
            store_id: store_id,
            role_id: 5,
        }).then(function(users){
            vm.xiaoshous = users.data;
        });
        /**
         * Initialize
         */
        function init()
        {

            // Figure out the title
            switch ( vm.dialogData.type )
            {
                case 'add' :
                    vm.dialogTitle = 'Add Event';
                    break;

                case 'edit' :
                    vm.dialogTitle = 'Add Event';
                    break;

                default:
                    break;
            }

            // Edit
            if ( vm.dialogData.calendarEvent )
            {
                // Clone the calendarEvent object before doing anything
                // to make sure we are not going to brake FullCalendar
                vm.calendarEvent = angular.copy(vm.dialogData.calendarEvent);

                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.calendarEvent.start) )
                {
                    vm.calendarEvent.start = vm.calendarEvent.start.toDate();
                }

                if ( moment.isMoment(vm.calendarEvent.end) )
                {
                    vm.calendarEvent.end = vm.calendarEvent.end.toDate();
                }
            }
            // Add
            else
            {
                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.dialogData.start) )
                {
                    vm.dialogData.start = vm.dialogData.start.toDate();
                }

                if ( moment.isMoment(vm.dialogData.end) )
                {
                    vm.dialogData.end = vm.dialogData.end.toDate();
                }

                vm.calendarEvent = {
                    start        : vm.dialogData.start,
                    end          : vm.dialogData.end,
                    notifications: []
                };
            }
        }

        /**
         * Save the event
         */
        function saveEvent() {
            var data = angular.copy(vm.onduty);
            var teachers = Object.keys(data.teachers);
            if(teachers.length == 0){
                alert('请选择老师');
                return false;
            }
            var xiaoshous = Object.keys(data.xiaoshous);
            if(xiaoshous.length == 0){
                alert('请选销售');
                return false;
            }
            var qiantais = Object.keys(data.qiantais);
            if(qiantais.length == 0){
                alert('请选前台');
                return false;
            }
            $http({
            method: 'POST',
            url: msApi.getApiUrl('ondutys'),
            data: angular.toJson(data)
        }).success(function (req) {
            $rootScope.message_success = '操作成功!';
            $timeout(function(){$rootScope.message_success = '';},5000);

            closeDialog();
        }).error(function(data, state) {
            vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
            $rootScope.message_danger = vm.error_arr;
            $timeout(function(){$rootScope.message_danger = '';},5000);
        });


            // Convert the javascript date objects back to the moment.js dates
            var dates = {
                start: moment.utc(vm.calendarEvent.start),
                end  : moment.utc(vm.calendarEvent.end)
            };

            var response = {
                type         : vm.dialogData.type,
                calendarEvent: angular.extend({}, vm.calendarEvent, dates)
            };

            $mdDialog.hide(response);
        }

        /**
         * Remove the event
         */
        function removeEvent()
        {
            var response = {
                type         : 'remove',
                calendarEvent: vm.calendarEvent
            };

            $mdDialog.hide(response);
        }

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store.system')
        .controller('RoleDialogController', RoleDialogController);

    /** @ngInject */
    function RoleDialogController($rootScope, $timeout, $http, $mdDialog, Role, Roles, event, msApi)
    {
        var vm = this;
        console.log(Roles);
        // Data
        vm.title = '编辑角色';
        vm.role = angular.copy(Role);
        vm.roles = Roles;
        vm.newRole = false;
        console.log(vm.roles);
        if ( !vm.role )
        {
            vm.role = {
                'id'                : '',
                'role'             : '',
                'status'             : ''
            };
            vm.title = '添加角色';
            vm.newRole = true;
        }

        // Methods
        vm.addNewRole = addNewRole;
        vm.saveRole = saveRole;
        vm.deleteRole = deleteRole;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Add new task
         */
        function addNewRole()
        {
            vm.roles.unshift(vm.role);
            msApi.request('store.system.roles@post', {'role': vm.role});
            closeDialog();
        }

        /**
         * Save task
         */
        function saveRole()
        {
            // Dummy save action
            for ( var i = 0; i < vm.roles.length; i++ )
            {
                if ( vm.roles[i].id === vm.role.id )
                {
                    vm.roles[i] = angular.copy(vm.role);
                    break;
                }
            }

            closeDialog();
        }

        /**
         * Delete task
         */
        function deleteRole()
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure?')
                .content('The Role will be deleted.')
                .ariaLabel('Delete Role')
                .ok('Delete')
                .cancel('Cancel');
                //.targetEvent(event);

            $mdDialog.show(confirm).then(function ()
            {
                // Dummy delete action
                for ( var i = 0; i < vm.roles.length; i++ )
                {
                    if ( vm.roles[i].id === vm.role.id )
                    {
                        vm.roles[i].deleted = true;
                        break;
                    }
                }
            }, function ()
            {
                // Cancel Action
            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
/**
 * Created by guyue on 2019/10/14.
 */
(function () {
    'use strict';

    angular
        .module('app.store.system')
        .controller('CtimeDialogController', CtimeDialogController);

    /** @ngInject */
    function CtimeDialogController($rootScope, $timeout, $mdDialog, $filter,  event, msApi, $cookies, $http, Ctimes, ctime) {
        var vm = this;
        var store_id = $cookies.get('store_id');
        vm.title = '编辑';
        vm.ctimes = Ctimes;
        console.log(vm.ctimes);
        vm.ctime = ctime;
        var ctimeIndex = vm.ctimes.indexOf(ctime);
        var store_id = $cookies.get('store_id');
        vm.startTime = {hour:"00",minute:"00"};
        vm.endTime = {hour:"01",minute:"00"};
        vm.hours = [];
        for(var i=0;i<24;i++){
            var h = i<10?("0"+i):(""+i)
            vm.hours.push(h);
        }
        vm.minutes = [];
        for(var i=0;i<12;i++){
            var m = i*5;
            m = m<10?"0"+m:""+m;
            vm.minutes.push(m);
        }
        vm.newCtime = false;
        if (!vm.ctime) {
            vm.ctime = '';
            vm.title = '添加';
            vm.newCtime = true;
        } else {
            var startEnd = ctime.split("~");
            var startTime = startEnd[0];
            var endTime = startEnd[1];
            var hm = startTime.split(":");
            vm.startTime.hour = hm[0];
            vm.startTime.minute = hm[1];
            hm = endTime.split(":");
            vm.endTime.hour = hm[0];
            vm.endTime.minute = hm[1];
        }

        // Methods
        vm.closeDialog = closeDialog;
        function closeDialog() {
            $mdDialog.hide().then(function(){
            });
        }
        //////////

        /**
         * Add new task
         */
        vm.addNewCtime = addNewCtime;
        function addNewCtime() {
            vm.ctime = getTimeStr();
            vm.ctimes.push(vm.ctime);
            vm.ctimes.sort();
            vm.ctimes = unique(vm.ctimes);
            vm.saveStoreCourseTimes();
            //@to-do
        }

        /**
         * Save task
         */
        vm.saveCtime = saveCtime;
        function saveCtime() {
            //console.log(typeof angular.toJson(data));
            vm.ctime = getTimeStr();
            vm.ctimes[ctimeIndex] = vm.ctime;
            vm.ctimes.sort();
            vm.ctimes = unique(vm.ctimes);
            vm.saveStoreCourseTimes();
            //@to-do
        }
        function unique(arr) {
            return arr.filter(function(item, index, arr) {
              //当前元素，在原始数组中的第一个索引==当前索引值，否则返回当前元素
              return arr.indexOf(item, 0) === index;
            });
        }
        function getTimeStr(){
            return vm.startTime.hour+":"+vm.startTime.minute+"~"+vm.endTime.hour+":"+vm.endTime.minute;
        }

        vm.saveStoreCourseTimes = saveStoreCourseTimes;
        // 保存 门店配置
        function saveStoreCourseTimes() {
            msApi.resolve('store.system.stores@get', {'act':'save_settings','id':store_id, 'ctime_list':JSON.stringify(vm.ctimes)}).then(function(response){
                if (response.data.status == 1){
                    $rootScope.message_success = '操作成功!';
                    $timeout(function(){$rootScope.message_success = '';},5000);
                }else {
                    $rootScope.message_danger = response.data.msg;
                    $timeout(function(){$rootScope.message_danger = '';},5000);
                }
                closeDialog();
            });
        }

    }
})();

(function ()
{
    'use strict';

    angular.module('app.store.system')
        .controller('EventDetailDialogController', EventDetailDialogController);

    /** @ngInject */
    function EventDetailDialogController($mdDialog, calendarEvent, showEventFormDialog, event)
    {
        var vm = this;

        // Data
        vm.calendarEvent = calendarEvent;

        // Methods
        vm.editEvent = editEvent;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Edit the calendar event
         *
         * @param calendarEvent
         */
        function editEvent(calendarEvent)
        {
            showEventFormDialog('edit', calendarEvent, false, false, event);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store.reports',
            [
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        var store_id = msApiProvider.getCookies('store_id');
        var error_url = msApiProvider.getErrorUrl();
        // State

        $stateProvider.state('app.store.reports', {
            abstract: true,
            url     : '/reports'
        }).state('app.store.reports.teachers', {//老师统计
            url      : '/teachers',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/reports/teachers.html',
                    controller : 'TeachersReportController as vm'
                }
            },
            resolve  : {
                /*Teachers: function (msApi){
                    return msApi.resolve('store.reports.teachers@get', {'store_id': store_id});
                }*/
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_report', 'admin_report_teacher_list'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'reports'

            }).state('app.store.reports.amounts', {//营业额统计
                url      : '/amounts',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/store/reports/amounts.html',
                        controller : 'AmountsReportController as vm'
                    }
                },
                resolve  : {
                },
                data: {
                    permissions: {
                        //except: ['anonymous'],
                        only:['admin_report', 'admin_report_amount_list'],
                        redirectTo: error_url
                    }
                },
                bodyClass: 'reports'

        }).state('app.store.reports.zhong', {//营业额统计
            url      : '/zhong',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/reports/zhong.html',
                    controller : 'ZhongReportController as vm'
                }
            },
            resolve  : {
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_report', 'admin_report_amount_list'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'reports'

        }).state('app.store.reports.incomes', {//其它收入
        url      : '/incomes',
        views    : {
            'content@app': {
                templateUrl: 'app/main/apps/store/reports/incomes.html',
                controller : 'IncomesReportController as vm'
            }
        },
        resolve  : {
        },
        data: {
            permissions: {
                only:['admin_report', 'admin_report_income_list'],
                redirectTo: error_url
            }
        },
        bodyClass: 'reports'

    }).state('app.store.reports.pays', {//支出
            url      : '/pays',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/reports/pays.html',
                    controller : 'PaysReportController as vm'
                }
            },
            resolve  : {
            },
            data: {
                permissions: {
                    only:['admin_report', 'admin_report_pay_list'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'reports'

        }).state('app.store.reports.xiaokes', {//销课统计
            url      : '/xiaokes',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/reports/xiaokes.html',
                    controller : 'XiaokesReportController as vm'
                }
            },
            resolve  : {
            },
            data: {
                permissions: {
                    only:['admin_report', 'admin_report_xiaoke_export'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'reports'

        }).state('app.store.reports.amountdetails', {
            url      : '/amountdetails/:date/:type',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/reports/amount-details.html',
                    controller : 'AmountDetailsController as vm'
                }
            },

            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_contract', 'admin_contract_list'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'contracts'
        }).state('app.store.reports.xiaokechart', {
            url      : '/xiaokechart',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/reports/xiaoke-chart.html',
                    controller : 'XiaokeChartController as vm'
                }
            },

            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_contract', 'admin_contract_xiaoke'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'contracts'
        }).state('app.store.reports.archive', {
            url      : '/archive',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/reports/archive.html',
                    controller : 'ArchiveController as vm'
                }
            },

            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_contract', 'admin_report_amount_list'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'contracts'
        });
        //console.log(msApiProvider.getStoreId());
        msApiProvider.register('store.reports.teachers', [msApiProvider.getApiUrl() + 'teachers/reports']);
        msApiProvider.register('store.reports.amountsdetails', [msApiProvider.getApiUrl() + 'amountarchives/details']);
        msApiProvider.register('store.reports.amounts', [msApiProvider.getApiUrl() + 'amountarchives']);
        msApiProvider.register('store.reports.incomes', [msApiProvider.getApiUrl() + 'incomes']);
        msApiProvider.register('store.reports.pays', [msApiProvider.getApiUrl() + 'pays']);
        msApiProvider.register('store.reports.xiaokes', [msApiProvider.getApiUrl() + 'xiaokearchives']);

        // Navigation 菜单管理
        msNavigationServiceProvider.saveItem('store.reports', {//报表管理
            title : '财务管理',
            icon  : 'icon-currency-usd',
            weight: 2
        });
        msNavigationServiceProvider.saveItem('store.reports.archive', {//营业额统计
            title : '营收总统计',
            icon  : 'icon-poll',
            state : 'app.store.reports.archive',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('store.reports.zhong', {//营收统计图表
            title : '营收统计图表',
            icon  : 'icon-chart-pie',
            state : 'app.store.reports.zhong',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('store.reports.xiaokechart', {//消课统计图表
            title : '消课统计图表',
            icon  : 'icon-chart-pie',
            state : 'app.store.reports.xiaokechart',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('store.reports.amounts', {//营业额统计
            title : '营业额统计',
            icon  : 'icon-poll',
            state : 'app.store.reports.amounts',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('store.reports.xiaokes', {//营业额统计
            title : '销课统计',
            icon  : 'icon-poll',
            state : 'app.store.reports.xiaokes',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('store.reports.incomes', {//其它收入
            title : '其它收入',
            icon  : 'icon-heart',
            state : 'app.store.reports.incomes',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('store.reports.pays', {//支出
            title : '支出',
            icon  : 'icon-star',
            state : 'app.store.reports.pays',
            weight: 1
        });
    }
})();
(function () {
    'use strict';

    angular
        .module('app.store.reports')
        .controller('PayDialogController', PayDialogController);

    /** @ngInject */
    function PayDialogController($rootScope, $timeout, $mdDialog, $filter, Pays, Pay, is_cud, event, msApi, $http, $cookies, $qupload) {
        var vm = this;
        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00') return new Date(str);
        }
        // Data
        vm.title = '编辑';
        vm.is_cud = is_cud;
        vm.pay = Pay;
        vm.pays = Pays;
        var store_id = $cookies.get('store_id');
        vm.curr_user = $cookies.getObject('curr_user');
        vm.newPay = false;
        if (!vm.pay) {
            vm.pay = {
                'id': '',
                'amount': '',
                'pay_type': '',
                'pay_date': new Date(),
                'income_fang': '',
                'remarks': '',
                'attach': '',
                'status': 1,
                'store_id': store_id,
                'creater_uid': vm.curr_user.id,
            };
            vm.title = '添加';
            vm.newPay = true;
        }else {
            vm.pay.pay_date = vm.StrToDate(vm.pay.pay_date);
        }

        // 支付类型
        msApi.request('store.contracts.categories@get', {'store_id': store_id, 'type': '5', 'per-page': 200}).then(
            function (response) {
                vm.pay_types = response.data;
            });
        // Methods
        vm.addNewPay = addNewPay;
        vm.savePay = savePay;
        vm.deletePay = deletePay;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Add new task
         */
        function addNewPay() {
            var str = Date.parse(new Date())+'';
            vm.pay.created_at =  str.substr(0,str.length-3);
            vm.pay.updated_at = vm.pay.created_at;
            var data = angular.copy(vm.pay);
            //data.pay_date = (data.pay_date).toISOString().slice(0,10);
            data.pay_date = $filter("date")(new Date(data.pay_date), "yyyy-MM-dd");
            $http({
                method: 'POST',
                url: msApi.getApiUrl('pays'),
                data: angular.toJson(data)
            }).success(function (req) {
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                vm.pay.id = req.id;
                vm.pays.data.unshift(req);
                closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }

        /**
         * Save task
         */
        function savePay() {
            var str = Date.parse(new Date())+'';
            vm.pay.updated_at =  str.substr(0,str.length-3);
            var data = angular.copy(vm.pay);
            //data.pay_date = (data.pay_date).toISOString().slice(0,10);
            data.pay_date = $filter("date")(new Date(data.pay_date), "yyyy-MM-dd");
            $http({
                method: 'PUT',
                url: msApi.getApiUrl('pays/' + data.id),
                data: data//angular.toJson(data)
            }).success(function (req) {
                // Dummy save action
                for (var i = 0; i < vm.pays.data.length; i++) {
                    if (vm.pays.data[i].id === vm.pay.id) {
                        vm.pays.data[i] = req;//angular.copy(vm.contract);
                        break;
                    }
                }
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                closeDialog();
            }).error(function (data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }

        /**
         * Delete task
         */
        function deletePay() {
            var confirm = $mdDialog.confirm()
                .title('删除确认操作?')
                .content('确认要删除此收入吗.')
                .ariaLabel('删除收入')
                .ok('删除')
                .cancel('取消');
                //.targetEvent(event);

            $mdDialog.show(confirm).then(function () {
                var data = vm.pay;
                data.status = 0;
                $http({
                    method: 'PUT',
                    url: msApi.getApiUrl('pays/' + data.id),
                    data: data,
                }).success(function (req) {
                    vm.pays.data.splice(vm.pays.data.indexOf(vm.pay), 1);
                    $rootScope.message_success = '操作成功!';
                    $timeout(function(){$rootScope.message_success = '';},5000);
                }).error(function(data, state) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function(){$rootScope.message_danger = '';},5000);
                });
            }, function () {
                // Cancel Action
            });
        }

        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }
        // 七牛 文件上传 >>>>>>>>>>>>>>>>>>
        msApi.request('store.users.list@get', {'act': 'upToken'}).then(
            function (response){
                vm.upToken = response.data.upToken;
                vm.upHost  = response.data.upHost;
            });
        vm.selectFiles = [];
        var start = function (index) {
            vm.selectFiles[index].progress = {
                p: 0
            };
            vm.selectFiles[index].upload = $qupload.upload({
                key: 'pay/'+$filter("date")(new Date(), "yyyyMMdd")+'/'+$filter("date")(new Date(), "HHmmss")+'.jpg',
                file: vm.selectFiles[index].file,
                token: vm.upToken
            });
            vm.selectFiles[index].upload.then(function (response) {
                // upload success
                //$log.info(response);
                //console.log("upload success");
                //console.log(response);
                vm.pay.attach = vm.upHost+response.key;
            }, function (response) {
                // upload failure
                //$log.info(response);
                //console.log("upload failure");
                //console.log(response);
            }, function (evt) {
                // progress
                vm.selectFiles[index].progress.p = Math.floor(100 * evt.loaded / evt.totalSize);
            });
        };
        vm.abort = function (index) {
            vm.selectFiles[index].upload.abort();
            vm.selectFiles.splice(index, 1);
        };
        vm.onFileSelect = function ($files) {
            var offsetx = vm.selectFiles.length;
            for (var i = 0; i < $files.length; i++) {
                vm.selectFiles[i + offsetx] = {
                    file: $files[i]
                };
                start(i + offsetx);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.system')
        .controller('CategoryDialogsController', CategoryDialogsController);

    /** @ngInject */
    function CategoryDialogsController($rootScope, $timeout, $mdDialog, Categorie, Categories, type, event, $http, msApi, $cookies)
    {
        var store_id = $cookies.get('store_id');
        var vm = this;
        vm.curr_user = $cookies.getObject('curr_user');
        vm.current_user_name = vm.curr_user.username;
        if(vm.current_user_name == 'admin' || vm.current_user_name == 'root'){
            store_id=0;
        }

        // Data
        vm.title = '编辑';
        vm.categorie = angular.copy(Categorie);
        vm.categories = Categories;
        vm.newCategorie = false;
        if ( !vm.categorie )
        {
            vm.categorie = {
                'id'                : '',
                'name'              : '',
                'type'              : type,//课程分类
                'parent_id'         : '0',
                'store_id'          : store_id,
                'status'            : 1,
                'created_by'        : '',
                'type_name'         : '课程类型',
                'store_name'        : $cookies.get('store_name')
            };
            vm.title = '添加';
            vm.newCategorie = true;
        }

        // Methods
        vm.addNewCategorie = addNewCategorie;
        vm.saveCategorie = saveCategorie;
        vm.deleteCategorie = deleteCategorie;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Add new task
         */
        function addNewCategorie()
        {

            var data = vm.categorie;
            //console.log(typeof angular.toJson(data));
            $http({
                method:'POST',
                url: msApi.getApiUrl('categories'),
                data:data
            }).success(function(req){
                vm.categorie.id = req.id;
                vm.categories.data.unshift(vm.categorie);

                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data;
            });

        }

        /**
         * Save task
         */
        function saveCategorie()
        {
            var data = vm.categorie;
            $http({
                method:'PUT',
                url: msApi.getApiUrl('categories/' +data.id),
                data:data
            }).success(function(req){
                // Dummy save action
                for ( var i = 0; i < vm.categories.data.length; i++ )
                {
                    if ( vm.categories.data[i].id === vm.categorie.id )
                    {
                        vm.categories.data[i] = angular.copy(vm.categorie);
                        break;
                    }
                }
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data;
            });

        }

        /**
         * Delete task
         */
        function deleteCategorie()
        {
            var confirm = $mdDialog.confirm()
                .title('删除确认操作?')
                .content('确认要删除此分类吗.')
                .ariaLabel('删除分类')
                .ok('删除')
                .cancel('取消');
                //.targetEvent(event);

            $mdDialog.show(confirm).then(function ()
            {
                var data = vm.categorie;
                data.status = 0;
                //console.log(typeof angular.toJson(data));
                $http({
                    method:'PUT',
                    url: msApi.getApiUrl('categories/' +data.id),
                    data:data,
                }).success(function(req){
                    vm.categories.data.splice(vm.categories.data.indexOf(vm.categorie), 1);
                    $rootScope.message_success = '操作成功!';
                    $timeout(function(){$rootScope.message_success = '';},5000);
                }).error(function(data, state) {
                    vm.error_arr = data;
                });
            }, function ()
            {
                // Cancel Action
            });
        }



        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.signups',
            [
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        var store_id = msApiProvider.getCookies('store_id');
        var error_url = msApiProvider.getErrorUrl();
        // State

        $stateProvider.state('app.store.signups', {
            abstract: true,
            url     : '/signups'
        }).state('app.store.signups.list', {//预约报名纪录报表
            url      : '/signups',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/signups/signups.html',
                    controller : 'SignupsController as vm'
                }
            },
            resolve  : {
                /*Signups: function (msApi){
                    return msApi.resolve('store.signups.list@get', {'store_id': store_id});
                }*/
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_signup', 'admin_signup_list'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'reports'

        }).state('app.store.signups.report', {//预约报名纪录报表
            url      : '/signups',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/signups/report.html',
                    controller : 'SignupsReportController as vm'
                }
            },
            resolve  : {
                /*Signups: function (msApi){
                 return msApi.resolve('store.reports.signups@get', {'store_id': store_id});
                 }*/
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_report', 'admin_report_signup_list'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'reports'

        });
        //console.log(msApiProvider.getStoreId());
        msApiProvider.register('store.signups.list', [msApiProvider.getApiUrl() + 'signups']);
        msApiProvider.register('store.signups.logs', [msApiProvider.getApiUrl() + 'signupeditlogs']);
        msApiProvider.register('store.reports.signups', [msApiProvider.getApiUrl() + 'signups']);

        // Navigation 菜单管理 ---- 临时关掉
        // msNavigationServiceProvider.saveItem('store.signups', {//预约管理
        //     title : '预约管理',
        //     icon  : 'icon-calendar-check',
        //     weight: 2
        // });
        // msNavigationServiceProvider.saveItem('store.signups.list', {//预约列表
        //     title : '预约列表',
        //     icon  : 'icon-view-dashboard',
        //     state : 'app.store.signups.list',
        //     weight: 1
        // });
        // msNavigationServiceProvider.saveItem('store.signups.report', {//预约报名纪录
        //     title : '预约报名纪录',
        //     icon  : 'icon-view-dashboard',
        //     state : 'app.store.signups.report',
        //     weight: 1
        // });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.signups')
        .controller('LogsDialogController', LogsDialogController);

    /** @ngInject */
    function LogsDialogController($rootScope, $timeout, $mdDialog, Signup, event, $scope, msApi, $http)
    {
        var vm = this;
        // Data
        vm.title = '操作记录';
        vm.signup = angular.copy(Signup);

        msApi.request("store.signups.logs@get", {'signup_id': vm.signup.id}).then(
            function (response){
                vm.logs = response.data;
            });

        vm.closeDialog = closeDialog;
        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.store.reports')
        .controller('IncomeDialogController', IncomeDialogController);

    /** @ngInject */
    function IncomeDialogController($rootScope, $timeout, $mdDialog, $filter, Incomes, Income, is_cud, event, msApi, $http, $cookies) {
        var vm = this;
        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00') return new Date(str);
        }
        // Data
        vm.title = '编辑';
        vm.is_cud = is_cud;
        vm.income = Income;
        vm.incomes = Incomes;
        var store_id = $cookies.get('store_id');
        vm.curr_user = $cookies.getObject('curr_user');

        vm.newIncome = false;
        if (!vm.income) {
            vm.income = {
                'id': '',
                'amount': '',
                'income_type': '',
                'sale_project': '',
                'sale_fang': '',
                'remarks': '',
                'income_date': new Date(),
                'status': 1,
                'store_id': store_id,
                'creater_uid':  vm.curr_user.id
            };
            vm.title = '添加';
            vm.newIncome = true;
        }else {
            vm.income.income_date = vm.StrToDate(vm.income.income_date);
        }

        // 支付类型
        msApi.request('store.contracts.categories@get', {'store_id': store_id, 'type': '5', 'per-page': 200}).then(
            function (response) {
                vm.pay_types = response.data;
            });
        // Methods
        vm.addNewIncome = addNewIncome;
        vm.saveIncome = saveIncome;
        vm.deleteIncome = deleteIncome;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Add new task
         */
        function addNewIncome() {
            var str = Date.parse(new Date())+'';
            vm.income.created_at =  str.substr(0,str.length-3);
            vm.income.updated_at = vm.income.created_at;
            var data = angular.copy(vm.income);
            //data.income_date = (data.income_date).toISOString().slice(0,10);
            data.income_date = $filter("date")(new Date(data.income_date), "yyyy-MM-dd");
            $http({
                method: 'POST',
                url: msApi.getApiUrl('incomes'),
                data: angular.toJson(data)
            }).success(function (req) {
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);

                vm.income.id = req.id;
                vm.incomes.data.unshift(req);
                closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }

        /**
         * Save task
         */
        function saveIncome() {
            var str = Date.parse(new Date())+'';
            vm.income.updated_at =  str.substr(0,str.length-3);
            var data = angular.copy(vm.income);
            data.income_date = $filter("date")(new Date(data.income_date), "yyyy-MM-dd");
            data._method = 'PUT';
            $http({
                method: 'PUT',
                url: msApi.getApiUrl('incomes/' + data.id),
                data: data//angular.toJson(data)
            }).success(function (req) {
                // Dummy save action
                for (var i = 0; i < vm.incomes.data.length; i++) {
                    if (vm.incomes.data[i].id === vm.income.id) {
                        vm.incomes.data[i] = req;//angular.copy(vm.contract);
                        break;
                    }
                }
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                closeDialog();
            }).error(function (data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }

        /**
         * Delete task
         */
        function deleteIncome() {
            var confirm = $mdDialog.confirm()
                .title('删除确认操作?')
                .content('确认要删除此收入吗.')
                .ariaLabel('删除收入')
                .ok('删除')
                .cancel('取消');
                //.targetEvent(event);

            $mdDialog.show(confirm).then(function () {
                var data = vm.income;
                data.status = 0;
                $http({
                    method: 'PUT',
                    url: msApi.getApiUrl('incomes/' + data.id),
                    data: data,
                }).success(function (req) {
                    vm.incomes.data.splice(vm.incomes.data.indexOf(vm.income), 1);
                    $rootScope.message_success = '操作成功!';
                    $timeout(function(){$rootScope.message_success = '';},5000);
                }).error(function(data, state) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function(){$rootScope.message_danger = '';},5000);
                });
            }, function () {
                // Cancel Action
            });
        }

        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.plans',['angularQFileUpload'])
        .config(config);


    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, msApiProvider)
    {
        var store_id = msApiProvider.getCookies('store_id');
        var error_url = msApiProvider.getErrorUrl();
        // State
        $stateProvider.state('app.store.plans', {
            abstract: true,
            url     : '/plan'
        }).state('app.store.plans.list', {
            url      : '/list',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/plan/plan.html',
                    controller : 'PlanController as vm'
                }
            },
            resolve  : {
            },
            bodyClass: 'plans'
        }).state('app.store.plans.detail', {//课程详情
            url: '/detail/:id',
            views: {
                'content@app': {
                    templateUrl: 'app/main/apps/store/plan/plandetail.html',
                    controller: 'PlanDetailController as vm'
                }
            },
            resolve: {
                Plan: function (msApi, $stateParams)//课程
                {
                    msApiProvider.register('store.plans.plan', [msApiProvider.getApiUrl() + 'plans/' + $stateParams.id]);

                    return msApi.resolve('store.plans.plan@get');
                }
            },
            data: {}
        });
        msApiProvider.register('store.plans.list', [msApiProvider.getApiUrl() + 'plans']);
        msApiProvider.register('store.plans.plantasks', [msApiProvider.getApiUrl() + 'plantasks']);
        // Navigation 菜单管理
        msNavigationServiceProvider.saveItem('store.plans', {//计划管理
            title : '计划管理',
            icon  : 'icon-book',
            weight: 2
        });
        msNavigationServiceProvider.saveItem('store.plans.list', {//营业额统计
            title : '计划列表',
            icon  : 'icon-timetable',
            state : 'app.store.plans.list',
            weight: 1
        });

    }
})();
/**
 * Created by guyue on 2019/10/14.
 */
(function () {
    'use strict';

    angular
        .module('app.store.plans')
        .controller('PlanImportDialogController', PlanImportDialogController);

    /** @ngInject */
    function PlanImportDialogController($rootScope, $timeout, $mdDialog, $filter,  event, msApi, $cookies, $http, Plans, Plan) {
        var vm = this;
        vm.title = '导入计划任务';
        vm.plans = Plans;
        vm.plan = Plan;
        var store_id = $cookies.get('store_id');

        vm.newPlan = false;
        if (!vm.plan) {
            vm.plan = {
                'id': '',
                'store_id': store_id,
                'title': '',
                'num': '',
                'desc': '',
                'status': 1,
                'creater': '',
            };
            vm.newPlan = true;
        } else {
        }
        // Methods
        vm.closeDialog = closeDialog;
        function closeDialog() {
            $mdDialog.hide().then(function(){
            });
        }
        //////////


        vm.onFileSelect = function ($files) {
            console.log($files);
            var formdata = new FormData();
            formdata.append('file',$files[0]);
            formdata.append('id',vm.plan.id);
            $http({
                method: 'POST',
                url: msApi.getApiUrl('../normal/import-tasks'),
                data: formdata,
                headers: {
                    'Content-Type': undefined
                }
            }).success(function (req) {
                console.log(req);
                if (req.code&&req.code=="error"){
                    vm.message = req.msg;
                    vm.messageCode = req.code;
                }else{
                    vm.message = req.msg;
                    vm.messageCode = req.code;
                }
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
            }).error(function (data, status) {
                console.log(data);
            });
        };
    }
})();

/**
 * Created by guyue on 2019/10/14.
 */
(function () {
    'use strict';

    angular
        .module('app.store.plans')
        .controller('PlanDialogController', PlanDialogController);

    /** @ngInject */
    function PlanDialogController($rootScope, $timeout, $mdDialog, $filter,  event, msApi, $cookies, $http, Plans, Plan) {
        var vm = this;
        vm.title = '编辑';
        vm.plans = Plans;
        vm.plan = Plan;
        var store_id = $cookies.get('store_id');

        vm.newPlan = false;
        if (!vm.plan) {
            vm.plan = {
                'id': '',
                'store_id': store_id,
                'title': '',
                'num': '',
                'desc': '',
                'status': 1,
                'creater': '',
            };
            vm.title = '添加';
            vm.newPlan = true;
        } else {
        }

        // Methods
        vm.closeDialog = closeDialog;
        function closeDialog() {
            $mdDialog.hide().then(function(){
            });
        }
        //////////

        /**
         * Add new task
         */
        vm.addNewPlan = addNewPlan;
        function addNewPlan() {
            var data = angular.copy(vm.plan);
            //console.log(typeof angular.toJson(data));
            $http({
                method: 'POST',
                url: msApi.getApiUrl('plans'),
                data: data
            }).success(function (req) {
                vm.plan.id = req.id;
                if (vm.plans){
                  vm.plans.push(vm.plan);
                }


                $rootScope.message_success = '操作成功!';
                $timeout(function () {
                    $rootScope.message_success = '';
                }, 5000);
                closeDialog();
            }).error(function (data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function () {
                    $rootScope.message_danger = '';
                }, 5000);
            });
        }

        /**
         * Save task
         */
        vm.savePlan = savePlan;
        function savePlan() {
            //console.log(typeof angular.toJson(data));
            var data = angular.copy(vm.plan);
            $http({
                method: 'PUT',
                url: msApi.getApiUrl('plans/' + data.id),
                data: data
            }).success(function (req) {
                // Dummy save action
                for (var i = 0; i < vm.plans.length; i++) {
                    if (vm.plans[i].id === vm.plan.id) {
                        vm.plans[i] = angular.copy(vm.plan);
                        break;
                    }
                }
                $rootScope.message_success = '操作成功!';
                $timeout(function () {
                    $rootScope.message_success = '';
                }, 5000);
                closeDialog();
            }).error(function (data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function () {
                    $rootScope.message_danger = '';
                }, 5000);
            });
        }
        vm.onFileSelect = function ($files) {
            var offsetx = vm.selectFiles.length;
            for (var i = 0; i < $files.length; i++) {
                vm.selectFiles[i + offsetx] = {
                    file: $files[i]
                };
                start(i + offsetx);
            }
        };
    }
})();

/**
 * Created by guyue on 2019/10/14.
 */
(function () {
    'use strict';

    angular
        .module('app.store.plans')
        .controller('PlanTaskDialogController', PlanTaskDialogController);

    /** @ngInject */
    function PlanTaskDialogController($rootScope, $timeout, $mdDialog, $filter,  event, msApi, $cookies, $http, Tasks, Task, Plan) {
        var vm = this;
        vm.title = '编辑';
        vm.tasks = Tasks;
        vm.plan = Plan;
        vm.task = Task;
        var store_id = $cookies.get('store_id');
        console.log(vm.tasks);
        vm.newTask = false;
        if (!vm.task) {
            vm.task = {
                'id': '',
                'store_id': store_id,
                'plan_id': vm.plan.id,
                'title': '',
                'desc': '',
                'status': 1,
                'creater': '',
            };
            vm.title = '添加';
            vm.newTask = true;
        } else {
        }

        // Methods
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Add new task
         */
        vm.addNewTask = addNewTask;
        function addNewTask() {
            var data = angular.copy(vm.task);
            //console.log(typeof angular.toJson(data));
            $http({
                method: 'POST',
                url: msApi.getApiUrl('plantasks'),
                data: data
            }).success(function (req) {
                vm.task.id = req.id;
                //console.log(vm.tasks);
                if (vm.tasks){
                  vm.tasks.push(req);
                }

                closeDialog();
                $rootScope.message_success = '操作成功!';
                $timeout(function () {
                    $rootScope.message_success = '';
                }, 5000);

            }).error(function (data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function () {
                    $rootScope.message_danger = '';
                }, 5000);
            });
        }

        /**
         * Save task
         */
        vm.saveTask = saveTask;
        function saveTask() {
            var data = angular.copy(vm.task);
            //console.log(typeof angular.toJson(data));
            $http({
                method: 'PUT',
                url: msApi.getApiUrl('plantasks/' + data.id),
                data: data
            }).success(function (req) {
                // Dummy save action

                for (var i = 0; i < vm.tasks.length; i++) {
                    if (vm.tasks[i].id === vm.task.id) {
                        vm.tasks[i] = req;
                        break;
                    }
                }
                closeDialog();
                $rootScope.message_success = '操作成功!';
                $timeout(function () {
                    $rootScope.message_success = '';
                }, 5000);
                closeDialog();
            }).error(function (data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function () {
                    $rootScope.message_danger = '';
                }, 5000);
            });
        }
        function closeDialog() {
            $mdDialog.hide().then(function(){
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store.courses',
            [
                'ui.date'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        var store_id = msApiProvider.getCookies('store_id');
        var error_url = msApiProvider.getErrorUrl();
        // State

        $stateProvider.state('app.store.courses', {
            abstract: true,
            url     : '/courses'
        })
        .state('app.store.courses.list', {//课程列表
            url      : '/list',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/courses/courses.html',
                    controller : 'CoursesController as vm'
                }
            },
            resolve  : {
                /*Courses: function (msApi){
                    return msApi.resolve('store.courses.list@get', {'store_id': store_id});
                },*/
                Store: function(msApi){
                    var store_id = msApiProvider.getCookies('store_id');
                    msApiProvider.register('store.courses.stores', [msApiProvider.getApiUrl() + 'stores/'+store_id]);

                    return msApi.resolve('store.courses.stores@get');
                }
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_courses', 'admin_courses_list'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'courses'
        }).state('app.store.courses.detail', {//课程详情
            url      : '/detail/:id',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/courses/course-detail.html',
                    controller : 'CourseDetailController as vm'
                }
            },
            resolve  : {
                Store: function(msApi){
                    var store_id = msApiProvider.getCookies('store_id');
                    msApiProvider.register('store.courses.stores', [msApiProvider.getApiUrl() + 'stores/'+store_id]);

                    return msApi.resolve('store.courses.stores@get');
                },
                Course: function (msApi,$stateParams)//课程
                {
                    msApiProvider.register('store.courses.course', [msApiProvider.getApiUrl() + 'courses/'+$stateParams.id]);

                    return msApi.resolve('store.courses.course@get');
                }
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_courses', 'admin_courses_list'],
                    redirectTo: error_url
                }
            },
                bodyClass: 'courses'
        }).state('app.store.courses.categories', {//课程分类
            url      : '/categories',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/courses/category.html',
                    controller : 'CourseCategoryController as vm'
                }
            },
            resolve  : {
                /*Categories: function (msApi){
                    return msApi.resolve('store.courses.categories@get', {'type':1, 'store_id': store_id});
                }*/
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_courses', 'admin_courses_categories', 'admin_courses_categories_list'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'courses'
        }).state('app.store.courses.experiences', {//体验管理
            url      : '/experiences',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/courses/experiences.html',
                    controller : 'CourseExperienceController as vm'
                }
            },
            resolve  : {
                /*Experiences: function (msApi){
                    return msApi.resolve('store.courses.experiences@get', {'store_id': store_id});
                }*/
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_task', 'admin_task_list'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'courses'
        }).state('app.store.courses.signup', {//预约体验课
            url      : '/signup/:task_id',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/courses/signup.html',
                    controller : 'CourseSignupController as vm'
                }
            },
            resolve  : {
                Experiences: function (msApi){
                    var store_id = msApiProvider.getCookies('store_id');
                    return msApi.resolve('store.courses.experiences@get', {'store_id': store_id});
                }
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_task', 'admin_task_cud'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'courses'
        }).state('app.store.courses.paike', {//排课
            url      : '/paike',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/courses/paike.html',
                    controller : 'CoursePaikeController as vm'
                }
            },
            resolve  : {

            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_courses'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'courses'
        }).state('app.store.courses.jiake', {//排课
            url      : '/jiake',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/courses/jiake.html',
                    controller : 'CourseJiakeController as vm'
                }
            },
            resolve  : {

            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_courses'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'courses'
        }).state('app.store.courses.task', {//排课 加学生
            url      : '/task/:customer_id',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/courses/task.html',
                    controller : 'CourseTaskController as vm'
                }
            },
            resolve  : {
                Contract:function(){ return null;}
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_courses'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'courses'
        }).state('app.store.courses.taskcontract', {//排课 加学生及合同
            url      : '/task/:customer_id/:contract_id',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/courses/task.html',
                    controller : 'CourseTaskController as vm'
                }
            },
            resolve  : {
                Contract: function (msApi,$stateParams)//合同
                {
                    msApiProvider.register('store.contracts.contract', [msApiProvider.getApiUrl() + 'contracts/'+$stateParams.contract_id]);
                    return msApi.resolve('store.contracts.contract@get');
                },
                // CourseTimes: function (msApi,$stateParams)//合同
                // {
                //     return msApi.request("store.courses.categories@get", {'store_id':store_id, 'act': 'course_time_arr'});
                // },
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_courses'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'courses'
        });
        //console.log(msApiProvider.getStoreId());
        msApiProvider.register('store.courses.rooms', [msApiProvider.getApiUrl() + 'rooms']);
        msApiProvider.register('store.courses.plans', [msApiProvider.getApiUrl() + 'plans']);
        msApiProvider.register('store.courses.tasks', [msApiProvider.getApiUrl() + 'plantasks']);
        msApiProvider.register('store.courses.taskcontract', [msApiProvider.getApiUrl() + 'plancontracttasks']);
        msApiProvider.register('store.courses.list', [msApiProvider.getApiUrl() + 'courses']);
        msApiProvider.register('store.courses.categories', [msApiProvider.getApiUrl() + 'categories']);
        msApiProvider.register('store.courses.experiences', [msApiProvider.getApiUrl() + 'tasks']);
        msApiProvider.register('store.courses.users', [msApiProvider.getApiUrl() + 'users']);
        msApiProvider.register('store.courses.signups', [msApiProvider.getApiUrl() + 'signups']);
        msApiProvider.register('store.courses.courseslogs', [msApiProvider.getApiUrl() + 'courseslogs']);
        msApiProvider.register('store.courses.coursepaikelogs', [msApiProvider.getApiUrl() + 'coursepaikelogs']);
        msApiProvider.register('store.courses.customer', [msApiProvider.getApiUrl() + 'customers']);


        // Navigation 菜单管理
        msNavigationServiceProvider.saveItem('store.courses', {//课程管理组
            title : '课程管理',
            icon  : 'icon-book',
            weight: 2
        });

        msNavigationServiceProvider.saveItem('store.courses.list', {//课程列表菜单
            title : '课程',
            icon  : 'icon-book-variant',
            state : 'app.store.courses.list',
            weight: 1
        });
        // msNavigationServiceProvider.saveItem('store.courses.paike', {//课程列表菜单
        //     title : '排课',
        //     icon  : 'icon-timetable',
        //     state : 'app.store.courses.paike',
        //     weight: 1
        // });
        /*msNavigationServiceProvider.saveItem('store.courses.jiake', {//加课
            title : '加课',
            icon  : 'icon-timetable',
            state : 'app.store.courses.jiake',
            weight: 1
        });*/
        msNavigationServiceProvider.saveItem('store.courses.task', {//加课
            title : '排课',
            icon  : 'icon-timetable',
            state : 'app.store.courses.task',
            weight: 1
        });
        /*msNavigationServiceProvider.saveItem('store.courses.categories', {//课程列表菜单
            title : '课程分类',
            icon  : 'icon-book-multiple-variant',
            state : 'app.store.courses.categories',
            weight: 2
        });*/
        msNavigationServiceProvider.saveItem('store.courses.experiences', {//体验管理菜单
            title : '体验管理',
            icon  : 'icon-heart',
            state : 'app.store.courses.experiences',
            weight: 4
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store.courses')
        .controller('TiaokDialogController', TiaokDialogController);

    /** @ngInject */
    function TiaokDialogController($rootScope, $timeout, $mdDialog, $filter, Course, Courses, is_cud, event, msApi, $cookies, $http, Store)
    {

        var vm = this;
        vm.title = '调课';
        vm.course = Course;
        vm.courses = Courses;
        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00')
                return new Date(str);
        }
        var store_id = $cookies.get('store_id');

        vm.course.course_time = vm.StrToDate(vm.course.course_time);
        msApi.request("store.courses.categories@get", {'store_id':store_id, 'act': 'course_begintime_arr'}).then(//课程开始时间
            function (response){
                vm.course_begintime_arr = response.data;
            });

        msApi.request("store.courses.categories@get", {'store_id':store_id, 'act': 'course_endtime_arr'}).then(//课程结束时间
            function (response){
                vm.course_endtime_arr = response.data;
            });
        vm.saveCourse = saveCourse;
        function saveCourse()
        {
            vm.course.update_time = $filter("date")(new Date(), "yyyy-MM-dd HH:mm:ss");
            var data = angular.copy(vm.course);
            //data.course_time = (data.course_time).toISOString().slice(0,10);
            data.course_time = $filter("date")(new Date(data.course_time), "yyyy-MM-dd");
            data.check = vm.check;
            //console.log(typeof angular.toJson(data));
            $http({
                method:'POST',
                url: msApi.getApiUrl('courses/tiaok'),
                data:data,
                headers:{'Content-Type':'application/x-www-form-urlencoded'},
                transformRequest:function(obj){
                    //console.log(obj);
                    var str = [];
                    for(var p in obj){
                        str.push(encodeURIComponent(p) + "=" +encodeURIComponent(obj[p]));
                    }
                    return str.join("&");
                }
            }).success(function(req){
                vm.course.status_text = req.status_text;
                // Dummy save action
                for ( var i = 0; i < vm.courses.data.length; i++ )
                {
                    if ( vm.courses.data[i].id === vm.course.id )
                    {
                        vm.courses.data[i] = angular.copy(vm.course);
                        break;
                    }
                }
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                vm.closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }
        vm.closeDialog = closeDialog;
        function closeDialog()
        {
            $mdDialog.hide().then(function(){
                //vm.course.course_time = (vm.course.course_time).toISOString().slice(0,10);
            });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.courses')
        .controller('ExperienceDialogController', ExperienceDialogController);

    /** @ngInject */
    function ExperienceDialogController($rootScope, $timeout, $http, $mdDialog, Experience, Experiences, is_cud, is_del, consults, pay_types, event, msApi,$cookies)
    {
        var store_id = $cookies.get('store_id');
        var vm = this;
        vm.is_cud = is_cud
        vm.is_del = is_del;
        // Data
        vm.title = '编辑';
        vm.experience = angular.copy(Experience);
        vm.consults = consults;// 销售顾问
        vm.pay_types = pay_types;// 支付类型
        vm.experiences = Experiences;
        vm.newExperience = false;
        if ( !vm.experience )
        {
            vm.experience = {
                'id'                : '',
                'customer_id'       : 0,
                'courses_id'        : 0,
                'consult_id'        : 0,
                'parent'            : '',
                'relation'          : '爸爸',
                'mobile'            : '',
                'name'              : '',
                'birthday'          : new Date(),
                'sex'               : '1',
                'apply_time'        : new Date(),
                'task_time'         : new Date(),
                'pay_type'          : '',
                'amount'            : '',
                'remarks'           : '',
                'plan_time'         : '',
                'status'            : 0,
                'source'            :'',
                'store_id'          : store_id,
                'skqk'              :{'yy':0, 'ap':0, 'pz':0, 'sk':0, 'kk': 0}
            };
            vm.title = '添加';
            vm.newExperience = true;
        }

        // Methods
        vm.addNewExperience = addNewExperience;
        vm.saveExperience = saveExperience;
        vm.deleteExperience = deleteExperience;
        vm.closeDialog = closeDialog;
        vm.checkMobile = checkMobile;
        function checkMobile(mobile){
            vm.title = '添加';
            vm.experience = {
                'id'                : '',
                'customer_id'       : 0,
                'courses_id'        : 0,
                'consult_id'        : 0,
                'parent'            : '',
                'relation'          : '爸爸',
                'mobile'            : mobile,
                'name'              : '',
                'birthday'          : new Date(),
                'sex'               : '1',
                'apply_time'        : new Date(),
                'task_time'         : new Date(),
                'pay_type'          : '',
                'amount'            : 0,
                'remarks'           : '',
                'status'            : 0,
                'plan_time'         : '',
                'source'            : '',
                'store_id'          : store_id,
                'skqk'              :{'yy':0, 'ap':0, 'pz':0, 'sk':0, 'kk': 0}
            };

            if(mobile) {
                $http.get(msApi.getApiUrl('tasks'), {params: {"mobile": mobile}}).success(function (response) {
                    //console.log (vm.parent);
                    if (response.data.length > 0) {
                        vm.experience = response.data[0];
                        vm.experience.store_id = store_id;
                    }
                });
            }
        }

        //////////

        /**
         * Add new task
         */
        function addNewExperience()
        {
            var data = vm.experience;
            //console.log(data);
            $http({
                method:'POST',
                url: msApi.getApiUrl('tasks'),
                data:data
            }).success(function(req){
                vm.experience.id = req.id;
                vm.experience.apply_time = req.apply_time;
                vm.experience.birthday_month = req.birthday_month;
                vm.experience.birthday = req.birthday;
                vm.experience.sex_text = req.sex_text;
                vm.experiences.data.unshift(vm.experience);

                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }

        /**
         * Save task
         */
        function saveExperience()
        {
            var data = vm.experience;
            //console.log(typeof angular.toJson(data));
            $http({
                method:'PUT',
                url: msApi.getApiUrl('tasks/' +data.id),
                data:data
            }).success(function(req){
                // Dummy save action
                for ( var i = 0; i < vm.experiences.data.length; i++ )
                {
                    if ( vm.experiences.data[i].id === vm.experience.id )
                    {
                        vm.experiences.data[i] = angular.copy(vm.experience);
                        break;
                    }
                }
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });

        }

        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00') return new Date(str);
        }
        vm.DateToStr = function(mDate){
            return moment(mDate).format('YYYY-MM-DD');
        }
        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
        /**
         * Delete task
         */
        function deleteExperience()
        {
            var confirm = $mdDialog.confirm()
                .title('删除确认操作?')
                .content('确认要删除此课程吗.')
                .ariaLabel('删除课程')
                .ok('删除')
                .cancel('取消');
            //.targetEvent(event);
            $mdDialog.show(confirm).then(function ()
            {
                var data = angular.copy(vm.experience);
                data.status = -1;
                $http({
                    method: 'PUT',
                    url: msApi.getApiUrl('tasks/' +data.id),
                    data: data
                }).success(function (req) {
                    vm.experiences.data.splice(vm.experiences.data.indexOf(vm.experience), 1);
                    $rootScope.message_success = '操作成功!';
                    $timeout(function () {
                        $rootScope.message_success = '';
                    }, 5000);
                }).error(function (data, state) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function () {
                        $rootScope.message_danger = '';
                    }, 5000);
                });
            }, function ()
            {
                // Cancel Action
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.courses')
        .controller('CourseDialogController', CourseDialogController);

    /** @ngInject */
    function CourseDialogController($rootScope, $timeout, $mdDialog, $filter, Course, Courses, is_cud, event, msApi, $cookies, $http, Store)
    {
        var vm = this;
        vm.is_cud = is_cud;
        vm.StrToDate = function (str) { if (str && str != '0000-00-00') return new Date(str); }
        // Data
        vm.title = '编辑';
        //vm.course = angular.copy(Course);
        vm.course = Course;
        vm.courses = Courses;
        vm.store = angular.copy(Store);
        vm.hasConflict = null;//有没有冲突的判断标记
        //console.log(vm.store);
        var store_id = $cookies.get('store_id');
        msApi.request("store.courses.users@get", {'store_id':store_id, 'role_id': 3}).then(//老师
            function (response){
                vm.teachers = response.data;
                //console.log(response.data);
            });

        msApi.request("store.courses.users@get", {'store_id':store_id, 'role_id': 6}).then(//助教
            function (response){
                vm.assistants = response.data;
            });

        msApi.request("store.courses.categories@get", {'store_id':store_id, type: 1}).then(//课程类型
            function (response){
                vm.categories = response.data;
            });

        msApi.request("store.courses.categories@get", {'store_id':store_id, type: 2}).then(//课程级别
            function (response){
                vm.jibei_types = response.data;
            });

        msApi.request("store.courses.categories@get", {'store_id':store_id, 'act': 'course_begintime_arr'}).then(//课程开始时间
            function (response){
                vm.course_begintime_arr = response.data;
            });

        msApi.request("store.courses.categories@get", {'store_id':store_id, 'act': 'course_endtime_arr'}).then(//课程结束时间
            function (response){
                vm.course_endtime_arr = response.data;
            });

        vm.newCourse = false;
        if ( !vm.course )
        {
            vm.course = {
                'id'                : '',
                'store_id'          : store_id,
                'name'              : '',
                'number'            : '',
                'content'           : '',
                'type'              : '',
                'location'          : '',
                'categories_id'     : '',
                'course_time'       : new Date(),
                'signup_count'      : 0,
                'course_size'       : '',
                'teacher_id'        : '',
                'assistant_id'      : 0,
                'created_by'        : '',
                'min_count'         :0,
                'status_text'       :'',
                'room_id':0
            };
            vm.title = '添加';
            vm.newCourse = true;
        }else {
            vm.course.course_time = vm.StrToDate(vm.course.course_time);
        }

        // Methods
        vm.addNewCourse = addNewCourse;
        vm.saveCourse = saveCourse;
        vm.deleteCourse = deleteCourse;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Add new task
         */
        function addNewCourse()
        {
            vm.course.update_time = moment().format("YYYY-MM-DD HH:mm:ss");
            var data = angular.copy(vm.course);
           //data.course_time = (data.course_time).toISOString().slice(0,10);
            data.course_time = moment(data.course_time).format("YYYY-MM-DD");
            //console.log(typeof angular.toJson(data));
            $http({
                method:'POST',
                url: msApi.getApiUrl('courses'),
                data:data
            }).success(function(req){
                // 类型
                angular.forEach(vm.categories, function(v,k){
                   if (v['id'] == vm.course.categories_id)
                       vm.course.categories_name = v['name'];
                });
                // 老师
                angular.forEach(vm.teachers, function(v,k){
                    if (v['id'] == vm.course.teacher_id)
                        vm.course.teacher_name = v['name'];
                });
                // 助教
                angular.forEach(vm.assistants, function(v,k){
                    if (v['id'] == vm.course.assistant_id)
                        vm.course.assistant_name = v['name'];
                });
                vm.course.id = req.id;
                vm.course.status_text = req.status_text;
                vm.courses.data.unshift(vm.course);

                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }

        /**
         * Save task
         */
        function saveCourse()
        {
            vm.hasConflict = null;
            vm.course.update_time = moment().format("YYYY-MM-DD HH:mm:ss");
            var data = angular.copy(vm.course);
            //data.course_time = (data.course_time).toISOString().slice(0,10);
            data.course_time = moment(data.course_time).format("YYYY-MM-DD");
            //console.log(typeof angular.toJson(data));

            var conflictData = {course_id:vm.course.id,
                                customer_id:vm.course.customer_id,
                                teacher_id:vm.course.teacher_id,
                                start_date:data.course_time,
                                start_time:vm.course.course_begintime,
                                end_time:vm.course.course_endtime,
                                room_id:vm.course.room_id
                            };
            $http({
                method:'POST',
                url: msApi.getApiUrl('courses/check-one-conflict'),
                data:conflictData,
                headers:{'Content-Type':'application/x-www-form-urlencoded'},
                transformRequest:function(obj){
                    //console.log(obj);
                    var str = [];
                    for(var p in obj){
                        str.push(encodeURIComponent(p) + "=" +encodeURIComponent(obj[p]));
                    }
                    return str.join("&");
                }
            }).success(function(req){
                if (req.code&&req.code=="error"){
                    if (req.err_code&&req.err_code == "0001"){
                        $rootScope.message_danger = req.msg;
                        vm.hasConflict = req.data;
                        $timeout(function(){$rootScope.message_danger = '';},5000);
                    }else{
                        $rootScope.message_danger = vm.error_arr;
                        $timeout(function(){$rootScope.message_danger = '';},5000);
                    }
                }else{//没有冲突提交数据
                    $http({
                        method:'PUT',
                        url: msApi.getApiUrl('courses/' +data.id),
                        data:data
                    }).success(function(req){
                        // 类型
                        angular.forEach(vm.categories, function(v,k){
                            if (v['id'] == vm.course.categories_id)
                                vm.course.categories_name = v['name'];
                            //console.log(v['name']);
                        });
                        // 老师
                        angular.forEach(vm.teachers, function(v,k){
                            if (v['id'] == vm.course.teacher_id)
                                vm.course.teacher_name = v['name'];
                        });
                        // 助教
                        angular.forEach(vm.assistants, function(v,k){
                            if (v['id'] == vm.course.assistant_id)
                                vm.course.assistant_name = v['name'];
                        });
        
                        vm.course.status_text = req.status_text;
                        // Dummy save action
                        for ( var i = 0; i < vm.courses.data.length; i++ )
                        {
                            if ( vm.courses.data[i].id === vm.course.id )
                            {
                                vm.courses.data[i] = angular.copy(vm.course);
                                break;
                            }
                        }
                        $rootScope.message_success = '操作成功!';
                        $timeout(function(){$rootScope.message_success = '';},5000);
                        closeDialog();
                    }).error(function(data, state) {
                        vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                        $rootScope.message_danger = vm.error_arr;
                        $timeout(function(){$rootScope.message_danger = '';},5000);
                    });
                }
                
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
            return;

        }

        /**
         * Delete task
         */
        function deleteCourse()
        {
            var confirm = $mdDialog.confirm()
                .title('删除确认操作?')
                .content('确认要删除此课程吗.')
                .ariaLabel('删除课程')
                .ok('删除')
                .cancel('取消');
                //.targetEvent(event);
            $mdDialog.show(confirm).then(function ()
            {
                var data = angular.copy(vm.course);
                data.course_time = moment(data.course_time).format("YYYY-MM-DD"); 
                data.status = 0;
                $http({
                    method: 'PUT',
                    url: msApi.getApiUrl('courses/' +data.id),
                    data: data
                }).success(function (req) {
                    vm.courses.data.splice(vm.courses.data.indexOf(vm.course), 1);
                    $rootScope.message_success = '操作成功!';
                    $timeout(function () {
                        $rootScope.message_success = '';
                    }, 5000);
                }).error(function (data, state) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function () {
                        $rootScope.message_danger = '';
                    }, 5000);
                });
            }, function ()
            {
                // Cancel Action
            });
        }



        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide().then(function(){
                //vm.course.course_time = (vm.course.course_time).toISOString().slice(0,10);
                vm.course.course_time = moment(vm.course.course_time).format("YYYY-MM-DD");
            });
        }

        vm.rooms = {};
        vm.simulateQuery = false;
        vm.isDisabled = false;
        vm.noCache = true;
        vm.searchText = vm.newCourse ? '' : vm.course.room;
        vm.selectedItem = vm.newCourse ? '' : {'value' : vm.course.room, 'display' : vm.course.room};
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.roomsall = {};

        function searchTextChange(text) {
            if(text){
                $http.get(msApi.getApiUrl('rooms'), {params: {'store_id':store_id, 'name':text, }}).success(function (results) {
                    vm.rooms = results.data;
                    vm.roomsall = loadAll();
                    $('#room-auto').find('input[type="search"]').focus();
                    return vm.roomsall;
                });
            }else {
                vm.roomsall = [];
                return vm.roomsall;
            }

        }
        // 预约状态

        function selectedItemChange(item) {
            //console.log(item);
            if(item){
                vm.course.room = item.value;
                angular.forEach(vm.rooms, function (v, k) {

                    if (v['name'] == item.value) {
                        vm.course.room_id = v['id'];
                    }
                });
            }else{
                vm.course.room = '';
                vm.course.room_id = 0;
            }
        }
        function loadAll() {
            var allStates = '';
            angular.forEach(vm.rooms, function (v, k) {
                allStates = allStates + v.name + ', ';
            });
            allStates = allStates.substr(0, allStates.length - 2);
            return allStates.split(/, +/g).map(
                function (state) {
                    return {
                        value: state,//.toLowerCase(),
                        display: state
                    };
                });
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.courses')
        .controller('CategoryDialogController', CategoryDialogController);

    /** @ngInject */
    function CategoryDialogController($rootScope, $timeout, $mdDialog, Categorie, Categories, is_cud, event, $http, msApi, $cookies)
    {
        var vm = this;
        vm.is_cud = is_cud
        // Data
        vm.title = '编辑';
        vm.categorie = angular.copy(Categorie);
        vm.categories = Categories;

        var store_id = $cookies.get('store_id');
        msApi.request("store.courses.categories@get", {'type':1, 'parent_id':0, 'store_id': store_id}).then(
            function (response){
                vm.parentCategories = response.data;
            });
        vm.newCategorie = false;
        if ( !vm.categorie )
        {
            vm.categorie = {
                'id'                : '',
                'name'              : '',
                'type'              : 1,//课程分类
                'parent_id'         : '0',
                'store_id'          : $cookies.get('store_id'),
                'status'            : 1,
                'created_by'        : '',
                'type_name'         : '课程类型',
                'store_name'        : $cookies.get('store_name')
            };
            vm.title = '添加';
            vm.newCategorie = true;
        }

        // Methods
        vm.addNewCategorie = addNewCategorie;
        vm.saveCategorie = saveCategorie;
        vm.deleteCategorie = deleteCategorie;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Add new task
         */
        function addNewCategorie()
        {
            var data = vm.categorie;
            //console.log(typeof angular.toJson(data));
            $http({
                method:'POST',
                url: msApi.getApiUrl('categories'),
                data:data
            }).success(function(req){
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);

                vm.categorie.id = req.id;
                vm.categories.data.unshift(vm.categorie);
                closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }

        /**
         * Save task
         */
        function saveCategorie()
        {
            var data = vm.categorie;
            //console.log(typeof angular.toJson(data));
            $http({
                method:'PUT',
                url: msApi.getApiUrl('categories/' +data.id),
                data:data
            }).success(function(req){
                // Dummy save action
                for ( var i = 0; i < vm.categories.data.length; i++ )
                {
                    if ( vm.categories.data[i].id === vm.categorie.id )
                    {
                        vm.categories.data[i] = angular.copy(vm.categorie);
                        break;
                    }
                }
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }

        /**
         * Delete task
         */
        function deleteCategorie()
        {
            var confirm = $mdDialog.confirm()
                .title('删除确认操作?')
                .content('确认要删除此分类吗.')
                .ariaLabel('删除分类')
                .ok('删除')
                .cancel('取消');
                //.targetEvent(event);

            $mdDialog.show(confirm).then(function ()
            {
                var data = angular.copy(vm.categorie);
                data.status = 0;
                $http({
                    method: 'PUT',
                    url: msApi.getApiUrl('categories/' +data.id),
                    data: data
                }).success(function (req) {
                    vm.categories.data.splice(vm.categories.data.indexOf(vm.categorie), 1);
                    $rootScope.message_success = '操作成功!';
                    $timeout(function () {
                        $rootScope.message_success = '';
                    }, 5000);
                }).error(function (data, state) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function () {
                        $rootScope.message_danger = '';
                    }, 5000);
                });
            }, function ()
            {
                // Cancel Action
            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.customers',['angularQFileUpload','app.components.charts.c3',
            'app.components.charts.chart-js',
            'app.components.charts.chartist',
            'app.components.charts.nvd3',])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, msApiProvider)
    {
        // State
        var store_id = msApiProvider.getCookies('store_id');
        var error_url = msApiProvider.getErrorUrl();
        $stateProvider.state('app.store.customers', {
            abstract: true,
            url     : '/customers'
        })
        .state('app.store.customers.list', {//学生列表
            url      : '/list',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/customers/customers.html',
                    controller : 'CustomersController as vm'
                }
            },
            resolve: {
                /*Customers: function (msApi)//学生
                {
                    return msApi.resolve('store.customers.list@get', {'store_id': store_id});
                }*/
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_customer', 'admin_customer_list'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'customers'
        }).state('app.store.customers.detail', {//学生详情
                url      : '/detail/:id',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/store/customers/customer-detail.html',
                        controller : 'CustomersDetailController as vm'
                    }
                },
                resolve: {
                    /*Customers: function (msApi)//学生
                    {
                        return msApi.resolve('store.customers.list@get', {'store_id': store_id});
                    },*/
                    Customer: function (msApi,$stateParams)//学生
                    {
                        msApiProvider.register('store.customers.customer', [msApiProvider.getApiUrl() + 'customers/'+$stateParams.id]);

                        return msApi.resolve('store.customers.customer@get');
                    }
                },
                data: {
                    permissions: {
                        //except: ['anonymous'],
                        only:['admin_customer', 'admin_customer_list'],
                        redirectTo: error_url
                    }
                },
                bodyClass: 'customers'
        }).state('app.store.customers.parents', {//家长列表
            url      : '/parents',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/customers/parents.html',
                    controller : 'ParentsController as vm'
                }
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_customer', 'admin_parent', 'admin_parent_list'],
                    redirectTo: error_url
                }
            },
            resolve: {
                Parents: function (msApi,$stateParams)//学生
                {
                    var store_id = msApiProvider.getCookies('store_id');
                    msApiProvider.register('store.customers.parents', [msApiProvider.getApiUrl() + 'parents']);

                    return msApi.resolve('store.customers.parents@get', {'store_id': store_id});
                }
            },
            bodyClass: 'customers'
        }).state('app.store.customers.wizard', {//创建学生及合同
            url      : '/create-wizard/:task_id',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/customers/customer-contract-wizard.html',
                    controller : 'CustomerContractController as vm'
                }
            },
            resolve: {
                Task: function (msApi,$stateParams)//学生
                {
                    if($stateParams.task_id){
                        msApiProvider.register('store.customers.task', [msApiProvider.getApiUrl() + 'tasks/'+$stateParams.task_id]);

                        return msApi.resolve('store.customers.task@get');
                    }
                    return {};
                }
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_customer', 'admin_contract', 'admin_customer_contract'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'customers'
        }).state('app.store.customers.addparents', {//学生联系人
            url      : '/addparents/:id',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/customers/customer-parents.html',
                    controller : 'CustomerParentsController as vm'
                }
            },
            resolve: {
                Customer: function (msApi,$stateParams)//学生
                {
                    msApiProvider.register('store.customers.customer', [msApiProvider.getApiUrl() + 'customers/'+$stateParams.id]);

                    return msApi.resolve('store.customers.customer@get');
                }
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_customer', 'admin_parent', 'admin_customer_cud' , 'admin_parent_cud'],
                    redirectTo: error_url
                }
            },
                bodyClass: 'customers'
            });
        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/apps/customers');
        // Navigation 菜单管理
        msNavigationServiceProvider.saveItem('store.customers', {//课程管理组
            title : '学生管理',
            icon  : 'icon-human-child',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('store.customers.list', {//课程列表菜单
            title : '学生列表',
            icon  : 'icon-human',
            state : 'app.store.customers.list',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('store.customers.wizard', {//课程列表菜单
            title : '创建学生及合同',
            icon  : 'icon-loupe',
            state : 'app.store.customers.wizard',
            weight: 2
        });


        msNavigationServiceProvider.saveItem('store.customers.parents', {//家长列表
            title : '家长列表',
            icon  : 'icon-human-male-female',
            state : 'app.store.customers.parents',
            weight: 1
        });

        msApiProvider.register('store.customers.contracts', [msApiProvider.getApiUrl() + 'contracts']);
        msApiProvider.register('store.customers.gudins', [msApiProvider.getApiUrl() + 'customergudins']);
        msApiProvider.register('store.customers.list', [msApiProvider.getApiUrl() + 'customers']);
        //msApiProvider.register('store.customers.parents', [msApiProvider.getApiUrl() + 'customerhasparents']);
        msApiProvider.register('store.customers.parents', [msApiProvider.getApiUrl() + 'parents']);
        msApiProvider.register('store.customers.users', [msApiProvider.getApiUrl() + 'users']);
        msApiProvider.register('store.customers.contract', [msApiProvider.getApiUrl() + 'contracts']);
        msApiProvider.register('store.customers.images', [msApiProvider.getApiUrl() + 'images']);
        msApiProvider.register('store.customers.signups', [msApiProvider.getApiUrl() + 'signups']);
        msApiProvider.register('store.customers.wechats', [msApiProvider.getApiUrl() + 'wechats']);
    }
})();
(function () {
    'use strict';

    angular
        .module('app.store.customers')
        .controller('ZcardDialogController', ZcardDialogController);

    /** @ngInject */
    function ZcardDialogController($rootScope, $timeout, $mdDialog, $filter, Customer, Customers, is_cud, event, msApi, $http, $cookies, $qupload) {
        var vm = this;
        vm.customer = Customer;
        vm.customers = Customers;
        vm.to_store_id = 0;
        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00') return new Date(str);
        }
        // Data
        vm.title = '转店';
        vm.is_cud = is_cud;
        var store_id = $cookies.get('store_id');

        var store_city = $cookies.get('store_city');
        vm.curr_user = $cookies.getObject('curr_user');
        vm.pay = {
            'id': '',
            'amount': '',
            'pay_type': '',
            'pay_date': new Date(),
            'income_fang': '',
            'remarks': '转门店',
            'attach': '',
            'status': 1,
            'store_id': store_id,
            'creater_uid': vm.curr_user.id,
        };
        msApi.resolve('store.customers.contracts@get',{customer_id:vm.customer.id,store_id:store_id}).then(function(contracts){
            vm.contracts = contracts
        });
        //所有门店
        msApi.request('store.system.stores@get', {'city': store_city, 'noid': store_id}).then(
            function (response) {
                vm.stores = response.data;
            });

        // 支付类型
        msApi.request('store.contracts.categories@get', {'store_id': store_id, 'type': '5', 'per-page': 200}).then(
            function (response) {
                vm.pay_types = response.data;
            });
        // Methods
        vm.saveZcard = saveZcard;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Add new task
         */
        function saveZcard() {
            var data = vm.customer
            data.act = 'zcard';
            data.to_store_id = vm.to_store_id;
            $http({
                method: 'PUT',
                url: msApi.getApiUrl('customers/' + data.id),
                data: data//angular.toJson(data)
            }).success(function (req) {
                vm.customers.data.splice(vm.customers.data.indexOf(vm.customer), 1);
                var str = Date.parse(new Date())+'';
                vm.pay.created_at =  str.substr(0,str.length-3);
                vm.pay.updated_at = vm.pay.created_at;
                vm.pay.customer_id = vm.customer.id;
                var data1 = angular.copy(vm.pay);
                //data1.pay_date = (data1.pay_date).toISOString().slice(0,10);
                data1.pay_date = $filter("date")(new Date(data1.pay_date), "yyyy-MM-dd");
                $http({
                    method: 'POST',
                    url: msApi.getApiUrl('pays'),
                    data: angular.toJson(data1)
                }).success(function (req) {
                    $rootScope.message_success = '操作成功!';
                    $timeout(function(){$rootScope.message_success = '';},5000);
                    closeDialog();
                }).error(function(data, state) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function(){$rootScope.message_danger = '';},5000);
                });
                //$rootScope.message_success = '操作成功!';
                //$timeout(function(){$rootScope.message_success = '';},5000);
                //closeDialog();
            }).error(function (data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }

        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }
        // 七牛 文件上传 >>>>>>>>>>>>>>>>>>
        msApi.request('store.users.list@get', {'act': 'upToken'}).then(
            function (response){
                vm.upToken = response.data.upToken;
                vm.upHost  = response.data.upHost;
            });
        vm.selectFiles = [];
        var start = function (index) {
            vm.selectFiles[index].progress = {
                p: 0
            };
            vm.selectFiles[index].upload = $qupload.upload({
                key: 'pay/'+$filter("date")(new Date(), "yyyyMMdd")+'/'+$filter("date")(new Date(), "HHmmss")+'.jpg',
                file: vm.selectFiles[index].file,
                token: vm.upToken
            });
            vm.selectFiles[index].upload.then(function (response) {
                // upload success
                //$log.info(response);
                //console.log("upload success");
                //console.log(response);
                vm.pay.attach = vm.upHost+response.key;
            }, function (response) {
                // upload failure
                //$log.info(response);
                //console.log("upload failure");
                //console.log(response);
            }, function (evt) {
                // progress
                vm.selectFiles[index].progress.p = Math.floor(100 * evt.loaded / evt.totalSize);
            });
        };
        vm.abort = function (index) {
            vm.selectFiles[index].upload.abort();
            vm.selectFiles.splice(index, 1);
        };
        vm.onFileSelect = function ($files) {
            var offsetx = vm.selectFiles.length;
            for (var i = 0; i < $files.length; i++) {
                vm.selectFiles[i + offsetx] = {
                    file: $files[i]
                };
                start(i + offsetx);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.customers')
        .controller('WechatDialogController', WechatDialogController);

    /** @ngInject */
    function WechatDialogController($rootScope, $timeout, $mdDialog, Parent, is_cud, event, $scope, msApi, $http)
    {
        var vm = this;
        vm.is_cud = is_cud;
        // Data
        vm.title = '绑定的微信号';
        vm.parent = angular.copy(Parent);

        msApi.request("store.customers.wechats@get", {'parents_id': vm.parent.id}).then(
            function (response){
                vm.wechats = response.data;
            });

        vm.saveWechat = saveWechat;
        vm.closeDialog = closeDialog;

        /**
         * Save task
         */
        function saveWechat(ev, wechat)
        {
            var confirm = $mdDialog.confirm()
                .title('取消绑定确认操作?')
                .content('确认要取消绑定此吗.')
                .ariaLabel('取消绑定')
                .ok('确定')
                .cancel('取消');
                //.targetEvent(event);

            $mdDialog.show(confirm).then(function () {
                var data = {'parents_id': 0};
                $http({
                    method: 'PUT',
                    url: msApi.getApiUrl('wechats/' + wechat.id),
                    data: data
                }).success(function (req) {
                    vm.wechats.splice(vm.wechats.indexOf(wechat), 1);
                    $rootScope.message_success = '操作成功!';
                    $timeout(function () {
                        $rootScope.message_success = '';
                    }, 5000);
                    closeDialog();
                }).error(function (data, state) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function(){$rootScope.message_danger = '';},5000);
                });
            });
        }


        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.customers')
        .controller('ParentDialogController', ParentDialogController);

    /** @ngInject */
    function ParentDialogController($rootScope, $timeout, $mdDialog,  Parent,Parents, event, $scope, msApi, $http,$cookies)
    {
        var store_id = $cookies.get('store_id');
        var vm = this;
        // Data
        vm.title = '编辑';
        vm.parent = angular.copy(Parent);
        vm.parents = Parents;
        //vm.customer = angular.copy(Customer);
        //vm.customers = Customers;
        /*msApi.request("store.customers.parents@get", {'store_id': store_id}).then(//父母
            function (response){
                vm.parents = response.data;
                //console.log(response.data);
            });*/

        vm.newParent = false;

        if ( !vm.parent )
        {
            vm.parent = {
                'id'                : '',
                'username'          : '',
                'mobile'            : '',
                'name'              : '',
                'email'             : '',
                'relation'          : 0,
                'wechat'            : '',
                'qq'                : '',
                'store_id'          : $cookies.get('store_id')
                //'customer_id'       : vm.customer.id
            };
            vm.title = '添加';
            vm.newParent = true;
        }
        vm.is_parent = false;
        // Methods
        vm.addNewParent = addNewParent;
        vm.saveParent = saveParent;
        vm.deleteParent = deleteParent;
        vm.closeDialog = closeDialog;
        vm.checkParent = checkParent;
        vm.bindingParent = bindingParent;

        //////////
        //上传图片
        vm.upload = upload;
        vm.imageSuccess = imageSuccess;
        vm.ngFlowOptions = {
            singleFile: true
            // You can configure the ngFlow from here
            /*target                   : 'api/media/image',
             chunkSize                : 15 * 1024 * 1024,
             maxChunkRetries          : 1,
             simultaneousUploads      : 1,
             testChunks               : false,
             progressCallbacksInterval: 1000*/
        };
        vm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };
        function upload()
        {
            // Set headers
            vm.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest'
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            vm.ngFlow.flow.upload();
        }
        /**
         * Image Success
         * @param file
         * @param message
         */
        function imageSuccess(file, message)
        {
            var fileReader = new FileReader();

            fileReader.readAsDataURL(file.file);

            fileReader.onload = function (event)
            {
                file.url = event.target.result;

                $scope.$evalAsync(function ()
                {
                    vm.task.photo = file.url;
                });
            };

            file.type = 'image';
        }
        /**
         * Add new task
         */
        function addNewParent()
        {
            var data = vm.parent;
            data.customer_id = vm.customer.id;
            $http({
                method:'POST',
                url: msApi.getApiUrl('parents'),
                data:data
            }).success(function(req){
                vm.parent.id = req.id;
                vm.parents.unshift(vm.parent);
                vm.customer.main_contactor = req.id;
                vm.customer.main_contactor_name = vm.parent.name;
                vm.customer.main_contactor_mobile = vm.parent.mobile;
                for ( var i = 0; i < vm.customers.data.length; i++ )
                {
                    if ( vm.customers.data[i].id === vm.customer.id )
                    {
                        vm.customers.data[i] = angular.copy(vm.customer);
                        break;
                    }
                }
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }

        /**
         * Save task
         */
        function saveParent()
        {
            var data = vm.parent;
            $http({
                method:'PUT',
                url: msApi.getApiUrl('parents/' +data.id),
                data:data
            }).success(function(req){
                for ( var i = 0; i < vm.parents.data.length; i++ )
                {
                    if ( vm.parents.data[i].id === vm.parent.id )
                    {
                        vm.parents.data[i] = angular.copy(vm.parent);
                        break;
                    }
                }
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }

        /**
         * Delete task
         */
        function deleteParent()
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure?')
                .content('The Task will be deleted.')
                .ariaLabel('Delete Task')
                .ok('Delete')
                .cancel('Cancel');
                //.targetEvent(event);

            $mdDialog.show(confirm).then(function ()
            {
                // Dummy delete action
                for ( var i = 0; i < vm.parents.length; i++ )
                {
                    if ( vm.parents[i].id === vm.parent.id )
                    {
                        vm.parents[i].deleted = true;
                        break;
                    }
                }
            }, function ()
            {
                // Cancel Action
            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
        function checkParent(mobile){
            vm.is_parent = false;
           // vm.newParent = true;
            //vm.title = '添加';
            if(mobile && mobile > 6) {
                $http.get(msApi.getApiUrl('parents'), {params: {"mobile": mobile}}).success(function (response) {
                    //console.log (vm.parent);
                    if (response.data.length > 0) {
                        vm.parent = response.data[0];
                        vm.parent.store_id = $cookies.get('store_id');
                        if( vm.newParent){
                            vm.is_parent = true;
                            vm.newParent = false;
                            vm.title = '绑定';
                        }
                    }
                });
            }else{
                vm.parent.mobile = mobile;
            }
        }

        function bindingParent(parent){
            /*var data = {};
            data.parents_id = vm.parent.id;
            data.customer_id = vm.customer.id;
            //console.log(vm.parent);
            $http({
                method:'POST',
                url: msApi.getApiUrl('customerhasparents'),
                data:data
            })*/
            parent.customer_id = vm.customer.id;//设置当前BB给父母
            console.log(parent);
            $http({
                method:'PUT',
                url: msApi.getApiUrl('parents/'+parent.id),
                data:parent
            }).success(function(req){

                //vm.courses.unshift(vm.course);

            }).error(function(data,status){
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
            closeDialog();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.customers')
        .controller('ResetpwdParentController', ResetpwdParentController);

    /** @ngInject */
    function ResetpwdParentController($rootScope, $timeout, $mdDialog, Parents, Parent, msApi)
    {
        //console.log($filter("date")(new Date(), "yyyy-MM-dd HH:mm:ss"));
        var vm = this;
        // Data
        vm.title = '重置密码';
        vm.parent = angular.copy(Parent);
        vm.parents = Parents;

        vm.saveParent = saveParent;
        vm.closeDialog = closeDialog;
        vm.data = {
            'pwd':'',
            'confpwd':''
        };
        //////////

        /**
         * Save task
         */
        function saveParent()
        {
            if(vm.data.pwd != vm.data.confpwd){
                $rootScope.message_success = '两次密码输入不一致';
                return false;
            }
            msApi.request("store.customers.parents@get", {'act':'changepwd', 'id': vm.parent.id, pwd:vm.data.pwd, confpwd:vm.data.confpwd}).then(
                // Success
                function (response)
                {
                    $rootScope.message_success = response.data.notice_message;
                    $timeout(function(){$rootScope.message_success = '';},5000);
                    if (response.data.status == 1)
                        closeDialog();
                    closeDialog();
                }
            );

        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.store.customers')
        .controller('GudinDialogController', GudinDialogController);

    /** @ngInject */
    function GudinDialogController($rootScope, $timeout, $mdDialog, Customer, Customers, event, msApi, $http, $cookies) {
        var vm = this;
        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00') return new Date(str);
        }
        vm.weeks =[];
        vm.week = moment().format('ww');//周
        for ( var i = 1; i < 53; i++ ) {
            var newm = moment().week(i);
            var weekOfday = newm.format('E');
            var star = newm.subtract(weekOfday-1, 'days');
            //var star =newm.add(1, 'days');
            var sdate = star.format("MM-DD");
            //var end = newm.add(6, 'days');
            var end = star.add(6, 'days');
            var edate = end.format("MM-DD");
            vm.weeks.push({
                'id': i,
                'sdate':sdate,
                'edate':edate,
            })
        }

        // Data
        vm.title = '设置固定课';
        //合同
        vm.customer = Customer;
        //vm.contract = angular.copy(Contract);
        vm.customers = Customers;
        //console.log(vm.customers);
        vm.selected = [];

        var store_id = $cookies.get('store_id');
        vm.closeDialog = closeDialog;
        vm.query1 = {
            store_id:store_id,
            "per-page": 1000,
            'act': 'gudin',
            //limit:10000,
            page: 1
        }
        doSearch();
        vm.doSearch = doSearch;
       function doSearch() {
            var newm = moment().week(vm.week);
            var weekOfday = newm.format('E');
            var star = newm.subtract(weekOfday-1, 'days');
            //var star =newm.add(1, 'days');
            var sdate = star.format("YYYY-MM-DD");
            //var end = newm.add(6, 'days');
            var end = star.add(6, 'days');
            var edate = end.format("YYYY-MM-DD");

            vm.query1.start_time = sdate;
            vm.query1.end_time = edate;
            $rootScope.loadingProgress = true;
            //固定课程
            msApi.request('store.courses.list@get', vm.query1).then(
                function (response) {
                    $rootScope.loadingProgress = false;
                    vm.courses = response.data;
                    msApi.request('store.customers.gudins@get', {'customer_id': vm.customer.id, 'store_id': store_id}).then(
                        function (res) {
                            if (res.data) {
                                vm.gudins = res.data
                                console.log(vm.gudins);
                                angular.forEach(vm.gudins, function (v, k) {
                                    for (var i = 0; i < vm.courses.length; i++) {
                                        if (vm.courses[i].number == v.number) {
                                            vm.selected.push(vm.courses[i]);
                                            break;
                                        }
                                    }
                                });
                                console.log(vm.selected);
                            }
                        });
                });
        }
        vm.save = save;
        function save() {
            /*var data  = {
                id : vm.customer.id,
                gudins: vm.gudins,
                act: 'gudin'

            };*/
            vm.customer.gudins = vm.gudins;
            vm.customer.act ='gudin';

            if(vm.gudins.length == 0){
                alert('请选择固定课');
                return false;
            }
            var data = vm.customer;
            console.log(data);
            $http({
                method:'PUT',
                url: msApi.getApiUrl('customers/' +data.id),
                data:data
            }).success(function(req){
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }
        function closeDialog() {
            $mdDialog.hide().then(function(){
            });
        }
        vm.toggle = function (item, list, index) {
            var idx = list.indexOf(item);
            vm.gudins[index] = {};
            if (idx > -1) {
                list.splice(idx, 1);
                angular.forEach(vm.gudins, function (v, k) {
                    if(v.number == item.number){
                        v.number_checkbox = false;
                    }
                });
            }
            else {
                list.push(item);
                angular.forEach(vm.gudins, function (v, k) {
                    if(v.number == item.number){
                        v.number_checkbox = true;
                    }
                });
            }
            vm.gudins[index].number= item.number;
            vm.gudins[index].content = item.content;
        };

        vm.exists = function (item, list) {
            return list.indexOf(item) > -1;
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.customers')
        .controller('CustomerDialogController', CustomerDialogController);

    /** @ngInject */
    function CustomerDialogController($rootScope, $timeout, $mdDialog, $filter, Customer, Customers, is_cud, $cookies, $http, msApi, $qupload, $location)
    {
        var vm = this;
        // Data
        vm.title = '编辑';
        //vm.customer = angular.copy(Customer);
        vm.customer = Customer;
        vm.customers = Customers;
        vm.is_cud = is_cud;
        var store_id = $cookies.get('store_id');
        // 课程顾问
        msApi.request('store.customers.users@get', {'store_id': store_id, 'role_id': 5}).then(
            function (response){
                vm.users = response.data;
            });
        vm.newCustomer = false;

        vm.StrToDate = function (str) { if (str && str != '0000-00-00') return new Date(str); }

        if ( !vm.customer )
        {
            vm.customer = {
                'id'                : '',
                'member_id'         : 'BB'+new Date().getTime(),
                'name'              : '',
                'nickname'          : '',
                'skype'          : '',
                'sex'               : 0,
                'sex_text'          : 0,
                'birthday_month'    :0,
                'birthday'          : new Date(),
                'photo_id'          : 0,
                'store_id'          : $cookies.get('store_id'),
                'main_contactor'    : 0,
                'consult_id'        : 0,
                'remarks'           : '',
                'photo'             :'',
                'email'             :'',
                'video_url'             :'',
                'avatar'            : ''//'assets/images/avatars/profile.jpg'
            };
            vm.title = '添加';
            vm.newCustomer = true;
        }else {
            vm.customer.birthday = moment(vm.customer.birthday).format("YYYY-MM-DD 00:00:00");//使用当地日期
            vm.customer.birthday = vm.StrToDate(vm.customer.birthday);
        }
        // Methods
        vm.addNewCustomer = addNewCustomer;
        vm.saveCustomer = saveCustomer;
        vm.deleteCustomer = deleteCustomer;
        vm.closeDialog = closeDialog;

        /**
         * Add new Customer
         */
        function addNewCustomer()
        {
            vm.customer.update_time = moment().format("YYYY-MM-DD HH:mm:ss");
            var data = angular.copy(vm.customer);
            //data.birthday = (data.birthday).toISOString().slice(0,10);
            data.birthday = moment(data.birthday).format("YYYY-MM-DD");;
            $http({
                method:'POST',
                url: msApi.getApiUrl('customers'),
                data:data
            }).success(function(req) {
                angular.forEach(vm.users, function(v,k){
                    if (v['id'] == data.consult_id)
                        vm.customer.consult_name = v['name'];
                });
                vm.customer.id = req.id;
                vm.customers.data.unshift(req);
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }

        /**
         * Save customer
         */
        function saveCustomer()
        {
            vm.customer.update_time = moment().format("YYYY-MM-DD HH:mm:ss");
            var data = angular.copy(vm.customer);
            data.birthday = moment(data.birthday).format("YYYY-MM-DD");
            $http({
                method:'PUT',
                url: msApi.getApiUrl('customers/' +data.id),
                data:data
            }).success(function(req){
                // console.log(req);
                //Dummy save action
                for ( var i = 0; i < vm.customers.data.length; i++ )
                {
                    if ( vm.customers.data[i].id === vm.customer.id )
                    {
                        vm.customers.data[i] =req;
                        break;
                    }
                }
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                closeDialog();
                //console.log(vm);
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }

        /**
         * Delete customer
         */
        function deleteCustomer()
        {
            var confirm = $mdDialog.confirm()
                .title('删除确认操作?')
                .content('确认要删除此宝定吗.')
                .ariaLabel('删除宝定')
                .ok('删除')
                .cancel('取消');
                //.targetEvent(event);

            $mdDialog.show(confirm).then(function ()
            {
                var data = angular.copy(vm.customer);
                data.status = 0;
                data.birthday = $filter("date")(new Date(data.birthday), "yyyy-MM-dd");
                $http({
                    method: 'PUT',
                    url: msApi.getApiUrl('customers/' +data.id),
                    data: data
                }).success(function (req) {
                    vm.customers.data.splice(vm.customers.data.indexOf(vm.customer), 1);
                    $rootScope.message_success = '操作成功!';
                    $timeout(function () {
                        $rootScope.message_success = '';
                    }, 5000);
                }).error(function (data, state) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function () {
                        $rootScope.message_danger = '';
                    }, 5000);
                });
            }, function ()
            {
                // Cancel Action
            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }


        /// 七牛上传图片
        // https://github.com/icattlecoder/angularQFileUpload
        // 七牛 文件上传 >>>>>>>>>>>>>>>>>>
        msApi.request('store.customers.users@get', {'act': 'upToken'}).then(
            function (response){
                vm.upToken = response.data.upToken;
                vm.upHost  = response.data.upHost;
            });
        vm.selectFiles = [];
        var start = function (index) {
            vm.selectFiles[index].progress = {
                p: 0
            };
            vm.selectFiles[index].upload = $qupload.upload({
                key: 'avatar/'+$filter("date")(new Date(), "yyyyMMdd")+'/'+$filter("date")(new Date(), "HHmmss")+'.jpg',
                file: vm.selectFiles[index].file,
                token: vm.upToken
            });
            vm.selectFiles[index].upload.then(function (response) {
                // upload success
                //$log.info(response);
                //console.log("upload success");
                //console.log(response);
                vm.customer.avatar = vm.upHost+response.key;
            }, function (response) {
                // upload failure
                //$log.info(response);
                //console.log("upload failure");
                //console.log(response);
            }, function (evt) {
                // progress
                vm.selectFiles[index].progress.p = Math.floor(100 * evt.loaded / evt.totalSize);
            });
        };
        vm.abort = function (index) {
            vm.selectFiles[index].upload.abort();
            vm.selectFiles.splice(index, 1);
        };
        vm.onFileSelect = function ($files) {
            var offsetx = vm.selectFiles.length;
            for (var i = 0; i < $files.length; i++) {
                vm.selectFiles[i + offsetx] = {
                    file: $files[i]
                };
                start(i + offsetx);
            }
        };

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.contracts',['angularQFileUpload'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider,msApiProvider)
    {
        var store_id = msApiProvider.getCookies('store_id');
        var error_url = msApiProvider.getErrorUrl();
        // State
        $stateProvider.state('app.store.contracts', {
            abstract: true,
            url     : '/contract'
        }).state('app.store.contracts.list', {//课程列表
            url      : '/list',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/contracts/contracts.html',
                    controller : 'ContractsController as vm'
                }
            },
            resolve  : {
                /*Contracts: function (msApi){
                    return msApi.resolve('store.contracts.list@get', {'store_id': store_id});
                },
                Customers: function (msApi){
                    return msApi.resolve('store.contracts.customers@get', {'store_id': store_id});
                }*/
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_contract', 'admin_contract_list'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'contracts'
        }).state('app.store.contracts.detail', {//合同详情
            url      : '/detail/:id',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/contracts/contract-detail.html',
                    controller : 'ContractDetailController as vm'
                }
            },
            resolve  : {
                Contract: function (msApi,$stateParams)//合同
                {
                    msApiProvider.register('store.contracts.contract', [msApiProvider.getApiUrl() + 'contracts/'+$stateParams.id]);

                    return msApi.resolve('store.contracts.contract@get');
                }
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_contract', 'admin_contract_list'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'contracts'
        }).state('app.store.contracts.signup', {//约课
            url      : '/signup/:contract_id/:customer_id',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/contracts/signup.html',
                    controller : 'CustomerSignupController as vm'
                }
            },
            resolve  : {
                Customer: function (msApi,$stateParams)//学生
                {
                    msApiProvider.register('store.contracts.customer', [msApiProvider.getApiUrl() + 'customers/'+$stateParams.customer_id]);

                    return msApi.resolve('store.contracts.customer@get');
                }
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_contract', 'admin_contract_signup'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'contracts'
        }).state('app.store.contracts.recycle', {//回收站列表
            url      : '/recycle/:flag',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/contracts/contracts.html',
                    controller : 'ContractsController as vm'
                }
            },
            resolve  : {
                /*Contracts: function (msApi){
                 return msApi.resolve('store.contracts.list@get', {'store_id': store_id});
                 },
                 Customers: function (msApi){
                 return msApi.resolve('store.contracts.customers@get', {'store_id': store_id});
                 }*/
            },
            data: {
                permissions: {
                    //except: ['anonymous'],
                    only:['admin_contract', 'admin_contract_list'],
                    redirectTo: error_url
                }
            },
            bodyClass: 'contracts'
        }).state('app.store.contracts.leaves', {//请假管理
                url      : '/leaves',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/store/contracts/leaves.html',
                        controller : 'ContractLeavesController as vm'
                    }
                },
                resolve  : {
                   /* Leaves: function (msApi){
                        return msApi.resolve('store.contracts.leaves@get', {'store_id': store_id});
                    }*/
                },
                data: {
                    permissions: {
                        //except: ['anonymous'],
                        only:['admin_contract', 'admin_qingjia', 'admin_qingjia_list'],
                        redirectTo: error_url
                    }
                },
                bodyClass: 'contracts'
        });

        // Navigation 菜单管理
        msNavigationServiceProvider.saveItem('store.contracts', {//课程管理组c
            title : '合同管理',
            icon  : 'icon-file-document-box',
            weight: 3
            //permission:'admin_customers'
        });

        msNavigationServiceProvider.saveItem('store.contracts.recycle', {//课程列表菜单
            title : '合同回收站',
            icon  : 'icon-delete',
            state : 'app.store.contracts.recycle',
            weight: 2,
            stateParams:{flag:1}
        });
        msNavigationServiceProvider.saveItem('store.contracts.list', {//课程列表菜单
            title : '合同列表',
            icon  : 'icon-library-books',
            state : 'app.store.contracts.list',
            weight: 1
        });
        msNavigationServiceProvider.saveItem('store.contracts.leaves', {//请假管理菜单
            title : '请假管理',
            icon  : 'icon-calendar-clock',
            state : 'app.store.contracts.leaves',
            weight: 3
        });
        msApiProvider.register('store.contracts.list', [msApiProvider.getApiUrl() + 'contracts']);
        msApiProvider.register('store.contracts.consults', [msApiProvider.getApiUrl() + 'users']);
        msApiProvider.register('store.contracts.customers', [msApiProvider.getApiUrl() + 'customers']);
        msApiProvider.register('store.contracts.categories', [msApiProvider.getApiUrl() + 'categories']);
        msApiProvider.register('store.contracts.leaves', [msApiProvider.getApiUrl() + 'qingjias']);
        msApiProvider.register('store.contracts.contractslogs', [msApiProvider.getApiUrl() + 'contractslogs']);
        msApiProvider.register('store.contracts.contractsattachments', [msApiProvider.getApiUrl() + 'contractsattachments']);
    }
})();

(function () {
    'use strict';

    angular
        .module('app.store.contracts')
        .controller('ZcardDialogController', ZcardDialogController);

    /** @ngInject */
    function ZcardDialogController($rootScope, $timeout, $mdDialog, $filter, Contracts, Contract, is_cud, event, msApi, $http, $cookies, $qupload) {
        var vm = this;
        vm.contract = Contract;
        vm.contracts = Contracts;
        vm.to_store_id = 0;
        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00') return new Date(str);
        }
        // Data
        vm.title = '转卡';
        vm.is_cud = is_cud;
        var store_id = $cookies.get('store_id');

        var store_city = $cookies.get('store_city');
        vm.curr_user = $cookies.getObject('curr_user');
        vm.pay = {
            'id': '',
            'amount': '',
            'pay_type': '',
            'pay_date': new Date(),
            'income_fang': '',
            'remarks': '转卡到其它门店',
            'attach': '',
            'status': 1,
            'store_id': store_id,
            'creater_uid': vm.curr_user.id,
        };
        //所有门店
        msApi.request('store.system.stores@get', {'city': store_city, 'noid': store_id}).then(
            function (response) {
                vm.stores = response.data;
            });

        // 支付类型
        msApi.request('store.contracts.categories@get', {'store_id': store_id, 'type': '5', 'per-page': 200}).then(
            function (response) {
                vm.pay_types = response.data;
            });
        // Methods
        vm.saveZcard = saveZcard;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Add new task
         */
        function saveZcard() {
            var data = vm.contract
            data.status = 0;
            data.act = 'zcard';
            data.to_store_id = vm.to_store_id;
            if(vm.pay.remarks != '' && vm.pay.remarks != null){
                data.remarks = vm.pay.remarks;
            }
            $http({
                method: 'PUT',
                url: msApi.getApiUrl('contracts/' + data.id),
                data: data//angular.toJson(data)
            }).success(function (req) {
                // Dummy save action
                for (var i = 0; i < vm.contracts.data.length; i++) {
                    if (vm.contracts.data[i].id === vm.contract.id) {
                        vm.contracts.data[i] = req;//angular.copy(vm.contract);
                        break;
                    }
                }
                var str = Date.parse(new Date())+'';
                vm.pay.created_at =  str.substr(0,str.length-3);
                vm.pay.updated_at = vm.pay.created_at;
                var data1 = angular.copy(vm.pay);
                //data1.pay_date = (data1.pay_date).toISOString().slice(0,10);
                data1.pay_date = $filter("date")(new Date(data1.pay_date), "yyyy-MM-dd");
                $http({
                    method: 'POST',
                    url: msApi.getApiUrl('pays'),
                    data: angular.toJson(data1)
                }).success(function (req) {
                    $rootScope.message_success = '操作成功!';
                    $timeout(function(){$rootScope.message_success = '';},5000);
                    closeDialog();
                }).error(function(data, state) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function(){$rootScope.message_danger = '';},5000);
                });
                //$rootScope.message_success = '操作成功!';
                //$timeout(function(){$rootScope.message_success = '';},5000);
                //closeDialog();
            }).error(function (data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }

        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }
        // 七牛 文件上传 >>>>>>>>>>>>>>>>>>
        msApi.request('store.users.list@get', {'act': 'upToken'}).then(
            function (response){
                vm.upToken = response.data.upToken;
                vm.upHost  = response.data.upHost;
            });
        vm.selectFiles = [];
        var start = function (index) {
            vm.selectFiles[index].progress = {
                p: 0
            };
            vm.selectFiles[index].upload = $qupload.upload({
                key: 'pay/'+$filter("date")(new Date(), "yyyyMMdd")+'/'+$filter("date")(new Date(), "HHmmss")+'.jpg',
                file: vm.selectFiles[index].file,
                token: vm.upToken
            });
            vm.selectFiles[index].upload.then(function (response) {
                // upload success
                //$log.info(response);
                //console.log("upload success");
                //console.log(response);
                vm.pay.attach = vm.upHost+response.key;
            }, function (response) {
                // upload failure
                //$log.info(response);
                //console.log("upload failure");
                //console.log(response);
            }, function (evt) {
                // progress
                vm.selectFiles[index].progress.p = Math.floor(100 * evt.loaded / evt.totalSize);
            });
        };
        vm.abort = function (index) {
            vm.selectFiles[index].upload.abort();
            vm.selectFiles.splice(index, 1);
        };
        vm.onFileSelect = function ($files) {
            var offsetx = vm.selectFiles.length;
            for (var i = 0; i < $files.length; i++) {
                vm.selectFiles[i + offsetx] = {
                    file: $files[i]
                };
                start(i + offsetx);
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.store.contracts')
        .controller('AllowDialogController', AllowDialogController);

    /** @ngInject */
    function AllowDialogController($rootScope, $timeout, $mdDialog, $filter, course, data, error, is_allow, msApi, $http, $cookies,$location) {
        var vm = this;
        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00') return new Date(str);
        }

        // Data
        vm.title = '确认';
        vm.is_allow = is_allow;
        vm.course = course;
        vm.data = data;
        vm.error = error;
        var store_id = $cookies.get('store_id');
        vm.save = save;
        vm.closeDialog = closeDialog;

        /**
         * Save task
         */
        function save() {
            $http({
                method: 'POST',
                url: msApi.getApiUrl('signups'),
                data: vm.data
            }).success(function (req) {
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                closeDialog();
                $location.path("/store/courses/detail/" + vm.course.id);
            }).error(function (data, status) {
                $location.path("/store/courses/detail/" + vm.course.id);
            });
        }

        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide().then(function(){

            });
        }
    }
})();
(function () {
    'use strict';

    angular
        .module('app.store.contracts')
        .controller('ContractDialogController', ContractDialogController);

    /** @ngInject */
    function ContractDialogController($rootScope, $timeout, $mdDialog, $filter, Contract, Contracts, is_cud, event, msApi, $http, $cookies) {
        var vm = this;
        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00') return moment(str).toDate();
        }
        vm.countFlexSize = function(mLength){
            if (mLength>4) return 100/25;
            return parseInt(100/mLength);
        }
        // Data
        vm.title = '编辑';
        vm.is_cud = is_cud;
        //合同
        vm.contracts = Contracts;
        //vm.contract = angular.copy(Contract);
        vm.contract = Contract;
        // console.log(vm.contract);
        vm.selected = [];
        vm.initContractPlan = vm.contract?vm.contract.plan_id:-1;//保存最开始的计划id，当改变plan时，要给出提示

        var store_id = $cookies.get('store_id');
        vm.newContract = false;
        if (!vm.contract) {
            vm.contract = {
                'id': '',
                'customer_id': '',
                'customer_name': '',
                'customer_sex':'',
                'customer_nickname': '',
                'customer_birthday':'',
                'contact_guid': 'HT'+new Date().getTime(),
                'contract_type_id': 0,
                'contract_type': '',
                'pay_type_id': 0,
                'pay_type': '',
                'card_type_id':0,
                'card_type':'',
                'can_leave_times': 0,
                'can_leave_times1': 0,
                'amount': '',
                'start_date': new Date(),
                'end_date': new Date(),
                'store_id': store_id,
                'remarks': '',
                'consult_id': 0,
                'consult_name': '',
                'plan_id':0,
                'plan_title': '',
                'status': 1,
                'sign_date': new Date()
                // 'ContractsHasCourses': [
                //     {'contracts_id':'', 'course_category_id':'', 'categories_name':'', 'course_number':'', 'course_number_ remaining':''}
                // ]

            };
            vm.title = '添加';
            vm.newContract = true;
        }else {
            vm.contract.start_date = vm.StrToDate(vm.contract.start_date);
            vm.contract.end_date = vm.StrToDate(vm.contract.end_date);
            vm.contract.sign_date = vm.StrToDate(vm.contract.sign_date);

        }
        
        //销售顾问
        msApi.request('store.contracts.consults@get', {'store_id': store_id, 'role_id': 5}).then(
            function (response) {
                vm.consults = response.data;
            });

        //学生信息
        /*msApi.request('store.contracts.customers@get', {'store_id': store_id,"act":'all'}).then(
         function (response){
            vm.customers = response.data;
             console.log(vm.customers);
         });
        console.log(vm.customers);*/
        // 合同卡类型
        msApi.request('store.contracts.categories@get', {'store_id': store_id, 'type': '3', 'per-page': 200}).then(
            function (response) {
                vm.card_types = response.data;
                angular.forEach(vm.card_types ,function (v,k) {
                    if(v.name == vm.contract.card_type){
                        vm.contract.card_type_id = v.id;
                    }
                });

            });

        // 合同卡项
        msApi.request('store.contracts.categories@get', {'store_id': store_id, 'type': '4', 'per-page': 200}).then(
            function (response) {
                vm.contract_types = response.data;
            });

        // 支付类型
        msApi.request('store.contracts.categories@get', {'store_id': store_id, 'type': '5', 'per-page': 200}).then(
            function (response) {
                vm.pay_types = response.data;
                angular.forEach(vm.pay_types ,function (v,k) {
                    if(v.name == vm.contract.pay_type){
                        vm.contract.pay_type_id = v.id;
                    }
                });

            });

        // 合同状态
        msApi.request('store.contracts.categories@get', {'store_id': store_id, 'act': 'contracts_status', 'per-page': 200}).then(
            function (response) {
                vm.contracts_status = response.data;
            });
        // 课程分类
        msApi.request('store.contracts.categories@get', {'store_id': store_id, 'type': '1', 'per-page': 200}).then(
            function (response) {
                vm.course_categorys = response.data;
                if (vm.contract.ContractsHasCourses) {
                    angular.forEach(vm.contract.ContractsHasCourses, function (v, k) {
                        for (var i = 0; i < vm.course_categorys.length; i++) {
                            if (vm.course_categorys[i].id == v.course_category_id) {
                                vm.selected.push(vm.course_categorys[i]);
                                // console.log(vm.selected);
                                break;
                            }
                        }
                    });
                }
            });


        vm.toggle = function (item, list) {
            var idx = list.indexOf(item);
            if (idx > -1) {
                list.splice(idx, 1);
                angular.forEach(vm.contract.ContractsHasCourses, function (v, k) {
                    if(v.course_category_id == item.id){
                        v.course_category_checkbox = false;
                    }
                });
            }
            else {
                list.push(item);
                angular.forEach(vm.contract.ContractsHasCourses, function (v, k) {
                    if(v.course_category_id == item.id){
                        v.course_category_checkbox = true;
                    }
                });
            }
            console.log(vm.contract.ContractsHasCourses);
        };

        vm.exists = function (item, list) {
            return list.indexOf(item) > -1;
        };

        // Methods
        vm.addNewContract = addNewContract;
        vm.saveContract = saveContract;
        vm.deleteContract = deleteContract;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Add new task
         */
        function addNewContract() {
            vm.contract.update_time = moment().format("YYYY-MM-DD HH:mm:ss");
            var data = angular.copy(vm.contract);
            /*data.start_date = (data.start_date).toISOString().slice(0,10);
            data.end_date = (data.end_date).toISOString().slice(0,10);
            data.sign_date = (data.sign_date).toISOString().slice(0,10);*/
            data.start_date = moment(data.start_date).format("YYYY-MM-DD");
            data.end_date = moment(data.end_date).format("YYYY-MM-DD");
            data.sign_date = moment(data.sign_date).format("YYYY-MM-DD");
            angular.forEach(vm.contract_types ,function (v,k){
                if(v.name == vm.contract.contract_type){
                    data.contract_type_id = v.id;
                }
            });
            angular.forEach(vm.card_types ,function (v,k) {
                if(v.id == vm.contract.card_type_id){
                    data.card_type = v.name;
                }
            });
            angular.forEach(vm.pay_types ,function (v,k) {
                if(v.id == vm.contract.pay_type_id){
                    data.pay_type = v.name;
                }
            });
            angular.forEach(vm.consults, function (v, k) {
                if (v['id'] == data.consult_id) {
                    data.consult_name = v['name'];
                }
            });
            angular.forEach(vm.contracts_status, function (v, k) {
                if (v['id'] == data.status) {
                    data.status_name = v['name'];
                }
            });
            angular.forEach(data.ContractsHasCourses, function (v, k) {
                if(v != undefined) {
                    if ("course_number" in v) {
                        v.course_category_id = k;
                        angular.forEach(vm.course_categorys, function (va, ke) {
                            if (k == va.id) {
                                v.categories_name = va.name;
                                v.course_number_remaining = v.course_number;
                            }
                        });
                    }
                    else {
                        delete vm.contract.ContractsHasCourses[k];
                    }
                }
            });
            if(data.ContractsHasCourses.length ==0){
                alert('请选择课程分类');
                return false;
            }
            $http({
                method: 'POST',
                url: msApi.getApiUrl('contracts'),
                data: angular.toJson(data)
            }).success(function (req) {
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);

                vm.contract.id = req.id;
                if (vm.contracts) vm.contracts.data.unshift(req);
                closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }

        /**
         * Save task
         */
        function saveContract() {
            vm.contract.update_time = moment().format("YYYY-MM-DD HH:mm:ss");
            var data = angular.copy(vm.contract);
            console.log(data.ContractsHasCourses);

            data.start_date = moment(data.start_date).format("YYYY-MM-DD");
            data.end_date = moment(data.end_date).format("YYYY-MM-DD");
            data.sign_date = moment(data.sign_date).format("YYYY-MM-DD");

            console.log(data);
            angular.forEach(vm.contract_types ,function (v,k) {
                if(v.name == vm.contract.contract_type){
                    data.contract_type_id = v.id;
                }
            });
            angular.forEach(vm.card_types ,function (v,k) {
                if(v.id == vm.contract.card_type_id){
                    data.card_type = v.name;
                }
            });
            angular.forEach(vm.pay_types ,function (v,k) {
                if(v.id == vm.contract.pay_type_id){
                    data.pay_type = v.name;
                }
            });
            angular.forEach(vm.consults, function (v, k) {
                if (v['id'] == data.consult_id) {
                    data.consult_name = v['name'];
                }
            });
            angular.forEach(vm.contracts_status, function (v, k) {
                if (v['id'] == data.status) {
                    data.status_name = v['name'];
                }
            });
            /*angular.forEach(data.ContractsHasCourses, function (v, k) {
                v.course_category_id = k;
                angular.forEach(vm.course_categorys, function (va, ke) {
                    if (k == va.id) {
                        v.categories_name = va.name;
                    }
                });
            });*/
            angular.forEach(data.ContractsHasCourses, function (v, k) {
                if(v != undefined) {
                    if ("course_number" in v) {
                        v.course_category_id = k;
                        angular.forEach(vm.course_categorys, function (va, ke) {
                            if (k == va.id) {
                                v.categories_name = va.name;
                            }
                        });
                    }
                    else {
                        delete data.ContractsHasCourses[k];
                    }
                }
            });
            if(data.ContractsHasCourses.length ==0){
                data.ContractsHasCourses = [];
                alert('请选择课程分类');
                return false;
            }


            var postData = function(){
                $http({
                    method: 'PUT',
                    url: msApi.getApiUrl('contracts/' + data.id),
                    data: data//angular.toJson(data)
                }).success(function (req) {
                    // Dummy save action
                    if (vm.contracts){
                        for (var i = 0; i < vm.contracts.data.length; i++) {
                            if (vm.contracts.data[i].id === vm.contract.id) {
                                vm.contracts.data[i] = req;//angular.copy(vm.contract);
                                break;
                            }
                        }
                    }
                    $rootScope.message_success = '操作成功!';
                    $timeout(function(){$rootScope.message_success = '';},5000);
                    closeDialog();
                }).error(function (data, state) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function(){$rootScope.message_danger = '';},5000);
                });
            }

            if (vm.initContractPlan!=vm.contract.plan_id){
                var confirm = $mdDialog.confirm({skipHide: true})
                .title('确认要更改本合同原有计划？')
                .content('当前合同您更改了原有当课程计划，原来课程计划下的课程都会被删除。请谨慎使用')
                .ariaLabel('删除合同')
                .ok('提交')
                .cancel('取消');
                //.targetEvent(event);
                $mdDialog.show(confirm).then(function () {
                    postData();
                }, function ()
                {
                    // Cancel Action
                });
            }else{
                postData();
            }
            

            
        }

        /**
         * Delete task
         */
        function deleteContract() {
            var confirm = $mdDialog.confirm()
                .title('删除确认操作?')
                .content('确认要删除此合同吗.')
                .ariaLabel('删除合同')
                .ok('删除')
                .cancel('取消');
                //.targetEvent(event);

            $mdDialog.show(confirm).then(function () {
                var data = angular.copy(vm.contract);
                data.status = 0;
                data.start_date = moment(data.start_date).format("YYYY-MM-DD");
                data.end_date = moment(data.end_date).format("YYYY-MM-DD");
                data.sign_date = moment(data.sign_date).format("YYYY-MM-DD");
                $http({
                    method: 'PUT',
                    url: msApi.getApiUrl('contracts/' + data.id),
                    data: data
                }).success(function (req) {
                    if (vm.contracts){
                        vm.contracts.data.splice(vm.contracts.data.indexOf(vm.contract), 1);
                    }
                    $rootScope.message_success = '操作成功!';
                    $timeout(function () {
                        $rootScope.message_success = '';
                    }, 5000);
                }).error(function (data, state) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function () {
                        $rootScope.message_danger = '';
                    }, 5000);
                });
            }, function ()
            {
                // Cancel Action
            });
        }


        /**
         * New tag
         *
         * @param chip
         * @returns {{label: *, color: string}}
         */
        function newTag(chip) {
            var tagColors = ['#388E3C', '#F44336', '#FF9800', '#0091EA', '#9C27B0'];

            return {
                name: chip,
                label: chip,
                color: tagColors[Math.floor(Math.random() * (tagColors.length))]
            };
        }

        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide().then(function(){
                /*vm.contract.start_date = (vm.contract.start_date).toISOString().slice(0,10);
                vm.contract.end_date = (vm.contract.end_date).toISOString().slice(0,10);
                vm.contract.sign_date = (vm.contract.sign_date).toISOString().slice(0,10);*/
                vm.contract.start_date = moment(vm.contract.start_date).format("YYYY-MM-DD");
                vm.contract.end_date = moment(vm.contract.end_date).format("YYYY-MM-DD");
                vm.contract.sign_date = moment(vm.contract.sign_date).format("YYYY-MM-DD");
            });
        }
        vm.customers = {};
        vm.simulateQuery = false;
        vm.isDisabled = false;
        vm.noCache = true;
        vm.searchText = vm.newContract ? '' : vm.contract.customer_name;
        vm.selectedItem = vm.newContract ? '' : {'value' : vm.contract.customer_name, 'display' : vm.contract.customer_name};
        //vm.states = loadAll();
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.customesall = {};

        function querySearch(query) {
            if(query){
                var results = vm.states.filter(createFilterFor(query));
            }

            //var results = query ? vm.states.filter(createFilterFor(query)) : vm.states,
            var deferred;
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function () {
                    deferred.resolve(results);
                }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }
        // 搜索学生
        function searchTextChange(text) {
            if(text){
               $http.get(msApi.getApiUrl('customers'), {params: {'store_id':store_id, 'keyword':text, 'act': 'searched'}}).success(function (results) {
                   vm.customers = results.data;
                   vm.customesall = loadAll();
                   $('#customer-auto').find('input[type="search"]').focus();
                   return vm.customesall;
                });
            }else {
                vm.customesall = [];
                return vm.customesall;
            }
        }
        vm.selectedPlanItem = vm.newContract||!vm.contract.plan_id ? '' : {'value' : vm.contract.plan_id, 'display' : vm.contract.plan_title};
        vm.searchPlanText = "";
        vm.plans = {};
        vm.plansall = [];
        // 搜索教学计划
        vm.searchPlans = function(text) {
            // if(text){
                $http.get(msApi.getApiUrl('plans'), {params: {'title':text,'sort': 'title','per-page':100}}).success(function (results) {
                    vm.plans = results.data;
                    vm.plansall = [];
                    angular.forEach(vm.plans, function (item, index) {
                        item.value = item.id;
                        item.display = item.title;
                        vm.plansall.push(item);
                    });
                    $('#plans-auto').find('input[type="search"]').focus();
                    return vm.plansall;
                });
            // }else {
            //     vm.plansall = [];
            //     return vm.plansall;
            // }
        }
        vm.searchPlans("");//拉出所有的学习计划
        //选中某个教学计划触发事件
        vm.selectedPlanItemChange = function(item){
            if (item){
                vm.contract.plan_id = item.id;
                vm.contract.plan_title = item.title;
            }else{
                vm.contract.plan_id = null;
                vm.contract.plan_title = "";
            }
        }


        msApi.register('store.courses.contracts', [msApi.getApiUrl() + 'contracts']);
        // 预约状态

        function selectedItemChange(item) {
            //console.log(item);
            if(item){
                vm.contract.customer_name = item.value;
                angular.forEach(vm.customers, function (v, k) {

                    if (v['name'] == item.value) {
                        var data = {
                            'act': 'contractnum',
                            'customer_id': v['id']
                        };
                        vm.contract.customer_id = v['id'];
                        vm.contract.customer_sex = v['sex_text'];
                        vm.contract.customer_birthday = v['birthday_month'];
                        vm.contract.customer_nickname = v['nickname'];
                        msApi.request('store.courses.contracts@get',data).then(
                            function (response) {
                                vm.contract.contact_guid = response.data.contract_num;
                            });
                    }
                });
            }else{
                vm.contract.customer_name = '';
                vm.contract.contact_guid = '';
            }
        }
        function loadAll() {
            var allStates = '';
            angular.forEach(vm.customers, function (v, k) {
                allStates = allStates + v.name + ', ';
            });
            allStates = allStates.substr(0, allStates.length - 2);
            return allStates.split(/, +/g).map(
                function (state) {
                    return {
                        value: state,//.toLowerCase(),
                        display: state
                    };
                });
        }
        function loadPlansAll() {
            var allPlans = [];
            angular.forEach(vm.plans, function (item, index) {
                array_push(allPlans,{value:id,display:title});
            });
            return allPlans;
        }

        function createFilterFor(query) {
            var lowercaseQuery = query;//angular.lowercase(query);
            return function filterFn(state) {
                return (state.value.indexOf(lowercaseQuery) === 0);
            };
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store.calendar',
            [
                // 3rd Party Dependencies
                'ui.calendar'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, msApiProvider)
    {
        var store_id = msApiProvider.getCookies('store_id');
        // State
        $stateProvider.state('app.store.calendar', {
            url      : '/calendar',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/store/calendar/calendar.html',
                    controller : 'StoreCalendarController as vm'
                }
            },
            resolve  : {
                // Courses: function (msApi){
                //     return msApi.resolve('store.calendar.courses@get', {'store_id': store_id});
                // }
        },
            bodyClass: 'calendar'
        });
        msApiProvider.register('store.calendar.courses', [msApiProvider.getApiUrl() + 'courses']);
        msApiProvider.register('store.teachers.list', [msApiProvider.getApiUrl() + 'users']);// 老师

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/store/calendar');

        // Navigation
        msNavigationServiceProvider.saveItem('store.calendar', {
            title : 'Calendar',
            icon  : 'icon-calendar-today',
            state : 'app.store.calendar',
            weight: 2
        });
    }
})();
(function ()
{
    'use strict';

    angular.module('app.store.calendar')
        .controller('StoreEventFormDialogController', StoreEventFormDialogController);

    /** @ngInject */
    function StoreEventFormDialogController($mdDialog, dialogData)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.notifications = ['15 minutes before', '30 minutes before', '1 hour before'];

        // Methods
        vm.saveEvent = saveEvent;
        vm.removeEvent = removeEvent;
        vm.closeDialog = closeDialog;

        init();

        //////////

        /**
         * Initialize
         */
        function init()
        {
            // Figure out the title
            switch ( vm.dialogData.type )
            {
                case 'add' :
                    vm.dialogTitle = 'Add Event';
                    break;

                case 'edit' :
                    vm.dialogTitle = 'Add Event';
                    break;

                default:
                    break;
            }

            // Edit
            if ( vm.dialogData.calendarEvent )
            {
                // Clone the calendarEvent object before doing anything
                // to make sure we are not going to brake FullCalendar
                vm.calendarEvent = angular.copy(vm.dialogData.calendarEvent);

                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.calendarEvent.start) )
                {
                    vm.calendarEvent.start = vm.calendarEvent.start.toDate();
                }

                if ( moment.isMoment(vm.calendarEvent.end) )
                {
                    vm.calendarEvent.end = vm.calendarEvent.end.toDate();
                }
            }
            // Add
            else
            {
                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.dialogData.start) )
                {
                    vm.dialogData.start = vm.dialogData.start.toDate();
                }

                if ( moment.isMoment(vm.dialogData.end) )
                {
                    vm.dialogData.end = vm.dialogData.end.toDate();
                }

                vm.calendarEvent = {
                    start        : vm.dialogData.start,
                    end          : vm.dialogData.end,
                    notifications: []
                };
            }
        }

        /**
         * Save the event
         */
        function saveEvent()
        {
            // Convert the javascript date objects back to the moment.js dates
            var dates = {
                start: moment.utc(vm.calendarEvent.start),
                end  : moment.utc(vm.calendarEvent.end)
            };

            var response = {
                type         : vm.dialogData.type,
                calendarEvent: angular.extend({}, vm.calendarEvent, dates)
            };

            $mdDialog.hide(response);
        }

        /**
         * Remove the event
         */
        function removeEvent()
        {
            var response = {
                type         : 'remove',
                calendarEvent: vm.calendarEvent
            };

            $mdDialog.hide(response);
        }

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.store.calendar')
        .controller('StoreEventDetailDialogController', StoreEventDetailDialogController);

    /** @ngInject */
    function StoreEventDetailDialogController($mdDialog, calendarEvent, showEventFormDialog, event)
    {
        var vm = this;

        // Data
        vm.calendarEvent = calendarEvent;

        // Methods
        vm.editEvent = editEvent;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Edit the calendar event
         *
         * @param calendarEvent
         */
        function editEvent(calendarEvent)
        {
            showEventFormDialog('edit', calendarEvent, false, false, event);
        }
    }
})();


angular.module('toastDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope, $mdToast) {
  var last = {
      bottom: false,
      top: true,
      left: false,
      right: true
    };

  $scope.toastPosition = angular.extend({},last);

  $scope.getToastPosition = function() {
    sanitizePosition();

    return Object.keys($scope.toastPosition)
      .filter(function(pos) { return $scope.toastPosition[pos]; })
      .join(' ');
  };

  function sanitizePosition() {
    var current = $scope.toastPosition;

    if ( current.bottom && last.top ) current.top = false;
    if ( current.top && last.bottom ) current.bottom = false;
    if ( current.right && last.left ) current.left = false;
    if ( current.left && last.right ) current.right = false;

    last = angular.extend({},current);
  }

  $scope.showSimpleToast = function() {
    var pinTo = $scope.getToastPosition();

    $mdToast.show(
      $mdToast.simple()
        .textContent('Simple Toast!')
        .position(pinTo )
        .hideDelay(3000)
    );
  };

  $scope.showActionToast = function() {
    var pinTo = $scope.getToastPosition();
    var toast = $mdToast.simple()
      .textContent('Marked as read')
      .action('UNDO')
      .highlightAction(true)
      .highlightClass('md-accent')// Accent is used by default, this just demonstrates the usage.
      .position(pinTo);

    $mdToast.show(toast).then(function(response) {
      if ( response == 'ok' ) {
        alert('You clicked the \'UNDO\' action.');
      }
    });
  };

})

.controller('ToastCtrl', function($scope, $mdToast) {
  $scope.closeToast = function() {
    $mdToast.hide();
  };
});

(function () {
  'use strict';

    angular
      .module('virtualRepeatScrollToDemo', ['ngMaterial'])
      .controller('AppCtrl', function($scope) {
        this.selectedYear = 0;
        this.years = [];
        this.items = [];
        var currentYear = new Date().getFullYear();
        var monthNames = ['January', 'February', 'March', 'April', 'May', 'June',
          'July', 'August', 'September', 'October', 'November', 'December'];
        // Build a list of months over 20 years
        for (var y = currentYear; y >= (currentYear-20); y--) {
          this.years.push(y);
          this.items.push({year: y, text: y, header: true});
          for (var m = 11; m >= 0; m--) {
            this.items.push({year: y, month: m, text: monthNames[m]});
          }
        }
        // Whenever a different year is selected, scroll to that year
        $scope.$watch('ctrl.selectedYear', angular.bind(this, function(yearIndex) {
          var scrollYear = Math.floor(this.topIndex / 13);
          if(scrollYear !== yearIndex) {
            this.topIndex = yearIndex * 13;
          }
        }));
        // The selected year should follow the year that is at the top of the scroll container
        $scope.$watch('ctrl.topIndex', angular.bind(this, function(topIndex) {
          var scrollYear = Math.floor(topIndex / 13);
          this.selectedYear = scrollYear;
        }));
      });

})();

angular.module('whiteframeDirectiveUsage', ['ngMaterial']);

angular.module('whiteframedemoDirectiveInterpolationUsage', ['ngMaterial'])
    .controller('DemoCtrl', function($interval) {
      this.elevation = 1;
      this.showFrame = 3;
      
      this.nextElevation = function() {
        if (++this.elevation == 25) {
          this.elevation = 1;
        }
      };

      $interval(this.nextElevation.bind(this), 500);
      
      this.toggleFrame = function() {
        this.showFrame = this.showFrame == 3 ? -1 : 3;
      };
    });

angular.module('whiteframeBasicUsage', ['ngMaterial']);

(function () {
  'use strict';

    angular
      .module('virtualRepeatVerticalDemo', ['ngMaterial'])
      .controller('AppCtrl', function() {
        this.items = [];
        for (var i = 0; i < 1000; i++) {
          this.items.push(i);
        }
      });

})();

(function () {
  'use strict';

    angular
      .module('virtualRepeatInfiniteScrollDemo', ['ngMaterial'])
      .controller('AppCtrl', function($timeout) {

        // In this example, we set up our model using a plain object.
        // Using a class works too. All that matters is that we implement
        // getItemAtIndex and getLength.
        this.infiniteItems = {
          numLoaded_: 0,
          toLoad_: 0,

          // Required.
          getItemAtIndex: function(index) {
            if (index > this.numLoaded_) {
              this.fetchMoreItems_(index);
              return null;
            }

            return index;
          },

          // Required.
          // For infinite scroll behavior, we always return a slightly higher
          // number than the previously loaded items.
          getLength: function() {
            return this.numLoaded_ + 5;
          },

          fetchMoreItems_: function(index) {
            // For demo purposes, we simulate loading more items with a timed
            // promise. In real code, this function would likely contain an
            // $http request.

            if (this.toLoad_ < index) {
              this.toLoad_ += 20;
              $timeout(angular.noop, 300).then(angular.bind(this, function() {
                this.numLoaded_ = this.toLoad_;
              }));
            }
          }
        };
      });

})();

(function () {
  'use strict';

    angular
      .module('virtualRepeatHorizontalDemo', ['ngMaterial'])
      .controller('AppCtrl', function() {
        this.items = [];
        for (var i = 0; i < 1000; i++) {
          this.items.push(i);
        }
      });

})();

(function () {
  'use strict';

    angular
      .module('virtualRepeatDeferredLoadingDemo', ['ngMaterial'])
      .controller('AppCtrl', function($timeout) {

        // In this example, we set up our model using a class.
        // Using a plain object works too. All that matters
        // is that we implement getItemAtIndex and getLength.
        var DynamicItems = function() {
          /**
           * @type {!Object<?Array>} Data pages, keyed by page number (0-index).
           */
          this.loadedPages = {};

          /** @type {number} Total number of items. */
          this.numItems = 0;

          /** @const {number} Number of items to fetch per request. */
          this.PAGE_SIZE = 50;

          this.fetchNumItems_();
        };

        // Required.
        DynamicItems.prototype.getItemAtIndex = function(index) {
          var pageNumber = Math.floor(index / this.PAGE_SIZE);
          var page = this.loadedPages[pageNumber];

          if (page) {
            return page[index % this.PAGE_SIZE];
          } else if (page !== null) {
            this.fetchPage_(pageNumber);
          }
        };

        // Required.
        DynamicItems.prototype.getLength = function() {
          return this.numItems;
        };

        DynamicItems.prototype.fetchPage_ = function(pageNumber) {
          // Set the page to null so we know it is already being fetched.
          this.loadedPages[pageNumber] = null;

          // For demo purposes, we simulate loading more items with a timed
          // promise. In real code, this function would likely contain an
          // $http request.
          $timeout(angular.noop, 300).then(angular.bind(this, function() {
            this.loadedPages[pageNumber] = [];
            var pageOffset = pageNumber * this.PAGE_SIZE;
            for (var i = pageOffset; i < pageOffset + this.PAGE_SIZE; i++) {
              this.loadedPages[pageNumber].push(i);
            }
          }));
        };

        DynamicItems.prototype.fetchNumItems_ = function() {
          // For demo purposes, we simulate loading the item count with a timed
          // promise. In real code, this function would likely contain an
          // $http request.
          $timeout(angular.noop, 300).then(angular.bind(this, function() {
            this.numItems = 50000;
          }));
        };
        
        this.dynamicItems = new DynamicItems();
      });
})();

angular.module('tooltipDemo1', ['ngMaterial'])
.controller('AppCtrl', function($scope) {
  $scope.demo = {
    showTooltip : false,
    tipDirection : ''
  };

  $scope.demo.delayTooltip = undefined;
  $scope.$watch('demo.delayTooltip',function(val) {
    $scope.demo.delayTooltip = parseInt(val, 10) || 0;
  });

  $scope.$watch('demo.tipDirection',function(val) {
    if (val && val.length ) {
      $scope.demo.showTooltip = true;
    }
  })
});


angular.module('toolbarDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

});

angular.module('toolbarDemo2', ['ngMaterial'])

.controller('TitleController', function($scope) {
  $scope.title = 'My App Title';
})
.controller('AppCtrl', function($scope) {
  var imagePath = 'assets/angular-material-assets/img/list/60.jpeg';

  $scope.todos = [];
  for (var i = 0; i < 15; i++) {
    $scope.todos.push({
      face: imagePath,
      what: "Brunch this weekend?",
      who: "Min Li Chan",
      notes: "I'll be in your neighborhood doing errands."
    });
  }
});

(function() {

  var isDlgOpen;

  angular
    .module('toastDemo2', ['ngMaterial'])
    .controller('AppCtrl', function($scope, $mdToast) {
      $scope.showCustomToast = function() {
        $mdToast.show({
          hideDelay   : 3000,
          position    : 'top right',
          controller  : 'ToastCtrl',
          templateUrl : 'toast-template.html'
        });
      };
    })
    .controller('ToastCtrl', function($scope, $mdToast, $mdDialog) {

      $scope.closeToast = function() {
        if (isDlgOpen) return;

        $mdToast
          .hide()
          .then(function() {
            isDlgOpen = false;
          });
      };

      $scope.openMoreInfo = function(e) {
        if ( isDlgOpen ) return;
        isDlgOpen = true;

        $mdDialog
          .show($mdDialog
            .alert()
            .title('More info goes here.')
            .textContent('Something witty.')
            .ariaLabel('More info')
            .ok('Got it')
            .targetEvent(e)
          )
          .then(function() {
            isDlgOpen = false;
          })
      };
    });

})();

(function () {
  'use strict';

  angular
      .module('tabsDemoStaticTabs', ['ngMaterial'] )
      .controller('AppCtrl', AppCtrl);

  function AppCtrl ( $scope ) {
    $scope.data = {
      selectedIndex: 0,
      secondLocked:  true,
      secondLabel:   "Item Two",
      bottom:        false
    };
    $scope.next = function() {
      $scope.data.selectedIndex = Math.min($scope.data.selectedIndex + 1, 2) ;
    };
    $scope.previous = function() {
      $scope.data.selectedIndex = Math.max($scope.data.selectedIndex - 1, 0);
    };
  }
})();

(function () {
  'use strict';
  angular
      .module('tabsDemoDynamicTabs', ['ngMaterial'])
      .controller('AppCtrl', AppCtrl);

  function AppCtrl ($scope, $log) {
    var tabs = [
          { title: 'One', content: "Tabs will become paginated if there isn't enough room for them."},
          { title: 'Two', content: "You can swipe left and right on a mobile device to change tabs."},
          { title: 'Three', content: "You can bind the selected tab via the selected attribute on the md-tabs element."},
          { title: 'Four', content: "If you set the selected tab binding to -1, it will leave no tab selected."},
          { title: 'Five', content: "If you remove a tab, it will try to select a new one."},
          { title: 'Six', content: "There's an ink bar that follows the selected tab, you can turn it off if you want."},
          { title: 'Seven', content: "If you set ng-disabled on a tab, it becomes unselectable. If the currently selected tab becomes disabled, it will try to select the next tab."},
          { title: 'Eight', content: "If you look at the source, you're using tabs to look at a demo for tabs. Recursion!"},
          { title: 'Nine', content: "If you set md-theme=\"green\" on the md-tabs element, you'll get green tabs."},
          { title: 'Ten', content: "If you're still reading this, you should just go check out the API docs for tabs!"}
        ],
        selected = null,
        previous = null;
    $scope.tabs = tabs;
    $scope.selectedIndex = 2;
    $scope.$watch('selectedIndex', function(current, old){
      previous = selected;
      selected = tabs[current];
      if ( old + 1 && (old != current)) $log.debug('Goodbye ' + previous.title + '!');
      if ( current + 1 )                $log.debug('Hello ' + selected.title + '!');
    });
    $scope.addTab = function (title, view) {
      view = view || title + " Content View";
      tabs.push({ title: title, content: view, disabled: false});
    };
    $scope.removeTab = function (tab) {
      var index = tabs.indexOf(tab);
      tabs.splice(index, 1);
    };
  }
})();


angular.module('tabsDemoDynamicHeight', ['ngMaterial']);
angular.module('switchDemo1', ['ngMaterial'])
.controller('SwitchDemoCtrl', function($scope) {
  $scope.data = {
    cb1: true,
    cb4: true,
    cb5: false
  };

  $scope.message = 'false';

  $scope.onChange = function(cbState) {
  	$scope.message = cbState;
  };
});

angular.module('demoSwipe', ['ngMaterial'])
  .controller('demoSwipeCtrl', function($scope) {
    $scope.onSwipeLeft = function(ev) {
      alert('You swiped left!!');
    };

    $scope.onSwipeRight = function(ev) {
      alert('You swiped right!!');
    };
    $scope.onSwipeUp = function(ev) {
      alert('You swiped up!!');
    };

    $scope.onSwipeDown = function(ev) {
      alert('You swiped down!!');
    };
  });


angular.module('subheaderBasicDemo', ['ngMaterial'])
.config(function($mdThemingProvider) {
  $mdThemingProvider.theme('altTheme')
    .primaryPalette('purple');
})
.controller('SubheaderAppCtrl', function($scope) {
    var imagePath = 'assets/angular-material-assets/img/list/60.jpeg';
    $scope.messages = [
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
    ];
});


angular.module('sliderDemo2', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

  $scope.vol = Math.floor(Math.random() * 100);
  $scope.bass = Math.floor(Math.random() * 100);
  $scope.master = Math.floor(Math.random() * 100);
});


angular.module('sliderDemo1', ['ngMaterial'])
  .config(function($mdIconProvider) {
    $mdIconProvider
      .iconSet('device', 'assets/angular-material-assets/img/icons/sets/device-icons.svg', 24);
  })
.controller('AppCtrl', function($scope) {

  $scope.color = {
    red: Math.floor(Math.random() * 255),
    green: Math.floor(Math.random() * 255),
    blue: Math.floor(Math.random() * 255)
  };

  $scope.rating1 = 3;
  $scope.rating2 = 2;
  $scope.rating3 = 4;

  $scope.disabled1 = Math.floor(Math.random() * 100);
  $scope.disabled2 = 0;
  $scope.disabled3 = 70;

  $scope.invert = Math.floor(Math.random() * 100);

  $scope.isDisabled = true;
});

angular
  .module('sidenavDemo1', ['ngMaterial'])
  .controller('AppCtrl', function ($scope, $timeout, $mdSidenav, $log) {
    $scope.toggleLeft = buildDelayedToggler('left');
    $scope.toggleRight = buildToggler('right');
    $scope.isOpenRight = function(){
      return $mdSidenav('right').isOpen();
    };

    /**
     * Supplies a function that will continue to operate until the
     * time is up.
     */
    function debounce(func, wait, context) {
      var timer;

      return function debounced() {
        var context = $scope,
            args = Array.prototype.slice.call(arguments);
        $timeout.cancel(timer);
        timer = $timeout(function() {
          timer = undefined;
          func.apply(context, args);
        }, wait || 10);
      };
    }

    /**
     * Build handler to open/close a SideNav; when animation finishes
     * report completion in console
     */
    function buildDelayedToggler(navID) {
      return debounce(function() {
        // Component lookup should always be available since we are not using `ng-if`
        $mdSidenav(navID)
          .toggle()
          .then(function () {
            $log.debug("toggle " + navID + " is done");
          });
      }, 200);
    }

    function buildToggler(navID) {
      return function() {
        // Component lookup should always be available since we are not using `ng-if`
        $mdSidenav(navID)
          .toggle()
          .then(function () {
            $log.debug("toggle " + navID + " is done");
          });
      }
    }
  })
  .controller('LeftCtrl', function ($scope, $timeout, $mdSidenav, $log) {
    $scope.close = function () {
      // Component lookup should always be available since we are not using `ng-if`
      $mdSidenav('left').close()
        .then(function () {
          $log.debug("close LEFT is done");
        });

    };
  })
  .controller('RightCtrl', function ($scope, $timeout, $mdSidenav, $log) {
    $scope.close = function () {
      // Component lookup should always be available since we are not using `ng-if`
      $mdSidenav('right').close()
        .then(function () {
          $log.debug("close RIGHT is done");
        });
    };
  });

angular
  .module('sidenavDemo2', ['ngMaterial'])
  .controller('AppCtrl', function ($scope, $timeout, $mdSidenav) {
    $scope.toggleLeft = buildToggler('left');
    $scope.toggleRight = buildToggler('right');

    function buildToggler(componentId) {
      return function() {
        $mdSidenav(componentId).toggle();
      }
    }
  });

angular.module('selectDemoValidation', ['ngMaterial', 'ngMessages'])
.controller('AppCtrl', function($scope) {
  $scope.clearValue = function() {
    $scope.quest = undefined;
    $scope.favoriteColor = undefined;
    $scope.myForm.$setPristine();;
  };
  $scope.save = function() {
    if ($scope.myForm.$valid) {
      $scope.myForm.$setSubmitted();
      alert('Form was valid.');
    } else {
      alert('Form was invalid!');
    }
  };
});

angular
    .module('selectDemoSelectedText', ['ngMaterial'])
    .controller('SelectedTextController', function($scope) {
      $scope.items = [1, 2, 3, 4, 5, 6, 7];
      $scope.selectedItem;
      $scope.getSelectedText = function() {
        if ($scope.selectedItem !== undefined) {
          return "You have selected: Item " + $scope.selectedItem;
        } else {
          return "Please select an item";
        }
      };
    });

angular
    .module('selectDemoSelectHeader', ['ngMaterial'])
    .controller('SelectHeaderController', function($scope, $element) {
      $scope.vegetables = ['Corn' ,'Onions' ,'Kale' ,'Arugula' ,'Peas', 'Zucchini'];
      $scope.searchTerm;
      $scope.clearSearchTerm = function() {
        $scope.searchTerm = '';
      };
      // The md-select directive eats keydown events for some quick select
      // logic. Since we have a search input here, we don't need that logic.
      $element.find('input').on('keydown', function(ev) {
          ev.stopPropagation();
      });
    });

angular.module('selectDemoOptionsAsync', ['ngMaterial'])
.controller('SelectAsyncController', function($timeout, $scope) {
  $scope.user = null;
  $scope.users = null;

  $scope.loadUsers = function() {

    // Use timeout to simulate a 650ms request.
    return $timeout(function() {

      $scope.users =  $scope.users  || [
        { id: 1, name: 'Scooby Doo' },
        { id: 2, name: 'Shaggy Rodgers' },
        { id: 3, name: 'Fred Jones' },
        { id: 4, name: 'Daphne Blake' },
        { id: 5, name: 'Velma Dinkley' }
      ];

    }, 650);
  };
});


angular
  .module('appDemoFontIconsWithClassnames', ['ngMaterial'])
  .controller('DemoCtrl', function( $scope ) {
      // Create list of font-icon names with color overrides
      var iconData = [
            {name: 'icon-home'        , color: "#777" },
            {name: 'icon-user-plus'   , color: "rgb(89, 226, 168)" },
            {name: 'icon-google-plus2', color: "#A00" },
            {name: 'icon-youtube4'    , color:"#00A" },
             // Use theming to color the font-icon
            {name: 'icon-settings'    , color:"#A00", theme:"md-warn md-hue-5"}
          ];

      // Create a set of sizes...
      $scope.sizes = [
        {size:48,padding:10},
        {size:36,padding:6},
        {size:24,padding:2},
        {size:12,padding:0}
      ];

      $scope.fonts = [].concat(iconData);



  })
  .config(function($mdThemingProvider){
    // Update the theme colors to use themes on font-icons
    $mdThemingProvider.theme('default')
          .primaryPalette("red")
          .accentPalette('green')
          .warnPalette('blue');
  });

angular
    .module('selectDemoOptGroups', ['ngMaterial'])
    .controller('SelectOptGroupController', function($scope) {
      $scope.sizes = [
          "small (12-inch)",
          "medium (14-inch)",
          "large (16-inch)",
          "insane (42-inch)"
      ];
      $scope.toppings = [
        { category: 'meat', name: 'Pepperoni' },
        { category: 'meat', name: 'Sausage' },
        { category: 'meat', name: 'Ground Beef' },
        { category: 'meat', name: 'Bacon' },
        { category: 'veg', name: 'Mushrooms' },
        { category: 'veg', name: 'Onion' },
        { category: 'veg', name: 'Green Pepper' },
        { category: 'veg', name: 'Green Olives' }
      ];
      $scope.selectedToppings = [];
      $scope.printSelectedToppings = function printSelectedToppings() {
        var numberOfToppings = this.selectedToppings.length;

        // If there is more than one topping, we add an 'and'
        // to be gramatically correct. If there are 3+ toppings
        // we also add an oxford comma.
        if (numberOfToppings > 1) {
          var needsOxfordComma = numberOfToppings > 2;
          var lastToppingConjunction = (needsOxfordComma ? ',' : '') + ' and ';
          var lastTopping = lastToppingConjunction +
              this.selectedToppings[this.selectedToppings.length - 1];
          return this.selectedToppings.slice(0, -1).join(', ') + lastTopping;
        }

        return this.selectedToppings.join('');
      };
    });

(function () {
  'use strict';
  angular
      .module('selectDemoBasic', ['ngMaterial'])
      .controller('AppCtrl', function() {
        this.userState = '';
        this.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
            'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
            'WY').split(' ').map(function (state) { return { abbrev: state }; });
      });
})();

angular
  .module('radioDemo2', ['ngMaterial'])
  .controller('ContactController', function($scope, $filter) {
    var self = this;

    self.contacts = [{
      'id': 1,
      'fullName': 'Maria Guadalupe',
      'lastName': 'Guadalupe',
      'title': "CEO, Found"
    }, {
      'id': 2,
      'fullName': 'Gabriel García Marquéz',
      'lastName': 'Marquéz',
      'title': "VP Sales & Marketing"
    }, {
      'id': 3,
      'fullName': 'Miguel de Cervantes',
      'lastName': 'Cervantes',
      'title': "Manager, Operations"
    }, {
      'id': 4,
      'fullName': 'Pacorro de Castel',
      'lastName': 'Castel',
      'title': "Security"
    }];
    self.selectedId = 2;
    self.selectedUser = function() {
      return $filter('filter')(self.contacts, { id: self.selectedId })[0].lastName;
    }
  });


angular
  .module('radioDemo1', ['ngMaterial'])
  .controller('AppCtrl', function($scope) {

    $scope.data = {
      group1 : 'Banana',
      group2 : '2',
      group3 : 'avatar-1'
    };

    $scope.avatarData = [{
        id: "avatars:svg-1",
        title: 'avatar 1',
        value: 'avatar-1'
      },{
        id: "avatars:svg-2",
        title: 'avatar 2',
        value: 'avatar-2'
      },{
        id: "avatars:svg-3",
        title: 'avatar 3',
        value: 'avatar-3'
    }];

    $scope.radioData = [
      { label: '1', value: 1 },
      { label: '2', value: 2 },
      { label: '3', value: '3', isDisabled: true },
      { label: '4', value: '4' }
    ];


    $scope.submit = function() {
      alert('submit');
    };

    $scope.addItem = function() {
      var r = Math.ceil(Math.random() * 1000);
      $scope.radioData.push({ label: r, value: r });
    };

    $scope.removeItem = function() {
      $scope.radioData.pop();
    };

  })
  .config(function($mdIconProvider) {
    $mdIconProvider.iconSet("avatars", 'assets/angular-material-assets/icons/avatar-icons.svg',128);
  });

angular.module('progressLinearDemo1', ['ngMaterial'])
  .config(function($mdThemingProvider) {
  })
  .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
    var self = this, j= 0, counter = 0;

    self.mode = 'query';
    self.activated = true;
    self.determinateValue = 30;
    self.determinateValue2 = 30;

    self.showList = [ ];

    /**
     * Turn off or on the 5 themed loaders
     */
    self.toggleActivation = function() {
        if ( !self.activated ) self.showList = [ ];
        if (  self.activated ) {
          j = counter = 0;
          self.determinateValue = 30;
          self.determinateValue2 = 30;
        }
    };

    $interval(function() {
      self.determinateValue += 1;
      self.determinateValue2 += 1.5;

      if (self.determinateValue > 100) self.determinateValue = 30;
      if (self.determinateValue2 > 100) self.determinateValue2 = 30;

        // Incrementally start animation the five (5) Indeterminate,
        // themed progress circular bars

        if ( (j < 2) && !self.showList[j] && self.activated ) {
          self.showList[j] = true;
        }
        if ( counter++ % 4 == 0 ) j++;

        // Show the indicator in the "Used within Containers" after 200ms delay
        if ( j == 2 ) self.contained = "indeterminate";

    }, 100, 0, true);

    $interval(function() {
      self.mode = (self.mode == 'query' ? 'determinate' : 'query');
    }, 7200, 0, true);
  }]);

(function() {
'use strict';

angular.module('panelAnimationsDemo', ['ngMaterial'])
    .controller('AnimationCtrl', AnimationCtrl)
    .controller('DialogCtrl', DialogCtrl);


function AnimationCtrl($mdPanel) {
  this._mdPanel = $mdPanel;
  this.openFrom = 'button';
  this.closeTo = 'button';
  this.animationType = 'none';
}


AnimationCtrl.prototype.showDialog = function() {
  var position = this._mdPanel.newPanelPosition()
      .absolute()
      .right()
      .top();

  var animation = this._mdPanel.newPanelAnimation();

  switch(this.openFrom) {
    case 'button':
      animation.openFrom('.animation-target');
      break;
    case 'corner':
      animation.openFrom({top:0, left:0});
      break;
    case 'bottom':
      animation.openFrom({
        top: document.documentElement.clientHeight,
        left: document.documentElement.clientWidth / 2 - 250
      });
  }
  switch(this.closeTo) {
    case 'button':
      animation.closeTo('.animation-target');
      break;
    case 'corner':
      animation.closeTo({top:0, left:0});
      break;
    case 'bottom':
      animation.closeTo({
        top: document.documentElement.clientHeight,
        left: document.documentElement.clientWidth / 2 - 250
      });
  }

  switch(this.animationType) {
    case 'custom':
      animation.withAnimation({
        open: 'demo-dialog-custom-animation-open',
        close: 'demo-dialog-custom-animation-close'
      });
      break;
    case 'slide':
      animation.withAnimation(this._mdPanel.animation.SLIDE);
      break;
    case 'scale':
      animation.withAnimation(this._mdPanel.animation.SCALE);
      break;
    case 'fade':
      animation.withAnimation(this._mdPanel.animation.FADE);
      break;
    case 'none':
      animation = undefined;
      break;
  }

  var config = {
    animation: animation,
    attachTo: angular.element(document.body),
    controller: DialogCtrl,
    controllerAs: 'ctrl',
    templateUrl: 'panel.tmpl.html',
    panelClass: 'demo-dialog-example',
    position: position,
    trapFocus: true,
    zIndex: 150,
    clickOutsideToClose: true,
    clickEscapeToClose: true,
    hasBackdrop: true,
  };

  this._mdPanel.open(config);
};


// Necessary to pass locals to the dialog template.
function DialogCtrl(mdPanelRef) {
  this._mdPanelRef = mdPanelRef;
}

DialogCtrl.prototype.closeDialog = function() {
  this._mdPanelRef && this._mdPanelRef.close();
};

})();

angular
  .module('progressCircularDemo1', ['ngMaterial'])
  .controller('AppCtrl', ['$interval',
    function($interval) {
      var self = this;

      self.activated = true;
      self.determinateValue = 30;

      // Iterate every 100ms, non-stop and increment
      // the Determinate loader.
      $interval(function() {

        self.determinateValue += 1;
        if (self.determinateValue > 100) {
          self.determinateValue = 30;
        }

      }, 100);
    }
  ]);

(function() {
'use strict';

angular.module('panelDemo', ['ngMaterial'])
    .controller('BasicDemoCtrl', BasicDemoCtrl)
    .controller('PanelDialogCtrl', PanelDialogCtrl);


function BasicDemoCtrl($mdPanel) {
  this._mdPanel = $mdPanel;

  this.desserts = [
    'Apple Pie',
    'Donut',
    'Fudge',
    'Cupcake',
    'Ice Cream',
    'Tiramisu'
  ];

  this.selected = {favoriteDessert: 'Donut'};
  this.disableParentScroll = false;
}


BasicDemoCtrl.prototype.showDialog = function() {
  var position = this._mdPanel.newPanelPosition()
      .absolute()
      .center();

  var config = {
    attachTo: angular.element(document.body),
    controller: PanelDialogCtrl,
    controllerAs: 'ctrl',
    disableParentScroll: this.disableParentScroll,
    templateUrl: 'panel.tmpl.html',
    hasBackdrop: true,
    panelClass: 'demo-dialog-example',
    position: position,
    trapFocus: true,
    zIndex: 150,
    clickOutsideToClose: true,
    escapeToClose: true,
    focusOnOpen: true
  };

  this._mdPanel.open(config);
};


BasicDemoCtrl.prototype.showMenu = function(ev) {
  var position = this._mdPanel.newPanelPosition()
      .relativeTo('.demo-menu-open-button')
      .addPanelPosition(this._mdPanel.xPosition.ALIGN_START, this._mdPanel.yPosition.BELOW);

  var config = {
    attachTo: angular.element(document.body),
    controller: PanelMenuCtrl,
    controllerAs: 'ctrl',
    template:
        '<div class="demo-menu-example" ' +
        '     aria-label="Select your favorite dessert." ' +
        '     role="listbox">' +
        '  <div class="demo-menu-item" ' +
        '       ng-class="{selected : dessert == ctrl.favoriteDessert}" ' +
        '       aria-selected="{{dessert == ctrl.favoriteDessert}}" ' +
        '       tabindex="-1" ' +
        '       role="option" ' +
        '       ng-repeat="dessert in ctrl.desserts" ' +
        '       ng-click="ctrl.selectDessert(dessert)"' +
        '       ng-keydown="ctrl.onKeydown($event, dessert)">' +
        '    {{ dessert }} ' +
        '  </div>' +
        '</div>',
    panelClass: 'demo-menu-example',
    position: position,
    locals: {
      'selected': this.selected,
      'desserts': this.desserts
    },
    openFrom: ev,
    clickOutsideToClose: true,
    escapeToClose: true,
    focusOnOpen: false,
    zIndex: 2
  };

  this._mdPanel.open(config);
};


function PanelDialogCtrl(mdPanelRef) {
  this._mdPanelRef = mdPanelRef;
}


PanelDialogCtrl.prototype.closeDialog = function() {
  var panelRef = this._mdPanelRef;

  panelRef && panelRef.close().then(function() {
    angular.element(document.querySelector('.demo-dialog-open-button')).focus();
    panelRef.destroy();
  });
};



function PanelMenuCtrl(mdPanelRef, $timeout) {
  this._mdPanelRef = mdPanelRef;
  this.favoriteDessert = this.selected.favoriteDessert;
  $timeout(function() {
    var selected = document.querySelector('.demo-menu-item.selected');
    if (selected) {
      angular.element(selected).focus();
    } else {
      angular.element(document.querySelectorAll('.demo-menu-item')[0]).focus();
    }
  });
}


PanelMenuCtrl.prototype.selectDessert = function(dessert) {
  this.selected.favoriteDessert = dessert;
  this._mdPanelRef && this._mdPanelRef.close().then(function() {
    angular.element(document.querySelector('.demo-menu-open-button')).focus();
  });
};


PanelMenuCtrl.prototype.onKeydown = function($event, dessert) {
  var handled;
  switch ($event.which) {
    case 38: // Up Arrow.
      var els = document.querySelectorAll('.demo-menu-item');
      var index = indexOf(els, document.activeElement);
      var prevIndex = (index + els.length - 1) % els.length;
      els[prevIndex].focus();
      handled = true;
      break;

    case 40: // Down Arrow.
      var els = document.querySelectorAll('.demo-menu-item');
      var index = indexOf(els, document.activeElement);
      var nextIndex = (index + 1) % els.length;
      els[nextIndex].focus();
      handled = true;
      break;

    case 13: // Enter.
    case 32: // Space.
      this.selectDessert(dessert);
      handled = true;
      break;

    case 9: // Tab.
      this._mdPanelRef && this._mdPanelRef.close();
  }

  if (handled) {
    $event.preventDefault();
    $event.stopImmediatePropagation();
  }

  function indexOf(nodeList, element) {
    for (var item, i = 0; item = nodeList[i]; i++) {
      if (item === element) {
        return i;
      }
    }
    return -1;
  }
};

})();

(function() {
  'use strict';

  angular.module('navBarDemoBasicUsage', ['ngMaterial'])
      .controller('AppCtrl', AppCtrl);

  function AppCtrl($scope) {
    $scope.currentNavItem = 'page1';
  }
})();

angular
  .module('menuBarDemoBasic', ['ngMaterial'])
  .config(function($mdIconProvider) {
    $mdIconProvider
      .defaultIconSet('assets/angular-material-assets/img/icons/sets/core-icons.svg', 24);
  })
  .filter('keyboardShortcut', function($window) {
    return function(str) {
      if (!str) return;
      var keys = str.split('-');
      var isOSX = /Mac OS X/.test($window.navigator.userAgent);

      var seperator = (!isOSX || keys.length > 2) ? '+' : '';

      var abbreviations = {
        M: isOSX ? '⌘' : 'Ctrl',
        A: isOSX ? 'Option' : 'Alt',
        S: 'Shift'
      };

      return keys.map(function(key, index) {
        var last = index == keys.length - 1;
        return last ? key : abbreviations[key];
      }).join(seperator);
    };
  })
  .controller('DemoBasicCtrl', function DemoCtrl($mdDialog) {
    this.settings = {
      printLayout: true,
      showRuler: true,
      showSpellingSuggestions: true,
      presentationMode: 'edit'
    };

    this.sampleAction = function(name, ev) {
      $mdDialog.show($mdDialog.alert()
        .title(name)
        .textContent('You triggered the "' + name + '" action')
        .ok('Great')
        .targetEvent(ev)
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
      );
    };
  });


angular
  .module('menuDemoPosition', ['ngMaterial'])
  .config(function($mdIconProvider) {
    $mdIconProvider
      .iconSet("call", 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24)
      .iconSet("social", 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24);
  })
  .controller('PositionDemoCtrl', function DemoCtrl($mdDialog) {
    var originatorEv;
    
    this.menuHref = "http://www.google.com/design/spec/components/menus.html#menus-specs";

    this.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };

    this.announceClick = function(index) {
      $mdDialog.show(
        $mdDialog.alert()
          .title('You clicked!')
          .textContent('You clicked the menu item at index ' + index)
          .ok('Nice')
          .targetEvent(originatorEv)
          .parent(angular.element(document.body))
      );
      originatorEv = null;
    };
  });



angular.module('menuDemoWidth', ['ngMaterial']).config(function($mdIconProvider) {
  $mdIconProvider
    .iconSet("call", 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24)
    .iconSet("social", 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24);
}).controller('WidthDemoCtrl', function($mdDialog) {
  var vm = this;

  this.announceClick = function(index) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('You clicked!')
        .textContent('You clicked the menu item at index ' + index)
        .ok('Nice')
        .parent(angular.element(document.body))
    );
  };
});

angular
  .module('menuDemoBasic', ['ngMaterial'])
  .config(function($mdIconProvider) {
    $mdIconProvider
      .iconSet("call", 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24)
      .iconSet("social", 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24);
  })
  .controller('BasicDemoCtrl', function DemoCtrl($mdDialog) {
    var originatorEv;

    this.openMenu = function($mdOpenMenu, ev) {
      originatorEv = ev;
      $mdOpenMenu(ev);
    };

    this.notificationsEnabled = true;
    this.toggleNotifications = function() {
      this.notificationsEnabled = !this.notificationsEnabled;
    };

    this.redial = function() {
      $mdDialog.show(
        $mdDialog.alert()
          .targetEvent(originatorEv)
          .clickOutsideToClose(true)
          .parent('body')
          .title('Suddenly, a redial')
          .textContent('You just called a friend; who told you the most amazing story. Have a cookie!')
          .ok('That was easy')
      );

      originatorEv = null;
    };

    this.checkVoicemail = function() {
      // This never happens.
    };
  });

angular.module('listDemo2', ['ngMaterial'])
.config(function($mdIconProvider) {
  $mdIconProvider
    .iconSet('social', 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24)
    .iconSet('device', 'assets/angular-material-assets/img/icons/sets/device-icons.svg', 24)
    .iconSet('communication', 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24)
    .defaultIconSet('assets/angular-material-assets/img/icons/sets/core-icons.svg', 24);
})
.controller('ListCtrl', function($scope, $mdDialog) {
  $scope.toppings = [
    { name: 'Pepperoni', wanted: true },
    { name: 'Sausage', wanted: false },
    { name: 'Black Olives', wanted: true },
    { name: 'Green Peppers', wanted: false }
  ];

  $scope.settings = [
    { name: 'Wi-Fi', extraScreen: 'Wi-fi menu', icon: 'device:network-wifi', enabled: true },
    { name: 'Bluetooth', extraScreen: 'Bluetooth menu', icon: 'device:bluetooth', enabled: false },
  ];

  $scope.messages = [
    {id: 1, title: "Message A", selected: false},
    {id: 2, title: "Message B", selected: true},
    {id: 3, title: "Message C", selected: true},
  ];

  $scope.people = [
    { name: 'Janet Perkins', img: 'assets/angular-material-assets/img/100-0.jpeg', newMessage: true },
    { name: 'Mary Johnson', img: 'assets/angular-material-assets/img/100-1.jpeg', newMessage: false },
    { name: 'Peter Carlsson', img: 'assets/angular-material-assets/img/100-2.jpeg', newMessage: false }
  ];

  $scope.goToPerson = function(person, event) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('Navigating')
        .textContent('Inspect ' + person)
        .ariaLabel('Person inspect demo')
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .ok('Neat!')
        .targetEvent(event)
    );
  };

  $scope.navigateTo = function(to, event) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('Navigating')
        .textContent('Imagine being taken to ' + to)
        .ariaLabel('Navigation demo')
        .ok('Neat!')
        .targetEvent(event)
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
    );
  };

  $scope.doPrimaryAction = function(event) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('Primary Action')
        .textContent('Primary actions can be used for one click actions')
        .ariaLabel('Primary click demo')
        .ok('Awesome!')
        .targetEvent(event)
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
    );
  };

  $scope.doSecondaryAction = function(event) {
    $mdDialog.show(
      $mdDialog.alert()
        .title('Secondary Action')
        .textContent('Secondary actions can be used for one click actions')
        .ariaLabel('Secondary click demo')
        .ok('Neat!')
        .targetEvent(event)
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
    );
  };

});


angular.module('listDemo1', ['ngMaterial'])
.config(function($mdIconProvider) {
  $mdIconProvider
    .iconSet('communication', 'assets/angular-material-assets/img/icons/sets/communication-icons.svg', 24);
})
.controller('AppCtrl', function($scope) {
    var imagePath = 'assets/angular-material-assets/img/list/60.jpeg';

    $scope.phones = [
      {
        type: 'Home',
        number: '(555) 251-1234',
        options: {
          icon: 'communication:phone'
        }
      },
      {
        type: 'Cell',
        number: '(555) 786-9841',
        options: {
          icon: 'communication:phone',
          avatarIcon: true
        }
      },
      {
        type: 'Office',
        number: '(555) 314-1592',
        options: {
          face : imagePath
        }
      },
      {
        type: 'Offset',
        number: '(555) 192-2010',
        options: {
          offset: true,
          actionIcon: 'communication:phone'
        }
      }
    ];
    $scope.todos = [
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
      {
        face : imagePath,
        what: 'Brunch this weekend?',
        who: 'Min Li Chan',
        when: '3:08PM',
        notes: " I'll be in your neighborhood doing errands"
      },
    ];
});

angular
  .module('inputIconDemo', ['ngMaterial', 'ngMessages'])
  .controller('DemoCtrl', function($scope) {
    $scope.user = {
      name: 'John Doe',
      email: '',
      phone: '',
      address: 'Mountain View, CA',
      donation: 19.99
    };
  });

angular.module('inputErrorsAdvancedApp', ['ngMaterial', 'ngMessages'])

  .controller('AppCtrl', function($scope) {
    $scope.showHints = true;

    $scope.user = {
      name: "",
      email: "",
      social: "123456789",
      phone: "N/A"
    };
  });

angular.module('inputErrorsApp', ['ngMaterial', 'ngMessages'])

.controller('AppCtrl', function($scope) {
  $scope.project = {
    description: 'Nuclear Missile Defense System',
    rate: 500
  };
});

angular
  .module('inputBasicDemo', ['ngMaterial', 'ngMessages'])
  .controller('DemoCtrl', function($scope) {
    $scope.user = {
      title: 'Developer',
      email: 'ipsum@lorem.com',
      firstName: '',
      lastName: '',
      company: 'Google',
      address: '1600 Amphitheatre Pkwy',
      city: 'Mountain View',
      state: 'CA',
      biography: 'Loves kittens, snowboarding, and can type at 130 WPM.\n\nAnd rumor has it she bouldered up Castle Craig!',
      postalCode: '94043'
    };

    $scope.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
    'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
    'WY').split(' ').map(function(state) {
        return {abbrev: state};
      });
  })
  .config(function($mdThemingProvider) {

    // Configure a dark theme with primary foreground yellow

    $mdThemingProvider.theme('docs-dark', 'default')
      .primaryPalette('yellow')
      .dark();

  });


angular.module('appUsingTemplateCache', ['ngMaterial'])
  .controller('DemoCtrl', function($scope) {})
  .config(function($mdIconProvider) {

    // Register icon IDs with sources. Future $mdIcon( <id> ) lookups
    // will load by url and retrieve the data via the $templateRequest

    $mdIconProvider
      .iconSet('core', 'assets/angular-material-assets/img/icons/sets/core-icons.svg',24)
      .icon('social:cake', 'assets/angular-material-assets/img/icons/cake.svg',24);

  })
  .run(function($templateRequest) {

    var urls = [
      'assets/angular-material-assets/img/icons/sets/core-icons.svg',
      'assets/angular-material-assets/img/icons/cake.svg',
      'assets/angular-material-assets/img/icons/android.svg'
    ];

    // Pre-fetch icons sources by URL and cache in the $templateCache...
    // subsequent $templateRequest calls will look there first.

    angular.forEach(urls, function(url) {
      $templateRequest(url);
    });

  })
  ;


angular.module('appSvgIconSets', ['ngMaterial'])
  .controller('DemoCtrl', function($scope) {})
  .config(['$mdIconProvider', function($mdIconProvider) {
    $mdIconProvider
      .iconSet('social', 'assets/angular-material-assets/img/icons/sets/social-icons.svg', 24)
      .defaultIconSet('assets/angular-material-assets/img/icons/sets/core-icons.svg', 24);
  }]);


angular.module('appDemoSvgIcons', ['ngMaterial'])
.controller('DemoCtrl', function( $scope ) {

    $scope.insertDriveIconURL = 'assets/angular-material-assets/img/icons/ic_insert_drive_file_24px.svg';
    $scope.getAndroid = function() {
      return 'assets/angular-material-assets/img/icons/android.svg';
    }
    /* Returns base64 encoded SVG. */
    $scope.getAndroidEncoded = function() {
      return 'PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAyNCAyNCI+PGcgaWQ9ImFuZHJvaWQiPjxwYXRoIGQ9Ik02IDE4YzAgLjU1LjQ1IDEgMSAxaDF2My41YzAgLjgzLjY3IDEuNSAxLjUgMS41czEuNS0uNjcgMS41LTEuNVYxOWgydjMuNWMwIC44My42NyAxLjUgMS41IDEuNXMxLjUtLjY3IDEuNS0xLjVWMTloMWMuNTUgMCAxLS40NSAxLTFWOEg2djEwek0zLjUgOEMyLjY3IDggMiA4LjY3IDIgOS41djdjMCAuODMuNjcgMS41IDEuNSAxLjVTNSAxNy4zMyA1IDE2LjV2LTdDNSA4LjY3IDQuMzMgOCAzLjUgOHptMTcgMGMtLjgzIDAtMS41LjY3LTEuNSAxLjV2N2MwIC44My42NyAxLjUgMS41IDEuNXMxLjUtLjY3IDEuNS0xLjV2LTdjMC0uODMtLjY3LTEuNS0xLjUtMS41em0tNC45Ny01Ljg0bDEuMy0xLjNjLjItLjIuMi0uNTEgMC0uNzEtLjItLjItLjUxLS4yLS43MSAwbC0xLjQ4IDEuNDhDMTMuODUgMS4yMyAxMi45NSAxIDEyIDFjLS45NiAwLTEuODYuMjMtMi42Ni42M0w3Ljg1LjE1Yy0uMi0uMi0uNTEtLjItLjcxIDAtLjIuMi0uMi41MSAwIC43MWwxLjMxIDEuMzFDNi45NyAzLjI2IDYgNS4wMSA2IDdoMTJjMC0xLjk5LS45Ny0zLjc1LTIuNDctNC44NHpNMTAgNUg5VjRoMXYxem01IDBoLTFWNGgxdjF6Ii8+PC9nPjwvc3ZnPg==';
    }
});


angular
  .module('appDemoFontIconsWithLigatures', ['ngMaterial'])
  .controller('DemoCtrl', function( $scope ) {
      // Specify a list of font-icons with ligatures and color overrides
      var iconData = [
            {name: 'accessibility'  , color: "#777" },
            {name: 'question_answer', color: "rgb(89, 226, 168)" },
            {name: 'backup'         , color: "#A00" },
            {name: 'email'          , color: "#00A" }
          ];

      $scope.fonts = [].concat(iconData);

      // Create a set of sizes...
      $scope.sizes = [
        {size:"md-18",padding:0},
        {size:"md-24",padding:2},
        {size:"md-36",padding:6},
        {size:"md-48",padding:10}
      ];

  });


angular.module('gridListdemoResponsiveUsage', ['ngMaterial'])
.controller('AppCtrl', function($scope) {
  var COLORS = ['#ffebee', '#ffcdd2', '#ef9a9a', '#e57373', '#ef5350', '#f44336', '#e53935', '#d32f2f', '#c62828', '#b71c1c', '#ff8a80', '#ff5252', '#ff1744', '#d50000', '#f8bbd0', '#f48fb1', '#f06292', '#ec407a', '#e91e63', '#d81b60', '#c2185b', '#ad1457', '#880e4f', '#ff80ab', '#ff4081', '#f50057', '#c51162', '#e1bee7', '#ce93d8', '#ba68c8', '#ab47bc', '#9c27b0', '#8e24aa', '#7b1fa2', '#4a148c', '#ea80fc', '#e040fb', '#d500f9', '#aa00ff', '#ede7f6', '#d1c4e9', '#b39ddb', '#9575cd', '#7e57c2', '#673ab7', '#5e35b1', '#4527a0', '#311b92', '#b388ff', '#7c4dff', '#651fff', '#6200ea', '#c5cae9', '#9fa8da', '#7986cb', '#5c6bc0', '#3f51b5', '#3949ab', '#303f9f', '#283593', '#1a237e', '#8c9eff', '#536dfe', '#3d5afe', '#304ffe', '#e3f2fd', '#bbdefb', '#90caf9', '#64b5f6', '#42a5f5', '#2196f3', '#1e88e5', '#1976d2', '#1565c0', '#0d47a1', '#82b1ff', '#448aff', '#2979ff', '#2962ff', '#b3e5fc', '#81d4fa', '#4fc3f7', '#29b6f6', '#03a9f4', '#039be5', '#0288d1', '#0277bd', '#01579b', '#80d8ff', '#40c4ff', '#00b0ff', '#0091ea', '#e0f7fa', '#b2ebf2', '#80deea', '#4dd0e1', '#26c6da', '#00bcd4', '#00acc1', '#0097a7', '#00838f', '#006064', '#84ffff', '#18ffff', '#00e5ff', '#00b8d4', '#e0f2f1', '#b2dfdb', '#80cbc4', '#4db6ac', '#26a69a', '#009688', '#00897b', '#00796b', '#00695c', '#a7ffeb', '#64ffda', '#1de9b6', '#00bfa5', '#e8f5e9', '#c8e6c9', '#a5d6a7', '#81c784', '#66bb6a', '#4caf50', '#43a047', '#388e3c', '#2e7d32', '#1b5e20', '#b9f6ca', '#69f0ae', '#00e676', '#00c853', '#f1f8e9', '#dcedc8', '#c5e1a5', '#aed581', '#9ccc65', '#8bc34a', '#7cb342', '#689f38', '#558b2f', '#33691e', '#ccff90', '#b2ff59', '#76ff03', '#64dd17', '#f9fbe7', '#f0f4c3', '#e6ee9c', '#dce775', '#d4e157', '#cddc39', '#c0ca33', '#afb42b', '#9e9d24', '#827717', '#f4ff81', '#eeff41', '#c6ff00', '#aeea00', '#fffde7', '#fff9c4', '#fff59d', '#fff176', '#ffee58', '#ffeb3b', '#fdd835', '#fbc02d', '#f9a825', '#f57f17', '#ffff8d', '#ffff00', '#ffea00', '#ffd600', '#fff8e1', '#ffecb3', '#ffe082', '#ffd54f', '#ffca28', '#ffc107', '#ffb300', '#ffa000', '#ff8f00', '#ff6f00', '#ffe57f', '#ffd740', '#ffc400', '#ffab00', '#fff3e0', '#ffe0b2', '#ffcc80', '#ffb74d', '#ffa726', '#ff9800', '#fb8c00', '#f57c00', '#ef6c00', '#e65100', '#ffd180', '#ffab40', '#ff9100', '#ff6d00', '#fbe9e7', '#ffccbc', '#ffab91', '#ff8a65', '#ff7043', '#ff5722', '#f4511e', '#e64a19', '#d84315', '#bf360c', '#ff9e80', '#ff6e40', '#ff3d00', '#dd2c00', '#d7ccc8', '#bcaaa4', '#795548', '#d7ccc8', '#bcaaa4', '#8d6e63', '#eceff1', '#cfd8dc', '#b0bec5', '#90a4ae', '#78909c', '#607d8b', '#546e7a', '#cfd8dc', '#b0bec5', '#78909c'];

  this.colorTiles = (function() {
    var tiles = [];
    for (var i = 0; i < 46; i++) {
      tiles.push({
        color: randomColor(),
        colspan: randomSpan(),
        rowspan: randomSpan()
      });
    }
    return tiles;
  })();


  function randomColor() {
    return COLORS[Math.floor(Math.random() * COLORS.length)];
  }

  function randomSpan() {
    var r = Math.random();
    if (r < 0.8) {
      return 1;
    } else if (r < 0.9) {
      return 2;
    } else {
      return 3;
    }
  }
});


angular
  .module('gridListDemoApp', ['ngMaterial'])
  .controller('gridListDemoCtrl', function($scope) {

    this.tiles = buildGridModel({
            icon : "avatar:svg-",
            title: "Svg-",
            background: ""
          });

    function buildGridModel(tileTmpl){
      var it, results = [ ];

      for (var j=0; j<11; j++) {

        it = angular.extend({},tileTmpl);
        it.icon  = it.icon + (j+1);
        it.title = it.title + (j+1);
        it.span  = { row : 1, col : 1 };

        switch(j+1) {
          case 1:
            it.background = "red";
            it.span.row = it.span.col = 2;
            break;

          case 2: it.background = "green";         break;
          case 3: it.background = "darkBlue";      break;
          case 4:
            it.background = "blue";
            it.span.col = 2;
            break;

          case 5:
            it.background = "yellow";
            it.span.row = it.span.col = 2;
            break;

          case 6: it.background = "pink";          break;
          case 7: it.background = "darkBlue";      break;
          case 8: it.background = "purple";        break;
          case 9: it.background = "deepBlue";      break;
          case 10: it.background = "lightPurple";  break;
          case 11: it.background = "yellow";       break;
        }

        results.push(it);
      }
      return results;
    }
  })
  .config( function( $mdIconProvider ){
    $mdIconProvider.iconSet("avatar", 'assets/angular-material-assets/icons/avatar-icons.svg', 128);
  });


angular.module('gridListDemo1', ['ngMaterial'])
.controller('AppCtrl', function($scope) {});

(function() {
  'use strict';

  angular.module('fabToolbarBasicUsageDemo', ['ngMaterial'])
    .controller('AppCtrl', function($scope) {
      $scope.isOpen = false;

      $scope.demo = {
        isOpen: false,
        count: 0,
        selectedDirection: 'left'
      };
    });
})();
(function() {
  'use strict';

  angular.module('fabSpeedDialDemoMoreOptions', ['ngMaterial'])
    .controller('DemoCtrl', function($scope, $mdDialog, $timeout) {
      var self = this;

      self.hidden = false;
      self.isOpen = false;
      self.hover = false;

      // On opening, add a delayed property which shows tooltips after the speed dial has opened
      // so that they have the proper position; if closing, immediately hide the tooltips
      $scope.$watch('demo.isOpen', function(isOpen) {
        if (isOpen) {
          $timeout(function() {
            $scope.tooltipVisible = self.isOpen;
          }, 600);
        } else {
          $scope.tooltipVisible = self.isOpen;
        }
      });

      self.items = [
        { name: "Twitter", icon: "assets/angular-material-assets/img/icons/twitter.svg", direction: "bottom" },
        { name: "Facebook", icon: "assets/angular-material-assets/img/icons/facebook.svg", direction: "top" },
        { name: "Google Hangout", icon: "assets/angular-material-assets/img/icons/hangout.svg", direction: "bottom" }
      ];

      self.openDialog = function($event, item) {
        // Show the dialog
        $mdDialog.show({
          clickOutsideToClose: true,
          controller: function($mdDialog) {
            // Save the clicked item
            this.item = item;

            // Setup some handlers
            this.close = function() {
              $mdDialog.cancel();
            };
            this.submit = function() {
              $mdDialog.hide();
            };
          },
          controllerAs: 'dialog',
          templateUrl: 'dialog.html',
          targetEvent: $event,
          parent: angular.element(document.body),
        });
      }
    });
})();

angular.module('dividerDemo1', ['ngMaterial'])
  .controller('AppCtrl', function($scope) {
    var imagePath = 'assets/angular-material-assets/img/list/60.jpeg';
    $scope.messages = [{
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }, {
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }, {
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }, {
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }, {
      face : imagePath,
      what: 'Brunch this weekend?',
      who: 'Min Li Chan',
      when: '3:08PM',
      notes: " I'll be in your neighborhood doing errands"
    }];
  });

(function() {
  'use strict';

  angular.module('fabSpeedDialDemoBasicUsage', ['ngMaterial'])
    .controller('DemoCtrl', function() {
      this.topDirections = ['left', 'up'];
      this.bottomDirections = ['down', 'right'];

      this.isOpen = false;

      this.availableModes = ['md-fling', 'md-scale'];
      this.selectedMode = 'md-fling';

      this.availableDirections = ['up', 'down', 'left', 'right'];
      this.selectedDirection = 'up';
    });
})();

angular.module('dialogDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope, $mdDialog) {
  $scope.status = '  ';
  $scope.customFullscreen = false;

  $scope.showAlert = function(ev) {
    // Appending dialog to document.body to cover sidenav in docs app
    // Modal dialogs should fully cover application
    // to prevent interaction outside of dialog
    $mdDialog.show(
      $mdDialog.alert()
        .parent(angular.element(document.querySelector('#popupContainer')))
        .clickOutsideToClose(true)
        .parent(angular.element(document.body))
        .title('This is an alert title')
        .textContent('You can specify some description text in here.')
        .ariaLabel('Alert Dialog Demo')
        .ok('Got it!')
        .targetEvent(ev)
    );
  };

  $scope.showConfirm = function(ev) {
    // Appending dialog to document.body to cover sidenav in docs app
    var confirm = $mdDialog.confirm()
          .title('Would you like to delete your debt?')
          .textContent('All of the banks have agreed to forgive you your debts.')
          .ariaLabel('Lucky day')
          .targetEvent(ev)
          .clickOutsideToClose(true)
          .parent(angular.element(document.body))
          .ok('Please do it!')
          .cancel('Sounds like a scam');

    $mdDialog.show(confirm).then(function() {
      $scope.status = 'You decided to get rid of your debt.';
    }, function() {
      $scope.status = 'You decided to keep your debt.';
    });
  };

  $scope.showPrompt = function(ev) {
    // Appending dialog to document.body to cover sidenav in docs app
    var confirm = $mdDialog.prompt()
      .title('What would you name your dog?')
      .textContent('Bowser is a common name.')
      .placeholder('Dog name')
      .ariaLabel('Dog name')
      .initialValue('Buddy')
      .targetEvent(ev)
          .parent(angular.element(document.body))
      .ok('Okay!')
      .cancel('I\'m a cat person');

    $mdDialog.show(confirm).then(function(result) {
      $scope.status = 'You decided to name your dog ' + result + '.';
    }, function() {
      $scope.status = 'You didn\'t name your dog.';
    });
  };

  $scope.showAdvanced = function(ev) {
    $mdDialog.show({
      controller: DialogController,
      templateUrl: 'dialog1.tmpl.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose:true,
      fullscreen: $scope.customFullscreen // Only for -xs, -sm breakpoints.
    })
    .then(function(answer) {
      $scope.status = 'You said the information was "' + answer + '".';
    }, function() {
      $scope.status = 'You cancelled the dialog.';
    });
  };

  $scope.showTabDialog = function(ev) {
    $mdDialog.show({
      controller: DialogController,
      templateUrl: 'tabDialog.tmpl.html',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose:true
    })
        .then(function(answer) {
          $scope.status = 'You said the information was "' + answer + '".';
        }, function() {
          $scope.status = 'You cancelled the dialog.';
        });
  };

  $scope.showPrerenderedDialog = function(ev) {
    $mdDialog.show({
      controller: DialogController,
      contentElement: '#myDialog',
      parent: angular.element(document.body),
      targetEvent: ev,
      clickOutsideToClose: true
    });
  };

  function DialogController($scope, $mdDialog) {
    $scope.hide = function() {
      $mdDialog.hide();
    };

    $scope.cancel = function() {
      $mdDialog.cancel();
    };

    $scope.answer = function(answer) {
      $mdDialog.hide(answer);
    };
  }
});

angular.module('dialogDemo2', ['ngMaterial'])

.controller('AppCtrl', function($scope, $mdDialog) {
  $scope.openFromLeft = function() {
    $mdDialog.show(
      $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('Opening from the left')
        .textContent('Closing to the right!')
        .ariaLabel('Left to right demo')
        .parent(angular.element(document.body))
        .ok('Nice!')
        // You can specify either sting with query selector
        .openFrom('#left')
        // or an element
        .closeTo(angular.element(document.querySelector('#right')))
    );
  };

  $scope.openOffscreen = function() {
    $mdDialog.show(
      $mdDialog.alert()
        .clickOutsideToClose(true)
        .title('Opening from offscreen')
        .textContent('Closing to offscreen')
        .ariaLabel('Offscreen Demo')
        .parent(angular.element(document.body))
        .ok('Amazing!')
        // Or you can specify the rect to do the transition from
        .openFrom({
          top: -50,
          width: 30,
          height: 80
        })
        .closeTo({
          left: 1500
        })
    );
  };
});

angular.module('datepickerBasicUsage',
    ['ngMaterial', 'ngMessages']).controller('AppCtrl', function($scope) {
  $scope.myDate = new Date();

  $scope.minDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth() - 2,
      $scope.myDate.getDate());

  $scope.maxDate = new Date(
      $scope.myDate.getFullYear(),
      $scope.myDate.getMonth() + 2,
      $scope.myDate.getDate());

  $scope.onlyWeekendsPredicate = function(date) {
    var day = date.getDay();
    return day === 0 || day === 6;
  };
});

angular.module('bottomSheetDemo1', ['ngMaterial'])
.config(function($mdIconProvider) {
    $mdIconProvider
      .icon('share-arrow', 'assets/angular-material-assets/img/icons/share-arrow.svg', 24)
      .icon('upload', 'assets/angular-material-assets/img/icons/upload.svg', 24)
      .icon('copy', 'assets/angular-material-assets/img/icons/copy.svg', 24)
      .icon('print', 'assets/angular-material-assets/img/icons/print.svg', 24)
      .icon('hangout', 'assets/angular-material-assets/img/icons/hangout.svg', 24)
      .icon('mail', 'assets/angular-material-assets/img/icons/mail.svg', 24)
      .icon('message', 'assets/angular-material-assets/img/icons/message.svg', 24)
      .icon('copy2', 'assets/angular-material-assets/img/icons/copy2.svg', 24)
      .icon('facebook', 'assets/angular-material-assets/img/icons/facebook.svg', 24)
      .icon('twitter', 'assets/angular-material-assets/img/icons/twitter.svg', 24);
  })
.controller('BottomSheetExample', function($scope, $timeout, $mdBottomSheet, $mdToast) {
  $scope.alert = '';

  $scope.showListBottomSheet = function() {
    $scope.alert = '';
    $mdBottomSheet.show({
      templateUrl: 'bottom-sheet-list-template.html',
      controller: 'ListBottomSheetCtrl'
    }).then(function(clickedItem) {
      $scope.alert = clickedItem['name'] + ' clicked!';
    });
  };

  $scope.showGridBottomSheet = function() {
    $scope.alert = '';
    $mdBottomSheet.show({
      templateUrl: 'bottom-sheet-grid-template.html',
      controller: 'GridBottomSheetCtrl',
      clickOutsideToClose: false
    }).then(function(clickedItem) {
      $mdToast.show(
            $mdToast.simple()
              .textContent(clickedItem['name'] + ' clicked!')
              .position('top right')
              .hideDelay(1500)
          );
    });
  };
})

.controller('ListBottomSheetCtrl', function($scope, $mdBottomSheet) {

  $scope.items = [
    { name: 'Share', icon: 'share-arrow' },
    { name: 'Upload', icon: 'upload' },
    { name: 'Copy', icon: 'copy' },
    { name: 'Print this page', icon: 'print' },
  ];

  $scope.listItemClick = function($index) {
    var clickedItem = $scope.items[$index];
    $mdBottomSheet.hide(clickedItem);
  };
})
.controller('GridBottomSheetCtrl', function($scope, $mdBottomSheet) {
  $scope.items = [
    { name: 'Hangout', icon: 'hangout' },
    { name: 'Mail', icon: 'mail' },
    { name: 'Message', icon: 'message' },
    { name: 'Copy', icon: 'copy2' },
    { name: 'Facebook', icon: 'facebook' },
    { name: 'Twitter', icon: 'twitter' },
  ];

  $scope.listItemClick = function($index) {
    var clickedItem = $scope.items[$index];
    $mdBottomSheet.hide(clickedItem);
  };
})
.run(function($templateRequest) {

    var urls = [
      'assets/angular-material-assets/img/icons/share-arrow.svg',
      'assets/angular-material-assets/img/icons/upload.svg',
      'assets/angular-material-assets/img/icons/copy.svg',
      'assets/angular-material-assets/img/icons/print.svg',
      'assets/angular-material-assets/img/icons/hangout.svg',
      'assets/angular-material-assets/img/icons/mail.svg',
      'assets/angular-material-assets/img/icons/message.svg',
      'assets/angular-material-assets/img/icons/copy2.svg',
      'assets/angular-material-assets/img/icons/facebook.svg',
      'assets/angular-material-assets/img/icons/twitter.svg'
    ];

    angular.forEach(urls, function(url) {
      $templateRequest(url);
    });

  });


angular.module('contentDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

});

angular
  .module('colorsThemePickerDemo', ['ngMaterial'])
  .controller('ThemeDemoCtrl', function ($scope, $mdColorPalette) {
    $scope.colors = Object.keys($mdColorPalette); 

    $scope.mdURL = 'https://material.google.com/style/color.html#color-color-palette';
    $scope.primary = 'purple';
    $scope.accent = 'green';

    $scope.isPrimary = true;

    $scope.selectTheme = function (color) {
      if ($scope.isPrimary) {
        $scope.primary = color;

        $scope.isPrimary = false;
      }
      else {
        $scope.accent = color;

        $scope.isPrimary = true;
      }
    };
  })
  .directive('themePreview', function () {
    return {
      restrict: 'E',
      templateUrl: 'themePreview.tmpl.html',
      scope: {
        primary: '=',
        accent: '='
      },
      controller: function ($scope, $mdColors, $mdColorUtil) {
        $scope.getColor = function (color) {
          return $mdColorUtil.rgbaToHex($mdColors.getThemeColor(color))
        };
      }
    }
  })
  .directive('mdJustified', function() {
    return {
      restrict : 'A',
      compile : function(element, attrs)  {
        var layoutDirection = 'layout-'+ (attrs.mdJustified || "row");

        element.removeAttr('md-justified');
        element.addClass(layoutDirection);
        element.addClass("layout-align-space-between-stretch");

        return angular.noop;
      }
    };
  });

angular.module('colorsDemo', ['ngMaterial'])
  .config(function ($mdThemingProvider, $mdIconProvider) {
    $mdThemingProvider.theme('forest')
      .primaryPalette('brown')
      .accentPalette('green');

    $mdIconProvider
      .defaultIconSet('assets/angular-material-assets/img/icons/sets/social-icons.svg', 24);
  })
  .directive('regularCard', function () {
    return {
      restrict: 'E',
      templateUrl: 'regularCard.tmpl.html',
      scope: {
        name: '@',
      }
    }
  })
  .directive('userCard', function () {
    return {
      restrict: 'E',
      templateUrl: 'userCard.tmpl.html',
      scope: {
        name: '@',
        theme: '@'
      },
      controller: function ($scope) {
        $scope.theme = $scope.theme || 'default';
      }
    }
  });

(function () {
  'use strict';
  angular
      .module('staticChipsDemo', ['ngMaterial'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q) {
    this.chipText = 'Football';
  }
})();

(function () {
  'use strict';
  angular
      .module('chipsCustomSeparatorDemo', ['ngMaterial'])
      .controller('CustomSeparatorCtrl', DemoCtrl);

  function DemoCtrl ($mdConstant) {
    // Use common key codes found in $mdConstant.KEY_CODE...
    this.keys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA];
    this.tags = [];

    // Any key code can be used to create a custom separator
    var semicolon = 186;
    this.customKeys = [$mdConstant.KEY_CODE.ENTER, $mdConstant.KEY_CODE.COMMA, semicolon];
    this.contacts = ['test@example.com'];
  }
})();

(function () {
  'use strict';
  angular
      .module('chipsCustomInputDemo', ['ngMaterial'])
      .controller('CustomInputDemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q) {
    var self = this;

    self.readonly = false;
    self.selectedItem = null;
    self.searchText = null;
    self.querySearch = querySearch;
    self.vegetables = loadVegetables();
    self.selectedVegetables = [];
    self.numberChips = [];
    self.numberChips2 = [];
    self.numberBuffer = '';
    self.autocompleteDemoRequireMatch = true;
    self.transformChip = transformChip;

    /**
     * Return the proper object when the append is called.
     */
    function transformChip(chip) {
      // If it is an object, it's already a known chip
      if (angular.isObject(chip)) {
        return chip;
      }

      // Otherwise, create a new one
      return { name: chip, type: 'new' }
    }

    /**
     * Search for vegetables.
     */
    function querySearch (query) {
      var results = query ? self.vegetables.filter(createFilterFor(query)) : [];
      return results;
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(vegetable) {
        return (vegetable._lowername.indexOf(lowercaseQuery) === 0) ||
            (vegetable._lowertype.indexOf(lowercaseQuery) === 0);
      };

    }

    function loadVegetables() {
      var veggies = [
        {
          'name': 'Broccoli',
          'type': 'Brassica'
        },
        {
          'name': 'Cabbage',
          'type': 'Brassica'
        },
        {
          'name': 'Carrot',
          'type': 'Umbelliferous'
        },
        {
          'name': 'Lettuce',
          'type': 'Composite'
        },
        {
          'name': 'Spinach',
          'type': 'Goosefoot'
        }
      ];

      return veggies.map(function (veg) {
        veg._lowername = veg.name.toLowerCase();
        veg._lowertype = veg.type.toLowerCase();
        return veg;
      });
    }
  }
})();

(function () {
  'use strict';
  angular
      .module('contactChipsDemo', ['ngMaterial'])
      .controller('ContactChipDemoCtrl', DemoCtrl);

  function DemoCtrl ($q, $timeout) {
    var self = this;
    var pendingSearch, cancelSearch = angular.noop;
    var cachedQuery, lastSearch;

    self.allContacts = loadContacts();
    self.contacts = [self.allContacts[0]];
    self.asyncContacts = [];
    self.filterSelected = true;

    self.querySearch = querySearch;
    self.delayedQuerySearch = delayedQuerySearch;

    /**
     * Search for contacts; use a random delay to simulate a remote call
     */
    function querySearch (criteria) {
      cachedQuery = cachedQuery || criteria;
      return cachedQuery ? self.allContacts.filter(createFilterFor(cachedQuery)) : [];
    }

    /**
     * Async search for contacts
     * Also debounce the queries; since the md-contact-chips does not support this
     */
    function delayedQuerySearch(criteria) {
      cachedQuery = criteria;
      if ( !pendingSearch || !debounceSearch() )  {
        cancelSearch();

        return pendingSearch = $q(function(resolve, reject) {
          // Simulate async search... (after debouncing)
          cancelSearch = reject;
          $timeout(function() {

            resolve( self.querySearch() );

            refreshDebounce();
          }, Math.random() * 500, true)
        });
      }

      return pendingSearch;
    }

    function refreshDebounce() {
      lastSearch = 0;
      pendingSearch = null;
      cancelSearch = angular.noop;
    }

    /**
     * Debounce if querying faster than 300ms
     */
    function debounceSearch() {
      var now = new Date().getMilliseconds();
      lastSearch = lastSearch || now;

      return ((now - lastSearch) < 300);
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(contact) {
        return (contact._lowername.indexOf(lowercaseQuery) != -1);;
      };

    }

    function loadContacts() {
      var contacts = [
        'Marina Augustine',
        'Oddr Sarno',
        'Nick Giannopoulos',
        'Narayana Garner',
        'Anita Gros',
        'Megan Smith',
        'Tsvetko Metzger',
        'Hector Simek',
        'Some-guy withalongalastaname'
      ];

      return contacts.map(function (c, index) {
        var cParts = c.split(' ');
        var contact = {
          name: c,
          email: cParts[0][0].toLowerCase() + '.' + cParts[1].toLowerCase() + '@example.com',
          image: 'http://lorempixel.com/50/50/people?' + index
        };
        contact._lowername = contact.name.toLowerCase();
        return contact;
      });
    }
  }


})();

(function () {
  'use strict';
  angular
      .module('chipsDemo', ['ngMaterial', 'ngMessages'])
      .config(['$mdIconProvider', function($mdIconProvider) {
        $mdIconProvider.icon('md-close', 'assets/angular-material-assets/img/icons/ic_close_24px.svg', 24);
      }])
      .controller('BasicDemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q) {
    var self = this;

    self.readonly = false;

    // Lists of fruit names and Vegetable objects
    self.fruitNames = ['Apple', 'Banana', 'Orange'];
    self.roFruitNames = angular.copy(self.fruitNames);
    self.editableFruitNames = angular.copy(self.fruitNames);

    self.tags = [];
    self.vegObjs = [
      {
        'name' : 'Broccoli',
        'type' : 'Brassica'
      },
      {
        'name' : 'Cabbage',
        'type' : 'Brassica'
      },
      {
        'name' : 'Carrot',
        'type' : 'Umbelliferous'
      }
    ];

    self.newVeg = function(chip) {
      return {
        name: chip,
        type: 'unknown'
      };
    };
  }
})();


angular.module('checkboxDemo2', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

    $scope.items = [1,2,3,4,5];
      $scope.selected = [];

      $scope.toggle = function (item, list) {
        var idx = list.indexOf(item);
        if (idx > -1) {
          list.splice(idx, 1);
        }
        else {
          list.push(item);
        }
      };

      $scope.exists = function (item, list) {
        return list.indexOf(item) > -1;
      };
});


angular.module('checkboxDemo3', ['ngMaterial'])

.controller('AppCtrl', function($scope) {
  $scope.items = [1,2,3,4,5];
  $scope.selected = [1];
  $scope.toggle = function (item, list) {
    var idx = list.indexOf(item);
    if (idx > -1) {
      list.splice(idx, 1);
    }
    else {
      list.push(item);
    }
  };

  $scope.exists = function (item, list) {
    return list.indexOf(item) > -1;
  };

  $scope.isIndeterminate = function() {
    return ($scope.selected.length !== 0 &&
        $scope.selected.length !== $scope.items.length);
  };

  $scope.isChecked = function() {
    return $scope.selected.length === $scope.items.length;
  };

  $scope.toggleAll = function() {
    if ($scope.selected.length === $scope.items.length) {
      $scope.selected = [];
    } else if ($scope.selected.length === 0 || $scope.selected.length > 0) {
      $scope.selected = $scope.items.slice(0);
    }
  };
});


angular.module('checkboxDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {

  $scope.data = {};
  $scope.data.cb1 = true;
  $scope.data.cb2 = false;
  $scope.data.cb3 = false;
  $scope.data.cb4 = false;
  $scope.data.cb5 = false;

});


angular.module('cardDemo3', ['ngMaterial'])

.config(['$mdIconProvider', function($mdIconProvider) {
  $mdIconProvider.icon('md-toggle-arrow', 'assets/angular-material-assets/img/icons/toggle-arrow.svg', 48);
}])
.controller('AppCtrl', function($scope) {
  $scope.imagePath = 'assets/angular-material-assets/img/washedout.png';
});


angular.module('cardDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {
  $scope.imagePath = 'assets/angular-material-assets/img/washedout.png';
})
.config(function($mdThemingProvider) {
  $mdThemingProvider.theme('dark-grey').backgroundPalette('grey').dark();
  $mdThemingProvider.theme('dark-orange').backgroundPalette('orange').dark();
  $mdThemingProvider.theme('dark-purple').backgroundPalette('deep-purple').dark();
  $mdThemingProvider.theme('dark-blue').backgroundPalette('blue').dark();
});


angular.module('cardDemo2', ['ngMaterial'])

.controller('AppCtrl', function($scope) {
  $scope.imagePath = 'assets/angular-material-assets/img/washedout.png';
});


angular.module('buttonsDemo1', ['ngMaterial'])

.controller('AppCtrl', function($scope) {
  $scope.title1 = 'Button';
  $scope.title4 = 'Warn';
  $scope.isDisabled = true;

  $scope.googleUrl = 'http://google.com';

});

(function () {
  'use strict';
  angular
      .module('autocompleteDemoInsideDialog', ['ngMaterial'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl($mdDialog) {
    var self = this;

    self.openDialog = function($event) {
      $mdDialog.show({
        controller: DialogCtrl,
        controllerAs: 'ctrl',
        templateUrl: 'dialog.tmpl.html',
        parent: angular.element(document.body),
        targetEvent: $event,
        clickOutsideToClose:true
      })
    }
  }

  function DialogCtrl ($timeout, $q, $scope, $mdDialog) {
    var self = this;

    // list of `state` value/display objects
    self.states        = loadAll();
    self.querySearch   = querySearch;

    // ******************************
    // Template methods
    // ******************************

    self.cancel = function($event) {
      $mdDialog.cancel();
    };
    self.finish = function($event) {
      $mdDialog.hide();
    };

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch (query) {
      return query ? self.states.filter( createFilterFor(query) ) : self.states;
    }

    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {
      var allStates = 'Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware,\
              Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana,\
              Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana,\
              Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina,\
              North Dakota, Ohio, Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina,\
              South Dakota, Tennessee, Texas, Utah, Vermont, Virginia, Washington, West Virginia,\
              Wisconsin, Wyoming';

      return allStates.split(/, +/g).map( function (state) {
        return {
          value: state.toLowerCase(),
          display: state
        };
      });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(state) {
        return (state.value.indexOf(lowercaseQuery) === 0);
      };

    }
  }
})();

(function () {
  'use strict';
  angular
      .module('autocompleteFloatingLabelDemo', ['ngMaterial', 'ngMessages'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q) {
    var self = this;

    // list of `state` value/display objects
    self.states        = loadAll();
    self.selectedItem  = null;
    self.searchText    = null;
    self.querySearch   = querySearch;

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch (query) {
      var results = query ? self.states.filter( createFilterFor(query) ) : self.states;
      var deferred = $q.defer();
      $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
      return deferred.promise;
    }

    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {
      var allStates = 'Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware,\
              Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana,\
              Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana,\
              Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina,\
              North Dakota, Ohio, Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina,\
              South Dakota, Tennessee, Texas, Utah, Vermont, Virginia, Washington, West Virginia,\
              Wisconsin, Wyoming';

      return allStates.split(/, +/g).map( function (state) {
        return {
          value: state.toLowerCase(),
          display: state
        };
      });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(state) {
        return (state.value.indexOf(lowercaseQuery) === 0);
      };

    }
  }
})();

(function () {
  'use strict';
  angular
      .module('autocompleteCustomTemplateDemo', ['ngMaterial'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q, $log) {
    var self = this;

    self.simulateQuery = false;
    self.isDisabled    = false;

    self.repos         = loadAll();
    self.querySearch   = querySearch;
    self.selectedItemChange = selectedItemChange;
    self.searchTextChange   = searchTextChange;

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for repos... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch (query) {
      var results = query ? self.repos.filter( createFilterFor(query) ) : self.repos,
          deferred;
      if (self.simulateQuery) {
        deferred = $q.defer();
        $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
        return deferred.promise;
      } else {
        return results;
      }
    }

    function searchTextChange(text) {
      $log.info('Text changed to ' + text);
    }

    function selectedItemChange(item) {
      $log.info('Item changed to ' + JSON.stringify(item));
    }

    /**
     * Build `components` list of key/value pairs
     */
    function loadAll() {
      var repos = [
        {
          'name'      : 'Angular 1',
          'url'       : 'https://github.com/angular/angular.js',
          'watchers'  : '3,623',
          'forks'     : '16,175',
        },
        {
          'name'      : 'Angular 2',
          'url'       : 'https://github.com/angular/angular',
          'watchers'  : '469',
          'forks'     : '760',
        },
        {
          'name'      : 'Angular Material',
          'url'       : 'https://github.com/angular/material',
          'watchers'  : '727',
          'forks'     : '1,241',
        },
        {
          'name'      : 'Bower Material',
          'url'       : 'https://github.com/angular/bower-material',
          'watchers'  : '42',
          'forks'     : '84',
        },
        {
          'name'      : 'Material Start',
          'url'       : 'https://github.com/angular/material-start',
          'watchers'  : '81',
          'forks'     : '303',
        }
      ];
      return repos.map( function (repo) {
        repo.value = repo.name.toLowerCase();
        return repo;
      });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(item) {
        return (item.value.indexOf(lowercaseQuery) === 0);
      };

    }
  }
})();

(function () {
  'use strict';
  angular
      .module('autocompleteDemo', ['ngMaterial'])
      .controller('DemoCtrl', DemoCtrl);

  function DemoCtrl ($timeout, $q, $log) {
    var self = this;

    self.simulateQuery = false;
    self.isDisabled    = false;

    // list of `state` value/display objects
    self.states        = loadAll();
    self.querySearch   = querySearch;
    self.selectedItemChange = selectedItemChange;
    self.searchTextChange   = searchTextChange;

    self.newState = newState;

    function newState(state) {
      alert("Sorry! You'll need to create a Constitution for " + state + " first!");
    }

    // ******************************
    // Internal methods
    // ******************************

    /**
     * Search for states... use $timeout to simulate
     * remote dataservice call.
     */
    function querySearch (query) {
      var results = query ? self.states.filter( createFilterFor(query) ) : self.states,
          deferred;
      if (self.simulateQuery) {
        deferred = $q.defer();
        $timeout(function () { deferred.resolve( results ); }, Math.random() * 1000, false);
        return deferred.promise;
      } else {
        return results;
      }
    }

    function searchTextChange(text) {
      $log.info('Text changed to ' + text);
    }

    function selectedItemChange(item) {
      $log.info('Item changed to ' + JSON.stringify(item));
    }

    /**
     * Build `states` list of key/value pairs
     */
    function loadAll() {
      var allStates = 'Alabama, Alaska, Arizona, Arkansas, California, Colorado, Connecticut, Delaware,\
              Florida, Georgia, Hawaii, Idaho, Illinois, Indiana, Iowa, Kansas, Kentucky, Louisiana,\
              Maine, Maryland, Massachusetts, Michigan, Minnesota, Mississippi, Missouri, Montana,\
              Nebraska, Nevada, New Hampshire, New Jersey, New Mexico, New York, North Carolina,\
              North Dakota, Ohio, Oklahoma, Oregon, Pennsylvania, Rhode Island, South Carolina,\
              South Dakota, Tennessee, Texas, Utah, Vermont, Virginia, Washington, West Virginia,\
              Wisconsin, Wyoming';

      return allStates.split(/, +/g).map( function (state) {
        return {
          value: state.toLowerCase(),
          display: state
        };
      });
    }

    /**
     * Create filter function for a query string
     */
    function createFilterFor(query) {
      var lowercaseQuery = angular.lowercase(query);

      return function filterFn(state) {
        return (state.value.indexOf(lowercaseQuery) === 0);
      };

    }
  }
})();

(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.tabbed', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_tabbed', {
            url  : '/ui/page-layouts/simple/tabbed',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/tabbed/tabbed.html',
                    controller : 'SimpleTabbedController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.tabbed')
        .controller('SimpleTabbedController', SimpleTabbedController);

    /** @ngInject */
    function SimpleTabbedController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_right-sidenav-ii', {
            url  : '/ui/page-layouts/simple/right-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/right-sidenav-ii/right-sidenav-ii.html',
                    controller : 'SimpleRightSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-ii')
        .controller('SimpleRightSidenavIIController', SimpleRightSidenavIIController);

    /** @ngInject */
    function SimpleRightSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-iii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_right-sidenav-iii', {
            url  : '/ui/page-layouts/simple/right-sidenav-iii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/right-sidenav-iii/right-sidenav-iii.html',
                    controller : 'SimpleRightSidenavIIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav-iii')
        .controller('SimpleRightSidenavIIIController', SimpleRightSidenavIIIController);

    /** @ngInject */
    function SimpleRightSidenavIIIController($mdSidenav)
    {

        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_right-sidenav', {
            url  : '/ui/page-layouts/simple/right-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/right-sidenav/right-sidenav.html',
                    controller : 'SimpleRightSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.right-sidenav')
        .controller('SimpleRightSidenavController', SimpleRightSidenavController);

    /** @ngInject */
    function SimpleRightSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-iii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_left-sidenav-iii', {
            url  : '/ui/page-layouts/simple/left-sidenav-iii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/left-sidenav-iii/left-sidenav-iii.html',
                    controller : 'SimpleLeftSidenavIIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-iii')
        .controller('SimpleLeftSidenavIIIController', SimpleLeftSidenavIIIController);

    /** @ngInject */
    function SimpleLeftSidenavIIIController($mdSidenav)
    {

        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_left-sidenav-ii', {
            url  : '/ui/page-layouts/simple/left-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/left-sidenav-ii/left-sidenav-ii.html',
                    controller : 'SimpleLeftSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav-ii')
        .controller('SimpleLeftSidenavIIController', SimpleLeftSidenavIIController);

    /** @ngInject */
    function SimpleLeftSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_left-sidenav', {
            url  : '/ui/page-layouts/simple/left-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/left-sidenav/left-sidenav.html',
                    controller : 'SimpleLeftSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.left-sidenav')
        .controller('SimpleLeftSidenavController', SimpleLeftSidenavController);

    /** @ngInject */
    function SimpleLeftSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.fullwidth', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_simple_fullwidth', {
            url  : '/ui/page-layouts/simple/fullwidth',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/simple/fullwidth/fullwidth.html',
                    controller : 'SimpleFullwidthController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.simple.fullwidth')
        .controller('SimpleFullwidthController', SimpleFullwidthController);

    /** @ngInject */
    function SimpleFullwidthController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_right-sidenav-ii', {
            url  : '/ui/page-layouts/carded/right-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/right-sidenav-ii/right-sidenav-ii.html',
                    controller : 'CardedRightSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav-ii')
        .controller('CardedRightSidenavIIController', CardedRightSidenavIIController);

    /** @ngInject */
    function CardedRightSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_right-sidenav', {
            url  : '/ui/page-layouts/carded/right-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/right-sidenav/right-sidenav.html',
                    controller : 'CardedRightSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.right-sidenav')
        .controller('CardedRightSidenavController', CardedRightSidenavController);

    /** @ngInject */
    function CardedRightSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_left-sidenav-ii', {
            url  : '/ui/page-layouts/carded/left-sidenav-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/left-sidenav-ii/left-sidenav-ii.html',
                    controller : 'CardedLeftSidenavIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav-ii')
        .controller('CardedLeftSidenavIIController', CardedLeftSidenavIIController);

    /** @ngInject */
    function CardedLeftSidenavIIController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_left-sidenav', {
            url  : '/ui/page-layouts/carded/left-sidenav',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/left-sidenav/left-sidenav.html',
                    controller : 'CardedLeftSidenavController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.left-sidenav')
        .controller('CardedLeftSidenavController', CardedLeftSidenavController);

    /** @ngInject */
    function CardedLeftSidenavController($mdSidenav)
    {
        var vm = this;

        // Data

        // Methods
        vm.toggleSidenav = toggleSidenav;

        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth-ii', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_fullwidth-ii', {
            url  : '/ui/page-layouts/carded/fullwidth-ii',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/fullwidth-ii/fullwidth-ii.html',
                    controller : 'CardedFullwidthIIController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth-ii')
        .controller('CardedFullwidthIIController', CardedFullwidthIIController);

    /** @ngInject */
    function CardedFullwidthIIController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_carded_fullwidth', {
            url  : '/ui/page-layouts/carded/fullwidth',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/carded/fullwidth/fullwidth.html',
                    controller : 'CardedFullwidthController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.carded.fullwidth')
        .controller('CardedFullwidthController', CardedFullwidthController);

    /** @ngInject */
    function CardedFullwidthController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_theme-colors', {
            url      : '/ui/theme-colors',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/theme-colors/theme-colors.html',
                    controller : 'ThemeColorsController as vm'
                }
            },
            bodyClass: 'theme-colors'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors')
        .controller('CustomThemeDialogController', CustomThemeDialogController);

    /** @ngInject */
    function CustomThemeDialogController(fuseTheming, $mdDialog, fuseGenerator, $cookies, $window)
    {
        // Data
        var vm = this;
        vm.palettes = fuseTheming.getRegisteredPalettes();
        vm.themes = fuseTheming.getRegisteredThemes();

        // Delete Unnecessary hue value
        delete vm.palettes.grey['1000'];

        // Methods
        vm.rgba = fuseGenerator.rgba;
        vm.setTheme = setTheme;
        vm.closeDialog = closeDialog;

        //////////

        // If custom theme exist keep using it otherwise set default as a custom
        if ( !vm.themes.custom )
        {
            vm.theme = angular.copy(vm.themes['default'].colors);
        }
        else
        {
            vm.theme = vm.themes.custom.colors;
        }

        /**
         * Put custom theme into the cookies
         * and reload for generate styles
         */
        function setTheme()
        {
            $cookies.putObject('customTheme', vm.theme);
            $cookies.put('selectedTheme', 'custom');
            $window.location.reload();
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        $stateProvider.state('app.notes', {
            url    : '/notes',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/notes/notes.html',
                    controller : 'NotesController as vm'
                }
            },
            resolve: {
                Notes : function (NotesService)
                {
                    return NotesService.getData();
                },
                Labels: function (LabelsService)
                {
                    return LabelsService.getData();
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/notes');

        // Api
        msApiProvider.register('notes.notes', ['app/data/notes/notes.json']);
        msApiProvider.register('notes.labels', ['app/data/notes/labels.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.notes', {
            title : 'Notes',
            icon  : 'icon-lightbulb',
            state : 'app.notes',
            weight: 11
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('msNoteItemController', msNoteItemController)
        .directive('msNoteItem', msNoteItemDirective);

    /** @ngInject */
    function msNoteItemController($document)
    {
        var vm = this;
        var fontSizes = {
            '1': {
                fontSize  : 14,
                lineHeight: 19
            },
            '2': {
                fontSize  : 18,
                lineHeight: 28
            },
            '3': {
                fontSize  : 24,
                lineHeight: 36
            },
            '4': {
                fontSize  : 36,
                lineHeight: 48
            },
            '5': {
                fontSize  : 48,
                lineHeight: 60
            }
        };

        vm.element = [];
        vm.noFontResize = false;

        // Methods
        vm.updateDescriptionFontSize = updateDescriptionFontSize;

        //////

        function updateDescriptionFontSize()
        {
            if ( vm.noFontResize || !vm.note.description || vm.note.description === '' )
            {
                return;
            }

            var fontSize = '';
            var descWidth = Math.floor(vm.columnWidth - 52); // 48px paddings, + 4px tolerance
            var tmp = angular.element('<div style="visibility:hidden; font-size:10px;line-height: 10px;position:absolute;z-index:-1;white-space:pre-wrap;word-wrap: break-word;"></div>');
            tmp.appendTo($document.find('body'));

            fontSize = checkLineCount(sizeFromMaxWordCount());

            angular.element(vm.element).find('md-description').attr('font-size', fontSize);

            tmp.remove();

            function sizeFromMaxWordCount()
            {
                var words = vm.note.description.split(' ');

                var wordLengths = words.map(function (word)
                {
                    return tmp.text(word)[0].clientWidth;
                });

                var maxWordLength = Math.max.apply(Math, wordLengths);

                var maxPx = Math.floor((descWidth * 10) / maxWordLength);

                if ( maxPx < 18 )
                {
                    fontSize = 1;
                }
                else if ( 18 <= maxPx && maxPx < 24 )
                {
                    fontSize = 2;
                }
                else if ( 24 <= maxPx && maxPx < 36 )
                {
                    fontSize = 3;
                }
                else if ( 36 <= maxPx && maxPx < 48 )
                {
                    fontSize = 4;

                }
                else if ( maxPx >= 48 )
                {
                    fontSize = 5;
                }
                return fontSize;
            }

            function checkLineCount(sizeFromMaxWord)
            {
                var size = fontSizes[sizeFromMaxWord];
                var result;

                tmp.text(vm.note.description);
                tmp.width(descWidth);
                tmp.css({
                    'line-height': size.lineHeight + 'px',
                    'font-size'  : size.fontSize + 'px'
                });

                var lineCount = tmp[0].clientHeight / size.lineHeight;

                if ( 4 < lineCount && lineCount < 6 )
                {
                    result = 4;
                }
                else if ( 6 <= lineCount && lineCount < 9 )
                {
                    result = 3;
                }
                else if ( 9 <= lineCount && lineCount < 11 )
                {
                    result = 2;
                }
                else if ( 11 <= lineCount )
                {
                    result = 1;
                }
                else
                {
                    result = sizeFromMaxWord;
                }
                return result;
            }
        }
    }

    /** @ngInject */
    function msNoteItemDirective()
    {
        return {
            restrict        : 'A',
            controller      : 'msNoteItemController as MsNoteItem',
            templateUrl     : 'app/main/apps/notes/directives/ms-note-item/ms-note-item.html',
            require         : ['msNoteItem', '^msMasonry'],
            bindToController: {
                msNoteItem: '='
            },
            link            : function (scope, element, attributes, controllers)
            {

                var MsNoteItem = controllers[0];
                var msMasonry = controllers[1];

                MsNoteItem.element = element;
                MsNoteItem.note = MsNoteItem.msNoteItem;


                if ( angular.isDefined(attributes.noFontResize) )
                {
                    MsNoteItem.noFontResize = true;
                }

                scope.$watch('MsNoteItem.msNoteItem', function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        MsNoteItem.note = newVal;
                    }
                });

                scope.$on('msMasonryItem:startReLayout', function ()
                {
                    if ( MsNoteItem.noFontResize || MsNoteItem.columnWidth === msMasonry.columnWidth )
                    {
                        return;
                    }

                    MsNoteItem.columnWidth = msMasonry.columnWidth;

                    MsNoteItem.updateDescriptionFontSize();
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('msNoteFormController', msNoteFormController)
        .directive('msNoteForm', msNoteFormDirective);

    /** @ngInject */
    function msNoteFormController($scope, NotesService, msUtils, $mdDialog, $timeout, LabelsService)
    {
        var MsNoteForm = this;
        var notes = NotesService.data;

        //Data
        MsNoteForm.type = '';
        MsNoteForm.defaultNote = {
            'id'         : '',
            'title'      : '',
            'description': '',
            'archive'    : false,
            'image'      : '',
            'color'      : '',
            'time'       : new Date(),
            'reminder'   : null,
            'checklist'  : [],
            'labels'     : []
        };
        MsNoteForm.noteId = '';
        MsNoteForm.editNode = {};
        MsNoteForm.newCheckListItem = '';
        MsNoteForm.checkListForm = false;
        MsNoteForm.labels = LabelsService.data;

        MsNoteForm.ngFlowOptions = {
            singleFile: true
            // You can configure the ngFlow from here
            /*target                   : 'api/media/image',
             chunkSize                : 15 * 1024 * 1024,
             maxChunkRetries          : 1,
             simultaneousUploads      : 1,
             testChunks               : false,
             progressCallbacksInterval: 1000*/
        };
        MsNoteForm.ngFlow = {
            // ng-flow will be injected into here through its directive
            flow: {}
        };

        //Methods
        MsNoteForm.init = init;
        MsNoteForm.submit = submit;
        MsNoteForm.isNotValid = isNotValid;
        MsNoteForm.deleteNote = deleteNote;
        MsNoteForm.deleteImage = deleteImage;
        MsNoteForm.addChecklistItem = addChecklistItem;
        MsNoteForm.checklistFormToggle = checklistFormToggle;
        MsNoteForm.deleteCheckItem = deleteCheckItem;
        MsNoteForm.toggleArchive = toggleArchive;
        MsNoteForm.toggleInArray = msUtils.toggleInArray;
        MsNoteForm.exists = msUtils.exists;
        MsNoteForm.upload = upload;
        MsNoteForm.imageSuccess = imageSuccess;

        //////

        /**
         * Initialize
         */
        function init()
        {
            // If form type edit
            if ( MsNoteForm.type === 'edit' )
            {
                MsNoteForm.editNode = notes.getById(MsNoteForm.noteId);
                MsNoteForm.note = angular.copy(MsNoteForm.editNode);
            }
            // If form type new
            else
            {
                resetForm();
            }
        }

        /**
         * Watch New Note Form, reset form if it is closed
         */
        $scope.$on('MsNewNote:closed', function ()
        {
            resetForm();
        });

        /**
         * Reset Form
         */
        function resetForm()
        {
            $scope.$evalAsync(function ()
            {
                MsNoteForm.note = angular.copy(MsNoteForm.defaultNote);
                MsNoteForm.checkListForm = false;
            });
        }

        /**
         * Submit Form
         */
        function submit()
        {
            if ( MsNoteForm.type === 'new' )
            {
                add();
            }
            else if ( MsNoteForm.type === 'edit' )
            {
                save();
            }
        }

        /**
         * Add new note
         */
        function add()
        {
            if ( isNotValid() )
            {
                return;
            }

            // Set default values
            MsNoteForm.note.id = msUtils.guidGenerator();
            MsNoteForm.note.time = new Date();

            // Add the note
            NotesService.addNote(angular.copy(MsNoteForm.note));

            // Reset the current note to an empty one
            MsNoteForm.note = angular.copy(MsNoteForm.defaultNote);

            $scope.$emit('MsNewNote:close');
        }

        /**
         * Save Note
         */
        function save()
        {
            if ( isNotValid() )
            {
                return;
            }

            // Update the note
            NotesService.updateNote(MsNoteForm.note);

            // Hide the dialog
            $mdDialog.hide();
        }

        /**
         * Delete Note Image
         */
        function deleteImage()
        {
            MsNoteForm.note.image = '';
        }

        /**
         * Toggle Archive State
         */
        function toggleArchive()
        {
            if ( MsNoteForm.type === 'new' )
            {
                MsNoteForm.note.archive = true;
                submit();
            }
            else if ( MsNoteForm.type === 'edit' )
            {
                MsNoteForm.note.archive = !MsNoteForm.note.archive;
                save();
            }
        }

        /**
         * One of the image, title, description, checklist inputs are should be exist.
         * @returns {boolean}
         */
        function isNotValid()
        {
            return MsNoteForm.note.image === '' && MsNoteForm.note.title === '' && MsNoteForm.note.description === '' && MsNoteForm.note.checklist.length === 0;
        }

        /**
         * Delete Note
         * @param ev
         */
        function deleteNote(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the note?')
                .htmlContent('the note will be deleted permanently.')
                .ariaLabel('delete note')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                NotesService.deleteNote(MsNoteForm.note);
            });
        }

        /**
         * Add Checklist Item
         */
        function addChecklistItem()
        {
            if ( MsNoteForm.newCheckListItem === '' )
            {
                return;
            }

            MsNoteForm.note.checklist.push({
                checked: false,
                text   : MsNoteForm.newCheckListItem
            });

            MsNoteForm.newCheckListItem = '';

            focusChecklistInput();
        }

        /**
         * Checklist form toggle
         */
        function checklistFormToggle()
        {
            $scope.$evalAsync(function ()
            {
                MsNoteForm.checkListForm = !MsNoteForm.checkListForm;

                $timeout(function ()
                {
                    focusChecklistInput();
                });
            });
        }

        /**
         * Delete check item
         * @param item
         */
        function deleteCheckItem(item)
        {
            MsNoteForm.note.checklist.splice(MsNoteForm.note.checklist.indexOf(item), 1);
            focusChecklistInput();
        }

        /**
         * Focus checklist input
         */
        function focusChecklistInput()
        {
            angular.element('#new-checklist-item-input').focus();
        }

        /**
         * Upload
         */
        function upload()
        {
            // Set headers
            MsNoteForm.ngFlow.flow.opts.headers = {
                'X-Requested-With': 'XMLHttpRequest',
                //'X-XSRF-TOKEN'    : $cookies.get('XSRF-TOKEN')
            };

            MsNoteForm.ngFlow.flow.upload();
        }

        /**
         * Image Success
         * @param file
         * @param message
         */
        function imageSuccess(file, message)
        {
            var fileReader = new FileReader();

            fileReader.readAsDataURL(file.file);

            fileReader.onload = function (event)
            {
                file.url = event.target.result;

                $scope.$evalAsync(function ()
                {
                    MsNoteForm.note.image = file.url;
                });
            };

            file.type = 'image';
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };

    }

    /** @ngInject */
    function msNoteFormDirective()
    {
        return {
            restrict    : 'EA',
            controller  : 'msNoteFormController',
            controllerAs: 'MsNoteForm',
            scope       : {
                noteType: '=',
                noteId  : '='
            },
            templateUrl : 'app/main/apps/notes/directives/ms-note-form/ms-note-form.html',
            link        : function (scope, element, attributes, MsNoteForm)
            {
                // Type
                MsNoteForm.type = scope.noteType;

                // Note id
                if ( angular.isDefined(scope.noteId) )
                {
                    MsNoteForm.noteId = scope.noteId;
                }

                MsNoteForm.init();

            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('msNewNoteController', msNewNoteController)
        .directive('msNewNoteButton', msNewNoteButtonDirective)
        .directive('msNewNote', msNewNoteDirective);

    /** @ngInject */
    function msNewNoteController($scope, $document)
    {
        var MsNewNote = this;

        //Data
        MsNewNote.formVisible = false;
        MsNewNote.form = {
            title      : '',
            description: ''
        };

        //Methods
        MsNewNote.open = open;
        MsNewNote.close = close;
        MsNewNote.element = [];

        //////

        /**
         * Close Trigger
         */
        $scope.$on('MsNewNote:close', function ()
        {
            close();
        });

        /**
         * Open new note form
         */
        function open()
        {
            MsNewNote.element.addClass('form-visible');
            MsNewNote.element.find('textarea').focus();
            $document.on('click', outSideClick);
        }

        /**
         * Close new note form
         */
        function close()
        {
            MsNewNote.element.removeClass('form-visible');
            $scope.$broadcast('MsNewNote:closed');

            $document.off('click', outSideClick);
        }

        /**
         * Click Outside Event Handler
         * @param event
         */
        function outSideClick(event)
        {
            var isChild = MsNewNote.element.has(event.target).length > 0;
            var isSelf = MsNewNote.element[0] === event.target;
            var isMenu = angular.element(event.target).closest('md-menu-content').length > 0;
            var isCalendar = angular.element(event.target).closest('md-calendar').length > 0 || angular.element(event.target).closest('.md-datepicker-calendar-pane').length > 0 || angular.element(event.target).hasClass('md-scroll-mask');

            var isInside = isChild || isSelf || isMenu || isCalendar;

            if ( !isInside )
            {
                close();
            }
        }
    }

    /** @ngInject */
    function msNewNoteDirective()
    {
        return {
            restrict    : 'E',
            controller  : 'msNewNoteController',
            controllerAs: 'MsNewNote',
            templateUrl : 'app/main/apps/notes/directives/ms-new-note/ms-new-note.html',
            link        : function (scope, element, attributes, MsNewNote)
            {
                MsNewNote.element = element;
            }
        };
    }

    /** @ngInject */
    function msNewNoteButtonDirective()
    {
        return {
            restrict: 'EA',
            require : '^msNewNote',
            link    : function (scope, element, attributes, msNewNote)
            {
                element.on('click', function ()
                {
                    msNewNote.open();
                });
            }
        };
    }
})();
(function () {
    'use strict';

    angular
        .module('app.store.system')
        .controller('StoreDialogController', StoreDialogController);

    /** @ngInject */
    function StoreDialogController($rootScope, $timeout, $filter, Store, Stores, event, msApi, $http, $cookies, $mdDialog) {
        var vm = this;
        // Data
        vm.title = '编辑';
        //合同
        vm.stores = Stores;
        vm.store = angular.copy(Store);
        vm.citys = {"data":[{'name':'上海市'}]};

        var store_id = $cookies.get('store_id');
        vm.newStore = false;
        if (!vm.store) {
            vm.store = {
                'id': '',
                'name': '',
                'address': '',
                'phone':'',
                'city': '',
                //'settings':'',
                'province':0,
                'current_store_id' :store_id,
                'media':''
                //'address_list': ''

            };
            vm.title = '添加';
            vm.newStore = true;
        }

        // Methods
        vm.addNewStore = addNewStore;
        vm.saveStore = saveStore;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Add new task
         */
        function addNewStore() {
            $http({
                method: 'POST',
                url: msApi.getApiUrl('stores'),
                data: vm.store
            }).success(function (req) {
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);

                vm.store.id = req.id;
                vm.stores.unshift(vm.store);
                closeDialog();
            }).error(function(data, state) {
                vm.error_arr = data;
            });
        }

        /**
         * Save task
         */
        function saveStore() {
            //vm.store.settings = "";
            delete vm.store.settings;
            //delete vm.store.media;
            delete vm.store.address_list;
            $http({
                method: 'PUT',
                url: msApi.getApiUrl('stores/' + vm.store.id),
                data: vm.store
            }).success(function (req) {
                // Dummy save action
                for (var i = 0; i < vm.stores.length; i++) {
                    if (vm.stores[i].id === vm.store.id) {
                        vm.stores[i] = angular.copy(vm.store);
                        break;
                    }
                }
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
                closeDialog();
            }).error(function (data, state) {
                vm.error_arr = data;
            });
        }

        /**
         * Close dialog
         */
        function closeDialog() {
            $mdDialog.hide();
        }
        vm.simulateQuery = false;
        vm.isDisabled = false;
        vm.searchText = vm.newStore ? '' : vm.store.city;
        vm.selectedItem = vm.newStore ? '' : {'value' : vm.store.city, 'display' : vm.store.city};
        vm.states = loadAll();
        vm.querySearch = querySearch;
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;

        function querySearch(query) {
            var results = query ? vm.states.filter(createFilterFor(query)) : vm.states,
                deferred;
            if (vm.simulateQuery) {
                deferred = $q.defer();
                $timeout(function () {
                    deferred.resolve(results);
                }, Math.random() * 1000, false);
                return deferred.promise;
            } else {
                return results;
            }
        }

        function searchTextChange(text) {
            //console.log(text);
        }
        function selectedItemChange(item) {
            //console.log(item);
            if(item){
                vm.store.city = item.value;
            }else{
                vm.store.city = '';

            }
        }
        function loadAll() {
            var allStates = '';
            angular.forEach(vm.citys.data, function (v, k) {
                allStates = allStates + v.name + ', ';
            });
            allStates = allStates.substr(0, allStates.length - 2);
            return allStates.split(/, +/g).map(
                function (state) {
                    return {
                        value: state,//.toLowerCase(),
                        display: state
                    };
                });
        }
        function createFilterFor(query) {
            var lowercaseQuery = query//angular.lowercase(query);
            return function filterFn(state) {
                return (state.value.indexOf(lowercaseQuery) === 0);
            };
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.mail',
            [
                // 3rd Party Dependencies
                'textAngular'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.mail', {
                abstract: true,
                url     : '/mail',
                resolve : {
                    Folders: function (msApi)
                    {
                        return msApi.resolve('mail.folders@get');
                    },
                    Labels : function (msApi)
                    {
                        return msApi.resolve('mail.labels@get');
                    }
                }
            })
            .state('app.mail.threads', {
                url      : '/{type:(?:label)}/:filter',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/mail/mail.html',
                        controller : 'MailController as vm'
                    }
                },
                params   : {
                    type: {
                        value : null,
                        squash: true
                    }
                },
                bodyClass: 'mail'
            })
            .state('app.mail.threads.thread', {
                url      : '/:threadId',
                bodyClass: 'mail'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/mail');

        // Api
        msApiProvider.register('mail.folders', ['app/data/mail/folders.json']);
        msApiProvider.register('mail.labels', ['app/data/mail/labels.json']);

        msApiProvider.register('mail.label.notes', ['app/data/mail/labels/notes.json']);
        msApiProvider.register('mail.label.paypal', ['app/data/mail/labels/paypal.json']);
        msApiProvider.register('mail.label.invoices', ['app/data/mail/labels/invoices.json']);
        msApiProvider.register('mail.label.amazon', ['app/data/mail/labels/amazon.json']);

        msApiProvider.register('mail.folder.inbox', ['app/data/mail/folders/inbox.json']);
        msApiProvider.register('mail.folder.sent', ['app/data/mail/folders/sent.json']);
        msApiProvider.register('mail.folder.drafts', ['app/data/mail/folders/drafts.json']);
        msApiProvider.register('mail.folder.spam', ['app/data/mail/folders/spam.json']);
        msApiProvider.register('mail.folder.trash', ['app/data/mail/folders/trash.json']);
        msApiProvider.register('mail.folder.starred', ['app/data/mail/folders/starred.json']);
        msApiProvider.register('mail.folder.important', ['app/data/mail/folders/important.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.mail', {
            title      : 'Mail',
            icon       : 'icon-email',
            state      : 'app.mail.threads',
            stateParams: {
                filter: 'inbox'
            },
            badge      : {
                content: 25,
                color  : '#F44336'
            },
            weight     : 4
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.mail')
        .controller('ComposeDialogController', ComposeDialogController);

    /** @ngInject */
    function ComposeDialogController($mdDialog, selectedMail)
    {
        var vm = this;

        // Data
        vm.form = {
            from: 'johndoe@creapond.com'
        };

        vm.hiddenCC = true;
        vm.hiddenBCC = true;

        // If replying
        if ( angular.isDefined(selectedMail) )
        {
            vm.form.to = selectedMail.from.email;
            vm.form.subject = 'RE: ' + selectedMail.subject;
            vm.form.message = '<blockquote>' + selectedMail.message + '</blockquote>';
        }

        // Methods
        vm.closeDialog = closeDialog;

        //////////

        function closeDialog()
        {
            $mdDialog.hide();
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.contacts',
            [
                // 3rd Party Dependencies
                'xeditable'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        $stateProvider.state('app.contacts', {
            url    : '/contacts',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/contacts/contacts.html',
                    controller : 'ContactsController as vm'
                }
            },
            resolve: {
                Contacts: function (msApi)
                {
                    return msApi.resolve('contacts.contacts@get');
                },
                User: function (msApi)
                {
                    return msApi.resolve('contacts.user@get');
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/contacts');

        // Api
        msApiProvider.register('contacts.contacts', ['app/data/contacts/contacts.json']);
        msApiProvider.register('contacts.user', ['app/data/contacts/user.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.contacts', {
            title : 'Contacts',
            icon  : 'icon-account-box',
            state : 'app.contacts',
            weight: 10
        });

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts')
        .controller('ContactDialogController', ContactDialogController);

    /** @ngInject */
    function ContactDialogController($mdDialog, Contact, Contacts, User, msUtils)
    {
        var vm = this;

        // Data
        vm.title = 'Edit Contact';
        vm.contact = angular.copy(Contact);
        vm.contacts = Contacts;
        vm.user = User;
        vm.newContact = false;
        vm.allFields = false;

        if ( !vm.contact )
        {
            vm.contact = {
                'id'      : msUtils.guidGenerator(),
                'name'    : '',
                'lastName': '',
                'avatar'  : 'assets/images/avatars/profile.jpg',
                'nickname': '',
                'company' : '',
                'jobTitle': '',
                'email'   : '',
                'phone'   : '',
                'address' : '',
                'birthday': null,
                'notes'   : ''
            };

            vm.title = 'New Contact';
            vm.newContact = true;
            vm.contact.tags = [];
        }

        // Methods
        vm.addNewContact = addNewContact;
        vm.saveContact = saveContact;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.closeDialog = closeDialog;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        //////////

        /**
         * Add new contact
         */
        function addNewContact()
        {
            vm.contacts.unshift(vm.contact);

            closeDialog();
        }

        /**
         * Save contact
         */
        function saveContact()
        {
            // Dummy save action
            for ( var i = 0; i < vm.contacts.length; i++ )
            {
                if ( vm.contacts[i].id === vm.contact.id )
                {
                    vm.contacts[i] = angular.copy(vm.contact);
                    break;
                }
            }

            closeDialog();
        }

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteContactConfirm(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the contact?')
                .htmlContent('<b>' + vm.contact.name + ' ' + vm.contact.lastName + '</b>' + ' will be deleted.')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.contacts.splice(vm.contacts.indexOf(Contact), 1);

            });
        }

        /**
         * Close dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.calendar',
            [
                // 3rd Party Dependencies
                'ui.calendar'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.calendar', {
            url      : '/calendar',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/calendar/calendar.html',
                    controller : 'CalendarController as vm'
                }
            },
            bodyClass: 'calendar'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/calendar');

        // Navigation
        msNavigationServiceProvider.saveItem('apps.calendar', {
            title : 'Calendar',
            icon  : 'icon-calendar-today',
            state : 'app.calendar',
            weight: 2
        });
    }
})();
(function ()
{
    'use strict';

    angular.module('app.calendar')
        .controller('EventFormDialogController', EventFormDialogController);

    /** @ngInject */
    function EventFormDialogController($mdDialog, dialogData)
    {
        var vm = this;

        // Data
        vm.dialogData = dialogData;
        vm.notifications = ['15 minutes before', '30 minutes before', '1 hour before'];

        // Methods
        vm.saveEvent = saveEvent;
        vm.removeEvent = removeEvent;
        vm.closeDialog = closeDialog;

        init();

        //////////

        /**
         * Initialize
         */
        function init()
        {
            // Figure out the title
            switch ( vm.dialogData.type )
            {
                case 'add' :
                    vm.dialogTitle = 'Add Event';
                    break;

                case 'edit' :
                    vm.dialogTitle = 'Add Event';
                    break;

                default:
                    break;
            }

            // Edit
            if ( vm.dialogData.calendarEvent )
            {
                // Clone the calendarEvent object before doing anything
                // to make sure we are not going to brake FullCalendar
                vm.calendarEvent = angular.copy(vm.dialogData.calendarEvent);

                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.calendarEvent.start) )
                {
                    vm.calendarEvent.start = vm.calendarEvent.start.toDate();
                }

                if ( moment.isMoment(vm.calendarEvent.end) )
                {
                    vm.calendarEvent.end = vm.calendarEvent.end.toDate();
                }
            }
            // Add
            else
            {
                // Convert moment.js dates to javascript date object
                if ( moment.isMoment(vm.dialogData.start) )
                {
                    vm.dialogData.start = vm.dialogData.start.toDate();
                }

                if ( moment.isMoment(vm.dialogData.end) )
                {
                    vm.dialogData.end = vm.dialogData.end.toDate();
                }

                vm.calendarEvent = {
                    start        : vm.dialogData.start,
                    end          : vm.dialogData.end,
                    notifications: []
                };
            }
        }

        /**
         * Save the event
         */
        function saveEvent()
        {
            // Convert the javascript date objects back to the moment.js dates
            var dates = {
                start: moment.utc(vm.calendarEvent.start),
                end  : moment.utc(vm.calendarEvent.end)
            };

            var response = {
                type         : vm.dialogData.type,
                calendarEvent: angular.extend({}, vm.calendarEvent, dates)
            };

            $mdDialog.hide(response);
        }

        /**
         * Remove the event
         */
        function removeEvent()
        {
            var response = {
                type         : 'remove',
                calendarEvent: vm.calendarEvent
            };

            $mdDialog.hide(response);
        }

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.cancel();
        }
    }
})();

(function ()
{
    'use strict';

    angular.module('app.calendar')
        .controller('EventDetailDialogController', EventDetailDialogController);

    /** @ngInject */
    function EventDetailDialogController($mdDialog, calendarEvent, showEventFormDialog, event)
    {
        var vm = this;

        // Data
        vm.calendarEvent = calendarEvent;

        // Methods
        vm.editEvent = editEvent;
        vm.closeDialog = closeDialog;

        //////////

        /**
         * Close the dialog
         */
        function closeDialog()
        {
            $mdDialog.hide();
        }

        /**
         * Edit the calendar event
         *
         * @param calendarEvent
         */
        function editEvent(calendarEvent)
        {
            showEventFormDialog('edit', calendarEvent, false, false, event);
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.blank', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_page-layouts_blank', {
            url  : '/ui/page-layouts/blank',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/page-layouts/blank/blank.html',
                    controller : 'BlankController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.page-layouts.blank')
        .controller('BlankController', BlankController);

    /** @ngInject */
    function BlankController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.nvd3',
            [
                // 3rd Party Dependencies
                'nvd3'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_charts_nvd3', {
            url  : '/components/charts/nvd3',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/charts/nvd3/nvd3.html',
                    controller : 'Nvd3Controller as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.nvd3')
        .controller('Nvd3Controller', Nvd3Controller);

    function Nvd3Controller()
    {
        var vm = this;

        // Data
        vm.lineChart = {
            options: {
                chart   : {
                    type                   : 'lineChart',
                    height                 : 450,
                    margin                 : {
                        top   : 20,
                        right : 20,
                        bottom: 40,
                        left  : 55
                    },
                    x                      : function (d)
                    {
                        return d.x;
                    },
                    y                      : function (d)
                    {
                        return d.y;
                    },
                    useInteractiveGuideline: true,
                    xAxis                  : {
                        axisLabel: 'Time (ms)'
                    },
                    yAxis                  : {
                        axisLabel        : 'Voltage (v)',
                        tickFormat       : function (d)
                        {
                            return d3.format('.02f')(d);
                        },
                        axisLabelDistance: 30
                    }
                },
                title   : {
                    enable: true,
                    text  : 'Title for Line Chart'
                },
                subtitle: {
                    enable: true,
                    text  : 'Subtitle for simple line chart. Lorem ipsum dolor sit amet, at eam blandit sadipscing, vim adhuc sanctus disputando ex, cu usu affert alienum urbanitas.',
                    css   : {
                        'text-align': 'center',
                        'margin'    : '10px 13px 0px 7px'
                    }
                },
                caption : {
                    enable: true,
                    html  : '<b>Figure 1.</b> Lorem ipsum dolor sit amet, at eam blandit sadipscing, <span style="text-decoration: underline;">vim adhuc sanctus disputando ex</span>, cu usu affert alienum urbanitas. <i>Cum in purto erat, mea ne nominavi persecuti reformidans.</i> Docendi blandit abhorreant ea has, minim tantas alterum pro eu. <span style="color: darkred;">Exerci graeci ad vix, elit tacimates ea duo</span>. Id mel eruditi fuisset. Stet vidit patrioque in pro, eum ex veri verterem abhorreant, id unum oportere intellegam nec<sup>[1, <a href="https://github.com/krispo/angular-nvd3" target="_blank">2</a>, 3]</sup>.',
                    css   : {
                        'text-align': 'justify',
                        'margin'    : '10px 13px 0px 7px'
                    }
                }
            },
            data   : sinAndCos()
        };

        vm.stackedAreaChart = {
            options: {
                chart: {
                    type                   : 'stackedAreaChart',
                    height                 : 450,
                    margin                 : {
                        top   : 20,
                        right : 20,
                        bottom: 60,
                        left  : 40
                    },
                    x                      : function (d)
                    {
                        return d[0];
                    },
                    y                      : function (d)
                    {
                        return d[1];
                    },
                    useVoronoi             : false,
                    clipEdge               : true,
                    transitionDuration     : 500,
                    useInteractiveGuideline: true,
                    xAxis                  : {
                        showMaxMin: false,
                        tickFormat: function (d)
                        {
                            return d3.time.format('%x')(new Date(d));
                        }
                    },
                    yAxis                  : {
                        tickFormat: function (d)
                        {
                            return d3.format(',.2f')(d);
                        }
                    }
                }
            },

            data: [
                {
                    'key'   : 'North America',
                    'values': [[1025409600000, 23.041422681023], [1028088000000, 19.854291255832], [1030766400000, 21.02286281168], [1033358400000, 22.093608385173], [1036040400000, 25.108079299458], [1038632400000, 26.982389242348], [1041310800000, 19.828984957662], [1043989200000, 19.914055036294], [1046408400000, 19.436150539916], [1049086800000, 21.558650338602], [1051675200000, 24.395594061773], [1054353600000, 24.747089309384], [1056945600000, 23.491755498807], [1059624000000, 23.376634878164], [1062302400000, 24.581223154533], [1064894400000, 24.922476843538], [1067576400000, 27.357712939042], [1070168400000, 26.503020572593], [1072846800000, 26.658901244878], [1075525200000, 27.065704156445], [1078030800000, 28.735320452588], [1080709200000, 31.572277846319], [1083297600000, 30.932161503638], [1085976000000, 31.627029785554], [1088568000000, 28.728743674232], [1091246400000, 26.858365172675], [1093924800000, 27.279922830032], [1096516800000, 34.408301211324], [1099195200000, 34.794362930439], [1101790800000, 35.609978198951], [1104469200000, 33.574394968037], [1107147600000, 31.979405070598], [1109566800000, 31.19009040297], [1112245200000, 31.083933968994], [1114833600000, 29.668971113185], [1117512000000, 31.490638014379], [1120104000000, 31.818617451128], [1122782400000, 32.960314008183], [1125460800000, 31.313383196209], [1128052800000, 33.125486081852], [1130734800000, 32.791805509149], [1133326800000, 33.506038030366], [1136005200000, 26.96501697216], [1138683600000, 27.38478809681], [1141102800000, 27.371377218209], [1143781200000, 26.309915460827], [1146369600000, 26.425199957518], [1149048000000, 26.823411519396], [1151640000000, 23.850443591587], [1154318400000, 23.158355444054], [1156996800000, 22.998689393695], [1159588800000, 27.9771285113], [1162270800000, 29.073672469719], [1164862800000, 28.587640408904], [1167541200000, 22.788453687637], [1170219600000, 22.429199073597], [1172638800000, 22.324103271052], [1175313600000, 17.558388444187], [1177905600000, 16.769518096208], [1180584000000, 16.214738201301], [1183176000000, 18.729632971229], [1185854400000, 18.814523318847], [1188532800000, 19.789986451358], [1191124800000, 17.070049054933], [1193803200000, 16.121349575716], [1196398800000, 15.141659430091], [1199077200000, 17.175388025297], [1201755600000, 17.286592443522], [1204261200000, 16.323141626568], [1206936000000, 19.231263773952], [1209528000000, 18.446256391095], [1212206400000, 17.822632399764], [1214798400000, 15.53936647598], [1217476800000, 15.255131790217], [1220155200000, 15.660963922592], [1222747200000, 13.254482273698], [1225425600000, 11.920796202299], [1228021200000, 12.122809090924], [1230699600000, 15.691026271393], [1233378000000, 14.720881635107], [1235797200000, 15.387939360044], [1238472000000, 13.765436672228], [1241064000000, 14.631445864799], [1243742400000, 14.292446536221], [1246334400000, 16.170071367017], [1249012800000, 15.948135554337], [1251691200000, 16.612872685134], [1254283200000, 18.778338719091], [1256961600000, 16.756026065421], [1259557200000, 19.385804443146], [1262235600000, 22.950590240168], [1264914000000, 23.61159018141], [1267333200000, 25.708586989581], [1270008000000, 26.883915999885], [1272600000000, 25.893486687065], [1275278400000, 24.678914263176], [1277870400000, 25.937275793024], [1280548800000, 29.461381693838], [1283227200000, 27.357322961861], [1285819200000, 29.057235285673], [1288497600000, 28.549434189386], [1291093200000, 28.506352379724], [1293771600000, 29.449241421598], [1296450000000, 25.796838168807], [1298869200000, 28.740145449188], [1301544000000, 22.091744141872], [1304136000000, 25.07966254541], [1306814400000, 23.674906973064], [1309406400000, 23.418002742929], [1312084800000, 23.24364413887], [1314763200000, 31.591854066817], [1317355200000, 31.497112374114], [1320033600000, 26.67238082043], [1322629200000, 27.297080015495], [1325307600000, 20.174315530051], [1327986000000, 19.631084213898], [1330491600000, 20.366462219461], [1333166400000, 19.284784434185], [1335758400000, 19.157810257624]]
                },

                {
                    'key'   : 'Africa',
                    'values': [[1025409600000, 7.9356392949025], [1028088000000, 7.4514668527298], [1030766400000, 7.9085410566608], [1033358400000, 5.8996782364764], [1036040400000, 6.0591869346923], [1038632400000, 5.9667815800451], [1041310800000, 8.65528925664], [1043989200000, 8.7690763386254], [1046408400000, 8.6386160387453], [1049086800000, 5.9895557449743], [1051675200000, 6.3840324338159], [1054353600000, 6.5196511461441], [1056945600000, 7.0738618553114], [1059624000000, 6.5745957367133], [1062302400000, 6.4658359184444], [1064894400000, 2.7622758754954], [1067576400000, 2.9794782986241], [1070168400000, 2.8735432712019], [1072846800000, 1.6344817513645], [1075525200000, 1.5869248754883], [1078030800000, 1.7172279157246], [1080709200000, 1.9649927409867], [1083297600000, 2.0261695079196], [1085976000000, 2.0541261923929], [1088568000000, 3.9466318927569], [1091246400000, 3.7826770946089], [1093924800000, 3.9543021004028], [1096516800000, 3.8309891064711], [1099195200000, 3.6340958946166], [1101790800000, 3.5289755762525], [1104469200000, 5.702378559857], [1107147600000, 5.6539569019223], [1109566800000, 5.5449506370392], [1112245200000, 4.7579993280677], [1114833600000, 4.4816139372906], [1117512000000, 4.5965558568606], [1120104000000, 4.3747066116976], [1122782400000, 4.4588822917087], [1125460800000, 4.4460351848286], [1128052800000, 3.7989113035136], [1130734800000, 3.7743883140088], [1133326800000, 3.7727852823828], [1136005200000, 7.2968111448895], [1138683600000, 7.2800122043237], [1141102800000, 7.1187787503354], [1143781200000, 8.351887016482], [1146369600000, 8.4156698763993], [1149048000000, 8.1673298604231], [1151640000000, 5.5132447126042], [1154318400000, 6.1152537710599], [1156996800000, 6.076765091942], [1159588800000, 4.6304473798646], [1162270800000, 4.6301068469402], [1164862800000, 4.3466656309389], [1167541200000, 6.830104897003], [1170219600000, 7.241633040029], [1172638800000, 7.1432372054153], [1175313600000, 10.608942063374], [1177905600000, 10.914964549494], [1180584000000, 10.933223880565], [1183176000000, 8.3457524851265], [1185854400000, 8.1078413081882], [1188532800000, 8.2697185922474], [1191124800000, 8.4742436475968], [1193803200000, 8.4994601179319], [1196398800000, 8.7387319683243], [1199077200000, 6.8829183612895], [1201755600000, 6.984133637885], [1204261200000, 7.0860136043287], [1206936000000, 4.3961787956053], [1209528000000, 3.8699674365231], [1212206400000, 3.6928925238305], [1214798400000, 6.7571718894253], [1217476800000, 6.4367313362344], [1220155200000, 6.4048441521454], [1222747200000, 5.4643833239669], [1225425600000, 5.3150786833374], [1228021200000, 5.3011272612576], [1230699600000, 4.1203601430809], [1233378000000, 4.0881783200525], [1235797200000, 4.1928665957189], [1238472000000, 7.0249415663205], [1241064000000, 7.006530880769], [1243742400000, 6.994835633224], [1246334400000, 6.1220222336254], [1249012800000, 6.1177436137653], [1251691200000, 6.1413396231981], [1254283200000, 4.8046006145874], [1256961600000, 4.6647600660544], [1259557200000, 4.544865006255], [1262235600000, 6.0488249316539], [1264914000000, 6.3188669540206], [1267333200000, 6.5873958262306], [1270008000000, 6.2281189839578], [1272600000000, 5.8948915746059], [1275278400000, 5.5967320482214], [1277870400000, 0.99784432084837], [1280548800000, 1.0950794175359], [1283227200000, 0.94479734407491], [1285819200000, 1.222093988688], [1288497600000, 1.335093106856], [1291093200000, 1.3302565104985], [1293771600000, 1.340824670897], [1296450000000, 0], [1298869200000, 0], [1301544000000, 0], [1304136000000, 0], [1306814400000, 0], [1309406400000, 0], [1312084800000, 0], [1314763200000, 0], [1317355200000, 4.4583692315], [1320033600000, 3.6493043348059], [1322629200000, 3.8610064091761], [1325307600000, 5.5144800685202], [1327986000000, 5.1750695220791], [1330491600000, 5.6710066952691], [1333166400000, 5.5611890039181], [1335758400000, 5.5979368839939]]
                },

                {
                    'key'   : 'South America',
                    'values': [[1025409600000, 7.9149900245423], [1028088000000, 7.0899888751059], [1030766400000, 7.5996132380614], [1033358400000, 8.2741174301034], [1036040400000, 9.3564460833513], [1038632400000, 9.7066786059904], [1041310800000, 10.213363052343], [1043989200000, 10.285809585273], [1046408400000, 10.222053149228], [1049086800000, 8.6188592137975], [1051675200000, 9.3335447543566], [1054353600000, 8.9312402186628], [1056945600000, 8.1895089343658], [1059624000000, 8.260622135079], [1062302400000, 7.7700786851364], [1064894400000, 7.9907428771318], [1067576400000, 8.7769091865606], [1070168400000, 8.4855077060661], [1072846800000, 9.6277203033655], [1075525200000, 9.9685913452624], [1078030800000, 10.615085181759], [1080709200000, 9.2902488079646], [1083297600000, 8.8610439830061], [1085976000000, 9.1075344931229], [1088568000000, 9.9156737639203], [1091246400000, 9.7826003238782], [1093924800000, 10.55403610555], [1096516800000, 10.926900264097], [1099195200000, 10.903144818736], [1101790800000, 10.862890389067], [1104469200000, 10.64604998964], [1107147600000, 10.042790814087], [1109566800000, 9.7173391591038], [1112245200000, 9.6122415755443], [1114833600000, 9.4337921146562], [1117512000000, 9.814827171183], [1120104000000, 12.059260396788], [1122782400000, 12.139649903873], [1125460800000, 12.281290663822], [1128052800000, 8.8037085409056], [1130734800000, 8.6300618239176], [1133326800000, 9.1225708491432], [1136005200000, 12.988124170836], [1138683600000, 13.356778764353], [1141102800000, 13.611196863271], [1143781200000, 6.8959030061189], [1146369600000, 6.9939633271353], [1149048000000, 6.7241510257676], [1151640000000, 5.5611293669517], [1154318400000, 5.6086488714041], [1156996800000, 5.4962849907033], [1159588800000, 6.9193153169278], [1162270800000, 7.0016334389778], [1164862800000, 6.7865422443273], [1167541200000, 9.0006454225383], [1170219600000, 9.2233916171431], [1172638800000, 8.8929316009479], [1175313600000, 10.345937520404], [1177905600000, 10.075914677026], [1180584000000, 10.089006188111], [1183176000000, 10.598330295008], [1185854400000, 9.9689546533009], [1188532800000, 9.7740580198146], [1191124800000, 10.558483060626], [1193803200000, 9.9314651823603], [1196398800000, 9.3997715873769], [1199077200000, 8.4086493387262], [1201755600000, 8.9698309085926], [1204261200000, 8.2778357995396], [1206936000000, 8.8585045600123], [1209528000000, 8.7013756413322], [1212206400000, 7.7933605469443], [1214798400000, 7.0236183483064], [1217476800000, 6.9873088186829], [1220155200000, 6.8031713070097], [1222747200000, 6.6869531315723], [1225425600000, 6.138256993963], [1228021200000, 5.6434994016354], [1230699600000, 5.495220262512], [1233378000000, 4.6885326869846], [1235797200000, 4.4524349883438], [1238472000000, 5.6766520778185], [1241064000000, 5.7675774480752], [1243742400000, 5.7882863168337], [1246334400000, 7.2666010034924], [1249012800000, 7.5191821322261], [1251691200000, 7.849651451445], [1254283200000, 10.383992037985], [1256961600000, 9.0653691861818], [1259557200000, 9.6705248324159], [1262235600000, 10.856380561349], [1264914000000, 11.27452370892], [1267333200000, 11.754156529088], [1270008000000, 8.2870811422455], [1272600000000, 8.0210264360699], [1275278400000, 7.5375074474865], [1277870400000, 8.3419527338039], [1280548800000, 9.4197471818443], [1283227200000, 8.7321733185797], [1285819200000, 9.6627062648126], [1288497600000, 10.187962234548], [1291093200000, 9.8144201733476], [1293771600000, 10.275723361712], [1296450000000, 16.796066079353], [1298869200000, 17.543254984075], [1301544000000, 16.673660675083], [1304136000000, 17.963944353609], [1306814400000, 16.63774086721], [1309406400000, 15.84857094609], [1312084800000, 14.767303362181], [1314763200000, 24.778452182433], [1317355200000, 18.370353229999], [1320033600000, 15.253137429099], [1322629200000, 14.989600840649], [1325307600000, 16.052539160125], [1327986000000, 16.424390322793], [1330491600000, 17.884020741104], [1333166400000, 18.372698836036], [1335758400000, 18.315881576096]]
                },

                {
                    'key'   : 'Asia',
                    'values': [[1025409600000, 13.153938631352], [1028088000000, 12.456410521864], [1030766400000, 12.537048663919], [1033358400000, 13.947386398309], [1036040400000, 14.421680682568], [1038632400000, 14.143238262286], [1041310800000, 12.229635347478], [1043989200000, 12.508479916948], [1046408400000, 12.155368409526], [1049086800000, 13.335455563994], [1051675200000, 12.888210138167], [1054353600000, 12.842092790511], [1056945600000, 12.513816474199], [1059624000000, 12.21453674494], [1062302400000, 11.750848343935], [1064894400000, 10.526579636787], [1067576400000, 10.873596086087], [1070168400000, 11.019967131519], [1072846800000, 11.235789380602], [1075525200000, 11.859910850657], [1078030800000, 12.531031616536], [1080709200000, 11.360451067019], [1083297600000, 11.456244780202], [1085976000000, 11.436991407309], [1088568000000, 11.638595744327], [1091246400000, 11.190418301469], [1093924800000, 11.835608007589], [1096516800000, 11.540980244475], [1099195200000, 10.958762325687], [1101790800000, 10.885791159509], [1104469200000, 13.605810720109], [1107147600000, 13.128978067437], [1109566800000, 13.119012086882], [1112245200000, 13.003706129783], [1114833600000, 13.326996807689], [1117512000000, 13.547947991743], [1120104000000, 12.807959646616], [1122782400000, 12.931763821068], [1125460800000, 12.795359993008], [1128052800000, 9.6998935538319], [1130734800000, 9.3473740089131], [1133326800000, 9.36902067716], [1136005200000, 14.258619539875], [1138683600000, 14.21241095603], [1141102800000, 13.973193618249], [1143781200000, 15.218233920664], [1146369600000, 14.382109727451], [1149048000000, 13.894310878491], [1151640000000, 15.593086090031], [1154318400000, 16.244839695189], [1156996800000, 16.017088850647], [1159588800000, 14.183951830057], [1162270800000, 14.148523245696], [1164862800000, 13.424326059971], [1167541200000, 12.974450435754], [1170219600000, 13.232470418021], [1172638800000, 13.318762655574], [1175313600000, 15.961407746104], [1177905600000, 16.287714639805], [1180584000000, 16.24659058389], [1183176000000, 17.564505594808], [1185854400000, 17.872725373164], [1188532800000, 18.018998508756], [1191124800000, 15.584518016602], [1193803200000, 15.480850647182], [1196398800000, 15.699120036985], [1199077200000, 19.184281817226], [1201755600000, 19.691226605205], [1204261200000, 18.982314051293], [1206936000000, 18.707820309008], [1209528000000, 17.459630929759], [1212206400000, 16.500616076782], [1214798400000, 18.086324003978], [1217476800000, 18.929464156259], [1220155200000, 18.233728682084], [1222747200000, 16.315776297325], [1225425600000, 14.632892190251], [1228021200000, 14.667835024479], [1230699600000, 13.946993947309], [1233378000000, 14.394304684398], [1235797200000, 13.724462792967], [1238472000000, 10.930879035807], [1241064000000, 9.8339915513708], [1243742400000, 10.053858541872], [1246334400000, 11.786998438286], [1249012800000, 11.780994901769], [1251691200000, 11.305889670277], [1254283200000, 10.918452290083], [1256961600000, 9.6811395055706], [1259557200000, 10.971529744038], [1262235600000, 13.330210480209], [1264914000000, 14.592637568961], [1267333200000, 14.605329141157], [1270008000000, 13.936853794037], [1272600000000, 12.189480759072], [1275278400000, 11.676151385046], [1277870400000, 13.058852800018], [1280548800000, 13.62891543203], [1283227200000, 13.811107569918], [1285819200000, 13.786494560786], [1288497600000, 14.045162857531], [1291093200000, 13.697412447286], [1293771600000, 13.677681376221], [1296450000000, 19.96151186453], [1298869200000, 21.049198298156], [1301544000000, 22.687631094009], [1304136000000, 25.469010617433], [1306814400000, 24.88379943712], [1309406400000, 24.203843814249], [1312084800000, 22.138760964036], [1314763200000, 16.034636966228], [1317355200000, 15.394958944555], [1320033600000, 12.62564246197], [1322629200000, 12.973735699739], [1325307600000, 15.78601833615], [1327986000000, 15.227368020134], [1330491600000, 15.899752650733], [1333166400000, 15.661317319168], [1335758400000, 15.359891177281]]
                },

                {
                    'key'   : 'Europe',
                    'values': [[1025409600000, 9.3433263069351], [1028088000000, 8.4583069475546], [1030766400000, 8.0342398154196], [1033358400000, 8.1538966876572], [1036040400000, 10.743604786849], [1038632400000, 12.349366155851], [1041310800000, 10.742682503899], [1043989200000, 11.360983869935], [1046408400000, 11.441336039535], [1049086800000, 10.897508791837], [1051675200000, 11.469101547709], [1054353600000, 12.086311476742], [1056945600000, 8.0697180773504], [1059624000000, 8.2004392233445], [1062302400000, 8.4566434900643], [1064894400000, 7.9565760979059], [1067576400000, 9.3764619255827], [1070168400000, 9.0747664160538], [1072846800000, 10.508939004673], [1075525200000, 10.69936754483], [1078030800000, 10.681562399145], [1080709200000, 13.184786109406], [1083297600000, 12.668213052351], [1085976000000, 13.430509403986], [1088568000000, 12.393086349213], [1091246400000, 11.942374044842], [1093924800000, 12.062227685742], [1096516800000, 11.969974363623], [1099195200000, 12.14374574055], [1101790800000, 12.69422821995], [1104469200000, 9.1235211044692], [1107147600000, 8.758211757584], [1109566800000, 8.8072309258443], [1112245200000, 11.687595946835], [1114833600000, 11.079723082664], [1117512000000, 12.049712896076], [1120104000000, 10.725319428684], [1122782400000, 10.844849996286], [1125460800000, 10.833535488461], [1128052800000, 17.180932407865], [1130734800000, 15.894764896516], [1133326800000, 16.412751299498], [1136005200000, 12.573569093402], [1138683600000, 13.242301508051], [1141102800000, 12.863536342041], [1143781200000, 21.034044171629], [1146369600000, 21.419084618802], [1149048000000, 21.142678863692], [1151640000000, 26.56848967753], [1154318400000, 24.839144939906], [1156996800000, 25.456187462166], [1159588800000, 26.350164502825], [1162270800000, 26.478333205189], [1164862800000, 26.425979547846], [1167541200000, 28.191461582256], [1170219600000, 28.930307448808], [1172638800000, 29.521413891117], [1175313600000, 28.188285966466], [1177905600000, 27.704619625831], [1180584000000, 27.49086242483], [1183176000000, 28.770679721286], [1185854400000, 29.06048067145], [1188532800000, 28.240998844973], [1191124800000, 33.004893194128], [1193803200000, 34.075180359928], [1196398800000, 32.548560664834], [1199077200000, 30.629727432729], [1201755600000, 28.642858788159], [1204261200000, 27.973575227843], [1206936000000, 27.393351882726], [1209528000000, 28.476095288522], [1212206400000, 29.29667866426], [1214798400000, 29.222333802896], [1217476800000, 28.092966093842], [1220155200000, 28.107159262922], [1222747200000, 25.482974832099], [1225425600000, 21.208115993834], [1228021200000, 20.295043095268], [1230699600000, 15.925754618402], [1233378000000, 17.162864628346], [1235797200000, 17.084345773174], [1238472000000, 22.24600710228], [1241064000000, 24.530543998508], [1243742400000, 25.084184918241], [1246334400000, 16.606166527359], [1249012800000, 17.239620011628], [1251691200000, 17.336739127379], [1254283200000, 25.478492475754], [1256961600000, 23.017152085244], [1259557200000, 25.617745423684], [1262235600000, 24.061133998641], [1264914000000, 23.223933318646], [1267333200000, 24.425887263936], [1270008000000, 35.501471156693], [1272600000000, 33.775013878675], [1275278400000, 30.417993630285], [1277870400000, 30.023598978467], [1280548800000, 33.327519522436], [1283227200000, 31.963388450372], [1285819200000, 30.49896723209], [1288497600000, 32.403696817913], [1291093200000, 31.47736071922], [1293771600000, 31.53259666241], [1296450000000, 41.760282761548], [1298869200000, 45.605771243237], [1301544000000, 39.986557966215], [1304136000000, 43.84633051005], [1306814400000, 39.857316881858], [1309406400000, 37.675127768207], [1312084800000, 35.775077970313], [1314763200000, 48.631009702578], [1317355200000, 42.830831754505], [1320033600000, 35.611502589362], [1322629200000, 35.320136981738], [1325307600000, 31.564136901516], [1327986000000, 32.074407502433], [1330491600000, 35.053013769977], [1333166400000, 33.873085184128], [1335758400000, 32.321039427046]]
                },

                {
                    'key'   : 'Australia',
                    'values': [[1025409600000, 5.1162447683392], [1028088000000, 4.2022848306513], [1030766400000, 4.3543715758736], [1033358400000, 5.4641223667245], [1036040400000, 6.0041275884577], [1038632400000, 6.6050520064486], [1041310800000, 5.0154059912793], [1043989200000, 5.1835708554647], [1046408400000, 5.1142682006164], [1049086800000, 5.0271381717695], [1051675200000, 5.3437782653456], [1054353600000, 5.2105844515767], [1056945600000, 6.552565997799], [1059624000000, 6.9873363581831], [1062302400000, 7.010986789097], [1064894400000, 4.4254242025515], [1067576400000, 4.9613848042174], [1070168400000, 4.8854920484764], [1072846800000, 4.0441111794228], [1075525200000, 4.0219596813179], [1078030800000, 4.3065749225355], [1080709200000, 3.9148434915404], [1083297600000, 3.8659430654512], [1085976000000, 3.9572824600686], [1088568000000, 4.7372190641522], [1091246400000, 4.6871476374455], [1093924800000, 5.0398702564196], [1096516800000, 5.5221787544964], [1099195200000, 5.424646299798], [1101790800000, 5.9240223067349], [1104469200000, 5.9936860983601], [1107147600000, 5.8499523215019], [1109566800000, 6.4149040329325], [1112245200000, 6.4547895561969], [1114833600000, 5.9385382611161], [1117512000000, 6.0486751030592], [1120104000000, 5.23108613838], [1122782400000, 5.5857797121029], [1125460800000, 5.3454665096987], [1128052800000, 5.0439154120119], [1130734800000, 5.054634702913], [1133326800000, 5.3819451380848], [1136005200000, 5.2638869269803], [1138683600000, 5.5806167415681], [1141102800000, 5.4539047069985], [1143781200000, 7.6728842432362], [1146369600000, 7.719946716654], [1149048000000, 8.0144619912942], [1151640000000, 7.942223133434], [1154318400000, 8.3998279827444], [1156996800000, 8.532324572605], [1159588800000, 4.7324285199763], [1162270800000, 4.7402397487697], [1164862800000, 4.9042069355168], [1167541200000, 5.9583963430882], [1170219600000, 6.3693899239171], [1172638800000, 6.261153903813], [1175313600000, 5.3443942184584], [1177905600000, 5.4932111235361], [1180584000000, 5.5747393101109], [1183176000000, 5.3833633060013], [1185854400000, 5.5125898831832], [1188532800000, 5.8116112661327], [1191124800000, 4.3962296939996], [1193803200000, 4.6967663605521], [1196398800000, 4.7963004350914], [1199077200000, 4.1817985183351], [1201755600000, 4.3797643870182], [1204261200000, 4.6966642197965], [1206936000000, 4.3609995132565], [1209528000000, 4.4736290996496], [1212206400000, 4.3749762738128], [1214798400000, 3.3274661194507], [1217476800000, 3.0316184691337], [1220155200000, 2.5718140204728], [1222747200000, 2.7034994044603], [1225425600000, 2.2033786591364], [1228021200000, 1.9850621240805], [1230699600000, 0], [1233378000000, 0], [1235797200000, 0], [1238472000000, 0], [1241064000000, 0], [1243742400000, 0], [1246334400000, 0], [1249012800000, 0], [1251691200000, 0], [1254283200000, 0.44495950017788], [1256961600000, 0.33945469262483], [1259557200000, 0.38348269455195], [1262235600000, 0], [1264914000000, 0], [1267333200000, 0], [1270008000000, 0], [1272600000000, 0], [1275278400000, 0], [1277870400000, 0], [1280548800000, 0], [1283227200000, 0], [1285819200000, 0], [1288497600000, 0], [1291093200000, 0], [1293771600000, 0], [1296450000000, 0.52216435716176], [1298869200000, 0.59275786698454], [1301544000000, 0], [1304136000000, 0], [1306814400000, 0], [1309406400000, 0], [1312084800000, 0], [1314763200000, 0], [1317355200000, 0], [1320033600000, 0], [1322629200000, 0], [1325307600000, 0], [1327986000000, 0], [1330491600000, 0], [1333166400000, 0], [1335758400000, 0]]
                },

                {
                    'key'   : 'Antarctica',
                    'values': [[1025409600000, 1.3503144674343], [1028088000000, 1.2232741112434], [1030766400000, 1.3930470790784], [1033358400000, 1.2631275030593], [1036040400000, 1.5842699103708], [1038632400000, 1.9546996043116], [1041310800000, 0.8504048300986], [1043989200000, 0.85340686311353], [1046408400000, 0.843061357391], [1049086800000, 2.119846992476], [1051675200000, 2.5285382124858], [1054353600000, 2.5056570712835], [1056945600000, 2.5212789901005], [1059624000000, 2.6192011642534], [1062302400000, 2.5382187823805], [1064894400000, 2.3393223047168], [1067576400000, 2.491219888698], [1070168400000, 2.497555874906], [1072846800000, 1.734018115546], [1075525200000, 1.9307268299646], [1078030800000, 2.2261679836799], [1080709200000, 1.7608893704206], [1083297600000, 1.6242690616808], [1085976000000, 1.7161663801295], [1088568000000, 1.7183554537038], [1091246400000, 1.7179780759145], [1093924800000, 1.7314274801784], [1096516800000, 1.2596883356752], [1099195200000, 1.381177053009], [1101790800000, 1.4408819615814], [1104469200000, 3.4743581836444], [1107147600000, 3.3603749903192], [1109566800000, 3.5350883257893], [1112245200000, 3.0949644237828], [1114833600000, 3.0796455899995], [1117512000000, 3.3441247640644], [1120104000000, 4.0947643978168], [1122782400000, 4.4072631274052], [1125460800000, 4.4870979780825], [1128052800000, 4.8404549457934], [1130734800000, 4.8293016233697], [1133326800000, 5.2238093263952], [1136005200000, 3.382306337815], [1138683600000, 3.7056975170243], [1141102800000, 3.7561118692318], [1143781200000, 2.861913700854], [1146369600000, 2.9933744103381], [1149048000000, 2.7127537218463], [1151640000000, 3.1195497076283], [1154318400000, 3.4066964004508], [1156996800000, 3.3754571113569], [1159588800000, 2.2965579982924], [1162270800000, 2.4486818633018], [1164862800000, 2.4002308848517], [1167541200000, 1.9649579750349], [1170219600000, 1.9385263638056], [1172638800000, 1.9128975336387], [1175313600000, 2.3412869836298], [1177905600000, 2.4337870351445], [1180584000000, 2.62179703171], [1183176000000, 3.2642864957929], [1185854400000, 3.3200396223709], [1188532800000, 3.3934212707572], [1191124800000, 4.2822327088179], [1193803200000, 4.1474964228541], [1196398800000, 4.1477082879801], [1199077200000, 5.2947122916128], [1201755600000, 5.2919843508028], [1204261200000, 5.198978305031], [1206936000000, 3.5603057673513], [1209528000000, 3.3009087690692], [1212206400000, 3.1784852603792], [1214798400000, 4.5889503538868], [1217476800000, 4.401779617494], [1220155200000, 4.2208301828278], [1222747200000, 3.89396671475], [1225425600000, 3.0423832241354], [1228021200000, 3.135520611578], [1230699600000, 1.9631418164089], [1233378000000, 1.8963543874958], [1235797200000, 1.8266636017025], [1238472000000, 0.93136635895188], [1241064000000, 0.92737801918888], [1243742400000, 0.97591889805002], [1246334400000, 2.6841193805515], [1249012800000, 2.5664341140531], [1251691200000, 2.3887523699873], [1254283200000, 1.1737801663681], [1256961600000, 1.0953582317281], [1259557200000, 1.2495674976653], [1262235600000, 0.36607452464754], [1264914000000, 0.3548719047291], [1267333200000, 0.36769242398939], [1270008000000, 0], [1272600000000, 0], [1275278400000, 0], [1277870400000, 0], [1280548800000, 0], [1283227200000, 0], [1285819200000, 0.85450741275337], [1288497600000, 0.91360317921637], [1291093200000, 0.89647678692269], [1293771600000, 0.87800687192639], [1296450000000, 0], [1298869200000, 0], [1301544000000, 0.43668720882994], [1304136000000, 0.4756523602692], [1306814400000, 0.46947368328469], [1309406400000, 0.45138896152316], [1312084800000, 0.43828726648117], [1314763200000, 2.0820861395316], [1317355200000, 0.9364411075395], [1320033600000, 0.60583907839773], [1322629200000, 0.61096950747437], [1325307600000, 0], [1327986000000, 0], [1330491600000, 0], [1333166400000, 0], [1335758400000, 0]]
                }

            ]
        };

        vm.historicalBarChart = {
            options: {
                chart: {
                    type              : 'historicalBarChart',
                    height            : 450,
                    margin            : {
                        top   : 20,
                        right : 20,
                        bottom: 60,
                        left  : 50
                    },
                    x                 : function (d)
                    {
                        return d[0];
                    },
                    y                 : function (d)
                    {
                        return d[1] / 100000;
                    },
                    showValues        : true,
                    valueFormat       : function (d)
                    {
                        return d3.format(',.1f')(d);
                    },
                    transitionDuration: 500,
                    xAxis             : {
                        axisLabel   : 'X Axis',
                        tickFormat  : function (d)
                        {
                            return d3.time.format('%x')(new Date(d));
                        },
                        rotateLabels: 50,
                        showMaxMin  : false
                    },
                    yAxis             : {
                        axisLabel        : 'Y Axis',
                        axisLabelDistance: 35,
                        tickFormat       : function (d)
                        {
                            return d3.format(',.1f')(d);
                        }
                    }
                }
            },

            data: [
                {
                    'key'   : 'Quantity',
                    'bar'   : true,
                    'values': [[1159588800000, 3899486.0], [1162270800000, 3899486.0], [1164862800000, 3899486.0], [1167541200000, 3564700.0], [1170219600000, 3564700.0], [1172638800000, 3564700.0], [1175313600000, 2648493.0], [1177905600000, 2648493.0], [1180584000000, 2648493.0], [1183176000000, 2522993.0], [1185854400000, 2522993.0], [1188532800000, 2522993.0], [1191124800000, 2906501.0], [1193803200000, 2906501.0], [1196398800000, 2906501.0], [1199077200000, 2206761.0], [1201755600000, 2206761.0], [1204261200000, 2206761.0], [1206936000000, 2287726.0], [1209528000000, 2287726.0], [1212206400000, 2287726.0], [1214798400000, 2732646.0], [1217476800000, 2732646.0], [1220155200000, 2732646.0], [1222747200000, 2599196.0], [1225425600000, 2599196.0], [1228021200000, 2599196.0], [1230699600000, 1924387.0], [1233378000000, 1924387.0], [1235797200000, 1924387.0], [1238472000000, 1756311.0], [1241064000000, 1756311.0], [1243742400000, 1756311.0], [1246334400000, 1743470.0], [1249012800000, 1743470.0], [1251691200000, 1743470.0], [1254283200000, 1519010.0], [1256961600000, 1519010.0], [1259557200000, 1519010.0], [1262235600000, 1591444.0], [1264914000000, 1591444.0], [1267333200000, 1591444.0], [1270008000000, 1543784.0], [1272600000000, 1543784.0], [1275278400000, 1543784.0], [1277870400000, 1309915.0], [1280548800000, 1309915.0], [1283227200000, 1309915.0], [1285819200000, 1331875.0], [1288497600000, 1331875.0], [1291093200000, 1331875.0], [1293771600000, 1331875.0], [1296450000000, 1154695.0], [1298869200000, 1154695.0], [1301544000000, 1194025.0], [1304136000000, 1194025.0], [1306814400000, 1194025.0], [1309406400000, 1194025.0], [1312084800000, 1194025.0], [1314763200000, 1244525.0], [1317355200000, 475000.0], [1320033600000, 475000.0], [1322629200000, 475000.0], [1325307600000, 690033.0], [1327986000000, 690033.0], [1330491600000, 690033.0], [1333166400000, 514733.0], [1335758400000, 514733.0]]
                }]
        };

        vm.multiBarHorizontalChart = {
            options: {
                chart: {
                    type              : 'multiBarHorizontalChart',
                    height            : 450,
                    x                 : function (d)
                    {
                        return d.label;
                    },
                    y                 : function (d)
                    {
                        return d.value;
                    },
                    showControls      : true,
                    showValues        : true,
                    transitionDuration: 500,
                    xAxis             : {
                        showMaxMin: false
                    },
                    yAxis             : {
                        axisLabel : 'Values',
                        tickFormat: function (d)
                        {
                            return d3.format(',.2f')(d);
                        }
                    }
                }
            },
            data   : [
                {
                    'key'   : 'Series1',
                    'color' : '#d62728',
                    'values': [
                        {
                            'label': 'Group A',
                            'value': -1.8746444827653
                        },
                        {
                            'label': 'Group B',
                            'value': -8.0961543492239
                        },
                        {
                            'label': 'Group C',
                            'value': -0.57072943117674
                        },
                        {
                            'label': 'Group D',
                            'value': -2.4174010336624
                        },
                        {
                            'label': 'Group E',
                            'value': -0.72009071426284
                        },
                        {
                            'label': 'Group F',
                            'value': -0.77154485523777
                        },
                        {
                            'label': 'Group G',
                            'value': -0.90152097798131
                        },
                        {
                            'label': 'Group H',
                            'value': -0.91445417330854
                        },
                        {
                            'label': 'Group I',
                            'value': -0.055746319141851
                        }
                    ]
                },
                {
                    'key'   : 'Series2',
                    'color' : '#1f77b4',
                    'values': [
                        {
                            'label': 'Group A',
                            'value': 25.307646510375
                        },
                        {
                            'label': 'Group B',
                            'value': 16.756779544553
                        },
                        {
                            'label': 'Group C',
                            'value': 18.451534877007
                        },
                        {
                            'label': 'Group D',
                            'value': 8.6142352811805
                        },
                        {
                            'label': 'Group E',
                            'value': 7.8082472075876
                        },
                        {
                            'label': 'Group F',
                            'value': 5.259101026956
                        },
                        {
                            'label': 'Group G',
                            'value': 0.30947953487127
                        },
                        {
                            'label': 'Group H',
                            'value': 0
                        },
                        {
                            'label': 'Group I',
                            'value': 0
                        }
                    ]
                }
            ]
        };

        vm.pieChart = {
            options: {
                chart: {
                    type              : 'pieChart',
                    height            : 500,
                    x                 : function (d)
                    {
                        return d.key;
                    },
                    y                 : function (d)
                    {
                        return d.y;
                    },
                    showLabels        : true,
                    transitionDuration: 500,
                    labelThreshold    : 0.01,
                    legend            : {
                        margin: {
                            top   : 5,
                            right : 35,
                            bottom: 5,
                            left  : 0
                        }
                    }
                }
            },
            data   : [
                {
                    key: 'One',
                    y  : 5
                },
                {
                    key: 'Two',
                    y  : 2
                },
                {
                    key: 'Three',
                    y  : 9
                },
                {
                    key: 'Four',
                    y  : 7
                },
                {
                    key: 'Five',
                    y  : 4
                },
                {
                    key: 'Six',
                    y  : 3
                },
                {
                    key: 'Seven',
                    y  : 0.5
                }
            ]
        };

        vm.donutChart = {
            options: {
                chart: {
                    type      : 'pieChart',
                    height    : 450,
                    donut     : true,
                    x         : function (d)
                    {
                        return d.key;
                    },
                    y         : function (d)
                    {
                        return d.y;
                    },
                    showLabels: true,

                    pie               : {
                        startAngle: function (d)
                        {
                            return d.startAngle / 2 - Math.PI / 2;
                        },
                        endAngle  : function (d)
                        {
                            return d.endAngle / 2 - Math.PI / 2;
                        }
                    },
                    transitionDuration: 500,
                    legend            : {
                        margin: {
                            top   : 5,
                            right : 70,
                            bottom: 5,
                            left  : 0
                        }
                    }
                }
            },

            data: [
                {
                    key: 'One',
                    y  : 5
                },
                {
                    key: 'Two',
                    y  : 2
                },
                {
                    key: 'Three',
                    y  : 9
                },
                {
                    key: 'Four',
                    y  : 7
                },
                {
                    key: 'Five',
                    y  : 4
                },
                {
                    key: 'Six',
                    y  : 3
                },
                {
                    key: 'Seven',
                    y  : 0.5
                }
            ]

        };

        vm.sparklineChart = {
            options: {
                chart: {
                    type              : 'sparklinePlus',
                    height            : 450,
                    x                 : function (d, i)
                    {
                        return i;
                    },
                    xTickFormat       : function (d)
                    {
                        return d3.time.format('%x')(new Date(vm.sparklineChart.data[d].x));
                    },
                    transitionDuration: 250
                }
            },

            //$scope.data = sine();
            data: volatileChart(130.0, 0.02)
        };

        vm.bulletChart = {
            options: {
                chart: {
                    type              : 'bulletChart',
                    transitionDuration: 500
                }
            },
            data   : {
                'title'   : 'Revenue',
                'subtitle': 'US$, in thousands',
                'ranges'  : [150, 225, 300],
                'measures': [220],
                'markers' : [250]
            }
        };

        vm.scatterChart = {
            options: {
                chart: {
                    type              : 'scatterChart',
                    height            : 450,
                    color             : d3.scale.category10().range(),
                    scatter           : {
                        onlyCircles: false
                    },
                    showDistX         : true,
                    showDistY         : true,
                    tooltipContent    : function (key)
                    {
                        return '<h3>' + key + '</h3>';
                    },
                    transitionDuration: 350,
                    xAxis             : {
                        axisLabel : 'X Axis',
                        tickFormat: function (d)
                        {
                            return d3.format('.02f')(d);
                        }
                    },
                    yAxis             : {
                        axisLabel        : 'Y Axis',
                        tickFormat       : function (d)
                        {
                            return d3.format('.02f')(d);
                        },
                        axisLabelDistance: 30
                    }
                }
            },
            data   : generateData(4, 5)
        };

        // Methods


        //////////

        /*Random Data Generator */
        function sinAndCos()
        {
            var sin = [], sin2 = [],
                cos = [];

            //Data is represented as an array of {x,y} pairs.
            for ( var i = 0; i < 100; i++ )
            {
                sin.push({
                    x: i,
                    y: Math.sin(i / 10)
                });
                sin2.push({
                    x: i,
                    y: (i % 10 === 5 ? null : Math.sin(i / 10) * 0.25 + 0.5)
                });
                cos.push({
                    x: i,
                    y: 0.5 * Math.cos(i / 10 + 2) + Math.random() / 10
                });
            }

            //Line chart data should be sent as an array of series objects.
            return [
                {
                    values: sin,      //values - represents the array of {x,y} data points
                    key   : 'Sine Wave', //key  - the name of the series.
                    color : '#ff7f0e'  //color - optional: choose your own line color.
                },
                {
                    values: cos,
                    key   : 'Cosine Wave',
                    color : '#2ca02c'
                },
                {
                    values: sin2,
                    key   : 'Another sine wave',
                    color : '#7777ff',
                    area  : true      //area - set to true if you want this line to turn into a filled area chart.
                }
            ];
        }

        function volatileChart(startPrice, volatility, numPoints)
        {
            var rval = [];
            var now = +new Date();
            numPoints = numPoints || 100;
            for ( var i = 1; i < numPoints; i++ )
            {
                rval.push({
                    x: now + i * 1000 * 60 * 60 * 24,
                    y: startPrice
                });
                var rnd = Math.random();
                var changePct = 2 * volatility * rnd;
                if ( changePct > volatility )
                {
                    changePct -= (2 * volatility);
                }
                startPrice = startPrice + startPrice * changePct;
            }
            return rval;
        }

        /* Random Data Generator (took from nvd3.org) */
        function generateData(groups, points)
        {
            var data = [],
                shapes = ['circle', 'cross', 'triangle-up', 'triangle-down', 'diamond', 'square'],
                random = d3.random.normal();

            for ( var i = 0; i < groups; i++ )
            {
                data.push({
                    key   : 'Group ' + i,
                    values: []
                });

                for ( var j = 0; j < points; j++ )
                {
                    data[i].values.push(
                        {
                            x    : random(),
                            y    : random(),
                            size : Math.random(),
                            shape: shapes[j % 6]
                        });
                }
            }
            return data;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.chartist',
            [
                // 3rd Party Dependencies
                'angular-chartist'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_charts_chartist', {
            url  : '/components/charts/chartist',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/charts/chartist/chartist.html',
                    controller : 'ChartistController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.chartist')
        .controller('ChartistController', ChartistController);

    function ChartistController()
    {
        var vm = this;

        // Data

        // line chart
        vm.lineChart = {
            data   : {
                labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday'],
                series: [
                    [12, 9, 7, 8, 5],
                    [2, 1, 3.5, 7, 3],
                    [1, 3, 4, 5, 6]
                ]
            },
            options: {
                fullWidth   : true,
                chartPadding: {
                    right: 40
                }
            }
        };

        // line Area chart
        vm.lineAreaChart = {
            data   : {
                labels: [1, 2, 3, 4, 5, 6, 7, 8],
                series: [
                    [5, 9, 7, 8, 5, 3, 5, 4]
                ]
            },
            options: {
                low     : 0,
                showArea: true
            }
        };

        vm.biPolarLineChart = {
            data   : {
                labels: [1, 2, 3, 4, 5, 6, 7, 8],
                series: [
                    [1, 2, 3, 1, -2, 0, 1, 0],
                    [-2, -1, -2, -1, -2.5, -1, -2, -1],
                    [0, 0, 0, 1, 2, 2.5, 2, 1],
                    [2.5, 2, 1, 0.5, 1, 0.5, -1, -2.5]
                ]
            },
            options: {
                high     : 3,
                low      : -3,
                showArea : true,
                showLine : false,
                showPoint: false,
                fullWidth: true,
                axisX    : {
                    showLabel: false,
                    showGrid : false
                }
            }
        };

        vm.stackedBarChart = {
            data   : {
                labels: ['Q1', 'Q2', 'Q3', 'Q4'],
                series: [
                    [800000, 1200000, 1400000, 1300000],
                    [200000, 400000, 500000, 300000],
                    [100000, 200000, 400000, 600000]
                ]
            },
            options: {
                stackBars: true,
                axisY    : {
                    labelInterpolationFnc: function (value)
                    {
                        return (value / 1000) + 'k';
                    }
                }
            },
            events : {
                draw: function (data)
                {
                    if ( data.type === 'bar' )
                    {
                        data.element.attr({
                            style: 'stroke-width: 30px'
                        });
                    }
                }
            }
        };

        // bar chart
        vm.barChart = {
            data             : {
                labels: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
                series: [
                    [5, 4, 3, 7, 5, 10, 3, 4, 8, 10, 6, 8],
                    [3, 2, 9, 5, 4, 6, 4, 6, 7, 8, 7, 4]
                ]
            },
            options          : {
                seriesBarDistance: 15
            },
            responsiveOptions: [
                ['screen and (min-width: 641px) and (max-width: 1024px)', {
                    seriesBarDistance: 10,
                    axisX            : {
                        labelInterpolationFnc: function (value)
                        {
                            return value;
                        }
                    }
                }],
                ['screen and (max-width: 640px)', {
                    seriesBarDistance: 5,
                    axisX            : {
                        labelInterpolationFnc: function (value)
                        {
                            return value[0];
                        }
                    }
                }]
            ]
        };

        // Horizontal bar chart
        vm.horizontalBarChart = {
            data   : {
                labels: ['Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday', 'Sunday'],
                series: [
                    [5, 4, 3, 7, 5, 10, 3],
                    [3, 2, 9, 5, 4, 6, 4]
                ]
            },
            options: {
                seriesBarDistance: 10,
                reverseData      : true,
                horizontalBars   : true,
                axisY            : {
                    offset: 70
                }
            }
        };

        vm.biPolarBarChart = {
            data   : {
                labels: ['W1', 'W2', 'W3', 'W4', 'W5', 'W6', 'W7', 'W8', 'W9', 'W10'],
                series: [
                    [1, 2, 4, 8, 6, -2, -1, -4, -6, -2]
                ]
            },
            options: {
                high : 10,
                low  : -10,
                axisX: {
                    labelInterpolationFnc: function (value, index)
                    {
                        return index % 2 === 0 ? value : null;
                    }
                }
            }
        };

        // pie chart
        vm.pieChart = {
            data             : {
                labels: ['Bananas', 'Apples', 'Grapes'],
                series: [20, 15, 40]
            },
            options          : {
                labelInterpolationFnc: function (value)
                {
                    return value[0];
                }
            },
            responsiveOptions: [
                ['screen and (min-width: 640px)', {
                    chartPadding         : 40,
                    labelOffset          : 150,
                    labelDirection       : 'explode',
                    labelInterpolationFnc: function (value)
                    {
                        return value;
                    }
                }],
                ['screen and (min-width: 1024px)', {
                    labelOffset : 120,
                    chartPadding: 30
                }]
            ]

        };

        // donut chart
        vm.donutChart = {
            data   : {
                series: [20, 10, 30, 40]
            },
            options: {
                donut: true
            }
        };

        vm.gaugeChart = {
            data   : {
                series: [20, 10, 30, 40]
            },
            options: {
                donut     : true,
                donutWidth: 60,
                startAngle: 270,
                total     : 200,
                showLabel : true
            }
        };
        // Methods

        //////////

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.chart-js',
            [
                // 3rd Party Dependencies
                'chart.js'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_charts_chart-js', {
            url  : '/components/charts/chart-js',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/charts/chart-js/chart-js.html',
                    controller : 'ChartJsController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.chart-js')
        .controller('ChartJsController', ChartJsController);

    function ChartJsController()
    {
        var vm = this;

        // Data
        vm.lineChart = {
            labels: ['January', 'February', 'March', 'April', 'May', 'June', 'July'],
            series: ['Series A', 'Series B'],
            data  : [
                [65, 59, 80, 81, 56, 55, 40],
                [28, 48, 40, 19, 86, 27, 90]
            ]
        };

        vm.barChart = {
            labels: ['2006', '2007', '2008', '2009', '2010', '2011', '2012'],
            series: ['Series A', 'Series B'],
            data  : [
                [65, 59, 80, 81, 56, 55, 40],
                [28, 48, 40, 19, 86, 27, 90]
            ]
        };

        vm.doughnutChart = {
            labels: ['Download Sales', 'In-Store Sales', 'Mail-Order Sales'],
            data  : [300, 500, 100]
        };

        vm.radarChart = {
            labels: ['Eating', 'Drinking', 'Sleeping', 'Designing', 'Coding', 'Cycling', 'Running'],
            data  : [
                [65, 59, 90, 81, 56, 55, 40],
                [28, 48, 40, 19, 96, 27, 100]
            ]
        };

        vm.pieChart = {
            labels: ['Download Sales', 'In-Store Sales', 'Mail-Order Sales'],
            data  : [300, 500, 100]
        };

        vm.polarChart = {
            labels: ['Download Sales', 'In-Store Sales', 'Mail-Order Sales', 'Tele Sales', 'Corporate Sales'],
            data  : [300, 500, 100, 40, 120]
        };

        // Methods

        //////////

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.c3',
            [
                // 3rd Party Dependencies
                'gridshore.c3js.chart'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_charts_c3', {
            url  : '/components/charts/c3',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/charts/c3/c3.html',
                    controller : 'C3Controller as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.charts.c3')
        .controller('C3Controller', C3Controller);

    function C3Controller()
    {
        var vm = this;

        // Data

        // Methods

        //////////

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-500', {
            url      : '/pages/errors/error-500',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-500': {
                    templateUrl: 'app/main/pages/errors/500/error-500.html',
                    controller : 'Error500Controller as vm'
                }
            },
            bodyClass: 'error-500'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/500');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.errors.error-500', {
            title : '500',
            state : 'app.pages_errors_error-500',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-500')
        .controller('Error500Controller', Error500Controller);

    /** @ngInject */
    function Error500Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-401', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-401', {
            url      : '/pages/errors/error-401',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-401': {
                    templateUrl: 'app/main/pages/errors/401/error-401.html',
                    controller : 'Error401Controller as vm'
                }
            },
            bodyClass: 'error-401'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/401');

        // Navigation
       /* msNavigationServiceProvider.saveItem('pages.errors', {
            title : 'Errors',
            icon  : 'icon-alert',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('pages.errors.error-401', {
            title : '401',
            state : 'app.pages_errors_error-401',
            weight: 1
        });*/
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-401')
        .controller('Error401Controller', Error401Controller);

    /** @ngInject */
    function Error401Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_errors_error-404', {
            url      : '/pages/errors/error-404',
            views    : {
                'main@'                             : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_errors_error-404': {
                    templateUrl: 'app/main/pages/errors/404/error-404.html',
                    controller : 'Error404Controller as vm'
                }
            },
            bodyClass: 'error-404'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/errors/404');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.errors', {
            title : 'Errors',
            icon  : 'icon-alert',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('pages.errors.error-404', {
            title : '404',
            state : 'app.pages_errors_error-404',
            weight: 1
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.error-404')
        .controller('Error404Controller', Error404Controller);

    /** @ngInject */
    function Error404Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_reset-password', {
            url      : '/pages/auth/reset-password',
            views    : {
                'main@'                                : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_reset-password': {
                    templateUrl: 'app/main/pages/auth/reset-password/reset-password.html',
                    controller : 'ResetPasswordController as vm'
                }
            },
            bodyClass: 'reset-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/reset-password');

        // Navigation
        // msNavigationServiceProvider.saveItem('pages.auth.reset-password', {
        //     title : 'Reset Password',
        //     state : 'app.pages_auth_reset-password',
        //     weight: 6
        // });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.reset-password')
        .controller('ResetPasswordController', ResetPasswordController);

    /** @ngInject */
    function ResetPasswordController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register-v2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_register-v2', {
            url      : '/pages/auth/register-v2',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_register-v2': {
                    templateUrl: 'app/main/pages/auth/register-v2/register-v2.html',
                    controller : 'RegisterV2Controller as vm'
                }
            },
            bodyClass: 'register-v2'
        });

        // Translate
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/register-v2');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.register-v2', {
            title : 'Register v2',
            state : 'app.pages_auth_register-v2',
            weight: 4
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register-v2')
        .controller('RegisterV2Controller', RegisterV2Controller);

    /** @ngInject */
    function RegisterV2Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_register', {
            url      : '/pages/auth/register',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_register': {
                    templateUrl: 'app/main/pages/auth/register/register.html',
                    controller : 'RegisterController as vm'
                }
            },
            bodyClass: 'register'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/register');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.register', {
            title : 'Register',
            state : 'app.pages_auth_register',
            weight: 3
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.register')
        .controller('RegisterController', RegisterController);

    /** @ngInject */
    function RegisterController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login-v2', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login-v2', {
            url      : '/pages/auth/login-v2',
            views    : {
                'main@'                          : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login-v2': {
                    templateUrl: 'app/main/pages/auth/login-v2/login-v2.html',
                    controller : 'LoginV2Controller as vm'
                }
            },
            bodyClass: 'login-v2'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/login-v2');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.auth.login-v2', {
            title : 'Login v2',
            state : 'app.pages_auth_login-v2',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login-v2')
        .controller('LoginV2Controller', LoginV2Controller);

    /** @ngInject */
    function LoginV2Controller()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.lock', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_lock', {
            url      : '/pages/auth/lock',
            views    : {
                'main@'                      : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_lock': {
                    templateUrl: 'app/main/pages/auth/lock/lock.html',
                    controller : 'LockController as vm'
                }
            },
            bodyClass: 'lock'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/lock');

        // Navigation
        // msNavigationServiceProvider.saveItem('pages.auth.lock', {
        //     title : 'Lock Screen',
        //     state : 'app.pages_auth_lock',
        //     weight: 7
        // });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.lock')
        .controller('LockController', LockController);

    /** @ngInject */
    function LockController($cookies,$scope,$state,msApi)
    {
        var vm = this;

        vm.current_user = $cookies.getObject('curr_user');
        /*vm.current_user['username'] = $cookies.get('current_user[username]');
        vm.current_user['email'] = $cookies.get('current_user[email]');
        vm.current_user['mobile'] = $cookies.get('current_user[mobile]');
        vm.current_user['name'] = $cookies.get('current_user[name]');
        vm.current_user['sex'] = $cookies.get('current_user[sex]');
        vm.current_user['avatar'] = $cookies.get('current_user[avatar]');*/
        vm.current_user['auth_key'] = $cookies.get('auth_key');


        vm.loading = false;




        // Data
        vm.form = {
            username: vm.current_user['username']
        };



        // Methods

        // Prevent to use the back button.
        $scope.$on('$locationChangeStart', function(event) {
                event.preventDefault();
        });


        vm.formSubmit = function(){
            var username = vm.form.username;
            var password = vm.form.password;
            vm.loading = true;
            msApi.request("pages.auth.login@get", {'act':'login', 'username': username, 'password':password}).then(
                // Success
                function (response)
                {
                    vm.loading = false;
                    console.log(response.data);
                    if (response.data.login_status == false) {// login failed
                        vm.login_message = response.data.login_message;
                    }else {// login success
                        vm.setLocking(false);
                        $state.go('app.store.dashboard');
                    }
                }
            );
        }

        vm.setLocking = function(lock){
            if (lock) {
                $cookies.put('locking','true');
            }else{
                $cookies.remove('locking');
            }
        }
        //////////
        vm.setLocking(true);//设置为locking状态
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_login', {
            url      : '/pages/auth/login',
            views    : {
                'main@'                       : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_login': {
                    templateUrl: 'app/main/pages/auth/login/login.html',
                    controller : 'LoginController as vm'
                }
            },
            bodyClass: 'login'
        });

        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/pages/auth/login');
        msApiProvider.register('pages.auth.login', [msApiProvider.getApiUrl() + 'users']);

        // Navigation
        // msNavigationServiceProvider.saveItem('pages.auth', {
        //     title : 'Authentication',
        //     icon  : 'icon-lock',
        //     weight: 1
        // });
        //
        // msNavigationServiceProvider.saveItem('pages.auth.login', {
        //     title : 'Login',
        //     state : 'app.pages_auth_login',
        //     weight: 1
        // });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.login')
        .controller('LoginController', LoginController);

    /** @ngInject */
    function LoginController($location, $state, msApi, $cookies, UserService)
    {
        var vm = this;
        // Data

        // Methods
        vm.formSubmit = formSubmit;
        //////////
        
        function formSubmit() {
            $('#login-btn').hide();
            vm.loadingThreads = true;
            var username = vm.form.username;
            var password = vm.form.password;

            msApi.request("pages.auth.login@get", {'act':'login', 'username': username, 'password':password}).then(
                // Success
                function (response)
                {
                    if (response.data.login_status == false) {// login failed
                        vm.login_message = response.data.login_message;
                        $('#login-btn').show();
                    }else {// login success
                        $cookies.put('store_id', response.data.store_id);
                        $cookies.put('store_name', response.data.store_name);
                        $cookies.put('store_city', response.data.store_city);
                        $cookies.put('role_id', response.data.role_id);
                        $cookies.put('auth_key', response.data.auth_key);
                        /*$cookies.put('current_user[id]', response.data.user.id);
                        $cookies.put('current_user[username]', response.data.user.username);
                        $cookies.put('current_user[email]', response.data.user.email);
                        $cookies.put('current_user[mobile]', response.data.user.mobile);
                        $cookies.put('current_user[name]', response.data.user.name);
                        $cookies.put('current_user[sex]', response.data.user.sex);
                        $cookies.put('current_user[avatar]', response.data.user.avatar);
                        $cookies.put('current_user[auth_key]', response.data.auth_key);
                        $cookies.put('current_user[role_id]', response.data.role_id);*/
                        UserService.loginWith(response.data);
                        //console.log(response.data);
                        $cookies.putObject('curr_permissions', response.data.permissions);
                        $cookies.putObject('curr_roles', response.data.roles);
                        var user =  angular.copy(response.data.user);
                        delete user.StoreHasUser;
                        delete user.RoleHasUser;
                        console.log(user);
                        $cookies.putObject('curr_user', user);
                        //$cookies.putObject('StoreHasUser', response.data.user.StoreHasUser);
                        var userall = angular.copy(response.data);
                        delete userall.permissions;
                        delete userall.roles;
                        delete userall.user;
                        delete userall.store_id;
                        delete userall.store_name;
                        delete userall.role_id;
                        delete userall.auth_key;
                        console.log(userall);
                        $cookies.putObject('tri_user', userall);

                        $cookies.remove('locking');
                        //$state.go('app.dashboards_project');
                        $location.path('/store/dashboard');
                        //document.location.reload();
                        //
                    }
                }
            );
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.pages_auth_forgot-password', {
            url      : '/pages/auth/forgot-password',
            views    : {
                'main@'                                 : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_auth_forgot-password': {
                    templateUrl: 'app/main/pages/auth/forgot-password/forgot-password.html',
                    controller : 'ForgotPasswordController as vm'
                }
            },
            bodyClass: 'forgot-password'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/auth/forgot-password');
        msApiProvider.register('app.pages.auth.user', [msApiProvider.getApiUrl() + 'users']);
        // Navigation
        // msNavigationServiceProvider.saveItem('pages.auth.forgot-password', {
        //     title : 'Forgot Password',
        //     state : 'app.pages_auth_forgot-password',
        //     weight: 5
        // });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.auth.forgot-password')
        .controller('ForgotPasswordController', ForgotPasswordController);

    /** @ngInject */
    function ForgotPasswordController($location, $state, msApi, $cookies)
    {
        var vm = this;
        // Data

        // Methods
        vm.formSubmit = formSubmit;
        //////////

        function formSubmit() {
            var mobile = vm.form.mobile;
            msApi.request("app.pages.auth.user@get", {'act':'forgotpassword', 'mobile': mobile}).then(
                // Success
                function (response)
                {
                    vm.notice_message = response.data.notice_message;
                    //console.log(response.data);
                    // if (response.data.status == false) {// login failed
                    // }else {// login success
                    // }
                }
            );
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.users')
        .controller('UsersController', UsersController);

    /** @ngInject */
    function UsersController($rootScope, $timeout, $http, Roles, $mdDialog, $document, msApi, $cookies)
    {
        var vm = this;
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        vm.is_cud = false;//是否可以增删改
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_teacher' || v == 'admin_teacher_cud'){
                vm.is_cud = true;
            }
        });
        vm.roles = Roles.data;
        vm.role_id = vm.roles[0]['id'];
        vm.doSearch = doSearch;
        var store_id = $cookies.get('store_id');
        //console.log(vm.roles);
        /*vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };*/

        // pager
        vm.query = {
            name:'',
            status:10,
            store_id: store_id,
            role_id: vm.role_id,
            sort: '-id',
            limit: 20,
            page: 1
        };
        function doSearch(){
            msApi.resolve('store.users.list@get', vm.query).then(function(users){vm.users = users});
        }
        var apiName = "store.users.list@get";

        init();
        /**
         * Initialize
         */
        function init()
        {
            vm.loadingThreads = true;
            // Figure out the api name
            msApi.request(apiName, {'store_id':$cookies.get('store_id'),'role_id':vm.role_id}).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.users = response;
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }

        vm.resetpwdDialog = resetpwdDialog;
        vm.openUserDialog = openUserDialog;
        vm.setstoreDialog = setstoreDialog;
        vm.setroleDialog = setroleDialog;
        function setstoreDialog(ev, user){
            $mdDialog.show({
                controller         : 'SetStoreDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/users/dialogs/setstore/setstore-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    User : user,
                    Users: vm.users,
                    event: ev,
                    role_id: vm.role_id
                }
            });
        }
        function setroleDialog(ev, user){
            console.log(user);
            $mdDialog.show({
                controller         : 'SetRoleDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/users/dialogs/setrole/setrole-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    User : user,
                    Users: vm.users,
                    event: ev,
                    role_id: vm.role_id
                }
            });
        }
        function openUserDialog(ev, user)
        {
            $mdDialog.show({
                controller         : 'UserDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/users/dialogs/user/user-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    User : user,
                    Users: vm.users,
                    event: ev,
                    role_id: vm.role_id
                }
            });
        }

        // 重置密码
        function resetpwdDialog(ev, user)
        {
            $mdDialog.show({
                controller         : 'ResetpwdDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/users/dialogs/resetpwd/resetpwd-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    User : user,
                    Users: vm.users,
                    event: ev,
                    role_id: vm.role_id
                }
            });
        }
        
        vm.toggleSidenav = toggleSidenav;
        vm.isActive = isActive;
        function toggleSidenav(role_id)
        {
            vm.role_id = role_id;
            vm.query.role_id = role_id;
            vm.loadingThreads = true;
            msApi.request(apiName, {'store_id':$cookies.get('store_id'),'role_id':role_id, 'status': 10}).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.users = response;
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
        function isActive(role_id) {
            return vm.role_id == role_id;
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.teachers')
        .controller('TeachersController', TeachersController)
        .controller('TeacherDetailController', TeacherDetailController)
        .controller('TeachersReportController', TeachersReportController);

    /** @ngInject */
    function TeachersController($rootScope, $timeout, $http, $mdDialog, $document, $cookies, msApi)
    {
        var vm = this;
        var store_id = $cookies.get('store_id');
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        vm.is_cud = false;//是否可以增删改
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_teacher' || v == 'admin_teacher_cud'){
                vm.is_cud = true;
            }
        });
        init();
        //vm.teachers = Teachers;
        //vm.stores = Stores.data;
        vm.openTeacherDialog = openTeacherDialog;
        vm.resetpwd = resetpwd;
        vm.doSearch = doSearch;
        vm.query = {
            name:'',
            status:10,
            store_id: store_id,
            role_id: 3,
            sort: '-id',
            limit: 20,
            page: 1
        };
        function doSearch(){
            msApi.resolve('store.teachers.list@get', vm.query).then(function(teachers){vm.teachers = teachers});
        }
        function resetpwd(ev, teacher){
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'TeacherResetpwdController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/teachers/dialogs/teacher/teacher-resetpwd.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Teacher : teacher,
                    Teachers: vm.teachers
                    //Stores: vm.stores
                }
            });
        }

        function openTeacherDialog(ev, teacher)
        {
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'TeacherDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/teachers/dialogs/teacher/teacher-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Teacher : teacher,
                    Teachers: vm.teachers
                    //Stores: vm.stores
                }
            });
        }
        function init()
        {
            vm.loadingThreads = true;
            // Figure out the api name
            msApi.request('store.teachers.list@get', {'store_id':store_id, 'role_id': 3}).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.teachers = response;

                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
    }

    function TeacherDetailController($rootScope, $timeout, $http, $stateParams, $mdDialog, $document, msApi){
        var vm = this;
        //  老师
        msApi.request('store.teachers.list@get', {'id': $stateParams.id}).then(
            function (response){
                if(response.data.length > 0) {
                    vm.teacher = response.data[0];
                }
            });
        vm.doSearch1 = doSearch1;
        vm.query1 = {
            teacher_id:$stateParams.id,
            act:'item1',
            expand: 'signups,customer',
            sort: 'course_time',
            limit:20,
            page: 1
        };
        function doSearch1() {
            // 报名中课程信息{'teacher_id': $stateParams.id, 'act': 'item1', 'expand': 'signups,customer'}
            msApi.request('store.courses.list@get', vm.query1).then(
                function (response) {
                    vm.courses1 = response;
                });
        }
        doSearch1();
        // 进行中课程信息 {'teacher_id': $stateParams.id, 'act': 'item2', 'expand': 'signups,customer'}
        vm.doSearch2 = doSearch2;
        vm.query2 = {
            teacher_id:$stateParams.id,
            act:'item2',
            expand: 'signups,customer',
            sort: 'course_time',
            limit: 20,
            page: 1
        };
        function doSearch2() {
            msApi.request('store.courses.list@get', vm.query2).then(
                function (response) {
                    vm.courses2 = response;
                });
            // 已结束课程信息{'teacher_id': $stateParams.id, 'act': 'item3', 'expand': 'signups,customer'}
        }
        doSearch2();
        vm.doSearch3 = doSearch3;
        vm.query3 = {
            teacher_id:$stateParams.id,
            act:'item3',
            expand: 'signups,customer',
            sort: 'course_time',
            limit: 20,
            page: 1
        };
        function doSearch3() {
            msApi.request('store.courses.list@get', vm.query3).then(
                function (response) {
                    vm.courses3 = response;
                    console.log(vm.courses3);
                });
            // // 报名信息
            // msApi.request('store.signups.list@get', {'courses_id': $stateParams.id}).then(
            //     function (response){
            //         if(response.data.length > 0){
            //             vm.customer = response.data[0];
            //         }
            //     });

        }
        doSearch3();
    }
    function TeachersReportController($filter, $rootScope , msApi, $cookies)
    {
        var store_id = $cookies.get('store_id');
        var vm = this;
        vm.is_export = false;//是否可以增删改
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_report_teacher_export' || v == 'admin_courses'){
                vm.is_export = true;
            }
        });
        vm.is_del = false;
        // pager
        vm.query = {
            sdate:'',
            edate:'',
            store_id: store_id,
            status:10
        };
        init();
        vm.doSearch = doSearch;

        function doSearch(){
            vm.query.is_del = vm.is_del;
            $rootScope.loadingProgress = true;
            msApi.resolve('store.reports.teachers@get', vm.query).then(
                function(teachers){
                    vm.teachers = teachers;
                    $rootScope.loadingProgress = false;
                }
            );
        }
        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00') return new Date(str);
        }
        //导出
        vm.exportSignups = exportSignups;
        function exportSignups(ev){
            /*var sdate = (vm.query.sdate).toISOString().slice(0,10);
            var edate = (vm.query.edate).toISOString().slice(0,10);*/
            var sdate = vm.query.sdate == '' ? '' : $filter("date")(new Date(vm.query.sdate), "yyyy-MM-dd");
            var edate = vm.query.edate == '' ? '' : $filter("date")(new Date(vm.query.edate), "yyyy-MM-dd");
            window.open(msApi.getApiUrl('teachers/reports')+'&sdate='+sdate+'&edate='+edate+'&store_id='+store_id+'&act=export');
        }


        function init() {
            vm.loadingThreads = true;
            vm.query.sdate = moment(new Date()).utc().format('YYYY-MM-01');
            vm.query.edate = moment(new Date()).utc().format('YYYY-MM-DD');
            // Figure out the api name
            msApi.request('store.reports.teachers@get', vm.query).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.teachers = response;
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.teachers')
        .controller('TeacherCoursesController', TeacherCoursesController);

    /** @ngInject */
    function TeacherCoursesController($filter,$rootScope, $timeout, $http, $mdDialog, $document, $cookies, msApi, $mdSidenav)
    {
        var store_id = $cookies.get('store_id');
        var vm = this;
        vm.is_export = false;//
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_report_teacher_export' || v == 'admin_courses'){
                vm.is_export = true;
            }
        });
        vm.is_del = true;
        vm.query1 = {
            'store_id':store_id, 'role_id': 3
        }
        msApi.request("store.courses.users@get", vm.query1).then(//老师
            function (response){
                vm.teachers = response.data;
                //console.log(response.data);
            });

        //vm.courses = Courses;
        vm.selectedFiles = '';

        // pager
        vm.query = {
            act:'tec',
            is_del:vm.is_del,
            teacher_ids: '',
            sdate:'',
            edate:'',
            store_id: store_id,
            sort: '-course_time',
            limit: 20,
            page: 1
        };
        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00') return new Date(str);
        }
        init();
        vm.doSearch = doSearch;

        function doSearch(){
            vm.query.teacher_ids = '';
            angular.forEach(vm.selectedThreads, function (v, k) {
                if(vm.query.teacher_ids){
                    vm.query.teacher_ids = vm.query.teacher_ids+','+v.id;
                }else {
                    vm.query.teacher_ids = v.id;
                }
            });
            vm.query.is_del = vm.is_del;
            $rootScope.loadingProgress = true;
            msApi.resolve('store.courses.list@get', vm.query).then(function(courses){vm.courses = courses;$rootScope.loadingProgress = false;});
        }
        function init(){
            vm.loadingThreads = true;
            var now_date = moment(new Date()).utc().format('YYYY-MM-DD');
            vm.query.sdate = now_date;
            vm.query.edate = now_date;
            // Figure out the api name
            msApi.request('store.courses.list@get', vm.query).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.courses = response;
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
        vm.exportSignups = function exportSignups(ev){
            /*var sdate = (vm.query.sdate).toISOString().slice(0,10);
            var edate = (vm.query.edate).toISOString().slice(0,10);*/
            var sdate = vm.query.sdate == '' ? '' : $filter("date")(new Date(vm.query.sdate), "yyyy-MM-dd");
            var edate = vm.query.edate == '' ? '' : $filter("date")(new Date(vm.query.edate), "yyyy-MM-dd");
            window.open(msApi.getApiUrl('teachers/report-courses')+'&sdate='+sdate+'&edate='+edate+'&store_id='+store_id+'&teacher_id='+vm.query.teacher_id+'&is_del='+vm.is_del);
        }
        vm.toggleSidenav = toggleSidenav;
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
        vm.selectedThreads = [];
        vm.toggleSelectThreads = toggleSelectThreads;
        function toggleSelectThreads()
        {

            if ( vm.selectedThreads.length > 0)
            {
                vm.deselectThreads();
            }
            else
            {
                vm.selectThreads();
            }
        }

        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        function toggleSelectThread(thread, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            if ( vm.selectedThreads.indexOf(thread) > -1 )
            {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            }
            else
            {
                vm.selectedThreads.push(thread);
            }
            doSearch();
        }
        function isSelected(thread)
        {
            //if (! vm.selectedThreads) {return;}      // If
            return vm.selectedThreads.indexOf(thread) > -1;
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.system')
        .controller('WechatTempController', WechatTempController);

    /** @ngInject */
    function WechatTempController($rootScope, $timeout, $http,$mdDialog, $document, msApi, $state, $cookies) {
        var vm = this;
        vm.temps = [
            {
                yongtu: '批课操作<br />系统自动给该家长发送', number: 'course_sign', name: '课程预约结果通知',
                content: '课程预约结果通知。教师：Linda<br> 课程：奶鲨鱼班<br /> 时间：2018-10-20 10:00<br> 地点：白云<br />结果：通过<br />请准时参加',
                status: '1', id: '7LwEQMNp4oLximoVYvgbPuRA61NefsvLt2mnM_BHvh8'
            },
            {
                yongtu: '请假审批操作<br />系统自动给该家长发送', number: 'apply_qj', name: '请假审批通知',
                content: '请假已通过<br>申请人：张三<br>开始时间：2018-10-01<br>结束时间：208-10-15<br>感谢你的使用',
                status: '1', id: 'EgPXrzpzar6ue5-usKWMgwLcZYL3xNYyjv90DV-i_T4'
            },
            {
                yongtu: '体验安排课程<br />系统自动给该家长发送', number: 'task', name: '课程通知',
                content: '体验课程已安排<br>课程：奶鲨鱼班<br> 地点：白云<br> 讲师：Linda<br> 时间：2018-10-20 10:00<br>请准时参加',
                status: '1', id: 'jgMGzCG7WG4oEB5E7q9L-H_Tx3XtkMjog8Tr1R7p8og'
            },
            {
                yongtu: '预约状态变更<br>系统自动给该家长发送', number: 'task', name: '课程通知',
                content: '预约状态由备选变更为预约<br>课程：奶鲨鱼班<br> 地点：白云<br> 讲师：Linda<br> 时间：2018-10-20 10:00<br>请知晓',
                status: '1', id: 'jgMGzCG7WG4oEB5E7q9L-H_Tx3XtkMjog8Tr1R7p8og'
            },
            {
                yongtu: '预约状态变更<br>系统自动给该家长发送', number: 'task', name: '课程通知',
                content: '预约状态由候补变更为已取消<br>课程：奶鲨鱼班<br> 地点：白云<br> 讲师：Linda<br> 时间：2018-10-20 10:00<br>请知晓',
                status: '1', id: 'jgMGzCG7WG4oEB5E7q9L-H_Tx3XtkMjog8Tr1R7p8og'
            },
            {
                yongtu: '预约操作<br>系统自动给该家长发送', number: 'signup', name: '预约成功提醒',
                content: '课程预约成功提醒!<br>会员姓名：张三<br>预约课程：奶鲨鱼班<br>课程时间：2018-10-20 10:00<br>该课人数：<br>请知晓',
                status: '1', id: 'Fzuopq9hDOY_oizuIeXDiYLPAzcxuU9ce7NRKytHfXQ'
            },
            {
                yongtu: '取消预约操作<br>系统自动给该家长发送', number: 'cancel_signup', name: '预约取消成功通知',
                content: '您的上课预约已取消成功<br>会员名：李童<br>上课时间：2018-10-20 10:00<br>课程：奶鲨鱼班<br>请知晓。',
                status: '1', id: 't2X5W3mHsOX0aDkQKvmnbwjkjfJFvYvflFC0G8rfQSM'
            },
            {
                yongtu: '申请体验操作<br>系统自动给该家长发送', number: 'task_apply', name: '申请通知',
                content: '体验课程申请通知<br>申请名称：体验课程<br>申请人：小刘<br>申请类型：体验课<br>申请时间：2018-10-20 10:00<br>请耐心等待课程安排',
                status: '1', id: 'm44ornYTQNp-LhO3bvcXnIpg0tP6c3V0fleR9n38fw0'
            },
            {
                yongtu: '合同到期提醒<br>系统自动给该家长发送', number: 'contract_expire', name: '合同到期提醒',
                content: '尊敬的李童用户：<br>合同编号：P0001<br>合同开始日期：2018-10-01<br>合同结束日期：2019-09-30<br>团体课2节，私教课2节',
                status: '1', id: 'uaO8lKQcBhBQD9aPImIGBhURJIX7UvVTPGZzl0dDVaQ'
            },
            {
                yongtu: '指定时间内未上课提醒<br>系统自动给该家长发送', number: 'not_course', name: '合同到期提醒',
                content: '尊敬的李童用户,漾子喊你回娘家啦,期待您的到来哟：<br>门店名称：夏门旗舰店<br>联系电话：0592-6738000<br>时间：2018-10-30',
                status: '1', id: 'K51CEBNwAoAtrWUb9WNbnYUx13iGDS4Uqy9lz_n4J2Y'
            },
        ];
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.system')
        .controller('WechatsendlogsController', WechatsendlogsController);

    /** @ngInject */
    function WechatsendlogsController($rootScope, $timeout, $http, Wechatsendlogs,$mdDialog, $document, msApi, $state, $cookies)
    {
        var vm = this;
        vm.wechatsendlogs = Wechatsendlogs;
        vm.doSearch = doSearch;

        // pager
        vm.query = {
            parent_name:'',
            sort: '-id',
            limit: 20,
            store_id:$cookies.get('store_id'),
            page: 1
        };
        function doSearch(){
            msApi.resolve('store.system.wechatsendlogs@get', vm.query).then(function(wechatsendlogs){vm.wechatsendlogs = wechatsendlogs});
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.store.system')
        .controller('SmstemplatesController', SmstemplatesController);

    /** @ngInject */
    function SmstemplatesController($rootScope, $timeout, $http, Smstemplates, $mdDialog, $document, msApi, $state, $cookies)
    {
        var vm = this;
        vm.smstemplates = Smstemplates;
        vm.doSearch = doSearch;
        var store_id = $cookies.get('store_id');

        // pager
        vm.query = {
            title:'',
            sort: '-id',
            limit: 20,
            page: 1
        };
        function doSearch(){
            msApi.resolve('store.system.smssendlogs@get', vm.query).then(function(smstemplates){vm.smstemplates = smstemplates});
        }
        msApi.request('store.system.users@get', {'act': 'smsbalance'}).then(
            function (response) {
                vm.total = response.data;
            });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.store.system')
        .controller('SmssendlogsController', SmssendlogsController);

    /** @ngInject */
    function SmssendlogsController($rootScope, $timeout, $http,$mdDialog, $document, msApi, $state, $cookies)
    {
        var store_id = $cookies.get('store_id');
        var vm = this;
        //vm.smssendlogs = Smssendlogs;
        vm.doSearch = doSearch;
        init();
        // pager
        vm.query = {
            reciver_username:'',
            sort: '-id',
            limit: 20,
            page: 1
        };
        function doSearch(){
            msApi.resolve('store.system.smssendlogs@get', vm.query).then(function(smssendlogs){vm.smssendlogs = smssendlogs});
        }
        function init()
        {
            vm.loadingThreads = true;
            // Figure out the api name
            msApi.request('store.system.smssendlogs@get', {'store_id':store_id}).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.smssendlogs = response;

                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.store.system')
        .controller('SetStoreController', SetStoreController);

    /** @ngInject */
    function SetStoreController($rootScope, $timeout, $http, Store, $mdDialog, $document, msApi, $state, $cookies)
    {
        var vm = this;
        vm.store = Store;
        //console.log(vm.store.settings.address_list);
        var store_id = $cookies.get('store_id');
        vm.saveStoreSettings = saveStoreSettings;

        // 保存 门店配置
        function saveStoreSettings() {
            var address_list = vm.store.settings.address_list;
            msApi.resolve('store.system.stores@get', {'act':'save_settings','id':store_id, 'address_list':address_list}).then(function(response){
                if (response.data.status == 1){
                    $rootScope.message_success = '操作成功!';
                    $timeout(function(){$rootScope.message_success = '';},5000);
                }else {
                    $rootScope.message_danger = response.data.msg;
                    $timeout(function(){$rootScope.message_danger = '';},5000);
                }
            });
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.store.system')
        .controller('RoomController', RoomController);

    /** @ngInject */
    function RoomController($rootScope, $timeout, $q, msApi, $mdDialog, $document, $http, $cookies)
    {
        var store_id = $cookies.get('store_id');
        var vm = this;
        vm.query = {
            title:'',
            desc:'',
            sort: 'title',
            limit: 20,
            page: 1,
            _meta:{}
        };
        init();
        vm.doSearch = doSearch;
        function doSearch(){
            msApi.resolve('store.system.rooms@get', vm.query).then(function(response){
                vm.rooms = response.data;
                vm._meta = response._meta;
            });
        }
        function init(){
            vm.loadingThreads = true;
            // Figure out the api name
            msApi.request('store.system.rooms@get', vm.query).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.rooms = response.data;
                    vm._meta = response._meta;
                    console.log(vm._meta);
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
        vm.openRoomDialog = openRoomDialog ;
        function openRoomDialog(ev, room)
        {
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'RoomDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/system/dialogs/room/room-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Room : room,
                    Rooms: vm.rooms,
                    event: ev
                }
            });
        }

        vm.deleteRoom = deleteRoom;
        function deleteRoom(ev, room) {
            ev.stopPropagation();
            var confirm = $mdDialog.confirm()
                .title('删除确认操作?')
                .content('确认要删除此计划吗.')
                .ariaLabel('删除计划')
                .ok('删除')
                .cancel('取消');
            //.targetEvent(event);
            $mdDialog.show(confirm).then(function ()
            {
                var data = angular.copy(room);
                data.status = 0;
                $http({
                    method: 'PUT',
                    url: msApi.getApiUrl('rooms/' + data.id),
                    data: data
                }).success(function (req) {
                    vm.rooms.splice(vm.rooms.indexOf(room), 1);
                    $rootScope.message_success = '操作成功!';
                    $timeout(function () {
                        $rootScope.message_success = '';
                    }, 5000);
                }).error(function (data, state) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function () {
                        $rootScope.message_danger = '';
                    }, 5000);
                });
            }, function ()
            {
                // Cancel Action
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store.system')
        .controller('OndutyController', OndutyController);

    /** @ngInject */
    function OndutyController($mdDialog, $document, $cookies, $rootScope, msApi)
    {
        var vm = this;
        vm.res = [];
        vm.events = [vm.res];

        // Data
        var date = new Date();
        var d = date.getDate();
        var m = date.getMonth();
        var y = date.getFullYear();
        var apiName = "store.calendar.courses@get";
        var store_id = $cookies.get('store_id');
        vm.query = {
            store_id:store_id,
            "per-page": 1000,
            //limit:10000,
            page: 1
        }

        var apiName = "store.system.ondutys@get";

        vm.calendarUiConfig = {
            calendar: {
                editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                monthNames : ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], //月份自定义命名
                monthNamesShort: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], //月份缩略命名（英语比较实用：全称January可设置缩略为Jan）
                dayNames          : ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
                dayNamesShort     : ['日', '一', '二', '三', '四', '五', '六'],
                viewRender        : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');

                    vm.query.start_time = view.start.format("YYYY-MM-DD");
                    vm.query.end_time = view.end.format("YYYY-MM-DD");
                    loadEvents();//加载活动时间
                },
                eventRender: function(event, element, view) {
                    if (view.type=='month') {
                        element.find('.fc-title').append("店内人员：" + event.description)+'人';
                    }else{
                        var appendText = "<br/>店内人员：" + event.description+'人';
                        element.find('.fc-title').append(appendText);
                    }

                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M'
                },
                eventClick        : eventDetail,
                selectable        : true,
                selectHelper      : true,
                select            : select,
                firstDay:1,
                allDaySlot:false,
                weekNumbers:true,
                disableResizing: true,
                eventDurationEditable: false,
                eventStartEditable: false,
            }
        };
        /**
         * 加载固定日期的
         * @param start
         * @param end
         */
        function loadEvents(){
            $rootScope.loadingProgress = true;
            msApi.resolve(apiName, vm.query).then(function(result){
                $rootScope.loadingProgress = false;
                vm.res = result.data;
                angular.forEach(vm.res, function(v,k){
                    handleEvent(v);
                });
            });
        }
        function handleEvent(event){
            var isIn = false;
            for(var i=0;i<vm.events[0].length;i++){
                if (vm.events[0][i].id==event.id){
                    isIn = true;
                    break;
                }
            }
            if (!isIn){
                //支持safair时间
               // console.log(event);return false;
                var start = event.date.replace(/-/g, "/");
                start = new Date(event.date);
                event.description = event.data.total;
                event.stick = true;



                //console.log(start.setTimeZone(TimeZone.getTimeZone("Asia/Shanghai")));
                //color处理
                var now = new Date();
                if (start < now){//过期了显示灰色
                    event.color = "#ccc";
                }else{
                }

                vm.events[0].push(event);
            }
        }
        // Methods
        vm.addEvent = addEvent;
        vm.next = next;
        vm.prev = prev;

        //////////

        /**
         * Go to next on current view (week, month etc.)
         */
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();
        }

        /**
         * Show event detail
         *
         * @param calendarEvent
         * @param e
         */
        function eventDetail(calendarEvent, e)
        {
            showEventDetailDialog(calendarEvent, e);
        }

        /**
         * Add new event in between selected dates
         *
         * @param start
         * @param end
         * @param e
         */
        function select(start, end, e)
        {
            var date = start.format("YYYY-MM-DD");
            msApi.resolve(apiName, {date:date, store_id:store_id,}).then(function(result){
                $rootScope.loadingProgress = false;
                if(result.data.length > 0){
                    showEventDetailDialog(result.data[0]);
                }else {
                    showEventFormDialog('add', false, start, end, e);
                }
            });
        }

        /**
         * Add event
         *
         * @param e
         */
        function addEvent(e)
        {
            var start = new Date(),
                end = new Date();
            showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Show event detail dialog
         * @param calendarEvent
         * @param e
         */
        function showEventDetailDialog(calendarEvent, e)
        {
            $mdDialog.show({
                controller         : 'EventDetailDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/system/dialogs/event-detail/event-detail-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    calendarEvent      : calendarEvent,
                    showEventFormDialog: showEventFormDialog,
                    event              : e
                }
            });
        }

        /**
         * Show event add/edit form dialog
         *
         * @param type
         * @param calendarEvent
         * @param start
         * @param end
         * @param e
         */
        function showEventFormDialog(type, calendarEvent, start, end, e)
        {
            var dialogData = {
                type         : type,
                calendarEvent: calendarEvent,
                start        : start,
                end          : end
            };
            $mdDialog.show({
                controller         : 'EventFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/system/dialogs/event-form/event-form-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    dialogData: dialogData
                }
            }).then(function (response)
            {
                switch ( response.type )
                {
                    case 'add':
                        // Add new
                        vm.events[0].push({
                            id   : vm.events[0].length + 20,
                            title: response.calendarEvent.title,
                            start: response.calendarEvent.start,
                            end  : response.calendarEvent.end
                        });
                        break;

                    case 'edit':
                        // Edit
                        for ( var i = 0; i < vm.events[0].length; i++ )
                        {
                            // Update
                            if ( vm.events[0][i].id === response.calendarEvent.id )
                            {
                                vm.events[0][i] = {
                                    title: response.calendarEvent.title,
                                    start: response.calendarEvent.start,
                                    end  : response.calendarEvent.end
                                };

                                break;
                            }
                        }
                        break;

                    case 'remove':
                        // Remove
                        for ( var j = 0; j < vm.events[0].length; j++ )
                        {
                            // Update
                            if ( vm.events[0][j].id === response.calendarEvent.id )
                            {
                                vm.events[0].splice(j, 1);

                                break;
                            }
                        }
                        break;
                }
            });
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.store.system')
        .controller('CtimeController', CtimeController);

    /** @ngInject */
    function CtimeController($rootScope, $timeout, $q, msApi, $mdDialog, $document, $http, $cookies, Store)
    {
        var vm = this;
        var store_id = $cookies.get('store_id');
        vm.ctime_list = Store.settings.ctime_list?Store.settings.ctime_list:[];
        vm.ctime_list = vm.ctime_list.sort();
        // vm.ctime_list = ["00:00~02:00",'01:00~02:00'];
        var vm = this;
        vm.saveStoreCourseTimes = saveStoreCourseTimes;
        // 保存 门店配置
        function saveStoreCourseTimes() {
            function unique(arr) {
                return arr.filter(function(item, index, arr) {
                  //当前元素，在原始数组中的第一个索引==当前索引值，否则返回当前元素
                  return arr.indexOf(item, 0) === index;
                });
            }
            vm.ctime_list.sort();
            vm.ctime_list = unique(vm.ctime_list);
            Store.settings.ctime_list = vm.ctime_list;
            var ctime_list = JSON.stringify(vm.ctime_list);
            msApi.resolve('store.system.stores@get', {'act':'save_settings','id':store_id, 'ctime_list':ctime_list}).then(function(response){
                if (response.data.status == 1){
                    $rootScope.message_success = '操作成功!';
                    $timeout(function(){$rootScope.message_success = '';},5000);
                }else {
                    $rootScope.message_danger = response.data.msg;
                    $timeout(function(){$rootScope.message_danger = '';},5000);
                }
            });
        }

        vm.openCtimeDialog = openCtimeDialog ;
        function openCtimeDialog(ev, ctime)
        {
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'CtimeDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/system/dialogs/ctime/ctime-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    ctime : ctime,
                    Ctimes: vm.ctime_list,
                    event: ev
                }
            });
        }

        vm.deleteCtime = deleteCtime;
        function deleteCtime(ev, ctime) {
            ev.stopPropagation();
            var confirm = $mdDialog.confirm()
                .title('删除确认操作?')
                .content('确认要删除此计划吗.')
                .ariaLabel('删除计划')
                .ok('删除')
                .cancel('取消');
            //.targetEvent(event);
            $mdDialog.show(confirm).then(function ()
            {
                console.log(ctime);
                var index = vm.ctime_list.indexOf(ctime);
                vm.ctime_list.splice(index,1);
                saveStoreCourseTimes()
            }, function ()
            {
                // Cancel Action
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store.system')
        .controller('ConfigController', ConfigController);

    /** @ngInject */
    function ConfigController($rootScope, $timeout, $http, $mdDialog, $document, msApi, $state, $cookies)
    {
        var vm = this;
        var store_id = $cookies.get('store_id');
        vm.curr_user = $cookies.getObject('curr_user');
        vm.current_user_name = vm.curr_user.username;
        vm.configs = {};
        init();
        function init(){
            vm.loadingThreads = true;

            // Figure out the api name
            msApi.request('store.system.configsys@get', {'act': 'get', 'store_id': store_id}).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.configs = response.data;
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
        // vm.role_id = $cookies.get('role_id');

        vm.saveConfigSettings = saveConfigSettings;
        // 保存 门店配置
        function saveConfigSettings() {
            vm.configs.store_id = store_id;
            vm.configs.act = 'save_settings';
            msApi.resolve('store.system.configsys@get', vm.configs).then(function(response){
                if (response.data.status == 1){
                    $rootScope.message_success = '操作成功!';
                    $timeout(function(){$rootScope.message_success = '';},5000);
                }else {
                    $rootScope.message_danger = response.data.msg;
                    $timeout(function(){$rootScope.message_danger = '';},5000);
                }
            });
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.store.system')
        .controller('CategoriesController', CategoriesController);

    /** @ngInject */
    function CategoriesController($rootScope, $timeout, $http, CategoryTypes, $mdDialog, $document, msApi, $state, $cookies)
    {
        var vm = this;
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        vm.is_cud = false;//是否可以增删改
        vm.is_kd = false;//是否可以设置跨店
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_system_categories_cud' || v == 'admin_system_categories' || v == 'admin_system'){
                vm.is_cud = true;
            }
        });
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_system_categories_kudian' || v == 'admin_system' || v == 'admin_system_categories'){
                vm.is_kd = true;
            }
        });
        //vm.categories = Categories;
        vm.doSearch = doSearch;
        var store_id = $cookies.get('store_id');
        init();
        /*vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };*/
        vm.role_id = $cookies.get('role_id');
        // pager
        vm.query = {
            name:'',
            store_id: store_id,
            type: $state.params.type || 1,
            //sort: '-id',
            limit: 20,
            page: 1
        };
        function doSearch(){
            msApi.resolve('store.system.categories@get', vm.query).then(function(categories){vm.categories = categories});
        }
        function init()
        {
            vm.loadingThreads = true;
            // Figure out the api name
            msApi.request('store.system.categories@get', {'store_id':store_id, 'type':1}).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.categories = response;

                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
        var apiName = "store.users.list@get";
        var apiName = 'store.system.categories@get';
        // Data
        vm.categoryTypes = CategoryTypes.data;
        $state.params.type = vm.categoryTypes[0]['id'];
        vm.type = $state.params.type;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.isActive = isActive;
        //////////

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        var store_id = $cookies.get('store_id');
        function toggleSidenav(type)
        {
            $state.params.type = type;
            vm.type = $state.params.type;
            vm.query.type = type;
            //$mdSidenav(sidenavId).toggle();
            vm.loadingThreads = true;
            msApi.request(apiName, {'store_id': store_id, 'type':type}).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.categories = response;
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
        function isActive(type) {
            return $state.params.type == type;
        }

        vm.openCategorieDialog = openCategorieDialog;
        function openCategorieDialog(ev, categorie)
        {
            $mdDialog.show({
                controller         : 'CategoryDialogsController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/system/dialogs/category/category-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Categorie : categorie,
                    Categories: vm.categories,
                    type:  $state.params.type,
                    event: ev
                }
            });
        }
        vm.openKuadianialog = openKuadianialog;
        function openKuadianialog(ev, categorie)
        {
            $mdDialog.show({
                controller         : 'KuadianDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/system/dialogs/kuadian/kuadian-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Categorie : categorie,
                    Categories: vm.categories,
                    type:  $state.params.type,
                    is_kd:vm.is_kd,
                    event: ev
                }
            });
        }
        vm.checkEdit = checkEdit;
        function checkEdit(storeId){
            var is_flag = true;
            if(storeId == 0 && vm.role_id != 1){
                is_flag = false;
            }
            return is_flag;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.store.reports')
        .controller('ZhongReportController', ZhongReportController);

    /** @ngInject */
    function ZhongReportController($filter, $rootScope , msApi, $cookies) {
        var store_id = $cookies.get('store_id');
        var vm = this;
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        vm.is_export = false;//是否可以增删改
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_report_amount_export' || v == 'admin_report'){
                vm.is_export = true;
            }
        });
        vm.types = [{'id':'','text':'统计类型'},
            {'id' : 'd', 'text' : '按日'},
            {'id' : 'w', 'text' : '按周'},
            {'id' : 'm', 'text' : '按月'}];
        // pager
        vm.query = {
            act:'where',
            type:'',
            sdate:'',
            edate:'',
            store_id: store_id,
            limit: 20,
            page: 1
        };
        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00') return new Date(str);
        }

        init();
        vm.doSearch = doSearch;

        function doSearch(){
            $rootScope.loadingProgress = true;
            vm.lineChart.data = {labels: [],
                series: []}
            vm.barChart.data ={abels: [],
                series: []
            }
            vm.barChart1.data ={labels: [],
                series: []}
            vm.pieChart.data ={}
            msApi.request('store.reports.amounts@get', vm.query).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.res = response;
                    if(vm.res.pays){
                        angular.forEach(vm.res.pays, function (v, k) {
                            vm.pieChart.data.push({key:v.pay_type,y:v.amount});
                        });
                    }

                    vm.lineChart.data = {labels:vm.res.all.labels,
                        series: [vm.res.all.values]};
                    vm.barChart.data = {labels:vm.res.card_type.labels,
                        series: [vm.res.card_type.values]};
                    vm.barChart1.data = {labels:vm.res.contract_type.labels,
                        series: [vm.res.contract_type.values]};
                    $rootScope.loadingProgress = false;
                }
            );
        }
        vm.doDaySearch = doDaySearch;
        function doDaySearch(act) {
            vm.lineChart.data = {labels: [],
                series: []}
            vm.barChart.data ={abels: [],
                series: []
            }
            vm.barChart1.data ={labels: [],
                series: []}
            vm.pieChart.data ={}
            $('.search-input-wrapper label').removeClass('active')
            $('#tag-'+act).addClass('active');
            msApi.request('store.reports.amounts@get',  {act:act, store_id:store_id}).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.res = response;
                    console.log(vm.res);
                    if(vm.res.pays){
                        angular.forEach(vm.res.pays, function (v, k) {
                            vm.pieChart.data.push({key:v.pay_type,y:v.amount});
                        });
                    }

                    vm.lineChart.data = {labels:vm.res.all.labels,
                        series: [vm.res.all.values]};
                    vm.barChart.data = {labels:vm.res.card_type.labels,
                        series: [vm.res.card_type.values]};
                    vm.barChart1.data = {labels:vm.res.contract_type.labels,
                        series: [vm.res.contract_type.values]};
                    $rootScope.loadingProgress = false;
                }
            );
        }
        //导出
        vm.exportAmounts = exportAmounts;
        function exportAmounts(ev){
            /*var sdate = vm.query.sdate == '' ? '' : (vm.query.sdate).toISOString().slice(0,10);
            var edate = vm.query.edate == '' ? '' : (vm.query.edate).toISOString().slice(0,10);*/
            var sdate = vm.query.sdate == '' ? '' : $filter("date")(new Date(vm.query.sdate), "yyyy-MM-dd");
            var edate = vm.query.edate == '' ? '' : $filter("date")(new Date(vm.query.edate), "yyyy-MM-dd");
            window.open(msApi.getApiUrl('amountarchives/export')+'&sdate='+sdate+'&edate='+edate+'&type='+vm.query.type+'&store_id='+store_id);
        }

        vm.pieChart = {
            options: {
                chart: {
                    type              : 'pieChart',
                    height            : 320,
                    x                 : function (d)
                    {
                        return d.key;
                    },
                    y                 : function (d)
                    {
                        return d.y;
                    },
                    showLabels        : true,
                    transitionDuration: 500,
                    labelThreshold    : 0.01,
                    legend            : {
                        margin: {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        }
                    }
                }
            },
            data   : []
        };
        vm.lineChart = {
            data   : {
                labels: [],
                series: []
            },
            options: {
                fullWidth   : true,
                chartPadding: {

                },
                chart: {
                    height: 320,
                }
            }
        };
        vm.barChart = {
            data             : {
                labels: [],
                series: []
            },
            options          : {
                seriesBarDistance: 15
            },
            responsiveOptions: [
                ['screen and (min-width: 641px) and (max-width: 1024px)', {
                    seriesBarDistance: 10,
                    axisX            : {
                        labelInterpolationFnc: function (value)
                        {
                            return value;
                        }
                    }
                }],
                ['screen and (max-width: 640px)', {
                    seriesBarDistance: 5,
                    axisX            : {
                        labelInterpolationFnc: function (value)
                        {
                            return value[0];
                        }
                    }
                }]
            ]
        };
        vm.barChart1 = {
            data             : {
                labels: [],
                series: []
            },
            options          : {
                seriesBarDistance: 15
            },
            responsiveOptions: [
                ['screen and (min-width: 641px) and (max-width: 1024px)', {
                    seriesBarDistance: 10,
                    axisX            : {
                        labelInterpolationFnc: function (value)
                        {
                            return value;
                        }
                    }
                }],
                ['screen and (max-width: 640px)', {
                    seriesBarDistance: 5,
                    axisX            : {
                        labelInterpolationFnc: function (value)
                        {
                            return value[0];
                        }
                    }
                }]
            ]
        };
        function init() {
            msApi.request('store.reports.amounts@get',  {act:'today', store_id:store_id}).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.res = response;
                    console.log(vm.res);
                    if(vm.res.pays){
                        angular.forEach(vm.res.pays, function (v, k) {
                            vm.pieChart.data.push({key:v.pay_type,y:v.amount});
                        });
                    }

                    vm.lineChart.data = {labels:vm.res.all.labels,
                        series: [vm.res.all.values]};
                    vm.barChart.data = {labels:vm.res.card_type.labels,
                        series: [vm.res.card_type.values]};
                    vm.barChart1.data = {labels:vm.res.contract_type.labels,
                        series: [vm.res.contract_type.values]};
                    vm.loadingThreads = false;
                }
            );
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store.reports')
        .controller('XiaokesReportController', XiaokesReportController)
        .controller('XiaokeChartController', XiaokeChartController);

    /** @ngInject */
    function XiaokesReportController($filter, $rootScope , msApi, $cookies)
    {
        var store_id = $cookies.get('store_id');
        var vm = this;
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        vm.is_export = false;//是否可以增删改
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_report_xiaoke_export' || v == 'admin_report'){
                vm.is_export = true;
            }
        });
        vm.types = [{'id':'','text':'统计类型'},
            {'id' : 'd', 'text' : '按日'},
            {'id' : 'w', 'text' : '按周'},
            {'id' : 'm', 'text' : '按月'}];
        vm.classifys = [{'id':'0','text':'销课记录'},
            {'id' : '1', 'text' : '跨入销课'},
            {'id' : '2', 'text' : '跨出销课'}];
        // pager
        vm.query = {
            classify: 0,
            type:'',
            sdate:'',
            edate:'',
            store_id: store_id,
            sort: '-id',
            limit: 20,
            page: 1
        };
        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00') return new Date(str);
        }

        init();
        vm.doSearch = doSearch;

        function doSearch(){
            $rootScope.loadingProgress = true;
            msApi.resolve('store.reports.xiaokes@get', vm.query).then(
                function(lists){
                    vm.xiaokes = lists;$rootScope.loadingProgress = false;
                }
            );
        }
        //导出
        vm.exportXiaokes = exportXiaokes;
        function exportXiaokes(ev){
            /*var sdate = vm.query.sdate == '' ? '' : (vm.query.sdate).toISOString().slice(0,10);
            var edate = vm.query.edate == '' ? '' : (vm.query.edate).toISOString().slice(0,10);*/
            var sdate = vm.query.sdate == '' ? '' : $filter("date")(new Date(vm.query.sdate), "yyyy-MM-dd");
            var edate = vm.query.edate == '' ? '' : $filter("date")(new Date(vm.query.edate), "yyyy-MM-dd");
            window.open(msApi.getApiUrl('xiaokearchives/export')+'&sdate='+sdate+'&edate='+edate+'&type='+vm.query.type+'&store_id='+store_id);
        }
        function init()
        {
            vm.loadingThreads = true;
            var now_date = moment(new Date()).utc().format('YYYY-MM-DD');
            vm.query.type = 'd';
            //vm.query.sdate = now_date;
            //vm.query.edate = now_date;
            msApi.request('store.reports.xiaokes@get', vm.query).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.xiaokes = response;
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
    }
    function XiaokeChartController($rootScope , msApi, $cookies){
        var store_id = $cookies.get('store_id');
        var vm = this;
        vm.classifys = [{'id':'0','text':'销课记录'},
            {'id' : '1', 'text' : '跨入销课'},
            {'id' : '2', 'text' : '跨出销课'}];
        vm.lineChart = {
            data   : {
                labels: [],
                series: []
            },
            options: {
                fullWidth   : true,
                chartPadding: {

                },
                chart: {
                    height: 320,
                }
            }
        };
        vm.barChart = {
            data             : {
                labels: [],
                series: []
            },
            options          : {
                seriesBarDistance: 15
            },
            responsiveOptions: [
                ['screen and (min-width: 641px) and (max-width: 1024px)', {
                    seriesBarDistance: 10,
                    axisX            : {
                        labelInterpolationFnc: function (value)
                        {
                            return value;
                        }
                    }
                }],
                ['screen and (max-width: 640px)', {
                    seriesBarDistance: 5,
                    axisX            : {
                        labelInterpolationFnc: function (value)
                        {
                            return value[0];
                        }
                    }
                }]
            ]
        };
        vm.pieChart = {
            options: {
                chart: {
                    type              : 'pieChart',
                    height            : 320,
                    x                 : function (d)
                    {
                        return d.key;
                    },
                    y                 : function (d)
                    {
                        return d.y;
                    },
                    showLabels        : true,
                    transitionDuration: 500,
                    labelThreshold    : 0.01,
                    legend            : {
                        margin: {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        }
                    }
                }
            },
            data   : []
        };
        vm.pieChart1 = {
            options: {
                chart: {
                    type              : 'pieChart',
                    height            : 320,
                    x                 : function (d)
                    {
                        return d.key;
                    },
                    y                 : function (d)
                    {
                        return d.y;
                    },
                    showLabels        : true,
                    transitionDuration: 500,
                    labelThreshold    : 0.01,
                    legend            : {
                        margin: {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        }
                    }
                }
            },
            data   : []
        };
        vm.query = {
            classify: 0,
            type:'',
            sdate:'',
            edate:'',
            store_id: store_id,
            sort: '-id',
        };
        init();
        vm.doSearch = doSearch;

        function doSearch(){
            $rootScope.loadingProgress = true;
            vm.lineChart.data = {labels: [],
                series: []}
            vm.barChart.data ={abels: [],
                series: []
            }
            vm.pieChart.data = [];
            vm.pieChart1.data = [];
            $rootScope.loadingProgress = true;
            msApi.resolve('store.reports.xiaokes@get', vm.query).then(
                function(lists){
                    vm.res = lists;
                    if(vm.res.kuarus){
                        angular.forEach(vm.res.kuarus, function (v, k) {
                            vm.pieChart.data.push({key:v.card_type,y:v.amount});
                        });
                    }
                    if(vm.res.kuachus){
                        angular.forEach(vm.res.kuachus, function (v, k) {
                            vm.pieChart1.data.push({key:v.card_type,y:v.amount});
                        });
                    }
                    vm.lineChart.data = {labels:vm.res.all.labels,
                        series: [vm.res.all.values]};
                    vm.barChart.data = {labels:vm.res.contract_type.labels,
                        series: [vm.res.contract_type.values]};
                    $rootScope.loadingProgress = false;
                }
            );
        }
        vm.doDaySearch = doDaySearch;
        function doDaySearch(act) {
            vm.lineChart.data = {labels: [],
                series: []}
            vm.barChart.data ={abels: [],
                series: []
            }
            vm.pieChart.data = [];
            vm.pieChart1.data = [];
            $('.search-input-wrapper label').removeClass('active')
            $('#tag-'+act).addClass('active');
            msApi.request('store.reports.xiaokes@get',  {act:act, store_id:store_id}).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.res = response;
                    if(vm.res.kuarus){
                        angular.forEach(vm.res.kuarus, function (v, k) {
                            vm.pieChart.data.push({key:v.card_type,y:v.amount});
                        });
                    }
                    if(vm.res.kuachus){
                        angular.forEach(vm.res.kuachus, function (v, k) {
                            vm.pieChart1.data.push({key:v.card_type,y:v.amount});
                        });
                    }
                    vm.lineChart.data = {labels:vm.res.all.labels,
                        series: [vm.res.all.values]};
                    vm.barChart.data = {labels:vm.res.contract_type.labels,
                        series: [vm.res.contract_type.values]};
                    $rootScope.loadingProgress = false;
                }
            );
        }
        function init() {
            vm.loadingThreads = true;
            msApi.request('store.reports.xiaokes@get',  {act:'today', store_id:store_id}).then(
                // Success
                function (response) {
                    vm.lineChart.data = {labels: [],
                        series: []}
                    vm.barChart.data ={abels: [],
                        series: []
                    }
                    vm.pieChart.data = [];
                    vm.pieChart1.data = [];
                    vm.res = response;
                    if(vm.res.kuarus){
                        angular.forEach(vm.res.kuarus, function (v, k) {
                            vm.pieChart.data.push({key:v.card_type,y:v.amount});
                        });
                    }
                    if(vm.res.kuachus){
                        angular.forEach(vm.res.kuachus, function (v, k) {
                            vm.pieChart1.data.push({key:v.card_type,y:v.amount});
                        });
                    }
                    vm.lineChart.data = {labels:vm.res.all.labels,
                        series: [vm.res.all.values]};
                    vm.barChart.data = {labels:vm.res.contract_type.labels,
                        series: [vm.res.contract_type.values]};
                    vm.loadingThreads = false;
                }
            );
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store.reports')
        .controller('PaysReportController', PaysReportController);

    /** @ngInject */
    function PaysReportController($filter, $rootScope , msApi, $cookies, $mdDialog, $document)
    {
        var store_id = $cookies.get('store_id');
        var vm = this;
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        vm.is_cud = false;//是否可以增删改
        vm.is_export = false;//是否可以增删改
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_report_pay_cud' || v == 'admin_report'){
                vm.is_cud = true;
            }
            if( v == 'admin_report_pay_export' || v == 'admin_report'){
                vm.is_export = true;
            }
        });
        // pager
        vm.query = {
            sdate:'',
            edate:'',
            store_id: store_id,
            sort: '-id',
            limit: 20,
            page: 1
        };
        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00') return new Date(str);
        }

        init();
        vm.doSearch = doSearch;

        function doSearch(){
            $rootScope.loadingProgress = true;
            msApi.resolve('store.reports.pays@get', vm.query).then(
                function(lists){
                    vm.pays = lists;$rootScope.loadingProgress = false;
                }
            );
        }
        //弹窗
        vm.openPayDialog = openPayDialog;
        function openPayDialog(ev, pay)
        {
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'PayDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/reports/dialogs/pay/pay-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Pay : pay,
                    Pays: vm.pays,
                    is_cud: vm.is_cud,
                    event: ev
                }
            });
        }
        //导出
        vm.exportPays = exportPays;
        function exportPays(ev){
            /*var sdate = vm.query.sdate == '' ? '' : (vm.query.sdate).toISOString().slice(0,10);
            var edate = vm.query.edate == '' ? '' : (vm.query.edate).toISOString().slice(0,10);*/
            var sdate = vm.query.sdate == '' ? '' : $filter("date")(new Date(vm.query.sdate), "yyyy-MM-dd");
            var edate = vm.query.edate == '' ? '' : $filter("date")(new Date(vm.query.edate), "yyyy-MM-dd");
            window.open(msApi.getApiUrl('pays/export')+'&sdate='+sdate+'&edate='+edate+'&store_id='+store_id);
        }
        function init()
        {
            vm.loadingThreads = true;
            var now_date = moment(new Date()).utc().format('YYYY-MM-DD');
            vm.query.sdate = now_date;
            vm.query.edate = now_date;
            msApi.request('store.reports.pays@get', vm.query).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.pays = response;
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store.reports')
        .controller('IncomesReportController', IncomesReportController);

    /** @ngInject */
    function IncomesReportController($filter, $rootScope , msApi, $cookies, $mdDialog, $document)
    {
        var store_id = $cookies.get('store_id');
        var vm = this;
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        vm.is_cud = false;//是否可以增删改
        vm.is_export = false;//是否可以增删改
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_report_income_cud' || v == 'admin_report'){
                vm.is_cud = true;
            }
            if( v == 'admin_report_income_export' || v == 'admin_report'){
                vm.is_export = true;
            }
        });
        // pager
        vm.query = {
            sdate:'',
            edate:'',
            store_id: store_id,
            sort: '-id',
            limit: 20,
            page: 1
        };
        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00') return new Date(str);
        }

        init();
        vm.doSearch = doSearch;

        function doSearch(){
            $rootScope.loadingProgress = true;
            msApi.resolve('store.reports.incomes@get', vm.query).then(
                function(lists){
                    vm.incomes = lists;$rootScope.loadingProgress = false;
                }
            );
        }
        //弹窗
        vm.openIncomeDialog = openIncomeDialog;
        function openIncomeDialog(ev, income)
        {
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'IncomeDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/reports/dialogs/income/income-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Income : income,
                    Incomes: vm.incomes,
                    is_cud: vm.is_cud,
                    event: ev
                }
            });
        }
        //导出
        vm.exportIncomes = exportIncomes;
        function exportIncomes(ev){
            /*var sdate = vm.query.sdate == '' ? '' : (vm.query.sdate).toISOString().slice(0,10);
            var edate = vm.query.edate == '' ? '' : (vm.query.edate).toISOString().slice(0,10);*/
            var sdate = vm.query.sdate == '' ? '' : $filter("date")(new Date(vm.query.sdate), "yyyy-MM-dd");
            var edate = vm.query.edate == '' ? '' : $filter("date")(new Date(vm.query.edate), "yyyy-MM-dd");
            window.open(msApi.getApiUrl('incomes/export')+'&sdate='+sdate+'&edate='+edate+'&store_id='+store_id);
        }
        function init()
        {
            vm.loadingThreads = true;
            var now_date = moment(new Date()).utc().format('YYYY-MM-DD');
            vm.query.sdate = now_date;
            vm.query.edate = now_date;
            msApi.request('store.reports.incomes@get', vm.query).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.incomes = response;
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store.reports')
        .controller('AmountsReportController', AmountsReportController)
        .controller('AmountDetailsController', AmountDetailsController)
        .controller('ArchiveController', ArchiveController);

    /** @ngInject */
    function AmountsReportController($rootScope , msApi, $cookies) {
        var store_id = $cookies.get('store_id');
        var vm = this;
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        vm.is_export = false;//是否可以增删改
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_report_amount_export' || v == 'admin_report'){
                vm.is_export = true;
            }
        });
        vm.types = [{'id':'','text':'统计类型'},
            {'id' : 'd', 'text' : '按日'},
            {'id' : 'w', 'text' : '按周'},
            {'id' : 'm', 'text' : '按月'}];
        // pager
        vm.query = {
            type:'',
            sdate:'',
            edate:'',
            store_id: store_id,
            sort: '-id',
            card_type_id: 0,
            contract_type_id: 0,
            pay_type: 0,
            uid: 0,
            limit: 20,
            page: 1
        };
        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00') return new Date(str);
        }

        init();
        vm.doSearch = doSearch;

        function doSearch(){
            $rootScope.loadingProgress = true;
            msApi.resolve('store.reports.amounts@get', vm.query).then(
                function(lists){
                    vm.lists = lists;$rootScope.loadingProgress = false;
                }
            );
        }
        //导出
        vm.exportAmounts = exportAmounts;
        function exportAmounts(ev){
            var sdate = vm.query.sdate == '' ? '' : (vm.query.sdate).toISOString().slice(0,10);
            var edate = vm.query.edate == '' ? '' : (vm.query.edate).toISOString().slice(0,10);
            window.open(msApi.getApiUrl('amountarchives/export')+'&sdate='+sdate+'&edate='+edate+'&type='+vm.query.type+'&store_id='+store_id);
        }
        function init()
        {
            vm.loadingThreads = true;
            var now_date = moment(new Date()).utc().format('YYYY-MM-DD');
            vm.query.type = 'd';
            //vm.query.sdate = now_date;
            //vm.query.edate = now_date;
            msApi.request('store.reports.amounts@get', vm.query).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.lists = response;
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
    }
    function AmountDetailsController($rootScope , msApi, $cookies, $stateParams) {
        var store_id = $cookies.get('store_id');
        var vm = this;
        msApi.resolve('store.reports.amountsdetails@get', {store_id:store_id, date:$stateParams.date, type:$stateParams.type}).then(
            function(response){
                vm.lists = response.data;
                console.log(vm.lists);
            }
        );
    }
    function ArchiveController($rootScope , msApi, $cookies, $stateParams) {
        var store_id = $cookies.get('store_id');
        var vm = this;
        vm.query = {
            sdate:'',
            edate:'',
            act:'all',
            store_id:store_id
        }
        doSearch();
        vm.doSearch = doSearch;
        function doSearch(){
            $rootScope.loadingProgress = true;
            msApi.request('store.reports.amounts@get',  vm.query).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.res = response;
                    console.log(vm.res);
                    $rootScope.loadingProgress = false;
                }
            );
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store.signups')
        .controller('SignupsController', SignupsController)
        .controller('SignupsReportController', SignupsReportController);

    /** @ngInject */
    function SignupsReportController($filter, $rootScope , msApi, $cookies)
    {
        var store_id = $cookies.get('store_id');
        var vm = this;
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        vm.is_export = false;//是否可以增删改
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_report_signup_export' || v == 'admin_report'){
                vm.is_export = true;
            }
        });
        // pager
        vm.query = {
            status:'',
            sdate:'',
            edate:'',
            store_id: store_id,
            sort: '-id',
            limit: 20,
            page: 1
        };
        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00') return new Date(str);
        }

        init();
        vm.doSearch = doSearch;

        function doSearch(){
            $rootScope.loadingProgress = true;
            msApi.resolve('store.reports.signups@get', vm.query).then(
                function(signups){
                    vm.signups = signups;$rootScope.loadingProgress = false;
                }
            );
        }
        // 预约状态
        msApi.request('store.courses.signups@get', {'act': 'status'}).then(
            function (response) {
                vm.signup_status = response.data;
                vm.signup_status.push({'id':'','text':'预约状态'});
            }
        );
        //导出
        vm.exportSignups = exportSignups;
        function exportSignups(ev){
            /*var sdate = (vm.query.sdate).toISOString().slice(0,10);
            var edate = (vm.query.edate).toISOString().slice(0,10);*/
            var sdate = vm.query.sdate == '' ? '' : $filter("date")(new Date(vm.query.sdate), "yyyy-MM-dd");
            var edate = vm.query.edate == '' ? '' : $filter("date")(new Date(vm.query.edate), "yyyy-MM-dd");
            window.open(msApi.getApiUrl('signups/export')+'&sdate='+sdate+'&edate='+edate+'&status='+vm.query.status+'&store_id='+store_id);
        }
        function init()
        {
            vm.loadingThreads = true;
            var now_date = moment(new Date()).utc().format('YYYY-MM-DD');
            vm.query.sdate = now_date;
            vm.query.edate = now_date;
            msApi.request('store.reports.signups@get', vm.query).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.signups = response;
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
    }

    /** @ngInject */
    function SignupsController($rootScope , msApi, $cookies, $mdDialog, $http, $timeout, $document)
    {
        var vm = this;
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        vm.is_cud = false;//是否可以增删改
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_signup_cud' || v == 'admin_signup'){
                vm.is_cud = true;
            }
        });
        //vm.signups = Signups;
        var store_id = $cookies.get('store_id');

        // pager
        vm.query = {
            course_status:true,
            status:'',
            sdate:'',
            edate:'',
            store_id: store_id,
            sort: '-course_time',
            limit: 20,
            page: 1
        };
        init();
        vm.doSearch = doSearch;

        function doSearch(){
            $rootScope.loadingProgress = true;
            msApi.resolve('store.signups.list@get', vm.query).then(
                function(signups){
                    vm.signups = signups;
                    $rootScope.loadingProgress = false;
                }
            );
        }
        // 预约状态
        msApi.request('store.courses.signups@get', {'act': 'status'}).then(
            function (response) {
                vm.signup_status = response.data;
                vm.signup_status.push({'id':'','text':'预约状态'});
            }
        );
        //导出
        vm.exportSignups = exportSignups;
        function exportSignups(ev){
            window.open(msApi.getApiUrl('signups/export')+'&sdate='+vm.query.sdate+'&edate='+vm.query.edate+'&status='+vm.query.status+'&store_id='+store_id);
        }
        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00') return new Date(str);
        }

        //更新状态
        vm.updateStatus = updateStatus;
        function updateStatus(signup, status){
            var confirm = $mdDialog.confirm()
                .title('确认操作?')
                .content('确认要执行这个操作吗.')
                .ariaLabel('修改状态')
                .ok('确定')
                .cancel('取消');
                //.targetEvent(event);
            $mdDialog.show(confirm).then(function (){
                var data = {'status' : status}
                $http({
                    method:'PUT',
                    url: msApi.getApiUrl('signups/' +signup.id),
                    data:data
                }).success(function(req){
                    $rootScope.message_success = '操作成功!';
                    $timeout(function(){$rootScope.message_success = '';},5000);
                    var status_text = '', status_class = '';
                    angular.forEach(vm.signup_status, function (v, k) {
                        if (v.id == status) {
                            status_text  = v.text;
                            status_class = v.class;
                        }
                    });
                    signup.status_class = status_class;
                    signup.status_text  = status_text;
                    signup.status       = status;
                    // Dummy save action
                    for ( var i = 0; i < vm.signups.length; i++ )
                    {
                        if ( vm.signups[i].id === data.id )
                        {
                            vm.signups[i] = angular.copy(signup);
                            break;
                        }
                    }
                }).error(function(data, state) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function(){$rootScope.message_danger = '';},5000);
                });
            }, function (){
                // Cancel Action
            });
            //closeDialog();
        }
        function init()
        {
            vm.loadingThreads = true;
            var now_date = moment(new Date()).utc().format('YYYY-MM-DD');
            vm.query.sdate = now_date;
            vm.query.edate = now_date;
            // Figure out the api name
            msApi.request('store.signups.list@get', vm.query).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.signups = response;
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
        vm.loglist = function(ev, signup){
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'LogsDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/signups/dialogs/logs/logs-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Signup : signup,
                    event: ev
                }
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store.plans')
        .controller('PlanDetailController', PlanDetailController);

    /** @ngInject */
    function PlanDetailController($rootScope, $timeout, $q, msApi, $mdDialog, $document, $http, $cookies, Plan, $stateParams)
    {
        var store_id = $cookies.get('store_id');
        var vm = this;
        vm.plan = Plan;
        vm.tasks = null;
        init();
        function init(){
            vm.loadingThreads = true;
            // Figure out the api name
            msApi.request('store.plans.list@get').then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.plans = response;
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
        msApi.request('store.plans.plantasks@get', {'plan_id': $stateParams.id,'store_id': store_id,'sort':'-status','per-page':1000}).then(
            function (response){
                vm.tasks = response.data;
                console.log(vm.tasks);
            });
        vm.openPlanDialog = openPlanDialog ;
        function openPlanDialog(ev, plan)
        {
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'PlanDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/plan/dialogs/plan/plan-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Plan : plan,
                    Plans: vm.plans,
                    event: ev
                }
            });
        }
        vm.openPlantaskDialog = openPlantaskDialog ;
        function openPlantaskDialog(ev, plan, task)
        {
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'PlanTaskDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/plan/dialogs/task/task-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Task:task,
                    Tasks: vm.tasks,
                    Plan:vm.plan,
                    event: ev
                }
            });
        }
        vm.deleteTask = deleteTask;
        function deleteTask(ev, task) {
            ev.stopPropagation();
            var confirm = $mdDialog.confirm()
                .title('删除确认操作?')
                .content('确认要删除此计划任务吗.')
                .ariaLabel('删除计划任务')
                .ok('删除')
                .cancel('取消');
            //.targetEvent(event);
            $mdDialog.show(confirm).then(function ()
            {
                var data = angular.copy(task);
                data.status = 0;
                $http({
                    method: 'PUT',
                    url: msApi.getApiUrl('plantasks/' + data.id),
                    data: data
                }).success(function (req) {
                    vm.tasks.splice(vm.tasks.indexOf(task), 1);
                    $rootScope.message_success = '操作成功!';
                    $timeout(function () {
                        $rootScope.message_success = '';
                    }, 5000);
                }).error(function (data, state) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function () {
                        $rootScope.message_danger = '';
                    }, 5000);
                });
            }, function ()
            {
                // Cancel Action
            });
        }
        vm.deleteAllTask = deleteAllTask;
        function deleteAllTask(ev, task) {
            ev.stopPropagation();
            var confirm = $mdDialog.confirm()
                .title('删除确认操作?')
                .content('确认要删除所有此计划任务吗.')
                .ariaLabel('删除计划所有任务')
                .ok('删除')
                .cancel('取消');
            //.targetEvent(event);
            $mdDialog.show(confirm).then(function ()
            {
                var data = {'act':'deleteall','plan_id':vm.plan.id};
                msApi.request('store.plans.plantasks@get', data).then(
                    function (response) {
                        vm.tasks = [];
                        console.log(response);
                        $rootScope.message_success = '操作成功!';
                        $timeout(function () {
                            $rootScope.message_success = '';
                        }, 5000);
                    });
            }, function ()
            {
                // Cancel Action
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store.plans')
        .controller('PlanController', PlanController);

    /** @ngInject */
    function PlanController($rootScope, $timeout, $q, msApi, $mdDialog, $document, $http, $cookies)
    {
        var store_id = $cookies.get('store_id');
        var vm = this;
        vm.query = {
            title:'',
            desc:'',
            sort: 'title',
            limit: 20,
            page: 1,
            _meta:{}
        };
        init();
        vm.doSearch = doSearch;
        function doSearch(){
            msApi.resolve('store.plans.list@get', vm.query).then(function(response){
                vm.plans = response.data;
                vm._meta = response._meta;
            });
        }
        function init(){
            vm.loadingThreads = true;
            // Figure out the api name
            msApi.request('store.plans.list@get', vm.query).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.plans = response.data;
                    vm._meta = response._meta;
                    console.log(vm._meta);
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
        vm.openPlanDialog = openPlanDialog ;
        function openPlanDialog(ev, plan)
        {
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'PlanDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/plan/dialogs/plan/plan-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Plan : plan,
                    Plans: vm.plans,
                    event: ev
                }
            });
        }
        vm.importPlanDialog = importPlanDialog;
        function importPlanDialog(ev,plan){
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'PlanImportDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/plan/dialogs/plan/plan-import-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Plan : plan,
                    Plans: vm.plans,
                    event: ev
                }
            });
        }
        vm.openPlantaskDialog = openPlantaskDialog ;
        function openPlantaskDialog(ev, plan)
        {
            msApi.resolve('store.plans.plantasks@get', {
                plan_id:plan.id,store_id:store_id
            }).then(function(tasks){
                vm.tasks = tasks.data;
            console.log(tasks);});
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'PlanTaskDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/plan/dialogs/task/task-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Task:null,
                    Tasks: vm.tasks,
                    Plan:plan,
                    event: ev
                }
            });
        }

        vm.deletePlan = deletePlan;
        function deletePlan(ev, plan) {
            ev.stopPropagation();
            var confirm = $mdDialog.confirm()
                .title('删除确认操作?')
                .content('确认要删除此计划吗.')
                .ariaLabel('删除计划')
                .ok('删除')
                .cancel('取消');
            //.targetEvent(event);
            $mdDialog.show(confirm).then(function ()
            {
                var data = angular.copy(plan);
                data.status = 0;
                $http({
                    method: 'PUT',
                    url: msApi.getApiUrl('plans/' + data.id),
                    data: data
                }).success(function (req) {
                    vm.plans.splice(vm.plans.indexOf(plan), 1);
                    $rootScope.message_success = '操作成功!';
                    $timeout(function () {
                        $rootScope.message_success = '';
                    }, 5000);
                }).error(function (data, state) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function () {
                        $rootScope.message_danger = '';
                    }, 5000);
                });
            }, function ()
            {
                // Cancel Action
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store.courses')
        .controller('CourseTaskController', CourseTaskController);

    /** @ngInject */
    function CourseTaskController($filter, $scope, $mdDialog, $cookies, $rootScope, $http, $timeout, msApi, $mdSidenav ,$stateParams, Contract)
    {
        var store_id = $cookies.get('store_id');
        var auth_key = $cookies.get('auth_key');
        var vm = this;
        vm.contract = Contract;
        //学生多选
        vm.readonly = false;
        vm.selectedItem = null;
        vm.searchText = null;
        vm.querySearch = querySearch;
        vm.vegetables = [];
        vm.selectedVegetables = [];
        vm.numberChips = [];
        vm.numberChips2 = [];
        vm.numberBuffer = '';
        vm.autocompleteDemoRequireMatch = true;
        vm.transformChip = transformChip;
        vm.categories_id = 0;
        vm.type = 0;
        vm.savingTask = false;
        vm.checkingConfuse = false;
        vm.isLoadingTasks = false;//是否正在家在 选择的计划下的任务
        vm.stuPlanCourses = [];
        vm.deleteCourseIds = [];
        //结束
        vm.res = [];
        vm.events = [vm.res];
        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00') return new Date(str);
        }
        vm.list = [];//加课项
        //传学员id的情况
        if($stateParams.customer_id > 0){
            $http.get(msApi.getApiUrl('customers/'+$stateParams.customer_id)).success(function (res) {
                vm.selectedVegetables.push({
                    id:res.id,name:res.name
                });
                vm.selectedItem = {id:res.id,name:res.name};
            });
        }
        //传了合同ID的情况
        if ($stateParams.contract_id > 0){
            vm.isLoadingTasks = true;
            msApi.request('store.courses.plans@get', {"per-page": 1000,"sort":"title"}).then(
                function (response) {
                    // vm.isLoadingTasks = false;
                    $rootScope.loadingProgress = false;
                    vm.plans = response.data;
                    if (vm.plans){
                        for(i = 0;i<vm.plans.length;i++){
                            if (vm.plans[i].id == vm.contract.plan_id){
                                vm.selectPlan(vm.plans[i]);
                            }
                        }
                    }
                    
                }).catch(function (result) {
                    vm.isLoadingTasks = false;
                });
        }

        var apiName = "store.calendar.courses@get";
        vm.query = {
            store_id:store_id,
            "per-page": 1000,
            //limit:10000,
            page: 1
        }
        vm.myDate = new Date();
        //BY JOE -- START
        var highlight_dates = []; //选择的日期
        function changeList() {
            if (vm.list.length > 0) {
                var i = 0;
                angular.forEach(vm.list, function (item, index) {
                    // if (item.passed) return;//如果已经过去，直接不处理  ---- 过去先开放出去
                    if(highlight_dates[i]) {
                        var date = $filter("date")(highlight_dates[i].date, "yyyy-MM-dd");
                        vm.list[index].date = highlight_dates[i].date;
                        vm.list[index].date1 = date;
                        vm.list[index].room = highlight_dates[i].room;
                        vm.list[index].teacher = highlight_dates[i].teacher;
                        vm.list[index].time = highlight_dates[i].time;
                        changeDate(vm.list[index]);
                        i++;
                    }
                    if (item.childs.length > 0) {
                        angular.forEach(item.childs, function (child, ke) {
                            if(highlight_dates[i]) {
                                var date = $filter("date")(highlight_dates[i].date, "yyyy-MM-dd");
                                vm.list[index].childs[ke].date = highlight_dates[i].date;
                                vm.list[index].childs[ke].date1 = date;
                                vm.list[index].childs[ke].room = highlight_dates[i].room;
                                vm.list[index].childs[ke].teacher = highlight_dates[i].teacher;
                                vm.list[index].childs[ke].time = highlight_dates[i].time;
                                changeDate(vm.list[index].childs[ke]);
                                i++;
                            }
                        });
                    }
                });
            }
            // console.log(highlight_dates);
        }
        vm.dateOptions = {
            numberOfMonths: 8,
            changeYear: true,
            changeMonth: true,
            yearRange: '1900:-0',
            onSelect: function(value, picker){
                // console.log("value:"+value);
                var selectedDate = new Date(value+" 00:00:00");
                // console.log("selectedDate:");
                // console.log(selectedDate);
                // if (moment(selectedDate).isBefore(moment())) return false; //如果日期已经结束，不允许点击
                var strs = new Array(); //定义一数组
                strs = value.split("/"); //字符分割
                var new_date = strs[2] + '-' + strs[0] + '-' + strs[1];
                // console.log("new_data:"+new_date);
                var inSelected = false;
                for (var i = 0; i < highlight_dates.length; i++) {
                    if (highlight_dates[i].date.getTime() == selectedDate.getTime()) {
                        inSelected = true;
                        highlight_dates.splice(i, 1);//删除本身已存在的日期
                        if (vm.list.length > 0) {
                            var is_flag = true
                            angular.forEach(vm.list, function (v, k) {
                                if (v.date1 == new_date) {
                                    if (is_flag) {
                                        vm.list[k].date = '';
                                        vm.list[k].date1 = '';
                                        vm.list[k].zeno_time = '';
                                        is_flag = false;
                                    }
                                }
                                if (v.childs.length > 0) {
                                    angular.forEach(v.childs, function (child, ke) {
                                        if (child.date1 == new_date) {
                                            if (is_flag) {
                                                vm.list[k].childs[ke].date = '';
                                                vm.list[k].childs[ke].date1 = '';
                                                vm.list[k].childs[ke].zeno_time = '';
                                                is_flag = false;
                                            }
                                        }
                                    });
                                }
                            });
                        }
                        break;
                    }
                }
                //不存在于数组才加入
                if (!inSelected) {
                    var newDateItem = {
                        date:selectedDate,
                        time:null,
                        room:null,
                        teacher:null
                    }
                    highlight_dates.push(newDateItem);

                }
                highlight_dates.sort(function (a, b) {
                    return a.date>b.date?1:-1;
                });
                changeList();
                console.log(highlight_dates);
                //$scope.$apply();

                return true;
            },
            beforeShowDay: function(date){
                // console.log('in beforeShowDay-----------------');
                // console.log(highlight_dates);
                // if (moment(date).isBefore(moment())) return [true,'passed'];
                for (var i = 0; i < highlight_dates.length; i++) {
                    if (highlight_dates[i].date.getTime() == date.getTime()) {
                        return [true, 'highlight'];
                    }
                }
                return [true];
            }
        };

        //BY JOE --END
        msApi.request("store.courses.categories@get", {'store_id':store_id, 'act': 'course_time_arr'}).then(//课程开始时间
            function (response){
                vm.course_time_arr = response.data;
            });
        msApi.request("store.courses.users@get", {'store_id':store_id, 'role_id': 3,'sort':'name','fields':'id,name,timezone','per-page': 1000}).then(//教练
            function (response){
                vm.teachers = response.data;
            });
        msApi.request("store.courses.rooms@get", {'store_id':store_id}).then(//教练
            function (response){
                vm.rooms = response.data;
            });
        msApi.request("store.courses.users@get", {'store_id':store_id, 'role_id': 6,'sort':'name','fields':'id,name,timezone','per-page': 1000}).then(//助教
            function (response){
                vm.assistants = response.data;
            });
        msApi.request("store.courses.categories@get", {'store_id':store_id, type: 1}).then(//课程类型
            function (response){
                vm.categories = response.data;
            });

        msApi.request("store.courses.categories@get", {'store_id':store_id, type: 2}).then(//课程级别
            function (response){
                vm.jibei_types = response.data;
            });
        /**
         * @param start
         * @param end
         */
        function loadEvents(){
            $rootScope.loadingProgress = true;
        }
        /**
         * Add new event in between selected dates
         *
         * @param start
         * @param end
         * @param e
         */
        vm.all_time = '';
        vm.all_kshi = 1;
        vm.all_room = '';
        vm.all_teacher = '';
        vm.all_zhuj = '';
        vm.selTime = selTime;
        function selTime() {
            if(vm.list.length > 0) {
                angular.forEach(vm.list, function (item, k) {
                    if (item.passed) return;//如果已经过去不处理 
                    item.time = vm.all_time;
                    changeDate(item);
                    if(item.childs.length > 0){
                        angular.forEach(item.childs, function (child, key) {
                            child.time = vm.all_time;
                            changeDate(child);
                        });
                    }
                });
            }
        }
        vm.selKshi = selKshi;
        function selKshi() {
            if(vm.list.length > 0) {
                angular.forEach(vm.list, function (item, k) {
                    if (item.passed) return;//如果已经过去不处理
                    item.kshi = vm.all_kshi;
                    if(item.childs.length > 0){
                        angular.forEach(item.childs, function (child, key) {
                            child.kshi = vm.all_kshi;
                        });
                    }
                });
            }
        }
        vm.selRoom = selRoom;
        function selRoom() {
            if(vm.list.length > 0) {
                angular.forEach(vm.list, function (item, k) {
                    if (item.passed) return;//如果已经过去不处理
                    item.room = vm.all_room;
                    if(item.childs.length > 0){
                        angular.forEach(item.childs, function (child, key) {
                            child.room = vm.all_room;
                        });
                    }
                });
            }
        }
        vm.selTeacher = selTeacher;
        function selTeacher() {
            if(vm.list.length > 0) {
                angular.forEach(vm.list, function (item, k) {
                    if (item.passed) return;//如果已经过去不处理
                    item.teacher = vm.all_teacher;
                    changeDate(item, k);
                    if(item.childs.length > 0){
                        angular.forEach(item.childs, function (child, key) {
                            child.teacher = vm.all_teacher;
                            changeDate(child);
                        });
                    }
                });
            }
        }
        vm.selZhuj = selZhuj;
        function selZhuj() {
            if(vm.list.length > 0) {
                angular.forEach(vm.list, function (item, k) {
                    if (item.passed) return;//如果已经过去不处理
                    item.zhuj = vm.all_zhuj;
                    if(item.childs.length > 0){
                        angular.forEach(item.childs, function (child, key) {
                            child.zhuj = vm.all_zhuj;
                        });
                    }
                });
            }
        }
        vm.i=0;
        vm.changeDate = changeDate
            //上课时间按时区转换
        function changeDate(item,type) {
            type = type || 0;

            if(type == 1){
                var old_date1 = item.date1+' 00:00:00';
                item.date1 = $filter("date")(new Date(item.date), "yyyy-MM-dd");
                var  inSelected = false;
                for (var i = 0; i < highlight_dates.length; i++) {
                    var hdateItem = highlight_dates[i];
                    if (hdateItem.date.getTime() == item.date.getTime()) {
                        inSelected = true;
                    }
                    if(hdateItem.date.getTime() == (new Date(old_date1)).getTime()){
                        highlight_dates.splice(i, 1);//删除原来已存在的日期
                    }
                }
                if(!inSelected) {
                    var newDateItem = {
                        date:new Date(item.date1+' 00:00:00'),
                        time:null,
                        room:null,
                        teacher:null
                    }
                    highlight_dates.push(newDateItem);
                    $("#taskplanDatePicker").datepicker("refresh");
                }
                //testing....
                /*highlight_dates = [];
                highlight_dates.push(new Date("2019-11-27 00:00:00"));
                highlight_dates.push(new Date("2019-11-28 00:00:00"));
                highlight_dates.push(new Date("2019-11-29 00:00:00"));
                jQuery("#taskplanDatePicker").datepicker( "refresh" );*/
            }
            item.timezone = '';
            item.zeno_time = '';
            angular.forEach(vm.teachers, function(v,k){
                if(item.teacher == v.id){
                    item.timezone = v.timezone;
                    //item.date1 = (item.date).toISOString().slice(0,10);
                    if(item.time !== '' && item.teacher > 0 &&  item.timezone != '' && item.timezone != 'Asia/Shanghai'){
                        if (!item.date1) item.date1 = moment(item.date).format("YYYY-MM-DD");
                        var str = item.time.split('~');
                        var star = item.date1+' '+str[0];
                        var end = item.date1+' '+str[1];
                        item.zeno_time = moment.tz(star,"Asia/Shanghai").tz(item.timezone).format("YYYY-MM-DD HH:mm");
                        item.zeno_time = item.zeno_time + '~'+(moment.tz(end,"Asia/Shanghai").tz(item.timezone).format('HH:mm'));
                        //vm.list[index] = item;

                    }
                }
            });

        }
        vm.planChange = planChange;
        function planChange() {
            if(vm.curr_plan.title === '' || vm.curr_plan.title === null || !("title" in vm.curr_plan)) {
                vm.curr_plan = {};
            }
        }
        vm.addItem = addItem;
        function addItem() {
            var obj = {
                task_id:0,
                task_title:'',
                name:'',
                content: '',
                date:'',
                time:'',
                kshi:1,
                room:0,
                teacher:0,
                zhuj:0,
                time_error:0,
                room_error:0,
                teacher_error:0,
                zhuj_errorr:0,
                zeno_time:'',
                childs:[]
            };
            vm.list.push(obj);
        }
        vm.addChild = addChild;
        function addChild(index) {
            var obj = {
                date:'',
                time:vm.list[index].time,
                kshi:1,
                room:vm.list[index].room,
                teacher:vm.list[index].teacher,
                zhuj:vm.list[index].zhuj,
                zeno_time:'',
            };
            if (!vm.list[index].passed){//当如果当前任务已经是结束了，添加新当子任务当时候作为新的添加
                vm.list[index]['childs'].push(obj);
            }else{
                var newTask = angular.copy(vm.list[index]);
                //清除不该有的，日期，课程ID，是否过时
                newTask.date = "";
                delete(newTask.course_id);
                delete(newTask.passed);
                newTask.childs = [];
                vm.list.splice(index+1,0,newTask);
            }
            changeList();
        }
        vm.delChild = delChild;
        function delChild(parent,item) {
            if (item.course_id) vm.deleteCourseIds.push(item.course_id);//如果是删除已有课程，把ID放到数组里

            parent.childs.splice(parent.childs.indexOf(item), 1);
            changeList();
        }
        vm.delTaskItem = function(index){
            if (vm.list[index].course_id) vm.deleteCourseIds.push(vm.list[index].course_id);//如果是删除已有课程，把ID放到数组里
            vm.list.splice(index, 1);
            changeList();
        }
        vm.removeItem = removeItem;
        function removeItem(item) {
            vm.list.splice(vm.list.indexOf(item), 1);
        }
        vm.saveCourse = saveCourse;
        function saveCourse(ev) {
            //$('#sub-btn').hide();
            //vm.loadingThreads = true;
            vm.savingTask  = true;
            if(vm.list.length > 0) {
                angular.forEach(vm.list, function (item, k) {
                    //item.date1 = (item.date).toISOString().slice(0, 10);
                    item.date1 = moment(item.date).format("YYYY-MM-DD");
                    
                    if(item.childs.length > 0){
                        angular.forEach(item.childs, function (child, key) {
                            //child.date1 = (child.date).toISOString().slice(0, 10);
                            child.date1 = moment(child.date).format("YYYY-MM-DD");
                        });
                    }
                });
                
                var url = msApi.getApiUrl('courses/task'),
                    data = {
                        store_id: store_id,
                        number: vm.number,
                        type:vm.type,
                        categories_id:vm.categories_id,
                        signupshu: 0,
                        plan_id:vm.plan_id,
                        customer_id:vm.customer_id,
                        list: vm.list,
                        delete_course_ids: vm.deleteCourseIds,
                        customers:vm.selectedVegetables,

                    },
                    transFn = function (data) {
                        return $.param(data);
                    },
                    config = {
                        headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
                        transformRequest: transFn
                    };
                $http.post(url, data, config).success(function (data, status, headers, config) {
                    vm.savingTask  = false;
                    msg(ev,'提示', '操作成功');
                    //alert('操作成功');
                    $('#sub-btn').show();
                    vm.selectPlan(vm.curr_plan);//重新加载所有的内容
                    $timeout(function(){$rootScope.message_success = '';},5000);
                    // vm.loadingThreads = false;
                    // vm.curr_plan = null;
                    // vm.list = [];
                    // vm.number = '';
                    // vm.readonly = false;
                    // vm.selectedItem = null;
                    // vm.searchText = null;
                    // vm.vegetables = [];
                    // vm.selectedVegetables = [];
                    // vm.numberChips = [];
                    // vm.numberChips2 = [];
                    // vm.numberBuffer = '';
                    // vm.autocompleteDemoRequireMatch = true;
                    // $timeout(function(){$rootScope.message_success = '';},5000);
                }).error(function (data, state) {
                   // alert('操作失败');
                    //$('#sub-btn').show();
                    //vm.loadingThreads = false;
                    vm.savingTask  = false;
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    msg(ev,'提示', vm.error_arr);
                });
            }else {
                $timeout(function () {
                    vm.savingTask  = false;
                    vm.loadingThreads = false;
                }, 2000);

            }
        }
        vm.check = check;
        function check(ev) {

            if(vm.list.length > 0) {
                vm.checkingConfuse = true;
                var copyList = [];
                angular.forEach(vm.list, function(item,k){
                    //item.date1 = (item.date).toISOString().slice(0,10);
                    item.date1 = moment(item.date).format("YYYY-MM-DD");//$filter("date")(new Date(item.date), "yyyy-MM-dd");
                    // if (!item.passed) copyList.push(item);//没有过时间的添加进去 ---- 过去先开放出去
                    delete(item.is_conflict);
                    delete(item.course_conflict);
                    angular.forEach(item.childs,function(citem,cIndex){
                        citem.date1 = moment(citem.date).format("YYYY-MM-DD");
                        delete(citem.is_conflict);
                        delete(citem.course_conflict);
                    });
                    copyList.push(item);
                });
                var url = msApi.getApiUrl('courses/checkct'),
                    data = {
                        store_id: store_id,
                        plan_id:vm.plan_id,
                        number: vm.number,
                        type:vm.type,
                        categories_id:vm.categories_id,
                        list: copyList,
                        customers:vm.selectedVegetables,
                        edate :copyList[0].date
                    },
                    transFn = function (data) {
                        return $.param(data);
                    },
                    config = {
                        headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
                        transformRequest: transFn
                    };
                $http.post(url, data, config).success(function (data, status, headers, config) {
                    vm.checkingConfuse = false;
                    if('list' in data ){
                        angular.forEach(data.list, function(v,k){
                            copyList[k].is_conflict =  v.is_conflict?true:false;
                            copyList[k].conflict_course =  v.conflict_course?v.conflict_course:"";
                            copyList[k].time_error =  v.time_error != 0  ? v.time_error : '';
                            copyList[k].room_error =  v.room_error != 0 ? v.room_error : '';
                            copyList[k].teacher_error = v.teacher_error != 0 ? v.teacher_error : '';
                            copyList[k].zhuj_errorr = v.zhuj_errorr != 0 ? v.zhuj_errorr : '';
                            console.log(copyList[k].childs);
                            angular.forEach(v.childs, function(child,cIndex){
                                copyList[k].childs[cIndex].is_conflict =  child.is_conflict?true:false;
                                copyList[k].childs[cIndex].conflict_course =  child.conflict_course?child.conflict_course:"";
                                copyList[k].childs[cIndex].time_error =  child.time_error != 0  ? child.time_error : '';
                                copyList[k].childs[cIndex].room_error =  child.room_error != 0 ? child.room_error : '';
                                copyList[k].childs[cIndex].teacher_error = child.teacher_error != 0 ? child.teacher_error : '';
                                copyList[k].childs[cIndex].zhuj_errorr = child.zhuj_errorr != 0 ? child.zhuj_errorr : '';
                            });
                            
                        });
                    }
                    if(('code' in data) && data.code == 'error'){
                        msg(ev,'提示', data.msg);
                    }else{
                        msg(ev,'提示', '检测成功');
                    }
                }).error(function (data, state) {
                    vm.checkingConfuse = false;
                    vm.error_arr = data && data[0].message ? data[0].message : '检测失败!';
                    msg(ev,'提示', vm.error_arr);
                });
            }
        }

        //选择计化
        vm.selectPlan = selectPlan;
        function selectPlan(plan, sidenavId) {
            //console.log(vm.contract);
            vm.curr_plan = plan;
            if (vm.contract){
                vm.number = plan.number+"-"+vm.contract.contact_guid;
            }else{
                vm.number = plan.number+"-"+moment(new Date()).format('YYYYMMDDHHmmss');
            }
            vm.isLoadingTasks = true;
            vm.plan_id=plan.id;
            vm.list = [];
            highlight_dates = [];
            msApi.request('store.courses.tasks@get', {'plan_id': plan.id,'store_id': store_id,'sort':'id','per-page':10000}).then(
                function (response){
                    vm.tasks =  response.data;
                    if(plan.num > 0  && vm.tasks){
                        angular.forEach(vm.tasks, function(v,k){
                            var name = v.desc?(v.title+" - "+v.desc):v.title;
                            var obj = {
                                task_id:v.id,
                                task_title:v.title,
                                name:name,
                                content:v.desc,
                                date:'',
                                time:'',
                                kshi:1,
                                room:0,
                                teacher:0,
                                zhuj:0,
                                time_error:0,
                                room_error:0,
                                teacher_error:0,
                                zhuj_errorr:0,
                                zeno_time:'',
                                childs:[]
                            };
                            vm.list.push(obj);
                        });

                        //获取当前学生当前计划的课程
                        vm.fetchStudentPlanCourses(null,false);

                    }
                });
            if (sidenavId) $mdSidenav(sidenavId).toggle();
        }
        //根据当前学生已安排的学习计划课程，更新列表数据
        vm.updatePlanTaskWithCourses = function(taskList, studentCourses){
            highlight_dates = [];
            //添加 taskList 里的标记
            taskList.forEach(function(item,index){item.handled = false;});
            var courses = angular.copy(studentCourses);
            courses.forEach(function(course,index){
                if (vm.categories_id == 0 || vm.type == 0) {//如果分类没有被设置过, 设置这次计划的课程类型
                    vm.categories_id = course.categories_id;
                    vm.type = course.type;
                }
                for(i=0;i<taskList.length;i++){//遍历列表，找是否有当前任务，如果有，把课程相应的信息设置进任务信息
                    var task = taskList[i];
                    if (task.task_id == course.task_id ){
                        if (!task.handled){//之前没有设置过当前任务
                            setTask(task,course);//把course的信息付值到course
                            var taskDateItem = {
                                date:task.date,
                                time:task.time,
                                room:task.room,
                                teacher:task.teacher
                            }
                            highlight_dates.push(taskDateItem);
                        }else{//已经设置过，添加子任务
                            if (!task.childs) task.childs = [];//如果没有定义childs，初始化
                            var obj = {
                                task_id:task.task_id,
                                task_title:task.task_title,
                                name:task.name,
                                content: task.content,
                                date:task.date,
                                time:task.time,
                                kshi:1,
                                room:0,
                                teacher:0,
                                zhuj:0,
                                time_error:0,
                                room_error:0,
                                teacher_error:0,
                                zhuj_errorr:0,
                                zeno_time:''
                            };
                            setTask(obj,course);
                            task.childs.push(obj);
                            var taskDateItem = {
                                date:obj.date,
                                time:obj.time,
                                room:obj.room,
                                teacher:obj.teacher
                            }
                            highlight_dates.push(taskDateItem);
                        }
                        // if (!task.passed) highlight_dates.push(task.date);//把设置的时间添加进去
                    }
                }
            });

            //删除标记
            taskList.forEach(function(item,index){delete(item.handled);});
            $("#taskplanDatePicker").datepicker("refresh");
        }
        function setTask(task,source){
            task.name = source.name;
            task.content = source.content;
            task.date = new Date(source.course_time+"  00:00:00");
            task.time = source.course_begintime+"~"+source.course_endtime;
            task.room = source.room_id;
            task.teacher = source.teacher_id;
            task.course_id = source.id;
            //task.zhuj = course.  @to-do在course里没找到助教
            // task.zeno_time = course.start_zone
            task.passed = moment(source.start).isBefore(moment());//判断当前课程是否已经过去
            task.handled = true;
        }
        /**
         * 获取选择的学生及计划已有的课程
         * @param {}} event 
         */
        vm.fetchStudentPlanCourses = function(event,showSidenv){
            vm.stuPlanCourses = [];
            if (vm.selectedVegetables.length==0||!vm.curr_plan) return;//没有数据不做任何事情
            var studentIds = [];

            for(i=0;i<vm.selectedVegetables.length;i++){
                studentIds.push(vm.selectedVegetables[i].id);
            }
            var queryData = {
                plan_id:vm.curr_plan.id,
                student_id:studentIds.toString(),
                contact_guid:vm.contract?vm.contract.contact_guid:null,
                "per-page": 1000,
                sort:"course_time"
            };
            $rootScope.loadingProgress = true;
            vm.isStuPlanCoursesLoading = true;
            msApi.resolve('store.courses.list@get', queryData).then(function(res){
                vm.stuPlanCourses = res.data;
                $rootScope.loadingProgress = false;
                vm.isStuPlanCoursesLoading = false;
                vm.updatePlanTaskWithCourses(vm.list,res.data);//更新列表里的数据
            }).catch(function(reason){
                $rootScope.loadingProgress = false;
                vm.isStuPlanCoursesLoading = false;
            });
            if (showSidenv) $mdSidenav("spcourses-sidenav").toggle();
            vm.isLoadingTasks = false;

        }
        vm.courses = [];
        // Expose the toggle function

        vm.toggleSidenavPlans = toggleSidenavPlans;
        //所有任务计划
        function toggleSidenavPlans(sidenavId)
        {
            vm.query = {
                store_id:store_id,
                status:1,
                "per-page": 1000,
                'act': 'gudin',
                //limit:10000,
                //'number':vm.course.number,
                page: 1
            }
            //所有任务
            if (!vm.plans||vm.plans.length==0){
                vm.isLoadingTasks = true;
                msApi.request('store.courses.plans@get', vm.query).then(
                    function (response) {
                        vm.isLoadingTasks = false;
                        $rootScope.loadingProgress = false;
                        vm.plans = response.data;
                    }).catch(function(reason){
                        vm.isLoadingTasks = false;
                    });
            }
            $mdSidenav(sidenavId).toggle();
        }
        vm.customers = {};

        /**
         * Return the proper object when the append is called.
         */
        function transformChip(chip) {
            // If it is an object, it's already a known chip
            if (angular.isObject(chip)) {
                return chip;
            }

            // Otherwise, create a new one
            return { name: chip, id: '0' };
        }
        vm.customers = null;

        /**
         * Search for vegetables.
         */
        function querySearch (query) {
            if(query){
                return $http.get(msApi.getApiUrl('customers'), {params: {'store_id':store_id, 'keyword':query, 'act': 'searched'}}).then(function (results) {
                    vm.customers = results.data.data;
                    vm.vegetables = loadVegetables();
                    $('#customer-auto').find('input[type="search"]').focus();
                    return vm.vegetables;
                });
            }
            vm.vegetables = [];
            return vm.vegetables;
        }

        function loadVegetables() {
            var ret = [];
            if(vm.customers.length > 0){
                angular.forEach(vm.customers, function (v, k) {
                    ret.push({
                        id:v.id,name:v.name
                    });
                });
                return ret;
            }
        }
        function msg(ev,title,content) {
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    };
                },
                template           : '<md-dialog>' +
                '  <md-dialog-content>' +
                '<h1>'+title+'</h1><div>'+content+'</div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Close' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: ''
                },
                clickOutsideToClose: true
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store.courses')
        .controller('CoursePaikeController', CoursePaikeController);

    /** @ngInject */
    function CoursePaikeController($scope, $mdDialog, $document, $cookies, $rootScope, $location, $http, $timeout, msApi, $mdSidenav, uiCalendarConfig)
    {
        var vm = this;
        var store_id = $cookies.get('store_id');
        vm.courses = [];
        vm.events = [vm.courses];
        var d = new Date();
        vm.year = d.getFullYear();//当前所选年份
        var nowYear = d.getFullYear();//当前年份
        vm.years = [{'id':nowYear-1},{'id':nowYear},{'id':nowYear+1}];//最近三个年份
        vm.weeks =[];
        vm.week = moment().format('ww');//周
        vm.lsweek = 0;//历史所选周
        vm.mbweek = 0;//目标所选周
        vm.sourceWeeks = [];//历史周
        vm.mbWeeks = [];//目标周
        for ( var i = 1; i < 53; i++ ) {
            var newm = moment().week(i);
            var weekOfday = newm.format('E');
            var star = newm.subtract(weekOfday-1, 'days');
            //var star =newm.add(1, 'days');
            var sdate = star.format("MM-DD");
            //var end = newm.add(6, 'days');
            var end = star.add(6, 'days');
            var edate = end.format("MM-DD");
            vm.weeks.push({
                'id': i,
                'sdate':sdate,
                'edate':edate,
            })
        }

        for ( var i = vm.week-15; i < vm.week+1; i++ ) {
            var newm = moment().week(i);
            var weekOfday = newm.format('E');
            var star = newm.subtract(weekOfday-1, 'days');
            //var star =newm.add(1, 'days');
            var sdate = star.format("MM-DD");
            //var end = newm.add(6, 'days');
            var end = star.add(6, 'days');
            var edate = end.format("MM-DD");
            vm.sourceWeeks.push({
                'id': i,
                'sdate':sdate,
                'edate':edate,
            })
        }
        for ( var i = vm.week; i < vm.week+15; i++ ) {
            var newm = moment().week(i);
            var weekOfday = newm.format('E');
            var star = newm.subtract(weekOfday-1, 'days');
            //var star =newm.add(1, 'days');
            var sdate = star.format("MM-DD");
            //var end = newm.add(6, 'days');
            var end = star.add(6, 'days');
            var edate = end.format("MM-DD");
            vm.mbWeeks.push({
                'id': i,
                'sdate':sdate,
                'edate':edate,
            })
        }
        // Expose the toggle function
        vm.toggleSidenav = toggleSidenav;
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
        // Data
        var date = new Date();
        var d = date.getDate();
        var m = date.getMonth();
        var y = date.getFullYear();
        var apiName = "store.courses.list@get";
        var store_id = $cookies.get('store_id');
        vm.query = {
            store_id:store_id,
            "per-page": 1000,
            //limit:10000,
            page: 1
        }
        vm.query1 = {
            store_id:store_id,
            "per-page": 1000,
            //limit:10000,
            page: 1
        }
        vm.exists = [];//已复制的课程
        vm.doSearchCourse = doSearchCourse;
        function doSearchCourse() {
            if(vm.lsweek == 0){
                alert('请选择历史周');
                return false;
            }
            if(vm.mbweek == 0){
                alert('请选择目标周');
                return false;
            }
            var newm = moment().week(vm.lsweek);
            var weekOfday = newm.format('E');
            var star = newm.subtract(weekOfday-1, 'days');
            //var star =newm.add(1, 'days');
            var sdate = star.format("YYYY-MM-DD");
            //var end = newm.add(6, 'days');
            var end = star.add(6, 'days');
            var edate = end.format("YYYY-MM-DD");

            vm.query1.start_time = sdate;
            vm.query1.end_time = edate;
            $rootScope.loadingProgress = true;
            msApi.resolve(apiName, vm.query1).then(function(result){
                $rootScope.loadingProgress = false;
                vm.courses1 = result.data;
                if(vm.courses1){
                    vm.query2 = {
                        store_id:store_id,
                        week:vm.lsweek,
                        mb_week:vm.mbweek,
                        "per-page": 1000,
                        //limit:10000,
                        page: 1
                    }
                    msApi.resolve('store.courses.coursepaikelogs@get', vm.query2).then(function(result){
                        $rootScope.loadingProgress = false;
                        if(result.data){
                            angular.forEach(result.data, function (v, k) {
                                vm.exists[v.course_id] = v
                            })
                            angular.forEach(vm.courses1, function (v, k) {
                                if(vm.exists[v.id] && v.id == vm.exists[v.id].course_id){
                                    v.is_copy = true;
                                }else{
                                    v.is_copy = false;
                                }
                            })
                        }
                    });
                }
            });

        }
        vm.gudin = false;
        vm.linshi = false;
        vm.doCopyCourse = function () {
            if(vm.lsweek == 0){
                alert('请选择历史周');
                return false;
            }
            if(vm.mbweek == 0){
                alert('请选择目标周');
                return false;
            }
            if ( vm.selectedThreads.length > 0) {
                angular.forEach(vm.selectedThreads, function (v, k) {
                    var day = new moment(v.course_time).format('e');
                    var mbdate = moment().week(vm.mbweek);
                    var course = {
                        'store_id'          : store_id,
                        'name'              : v.name,
                        'number'            : v.number,
                        'content'           : v.content,
                        'type'              : v.type,
                        'location'          : v.location,
                        'categories_id'     : v.categories_id,
                        'course_time'       : mbdate.day(day).format("YYYY-MM-DD"),
                        'course_begintime'  : v.course_begintime,
                        'course_endtime'    : v.course_endtime,
                        'course_size'       : v.course_size,
                        'teacher_id'        : v.teacher_id,
                        'assistant_id'      : v.assistant_id,
                        'created_by'        : v.created_by,
                        'min_count'         : v.min_count,
                        'status'            : 1
                    };
                    $http({
                        method:'POST',
                        url: msApi.getApiUrl('courses'),
                        data:course
                    }).success(function(req){
                        var data = {
                            'store_id' :store_id,
                            'number':v.number,
                            'course_id':v.id,
                            'mb_course_id':req.id,
                            'week' : vm.lsweek,
                            'mb_week' : vm.mbweek,
                            'signupshu': v.signupshu,
                            'gudin' :vm.gudin,
                            'linshi':vm.linshi
                        }
                        $http({
                            method: 'POST',
                            url: msApi.getApiUrl('coursepaikelogs'),
                            data: data
                        }).success(function (req) {
                            $rootScope.message_success = '操作成功!';
                            $timeout(function(){$rootScope.message_success = '';},5000);
                        }).error(function(data, state) {
                        });

                    }).error(function(data, state) {
                        vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                        $rootScope.message_danger = vm.error_arr;
                        $timeout(function(){$rootScope.message_danger = '';},5000);
                    });
                });
            }else {
                alert('请选择复制的课程');
                return false;
            }

        }
        vm.selectedThreads = [];
        vm.currentThread = null;
        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.selectThreads = selectThreads;
        vm.deselectThreads = deselectThreads;
        vm.toggleSelectThreads = toggleSelectThreads;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;
        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread)
        {
            //if (! vm.selectedThreads) {return;}      // If
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            if ( vm.selectedThreads.indexOf(thread) > -1 )
            {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            }
            else
            {
                vm.selectedThreads.push(thread);
            }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value)
        {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for ( var i = 0; i < vm.courses1.length; i++ )
            {
                if ( angular.isUndefined(key) && angular.isUndefined(value) )
                {
                    vm.selectedThreads.push(vm.courses1[i]);
                    continue;
                }

                if ( angular.isDefined(key) && angular.isDefined(value) && vm.courses1[i][key] === value )
                {
                    vm.selectedThreads.push(vm.courses1[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function deselectThreads()
        {
            vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads()
        {

            if ( vm.selectedThreads.length > 0)
            {
                vm.deselectThreads();
            }
            else
            {
                vm.selectThreads();
            }
        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event)
        {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if ( event )
            {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if ( thread )
            {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if ( vm.currentThread )
            {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for ( var x = 0; x < vm.selectedThreads.length; x++ )
            {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event)
        {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if ( event )
            {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if ( thread )
            {
                if ( typeof(thread[key]) !== 'boolean' )
                {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if ( vm.currentThread )
            {
                if ( typeof(vm.currentThread[key]) !== 'boolean' )
                {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for ( var x = 0; x < vm.selectedThreads.length; x++ )
            {
                if ( typeof(vm.selectedThreads[x][key]) !== 'boolean' )
                {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }


        vm.calendarUiConfig = {
            calendar: {
                editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                monthNames : ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], //月份自定义命名
                monthNamesShort: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], //月份缩略命名（英语比较实用：全称January可设置缩略为Jan）
                dayNames          : ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
                dayNamesShort     : ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
                defaultView       : 'agendaWeek',
                viewRender        : function (view) {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                    vm.query.start_time = view.start.format("YYYY-MM-DD");
                    vm.query.end_time = view.end.format("YYYY-MM-DD");
                    loadEvents();//加载活动时间
                },
                eventRender: function(event, element, view) {
                    if (view.type=='month')
                        element.find('.fc-title').append(" - " + event.description);
                    else{
                        view.start = view.start.add(1, 'days');
                        view.end = view.end.add(1, 'days');
                        var appendText = "<br/>" + event.description;
                        appendText += "<br>"+event.assistant_name;
                        appendText += "<br> 报名:"+event.signup_count+"/"+event.course_size;
                        element.find('.fc-title').append(appendText);
                    }

                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M'
                },
                minTime:'09:00:00',
                maxTime:'21:00:00',
                disableResizing: true,
                eventDurationEditable: false,
                eventStartEditable: false,
                eventClick        : eventDetail,
                selectable        : true,
                selectHelper      : true,
                select            : select,
                firstDay:1,
                allDaySlot:false,
                weekNumbers:true,
                navLinks : true,
                /*firstDay:function () {
                    new Date().getDay();
                }*/
            }
        };

        // Methods
        vm.addEvent = addEvent;
        vm.next = next;
        vm.prev = prev;

        //////////

        /**
         * Go to next on current view (week, month etc.)
         */
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();
        }

        /**
         * Show event detail
         *
         * @param calendarEvent
         * @param e
         */
        function eventDetail(calendarEvent, e)
        {
            $location.path('/store/courses/detail/'+calendarEvent.id);
            //showEventDetailDialog(calendarEvent, e);

        }
        vm.doSearch = doSearch;
        function doSearch() {
            var m = moment().set('year', vm.year);
            var newm = m.week(vm.week);
            var weekOfday = newm.format('E');
            var star = newm.subtract(weekOfday-1, 'days');
            //var star =newm.add(1, 'days');

            //vm.calendarView.start = moment().add(2, 'days');
            //vm.calendarView.end = moment().add(10, 'days');
            $('#calendarView').fullCalendar( 'gotoDate', star );
        }

        /**
         * Add new event in between selected dates
         *
         * @param start
         * @param end
         * @param e
         */
        function select(start, end, e)
        {
            return;//禁用不弹出Event form, 第二版本再做这事
            showEventFormDialog('add', false, start, end, e);
        }


        /**
         * 加载固定日期的活动
         * @param start
         * @param end
         */
        function loadEvents(){
            $rootScope.loadingProgress = true;
            msApi.resolve(apiName, vm.query).then(function(result){
                $rootScope.loadingProgress = false;
                vm.courses = result.data;
                angular.forEach(vm.courses, function(v,k){
                    handleEvent(v);
                });
            });
        }

        function handleEvent(event){
            var isIn = false;
            for(var i=0;i<vm.events[0].length;i++){
                if (vm.events[0][i].id==event.id){
                    isIn = true;
                    break;
                }
            }
            if (!isIn){
                //支持safair时间
                event.start = event.start.replace(/-/g, "/");
                event.start = new Date(event.start);
                //支持safair时间
                event.end = event.end.replace(/-/g, "/");
                event.end = new Date(event.end);
                event.description = event.teacher_name;
                event.stick = true;



                //console.log(start.setTimeZone(TimeZone.getTimeZone("Asia/Shanghai")));
                //color处理
                var now = new Date();
                if (event.start < now){//过期了显示灰色
                    event.color = "#ccc";
                }else{
                    var leaveNum = event.course_size - event.signup_count;
                    if (leaveNum <= 0 ){//满
                        event.color = "#E57268";
                    }else if (leaveNum < 3){//门店紧张
                        //event.color = "#FFE168";
                        event.color = "#ff9800";
                    }

                }

                vm.events[0].push(event);
            }
        }

        function eventExist(event,events){
            var isIn = false;
            for(var i=0;i<events.length;i++){
                if (events[i].id==event.id){
                    isIn = true;
                    break;
                }
            }
            return isIn;
        }

        /**
         * Add event
         *
         * @param e
         */
        function addEvent(e)
        {
            var start = new Date(),
                end = new Date();

            showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Show event detail dialog
         * @param calendarEvent
         * @param e
         */
        function showEventDetailDialog(calendarEvent, e)
        {
            $mdDialog.show({
                controller         : 'StoreEventDetailDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/calendar/dialogs/event-detail/event-detail-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    calendarEvent      : calendarEvent,
                    showEventFormDialog: showEventFormDialog,
                    event              : e
                }
            });
        }

        /**
         * Show event add/edit form dialog
         *
         * @param type
         * @param calendarEvent
         * @param start
         * @param end
         * @param e
         */
        function showEventFormDialog(type, calendarEvent, start, end, e)
        {
            var dialogData = {
                type         : type,
                calendarEvent: calendarEvent,
                start        : start,
                end          : end
            };

            $mdDialog.show({
                controller         : 'StoreEventFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/calendar/dialogs/event-form/event-form-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    dialogData: dialogData
                }
            }).then(function (response)
            {
                switch ( response.type )
                {
                    case 'add':
                        // Add new
                        vm.events[0].push({
                            id   : vm.events[0].length + 20,
                            title: response.calendarEvent.title,
                            start: response.calendarEvent.start,
                            end  : response.calendarEvent.end
                        });
                        break;

                    case 'edit':
                        // Edit
                        for ( var i = 0; i < vm.events[0].length; i++ )
                        {
                            // Update
                            if ( vm.events[0][i].id === response.calendarEvent.id )
                            {
                                vm.events[0][i] = {
                                    title: response.calendarEvent.title,
                                    start: response.calendarEvent.start,
                                    end  : response.calendarEvent.end
                                };

                                break;
                            }
                        }
                        break;

                    case 'remove':
                        // Remove
                        for ( var j = 0; j < vm.events[0].length; j++ )
                        {
                            // Update
                            if ( vm.events[0][j].id === response.calendarEvent.id )
                            {
                                vm.events[0].splice(j, 1);

                                break;
                            }
                        }
                        break;
                }
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store.courses')
        .controller('CourseJiakeController', CourseJiakeController);

    /** @ngInject */
    function CourseJiakeController($filter,$scope, $mdDialog, $document, $cookies, $rootScope, $location, $http, $timeout, msApi, $mdSidenav, uiCalendarConfig)
    {
        var store_id = $cookies.get('store_id');
        var auth_key = $cookies.get('auth_key');
        var vm = this;
        vm.res = [];
        vm.events = [vm.res];
        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00') return new Date(str);
        }
        vm.list = [];//加课项
        vm.curr_course = {};//当前选中的课程

        // Data
        var date = new Date();
        var d = date.getDate();
        var m = date.getMonth()+1;
        var y = date.getFullYear();
        var arr = [];
        arr.push({y :y,m:m});
        var min = 0;
        var max = 5;
        for (var i= min; i < max; i++) {
            var year = arr[i].y;
            var month = arr[i].m;
            if(arr[i].m === 12){
                year = arr[i].y + 1;
                month = 1;
            }else{
                month = arr[i].m + 1;
            }
            arr.push({y:year,m:month});
        }
        var apiName = "store.calendar.courses@get";
        vm.query = {
            store_id:store_id,
            "per-page": 1000,
            //limit:10000,
            page: 1
        }

        vm.calendarUiConfig = {
            calendar: {
                editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                monthNames : ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], //月份自定义命名
                monthNamesShort: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], //月份缩略命名（英语比较实用：全称January可设置缩略为Jan）
                dayNames          : ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
                dayNamesShort     : ['日', '一', '二', '三', '四', '五', '六'],
                viewRender        : function (view) {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                },
                eventRender: function(event, element, view) {
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M'
                },
                selectable        : true,
                selectHelper      : true,
                select            : select,
                firstDay:1,
                allDaySlot:false,
                disableResizing: true,
                eventDurationEditable: false,
                eventStartEditable: false,
            }
        };
        vm.calendarUiConfig1 = {
            calendar: {
                editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                monthNames : ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], //月份自定义命名
                monthNamesShort: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], //月份缩略命名（英语比较实用：全称January可设置缩略为Jan）
                dayNames          : ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
                dayNamesShort     : ['日', '一', '二', '三', '四', '五', '六'],
                defaultDate:arr[1].y+ '-' + arr[1].m + '-10',
                viewRender        : function (view) {
                    vm.calendarView1 = view;
                    vm.calendar1 = vm.calendarView1.calendar;
                    vm.currentMonthShort1 = vm.calendar1.getDate().format('MMM');
                },
                eventRender: function(event, element, view) {
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M'
                },
                selectable        : true,
                selectHelper      : true,
                select            : select,
                firstDay:1,
                allDaySlot:false,
                disableResizing: true,
                eventDurationEditable: false,
                eventStartEditable: false,
            }
        };
        vm.calendarUiConfig2 = {
            calendar: {
                editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                monthNames : ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], //月份自定义命名
                monthNamesShort: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], //月份缩略命名（英语比较实用：全称January可设置缩略为Jan）
                dayNames          : ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
                dayNamesShort     : ['日', '一', '二', '三', '四', '五', '六'],
                defaultDate:arr[2].y+ '-' + arr[2].m + '-' + d,
                viewRender        : function (view) {
                    vm.calendarView2 = view;
                    vm.calendar2 = vm.calendarView2.calendar;
                    vm.currentMonthShort2 = vm.calendar2.getDate().format('MMM');
                },
                eventRender: function(event, element, view) {
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M'
                },
                selectable        : true,
                selectHelper      : true,
                select            : select,
                firstDay:1,
                allDaySlot:false,
                disableResizing: true,
                eventDurationEditable: false,
                eventStartEditable: false,
            }
        };
        vm.calendarUiConfig3 = {
            calendar: {
                editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                monthNames : ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], //月份自定义命名
                monthNamesShort: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], //月份缩略命名（英语比较实用：全称January可设置缩略为Jan）
                dayNames          : ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
                dayNamesShort     : ['日', '一', '二', '三', '四', '五', '六'],
                defaultDate:arr[3].y+ '-' + arr[3].m + '-' + d,
                viewRender        : function (view) {
                    vm.calendarView3 = view;
                    vm.calendar3 = vm.calendarView3.calendar;
                    vm.currentMonthShort3 = vm.calendar3.getDate().format('MMM');
                },
                eventRender: function(event, element, view) {
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M'
                },
                selectable        : true,
                selectHelper      : true,
                select            : select,
                firstDay:1,
                allDaySlot:false,
                disableResizing: true,
                eventDurationEditable: false,
                eventStartEditable: false,
            }
        };
        vm.calendarUiConfig4 = {
            calendar: {
                editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                monthNames : ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], //月份自定义命名
                monthNamesShort: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], //月份缩略命名（英语比较实用：全称January可设置缩略为Jan）
                dayNames          : ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
                dayNamesShort     : ['日', '一', '二', '三', '四', '五', '六'],
                defaultDate:arr[4].y+ '-' + arr[4].m + '-' + d,
                viewRender        : function (view) {
                    vm.calendarView4 = view;
                    vm.calendar4 = vm.calendarView4.calendar;
                    vm.currentMonthShort4 = vm.calendar4.getDate().format('MMM');
                },
                eventRender: function(event, element, view) {
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M'
                },
                selectable        : true,
                selectHelper      : true,
                select            : select,
                firstDay:1,
                allDaySlot:false,
                disableResizing: true,
                eventDurationEditable: false,
                eventStartEditable: false,
            }
        };
        vm.calendarUiConfig5 = {
            calendar: {
                editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                monthNames : ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], //月份自定义命名
                monthNamesShort: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], //月份缩略命名（英语比较实用：全称January可设置缩略为Jan）
                dayNames          : ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
                dayNamesShort     : ['日', '一', '二', '三', '四', '五', '六'],
                defaultDate:arr[5].y+ '-' + arr[5].m + '-' + d,
                viewRender        : function (view) {
                    vm.calendarView5 = view;
                    vm.calendar5 = vm.calendarView5.calendar;
                    vm.currentMonthShort5 = vm.calendar5.getDate().format('MMM');
                },
                eventRender: function(event, element, view) {
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M'
                },
                selectable        : true,
                selectHelper      : true,
                select            : select,
                firstDay:1,
                allDaySlot:false,
                disableResizing: true,
                eventDurationEditable: false,
                eventStartEditable: false,
            }
        };
        msApi.request("store.courses.categories@get", {'store_id':store_id, 'act': 'course_time_arr'}).then(//课程开始时间
            function (response){
                vm.course_time_arr = response.data;
            });
        msApi.request("store.courses.users@get", {'store_id':store_id, 'role_id': 3}).then(//教练
            function (response){
                vm.teachers = response.data;
                //console.log(response.data);
            });
        msApi.request("store.courses.rooms@get", {'store_id':store_id}).then(//教练
            function (response){
                vm.rooms = response.data;
            });
        msApi.request("store.courses.users@get", {'store_id':store_id, 'role_id': 6}).then(//助教
            function (response){
                vm.assistants = response.data;
            });
        /**
         * @param start
         * @param end
         */
        function loadEvents(){
            $rootScope.loadingProgress = true;
        }
        /**
         * Add new event in between selected dates
         *
         * @param start
         * @param end
         * @param e
         */
        vm.all_time = '';
        vm.all_kshi = 1;
        vm.all_room = '';
        vm.all_teacher = '';
        vm.all_zhuj = '';
        vm.selTime = selTime;
        function selTime() {
            if(vm.list.length > 0) {
                angular.forEach(vm.list, function (item, k) {
                    item.time = vm.all_time;
                });
            }
        }
        vm.selKshi = selKshi;
        function selKshi() {
            if(vm.list.length > 0) {
                angular.forEach(vm.list, function (item, k) {
                    item.kshi = vm.all_kshi;
                });
            }
        }
        vm.selRoom = selRoom;
        function selRoom() {
            if(vm.list.length > 0) {
                angular.forEach(vm.list, function (item, k) {
                    item.room = vm.all_room;
                });
            }
        }
        vm.selTeacher = selTeacher;
        function selTeacher() {
            if(vm.list.length > 0) {
                angular.forEach(vm.list, function (item, k) {
                    item.teacher = vm.all_teacher;
                });
            }
        }
        vm.selZhuj = selZhuj;
        function selZhuj() {
            if(vm.list.length > 0) {
                angular.forEach(vm.list, function (item, k) {
                    item.zhuj = vm.all_zhuj;
                });
            }
        }
        vm.i=0;
        function select(start, end, e) {
            var date = start.format("YYYY-MM-DD");
            var isflag = true;
            if(vm.list.length > 0) {
                angular.forEach(vm.list, function (v, k) {
                    if (v.date1 === date) {
                        vm.list.splice(vm.list.indexOf(v), 1);
                        isflag = false;
                    }
                });
            }
            if(isflag){
                var obj = {
                    date:vm.StrToDate(date),
                    date1:date,
                    time:'',
                    kshi:1,
                    room:0,
                    teacher:0,
                    zhuj:0,
                    time_error:0,
                    room_error:0,
                    teacher_error:0,
                    zhuj_errorr:0,
                };
                vm.list.push(obj);
            }
        }
        //上课时间按时区转换
        vm.changeDate = function (item) {
            item.timezone = '';
            angular.forEach(vm.teachers, function(v,k){
                if(item.teacher === v.id){
                    item.timezone = v.timezone;
                }
            });
            if(item.time !== '' && item.teacher > 0){
                var str = item.time.split('~');
                item.zeno_time = (moment(item.date1+' '+str[0]).zone("America/Los_Angeles")).utc().format('YYYY-MM-DD HH:mm');
                item.zeno_time = item.zeno_time + '~'+(moment(item.date1+' '+str[1]).zone("America/Los_Angeles")).utc().format('HH:mm');
            }
        }
        vm.numChange = numChange;
        function numChange() {
            if(vm.curr_course.number === '' || vm.curr_course.number === null || !("number" in vm.curr_course)) {
                vm.curr_course = {};
            }
        }
        vm.addItem = addItem;
        function addItem() {
            var obj = {
                date:'',
                time:'',
                kshi:1,
                room:0,
                teacher:0,
                zhuj:0,
                time_error:0,
                room_error:0,
                teacher_error:0,
                zhuj_errorr:0,
            };
            vm.list.push(obj);
        }
        vm.removeItem = removeItem;
        function removeItem(item) {
            vm.list.splice(vm.list.indexOf(item), 1);
        }
        vm.saveCourse = saveCourse;
        function saveCourse() {
            $('#sub-btn').hide();
            vm.loadingThreads = true;
            if(vm.list.length > 0) {
                angular.forEach(vm.list, function (item, k) {
                    //item.date1 = (item.date).toISOString().slice(0, 10);
                    item.date1 = $filter("date")(new Date(item.date), "yyyy-MM-dd");
                });

                var url = msApi.getApiUrl('courses/jiake'),
                    data = {
                        store_id: store_id,
                        name: vm.curr_course.name,
                        number: vm.curr_course.number,
                        content: vm.curr_course.content,
                        type: vm.curr_course.type,
                        categories_id: vm.curr_course.categories_id,
                        signupshu: vm.curr_course.signupshu,
                        list: vm.list
                    },
                    transFn = function (data) {
                        return $.param(data);
                    },
                    config = {
                        headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
                        transformRequest: transFn
                    };
                $http.post(url, data, config).success(function (data, status, headers, config) {
                    //$rootScope.message_success = '操作成功!';
                    $('#sub-btn').show();
                    vm.loadingThreads = false;
                    vm.list = [];
                    vm.curr_course = null;
                    //$timeout(function(){$rootScope.message_success = '';},5000);
                }).error(function (data, state) {
                    $('#sub-btn').show();
                    vm.loadingThreads = false;
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function () {
                        $rootScope.message_danger = '';
                    }, 5000);
                });
            }else {
                $timeout(function () {
                    $('#sub-btn').show();
                    vm.loadingThreads = false;
                }, 2000);

            }
        }
        vm.check = check;
        function check() {
            if(vm.list.length > 0) {
                angular.forEach(vm.list, function(item,k){
                    //item.date1 = (item.date).toISOString().slice(0,10);
                    item.date1 = $filter("date")(new Date(item.date), "yyyy-MM-dd");
                });
                console.log(vm.list);
                var url = msApi.getApiUrl('courses/checkct'),
                    data = {
                        store_id: store_id,
                        list: vm.list,
                        edate :vm.list[0].date
                    },
                    transFn = function (data) {
                        return $.param(data);
                    },
                    config = {
                        headers: {'Content-Type': 'application/x-www-form-urlencoded;charset=UTF-8'},
                        transformRequest: transFn
                    };
                $http.post(url, data, config).success(function (data, status, headers, config) {
                    $rootScope.message_success = '操作成功!';
                    angular.forEach(data, function(v,k){
                        vm.list[k].time_error = v.time_error;
                        vm.list[k].room_error = v.room_error;
                        vm.list[k].teacher_error = v.teacher_error;
                        vm.list[k].zhuj_errorr = v.zhuj_errorr;
                    });
                    $timeout(function () {
                        $rootScope.message_success = '';
                    }, 5000);
                }).error(function (data, state) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function () {
                        $rootScope.message_danger = '';
                    }, 5000);
                });
            }
        }
        vm.selectCourse = selectCourse;
        function selectCourse(course) {
            vm.curr_course = course;
            console.log(vm.curr_course);
        }
        vm.courses = [];
        // Expose the toggle function
        vm.toggleSidenav = toggleSidenav;
        //所有固定课程
        function toggleSidenav(sidenavId)
        {
            vm.query = {
                store_id:store_id,
                "per-page": 1000,
                'act': 'gudin',
                //limit:10000,
                //'number':vm.course.number,
                page: 1
            }
            //固定课程
            msApi.request('store.courses.list@get', vm.query).then(
                function (response) {
                    $rootScope.loadingProgress = false;
                    vm.courses = response.data;
                });
            $mdSidenav(sidenavId).toggle();
        }
        //固定课程搜索
        function toggleSidenavSearch(sidenavId)
        {
            vm.query = {
                store_id:store_id,
                "per-page": 1000,
                'act': 'gudin',
                //limit:10000,
                //'number':vm.course.number,
                page: 1
            }
            //固定课程
            msApi.request('store.courses.list@get', vm.query).then(
                function (response) {
                    $rootScope.loadingProgress = false;
                    vm.courses = response.data;
                });
            $mdSidenav(sidenavId).toggle();
        }

    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store.courses')
        .controller('CourseExperienceController', CourseExperienceController)
        .controller('CourseSignupController', CourseSignupController);

    /** @ngInject */
    function CourseExperienceController($filter, $rootScope, $timeout, $http, $q, msApi, $mdDialog, $document,$cookies)
    {
        var store_id = $cookies.get('store_id');
        var vm = this;
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        vm.is_cud = false;//是否可以增改
        vm.is_del = false;//是否可以删除
        vm.is_export = false;//是否有导出权限
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_task_cud' || v == 'admin_task'){
                vm.is_cud = true;
            }
            if( v == 'admin_task_export' || v == 'admin_task'){
                vm.is_export = true;
            }
            if( v == 'admin_task_del' || v == 'admin_task'){
                vm.is_del = true;
            }
        });
        // Data
        //vm.experiences = Experiences;
        vm.exportExperiences = exportExperiences;

        /*vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };*/
        vm.query = {
            status:'',
            is_member:'',
            task_status:'',
            parent:'',
            source:'',
            remarks:'',
            mobile:'',
            store_id: store_id,
            name:'',
            consult_id: '',
            sdate: '',
            edate: '',
            sort: '-id',
            limit: 20,
            page: 1
        };
        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00') return new Date(str);
        }
        init();
        vm.updateRemarks = updateRemarks;   //备注
        vm.updateSource = updateSource;     //来源
        vm.updateConsult = updateConsult;   //销售顾问
        vm.updateAmount = updateAmount;     //支付金额
        vm.updatePayType = updatePayType;   //支付方式
        vm.doSearch = doSearch;             //搜索
        function doSearch(){
            msApi.resolve('store.courses.experiences@get', vm.query).then(function(experiences){vm.experiences = experiences});
        }
        function init(){
            vm.loadingThreads = true;
            var now_date = moment(new Date()).utc().format('YYYY-MM-DD');
            //vm.query.sdate = now_date;
            //vm.query.edate = now_date;
            // Figure out the api name
            msApi.request('store.courses.experiences@get', vm.query).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.experiences = response;
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
        // 预约状态
        msApi.request('store.courses.signups@get', {'act': 'status'}).then(
            function (response) {
                vm.signup_status = response.data;
                vm.signup_status.push({'id':'','text':'约课状态'});
            }
        );
        vm.status_arr = [{'id':'','text':'安排状态'},{'id':'0','text':'未安排'},{'id':'1','text':'已安排'}];
        vm.yonghu_arr = [{'id':'','text':'是否为会员'},{'id':'0','text':'否'},{'id':'1','text':'是'}];
        vm.openExperienceDialog = openExperienceDialog;
        function openExperienceDialog(ev, experience)
        {
            $mdDialog.show({
                controller         : 'ExperienceDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/courses/dialogs/experience/experience-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Experience : experience,
                    Experiences: vm.experiences,
                    is_cud : vm.is_cud,
                    is_del : vm.is_del,
                    consults:vm.consults,
                    pay_types:vm.pay_types,
                    event: ev
                }
            });
        }
        //来源
        function updateSource(id, source){
            var data = {'source':source};
            $http({
                method:'PUT',
                url: msApi.getApiUrl('tasks/' +id),
                data:data
            }).success(function(req){
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
            });
        }
        //备注
        function updateRemarks(id, remarks){
            var data = {'remarks':remarks};
            $http({
                method:'PUT',
                url: msApi.getApiUrl('tasks/' +id),
                data:data
            }).success(function(req){
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
            });
        }
        //销售顾问
        function updateConsult(id, consult_id){
            var data = {'consult_id':consult_id};
            $http({
                method:'PUT',
                url: msApi.getApiUrl('tasks/' +id),
                data:data
            }).success(function(req){
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
            });
        }
        //支付金额
        function updateAmount(id, amount){
            var data = {'amount':amount};
            $http({
                method:'PUT',
                url: msApi.getApiUrl('tasks/' +id),
                data:data
            }).success(function(req){
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
            });
        }
        //支付方式
        function updatePayType(id, pay_type){
            var data = {'pay_type':pay_type};
            $http({
                method:'PUT',
                url: msApi.getApiUrl('tasks/' +id),
                data:data
            }).success(function(req){
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
            });
        }
        function exportExperiences() {
            /*var sdate = vm.query.sdate == '' ? '' : (vm.query.sdate).toISOString().slice(0,10);
            var edate = vm.query.edate == '' ? '' : (vm.query.edate).toISOString().slice(0,10);*/
            var edate = vm.query.sdate == '' ? '' :  $filter("date")(new Date(vm.query.sdate), "yyyy-MM-dd");
            var edate = vm.query.edate == '' ? '' :  $filter("date")(new Date(vm.query.edate), "yyyy-MM-dd");
            var consult_id = vm.query.hasOwnProperty('consult_id') ? vm.query.consult_id : 0 ;
            window.open(msApi.getApiUrl('tasks/export') + '&is_member='+vm.query.is_member+'&store_id=' + store_id+ '&name=' + vm.query.name+ '&mobile=' + vm.query.mobile+ '&parent=' + vm.query.parent+ '&source=' + vm.query.source+ '&status=' + vm.query.status+ '&task_status=' + vm.query.task_status+'&sdate='+sdate+'&edate='+edate+'&consult_id='+vm.query.consult_id);
        }
        //msApi.request('store.courses.users@get', {'store_id': store_id, 'role_id': 5}).then(
        msApi.request('store.courses.users@get', {'store_id': store_id,'status' : 10, 'per-page': 200}).then(
            function (response) {
                vm.consults = response.data;
                vm.users = response.data;
                vm.users.push({'id':'','name':'销售顾问'});
        });
        // 支付类型
        msApi.request('store.contracts.categories@get', {'type': '5'}).then(
            function (response) {
                vm.pay_types = response.data;
            });
    }
    function CourseSignupController($rootScope, $timeout, $stateParams, msApi, $http, $location, $cookies, Experiences){
        var store_id = $cookies.get('store_id');
        var vm = this;
        /*vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };*/
        vm.StrToDate = function (str) { if (str && str != '0000-00-00') return new Date(str); }
        vm.query = {
            name:'',
            store_id: store_id,
            sort: '-course_time',
            limit: 20,
            page: 1,
            not_start: 1,
            status: 1,
            sdate: '',
            edate: ''
        };
        init();
        vm.doSearch = doSearch;
        function doSearch(){
            msApi.resolve('store.courses.list@get', vm.query).then(function(courses){vm.courses = courses});
        }
        function init(){
            var now_date = moment(new Date()).utc().format('YYYY-MM-DD');
            vm.query.sdate = now_date;
            vm.query.edate = now_date;

            msApi.request('store.courses.list@get', vm.query).then(
                function (response){
                    vm.courses = response;
                });
        }
        msApi.request('store.courses.experiences@get', {'id': $stateParams.task_id}).then(
            function (response){
                vm.experience = response.data[0];
                if(vm.experience.customer_id){
                    msApi.request('store.courses.customer@get', {'id': vm.experience.customer_id}).then(
                        function (response){
                            vm.customer = response.data[0];
                        });
                }
            });

        //预约
        vm.signup = signup;
        function signup(ev , course){
            var data = {};
            data.courses_id = course.id;
            data.customer_id = vm.experience.customer_id || 0;
            data.task_id = vm.experience.id;
            data.status = 0;
            data.courses_name = course.name;
            data.store_id = course.store_id;
            data.from_store_id = 0;
            if(vm.experience.customer_id){
                data.from_store_id = vm.customer.store_id;
            }

            //console.log(typeof angular.toJson(data));
            $http({
                method:'POST',
                url: msApi.getApiUrl('signups'),
                data:data
            }).success(function(req){
                for ( var i = 0; i < Experiences.data.length; i++ )
                {
                    vm.experience.courses_name = course.name;
                    if ( Experiences.data[i].id === vm.experience.id )
                    {
                        Experiences.data[i] = angular.copy(vm.experience);
                        break;
                    }
                }
                $location.path('/store/courses/experiences');
                //vm.courses.unshift(vm.course);

            }).error(function(data,status){
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
                $location.path('/store/courses/experiences');
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store.courses')
        .controller('CourseDetailController', CourseDetailController)
        .controller('CoursesController', CoursesController);

    /** @ngInject */
    function CoursesController($filter, $rootScope, $timeout, $scope, $http, $q , msApi, $mdDialog, $document, $cookies, Store, $window)
    {
        var store_id = $cookies.get('store_id');
        var vm = this;
        vm.cols = {
            plan:true,
            date:true,
            time:true,
            teacherDate:false,
            teacherTime:false,
            name:true,
            room:true,
            category:true,
            type:true,
            student:true,
            book:false,
            teacher:true,
            number:false,
            status:true,
            updated:false,
            action:true
        }
        vm.courseStatus = [
            {status:'',name:'所有'},
            {status:1,name:'正常开课'},
            {status:10,name:'已结束'},
        ];
        vm.is_cud = false;//是否可以增删改
        vm.isShowTeacherTime = false;//是否显示老师时间
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_courses_cud' || v == 'admin_courses'){
                vm.is_cud = true;
            }
        });
        msApi.request("store.courses.users@get", {'store_id':store_id, 'role_id': 3, 'per-page': 200,'sort':'name'}).then(//老师
            function (response){
                vm.teachers = response.data;
                //console.log(response.data);
            });

        msApi.request("store.courses.categories@get", {'store_id':store_id, type: 1, 'per-page': 200}).then(//课程类型
            function (response){
                vm.categories = response.data;
            });

        msApi.request("store.courses.categories@get", {'store_id':store_id, type: 2, 'per-page': 200}).then(//课程级别
            function (response){
                vm.jibei_types = response.data;
            });
        //vm.courses = Courses;
        vm.store =Store
        vm.selectedFiles = '';
        vm.customesall = [];
        // pager
        vm.query = {
            name:'',
            sdate:'',
            edate:'',
            store_id: store_id,
            sort: '-course_time',
            limit: 20,
            page: 1
        };
        vm.StrToDate = function (str) {
            if (str && str != '0000-00-00') return new Date(str);
        }
        init();
        vm.openCourseDialog = openCourseDialog;
        vm.doSearch = doSearch;
        vm.selectStudentChanged = selectStudentChanged;
        vm.searchStudentTextChange = searchStudentTextChange;
        vm.timeTypeChanged = timeTypeChanged;
        function timeTypeChanged(){
            if (vm.isShowTeacherTime){
                vm.cols.date = false;
                vm.cols.time = false;
                vm.cols.teacherDate = true;
                vm.cols.teacherTime = true;
            }else{
                vm.cols.date = true;
                vm.cols.time = true;
                vm.cols.teacherDate = false;
                vm.cols.teacherTime = false;
            }
        }
        function doSearch(){
            
            $rootScope.loadingProgress = true;
            msApi.resolve('store.courses.list@get', vm.query).then(function(courses){vm.courses = courses;$rootScope.loadingProgress = false;});
        }
        function init(){
            vm.loadingThreads = true;
            var now_date = moment(new Date()).utc().format('YYYY-MM-DD');
            vm.query.sdate = now_date;
            vm.query.edate = now_date;
            // Figure out the api name
            msApi.request('store.courses.list@get', vm.query).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.courses = response;
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
        function selectStudentChanged(item){
            vm.query.student = item.value;
            vm.doSearch();
        }
        // 搜索学生
        function searchStudentTextChange(text) {
            if(text){
                $http.get(msApi.getApiUrl('customers'), {params: {'store_id':store_id, 'keyword':text, 'act': 'searched'}}).success(function (results) {
                    vm.customers = results.data;
                    vm.customesall = loadAll(text);
                    $('#customer-auto').find('input[type="search"]').focus();
                    return vm.customesall;
                });
            }else {
                vm.query.student = "";
                vm.doSearch();
                vm.customesall = [];
                return vm.customesall;
            }
        }
        function loadAll(search) {
            var allStates = '';
            var customersall = [];
            angular.forEach(vm.customers, function (v, k) {
                var text = search;
                if (v.name.indexOf(search)!=-1) text = v.name;
                if (v.nickname.indexOf(search)!=-1) text = v.nickname;
                customersall.push({
                    value:text,
                    display:v.nickname+ "("+v.name+")"
                });
            });
            return customersall;
        }
        function openCourseDialog(ev, course)
        {
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'CourseDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/courses/dialogs/course/course-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Course : course,
                    Courses: vm.courses,
                    Store: vm.store,
                    is_cud: vm.is_cud,
                    event: ev
                }
            });
        }
        vm.openTiaokDialog = openTiaokDialog;
        function openTiaokDialog(ev, course)
        {
            console.log(111);
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'TiaokDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/courses/dialogs/tiaok/tiaok-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Course : course,
                    Courses: vm.courses,
                    Store: vm.store,
                    is_cud: vm.is_cud,
                    event: ev
                }
            });
        }
        vm.upload = upload;
        var fileList;
        function upload($files) {
            // console.log($files);
            var fd = new FormData();
            //Take the first selected file
            fd.append("file", $files[0]);

            $http.post(msApi.getApiUrl('courses/import'), fd, {
                withCredentials: true,
                headers: {'Content-Type': undefined },
                transformRequest: angular.identity
            }).success(function(response){
                doSearch();
                $("input[type='file']").val('');//清除input box 的选择
                if(response.code == 2){
                    //vm.error_arr = response.msg;
                    alert(response.msg);
                }else if(response.code == 0){
                    $rootScope.message_success = '操作成功!';
                }else{
                    vm.error_arr = response.msg ? response.msg : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function(){$rootScope.message_danger = '';},5000);
                }
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });

            return;

            if($files !== null && $files.length > 0) {
                fileList = $files;

                uploadStarted();
                //console.log(fileList);
                // read excel file >>
                var files = fileList;
                var i,f;
                for (i = 0, f = files[i]; i != files.length; ++i) {
                    var reader = new FileReader();
                    var name = f.name;
                    console.log(reader);
                    reader.onload = function(e) {
                        var data = e.target.result;
                        console.log(e);
                        var workbook = XLSX.read(data, {type: 'binary'});
                        //console.log(workbook);
                        var result = [];
                        workbook.SheetNames.forEach(function(sheetName) {
                            var roa = XLSX.utils.sheet_to_row_object_array(workbook.Sheets[sheetName]);
                            if(roa.length > 0){
                                //result[sheetName] = roa;
                                result.push(roa);
                            }
                            // save data to model
                        });
                        // save data to model
                        //console.log(result);
                        var boxAll = [];
                        result.forEach(function(data1){
                            data1.forEach(function(data){
                                //console.log(data);
                                var course = {};
                                course['name']      = data['课程名称'];
                                course['store']           = data['门店'];
                                course['category'] = data['课程类型'];
                                course['type']     = data['课程级别'];
                                course['location']         = data['上课地址'];
                                course['course_time']   = data['上课日期'];
                                course['course_begintime']     = data['上课开始时间'];
                                course['course_endtime']     = data['上课结束时间'];
                                course['course_size']     = data['预招人数'];
                                course['teacher']     = data['主老师'];
                                course['assistant']     = data['助理'];
                                course['act']     = 'import';
                                $http({
                                    method:'POST',
                                    url: msApi.getApiUrl('courses'),
                                    data:course
                                }).success(function(req){

                                })
                                //boxAll.push(box);
                            });
                        });
                        // invoke service save all data
                        //Boxs.saveAll(boxAll);
                    };
                    //reader.readAsBinaryString(f);
                }
                // read excel file <<

                //$timeout(uploadComplete, 4000);
            }
        }
        function uploadStarted() {
            vm.status = 'uploading';
        }
        vm.exportCourses = exportCourses;
        function exportCourses(ev){
            /*var sdate = vm.query.sdate == '' ? '' : (vm.query.sdate).toISOString().slice(0,10);
            var edate = vm.query.edate == '' ? '' : (vm.query.edate).toISOString().slice(0,10);*/
            var sdate = vm.query.sdate == '' ? '' : $filter("date")(new Date(vm.query.sdate), "yyyy-MM-dd");
            var edate = vm.query.edate == '' ? '' : $filter("date")(new Date(vm.query.edate), "yyyy-MM-dd");
            console.log(msApi.getApiUrl('courses/export')+'&sdate='+sdate+'&edate='+edate+'&store_id='+store_id+
            '&name='+vm.query.name+'&categories_id='+vm.query.categories_id+'&type='+vm.query.type+
            '&teacher_id='+vm.query.teacher_id+'&number='+vm.query.number+'&student='+vm.query.student);
            window.open(msApi.getApiUrl('courses/export')+'&sdate='+sdate+'&edate='+edate+'&store_id='+store_id+
                '&name='+vm.query.name+'&categories_id='+vm.query.categories_id+'&type='+vm.query.type+
                '&teacher_id='+vm.query.teacher_id+'&number='+vm.query.number+'&student='+vm.query.student);
        }
    }
    function CourseDetailController($rootScope, $timeout, $stateParams, $http, $mdDialog, $document, msApi, $cookies,Store,Course) {
        var vm = this;
        var store_id = $cookies.get('store_id');
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        vm.is_cud = false;//是否可以增删改
        vm.is_signup = false;//是否可以批课
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_courses_cud' || v == 'admin_courses'){
                vm.is_cud = true;
            }
            if( v == 'admin_signup_cud' || v == 'admin_signup'){
                vm.is_signup = true;
            }
        });
        vm.course = Course;
        init();
        //  课程
        /*msApi.request('store.courses.list@get', {'id': $stateParams.id}).then(
            function (response){
                if(response.data.length > 0) {
                    vm.course = response.data[0];
                }
            });*/
        function init(){
            vm.loadingThreads = true;
            // Figure out the api name
            msApi.request('store.courses.list@get').then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.courses = response;
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
        msApi.request('store.courses.signups@get', {'courses_id': $stateParams.id,'store_id': store_id,'sort':'-status'}).then(
            function (response){
                    var data = response.data;
                    var statusWeight = [0,10,50,60,30,50,20];
                    data.sort(function(a,b){
                        var aW = statusWeight[a.status];
                        var bW = statusWeight[b.status];
                        return aW -  bW;
                    });
                    vm.signups = data;
            });
        //修改记录
        msApi.request('store.courses.courseslogs@get', {'courses_id': $stateParams.id}).then(
            function (response){
                vm.coursesLogs = response.data;
            });
        // 预约状态
        msApi.request('store.courses.signups@get', {'act': 'status'}).then(
            function (response) {
                vm.signup_status = response.data;
            });

        //更新状态
        vm.updateStatus = updateStatus;
        function updateStatus(signup, status){
            var confirm = $mdDialog.confirm()
                .title('确认操作?')
                .content('确认要执行这个操作吗.')
                .ariaLabel('修改状态')
                .ok('确定')
                .cancel('取消');
                //.targetEvent(event);
            $mdDialog.show(confirm).then(function (){
                var data = {'status' : status}
                $http({
                    method:'PUT',
                    url: msApi.getApiUrl('signups/' +signup.id),
                    data:data
                }).success(function(req){
                    $rootScope.message_success = '操作成功!';
                    $timeout(function(){$rootScope.message_success = '';},5000);
                    var status_text = '', status_class = '';
                    angular.forEach(vm.signup_status, function (v, k) {
                        if (v.id == status) {
                            status_text  = v.text;
                            status_class = v.class;
                        }
                    });
                    signup.status_class = status_class;
                    signup.status_text  = status_text;
                    signup.status       = status;
                    // Dummy save action
                    for ( var i = 0; i < vm.signups.length; i++ )
                    {
                        if ( vm.signups[i].id === data.id )
                        {
                            vm.signups[i] = angular.copy(signup);
                            break;
                        }
                    }
                }).error(function(data, state) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function(){$rootScope.message_danger = '';},5000);
                });
            }, function (){
            // Cancel Action
            });
            //closeDialog();
        }
        function closeDialog()
        {
            $mdDialog.hide();
        }
        vm.openCourseDialog = openCourseDialog;
        vm.store =Store;
        function openCourseDialog(ev, course)
        {
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'CourseDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/courses/dialogs/course/course-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Course : Course,
                    Courses: vm.courses,
                    Store: vm.store,
                    is_cud: vm.is_cud,
                    event: ev
                }
            });
        }
        vm.signuploglist = function(ev, signup){
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'LogsDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/signups/dialogs/logs/logs-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Signup : signup,
                    event: ev
                }
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store.courses')
        .controller('CourseCategoryController', CourseCategoryController);

    /** @ngInject */
    function CourseCategoryController($rootScope, $timeout, $http, $q, msApi, $mdDialog, $document, $cookies)
    {
        var vm = this;
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        vm.is_cud = false;//是否可以增删改
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_courses_categories_cud' || v == 'admin_courses_categories' || v == 'admin_courses'){
                vm.is_cud = true;
            }
        });
        // Data
        //vm.categories = Categories;
        /*vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };*/
        var store_id = $cookies.get('store_id');
        init();
        vm.role_id = $cookies.get('role_id');
        vm.query = {
            name:'',
            store_id: store_id,
            type:1,
            sort: '-id',
            limit: 20,
            page: 1
        };
        vm.doSearch = doSearch;
        function doSearch(){
            msApi.resolve('store.courses.categories@get', vm.query).then(function(categories){vm.categories = categories});
        }
        function init(){
            vm.loadingThreads = true;
            // Figure out the api name
            msApi.request('store.courses.categories@get', {'type':1,'store_id':store_id}).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.categories = response;
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
        vm.openCategorieDialog = openCategorieDialog;
        function openCategorieDialog(ev, categorie)
        {
            $mdDialog.show({
                controller         : 'CategoryDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/courses/dialogs/category/category-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Categorie : categorie,
                    Categories: vm.categories,
                    is_cud: vm.is_cud,
                    event: ev
                }
            });
        }
        vm.checkEdit = checkEdit;
        function checkEdit(storeId){
            var is_flag = true;
            if(storeId == 0 && vm.role_id != 1){
                is_flag = false;
            }
            return is_flag;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store', ['app.store.calendar','app.store.plans','app.store.courses','app.store.contracts','app.store.customers','app.store.teachers','app.store.users','app.store.reports','app.store.signups','app.store.system'])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        var store_id = msApiProvider.getCookies('store_id');
        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/apps/store');

        // Api
        msApiProvider.register('store.dashboard1', ['app/data/dashboard/project/data.json']);
        msApiProvider.register('store.dashboardRightNav', ['app/data/dashboard/project/data.json']);
        msApiProvider.register('store.dashboard', [msApiProvider.getApiUrl() + 'users']);


        // State
        $stateProvider
            .state('app.store', {
                abstract: true,
                url     : '/store'
            })
            .state('app.store.dashboard', {
                url      : '/dashboard',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/store/dashboard/dashboard.html',
                        controller : 'DashboardStoreController as vm'
                    }
                },
                resolve  : {
                    /*Dashboard1: function (msApi)
                    {
                        return msApi.resolve('store.dashboard1@get');
                    },*/
                    /*Dashboard: function (msApi)
                    {
                        return msApi.resolve('store.dashboard@get', {'store_id':store_id, 'act': 'home'});
                    },*/
                    /*RightNavDashboardData:function (msApi)
                    {
                        return msApi.resolve('store.dashboardRightNav@get');
                    }
                    */

                },
                bodyClass: 'dashboard-store'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/store');

        // Navigation
        msNavigationServiceProvider.saveItem('store', {
            title : '店铺管理',
            group : true,
            weight: 2
        });

        msNavigationServiceProvider.saveItem('store.dashboard', {
            title: 'Dashboard',
            state: 'app.store.dashboard'
        });

    }




})();
(function ()
{
    'use strict';

    angular
        .module('app.store')
        .controller('DashboardStoreController', DashboardStoreController);

    /** @ngInject */
    function DashboardStoreController($mdDialog, $rootScope, $timeout, $http, msApi, $scope ,$interval,$cookies)
    {
        var store_id = $cookies.get('store_id');
        var vm = this;
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        vm.is_amount = false;
        vm.is_birthday = false;
        vm.is_course = false;
        vm.is_expire_member = false;
        vm.is_new_member = false;
        vm.is_task = false;
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_dashboard_amount' || v == 'admin_dashboard'){
                vm.is_amount = true;
            }
            if( v == 'admin_dashboard_birthday_baby' || v == 'admin_dashboard'){
                vm.is_birthday = true;
            }
            if( v == 'admin_dashboard_course' || v == 'admin_dashboard'){
                vm.is_course = true;
            }
            if( v == 'admin_dashboard_expire_member' || v == 'admin_dashboard'){
                vm.is_expire_member = true;
            }
            if( v == 'admin_dashboard_new_member' || v == 'admin_dashboard'){
                vm.is_new_member = true;
            }
            if( v == 'admin_dashboard_task_user' || v == 'admin_dashboard'){
                ///@to-do 禁用，对于k12plus没啥用
                // vm.is_task = true;
            }
        });
        vm.store_name = $cookies.get('store_name');
        // Data
        //vm.data = Dashboard.data;


        msApi.request('store.dashboard@get', {'store_id':store_id, 'act': 'home'}).then(
            // Success
            function (response)
            {
                // Load new threads
                vm.data = response.data;
                vm.amount_list = {ranges:{},
                    currentRange: '0'};
                var list  = ['明细'];
                angular.forEach(vm.data.amount_list, function (v, k) {
                    list.push(v.contract_type + '：' + v.amount);
                });
                vm.amount_list.ranges = list;
                // Hide the loading screen
                vm.loadingThreads = false;
            }
        );

        msApi.register('store.courses.signups', [msApi.getApiUrl() + 'signups']);
        // 预约状态
        msApi.request('store.courses.signups@get', {'act': 'status'}).then(
            function (response) {
                vm.signup_status = response.data;
                //document.location.reload();
            });
        vm.birthdayChanage= birthdayChanage;
        function birthdayChanage(){
            msApi.request('store.dashboard@get', {'store_id':store_id, 'act': 'birthday','btype': vm.birthday.currentRange}).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.data.customers = response.data.customers;
                    vm.loadingThreads = false;
                }
            );

        }
        vm.birthdayCountChanage= birthdayCountChanage;
        function birthdayCountChanage(){
            msApi.request('store.dashboard@get', {'store_id':store_id, 'act': 'birthday_count','btype': vm.birthday_count.currentRange}).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.data.customer_count = response.data.customer_count;
                    vm.loadingThreads = false;
                }
            );
        }
        //更新状态
        vm.updateStatus = updateStatus;
        function updateStatus(signup, status){
            var confirm = $mdDialog.confirm()
                .title('确认操作?')
                .content('确认要执行这个操作吗.')
                .ariaLabel('修改状态')
                .ok('确定')
                .cancel('取消');
                //.targetEvent(event);
            $mdDialog.show(confirm).then(function (){
                var data = {'status' : status}
                $http({
                    method:'PUT',
                    url: msApi.getApiUrl('signups/' +signup.id),
                    data:data
                }).success(function(req){
                    $rootScope.message_success = '操作成功!';
                    $timeout(function(){$rootScope.message_success = '';},5000);
                    var status_text = '', status_class = '';
                    angular.forEach(vm.signup_status, function (v, k) {
                        if (v.id == status) {
                            status_text  = v.text;
                            status_class = v.class;
                        }
                    });
                    signup.status_class = status_class;
                    signup.status_text  = status_text;
                    signup.status       = status;
                    // Dummy save action
                    for ( var i = 0; i < vm.data.signups.length; i++ )
                    {
                        if ( vm.data.signups[i].id === data.id )
                        {
                            vm.data.signups[i] = angular.copy(signup);
                            break;
                        }
                    }
                }).error(function(data, state) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function(){$rootScope.message_danger = '';},5000);
                });
            }, function (){
                // Cancel Action
            });
            //closeDialog();
        }
        vm.birthday  = {
            ranges:{"T": "上个月",
            "C": "当前月",
            "N": "下个月"
            },
            currentRange:'C'

        };
        vm.birthday_count  = {
            ranges:{"T": "上个月",
                "C": "当前月",
                "N": "下个月"
            },
            currentRange:'C'

        };


        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        vm.nowWidget = {
            now   : {
                second: '',
                minute: '',
                hour  : '',
                day   : '',
                month : '',
                year  : ''
            },
            ticker: function ()
            {
                var now = moment();
                vm.nowWidget.now = {
                    second : now.format('ss'),
                    minute : now.format('mm'),
                    hour   : now.format('HH'),
                    day    : now.format('D'),
                    weekDay: now.format('dddd'),
                    month  : now.format('MMMM'),
                    year   : now.format('YYYY')
                };
            }
        };
        vm.nowWidget.ticker();
        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function ()
        {
            $interval.cancel(nowWidgetTicker);
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.customers')
        .controller('ParentsController', ParentsController)
        .controller('CustomersController', CustomersController)
        .controller('CustomersDetailController', CustomersDetailController)

    /** @ngInject */
    function CustomersController($rootScope, $timeout, $location, $mdDialog, $document, msApi, $cookies, $http)
    {
        var vm = this;
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        vm.is_cud = false;//是否可以增删改
        vm.sexs =[{'id':0,'name':'女'},{'id':1,'name':'男'}];
        vm.months =[{'id':'0~6'},{'id':'0~8'},{'id':'9~18'},{'id':'19~30'},{'id':'31~42'}, {'id':'42~72'}];
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_customer_cud' || v == 'admin_customer'){
                vm.is_cud = true;
            }
        });
        vm.is_zcard = false;
        angular.forEach(vm.curr_permissions, function (v, k) {
            if(v == 'admin_customer_zcard'){
                vm.is_zcard = true;
            }
        });
        // 课程顾问
        msApi.request('store.customers.users@get', {'store_id': store_id, 'role_id': 5}).then(
            function (response){
                vm.users = response.data;
            });
        //vm.customers = Customers;
        vm.openCustomerDialog = openCustomerDialog;
        vm.doSearch = doSearch;
        var store_id = $cookies.get('store_id');
        init();
        function init(){
            vm.loadingThreads = true;
            // Figure out the api name
            msApi.request('store.customers.list@get', {'store_id':store_id}).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.customers = response;
                    console.log(vm.customers.data);
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
        vm.openZcardDialog = openZcardDialog;
        function openZcardDialog(ev, customer)
        {
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'ZcardDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/customers/dialogs/zcard/zcard-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Customer : customer,
                    Customers: vm.customers,
                    is_cud: vm.is_cud,
                    event: ev
                }
            });
        }
        /*vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };*/
        // pager
        vm.query = {
            name:'',
            month:'',
            store_id: store_id,
            sort: '-id',
            limit: 20,
            page: 1
        };
        function doSearch(){
            msApi.resolve('store.customers.list@get', vm.query).then(function(customers){vm.customers = customers});
        }
        /**
         * Open new task dialog
         *
         * @param ev
         * @param task
         */
        function openCustomerDialog(ev, customer)
        {
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'CustomerDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/customers/dialogs/customer/customer-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Customer : customer,
                    Customers: vm.customers,
                    is_cud: vm.is_cud,
                    event: ev
                }
            });

        }
        vm.addparents = addparents;
        function addparents(ev, id) {
            ev.stopPropagation();
            $location.path("/store/customers/addparents/"+id);
        }
        vm.openGudin = openGudin;
        function openGudin(ev, customer) {
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'GudinDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/customers/dialogs/gudin/gudin-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Customer : customer,
                    Customers: vm.customers,
                    event: ev
                }
            });
        }
    }
    function CustomersDetailController($rootScope, $timeout, Customer, $mdDialog, $document, msApi, $cookies, $http , $stateParams, $filter, $qupload){
        var vm = this;
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        vm.is_cud = false;//是否可以增删改
        vm.is_signup = true;//是否可以批课
        vm.images = null;
        vm.selectedCourseStatus = -1;
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_customer_cud' || v == 'admin_customer'){
                vm.is_cud = true;
            }
            if( v == 'admin_signup_cud' || v == 'admin_signup'){
                vm.is_signup = true;
            }
        });
        // 预约状态
        msApi.request('store.courses.signups@get', {'act': 'status'}).then(
            function (response) {
                vm.signup_status = response.data;
                console.log(vm.signup_status);
            });

        var store_id = $cookies.get('store_id');
        init();
        vm.customer = Customer;
        console.log("++++++++");
        console.log(Customer);
        vm.contracts = [];//合同
        vm.contractPlans = [];//合同对应的教学计划
        vm.selectedPlanFilter = 0;//选择的课程计划过滤
        vm.orderBy = "course_time";//默认课程时间倒序
        //vm.customers = Customers;
        vm.parents = vm.customer.parents;
        vm.is_parents_new = true;
        //弹出编辑框
        vm.openCustomerDialog = openCustomerDialog;
        vm.setMainContactor = setMainContactor;
        var lab = ['基础', '划手', '闭气', '潜水', '跳水', '适应'];
        vm.radarChart = {
            labels: lab,
            data  : [
                [0,0,0,0,0,0]
            ]
        };
        //雷达图
        vm.radarChart = {
            labels: lab,
            data  : [
                [vm.customer.rate.jichu, vm.customer.rate.djhs, vm.customer.rate.bqfs, vm.customer.rate.qs, vm.customer.rate.ts, vm.customer.rate.sjhjsy]
            ]
        };
        function init(){
            vm.loadingThreads = true;
            // Figure out the api name
            msApi.request('store.customers.list@get', {'store_id':store_id}).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.customers = response;
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
        $timeout(function(){
        //父母信息
        msApi.request('store.customers.parents@get', {'customer_id': $stateParams.id}).then(
            function (response){
                if(response.data.length > 0) {
                    vm.parents = response.data;
                    vm.is_parents_new = false;
                }
            });
        },1000);
        //合同信息
        msApi.request('store.customers.contract@get', {'customer_id': $stateParams.id,'all':true}).then(
            function (response){
                if(response.data.length > 0){
                    vm.contracts = response.data;
                    vm.contracts.forEach(function(cItem){
                        var cExist = false;
                        vm.contractPlans.forEach(function(item){
                            if (item.id==cItem.plan_id) cExist = true;
                        });
                        if (!cExist) {
                            vm.contractPlans.push({id:cItem.plan_id,title:cItem.plan_title});
                        }
                    });

                    //console.log(vm.contract);
                }
            });
        vm.query1 = {
            customer_id: $stateParams.id,
            sort: vm.orderBy,
            limit: 10,
            page: 1
        };
        vm.doStatusSearch = doStatusSearch;
        function doStatusSearch(){
            var status = vm.selectedCourseStatus;
            var planId = vm.selectedPlanFilter;
            $('.status-text').removeClass('status-txt-color1');
            $('.status-text').addClass('status-txt-color');
            if(status >= 0){
                vm.query1.status = status;
            }else{
                vm.query1.status = null;
                // vm.query1.page =1;
            }
            vm.query1.plan_id = planId;
            if (vm.query1.plan_id=="0") vm.query1.plan_id = null;
            vm.query1.sort = vm.orderBy;
            msApi.resolve('store.customers.signups@get', vm.query1).then(function(signups){vm.signups = signups});
        }
        //{'customer_id': $stateParams.id, 'sort':'-courses_id'}
        //课程信息
        msApi.request('store.customers.signups@get', vm.query1).then(
            function (response){
                vm.signups = response;
            });
        vm.query2 = {
            act: 'courses',
            customer_id: $stateParams.id,
            sort: '-id',
            limit: 20,
            page: 1
        };
        vm.doSearch2 = doSearch2;
        function doSearch2(){
            msApi.resolve('store.customers.images@get', vm.query2).then(function(images){vm.images = images});
        }
        //照片墙
        msApi.request('store.customers.images@get',  vm.query2).then(
            function (response){
                vm.images = response;
            });
        // 预约状态
        msApi.request('store.courses.signups@get', {'act': 'status'}).then(
            function (response) {
                vm.signup_status = response.data;
            });
        /**
         * Open new task dialog
         *
         * @param ev
         * @param task
         */
        function openCustomerDialog(ev, customer)
        {
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'CustomerDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/customers/dialogs/customer/customer-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Customer : Customer,
                    Customers: vm.customers,
                    event: ev,
                    is_signup:vm.is_signup,
                    is_cud:vm.is_cud
                }
            });

        }
        function setMainContactor(ev, parent){
            if(parent){
                vm.customer.main_contactor = parent.id
                $http({
                    method:'PUT',
                    url: msApi.getApiUrl('customers/' +vm.customer.id),
                    data:vm.customer
                }).success(function(req) {
                    //alert('成功设置为主联系人');
                });
            }
        }

        // 续费按钮点击事件
        vm.xufei = xufei;
        function xufei(){
            
        }
        vm.deleteImg = deleteImg;
        function deleteImg(image){
            var confirm = $mdDialog.confirm()
                .title('删除确认操作?')
                .content('确认要删除此宝定吗.')
                .ariaLabel('删除宝定')
                .ok('删除')
                .cancel('取消');
                //.targetEvent(event);

            $mdDialog.show(confirm).then(function ()
            {
                var data = image;
                data.status = 0;
                $http({
                    method:'PUT',
                    url: msApi.getApiUrl('images/' +data.id),
                    data:data
                    /*headers:{'Content-Type':'application/x-www-form-urlencoded'},
                    transformRequest:function(obj){
                        //console.log(obj);
                        var str = [];
                        for(var p in obj){
                            str.push(encodeURIComponent(p) + "=" +encodeURIComponent(obj[p]));
                        }
                        return str.join("&");
                    }*/
                }).success(function(req){
                    vm.images.data.splice(vm.images.data.indexOf(image), 1);
                    $rootScope.message_success = '操作成功!';
                    $timeout(function(){$rootScope.message_success = '';},5000);
                }).error(function(data, state) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function(){$rootScope.message_danger = '';},5000);
                });
            }, function ()
            {
                // Cancel Action
            });
        }

        /// 七牛上传图片
        // https://github.com/icattlecoder/angularQFileUpload
        // 七牛 文件上传 >>>>>>>>>>>>>>>>>>
        msApi.request('store.customers.users@get', {'act': 'upToken'}).then(
            function (response){
                vm.upToken = response.data.upToken;
                vm.upHost  = response.data.upHost;
            });
        vm.selectFiles = [];
        var start = function (index, course_id, signup_key) {
            vm.selectFiles[index].progress = {
                p: 0
            };
            vm.selectFiles[index].upload = $qupload.upload({
                key: $filter("date")(new Date(), "yyyyMMdd")+'/'+course_id+'/'+$filter("date")(new Date(), "HHmmss")+index+'.jpg',
                file: vm.selectFiles[index].file,
                token: vm.upToken
            });
            vm.selectFiles[index].upload.then(function (response) {
                // upload success
                //$log.info(response);
                //console.log("upload success");
                //console.log(response);
                // post data to backend
                vm.curr_user = $cookies.getObject('curr_user');
                var data = {
                    'url'         :vm.upHost+response.key,
                    'user_uid'    :vm.curr_user.id,
                    'customer_id' :vm.customer.id,
                    'courses_id'  :course_id
                };
                $http({
                    method:'POST',
                    url: msApi.getApiUrl('images'),
                    data:data
                }).success(function(req) {
                    //vm.tasks.unshift(vm.task);
                });
                // bind data to angularjs
                vm.signups['data'][signup_key].course.images.push(data);
                vm.images.data.push(data);

            }, function (response) {
                // upload failure
                //$log.info(response);
                //console.log("upload failure");
                //console.log(response);
            }, function (evt) {
                // progress
                vm.selectFiles[index].progress.p = Math.floor(100 * evt.loaded / evt.totalSize);
            });
        };
        vm.abort = function (index) {
            vm.selectFiles[index].upload.abort();
            vm.selectFiles.splice(index, 1);
        };
        vm.onFileSelect = function ($files, course_id, signup_key) {
            var offsetx = vm.selectFiles.length;
            for (var i = 0; i < $files.length; i++) {
                vm.selectFiles[i + offsetx] = {
                    file: $files[i]
                };
                start(i + offsetx, course_id, signup_key);
            }
        };
        // 七牛 文件上传 <<<<<<<<<<<<<<<<<<

        //更新状态
        vm.updateStatus = updateStatus;
        function updateStatus(signup, status){
            var confirm = $mdDialog.confirm()
                .title('确认操作?')
                .content('确认要执行这个操作吗.')
                .ariaLabel('修改状态')
                .ok('确定')
                .cancel('取消');
                //.targetEvent(event);
            $mdDialog.show(confirm).then(function (){
                var data = {'status' : status}
                $http({
                    method:'PUT',
                    url: msApi.getApiUrl('signups/' +signup.id),
                    data:data
                }).success(function(req){
                    $rootScope.message_success = '操作成功!';
                    $timeout(function(){$rootScope.message_success = '';},5000);
                    var status_text = '', status_class = '';
                    angular.forEach(vm.signup_status, function (v, k) {
                        if (v.id == status) {
                            status_text  = v.text;
                            status_class = v.class;
                        }
                    });
                    //signup.status_class = status_class;
                    //console.log(signup.status_class);
                    signup.status_text  = status_text;
                    signup.status       = status;
                    // Dummy save action
                    for ( var i = 0; i < vm.signups.length; i++ )
                    {
                        if ( vm.signups[i].id === data.id )
                        {
                            vm.signups[i] = angular.copy(signup);
                            break;
                        }
                    }
                }).error(function(data, state) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function(){$rootScope.message_danger = '';},5000);
                });
            }, function (){
                // Cancel Action
            });
            //closeDialog();
        }
    }


    // 家长
    function ParentsController($rootScope, $timeout, $mdDialog, $document, msApi, $cookies, $http, Parents)
    {
        var vm = this;
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        vm.is_cud = false;//是否可以增删改
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_parent_cud' || v == 'admin_parent' || v == 'admin_customer'){
                vm.is_cud = true;
            }
        });
        vm.parents = Parents;
        vm.doSearch = doSearch;
        vm.openWechatDialog = openWechatDialog;
        vm.openParentDialog = openParentDialog;
        vm.resetpwdParent = resetpwdParent;

        // pager
        vm.query = {
            name:'',
            mobile:'',
            store_id:$cookies.get('store_id'),
            sort: '-id',
            limit: 20,
            page: 1
        };
        function doSearch(){
            msApi.resolve('store.customers.parents@get', vm.query).then(function(parents){vm.parents = parents});
        }
        function openWechatDialog(ev, parent){
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'WechatDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/customers/dialogs/wechat/wechat-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Parent:parent,
                    is_cud: vm.is_cud,
                    event: ev
                }
            });
        }
        /**
         * Open new task dialog
         *
         * @param ev
         * @param task
         */
        function openParentDialog(ev, parent)
        {
            ev.stopPropagation();

            $mdDialog.show({
             controller         : 'ParentDialogController',
             controllerAs       : 'vm',
             templateUrl        : 'app/main/apps/store/customers/dialogs/parent/parent-dialog.html',
             parent             : angular.element($document.body),
             targetEvent        : ev,
             clickOutsideToClose: true,
             locals             : {
             Parent : parent,
             Parents : vm.parents,
             event: ev
             }
             });
        }
        function resetpwdParent(ev, parent){
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'ResetpwdParentController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/customers/dialogs/resetpwd/resetpwd-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Parent : parent,
                    Parents : Parents,
                    event: ev
                }
            });
        }
    }


})();
(function ()
{
    'use strict';

    angular
        .module('app.store.customers')
        .controller('CustomerContractController', CustomerContractController);

    // 创建学生及合同
    function CustomerContractController(Task, $stateParams, $rootScope, $timeout, $q, $mdDialog, $document, msApi, $cookies, $http, $qupload,$filter,$location)
    {

        var vm = this;
        vm.sending = false;
        vm.task = Task;
        vm.customer = {
            'id'                : '',
            'member_id'         : 'BB'+new Date().getTime(),
            'name'              : '',
            'nickname'          : '',
            'email'             : '',
            'sex'               : 0,
            'birthday'          : moment().subtract(5,'months').format('YYYY-MM-DD'),
            'photo_id'          : '',
            'store_id'          : $cookies.get('store_id'),
            'main_contactor'    : 0,
            'consult_id'        : 0,
            'remarks'           : '',
            'skype'             : '',
            'photo'             : '',
            'avatar'            : ''//'assets/images/avatars/profile.jpg'
        };
        //体验升级为会员
        if($stateParams.task_id && vm.task.id){
            vm.customer.name = vm.task.name;
            vm.customer.birthday = vm.task.birthday;
            vm.customer.sex = vm.task.sex;
        }
        var store_id = $cookies.get('store_id');
        //字符串转Date类型
        vm.StrToDate = function (str) { if (str && str != '0000-00-00') return new Date(str); }
        //Date类型转字符串
        vm.DateToStr = function (mDate) { 
            console.log(moment(mDate).format('YYYY-MM-DD'));
            return moment(mDate).format('YYYY-MM-DD');
        }
        //根据个数计算Flex的大小
        vm.countFlexSize = function (mLength){
            if (mLength > 5) return 100/5;
            return parseInt(100/mLength);
        }
        // 课程顾问
        msApi.request('store.customers.users@get', {'store_id': store_id, 'role_id': 5}).then(
            function (response){
                vm.users = response.data;
            });


        /// 七牛上传图片
        // https://github.com/icattlecoder/angularQFileUpload
        // 七牛 文件上传 >>>>>>>>>>>>>>>>>>
        msApi.request('store.customers.users@get', {'act': 'upToken'}).then(
            function (response){
                vm.upToken = response.data.upToken;
                vm.upHost  = response.data.upHost;
            });
        vm.selectFiles = [];
        var start = function (index) {
            vm.selectFiles[index].progress = {
                p: 0
            };
            vm.selectFiles[index].upload = $qupload.upload({
                key: 'avatar/'+$filter("date")(new Date(), "yyyyMMdd")+'/'+$filter("date")(new Date(), "HHmmss")+'.jpg',
                file: vm.selectFiles[index].file,
                token: vm.upToken
            });
            vm.selectFiles[index].upload.then(function (response) {
                // upload success
                //$log.info(response);
                //console.log("upload success");
                //console.log(response);
                vm.customer.avatar = vm.upHost+response.key;
            }, function (response) {
                // upload failure
                //$log.info(response);
                //console.log("upload failure");
                //console.log(response);
            }, function (evt) {
                // progress
                vm.selectFiles[index].progress.p = Math.floor(100 * evt.loaded / evt.totalSize);
            });
        };
        vm.abort = function (index) {
            vm.selectFiles[index].upload.abort();
            vm.selectFiles.splice(index, 1);
        };
        vm.onFileSelect = function ($files) {
            var offsetx = vm.selectFiles.length;
            for (var i = 0; i < $files.length; i++) {
                vm.selectFiles[i + offsetx] = {
                    file: $files[i]
                };
                start(i + offsetx);
            }
        };


        ////// 第二部 联系人信息  /////////
        vm.parents = [
            {
                mobile:'',
                relation:'爸爸',
                username:'',
                name:'',
                email:'',
                wechat:'',
                qq:'',
                store_id : $cookies.get('store_id'),
                was:false
            }
        ];
        /**
         * 检查手机号的父母是否存在
         * @param mobile
         * @param index
         */
        vm.checkParent = function(mobile,index){
            if(mobile) {
                $http.get(msApi.getApiUrl('parents'), {params: {"mobile": mobile}}).success(function (response) {
                    //console.log (vm.parent);
                    if (response.data.length > 0) {
                        vm.parents[index] = response.data[0];
                        vm.parents[index].store_id = $cookies.get('store_id');
                        vm.parents[index].was = true;
                        if (vm.customer.id) vm.parents[index].customer_id = vm.customer.id;
                    }else{
                        vm.parents[index].mobile = mobile;
                        /*vm.parents[index].username = '';
                        vm.parents[index].name = '';
                        vm.parents[index].email = '';
                        vm.parents[index].wechat = '';
                        vm.parents[index].qq = '';*/
                        vm.parents[index].was = false;
                        vm.parents[index].store_id = $cookies.get('store_id');
                    }
                });
            }else{

            }
        }
        //体验升级为会员
        if($stateParams.task_id && vm.task.id){
            vm.parents[0].mobile = vm.task.mobile;
            vm.parents[0].username = vm.task.mobile;
            vm.parents[0].name = vm.task.parent;
            vm.parents[0].relation = vm.task.relation;
            vm.checkParent(vm.task.mobile,0);
        }
        /**
         * 点击 "添加另一个关系" 处理方法
         */
        vm.addOtherRelation = function(){
            var relation = vm.parents[0].relation == '爸爸'?'妈妈':'爸爸';
            vm.parents.push({
                mobile:'',
                relation:relation,
                username:'',
                name:'',
                email:'',
                wechat:'',
                qq:'',
                store_id : $cookies.get('store_id'),
                was:false
            });
        }
        vm.removeOtherRelation = function(){
            vm.parents.splice(1,1);
        }
        /**
         * 手机修改事件
         * @param mobile
         * @param index
         */
        vm.mobileChanged = function(mobile,index){
            //vm.parents[index].username = vm.parents[index].username?vm.parents[index].username:mobile;
            //vm.parents[index].username = mobile;
            vm.checkParent(mobile,index);
        }


        ///////// 第三部 合同数据  ////////
        vm.contract = {
            'id': '',
            'customer_id': '',
            'customer_name': '',
            'contact_guid': vm.customer.member_id+'-1',
            'card_type': '新办卡',
            'contract_type': '',
            'pay_type': '',
            'can_leave_times': 2,
            'amount': '',
            'start_date': moment().format("YYYY-MM-DD"),
            'end_date': moment().format("YYYY-MM-DD"),
            'store_id': store_id,
            'remarks': '',
            'consult_id': 0,
            'consult_name': '',
            'plan_id': null,
            'plan_title': '',
            'status': 1,
            'sign_date': moment().format("YYYY-MM-DD")
        };//初始化数据
        vm.contractOptionsSelected = [];
        vm.contractOptionsToggle = function (item) {
            var idx = vm.contractOptionsSelected.indexOf(item);
            if (idx > -1) {
                vm.contractOptionsSelected.splice(idx, 1);
            }
            else {
                vm.contractOptionsSelected.push(item);
            }
        };

        vm.contractOptionsExists = function (item) {
            return vm.contractOptionsSelected.indexOf(item) > -1;
        };
        // 课程分类
        msApi.request('store.contracts.categories@get', {'store_id': store_id, 'type': '1'}).then(
            function (response) {
                vm.course_categorys = response.data;
                if (vm.contract.ContractsHasCourses) {
                    angular.forEach(vm.contract.ContractsHasCourses, function (v, k) {
                        for (var i = 0; i < vm.course_categorys.length; i++) {
                            if (vm.course_categorys[i].id == v.course_category_id) {
                                vm.contractOptionsSelected.push(vm.course_categorys[i]);
                                break;
                            }
                        }
                    });
                }
        });
        // 合同卡类型
        msApi.request('store.contracts.categories@get', {'store_id': store_id, 'type': '3'}).then(
            function (response) {
                vm.card_types = response.data;
            });

        // 合同卡项
        msApi.request('store.contracts.categories@get', {'store_id': store_id, 'type': '4'}).then(
            function (response) {
                vm.contract_types = response.data;
            });

        // 支付类型
        msApi.request('store.contracts.categories@get', {'store_id': store_id, 'type': '5'}).then(
            function (response) {
                vm.pay_types = response.data;
            });

        // 合同状态
        msApi.request('store.contracts.categories@get', {'store_id': store_id, 'act': 'contracts_status'}).then(
            function (response) {
                vm.contracts_status = response.data;
            });



        ///////////提交处理事件////////////
        /**
         * 表单数据处理函数
         * @param msWizard
         */
        vm.sendForm = function(msWizard){
            //msWizard.resetForm();//充值 wizard表单
            vm.sending = true;
            //创建学生信息
            vm.customer.update_time = $filter("date")(new Date(), "yyyy-MM-dd HH:mm:ss");
            $http({
                method:vm.customer.id?'PUT':'POST',
                url: msApi.getApiUrl('customers'+(vm.customer.id?'/'+vm.customer.id:'')),
                data:vm.customer
            }).then(function(sucessResponse){
                console.log(sucessResponse);
                vm.customer.sex_text     = vm.customer.sex==1?'男':'女';
                vm.customer.store_name   = $cookies.get('store_name');
                angular.forEach(vm.users, function(v,k){
                    if (v['id'] == vm.customer.consult_id)
                        vm.customer.consult_name = v['name'];
                });
                vm.customer.id = sucessResponse.data.id;
                $rootScope.message_success = '操作成功!';

                //体验升级为会员
                if($stateParams.task_id && vm.task.id){
                    var newTask = {'customer_id':vm.customer.id};
                    $http({
                        method: 'PUT',
                        url: msApi.getApiUrl('tasks/' + vm.task.id),
                        data:newTask
                    }).success(function (req) {
                        $rootScope.message_success = '操作成功!';
                        $timeout(function(){$rootScope.message_success = '';},5000);
                    }).error(function (data, state) {
                        vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                        $rootScope.message_danger = vm.error_arr;
                        $timeout(function(){$rootScope.message_danger = '';},5000);
                    });
                }
                //处理联系人
                var promises = [];
                angular.forEach(vm.parents,function(parent,index){//循环所有的parents, 把提交数据的promise 放到数组里
                    //if (parent.binded) return ;//如果已经绑定,不做任何事情
                    parent.customer_id = vm.customer.id;//设置当前BB给父母
                    var npromise = $http({
                        method:parent.id?'PUT':'POST',
                        url: msApi.getApiUrl('parents'+(parent.id?'/'+parent.id:'')),
                        data:parent
                    });
                    //}
                    promises.push(npromise);//把promises添加入promises数组
                });
                $q.all(promises).then(function(values){
                    console.log(values);
                    angular.forEach(values,function(item,index){
                        if (item.data&&item.data.id){//如果返回的是添加的数据
                            //vm.parents[index].binded = true;//表示当前父母已经处理,后续无需处理
                            vm.parents[index].id = item.data.id;
                        }
                    });
                });

                //处理合同
                vm.contract.update_time = $filter("date")(new Date(), "yyyy-MM-dd HH:mm:ss");
                vm.contract.customer_id = vm.customer.id;
                vm.contract.consult_id = vm.customer.consult_id;
                vm.contract.customer_name = vm.customer.name;
                angular.forEach(vm.users, function (v, k) {
                    if (v['id'] == vm.contract.consult_id) {
                        vm.contract.consult_name = v['name'];
                    }
                });
                angular.forEach(vm.contracts_status, function (v, k) {
                    if (v['id'] == vm.contract.status) {
                        vm.contract.status_name = v['name'];
                    }
                });
                angular.forEach(vm.contract.ContractsHasCourses, function (v, k) {
                    v.course_category_id = k;
                    angular.forEach(vm.course_categorys, function (va, ke) {
                        if (k == va.id) {
                            v.categories_name = va.name;
                            v.course_number_remaining = va.course_number;
                        }
                    });
                });
                $http({
                    method: 'POST',
                    url: msApi.getApiUrl('contracts'),
                    data: angular.toJson(vm.contract)
                }).success(function (req) {
                    $rootScope.message_success = '操作成功!';
                    $timeout(function(){$rootScope.message_success = '';},5000);
                    vm.contract.id = req.id;

                    //合同创建完后转到学生主页
                    //vm.sending = false;  //不同启用了,因为直接页面跳转
                    $timeout(function(){
                        $location.path("/store/customers/detail/"+vm.customer.id);
                    },1000);
                }).error(function(data, state) {
                    vm.sending = false;
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function(){$rootScope.message_danger = '';},5000);
                });

            },function(errorRerponse){//学生数据保存出现问题 @to-do
                vm.sending = false;
            });
        }


        vm.selectedPlanItem = "";
        vm.searchPlanText = "";
        vm.plans = {};
        vm.plansall = [];
        // 搜索教学计划
        vm.searchPlans = function(text) {
            // if(text){
                $http.get(msApi.getApiUrl('plans'), {params: {'title':text,'per-page':1000,'sort':'title'}}).success(function (results) {
                    vm.plans = results.data;
                    vm.plansall = [];
                    angular.forEach(vm.plans, function (item, index) {
                        item.value = item.id;
                        item.display = item.title;
                        vm.plansall.push(item);
                    });
                    $('#plans-auto').find('input[type="search"]').focus();
                    return vm.plansall;
                });
            // }else {
            //     vm.plansall = [];
            //     return vm.plansall;
            // }
        }
        vm.searchPlans("");
        //选中某个教学计划触发事件
        vm.selectedPlanItemChange = function(item){
            if (item){
                vm.contract.plan_id = item.id;
                vm.contract.plan_title = item.title;
            }else{
                vm.contract.plan_id = null;
                vm.contract.plan_title = "";
            }
        }

    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.store.customers')
        .controller('CustomerParentsController', CustomerParentsController);

    // 创建学生及合同
    function CustomerParentsController(Customer, $rootScope, $stateParams, $timeout, $q, $mdDialog, $document, msApi, $cookies, $http, $qupload,$filter,$location)
    {
        var store_id = $cookies.get('store_id');
        var vm = this;
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        vm.is_cud = false;//是否可以增删改
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_parent_cud' || v == 'admin_customer'){
                vm.is_cud = true;
            }
        });
        vm.sending = false;
        vm.customer = Customer;
        vm.is_parents_new = true;
        vm.StrToDate = function (str) { if (str && str != '0000-00-00') return new Date(str); }
        //父母信息
        msApi.request('store.customers.parents@get', {'customer_id': $stateParams.id}).then(
            function (response){
                if(response.data.length > 0) {
                    vm.parents = response.data;
                    vm.is_parents_new = false;
                }
            });

        if(vm.is_parents_new){
            vm.parents = [
                {
                    mobile:'',
                    relation:'爸爸',
                    username:'',
                    name:'',
                    email:'',
                    wechat:'',
                    qq:'',
                    store_id          : store_id,
                    was:false
                }
            ];
        }
        /**
         * 点击 "添加另一个关系" 处理方法
         */
        vm.addOtherRelation = function(){
            var relation = vm.parents[0].relation == '爸爸'?'妈妈':'爸爸';
            vm.parents.push({
                mobile:'',
                relation:relation,
                username:'',
                name:'',
                email:'',
                wechat:'',
                qq:'',
                store_id          : store_id,
                was:false
            });
        }
        //删除联系人
        vm.removeOtherRelation = function(pid,$index){
            msApi.request('store.customers.parents@get', {act: 'delete', id:pid, customer_id: $stateParams.id})
            .then(function (response) {
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
            });
            vm.parents.splice($index,1);
            vm.parents.push({
                mobile:'',
                relation:'妈妈',
                username:'',
                name:'',
                email:'',
                wechat:'',
                qq:'',
                store_id          : store_id,
                was:false
            });
        }
        /**
         * 手机修改事件
         * @param mobile
         * @param index
         */
        vm.mobileChanged = function(mobile,index){
            //vm.parents[index].username = vm.parents[index].username?vm.parents[index].username:mobile;
           // vm.parents[index].username = mobile;
            vm.checkParent(mobile,index);
        }
        /**
         * 检查手机号的父母是否存在
         * @param mobile
         * @param index
         */
        vm.checkParent = function(mobile,index){
            if(mobile && mobile.length > 6) {
                $http.get(msApi.getApiUrl('parents'), {params: {"mobile": mobile}}).success(function (response) {
                    //console.log (vm.parent);
                    if (response.data.length > 0) {
                        vm.parents[index] = response.data[0];
                        vm.parents[index].was = true;
                        vm.parents[index].store_id = store_id;
                        if (vm.customer.id) vm.parents[index].customer_id = vm.customer.id;
                    }else{
                        vm.parents[index].mobile = mobile;
                        /*vm.parents[index].username = '';
                        vm.parents[index].name = '';
                        vm.parents[index].email = '';
                        vm.parents[index].wechat = '';
                        vm.parents[index].qq = '';*/
                        vm.parents[index].was = false;
                        vm.parents[index].store_id = store_id;
                    }
                });
            }else{

            }
        }


        ///////////提交处理事件////////////
        /**
         * 表单数据处理函数
         * @param msWizard
         */
        vm.sendForm = function(msWizard){
            //msWizard.resetForm();//充值 wizard表单
            vm.sending = true;

            //处理联系人
            var promises = [];
            angular.forEach(vm.parents,function(parent,index){//循环所有的parents, 把提交数据的promise 放到数组里
                //if (parent.binded) return ;//如果已经绑定,不做任何事情
                parent.customer_id = vm.customer.id;//设置当前BB给父母
                var npromise = $http({
                    method:parent.id?'PUT':'POST',
                    url: msApi.getApiUrl('parents'+(parent.id?'/'+parent.id:'')),
                    data:parent,
                }).success(function(req){
                }).error(function(data, state) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function(){$rootScope.message_danger = '';},5000);
                });
                //}
                promises.push(npromise);//把promises添加入promises数组
            });

            //vm.sending = false;  //不同启用了,因为直接页面跳转
            $timeout(function(){
                if(!vm.error_arr) {
                    $location.path("/store/customers/detail/" + vm.customer.id);
                }
            },1000);

        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.store.courses')
        .controller('ContractLeavesController', ContractLeavesController);

    /** @ngInject */
    function ContractLeavesController($rootScope, $timeout, $q, msApi, $mdDialog, $document, $http, $cookies)
    {
        var store_id = $cookies.get('store_id');
        var vm = this;
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        vm.is_cud = false;//是否可以增删改
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_qingjia_cud' || v == 'admin_qingjia' || v == 'admin_contract'){
                vm.is_cud = true;
            }
        });
        vm.months =[{'id':'0~6'},{'id':'0~8'},{'id':'9~18'},{'id':'19~30'},{'id':'31~42'}, {'id':'42~72'}];
        // Data
        //vm.leaves = Leaves;
        /*vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };*/
        vm.query = {
            customer_name:'',
            day:'',
            sdate:'',
            status:'',
            sort: '-id',
            limit: 20,
            page: 1
        };
        vm.leave_status = [{'id':'','text':'状态'},{'id':'0','text':'不批准'},{'id':'1','text':'已批准'},{'id':'2','text':'未审批'}];
        init();
        vm.doSearch = doSearch;
        function doSearch(){
            msApi.resolve('store.contracts.leaves@get', vm.query).then(function(leaves){vm.leaves = leaves});
        }
        //审批
        vm.doShenpi = doShenpi;
        function doShenpi(ev,leave,status){
            var data = leave;
            data.status = status;
            data._method = 'PUT';
            $http({
                method:'POST',
                url: msApi.getApiUrl('qingjias/'+leave.id),
                data:data,
                headers:{'Content-Type':'application/x-www-form-urlencoded'},
                transformRequest:function(obj){
                    //console.log(obj);
                    var str = [];
                    for(var p in obj){
                        str.push(encodeURIComponent(p) + "=" +encodeURIComponent(obj[p]));
                    }
                    return str.join("&");
                }
            }).success(function(req){
                if(status == 0){
                    leave.status_name ='不批准';
                }
                if(status == 1){
                    leave.status_name ='批准';
                }

                for (var i = 0; i < vm.leaves.data.length; i++) {
                    if (vm.leaves.data[i].id === leave.id) {
                        vm.leaves.data[i] = angular.copy(leave);
                        break;
                    }
                }
                $rootScope.message_success = '保存成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });

        }
        function init(){
            vm.loadingThreads = true;
            // Figure out the api name
            msApi.request('store.contracts.leaves@get', vm.query).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.leaves = response;
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.store.contracts')
        .controller('ContractDetailController', ContractDetailController)
        .controller('CustomerSignupController', CustomerSignupController)
        .controller('ContractsController', ContractsController);

    /** @ngInject */
    function ContractsController($filter, $rootScope, $timeout, $http, $mdDialog,$stateParams, $document, msApi, $cookies, $location)
    {
        var store_id = $cookies.get('store_id');
        var vm = this;
        //定义过滤条件是否启用
        vm.contractFilterEnable = {
            contact_guid:true,
            name:true,
            consult:true,
            card_type:true,
            contract_type:true,
            pay_type:true,
            status:true,
            month:false,
            plan:true
        }
        vm.title = '合同列表';
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        vm.curr_roles = $cookies.getObject('curr_roles');
        vm.is_cud = false;//是否可以增删改
        vm.is_export = false;//是否有导出权限
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_contract_cud' || v == 'admin_contract'){
                vm.is_cud = true;
            }
            if( v == 'admin_contract_export' || v == 'admin_contract'){
                vm.is_export = true;
            }
        });
        //销售顾问
        msApi.request('store.contracts.consults@get', {'store_id': store_id, 'role_id': 5}).then(
            function (response) {
                vm.consults = response.data;
            });
        // 合同卡类型
        msApi.request('store.contracts.categories@get', {'store_id': store_id, 'type': '3', 'per-page': 200}).then(
            function (response) {
                vm.card_types = response.data;
            });

        // 合同卡项
        msApi.request('store.contracts.categories@get', {'store_id': store_id, 'type': '4', 'per-page': 200}).then(
            function (response) {
                vm.contract_types = response.data;
            });

        // 支付类型
        msApi.request('store.contracts.categories@get', {'store_id': store_id, 'type': '5', 'per-page': 200}).then(
            function (response) {
                vm.pay_types = response.data;
            });

        // 合同状态
        msApi.request('store.contracts.categories@get', {'store_id': store_id, 'act': 'contracts_status', 'per-page': 200}).then(
            function (response) {
                vm.contracts_status = response.data;
            });
        //合同
        //vm.contracts = Contracts;

        vm.doSearch = doSearch;
        // pager
        vm.query = {
            contact_guid:'',
            plan_title:'',
            sdate:'',
            edate:'',
            store_id: store_id,
            sort: '-id',
            limit: 10,
            page: 1
        };
        vm.months =[{'id':'0~6'},{'id':'0~8'},{'id':'9~18'},{'id':'19~30'},{'id':'31~42'}, {'id':'42~72'}];
        if($stateParams.flag == '1'){
            vm.query = {
                contact_guid:'',
                sdate:'',
                edate:'',
                store_id: store_id,
                sort: '-id',
                status:0,
                limit: 10,
                page: 1

            };
            vm.title = '合同回收站';
        }
        //台州的销售顾问只能看他自己的合同 除开发管理员 admin_root 店长 store_manager 超级管理员	super_manager 外
        if(store_id == 2 ){
            var is_flag = true;
            for (var i = 0; i < vm.curr_roles.length; i++) {
                var role = vm.curr_roles[i];
                if (role == 'admin_root' || role == 'store_manager' || role == 'super_manager' || role == 'qiantai') {
                    is_flag = false;
                }
            }
            if(is_flag){
                vm.curr_user = $cookies.getObject('curr_user');
                vm.query.consult_id = vm.curr_user.id;
            }
        }

        init();
        function doSearch(){
            msApi.resolve('store.contracts.list@get', vm.query).then(function(contracts){vm.contracts = contracts});
        }
        function init(){
            vm.loadingThreads = true;
            // Figure out the api name
            msApi.request('store.contracts.list@get', vm.query).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.contracts = response;
                    // Hide the loading screen
                    vm.loadingThreads = false;
                }
            );

        }
        vm.openYuyue = openYuyue;
        function openYuyue(ev, contract_id, customer_id) {
            ev.stopPropagation();
            $location.path("/store/contract/signup/"+contract_id+'/'+customer_id);
        }
        vm.openCustomer = openCustomer;
        function openCustomer(ev, id) {
            ev.stopPropagation();
            $location.path("/store/customers/detail/"+id);
        }
        /*vm.customers = null;
        msApi.resolve('store.contracts.customers@get', {'store_id':store_id,"act":'all'}).then(
            // Success
            function (response)
            {
                // Load new threads
                vm.customers = response.data;
                // Hide the loading screen
                vm.loadingThreads = false;
            }
        );
        */
        var store_id = $cookies.get('store_id');
        vm.openZcardDialog = openZcardDialog;
        function openZcardDialog(ev, contract)
        {
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'ZcardDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/contracts/dialogs/zcard/zcard-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Contract : contract,
                    Contracts: vm.contracts,
                    is_cud: vm.is_cud,
                    event: ev
                }
            });
        }
        //弹窗
        vm.openContractDialog = openContractDialog;
        function openContractDialog(ev, contract)
        {
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'ContractDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/contracts/dialogs/contract/contract-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Contract : contract,
                    Contracts: vm.contracts,
                    is_cud: vm.is_cud,
                    event: ev
                }
            });
        }

        vm.updateStatus = updateStatus;
        function updateStatus(ev, contract){
            var confirm = $mdDialog.confirm()
                .title('还原确认操作?')
                .content('确认要还原此合同吗.')
                .ariaLabel('还原合同')
                .ok('还原')
                .cancel('取消');
                //.targetEvent(event);
            $mdDialog.show(confirm).then(function () {
                contract.status = 1;

                $http({
                    method: 'PUT',
                    url: msApi.getApiUrl('contracts/' + contract.id),
                    data: contract
                }).success(function (req) {
                    vm.contracts.data.splice(vm.contracts.data.indexOf(contract), 1);
                    $rootScope.message_success = '操作成功!';
                    $timeout(function(){$rootScope.message_success = '';},5000);
                    $location.path("/store/contract/list");
                }).error(function(data, state) {
                    vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                    $rootScope.message_danger = vm.error_arr;
                    $timeout(function(){$rootScope.message_danger = '';},5000);
                });
            }, function () {
                // Cancel Action
            });
        }


        vm.exportContracts = exportContracts;
        function exportContracts(ev){
            /*var sdate = vm.query.sdate == '' ? '' : (vm.query.sdate).toISOString().slice(0,10);
            var edate = vm.query.edate == '' ? '' : (vm.query.edate).toISOString().slice(0,10);*/
            var sdate = vm.query.sdate == '' ? '' : $filter("date")(new Date(vm.query.sdate), "yyyy-MM-dd");
            var edate = vm.query.edate == '' ? '' : $filter("date")(new Date(vm.query.edate), "yyyy-MM-dd");
            var consult_id = vm.query.hasOwnProperty('consult_id') ? vm.query.consult_id : 0 ;
            window.open(msApi.getApiUrl('contracts/export')+'&consult_id='+consult_id+'&sdate='+sdate+'&edate='+edate+'&contact_guid='+vm.query.contact_guid+'&store_id='+store_id+"&plan_title="+vm.query.plan_title);
        }
    }
    function ContractDetailController($rootScope, $timeout, $http, $stateParams, $filter, $mdDialog, $document, msApi, $cookies, $qupload, $location, Contract) {
        var vm = this;
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        vm.is_cud = false;//是否可以增删改
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_contract_cud' || v == 'admin_contract'){
                vm.is_cud = true;
            }
        });
        var store_id = $cookies.get('store_id');
        vm.contract = Contract;
        init();
        //弹窗
        vm.openContractDialog = openContractDialog;
        function openContractDialog(ev, contract)
        {
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'ContractDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/contracts/dialogs/contract/contract-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Contract : Contract,
                    Contracts: vm.contracts,
                    is_cud: vm.is_cud,
                    event: ev
                }
            });
        }
        vm.createCoursesForContract = function(ev,contract){
            $location.path("/store/courses/task/"+contract.customer_id+"/"+contract.id);
        }
        function init() {
            // //合同
            // msApi.request('store.contracts.list@get').then(
            //     function (response) {
            //         if (response.data.length > 0) {
            //             vm.contracts = response;
            //         }
            //     });
        }
        // 合同附件
        msApi.request('store.contracts.contractsattachments@get', {'contracts_id': $stateParams.id}).then(
            function (response) {
                vm.contractsattachments = response.data;
            });
        //修改记录
        msApi.request('store.contracts.contractslogs@get', {'contracts_id': $stateParams.id}).then(
            function (response){
                vm.contractLogs = response.data;
            });


        // https://github.com/icattlecoder/angularQFileUpload
        // 七牛 文件上传 >>>>>>>>>>>>>>>>>>
        msApi.request('store.contracts.consults@get', {'act': 'upToken'}).then(
            function (response){
                vm.upToken = response.data.upToken;
                vm.upHost  = response.data.upHost;
            });

        //如果有课程计划列出安排的课程
        vm.signups = [];
        if (vm.contract.plan_id){
            vm.signupQuery = {
                customer_id: vm.contract.customer_id,
                sort: 'course_time',
                plan_id: vm.contract.plan_id,
                contract_num: vm.contract.contact_guid,
                limit: 10,
                page: 1
            };
            msApi.request('store.customers.signups@get', vm.signupQuery).then(
                function (response){
                    vm.signups = response;
                });
        }


        vm.selectFiles = [];
        var start = function (index) {
            vm.selectFiles[index].progress = {
                p: 0
            };

            vm.selectFiles[index].upload = $qupload.upload({
                key: 'contract/'+$filter("date")(new Date(), "yyyyMMdd")+'/'+$filter("date")(new Date(), "HHmmss")+'_'+vm.selectFiles[index].file.name,
                file: vm.selectFiles[index].file,
                token: vm.upToken
            });
            vm.selectFiles[index].upload.then(function (response) {
                // upload success
                //$log.info(response);
                //console.log("upload success");
                //console.log(response);
                var data = {
                    'act': 'saveattachment',
                    'contracts_id': $stateParams.id,
                    'url': vm.upHost+response.key,
                    'file_name': vm.selectFiles[index].file.name.split('.')[0],
                    'file_size': vm.selectFiles[index].file.size,
                    'file_type': vm.selectFiles[index].file.type
                };
                msApi.request('store.contracts.list@get', data).then(
                    function (response) {
                        $rootScope.message_success = '操作成功!';
                        $timeout(function(){$rootScope.message_success = '';},5000);
                        vm.contractsattachments.unshift(data);
                    });
                // $http({
                //     method: 'POST',
                //     url: msApi.getApiUrl('contractsattachments'),
                //     //data: angular.toJson(data)
                //     data: data
                // }).success(function (req) {
                //     console.log(req);
                //     $rootScope.message_success = '操作成功!';
                //     $timeout(function(){$rootScope.message_success = '';},5000);
                //
                //     vm.contractsattachments.push(vm.upHost+response.key);
                // }).error(function(data, state) {
                //     vm.error_arr = data;
                // });
            }, function (response) {
                // upload failure
                //$log.info(response);
                //console.log("upload failure");
                //console.log(response);
            }, function (evt) {
                // progress
                vm.selectFiles[index].progress.p = Math.floor(100 * evt.loaded / evt.totalSize);
            });
        };
        vm.abort = function (index) {
            vm.selectFiles[index].upload.abort();
            vm.selectFiles.splice(index, 1);
        };
        vm.onFileSelect = function ($files) {
            var offsetx = vm.selectFiles.length;
            for (var i = 0; i < $files.length; i++) {
                vm.selectFiles[i + offsetx] = {
                    file: $files[i]
                };
                start(i + offsetx);
            }
        };
    }
    //约课
    function CustomerSignupController($rootScope, $timeout, $stateParams, msApi, $http, $location, $cookies,$mdDialog, $document, Customer){
        var store_id = $cookies.get('store_id');
        var vm = this;
        vm.is_allow = false;//是否可无验证约课
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        console.log(vm.curr_permissions);
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_contract_signup_allow'){
                vm.is_allow = true;
                console.log(vm.is_allow );
            }
        });
        msApi.request("store.courses.categories@get", {'store_id':store_id, type: 1, 'per-page': 200}).then(//课程类型
            function (response){
                vm.categories = response.data;
            });
        vm.customer = Customer;
        vm.StrToDate = function (str) { if (str && str != '0000-00-00') return new Date(str); }
        vm.query = {
            name:'',
            store_id: store_id,
            sort: '-course_time',
            limit: 20,
            page: 1,
            customer_id:$stateParams.customer_id,
            not_start:1,
            sdate: '',
            status: 1,
            edate: ''
        };
        init();
        vm.doSearch = doSearch;
        function doSearch(){
            //vm.query.edate = vm.query.sdate;
            $rootScope.loadingProgress = true;
            msApi.resolve('store.courses.list@get', vm.query).then(function(courses){
                vm.courses = courses;
                $rootScope.loadingProgress = false;
            });
        }
        function init() {
            vm.loadingThreads = true;
            var now_date = moment(new Date()).utc().format('YYYY-MM-DD');
            vm.query.sdate = now_date;
            vm.query.edate = now_date;
            msApi.request('store.courses.list@get', vm.query).then(
                function (response) {
                    vm.courses = response;
                    vm.loadingThreads = false;
                });
        }
        //预约
        vm.signup = signup;
        function signup(ev , course){
            var data = {};
            data.courses_id = course.id;
            data.customer_id = $stateParams.customer_id;
            data.contracts_id = $stateParams.contract_id;
            data.categories_id = course.categories_id;
            data.task_id = 0;
            data.status = 0;
            data.courses_name = course.name;
            data.store_id = course.store_id;
            data.from_store_id = vm.customer.store_id;
            if (course.signup_count >= course.course_size){
                data.status = 6;//此课程预约人数已满设为备选状态
            }
            $http.get(msApi.getApiUrl('courses'), {params: {'store_id':store_id, customer_id:$stateParams.customer_id,courses_id: course.id, 'act': 'signup'}}).success(function (results) {
                if(results.status == 'error'){
                    if(vm.is_allow){
                        console.log(vm.is_allow );
                        openAllowDialog(course, data, results);
                    }else {
                        $rootScope.message_danger = results.msg;;
                        $timeout(function(){$rootScope.message_danger = '';},5000);
                    }
                }else {
                    //console.log(typeof angular.toJson(data));
                    $http({
                        method: 'POST',
                        url: msApi.getApiUrl('signups'),
                        data: data
                    }).success(function (req) {
                        $rootScope.message_success = '操作成功!';
                        $timeout(function(){$rootScope.message_success = '';},5000);
                        $location.path("/store/courses/detail/" + course.id);
                    }).error(function (data, status) {
                        $location.path("/store/courses/detail/" + course.id);
                    });
                }
            }).error(function (data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }
        //弹窗

        function openAllowDialog(course, data, error)
        {
            //ev.stopPropagation();
            $mdDialog.show({
                controller         : 'AllowDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/contracts/dialogs/signup/allow-dialog.html',
                parent             : angular.element($document.body),
                //targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    course : course,
                    data: data,
                    error: error,
                    is_allow: vm.is_allow,
                    //event: ev
                }
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.store.calendar')
        .controller('StoreCalendarController', StoreCalendarController);

    /** @ngInject */
    function StoreCalendarController($http, $mdSidenav, $mdDialog, $document, $cookies, $rootScope, $location, msApi, uiCalendarConfig)
    {
        var vm = this;
        vm.courses = [];
        vm.events = [vm.courses];
        vm.query1 = {
            'store_id':store_id, 'role_id': 3
        }
        msApi.request("store.courses.users@get", vm.query1).then(//老师
            function (response){
                vm.teachers = response.data;
                //console.log(response.data);
            });

        // Data
        var date = new Date();
        var d = date.getDate();
        var m = date.getMonth();
        var y = date.getFullYear();
        var apiName = "store.calendar.courses@get";
        var store_id = $cookies.get('store_id');
        vm.query = {
            store_id:store_id,
            "per-page": 1000,
            //limit:10000,
            page: 1
        }
        //init();
        /**
         * Initialize
         */
        function init()
        {

            // vm.loadingThreads = true;
            // // Figure out the api name
            // msApi.request(apiName, {'store_id':$cookies.get('store_id')}).then(
            //     // Success
            //     function (response)
            //     {
            //         // Load new threads
            //         //vm.events = response.data;
            //         //console.log(vm.events);
            //         // Hide the loading screen
            //         vm.loadingThreads = false;
            //     }
            // );
        }
        vm.toggleSidenavPlans = toggleSidenavPlans;
        //所有任务计划
        function toggleSidenavPlans(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
        vm.calendarUiConfig = {
            calendar: {
                editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                monthNames : ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], //月份自定义命名
                monthNamesShort: ["一月", "二月", "三月", "四月", "五月", "六月", "七月", "八月", "九月", "十月", "十一月", "十二月"], //月份缩略命名（英语比较实用：全称January可设置缩略为Jan）
                dayNames          : ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
                dayNamesShort     : ['日', '一', '二', '三', '四', '五', '六'],
                defaultView       : 'agendaWeek',
                viewRender        : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                    //vm.query.start_time = view.start.format("YYYY-MM-DD HH:mm");
                    //vm.query.end_time = view.end.format("YYYY-MM-DD HH:mm");
                    vm.query.start_time = view.start.format("YYYY-MM-DD");
                    vm.query.end_time = view.end.format("YYYY-MM-DD");
                    loadEvents();//加载活动时间
                },
                eventRender: function(event, element, view) {
                    if (view.type=='month')
                        element.find('.fc-title').append(" - " + event.description);
                    else{
                        var appendText = "<br/>" + event.description;
                        appendText += "<br>"+event.assistant_name;
                        appendText += "<br> 报名:"+event.signup_count+"/"+event.course_size;
                        element.find('.fc-title').append(appendText);
                    }

                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M'
                },
                minTime:'01:00:00',
                maxTime:'23:59:59',
                disableResizing: true,
                eventDurationEditable: false,
                eventStartEditable: false,
                eventClick        : eventDetail,
                selectable        : true,
                selectHelper      : true,
                select            : select,
                firstDay:1,
                allDaySlot:false,
                weekNumbers:true
            }
        };

        // Methods
        vm.addEvent = addEvent;
        vm.next = next;
        vm.prev = prev;

        //////////

        /**
         * Go to next on current view (week, month etc.)
         */
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();
        }

        /**
         * Show event detail
         *
         * @param calendarEvent
         * @param e
         */
        function eventDetail(calendarEvent, e)
        {
            $location.path('/store/courses/detail/'+calendarEvent.id);
            //showEventDetailDialog(calendarEvent, e);

        }

        /**
         * Add new event in between selected dates
         *
         * @param start
         * @param end
         * @param e
         */
        function select(start, end, e)
        {
            return;//禁用不弹出Event form, 第二版本再做这事
            showEventFormDialog('add', false, start, end, e);
        }


        /**
         * 加载固定日期的活动
         * @param start
         * @param end
         */
        function loadEvents(){
            $rootScope.loadingProgress = true;
            msApi.resolve(apiName, vm.query).then(function(result){
                $rootScope.loadingProgress = false;
                vm.courses = result.data;
                angular.forEach(vm.courses, function(v,k){
                    handleEvent(v);
                });
            });
        }

        function handleEvent(event){
            var isIn = false;
            for(var i=0;i<vm.events[0].length;i++){
                if (vm.events[0][i].id==event.id){
                    isIn = true;
                    break;
                }
            }
            if (!isIn){
                //支持safair时间
                event.start = event.start.replace(/-/g, "/");
                event.start = new Date(event.start+"+08:00");
                //支持safair时间
                event.end = event.end.replace(/-/g, "/");
                event.end = new Date(event.end+"+08:00");
                event.description = event.teacher_name;
                event.stick = true;



                //console.log(start.setTimeZone(TimeZone.getTimeZone("Asia/Shanghai")));
                
                //color处理
                var now = new Date();
                if (event.start < now){//过期了显示灰色
                    event.color = "#ccc";
                }else{
                    var leaveNum = event.course_size - event.signup_count;
                    if (leaveNum <= 0 ){//满
                        event.color = "#E57268";
                    }else if (leaveNum < 3){//门店紧张
                        //event.color = "#FFE168";
                        event.color = "#ff9800";
                    }

                }

                vm.events[0].push(event);
            }
        }

        function eventExist(event,events){
            var isIn = false;
            for(var i=0;i<events.length;i++){
                if (events[i].id==event.id){
                    isIn = true;
                    break;
                }
            }
            return isIn;
        }

        /**
         * Add event
         *
         * @param e
         */
        function addEvent(e)
        {
            var start = new Date(),
                end = new Date();

            showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Show event detail dialog
         * @param calendarEvent
         * @param e
         */
        function showEventDetailDialog(calendarEvent, e)
        {
            $mdDialog.show({
                controller         : 'StoreEventDetailDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/calendar/dialogs/event-detail/event-detail-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    calendarEvent      : calendarEvent,
                    showEventFormDialog: showEventFormDialog,
                    event              : e
                }
            });
        }

        /**
         * Show event add/edit form dialog
         *
         * @param type
         * @param calendarEvent
         * @param start
         * @param end
         * @param e
         */
        function showEventFormDialog(type, calendarEvent, start, end, e)
        {
            var dialogData = {
                type         : type,
                calendarEvent: calendarEvent,
                start        : start,
                end          : end
            };

            $mdDialog.show({
                controller         : 'StoreEventFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/store/calendar/dialogs/event-form/event-form-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    dialogData: dialogData
                }
            }).then(function (response)
            {
                switch ( response.type )
                {
                    case 'add':
                        // Add new
                        vm.events[0].push({
                            id   : vm.events[0].length + 20,
                            title: response.calendarEvent.title,
                            start: response.calendarEvent.start,
                            end  : response.calendarEvent.end
                        });
                        break;

                    case 'edit':
                        // Edit
                        for ( var i = 0; i < vm.events[0].length; i++ )
                        {
                            // Update
                            if ( vm.events[0][i].id === response.calendarEvent.id )
                            {
                                vm.events[0][i] = {
                                    title: response.calendarEvent.title,
                                    start: response.calendarEvent.start,
                                    end  : response.calendarEvent.end
                                };

                                break;
                            }
                        }
                        break;

                    case 'remove':
                        // Remove
                        for ( var j = 0; j < vm.events[0].length; j++ )
                        {
                            // Update
                            if ( vm.events[0][j].id === response.calendarEvent.id )
                            {
                                vm.events[0].splice(j, 1);

                                break;
                            }
                        }
                        break;
                }
            });
        }
        vm.customers = {};
        vm.simulateQuery = false;
        vm.isDisabled = false;
        vm.noCache = true;
        vm.searchText = null;
        vm.selectedItem = null;
        //vm.states = loadAll();
        vm.selectedItemChange = selectedItemChange;
        vm.searchTextChange = searchTextChange;
        vm.customesall = {};
        function searchTextChange(text) {
            if(text){
                $http.get(msApi.getApiUrl('customers'), {params: {'store_id':store_id, 'keyword':text, 'act': 'searched'}}).success(function (results) {
                    vm.customers = results.data;
                    vm.customesall = loadAll();
                    $('#customer-auto').find('input[type="search"]').focus();
                    return vm.customesall;
                });
            }else {
                vm.customesall = [];
                return vm.customesall;
            }

        }
        function selectedItemChange(item) {
            //console.log(item);
            if(item){
                vm.customer_name = item.value;
                angular.forEach(vm.customers, function (v, k) {

                    if (v['name'] == item.value) {
                        vm.query.customer_id = v['id'];
                    }
                });
            }else{
                vm.customer_name = '';
                vm.query.customer_id = 0;

            }
        }
        function loadAll() {
            var allStates = '';
            angular.forEach(vm.customers, function (v, k) {
                allStates = allStates + v.name + ', ';
            });
            allStates = allStates.substr(0, allStates.length - 2);
            return allStates.split(/, +/g).map(
                function (state) {
                    return {
                        value: state,//.toLowerCase(),
                        display: state
                    };
                });
        }
        vm.doSearchCourse = doSearchCourse;
        function doSearchCourse(){
            vm.query.teacher_ids = '';
            angular.forEach(vm.selectedThreads, function (v, k) {
                if(vm.query.teacher_ids){
                    vm.query.teacher_ids = vm.query.teacher_ids+','+v.id;
                }else {
                    vm.query.teacher_ids = v.id;
                }
            });
            $rootScope.loadingProgress = true;
            msApi.resolve('store.calendar.courses@get', vm.query).then(function(courses){vm.courses = courses;$rootScope.loadingProgress = false;});
        }
        vm.doRes = doRes;
        function doRes() {
            vm.query.teacher_ids = '';
            vm.selectedThreads = [];
            vm.query.name = '';
            vm.query.customer_id = 0;
            vm.customer_name = '';
        }
        vm.selectedThreads = [];
        vm.toggleSelectThreads = toggleSelectThreads;
        function toggleSelectThreads()
        {

            if ( vm.selectedThreads.length > 0)
            {
                vm.deselectThreads();
            }
            else
            {
                vm.selectThreads();
            }
        }

        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        function toggleSelectThread(thread, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            if ( vm.selectedThreads.indexOf(thread) > -1 )
            {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            }
            else
            {
                vm.selectedThreads.push(thread);
            }
        }
        function isSelected(thread)
        {
            //if (! vm.selectedThreads) {return;}      // If
            return vm.selectedThreads.indexOf(thread) > -1;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .factory('NotesService', NotesService);

    /** @ngInject */
    function NotesService(msApi, $q)
    {
        var service = {
            data      : [],
            addNote   : addNote,
            updateNote: updateNote,
            deleteNote: deleteNote,
            getData   : getData
        };

        /**
         * Add Note
         * @param note
         */
        function addNote(note)
        {
            service.data.push(note);
        }

        /**
         * Update Note
         * @param note
         */
        function updateNote(note)
        {
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === note.id )
                {
                    service.data[i] = note;
                }
            }
        }

        /**
         * Delete Note
         * @param note
         */
        function deleteNote(note)
        {
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === note.id )
                {
                    service.data.splice(i, 1);
                }
            }
        }

        /**
         * Get service data
         * @returns {Array}
         */
        function getData()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            msApi.request('notes.notes@get', {},
                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        return service;

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .factory('LabelsService', LabelsService);

    /** @ngInject */
    function LabelsService(msUtils, NotesService, msApi, $q)
    {
        var service = {
            data       : [],
            addLabel   : addLabel,
            updateLabel: updateLabel,
            deleteLabel: deleteLabel,
            getData    : getData
        };

        /**
         * Add label
         * @param newLabel
         */
        function addLabel(newLabel)
        {
            if ( newLabel.name === '' )
            {
                return;
            }

            service.data.push({
                id   : msUtils.guidGenerator(),
                name : newLabel.name,
                color: newLabel.color || ''
            });
        }

        /**
         * Update Label
         * @param note
         */
        function updateLabel(note)
        {
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === note.id )
                {
                    service.data[i] = note;
                }
            }
        }

        /**
         * Delete Label
         * @param label
         */
        function deleteLabel(label)
        {
            var notes = NotesService.data;

            // Look for all notes if they have the labels
            for ( var j = 0; j < notes.length; j++ )
            {
                if ( notes[j].labels.indexOf(label.id) > -1 )
                {
                    notes[j].labels.splice(notes[j].labels.indexOf(label.id), 1);
                }
            }

            // Delete label from service data
            for ( var i = 0; i < service.data.length; i++ )
            {
                if ( service.data[i].id === label.id )
                {
                    service.data.splice(i, 1);
                }
            }

        }

        /**
         * Get service data
         * @returns {Array}
         */
        function getData()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            msApi.request('notes.labels@get', {},
                // SUCCESS
                function (response)
                {
                    // Attach the data
                    service.data = response.data;

                    // Resolve the promise
                    deferred.resolve(response);
                },

                // ERROR
                function (response)
                {
                    // Reject the promise
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        return service;

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.main-store.stores', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        var error_url = msApiProvider.getErrorUrl();
        // State
        $stateProvider
            .state('app.main-store', {
                abstract: true,
                url     : '/main-store'
            })
            .state('app.main-store.stores', {
                url      : '/stores',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/apps/main-store/stores/stores.html',
                        controller : 'MSStoresController as vm'
                    }
                },
                resolve  : {
                    Stores: function (msApi){
                        return msApi.resolve('chainstore.stores@get');
                    }
                },
                data: {
                    permissions: {
                        //except: ['anonymous'],
                        only:['admin_store', 'admin_store_list'],
                        redirectTo: error_url
                    }
                },
                bodyClass: 'timeline'
            });

        // API

        //console.log(msApiProvider.getApiUrl());
        //msApiProvider.register('chainstore.stores', ['app/data/chainstore/stores.json']);
        msApiProvider.register('chainstore.stores', [msApiProvider.getApiUrl() + 'stores']);

        var role_id = msApiProvider.getCookies('role_id');
        if (role_id == 1) {//超管
            // Navigation
            msNavigationServiceProvider.saveItem('main-store.stores', {
                title: '店铺',
                state: 'app.main-store.stores'
            });
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.main-store.stores')
        .controller('MSStoresController', MSStoresController);

    /** @ngInject */
    function MSStoresController($q, msApi, Stores, $cookies, $mdDialog, $document)
    {
        var vm = this;
        vm.curr_permissions = $cookies.getObject('curr_permissions');
        vm.is_cud = false;//是否可以增删改
        angular.forEach(vm.curr_permissions, function (v, k) {
            if( v == 'admin_store_cud' || v == 'admin_store'){
                vm.is_cud = true;
            }
        });
        //console.log('main-store');
        // Data
        var store_id = $cookies.get('store_id');
        vm.stores = Stores.data;
        angular.forEach(vm.stores, function(v,k){
            v.current_store_id = store_id;
        });
        vm.switchStore = switchStore;
        //切换门店
        function switchStore(ev, store){
            vm.store_name = store.name;
            $cookies.put('store_name',vm.store_name);
            $cookies.put('store_id',store.id);
            $window.location.reload();
        }
        //弹窗
        vm.openStoretDialog = openStoretDialog;
        function openStoretDialog(ev, store)
        {
            ev.stopPropagation();
            $mdDialog.show({
                controller         : 'StoreDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/main-store/stores/dialogs/store-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Store : store,
                    Stores: vm.stores,
                    event: ev
                }
            });
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.dashboards.server',
            [
                // 3rd Party Dependencies
                'nvd3',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.dashboards_server', {
            url      : '/dashboard-server',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/server/dashboard-server.html',
                    controller : 'DashboardServerController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('dashboard.server@get');
                }
            },
            bodyClass: 'dashboard-server'
        });

        // Api
        msApiProvider.register('dashboard.server', ['app/data/dashboard/server/data.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.server')
        .controller('DashboardServerController', DashboardServerController);

    /** @ngInject */
    function DashboardServerController($scope, $interval, DashboardData)
    {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;

        // Widget 1
        vm.widget1 = {
            title: vm.dashboardData.widget1.title,
            chart: {
                options: {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#4caf50', '#3f51b5', '#ff5722'],
                        height                 : 320,
                        margin                 : {
                            top   : 32,
                            right : 32,
                            bottom: 32,
                            left  : 48
                        },
                        useInteractiveGuideline: true,
                        clipVoronoi            : false,
                        interpolate            : 'cardinal',
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + ' min.';
                            },
                            showMaxMin: false
                        },
                        yAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + ' MB';
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        },
                        legend                 : {
                            margin    : {
                                top   : 8,
                                right : 0,
                                bottom: 32,
                                left  : 0
                            },
                            rightAlign: false
                        }
                    }
                },
                data   : vm.dashboardData.widget1.chart
            }
        };

        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = {
            title   : vm.dashboardData.widget4.title,
            value   : vm.dashboardData.widget4.value,
            footnote: vm.dashboardData.widget4.footnote,
            detail  : vm.dashboardData.widget4.detail,
            chart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'lineChart',
                        color       : ['rgba(0, 0, 0, 0.27)'],
                        height      : 50,
                        margin      : {
                            top   : 8,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        duration    : 1,
                        clipEdge    : true,
                        interpolate : 'cardinal',
                        interactive : false,
                        isArea      : true,
                        showLegend  : false,
                        showControls: false,
                        showXAxis   : false,
                        showYAxis   : false,
                        x           : function (d)
                        {
                            return d.x;
                        },
                        y           : function (d)
                        {
                            return d.y;
                        },
                        yDomain     : [0, 4]
                    }
                },
                data   : vm.dashboardData.widget4.chart
            },
            init    : function ()
            {
                // Run this function once to initialize the widget

                // Grab the x value
                var lastIndex = vm.dashboardData.widget4.chart[0].values.length - 1,
                    x = vm.dashboardData.widget4.chart[0].values[lastIndex].x;

                /**
                 * Emulate constant data flow
                 *
                 * @param min
                 * @param max
                 */
                function latencyTicker(min, max)
                {
                    // Increase the x value
                    x++;

                    var randomNumber = Math.floor(Math.random() * (max - min + 1)) + min;

                    var newValue = {
                        x: x,
                        y: randomNumber
                    };

                    vm.widget4.chart.data[0].values.shift();
                    vm.widget4.chart.data[0].values.push(newValue);

                    // Randomize the value
                    vm.widget4.value = 20 + randomNumber + 'ms';
                }

                // Set interval
                var latencyTickerInterval = $interval(function ()
                {
                    latencyTicker(1, 4);
                }, 1000);

                // Cleanup
                $scope.$on('$destroy', function ()
                {
                    $interval.cancel(latencyTickerInterval);
                });
            }
        };

        // Widget 5
        vm.widget5 = vm.dashboardData.widget5;

        // Widget 6
        vm.widget6 = {
            title: vm.dashboardData.widget6.title,
            chart: {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#03A9F4'],
                        height                 : 140,
                        margin                 : {
                            top   : 8,
                            right : 32,
                            bottom: 16,
                            left  : 48
                        },
                        duration               : 1,
                        clipEdge               : true,
                        clipVoronoi            : false,
                        interpolate            : 'cardinal',
                        isArea                 : true,
                        useInteractiveGuideline: true,
                        showLegend             : false,
                        showControls           : false,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        yDomain                : [0, 100],
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + ' sec.';
                            },
                            showMaxMin: false
                        },
                        yAxis                  : {
                            tickFormat: function (d)
                            {
                                return d + '%';
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data   : vm.dashboardData.widget6.chart
            },
            init : function ()
            {
                // Run this function once to initialize the widget

                // Grab the x value
                var lastIndex = vm.dashboardData.widget6.chart[0].values.length - 1,
                    x = vm.dashboardData.widget6.chart[0].values[lastIndex].x;

                /**
                 * Emulate constant data flow
                 *
                 * @param min
                 * @param max
                 */
                function cpuTicker(min, max)
                {
                    // Increase the x value
                    x = x + 5;

                    var newValue = {
                        x: x,
                        y: Math.floor(Math.random() * (max - min + 1)) + min
                    };

                    vm.widget6.chart.data[0].values.shift();
                    vm.widget6.chart.data[0].values.push(newValue);
                }

                // Set interval
                var cpuTickerInterval = $interval(function ()
                {
                    cpuTicker(0, 100);
                }, 5000);

                // Cleanup
                $scope.$on('$destroy', function ()
                {
                    $interval.cancel(cpuTickerInterval);
                });
            }
        };

        // Widget 7
        vm.widget7 = {
            title    : vm.dashboardData.widget7.title,
            table    : vm.dashboardData.widget7.table,
            dtOptions: {
                dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                pageLength: 10,
                lengthMenu: [10, 20, 50, 100],
                autoWidth : false,
                responsive: true,
                columnDefs: [
                    {
                        width  : '20%',
                        targets: [0, 1, 2, 3, 4]
                    }
                ],
                columns   : [
                    {},
                    {},
                    {
                        render: function (data, type)
                        {
                            if ( type === 'display' )
                            {
                                return data + ' KB/s';
                            }
                            else
                            {
                                return data;
                            }
                        }
                    },
                    {
                        render: function (data, type)
                        {
                            if ( type === 'display' )
                            {
                                return data + '%';
                            }
                            else
                            {
                                return data;
                            }
                        }
                    },
                    {
                        render: function (data, type)
                        {
                            if ( type === 'display' )
                            {
                                var el = angular.element(data);
                                el.html(el.text() + ' MB');

                                return el[0].outerHTML;
                            }
                            else
                            {
                                return data;
                            }
                        }
                    }
                ]
            }
        };

        // Widget 8
        vm.widget8 = vm.dashboardData.widget8;

        // Methods

        //////////

        // Init Widget 4
        vm.widget4.init();

        // Init Widget 6
        vm.widget6.init();
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.project',
            [
                // 3rd Party Dependencies
                'nvd3',
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        var store_id = msApiProvider.getCookies('store_id');
        // State
        $stateProvider.state('app.dashboards_project', {
            url      : '/dashboard-project',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/project/dashboard-project.html',
                    controller : 'DashboardProjectController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('dashboard.project@get', {'store_id':store_id, 'act': 'home'});
                },
                DashboardData1: function (msApi)
                {
                    return msApi.resolve('dashboard.project1@get');
                }
            },
            bodyClass: 'dashboard-project'
        });

        // Api
        msApiProvider.register('dashboard.project1', ['app/data/dashboard/project/data.json']);
        msApiProvider.register('dashboard.project', [msApiProvider.getApiUrl() + 'users']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.project')
        .controller('DashboardProjectController', DashboardProjectController);

    /** @ngInject */
    function DashboardProjectController($scope, $interval, $mdSidenav, DashboardData, DashboardData1, $cookies)
    {
        var vm = this;
        vm.store_name = $cookies.get('store_name');

        // Data
        vm.data = DashboardData.data;
        //console.log(vm.data.today_courses.length);
        //console.log(vm.data.customers.length);
        vm.dashboardData = DashboardData1;
        vm.projects = vm.dashboardData.projects;

        // Widget 1
        vm.widget1 = vm.dashboardData.widget1;

        // Widget 2
        vm.widget2 = vm.dashboardData.widget2;

        // Widget 3
        vm.widget3 = vm.dashboardData.widget3;

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;

        // Widget 5
        vm.widget5 = {
            title       : vm.dashboardData.widget5.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'multiBarChart',
                        color       : ['#03a9f4', '#b3e5fc'],
                        height      : 420,
                        margin      : {
                            top   : 8,
                            right : 16,
                            bottom: 32,
                            left  : 32
                        },
                        clipEdge    : true,
                        groupSpacing: 0.3,
                        reduceXTicks: false,
                        stacked     : true,
                        duration    : 250,
                        x           : function (d)
                        {
                            return d.x;
                        },
                        y           : function (d)
                        {
                            return d.y;
                        },
                        yAxis       : {
                            tickFormat: function (d)
                            {
                                return d;
                            }
                        },
                        legend      : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        controls    : {
                            margin: {
                                top   : 8,
                                bottom: 32
                            }
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            supporting  : {
                widgets: {
                    created  : {
                        data : vm.dashboardData.widget5.supporting.created,
                        chart: {
                            data: []
                        }
                    },
                    closed   : {
                        data : vm.dashboardData.widget5.supporting.closed,
                        chart: {
                            data: []
                        }
                    },
                    reOpened : {
                        data : vm.dashboardData.widget5.supporting.reOpened,
                        chart: {
                            data: []
                        }
                    },
                    wontFix  : {
                        data : vm.dashboardData.widget5.supporting.wontFix,
                        chart: {
                            data: []
                        }
                    },
                    needsTest: {
                        data : vm.dashboardData.widget5.supporting.needsTest,
                        chart: {
                            data: []
                        }
                    },
                    fixed    : {
                        data : vm.dashboardData.widget5.supporting.fixed,
                        chart: {
                            data: []
                        }
                    }
                },
                chart  : {
                    config : {
                        refreshDataOnly: true,
                        deepWatchData  : true
                    },
                    options: {
                        chart: {
                            type                   : 'lineChart',
                            color                  : ['#03A9F4'],
                            height                 : 50,
                            margin                 : {
                                top   : 8,
                                right : 0,
                                bottom: 0,
                                left  : 0
                            },
                            isArea                 : true,
                            interpolate            : 'cardinal',
                            clipEdge               : true,
                            duration               : 500,
                            showXAxis              : false,
                            showYAxis              : false,
                            showLegend             : false,
                            useInteractiveGuideline: true,
                            x                      : function (d)
                            {
                                return d.x;
                            },
                            y                      : function (d)
                            {
                                return d.y;
                            },
                            yDomain                : [0, 9],
                            xAxis                  : {
                                tickFormat: function (d)
                                {
                                    return vm.widget5.days[d];
                                }
                            },
                            interactiveLayer       : {
                                tooltip: {
                                    gravity: 'e',
                                    classes: 'gravity-e'
                                }
                            }
                        }
                    },
                    data   : []
                }
            },
            days        : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges      : vm.dashboardData.widget5.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget5.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget5.mainChart, function (chartData, index)
                {
                    vm.widget5.mainChart.data[index] = {
                        key   : chartData.key,
                        values: chartData.values[range]
                    };
                });

                /**
                 * Do the same thing for the supporting widgets but they
                 * only have 1 dataset so we can do [0] without needing to
                 * iterate through in their data arrays
                 */
                angular.forEach(vm.dashboardData.widget5.supporting, function (widget, name)
                {
                    vm.widget5.supporting.widgets[name].chart.data[0] = {
                        key   : widget.chart.key,
                        values: widget.chart.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget5.changeRange('TW');
            }
        };

        // Widget 6
        vm.widget6 = {
            title       : vm.dashboardData.widget6.title,
            mainChart   : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type        : 'pieChart',
                        color       : ['#f44336', '#9c27b0', '#03a9f4', '#e91e63'],
                        height      : 400,
                        margin      : {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        donut       : true,
                        clipEdge    : true,
                        cornerRadius: 0,
                        labelType   : 'percent',
                        padAngle    : 0.02,
                        x           : function (d)
                        {
                            return d.label;
                        },
                        y           : function (d)
                        {
                            return d.value;
                        },
                        tooltip     : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : []
            },
            footerLeft  : vm.dashboardData.widget6.footerLeft,
            footerRight : vm.dashboardData.widget6.footerRight,
            ranges      : vm.dashboardData.widget6.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget6.currentRange = range;

                /**
                 * Update main chart data by iterating through the
                 * chart dataset and separately adding every single
                 * dataset by hand.
                 *
                 * You MUST NOT swap the entire data object by doing
                 * something similar to this:
                 * vm.widget.mainChart.data = chartData
                 *
                 * It would be easier but it won't work with the
                 * live updating / animated charts due to how d3
                 * works.
                 *
                 * If you don't need animated / live updating charts,
                 * you can simplify these greatly.
                 */
                angular.forEach(vm.dashboardData.widget6.mainChart, function (data, index)
                {
                    vm.widget6.mainChart.data[index] = {
                        label: data.label,
                        value: data.values[range]
                    };
                });
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget6.changeRange('TW');
            }
        };

        // Widget 7
        vm.widget7 = {
            title       : vm.dashboardData.widget7.title,
            ranges      : vm.dashboardData.widget7.ranges,
            schedule    : vm.dashboardData.widget7.schedule,
            currentRange: 'T'
        };

        // Widget 8
        vm.widget8 = {
            title    : vm.dashboardData.widget8.title,
            mainChart: {
                options: {
                    chart: {
                        type     : 'pieChart',
                        color    : ['#f44336', '#9c27b0', '#03a9f4', '#e91e63', '#ffc107'],
                        height   : 400,
                        margin   : {
                            top   : 0,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        labelType: 'percent',
                        x        : function (d)
                        {
                            return d.label;
                        },
                        y        : function (d)
                        {
                            return d.value;
                        },
                        tooltip  : {
                            gravity: 's',
                            classes: 'gravity-s'
                        }
                    }
                },
                data   : vm.dashboardData.widget8.mainChart
            }
        };

        // Widget 9
        vm.widget9 = {
            title       : vm.dashboardData.widget9.title,
            weeklySpent : {
                title    : vm.dashboardData.widget9.weeklySpent.title,
                count    : vm.dashboardData.widget9.weeklySpent.count,
                chartData: []
            },
            totalSpent  : {
                title    : vm.dashboardData.widget9.totalSpent.title,
                count    : vm.dashboardData.widget9.totalSpent.count,
                chartData: []
            },
            remaining   : {
                title    : vm.dashboardData.widget9.remaining.title,
                count    : vm.dashboardData.widget9.remaining.count,
                chartData: []
            },
            totalBudget : vm.dashboardData.widget9.totalBudget,
            chart       : {
                config : {
                    refreshDataOnly: true,
                    deepWatchData  : true
                },
                options: {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#00BCD4'],
                        height                 : 50,
                        margin                 : {
                            top   : 8,
                            right : 0,
                            bottom: 0,
                            left  : 0
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        yDomain                : [0, 9],
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                return vm.widget9.days[d];
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 'e',
                                classes: 'gravity-e'
                            }
                        }
                    }
                }
            },
            days        : ['Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat', 'Sun'],
            ranges      : vm.dashboardData.widget9.ranges,
            currentRange: '',
            changeRange : function (range)
            {
                vm.widget9.currentRange = range;

                /**
                 * Update mini charts. They only have 1 dataset
                 * so we can do [0] without needing to iterate
                 * through in their data arrays
                 */
                vm.widget9.weeklySpent.chartData[0] = {
                    key   : vm.dashboardData.widget9.weeklySpent.chart.label,
                    values: vm.dashboardData.widget9.weeklySpent.chart.values[range]
                };

                vm.widget9.totalSpent.chartData[0] = {
                    key   : vm.dashboardData.widget9.totalSpent.chart.label,
                    values: vm.dashboardData.widget9.totalSpent.chart.values[range]
                };

                vm.widget9.remaining.chartData[0] = {
                    key   : vm.dashboardData.widget9.remaining.chart.label,
                    values: vm.dashboardData.widget9.remaining.chart.values[range]
                };
            },
            init        : function ()
            {
                // Run this function once to initialize widget

                /**
                 * Update the range for the first time
                 */
                vm.widget9.changeRange('TW');
            }
        };

        // Widget 10
        vm.widget10 = vm.dashboardData.widget10;

        // Widget 11
        vm.widget11 = {
            title    : vm.dashboardData.widget11.title,
            table    : vm.dashboardData.widget11.table,
            dtOptions: {
                dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
                pagingType: 'simple',
                autoWidth : false,
                responsive: true,
                order     : [1, 'asc'],
                columnDefs: [
                    {
                        width    : '40',
                        orderable: false,
                        targets  : [0]
                    },
                    {
                        width  : '20%',
                        targets: [1, 2, 3, 4, 5]
                    }
                ]
            }
        };

        // Now widget
        vm.nowWidget = {
            now   : {
                second: '',
                minute: '',
                hour  : '',
                day   : '',
                month : '',
                year  : ''
            },
            ticker: function ()
            {
                var now = moment();
                vm.nowWidget.now = {
                    second : now.format('ss'),
                    minute : now.format('mm'),
                    hour   : now.format('HH'),
                    day    : now.format('D'),
                    weekDay: now.format('dddd'),
                    month  : now.format('MMMM'),
                    year   : now.format('YYYY')
                };
            }
        };

        // Weather widget
        vm.weatherWidget = vm.dashboardData.weatherWidget;

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.selectProject = selectProject;

        //////////
        vm.selectedProject = vm.projects[0];

        // Initialize Widget 5
        vm.widget5.init();

        // Initialize Widget 6
        vm.widget6.init();

        // Initialize Widget 9
        vm.widget9.init();

        // Now widget ticker
        vm.nowWidget.ticker();

        var nowWidgetTicker = $interval(vm.nowWidget.ticker, 1000);

        $scope.$on('$destroy', function ()
        {
            $interval.cancel(nowWidgetTicker);
        });

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Select project
         */
        function selectProject(project)
        {
            vm.selectedProject = project;
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.analytics',
            [
                // 3rd Party Dependencies
                'nvd3'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        // State
        $stateProvider.state('app.dashboards_analytics', {
            url      : '/dashboard-analytics',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/apps/dashboards/analytics/dashboard-analytics.html',
                    controller : 'DashboardAnalyticsController as vm'
                }
            },
            resolve  : {
                DashboardData: function (msApi)
                {
                    return msApi.resolve('dashboard.analytics@get');
                }
            },
            bodyClass: 'dashboard-analytics'
        });

        // Api
        msApiProvider.register('dashboard.analytics', ['app/data/dashboard/analytics/data.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards.analytics')
        .controller('DashboardAnalyticsController', DashboardAnalyticsController);

    /** @ngInject */
    //function DashboardAnalyticsController(DashboardData, uiGmapGoogleMapApi)
    function DashboardAnalyticsController(DashboardData)
    {
        var vm = this;

        // Data
        vm.dashboardData = DashboardData;
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];

        vm.widget1 = {
            title             : vm.dashboardData.widget1.title,
            onlineUsers       : vm.dashboardData.widget1.onlineUsers,
            bigChart          : {
                options: {
                    chart: {
                        type                   : 'lineWithFocusChart',
                        color                  : ['#2196F3'],
                        height                 : 400,
                        margin                 : {
                            top   : 32,
                            right : 32,
                            bottom: 64,
                            left  : 48
                        },
                        isArea                 : true,
                        useInteractiveGuideline: true,
                        duration               : 1,
                        clipEdge               : true,
                        clipVoronoi            : false,
                        interpolate            : 'cardinal',
                        showLegend             : false,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            showMaxMin: false,
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%b %d')(date);
                            }
                        },
                        yAxis                  : {
                            showMaxMin: false
                        },
                        x2Axis                 : {
                            showMaxMin: false,
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%b %d')(date);
                            }
                        },
                        y2Axis                 : {
                            showMaxMin: false
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        },
                        legend                 : {
                            margin    : {
                                top   : 8,
                                right : 0,
                                bottom: 32,
                                left  : 0
                            },
                            rightAlign: false
                        }
                    }
                },
                data   : vm.dashboardData.widget1.bigChart.chart
            },
            sessions          : {
                title   : vm.dashboardData.widget1.sessions.title,
                value   : vm.dashboardData.widget1.sessions.value,
                previous: vm.dashboardData.widget1.sessions.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#03A9F4'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.sessions.chart
            },
            pageviews         : {
                title   : vm.dashboardData.widget1.pageviews.title,
                value   : vm.dashboardData.widget1.pageviews.value,
                previous: vm.dashboardData.widget1.pageviews.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#3F51B5'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.pageviews.chart
            },
            pagesSessions     : {
                title   : vm.dashboardData.widget1.pagesSessions.title,
                value   : vm.dashboardData.widget1.pagesSessions.value,
                previous: vm.dashboardData.widget1.pagesSessions.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#E91E63'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.pagesSessions.chart
            },
            avgSessionDuration: {
                title   : vm.dashboardData.widget1.avgSessionDuration.title,
                value   : vm.dashboardData.widget1.avgSessionDuration.value,
                previous: vm.dashboardData.widget1.avgSessionDuration.previous,
                options : {
                    chart: {
                        type                   : 'lineChart',
                        color                  : ['#009688'],
                        height                 : 40,
                        margin                 : {
                            top   : 4,
                            right : 4,
                            bottom: 4,
                            left  : 4
                        },
                        isArea                 : true,
                        interpolate            : 'cardinal',
                        clipEdge               : true,
                        duration               : 500,
                        showXAxis              : false,
                        showYAxis              : false,
                        showLegend             : false,
                        useInteractiveGuideline: true,
                        x                      : function (d)
                        {
                            return d.x;
                        },
                        y                      : function (d)
                        {
                            return d.y;
                        },
                        xAxis                  : {
                            tickFormat: function (d)
                            {
                                var date = new Date(new Date().setDate(new Date().getDate() + d));
                                return d3.time.format('%A, %B %d, %Y')(date);
                            }
                        },
                        yAxis                  : {
                            tickFormat: function (d)
                            {
                                var formatTime = d3.time.format('%M:%S');
                                return formatTime(new Date('2012', '0', '1', '0', '0', d));
                            }
                        },
                        interactiveLayer       : {
                            tooltip: {
                                gravity: 's',
                                classes: 'gravity-s'
                            }
                        }
                    }
                },
                data    : vm.dashboardData.widget1.avgSessionDuration.chart
            }
        };

        // Widget 2
        vm.widget2 = {
            title: vm.dashboardData.widget2.title
        };

        // Widget 3
        vm.widget3 = {
            title       : vm.dashboardData.widget3.title,
            pages       : vm.dashboardData.widget3.pages,
            ranges      : vm.dashboardData.widget3.ranges,
            currentRange: vm.dashboardData.widget3.currentRange,
            changeRange : function (range)
            {
                vm.widget3.currentRange(range);
            }
        };

        // Widget 4
        vm.widget4 = vm.dashboardData.widget4;


        // Methods

        //////////

        // Widget 2
        // uiGmapGoogleMapApi.then(function ()
        // {
        //     vm.widget2.map = vm.dashboardData.widget2.map;
        // });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.chat', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        // State
        $stateProvider.state('app.chat', {
            url    : '/chat',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/apps/chat/chat.html',
                    controller : 'ChatController as vm'
                }
            },
            resolve: {
                Contacts: function (msApi)
                {
                    return msApi.resolve('chat.contacts@get');
                },
                User    : function (msApi)
                {
                    return msApi.resolve('chat.user@get');
                }
            }
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/apps/chat');

        // Api
        // Contacts data must be alphabatically ordered.
        msApiProvider.register('chat.contacts', ['app/data/chat/contacts.json']);
        msApiProvider.register('chat.chats', ['app/data/chat/chats/:id.json']);
        msApiProvider.register('chat.user', ['app/data/chat/user.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('apps.chat', {
            title : 'Chat',
            icon  : 'icon-hangouts',
            state : 'app.chat',
            badge : {
                content: 13,
                color  : '#09d261'
            },
            weight: 5
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.chat')
        .factory('ChatsService', ChatsService);

    /** @ngInject */
    function ChatsService($q, msApi)
    {
        
        var service = {
            chats         : {},
            contacts      : [],
            getContactChat: getContactChat
        };

        /**
         * Get contact chat from the server
         *
         * @param contactId
         * @returns {*}
         */
        function getContactChat(contactId)
        {

            // Create a new deferred object
            var deferred = $q.defer();

            // If contact doesn't have lastMessage, create a new chat
            if ( !service.contacts.getById(contactId).lastMessage)
            {
                service.chats[contactId] = [];

                deferred.resolve(service.chats[contactId]);
            }

            // If the chat exist in the service data, do not request
            if ( service.chats[contactId] )
            {
                deferred.resolve(service.chats[contactId]);
                
                return deferred.promise;
            }

            // Request the chat with the contactId
            msApi.request('chat.chats@get', {id: contactId},

                // SUCCESS
                function (response)
                {
                    // Attach the chats
                    service.chats[contactId] = response.data;

                    // Resolve the promise
                    deferred.resolve(service.chats[contactId]);
                },

                // ERROR
                function (response)
                {
                    deferred.reject(response);
                }
            );

            return deferred.promise;
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };
        return service;
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.simple-table', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.components_tables_simple-table', {
            url  : '/components/table/simple-table',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/tables/simple-table/simple-table.html',
                    controller : 'SimpleTableController as vm'
                }
            },
            resolve: {
                Employees: function (msApi)
                {
                    return msApi.resolve('tables.employees@get');
                }
            }
        });

        // Api
        msApiProvider.register('tables.employees', ['app/data/tables/employees.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.simple-table')
        .controller('SimpleTableController', SimpleTableController);

    /** @ngInject */
    function SimpleTableController(Employees)
    {
        var vm = this;

        // Data
        vm.employees = Employees.data;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.datatable',
            [
                // 3rd Party Dependencies
                'datatables'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.components_tables_datatable', {
            url    : '/components/table/datatable',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/components/tables/datatable/datatable.html',
                    controller : 'DatatableController as vm'
                }
            },
            resolve: {
                Employees: function (msApi)
                {
                    return msApi.resolve('tables.employees100@get');
                }
            }
        });

        // Api
        msApiProvider.register('tables.employees100', ['app/data/tables/employees100.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.tables.datatable')
        .controller('DatatableController', DatatableController);

    /** @ngInject */
    function DatatableController(Employees)
    {
        var vm = this;

        // Data
        vm.employees = Employees.data;

        vm.dtOptions = {
            dom       : '<"top"f>rt<"bottom"<"left"<"length"l>><"right"<"info"i><"pagination"p>>>',
            pagingType: 'simple',
            autoWidth : false,
            responsive: true
        };

        // Methods

        //////////
    }

})();
(function () {
    'use strict';

    /**
     * Replace those for demo assets
     * img/                     >>>            assets/angular-material-assets/img/
     * 'icons                   >>>            'assets/angular-material-assets/icons/
     */
    angular
        .module('app.components.material-docs', ['ngMaterial', 'ngMessages'])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider, $stateProvider, ELEMENTS_NAVIGATION, LAYOUT_NAVIGATION, THEMING_NAVIGATION) {
        msNavigationServiceProvider.saveItem('components.elements', {
            title : 'Angular Material Elements',
            icon  : 'icon-layers',
            weight: 0
        });

        msNavigationServiceProvider.saveItem('components.elements.inputs', {
            title : 'Inputs',
            weight: 0
        });

        msNavigationServiceProvider.saveItem('components.elements.buttons', {
            title : 'Buttons',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('components.elements.content-elements', {
            title : 'Content Elements',
            weight: 2
        });

        msNavigationServiceProvider.saveItem('components.elements.lists', {
            title : 'Lists',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('components.elements.menus', {
            title : 'Menus',
            weight: 4
        });

        msNavigationServiceProvider.saveItem('components.elements.progress', {
            title : 'Progress',
            weight: 5
        });

        msNavigationServiceProvider.saveItem('components.elements.others', {
            title : 'Others',
            weight: 6
        });

        msNavigationServiceProvider.saveItem('components.material_layout', {
            title : 'Angular Material Layout',
            icon  : 'icon-view-quilt',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('components.material_theming', {
            title : 'Angular Material Theming',
            icon  : 'icon-palette-advanced',
            weight: 1
        });


        angular.forEach(ELEMENTS_NAVIGATION, function (component) {

            $stateProvider.state('app.docs_' + component.stateName, {
                url  : '/components/angular-material/elements/' + component.url,
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/material-docs/material-doc-template.html',
                        controller : 'DocTemplateController as vm'
                    }
                },
                data : component
            });

            // Navigation
            msNavigationServiceProvider.saveItem(component.navPath + '.' + component.url, {
                title : component.name,
                state : 'app.docs_' + component.stateName,
                weight: component.weight
            });
        });

        angular.forEach(LAYOUT_NAVIGATION, function (component) {

            $stateProvider.state('app.docs_' + component.stateName, {
                url  : '/components/angular-material/' + component.url,
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/material-docs/material-doc-basic-template.html',
                        controller : 'BasicDocTemplateController as vm',
                    },
                },
                 data : {
                    component: component,
                    parentTitle    : 'ANGULAR MATERIAL LAYOUT'
                }
            });

            // Navigation
            msNavigationServiceProvider.saveItem('components.material_layout.' + component.url, {
                title : component.name,
                state : 'app.docs_' + component.stateName,
                weight: component.weight
            });
        });

        angular.forEach(THEMING_NAVIGATION, function (component) {

            $stateProvider.state('app.docs_' + component.stateName, {
                url  : '/components/angular-material/' + component.url,
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/material-docs/material-doc-basic-template.html',
                        controller : 'BasicDocTemplateController as vm',
                    },
                },
                data : {
                    component: component,
                    parentTitle    : 'ANGULAR MATERIAL THEMING'
                }
            });

            // Navigation
            msNavigationServiceProvider.saveItem('components.material_theming.' + component.url, {
                title : component.name,
                state : 'app.docs_' + component.stateName,
                weight: component.weight
            });
        });

    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components.material-docs')
        .controller('LayoutCtrl', LayoutCtrl)
        .controller('LayoutTipsCtrl', LayoutTipsCtrl);

    /** @ngInject */
    function LayoutCtrl($scope, $attrs, $location, $rootScope)
    {
        $rootScope.currentComponent = $rootScope.currentDoc = null;

        $scope.exampleNotEditable = true;
        $scope.layoutDemo = {
            mainAxis : 'center',
            crossAxis: 'center',
            direction: 'row'
        };
        $scope.layoutAlign = function ()
        {
            return $scope.layoutDemo.mainAxis +
                   ($scope.layoutDemo.crossAxis ? ' ' + $scope.layoutDemo.crossAxis : '');
        };
    }

    /** @ngInject */
    function LayoutTipsCtrl()
    {
        var self = this;

        /*
         * Flex Sizing - Odd
         */
        self.toggleButtonText = 'Hide';

        self.toggleContentSize = function ()
        {
            var contentEl = angular.element(document.getElementById('toHide'));

            contentEl.toggleClass('ng-hide');

            self.toggleButtonText = contentEl.hasClass('ng-hide') ? 'Show' : 'Hide';
        };
    }

})();
(function ()
{
    'use strict';
    angular
        .module('app.components.material-docs')
        .factory('$demoAngularScripts', DemoAngularScripts);

    function DemoAngularScripts()
    {
        var scripts = [
            'angular.js',
            'angular-animate.min.js',
            'angular-route.min.js',
            'angular-aria.min.js',
            'angular-messages.min.js'
        ];

        return {
            all: allAngularScripts
        };

        function allAngularScripts()
        {
            return scripts.map(fullPathToScript);
        }

        function fullPathToScript(script)
        {
            return "https://ajax.googleapis.com/ajax/libs/angularjs/1.4.8/" + script;
            //return "https://ajax.googleapis.com/ajax/libs/angularjs/" + BUILDCONFIG.ngVersion + "/" + script;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.components.material-docs')
        .directive('demoInclude', demoInclude)

    function demoInclude($q, $http, $compile, $templateCache, $timeout)
    {
        return {
            restrict: 'E',
            link    : postLink
        };

        function postLink(scope, element, attr)
        {
            var demoContainer;

            // Interpret the expression given as `demo-include files="something"`
            var files = scope.$eval(attr.files) || {};
            var ngModule = scope.$eval(attr.module) || '';

            $timeout(handleDemoIndexFile);

            /**
             * Fetch the index file, and if it contains its own ngModule
             * then bootstrap a new angular app with that ngModule. Otherwise, compile
             * the demo into the current ng-app.
             */
            function handleDemoIndexFile()
            {
                files.index.contentsPromise.then(function (contents)
                {
                    demoContainer = angular.element(
                        '<div class="demo-content ' + ngModule + '">'
                    );

                    var isStandalone = !!ngModule;
                    var demoScope;
                    var demoCompileService;
                    if ( isStandalone )
                    {
                        angular.bootstrap(demoContainer[0], [ngModule]);
                        demoScope = demoContainer.scope();
                        demoCompileService = demoContainer.injector().get('$compile');

                        scope.$on('$destroy', function ()
                        {
                            demoScope.$destroy();
                        });

                    }
                    else
                    {
                        demoScope = scope.$new();
                        demoCompileService = $compile;
                    }

                    // Once everything is loaded, put the demo into the DOM
                    $q.all([
                        handleDemoStyles(),
                        handleDemoTemplates()
                    ]).finally(function ()
                    {

                        demoScope.$evalAsync(function ()
                        {
                            element.append(demoContainer);
                            demoContainer.html(contents);
                            demoCompileService(demoContainer.contents())(demoScope);
                        });


                    });
                });

            }


            /**
             * Fetch the demo styles, and append them to the DOM.
             */
            function handleDemoStyles()
            {
                return $q.all(files.css.map(function (file)
                    {
                        return file.contentsPromise;
                    }))
                    .then(function (styles)
                    {
                        styles = styles.join('\n'); //join styles as one string

                        var styleElement = angular.element('<style>' + styles + '</style>');
                        document.body.appendChild(styleElement[0]);

                        scope.$on('$destroy', function ()
                        {
                            styleElement.remove();
                        });
                    });

            }

            /**
             * Fetch the templates for this demo, and put the templates into
             * the demo app's templateCache, with a url that allows the demo apps
             * to reference their templates local to the demo index file.
             *
             * For example, make it so the dialog demo can reference templateUrl
             * 'my-dialog.tmpl.html' instead of having to reference the url
             * 'generated/material.components.dialog/demo/demo1/my-dialog.tmpl.html'.
             */
            function handleDemoTemplates()
            {

                return $q.all(files.html.map(function (file)
                {

                    return file.contentsPromise.then(function (contents)
                    {
                        // Get the $templateCache instance that goes with the demo's specific ng-app.
                        var demoTemplateCache = demoContainer.injector().get('$templateCache');
                        demoTemplateCache.put(file.name, contents);

                        scope.$on('$destroy', function ()
                        {
                            demoTemplateCache.remove(file.name);
                        });

                    });

                }));

            }

        }

    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.components.material-docs')
        .directive('docsDemo', docsDemo)
        .directive('demoFile', demoFile)
        .filter('toHtml', toHtml)
        .directive('layoutAlign', function ()
        {
            return angular.noop;
        })
        .directive('layout', function ()
        {
            return angular.noop;
        });

    /** @ngInject */
    function docsDemo($mdUtil)
    {
        return {
            restrict        : 'E',
            scope           : true,
            templateUrl     : 'app/main/components/material-docs/demo/docs-demo.tmpl.html',
            transclude      : true,
            controller      :DocsDemoCtrl,
            controllerAs    : 'demoCtrl',
            bindToController: true
        };

        function DocsDemoCtrl($scope, $element, $attrs, $interpolate)
        {
            var self = this;

            self.interpolateCode = angular.isDefined($attrs.interpolateCode);
            self.demoId = $interpolate($attrs.demoId || '')($scope.$parent);
            self.demoTitle = $interpolate($attrs.demoTitle || '')($scope.$parent);
            self.demoModule = $interpolate($attrs.demoModule || '')($scope.$parent);
            self.files = {
                css : [],
                js  : [],
                html: []
            };

            self.addFile = function (name, contentsPromise)
            {
                var file = {
                    name           : convertName(name),
                    contentsPromise: contentsPromise,
                    fileType       : name.split('.').pop()
                };
                contentsPromise.then(function (contents)
                {
                    file.contents = contents;
                });

                if ( name === 'index.html' )
                {
                    self.files.index = file;
                }
                else if ( name === 'readme.html' )
                {
                    self.demoDescription = file;
                }
                else
                {
                    self.files[file.fileType] = self.files[file.fileType] || [];
                    self.files[file.fileType].push(file);
                }

                self.orderedFiles = []
                    .concat(self.files.index || [])
                    .concat(self.files.js || [])
                    .concat(self.files.css || [])
                    .concat(self.files.html || []);

            };

            self.editOnCodepen = function ()
            {
                codepen.editOnCodepen({
                    title : self.demoTitle,
                    files : self.files,
                    id    : self.demoId,
                    module: self.demoModule
                });
            };

            function convertName(name)
            {
                switch ( name )
                {
                    case "index.html" :
                        return "HTML";
                    case "script.js" :
                        return "JS";
                    case "style.css" :
                        return "CSS";
                    default :
                        return name;
                }
            }

        }
    }

    /** @ngInject */
    function demoFile($q, $interpolate)
    {
        return {
            restrict: 'E',
            require : '^docsDemo',
            compile : compile
        };

        function compile(element, attr)
        {
            var contentsAttr = attr.contents;
            var html = element.html();
            var name = attr.name;
            element.contents().remove();

            return function postLink(scope, element, attr, docsDemoCtrl)
            {
                docsDemoCtrl.addFile(
                    $interpolate(name)(scope),
                    $q.when(scope.$eval(contentsAttr) || html)
                );
                element.remove();
            };
        }
    }

    /** @ngInject */
    function toHtml($sce)
    {
        return function (str)
        {
            return $sce.trustAsHtml(str);
        };
    }
})();
(function ()
{
    'use strict';
    angular
        .module('app.components.material-docs')
        .factory('$demoAngularScripts', DemoAngularScripts);

    function DemoAngularScripts()
    {
        var scripts = [
            'angular.js',
            'angular-animate.min.js',
            'angular-route.min.js',
            'angular-aria.min.js',
            'angular-messages.min.js'
        ];

        return {
            all: allAngularScripts
        };

        function allAngularScripts()
        {
            return scripts.map(fullPathToScript);
        }

        function fullPathToScript(script)
        {
            return "https://ajax.googleapis.com/ajax/libs/angularjs/" + angular.version.full + "/" + script;
        }
    }
})();

angular.module('app.components.material-docs')
    .constant('THEMING_NAVIGATION', [
        {
            name       : "Introduction and Terms",
            stateName  : 'material_components_theming_introduction',
            id         : 'introduction',
            templateUrl: "partials/Theming/01_introduction.html",
            url        : "Theming/01_introduction",
            weight     : 1
        },
        {
            name       : "Declarative Syntax",
            stateName  : 'material_components_theming_declarative',
            id         : 'declarative',
            templateUrl: "partials/Theming/02_declarative_syntax.html",
            url        : "Theming/02_declarative_syntax",
            weight     : 2
        },
        {
            name       : "Configuring a Theme",
            stateName  : 'material_components_theming_configuring',
            id         : 'configuring',
            templateUrl: "partials/Theming/03_configuring_a_theme.html",
            url        : "Theming/03_configuring_a_theme",
            weight     : 3
        },
        {
            name       : "Multiple Themes",
            stateName  : 'material_components_theming_multiple',
            id         : 'multiple',
            templateUrl: "partials/Theming/04_multiple_themes.html",
            url        : "Theming/04_multiple_themes",
            weight     : 4
        },
        {
            name       : "Theming under the hood",
            stateName  : 'material_components_theming_under_the_hood',
            id         : 'under_the_hood',
            templateUrl: "partials/Theming/05_under_the_hood.html",
            url        : "Theming/05_under_the_hood",
            weight     : 5
        },
        {
            name       : "Browser Colors",
            stateName  : 'material_components_theming_browser_color',
            id         : 'browser_color',
            templateUrl: "partials/Theming/06_browser_color.html",
            url        : "Theming/06_browser_color",
            weight     : 6
        }
    ]);
angular.module('app.components.material-docs')
    .constant('LAYOUT_NAVIGATION', [
        {
            name       : 'Introduction',
            stateName  : 'material_components_layout_introduction',
            id         : 'layoutIntro',
            url        : 'layout/introduction',
            templateUrl: 'layout/layout-introduction.tmpl.html',
            weight     : 1
        },
        {
            name       : 'Layout Containers',
            stateName  : 'material_components_layout_containers',
            id         : 'layoutContainers',
            url        : 'layout/container',
            templateUrl: 'layout/layout-container.tmpl.html',
            weight     : 2
        },
        {
            name       : 'Layout Children',
            stateName  : 'material_components_layout_grid',
            id         : 'layoutGrid',
            url        : 'layout/children',
            templateUrl: 'layout/layout-children.tmpl.html',
            weight     : 3
        },
        {
            name       : 'Child Alignment',
            stateName  : 'material_components_layout_align',
            id         : 'layoutAlign',
            url        : 'layout/alignment',
            templateUrl: 'layout/layout-alignment.tmpl.html',
            weight     : 4
        },
        {
            name       : 'Extra Options',
            stateName  : 'material_components_layout_options',
            id         : 'layoutOptions',
            url        : 'layout/options',
            templateUrl: 'layout/layout-options.tmpl.html',
            weight     : 5
        },
        {
            name       : 'Troubleshooting',
            stateName  : 'material_components_layout_tips',
            id         : 'layoutTips',
            url        : 'layout/tips',
            templateUrl: 'layout/layout-tips.tmpl.html',
            weight     : 6
        }
    ]);
(function ()
{
    'use strict';

    angular
        .module('app.components.material-docs')
        .constant('ELEMENTS_NAVIGATION', [
            /* INPUTS */
            {
                name      : 'Autocomplete',
                url       : 'autocomplete',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.autocomplete',
                stateName : 'material_components_autocomplete',
                weight    : 1
            },
            {
                name      : 'Checkbox',
                url       : 'checkbox',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.checkbox',
                stateName : 'material_components_checkbox',
                weight    : 2
            },
            {
                name      : 'Chips',
                url       : 'chips',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.chips',
                stateName : 'material_components_chips',
                weight    : 3
            },
            {
                name      : 'Date Picker',
                url       : 'date-picker',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.datepicker',
                stateName : 'material_components_datepicker',
                weight    : 4
            },
            {
                name      : 'Input',
                url       : 'input',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.input',
                stateName : 'material_components_input',
                weight    : 5
            },
            {
                name      : 'Radio Button',
                url       : 'radio-button',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.radioButton',
                stateName : 'material_components_radioButton',
                weight    : 6
            },
            {
                name      : 'Select',
                url       : 'select',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.select',
                stateName : 'material_components_select',
                weight    : 7
            },
            {
                name      : 'Slider',
                url       : 'slider',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.slider',
                stateName : 'material_components_slider',
                weight    : 8
            },
            {
                name      : 'Switch',
                url       : 'switch',
                navPath   : 'components.elements.inputs',
                moduleName: 'material.components.switch',
                stateName : 'material_components_switch',
                weight    : 9
            },
            /* BUTTONS */
            {
                name      : 'Button',
                url       : 'button',
                navPath   : 'components.elements.buttons',
                moduleName: 'material.components.button',
                stateName : 'material_components_button',
                weight    : 1
            },
            {
                name      : 'Fab Actions',
                url       : 'fab-actions',
                navPath   : 'components.elements.buttons',
                moduleName: 'material.components.fabActions',
                stateName : 'material_components_fabActions',
                weight    : 2
            },
            {
                name      : 'Fab Speed Dial',
                url       : 'fab-speed-dial',
                navPath   : 'components.elements.buttons',
                moduleName: 'material.components.fabSpeedDial',
                stateName : 'material_components_fabSpeedDial',
                weight    : 3
            },
            {
                name      : 'Fab Toolbar',
                url       : 'fab-toolbar',
                navPath   : 'components.elements.buttons',
                moduleName: 'material.components.fabToolbar',
                stateName : 'material_components_fabToolbar',
                weight    : 4
            },
            /* CONTENT ELEMENTS */
            {
                name      : 'Bottom Sheet',
                url       : 'bottom-sheet',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.bottomSheet',
                stateName : 'material_components_bottomSheet',
                weight    : 1
            },
            {
                name      : 'Card',
                url       : 'card',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.card',
                stateName : 'material_components_card',
                weight    : 2
            },
            {
                name      : 'Content',
                url       : 'content',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.content',
                stateName : 'material_components_content',
                weight    : 3
            },
            {
                name      : 'Dialog',
                url       : 'dialog',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.dialog',
                stateName : 'material_components_dialog',
                weight    : 4
            },
            {
                name       : 'Icon',
                url        : 'icon',
                navPath    : 'components.elements.content-elements',
                moduleName : 'material.components.icon',
                stateName  : 'material_components_icon',
                excludeDemo: true,
                weight     : 5
            },
            {
                name      : 'Navbar',
                url       : 'navbar',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.navBar',
                stateName : 'material_components_navBar',
                weight    : 6
            },
            {
                name      : 'Panel',
                url       : 'panel',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.panel',
                stateName : 'material_components_panel',
                weight    : 7
            },
            {
                name      : 'Sidenav',
                url       : 'sidenav',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.sidenav',
                stateName : 'material_components_sidenav',
                weight    : 8
            },
            {
                name      : 'Subheader',
                url       : 'subheader',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.subheader',
                stateName : 'material_components_subheader',
                weight    : 9
            },
            {
                name      : 'Tabs',
                url       : 'tabs',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.tabs',
                stateName : 'material_components_tabs',
                weight    : 10
            },
            {
                name      : 'Toast',
                url       : 'toast',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.toast',
                stateName : 'material_components_toast',
                weight    : 11
            },
            {
                name      : 'Toolbar',
                url       : 'toolbar',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.toolbar',
                stateName : 'material_components_toolbar',
                weight    : 12
            },
            {
                name      : 'Tooltip',
                url       : 'tooltip',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.tooltip',
                stateName : 'material_components_tooltip',
                weight    : 13
            },
            {
                name      : 'Whiteframe',
                url       : 'whiteframe',
                navPath   : 'components.elements.content-elements',
                moduleName: 'material.components.whiteframe',
                stateName : 'material_components_whiteframe',
                weight    : 14
            },
            /* LISTS */
            {
                name      : 'Grid List',
                url       : 'grid-list',
                navPath   : 'components.elements.lists',
                moduleName: 'material.components.gridList',
                stateName : 'material_components_gridList',
                weight    : 1
            },
            {
                name      : 'List',
                url       : 'list',
                navPath   : 'components.elements.lists',
                moduleName: 'material.components.list',
                stateName : 'material_components_list',
                weight    : 2
            },
            /* MENUS */
            {
                name      : 'Menu',
                url       : 'menu',
                navPath   : 'components.elements.menus',
                moduleName: 'material.components.menu',
                stateName : 'material_components_menu',
                weight    : 1
            },
            {
                name      : 'Menu Bar',
                url       : 'menu-bar',
                navPath   : 'components.elements.menus',
                moduleName: 'material.components.menuBar',
                stateName : 'material_components_menu-bar',
                weight    : 2
            },
            /* PROGRESS */
            {
                name      : 'Progress Circular',
                url       : 'progress-circular',
                navPath   : 'components.elements.progress',
                moduleName: 'material.components.progressCircular',
                stateName : 'material_components_progressCircular',
                weight    : 1
            },
            {
                name      : 'Progress Linear',
                url       : 'progress-linear',
                navPath   : 'components.elements.progress',
                moduleName: 'material.components.progressLinear',
                stateName : 'material_components_progressLinear',
                weight    : 2
            },
            /* OTHERS */
            {
                name      : 'Colors',
                url       : 'colors',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.colors',
                stateName : 'material_components_colors',
                weight    : 1
            },
            {
                name      : 'Divider',
                url       : 'divider',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.divider',
                stateName : 'material_components_divider',
                weight    : 2
            },
            {
                name      : 'Ripple',
                url       : 'ripple',
                navPath   : 'components.elements.others',
                moduleName: 'material.core.ripple',
                stateName : 'material_core_ripple',
                weight    : 3
            },
            {
                name      : 'Sticky',
                url       : 'sticky',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.sticky',
                stateName : 'material_components_sticky',
                weight    : 4
            },
            {
                name      : 'Swipe',
                url       : 'swipe',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.swipe',
                stateName : 'material_components_swipe',
                weight    : 5
            },
            {
                name      : 'Util',
                url       : 'util',
                navPath   : 'components.elements.others',
                moduleName: 'material.core.util',
                stateName : 'material_core_util',
                weight    : 6
            },
            {
                name      : 'Virtual Repeat',
                url       : 'virtual-repeat',
                navPath   : 'components.elements.others',
                moduleName: 'material.components.virtualRepeat',
                stateName : 'material_components_virtualRepeat',
                weight    : 7
            },
            {
                name      : 'Aria',
                url       : 'aria',
                navPath   : 'components.elements.others',
                moduleName: 'material.core.aria',
                stateName : 'material_components_aria',
                weight    : 8
            }
        ]);
})();
angular.module('app.components.material-docs')
    .constant('DEMOS', [
        {
            'name'      : 'autocomplete',
            'moduleName': 'material.components.autocomplete',
            'label'     : 'Autocomplete',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'autocompleteDemo',
                        'module'      : 'autocompleteDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'autocompletedemoBasicUsage',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/autocomplete/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.autocomplete',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/autocomplete/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'autocompleteCustomTemplateDemo',
                        'module'      : 'autocompleteCustomTemplateDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'autocompletedemoCustomTemplate',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/autocomplete/demoCustomTemplate/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/autocomplete/demoCustomTemplate/script.js'
                        }
                    ],
                    'moduleName': 'material.components.autocomplete',
                    'name'      : 'demoCustomTemplate',
                    'label'     : 'Custom Template',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/autocomplete/demoCustomTemplate/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'autocompleteFloatingLabelDemo',
                        'module'      : 'autocompleteFloatingLabelDemo',
                        'dependencies': [
                            'ngMaterial',
                            'ngMessages'
                        ]
                    },
                    'id'        : 'autocompletedemoFloatingLabel',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/autocomplete/demoFloatingLabel/script.js'
                        }
                    ],
                    'moduleName': 'material.components.autocomplete',
                    'name'      : 'demoFloatingLabel',
                    'label'     : 'Floating Label',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/autocomplete/demoFloatingLabel/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'autocompleteDemoInsideDialog',
                        'module'      : 'autocompleteDemoInsideDialog',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'autocompletedemoInsideDialog',
                    'css'       : [],
                    'html'      : [
                        {
                            'name'      : 'dialog.tmpl.html',
                            'label'     : 'dialog.tmpl.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/autocomplete/demoInsideDialog/dialog.tmpl.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/autocomplete/demoInsideDialog/script.js'
                        }
                    ],
                    'moduleName': 'material.components.autocomplete',
                    'name'      : 'demoInsideDialog',
                    'label'     : 'Inside Dialog',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/autocomplete/demoInsideDialog/index.html'
                    }
                }
            ],
            'url'       : 'demo/autocomplete'
        },
        {
            'name'      : 'bottomSheet',
            'moduleName': 'material.components.bottomSheet',
            'label'     : 'Bottom Sheet',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'bottomSheetDemo1',
                        'module'      : 'bottomSheetDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'bottomSheetdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/bottomSheet/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [
                        {
                            'name'      : 'bottom-sheet-grid-template.html',
                            'label'     : 'bottom-sheet-grid-template.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/bottomSheet/demoBasicUsage/bottom-sheet-grid-template.html'
                        },
                        {
                            'name'      : 'bottom-sheet-list-template.html',
                            'label'     : 'bottom-sheet-list-template.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/bottomSheet/demoBasicUsage/bottom-sheet-list-template.html'
                        },
                        {
                            'name'      : 'readme.html',
                            'label'     : 'readme.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/bottomSheet/demoBasicUsage/readme.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/bottomSheet/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.bottomSheet',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/bottomSheet/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/bottomSheet'
        },
        {
            'name'      : 'button',
            'moduleName': 'material.components.button',
            'label'     : 'Button',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'buttonsDemo1',
                        'module'      : 'buttonsDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'buttondemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/button/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/button/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.button',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/button/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/button'
        },
        {
            'name'      : 'card',
            'moduleName': 'material.components.card',
            'label'     : 'Card',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'cardDemo1',
                        'module'      : 'cardDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'carddemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/card/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/card/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.card',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/card/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'cardDemo2',
                        'module'      : 'cardDemo2',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'carddemoCardActionButtons',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/card/demoCardActionButtons/script.js'
                        }
                    ],
                    'moduleName': 'material.components.card',
                    'name'      : 'demoCardActionButtons',
                    'label'     : 'Card Action Buttons',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/card/demoCardActionButtons/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'cardDemo3',
                        'module'      : 'cardDemo3',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'carddemoInCardActions',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/card/demoInCardActions/script.js'
                        }
                    ],
                    'moduleName': 'material.components.card',
                    'name'      : 'demoInCardActions',
                    'label'     : 'In Card Actions',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/card/demoInCardActions/index.html'
                    }
                }
            ],
            'url'       : 'demo/card'
        },
        {
            'name'      : 'checkbox',
            'moduleName': 'material.components.checkbox',
            'label'     : 'Checkbox',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'checkboxDemo1',
                        'module'      : 'checkboxDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'checkboxdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/checkbox/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/checkbox/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.checkbox',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/checkbox/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'checkboxDemo3',
                        'module'      : 'checkboxDemo3',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'checkboxdemoSelectAll',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/checkbox/demoSelectAll/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/checkbox/demoSelectAll/script.js'
                        }
                    ],
                    'moduleName': 'material.components.checkbox',
                    'name'      : 'demoSelectAll',
                    'label'     : 'Select All',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/checkbox/demoSelectAll/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'checkboxDemo2',
                        'module'      : 'checkboxDemo2',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'checkboxdemoSyncing',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/checkbox/demoSyncing/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/checkbox/demoSyncing/script.js'
                        }
                    ],
                    'moduleName': 'material.components.checkbox',
                    'name'      : 'demoSyncing',
                    'label'     : 'Syncing',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/checkbox/demoSyncing/index.html'
                    }
                }
            ],
            'url'       : 'demo/checkbox'
        },
        {
            'name'      : 'chips',
            'moduleName': 'material.components.chips',
            'label'     : 'Chips',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'chipsDemo',
                        'module'      : 'chipsDemo',
                        'dependencies': [
                            'ngMaterial',
                            'ngMessages'
                        ]
                    },
                    'id'        : 'chipsdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/chips/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/chips/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.chips',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/chips/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'contactChipsDemo',
                        'module'      : 'contactChipsDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'chipsdemoContactChips',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/chips/demoContactChips/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/chips/demoContactChips/script.js'
                        }
                    ],
                    'moduleName': 'material.components.chips',
                    'name'      : 'demoContactChips',
                    'label'     : 'Contact Chips',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/chips/demoContactChips/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'chipsCustomInputDemo',
                        'module'      : 'chipsCustomInputDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'chipsdemoCustomInputs',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/chips/demoCustomInputs/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/chips/demoCustomInputs/script.js'
                        }
                    ],
                    'moduleName': 'material.components.chips',
                    'name'      : 'demoCustomInputs',
                    'label'     : 'Custom Inputs',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/chips/demoCustomInputs/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'chipsCustomSeparatorDemo',
                        'module'      : 'chipsCustomSeparatorDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'chipsdemoCustomSeparatorKeys',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/chips/demoCustomSeparatorKeys/script.js'
                        }
                    ],
                    'moduleName': 'material.components.chips',
                    'name'      : 'demoCustomSeparatorKeys',
                    'label'     : 'Custom Separator Keys',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/chips/demoCustomSeparatorKeys/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'staticChipsDemo',
                        'module'      : 'staticChipsDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'chipsdemoStaticChips',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/chips/demoStaticChips/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/chips/demoStaticChips/script.js'
                        }
                    ],
                    'moduleName': 'material.components.chips',
                    'name'      : 'demoStaticChips',
                    'label'     : 'Static Chips',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/chips/demoStaticChips/index.html'
                    }
                }
            ],
            'url'       : 'demo/chips'
        },
        {
            'name'      : 'colors',
            'moduleName': 'material.components.colors',
            'label'     : 'Colors',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'colorsDemo',
                        'module'      : 'colorsDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'colorsdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/colors/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [
                        {
                            'name'      : 'regularCard.tmpl.html',
                            'label'     : 'regularCard.tmpl.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/colors/demoBasicUsage/regularCard.tmpl.html'
                        },
                        {
                            'name'      : 'userCard.tmpl.html',
                            'label'     : 'userCard.tmpl.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/colors/demoBasicUsage/userCard.tmpl.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/colors/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.colors',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/colors/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'colorsThemePickerDemo',
                        'module'      : 'colorsThemePickerDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'colorsdemoThemePicker',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/colors/demoThemePicker/style.css'
                        }
                    ],
                    'html'      : [
                        {
                            'name'      : 'themePreview.tmpl.html',
                            'label'     : 'themePreview.tmpl.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/colors/demoThemePicker/themePreview.tmpl.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/colors/demoThemePicker/script.js'
                        }
                    ],
                    'moduleName': 'material.components.colors',
                    'name'      : 'demoThemePicker',
                    'label'     : 'Theme Picker',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/colors/demoThemePicker/index.html'
                    }
                }
            ],
            'url'       : 'demo/colors'
        },
        {
            'name'      : 'content',
            'moduleName': 'material.components.content',
            'label'     : 'Content',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'contentDemo1',
                        'module'      : 'contentDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'contentdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/content/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/content/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.content',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/content/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/content'
        },
        {
            'name'      : 'datepicker',
            'moduleName': 'material.components.datepicker',
            'label'     : 'Datepicker',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'datepickerBasicUsage',
                        'module'      : 'datepickerBasicUsage',
                        'dependencies': [
                            'ngMaterial',
                            'ngMessages'
                        ]
                    },
                    'id'        : 'datepickerdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/datepicker/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/datepicker/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.datepicker',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/datepicker/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/datepicker'
        },
        {
            'name'      : 'dialog',
            'moduleName': 'material.components.dialog',
            'label'     : 'Dialog',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'dialogDemo1',
                        'module'      : 'dialogDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'dialogdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/dialog/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [
                        {
                            'name'      : 'dialog1.tmpl.html',
                            'label'     : 'dialog1.tmpl.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/dialog/demoBasicUsage/dialog1.tmpl.html'
                        },
                        {
                            'name'      : 'tabDialog.tmpl.html',
                            'label'     : 'tabDialog.tmpl.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/dialog/demoBasicUsage/tabDialog.tmpl.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/dialog/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.dialog',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/dialog/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'dialogDemo2',
                        'module'      : 'dialogDemo2',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'dialogdemoOpenFromCloseTo',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/dialog/demoOpenFromCloseTo/script.js'
                        }
                    ],
                    'moduleName': 'material.components.dialog',
                    'name'      : 'demoOpenFromCloseTo',
                    'label'     : 'Open From Close To',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/dialog/demoOpenFromCloseTo/index.html'
                    }
                }
            ],
            'url'       : 'demo/dialog'
        },
        {
            'name'      : 'divider',
            'moduleName': 'material.components.divider',
            'label'     : 'Divider',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'dividerDemo1',
                        'module'      : 'dividerDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'dividerdemoBasicUsage',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/divider/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.divider',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/divider/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/divider'
        },
        {
            'name'      : 'fabSpeedDial',
            'moduleName': 'material.components.fabSpeedDial',
            'label'     : 'FAB Speed Dial',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'fabSpeedDialDemoBasicUsage',
                        'module'      : 'fabSpeedDialDemoBasicUsage',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'fabSpeedDialdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/fabSpeedDial/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/fabSpeedDial/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.fabSpeedDial',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/fabSpeedDial/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'fabSpeedDialDemoMoreOptions',
                        'module'      : 'fabSpeedDialDemoMoreOptions',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'fabSpeedDialdemoMoreOptions',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/fabSpeedDial/demoMoreOptions/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/fabSpeedDial/demoMoreOptions/script.js'
                        }
                    ],
                    'moduleName': 'material.components.fabSpeedDial',
                    'name'      : 'demoMoreOptions',
                    'label'     : 'More Options',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/fabSpeedDial/demoMoreOptions/index.html'
                    }
                }
            ],
            'url'       : 'demo/fabSpeedDial'
        },
        {
            'name'      : 'fabToolbar',
            'moduleName': 'material.components.fabToolbar',
            'label'     : 'FAB Toolbar',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'fabToolbarBasicUsageDemo',
                        'module'      : 'fabToolbarBasicUsageDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'fabToolbardemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/fabToolbar/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/fabToolbar/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.fabToolbar',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/fabToolbar/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/fabToolbar'
        },
        {
            'name'      : 'gridList',
            'moduleName': 'material.components.gridList',
            'label'     : 'Grid List',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'gridListDemo1',
                        'module'      : 'gridListDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'gridListdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'styles.css',
                            'label'     : 'styles.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/gridList/demoBasicUsage/styles.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/gridList/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.gridList',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/gridList/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'gridListDemoApp',
                        'module'      : 'gridListDemoApp',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'gridListdemoDynamicTiles',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/gridList/demoDynamicTiles/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/gridList/demoDynamicTiles/script.js'
                        }
                    ],
                    'moduleName': 'material.components.gridList',
                    'name'      : 'demoDynamicTiles',
                    'label'     : 'Dynamic Tiles',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/gridList/demoDynamicTiles/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'gridListdemoResponsiveUsage',
                        'module'      : 'gridListdemoResponsiveUsage',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'gridListdemoResponsiveUsage',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/gridList/demoResponsiveUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.gridList',
                    'name'      : 'demoResponsiveUsage',
                    'label'     : 'Responsive Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/gridList/demoResponsiveUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/gridList'
        },
        {
            'name'      : 'icon',
            'moduleName': 'material.components.icon',
            'label'     : 'Icon',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'appDemoFontIconsWithClassnames',
                        'module'      : 'appDemoFontIconsWithClassnames',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'icondemoFontIconsWithClassnames',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/icon/demoFontIconsWithClassnames/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/icon/demoFontIconsWithClassnames/script.js'
                        }
                    ],
                    'moduleName': 'material.components.icon',
                    'name'      : 'demoFontIconsWithClassnames',
                    'label'     : 'Font Icons With Classnames',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/icon/demoFontIconsWithClassnames/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'appDemoFontIconsWithLigatures',
                        'module'      : 'appDemoFontIconsWithLigatures',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'icondemoFontIconsWithLigatures',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/icon/demoFontIconsWithLigatures/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/icon/demoFontIconsWithLigatures/script.js'
                        }
                    ],
                    'moduleName': 'material.components.icon',
                    'name'      : 'demoFontIconsWithLigatures',
                    'label'     : 'Font Icons With Ligatures',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/icon/demoFontIconsWithLigatures/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'appDemoSvgIcons',
                        'module'      : 'appDemoSvgIcons',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'icondemoLoadSvgIconsFromUrl',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/icon/demoLoadSvgIconsFromUrl/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/icon/demoLoadSvgIconsFromUrl/script.js'
                        }
                    ],
                    'moduleName': 'material.components.icon',
                    'name'      : 'demoLoadSvgIconsFromUrl',
                    'label'     : 'Load Svg Icons From Url',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/icon/demoLoadSvgIconsFromUrl/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'appSvgIconSets',
                        'module'      : 'appSvgIconSets',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'icondemoSvgIconSets',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/icon/demoSvgIconSets/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/icon/demoSvgIconSets/script.js'
                        }
                    ],
                    'moduleName': 'material.components.icon',
                    'name'      : 'demoSvgIconSets',
                    'label'     : 'Svg Icon Sets',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/icon/demoSvgIconSets/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'appUsingTemplateCache',
                        'module'      : 'appUsingTemplateCache',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'icondemoUsingTemplateRequest',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/icon/demoUsingTemplateRequest/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/icon/demoUsingTemplateRequest/script.js'
                        }
                    ],
                    'moduleName': 'material.components.icon',
                    'name'      : 'demoUsingTemplateRequest',
                    'label'     : 'Using Template Request',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/icon/demoUsingTemplateRequest/index.html'
                    }
                }
            ],
            'url'       : 'demo/icon'
        },
        {
            'name'      : 'input',
            'moduleName': 'material.components.input',
            'label'     : 'Input',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'inputBasicDemo',
                        'module'      : 'inputBasicDemo',
                        'dependencies': [
                            'ngMaterial',
                            'ngMessages'
                        ]
                    },
                    'id'        : 'inputdemoBasicUsage',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/input/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.input',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/input/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'inputErrorsApp',
                        'module'      : 'inputErrorsApp',
                        'dependencies': [
                            'ngMaterial',
                            'ngMessages'
                        ]
                    },
                    'id'        : 'inputdemoErrors',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/input/demoErrors/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/input/demoErrors/script.js'
                        }
                    ],
                    'moduleName': 'material.components.input',
                    'name'      : 'demoErrors',
                    'label'     : 'Errors',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/input/demoErrors/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'inputErrorsAdvancedApp',
                        'module'      : 'inputErrorsAdvancedApp',
                        'dependencies': [
                            'ngMaterial',
                            'ngMessages'
                        ]
                    },
                    'id'        : 'inputdemoErrorsAdvanced',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/input/demoErrorsAdvanced/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/input/demoErrorsAdvanced/script.js'
                        }
                    ],
                    'moduleName': 'material.components.input',
                    'name'      : 'demoErrorsAdvanced',
                    'label'     : 'Errors Advanced',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/input/demoErrorsAdvanced/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'inputIconDemo',
                        'module'      : 'inputIconDemo',
                        'dependencies': [
                            'ngMaterial',
                            'ngMessages'
                        ]
                    },
                    'id'        : 'inputdemoIcons',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/input/demoIcons/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/input/demoIcons/script.js'
                        }
                    ],
                    'moduleName': 'material.components.input',
                    'name'      : 'demoIcons',
                    'label'     : 'Icons',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/input/demoIcons/index.html'
                    }
                }
            ],
            'url'       : 'demo/input'
        },
        {
            'name'      : 'list',
            'moduleName': 'material.components.list',
            'label'     : 'List',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'listDemo1',
                        'module'      : 'listDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'listdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/list/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/list/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.list',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/list/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'listDemo2',
                        'module'      : 'listDemo2',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'listdemoListControls',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/list/demoListControls/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/list/demoListControls/script.js'
                        }
                    ],
                    'moduleName': 'material.components.list',
                    'name'      : 'demoListControls',
                    'label'     : 'List Controls',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/list/demoListControls/index.html'
                    }
                }
            ],
            'url'       : 'demo/list'
        },
        {
            'name'      : 'menu',
            'moduleName': 'material.components.menu',
            'label'     : 'Menu',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'menuDemoBasic',
                        'module'      : 'menuDemoBasic',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'menudemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/menu/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/menu/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.menu',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/menu/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'menuDemoPosition',
                        'module'      : 'menuDemoPosition',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'menudemoMenuPositionModes',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/menu/demoMenuPositionModes/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/menu/demoMenuPositionModes/script.js'
                        }
                    ],
                    'moduleName': 'material.components.menu',
                    'name'      : 'demoMenuPositionModes',
                    'label'     : 'Menu Position Modes',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/menu/demoMenuPositionModes/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'menuDemoWidth',
                        'module'      : 'menuDemoWidth',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'menudemoMenuWidth',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/menu/demoMenuWidth/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/menu/demoMenuWidth/script.js'
                        }
                    ],
                    'moduleName': 'material.components.menu',
                    'name'      : 'demoMenuWidth',
                    'label'     : 'Menu Width',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/menu/demoMenuWidth/index.html'
                    }
                }
            ],
            'url'       : 'demo/menu'
        },
        {
            'name'      : 'menuBar',
            'moduleName': 'material.components.menuBar',
            'label'     : 'Menu Bar',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'menuBarDemoBasic',
                        'module'      : 'menuBarDemoBasic',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'menuBardemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/menuBar/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/menuBar/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.menuBar',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/menuBar/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/menuBar'
        },
        {
            'name'      : 'navBar',
            'moduleName': 'material.components.navBar',
            'label'     : 'Nav Bar',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'navBarDemoBasicUsage',
                        'module'      : 'navBarDemoBasicUsage',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'navBardemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/navBar/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/navBar/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.navBar',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/navBar/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/navBar'
        },
        {
            'name'      : 'panel',
            'moduleName': 'material.components.panel',
            'label'     : 'Panel',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'panelDemo',
                        'module'      : 'panelDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'paneldemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.global.css',
                            'label'     : 'style.global.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/panel/demoBasicUsage/style.global.css'
                        }
                    ],
                    'html'      : [
                        {
                            'name'      : 'panel.tmpl.html',
                            'label'     : 'panel.tmpl.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/panel/demoBasicUsage/panel.tmpl.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/panel/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.panel',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/panel/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'panelAnimationsDemo',
                        'module'      : 'panelAnimationsDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'paneldemoPanelAnimations',
                    'css'       : [
                        {
                            'name'      : 'style.global.css',
                            'label'     : 'style.global.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/panel/demoPanelAnimations/style.global.css'
                        }
                    ],
                    'html'      : [
                        {
                            'name'      : 'panel.tmpl.html',
                            'label'     : 'panel.tmpl.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/panel/demoPanelAnimations/panel.tmpl.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/panel/demoPanelAnimations/script.js'
                        }
                    ],
                    'moduleName': 'material.components.panel',
                    'name'      : 'demoPanelAnimations',
                    'label'     : 'Panel Animations',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/panel/demoPanelAnimations/index.html'
                    }
                }
            ],
            'url'       : 'demo/panel'
        },
        {
            'name'      : 'progressCircular',
            'moduleName': 'material.components.progressCircular',
            'label'     : 'Progress Circular',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'progressCircularDemo1',
                        'module'      : 'progressCircularDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'progressCirculardemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/progressCircular/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/progressCircular/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.progressCircular',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/progressCircular/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/progressCircular'
        },
        {
            'name'      : 'progressLinear',
            'moduleName': 'material.components.progressLinear',
            'label'     : 'Progress Linear',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'progressLinearDemo1',
                        'module'      : 'progressLinearDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'progressLineardemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/progressLinear/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/progressLinear/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.progressLinear',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/progressLinear/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/progressLinear'
        },
        {
            'name'      : 'radioButton',
            'moduleName': 'material.components.radioButton',
            'label'     : 'Radio Button',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'radioDemo1',
                        'module'      : 'radioDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'radioButtondemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/radioButton/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/radioButton/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.radioButton',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/radioButton/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'radioDemo2',
                        'module'      : 'radioDemo2',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'radioButtondemoMultiColumn',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/radioButton/demoMultiColumn/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/radioButton/demoMultiColumn/script.js'
                        }
                    ],
                    'moduleName': 'material.components.radioButton',
                    'name'      : 'demoMultiColumn',
                    'label'     : 'Multi Column',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/radioButton/demoMultiColumn/index.html'
                    }
                }
            ],
            'url'       : 'demo/radioButton'
        },
        {
            'name'      : 'select',
            'moduleName': 'material.components.select',
            'label'     : 'Select',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'selectDemoBasic',
                        'module'      : 'selectDemoBasic',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'selectdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/select/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/select/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.select',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/select/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'selectDemoOptGroups',
                        'module'      : 'selectDemoOptGroups',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'selectdemoOptionGroups',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/select/demoOptionGroups/script.js'
                        }
                    ],
                    'moduleName': 'material.components.select',
                    'name'      : 'demoOptionGroups',
                    'label'     : 'Option Groups',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/select/demoOptionGroups/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'selectDemoOptionsAsync',
                        'module'      : 'selectDemoOptionsAsync',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'selectdemoOptionsWithAsyncSearch',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/select/demoOptionsWithAsyncSearch/script.js'
                        }
                    ],
                    'moduleName': 'material.components.select',
                    'name'      : 'demoOptionsWithAsyncSearch',
                    'label'     : 'Options With Async Search',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/select/demoOptionsWithAsyncSearch/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'selectDemoSelectHeader',
                        'module'      : 'selectDemoSelectHeader',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'selectdemoSelectHeader',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/select/demoSelectHeader/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/select/demoSelectHeader/script.js'
                        }
                    ],
                    'moduleName': 'material.components.select',
                    'name'      : 'demoSelectHeader',
                    'label'     : 'Select Header',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/select/demoSelectHeader/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'selectDemoSelectedText',
                        'module'      : 'selectDemoSelectedText',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'selectdemoSelectedText',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/select/demoSelectedText/script.js'
                        }
                    ],
                    'moduleName': 'material.components.select',
                    'name'      : 'demoSelectedText',
                    'label'     : 'Selected Text',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/select/demoSelectedText/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'selectDemoValidation',
                        'module'      : 'selectDemoValidation',
                        'dependencies': [
                            'ngMaterial',
                            'ngMessages'
                        ]
                    },
                    'id'        : 'selectdemoValidations',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/select/demoValidations/script.js'
                        }
                    ],
                    'moduleName': 'material.components.select',
                    'name'      : 'demoValidations',
                    'label'     : 'Validations',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/select/demoValidations/index.html'
                    }
                }
            ],
            'url'       : 'demo/select'
        },
        {
            'name'      : 'sidenav',
            'moduleName': 'material.components.sidenav',
            'label'     : 'Sidenav',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'sidenavDemo1',
                        'module'      : 'sidenavDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'sidenavdemoBasicUsage',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/sidenav/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.sidenav',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/sidenav/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'sidenavDemo2',
                        'module'      : 'sidenavDemo2',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'sidenavdemoCustomSidenav',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/sidenav/demoCustomSidenav/script.js'
                        }
                    ],
                    'moduleName': 'material.components.sidenav',
                    'name'      : 'demoCustomSidenav',
                    'label'     : 'Custom Sidenav',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/sidenav/demoCustomSidenav/index.html'
                    }
                }
            ],
            'url'       : 'demo/sidenav'
        },
        {
            'name'      : 'slider',
            'moduleName': 'material.components.slider',
            'label'     : 'Slider',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'sliderDemo1',
                        'module'      : 'sliderDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'sliderdemoBasicUsage',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/slider/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.slider',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/slider/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'sliderDemo2',
                        'module'      : 'sliderDemo2',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'sliderdemoVertical',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/slider/demoVertical/script.js'
                        }
                    ],
                    'moduleName': 'material.components.slider',
                    'name'      : 'demoVertical',
                    'label'     : 'Vertical',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/slider/demoVertical/index.html'
                    }
                }
            ],
            'url'       : 'demo/slider'
        },
        {
            'name'      : 'subheader',
            'moduleName': 'material.components.subheader',
            'label'     : 'Subheader',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'subheaderBasicDemo',
                        'module'      : 'subheaderBasicDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'subheaderdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/subheader/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/subheader/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.subheader',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/subheader/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/subheader'
        },
        {
            'name'      : 'swipe',
            'moduleName': 'material.components.swipe',
            'label'     : 'Swipe',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'demoSwipe',
                        'module'      : 'demoSwipe',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'swipedemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/swipe/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [
                        {
                            'name'      : 'readme.html',
                            'label'     : 'readme.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/swipe/demoBasicUsage/readme.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/swipe/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.swipe',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/swipe/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/swipe'
        },
        {
            'name'      : 'switch',
            'moduleName': 'material.components.switch',
            'label'     : 'Switch',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'switchDemo1',
                        'module'      : 'switchDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'switchdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/switch/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/switch/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.switch',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/switch/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/switch'
        },
        {
            'name'      : 'tabs',
            'moduleName': 'material.components.tabs',
            'label'     : 'Tabs',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'tabsDemoDynamicHeight',
                        'module'      : 'tabsDemoDynamicHeight',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'tabsdemoDynamicHeight',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/tabs/demoDynamicHeight/style.css'
                        }
                    ],
                    'html'      : [
                        {
                            'name'      : 'readme.html',
                            'label'     : 'readme.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/tabs/demoDynamicHeight/readme.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/tabs/demoDynamicHeight/script.js'
                        }
                    ],
                    'moduleName': 'material.components.tabs',
                    'name'      : 'demoDynamicHeight',
                    'label'     : 'Dynamic Height',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/tabs/demoDynamicHeight/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'tabsDemoDynamicTabs',
                        'module'      : 'tabsDemoDynamicTabs',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'tabsdemoDynamicTabs',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/tabs/demoDynamicTabs/style.css'
                        }
                    ],
                    'html'      : [
                        {
                            'name'      : 'readme.html',
                            'label'     : 'readme.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/tabs/demoDynamicTabs/readme.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/tabs/demoDynamicTabs/script.js'
                        }
                    ],
                    'moduleName': 'material.components.tabs',
                    'name'      : 'demoDynamicTabs',
                    'label'     : 'Dynamic Tabs',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/tabs/demoDynamicTabs/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'tabsDemoStaticTabs',
                        'module'      : 'tabsDemoStaticTabs',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'tabsdemoStaticTabs',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/tabs/demoStaticTabs/style.css'
                        }
                    ],
                    'html'      : [
                        {
                            'name'      : 'readme.html',
                            'label'     : 'readme.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/tabs/demoStaticTabs/readme.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/tabs/demoStaticTabs/script.js'
                        }
                    ],
                    'moduleName': 'material.components.tabs',
                    'name'      : 'demoStaticTabs',
                    'label'     : 'Static Tabs',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/tabs/demoStaticTabs/index.html'
                    }
                }
            ],
            'url'       : 'demo/tabs'
        },
        {
            'name'      : 'toast',
            'moduleName': 'material.components.toast',
            'label'     : 'Toast',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'toastDemo1',
                        'module'      : 'toastDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'toastdemoBasicUsage',
                    'css'       : [],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/toast/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.toast',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/toast/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'toastDemo2',
                        'module'      : 'toastDemo2',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'toastdemoCustomUsage',
                    'css'       : [],
                    'html'      : [
                        {
                            'name'      : 'toast-template.html',
                            'label'     : 'toast-template.html',
                            'fileType'  : 'html',
                            'outputPath': 'demo-partials/toast/demoCustomUsage/toast-template.html'
                        }
                    ],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/toast/demoCustomUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.toast',
                    'name'      : 'demoCustomUsage',
                    'label'     : 'Custom Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/toast/demoCustomUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/toast'
        },
        {
            'name'      : 'toolbar',
            'moduleName': 'material.components.toolbar',
            'label'     : 'Toolbar',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'toolbarDemo1',
                        'module'      : 'toolbarDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'toolbardemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/toolbar/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/toolbar/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.toolbar',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/toolbar/demoBasicUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'toolbarDemo2',
                        'module'      : 'toolbarDemo2',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'toolbardemoScrollShrink',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/toolbar/demoScrollShrink/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/toolbar/demoScrollShrink/script.js'
                        }
                    ],
                    'moduleName': 'material.components.toolbar',
                    'name'      : 'demoScrollShrink',
                    'label'     : 'Scroll Shrink',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/toolbar/demoScrollShrink/index.html'
                    }
                }
            ],
            'url'       : 'demo/toolbar'
        },
        {
            'name'      : 'tooltip',
            'moduleName': 'material.components.tooltip',
            'label'     : 'Tooltip',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'tooltipDemo1',
                        'module'      : 'tooltipDemo1',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'tooltipdemoBasicUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/tooltip/demoBasicUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/tooltip/demoBasicUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.tooltip',
                    'name'      : 'demoBasicUsage',
                    'label'     : 'Basic Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/tooltip/demoBasicUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/tooltip'
        },
        {
            'name'      : 'virtualRepeat',
            'moduleName': 'material.components.virtualRepeat',
            'label'     : 'Virtual Repeat',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'virtualRepeatDeferredLoadingDemo',
                        'module'      : 'virtualRepeatDeferredLoadingDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'virtualRepeatdemoDeferredLoading',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/virtualRepeat/demoDeferredLoading/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/virtualRepeat/demoDeferredLoading/script.js'
                        }
                    ],
                    'moduleName': 'material.components.virtualRepeat',
                    'name'      : 'demoDeferredLoading',
                    'label'     : 'Deferred Loading',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/virtualRepeat/demoDeferredLoading/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'virtualRepeatHorizontalDemo',
                        'module'      : 'virtualRepeatHorizontalDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'virtualRepeatdemoHorizontalUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/virtualRepeat/demoHorizontalUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/virtualRepeat/demoHorizontalUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.virtualRepeat',
                    'name'      : 'demoHorizontalUsage',
                    'label'     : 'Horizontal Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/virtualRepeat/demoHorizontalUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'virtualRepeatInfiniteScrollDemo',
                        'module'      : 'virtualRepeatInfiniteScrollDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'virtualRepeatdemoInfiniteScroll',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/virtualRepeat/demoInfiniteScroll/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/virtualRepeat/demoInfiniteScroll/script.js'
                        }
                    ],
                    'moduleName': 'material.components.virtualRepeat',
                    'name'      : 'demoInfiniteScroll',
                    'label'     : 'Infinite Scroll',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/virtualRepeat/demoInfiniteScroll/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'virtualRepeatScrollToDemo',
                        'module'      : 'virtualRepeatScrollToDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'virtualRepeatdemoScrollTo',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/virtualRepeat/demoScrollTo/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/virtualRepeat/demoScrollTo/script.js'
                        }
                    ],
                    'moduleName': 'material.components.virtualRepeat',
                    'name'      : 'demoScrollTo',
                    'label'     : 'Scroll To',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/virtualRepeat/demoScrollTo/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'virtualRepeatVerticalDemo',
                        'module'      : 'virtualRepeatVerticalDemo',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'virtualRepeatdemoVerticalUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/virtualRepeat/demoVerticalUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/virtualRepeat/demoVerticalUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.virtualRepeat',
                    'name'      : 'demoVerticalUsage',
                    'label'     : 'Vertical Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/virtualRepeat/demoVerticalUsage/index.html'
                    }
                }
            ],
            'url'       : 'demo/virtualRepeat'
        },
        {
            'name'      : 'whiteframe',
            'moduleName': 'material.components.whiteframe',
            'label'     : 'Whiteframe',
            'demos'     : [
                {
                    'ngModule'  : {
                        'name'        : 'whiteframeBasicUsage',
                        'module'      : 'whiteframeBasicUsage',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'whiteframedemoBasicClassUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/whiteframe/demoBasicClassUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/whiteframe/demoBasicClassUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.whiteframe',
                    'name'      : 'demoBasicClassUsage',
                    'label'     : 'Basic Class Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/whiteframe/demoBasicClassUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'whiteframeDirectiveUsage',
                        'module'      : 'whiteframeDirectiveUsage',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'whiteframedemoDirectiveAttributeUsage',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/whiteframe/demoDirectiveAttributeUsage/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/whiteframe/demoDirectiveAttributeUsage/script.js'
                        }
                    ],
                    'moduleName': 'material.components.whiteframe',
                    'name'      : 'demoDirectiveAttributeUsage',
                    'label'     : 'Directive Attribute Usage',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/whiteframe/demoDirectiveAttributeUsage/index.html'
                    }
                },
                {
                    'ngModule'  : {
                        'name'        : 'whiteframedemoDirectiveInterpolationUsage',
                        'module'      : 'whiteframedemoDirectiveInterpolationUsage',
                        'dependencies': [
                            'ngMaterial'
                        ]
                    },
                    'id'        : 'whiteframedemoDirectiveInterpolation',
                    'css'       : [
                        {
                            'name'      : 'style.css',
                            'label'     : 'style.css',
                            'fileType'  : 'css',
                            'outputPath': 'demo-partials/whiteframe/demoDirectiveInterpolation/style.css'
                        }
                    ],
                    'html'      : [],
                    'js'        : [
                        {
                            'name'      : 'script.js',
                            'label'     : 'script.js',
                            'fileType'  : 'js',
                            'outputPath': 'demo-partials/whiteframe/demoDirectiveInterpolation/script.js'
                        }
                    ],
                    'moduleName': 'material.components.whiteframe',
                    'name'      : 'demoDirectiveInterpolation',
                    'label'     : 'Directive Interpolation',
                    'index'     : {
                        'name'      : 'index.html',
                        'label'     : 'index.html',
                        'fileType'  : 'html',
                        'outputPath': 'demo-partials/whiteframe/demoDirectiveInterpolation/index.html'
                    }
                }
            ],
            'url'       : 'demo/whiteframe'
        }
    ]);
angular.module('app.components.material-docs')
    .constant('COMPONENTS', [
        {
            'name'      : 'material.components.autocomplete',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.autocomplete/index.html',
            'url'       : 'api/material.components.autocomplete',
            'label'     : 'material.components.autocomplete',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/autocomplete/autocomplete.js',
            'docs'      : [
                {
                    'name'      : 'mdAutocomplete',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': true,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.autocomplete/directive/mdAutocomplete.html',
                    'url'       : 'api/directive/mdAutocomplete',
                    'label'     : 'mdAutocomplete',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/autocomplete/js/autocompleteDirective.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdHighlightText',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': true,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.autocomplete/directive/mdHighlightText.html',
                    'url'       : 'api/directive/mdHighlightText',
                    'label'     : 'mdHighlightText',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/autocomplete/js/highlightDirective.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.bottomSheet',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.bottomSheet/index.html',
            'url'       : 'api/material.components.bottomSheet',
            'label'     : 'material.components.bottomSheet',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/bottomSheet/bottom-sheet.js',
            'docs'      : [
                {
                    'name'      : '$mdBottomSheet',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.components.bottomSheet/service/$mdBottomSheet.html',
                    'url'       : 'api/service/$mdBottomSheet',
                    'label'     : '$mdBottomSheet',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/bottomSheet/bottom-sheet.js',
                    'hasDemo'   : false
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.button',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.button/index.html',
            'url'       : 'api/material.components.button',
            'label'     : 'material.components.button',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/button/button.js',
            'docs'      : [
                {
                    'name'      : 'mdButton',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.button/directive/mdButton.html',
                    'url'       : 'api/directive/mdButton',
                    'label'     : 'mdButton',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/button/button.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.card',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.card/index.html',
            'url'       : 'api/material.components.card',
            'label'     : 'material.components.card',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/card/card.js',
            'docs'      : [
                {
                    'name'      : 'mdCard',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.card/directive/mdCard.html',
                    'url'       : 'api/directive/mdCard',
                    'label'     : 'mdCard',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/card/card.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.checkbox',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.checkbox/index.html',
            'url'       : 'api/material.components.checkbox',
            'label'     : 'material.components.checkbox',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/checkbox/checkbox.js',
            'docs'      : [
                {
                    'name'      : 'mdCheckbox',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.checkbox/directive/mdCheckbox.html',
                    'url'       : 'api/directive/mdCheckbox',
                    'label'     : 'mdCheckbox',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/checkbox/checkbox.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.chips',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.chips/index.html',
            'url'       : 'api/material.components.chips',
            'label'     : 'material.components.chips',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/chips/chips.js',
            'docs'      : [
                {
                    'name'      : 'mdChip',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': true,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.chips/directive/mdChip.html',
                    'url'       : 'api/directive/mdChip',
                    'label'     : 'mdChip',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/chips/js/chipDirective.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdChipRemove',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : false,
                        'attribute': true,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.chips/directive/mdChipRemove.html',
                    'url'       : 'api/directive/mdChipRemove',
                    'label'     : 'mdChipRemove',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/chips/js/chipRemoveDirective.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdChips',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': true,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.chips/directive/mdChips.html',
                    'url'       : 'api/directive/mdChips',
                    'label'     : 'mdChips',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/chips/js/chipsDirective.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdContactChips',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': true,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.chips/directive/mdContactChips.html',
                    'url'       : 'api/directive/mdContactChips',
                    'label'     : 'mdContactChips',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/chips/js/contactChipsDirective.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.colors',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.colors/index.html',
            'url'       : 'api/material.components.colors',
            'label'     : 'material.components.colors',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/colors/colors.js',
            'docs'      : [
                {
                    'name'      : '$mdColors',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.components.colors/service/$mdColors.html',
                    'url'       : 'api/service/$mdColors',
                    'label'     : '$mdColors',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/colors/colors.js',
                    'hasDemo'   : false
                },
                {
                    'name'      : 'mdColors',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : false,
                        'attribute': true,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.colors/directive/mdColors.html',
                    'url'       : 'api/directive/mdColors',
                    'label'     : 'mdColors',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/colors/colors.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.content',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.content/index.html',
            'url'       : 'api/material.components.content',
            'label'     : 'material.components.content',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/content/content.js',
            'docs'      : [
                {
                    'name'      : 'mdContent',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.content/directive/mdContent.html',
                    'url'       : 'api/directive/mdContent',
                    'label'     : 'mdContent',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/content/content.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.datepicker',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.datepicker/index.html',
            'url'       : 'api/material.components.datepicker',
            'label'     : 'material.components.datepicker',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/datepicker/datePicker.js',
            'docs'      : [
                {
                    'name'      : 'mdCalendar',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': true,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.datepicker/directive/mdCalendar.html',
                    'url'       : 'api/directive/mdCalendar',
                    'label'     : 'mdCalendar',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/datepicker/js/calendar.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : '$mdDateLocaleProvider',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.components.datepicker/service/$mdDateLocaleProvider.html',
                    'url'       : 'api/service/$mdDateLocaleProvider',
                    'label'     : '$mdDateLocaleProvider',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/datepicker/js/dateLocaleProvider.js',
                    'hasDemo'   : false
                },
                {
                    'name'      : 'mdDatepicker',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': true,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.datepicker/directive/mdDatepicker.html',
                    'url'       : 'api/directive/mdDatepicker',
                    'label'     : 'mdDatepicker',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/datepicker/js/datepickerDirective.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.dialog',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.dialog/index.html',
            'url'       : 'api/material.components.dialog',
            'label'     : 'material.components.dialog',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/dialog/dialog.js',
            'docs'      : [
                {
                    'name'      : 'mdDialog',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.dialog/directive/mdDialog.html',
                    'url'       : 'api/directive/mdDialog',
                    'label'     : 'mdDialog',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/dialog/dialog.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : '$mdDialog',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.components.dialog/service/$mdDialog.html',
                    'url'       : 'api/service/$mdDialog',
                    'label'     : '$mdDialog',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/dialog/dialog.js',
                    'hasDemo'   : false
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.divider',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.divider/index.html',
            'url'       : 'api/material.components.divider',
            'label'     : 'material.components.divider',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/divider/divider.js',
            'docs'      : [
                {
                    'name'      : 'mdDivider',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.divider/directive/mdDivider.html',
                    'url'       : 'api/directive/mdDivider',
                    'label'     : 'mdDivider',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/divider/divider.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.fabActions',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.fabActions/index.html',
            'url'       : 'api/material.components.fabActions',
            'label'     : 'material.components.fabActions',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/fabActions/fabActions.js',
            'docs'      : [
                {
                    'name'      : 'mdFabActions',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.fabActions/directive/mdFabActions.html',
                    'url'       : 'api/directive/mdFabActions',
                    'label'     : 'mdFabActions',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/fabActions/fabActions.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.fabSpeedDial',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.fabSpeedDial/index.html',
            'url'       : 'api/material.components.fabSpeedDial',
            'label'     : 'material.components.fabSpeedDial',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/fabSpeedDial/fabSpeedDial.js',
            'docs'      : [
                {
                    'name'      : 'mdFabSpeedDial',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.fabSpeedDial/directive/mdFabSpeedDial.html',
                    'url'       : 'api/directive/mdFabSpeedDial',
                    'label'     : 'mdFabSpeedDial',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/fabSpeedDial/fabSpeedDial.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.fabToolbar',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.fabToolbar/index.html',
            'url'       : 'api/material.components.fabToolbar',
            'label'     : 'material.components.fabToolbar',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/fabToolbar/fabToolbar.js',
            'docs'      : [
                {
                    'name'      : 'mdFabToolbar',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.fabToolbar/directive/mdFabToolbar.html',
                    'url'       : 'api/directive/mdFabToolbar',
                    'label'     : 'mdFabToolbar',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/fabToolbar/fabToolbar.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.gridList',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.gridList/index.html',
            'url'       : 'api/material.components.gridList',
            'label'     : 'material.components.gridList',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/gridList/grid-list.js',
            'docs'      : [
                {
                    'name'      : 'mdGridList',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.gridList/directive/mdGridList.html',
                    'url'       : 'api/directive/mdGridList',
                    'label'     : 'mdGridList',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/gridList/grid-list.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdGridTile',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.gridList/directive/mdGridTile.html',
                    'url'       : 'api/directive/mdGridTile',
                    'label'     : 'mdGridTile',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/gridList/grid-list.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.icon',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.icon/index.html',
            'url'       : 'api/material.components.icon',
            'label'     : 'material.components.icon',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/icon/icon.js',
            'docs'      : [
                {
                    'name'      : 'mdIcon',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.icon/directive/mdIcon.html',
                    'url'       : 'api/directive/mdIcon',
                    'label'     : 'mdIcon',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/icon/js/iconDirective.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : '$mdIconProvider',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.components.icon/service/$mdIconProvider.html',
                    'url'       : 'api/service/$mdIconProvider',
                    'label'     : '$mdIconProvider',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/icon/js/iconService.js',
                    'hasDemo'   : false
                },
                {
                    'name'      : '$mdIcon',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.components.icon/service/$mdIcon.html',
                    'url'       : 'api/service/$mdIcon',
                    'label'     : '$mdIcon',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/icon/js/iconService.js',
                    'hasDemo'   : false
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.input',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.input/index.html',
            'url'       : 'api/material.components.input',
            'label'     : 'material.components.input',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/input/input.js',
            'docs'      : [
                {
                    'name'      : 'mdInputContainer',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.input/directive/mdInputContainer.html',
                    'url'       : 'api/directive/mdInputContainer',
                    'label'     : 'mdInputContainer',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/input/input.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdInput',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.input/directive/mdInput.html',
                    'url'       : 'api/directive/mdInput',
                    'label'     : 'mdInput',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/input/input.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdSelectOnFocus',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : false,
                        'attribute': true,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.input/directive/mdSelectOnFocus.html',
                    'url'       : 'api/directive/mdSelectOnFocus',
                    'label'     : 'mdSelectOnFocus',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/input/input.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.list',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.list/index.html',
            'url'       : 'api/material.components.list',
            'label'     : 'material.components.list',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/list/list.js',
            'docs'      : [
                {
                    'name'      : 'mdList',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.list/directive/mdList.html',
                    'url'       : 'api/directive/mdList',
                    'label'     : 'mdList',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/list/list.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdListItem',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.list/directive/mdListItem.html',
                    'url'       : 'api/directive/mdListItem',
                    'label'     : 'mdListItem',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/list/list.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.menu',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.menu/index.html',
            'url'       : 'api/material.components.menu',
            'label'     : 'material.components.menu',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/menu/menu.js',
            'docs'      : [
                {
                    'name'      : 'mdMenu',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.menu/directive/mdMenu.html',
                    'url'       : 'api/directive/mdMenu',
                    'label'     : 'mdMenu',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/menu/js/menuDirective.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.menu-bar',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.menu-bar/index.html',
            'url'       : 'api/material.components.menu-bar',
            'label'     : 'material.components.menu-bar',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/menuBar/menu-bar.js',
            'docs'      : [
                {
                    'name'      : 'mdMenuBar',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.menu-bar/directive/mdMenuBar.html',
                    'url'       : 'api/directive/mdMenuBar',
                    'label'     : 'mdMenuBar',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/menuBar/js/menuBarDirective.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.navBar',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.navBar/index.html',
            'url'       : 'api/material.components.navBar',
            'label'     : 'material.components.navBar',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/navBar/navBar.js',
            'docs'      : [
                {
                    'name'      : 'mdNavBar',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.navBar/directive/mdNavBar.html',
                    'url'       : 'api/directive/mdNavBar',
                    'label'     : 'mdNavBar',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/navBar/navBar.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdNavItem',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.navBar/directive/mdNavItem.html',
                    'url'       : 'api/directive/mdNavItem',
                    'label'     : 'mdNavItem',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/navBar/navBar.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.panel',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.panel/index.html',
            'url'       : 'api/material.components.panel',
            'label'     : 'material.components.panel',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/panel/panel.js',
            'docs'      : [
                {
                    'name'      : '$mdPanel',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.components.panel/service/$mdPanel.html',
                    'url'       : 'api/service/$mdPanel',
                    'label'     : '$mdPanel',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/panel/panel.js',
                    'hasDemo'   : false
                },
                {
                    'name'      : 'MdPanelRef',
                    'type'      : 'type',
                    'outputPath': 'partials/api/material.components.panel/type/MdPanelRef.html',
                    'url'       : 'api/type/MdPanelRef',
                    'label'     : 'MdPanelRef',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/panel/panel.js',
                    'hasDemo'   : false
                },
                {
                    'name'      : 'MdPanelPosition',
                    'type'      : 'type',
                    'outputPath': 'partials/api/material.components.panel/type/MdPanelPosition.html',
                    'url'       : 'api/type/MdPanelPosition',
                    'label'     : 'MdPanelPosition',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/panel/panel.js',
                    'hasDemo'   : false
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.progressCircular',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.progressCircular/index.html',
            'url'       : 'api/material.components.progressCircular',
            'label'     : 'material.components.progressCircular',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/progressCircular/progress-circular.js',
            'docs'      : [
                {
                    'name'      : 'mdProgressCircular',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.progressCircular/directive/mdProgressCircular.html',
                    'url'       : 'api/directive/mdProgressCircular',
                    'label'     : 'mdProgressCircular',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/progressCircular/js/progressCircularDirective.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : '$mdProgressCircular',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.components.progressCircular/service/$mdProgressCircular.html',
                    'url'       : 'api/service/$mdProgressCircular',
                    'label'     : '$mdProgressCircular',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/progressCircular/js/progressCircularProvider.js',
                    'hasDemo'   : false
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.progressLinear',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.progressLinear/index.html',
            'url'       : 'api/material.components.progressLinear',
            'label'     : 'material.components.progressLinear',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/progressLinear/progress-linear.js',
            'docs'      : [
                {
                    'name'      : 'mdProgressLinear',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.progressLinear/directive/mdProgressLinear.html',
                    'url'       : 'api/directive/mdProgressLinear',
                    'label'     : 'mdProgressLinear',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/progressLinear/progress-linear.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.radioButton',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.radioButton/index.html',
            'url'       : 'api/material.components.radioButton',
            'label'     : 'material.components.radioButton',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/radioButton/radio-button.js',
            'docs'      : [
                {
                    'name'      : 'mdRadioGroup',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.radioButton/directive/mdRadioGroup.html',
                    'url'       : 'api/directive/mdRadioGroup',
                    'label'     : 'mdRadioGroup',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/radioButton/radio-button.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdRadioButton',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.radioButton/directive/mdRadioButton.html',
                    'url'       : 'api/directive/mdRadioButton',
                    'label'     : 'mdRadioButton',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/radioButton/radio-button.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.select',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.select/index.html',
            'url'       : 'api/material.components.select',
            'label'     : 'material.components.select',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/select/select.js',
            'docs'      : [
                {
                    'name'      : 'mdSelect',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.select/directive/mdSelect.html',
                    'url'       : 'api/directive/mdSelect',
                    'label'     : 'mdSelect',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/select/select.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.sidenav',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.sidenav/index.html',
            'url'       : 'api/material.components.sidenav',
            'label'     : 'material.components.sidenav',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/sidenav/sidenav.js',
            'docs'      : [
                {
                    'name'      : '$mdSidenav',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.components.sidenav/service/$mdSidenav.html',
                    'url'       : 'api/service/$mdSidenav',
                    'label'     : '$mdSidenav',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/sidenav/sidenav.js',
                    'hasDemo'   : false
                },
                {
                    'name'      : 'mdSidenavFocus',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : false,
                        'attribute': true,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.sidenav/directive/mdSidenavFocus.html',
                    'url'       : 'api/directive/mdSidenavFocus',
                    'label'     : 'mdSidenavFocus',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/sidenav/sidenav.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdSidenav',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.sidenav/directive/mdSidenav.html',
                    'url'       : 'api/directive/mdSidenav',
                    'label'     : 'mdSidenav',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/sidenav/sidenav.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.slider',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.slider/index.html',
            'url'       : 'api/material.components.slider',
            'label'     : 'material.components.slider',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/slider/slider.js',
            'docs'      : [
                {
                    'name'      : 'mdSliderContainer',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.slider/directive/mdSliderContainer.html',
                    'url'       : 'api/directive/mdSliderContainer',
                    'label'     : 'mdSliderContainer',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/slider/slider.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdSlider',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.slider/directive/mdSlider.html',
                    'url'       : 'api/directive/mdSlider',
                    'label'     : 'mdSlider',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/slider/slider.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.sticky',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.sticky/index.html',
            'url'       : 'api/material.components.sticky',
            'label'     : 'material.components.sticky',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/sticky/sticky.js',
            'docs'      : [
                {
                    'name'      : '$mdSticky',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.components.sticky/service/$mdSticky.html',
                    'url'       : 'api/service/$mdSticky',
                    'label'     : '$mdSticky',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/sticky/sticky.js',
                    'hasDemo'   : false
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.subheader',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.subheader/index.html',
            'url'       : 'api/material.components.subheader',
            'label'     : 'material.components.subheader',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/subheader/subheader.js',
            'docs'      : [
                {
                    'name'      : 'mdSubheader',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.subheader/directive/mdSubheader.html',
                    'url'       : 'api/directive/mdSubheader',
                    'label'     : 'mdSubheader',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/subheader/subheader.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.swipe',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.swipe/index.html',
            'url'       : 'api/material.components.swipe',
            'label'     : 'material.components.swipe',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/swipe/swipe.js',
            'docs'      : [
                {
                    'name'      : 'mdSwipeLeft',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : false,
                        'attribute': true,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.swipe/directive/mdSwipeLeft.html',
                    'url'       : 'api/directive/mdSwipeLeft',
                    'label'     : 'mdSwipeLeft',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/swipe/swipe.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdSwipeRight',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : false,
                        'attribute': true,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.swipe/directive/mdSwipeRight.html',
                    'url'       : 'api/directive/mdSwipeRight',
                    'label'     : 'mdSwipeRight',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/swipe/swipe.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdSwipeUp',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : false,
                        'attribute': true,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.swipe/directive/mdSwipeUp.html',
                    'url'       : 'api/directive/mdSwipeUp',
                    'label'     : 'mdSwipeUp',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/swipe/swipe.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdSwipeDown',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : false,
                        'attribute': true,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.swipe/directive/mdSwipeDown.html',
                    'url'       : 'api/directive/mdSwipeDown',
                    'label'     : 'mdSwipeDown',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/swipe/swipe.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.switch',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.switch/index.html',
            'url'       : 'api/material.components.switch',
            'label'     : 'material.components.switch',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/switch/switch.js',
            'docs'      : [
                {
                    'name'      : 'mdSwitch',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': true,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.switch/directive/mdSwitch.html',
                    'url'       : 'api/directive/mdSwitch',
                    'label'     : 'mdSwitch',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/switch/switch.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.tabs',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.tabs/index.html',
            'url'       : 'api/material.components.tabs',
            'label'     : 'material.components.tabs',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/tabs/tabs.js',
            'docs'      : [
                {
                    'name'      : 'mdTab',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.tabs/directive/mdTab.html',
                    'url'       : 'api/directive/mdTab',
                    'label'     : 'mdTab',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/tabs/js/tabDirective.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdTabs',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.tabs/directive/mdTabs.html',
                    'url'       : 'api/directive/mdTabs',
                    'label'     : 'mdTabs',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/tabs/js/tabsDirective.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.toast',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.toast/index.html',
            'url'       : 'api/material.components.toast',
            'label'     : 'material.components.toast',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/toast/toast.js',
            'docs'      : [
                {
                    'name'      : '$mdToast',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.components.toast/service/$mdToast.html',
                    'url'       : 'api/service/$mdToast',
                    'label'     : '$mdToast',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/toast/toast.js',
                    'hasDemo'   : false
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.toolbar',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.toolbar/index.html',
            'url'       : 'api/material.components.toolbar',
            'label'     : 'material.components.toolbar',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/toolbar/toolbar.js',
            'docs'      : [
                {
                    'name'      : 'mdToolbar',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.toolbar/directive/mdToolbar.html',
                    'url'       : 'api/directive/mdToolbar',
                    'label'     : 'mdToolbar',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/toolbar/toolbar.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.tooltip',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.tooltip/index.html',
            'url'       : 'api/material.components.tooltip',
            'label'     : 'material.components.tooltip',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/tooltip/tooltip.js',
            'docs'      : [
                {
                    'name'      : 'mdTooltip',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': true,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.tooltip/directive/mdTooltip.html',
                    'url'       : 'api/directive/mdTooltip',
                    'label'     : 'mdTooltip',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/tooltip/tooltip.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.virtualRepeat',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.virtualRepeat/index.html',
            'url'       : 'api/material.components.virtualRepeat',
            'label'     : 'material.components.virtualRepeat',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/virtualRepeat/virtual-repeater.js',
            'docs'      : [
                {
                    'name'      : 'mdVirtualRepeatContainer',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': false,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.virtualRepeat/directive/mdVirtualRepeatContainer.html',
                    'url'       : 'api/directive/mdVirtualRepeatContainer',
                    'label'     : 'mdVirtualRepeatContainer',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/virtualRepeat/virtual-repeater.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : 'mdVirtualRepeat',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : false,
                        'attribute': true,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.virtualRepeat/directive/mdVirtualRepeat.html',
                    'url'       : 'api/directive/mdVirtualRepeat',
                    'label'     : 'mdVirtualRepeat',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/virtualRepeat/virtual-repeater.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.components.whiteframe',
            'type'      : 'module',
            'outputPath': 'partials/api/material.components.whiteframe/index.html',
            'url'       : 'api/material.components.whiteframe',
            'label'     : 'material.components.whiteframe',
            'module'    : 'material.components',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/whiteframe/whiteframe.js',
            'docs'      : [
                {
                    'name'      : 'mdWhiteframe',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': true,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.components.whiteframe/directive/mdWhiteframe.html',
                    'url'       : 'api/directive/mdWhiteframe',
                    'label'     : 'mdWhiteframe',
                    'module'    : 'material.components',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/components/whiteframe/whiteframe.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.core.aria',
            'type'      : 'module',
            'outputPath': 'partials/api/material.core.aria/index.html',
            'url'       : 'api/material.core.aria',
            'label'     : 'material.core.aria',
            'module'    : 'material.core',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/aria/aria.js',
            'docs'      : [
                {
                    'name'      : '$mdAriaProvider',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.core.aria/service/$mdAriaProvider.html',
                    'url'       : 'api/service/$mdAriaProvider',
                    'label'     : '$mdAriaProvider',
                    'module'    : 'material.core',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/aria/aria.js',
                    'hasDemo'   : false
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.core.ripple',
            'type'      : 'module',
            'outputPath': 'partials/api/material.core.ripple/index.html',
            'url'       : 'api/material.core.ripple',
            'label'     : 'material.core.ripple',
            'module'    : 'material.core',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/ripple/ripple.js',
            'docs'      : [
                {
                    'name'      : 'mdInkRipple',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': true,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.core.ripple/directive/mdInkRipple.html',
                    'url'       : 'api/directive/mdInkRipple',
                    'label'     : 'mdInkRipple',
                    'module'    : 'material.core',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/ripple/ripple.js',
                    'hasDemo'   : true
                },
                {
                    'name'      : '$mdInkRipple',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.core.ripple/service/$mdInkRipple.html',
                    'url'       : 'api/service/$mdInkRipple',
                    'label'     : '$mdInkRipple',
                    'module'    : 'material.core',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/ripple/ripple.js',
                    'hasDemo'   : false
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.core.theming',
            'type'      : 'module',
            'outputPath': 'partials/api/material.core.theming/index.html',
            'url'       : 'api/material.core.theming',
            'label'     : 'material.core.theming',
            'module'    : 'material.core',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/theming/theming.js',
            'docs'      : [
                {
                    'name'      : '$mdThemingProvider',
                    'type'      : 'service',
                    'outputPath': 'partials/api/material.core.theming/service/$mdThemingProvider.html',
                    'url'       : 'api/service/$mdThemingProvider',
                    'label'     : '$mdThemingProvider',
                    'module'    : 'material.core',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/services/theming/theming.js',
                    'hasDemo'   : false
                }
            ],
            'hasDemo'   : false
        },
        {
            'name'      : 'material.core.util',
            'type'      : 'module',
            'outputPath': 'partials/api/material.core.util/index.html',
            'url'       : 'api/material.core.util',
            'label'     : 'material.core.util',
            'module'    : 'material.core',
            'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/util/util.js',
            'docs'      : [
                {
                    'name'      : 'mdAutofocus',
                    'type'      : 'directive',
                    'restrict'  : {
                        'element'  : true,
                        'attribute': true,
                        'cssClass' : false,
                        'comment'  : false
                    },
                    'outputPath': 'partials/api/material.core.util/directive/mdAutofocus.html',
                    'url'       : 'api/directive/mdAutofocus',
                    'label'     : 'mdAutofocus',
                    'module'    : 'material.core',
                    'githubUrl' : 'https://github.com/angular/material/blob/master/src/core/util/autofocus.js',
                    'hasDemo'   : true
                }
            ],
            'hasDemo'   : false
        }
    ]);
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider, msApiProvider)
    {
        // Translation
        $translatePartialLoaderProvider.addPart('app/quick-panel');

        // Api
        msApiProvider.register('quickPanel.activities', ['app/data/quick-panel/activities.json']);
        msApiProvider.register('quickPanel.contacts', ['app/data/quick-panel/contacts.json']);
        msApiProvider.register('quickPanel.events', ['app/data/quick-panel/events.json']);
        msApiProvider.register('quickPanel.notes', ['app/data/quick-panel/notes.json']);
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('ChatTabController', ChatTabController);

    /** @ngInject */
    function ChatTabController(msApi, $timeout)
    {
        var vm = this;

        // Data
        vm.chat = {};
        vm.chatActive = false;
        vm.replyMessage = '';

        msApi.request('quickPanel.contacts@get', {},
            // Success
            function (response)
            {
                vm.contacts = response.data;
            }
        );

        // Methods
        vm.toggleChat = toggleChat;
        vm.reply = reply;

        //////////

        function toggleChat(contact)
        {
            vm.chatActive = !vm.chatActive;

            if ( vm.chatActive )
            {
                vm.replyMessage = '';
                vm.chat.contact = contact;
                scrollToBottomOfChat(0);
            }
        }

        function reply()
        {
            if ( vm.replyMessage === '' )
            {
                return;
            }

            if ( !vm.chat.contact.dialog )
            {
                vm.chat.contact.dialog = [];
            }

            vm.chat.contact.dialog.push({
                who    : 'user',
                message: vm.replyMessage,
                time   : 'Just now'
            });

            vm.replyMessage = '';

            scrollToBottomOfChat(400);
        }

        function scrollToBottomOfChat(speed)
        {
            var chatDialog = angular.element('#chat-dialog');

            $timeout(function ()
            {
                chatDialog.animate({
                    scrollTop: chatDialog[0].scrollHeight
                }, speed);
            }, 0);

        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.typography', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_typography', {
            url      : '/ui/typography',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/typography/typography.html',
                    controller : 'TypographyController as vm'
                }
            },
            bodyClass: 'typography'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.typography')
        .controller('TypographyController', TypographyController);

    /** @ngInject */
    function TypographyController()
    {
        // Data

        // Methods

        //////////
    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.ui.theme-colors')
        .controller('ThemeColorsController', ThemeColorsController);

    /** @ngInject */
    function ThemeColorsController(fuseTheming, $mdDialog, $document)
    {
        var vm = this;
        // Data
        vm.themes = fuseTheming.themes;

        // Methods
        vm.createTheme = createTheme;
        //////////

        function createTheme(ev)
        {
            $mdDialog.show({
                controller         : 'CustomThemeDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/ui/theme-colors/dialogs/custom-theme/custom-theme-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.ui.material-colors', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_material-colors', {
            url  : '/ui/material-colors',
            views: {
                'content@app': {
                    templateUrl: 'app/main/ui/material-colors/material-colors.html',
                    controller : 'MaterialColorsController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.material-colors')
        .controller('MaterialColorsController', MaterialColorsController);

    /** @ngInject */
    function MaterialColorsController($mdColorPalette)
    {
        var vm = this;

        // Data
        vm.palettes = $mdColorPalette;

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.forms', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_forms', {
            url      : '/ui/forms',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/forms/forms.html',
                    controller : 'FormsController as vm'
                }
            },
            bodyClass: 'forms'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.forms')
        .controller('FormsController', FormsController);

    /** @ngInject */
    function FormsController($mdDialog)
    {
        var vm = this;

        // Data
        vm.horizontalStepper = {
            step1: {},
            step2: {},
            step3: {},
            step4: {},
            step5: {}
        };

        vm.verticalStepper = {
            step1: {},
            step2: {},
            step3: {},
            step4: {},
            step5: {}
        };

        vm.basicForm = {};
        vm.formWizard = {};
        vm.states = ('AL AK AZ AR CA CO CT DE FL GA HI ID IL IN IA KS KY LA ME MD MA MI MN MS ' +
        'MO MT NE NV NH NJ NM NY NC ND OH OK OR PA RI SC SD TN TX UT VT VA WA WV WI ' +
        'WY').split(' ').map(function (state)
        {
            return {abbrev: state};
        });

        // Methods
        vm.sendForm = sendForm;
        vm.showDataDialog = showDataDialog;
        vm.submitHorizontalStepper = submitHorizontalStepper;
        vm.submitVerticalStepper = submitVerticalStepper;

        //////////

        /**
         * Submit horizontal stepper data
         * @param event
         */
        function submitHorizontalStepper(event)
        {
            // Show the model data in a dialog
            vm.showDataDialog(event, vm.horizontalStepper);

            // Reset the form model
            vm.horizontalStepper = {
                step1: {},
                step2: {},
                step3: {},
                step4: {},
                step5: {}
            };
        }

        /**
         * Submit vertical stepper data
         *
         * @param event
         */
        function submitVerticalStepper(event)
        {
            // Show the model data in a dialog
            vm.showDataDialog(event, vm.verticalStepper);

            // Reset the form model
            vm.verticalStepper = {
                step1: {},
                step2: {},
                step3: {},
                step4: {},
                step5: {}
            };
        }

        /**
         * Submit stepper form
         *
         * @param ev
         */
        function showDataDialog(ev, data)
        {
            // You can do an API call here to send the form to your server

            // Show the sent data.. you can delete this safely.
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    };
                },
                template           : '<md-dialog>' +
                '  <md-dialog-content><h1>You have sent the form with the following data</h1><div><pre>{{formWizardData | json}}</pre></div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Close' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: data
                },
                clickOutsideToClose: true
            });
        }

        /**
         * Send form
         */
        function sendForm(ev)
        {
            // You can do an API call here to send the form to your server

            // Show the sent data.. you can delete this safely.
            $mdDialog.show({
                controller         : function ($scope, $mdDialog, formWizardData)
                {
                    $scope.formWizardData = formWizardData;
                    $scope.closeDialog = function ()
                    {
                        $mdDialog.hide();
                    };
                },
                template           : '<md-dialog>' +
                '  <md-dialog-content><h1>You have sent the form with the following data</h1><div><pre>{{formWizardData | json}}</pre></div></md-dialog-content>' +
                '  <md-dialog-actions>' +
                '    <md-button ng-click="closeDialog()" class="md-primary">' +
                '      Close' +
                '    </md-button>' +
                '  </md-dialog-actions>' +
                '</md-dialog>',
                parent             : angular.element('body'),
                targetEvent        : ev,
                locals             : {
                    formWizardData: vm.formWizard
                },
                clickOutsideToClose: true
            });

            // Clear the form data
            vm.formWizard = {};
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.icons', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.ui_icons', {
            url      : '/ui/icons',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/icons/icons.html',
                    controller : 'IconsController as vm'
                }
            },
            resolve  : {
                Icons: function (msApi)
                {
                    return msApi.resolve('icons@get');
                }
            },
            bodyClass: 'icons'
        });

        // Api
        msApiProvider.register('icons', ['assets/icons/selection.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.icons')
        .controller('IconsController', IconsController);

    /** @ngInject */
    function IconsController(Icons)
    {
        var vm = this;

        // Data
        vm.icons = Icons.icons;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.helper-classes', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.ui_helper-classes', {
            url      : '/ui/helper-classes',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/ui/helper-classes/helper-classes.html',
                    controller : 'HelperClassesController as vm'
                }
            },
            bodyClass: 'helper-classes'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui.helper-classes')
        .controller('HelperClassesController', HelperClassesController);

    /** @ngInject */
    function HelperClassesController()
    {
        // Data

        // Methods

        //////////
    }
})();



(function ()
{
    'use strict';

    angular
        .module('app.pages.search', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_search', {
            url      : '/pages/search',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/search/search.html',
                    controller : 'SearchController as vm'
                }
            },
            resolve  : {
                Classic : function (msApi)
                {
                    return msApi.resolve('search.classic@get');
                },
                Mails   : function (msApi)
                {
                    return msApi.resolve('search.mails@get');
                },
                Users   : function (msApi)
                {
                    return msApi.resolve('search.users@get');
                },
                Contacts: function (msApi)
                {
                    return msApi.resolve('search.contacts@get');
                }
            },
            bodyClass: 'search'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/search');

        // Api
        msApiProvider.register('search.classic', ['app/data/search/classic.json']);
        msApiProvider.register('search.mails', ['app/data/search/mails.json']);
        msApiProvider.register('search.users', ['app/data/search/users.json']);
        msApiProvider.register('search.contacts', ['app/data/search/contacts.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.search', {
            title : 'Search',
            icon  : 'icon-magnify',
            state : 'app.pages_search',
            weight: 7
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.search')
        .controller('SearchController', SearchController);

    /** @ngInject */
    function SearchController(Classic, Mails, Users, Contacts)
    {
        var vm = this;

        // Data
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];

        vm.classic = Classic.data;
        vm.mails = Mails.data;
        vm.users = Users.data;
        vm.contacts = Contacts.data;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.timeline', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pages_timeline', {
                url      : '/pages/timeline',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (msApi)
                    {
                        return msApi.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline'
            })
            .state('app.pages_timeline_left', {
                url      : '/pages/timeline-left',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline-left.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (msApi)
                    {
                        return msApi.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline-left'
            })
            .state('app.pages_timeline_right', {
                url      : '/pages/timeline-right',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/timeline/timeline-right.html',
                        controller : 'TimelineController as vm'
                    }
                },
                resolve  : {
                    Timeline: function (msApi)
                    {
                        return msApi.resolve('timeline.page1@get');
                    }
                },
                bodyClass: 'timeline-right'
            });

        // API
        msApiProvider.register('timeline.page1', ['app/data/timeline/page-1.json']);
        msApiProvider.register('timeline.page2', ['app/data/timeline/page-2.json']);
        msApiProvider.register('timeline.page3', ['app/data/timeline/page-3.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.timeline', {
            title : 'Timeline',
            icon  : 'icon-view-stream',
            weight: 8
        });

        msNavigationServiceProvider.saveItem('pages.timeline.default', {
            title: 'Default',
            state: 'app.pages_timeline'
        });

        msNavigationServiceProvider.saveItem('pages.timeline.left-aligned', {
            title: 'Left Aligned',
            state: 'app.pages_timeline_left'
        });

        msNavigationServiceProvider.saveItem('pages.timeline.right-aligned', {
            title: 'Right Aligned',
            state: 'app.pages_timeline_right'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.timeline')
        .controller('TimelineController', TimelineController);

    /** @ngInject */
    function TimelineController($q, msApi, Timeline)
    {
        var vm = this;

        // Data
        vm.timeline = Timeline.data;
        vm.timelineOptions = {
            scrollEl: '#content'
        };
        vm.currentPage = 1;
        vm.totalPages = 3;
        vm.pauseScroll = false;

        // Methods
        vm.loadNextPage = loadNextPage;

        //////////

        /**
         * Load next page
         * @returns promise
         */
        function loadNextPage()
        {
            // Create a new deferred object
            var deferred = $q.defer();

            // Increase the current page number
            vm.currentPage = vm.currentPage + 1;

            // Check if we still have pages that we can load
            if ( vm.currentPage > vm.totalPages )
            {
                // Reject the promise
                deferred.reject('No more pages');
            }
            else
            {
                // Emulate the api call and load new timeline items in
                var pageName = 'timeline.page' + vm.currentPage + '@get';

                msApi.request(pageName, {},

                    // SUCCESS
                    function (response)
                    {
                        for ( var i = 0; i < response.data.length; i++ )
                        {
                            vm.timeline.push(response.data[i]);
                        }

                        // Resolve the promise
                        deferred.resolve(response);
                    },

                    // ERROR
                    function (response)
                    {
                        // Reject the promise
                        deferred.reject(response);
                    }
                );
            }

            return deferred.promise;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.profile', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        $stateProvider.state('app.pages_profile', {
            url      : '/pages/profile',
            views    : {
                'content@app': {
                    templateUrl: 'app/main/pages/profile/profile.html',
                    controller : 'ProfileController as vm'
                }
            },
            resolve  : {
                Timeline    : function (msApi)
                {
                    return msApi.resolve('profile.timeline@get');
                },
                About       : function (msApi)
                {
                    return msApi.resolve('profile.about@get');
                },
                PhotosVideos: function (msApi)
                {
                    return msApi.resolve('profile.photosVideos@get');
                }
            },
            bodyClass: 'profile'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/profile');

        // Api
        msApiProvider.register('profile.timeline', ['app/data/profile/timeline.json']);
        msApiProvider.register('profile.about', ['app/data/profile/about.json']);
        msApiProvider.register('profile.photosVideos', ['app/data/profile/photos-videos.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.profile', {
            title : 'Profile',
            icon  : 'icon-account',
            state : 'app.pages_profile',
            weight: 6
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.profile')
        .controller('ProfileController', ProfileController);

    /** @ngInject */
    function ProfileController(Timeline, About, PhotosVideos)
    {
        var vm = this;

        // Data
        vm.posts = Timeline.posts;
        vm.activities = Timeline.activities;
        vm.about = About.data;
        vm.photosVideos = PhotosVideos.data;

        // Methods

        //////////
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_maintenance', {
            url      : '/pages/maintenance',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_maintenance': {
                    templateUrl: 'app/main/pages/maintenance/maintenance.html',
                    controller : 'MaintenanceController as vm'
                }
            },
            bodyClass: 'maintenance'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/maintenance');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.maintenance', {
            title : 'Maintenance',
            icon  : 'icon-oil',
            state : 'app.pages_maintenance',
            weight: 5
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.maintenance')
        .controller('MaintenanceController', MaintenanceController);

    /** @ngInject */
    function MaintenanceController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.invoice', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.pages_invoice_modern', {
                url      : '/pages/invoice/modern',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/invoice/views/modern/modern.html',
                        controller : 'InvoiceController as vm'
                    }
                },
                resolve  : {
                    Invoice: function (msApi)
                    {
                        return msApi.resolve('invoice@get');
                    }
                },
                bodyClass: 'invoice printable'
            })
            .state('app.pages_invoice_compact', {
                url      : '/pages/invoice/compact',
                views    : {
                    'content@app': {
                        templateUrl: 'app/main/pages/invoice/views/compact/compact.html',
                        controller : 'InvoiceController as vm'
                    }
                },
                resolve  : {
                    Invoice: function (msApi)
                    {
                        return msApi.resolve('invoice@get');
                    }
                },
                bodyClass: 'invoice printable'
            });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/invoice');

        // Api
        msApiProvider.register('invoice', ['app/data/invoice/invoice.json']);

        // Navigation
        msNavigationServiceProvider.saveItem('pages.invoice', {
            title : 'Invoice',
            icon  : 'icon-receipt',
            weight: 4
        });

        msNavigationServiceProvider.saveItem('pages.invoice.modern', {
            title : 'Modern',
            state : 'app.pages_invoice_modern'
        });

        msNavigationServiceProvider.saveItem('pages.invoice.compact', {
            title : 'Compact',
            state : 'app.pages_invoice_compact'
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.invoice')
        .controller('InvoiceController', InvoiceController);

    /** @ngInject */
    function InvoiceController(Invoice)
    {
        var vm = this;

        // Data
        vm.invoice = Invoice.data;

        // Methods

        //////////
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.pages.coming-soon',
            [
                // 3rd Party Dependencies
                'timer'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider.state('app.pages_coming-soon', {
            url      : '/pages/coming-soon',
            views    : {
                'main@'                        : {
                    templateUrl: 'app/core/layouts/content-only.html',
                    controller : 'MainController as vm'
                },
                'content@app.pages_coming-soon': {
                    templateUrl: 'app/main/pages/coming-soon/coming-soon.html',
                    controller : 'ComingSoonController as vm'
                }
            },
            bodyClass: 'coming-soon'
        });

        // Translation
        $translatePartialLoaderProvider.addPart('app/main/pages/coming-soon');

        // Navigation
        msNavigationServiceProvider.saveItem('pages.coming-soon', {
            title : 'Coming Soon',
            icon  : 'icon-alarm-check',
            state : 'app.pages_coming-soon',
            weight: 2
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.pages.coming-soon')
        .controller('ComingSoonController', ComingSoonController);

    /** @ngInject */
    function ComingSoonController()
    {
        var vm = this;

        // Data
        vm.endTime = 1499995790000;

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.notes')
        .controller('NotesController', NotesController);

    /** @ngInject */
    function NotesController($document, $timeout, $scope, $mdSidenav, NotesService, LabelsService, $mdDialog)
    {
        var vm = this;

        // Data
        vm.notes = NotesService.data;
        vm.labels = LabelsService.data;
        vm.search = '';
        vm.searchToolbar = false;
        vm.filters = {
            archive: false
        };
        vm.labelFilterIds = [];
        vm.noteListType = 'notes';

        // Methods
        vm.filterChange = filterChange;
        vm.openSearchToolbar = openSearchToolbar;
        vm.closeSearchToolbar = closeSearchToolbar;
        vm.editNote = editNote;
        vm.deleteLabel = deleteLabel;
        vm.toggleSidenav = toggleSidenav;
        vm.addNewLabel = LabelsService.addLabel;

        //////////

        /**
         * Change Notes Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.noteListType = type;

            if ( type === 'notes' )
            {
                vm.labelFilterIds = [];
                vm.filters = {
                    archive: false
                };
            }
            else if ( type === 'archive' )
            {
                vm.labelFilterIds = [];
                vm.filters = {
                    archive: true
                };
            }
            else if ( type === 'reminders' )
            {
                vm.labelFilterIds = [];
                vm.filters = {
                    reminder: '',
                    archive : false
                };
            }
            else if ( angular.isObject(type) )
            {
                vm.labelFilterIds = [];
                vm.labelFilterIds.push(type.id);
            }

            $mdSidenav('main-sidenav').close();

        }

        /**
         * Edit Note
         * @param ev
         * @param noteId
         */
        function editNote(ev, noteId)
        {
            $mdDialog.show({
                template           : '<md-dialog ms-scroll><ms-note-form note-type="\'edit\'" note-id="\'' + noteId + '\'"></ms-note-form></md-dialog>',
                parent             : $document.find('#notes'),
                targetEvent        : ev,
                clickOutsideToClose: true,
                escapeToClose      : true
            });
        }

        /**
         * Delete Label
         * @param ev
         * @param label
         */
        function deleteLabel(ev, label)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the label?')
                .htmlContent('The "' + label.name + '" label will be deleted permanently.')
                .ariaLabel('delete label')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {
                LabelsService.deleteLabel(label);
            });
        }

        /**
         * Open Search Toolbar
         */
        function openSearchToolbar()
        {
            vm.searchToolbar = true;

            $timeout(function ()
            {
                angular.element($document.find('#search-notes-input')).trigger('focus');

            });

            $document.on('keyup', escKeyEvent);
        }

        /**
         * Close Search Toolbar
         */
        function closeSearchToolbar()
        {
            $scope.$evalAsync(function ()
            {
                vm.searchToolbar = false;
                vm.search = '';
            });

            $document.off('keyup', escKeyEvent);
        }

        /**
         * Escape key event
         */
        function escKeyEvent(e)
        {
            if ( e.keyCode === 27 )
            {
                closeSearchToolbar();
            }
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.mail')
        .controller('MailController', MailController);

    /** @ngInject */
    function MailController($scope, $rootScope, $document, $mdDialog, $mdMedia, $mdSidenav, $state, msApi, Folders, Labels)
    {
        var vm = this;

        // Data
        vm.accounts = {
            'creapond'    : 'johndoe@creapond.com',
            'withinpixels': 'johndoe@withinpixels.com'
        };
        vm.colors = ['blue-bg', 'blue-grey-bg', 'orange-bg', 'pink-bg', 'purple-bg'];
        vm.selectedAccount = 'creapond';

        vm.folders = Folders.data;
        vm.labels = Labels.data;
        vm.loadingThreads = true;

        vm.currentFilter = {
            type  : $state.params.type,
            filter: $state.params.filter
        };
        vm.currentThread = null;
        vm.selectedThreads = [];

        vm.views = {
            classic: 'app/main/apps/mail/views/classic/classic-view.html',
            outlook: 'app/main/apps/mail/views/outlook/outlook-view.html'
        };
        vm.defaultView = 'outlook';
        vm.currentView = 'outlook';

        // Methods
        vm.loadFolder = loadFolder;
        vm.loadLabel = loadLabel;
        vm.isFolderActive = isFolderActive;
        vm.isLabelActive = isLabelActive;

        vm.openThread = openThread;
        vm.closeThread = closeThread;

        vm.isSelected = isSelected;
        vm.toggleSelectThread = toggleSelectThread;
        vm.selectThreads = selectThreads;
        vm.deselectThreads = deselectThreads;
        vm.toggleSelectThreads = toggleSelectThreads;

        vm.setThreadStatus = setThreadStatus;
        vm.toggleThreadStatus = toggleThreadStatus;

        vm.getLabel = getLabel;
        vm.getLabelColor = getLabelColor;
        vm.getLabelTitle = getLabelTitle;
        vm.toggleLabel = toggleLabel;
        vm.isLabelExist = isLabelExist;

        vm.changeView = changeView;

        vm.composeDialog = composeDialog;
        vm.replyDialog = replyDialog;

        vm.toggleSidenav = toggleSidenav;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Figure out the api name
            var apiName = 'mail.' + ($state.params.type || 'folder') + '.' + $state.params.filter + '@get';

            // Request the mails
            msApi.request(apiName).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.threads = response.data;

                    // Hide the loading screen
                    vm.loadingThreads = false;

                    // Open the thread if needed
                    if ( $state.params.threadId )
                    {
                        for ( var i = 0; i < vm.threads.length; i++ )
                        {
                            if ( vm.threads[i].id === $state.params.threadId )
                            {
                                vm.openThread(vm.threads[i]);
                                break;
                            }
                        }
                    }
                }
            );
        }

        // Watch screen size to change view modes
        $scope.$watch(function ()
        {
            return $mdMedia('xs');
        }, function (current, old)
        {
            if ( angular.equals(current, old) )
            {
                return;
            }

            if ( current )
            {
                vm.currentView = 'classic';
            }
        });

        $scope.$watch(function ()
        {
            return $mdMedia('gt-xs');
        }, function (current, old)
        {
            if ( angular.equals(current, old) )
            {
                return;
            }

            if ( current )
            {
                if ( vm.defaultView === 'outlook' )
                {
                    vm.currentView = 'outlook';
                }
            }
        });

        /**
         * Load folder
         *
         * @param name
         */
        function loadFolder(name)
        {
            // If we are already in the selected folder and
            // there is an open thread just close it
            if ( vm.isFolderActive(name) )
            {
                // Close the current thread if open
                if ( vm.currentThread )
                {
                    vm.closeThread();
                }

                return;
            }

            // Show loader
            $rootScope.loadingProgress = true;

            // Update the state without reloading the controller
            $state.go('app.mail.threads', {
                type  : null,
                filter: name
            }, {notify: false});

            // Build the API name
            var apiName = 'mail.folder.' + name + '@get';

            // Make the call
            msApi.request(apiName).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.threads = response.data;

                    // Set the current filter
                    vm.currentFilter = {
                        type  : null,
                        filter: name
                    };

                    // Close the current thread if open
                    if ( vm.currentThread )
                    {
                        vm.closeThread();
                    }

                    // Hide loader
                    $rootScope.loadingProgress = false;
                }
            );
        }

        /**
         * Load label
         *
         * @param name
         */
        function loadLabel(name)
        {
            // Update the state without reloading the controller
            $state.go('app.mail.threads', {
                type  : 'label',
                filter: name
            }, {notify: false});

            // If we are already in the selected folder and
            // there is an open thread just close it
            if ( vm.isLabelActive(name) )
            {
                // Close the current thread if open
                if ( vm.currentThread )
                {
                    vm.closeThread();
                }

                return;
            }

            // Show loader
            $rootScope.loadingProgress = true;

            // Build the API name
            var apiName = 'mail.label.' + name + '@get';

            // Make the call
            msApi.request(apiName).then(
                // Success
                function (response)
                {
                    // Load new threads
                    vm.threads = response.data;

                    // Set the current filter
                    vm.currentFilter = {
                        type  : 'label',
                        filter: name
                    };

                    // Close the current thread if open
                    if ( vm.currentThread )
                    {
                        vm.closeThread();
                    }

                    // Hide loader
                    $rootScope.loadingProgress = false;
                }
            );
        }

        /**
         * Is the folder with the given name active?
         *
         * @param name
         * @returns {boolean}
         */
        function isFolderActive(name)
        {
            return (vm.currentFilter.type === null && vm.currentFilter.filter === name);
        }

        /**
         * Is the label with the given name active?
         *
         * @param name
         * @returns {boolean}
         */
        function isLabelActive(name)
        {
            return (vm.currentFilter.type === 'label' && vm.currentFilter.filter === name);
        }

        /**
         * Open thread
         *
         * @param thread
         */
        function openThread(thread)
        {
            // Set the read status on the thread
            thread.read = true;

            // Assign thread as the current thread
            vm.currentThread = thread;

            // Update the state without reloading the controller
            $state.go('app.mail.threads.thread', {threadId: thread.id}, {notify: false});
        }

        /**
         * Close thread
         */
        function closeThread()
        {
            vm.currentThread = null;

            // Update the state without reloading the controller
            $state.go('app.mail.threads', {
                type  : vm.currentFilter.type,
                filter: vm.currentFilter.filter
            }, {notify: false});
        }

        /**
         * Return selected status of the thread
         *
         * @param thread
         * @returns {boolean}
         */
        function isSelected(thread)
        {
            return vm.selectedThreads.indexOf(thread) > -1;
        }

        /**
         * Toggle selected status of the thread
         *
         * @param thread
         * @param event
         */
        function toggleSelectThread(thread, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            if ( vm.selectedThreads.indexOf(thread) > -1 )
            {
                vm.selectedThreads.splice(vm.selectedThreads.indexOf(thread), 1);
            }
            else
            {
                vm.selectedThreads.push(thread);
            }
        }

        /**
         * Select threads. If key/value pair given,
         * threads will be tested against them.
         *
         * @param [key]
         * @param [value]
         */
        function selectThreads(key, value)
        {
            // Make sure the current selection is cleared
            // before trying to select new threads
            vm.selectedThreads = [];

            for ( var i = 0; i < vm.threads.length; i++ )
            {
                if ( angular.isUndefined(key) && angular.isUndefined(value) )
                {
                    vm.selectedThreads.push(vm.threads[i]);
                    continue;
                }

                if ( angular.isDefined(key) && angular.isDefined(value) && vm.threads[i][key] === value )
                {
                    vm.selectedThreads.push(vm.threads[i]);
                }
            }
        }

        /**
         * Deselect threads
         */
        function deselectThreads()
        {
            vm.selectedThreads = [];
        }

        /**
         * Toggle select threads
         */
        function toggleSelectThreads()
        {
            if ( vm.selectedThreads.length > 0 )
            {
                vm.deselectThreads();
            }
            else
            {
                vm.selectThreads();
            }
        }

        /**
         * Set the status on given thread, current thread or selected threads
         *
         * @param key
         * @param value
         * @param [thread]
         * @param [event]
         */
        function setThreadStatus(key, value, thread, event)
        {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if ( event )
            {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if ( thread )
            {
                thread[key] = value;
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if ( vm.currentThread )
            {
                vm.currentThread[key] = value;
                return;
            }

            // Otherwise do the status update on selected threads
            for ( var x = 0; x < vm.selectedThreads.length; x++ )
            {
                vm.selectedThreads[x][key] = value;
            }
        }

        /**
         * Toggle the value of the given key on given thread, current
         * thread or selected threads. Given key value must be boolean.
         *
         * @param key
         * @param thread
         * @param event
         */
        function toggleThreadStatus(key, thread, event)
        {
            // Stop the propagation if event provided
            // This will stop unwanted actions on button clicks
            if ( event )
            {
                event.stopPropagation();
            }

            // If the thread provided, do the changes on that
            // particular thread
            if ( thread )
            {
                if ( typeof(thread[key]) !== 'boolean' )
                {
                    return;
                }

                thread[key] = !thread[key];
                return;
            }

            // If the current thread is available, do the
            // changes on that one
            if ( vm.currentThread )
            {
                if ( typeof(vm.currentThread[key]) !== 'boolean' )
                {
                    return;
                }

                vm.currentThread[key] = !vm.currentThread[key];
                return;
            }

            // Otherwise do the status update on selected threads
            for ( var x = 0; x < vm.selectedThreads.length; x++ )
            {
                if ( typeof(vm.selectedThreads[x][key]) !== 'boolean' )
                {
                    continue;
                }

                vm.selectedThreads[x][key] = !vm.selectedThreads[x][key];
            }
        }

        /**
         * Get label object content
         *
         * @param id
         * @returns {*}
         */
        function getLabel(id)
        {
            for ( var i = 0; i < vm.labels.length; i++ )
            {
                if ( vm.labels[i].id === id )
                {
                    return vm.labels[i];
                }
            }
        }

        /**
         * Get label color from label object
         *
         * @param id
         * @returns {*}
         */
        function getLabelColor(id)
        {
            return vm.getLabel(id).color;
        }

        /**
         * Get label title from label object
         *
         * @param id
         * @returns {*}
         */
        function getLabelTitle(id)
        {
            return vm.getLabel(id).title;
        }

        /**
         * Toggle label
         *
         * @param label
         */
        function toggleLabel(label)
        {
            // Toggle label on the currently open thread
            if ( vm.currentThread )
            {
                if ( vm.currentThread.labels.indexOf(label.id) > -1 )
                {
                    vm.currentThread.labels.splice(vm.currentThread.labels.indexOf(label.id), 1);
                }
                else
                {
                    vm.currentThread.labels.push(label.id);
                }

                return;
            }

            // Toggle labels on selected threads
            // Toggle action will be determined by the first thread from the selection.
            if ( vm.selectedThreads.length > 0 )
            {
                // Decide if we are going to remove or add labels
                var removeLabels = (vm.selectedThreads[0].labels.indexOf(label.id) > -1);

                for ( var i = 0; i < vm.selectedThreads.length; i++ )
                {
                    if ( !removeLabels )
                    {
                        vm.selectedThreads[i].labels.push(label.id);
                        continue;
                    }

                    if ( vm.selectedThreads[i].labels.indexOf(label.id) > -1 )
                    {
                        vm.selectedThreads[i].labels.splice(vm.selectedThreads[i].labels.indexOf(label.id), 1);
                    }
                }
            }
        }

        /**
         * Is label exist?
         *
         * @param label
         * @returns {boolean}
         */
        function isLabelExist(label)
        {
            if ( vm.currentThread && vm.currentThread.labels )
            {
                return (vm.currentThread.labels.indexOf(label.id) > -1);
            }
        }

        /**
         * Change the view
         *
         * @param view
         */
        function changeView(view)
        {
            if ( vm.views[view] )
            {
                vm.defaultView = view;
                vm.currentView = view;
            }
        }

        /**
         * Open compose dialog
         *
         * @param ev
         */

        function composeDialog(ev)
        {
            $mdDialog.show({
                controller         : 'ComposeDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedMail: undefined
                },
                templateUrl        : 'app/main/apps/mail/dialogs/compose/compose-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

        /**
         * Open reply dialog
         *
         * @param ev
         */
        function replyDialog(ev)
        {
            $mdDialog.show({
                controller         : 'ComposeDialogController',
                controllerAs       : 'vm',
                locals             : {
                    selectedMail: vm.selectedMail
                },
                templateUrl        : 'app/main/apps/mail/dialogs/compose/compose-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : ev,
                clickOutsideToClose: true
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.chat')
        .controller('ChatController', ChatController);

    /** @ngInject */
    function ChatController(Contacts, ChatsService, $mdSidenav, User, $timeout, $document, $mdMedia)
    {

        var vm = this;

        // Data
        vm.contacts = ChatsService.contacts = Contacts.data;
        vm.chats = ChatsService.chats;
        vm.user = User.data;
        vm.leftSidenavView = false;
        vm.chat = undefined;

        // Methods
        vm.getChat = getChat;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleLeftSidenavView = toggleLeftSidenavView;
        vm.reply = reply;
        vm.setUserStatus = setUserStatus;
        vm.clearMessages = clearMessages;

        //////////

        /**
         * Get Chat by Contact id
         * @param contactId
         */
        function getChat(contactId)
        {
            ChatsService.getContactChat(contactId).then(function (response)
            {
                vm.chatContactId = contactId;
                vm.chat = response;

                // Reset the reply textarea
                resetReplyTextarea();

                // Scroll to the last message
                scrollToBottomOfChat();

                if ( !$mdMedia('gt-md') )
                {
                    $mdSidenav('left-sidenav').close();
                }

                // Reset Left Sidenav View
                vm.toggleLeftSidenavView(false);

            });
        }

        /**
         * Reply
         */
        function reply($event)
        {
            // If "shift + enter" pressed, grow the reply textarea
            if ( $event && $event.keyCode === 13 && $event.shiftKey )
            {
                vm.textareaGrow = true;
                return;
            }

            // Prevent the reply() for key presses rather than the"enter" key.
            if ( $event && $event.keyCode !== 13 )
            {
                return;
            }

            // Check for empty messages
            if ( vm.replyMessage === '' )
            {
                resetReplyTextarea();
                return;
            }

            // Message
            var message = {
                who    : 'user',
                message: vm.replyMessage,
                time   : new Date().toISOString()
            };

            // Add the message to the chat
            vm.chat.push(message);

            // Update Contact's lastMessage
            vm.contacts.getById(vm.chatContactId).lastMessage = message;

            // Reset the reply textarea
            resetReplyTextarea();

            // Scroll to the new message
            scrollToBottomOfChat();

        }

        /**
         * Clear Chat Messages
         */
        function clearMessages()
        {
            vm.chats[vm.chatContactId] = vm.chat = [];
            vm.contacts.getById(vm.chatContactId).lastMessage = null;
        }

        /**
         * Reset reply textarea
         */
        function resetReplyTextarea()
        {
            vm.replyMessage = '';
            vm.textareaGrow = false;
        }

        /**
         * Scroll Chat Content to the bottom
         * @param speed
         */
        function scrollToBottomOfChat()
        {
            $timeout(function ()
            {
                var chatContent = angular.element($document.find('#chat-content'));

                chatContent.animate({
                    scrollTop: chatContent[0].scrollHeight
                }, 400);
            }, 0);

        }

        /**
         * Set User Status
         */
        function setUserStatus(status)
        {
            vm.user.status = status;
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Toggle Left Sidenav View
         *
         * @param view id
         */
        function toggleLeftSidenavView(id)
        {
            vm.leftSidenavView = id;
        }

        /**
         * Array prototype
         *
         * Get by id
         *
         * @param value
         * @returns {T}
         */
        Array.prototype.getById = function (value)
        {
            return this.filter(function (x)
            {
                return x.id === value;
            })[0];
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.contacts')
        .controller('ContactsController', ContactsController);

    /** @ngInject */
    function ContactsController($scope, $mdSidenav, Contacts, User, msUtils, $mdDialog, $document)
    {

        var vm = this;

        // Data
        vm.contacts = Contacts.data;
        vm.user = User.data;
        vm.filterIds = null;
        vm.listType = 'all';
        vm.listOrder = 'name';
        vm.listOrderAsc = false;
        vm.selectedContacts = [];
        vm.newGroupName = '';

        // Methods
        vm.filterChange = filterChange;
        vm.openContactDialog = openContactDialog;
        vm.deleteContactConfirm = deleteContactConfirm;
        vm.deleteContact = deleteContact;
        vm.deleteSelectedContacts = deleteSelectedContacts;
        vm.toggleSelectContact = toggleSelectContact;
        vm.deselectContacts = deselectContacts;
        vm.selectAllContacts = selectAllContacts;
        vm.deleteContact = deleteContact;
        vm.addNewGroup = addNewGroup;
        vm.deleteGroup = deleteGroup;
        vm.toggleSidenav = toggleSidenav;
        vm.toggleInArray = msUtils.toggleInArray;
        vm.exists = msUtils.exists;

        //////////

        /**
         * Change Contacts List Filter
         * @param type
         */
        function filterChange(type)
        {

            vm.listType = type;

            if ( type === 'all' )
            {
                vm.filterIds = null;
            }
            else if ( type === 'frequent' )
            {
                vm.filterIds = vm.user.frequentContacts;
            }
            else if ( type === 'starred' )
            {
                vm.filterIds = vm.user.starred;
            }
            else if ( angular.isObject(type) )
            {
                vm.filterIds = type.contactIds;
            }

            vm.selectedContacts = [];

        }

        /**
         * Open new contact dialog
         *
         * @param ev
         * @param contact
         */
        function openContactDialog(ev, contact)
        {
            $mdDialog.show({
                controller         : 'ContactDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/contacts/dialogs/contact/contact-dialog.html',
                parent             : angular.element($document.find('#content-container')),
                targetEvent        : ev,
                clickOutsideToClose: true,
                locals             : {
                    Contact : contact,
                    User    : vm.user,
                    Contacts: vm.contacts
                }
            });
        }

        /**
         * Delete Contact Confirm Dialog
         */
        function deleteContactConfirm(contact, ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the contact?')
                .htmlContent('<b>' + contact.name + ' ' + contact.lastName + '</b>' + ' will be deleted.')
                .ariaLabel('delete contact')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                deleteContact(contact);
                vm.selectedContacts = [];

            }, function ()
            {

            });
        }

        /**
         * Delete Contact
         */
        function deleteContact(contact)
        {
            vm.contacts.splice(vm.contacts.indexOf(contact), 1);
        }

        /**
         * Delete Selected Contacts
         */
        function deleteSelectedContacts(ev)
        {
            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the selected contacts?')
                .htmlContent('<b>' + vm.selectedContacts.length + ' selected</b>' + ' will be deleted.')
                .ariaLabel('delete contacts')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.selectedContacts.forEach(function (contact)
                {
                    deleteContact(contact);
                });

                vm.selectedContacts = [];

            });

        }

        /**
         * Toggle selected status of the contact
         *
         * @param contact
         * @param event
         */
        function toggleSelectContact(contact, event)
        {
            if ( event )
            {
                event.stopPropagation();
            }

            if ( vm.selectedContacts.indexOf(contact) > -1 )
            {
                vm.selectedContacts.splice(vm.selectedContacts.indexOf(contact), 1);
            }
            else
            {
                vm.selectedContacts.push(contact);
            }
        }

        /**
         * Deselect contacts
         */
        function deselectContacts()
        {
            vm.selectedContacts = [];
        }

        /**
         * Sselect all contacts
         */
        function selectAllContacts()
        {
            vm.selectedContacts = $scope.filteredContacts;
        }

        /**
         *
         */
        function addNewGroup()
        {
            if ( vm.newGroupName === '' )
            {
                return;
            }

            var newGroup = {
                'id'        : msUtils.guidGenerator(),
                'name'      : vm.newGroupName,
                'contactIds': []
            };

            vm.user.groups.push(newGroup);
            vm.newGroupName = '';
        }

        /**
         * Delete Group
         */
        function deleteGroup(ev)
        {
            var group = vm.listType;

            var confirm = $mdDialog.confirm()
                .title('Are you sure want to delete the group?')
                .htmlContent('<b>' + group.name + '</b>' + ' will be deleted.')
                .ariaLabel('delete group')
                .targetEvent(ev)
                .ok('OK')
                .cancel('CANCEL');

            $mdDialog.show(confirm).then(function ()
            {

                vm.user.groups.splice(vm.user.groups.indexOf(group), 1);

                filterChange('all');
            });

        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.calendar')
        .controller('CalendarController', CalendarController);

    /** @ngInject */
    function CalendarController($mdDialog, $document)
    {
        var vm = this;

        // Data
        var date = new Date();
        var d = date.getDate();
        var m = date.getMonth();
        var y = date.getFullYear();

        vm.events = [
            [
                {
                    id   : 1,
                    title: 'All Day Event',
                    start: new Date(y, m, 1),
                    end  : null
                },
                {
                    id   : 2,
                    title: 'Long Event',
                    start: new Date(y, m, d - 5),
                    end  : new Date(y, m, d - 2)
                },
                {
                    id   : 3,
                    title: 'Some Event',
                    start: new Date(y, m, d - 3, 16, 0),
                    end  : null
                },
                {
                    id   : 4,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 4, 16, 0),
                    end  : null
                },
                {
                    id   : 5,
                    title: 'Birthday Party',
                    start: new Date(y, m, d + 1, 19, 0),
                    end  : new Date(y, m, d + 1, 22, 30)
                },
                {
                    id   : 6,
                    title: 'All Day Event',
                    start: new Date(y, m, d + 8, 16, 0),
                    end  : null
                },
                {
                    id   : 7,
                    title: 'Long Event',
                    start: new Date(y, m, d + 12, 16, 0),
                    end  : null
                },
                {
                    id   : 8,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 2, 0),
                    end  : null
                },
                {
                    id   : 9,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 4, 0),
                    end  : null
                },
                {
                    id   : 10,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 2, 0),
                    end  : null
                },
                {
                    id   : 11,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 4, 0),
                    end  : null
                },
                {
                    id   : 12,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 2, 0),
                    end  : null
                },
                {
                    id   : 13,
                    title: 'Repeating Event',
                    start: new Date(y, m, d + 14, 4, 0),
                    end  : null
                },
                {
                    id   : 14,
                    title: 'Conference',
                    start: new Date(y, m, d + 17, 4, 0),
                    end  : null
                },
                {
                    id   : 15,
                    title: 'Meeting',
                    start: new Date(y, m, d + 22, 4, 0),
                    end  : new Date(y, m, d + 24, 4, 0)
                }
            ]
        ];

        vm.calendarUiConfig = {
            calendar: {
                editable          : true,
                eventLimit        : true,
                header            : '',
                handleWindowResize: false,
                aspectRatio       : 1,
                dayNames          : ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                dayNamesShort     : ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                viewRender        : function (view)
                {
                    vm.calendarView = view;
                    vm.calendar = vm.calendarView.calendar;
                    vm.currentMonthShort = vm.calendar.getDate().format('MMM');
                },
                columnFormat      : {
                    month: 'ddd',
                    week : 'ddd D',
                    day  : 'ddd M'
                },
                eventClick        : eventDetail,
                selectable        : true,
                selectHelper      : true,
                select            : select
            }
        };

        // Methods
        vm.addEvent = addEvent;
        vm.next = next;
        vm.prev = prev;

        //////////

        /**
         * Go to next on current view (week, month etc.)
         */
        function next()
        {
            vm.calendarView.calendar.next();
        }

        /**
         * Go to previous on current view (week, month etc.)
         */
        function prev()
        {
            vm.calendarView.calendar.prev();
        }

        /**
         * Show event detail
         *
         * @param calendarEvent
         * @param e
         */
        function eventDetail(calendarEvent, e)
        {
            showEventDetailDialog(calendarEvent, e);
        }

        /**
         * Add new event in between selected dates
         *
         * @param start
         * @param end
         * @param e
         */
        function select(start, end, e)
        {
            showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Add event
         *
         * @param e
         */
        function addEvent(e)
        {
            var start = new Date(),
                end = new Date();

            showEventFormDialog('add', false, start, end, e);
        }

        /**
         * Show event detail dialog
         * @param calendarEvent
         * @param e
         */
        function showEventDetailDialog(calendarEvent, e)
        {
            $mdDialog.show({
                controller         : 'EventDetailDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/calendar/dialogs/event-detail/event-detail-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    calendarEvent      : calendarEvent,
                    showEventFormDialog: showEventFormDialog,
                    event              : e
                }
            });
        }

        /**
         * Show event add/edit form dialog
         *
         * @param type
         * @param calendarEvent
         * @param start
         * @param end
         * @param e
         */
        function showEventFormDialog(type, calendarEvent, start, end, e)
        {
            var dialogData = {
                type         : type,
                calendarEvent: calendarEvent,
                start        : start,
                end          : end
            };

            $mdDialog.show({
                controller         : 'EventFormDialogController',
                controllerAs       : 'vm',
                templateUrl        : 'app/main/apps/calendar/dialogs/event-form/event-form-dialog.html',
                parent             : angular.element($document.body),
                targetEvent        : e,
                clickOutsideToClose: true,
                locals             : {
                    dialogData: dialogData
                }
            }).then(function (response)
            {
                switch ( response.type )
                {
                    case 'add':
                        // Add new
                        vm.events[0].push({
                            id   : vm.events[0].length + 20,
                            title: response.calendarEvent.title,
                            start: response.calendarEvent.start,
                            end  : response.calendarEvent.end
                        });
                        break;

                    case 'edit':
                        // Edit
                        for ( var i = 0; i < vm.events[0].length; i++ )
                        {
                            // Update
                            if ( vm.events[0][i].id === response.calendarEvent.id )
                            {
                                vm.events[0][i] = {
                                    title: response.calendarEvent.title,
                                    start: response.calendarEvent.start,
                                    end  : response.calendarEvent.end
                                };

                                break;
                            }
                        }
                        break;

                    case 'remove':
                        // Remove
                        for ( var j = 0; j < vm.events[0].length; j++ )
                        {
                            // Update
                            if ( vm.events[0][j].id === response.calendarEvent.id )
                            {
                                vm.events[0].splice(j, 1);

                                break;
                            }
                        }
                        break;
                }
            });
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.widgets',
            [
                // 3rd Party Dependencies
                'gridshore.c3js.chart'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_widgets', {
            url  : '/components/widgets',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/widgets/widgets.html',
                    controller : 'WidgetsController as vm'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.widgets')
        .controller('WidgetsController', WidgetsController);

    /** @ngInject */
    function WidgetsController()
    {
        var vm = this;

        // Data
        vm.widget1 = {
            title        : 'WEEKLY TRANSACTIONS',
            value        : 30342,
            lastWeekValue: 30002,
            lastWeekDiff : '+ 1,12%',
            detail       : 'This is the back side. You can show detailed information here.'
        };

        vm.widget2 = {
            title        : 'SALES QUOTA',
            value        : 40,
            lastWeekValue: 85,
            lastWeekDiff : '- 45%',
            detail       : 'This is the back side. You can show detailed information here.'
        };

        vm.widget3 = {
            title : 'BOUNCE RATE',
            value : 80,
            detail: 'This is the back side. You can show detailed information here.'
        };

        vm.widget4 = {
            title        : 'STOCK COUNT',
            value        : 5583,
            lastWeekValue: 5583,
            lastWeekDiff : '- 0%',
            detail       : 'This is the back side. You can show detailed information here.'
        };

        vm.widget5 = {
            title: 'USERS ONLINE',
            value: 658
        };

        vm.widget6 = {
            title: 'WASTELANDERS',
            value: 358
        };

        vm.widget7 = {
            title: 'VAULTS SEALED',
            value: 24
        };

        vm.widget8 = {
            title: 'VAULTS OPEN',
            value: 62
        };

        vm.widget9 = {
            title: 'SONGS',
            value: 210
        };

        vm.widget10 = {
            title: 'VIDEOS',
            value: 54
        };

        vm.widget11 = {
            title: 'DOCUMENTS',
            value: 1252
        };

        vm.widget12 = {
            date       : 'June 27, Saturday',
            temperature: 28,
            event      : 'Sunny',
            icon       : 'icon-weather-cloudy',
            location   : 'New York, NY',
            detail     : [
                {
                    day        : 'Sun',
                    icon       : 'icon-weather-rainy',
                    temperature: 24,
                    event      : 'Rainy'
                },
                {
                    day        : 'Mon',
                    icon       : 'icon-weather-pouring',
                    temperature: 23,
                    event      : 'Rainy'
                },
                {
                    day        : 'Tue',
                    icon       : 'icon-weather-cloudy',
                    temperature: 29,
                    event      : 'Overcast'
                },
                {
                    day        : 'Wed',
                    icon       : 'icon-weather-partlycloudy',
                    temperature: 28,
                    event      : 'Sunny'
                },
                {
                    day        : 'Thu',
                    icon       : 'icon-weather-partlycloudy',
                    temperature: 31,
                    event      : 'Sunny'
                }
            ]
        };

        vm.widget13 = {
            date       : 'June 28, Saturday',
            temperature: 16,
            event      : 'Rainy',
            icon       : 'icon-weather-rainy',
            location   : 'Moscow',
            detail     : [
                {
                    day        : 'Sun',
                    icon       : 'icon-weather-rainy',
                    temperature: 24,
                    event      : 'Rainy'
                },
                {
                    day        : 'Mon',
                    icon       : 'icon-weather-pouring',
                    temperature: 23,
                    event      : 'Rainy'
                },
                {
                    day        : 'Tue',
                    icon       : 'icon-weather-cloudy',
                    temperature: 29,
                    event      : 'Overcast'
                },
                {
                    day        : 'Wed',
                    icon       : 'icon-weather-partlycloudy',
                    temperature: 28,
                    event      : 'Sunny'
                },
                {
                    day        : 'Thu',
                    icon       : 'icon-weather-partlycloudy',
                    temperature: 31,
                    event      : 'Sunny'
                }
            ]
        };

        vm.widget14 = {
            title: 'Visitor Demographics',
            tabs : [
                {
                    label : '30 days',
                    groups: [
                        {
                            title: 'Genders',
                            data : [
                                {
                                    title: 'Male',
                                    value: 40
                                },
                                {
                                    title: 'Female',
                                    value: 41
                                }
                            ]
                        },
                        {
                            title: 'Age',
                            data : [
                                {
                                    title: '25 - 34',
                                    value: 32
                                },
                                {
                                    title: '35 - 44',
                                    value: 85
                                }
                            ]
                        }
                    ]
                },
                {
                    label : '10 days',
                    groups: [
                        {
                            title: 'Genders',
                            data : [
                                {
                                    title: 'Male',
                                    value: 32
                                },
                                {
                                    title: 'Female',
                                    value: 49
                                }
                            ]
                        },
                        {
                            title: 'Age',
                            data : [
                                {
                                    title: '25 - 34',
                                    value: 85
                                },
                                {
                                    title: '35 - 44',
                                    value: 60
                                }
                            ]
                        }
                    ]
                },
                {
                    label : '1 day',
                    groups: [
                        {
                            title: 'Genders',
                            data : [
                                {
                                    title: 'Male',
                                    value: 28
                                },
                                {
                                    title: 'Female',
                                    value: 60
                                }
                            ]
                        },
                        {
                            title: 'Age',
                            data : [
                                {
                                    title: '25 - 34',
                                    value: 17
                                },
                                {
                                    title: '35 - 44',
                                    value: 64
                                }
                            ]
                        }
                    ]
                }
            ]
        };

        vm.widget15 = {
            title: 'CPU USAGE',
            value: 200,
            chart: {
                columns: [
                    {
                        id    : 'CPU',
                        name  : 'CPU',
                        color : 'white',
                        values: '30,200,100,400,150,250',
                        type  : 'spline'
                    }
                ]
            }
        };

        vm.widget16 = {
            title        : 'STOCK COUNT',
            value        : 5583,
            lastWeekValue: 5583,
            lastWeekDiff : '- 0%',
            chart        : {
                columns: [
                    {
                        id    : 'STOCK',
                        name  : 'STOCK',
                        color : 'purple',
                        values: '30,200,100,400,150,250',
                        type  : 'area'
                    }
                ]
            }
        };

        vm.widget17 = {
            title   : 'IO RATE',
            subtitle: 'Showing last 5 hours',
            chart   : {
                columns: [
                    {
                        id    : 'Input',
                        name  : 'Input',
                        color : 'green',
                        values: '30,75,290,400,150,250',
                        type  : 'spline'
                    },
                    {
                        id    : 'Output',
                        name  : 'Output',
                        color : 'blue',
                        values: '500,300,120,600,50,80',
                        type  : 'spline'
                    }
                ]
            }
        };

        vm.widget18 = {
            title        : 'WEEKLY VISITORS',
            value        : 30342,
            lastWeekValue: 30002,
            lastWeekDiff : '1.12%',
            chart        : {
                columns: [
                    {
                        id    : 'Visitors',
                        name  : 'Visitors',
                        color : 'steelblue',
                        values: '30,75,290,400,150,250,75,210,125,92,30,75,290,400',
                        type  : 'bar'
                    }
                ]
            }
        };

        vm.widget19 = {
            title   : 'Google Inc.',
            subtitle: 'NASDAQ: GOOG',
            value   : '531.69',
            diff    : '2.29%',
            chart   : {
                columns: [
                    {
                        id    : 'GOOG',
                        name  : 'GOOG',
                        color : 'white',
                        values: '30,75,290,400,150,250,75,210,125,92,30,75,290,400',
                        type  : 'bar'
                    }
                ]
            }
        };

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.price-tables', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider.state('app.components_price-tables', {
            url  : '/components/price-tables',
            views: {
                'content@app': {
                    templateUrl: 'app/main/components/price-tables/price-tables.html'
                }
            }
        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.price-tables')
        .controller('PriceTablesController', PriceTablesController);

    /** @ngInject */
    function PriceTablesController()
    {
        // Data

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.material-docs')
        .constant('ANGULAR_MATERIAL_VERSION', '1.1.1')
        .controller('DocTemplateController', DocTemplateController);

    /** @ngInject */
    function DocTemplateController(DEMOS, COMPONENTS, $state, $http, $templateCache, ANGULAR_MATERIAL_VERSION)
    {
        var vm = this;
        var component = $state.current.data;
        vm.materialVersion = ANGULAR_MATERIAL_VERSION;

        vm.componentName = component.name;

        vm.component = getComponent(component.moduleName);

        if ( !component.excludeDemo )
        {
            vm.demo = getDemo(component.moduleName);
        }

        if ( vm.component )
        {
            vm.docs = vm.component.docs;
        }

        if ( vm.demo )
        {
            vm.demos = [];

            angular.forEach(vm.demo.demos, function (demo)
            {
                // Get displayed contents (un-minified)
                var files = [demo.index]
                    .concat(demo.js || [])
                    .concat(demo.css || [])
                    .concat(demo.html || []);
                files.forEach(function (file)
                {
                    file.httpPromise = $http.get('app/main/components/material-docs/' + file.outputPath, {cache: $templateCache})
                        .then(function (response)
                        {
                            file.contents = response.data
                                .replace('<head/>', '');
                            return file.contents;
                        });
                });
                demo.$files = files;
                vm.demos.push(demo);
            });

            vm.demos = vm.demos.sort(function (a, b)
            {
                return a.name > b.name ? 1 : -1;
            });
        }

        // Data

        // Methods

        //////////

        function getDemo(value)
        {
            return DEMOS.filter(function (x)
            {
                return x.moduleName === value;
            })[0];
        }

        function getComponent(value)
        {
            return COMPONENTS.filter(function (x)
            {
                return x.name === value;
            })[0];
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.components.material-docs')
        .controller('BasicDocTemplateController', BasicDocTemplateController);

    /** @ngInject */
    function BasicDocTemplateController($state, ANGULAR_MATERIAL_VERSION) {
        var vm = this;
        vm.materialVersion = ANGULAR_MATERIAL_VERSION;

        vm.component = $state.current.data.component;
        vm.parentTitle = $state.current.data.parentTitle;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.maps',
            [
                // 3rd Party Dependencies
                'uiGmapgoogle-maps'
            ]
        )
        .config(config);

    /** @ngInject */
    function config($stateProvider)
    {
        $stateProvider
            .state('app.components_maps', {
                url  : '/components/maps',
                views: {
                    'content@app'                   : {
                        templateUrl: 'app/main/components/maps/maps.html',
                        controller : 'MapsController as vm'
                    },
                    'tabContent@app.components_maps': {
                        templateUrl: 'app/main/components/maps/tabs/simple.html'
                    }
                }
            })

            .state('app.components_maps.satellite', {
                url  : '/satellite',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/satellite.html'
                    }
                }
            })

            .state('app.components_maps.terrain', {
                url  : '/terrain',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/terrain.html'
                    }
                }
            })

            .state('app.components_maps.simple-marker', {
                url  : '/simple-marker',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/simple-marker.html'
                    }
                }
            })

            .state('app.components_maps.custom-marker', {
                url  : '/custom-marker',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/custom-marker.html'
                    }
                }
            })

            .state('app.components_maps.info-window', {
                url  : '/info-window',
                views: {
                    'tabContent': {
                        templateUrl: 'app/main/components/maps/tabs/info-window.html'
                    }
                }
            });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.maps')
        .controller('MapsController', MapsController);

    /** @ngInject */
    function MapsController($state, uiGmapGoogleMapApi)
    {
        var vm = this;

        // Data
        var currentState = $state.current.name;

        switch ( currentState )
        {
            case 'app.components_maps':
                vm.selectedNavItem = 'simpleMap';
                break;

            case 'app.components_maps.satellite':
                vm.selectedNavItem = 'satelliteMap';
                break;

            case 'app.components_maps.terrain':
                vm.selectedNavItem = 'terrainMap';
                break;

            case 'app.components_maps.simple-marker':
                vm.selectedNavItem = 'simpleMarkerMap';
                break;

            case 'app.components_maps.custom-marker':
                vm.selectedNavItem = 'customMarkerMap';
                break;

            case 'app.components_maps.info-window':
                vm.selectedNavItem = 'infoWindowMap';
                break;

            default:
                vm.selectedNavItem = 'simpleMap';
        }

        // Methods

        //////////

        uiGmapGoogleMapApi.then(function (maps)
        {
            vm.simpleMap = {
                center: {
                    latitude : -34.397,
                    longitude: 150.644
                },
                zoom  : 8
            };

            vm.satelliteMap = {
                center : {
                    latitude : -34.397,
                    longitude: 150.644
                },
                zoom   : 8,
                options: {
                    mapTypeId: maps.MapTypeId.SATELLITE
                }
            };

            vm.terrainMap = {
                center : {
                    latitude : -34.397,
                    longitude: 150.644
                },
                zoom   : 8,
                options: {
                    mapTypeId: maps.MapTypeId.TERRAIN
                }
            };

            vm.simpleMarkerMap = {
                center: {
                    latitude : -25.363882,
                    longitude: 131.044922
                },
                zoom  : 8,
                marker: {
                    id    : 0,
                    coords: {
                        latitude : -25.363882,
                        longitude: 131.044922
                    }
                }
            };

            vm.customMarkerMap = {
                center: {
                    latitude : -25.363882,
                    longitude: 131.044922
                },
                zoom  : 8,
                marker: {
                    id     : 0,
                    coords : {
                        latitude : -25.363882,
                        longitude: 131.044922
                    },
                    options: {
                        icon: {
                            anchor: new maps.Point(36, 36),
                            origin: new maps.Point(0, 0),
                            url   : '//google-developers.appspot.com/maps/documentation/javascript/examples/full/images/beachflag.png'
                        }
                    }
                }
            };

        });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.custom-directives', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msNavigationServiceProvider)
    {
        // State
        $stateProvider
            .state('app.components_custom-directives', {
                abstract: true,
                url     : '/components/custom-directives'
            })
            .state('app.components_custom-directives.ms-card', {
                url  : '/ms-card',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-card.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-form-wizard', {
                url  : '/ms-form-wizard',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-form-wizard.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-info-bar', {
                url  : '/ms-info-bar',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-info-bar.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-masonry', {
                url  : '/ms-masonry',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-masonry.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-material-color-picker', {
                url  : '/ms-material-color-picker',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-material-color-picker.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-nav', {
                url  : '/ms-nav',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-nav.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-navigation', {
                url  : '/ms-navigation',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-navigation.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-random-class', {
                url  : '/ms-random-class',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-random-class.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-responsive-table', {
                url  : '/ms-responsive-table',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-responsive-table.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-scroll', {
                url  : '/ms-scroll',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-scroll.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-search-bar', {
                url  : '/ms-search-bar',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-search-bar.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-shortcuts', {
                url  : '/ms-shortcuts',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-shortcuts.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-sidenav-helper', {
                url  : '/ms-sidenav-helper',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-sidenav-helper.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-splash-screen', {
                url  : '/ms-splash-screen',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-splash-screen.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-stepper', {
                url  : '/ms-stepper',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-stepper.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-timeline', {
                url  : '/ms-timeline',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-timeline.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            })
            .state('app.components_custom-directives.ms-widget', {
                url  : '/ms-widget',
                views: {
                    'content@app': {
                        templateUrl: 'app/main/components/custom-directives/pages/ms-widget.html',
                        controller : 'CustomDirectivesController as vm'
                    }
                }
            });

        // Navigation
        msNavigationServiceProvider.saveItem('components.custom-directives', {
            title : 'Custom Directives',
            icon  : 'icon-star',
            weight: 2
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-card', {
            title : 'ms-card',
            state : 'app.components_custom-directives.ms-card',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-form-wizard', {
            title : 'ms-form-wizard',
            state : 'app.components_custom-directives.ms-form-wizard',
            weight: 2
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-info-bar', {
            title : 'ms-info-bar',
            state : 'app.components_custom-directives.ms-info-bar',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-masonry', {
            title : 'ms-masonry',
            state : 'app.components_custom-directives.ms-masonry',
            weight: 4
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-material-color-picker', {
            title : 'ms-material-color-picker',
            state : 'app.components_custom-directives.ms-material-color-picker',
            weight: 5
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-nav', {
            title : 'ms-nav',
            state : 'app.components_custom-directives.ms-nav',
            weight: 6
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-navigation', {
            title : 'ms-navigation',
            state : 'app.components_custom-directives.ms-navigation',
            weight: 7
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-random-class', {
            title : 'ms-random-class',
            state : 'app.components_custom-directives.ms-random-class',
            weight: 8
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-responsive-table', {
            title : 'ms-responsive-table',
            state : 'app.components_custom-directives.ms-responsive-table',
            weight: 9
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-scroll', {
            title : 'ms-scroll',
            state : 'app.components_custom-directives.ms-scroll',
            weight: 10
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-search-bar', {
            title : 'ms-search-bar',
            state : 'app.components_custom-directives.ms-search-bar',
            weight: 11
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-shortcuts', {
            title : 'ms-shortcuts',
            state : 'app.components_custom-directives.ms-shortcuts',
            weight: 12
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-sidenav-helper', {
            title : 'ms-sidenav-helper',
            state : 'app.components_custom-directives.ms-sidenav-helper',
            weight: 13
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-splash-screen', {
            title : 'ms-splash-screen',
            state : 'app.components_custom-directives.ms-splash-screen',
            weight: 14
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-stepper', {
            title : 'ms-stepper',
            state : 'app.components_custom-directives.ms-stepper',
            weight: 15
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-timeline', {
            title : 'ms-timeline',
            state : 'app.components_custom-directives.ms-timeline',
            weight: 16
        });

        msNavigationServiceProvider.saveItem('components.custom-directives.ms-widget', {
            title : 'ms-widget',
            state : 'app.components_custom-directives.ms-widget',
            weight: 17
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components.custom-directives')
        .controller('CustomDirectivesController', CustomDirectivesController);

    /** @ngInject */
    function CustomDirectivesController()
    {
        // Data

        // Methods

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components.cards', [])
        .config(config);

    /** @ngInject */
    function config($stateProvider, msApiProvider)
    {
        $stateProvider.state('app.components_cards', {
            url    : '/components/cards',
            views  : {
                'content@app': {
                    templateUrl: 'app/main/components/cards/cards.html',
                    controller : 'CardsController as vm'
                }
            },
            resolve: {
                Cards: function (msApi)
                {
                    return msApi.resolve('cards@get');
                }
            }
        });

        // Api
        msApiProvider.register('cards', ['app/data/cards/cards.json']);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.components.cards')
        .controller('CardsController', CardsController);

    /** @ngInject */
    function CardsController(Cards)
    {
        var vm = this;

        // Data
        vm.cards = Cards.data;

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core',
            [
                'ngAnimate',
                'ngAria',
                'ngCookies',
                'ngMessages',
                'ngResource',
                'ngSanitize',
                'ngMaterial',
                'pascalprecht.translate',
                'ui.router'
            ]);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsWidgetController', MsWidgetController)
        .directive('msWidget', msWidgetDirective)
        .directive('msWidgetFront', msWidgetFrontDirective)
        .directive('msWidgetBack', msWidgetBackDirective);

    /** @ngInject */
    function MsWidgetController($scope, $element)
    {
        var vm = this;

        // Data
        vm.flipped = false;

        // Methods
        vm.flip = flip;

        //////////

        /**
         * Flip the widget
         */
        function flip()
        {
            if ( !isFlippable() )
            {
                return;
            }

            // Toggle flipped status
            vm.flipped = !vm.flipped;

            // Toggle the 'flipped' class
            $element.toggleClass('flipped', vm.flipped);
        }

        /**
         * Check if widget is flippable
         *
         * @returns {boolean}
         */
        function isFlippable()
        {
            return (angular.isDefined($scope.flippable) && $scope.flippable === true);
        }
    }

    /** @ngInject */
    function msWidgetDirective()
    {
        return {
            restrict  : 'E',
            scope     : {
                flippable: '=?'
            },
            controller: 'MsWidgetController',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    //////////
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetFrontDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-front');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

    /** @ngInject */
    function msWidgetBackDirective()
    {
        return {
            restrict  : 'E',
            require   : '^msWidget',
            transclude: true,
            compile   : function (tElement)
            {
                tElement.addClass('ms-widget-back');

                return function postLink(scope, iElement, iAttrs, MsWidgetCtrl, transcludeFn)
                {
                    // Custom transclusion
                    transcludeFn(function (clone)
                    {
                        iElement.empty();
                        iElement.append(clone);
                    });

                    // Methods
                    scope.flipWidget = MsWidgetCtrl.flip;
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsTimelineController', MsTimelineController)
        .directive('msTimeline', msTimelineDirective)
        .directive('msTimelineItem', msTimelineItemDirective);

    /** @ngInject */
    function MsTimelineController()
    {
        var vm = this;

        // Data
        vm.scrollEl = undefined;

        // Methods
        vm.setScrollEl = setScrollEl;
        vm.getScrollEl = getScrollEl;

        //////////

        /**
         * Set scroll element
         *
         * @param scrollEl
         */
        function setScrollEl(scrollEl)
        {
            vm.scrollEl = scrollEl;
        }

        /**
         * Get scroll element
         *
         * @returns {undefined|*}
         */
        function getScrollEl()
        {
            return vm.scrollEl;
        }
    }

    /** @ngInject */
    function msTimelineDirective()
    {
        return {
            scope     : {
                msTimeline: '=?',
                loadMore  : '&?msTimelineLoadMore'
            },
            controller: 'MsTimelineController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-timeline');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    // Create an element for triggering the load more action and append it
                    var loadMoreEl = angular.element('<div class="ms-timeline-loader md-accent-bg md-whiteframe-4dp"><span class="spinner animate-rotate"></span></div>');
                    iElement.append(loadMoreEl);

                    // Default config
                    var config = {
                        scrollEl: '#content'
                    };

                    // Extend the configuration
                    config = angular.extend(config, scope.msTimeline, {});
                    
                    // Grab the scrollable element and store it in the controller for general use
                    var scrollEl = angular.element(config.scrollEl);
                    MsTimelineCtrl.setScrollEl(scrollEl);

                    // Threshold
                    var threshold = 144;

                    // Register onScroll event for the first time
                    registerOnScroll();

                    /**
                     * onScroll Event
                     */
                    function onScroll()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() + threshold > loadMoreEl.position().top )
                        {
                            // Show the loader
                            loadMoreEl.addClass('show');

                            // Unregister scroll event to prevent triggering the function over and over again
                            unregisterOnScroll();

                            // Trigger load more event
                            scope.loadMore().then(
                                // Success
                                function ()
                                {
                                    // Hide the loader
                                    loadMoreEl.removeClass('show');

                                    // Register the onScroll event again
                                    registerOnScroll();
                                },

                                // Error
                                function ()
                                {
                                    // Remove the loader completely
                                    loadMoreEl.remove();
                                }
                            );
                        }
                    }

                    /**
                     * onScroll event registerer
                     */
                    function registerOnScroll()
                    {
                        scrollEl.on('scroll', onScroll);
                    }

                    /**
                     * onScroll event unregisterer
                     */
                    function unregisterOnScroll()
                    {
                        scrollEl.off('scroll', onScroll);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        unregisterOnScroll();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msTimelineItemDirective($timeout, $q)
    {
        return {
            scope  : true,
            require: '^msTimeline',
            compile: function (tElement)
            {
                tElement.addClass('ms-timeline-item').addClass('hidden');

                return function postLink(scope, iElement, iAttrs, MsTimelineCtrl)
                {
                    var threshold = 72,
                        itemLoaded = false,
                        itemInViewport = false,
                        scrollEl = MsTimelineCtrl.getScrollEl();

                    //////////

                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Check if the timeline item has ms-card
                        if ( iElement.find('ms-card') )
                        {
                            // If the ms-card template loaded...
                            scope.$on('msCard::cardTemplateLoaded', function (event, args)
                            {
                                var cardEl = angular.element(args[0]);

                                // Test the card to see if there is any image on it
                                testForImage(cardEl).then(function ()
                                {
                                    $timeout(function ()
                                    {
                                        itemLoaded = true;
                                    });
                                });
                            });
                        }
                        else
                        {
                            // Test the element to see if there is any image on it
                            testForImage(iElement).then(function ()
                            {
                                $timeout(function ()
                                {
                                    itemLoaded = true;
                                });
                            });
                        }

                        // Check if the loaded element also in the viewport
                        scrollEl.on('scroll', testForVisibility);

                        // Test for visibility for the first time without waiting for the scroll event
                        testForVisibility();
                    }

                    // Item ready watcher
                    var itemReadyWatcher = scope.$watch(
                        function ()
                        {
                            return itemLoaded && itemInViewport;
                        },
                        function (current, old)
                        {
                            if ( angular.equals(current, old) )
                            {
                                return;
                            }

                            if ( current )
                            {
                                iElement.removeClass('hidden').addClass('animate');

                                // Unbind itemReadyWatcher
                                itemReadyWatcher();
                            }
                        }, true);

                    /**
                     * Test the given element for image
                     *
                     * @param element
                     * @returns promise
                     */
                    function testForImage(element)
                    {
                        var deferred = $q.defer(),
                            imgEl = element.find('img');

                        if ( imgEl.length > 0 )
                        {
                            imgEl.on('load', function ()
                            {
                                deferred.resolve('Image is loaded');
                            });
                        }
                        else
                        {
                            deferred.resolve('No images');
                        }

                        return deferred.promise;
                    }

                    /**
                     * Test the element for visibility
                     */
                    function testForVisibility()
                    {
                        if ( scrollEl.scrollTop() + scrollEl.height() > iElement.position().top + threshold )
                        {
                            $timeout(function ()
                            {
                                itemInViewport = true;
                            });

                            // Unbind the scroll event
                            scrollEl.off('scroll', testForVisibility);
                        }
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSidenavHelper', msSidenavHelperDirective);

    /** @ngInject */
    function msSidenavHelperDirective()
    {
        return {
            restrict: 'A',
            require : '^mdSidenav',
            link    : function (scope, iElement, iAttrs, MdSidenavCtrl)
            {
                // Watch md-sidenav open & locked open statuses
                // and add class to the ".page-layout" if only
                // the sidenav open and NOT locked open
                scope.$watch(function ()
                {
                    return MdSidenavCtrl.isOpen() && !MdSidenavCtrl.isLockedOpen();
                }, function (current)
                {
                    if ( angular.isUndefined(current) )
                    {
                        return;
                    }

                    iElement.parent().toggleClass('full-height', current);
                    angular.element('html').toggleClass('sidenav-open', current);
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsStepperController', MsStepperController)
        .directive('msHorizontalStepper', msHorizontalStepperDirective)
        .directive('msHorizontalStepperStep', msHorizontalStepperStepDirective)
        .directive('msVerticalStepper', msVerticalStepperDirective)
        .directive('msVerticalStepperStep', msVerticalStepperStepDirective);

    /** @ngInject */
    function MsStepperController($timeout)
    {
        var vm = this;

        // Data
        vm.mainForm = undefined;

        vm.orientation = 'horizontal';
        vm.steps = [];
        vm.currentStep = undefined;
        vm.currentStepNumber = 1;

        // Methods
        vm.setOrientation = setOrientation;
        vm.registerMainForm = registerMainForm;
        vm.registerStep = registerStep;
        vm.setupSteps = setupSteps;
        vm.resetForm = resetForm;

        vm.setCurrentStep = setCurrentStep;

        vm.gotoStep = gotoStep;
        vm.gotoPreviousStep = gotoPreviousStep;
        vm.gotoNextStep = gotoNextStep;
        vm.gotoFirstStep = gotoFirstStep;
        vm.gotoLastStep = gotoLastStep;

        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.isStepCurrent = isStepCurrent;
        vm.isStepDisabled = isStepDisabled;
        vm.isStepOptional = isStepOptional;
        vm.isStepHidden = isStepHidden;
        vm.filterHiddenStep = filterHiddenStep;
        vm.isStepValid = isStepValid;
        vm.isStepNumberValid = isStepNumberValid;

        vm.isFormValid = isFormValid;

        //////////

        /**
         * Set the orientation of the stepper
         *
         * @param orientation
         */
        function setOrientation(orientation)
        {
            vm.orientation = orientation || 'horizontal';
        }

        /**
         * Register the main form
         *
         * @param form
         */
        function registerMainForm(form)
        {
            vm.mainForm = form;
        }

        /**
         * Register a step
         *
         * @param element
         * @param scope
         * @param form
         */
        function registerStep(element, scope, form)
        {
            var step = {
                element           : element,
                scope             : scope,
                form              : form,
                stepNumber        : scope.step || (vm.steps.length + 1),
                stepTitle         : scope.stepTitle,
                stepTitleTranslate: scope.stepTitleTranslate
            };

            // Push the step into steps array
            vm.steps.push(step);

            // Sort steps by stepNumber
            vm.steps.sort(function (a, b)
            {
                return a.stepNumber - b.stepNumber;
            });

            return step;
        }

        /**
         * Setup steps for the first time
         */
        function setupSteps()
        {
            vm.setCurrentStep(vm.currentStepNumber);
        }

        /**
         * Reset steps and the main form
         */
        function resetForm()
        {
            // Timeout is required here because we need to
            // let form model to reset before setting the
            // statuses
            $timeout(function ()
            {
                // Reset all the steps
                for ( var x = 0; x < vm.steps.length; x++ )
                {
                    vm.steps[x].form.$setPristine();
                    vm.steps[x].form.$setUntouched();
                }

                // Reset the main form
                vm.mainForm.$setPristine();
                vm.mainForm.$setUntouched();

                // Go to first step
                gotoFirstStep();
            });
        }

        /**
         * Set current step
         *
         * @param stepNumber
         */
        function setCurrentStep(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return;
            }

            // Update the current step number
            vm.currentStepNumber = stepNumber;

            if ( vm.orientation === 'horizontal' )
            {
                // Hide all steps
                for ( var i = 0; i < vm.steps.length; i++ )
                {
                    vm.steps[i].element.hide();
                }

                // Show the current step
                vm.steps[vm.currentStepNumber - 1].element.show();
            }
            else if ( vm.orientation === 'vertical' )
            {
                // Hide all step content
                for ( var j = 0; j < vm.steps.length; j++ )
                {
                    vm.steps[j].element.find('.ms-stepper-step-content').hide();
                }

                // Show the current step content
                vm.steps[vm.currentStepNumber - 1].element.find('.ms-stepper-step-content').show();
            }
        }

        /**
         * Go to a step
         *
         * @param stepNumber
         */
        function gotoStep(stepNumber)
        {
            // If the step we are about to go
            // is hidden, bail...
            if ( isStepHidden(stepNumber) )
            {
                return;
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the previous step
         */
        function gotoPreviousStep()
        {
            var stepNumber = vm.currentStepNumber - 1;

            // Test the previous steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s >= 1; s-- )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the next step
         */
        function gotoNextStep()
        {
            var stepNumber = vm.currentStepNumber + 1;

            // Test the following steps and make sure we
            // will land to the one that is not hidden
            for ( var s = stepNumber; s <= vm.steps.length; s++ )
            {
                if ( !isStepHidden(s) )
                {
                    stepNumber = s;
                    break;
                }
            }

            vm.setCurrentStep(stepNumber);
        }

        /**
         * Go to the first step
         */
        function gotoFirstStep()
        {
            vm.setCurrentStep(1);
        }

        /**
         * Go to the last step
         */
        function gotoLastStep()
        {
            vm.setCurrentStep(vm.steps.length);
        }

        /**
         * Check if the current step is the first step
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.currentStepNumber === 1;
        }

        /**
         * Check if the current step is the last step
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.currentStepNumber === vm.steps.length;
        }

        /**
         * Check if the given step is the current one
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepCurrent(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.currentStepNumber === stepNumber;
        }

        /**
         * Check if the given step should be disabled
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepDisabled(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            var disabled = false;

            for ( var i = 1; i < stepNumber; i++ )
            {
                if ( !isStepValid(i) )
                {
                    disabled = true;
                    break;
                }
            }

            return disabled;
        }

        /**
         * Check if the given step is optional
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepOptional(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return vm.steps[stepNumber - 1].scope.optionalStep;
        }

        /**
         * Check if the given step is hidden
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepHidden(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            return !!vm.steps[stepNumber - 1].scope.hideStep;
        }

        /**
         * Check if the given step is hidden as a filter
         *
         * @param step
         * @returns {boolean}
         */
        function filterHiddenStep(step)
        {
            return !isStepHidden(step.stepNumber);
        }

        /**
         * Check if the given step is valid
         *
         * @param stepNumber
         * @returns {null|boolean}
         */
        function isStepValid(stepNumber)
        {
            // If the stepNumber is not a valid step number, bail...
            if ( !isStepNumberValid(stepNumber) )
            {
                return null;
            }

            // If the step is optional, always return true
            if ( isStepOptional(stepNumber) )
            {
                return true;
            }

            return vm.steps[stepNumber - 1].form.$valid;
        }

        /**
         * Check if the given step number is a valid step number
         *
         * @param stepNumber
         * @returns {boolean}
         */
        function isStepNumberValid(stepNumber)
        {
            return !(angular.isUndefined(stepNumber) || stepNumber < 1 || stepNumber > vm.steps.length);
        }

        /**
         * Check if the entire form is valid
         *
         * @returns {boolean}
         */
        function isFormValid()
        {
            return vm.mainForm.$valid;
        }
    }

    /** @ngInject */
    function msHorizontalStepperDirective()
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msHorizontalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/horizontal/horizontal.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time
                    MsStepperCtrl.setOrientation('horizontal');
                    MsStepperCtrl.registerMainForm(FormCtrl);
                    MsStepperCtrl.setupSteps();
                };
            }
        };
    }

    /** @ngInject */
    function msHorizontalStepperStepDirective()
    {
        return {
            restrict: 'E',
            require : ['form', '^msHorizontalStepper'],
            priority: 1000,
            scope   : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            compile : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Hide the step by default
                    iElement.hide();
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperDirective($timeout)
    {
        return {
            restrict        : 'A',
            scope           : {},
            require         : ['form', 'msVerticalStepper'],
            priority        : 1001,
            controller      : 'MsStepperController as MsStepper',
            bindToController: {
                model: '=ngModel'
            },
            transclude      : true,
            templateUrl     : 'app/core/directives/ms-stepper/templates/vertical/vertical.html',
            compile         : function (tElement)
            {
                tElement.addClass('ms-stepper');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Register the main form and setup
                    // the steps for the first time

                    // Timeout is required in vertical stepper
                    // as we are using transclusion in steps.
                    // We have to wait for them to be transcluded
                    // and registered to the controller
                    $timeout(function ()
                    {
                        MsStepperCtrl.setOrientation('vertical');
                        MsStepperCtrl.registerMainForm(FormCtrl);
                        MsStepperCtrl.setupSteps();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msVerticalStepperStepDirective()
    {
        return {
            restrict   : 'E',
            require    : ['form', '^msVerticalStepper'],
            priority   : 1000,
            scope      : {
                step              : '=?',
                stepTitle         : '=?',
                stepTitleTranslate: '=?',
                optionalStep      : '=?',
                hideStep          : '=?'
            },
            transclude : true,
            templateUrl: 'app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-stepper-step');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var FormCtrl = ctrls[0],
                        MsStepperCtrl = ctrls[1];

                    // Is it an optional step?
                    scope.optionalStep = angular.isDefined(iAttrs.optionalStep);

                    // Register the step
                    scope.stepInfo = MsStepperCtrl.registerStep(iElement, scope, FormCtrl);

                    // Expose the controller to the scope
                    scope.MsStepper = MsStepperCtrl;

                    // Hide the step content by default
                    iElement.find('.ms-stepper-step-content').hide();
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msDatepickerFixConfig', msDatepickerFixConfigProvider)
        .directive('msDatepickerFix', msDatepickerFix);

    /** @ngInject */
    function msDatepickerFixConfigProvider()
    {
        var service = this;

        // Default configuration
        var defaultConfig = {
            // To view
            formatter: function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return val === '' ? val : new Date(val);
            },
            // To model
            parser   : function (val)
            {
                if ( !val )
                {
                    return '';
                }

                return moment(val).add(moment(val).utcOffset(), 'm').toDate();
            }
        };

        // Methods
        service.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfig = angular.extend({}, defaultConfig, configuration);
        }

        /**
         * Service
         */
        service.$get = function ()
        {
            return defaultConfig;
        };
    }

    /** @ngInject */
    function msDatepickerFix(msDatepickerFixConfig)
    {
        return {
            require : 'ngModel',
            priority: 1,
            link    : function (scope, elem, attrs, ngModel)
            {
                ngModel.$formatters.push(msDatepickerFixConfig.formatter); // to view
                ngModel.$parsers.push(msDatepickerFixConfig.parser); // to model
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msSplashScreen', msSplashScreenDirective);

    /** @ngInject */
    function msSplashScreenDirective($animate)
    {
        return {
            restrict: 'E',
            link    : function (scope, iElement)
            {
                var splashScreenRemoveEvent = scope.$on('msSplashScreen::remove', function ()
                {
                    $animate.leave(iElement).then(function ()
                    {
                        // De-register scope event
                        splashScreenRemoveEvent();

                        // Null-ify everything else
                        scope = iElement = null;
                    });
                });
            }
        };
    }
})();
/***
 * OPEASY 顶部快捷方式实现方式
 */
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsShortcutsController', MsShortcutsController)
        .directive('msShortcuts', msShortcutsDirective);

    /** @ngInject */
    function MsShortcutsController($scope, $cookies, $document, $timeout, $q, msNavigationService)
    {
        var vm = this;

        // Data
        vm.query = '';
        vm.queryOptions = {
            debounce: 300
        };
        vm.resultsLoading = false;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;
        vm.mobileBarActive = false;

        vm.results = null;
        vm.shortcuts = [];

        vm.sortableOptions = {
            ghostClass   : 'ghost',
            forceFallback: true,
            fallbackClass: 'dragging',
            onSort       : function ()
            {
                vm.saveShortcuts();
            }
        };

        // Methods
        vm.populateResults = populateResults;
        vm.loadShortcuts = loadShortcuts;
        vm.saveShortcuts = saveShortcuts;
        vm.addShortcut = addShortcut;
        vm.removeShortcut = removeShortcut;
        vm.handleResultClick = handleResultClick;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;
        vm.toggleMobileBar = toggleMobileBar;

        //////////

        init();

        function init()
        {
            // Load the shortcuts
            vm.loadShortcuts().then(
                // Success
                function (response)
                {
                    vm.shortcuts = response;

                    // Add shortcuts as results by default
                    if ( vm.shortcuts.length > 0 )
                    {
                        vm.results = response;
                    }
                }
            );

            // Watch the model changes to trigger the search
            $scope.$watch('MsShortcuts.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                // Show the loader
                vm.resultsLoading = true;

                // Populate the results
                vm.populateResults().then(
                    // Success
                    function (response)
                    {
                        vm.results = response;
                    },
                    // Error
                    function ()
                    {
                        vm.results = [];
                    }
                ).finally(
                    function ()
                    {
                        // Hide the loader
                        vm.resultsLoading = false;
                    }
                );
            });
        }

        /**
         * Populate the results
         */
        function populateResults()
        {
            var results = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    results.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the results
            if ( vm.query )
            {
                results = results.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(vm.query)) > -1 )
                    {
                        return true;
                    }
                });

                // Iterate through one last time and
                // add required properties to items
                for ( var i = 0; i < results.length; i++ )
                {
                    // Add false to hasShortcut by default
                    results[i].hasShortcut = false;

                    // Test if the item is in the shortcuts list
                    for ( var y = 0; y < vm.shortcuts.length; y++ )
                    {
                        if ( vm.shortcuts[y]._id === results[i]._id )
                        {
                            results[i].hasShortcut = true;
                            break;
                        }
                    }
                }
            }
            else
            {
                // If the query is empty, that means
                // there is nothing to search for so
                // we will populate the results with
                // current shortcuts if there is any
                if ( vm.shortcuts.length > 0 )
                {
                    results = vm.shortcuts;
                }
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Fake the service delay
            $timeout(function ()
            {
                // Resolve the promise
                deferred.resolve(results);
            }, 250);

            // Return a promise
            return deferred.promise;
        }

        /**
         * Load shortcuts
         */
        function loadShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // load the shortcuts from the cookies.
            // But here you can make an API call
            // to load them from the DB.
            var shortcuts = angular.fromJson($cookies.get('FUSE.shortcuts'));

            // No cookie available. Generate one
            // for the demo purposes...
            if ( angular.isUndefined(shortcuts) )
            {

                /**
                shortcuts = [
                    {
                        'title'      : 'Chat',
                        'icon'       : 'icon-hangouts',
                        'state'      : 'app.chat',
                        'badge'      : {
                            'content': 13,
                            'color'  : '#09d261'
                        },
                        'weight'     : 5,
                        'children'   : [],
                        '_id'        : 'chat',
                        '_path'      : 'apps.chat',
                        'uisref'     : 'app.chat',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Contacts',
                        'icon'       : 'icon-account-box',
                        'state'      : 'app.contacts',
                        'weight'     : 10,
                        'children'   : [],
                        '_id'        : 'contacts',
                        '_path'      : 'apps.contacts',
                        'uisref'     : 'app.contacts',
                        'hasShortcut': true
                    }, {
                        'title'      : 'Notes',
                        'icon'       : 'icon-lightbulb',
                        'state'      : 'app.notes',
                        'weight'     : 11,
                        'children'   : [],
                        '_id'        : 'notes',
                        '_path'      : 'apps.notes',
                        'uisref'     : 'app.notes',
                        'hasShortcut': true
                    }
                ];
                 **/

                shortcuts = [
                    {
                        'title'      : '合同',
                        'icon'       : 'icon-library-books',
                        'state'      : 'app.store.contracts.list',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'contracts ',
                        '_path'      : 'app.store.contracts.list',
                        'uisref'     : 'app.store.contracts.list',
                        'hasShortcut': true
                    },
                    {
                        'title'      : '学生',
                        'icon'       : 'icon-human-child',
                        'state'      : 'app.store.customers.list',
                        'weight'     : 1,
                        'children'   : [],
                        '_id'        : 'contracts ',
                        '_path'      : 'app.store.customers.list',
                        'uisref'     : 'app.store.customers.list',
                        'hasShortcut': true
                    }
                ];

                $cookies.put('FUSE.shortcuts', angular.toJson(shortcuts));
            }

            // Resolve the promise
            deferred.resolve(shortcuts);

            return deferred.promise;
        }

        /**
         * Save the shortcuts
         */
        function saveShortcuts()
        {
            var deferred = $q.defer();

            // For the demo purposes, we will
            // keep the shortcuts in the cookies.
            // But here you can make an API call
            // to save them to the DB.
            $cookies.put('FUSE.shortcuts', angular.toJson(vm.shortcuts));

            // Fake the service delay
            $timeout(function ()
            {
                deferred.resolve({'success': true});
            }, 250);

            return deferred.promise;
        }

        /**
         * Add item as shortcut
         *
         * @param item
         */
        function addShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = true;

            // Add as a shortcut
            vm.shortcuts.push(item);

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Remove item from shortcuts
         *
         * @param item
         */
        function removeShortcut(item)
        {
            // Update the hasShortcut status
            item.hasShortcut = false;

            // Remove the shortcut
            for ( var x = 0; x < vm.shortcuts.length; x++ )
            {
                if ( vm.shortcuts[x]._id === item._id )
                {
                    // Remove the x-th item from the array
                    vm.shortcuts.splice(x, 1);

                    // If we aren't searching for anything...
                    if ( !vm.query )
                    {
                        // If all the shortcuts have been removed,
                        // null-ify the results
                        if ( vm.shortcuts.length === 0 )
                        {
                            vm.results = null;
                        }
                        // Otherwise update the selected index
                        else
                        {
                            if ( x >= vm.shortcuts.length )
                            {
                                vm.selectedResultIndex = vm.shortcuts.length - 1;
                            }
                        }
                    }
                }
            }

            // Save the shortcuts
            vm.saveShortcuts();
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            // Add or remove the shortcut
            if ( item.hasShortcut )
            {
                vm.removeShortcut(item);
            }
            else
            {
                vm.addShortcut(item);
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $document.find('#ms-shortcut-add-menu').find('.results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }

        /**
         * Toggle mobile bar
         */
        function toggleMobileBar()
        {
            vm.mobileBarActive = !vm.mobileBarActive;
        }
    }

    /** @ngInject */
    function msShortcutsDirective()
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msShortcuts',
            controller      : 'MsShortcutsController as MsShortcuts',
            bindToController: {},
            templateUrl     : 'app/core/directives/ms-shortcuts/ms-shortcuts.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-shortcuts');

                return function postLink(scope, iElement)
                {
                    // Data

                };
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsSearchBarController', MsSearchBarController)
        .directive('msSearchBar', msSearchBarDirective);

    /** @ngInject */
    function MsSearchBarController($scope, $element, $timeout)
    {
        var vm = this;

        // Data
        vm.collapsed = true;
        vm.query = '';
        vm.queryOptions = {
            debounce: vm.debounce || 0
        };
        vm.resultsLoading = false;
        vm.results = null;
        vm.selectedResultIndex = 0;
        vm.ignoreMouseEvents = false;

        // Methods
        vm.populateResults = populateResults;

        vm.expand = expand;
        vm.collapse = collapse;

        vm.absorbEvent = absorbEvent;
        vm.handleKeydown = handleKeydown;
        vm.handleMouseenter = handleMouseenter;
        vm.temporarilyIgnoreMouseEvents = temporarilyIgnoreMouseEvents;
        vm.handleResultClick = handleResultClick;
        vm.ensureSelectedResultIsVisible = ensureSelectedResultIsVisible;

        //////////

        init();

        function init()
        {
            // Watch the model changes to trigger the search
            $scope.$watch('MsSearchBar.query', function (current, old)
            {
                if ( angular.isUndefined(current) )
                {
                    return;
                }

                if ( angular.equals(current, old) )
                {
                    return;
                }

                if ( vm.collapsed )
                {
                    return;
                }

                // Evaluate the onSearch function to access the
                // function itself
                var onSearchEvaluated = $scope.$parent.$eval(vm.onSearch, {query: current}),
                    isArray = angular.isArray(onSearchEvaluated),
                    isPromise = (onSearchEvaluated && !!onSearchEvaluated.then);

                if ( isArray )
                {
                    // Populate the results
                    vm.populateResults(onSearchEvaluated);
                }

                if ( isPromise )
                {
                    // Show the loader
                    vm.resultsLoading = true;

                    onSearchEvaluated.then(
                        // Success
                        function (response)
                        {
                            // Populate the results
                            vm.populateResults(response);
                        },
                        // Error
                        function ()
                        {
                            // Assign an empty array to show
                            // the no-results screen
                            vm.populateResults([]);
                        }
                    ).finally(function ()
                        {
                            // Hide the loader
                            vm.resultsLoading = false;
                        }
                    );
                }
            });
        }

        /**
         * Populate the results
         *
         * @param results
         */
        function populateResults(results)
        {
            // Before doing anything,
            // make sure the search bar is expanded
            if ( vm.collapsed )
            {
                return;
            }

            var isArray = angular.isArray(results),
                isNull = results === null;

            // Only accept arrays and null values
            if ( !isArray && !isNull )
            {
                return;
            }

            // Reset the selected result
            vm.selectedResultIndex = 0;

            // Populate the results
            vm.results = results;
        }

        /**
         * Expand
         */
        function expand()
        {
            // Set collapsed status
            vm.collapsed = false;

            // Call expand on scope
            $scope.expand();

            // Callback
            if ( vm.onExpand && angular.isFunction(vm.onExpand) )
            {
                vm.onExpand();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Empty the query
            vm.query = '';

            // Empty results to hide the results view
            vm.populateResults(null);

            // Set collapsed status
            vm.collapsed = true;

            // Call collapse on scope
            $scope.collapse();

            // Callback
            if ( vm.onCollapse && angular.isFunction(vm.onCollapse) )
            {
                vm.onCollapse();
            }
        }

        /**
         * Absorb the given event
         *
         * @param event
         */
        function absorbEvent(event)
        {
            event.preventDefault();
        }

        /**
         * Handle keydown
         *
         * @param event
         */
        function handleKeydown(event)
        {
            var keyCode = event.keyCode,
                keys = [27, 38, 40];

            // Prevent the default action if
            // one of the keys are pressed that
            // we are listening
            if ( keys.indexOf(keyCode) > -1 )
            {
                event.preventDefault();
            }

            switch ( keyCode )
            {
                // Enter
                case 13:

                    // Trigger result click
                    vm.handleResultClick(vm.results[vm.selectedResultIndex]);

                    break;

                // Escape
                case 27:

                    // Collapse the search bar
                    vm.collapse();

                    break;

                // Up Arrow
                case 38:

                    // Decrease the selected result index
                    if ( vm.selectedResultIndex - 1 >= 0 )
                    {
                        // Decrease the selected index
                        vm.selectedResultIndex--;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                // Down Arrow
                case 40:

                    if ( !vm.results )
                    {
                        return;
                    }

                    // Increase the selected result index
                    if ( vm.selectedResultIndex + 1 < vm.results.length )
                    {
                        // Increase the selected index
                        vm.selectedResultIndex++;

                        // Make sure the selected result is in the view
                        vm.ensureSelectedResultIsVisible();
                    }

                    break;

                default:
                    break;
            }
        }

        /**
         * Handle mouseenter
         *
         * @param index
         */
        function handleMouseenter(index)
        {
            if ( vm.ignoreMouseEvents )
            {
                return;
            }

            // Update the selected result index
            // with the given index
            vm.selectedResultIndex = index;
        }

        /**
         * Set a variable for a limited time
         * to make other functions to ignore
         * the mouse events
         */
        function temporarilyIgnoreMouseEvents()
        {
            // Set the variable
            vm.ignoreMouseEvents = true;

            // Cancel the previous timeout
            $timeout.cancel(vm.mouseEventIgnoreTimeout);

            // Set the timeout
            vm.mouseEventIgnoreTimeout = $timeout(function ()
            {
                vm.ignoreMouseEvents = false;
            }, 250);
        }

        /**
         * Handle the result click
         *
         * @param item
         */
        function handleResultClick(item)
        {
            if ( vm.onResultClick )
            {
                vm.onResultClick({item: item});
            }

            // Collapse the search bar
            vm.collapse();
        }

        /**
         * Ensure the selected result will
         * always be visible on the results
         * area
         */
        function ensureSelectedResultIsVisible()
        {
            var resultsEl = $element.find('.ms-search-bar-results'),
                selectedItemEl = angular.element(resultsEl.find('.result')[vm.selectedResultIndex]);

            if ( resultsEl && selectedItemEl )
            {
                var top = selectedItemEl.position().top - 8,
                    bottom = selectedItemEl.position().top + selectedItemEl.outerHeight() + 8;

                // Start ignoring mouse events
                vm.temporarilyIgnoreMouseEvents();

                if ( resultsEl.scrollTop() > top )
                {
                    resultsEl.scrollTop(top);
                }

                if ( bottom > (resultsEl.height() + resultsEl.scrollTop()) )
                {
                    resultsEl.scrollTop(bottom - resultsEl.height());
                }
            }
        }
    }

    /** @ngInject */
    function msSearchBarDirective($document)
    {
        return {
            restrict        : 'E',
            scope           : {},
            require         : 'msSearchBar',
            controller      : 'MsSearchBarController as MsSearchBar',
            bindToController: {
                debounce     : '=?',
                onSearch     : '@',
                onResultClick: '&?',
                onExpand     : '&?',
                onCollapse   : '&?'
            },
            templateUrl     : 'app/core/directives/ms-search-bar/ms-search-bar.html',
            compile         : function (tElement)
            {
                // Add class
                tElement.addClass('ms-search-bar');

                return function postLink(scope, iElement)
                {
                    // Data
                    var inputEl,
                        bodyEl = $document.find('body');

                    // Methods
                    scope.collapse = collapse;
                    scope.expand = expand;

                    //////////

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Grab the input element
                        inputEl = iElement.find('#ms-search-bar-input');
                    }

                    /**
                     * Expand action
                     */
                    function expand()
                    {
                        // Add expanded class
                        iElement.addClass('expanded');

                        // Add helper class to the body
                        bodyEl.addClass('ms-search-bar-expanded');

                        // Focus on the input
                        inputEl.focus();
                    }

                    /**
                     * Collapse action
                     */
                    function collapse()
                    {
                        // Remove expanded class
                        iElement.removeClass('expanded');

                        // Remove helper class from the body
                        bodyEl.removeClass('ms-search-bar-expanded');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msResponsiveTable', msResponsiveTableDirective);

    /** @ngInject */
    function msResponsiveTableDirective()
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement)
            {
                // Wrap the table
                var wrapper = angular.element('<div class="ms-responsive-table-wrapper"></div>');
                iElement.after(wrapper);
                wrapper.append(iElement);

                //////////
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msScrollConfig', msScrollConfigProvider)
        .directive('msScroll', msScrollDirective);

    /** @ngInject */
    function msScrollConfigProvider()
    {
        // Default configuration
        var defaultConfiguration = {
            wheelSpeed            : 1,
            wheelPropagation      : false,
            swipePropagation      : true,
            minScrollbarLength    : null,
            maxScrollbarLength    : null,
            useBothWheelAxes      : false,
            useKeyboard           : true,
            suppressScrollX       : false,
            suppressScrollY       : false,
            scrollXMarginOffset   : 0,
            scrollYMarginOffset   : 0,
            stopPropagationOnClick: true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            defaultConfiguration = angular.extend({}, defaultConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig
            };

            return service;

            //////////

            /**
             * Return the config
             */
            function getConfig()
            {
                return defaultConfiguration;
            }
        };
    }

    /** @ngInject */
    function msScrollDirective($timeout, msScrollConfig, msUtils, fuseConfig)
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                // Do not replace scrollbars if
                // 'disableCustomScrollbars' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbars') )
                {
                    return;
                }

                // Do not replace scrollbars on mobile devices
                // if 'disableCustomScrollbarsOnMobile' config enabled
                if ( fuseConfig.getConfig('disableCustomScrollbarsOnMobile') && msUtils.isMobile() )
                {
                    return;
                }

                // Add class
                tElement.addClass('ms-scroll');

                return function postLink(scope, iElement, iAttrs)
                {
                    var options = {};

                    // If options supplied, evaluate the given
                    // value. This is because we don't want to
                    // have an isolated scope but still be able
                    // to use scope variables.
                    // We don't want an isolated scope because
                    // we should be able to use this everywhere
                    // especially with other directives
                    if ( iAttrs.msScroll )
                    {
                        options = scope.$eval(iAttrs.msScroll);
                    }

                    // Extend the given config with the ones from provider
                    options = angular.extend({}, msScrollConfig.getConfig(), options);

                    // Initialize the scrollbar
                    $timeout(function ()
                    {
                        PerfectScrollbar.initialize(iElement[0], options);
                    }, 0);

                    // Update the scrollbar on element mouseenter
                    iElement.on('mouseenter', updateScrollbar);

                    // Watch scrollHeight and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollHeight');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    // Watch scrollWidth and update
                    // the scrollbar if it changes
                    scope.$watch(function ()
                    {
                        return iElement.prop('scrollWidth');
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        updateScrollbar();
                    });

                    /**
                     * Update the scrollbar
                     */
                    function updateScrollbar()
                    {
                        PerfectScrollbar.update(iElement[0]);
                    }

                    // Cleanup on destroy
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('mouseenter');
                        PerfectScrollbar.destroy(iElement[0]);
                    });
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msNavigationService', msNavigationServiceProvider)
        .controller('MsNavigationController', MsNavigationController)
        // Vertical
        .directive('msNavigation', msNavigationDirective)
        .controller('MsNavigationNodeController', MsNavigationNodeController)
        .directive('msNavigationNode', msNavigationNodeDirective)
        .directive('msNavigationItem', msNavigationItemDirective)
        //Horizontal
        .directive('msNavigationHorizontal', msNavigationHorizontalDirective)
        .controller('MsNavigationHorizontalNodeController', MsNavigationHorizontalNodeController)
        .directive('msNavigationHorizontalNode', msNavigationHorizontalNodeDirective)
        .directive('msNavigationHorizontalItem', msNavigationHorizontalItemDirective);

    /** @ngInject */
    function msNavigationServiceProvider()
    {
        // Inject $log service
        var $log = angular.injector(['ng']).get('$log');

        // Navigation array
        var navigation = [];

        var service = this;

        // Methods
        service.saveItem = saveItem;
        service.deleteItem = deleteItem;
        service.sortByWeight = sortByWeight;

        //////////

        /**
         * Create or update the navigation item
         *
         * @param path
         * @param item
         */
        function saveItem(path, item)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            var parts = path.split('.');

            // Generate the object id from the parts
            var id = parts[parts.length - 1];

            // Get the parent item from the parts
            var parent = _findOrCreateParent(parts);

            // Decide if we are going to update or create
            var updateItem = false;

            for ( var i = 0; i < parent.length; i++ )
            {
                if ( parent[i]._id === id )
                {
                    updateItem = parent[i];

                    break;
                }
            }

            // Update
            if ( updateItem )
            {
                angular.extend(updateItem, item);

                // Add proper ui-sref
                updateItem.uisref = _getUiSref(updateItem);
            }
            // Create
            else
            {
                // Create an empty children array in the item
                item.children = [];

                // Add the default weight if not provided or if it's not a number
                if ( angular.isUndefined(item.weight) || !angular.isNumber(item.weight) )
                {
                    item.weight = 1;
                }

                // Add the item id
                item._id = id;

                // Add the item path
                item._path = path;

                // Add proper ui-sref
                item.uisref = _getUiSref(item);

                // Push the item into the array
                parent.push(item);
            }
        }

        /**
         * Delete navigation item
         *
         * @param path
         */
        function deleteItem(path)
        {
            if ( !angular.isString(path) )
            {
                $log.error('path must be a string (eg. `dashboard.project`)');
                return;
            }

            // Locate the item by using given path
            var item = navigation,
                parts = path.split('.');

            for ( var p = 0; p < parts.length; p++ )
            {
                var id = parts[p];

                for ( var i = 0; i < item.length; i++ )
                {
                    if ( item[i]._id === id )
                    {
                        // If we have a matching path,
                        // we have found our object:
                        // remove it.
                        if ( item[i]._path === path )
                        {
                            item.splice(i, 1);
                            return true;
                        }

                        // Otherwise grab the children of
                        // the current item and continue
                        item = item[i].children;
                        break;
                    }
                }
            }

            return false;
        }

        /**
         * Sort the navigation items by their weights
         *
         * @param parent
         */
        function sortByWeight(parent)
        {
            // If parent not provided, sort the root items
            if ( !parent )
            {
                parent = navigation;
                parent.sort(_byWeight);
            }

            // Sort the children
            for ( var i = 0; i < parent.length; i++ )
            {
                var children = parent[i].children;

                if ( children.length > 1 )
                {
                    children.sort(_byWeight);
                }

                if ( children.length > 0 )
                {
                    sortByWeight(children);
                }
            }
        }

        /* ----------------- */
        /* Private Functions */
        /* ----------------- */

        /**
         * Find or create parent
         *
         * @param parts
         * @returns {Array|Boolean}
         * @private
         */
        function _findOrCreateParent(parts)
        {
            // Store the main navigation
            var parent = navigation;

            // If it's going to be a root item
            // return the navigation itself
            if ( parts.length === 1 )
            {
                return parent;
            }

            // Remove the last element from the parts as
            // we don't need that to figure out the parent
            parts.pop();

            // Find and return the parent
            for ( var i = 0; i < parts.length; i++ )
            {
                var _id = parts[i],
                    createParent = true;

                for ( var p = 0; p < parent.length; p++ )
                {
                    if ( parent[p]._id === _id )
                    {
                        parent = parent[p].children;
                        createParent = false;

                        break;
                    }
                }

                // If there is no parent found, create one, push
                // it into the current parent and assign it as a
                // new parent
                if ( createParent )
                {
                    var item = {
                        _id     : _id,
                        _path   : parts.join('.'),
                        title   : _id,
                        weight  : 1,
                        children: []
                    };

                    parent.push(item);
                    parent = item.children;
                }
            }

            return parent;
        }

        /**
         * Sort by weight
         *
         * @param x
         * @param y
         * @returns {number}
         * @private
         */
        function _byWeight(x, y)
        {
            return parseInt(x.weight) - parseInt(y.weight);
        }

        /**
         * Setup the ui-sref using state & state parameters
         *
         * @param item
         * @returns {string}
         * @private
         */
        function _getUiSref(item)
        {
            var uisref = '';

            if ( angular.isDefined(item.state) )
            {
                uisref = item.state;

                if ( angular.isDefined(item.stateParams) && angular.isObject(item.stateParams) )
                {
                    uisref = uisref + '(' + angular.toJson(item.stateParams) + ')';
                }
            }

            return uisref;
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */

        this.$get = function ()
        {
            var activeItem = null,
                navigationScope = null,
                folded = null,
                foldedOpen = null;

            var service = {
                saveItem          : saveItem,
                deleteItem        : deleteItem,
                sort              : sortByWeight,
                clearNavigation   : clearNavigation,
                setActiveItem     : setActiveItem,
                getActiveItem     : getActiveItem,
                getNavigation     : getNavigation,
                getFlatNavigation : getFlatNavigation,
                setNavigationScope: setNavigationScope,
                setFolded         : setFolded,
                getFolded         : getFolded,
                setFoldedOpen     : setFoldedOpen,
                getFoldedOpen     : getFoldedOpen,
                toggleFolded      : toggleFolded
            };

            return service;

            //////////

            /**
             * Clear the entire navigation
             */
            function clearNavigation()
            {
                // Clear the navigation array
                navigation = [];

                // Clear the vm.navigation from main controller
                if ( navigationScope )
                {
                    navigationScope.vm.navigation = navigation;
                }
            }

            /**
             * Set active item
             *
             * @param node
             * @param scope
             */
            function setActiveItem(node, scope)
            {
                activeItem = {
                    node : node,
                    scope: scope
                };
            }

            /**
             * Return active item
             */
            function getActiveItem()
            {
                return activeItem;
            }

            /**
             * Return navigation array
             *
             * @param root
             * @returns Array
             */
            function getNavigation(root)
            {
                if ( root )
                {
                    for ( var i = 0; i < navigation.length; i++ )
                    {
                        if ( navigation[i]._id === root )
                        {
                            return [navigation[i]];
                        }
                    }

                    return null;
                }

                return navigation;
            }

            /**
             * Return flat navigation array
             *
             * @param root
             * @returns Array
             */
            function getFlatNavigation(root)
            {
                // Get the correct navigation array
                var navigation = getNavigation(root);

                // Flatten the navigation object
                return _flattenNavigation(navigation);
            }

            /**
             * Store navigation's scope for later use
             *
             * @param scope
             */
            function setNavigationScope(scope)
            {
                navigationScope = scope;
            }

            /**
             * Set folded status
             *
             * @param status
             */
            function setFolded(status)
            {
                folded = status;
            }

            /**
             * Return folded status
             *
             * @returns {*}
             */
            function getFolded()
            {
                return folded;
            }

            /**
             * Set folded open status
             *
             * @param status
             */
            function setFoldedOpen(status)
            {
                foldedOpen = status;
            }

            /**
             * Return folded open status
             *
             * @returns {*}
             */
            function getFoldedOpen()
            {
                return foldedOpen;
            }


            /**
             * Toggle fold on stored navigation's scope
             */
            function toggleFolded()
            {
                navigationScope.toggleFolded();
            }

            /**
             * Flatten the given navigation
             *
             * @param navigation
             * @private
             */
            function _flattenNavigation(navigation)
            {
                var flatNav = [];

                for ( var x = 0; x < navigation.length; x++ )
                {
                    // Copy and clear the children of the
                    // navigation that we want to push
                    var navToPush = angular.copy(navigation[x]);
                    navToPush.children = [];

                    // Push the item
                    flatNav.push(navToPush);

                    // If there are child items in this navigation,
                    // do some nested function magic
                    if ( navigation[x].children.length > 0 )
                    {
                        flatNav = flatNav.concat(_flattenNavigation(navigation[x].children));
                    }
                }

                return flatNav;
            }
        };
    }

    /** @ngInject */
    function MsNavigationController($scope, msNavigationService)
    {
        var vm = this;

        // Data
        if ( $scope.root )
        {
            vm.navigation = msNavigationService.getNavigation($scope.root);
        }
        else
        {
            vm.navigation = msNavigationService.getNavigation();
        }

        // Methods
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Sort the navigation before doing anything else
            msNavigationService.sort();
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            angular.element('body').toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }
    }

    /** @ngInject */
    function msNavigationDirective($rootScope, $timeout, $mdSidenav, msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                folded: '=',
                root  : '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/vertical.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation');

                return function postLink(scope, iElement)
                {
                    var bodyEl = angular.element('body'),
                        foldExpanderEl = angular.element('<div id="ms-navigation-fold-expander"></div>'),
                        foldCollapserEl = angular.element('<div id="ms-navigation-fold-collapser"></div>'),
                        sidenav = $mdSidenav('navigation');

                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);

                    // Initialize
                    init();

                    /**
                     * Initialize
                     */
                    function init()
                    {
                        // Set the folded status for the first time.
                        // First, we have to check if we have a folded
                        // status available in the service already. This
                        // will prevent navigation to act weird if we already
                        // set the fold status, remove the navigation and
                        // then re-initialize it, which happens if we
                        // change to a view without a navigation and then
                        // come back with history.back() function.

                        // If the service didn't initialize before, set
                        // the folded status from scope, otherwise we
                        // won't touch anything because the folded status
                        // already set in the service...
                        if ( msNavigationService.getFolded() === null )
                        {
                            msNavigationService.setFolded(scope.folded);
                        }

                        if ( msNavigationService.getFolded() )
                        {
                            // Collapse everything.
                            // This must be inside a $timeout because by the
                            // time we call this, the 'msNavigation::collapse'
                            // event listener is not registered yet. $timeout
                            // will ensure that it will be called after it is
                            // registered.
                            $timeout(function ()
                            {
                                $rootScope.$broadcast('msNavigation::collapse');
                            });

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                    }

                    // Sidenav locked open status watcher
                    scope.$watch(function ()
                    {
                        return sidenav.isLockedOpen();
                    }, function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        var folded = msNavigationService.getFolded();

                        if ( folded )
                        {
                            if ( current )
                            {
                                // Collapse everything
                                $rootScope.$broadcast('msNavigation::collapse');
                            }
                            else
                            {
                                // Expand the active one and its parents
                                var activeItem = msNavigationService.getActiveItem();
                                if ( activeItem )
                                {
                                    activeItem.scope.$emit('msNavigation::stateMatched');
                                }
                            }
                        }
                    });

                    // Folded status watcher
                    scope.$watch('folded', function (current, old)
                    {
                        if ( angular.isUndefined(current) || angular.equals(current, old) )
                        {
                            return;
                        }

                        setFolded(current);
                    });

                    /**
                     * Set folded status
                     *
                     * @param folded
                     */
                    function setFolded(folded)
                    {
                        // Store folded status on the service for global access
                        msNavigationService.setFolded(folded);

                        if ( folded )
                        {
                            // Collapse everything
                            $rootScope.$broadcast('msNavigation::collapse');

                            // Add class to the body
                            bodyEl.addClass('ms-navigation-folded');

                            // Set fold expander
                            setFoldExpander();
                        }
                        else
                        {
                            // Expand the active one and its parents
                            var activeItem = msNavigationService.getActiveItem();
                            if ( activeItem )
                            {
                                activeItem.scope.$emit('msNavigation::stateMatched');
                            }

                            // Remove body class
                            bodyEl.removeClass('ms-navigation-folded ms-navigation-folded-open');

                            // Remove fold collapser
                            removeFoldCollapser();
                        }
                    }

                    /**
                     * Set fold expander
                     */
                    function setFoldExpander()
                    {
                        iElement.parent().append(foldExpanderEl);

                        // Let everything settle for a moment
                        // before registering the event listener
                        $timeout(function ()
                        {
                            foldExpanderEl.on('mouseenter touchstart', onFoldExpanderHover);
                        });
                    }

                    /**
                     * Set fold collapser
                     */
                    function setFoldCollapser()
                    {
                        bodyEl.find('#main').append(foldCollapserEl);
                        foldCollapserEl.on('mouseenter touchstart', onFoldCollapserHover);
                    }

                    /**
                     * Remove fold collapser
                     */
                    function removeFoldCollapser()
                    {
                        foldCollapserEl.remove();
                    }

                    /**
                     * onHover event of foldExpander
                     */
                    function onFoldExpanderHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(true);

                        // Expand the active one and its parents
                        var activeItem = msNavigationService.getActiveItem();
                        if ( activeItem )
                        {
                            activeItem.scope.$emit('msNavigation::stateMatched');
                        }

                        // Add class to the body
                        bodyEl.addClass('ms-navigation-folded-open');

                        // Remove the fold opener
                        foldExpanderEl.remove();

                        // Set fold collapser
                        setFoldCollapser();
                    }

                    /**
                     * onHover event of foldCollapser
                     */
                    function onFoldCollapserHover(event)
                    {
                        if ( event )
                        {
                            event.preventDefault();
                        }

                        // Set folded open status
                        msNavigationService.setFoldedOpen(false);

                        // Collapse everything
                        $rootScope.$broadcast('msNavigation::collapse');

                        // Remove body class
                        bodyEl.removeClass('ms-navigation-folded-open');

                        // Remove the fold collapser
                        foldCollapserEl.remove();

                        // Set fold expander
                        setFoldExpander();
                    }

                    /**
                     * Public access for toggling folded status externally
                     */
                    scope.toggleFolded = function ()
                    {
                        var folded = msNavigationService.getFolded();

                        setFolded(!folded);
                    };

                    /**
                     * On $stateChangeStart
                     */
                    scope.$on('$stateChangeStart', function ()
                    {
                        // Close the sidenav
                        sidenav.close();
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        foldCollapserEl.off('mouseenter touchstart');
                        foldExpanderEl.off('mouseenter touchstart');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationNodeController($scope, $element, $rootScope, $animate, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.collapsed = undefined;
        vm.collapsable = undefined;
        vm.group = undefined;
        vm.animateHeightClass = 'animate-height';

        // Methods
        vm.toggleCollapsed = toggleCollapsed;
        vm.collapse = collapse;
        vm.expand = expand;
        vm.getClass = getClass;
        vm.isHidden = isHidden;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Is collapsable?
            if ( !vm.hasChildren || vm.group )
            {
                vm.collapsable = false;
            }
            else
            {
                vm.collapsable = !!(angular.isUndefined(vm.node.collapsable) || typeof vm.node.collapsable !== 'boolean' || vm.node.collapsable === true);
            }

            // Is collapsed?
            if ( !vm.collapsable )
            {
                vm.collapsed = false;
            }
            else
            {
                vm.collapsed = !!(angular.isUndefined(vm.node.collapsed) || typeof vm.node.collapsed !== 'boolean' || vm.node.collapsed === true);
            }

            // Expand all parents if we have a matching state or
            // the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Expand if the current scope is collapsable and is collapsed
                if ( vm.collapsable && vm.collapsed )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.collapsed = false;
                    });
                }
            });

            // Listen for collapse event
            $scope.$on('msNavigation::collapse', function (event, path)
            {
                if ( vm.collapsed || !vm.collapsable )
                {
                    return;
                }

                // If there is no path defined, collapse
                if ( angular.isUndefined(path) )
                {
                    vm.collapse();
                }
                // If there is a path defined, do not collapse
                // the items that are inside that path. This will
                // prevent parent items from collapsing
                else
                {
                    var givenPathParts = path.split('.'),
                        activePathParts = [];

                    var activeItem = msNavigationService.getActiveItem();
                    if ( activeItem )
                    {
                        activePathParts = activeItem.node._path.split('.');
                    }

                    // Test for given path
                    if ( givenPathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    // Test for active path
                    if ( activePathParts.indexOf(vm.node._id) > -1 )
                    {
                        return;
                    }

                    vm.collapse();
                }
            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Collapse everything except the one we're using
                    $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
                }

                // Expand the parents if we the current
                // state is a child of the node's state
                if ( $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Emit the stateMatched
                    $scope.$emit('msNavigation::stateMatched');
                }
            });
        }

        /**
         * Toggle collapsed
         */
        function toggleCollapsed()
        {
            if ( vm.collapsed )
            {
                vm.expand();
            }
            else
            {
                vm.collapse();
            }
        }

        /**
         * Collapse
         */
        function collapse()
        {
            // Grab the element that we are going to collapse
            var collapseEl = vm.element.children('ul');

            // Grab the height
            var height = collapseEl[0].offsetHeight;

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = true;

                // Add collapsing class to the node
                vm.element.addClass('collapsing');

                // Animate the height
                $animate.animate(collapseEl,
                    {
                        'display': 'block',
                        'height' : height + 'px'
                    },
                    {
                        'height': '0px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        collapseEl.css({
                            'display': '',
                            'height' : ''
                        });

                        // Clear collapsing class from the node
                        vm.element.removeClass('collapsing');
                    }
                );

                // Broadcast the collapse event so child items can also be collapsed
                $scope.$broadcast('msNavigation::collapse');
            });
        }

        /**
         * Expand
         */
        function expand()
        {
            // Grab the element that we are going to expand
            var expandEl = vm.element.children('ul');

            // Move the element out of the dom flow and
            // make it block so we can get its height
            expandEl.css({
                'position'  : 'absolute',
                'visibility': 'hidden',
                'display'   : 'block',
                'height'    : 'auto'
            });

            // Grab the height
            var height = expandEl[0].offsetHeight;

            // Reset the style modifications
            expandEl.css({
                'position'  : '',
                'visibility': '',
                'display'   : '',
                'height'    : ''
            });

            $scope.$evalAsync(function ()
            {
                // Set collapsed status
                vm.collapsed = false;

                // Add expanding class to the node
                vm.element.addClass('expanding');

                // Animate the height
                $animate.animate(expandEl,
                    {
                        'display': 'block',
                        'height' : '0px'
                    },
                    {
                        'height': height + 'px'
                    },
                    vm.animateHeightClass
                ).then(
                    function ()
                    {
                        // Clear the inline styles after animation done
                        expandEl.css({
                            'height': ''
                        });

                        // Clear expanding class from the node
                        vm.element.removeClass('expanding');
                    }
                );

                // If item expanded, broadcast the collapse event from rootScope so that the other expanded items
                // can be collapsed. This is necessary for keeping only one parent expanded at any time
                $rootScope.$broadcast('msNavigation::collapse', vm.node._path);
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }

        /**
         * Check if node should be hidden
         *
         * @returns {boolean}
         */
        function isHidden()
        {
            if ( angular.isDefined(vm.node.hidden) && angular.isFunction(vm.node.hidden) )
            {
                return vm.node.hidden();
            }

            return false;
        }
    }

    /** @ngInject */
    function msNavigationNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationNode'
            },
            controller      : 'MsNavigationNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationItemDirective()
    {
        return {
            restrict: 'A',
            require : '^msNavigationNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationNodeCtrl)
                {
                    // If the item is collapsable...
                    if ( MsNavigationNodeCtrl.collapsable )
                    {
                        iElement.on('click', MsNavigationNodeCtrl.toggleCollapsed);
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalDirective(msNavigationService)
    {
        return {
            restrict   : 'E',
            scope      : {
                root: '@'
            },
            controller : 'MsNavigationController as vm',
            templateUrl: 'app/core/directives/ms-navigation/templates/horizontal.html',
            transclude : true,
            compile    : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal');

                return function postLink(scope)
                {
                    // Store the navigation in the service for public access
                    msNavigationService.setNavigationScope(scope);
                };
            }
        };
    }

    /** @ngInject */
    function MsNavigationHorizontalNodeController($scope, $element, $rootScope, $state, msNavigationService)
    {
        var vm = this;

        // Data
        vm.element = $element;
        vm.node = $scope.node;
        vm.hasChildren = undefined;
        vm.group = undefined;

        // Methods
        vm.getClass = getClass;

        //////////

        init();

        /**
         * Initialize
         */
        function init()
        {
            // Setup the initial values

            // Is active
            vm.isActive = false;

            // Has children?
            vm.hasChildren = vm.node.children.length > 0;

            // Is group?
            vm.group = !!(angular.isDefined(vm.node.group) && vm.node.group === true);

            // Mark all parents as active if we have a matching state
            // or the current state is a child of the node's state
            if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
            {
                // If state params are defined, make sure they are
                // equal, otherwise do not set the active item
                if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                {
                    return;
                }

                $scope.$emit('msNavigation::stateMatched');

                // Also store the current active menu item
                msNavigationService.setActiveItem(vm.node, $scope);
            }

            $scope.$on('msNavigation::stateMatched', function ()
            {
                // Mark as active if has children
                if ( vm.hasChildren )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
            });

            // Listen for clearActive event
            $scope.$on('msNavigation::clearActive', function ()
            {
                if ( !vm.hasChildren )
                {
                    return;
                }

                var activePathParts = [];

                var activeItem = msNavigationService.getActiveItem();
                if ( activeItem )
                {
                    activePathParts = activeItem.node._path.split('.');
                }

                // Test for active path
                if ( activePathParts.indexOf(vm.node._id) > -1 )
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = true;
                    });
                }
                else
                {
                    $scope.$evalAsync(function ()
                    {
                        vm.isActive = false;
                    });
                }

            });

            // Listen for $stateChangeSuccess event
            $scope.$on('$stateChangeSuccess', function ()
            {
                if ( vm.node.state === $state.current.name || $state.includes(vm.node.state) )
                {
                    // If state params are defined, make sure they are
                    // equal, otherwise do not set the active item
                    if ( angular.isDefined(vm.node.stateParams) && angular.isDefined($state.params) && !angular.equals(vm.node.stateParams, $state.params) )
                    {
                        return;
                    }

                    // Update active item on state change
                    msNavigationService.setActiveItem(vm.node, $scope);

                    // Clear all active states except the one we're using
                    $rootScope.$broadcast('msNavigation::clearActive');
                }
            });
        }

        /**
         * Return the class
         *
         * @returns {*}
         */
        function getClass()
        {
            return vm.node.class;
        }
    }

    /** @ngInject */
    function msNavigationHorizontalNodeDirective()
    {
        return {
            restrict        : 'A',
            bindToController: {
                node: '=msNavigationHorizontalNode'
            },
            controller      : 'MsNavigationHorizontalNodeController as vm',
            compile         : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-node');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    // Add custom classes
                    iElement.addClass(MsNavigationHorizontalNodeCtrl.getClass());

                    // Add group class if it's a group
                    if ( MsNavigationHorizontalNodeCtrl.group )
                    {
                        iElement.addClass('group');
                    }
                };
            }
        };
    }

    /** @ngInject */
    function msNavigationHorizontalItemDirective($mdMedia)
    {
        return {
            restrict: 'A',
            require : '^msNavigationHorizontalNode',
            compile : function (tElement)
            {
                tElement.addClass('ms-navigation-horizontal-item');

                return function postLink(scope, iElement, iAttrs, MsNavigationHorizontalNodeCtrl)
                {
                    iElement.on('click', onClick);

                    function onClick()
                    {
                        if ( !MsNavigationHorizontalNodeCtrl.hasChildren || $mdMedia('gt-md') )
                        {
                            return;
                        }

                        iElement.toggleClass('expanded');
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.off('click');
                    });
                };
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msRandomClass', msRandomClassDirective);

    /** @ngInject */
    function msRandomClassDirective()
    {
        return {
            restrict: 'A',
            scope   : {
                msRandomClass: '='
            },
            link    : function (scope, iElement)
            {
                var randomClass = scope.msRandomClass[Math.floor(Math.random() * (scope.msRandomClass.length))];
                iElement.addClass(randomClass);
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msNavFoldService', msNavFoldService)
        .directive('msNavIsFolded', msNavIsFoldedDirective)
        .controller('MsNavController', MsNavController)
        .directive('msNav', msNavDirective)
        .directive('msNavTitle', msNavTitleDirective)
        .directive('msNavButton', msNavButtonDirective)
        .directive('msNavToggle', msNavToggleDirective);

    /** @ngInject */
    function msNavFoldService()
    {
        var foldable = {};

        var service = {
            setFoldable    : setFoldable,
            isNavFoldedOpen: isNavFoldedOpen,
            toggleFold     : toggleFold,
            openFolded     : openFolded,
            closeFolded    : closeFolded
        };

        return service;

        //////////

        /**
         * Set the foldable
         *
         * @param scope
         * @param element
         */
        function setFoldable(scope, element)
        {
            foldable = {
                'scope'  : scope,
                'element': element
            };
        }

        /**
         * Is folded open
         */
        function isNavFoldedOpen()
        {
            return foldable.scope.isNavFoldedOpen();
        }

        /**
         * Toggle fold
         */
        function toggleFold()
        {
            foldable.scope.toggleFold();
        }

        /**
         * Open folded navigation
         */
        function openFolded()
        {
            foldable.scope.openFolded();
        }

        /**
         * Close folded navigation
         */
        function closeFolded()
        {
            foldable.scope.closeFolded();
        }
    }

    /** @ngInject */
    function msNavIsFoldedDirective($document, $rootScope, msNavFoldService)
    {
        return {
            restrict: 'A',
            link    : function (scope, iElement, iAttrs)
            {
                var isFolded = (iAttrs.msNavIsFolded === 'true'),
                    isFoldedOpen = false,
                    body = angular.element($document[0].body),
                    openOverlay = angular.element('<div id="ms-nav-fold-open-overlay"></div>'),
                    closeOverlay = angular.element('<div id="ms-nav-fold-close-overlay"></div>'),
                    sidenavEl = iElement.parent();

                // Initialize the service
                msNavFoldService.setFoldable(scope, iElement, isFolded);

                // Set the fold status for the first time
                if ( isFolded )
                {
                    fold();
                }
                else
                {
                    unfold();
                }

                /**
                 * Is nav folded open
                 */
                function isNavFoldedOpen()
                {
                    return isFoldedOpen;
                }

                /**
                 * Toggle fold
                 */
                function toggleFold()
                {
                    isFolded = !isFolded;

                    if ( isFolded )
                    {
                        fold();
                    }
                    else
                    {
                        unfold();
                    }
                }

                /**
                 * Fold the navigation
                 */
                function fold()
                {
                    // Add classes
                    body.addClass('ms-nav-folded');

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    // Append the openOverlay to the element
                    sidenavEl.append(openOverlay);

                    // Event listeners
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Open folded navigation
                 */
                function openFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    body.addClass('ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Remove open overlay
                    sidenavEl.find(openOverlay).remove();

                    // Append close overlay and bind its events
                    sidenavEl.parent().append(closeOverlay);
                    closeOverlay.on('mouseenter touchstart', function (event)
                    {
                        closeFolded(event);
                        isFoldedOpen = false;
                    });
                }

                /**
                 * Close folded navigation
                 */
                function closeFolded(event)
                {
                    if ( angular.isDefined(event) )
                    {
                        event.preventDefault();
                    }

                    // Collapse everything and scroll to the top
                    $rootScope.$broadcast('msNav::forceCollapse');
                    iElement.scrollTop(0);

                    body.removeClass('ms-nav-folded-open');

                    // Remove close overlay
                    sidenavEl.parent().find(closeOverlay).remove();

                    // Append open overlay and bind its events
                    sidenavEl.append(openOverlay);
                    openOverlay.on('mouseenter touchstart', function (event)
                    {
                        openFolded(event);
                        isFoldedOpen = true;
                    });
                }

                /**
                 * Unfold the navigation
                 */
                function unfold()
                {
                    body.removeClass('ms-nav-folded ms-nav-folded-open');

                    // Update the location
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    iElement.off('mouseenter mouseleave');
                }

                // Expose functions to the scope
                scope.toggleFold = toggleFold;
                scope.openFolded = openFolded;
                scope.closeFolded = closeFolded;
                scope.isNavFoldedOpen = isNavFoldedOpen;

                // Cleanup
                scope.$on('$destroy', function ()
                {
                    openOverlay.off('mouseenter touchstart');
                    closeOverlay.off('mouseenter touchstart');
                    iElement.off('mouseenter mouseleave');
                });
            }
        };
    }


    /** @ngInject */
    function MsNavController()
    {
        var vm = this,
            disabled = false,
            toggleItems = [],
            lockedItems = [];

        // Data

        // Methods
        vm.isDisabled = isDisabled;
        vm.enable = enable;
        vm.disable = disable;
        vm.setToggleItem = setToggleItem;
        vm.getLockedItems = getLockedItems;
        vm.setLockedItem = setLockedItem;
        vm.clearLockedItems = clearLockedItems;

        //////////

        /**
         * Is navigation disabled
         *
         * @returns {boolean}
         */
        function isDisabled()
        {
            return disabled;
        }

        /**
         * Disable the navigation
         */
        function disable()
        {
            disabled = true;
        }

        /**
         * Enable the navigation
         */
        function enable()
        {
            disabled = false;
        }

        /**
         * Set toggle item
         *
         * @param element
         * @param scope
         */
        function setToggleItem(element, scope)
        {
            toggleItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Get locked items
         *
         * @returns {Array}
         */
        function getLockedItems()
        {
            return lockedItems;
        }

        /**
         * Set locked item
         *
         * @param element
         * @param scope
         */
        function setLockedItem(element, scope)
        {
            lockedItems.push({
                'element': element,
                'scope'  : scope
            });
        }

        /**
         * Clear locked items list
         */
        function clearLockedItems()
        {
            lockedItems = [];
        }
    }

    /** @ngInject */
    function msNavDirective($rootScope, $mdComponentRegistry, msNavFoldService)
    {
        return {
            restrict  : 'E',
            scope     : {},
            controller: 'MsNavController',
            compile   : function (tElement)
            {
                tElement.addClass('ms-nav');

                return function postLink(scope)
                {
                    // Update toggle status according to the ui-router current state
                    $rootScope.$broadcast('msNav::expandMatchingToggles');

                    // Update toggles on state changes
                    var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
                    {
                        $rootScope.$broadcast('msNav::expandMatchingToggles');

                        // Close navigation sidenav on stateChangeSuccess
                        $mdComponentRegistry.when('navigation').then(function (navigation)
                        {
                            navigation.close();

                            if ( msNavFoldService.isNavFoldedOpen() )
                            {
                                msNavFoldService.closeFolded();
                            }
                        });
                    });

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        stateChangeSuccessEvent();
                    });
                };
            }
        };
    }

    /** @ngInject */
    function msNavTitleDirective()
    {
        return {
            restrict: 'A',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-title');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavButtonDirective()
    {
        return {
            restrict: 'AE',
            compile : function (tElement)
            {
                tElement.addClass('ms-nav-button');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msNavToggleDirective($rootScope, $q, $animate, $state)
    {
        return {
            restrict: 'A',
            require : '^msNav',
            scope   : true,
            compile : function (tElement, tAttrs)
            {
                tElement.addClass('ms-nav-toggle');

                // Add collapsed attr
                if ( angular.isUndefined(tAttrs.collapsed) )
                {
                    tAttrs.collapsed = true;
                }

                tElement.attr('collapsed', tAttrs.collapsed);

                return function postLink(scope, iElement, iAttrs, MsNavCtrl)
                {
                    var classes = {
                        expanded         : 'expanded',
                        expandAnimation  : 'expand-animation',
                        collapseAnimation: 'collapse-animation'
                    };

                    // Store all related states
                    var links = iElement.find('a');
                    var states = [];
                    var regExp = /\(.*\)/g;

                    angular.forEach(links, function (link)
                    {
                        var state = angular.element(link).attr('ui-sref');

                        if ( angular.isUndefined(state) )
                        {
                            return;
                        }

                        // Remove any parameter definition from the state name before storing it
                        state = state.replace(regExp, '');

                        states.push(state);
                    });

                    // Store toggle-able element and its scope in the main nav controller
                    MsNavCtrl.setToggleItem(iElement, scope);

                    // Click handler
                    iElement.children('.ms-nav-button').on('click', toggle);

                    // Toggle function
                    function toggle()
                    {
                        // If navigation is disabled, do nothing...
                        if ( MsNavCtrl.isDisabled() )
                        {
                            return;
                        }

                        // Disable the entire navigation to prevent spamming
                        MsNavCtrl.disable();

                        if ( isCollapsed() )
                        {
                            // Clear the locked items list
                            MsNavCtrl.clearLockedItems();

                            // Emit pushToLockedList event
                            scope.$emit('msNav::pushToLockedList');

                            // Collapse everything but locked items
                            $rootScope.$broadcast('msNav::collapse');

                            // Expand and then...
                            expand().then(function ()
                            {
                                // Enable the entire navigation after animations completed
                                MsNavCtrl.enable();
                            });
                        }
                        else
                        {
                            // Collapse with all children
                            scope.$broadcast('msNav::forceCollapse');
                        }
                    }

                    // Cleanup
                    scope.$on('$destroy', function ()
                    {
                        iElement.children('.ms-nav-button').off('click');
                    });

                    /*---------------------*/
                    /* Scope Events        */
                    /*---------------------*/

                    /**
                     * Collapse everything but locked items
                     */
                    scope.$on('msNav::collapse', function ()
                    {
                        // Only collapse toggles that are not locked
                        var lockedItems = MsNavCtrl.getLockedItems();
                        var locked = false;

                        angular.forEach(lockedItems, function (lockedItem)
                        {
                            if ( angular.equals(lockedItem.scope, scope) )
                            {
                                locked = true;
                            }
                        });

                        if ( locked )
                        {
                            return;
                        }

                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Collapse everything
                     */
                    scope.$on('msNav::forceCollapse', function ()
                    {
                        // Collapse and then...
                        collapse().then(function ()
                        {
                            // Enable the entire navigation after animations completed
                            MsNavCtrl.enable();
                        });
                    });

                    /**
                     * Expand toggles that match with the current states
                     */
                    scope.$on('msNav::expandMatchingToggles', function ()
                    {
                        var currentState = $state.current.name;
                        var shouldExpand = false;

                        angular.forEach(states, function (state)
                        {
                            if ( currentState === state )
                            {
                                shouldExpand = true;
                            }
                        });

                        if ( shouldExpand )
                        {
                            expand();
                        }
                        else
                        {
                            collapse();
                        }
                    });

                    /**
                     * Add toggle to the locked list
                     */
                    scope.$on('msNav::pushToLockedList', function ()
                    {
                        // Set expanded item on main nav controller
                        MsNavCtrl.setLockedItem(iElement, scope);
                    });

                    /*---------------------*/
                    /* Internal functions  */
                    /*---------------------*/

                    /**
                     * Is element collapsed
                     *
                     * @returns {bool}
                     */
                    function isCollapsed()
                    {
                        return iElement.attr('collapsed') === 'true';
                    }

                    /**
                     * Is element expanded
                     *
                     * @returns {bool}
                     */
                    function isExpanded()
                    {
                        return !isCollapsed();
                    }

                    /**
                     * Expand the toggle
                     *
                     * @returns $promise
                     */
                    function expand()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already expanded, do nothing..
                        if ( isExpanded() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', false);

                        // Grab the element to expand
                        var elementToExpand = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Move the element out of the dom flow and
                        // make it block so we can get its height
                        elementToExpand.css({
                            'position'  : 'absolute',
                            'visibility': 'hidden',
                            'display'   : 'block',
                            'height'    : 'auto'
                        });

                        // Grab the height
                        var height = elementToExpand[0].offsetHeight;

                        // Reset the style modifications
                        elementToExpand.css({
                            'position'  : '',
                            'visibility': '',
                            'display'   : '',
                            'height'    : ''
                        });

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToExpand,
                                {
                                    'display': 'block',
                                    'height' : '0px'
                                },
                                {
                                    'height': height + 'px'
                                },
                                classes.expandAnimation
                            ).then(
                                function ()
                                {
                                    // Add expanded class
                                    elementToExpand.addClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToExpand.css({'height': ''});

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }

                    /**
                     * Collapse the toggle
                     *
                     * @returns $promise
                     */
                    function collapse()
                    {
                        // Create a new deferred object
                        var deferred = $q.defer();

                        // If the menu item is already collapsed, do nothing..
                        if ( isCollapsed() )
                        {
                            // Reject the deferred object
                            deferred.reject({'error': true});

                            // Return the promise
                            return deferred.promise;
                        }

                        // Set element attr
                        iElement.attr('collapsed', true);

                        // Grab the element to collapse
                        var elementToCollapse = angular.element(iElement.find('ms-nav-toggle-items')[0]);

                        // Grab the height
                        var height = elementToCollapse[0].offsetHeight;

                        // Animate the height
                        scope.$evalAsync(function ()
                        {
                            $animate.animate(elementToCollapse,
                                {
                                    'height': height + 'px'
                                },
                                {
                                    'height': '0px'
                                },
                                classes.collapseAnimation
                            ).then(
                                function ()
                                {
                                    // Remove expanded class
                                    elementToCollapse.removeClass(classes.expanded);

                                    // Clear the inline styles after animation done
                                    elementToCollapse.css({
                                        'display': '',
                                        'height' : ''
                                    });

                                    // Resolve the deferred object
                                    deferred.resolve({'success': true});
                                }
                            );
                        });

                        // Return the promise
                        return deferred.promise;
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMaterialColorPickerController', msMaterialColorPickerController)
        .directive('msMaterialColorPicker', msMaterialColorPicker);

    /** @ngInject */
    function msMaterialColorPickerController($scope, $mdColorPalette, $mdMenu, fuseGenerator)
    {
        var vm = this;
        vm.palettes = $mdColorPalette; // Material Color Palette
        vm.selectedPalette = false;
        vm.selectedHues = false;
        $scope.$selectedColor = {};

        // Methods
        vm.activateHueSelection = activateHueSelection;
        vm.selectColor = selectColor;
        vm.removeColor = removeColor;

        /**
         * Initialize / Watch model changes
         */
        $scope.$watch('ngModel', setSelectedColor);

        /**
         * Activate Hue Selection
         * @param palette
         * @param hues
         */
        function activateHueSelection(palette, hues)
        {
            vm.selectedPalette = palette;
            vm.selectedHues = hues;
        }

        /**
         * Select Color
         * @type {selectColor}
         */
        function selectColor(palette, hue)
        {
            // Update Selected Color
            updateSelectedColor(palette, hue);

            // Update Model Value
            updateModel();

            // Hide The picker
            $mdMenu.hide();
        }

        function removeColor()
        {
            vm.selectedColor = {
                palette: '',
                hue    : '',
                class  : ''
            };

            activateHueSelection(false, false);

            updateModel();
        }

        /**
         * Set SelectedColor by model type
         */
        function setSelectedColor()
        {
            if ( !vm.modelCtrl.$viewValue || vm.modelCtrl.$viewValue === '' )
            {
                removeColor();
                return;
            }

            var palette, hue;

            // If ModelType Class
            if ( vm.msModelType === 'class' )
            {
                var color = vm.modelCtrl.$viewValue.split('-');
                if ( color.length >= 5 )
                {
                    palette = color[1] + '-' + color[2];
                    hue = color[3];
                }
                else
                {
                    palette = color[1];
                    hue = color[2];
                }
            }

            // If ModelType Object
            else if ( vm.msModelType === 'obj' )
            {
                palette = vm.modelCtrl.$viewValue.palette;
                hue = vm.modelCtrl.$viewValue.hue || 500;
            }

            // Update Selected Color
            updateSelectedColor(palette, hue);
        }

        /**
         * Update Selected Color
         * @param palette
         * @param hue
         */
        function updateSelectedColor(palette, hue)
        {
            vm.selectedColor = {
                palette     : palette,
                hue         : hue,
                class       : 'md-' + palette + '-' + hue + '-bg',
                bgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].value),
                fgColorValue: fuseGenerator.rgba(vm.palettes[palette][hue].contrast)
            };

            // If Model object not Equals the selectedColor update it
            // it can be happen when the model only have pallete and hue values
            if ( vm.msModelType === 'obj' && !angular.equals(vm.selectedColor, vm.modelCtrl.$viewValue) )
            {
                // Update Model Value
                updateModel();
            }

            activateHueSelection(palette, vm.palettes[palette]);

            $scope.$selectedColor = vm.selectedColor;
        }

        /**
         * Update Model Value by model type
         */
        function updateModel()
        {
            if ( vm.msModelType === 'class' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor.class);
            }
            else if ( vm.msModelType === 'obj' )
            {
                vm.modelCtrl.$setViewValue(vm.selectedColor);
            }
        }
    }

    /** @ngInject */
    function msMaterialColorPicker()
    {
        return {
            require    : ['msMaterialColorPicker', 'ngModel'],
            restrict   : 'E',
            scope      : {
                ngModel    : '=',
                msModelType: '@?'
            },
            controller : 'msMaterialColorPickerController as vm',
            transclude : true,
            templateUrl: 'app/core/directives/ms-material-color-picker/ms-material-color-picker.html',
            link       : function (scope, element, attrs, controllers, transclude)
            {
                var ctrl = controllers[0];

                /**
                 *  Pass model controller to directive controller
                 */
                ctrl.modelCtrl = controllers[1];

                /**
                 * ModelType: 'obj', 'class'(default)
                 * @type {string|string}
                 */
                ctrl.msModelType = scope.msModelType || 'class';

                transclude(scope, function (clone)
                {
                    clone = clone.filter(function (i, el)
                    {
                        return ( el.nodeType === 1 ) ? true : false;
                    });

                    if ( clone.length )
                    {
                        element.find('ms-color-picker-button').replaceWith(clone);
                    }
                });
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msInfoBar', msInfoBarDirective);

    /** @ngInject */
    function msInfoBarDirective($document)
    {
        return {
            restrict   : 'E',
            scope      : {},
            transclude : true,
            templateUrl: 'app/core/directives/ms-info-bar/ms-info-bar.html',
            link       : function (scope, iElement)
            {
                var body = $document.find('body'),
                    bodyClass = 'ms-info-bar-active';

                // Add body class
                body.addClass(bodyClass);

                /**
                 * Remove the info bar
                 */
                function removeInfoBar()
                {
                    body.removeClass(bodyClass);
                    iElement.remove();
                    scope.$destroy();
                }

                // Expose functions
                scope.removeInfoBar = removeInfoBar;
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('msMasonryController', msMasonryController)
        .directive('msMasonry', msMasonry)
        .directive('msMasonryItem', msMasonryItem);

    /** @ngInject */
    function msMasonryController($scope, $window, $mdMedia, $timeout)
    {
        var vm = this,
            defaultOpts = {
                columnCount     : 5,
                respectItemOrder: false,
                reLayoutDebounce: 400,
                responsive      : {
                    md: 3,
                    sm: 2,
                    xs: 1
                }
            },
            reLayoutTimeout = true;

        vm.options = null;
        vm.container = [];
        vm.containerPos = '';
        vm.columnWidth = '';
        vm.items = [];

        // Methods
        vm.reLayout = reLayout;
        vm.initialize = initialize;
        vm.waitImagesLoaded = waitImagesLoaded;

        function initialize()
        {
            vm.options = !vm.options ? defaultOpts : angular.extend(defaultOpts, vm.options);


            watchContainerResize();
        }

        $scope.$on('msMasonry:relayout', function ()
        {
            reLayout();
        });

        function waitImagesLoaded(element, callback)
        {
            if ( typeof imagesLoaded !== 'undefined' )
            {
                var imgLoad = $window.imagesLoaded(element);

                imgLoad.on('done', function ()
                {
                    callback();
                });
            }
            else
            {
                callback();
            }
        }

        function watchContainerResize()
        {
            $scope.$watch(
                function ()
                {
                    return vm.container.width();
                },
                function (newValue, oldValue)
                {
                    if ( newValue !== oldValue )
                    {
                        reLayout();
                    }
                }
            );
        }

        function reLayout()
        {
            // Debounce for relayout
            if ( reLayoutTimeout )
            {
                $timeout.cancel(reLayoutTimeout);
            }

            reLayoutTimeout = $timeout(function ()
            {
                start();

                $scope.$broadcast('msMasonry:relayoutFinished');

            }, vm.options.reLayoutDebounce);

            // Start relayout
            function start()
            {
                vm.containerPos = vm.container[0].getBoundingClientRect();

                updateColumnOptions();

                $scope.$broadcast('msMasonry:relayoutStarted');

                vm.items = vm.container.find('ms-masonry-item');

                //initialize lastRowBottomArr
                var referenceArr = Array.apply(null, new Array(vm.columnCount)).map(function ()
                {
                    return 0;
                });

                // set item positions
                for ( var i = 0; i < vm.items.length; i++ )
                {
                    var item = vm.items[i],
                        xPos, yPos, column, refTop;

                    item = angular.element(item);

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:startReLayout');
                    }

                    item.css({'width': vm.columnWidth});

                    if ( vm.options.respectItemOrder )
                    {
                        column = i % vm.columnCount;
                        refTop = referenceArr[column];
                    }
                    else
                    {
                        refTop = Math.min.apply(Math, referenceArr);
                        column = referenceArr.indexOf(refTop);
                    }

                    referenceArr[column] = refTop + item[0].getBoundingClientRect().height;

                    xPos = Math.round(column * vm.columnWidth);
                    yPos = refTop;

                    item.css({'transform': 'translate3d(' + xPos + 'px,' + yPos + 'px,0px)'});
                    item.addClass('placed');

                    if ( item.scope() )
                    {
                        item.scope().$broadcast('msMasonryItem:finishReLayout');
                    }
                }
            }
        }

        function updateColumnOptions()
        {
            vm.columnCount = vm.options.columnCount;

            if ( $mdMedia('gt-md') )
            {
                vm.columnCount = vm.options.columnCount;
            }
            else if ( $mdMedia('md') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.md ? vm.options.responsive.md : vm.columnCount);
            }
            else if ( $mdMedia('sm') )
            {
                vm.columnCount = (vm.columnCount > vm.options.responsive.sm ? vm.options.responsive.sm : vm.columnCount);
            }
            else
            {
                vm.columnCount = vm.options.responsive.xs;
            }

            vm.columnWidth = vm.containerPos.width / vm.columnCount;

        }
    }

    /** @ngInject */
    function msMasonry($timeout)
    {
        return {
            restrict  : 'AEC',
            controller: 'msMasonryController',
            compile   : compile
        };
        function compile(element, attributes)
        {
            return {
                pre : function preLink(scope, iElement, iAttrs, controller)
                {
                    controller.options = angular.fromJson(attributes.options || '{}');
                    controller.container = element;
                },
                post: function postLink(scope, iElement, iAttrs, controller)
                {
                    $timeout(function ()
                    {
                        controller.initialize();
                    });
                }
            };
        }
    }

    /** @ngInject */
    function msMasonryItem()
    {
        return {
            restrict: 'AEC',
            require : '^msMasonry',
            priority: 1,
            link    : link
        };

        function link(scope, element, attributes, controller)
        {
            controller.waitImagesLoaded(element, function ()
            {
                controller.reLayout();

            });

            scope.$on('msMasonryItem:finishReLayout', function ()
            {
                scope.$watch(function ()
                {
                    return element.height();
                }, function (newVal, oldVal)
                {
                    if ( newVal !== oldVal )
                    {
                        controller.reLayout();
                    }
                });
            });

            element.on('$destroy', function ()
            {
                controller.reLayout();
            });
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .directive('msCard', msCardDirective);

    /** @ngInject */
    function msCardDirective()
    {
        return {
            restrict: 'E',
            scope   : {
                templatePath: '=template',
                card        : '=ngModel',
                vm          : '=viewModel'
            },
            template: '<div class="ms-card-content-wrapper" ng-include="templatePath" onload="cardTemplateLoaded()"></div>',
            compile : function (tElement)
            {
                // Add class
                tElement.addClass('ms-card');

                return function postLink(scope, iElement)
                {
                    // Methods
                    scope.cardTemplateLoaded = cardTemplateLoaded;

                    //////////

                    /**
                     * Emit cardTemplateLoaded event
                     */
                    function cardTemplateLoaded()
                    {
                        scope.$emit('msCard::cardTemplateLoaded', iElement);
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsFormWizardController', MsFormWizardController)
        .directive('msFormWizard', msFormWizardDirective)
        .directive('msFormWizardForm', msFormWizardFormDirective);

    /** @ngInject */
    function MsFormWizardController()
    {
        var vm = this;

        // Data
        vm.forms = [];
        vm.selectedIndex = 0;

        // Methods
        vm.registerForm = registerForm;

        vm.previousStep = previousStep;
        vm.nextStep = nextStep;
        vm.firstStep = firstStep;
        vm.lastStep = lastStep;

        vm.totalSteps = totalSteps;
        vm.isFirstStep = isFirstStep;
        vm.isLastStep = isLastStep;

        vm.currentStepInvalid = currentStepInvalid;
        vm.previousStepInvalid = previousStepInvalid;
        vm.formsIncomplete = formsIncomplete;
        vm.resetForm = resetForm;

        //////////

        /**
         * Register form
         *
         * @param form
         */
        function registerForm(form)
        {
            vm.forms.push(form);
        }

        /**
         * Go to previous step
         */
        function previousStep()
        {
            if ( isFirstStep() )
            {
                return;
            }

            vm.selectedIndex--;
        }

        /**
         * Go to next step
         */
        function nextStep()
        {
            if ( isLastStep() )
            {
                return;
            }

            vm.selectedIndex++;
        }

        /**
         * Go to first step
         */
        function firstStep()
        {
            vm.selectedIndex = 0;
        }

        /**
         * Go to last step
         */
        function lastStep()
        {
            vm.selectedIndex = totalSteps() - 1;
        }

        /**
         * Return total steps
         *
         * @returns {int}
         */
        function totalSteps()
        {
            return vm.forms.length;
        }

        /**
         * Is first step?
         *
         * @returns {boolean}
         */
        function isFirstStep()
        {
            return vm.selectedIndex === 0;
        }

        /**
         * Is last step?
         *
         * @returns {boolean}
         */
        function isLastStep()
        {
            return vm.selectedIndex === totalSteps() - 1;
        }

        /**
         * Is current step invalid?
         *
         * @returns {boolean}
         */
        function currentStepInvalid()
        {
            return angular.isDefined(vm.forms[vm.selectedIndex]) && vm.forms[vm.selectedIndex].$invalid;
        }

        /**
         * Is previous step invalid?
         *
         * @returns {boolean}
         */
        function previousStepInvalid()
        {
            return vm.selectedIndex > 0 && angular.isDefined(vm.forms[vm.selectedIndex - 1]) && vm.forms[vm.selectedIndex - 1].$invalid;
        }

        /**
         * Check if there is any incomplete forms
         *
         * @returns {boolean}
         */
        function formsIncomplete()
        {
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                if ( vm.forms[x].$invalid )
                {
                    return true;
                }
            }

            return false;
        }

        /**
         * Reset form
         */
        function resetForm()
        {
            // Go back to the first step
            vm.selectedIndex = 0;

            // Make sure all the forms are back in the $pristine & $untouched status
            for ( var x = 0; x < vm.forms.length; x++ )
            {
                vm.forms[x].$setPristine();
                vm.forms[x].$setUntouched();
            }
        }
    }

    /** @ngInject */
    function msFormWizardDirective()
    {
        return {
            restrict  : 'E',
            scope     : true,
            controller: 'MsFormWizardController as msWizard',
            compile   : function (tElement)
            {
                tElement.addClass('ms-form-wizard');

                return function postLink()
                {

                };
            }
        };
    }

    /** @ngInject */
    function msFormWizardFormDirective()
    {
        return {
            restrict: 'A',
            require : ['form', '^msFormWizard'],
            compile : function (tElement)
            {
                tElement.addClass('ms-form-wizard-form');

                return function postLink(scope, iElement, iAttrs, ctrls)
                {
                    var formCtrl = ctrls[0],
                        MsFormWizardCtrl = ctrls[1];

                    MsFormWizardCtrl.registerForm(formCtrl);
                };
            }
        };
    }

})();
(function() {
    'use strict';

    angular
        .module('app.permission', [
            'permission', 'permission.ui'
        ]).config(config);
    function config(msNavigationServiceProvider, msApiProvider)
    {
        // Navigation
        // msNavigationServiceProvider.saveItem('pages', {
        //     title : 'PAGES',
        //     group : true,
        //     weight: 2
        // });
        msApiProvider.register('permission.permissions', [msApiProvider.getApiUrl() + 'users']);
        msApiProvider.register('permission.userauth', [msApiProvider.getApiUrl() + 'users']);
    }
})();

(function() {
    'use strict';

    angular
        .module('app.permission')
        .factory('UserService', UserService);

    /* @ngInject */
    function UserService($q, $http, $cookies, PermRoleStore) {
        var currentUser = {
            displayName: 'Anonymous',
            username: 'anonymous',
            avatar: 'assets/images/avatars/avatar-5.png',
            roles: ['ANONYMOUS']
        };

        var service = {
            /*getCurrentUser: getCurrentUser,
             getUsers: getUsers,*/
            hasPermission: hasPermission,
            /*login: login,
             loginWithPassword: loginWithPassword,
             logout:logout,*/
            loginWith:loginWith
        };

        return service;

        ///////////////

        /*function getCurrentUser() {
         return currentUser;
         }

         function getUsers() {
         return $http.get('app/permission/data/users.json');
         }*/

        function hasPermission(permission, role_permissions) {
            var deferred = $q.defer();
            var hasPermission = false;
            // check if user has permission via its roles
            angular.forEach(currentUser.roles, function(role) {
                // check role exists
                if(PermRoleStore.hasRoleDefinition(role)) {
                    // get the role
                    //var roles = PermRoleStore.getStore();
                    var roles = role_permissions;
                    if(angular.isDefined(roles[role])) {
                        // check if the permission we are validating is in this role's permissions
                        //if(-1 !== roles[role].validationFunction.indexOf(permission)) {
                        if(-1 !== roles[role].indexOf(permission)) {
                            hasPermission = true;
                        }
                    }
                }
            });

            // if we have permission resolve otherwise reject the promise
            if(hasPermission) {
                deferred.resolve();
            }
            else {
                deferred.reject();
            }

            // return promise
            return deferred.promise;
        }

        /*function login(username) {
         // you would replace the code below with a call you your API
         // request all users
         return getUsers()
         .then(function successCallback(response) {
         var returnUser = getCurrentUser();
         angular.forEach(response.data, function(user) {
         if(user.username === username) {
         returnUser = user;
         currentUser = user;
         }
         });
         return returnUser;
         });
         }*/
        function logout(){
            $cookies.remove('tri-user');
            $cookies.remove('curr_user');
            $cookies.remove('curr_permissions');
            $cookies.remove('curr_roles');
            currentUser = {
                displayName: '',
                username: '',
                avatar: '',
                roles: ['']
            };
        }
        /*function loginWithPassword(username,password) {
         // you would replace the code below with a call you your API
         // request all users
         return getUsers()
         .then(function successCallback(response) {
         var returnUser = getCurrentUser();
         angular.forEach(response.data, function(user) {
         if(user.username === username && password ==='111111') {
         returnUser = user;
         currentUser = user;
         }
         });
         return returnUser;
         });
         }*/
        function loginWith(user){
            currentUser = user;
            return user;
        }
    }
})();

(function() {
    'use strict';

    angular
        .module('app.permission')
        .run(permissionRun);

    /*@ngInject*/
    function permissionRun($rootScope, $cookies, $state,PermPermissionStore, PermRoleStore, UserService, msApi) {
        // normally this would be done at the login page but to show quick
        // demo we grab username from cookie and login the user
        var curr_user = $cookies.getObject('curr_user');
        var curr_roles = $cookies.getObject('curr_roles');
        var curr_permissions = $cookies.getObject('curr_permissions');
        var cookieUser = $cookies.getObject('tri_user');

        if(angular.isDefined(cookieUser)) {
            cookieUser.user = curr_user;
            cookieUser.permissions = curr_permissions;
            cookieUser.roles = curr_roles;
            cookieUser.store_id = $cookies.get('store_id');
            cookieUser.store_name = $cookies.get('store_name');
            cookieUser.role_id =$cookies.get('role_id');
            cookieUser.auth_key =$cookies.get('auth_key');
            UserService.loginWith(cookieUser);
        }

        var permissions = ["admin_contract",
            "admin_contract_cud",
            "admin_contract_export",
            "admin_contract_list",
            "admin_contract_signup",
            "admin_contract_signup_allow",
            "admin_courses",
            "admin_courses_categories",
            "admin_courses_categories_cud",
            "admin_courses_categories_list",
            "admin_courses_cud",
            "admin_courses_list",
            "admin_customer",
            "admin_customer_contract",
            "admin_customer_cud",
            "admin_customer_list",
            "admin_dashboard",
            "admin_dashboard_amount",
            "admin_dashboard_birthday_baby",
            "admin_dashboard_course",
            "admin_dashboard_expire_member",
            "admin_dashboard_new_member",
            "admin_dashboard_task_user",
            "admin_dashboard_xiaoke",
            "admin_parent",
            "admin_parent_cud",
            "admin_parent_list",
            "admin_qingjia",
            "admin_qingjia_cud",
            "admin_qingjia_list",
            "admin_report",
            "admin_report_amount_export",
            "admin_report_amount_list",
            "admin_report_income_cud",
            "admin_report_income_export",
            "admin_report_income_list",
            "admin_report_pay_cud",
            "admin_report_pay_export",
            "admin_report_pay_list",
            "admin_report_signup_export",
            "admin_report_signup_list",
            "admin_report_teacher_export",
            "admin_report_teacher_list",
            "admin_report_xiaoke_export",
            "admin_signup",
            "admin_signup_cud",
            "admin_signup_list",
            "admin_store",
            "admin_store_cud",
            "admin_store_list",
            "admin_system",
            "admin_system_categories",
            "admin_system_categories_cud",
            "admin_system_categories_list",
            "admin_system_logs",
            "admin_system_set",
            "admin_task",
            "admin_task_cud",
            "admin_task_export",
            "admin_task_list",
            "admin_teacher",
            "admin_teacher_cud",
            "admin_teacher_list",
            "admin_use_cud",
            "admin_user",
            "admin_user_list"];//["admin_contracts","admin_courses","admin_customers","admin_reports","admin_signups","admin_system","admin_teachers","admin_users"];
        var role_permissions = {"admin_root":[
            "admin_contract",
            "admin_contract_signup_allow",
            "admin_courses",
            "admin_customer",
            "admin_dashboard",
            "admin_parent",
            "admin_report",
            "admin_signup",
            "admin_store",
            "admin_system",
            "admin_system_logs",
            "admin_task",
            "admin_teacher",
            "admin_user"
        ],
            "course_guwen":[
                "admin_contract_list",
                "admin_courses_categories_list",
                "admin_courses_list",
                "admin_dashboard_course",
                "admin_dashboard_task_user",
                "admin_parent_list",
                "admin_system_categories_list",
                "admin_system_logs",
                "admin_task_list",
                "admin_teacher_list"
            ],
            "course_manager":[
                "admin_courses",
                "admin_dashboard_course",
                "admin_dashboard_task_user",
                "admin_signup_list",
                "admin_system_logs",
                "admin_teacher_list"
            ],
            "paike_manager":[
                "admin_courses",
                "admin_dashboard_course",
                "admin_dashboard_task_user",
                "admin_signup_list",
                "admin_system_logs",
                "admin_teacher_list"
            ],
            "qiantai":[
                "admin_contract",
                "admin_contract_cud",
                "admin_contract_list",
                "admin_contract_signup",
                "admin_contract_signup_allow",
                "admin_courses",
                "admin_courses_categories",
                "admin_courses_categories_cud",
                "admin_courses_categories_list",
                "admin_courses_cud",
                "admin_courses_list",
                "admin_customer",
                "admin_customer_contract",
                "admin_customer_cud",
                "admin_customer_list",
                "admin_dashboard",
                "admin_dashboard_amount",
                "admin_dashboard_birthday_baby",
                "admin_dashboard_course",
                "admin_dashboard_expire_member",
                "admin_dashboard_task_user",
                "admin_dashboard_xiaoke",
                "admin_parent",
                "admin_parent_cud",
                "admin_parent_list",
                "admin_qingjia",
                "admin_qingjia_cud",
                "admin_qingjia_list",
                "admin_report",
                "admin_report_amount_export",
                "admin_report_amount_list",
                "admin_report_income_cud",
                "admin_report_income_export",
                "admin_report_income_list",
                "admin_signup",
                "admin_system_categories_list",
                "admin_system_logs",
                "admin_task",
                "admin_teacher_list",
                "admin_user_list"
            ],
            "store_manager":[
                "admin_contract",
                "admin_contract_cud",
                "admin_contract_export",
                "admin_contract_list",
                "admin_contract_signup",
                "admin_contract_signup_allow",
                "admin_courses",
                "admin_courses_categories",
                "admin_courses_categories_cud",
                "admin_courses_categories_list",
                "admin_courses_cud",
                "admin_courses_list",
                "admin_customer",
                "admin_customer_contract",
                "admin_customer_cud",
                "admin_customer_list",
                "admin_dashboard",
                "admin_dashboard_amount",
                "admin_dashboard_birthday_baby",
                "admin_dashboard_course",
                "admin_dashboard_expire_member",
                "admin_dashboard_new_member",
                "admin_dashboard_task_user",
                "admin_dashboard_xiaoke",
                "admin_parent",
                "admin_qingjia_list",
                "admin_report",
                "admin_signup_list",
                "admin_store_list",
                "admin_system",
                "admin_task_export",
                "admin_task_list",
                "admin_teacher",
                "admin_user"
            ],
            "super_manager":[
                "admin_contract",
                "admin_courses",
                "admin_customer",
                "admin_dashboard",
                "admin_parent",
                "admin_qingjia_list",
                "admin_report",
                "admin_signup",
                "admin_store",
                "admin_system",
                "admin_task",
                "admin_teacher",
                "admin_user"
            ],
            "teacher":[
                "admin_contract",
                "admin_courses_categories_list",
                "admin_courses_list",
                "admin_customer_list",
                "admin_dashboard_birthday_baby",
                "admin_dashboard_course",
                "admin_dashboard_expire_member",
                "admin_dashboard_task_user",
                "admin_parent_list",
                "admin_qingjia_list",
                "admin_report_teacher_list",
                "admin_signup_list",
                "admin_store_list",
                "admin_system_categories_list",
                "admin_system_logs",
                "admin_task_list",
                "admin_teacher_list",
                "admin_user_list"
            ],
            "zhujiao":[
                "admin_courses_categories_list",
                "admin_courses_list",
                "admin_customer_list",
                "admin_dashboard_birthday_baby",
                "admin_dashboard_course",
                "admin_dashboard_expire_member",
                "admin_dashboard_task_user",
                "admin_parent_list",
                "admin_qingjia_list",
                "admin_report_teacher_list",
                "admin_signup_list",
                "admin_store_list",
                "admin_system_categories_list",
                "admin_system_logs",
                "admin_task_list",
                "admin_teacher_list",
                "admin_user_list"
            ]};/*{
            'course_guwen':[],
            'qiantai':['admin_contracts','admin_courses'],
            'admin_root':['admin_contracts','admin_courses'],
            'storemanager':['admin_contracts','admin_courses'],
            'teacher':['admin_contracts','admin_courses'],
            'super_manager' : [],
            'zhujiao11':[]};*/
        if($cookies.getObject('permissions')){
            permissions = $cookies.getObject('permissions');
        }
        if($cookies.getObject('role_permissions')){
            role_permissions = $cookies.getObject('role_permissions');
            setPermission(permissions, role_permissions);
        }

        if(role_permissions){
            setPermission(permissions, role_permissions);
        }
        //获取所有权限
        msApi.request("permission.permissions@get", {'act':'permissions'}).then(
            // Success
            function (response) {
                permissions = response.data.permissions;
                role_permissions = response.data.role_permissions;
                //$cookies.putObject('permissions', permissions);
                //$cookies.putObject('role_permissions', role_permissions);
                setPermission(permissions, role_permissions);
            }
        );
        //获取用户最新权限
        if(angular.isDefined(cookieUser)) {
            msApi.request("permission.userauth@get", {'act': 'userauth', 'uid': cookieUser.user.id}).then(
                function (response) {
                    cookieUser.permissions = response.data.permissions;
                    cookieUser.roles = response.data.roles;
                    $cookies.putObject('curr_permissions', cookieUser.permissions);
                    $cookies.putObject('curr_roles', cookieUser.roles);
                }
            );
        }
        // create permissions and add check function verify all permissions


        function setPermission(permissions, role_permissions){
            PermPermissionStore.defineManyPermissions(permissions, function (permissionName) {
                return UserService.hasPermission(permissionName,role_permissions);
            });
            // create roles for app
            PermRoleStore.defineManyRoles(role_permissions);
        }

        ///////////////////////

        // default redirect if access is denied
        function accessDenied() {
            $state.go('app.pages_errors_error-401');
        }

        // watches

        // redirect all denied permissions to 401
        var deniedHandle = $rootScope.$on('$stateChangePermissionDenied', accessDenied);

        // remove watch on destroy
        $rootScope.$on('$destroy', function() {
            deniedHandle();
        });
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .controller('MsThemeOptionsController', MsThemeOptionsController)
        .directive('msThemeOptions', msThemeOptions);

    /** @ngInject */
    function MsThemeOptionsController($cookies, fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        vm.layoutModes = [
            {
                label: 'Boxed',
                value: 'boxed'
            },
            {
                label: 'Wide',
                value: 'wide'
            }
        ];
        vm.layoutStyles = [
            {
                label : 'Vertical Navigation',
                value : 'verticalNavigation',
                figure: '/assets/images/theme-options/vertical-nav.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar',
                value : 'verticalNavigationFullwidthToolbar',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar.jpg'
            },
            {
                label : 'Vertical Navigation with Fullwidth Toolbar 2',
                value : 'verticalNavigationFullwidthToolbar2',
                figure: '/assets/images/theme-options/vertical-nav-with-full-toolbar-2.jpg'
            },
            {
                label : 'Horizontal Navigation',
                value : 'horizontalNavigation',
                figure: '/assets/images/theme-options/horizontal-nav.jpg'
            },
            {
                label : 'Content with Toolbar',
                value : 'contentWithToolbar',
                figure: '/assets/images/theme-options/content-with-toolbar.jpg'
            },
            {
                label : 'Content Only',
                value : 'contentOnly',
                figure: '/assets/images/theme-options/content-only.jpg'
            },
        ];

        vm.layoutMode = 'wide';
        vm.layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        // Methods
        vm.setActiveTheme = setActiveTheme;
        vm.getActiveTheme = getActiveTheme;
        vm.updateLayoutMode = updateLayoutMode;
        vm.updateLayoutStyle = updateLayoutStyle;

        //////////

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            fuseTheming.setActiveTheme(themeName);
        }

        /**
         * Get active theme
         *
         * @returns {service.themes.active|{name, theme}}
         */
        function getActiveTheme()
        {
            return fuseTheming.themes.active;
        }

        /**
         * Update layout mode
         */
        function updateLayoutMode()
        {
            var bodyEl = angular.element('body');

            // Update class on body element
            bodyEl.toggleClass('boxed', (vm.layoutMode === 'boxed'));
        }

        /**
         * Update layout style
         */
        function updateLayoutStyle()
        {
            // Update the cookie
            $cookies.put('layoutStyle', vm.layoutStyle);

            // Reload the page to apply the changes
            location.reload();
        }
    }

    /** @ngInject */
    function msThemeOptions($mdSidenav)
    {
        return {
            restrict   : 'E',
            scope      : {},
            controller : 'MsThemeOptionsController as vm',
            templateUrl: 'app/core/theme-options/theme-options.html',
            compile    : function (tElement)
            {
                tElement.addClass('ms-theme-options');

                return function postLink(scope)
                {
                    /**
                     * Toggle options sidenav
                     */
                    function toggleOptionsSidenav()
                    {
                        // Toggle the fuse theme options panel
                        $mdSidenav('fuse-theme-options').toggle();
                    }

                    // Expose the toggle function
                    scope.toggleOptionsSidenav = toggleOptionsSidenav;
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .service('fuseTheming', fuseThemingService);

    /** @ngInject */
    function fuseThemingService($cookies, $log, $mdTheming)
    {
        var service = {
            getRegisteredPalettes: getRegisteredPalettes,
            getRegisteredThemes  : getRegisteredThemes,
            setActiveTheme       : setActiveTheme,
            setThemesList        : setThemesList,
            themes               : {
                list  : {},
                active: {
                    'name' : '',
                    'theme': {}
                }
            }
        };

        return service;

        //////////

        /**
         * Get registered palettes
         *
         * @returns {*}
         */
        function getRegisteredPalettes()
        {
            return $mdTheming.PALETTES;
        }

        /**
         * Get registered themes
         *
         * @returns {*}
         */
        function getRegisteredThemes()
        {
            return $mdTheming.THEMES;
        }

        /**
         * Set active theme
         *
         * @param themeName
         */
        function setActiveTheme(themeName)
        {
            // If theme does not exist, fallback to the default theme
            if ( angular.isUndefined(service.themes.list[themeName]) )
            {
                // If there is no theme called "default"...
                if ( angular.isUndefined(service.themes.list.default) )
                {
                    $log.error('You must have at least one theme named "default"');
                    return;
                }

                $log.warn('The theme "' + themeName + '" does not exist! Falling back to the "default" theme.');

                // Otherwise set theme to default theme
                service.themes.active.name = 'default';
                service.themes.active.theme = service.themes.list.default;
                $cookies.put('selectedTheme', service.themes.active.name);

                return;
            }

            service.themes.active.name = themeName;
            service.themes.active.theme = service.themes.list[themeName];
            $cookies.put('selectedTheme', themeName);
        }

        /**
         * Set available themes list
         *
         * @param themeList
         */
        function setThemesList(themeList)
        {
            service.themes.list = themeList;
        }
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($mdThemingProvider, fusePalettes, fuseThemes)
    {
        // Inject Cookies Service
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);

        // Check if custom theme exist in cookies
        var customTheme = $cookies.getObject('customTheme');
        if ( customTheme )
        {
            fuseThemes['custom'] = customTheme;
        }

        $mdThemingProvider.alwaysWatchTheme(true);

        // Define custom palettes
        angular.forEach(fusePalettes, function (palette)
        {
            $mdThemingProvider.definePalette(palette.name, palette.options);
        });

        // Register custom themes
        angular.forEach(fuseThemes, function (theme, themeName)
        {
            $mdThemingProvider.theme(themeName)
                .primaryPalette(theme.primary.name, theme.primary.hues)
                .accentPalette(theme.accent.name, theme.accent.hues)
                .warnPalette(theme.warn.name, theme.warn.hues)
                .backgroundPalette(theme.background.name, theme.background.hues);
        });
    }

})();
(function ()
{
    'use strict';

    var fuseThemes = {
        default  : {
            primary   : {
                name: 'fuse-paleblue',
                hues: {
                    'default': '700',
                    'hue-1'  : '500',
                    'hue-2'  : '600',
                    'hue-3'  : '400'
                }
            },
            accent    : {
                name: 'light-blue',
                hues: {
                    'default': '600',
                    'hue-1'  : '400',
                    'hue-2'  : '700',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'red'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'pinkTheme': {
            primary   : {
                name: 'blue-grey',
                hues: {
                    'default': '800',
                    'hue-1'  : '600',
                    'hue-2'  : '400',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'pink',
                hues: {
                    'default': '400',
                    'hue-1'  : '300',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'blue'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        },
        'tealTheme': {
            primary   : {
                name: 'fuse-blue',
                hues: {
                    'default': '900',
                    'hue-1'  : '600',
                    'hue-2'  : '500',
                    'hue-3'  : 'A100'
                }
            },
            accent    : {
                name: 'teal',
                hues: {
                    'default': '500',
                    'hue-1'  : '400',
                    'hue-2'  : '600',
                    'hue-3'  : 'A100'
                }
            },
            warn      : {
                name: 'deep-orange'
            },
            background: {
                name: 'grey',
                hues: {
                    'default': 'A100',
                    'hue-1'  : 'A100',
                    'hue-2'  : '100',
                    'hue-3'  : '300'
                }
            }
        }
    };

    angular
        .module('app.core')
        .constant('fuseThemes', fuseThemes);
})();
(function () {
    'use strict';

    var fusePalettes = [
        {
            name: 'fuse-blue',
            options: {
                '50': '#ebf1fa',
                '100': '#c2d4ef',
                '200': '#9ab8e5',
                '300': '#78a0dc',
                '400': '#5688d3',
                '500': '#3470ca',
                '600': '#2e62b1',
                '700': '#275498',
                '800': '#21467e',
                '900': '#1a3865',
                'A100': '#c2d4ef',
                'A200': '#9ab8e5',
                'A400': '#5688d3',
                'A700': '#275498',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        },
        {
            name: 'fuse-paleblue',
            options: {
                '50': '#ececee',
                '100': '#c5c6cb',
                '200': '#9ea1a9',
                '300': '#7d818c',
                '400': '#5c616f',
                '500': '#3c4252',
                '600': '#353a48',
                '700': '#2d323e',
                '800': '#262933',
                '900': '#1e2129',
                'A100': '#c5c6cb',
                'A200': '#9ea1a9',
                'A400': '#5c616f',
                'A700': '#2d323e',
                'contrastDefaultColor': 'light',
                'contrastDarkColors': '50 100 200 A100',
                'contrastStrongLightColors': '300 400'
            }
        }
    ];

    angular
        .module('app.core')
        .constant('fusePalettes', fusePalettes);
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('fuseGenerator', fuseGeneratorService);

    /** @ngInject */
    function fuseGeneratorService($cookies, $log, fuseTheming)
    {
        // Storage for simplified themes object
        var themes = {};

        var service = {
            generate: generate,
            rgba    : rgba
        };

        return service;

        //////////

        /**
         * Generate less variables for each theme from theme's
         * palette by using material color naming conventions
         */
        function generate()
        {
            // Get registered themes and palettes and copy
            // them so we don't modify the original objects
            var registeredThemes = angular.copy(fuseTheming.getRegisteredThemes());
            var registeredPalettes = angular.copy(fuseTheming.getRegisteredPalettes());

            // First, create a simplified object that stores
            // all registered themes and their colors

            // Iterate through registered themes
            angular.forEach(registeredThemes, function (registeredTheme)
            {
                themes[registeredTheme.name] = {};

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(registeredTheme.colors, function (colorType, colorTypeName)
                {
                    themes[registeredTheme.name][colorTypeName] = {
                        'name'  : colorType.name,
                        'levels': {
                            'default': {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues.default].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues.default].contrast, 4)
                            },
                            'hue1'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-1']].contrast, 4)
                            },
                            'hue2'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-2']].contrast, 4)
                            },
                            'hue3'   : {
                                'color'    : rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].value),
                                'contrast1': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 1),
                                'contrast2': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 2),
                                'contrast3': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 3),
                                'contrast4': rgba(registeredPalettes[colorType.name][colorType.hues['hue-3']].contrast, 4)
                            }
                        }
                    };
                });
            });

            // Process themes one more time and then store them in the service for external use
            processAndStoreThemes(themes);

            // Iterate through simplified themes
            // object and create style variables
            var styleVars = {};

            // Iterate through registered themes
            angular.forEach(themes, function (theme, themeName)
            {
                styleVars = {};
                styleVars['@themeName'] = themeName;

                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorTypes, colorTypeName)
                {
                    // Iterate through color levels (default, hue1, hue2 & hue3)
                    angular.forEach(colorTypes.levels, function (colors, colorLevelName)
                    {
                        // Iterate through color name (color, contrast1, contrast2, contrast3 & contrast4)
                        angular.forEach(colors, function (color, colorName)
                        {
                            styleVars['@' + colorTypeName + ucfirst(colorLevelName) + ucfirst(colorName)] = color;
                        });
                    });
                });

                // Render styles
                render(styleVars);
            });
        }

        // ---------------------------
        //  INTERNAL HELPER FUNCTIONS
        // ---------------------------

        /**
         * Process and store themes for global use
         *
         * @param _themes
         */
        function processAndStoreThemes(_themes)
        {
            // Here we will go through every registered theme one more time
            // and try to simplify their objects as much as possible for
            // easier access to their properties.
            var themes = angular.copy(_themes);

            // Iterate through themes
            angular.forEach(themes, function (theme)
            {
                // Iterate through color types (primary, accent, warn & background)
                angular.forEach(theme, function (colorType, colorTypeName)
                {
                    theme[colorTypeName] = colorType.levels;
                    theme[colorTypeName].color = colorType.levels.default.color;
                    theme[colorTypeName].contrast1 = colorType.levels.default.contrast1;
                    theme[colorTypeName].contrast2 = colorType.levels.default.contrast2;
                    theme[colorTypeName].contrast3 = colorType.levels.default.contrast3;
                    theme[colorTypeName].contrast4 = colorType.levels.default.contrast4;
                    delete theme[colorTypeName].default;
                });
            });

            // Store themes and set selected theme for the first time
            fuseTheming.setThemesList(themes);

            // Remember selected theme.
            var selectedTheme = $cookies.get('selectedTheme');

            if ( selectedTheme )
            {
                fuseTheming.setActiveTheme(selectedTheme);
            }
            else
            {
                fuseTheming.setActiveTheme('default');
            }
        }


        /**
         * Render css files
         *
         * @param styleVars
         */
        function render(styleVars)
        {
            var cssTemplate = '/* Content hack because they wont fix */\n/* https://github.com/angular/material/pull/8067 */\n[md-theme="@themeName"] md-content.md-hue-1,\nmd-content.md-@themeName-theme.md-hue-1 {\n    color: @backgroundHue1Contrast1;\n    background-color: @backgroundHue1Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-2,\nmd-content.md-@themeName-theme.md-hue-2 {\n    color: @backgroundHue2Contrast1;\n    background-color: @backgroundHue2Color;\n}\n\n[md-theme="@themeName"] md-content.md-hue-3,\n md-content.md-@themeName-theme.md-hue-3 {\n    color: @backgroundHue3Contrast1;\n    background-color: @backgroundHue3Color;\n}\n\n/* Text Colors */\n[md-theme="@themeName"] a {\n    color: @accentDefaultColor;\n}\n\n[md-theme="@themeName"] .secondary-text,\n[md-theme="@themeName"] .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .hint-text,\n[md-theme="@themeName"] .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .fade-text,\n[md-theme="@themeName"] .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Primary */\n[md-theme="@themeName"] .md-primary-bg {\n    background-color: @primaryDefaultColor;\n    color: @primaryDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg .secondary-text,\n[md-theme="@themeName"] .md-primary-bg .icon {\n    color: @primaryDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg .hint-text,\n[md-theme="@themeName"] .md-primary-bg .disabled-text {\n    color: @primaryDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg .fade-text,\n[md-theme="@themeName"] .md-primary-bg .divider {\n    color: @primaryDefaultContrast4;\n}\n\n/* Primary, Hue-1 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 {\n    background-color: @primaryHue1Color;\n    color: @primaryHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .icon {\n    color: @primaryHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .disabled-text {\n    color: @primaryHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-1 .divider {\n    color: @primaryHue1Contrast4;\n}\n\n/* Primary, Hue-2 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 {\n    background-color: @primaryHue2Color;\n    color: @primaryHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .icon {\n    color: @primaryHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .disabled-text {\n    color: @primaryHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-2 .divider {\n    color: @primaryHue2Contrast4;\n}\n\n/* Primary, Hue-3 */\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 {\n    background-color: @primaryHue3Color;\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .icon {\n    color: @primaryHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .disabled-text {\n    color: @primaryHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-primary-bg.md-hue-3 .divider {\n    color: @primaryHue3Contrast4;\n}\n\n/* Primary foreground */\n[md-theme="@themeName"] .md-primary-fg {\n    color: @primaryDefaultColor !important;\n}\n\n/* Primary foreground, Hue-1 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-1 {\n    color: @primaryHue1Color !important;\n}\n\n/* Primary foreground, Hue-2 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-2 {\n    color: @primaryHue2Color !important;\n}\n\n/* Primary foreground, Hue-3 */\n[md-theme="@themeName"] .md-primary-fg.md-hue-3 {\n    color: @primaryHue3Color !important;\n}\n\n/* Accent */\n[md-theme="@themeName"] .md-accent-bg {\n    background-color: @accentDefaultColor;\n    color: @accentDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg .secondary-text,\n[md-theme="@themeName"] .md-accent-bg .icon {\n    color: @accentDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg .hint-text,\n[md-theme="@themeName"] .md-accent-bg .disabled-text {\n    color: @accentDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg .fade-text,\n[md-theme="@themeName"] .md-accent-bg .divider {\n    color: @accentDefaultContrast4;\n}\n\n/* Accent, Hue-1 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 {\n    background-color: @accentHue1Color;\n    color: @accentHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .icon {\n    color: @accentHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .disabled-text {\n    color: @accentHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-1 .divider {\n    color: @accentHue1Contrast4;\n}\n\n/* Accent, Hue-2 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 {\n    background-color: @accentHue2Color;\n    color: @accentHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .icon {\n    color: @accentHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .disabled-text {\n    color: @accentHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-2 .divider {\n    color: @accentHue2Contrast4;\n}\n\n/* Accent, Hue-3 */\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 {\n    background-color: @accentHue3Color;\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .icon {\n    color: @accentHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .disabled-text {\n    color: @accentHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-accent-bg.md-hue-3 .divider {\n    color: @accentHue3Contrast4;\n}\n\n/* Accent foreground */\n[md-theme="@themeName"] .md-accent-fg {\n    color: @accentDefaultColor !important;\n}\n\n/* Accent foreground, Hue-1 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-1 {\n    color: @accentHue1Color !important;\n}\n\n/* Accent foreground, Hue-2 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-2 {\n    color: @accentHue2Color !important;\n}\n\n/* Accent foreground, Hue-3 */\n[md-theme="@themeName"] .md-accent-fg.md-hue-3 {\n    color: @accentHue3Color !important;\n}\n\n/* Warn */\n[md-theme="@themeName"] .md-warn-bg {\n    background-color: @warnDefaultColor;\n    color: @warnDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg .secondary-text,\n[md-theme="@themeName"] .md-warn-bg .icon {\n    color: @warnDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg .hint-text,\n[md-theme="@themeName"] .md-warn-bg .disabled-text {\n    color: @warnDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg .fade-text,\n[md-theme="@themeName"] .md-warn-bg .divider {\n    color: @warnDefaultContrast4;\n}\n\n/* Warn, Hue-1 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 {\n    background-color: @warnHue1Color;\n    color: @warnHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .icon {\n    color: @warnHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .disabled-text {\n    color: @warnHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-1 .divider {\n    color: @warnHue1Contrast4;\n}\n\n/* Warn, Hue-2 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 {\n    background-color: @warnHue2Color;\n    color: @warnHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .icon {\n    color: @warnHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .disabled-text {\n    color: @warnHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-2 .divider {\n    color: @warnHue2Contrast4;\n}\n\n/* Warn, Hue-3 */\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 {\n    background-color: @warnHue3Color;\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .icon {\n    color: @warnHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .disabled-text {\n    color: @warnHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-warn-bg.md-hue-3 .divider {\n    color: @warnHue3Contrast4;\n}\n\n/* Warn foreground */\n[md-theme="@themeName"] .md-warn-fg {\n    color: @warnDefaultColor !important;\n}\n\n/* Warn foreground, Hue-1 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-1 {\n    color: @warnHue1Color !important;\n}\n\n/* Warn foreground, Hue-2 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-2 {\n    color: @warnHue2Color !important;\n}\n\n/* Warn foreground, Hue-3 */\n[md-theme="@themeName"] .md-warn-fg.md-hue-3 {\n    color: @warnHue3Color !important;\n}\n\n/* Background */\n[md-theme="@themeName"] .md-background-bg {\n    background-color: @backgroundDefaultColor;\n    color: @backgroundDefaultContrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg .secondary-text,\n[md-theme="@themeName"] .md-background-bg .icon {\n    color: @backgroundDefaultContrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg .hint-text,\n[md-theme="@themeName"] .md-background-bg .disabled-text {\n    color: @backgroundDefaultContrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg .fade-text,\n[md-theme="@themeName"] .md-background-bg .divider {\n    color: @backgroundDefaultContrast4;\n}\n\n/* Background, Hue-1 */\n[md-theme="@themeName"] .md-background-bg.md-hue-1 {\n    background-color: @backgroundHue1Color;\n    color: @backgroundHue1Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .icon {\n    color: @backgroundHue1Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .disabled-text {\n    color: @backgroundHue1Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-1 .divider {\n    color: @backgroundHue1Contrast4;\n}\n\n/* Background, Hue-2 */\n[md-theme="@themeName"] .md-background-bg.md-hue-2 {\n    background-color: @backgroundHue2Color;\n    color: @backgroundHue2Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .icon {\n    color: @backgroundHue2Contrast2;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .disabled-text {\n    color: @backgroundHue2Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-2 .divider {\n    color: @backgroundHue2Contrast4;\n}\n\n/* Background, Hue-3 */\n[md-theme="@themeName"] .md-background-bg.md-hue-3 {\n    background-color: @backgroundHue3Color;\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .secondary-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .icon {\n    color: @backgroundHue3Contrast1;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .hint-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .disabled-text {\n    color: @backgroundHue3Contrast3;\n}\n\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .fade-text,\n[md-theme="@themeName"] .md-background-bg.md-hue-3 .divider {\n    color: @backgroundHue3Contrast4;\n}\n\n/* Background foreground */\n[md-theme="@themeName"] .md-background-fg {\n    color: @backgroundDefaultColor !important;\n}\n\n/* Background foreground, Hue-1 */\n[md-theme="@themeName"] .md-background-fg.md-hue-1 {\n    color: @backgroundHue1Color !important;\n}\n\n/* Background foreground, Hue-2 */\n[md-theme="@themeName"] .md-background-fg.md-hue-2 {\n    color: @backgroundHue2Color !important;\n}\n\n/* Background foreground, Hue-3 */\n[md-theme="@themeName"] .md-background-fg.md-hue-3 {\n    color: @backgroundHue3Color !important;\n}';

            var regex = new RegExp(Object.keys(styleVars).join('|'), 'gi');
            var css = cssTemplate.replace(regex, function (matched)
            {
                return styleVars[matched];
            });

            var headEl = angular.element('head');
            var styleEl = angular.element('<style type="text/css"></style>');
            styleEl.html(css);
            headEl.append(styleEl);
        }

        /**
         * Convert color array to rgb/rgba
         * Also apply contrasts if needed
         *
         * @param color
         * @param _contrastLevel
         * @returns {string}
         */
        function rgba(color, _contrastLevel)
        {
            var contrastLevel = _contrastLevel || false;

            // Convert 255,255,255,0.XX to 255,255,255
            // According to Google's Material design specs, white primary
            // text must have opacity of 1 and we will fix that here
            // because Angular Material doesn't care about that spec
            if ( color.length === 4 && color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color.splice(3, 4);
            }

            // If contrast level provided, apply it to the current color
            if ( contrastLevel )
            {
                color = applyContrast(color, contrastLevel);
            }

            // Convert color array to color string (rgb/rgba)
            if ( color.length === 3 )
            {
                return 'rgb(' + color.join(',') + ')';
            }
            else if ( color.length === 4 )
            {
                return 'rgba(' + color.join(',') + ')';
            }
            else
            {
                $log.error('Invalid number of arguments supplied in the color array: ' + color.length + '\n' + 'The array must have 3 or 4 colors.');
            }
        }

        /**
         * Apply given contrast level to the given color
         *
         * @param color
         * @param contrastLevel
         */
        function applyContrast(color, contrastLevel)
        {
            var contrastLevels = {
                'white': {
                    '1': '1',
                    '2': '0.7',
                    '3': '0.3',
                    '4': '0.12'
                },
                'black': {
                    '1': '0.87',
                    '2': '0.54',
                    '3': '0.26',
                    '4': '0.12'
                }
            };

            // If white
            if ( color[0] === 255 && color[1] === 255 && color[2] === 255 )
            {
                color[3] = contrastLevels.white[contrastLevel];
            }
            // If black
            else if ( color[0] === 0 && color[1] === 0 && color[2] === 0 )
            {
                color[3] = contrastLevels.black[contrastLevel];
            }

            return color;
        }

        /**
         * Uppercase first
         */
        function ucfirst(string)
        {
            return string.charAt(0).toUpperCase() + string.slice(1);
        }
    }

})();
/**
 * Created By Joe
 */
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('globalSettings', settingsService);

    /** @ngInject */
    function settingsService()
    {
        var settings = {
            logoSmall:'K',
            appName:'K12Plus'
        };

        return settings;
    }

})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('msUtils', msUtils);

    /** @ngInject */
    function msUtils($window)
    {
        // Private variables
        var mobileDetect = new MobileDetect($window.navigator.userAgent),
            browserInfo = null;

        var service = {
            exists       : exists,
            detectBrowser: detectBrowser,
            guidGenerator: guidGenerator,
            isMobile     : isMobile,
            toggleInArray: toggleInArray
        };

        return service;

        //////////

        /**
         * Check if item exists in a list
         *
         * @param item
         * @param list
         * @returns {boolean}
         */
        function exists(item, list)
        {
            return list.indexOf(item) > -1;
        }

        /**
         * Returns browser information
         * from user agent data
         *
         * Found at http://www.quirksmode.org/js/detect.html
         * but modified and updated to fit for our needs
         */
        function detectBrowser()
        {
            // If we already tested, do not test again
            if ( browserInfo )
            {
                return browserInfo;
            }

            var browserData = [
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Edge',
                    versionSearch: 'Edge',
                    identity     : 'Edge'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Chrome',
                    identity : 'Chrome'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'OmniWeb',
                    versionSearch: 'OmniWeb/',
                    identity     : 'OmniWeb'
                },
                {
                    string       : $window.navigator.vendor,
                    subString    : 'Apple',
                    versionSearch: 'Version',
                    identity     : 'Safari'
                },
                {
                    prop    : $window.opera,
                    identity: 'Opera'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'iCab',
                    identity : 'iCab'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'KDE',
                    identity : 'Konqueror'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Firefox',
                    identity : 'Firefox'
                },
                {
                    string   : $window.navigator.vendor,
                    subString: 'Camino',
                    identity : 'Camino'
                },
                {
                    string   : $window.navigator.userAgent,
                    subString: 'Netscape',
                    identity : 'Netscape'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'MSIE',
                    identity     : 'Explorer',
                    versionSearch: 'MSIE'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Trident/7',
                    identity     : 'Explorer',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Gecko',
                    identity     : 'Mozilla',
                    versionSearch: 'rv'
                },
                {
                    string       : $window.navigator.userAgent,
                    subString    : 'Mozilla',
                    identity     : 'Netscape',
                    versionSearch: 'Mozilla'
                }
            ];

            var osData = [
                {
                    string   : $window.navigator.platform,
                    subString: 'Win',
                    identity : 'Windows'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Mac',
                    identity : 'Mac'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Linux',
                    identity : 'Linux'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPhone',
                    identity : 'iPhone'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPod',
                    identity : 'iPod'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'iPad',
                    identity : 'iPad'
                },
                {
                    string   : $window.navigator.platform,
                    subString: 'Android',
                    identity : 'Android'
                }
            ];

            var versionSearchString = '';

            function searchString(data)
            {
                for ( var i = 0; i < data.length; i++ )
                {
                    var dataString = data[i].string;
                    var dataProp = data[i].prop;

                    versionSearchString = data[i].versionSearch || data[i].identity;

                    if ( dataString )
                    {
                        if ( dataString.indexOf(data[i].subString) !== -1 )
                        {
                            return data[i].identity;

                        }
                    }
                    else if ( dataProp )
                    {
                        return data[i].identity;
                    }
                }
            }

            function searchVersion(dataString)
            {
                var index = dataString.indexOf(versionSearchString);

                if ( index === -1 )
                {
                    return;
                }

                return parseInt(dataString.substring(index + versionSearchString.length + 1));
            }

            var browser = searchString(browserData) || 'unknown-browser';
            var version = searchVersion($window.navigator.userAgent) || searchVersion($window.navigator.appVersion) || 'unknown-version';
            var os = searchString(osData) || 'unknown-os';

            // Prepare and store the object
            browser = browser.toLowerCase();
            version = browser + '-' + version;
            os = os.toLowerCase();

            browserInfo = {
                browser: browser,
                version: version,
                os     : os
            };

            return browserInfo;
        }

        /**
         * Generates a globally unique id
         *
         * @returns {*}
         */
        function guidGenerator()
        {
            var S4 = function ()
            {
                return (((1 + Math.random()) * 0x10000) || 0).toString(16).substring(1);
            };
            return (S4() + S4() + S4() + S4() + S4() + S4());
        }

        /**
         * Return if current device is a
         * mobile device or not
         */
        function isMobile()
        {
            return mobileDetect.mobile();
        }

        /**
         * Toggle in array (push or splice)
         *
         * @param item
         * @param array
         */
        function toggleInArray(item, array)
        {
            if ( array.indexOf(item) === -1 )
            {
                array.push(item);
            }
            else
            {
                array.splice(array.indexOf(item), 1);
            }
        }
    }
}());
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('msApi', msApiProvider);

    /** @ngInject **/
    function msApiProvider()
    {
        /* ----------------- */
        /* Provider          */
        /* ----------------- */
        var provider = this;

        // Inject the $log service
        var $log = angular.injector(['ng']).get('$log');

        // Data
        var baseUrl = '';
        // opeasy code >>
        // var apiUrl = 'http://k12plus.local.com/api.php/rest/';
        //var apiUrl = 'http://devbaby.d.sysmart.cn/api.php/rest/';
        // var apiUrl = 'http://api.k12plus.opeasy.com/api.php/rest/';
        var apiUrl = 'http://api.k12plus.edulinx.cn/api.php/rest/';
        var errorUrl = 'app.pages_errors_error-401';
        // opeasy code <<
        var api = [];

        // Methods
        provider.setBaseUrl = setBaseUrl;
        provider.getBaseUrl = getBaseUrl;
        provider.getApiObject = getApiObject;
        provider.register = register;

        // opeasy code >>
        provider.setApiUrl = setApiUrl;
        provider.getApiUrl = getApiUrl;
        provider.getErrorUrl = getErrorUrl;
        provider.getCookies = getCookies;
        provider.getCookiesObj = getCookiesObj;
        function getCookies($key) {
            var $cookies;
            angular.injector(['ngCookies']).invoke(['$cookies', function(_$cookies_) {
                $cookies = _$cookies_;
            }]);
            return $cookies.get($key);
        }
        function getCookiesObj($key) {
            var $cookies;
            angular.injector(['ngCookies']).invoke(['$cookies', function(_$cookies_) {
                $cookies = _$cookies_;
            }]);
            return $cookies.getObject($key);
        }
        //////////
        function setApiUrl(url)
        {
            apiUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getApiUrl(url_suffix)
        {
            if (url_suffix)
                return apiUrl+url_suffix+"?access-token="+getCookies('auth_key');
            return apiUrl;

        }
        function getErrorUrl(url)
        {
            if (url)
                return url;
            return errorUrl;

        }
        // opeasy code <<
        /**
         * Set base url for API endpoints
         *
         * @param url {string}
         */
        function setBaseUrl(url)
        {
            baseUrl = url;
        }

        /**
         * Return the base url
         *
         * @returns {string}
         */
        function getBaseUrl()
        {
            return baseUrl;
        }

        /**
         * Return the api object
         *
         * @returns {object}
         */
        function getApiObject()
        {
            return api;
        }

        /**
         * Register API endpoint
         *
         * @param key
         * @param resource
         */
        function register(key, resource)
        {
            if ( !angular.isString(key) )
            {
                $log.error('"path" must be a string (eg. `dashboard.project`)');
                return;
            }

            if ( !angular.isArray(resource) )
            {
                $log.error('"resource" must be an array and it must follow $resource definition');
                return;
            }

            // Store the API object
            api[key] = {
                url          : baseUrl + (resource[0] || ''),
                paramDefaults: resource[1] || [],
                actions      : resource[2] || [],
                options      : resource[3] || {}
            };
        }

        /* ----------------- */
        /* Service           */
        /* ----------------- */
        this.$get = function ($log, $q, $resource, $rootScope)
        {
            // Data

            // Methods
            var service = {
                // opeasy code >>
                setApiUrl : setApiUrl,
                getApiUrl : getApiUrl,
                // opeasy code <<
                setBaseUrl: setBaseUrl,
                getBaseUrl: getBaseUrl,
                register  : register,
                resolve   : resolve,
                request   : request
            };

            return service;

            //////////

            /**
             * Resolve an API endpoint
             *
             * @param action {string}
             * @param parameters {object}
             * @returns {promise|boolean}
             */
            function resolve(action, parameters)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::resolveStart');

                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // opeasy code >> 添加 access_token
                    params['access-token'] = getCookies('auth_key');
                    //console.log(params);
                    // opeasy code <<
                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // Success
                        function (response)
                        {
                            deferred.resolve(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveSuccess');
                        },

                        // Error
                        function (response)
                        {
                            deferred.reject(response);

                            // Emit an event
                            $rootScope.$broadcast('msApi::resolveError');
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }

            /**
             * Make a request to an API endpoint
             *
             * @param action {string}
             * @param [parameters] {object}
             * @param [success] {function}
             * @param [error] {function}
             *
             * @returns {promise|boolean}
             */
            function request(action, parameters, success, error)
            {
                // Emit an event
                $rootScope.$broadcast('msApi::requestStart');

                var actionParts = action.split('@'),
                    resource = actionParts[0],
                    method = actionParts[1],
                    params = parameters || {};

                if ( !resource || !method )
                {
                    $log.error('msApi.resolve requires correct action parameter (resourceName@methodName)');
                    return false;
                }

                // Create a new deferred object
                var deferred = $q.defer();

                // Get the correct resource definition from api object
                var apiObject = api[resource];

                if ( !apiObject )
                {
                    $log.error('Resource "' + resource + '" is not defined in the api service!');
                    deferred.reject('Resource "' + resource + '" is not defined in the api service!');
                }
                else
                {
                    // opeasy code >> 添加 access_token
                    params['access-token'] = getCookies('auth_key');
                    //console.log(params);
                    // opeasy code <<

                    // Generate the $resource object based on the stored API object
                    var resourceObject = $resource(apiObject.url, apiObject.paramDefaults, apiObject.actions, apiObject.options);

                    // Make the call...
                    resourceObject[method](params,

                        // SUCCESS
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestSuccess');

                            // Resolve the promise
                            deferred.resolve(response);

                            // Call the success function if there is one
                            if ( angular.isDefined(success) && angular.isFunction(success) )
                            {
                                success(response);
                            }
                        },

                        // ERROR
                        function (response)
                        {
                            // Emit an event
                            $rootScope.$broadcast('msApi::requestError');

                            // Reject the promise
                            deferred.reject(response);

                            // Call the error function if there is one
                            if ( angular.isDefined(error) && angular.isFunction(error) )
                            {
                                error(response);
                            }
                        }
                    );
                }

                // Return the promise
                return deferred.promise;
            }
        };
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.core')
        .factory('apiResolver', apiResolverService);

    /** @ngInject */
    function apiResolverService($q, $log, api)
    {
        var service = {
            resolve: resolve
        };

        return service;

        //////////
        /**
         * Resolve api
         * @param action
         * @param parameters
         */
        function resolve(action, parameters)
        {
            var actionParts = action.split('@'),
                resource = actionParts[0],
                method = actionParts[1],
                params = parameters || {};

            if ( !resource || !method )
            {
                $log.error('apiResolver.resolve requires correct action parameter (ResourceName@methodName)');
                return false;
            }

            // Create a new deferred object
            var deferred = $q.defer();

            // Get the correct api object from api service
            var apiObject = getApiObject(resource);

            if ( !apiObject )
            {
                $log.error('Resource "' + resource + '" is not defined in the api service!');
                deferred.reject('Resource "' + resource + '" is not defined in the api service!');
            }
            else
            {
                apiObject[method](params,

                    // Success
                    function (response)
                    {
                        deferred.resolve(response);
                    },

                    // Error
                    function (response)
                    {
                        deferred.reject(response);
                    }
                );
            }

            // Return the promise
            return deferred.promise;
        }

        /**
         * Get correct api object
         *
         * @param resource
         * @returns {*}
         */
        function getApiObject(resource)
        {
            // Split the resource in case if we have a dot notated object
            var resourceParts = resource.split('.'),
                apiObject = api;

            // Loop through the resource parts and go all the way through
            // the api object and return the correct one
            for ( var l = 0; l < resourceParts.length; l++ )
            {
                if ( angular.isUndefined(apiObject[resourceParts[l]]) )
                {
                    $log.error('Resource part "' + resourceParts[l] + '" is not defined!');
                    apiObject = false;
                    break;
                }

                apiObject = apiObject[resourceParts[l]];
            }

            if ( !apiObject )
            {
                return false;
            }

            return apiObject;
        }
    }

})();
(function () {
    'use strict';

    angular
        .module('app.core')
        .directive('hljs', hljsDirective);

    /** @ngInject */
    function hljsDirective($timeout, $q, $interpolate) {
        return {
            restrict: 'E',
            compile : function (element, attr) {
                var code;
                //No attribute? code is the content
                if (!attr.code) {
                    code = element.html();
                    element.empty();
                }

                return function (scope, element, attr) {

                    if (attr.code) {
                        // Attribute? code is the evaluation
                        code = scope.$eval(attr.code);
                    }
                    var shouldInterpolate = scope.$eval(attr.shouldInterpolate);

                    $q.when(code).then(function (code) {
                        if (code) {
                            if (shouldInterpolate) {
                                code = $interpolate(code)(scope);
                            }
                            var contentParent = angular.element(
                                '<pre><code class="highlight" ng-non-bindable></code></pre>'
                            );
                            element.append(contentParent);
                            // Defer highlighting 1-frame to prevent GA interference...
                            $timeout(function () {
                                render(code, contentParent);
                            }, 34, false);
                        }
                    });

                    function render(contents, parent) {

                        var codeElement = parent.find('code');
                        var lines = contents.split('\n');

                        // Remove empty lines
                        lines = lines.filter(function (line) {
                            return line.trim().length;
                        });

                        // Make it so each line starts at 0 whitespace
                        var firstLineWhitespace = lines[0].match(/^\s*/)[0];
                        var startingWhitespaceRegex = new RegExp('^' + firstLineWhitespace);
                        lines = lines.map(function (line) {
                            return line
                                .replace(startingWhitespaceRegex, '')
                                .replace(/\s+$/, '');
                        });

                        var highlightedCode = hljs.highlight(attr.language || attr.lang, lines.join('\n'), true);
                        highlightedCode.value = highlightedCode.value
                            .replace(/=<span class="hljs-value">""<\/span>/gi, '')
                            .replace('<head>', '')
                            .replace('<head/>', '');
                        codeElement.append(highlightedCode.value).addClass('highlight');
                    }
                };
            }
        };
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByTags', filterByTags)
        .filter('filterSingleByTags', filterSingleByTags);

    /** @ngInject */
    function filterByTags()
    {
        return function (items, tags)
        {
            if ( items.length === 0 || tags.length === 0 )
            {
                return items;
            }

            var filtered = [];

            items.forEach(function (item)
            {
                var match = tags.every(function (tag)
                {
                    var tagExists = false;

                    item.tags.forEach(function (itemTag)
                    {
                        if ( itemTag.name === tag.name )
                        {
                            tagExists = true;
                            return;
                        }
                    });

                    return tagExists;
                });

                if ( match )
                {
                    filtered.push(item);
                }
            });

            return filtered;
        };
    }

    /** @ngInject */
    function filterSingleByTags()
    {
        return function (itemTags, tags)
        {
            if ( itemTags.length === 0 || tags.length === 0 )
            {
                return;
            }

            if ( itemTags.length < tags.length )
            {
                return [];
            }

            var filtered = [];

            var match = tags.every(function (tag)
            {
                var tagExists = false;

                itemTags.forEach(function (itemTag)
                {
                    if ( itemTag.name === tag.name )
                    {
                        tagExists = true;
                        return;
                    }
                });

                return tagExists;
            });

            if ( match )
            {
                filtered.push(itemTags);
            }

            return filtered;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByPropIds', filterByPropIds);

    /** @ngInject */
    function filterByPropIds()
    {
        return function (items, parameter, ids)
        {
            if ( items.length === 0 || !ids || ids.length === 0 )
            {
                return items;
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item[parameter].indexOf(id) > -1 )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('filterByIds', filterByIds);

    /** @ngInject */
    function filterByIds()
    {
        return function (items, ids)
        {

            if ( items.length === 0 || !ids )
            {
                return items;
            }

            if ( ids.length === 0 )
            {
                return [];
            }

            var filtered = [];

            for ( var i = 0; i < items.length; i++ )
            {
                var item = items[i];
                var match = false;

                for ( var j = 0; j < ids.length; j++ )
                {
                    var id = ids[j];
                    if ( item.id === id )
                    {
                        match = true;
                        break;
                    }
                }

                if ( match )
                {
                    filtered.push(item);
                }

            }

            return filtered;

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('toTrusted', toTrustedFilter)
        .filter('htmlToPlaintext', htmlToPlainTextFilter)
        .filter('nospace', nospaceFilter)
        .filter('humanizeDoc', humanizeDocFilter);

    /** @ngInject */
    function toTrustedFilter($sce)
    {
        return function (value)
        {
            return $sce.trustAsHtml(value);
        };
    }

    /** @ngInject */
    function htmlToPlainTextFilter()
    {
        return function (text)
        {
            return String(text).replace(/<[^>]+>/gm, '');
        };
    }

    /** @ngInject */
    function nospaceFilter()
    {
        return function (value)
        {
            return (!value) ? '' : value.replace(/ /g, '');
        };
    }

    /** @ngInject */
    function humanizeDocFilter()
    {
        return function (doc)
        {
            if ( !doc )
            {
                return;
            }
            if ( doc.type === 'directive' )
            {
                return doc.name.replace(/([A-Z])/g, function ($1)
                {
                    return '-' + $1.toLowerCase();
                });
            }
            return doc.label || doc.name;
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .filter('altDate', altDate);

    /** @ngInject */
    function altDate()
    {
        return function (value)
        {
            var diff = Date.now() - new Date(value);

            /**
             * If in a hour
             * e.g. "2 minutes ago"
             */
            if ( diff < (60 * 60 * 1000) )
            {
                return moment(value).fromNow();
            }
            /*
             * If in the day
             * e.g. "11:23"
             */
            else if ( diff < (60 * 60 * 24 * 1000) )
            {
                return moment(value).format('HH:mm');
            }
            /*
             * If in week
             * e.g "Tuesday"
             */
            else if ( diff < (60 * 60 * 24 * 7 * 1000) )
            {
                return moment(value).format('dddd');
            }
            /*
             * If more than a week
             * e.g. 03/29/2016
             */
            else
            {
                return moment(value).calendar();
            }

        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .provider('fuseConfig', fuseConfigProvider);

    /** @ngInject */
    function fuseConfigProvider()
    {
        // Default configuration
        var fuseConfiguration = {
            'disableCustomScrollbars'        : false,
            'disableMdInkRippleOnMobile'     : true,
            'disableCustomScrollbarsOnMobile': true
        };

        // Methods
        this.config = config;

        //////////

        /**
         * Extend default configuration with the given one
         *
         * @param configuration
         */
        function config(configuration)
        {
            fuseConfiguration = angular.extend({}, fuseConfiguration, configuration);
        }

        /**
         * Service
         */
        this.$get = function ()
        {
            var service = {
                getConfig: getConfig,
                setConfig: setConfig
            };

            return service;

            //////////

            /**
             * Returns a config value
             */
            function getConfig(configName)
            {
                if ( angular.isUndefined(fuseConfiguration[configName]) )
                {
                    return false;
                }

                return fuseConfiguration[configName];
            }

            /**
             * Creates or updates config object
             *
             * @param configName
             * @param configValue
             */
            function setConfig(configName, configValue)
            {
                fuseConfiguration[configName] = configValue;
            }
        };
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.toolbar', [])
        .config(config);

    /** @ngInject */
    function config($translatePartialLoaderProvider)
    {
        $translatePartialLoaderProvider.addPart('app/toolbar');
    }
})();

(function ()
{
    'use strict';

    angular
        .module('app.toolbar')
        .controller('ToolbarController', ToolbarController);

    /** @ngInject */
    function ToolbarController($rootScope, $q, $state, $timeout, $mdSidenav, $translate, $mdToast, msNavigationService, msApi, $http, $cookies, $window)
    {
        var vm = this;
        vm.stores = null;
        vm.store_name = '';
        vm.switchStore = switchStore;
        // if(!$cookies.get('store_id')){
        //     $cookies.put('store_id',1);
        // }

        // opeasy code >>
        // 1.检测是否登陆
        if(!$cookies.get('store_id') || !$cookies.get('store_name')){
            $window.location.href = '/pages/auth/login';
        }
        if ($cookies.get('locking')){
            $state.go('app.pages_auth_lock');//如果有lock状态，赚到lock页面
        }
        vm.current_user = $cookies.getObject('curr_user');
        /*vm.current_user['username'] = $cookies.get('current_user[username]');
        vm.current_user['email'] = $cookies.get('current_user[email]');
        vm.current_user['mobile'] = $cookies.get('current_user[mobile]');
        vm.current_user['name'] = $cookies.get('current_user[name]');
        vm.current_user['sex'] = $cookies.get('current_user[sex]');
        vm.current_user['avatar'] = $cookies.get('current_user[avatar]');*/
        vm.current_user['auth_key'] = $cookies.get('auth_key');
        vm.current_user['StoreHasUser'] = $cookies.getObject('StoreHasUser');
        // opeasy code <<
        //console.log(msApi.getStoreId());
        var role_id = $cookies.get('role_id');
        if(role_id == 1 || role_id == 8 || vm.current_user['username'] == 'root' || vm.current_user['username'] == 'admin'){
            var url = msApi.getApiUrl() +"stores?access-token="+vm.current_user['auth_key'];
            $http.get(url).success(function (response) {
                //console.log($scope.sprintlist=response);
                vm.stores = response.data;
                for ( var i = 0; i < vm.stores.length; i++ )
                {
                    if ( vm.stores[i].id == $cookies.get('store_id'))
                    {
                        vm.store_name = vm.stores[i].name;
                        $cookies.put('store_name',vm.store_name);
                        break;
                    }
                }
                //console.log(msApi.getStoreId());
            });
        }else{
            var url = msApi.getApiUrl() +"users/"+ vm.current_user.id+"?access-token="+vm.current_user['auth_key'];
            //console.log(url);
            $http.get(url).success(function (response) {
                vm.stores = response.StoreHasUser;
                angular.forEach(vm.stores, function (v, k) {
                    if( v.id == $cookies.get('store_id')){
                        vm.store_name = v.name;
                        $cookies.put('store_name',vm.store_name);
                    }
                });
            });
        }

        //切换门店
        function switchStore(ev,store){
            vm.store_name = store.name;
            $cookies.put('store_name',vm.store_name);
            $cookies.put('store_id',store.id);
            $cookies.put('store_city',store.city);
            $window.location.reload();
        }
        // Data
        $rootScope.global = {
            search: ''
        };

        vm.bodyEl = angular.element('body');
        vm.userStatusOptions = [
            {
                'title': 'Online',
                'icon' : 'icon-checkbox-marked-circle',
                'color': '#4CAF50'
            },
            {
                'title': 'Away',
                'icon' : 'icon-clock',
                'color': '#FFC107'
            },
            {
                'title': 'Do not Disturb',
                'icon' : 'icon-minus-circle',
                'color': '#F44336'
            },
            {
                'title': 'Invisible',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#BDBDBD'
            },
            {
                'title': 'Offline',
                'icon' : 'icon-checkbox-blank-circle-outline',
                'color': '#616161'
            }
        ];
        vm.languages = {
            zh: {
                'title'      : '中文',
                'translation': 'TOOLBAR.CHINESE',
                'code'       : 'zh',
                'flag'       : 'zh'
            },
            en: {
                'title'      : 'English',
                'translation': 'TOOLBAR.ENGLISH',
                'code'       : 'en',
                'flag'       : 'us'
            }

        };

        // Methods
        vm.toggleSidenav = toggleSidenav;
        vm.logout = logout;
        vm.changeLanguage = changeLanguage;
        vm.setUserStatus = setUserStatus;
        vm.toggleHorizontalMobileMenu = toggleHorizontalMobileMenu;
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;
        vm.search = search;
        vm.searchResultClick = searchResultClick;

        //////////
        //vm.daily = null;
        vm.remarks = '';
        var data = {remarks: ''};
        //data.remarks = vm.remarks;
        init();

        /**
         * Initialize
         */
        function init()
        {
            // Select the first status as a default
            vm.userStatus = vm.userStatusOptions[0];

            // Get the selected language directly from angular-translate module setting
            vm.selectedLanguage = vm.languages[$translate.preferredLanguage('zh')];
            var url = msApi.getApiUrl() +"dailys?access-token="+vm.current_user['auth_key']+"&store_id="+$cookies.get('store_id')+'&act=select';
            $http.get(url).success(function (response) {
                vm.daily = response;
                vm.remarks = vm.daily.remarks;
                data = {store_id:$cookies.get('store_id'),
                    send_uid:vm.current_user.id,
                    res: {amount:0,//vm.daily.amount,
                        total:vm.daily.total,
                        teacher_count:vm.daily.teacher_count,
                        xiaoshou_count:vm.daily.xiaoshou_count,
                        qiantai_count:vm.daily.qiantai_count,
                        houqin_count:vm.daily.houqin_count,
                        task_count:vm.daily.task_count,
                        am_count:vm.daily.AM.length,
                        pm_count:vm.daily.PM.length,
                        ni_count:vm.daily.NI.length,
                        AM:vm.daily.AM,
                        PM:vm.daily.PM,
                        NI:vm.daily.NI,
                        remarks:vm.remarks
                    }
                }
            });
        }
        vm.sendDialy = function sendDialy() {
            //data.remarks=vm.remarks;
            data.remarks = vm.remarks;
            $http({
                method: 'POST',
                url: msApi.getApiUrl('dailys'),
                data: angular.toJson(data)
            }).success(function (req) {
                $rootScope.message_success = '操作成功!';
                $timeout(function(){$rootScope.message_success = '';},5000);
            }).error(function(data, state) {
                vm.error_arr = data && data[0].message ? data[0].message : '操作失败!';
                $rootScope.message_danger = vm.error_arr;
                $timeout(function(){$rootScope.message_danger = '';},5000);
            });
        }

        /**
         * Toggle sidenav
         *
         * @param sidenavId
         */
        function toggleSidenav(sidenavId)
        {
            $mdSidenav(sidenavId).toggle();
        }

        /**
         * Sets User Status
         * @param status
         */
        function setUserStatus(status)
        {
            vm.userStatus = status;
        }

        vm.settings = settings;
        function settings()
        {
        }

        /**
         * Logout Function
         */
        function logout()
        {
            $cookies.remove('store_id');
            $cookies.remove('store_name');
            $cookies.remove('curr_user');
            $cookies.remove('curr_roles');
            $cookies.remove('curr_permissions');
            $cookies.remove('tri_user');
            /*$cookies.remove('current_user[id]');
            $cookies.remove('current_user[username]');
            $cookies.remove('current_user[email]');
            $cookies.remove('current_user[mobile]');
            $cookies.remove('current_user[name]');
            $cookies.remove('current_user[sex]');
            $cookies.remove('current_user[avatar]');
            $cookies.remove('current_user[auth_key]');*/
            $cookies.remove('locking');
            $window.location.href = '/pages/auth/login';
            // Do logout here..
            /*msApi.request("pages.auth.login@get", {'act':'logout', 'username': vm.current_user.username}).then(
                // Success
                function (response)
                {
                    //console.log(response.data);
                    if (response.data.login_status == false) {// login failed
                        vm.login_message = response.data.login_message;
                    }else {// login success
                        $cookies.delete('store_id', response.data.user.store_id);
                        $cookies.delete('current_user', response.data.user);
                        $window.location.href = '/pages/auth/login';
                    }
                }
            );*/
        }

        /**
         * Change Language
         */
        function changeLanguage(lang)
        {
            vm.selectedLanguage = lang;

            /**
             * Show temporary message if user selects a language other than English
             *
             * angular-translate module will try to load language specific json files
             * as soon as you change the language. And because we don't have them, there
             * will be a lot of errors in the page potentially breaking couple functions
             * of the template.
             *
             * To prevent that from happening, we added a simple "return;" statement at the
             * end of this if block. If you have all the translation files, remove this if
             * block and the translations should work without any problems.
             */
            if ( lang.code !== 'en'&&lang.code !== 'zh' )
            {
                var message = '当前只支持英文或者中文';

                $mdToast.show({
                    template : '<md-toast id="language-message" layout="column" layout-align="center start"><div class="md-toast-content">' + message + '</div></md-toast>',
                    hideDelay: 7000,
                    position : 'top right',
                    parent   : '#content'
                });

                return;
            }

            // Change the language
            $translate.use(lang.code);
        }

        /**
         * Toggle horizontal mobile menu
         */
        function toggleHorizontalMobileMenu()
        {
            vm.bodyEl.toggleClass('ms-navigation-horizontal-mobile-menu-active');
        }

        /**
         * Toggle msNavigation folded
         */
        function toggleMsNavigationFolded()
        {
            msNavigationService.toggleFolded();
        }

        /**
         * Search action
         *
         * @param query
         * @returns {Promise}
         */
        function search(query)
        {
            var navigation = [],
                flatNavigation = msNavigationService.getFlatNavigation(),
                deferred = $q.defer();

            // Iterate through the navigation array and
            // make sure it doesn't have any groups or
            // none ui-sref items
            for ( var x = 0; x < flatNavigation.length; x++ )
            {
                if ( flatNavigation[x].uisref )
                {
                    navigation.push(flatNavigation[x]);
                }
            }

            // If there is a query, filter the navigation;
            // otherwise we will return the entire navigation
            // list. Not exactly a good thing to do but it's
            // for demo purposes.
            if ( query )
            {
                navigation = navigation.filter(function (item)
                {
                    if ( angular.lowercase(item.title).search(angular.lowercase(query)) > -1 )
                    {
                        return true;
                    }
                });
            }

            // Fake service delay
            $timeout(function ()
            {
                deferred.resolve(navigation);
            }, 1000);

            return deferred.promise;
        }

        /**
         * Search result click action
         *
         * @param item
         */
        function searchResultClick(item)
        {
            // If item has a link
            if ( item.uisref )
            {
                // If there are state params,
                // use them...
                if ( item.stateParams )
                {
                    $state.go(item.state, item.stateParams);
                }
                else
                {
                    $state.go(item.state);
                }
            }
        }
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.quick-panel')
        .controller('QuickPanelController', QuickPanelController);

    /** @ngInject */
    function QuickPanelController(msApi)
    {
        var vm = this;

        // Data
        vm.date = new Date();
        vm.settings = {
            notify: true,
            cloud : false,
            retro : true
        };

        msApi.request('quickPanel.activities@get', {},
            // Success
            function (response)
            {
                vm.activities = response.data;
            }
        );

        msApi.request('quickPanel.events@get', {},
            // Success
            function (response)
            {
                vm.events = response.data;
            }
        );

        msApi.request('quickPanel.notes@get', {},
            // Success
            function (response)
            {
                vm.notes = response.data;
            }
        );

        // Methods

        //////////
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation', [])
        .config(config);

    /** @ngInject */
    function config()
    {
        
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.navigation')
        .controller('NavigationController', NavigationController);

    /** @ngInject */
    function NavigationController($scope,globalSettings)
    {
        var vm = this;

        vm.gs = globalSettings;
        // Data
        vm.bodyEl = angular.element('body');
        vm.folded = false;
        vm.msScrollOptions = {
            suppressScrollX: true
        };

        // Methods
        vm.toggleMsNavigationFolded = toggleMsNavigationFolded;

        //////////

        /**
         * Toggle folded status
         */
        function toggleMsNavigationFolded()
        {
            vm.folded = !vm.folded;
        }

        // Close the mobile menu on $stateChangeSuccess
        $scope.$on('$stateChangeSuccess', function ()
        {
            vm.bodyEl.removeClass('ms-navigation-horizontal-mobile-menu-active');
        });
    }

})();
(function ()
{
    'use strict';

    /**
     * Main module of the Fuse
     */
    angular
        .module('fuse', [
            //'ui.router',
            // Common 3rd Party Dependencies
            //'uiGmapgoogle-maps',
            'textAngular',
            'xeditable',
            'md.data.table',

            // Core
            'app.core',

            // Navigation
            'app.navigation',

            // Toolbar
            'app.toolbar',

            // Quick Panel
            //'app.quick-panel',

            // Apps
            //'app.dashboards',
            //'app.calendar',
            // 'app.e-commerce',
            //'app.mail',
            // 'app.chat',
            //'app.file-manager',
            // 'app.gantt-chart',
            //'app.scrumboard',
             //'app.todo',
             //'app.contacts',
             //'app.notes',
             'app.permission',
            // Chain Store
            'app.main-store',
            'app.store',
            //'app.courses',


            // Pages
             'app.pages',

            // User Interface
             //'app.ui',

            // Components
            //'app.components'
            //'angular-permission'

        ]);
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('MainController', MainController);

    /** @ngInject */
    function MainController($scope, $rootScope, $mdDateLocale,$filter)
    {
        moment.tz.setDefault('Asia/Shanghai');//设置moment的timezone 的默认时区为国内上海时间
        // Opeasy code >> Date  解决日期显示的问题
        $mdDateLocale.formatDate = function(date) {
            // console.log("------:"+date);
            return  $filter("date")(new Date(date), "yyyy-MM-dd");

            // return moment(date).format('YYYY-MM-DD');
        };

        // vm.StrToDate = function (str) { if (str) return new Date(str); }
        // Opeasy code <<

        //////////

        // Remove the splash screen
        $scope.$on('$viewContentAnimationEnded', function (event)
        {
            if ( event.targetScope.$id === $scope.$id )
            {
                $rootScope.$broadcast('msSplashScreen::remove');
            }
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .run(runBlock);

    /** @ngInject */
    function runBlock(msUtils, fuseGenerator, fuseConfig)
    {
        /**
         * Generate extra classes based on registered themes so we
         * can use same colors with non-angular-material elements
         */
        fuseGenerator.generate();

        /**
         * Disable md-ink-ripple effects on mobile
         * if 'disableMdInkRippleOnMobile' config enabled
         */
        if ( fuseConfig.getConfig('disableMdInkRippleOnMobile') && msUtils.isMobile() )
        {
            var bodyEl = angular.element('body');
            bodyEl.attr('md-no-ink', true);
        }

        /**
         * Put isMobile() to the html as a class
         */
        if ( msUtils.isMobile() )
        {
            angular.element('html').addClass('is-mobile');
        }

        /**
         * Put browser information to the html as a class
         */
        var browserInfo = msUtils.detectBrowser();
        if ( browserInfo )
        {
            var htmlClass = browserInfo.browser + ' ' + browserInfo.version + ' ' + browserInfo.os;
            angular.element('html').addClass(htmlClass);
        }
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.core')
        .config(config);

    /** @ngInject */
    function config($ariaProvider, $logProvider, msScrollConfigProvider, fuseConfigProvider)
    {
        // Enable debug logging
        $logProvider.debugEnabled(true);

        /*eslint-disable */

        // ng-aria configuration
        $ariaProvider.config({
            tabindex: false
        });

        // Fuse theme configurations
        fuseConfigProvider.config({
            'disableCustomScrollbars'        : false,
            'disableCustomScrollbarsOnMobile': true,
            'disableMdInkRippleOnMobile'     : true
        });

        // msScroll configuration
        msScrollConfigProvider.config({
            wheelPropagation: true
        });

        /*eslint-enable */
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .run(runBlock);

    /** @ngInject */
    function runBlock($rootScope, $timeout, $state, editableThemes)
    {
        // 3rd Party Dependencies
        editableThemes.default.submitTpl = '<md-button class="md-icon-button" type="submit" aria-label="save"><md-icon md-font-icon="icon-checkbox-marked-circle" class="md-accent-fg md-hue-1"></md-icon></md-button>';
        editableThemes.default.cancelTpl = '<md-button class="md-icon-button" ng-click="$form.$cancel()" aria-label="cancel"><md-icon md-font-icon="icon-close-circle" class="icon-cancel"></md-icon></md-button>';

        // Activate loading indicator
        var stateChangeStartEvent = $rootScope.$on('$stateChangeStart', function ()
        {
            $rootScope.loadingProgress = true;
        });

        // De-activate loading indicator
        var stateChangeSuccessEvent = $rootScope.$on('$stateChangeSuccess', function ()
        {
            $timeout(function ()
            {
                $rootScope.loadingProgress = false;
            });
        });

        // Store state in the root scope for easy access
        $rootScope.state = $state;

        // Cleanup
        $rootScope.$on('$destroy', function ()
        {
            stateChangeStartEvent();
            stateChangeSuccessEvent();
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(routeConfig);

    /** @ngInject */
    function routeConfig($stateProvider, $urlRouterProvider, $locationProvider)
    {
        // Inject $cookies
        var $cookies;
        angular.injector(['ngCookies']).invoke([
            '$cookies', function (_$cookies)
            {
                $cookies = _$cookies;
            }
        ]);
        $locationProvider.html5Mode(true);
        //$urlRouterProvider.otherwise('/dashboard-project');
        $urlRouterProvider.otherwise('/pages/auth/login');
        /**
         * Layout Style Switcher
         *
         * This code is here for demonstration purposes.
         * If you don't need to switch between the layout
         * styles like in the demo, you can set one manually by
         * typing the template urls into the `State definitions`
         * area and remove this code
         */
        // Get active layout
        var layoutStyle = $cookies.get('layoutStyle') || 'verticalNavigation';

        var layouts = {
            verticalNavigation  : {
                main      : 'app/core/layouts/vertical-navigation.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation/navigation.html'
            },
            verticalNavigationFullwidthToolbar2  : {
                main      : 'app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html',
                toolbar   : 'app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html',
                navigation: 'app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html'
            },
            horizontalNavigation: {
                main      : 'app/core/layouts/horizontal-navigation.html',
                toolbar   : 'app/toolbar/layouts/horizontal-navigation/toolbar.html',
                navigation: 'app/navigation/layouts/horizontal-navigation/navigation.html'
            },
            contentOnly         : {
                main      : 'app/core/layouts/content-only.html',
                toolbar   : '',
                navigation: ''
            },
            contentWithToolbar  : {
                main      : 'app/core/layouts/content-with-toolbar.html',
                toolbar   : 'app/toolbar/layouts/content-with-toolbar/toolbar.html',
                navigation: ''
            }
        };
        // END - Layout Style Switcher

        // State definitions
        $stateProvider
            .state('app', {
                abstract: true,
                views   : {
                    'main@'         : {
                        templateUrl: layouts[layoutStyle].main,
                        controller : 'MainController as vm'
                    },
                    'toolbar@app'   : {
                        templateUrl: layouts[layoutStyle].toolbar,
                        controller : 'ToolbarController as vm'
                    },
                    'navigation@app': {
                        templateUrl: layouts[layoutStyle].navigation,
                        controller : 'NavigationController as vm'
                    },
                    /*'quickPanel@app': {
                        templateUrl: 'app/quick-panel/quick-panel.html',
                        controller : 'QuickPanelController as vm'
                    }*/
                }
            });
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .controller('IndexController', IndexController);

    /** @ngInject */
    function IndexController(fuseTheming)
    {
        var vm = this;

        // Data
        vm.themes = fuseTheming.themes;

        //////////
    }
})();
(function ()
{
    'use strict';

    angular
        .module('fuse');
})();

(function ()
{
    'use strict';

    angular
        .module('fuse')
        .config(config);

    /** @ngInject */
    //function config(uiGmapGoogleMapApiProvider, $translateProvider, $provide)
    function config($translateProvider, $provide)
    {
        // Put your common app configurations here

        // uiGmapgoogle-maps configuration
        // uiGmapGoogleMapApiProvider.configure({
        //     //    key: 'your api key',
        //     v        : '3.exp',
        //     libraries: 'weather,geometry,visualization'
        // });

        // angular-translate configuration
        $translateProvider.useLoader('$translatePartialLoader', {
            urlTemplate: '{part}/i18n/{lang}.json'
        });
        $translateProvider.preferredLanguage('en');
        $translateProvider.useSanitizeValueStrategy('sanitize');

        // Text Angular options
        $provide.decorator('taOptions', [
            '$delegate', function (taOptions)
            {
                taOptions.toolbar = [
                    ['bold', 'italics', 'underline', 'ul', 'ol', 'quote']
                ];

                taOptions.classes = {
                    focussed           : 'focussed',
                    toolbar            : 'ta-toolbar',
                    toolbarGroup       : 'ta-group',
                    toolbarButton      : 'md-button',
                    toolbarButtonActive: 'active',
                    disabled           : '',
                    textEditor         : 'form-control',
                    htmlEditor         : 'form-control'
                };

                return taOptions;
            }
        ]);

        // Text Angular tools
        $provide.decorator('taTools', [
            '$delegate', function (taTools)
            {
                taTools.quote.iconclass = 'icon-format-quote';
                taTools.bold.iconclass = 'icon-format-bold';
                taTools.italics.iconclass = 'icon-format-italic';
                taTools.underline.iconclass = 'icon-format-underline';
                taTools.strikeThrough.iconclass = 'icon-format-strikethrough';
                taTools.ul.iconclass = 'icon-format-list-bulleted';
                taTools.ol.iconclass = 'icon-format-list-numbers';
                taTools.redo.iconclass = 'icon-redo';
                taTools.undo.iconclass = 'icon-undo';
                taTools.clear.iconclass = 'icon-close-circle-outline';
                taTools.justifyLeft.iconclass = 'icon-format-align-left';
                taTools.justifyCenter.iconclass = 'icon-format-align-center';
                taTools.justifyRight.iconclass = 'icon-format-align-right';
                taTools.justifyFull.iconclass = 'icon-format-align-justify';
                taTools.indent.iconclass = 'icon-format-indent-increase';
                taTools.outdent.iconclass = 'icon-format-indent-decrease';
                taTools.html.iconclass = 'icon-code-tags';
                taTools.insertImage.iconclass = 'icon-file-image-box';
                taTools.insertLink.iconclass = 'icon-link';
                taTools.insertVideo.iconclass = 'icon-filmstrip';

                return taTools;
            }
        ]);
    }

})();
(function ()
{
    'use strict';

    angular
        .module('fuse')
        .factory('api', apiService);

    /** @ngInject */
    function apiService($resource)
    {
        /**
         * You can use this service to define your API urls. The "api" service
         * is designed to work in parallel with "apiResolver" service which you can
         * find in the "app/core/services/api-resolver.service.js" file.
         *
         * You can structure your API urls whatever the way you want to structure them.
         * You can either use very simple definitions, or you can use multi-dimensional
         * objects.
         *
         * Here's a very simple API url definition example:
         *
         *      api.getBlogList = $resource('http://api.example.com/getBlogList');
         *
         * While this is a perfectly valid $resource definition, most of the time you will
         * find yourself in a more complex situation where you want url parameters:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'});
         *
         * You can also define your custom methods. Custom method definitions allow you to
         * add hardcoded parameters to your API calls that you want to sent every time you
         * make that API call:
         *
         *      api.getBlogById = $resource('http://api.example.com/blog/:id', {id: '@id'}, {
         *         'getFromHomeCategory' : {method: 'GET', params: {blogCategory: 'home'}}
         *      });
         *
         * In addition to these definitions, you can also create multi-dimensional objects.
         * They are nothing to do with the $resource object, it's just a more convenient
         * way that we have created for you to packing your related API urls together:
         *
         *      api.blog = {
         *                   list     : $resource('http://api.example.com/blog'),
         *                   getById  : $resource('http://api.example.com/blog/:id', {id: '@id'}),
         *                   getByDate: $resource('http://api.example.com/blog/:date', {id: '@date'}, {
         *                       get: {
         *                            method: 'GET',
         *                            params: {
         *                                getByDate: true
         *                            }
         *                       }
         *                   })
         *       }
         *
         * If you look at the last example from above, we overrode the 'get' method to put a
         * hardcoded parameter. Now every time we make the "getByDate" call, the {getByDate: true}
         * object will also be sent along with whatever data we are sending.
         *
         * All the above methods are using standard $resource service. You can learn more about
         * it at: https://docs.angularjs.org/api/ngResource/service/$resource
         *
         * -----
         *
         * After you defined your API urls, you can use them in Controllers, Services and even
         * in the UIRouter state definitions.
         *
         * If we use the last example from above, you can do an API call in your Controllers and
         * Services like this:
         *
         *      function MyController (api)
         *      {
         *          // Get the blog list
         *          api.blog.list.get({},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the id of 3
         *          var id = 3;
         *          api.blog.getById.get({'id': id},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *
         *          // Get the blog with the date by using custom defined method
         *          var date = 112314232132;
         *          api.blog.getByDate.get({'date': date},
         *
         *              // Success
         *              function (response)
         *              {
         *                  console.log(response);
         *              },
         *
         *              // Error
         *              function (response)
         *              {
         *                  console.error(response);
         *              }
         *          );
         *      }
         *
         * Because we are directly using $resource service, all your API calls will return a
         * $promise object.
         *
         * --
         *
         * If you want to do the same calls in your UI Router state definitions, you need to use
         * "apiResolver" service we have prepared for you:
         *
         *      $stateProvider.state('app.blog', {
         *          url      : '/blog',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver)
         *              {
         *                  return apiResolver.resolve('blog.list@get');
         *              }
         *          }
         *      });
         *
         *  You can even use parameters with apiResolver service:
         *
         *      $stateProvider.state('app.blog.show', {
         *          url      : '/blog/:id',
         *          views    : {
         *               'content@app': {
         *                   templateUrl: 'app/main/apps/blog/blog.html',
         *                   controller : 'BlogController as vm'
         *               }
         *          },
         *          resolve  : {
         *              Blog: function (apiResolver, $stateParams)
         *              {
         *                  return apiResolver.resolve('blog.getById@get', {'id': $stateParams.id);
         *              }
         *          }
         *      });
         *
         *  And the "Blog" object will be available in your BlogController:
         *
         *      function BlogController(Blog)
         *      {
         *          var vm = this;
         *
         *          // Data
         *          vm.blog = Blog;
         *
         *          ...
         *      }
         */

        var api = {};

        // Base Url
        api.baseUrl = 'app/data/';

        /**
         * Here you can find all the definitions that the Demo Project requires
         *
         * If you wish to use this method, you can create your API definitions
         * in a similar way.
         */

        /*
         api.dashboard = {
         project  : $resource(api.baseUrl + 'dashboard/project/data.json'),
         server   : $resource(api.baseUrl + 'dashboard/server/data.json'),
         analytics: $resource(api.baseUrl + 'dashboard/analytics/data.json')
         };

         api.cards = $resource(api.baseUrl + 'cards/cards.json');

         api.fileManager = {
         documents: $resource(api.baseUrl + 'file-manager/documents.json')
         };

         api.ganttChart = {
         tasks: $resource(api.baseUrl + 'gantt-chart/tasks.json'),
         timespans : $resource(api.baseUrl + 'gantt-chart/timespans.json')
         };

         api.icons = $resource('assets/icons/selection.json');

         api.invoice = $resource(api.baseUrl + 'invoice/invoice.json');

         api.mail = {
         inbox: $resource(api.baseUrl + 'mail/inbox.json')
         };

         api.profile = {
         timeline    : $resource(api.baseUrl + 'profile/timeline.json'),
         about       : $resource(api.baseUrl + 'profile/about.json'),
         photosVideos: $resource(api.baseUrl + 'profile/photos-videos.json')
         };

         api.quickPanel = {
         activities: $resource(api.baseUrl + 'quick-panel/activities.json'),
         contacts  : $resource(api.baseUrl + 'quick-panel/contacts.json'),
         events    : $resource(api.baseUrl + 'quick-panel/events.json'),
         notes     : $resource(api.baseUrl + 'quick-panel/notes.json')
         };

         api.search = {
         classic : $resource(api.baseUrl + 'search/classic.json'),
         mails   : $resource(api.baseUrl + 'search/mails.json'),
         users   : $resource(api.baseUrl + 'search/users.json'),
         contacts: $resource(api.baseUrl + 'search/contacts.json')
         };

         api.scrumboard = {
         boardList: $resource(api.baseUrl + 'scrumboard/boardList.json'),
         board    : $resource(api.baseUrl + 'scrumboard/boards/:id.json')
         };

         api.tables = {
         employees   : $resource(api.baseUrl + 'tables/employees.json'),
         employees100: $resource(api.baseUrl + 'tables/employees100.json')
         };

         api.timeline = {
         page1: $resource(api.baseUrl + 'timeline/page-1.json'),
         page2: $resource(api.baseUrl + 'timeline/page-2.json'),
         page3: $resource(api.baseUrl + 'timeline/page-3.json')
         };

         api.todo = {
         tasks: $resource(api.baseUrl + 'todo/tasks.json'),
         tags : $resource(api.baseUrl + 'todo/tags.json')
         };
         */

        return api;
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.main-store', [
            'app.main-store.stores'
        ])
        .config(config);

    /** @ngInject */
    function config($stateProvider, $translatePartialLoaderProvider, msApiProvider, msNavigationServiceProvider)
    {

        var role_id = msApiProvider.getCookies('role_id');
        //console.log(role_id);
        // Translation
        //$translatePartialLoaderProvider.addPart('app/main/apps/main-store');
        // Navigation
        if (role_id == 1) {//超管
            msNavigationServiceProvider.saveItem('main-store', {
                title : '总店管理',
                group : true,
                weight: 1
            });
        }

    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.dashboards',
            [
                'app.dashboards.project',
                'app.dashboards.server',
                //'app.dashboards.analytics'
            ]
        )
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('apps', {
            title : 'APPS',
            group : true,
            weight: 1
        });

        msNavigationServiceProvider.saveItem('apps.dashboards', {
            title : 'Dashboards',
            icon  : 'icon-tile-four',
            weight: 1
        });

        msNavigationServiceProvider.saveItem('apps.dashboards.project', {
            title: 'Project',
            state: 'app.dashboards_project'
        });

        /*msNavigationServiceProvider.saveItem('apps.dashboards.server', {
            title: 'Server',
            state: 'app.dashboards_server'
        });

        msNavigationServiceProvider.saveItem('apps.dashboards.analytics', {
            title: 'Analytics',
            state: 'app.dashboards_analytics'
        });*/
    }

})();
(function ()
{
    'use strict';

    angular
        .module('app.ui', [
            'app.ui.forms',
            'app.ui.helper-classes',
            'app.ui.icons',
            'app.ui.material-colors',
            'app.ui.page-layouts.blank',
            'app.ui.page-layouts.carded.fullwidth',
            'app.ui.page-layouts.carded.fullwidth-ii',
            'app.ui.page-layouts.carded.left-sidenav',
            'app.ui.page-layouts.carded.left-sidenav-ii',
            'app.ui.page-layouts.carded.right-sidenav',
            'app.ui.page-layouts.carded.right-sidenav-ii',
            'app.ui.page-layouts.simple.fullwidth',
            'app.ui.page-layouts.simple.left-sidenav',
            'app.ui.page-layouts.simple.left-sidenav-ii',
            'app.ui.page-layouts.simple.left-sidenav-iii',
            'app.ui.page-layouts.simple.right-sidenav',
            'app.ui.page-layouts.simple.right-sidenav-ii',
            'app.ui.page-layouts.simple.right-sidenav-iii',
            'app.ui.page-layouts.simple.tabbed',
            'app.ui.theme-colors',
            'app.ui.typography'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('ui', {
            title : 'USER INTERFACE',
            group : true,
            weight: 3
        });

        msNavigationServiceProvider.saveItem('ui.forms', {
            title: 'Forms',
            icon : 'icon-window-restore',
            state: 'app.ui_forms'
        });

        msNavigationServiceProvider.saveItem('ui.icons', {
            title: 'Icons',
            icon : 'icon-file-image-box',
            state: 'app.ui_icons'
        });

        msNavigationServiceProvider.saveItem('ui.typography', {
            title: 'Typography',
            icon : 'icon-format-size',
            state: 'app.ui_typography'
        });

        msNavigationServiceProvider.saveItem('ui.helper-classes', {
            title: 'Helper Classes',
            icon : 'icon-help-circle',
            state: 'app.ui_helper-classes'
        });

        msNavigationServiceProvider.saveItem('ui.theme-colors', {
            title: 'Theme Colors',
            icon : 'icon-palette-advanced',
            state: 'app.ui_theme-colors'
        });

        msNavigationServiceProvider.saveItem('ui.material-colors', {
            title: 'Material Colors',
            icon : 'icon-palette',
            state: 'app.ui_material-colors'
        });


        msNavigationServiceProvider.saveItem('ui.page-layouts', {
            title: 'Page Layouts',
            icon : 'icon-view-quilt'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded', {
            title: 'Carded'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.fullwidth', {
            title: 'Full Width (I)',
            state: 'app.ui_page-layouts_carded_fullwidth'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.fullwidth-ii', {
            title: 'Full Width (II)',
            state: 'app.ui_page-layouts_carded_fullwidth-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.left-sidenav', {
            title: 'Left Sidenav (I)',
            state: 'app.ui_page-layouts_carded_left-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.left-sidenav-ii', {
            title: 'Left Sidenav (II)',
            state: 'app.ui_page-layouts_carded_left-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.right-sidenav', {
            title: 'Right Sidenav (I)',
            state: 'app.ui_page-layouts_carded_right-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.carded.right-sidenav-ii', {
            title: 'Right Sidenav (II)',
            state: 'app.ui_page-layouts_carded_right-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple', {
            title: 'Simple'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.fullwidth', {
            title: 'Full Width (I)',
            state: 'app.ui_page-layouts_simple_fullwidth'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.left-sidenav', {
            title: 'Left Sidenav (I)',
            state: 'app.ui_page-layouts_simple_left-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.left-sidenav-ii', {
            title: 'Left Sidenav (II)',
            state: 'app.ui_page-layouts_simple_left-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.left-sidenav-iii', {
            title: 'Left Sidenav (III)',
            state: 'app.ui_page-layouts_simple_left-sidenav-iii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.right-sidenav', {
            title: 'Right Sidenav (I)',
            state: 'app.ui_page-layouts_simple_right-sidenav'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.right-sidenav-ii', {
            title: 'Right Sidenav (II)',
            state: 'app.ui_page-layouts_simple_right-sidenav-ii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.right-sidenav-iii', {
            title: 'Right Sidenav (III)',
            state: 'app.ui_page-layouts_simple_right-sidenav-iii'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.simple.tabbed', {
            title: 'Tabbed',
            state: 'app.ui_page-layouts_simple_tabbed'
        });

        msNavigationServiceProvider.saveItem('ui.page-layouts.blank', {
            title: 'Blank',
            state: 'app.ui_page-layouts_blank'
        });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.pages', [
            'app.pages.auth.login',
            // 'app.pages.auth.login-v2',
            // 'app.pages.auth.register',
            // 'app.pages.auth.register-v2',
            'app.pages.auth.forgot-password',
            'app.pages.auth.reset-password',
            'app.pages.auth.lock',
            // 'app.pages.coming-soon',
              'app.pages.error-401',
             //'app.pages.error-404',
            // 'app.pages.error-500',
            // 'app.pages.invoice',
            // 'app.pages.maintenance',
            // 'app.pages.profile',
            // 'app.pages.search',
            // 'app.pages.timeline'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        // msNavigationServiceProvider.saveItem('pages', {
        //     title : 'PAGES',
        //     group : true,
        //     weight: 2
        // });
    }
})();
(function ()
{
    'use strict';

    angular
        .module('app.components', [
            'app.components.cards',
            'app.components.charts.c3',
            'app.components.charts.chart-js',
            'app.components.charts.chartist',
            'app.components.charts.nvd3',
            'app.components.custom-directives',
            'app.components.maps',
            'app.components.price-tables',
            'app.components.tables.simple-table',
            'app.components.tables.datatable',
            'app.components.widgets',
            'app.components.material-docs'
        ])
        .config(config);

    /** @ngInject */
    function config(msNavigationServiceProvider)
    {
        // Navigation
        msNavigationServiceProvider.saveItem('components', {
            title : 'COMPONENTS',
            group : true,
            weight: 4
        });

        msNavigationServiceProvider.saveItem('components.cards', {
            title : 'Cards',
            icon  : 'icon-content-copy',
            state : 'app.components_cards',
            weight: 3
        });

        msNavigationServiceProvider.saveItem('components.charts', {
            title : 'Charts',
            icon  : 'icon-poll',
            weight: 4
        });

        msNavigationServiceProvider.saveItem('components.charts.c3', {
            title: 'C3',
            state: 'app.components_charts_c3'
        });

        msNavigationServiceProvider.saveItem('components.charts.chart-js', {
            title: 'Chart.js',
            state: 'app.components_charts_chart-js'
        });

        msNavigationServiceProvider.saveItem('components.charts.chartist', {
            title: 'Chartist',
            state: 'app.components_charts_chartist'
        });

        msNavigationServiceProvider.saveItem('components.charts.nvd3', {
            title: 'nvD3',
            state: 'app.components_charts_nvd3'
        });

        msNavigationServiceProvider.saveItem('components.maps', {
            title: 'Maps',
            icon : 'icon-map-marker',
            state: 'app.components_maps',
            weight: 5
        });

        msNavigationServiceProvider.saveItem('components.price-tables', {
            title: 'Price Tables',
            icon : 'icon-view-carousel',
            state: 'app.components_price-tables',
            weight: 6
        });

        msNavigationServiceProvider.saveItem('components.tables', {
            title: 'Tables',
            icon : 'icon-table-large',
            weight: 7
        });

        msNavigationServiceProvider.saveItem('components.tables.simple-table', {
            title: 'Simple Table',
            state: 'app.components_tables_simple-table',
            weight: 8
        });

        msNavigationServiceProvider.saveItem('components.tables.datatable', {
            title: 'Datatable',
            state: 'app.components_tables_datatable',
            weight: 9
        });

        msNavigationServiceProvider.saveItem('components.widgets', {
            title: 'Widgets',
            icon : 'icon-apps',
            state: 'app.components_widgets',
            weight: 10
        });
    }
})();
angular.module("fuse").run(["$templateCache", function($templateCache) {$templateCache.put("app/quick-panel/quick-panel.html","<md-content><md-tabs md-no-pagination md-swipe-content md-stretch-tabs=\"always\"><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.TODAY\">TODAY</span></md-tab-label><md-tab-body><md-content class=\"today-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/today/today-tab.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"QUICKPANEL.CHAT\">CHAT</span></md-tab-label><md-tab-body><md-content \nclass=\"chat-tab scrollable\" ms-scroll ng-include=\"\'app/quick-panel/tabs/chat/chat-tab.html\'\" \nng-controller=\"ChatTabController as vm\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label><span \ntranslate=\"QUICKPANEL.ACTIVITY\">ACTIVITY</span></md-tab-label><md-tab-body><md-content class=\"activity-tab scrollable\" \nms-scroll ng-include=\"\'app/quick-panel/tabs/activity/activity-tab.html\'\"></md-content></md-tab-body></md-tab></md-tabs>\n</md-content>");
$templateCache.put("app/core/layouts/content-only.html","<div id=\"layout-content-only\" class=\"template-layout\" layout=\"column\" flex><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content></div>");
$templateCache.put("app/core/layouts/content-with-toolbar.html","<div id=\"layout-content-with-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ui-view=\"content\" flex></md-content><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/layouts/horizontal-navigation.html","<div id=\"layout-horizontal-navigation\" class=\"template-layout\" layout=\"column\" flex><div \nid=\"toolbar-navigation-container\" class=\"md-whiteframe-1dp\" layout=\"column\" layout-align=\"space-between start\">\n<md-toolbar id=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"horizontal-navigation\" ui-view=\"navigation\" layout=\"row\" layout-align=\"start end\" flex></div></div><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar-2.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar-2\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation-fullwidth-toolbar.html","<div id=\"layout-vertical-navigation-fullwidth-toolbar\" class=\"template-layout\" layout=\"column\" flex><md-toolbar \nid=\"toolbar\" class=\"md-menu-toolbar md-whiteframe-1dp md-accent\" ui-view=\"toolbar\"></md-toolbar><div \nid=\"main-container\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" class=\"md-primary-bg\" \nmd-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll ui-view=\"navigation\"></md-sidenav><div \nid=\"content-container\" flex layout=\"column\"><md-content id=\"content\" class=\"animate-slide-up md-hue-2\" ms-scroll \nui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" class=\"md-sidenav-right md-whiteframe-4dp\" \nmd-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav></div></div>");
$templateCache.put("app/core/layouts/vertical-navigation.html","<div id=\"layout-vertical-navigation\" class=\"template-layout\" layout=\"row\" flex><md-sidenav id=\"vertical-navigation\" \nclass=\"md-primary-bg\" md-is-locked-open=\"$mdMedia(\'gt-sm\')\" md-component-id=\"navigation\" ms-scroll \nui-view=\"navigation\"></md-sidenav><div id=\"content-container\" flex layout=\"column\"><md-toolbar id=\"toolbar\" \nclass=\"md-menu-toolbar md-whiteframe-1dp\" ui-view=\"toolbar\"></md-toolbar><md-content id=\"content\" \nclass=\"animate-slide-up md-hue-2\" ms-scroll ui-view=\"content\" flex></md-content></div><md-sidenav id=\"quick-panel\" \nclass=\"md-sidenav-right md-whiteframe-4dp\" md-component-id=\"quick-panel\" ms-scroll ui-view=\"quickPanel\"></md-sidenav>\n</div>");
$templateCache.put("app/core/theme-options/theme-options.html","<div class=\"ms-theme-options-button md-primary-bg\" ng-click=\"toggleOptionsSidenav()\"><md-icon md-font-icon=\"icon-cog\" \nclass=\"white-text\"></md-icon></div><md-sidenav md-component-id=\"fuse-theme-options\" class=\"md-sidenav-right\"><div \nclass=\"ms-theme-options-list\" layout=\"column\"><div class=\"theme-option layout-options\"><div class=\"option-title\">\nLayout Style:</div><md-radio-group layout=\"row\" layout-align=\"start start\" layout-wrap ng-model=\"vm.layoutStyle\" \nng-change=\"vm.updateLayoutStyle()\"><md-radio-button ng-repeat=\"layoutStyle in vm.layoutStyles\" \nng-value=\"layoutStyle.value\"><div layout=\"column\" layout-align=\"center center\"><img ng-src=\"{{layoutStyle.figure}}\"> \n<span class=\"text-center font-size-12 mt-8\">{{layoutStyle.label}}</span></div></md-radio-button></md-radio-group></div>\n<md-divider></md-divider><div class=\"theme-option\"><div class=\"option-title\">Layout Mode:</div><md-radio-group \nlayout=\"row\" layout-align=\"start center\" ng-model=\"vm.layoutMode\" ng-change=\"vm.updateLayoutMode()\"><md-radio-button \nng-repeat=\"layoutMode in vm.layoutModes\" ng-value=\"layoutMode.value\">{{layoutMode.label}}</md-radio-button>\n</md-radio-group></div><md-divider></md-divider><div class=\"theme-option color-palettes\"><div class=\"option-title\">\nColor Palette:</div><div layout=\"row\" layout-align=\"start start\" layout-wrap><md-button \nng-repeat=\"(themeName, theme) in vm.themes.list\" class=\"md-raised theme-button\" layout=\"row\" \nlayout-align=\"center center\" aria-label=\"{{themeName}}\" ng-click=\"vm.setActiveTheme(themeName)\" \nng-style=\"{\'background-color\': theme.primary.color,\'border-color\': theme.accent.color,\'color\': theme.primary.contrast1}\" \nng-class=\"{active: vm.getActiveTheme().name === themeName}\"><md-icon ng-style=\"{\'color\': theme.primary.contrast1}\" \nmd-font-icon=\"icon-palette\" class=\"icon s32\"></md-icon></md-button></div></div></div></md-sidenav>");
$templateCache.put("app/core/directives/ms-info-bar/ms-info-bar.html","<div id=\"ms-info-bar\" layout=\"row\" layout-align=\"start center\" flex><div id=\"ms-info-bar-message\" ng-transclude flex>\n</div><md-button id=\"ms-info-bar-close\" class=\"md-icon-button\" aria-label=\"Close\" ng-click=\"removeInfoBar()\"><md-icon \nmd-font-icon=\"icon-close s24\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-material-color-picker/ms-material-color-picker.html","<md-menu md-position-mode=\"target-right target\"><div ng-click=\"$mdOpenMenu($event)\"><ms-color-picker-button><md-button \naria-label=\"Row Color\" md-menu-origin ng-click=\"$mdOpenMenu($event)\" ng-class=\"vm.selectedColor.class\"><span \nng-show=\"vm.selectedColor.palette\">{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span \nng-show=\"!vm.selectedColor.palette\">Select Color</span></md-button></ms-color-picker-button></div><md-menu-content \nclass=\"ms-material-color-picker-menu-content\" layout-column><header \nng-class=\"vm.selectedColor.class || \'md-accent-bg\'\" class=\"md-whiteframe-4dp\" layout=\"row\" \nlayout-align=\"space-between center\"><md-button md-prevent-menu-close ng-click=\"vm.activateHueSelection(false,false)\" \nclass=\"md-icon-button\" ng-class=\"{\'hidden\':!vm.selectedPalette}\" aria-label=\"Palette\"><md-icon \nmd-font-icon=\"icon-arrow-left\" class=\"s20\"></md-icon></md-button><span ng-if=\"vm.selectedColor.palette\">\n{{vm.selectedColor.palette}} {{vm.selectedColor.hue}} </span><span ng-if=\"!vm.selectedColor.palette\">Select Color\n</span><md-button class=\"remove-color-button md-icon-button\" ng-click=\"vm.removeColor()\" aria-label=\"Remove Color\">\n<md-icon md-font-icon=\"icon-delete\" class=\"s20\"></md-icon></md-button></header><div class=\"colors\" ms-scroll><div \nng-show=\"!vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" ng-class=\"\'md-\'+palette+\'-500-bg\'\" \nng-repeat=\"(palette, hues) in vm.palettes\" ng-click=\"vm.activateHueSelection(palette,hues)\" layout=\"row\" \nlayout-align=\"start end\" md-prevent-menu-close md-ink-ripple><span class=\"label\">{{palette}}</span></div></div><div \nng-show=\"vm.selectedPalette\" layout=\"row\" layout-wrap><div class=\"color\" \nng-class=\"\'md-\'+vm.selectedPalette+\'-\'+hue+\'-bg\'\" ng-repeat=\"(hue, values) in vm.selectedHues\" \nng-click=\"vm.selectColor(vm.selectedPalette,hue)\" layout=\"row\" layout-align=\"start end\" md-ink-ripple><span \nclass=\"label\">{{hue}} </span><i ng-if=\"vm.selectedPalette == vm.selectedColor.palette && hue == vm.selectedColor.hue\" \nclass=\"s16 icon-check\"></i></div></div></div></md-menu-content></md-menu>");
$templateCache.put("app/core/directives/ms-search-bar/ms-search-bar.html","<div flex layout=\"row\" layout-align=\"start center\"><label for=\"ms-search-bar-input\"><md-button \nclass=\"ms-search-bar-expander md-icon-button\" aria-label=\"Expand Search Bar\" ng-click=\"MsSearchBar.expand()\" \nng-if=\"!MsSearchBar.resultsLoading || MsSearchBar.collapsed\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\">\n</md-icon></md-button><div class=\"ms-search-bar-loader\" layout=\"row\" layout-align=\"center center\" \nng-if=\"MsSearchBar.resultsLoading && !MsSearchBar.collapsed\"><md-progress-circular class=\"md-accent\" md-diameter=\"32\" \nmd-mode=\"indeterminate\"></md-progress-circular></div></label><input id=\"ms-search-bar-input\" type=\"text\" \nplaceholder=\"Search\" flex ng-model=\"MsSearchBar.query\" ng-model-options=\"MsSearchBar.queryOptions\" \nng-blur=\"MsSearchBar.collapse()\" ng-keydown=\"MsSearchBar.handleKeydown($event)\"><md-button \nclass=\"ms-search-bar-collapser md-icon-button\" ng-click=\"MsSearchBar.collapse()\" aria-label=\"Collapse Search Bar\">\n<md-icon md-font-icon=\"icon-close\" class=\"icon s24\"></md-icon></md-button><div class=\"ms-search-bar-results\" \nng-if=\"MsSearchBar.results\" ms-scroll><div class=\"no-results\" ng-if=\"MsSearchBar.results.length === 0\">No Results!\n</div><div class=\"result\" ng-repeat=\"result in MsSearchBar.results\" ng-click=\"MsSearchBar.handleResultClick(result)\" \nng-mouseenter=\"MsSearchBar.handleMouseenter($index)\" ng-mousedown=\"MsSearchBar.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsSearchBar.selectedResultIndex}\" md-ink-ripple><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"icon-container\" layout=\"row\" layout-align=\"center center\"><i \nng-if=\"result.icon\" class=\"icon {{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div>\n<div><div class=\"title\">{{result.title}}</div><div class=\"description\" ng-if=\"result.description\">\n{{result.description}}</div></div></div></div></div></div>");
$templateCache.put("app/core/directives/ms-shortcuts/ms-shortcuts.html","<div class=\"shortcuts-container\" layout=\"row\" layout-align=\"space-between center\" flex \nng-class=\"{\'mobile-bar-active\': MsShortcuts.mobileBarActive}\"><div class=\"flex-noshrink\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"shortcuts hide show-gt-xs\" layout=\"row\" layout-align=\"start center\" \nms-scroll ng-if=\"MsShortcuts.shortcuts.length > 0\" ng-sortable=\"MsShortcuts.sortableOptions\"><div \nng-repeat=\"shortcut in MsShortcuts.shortcuts\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button shortcut\" aria-label=\"{{shortcut.title}}\" ui-sref=\"{{shortcut.uisref}}\"><md-icon \nng-if=\"shortcut.icon\" md-font-icon=\"{{shortcut.icon}}\" class=\"icon s24\"></md-icon><div ng-if=\"!shortcut.icon\" \nclass=\"first-letter\">{{shortcut.title.charAt(0)}}</div><md-tooltip md-direction=\"bottom\">{{shortcut.title}}\n</md-tooltip></md-button></div></div><md-menu md-offset=\"8 56\" class=\"shortcut-menu hide show-gt-xs\"><md-button \nclass=\"md-icon-button add-shortcut-button\" aria-label=\"Add shortcut\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-menu-origin md-font-icon=\"icon-star\" class=\"icon amber-600-fg s24\"></md-icon><md-tooltip md-direction=\"bottom\">\nClick to add/remove shortcut</md-tooltip></md-button><md-menu-content><div id=\"ms-shortcut-add-menu\"><div \nclass=\"shortcut-search\" layout=\"row\" layout-align=\"start center\"><div class=\"search-icon\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"!MsShortcuts.resultsLoading\"><md-icon md-menu-align-target \nmd-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon></div><div class=\"shortcut-loader\" layout=\"row\" \nlayout-align=\"center center\" ng-if=\"MsShortcuts.resultsLoading\"><md-progress-circular class=\"md-accent\" \nmd-diameter=\"20\" md-mode=\"indeterminate\"></md-progress-circular></div><input type=\"text\" placeholder=\"Search\" flex \nng-model=\"MsShortcuts.query\" ng-model-options=\"MsShortcuts.queryOptions\" \nng-keydown=\"MsShortcuts.handleKeydown($event)\"></div><div class=\"results\" ng-if=\"MsShortcuts.results\" ms-scroll><div \nclass=\"no-results\" ng-if=\"MsShortcuts.results.length === 0\">No Results!</div><div class=\"result\" \nng-repeat=\"result in MsShortcuts.results\" ng-click=\"MsShortcuts.handleResultClick(result)\" \nng-mouseenter=\"MsShortcuts.handleMouseenter($index)\" ng-mousedown=\"MsShortcuts.absorbEvent($event)\" \nng-class=\"{\'selected\': $index == MsShortcuts.selectedResultIndex}\" md-prevent-menu-close=\"md-prevent-menu-close\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start space-between\"><div layout=\"row\" layout-align=\"start center\" flex>\n<div class=\"icon icon-container\" layout=\"row\" layout-align=\"center center\"><i ng-if=\"result.icon\" \nclass=\"{{result.icon}}\"></i><div ng-if=\"!result.icon\" class=\"square md-accent-bg\"></div></div><div><div class=\"title\">\n{{result.title}}</div></div></div><md-icon md-font-icon=\"icon-pin\" class=\"icon s18\" \nng-class=\"{\'fade-text\': !result.hasShortcut}\"></md-icon></div></div></div></div></md-menu-content></md-menu></div>\n<md-button class=\"md-icon-button toggle-mobile-menu hide-gt-xs\" aria-label=\"Add shortcut\" \nng-click=\"MsShortcuts.toggleMobileBar()\"><md-icon md-menu-origin md-font-icon=\"icon-star\" \nclass=\"icon amber-600-fg s24\" ng-hide=\"MsShortcuts.mobileBarActive\"></md-icon><md-icon md-menu-origin \nmd-font-icon=\"icon-close\" class=\"icon s24\" ng-hide=\"!MsShortcuts.mobileBarActive\"></md-icon></md-button></div>");
$templateCache.put("app/main/apps/calendar/calendar.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header\" \nng-class=\"vm.currentMonthShort\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-top\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span \nclass=\"logo-text\" translate=\"CALENDAR.CALENDAR\">Calendar</span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" aria-label=\"Search\" translate \ntranslate-attr-aria-label=\"CALENDAR.SEARCH\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.SEARCH\">Search</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.today()\" aria-label=\"Today\" translate translate-attr-aria-label=\"CALENDAR.TODAY\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span translate=\"CALENDAR.TODAY\">Today</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" \ntranslate translate-attr-aria-label=\"CALENDAR.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.DAY\">Day</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"Week\" translate translate-attr-aria-label=\"CALENDAR.WEEK\">\n<md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span translate=\"CALENDAR.WEEK\">Week</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate \ntranslate-attr-aria-label=\"CALENDAR.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.MONTH\">Month</span></md-tooltip></md-button></div></div><div class=\"header-bottom\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" \naria-label=\"Previous\" translate translate-attr-aria-label=\"CALENDAR.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button \nclass=\"md-icon-button arrow\" ng-click=\"vm.calendar.next()\" aria-label=\"Next\" translate \ntranslate-attr-aria-label=\"CALENDAR.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div>\n<md-button class=\"add-event-button md-fab md-warn\" ng-click=\"vm.addEvent($event)\" aria-label=\"Add event\" translate \ntranslate-attr-aria-label=\"CALENDAR.ADD_EVENT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nclass=\"content\"><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\">\n</div></div></div>");
$templateCache.put("app/main/apps/chat/chat.html","<div id=\"chat-app\" class=\"page-layout carded fullwidth\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\"><div\n class=\"content-card\" layout=\"row\" flex><md-sidenav class=\"sidenav left-sidenav md-sidenav-left\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"left-sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/apps/chat/sidenavs/left/left-sidenav.html\'\" layout=\"column\"></md-sidenav><div \nclass=\"start-point\" ng-if=\"!vm.chat\" flex layout=\"column\" flex layout-align=\"center center\"><div \nclass=\"big-circle md-whiteframe-4dp\"><md-icon class=\"s128 md-accent\" md-font-icon=\"icon-hangouts\"></md-icon></div><span\n class=\"app-title\" translate=\"CHAT.APP_TITLE\">Chat App</span> <span class=\"hide show-gt-md secondary-text\" \ntranslate=\"CHAT.START_MESSAGE\">Select contact to start the chat!..</span><md-button class=\"md-raised hide-gt-md\" \nng-click=\"vm.toggleSidenav(\'left-sidenav\')\" translate=\"CHAT.START_MESSAGE\">Select contact to start the chat!..\n</md-button></div><div ng-if=\"vm.chat\" class=\"chat\" layout=\"column\" flex><md-toolbar class=\"chat-toolbar\"><div \nclass=\"md-toolbar-tools\"><md-button class=\"hide-gt-md responsive-chats-button md-icon-button\" \nng-click=\"vm.toggleLeftSidenavView(false);vm.toggleSidenav(\'left-sidenav\')\" aria-label=\"chats button\"><md-icon \nmd-font-icon=\"icon-hangouts s36\"></md-icon></md-button><div class=\"chat-contact\" layout=\"row\" \nlayout-align=\"start center\" ng-click=\"vm.toggleSidenav(\'right-sidenav\')\"><div class=\"avatar-wrapper\"><img \nng-src=\"{{vm.contacts.getById(vm.chatContactId).avatar}}\" class=\"avatar\" \nalt=\"{{vm.contacts.getById(vm.chatContactId).name}}\"> <i class=\"icon icon- s16 status\" \nng-class=\"vm.contacts.getById(vm.chatContactId).status\"></i></div><div class=\"chat-contact-name\">\n{{vm.contacts.getById(vm.chatContactId).name}}</div></div><md-menu md-position-mode=\"target-right target\"><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.toggleSidenav(\'right-sidenav\')\" \ntranslate=\"CHAT.CONTACT_INFO\">Contact Info</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.clearMessages()\" translate=\"CHAT.CLEAR_MESSAGES\">Clear Messages</md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-toolbar><md-content id=\"chat-content\" flex ms-scroll><div class=\"chat-messages\" \nng-if=\"vm.chat\"><div layout=\"row\" ng-repeat=\"dialog in vm.chat\" class=\"md-padding message-row\" ng-class=\"dialog.who\">\n<img ng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.contacts.getById(vm.chatContactId).avatar}}\" class=\"avatar\" \nalt=\"{{vm.contacts.getById(vm.chatContactId).name}}\"> <img ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" \nng-src=\"{{vm.user.avatar}}\"><div class=\"bubble\"><div class=\"message\">{{dialog.message}}</div><div \nclass=\"time secondary-text\">{{dialog.time | altDate}}</div></div></div></div></md-content><div \nclass=\"chat-footer flex-noshrink\" layout=\"row\" layout-align=\"center center\"><form ng-submit=\"vm.reply()\" flex \nclass=\"reply-form\" layout=\"row\" layout-align=\"start center\"><md-input-container flex md-no-float><textarea \nng-keyup=\"vm.reply($event)\" md-no-autogrow ng-model=\"vm.replyMessage\" ng-class=\"{\'grow\': vm.textareaGrow}\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"CHAT.REPLY_PLACEHOLDER\">\n                            </textarea></md-input-container><md-button class=\"md-fab\" type=\"submit\" \naria-label=\"Send message\" translate translate-attr-aria-label=\"CHAT.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\">\n</md-icon></md-button></form></div></div><md-sidenav class=\"sidenav right-sidenav md-sidenav-right\" layout=\"column\" \nmd-component-id=\"right-sidenav\" ms-sidenav-helper ng-include=\"\'app/main/apps/chat/sidenavs/right/right-sidenav.html\'\">\n</md-sidenav></div></div></div>");
$templateCache.put("app/main/apps/contacts/contacts.html","<div id=\"contacts\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" \ntranslate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span><span class=\"logo-text\" translate=\"CONTACTS.CONTACTS\">\nContacts</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label \nfor=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input \nid=\"search\" placeholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"CONTACTS.SEARCH_FOR_ANYONE\"></md-input-container></div></div><div \nng-show=\"vm.selectedContacts.length > 0\" class=\"selected-bar header animate-slide-down md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"close-button-wrapper\" ng-click=\"vm.selectedContacts =[]\"><md-button \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"mr-8\"></md-icon><span \ntranslate=\"CONTACTS.BACK\">Back</span></md-button></div><div flex layout=\"row\" layout-align=\"space-between center\"><div>\n<span class=\"selected-contacts-count\"><span>{{vm.selectedContacts.length}}</span> <span translate=\"CONTACTS.SELECTED\">\nselected</span></span><md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"multi select toggle\" translate \ntranslate-attr-aria-label=\"CONTACTS.MULTI_SELECT_TOGGLE\"><md-icon md-font-icon=\"icon-menu-down\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectAllContacts()\" translate=\"CONTACTS.SELECT_ALL\">\nSelect all</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deselectContacts()\" \ntranslate=\"CONTACTS.SELECT_NONE\">Select none</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"multi-select-actions\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteSelectedContacts($event)\" \naria-label=\"delete selected\" translate translate-attr-label=\"CONTACTS.DELETE_SELECTED\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon></md-button></div></div></div><div class=\"content\" md-background-bg layout=\"row\" \nlayout-align=\"start start\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" ms-scroll \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" layout=\"column\" flex=\"100\" md-component-id=\"sidenav\" ms-sidenav-helper \nng-include=\"\'app/main/apps/contacts/sidenavs/main/main-sidenav.html\'\"></md-sidenav><div class=\"main scrollable\" \nms-scroll><md-list class=\"contacts-list\"><md-subheader class=\"md-no-sticky md-white-bg\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"list-title\" layout=\"row\" layout-align=\"start center\" \nng-hide=\"editGroupForm.$visible\"><span ng-if=\"vm.listType === \'all\'\" translate=\"CONTACTS.ALL_CONTACTS\">All contacts\n</span> <span ng-if=\"vm.listType === \'frequent\'\" translate=\"CONTACTS.FREQUENTLY_CONTACTED\">Frequnetly contacted</span> \n<span ng-if=\"vm.listType === \'starred\'\" translate=\"CONTACTS.STARRED_CONTACTS\">Starred contacts</span> <span \nng-if=\"vm.listType.name\">{{vm.listType.name}}</span> <span ng-if=\"filteredContacts.length\" \nclass=\"secondary-text contacts-count\">({{filteredContacts.length}})</span></div><div class=\"edit-group-form\" \nng-show=\"vm.listType.name\" layout=\"row\" layout-align=\"start center\"><span ng-show=\"editGroupForm.$visible\" \neditable-text=\"vm.listType.name\" e-form=\"editGroupForm\" onaftersave=\"vm.editGroup()\"></span><md-button \nclass=\"md-icon-button edit-group-button\" ng-click=\"editGroupForm.$show()\" ng-hide=\"editGroupForm.$visible\" \naria-label=\"edit group name\" translate translate-attr-label=\"CONTACTS.EDIT_GROUP_NAME\"><md-icon \nmd-font-icon=\"icon-pencil s18\"></md-icon></md-button><md-button class=\"md-icon-button edit-group-button\" \nng-click=\"vm.deleteGroup($event)\" ng-hide=\"editGroupForm.$visible\" aria-label=\"delete group\" translate \ntranslate-attr-label=\"CONTACTS.DELETE_GROUP\"><md-icon md-font-icon=\"icon-delete s18\"></md-icon></md-button></div><div \nflex></div><md-menu><md-button class=\"md-icon-button\" aria-label=\"Sort\" translate \ntranslate-attr-aria-label=\"CONTACTS.SORT\"><md-icon md-font-icon=\"icon-sort-alphabetical\" \nng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.listOrder = \'name\';vm.listOrderAsc = false\" \nng-style=\"vm.listOrder === \'name\' && vm.listOrderAsc=== false && {\'font-weight\':\'500\'}\"><span \ntranslate=\"CONTACTS.FIRST_NAME\">First Name</span> <small translate=\"CONTACTS.A_TO_Z\">(A to Z)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.listOrder = \'name\'; vm.listOrderAsc = true\" \nng-style=\"vm.listOrder === \'name\' && vm.listOrderAsc=== true && {\'font-weight\':\'500\'}\"><span \ntranslate=\"CONTACTS.FIRST_NAME\">First Name</span> <small translate=\"CONTACTS.Z_TO_A\">(Z to A)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.listOrder = \'lastName\';vm.listOrderAsc = false\" \nng-style=\"vm.listOrder === \'lastName\' && vm.listOrderAsc=== false && {\'font-weight\':\'500\'}\"><span \ntranslate=\"CONTACTS.LAST_NAME\">Last Name</span> <small translate=\"CONTACTS.A_TO_Z\">(A to Z)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.listOrder = \'lastName\'; vm.listOrderAsc = true\" \nng-style=\"vm.listOrder === \'lastName\' && vm.listOrderAsc=== true && {\'font-weight\':\'500\'}\"><span \ntranslate=\"CONTACTS.LAST_NAME\">Last Name</span> <small translate=\"CONTACTS.Z_TO_A\">(Z to A)</small></md-button>\n</md-menu-item></md-menu-content></md-menu></div></md-subheader><md-list-item class=\"contact-item md-white-bg\" \nmd-ink-ripple \nng-repeat=\"contact in vm.contacts | filter: vm.search | filter: global.search | filterByIds:vm.filterIds |  orderBy: vm.listOrder :vm.listOrderAsc | filter:query as filteredContacts track by contact.id \" \nng-click=\"vm.openContactDialog($event, contact)\" \nng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': filteredContacts.length - $index}\" \nng-class=\"{\'selected\': vm.isSelected(contact)}\"><md-checkbox ng-checked=\"vm.exists(contact, vm.selectedContacts)\" \nng-click=\"vm.toggleSelectContact(contact, $event)\" \naria-label=\"{{vm.exists(contact, vm.selectedContacts) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><img class=\"md-avatar\" \nng-if=\"contact.avatar\" alt=\"{{contact.name}}\" ng-src=\"{{contact.avatar}}\"><p class=\"text-truncate font-weight-600\">\n{{contact.name}} {{contact.lastName}}</p><p class=\"email text-truncate hide show-gt-sm\">{{contact.email}}</p><p \nclass=\"phone text-truncate hide show-gt-md\">{{contact.phone}}</p><p class=\"job-title text-truncate hide show-gt-lg\">\n{{contact.jobTitle}}</p><p class=\"company text-truncate hide show-gt-lg\">{{contact.company}}</p><div class=\"actions\" \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button hide show-gt-xs\" \nng-click=\"$event.stopPropagation();vm.toggleInArray(contact.id, vm.user.starred)\" aria-label=\"Toggle starred\" \ntranslate translate-attr-aria-label=\"CONTACTS.TOGGLE_STARRED\"><md-icon ng-if=\"vm.exists(contact.id,vm.user.starred)\" \nmd-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon ng-if=\"!vm.exists(contact.id,vm.user.starred)\" \nmd-font-icon=\"icon-star-outline\"></md-icon></md-button><md-menu><md-button class=\"md-icon-button\" aria-label=\"More\" \ntranslate translate-attr-aria-label=\"CONTACTS.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\" \nng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.deleteContactConfirm(contact, ev)\" translate=\"CONTACTS.DELETE_CONTACT\">Delete Contact</md-button>\n</md-menu-item><md-divider ng-if=\"vm.user.groups\"></md-divider><md-subheader class=\"md-no-sticky\" \nng-if=\"vm.user.groups\">Groups</md-subheader><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" \nng-click=\"vm.toggleInArray(contact.id,group.contactIds)\"><p class=\"pl-8\" \nng-style=\"vm.exists(contact.id,group.contactIds) && {\'font-weight\':\'500\'}\">{{group.name}}</p></md-list-item>\n</md-menu-content></md-menu></div></md-list-item></md-list><md-list-item class=\"no-results md-white-bg\" \nng-show=\"filteredContacts.length === 0\"><p translate=\"CONTACTS.NO_RESULTS\">No results..</p></md-list-item></div></div>\n<md-button class=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.openContactDialog($event)\" \naria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/apps/mail/mail.html","<div id=\"mail\" class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav \nclass=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"main-sidenav\" \nng-include=\"\'app/main/apps/mail/sidenavs/main/main-sidenav.html\'\" ms-scroll ms-sidenav-helper></md-sidenav><div \nclass=\"center\" layout=\"column\" flex><div class=\"header\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"search-wrapper md-whiteframe-4dp\" layout=\"row\" layout-align=\"start center\" flex><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'main-sidenav\')\" hide-gt-md \naria-label=\"Toggle Sidenav\" translate translate-attr-aria-label=\"MAIL.TOGGLE_SIDENAV\"><md-icon class=\"icon\" \nmd-font-icon=\"icon-menu\"></md-icon></md-button><div class=\"search\" flex layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-magnify\" class=\"icon s24\"></md-icon><input flex ng-model=\"vm.search\" type=\"text\" \nplaceholder=\"Search for an e-mail or contact\" translate translate-attr-placeholder=\"MAIL.SEARCH_PLACEHOLDER\"></div>\n</div></div><div class=\"content-card\" ng-class=\"vm.currentView\" layout=\"column\" flex \nng-include=\"vm.views[vm.currentView]\"></div></div></div>");
$templateCache.put("app/main/apps/notes/notes.html","<div id=\"notes\" class=\"\" layout=\"column\"><md-sidenav class=\"sidenav main-sidenav md-white-bg\" ms-scroll \nmd-component-id=\"main-sidenav\" ms-sidenav-helper ng-include=\"\'app/main/apps/notes/sidenavs/main/main-sidenav.html\'\">\n</md-sidenav><md-toolbar class=\"md-accent\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'main-sidenav\')\" aria-label=\"Toggle sidenav\" translate \ntranslate-attr-aria-label=\"NOTES.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button>\n<div class=\"main-title\" layout=\"row\" layout-align=\"start center\"><md-icon class=\"logo-icon mr-8\" \nmd-font-icon=\"icon-lightbulb\"></md-icon><span class=\"title\" ng-if=\"vm.noteListType === \'notes\'\" \ntranslate=\"NOTES.NOTES\">Notes</span> <span class=\"title\" ng-if=\"vm.noteListType === \'reminders\'\" \ntranslate=\"NOTES.REMINDERS\">Reminders</span> <span class=\"title\" ng-if=\"vm.noteListType === \'archive\'\" \ntranslate=\"NOTES.ARCHIVE\">Archive</span> <span class=\"title\" ng-if=\"vm.noteListType.name\">{{vm.noteListType.name}}\n</span> <span ng-if=\"filteredNotes.length\" class=\"pl-8 white-text secondary-text notes-count\">\n({{filteredNotes.length}})</span></div></div><div flex></div><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.openSearchToolbar()\" aria-label=\"open search toolbar\" translate \ntranslate-attr-aria-label=\"NOTES.OPEN_SEARCH_TOOLBAR\"><md-icon md-font-icon=\"icon-magnify\" class=\"icon\"></md-icon>\n</md-button></div><div ng-show=\"vm.searchToolbar\" \nclass=\"md-toolbar-tools search-toolbar animate-slide-down md-accent-bg\" layout=\"row\" layout-align=\"start center\">\n<md-button class=\"md-icon-button\" ng-click=\"vm.closeSearchToolbar()\" translate translate-attr-aria-label=\"NOTES.CLOSE\" \naria-label=\"close\"><md-icon md-font-icon=\"icon-close\" class=\"mr-8\"></md-icon></md-button><input \nid=\"search-notes-input\" placeholder=\"Search notes\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"NOTES.SEARCH_NOTES\" ng-model-options=\"{\'debounce\': 200}\" flex></div></md-toolbar>\n<md-content ms-scroll flex><ms-new-note ng-hide=\"vm.noteListType === \'archive\'\" class=\"md-whiteframe-2dp\">\n</ms-new-note><ms-masonry class=\"notes\" options=\'{\"columnCount\":5}\'><ms-masonry-item class=\"note\" \nng-repeat=\"note in vm.notes | filter:vm.search | filter:vm.filters | filterByPropIds:\'labels\':vm.labelFilterIds |  orderBy: \'time\':true | filter:query as filteredNotes track by note.id \" \nms-note-item=\"note\" ng-click=\"vm.editNote($event, note.id)\"></ms-masonry-item></ms-masonry><div \nclass=\"no-results text-center\" ng-if=\"filteredNotes.length === 0 &&  vm.search === \'\'\"><div class=\"message\" \nng-if=\"vm.noteListType === \'notes\'\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-lightbulb\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_NOTES_YET\">No notes yet...</div></div><div class=\"message\" \nng-if=\"vm.noteListType === \'reminders\'\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-bell\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_NOTES_WITH_REMINDERS\">No notes with reminders</div></div><div class=\"message\" \nng-if=\"vm.noteListType === \'archive\'\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-archive\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_ARCHIVED_NOTES\">No archived Notes</div></div><div class=\"message\" \nng-if=\"vm.noteListType.name\"><md-icon class=\"message-icon s96\" md-font-icon=\"icon-label\"></md-icon><div \nclass=\"message-text\" translate=\"NOTES.NO_NOTES_WITH_THIS_LABEL\">No notes with this label</div></div></div><div \nclass=\"no-results text-center\" ng-if=\"filteredNotes.length === 0 &&  vm.search !== \'\'\"><div class=\"message\"><md-icon \nclass=\"message-icon s96\" md-font-icon=\"icon-lightbulb\"></md-icon><div class=\"message-text\" \ntranslate=\"NOTES.NO_RESULTS\">No results...</div></div></div></md-content></div>");
$templateCache.put("app/main/components/cards/cards.html","<div id=\"cards\" class=\"page-layout simple fullwidth doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span></div><div \nclass=\"title\">Cards</div></div></div><div class=\"content\" md-background-bg><p>\nCards are useful for showing excerpts, quick information or notifications. Using <code>ms-card</code>\n directive you can easily create different cards compatible with Google\'s Material Design specifications.</p><p><code>\nms-card</code>\n directive templates have pre-defined content areas. The reason for that is to force you to create cards that follows both Google\'s Material Design specifications and Fuse Theme\'s general design rules. But of course you can create your own designs and templates and use them with \n<code>ms-card</code> directive.</p><div><div class=\"md-title mt-32\">Template 1</div><ms-card \ntemplate=\"\'app/core/directives/ms-card/templates/template-1/template-1.html\'\" ng-model=\"vm.cards[0]\"></ms-card><div \nclass=\"md-title mt-48\">Template 2</div><ms-card \ntemplate=\"\'app/core/directives/ms-card/templates/template-2/template-2.html\'\" ng-model=\"vm.cards[1]\"></ms-card><div \nclass=\"md-title mt-48\">Template 3</div><ms-card \ntemplate=\"\'app/core/directives/ms-card/templates/template-3/template-3.html\'\" ng-model=\"vm.cards[2]\"></ms-card><div \nclass=\"md-title mt-48\">Template 4</div><ms-card \ntemplate=\"\'app/core/directives/ms-card/templates/template-4/template-4.html\'\" ng-model=\"vm.cards[3]\"></ms-card><div \nclass=\"md-title mt-48\">Template 5</div><ms-card \ntemplate=\"\'app/core/directives/ms-card/templates/template-5/template-5.html\'\" ng-model=\"vm.cards[4]\"></ms-card><div \nclass=\"md-title mt-48\">Template 6</div><ms-card \ntemplate=\"\'app/core/directives/ms-card/templates/template-6/template-6.html\'\" ng-model=\"vm.cards[5]\"></ms-card><div \nclass=\"md-title mt-48\">Template 7</div><ms-card \ntemplate=\"\'app/core/directives/ms-card/templates/template-7/template-7.html\'\" ng-model=\"vm.cards[6]\"></ms-card><div \nclass=\"md-title mt-48\">Template 8</div><ms-card \ntemplate=\"\'app/core/directives/ms-card/templates/template-8/template-8.html\'\" ng-model=\"vm.cards[7]\"></ms-card><div \nclass=\"md-title mt-48\">Template 9</div><ms-card \ntemplate=\"\'app/core/directives/ms-card/templates/template-9/template-9.html\'\" ng-model=\"vm.cards[8]\"></ms-card><div \nclass=\"md-title mt-48\">Template 10</div><ms-card \ntemplate=\"\'app/core/directives/ms-card/templates/template-10/template-10.html\'\" ng-model=\"vm.cards[9]\"></ms-card></div>\n</div></div>");
$templateCache.put("app/main/components/maps/maps.html","<div id=\"maps\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span></div><div \nclass=\"title\">Maps</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"http://angular-ui.github.io/angular-google-maps/\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><md-nav-bar \nmd-selected-nav-item=\"vm.selectedNavItem\" nav-bar-aria-label=\"Maps\"><md-nav-item md-nav-sref=\"app.components_maps\" \nname=\"simpleMap\">Simple Map</md-nav-item><md-nav-item md-nav-sref=\"app.components_maps.satellite\" name=\"satelliteMap\">\nSatellite Map</md-nav-item><md-nav-item md-nav-sref=\"app.components_maps.terrain\" name=\"terrainMap\">Terrain Map\n</md-nav-item><md-nav-item md-nav-sref=\"app.components_maps.simple-marker\" name=\"simpleMarkerMap\">Simple Marker\n</md-nav-item><md-nav-item md-nav-sref=\"app.components_maps.custom-marker\" name=\"customMarkerMap\">Custom Marker\n</md-nav-item><md-nav-item md-nav-sref=\"app.components_maps.info-window\" name=\"infoWindowMap\">Info Window</md-nav-item>\n</md-nav-bar><md-content ui-view=\"tabContent\" flex class=\"card md-whiteframe-4dp\"></md-content></div></div>");
$templateCache.put("app/main/components/material-docs/material-doc-basic-template.html","<div class=\"doc-page material-docs layout-docs doc-template page-layout simple fullwidth\" layout=\"column\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\n{{vm.parentTitle}}</span></div><div class=\"title\">{{vm.component.name}}</div></div></div><div flex class=\"content\"><a \nclass=\"reference-link md-yellow-200-bg\" \nhref=\"https://material.angularjs.org/{{vm.materialVersion}}/{{vm.component.url}}\" target=\"_blank\">\nGo to official Angular Material <b>{{vm.component.name}}</b> documentation page</a><div \nng-include=\"\'app/main/components/material-docs/\'+vm.component.templateUrl\"></div></div></div>");
$templateCache.put("app/main/components/material-docs/material-doc-template.html","<div class=\"doc-page material-docs doc-template page-layout simple tabbed\" layout=\"column\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">\nANGULAR MATERIAL ELEMENTS</span></div><div class=\"title\">{{vm.componentName}}</div></div></div><div flex \nclass=\"content\"><md-tabs md-selected=\"selectedIndex\" md-dynamic-height><md-tab ng-if=\"vm.demo\"><md-tab-label>\n{{vm.demo.label}} (Demo)</md-tab-label><md-tab-body><a class=\"reference-link md-yellow-200-bg\" \nhref=\"https://material.angularjs.org/{{vm.materialVersion}}/demo/{{vm.demo.name}}\" target=\"_blank\">\nGo to official Angular Material <b>{{vm.demo.name}}</b> demo page</a><docs-demo ng-repeat=\"demo in vm.demos\" \ndemo-id=\"{{demo.id}}\" demo-title=\"{{demo.label}}\" demo-module=\"{{demo.ngModule.module}}\"><demo-file \nng-repeat=\"file in demo.$files\" name=\"{{file.name}}\" contents=\"file.httpPromise\"></demo-file></docs-demo></md-tab-body>\n</md-tab><md-tab ng-repeat=\"doc in vm.docs\"><md-tab-label>{{doc.name}} ({{doc.type}})</md-tab-label><md-tab-body><a \nclass=\"reference-link md-yellow-200-bg\" \nhref=\"https://material.angularjs.org/{{vm.materialVersion}}/api/{{doc.type}}/{{doc.name}}\" target=\"_blank\">\nGo to official Angular Material <b>{{doc.name}} {{doc.type}}</b> documentation page</a><div class=\"\" \nng-include=\"\'app/main/components/material-docs/\'+doc.outputPath\"></div></md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/components/price-tables/price-tables.html","<div id=\"price-tables\" class=\"page-layout simple fullwidth doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">PAGES</span></div><div \nclass=\"title\">Price Tables</div></div></div><div class=\"content\"><div class=\"md-title\">Style 1</div><div \nclass=\"price-tables\" flex layout=\"row\" layout-wrap><div class=\"price-table style-1 md-whiteframe-1dp\" layout=\"column\">\n<div class=\"package-type md-primary-bg\"><span>BASIC</span></div><div class=\"price\" layout=\"row\" \nlayout-align=\"center start\"><div class=\"currency\">$</div><div layout=\"row\" layout-align=\"center end\"><div \nclass=\"value\">4</div><div class=\"period\">/ month</div></div></div><md-divider></md-divider><div class=\"terms\" \nlayout=\"column\"><div class=\"term\"><span class=\"text-bold\">10</span> Projects</div><div class=\"term\"><span \nclass=\"text-bold\">10</span> Pages</div><div class=\"term\"><span class=\"text-bold\">100</span> Mb Disk Space</div></div>\n<md-button class=\"cta-button md-raised md-accent\">BUY NOW</md-button></div><div \nclass=\"price-table style-1 md-whiteframe-8dp\" layout=\"column\"><div class=\"package-type md-primary-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><span>STANDARD</span> <span class=\"sale md-accent-color md-hue-1\">Save 15%</span>\n</div><div class=\"price\" layout=\"row\" layout-align=\"center start\"><div class=\"currency\">$</div><div layout=\"row\" \nlayout-align=\"center end\"><div class=\"value\">8</div><div class=\"period\">/ month</div></div></div><md-divider>\n</md-divider><div class=\"terms\" layout=\"column\"><div class=\"term\"><span class=\"text-bold\">20</span> Projects</div><div \nclass=\"term\"><span class=\"text-bold\">20</span> Pages</div><div class=\"term\"><span class=\"text-bold\">200</span>\n Mb Disk Space</div></div><md-button class=\"cta-button md-raised md-accent\">BUY NOW</md-button></div><div \nclass=\"price-table style-1 md-whiteframe-1dp\" layout=\"column\"><div class=\"package-type md-primary-bg\" layout=\"row\">\n<span>ADVANCED</span></div><div class=\"price\" layout=\"row\" layout-align=\"center start\"><div class=\"currency\">$</div>\n<div layout=\"row\" layout-align=\"center end\"><div class=\"value\">12</div><div class=\"period\">/ month</div></div></div>\n<md-divider></md-divider><div class=\"terms\" layout=\"column\"><div class=\"term\"><span class=\"text-bold\">40</span>\n Projects</div><div class=\"term\"><span class=\"text-bold\">40</span> Pages</div><div class=\"term\"><span \nclass=\"text-bold\">500</span> Mb Disk Space</div></div><md-button class=\"cta-button md-raised md-accent\">BUY NOW\n</md-button></div></div><div class=\"md-title\">Style 2</div><div class=\"price-tables\" flex layout=\"row\" layout-wrap><div\n class=\"price-table style-2 md-whiteframe-1dp\" layout=\"column\"><div class=\"package-type md-accent-fg\">SILVER PACKAGE\n</div><div class=\"price\" layout=\"row\" layout-align=\"center start\"><div class=\"currency\">$</div><div class=\"value\">99\n</div></div><div class=\"period\">PER MONTH</div><div class=\"terms\" layout=\"column\" layout-align=\"start center\"><div \nclass=\"term\"><span class=\"text-bold\">10</span> Projects</div><div class=\"term\"><span class=\"text-bold\">10</span> Pages\n</div><div class=\"term\"><span class=\"text-bold\">100</span> Mb Disk Space</div></div><md-button \nclass=\"cta-button md-raised md-accent\">GET STARTED</md-button></div><div class=\"price-table style-2 md-whiteframe-8dp\" \nlayout=\"column\"><div class=\"badge md-warn-bg\">BEST VALUE</div><div class=\"package-type md-accent-fg\">GOLD PACKAGE</div>\n<div class=\"price\" layout=\"row\" layout-align=\"center start\"><div class=\"currency\">$</div><div class=\"value\">299</div>\n</div><div class=\"period\">PER MONTH</div><div class=\"terms\" layout=\"column\" layout-align=\"start center\"><div \nclass=\"term\"><span class=\"text-bold\">20</span> Projects</div><div class=\"term\"><span class=\"text-bold\">20</span> Pages\n</div><div class=\"term\"><span class=\"text-bold\">200</span> Mb Disk Space</div></div><md-button \nclass=\"cta-button md-raised md-accent\">GET STARTED</md-button></div><div class=\"price-table style-2 md-whiteframe-1dp\" \nlayout=\"column\"><div class=\"package-type md-accent-fg\">PLATINUM PACKAGE</div><div class=\"price\" layout=\"row\" \nlayout-align=\"center start\"><div class=\"currency\">$</div><div class=\"value\">499</div></div><div class=\"period\">\nPER MONTH</div><div class=\"terms\" layout=\"column\" layout-align=\"start center\"><div class=\"term\"><span \nclass=\"text-bold\">40</span> Projects</div><div class=\"term\"><span class=\"text-bold\">40</span> Pages</div><div \nclass=\"term\"><span class=\"text-bold\">500</span> Mb Disk Space</div></div><md-button \nclass=\"cta-button md-raised md-accent\">GET STARTED</md-button></div></div><div class=\"md-title\">Style 3</div><div \nclass=\"price-tables\" flex layout=\"row\" layout-align=\"start start\" layout-wrap><div \nclass=\"price-table style-3 md-whiteframe-1dp\" layout=\"column\"><div class=\"package-type\"><div class=\"title\">Starter\n</div><div class=\"subtitle\">For small teams</div></div><div class=\"price md-primary-bg md-hue-3\" layout=\"row\" \nlayout-align=\"center start\"><div class=\"currency\">$</div><div layout=\"row\" layout-align=\"center end\"><div \nclass=\"value\">29</div><div class=\"period\">monthly per user</div></div></div><div class=\"terms\" layout=\"column\" \nlayout-align=\"start center\"><div class=\"term\">Unlimited projects</div><div class=\"term\">Unlimited pages</div><div \nclass=\"term\">Unlimited disk space</div><div class=\"term\">24 / 7 Free support</div></div><md-button \nclass=\"cta-button md-raised md-accent\">GET STARTED FREE</md-button><div class=\"note\">7 day free trial to start</div>\n</div><div class=\"price-table style-3 md-whiteframe-8dp\" layout=\"column\"><div class=\"package-type\"><div class=\"title\">\nPro</div><div class=\"subtitle\">For larger teams</div></div><div class=\"price md-primary-bg\" layout=\"row\" \nlayout-align=\"center start\"><div class=\"currency\">$</div><div layout=\"row\" layout-align=\"center end\"><div \nclass=\"value\">59</div><div class=\"period\">monthly per user</div></div></div><div class=\"terms\" layout=\"column\" \nlayout-align=\"start center\"><div class=\"term\">Unlimited projects</div><div class=\"term\">Unlimited pages</div><div \nclass=\"term\">Unlimited disk space</div><div class=\"term\">24 / 7 Free support</div><div class=\"term md-warn-fg\">\nAdvanced reporting</div><div class=\"term md-warn-fg\">Customizable interface</div><div class=\"term md-warn-fg\">\nCRM Integration</div></div><md-button class=\"cta-button md-raised md-accent\">GET STARTED FREE</md-button><div \nclass=\"note\">30 day free trial to start</div></div><div class=\"price-table style-3 md-whiteframe-1dp\" layout=\"column\">\n<div class=\"package-type\"><div class=\"title\">Enterprise</div><div class=\"subtitle\">For big teams</div></div><div \nclass=\"price md-primary-bg md-hue-3\" layout=\"row\" layout-align=\"center start\"><div class=\"currency\">$</div><div \nlayout=\"row\" layout-align=\"center end\"><div class=\"value\">99</div><div class=\"period\">monthly per user</div></div>\n</div><div class=\"terms\" layout=\"column\" layout-align=\"start center\"><div class=\"term\">Unlimited projects</div><div \nclass=\"term\">Unlimited pages</div><div class=\"term\">Unlimited disk space</div><div class=\"term\">\nFor full feature list, call us</div></div><md-button class=\"cta-button md-raised md-accent\">CALL US</md-button><div \nclass=\"note\">90 day free trial to start</div></div></div></div></div>");
$templateCache.put("app/main/ui/forms/forms.html","<div id=\"forms\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"space-between\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Forms</div></div></div><div class=\"content\" layout=\"column\"><div class=\"md-title\">Stepper</div><div \nclass=\"pb-16\"><b>ms-stepper</b>\n is a custom made form wizard directive. It follows Google\'s Material Design specifications and we recommend you to use it. If for some reason, it\'s not suitable for your project, you can always use the Form Wizard that we put together using md-tabs and forms.\n</div><form name=\"horizontalStepper\" ms-horizontal-stepper ng-submit=\"vm.submitHorizontalStepper()\" \nng-model=\"vm.horizontalStepper\" novalidate><ms-horizontal-stepper-step ng-form=\"horizontalStep1\" step=\"1\" \nstep-title=\"\'Personal Information\'\"><div ng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-1.html\'\"></div>\n</ms-horizontal-stepper-step><ms-horizontal-stepper-step ng-form=\"horizontalStep2\" step=\"2\" step-title=\"\'Birthplace\'\" \noptional-step hide-step=\"!vm.horizontalStepper.step1.lastname\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-2.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep3\" step=\"3\" step-title=\"\'SSN\'\" optional-step \nhide-step=\"!vm.horizontalStepper.step2.birthplace\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-3.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep4\" step=\"4\" step-title=\"\'Address\'\" optional-step><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-4.html\'\"></div></ms-horizontal-stepper-step>\n<ms-horizontal-stepper-step ng-form=\"horizontalStep5\" step=\"5\" step-title=\"\'Payment Method\'\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/horizontal/step-5.html\'\"></div></ms-horizontal-stepper-step></form><div \nclass=\"mv-24\"></div><form name=\"verticalStepper\" ms-vertical-stepper ng-submit=\"vm.submitVerticalStepper()\" \nng-model=\"vm.verticalStepper\" novalidate><ms-vertical-stepper-step ng-form=\"verticalStep1\" step=\"1\" \nstep-title=\"\'Personal Information\'\"><div ng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-1.html\'\"></div>\n</ms-vertical-stepper-step><ms-vertical-stepper-step ng-form=\"verticalStep2\" step=\"2\" step-title=\"\'Birthplace\'\" \noptional-step hide-step=\"!vm.verticalStepper.step1.lastname\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-2.html\'\"></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep3\" step=\"3\" step-title=\"\'SSN\'\" optional-step \nhide-step=\"!vm.verticalStepper.step2.birthplace\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-3.html\'\"></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep4\" step=\"4\" step-title=\"\'Address\'\" optional-step><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-4.html\'\"></div></ms-vertical-stepper-step>\n<ms-vertical-stepper-step ng-form=\"verticalStep5\" step=\"5\" step-title=\"\'Payment Method\'\"><div \nng-include=\"\'app/main/ui/forms/stepper-steps/vertical/step-5.html\'\"></div></ms-vertical-stepper-step></form><div \nclass=\"md-title mt-32\">Form Wizard</div><div class=\"pb-16\">\nForm wizard is a combination of md-tabs and forms that we have created for you. You can have as many steps as you want.\n</div><div layout=\"row\"><ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nmd-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$invalid\">1</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Personal Information</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"firstname\" ng-model=\"vm.formWizard.firstname\" \nplaceholder=\"Firstname\" required><div ng-messages=\"wizardStep1.firstname.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.formWizard.lastname\" placeholder=\"Lastname\" \nrequired><div ng-messages=\"wizardStep1.lastname.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nLastname field is required.</span></div></div></md-input-container></div><md-input-container class=\"md-block\"><input \ntype=\"email\" name=\"email\" ng-model=\"vm.formWizard.email\" placeholder=\"Email\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"wizardStep1.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>\nEmail field is required</span></div><div ng-message=\"pattern\"><span>Email must be a valid e-mail address</span></div>\n</div></md-input-container><div layout=\"column\" layout-gt-sm=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\">\n<input type=\"password\" name=\"password\" ng-model=\"vm.formWizard.password\" placeholder=\"Password\" required><div \nng-messages=\"wizardStep1.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>Password field is required.\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"password\" \nname=\"passwordConfirm\" ng-model=\"vm.formWizard.passwordConfirm\" placeholder=\"Password (Confirm)\" required><div \nng-messages=\"wizardStep1.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nPassword (Confirm) field is required.</span></div></div></md-input-container></div></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2</span> <span \nclass=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i> </span><span \nclass=\"ms-form-wizard-step-text\">Address</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" \nms-form-wizard-form novalidate><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>City</label>\n<input type=\"text\" name=\"city\" ng-model=\"vm.formWizard.city\"></md-input-container><md-input-container flex><label>State\n</label><md-select ng-model=\"vm.formWizard.state\"><md-option ng-repeat=\"state in vm.states\" value=\"{{state.abbrev}}\">\n{{state.abbrev}}</md-option></md-select></md-input-container><md-input-container flex><label>Postal Code</label><input \nname=\"postalcode\" ng-model=\"vm.formWizard.postalCode\" placeholder=\"12345\" required ng-pattern=\"/^[0-9]{5}$/\" \nmd-maxlength=\"5\"><div ng-messages=\"wizardStep2.postalcode.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>You must supply a postal code.</span></div><div ng-message=\"pattern\"><span>\nThat doesn\'t look like a valid postal code.</span></div><div ng-message=\"md-maxlength\"><span>\nPostal code can\'t be longer than 5 characters.</span></div></div></md-input-container></div><md-input-container \nclass=\"md-block\"><label>Address</label><textarea ng-model=\"vm.formWizard.address\" md-maxlength=\"150\" max-rows=\"5\" \nrequired></textarea><div ng-messages=\"wizardStep2.address.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span>Address field is required.</span></div><div ng-message=\"md-maxlength\"><span>\nAddress can\'t be longer than 150 characters.</span></div></div></md-input-container></form></md-tab-body></md-tab>\n<md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">Payment Method</span></span></md-tab-label><md-tab-body><form \nname=\"wizardStep3\" ms-form-wizard-form novalidate><md-input-container class=\"md-block\"><input type=\"text\" \nname=\"cardholder\" ng-model=\"vm.formWizard.cardholder\" placeholder=\"Card Holder\" required><div \nng-messages=\"wizardStep3.cardholder.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard holder field is required.</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"cardnumber\" \nng-model=\"vm.formWizard.cardnumber\" placeholder=\"Card Number\" required><div \nng-messages=\"wizardStep3.cardnumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard number field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\">\n<input type=\"text\" name=\"CC2\" ng-model=\"vm.formWizard.cc2\" placeholder=\"CC2\" md-maxlength=\"3\" required><div \nng-messages=\"wizardStep3.cc2.$error\" role=\"alert\" multipl><div ng-message=\"required\"><span>CC2 field is required.\n</span></div><div ng-message=\"md-maxlength\"><span>CC2 can\'t be longer than 3 characters.</span></div></div>\n</md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"expirationDate\" \nng-model=\"vm.formWizard.expirationDate\" placeholder=\"Expiration Date\" required><div \nng-messages=\"wizardStep3.expirationDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nExpiration date field is required.</span></div></div></md-input-container></div></form></md-tab-body></md-tab>\n</md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">Previous\n</md-button><div class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">Next</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.sendForm(); msWizard.resetForm();\" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete()\">Send</md-button></div></ms-form-wizard></div><div class=\"md-title mt-32\">\nBasic form with validation</div><div class=\"pb-16\">\nWith this form example, Submit button will only be activated if all the required fields are filled and if there is no error on the form.\n</div><div layout=\"row\"><div class=\"form-wrapper md-whiteframe-1dp\" flex=\"60\"><form name=\"basicForm\" \nclass=\"md-inline-form\" novalidate><div class=\"form-title\">Optional form title</div><div layout=\"column\" \nlayout-gt-sm=\"row\"><md-input-container flex><input type=\"text\" name=\"firstname\" ng-model=\"vm.basicForm.firstname\" \nplaceholder=\"Firstname\" required><div ng-messages=\"basicForm.firstname.$error\" role=\"alert\"><div ng-message=\"required\">\n<span>Firstname field is required.</span></div></div></md-input-container><md-input-container flex><input type=\"text\" \nname=\"lastname\" ng-model=\"vm.basicForm.lastname\" placeholder=\"Lastname\" required><div \nng-messages=\"basicForm.lastname.$error\" role=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.\n</span></div></div></md-input-container></div><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex><label>\nCity</label><input type=\"text\" name=\"city\" ng-model=\"vm.basicForm.city\"></md-input-container><md-input-container flex>\n<label>State</label><md-select ng-model=\"vm.basicForm.state\"><md-option ng-repeat=\"state in vm.states\" \nvalue=\"{{state.abbrev}}\">{{state.abbrev}}</md-option></md-select></md-input-container><md-input-container flex><label>\nPostal Code</label><input name=\"postalcode\" ng-model=\"vm.basicForm.postalCode\" placeholder=\"12345\" required \nng-pattern=\"/^[0-9]{5}$/\" md-maxlength=\"5\"><div ng-messages=\"basicForm.postalcode.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>You must supply a postal code.</span></div><div \nng-message=\"pattern\"><span>That doesn\'t look like a valid postal code.</span></div><div ng-message=\"md-maxlength\">\n<span>Postal code can\'t be longer than 5 characters.</span></div></div></md-input-container></div><md-input-container \nclass=\"md-block\"><label>Biography</label><textarea ng-model=\"vm.basicForm.biography\" md-maxlength=\"150\" max-rows=\"5\">\n</textarea></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent\" aria-label=\"Submit\" \nng-disabled=\"basicForm.$invalid || basicForm.$pristine\">Submit</md-button></form></div><div \nclass=\"form-wrapper form-data-wrapper md-whiteframe-1dp\" flex=\"40\"><div class=\"form-title\">Form ng-model data</div><div\n class=\"json-data-wrapper\"><pre>{{vm.basicForm | json}}</pre></div></div></div></div></div>");
$templateCache.put("app/main/components/widgets/widgets.html","<div id=\"widgets\" class=\"page-layout simple fullwidth doc-page\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span></div><div \nclass=\"title\">Widgets</div></div></div><div class=\"content\"><p class=\"h3 m-16\">\nHere you can see some of the other widget styles. These are just tiny example of what you can do with using <code \nclass=\"no-highlight\">ms-widget</code>\n directive and helper classes. You are not limited to these styles or widgets, you can easily create wide variety of widgets.\n</p><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"h-170 p-16 light-blue-bg\"><div class=\"pb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">{{vm.widget1.title}}\n</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"md-display-1\" layout=\"row\" \nlayout-align=\"start center\"><span>{{vm.widget1.value | number}}</span><md-icon md-font-icon=\"icon-trending-up\" \nclass=\"s36 ml-16\"></md-icon></div><div layout=\"row\" layout-align=\"start center\"><span>\nLast week: {{vm.widget1.lastWeekValue | number}}</span> <span class=\"text-boxed-light\">{{vm.widget1.lastWeekDiff}}\n</span></div></div></ms-widget-front><ms-widget-back class=\"p-16 light-blue-bg white-fg\"><div class=\"flip-to-front\">\n<md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"h-170 p-16 green-bg\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h4 font-weight-500 secondary-text\">{{vm.widget2.title}}</div><md-menu><md-button aria-label=\"more\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"white-fg\" layout=\"column\" \nlayout-align=\"space-between\" flex><div><div class=\"md-display-1 pb-16\">{{vm.widget2.value}}%</div><div class=\"pb-16\">\n<md-progress-linear md-mode=\"determinate\" value=\"{{vm.widget2.value}}\"></md-progress-linear></div></div><div \nlayout=\"row\" layout-align=\"start center\"><span>Last week: {{vm.widget2.lastWeekValue}}%</span> <span \nclass=\"text-boxed-light\">{{vm.widget2.lastWeekDiff}}</span></div></div></ms-widget-front><ms-widget-back \nclass=\"p-16 green-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"h-170 p-16 blue-grey-bg white-fg\"><div class=\"pb-8\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h4 font-weight-500 secondary-text\">{{vm.widget3.title}}\n</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div layout=\"column\" layout-align=\"space-between\" flex><div><div class=\"md-display-1 pb-16\">{{vm.widget3.value}}%\n</div><div class=\"pb-8\"><md-progress-linear md-mode=\"determinate\" value=\"{{vm.widget3.value}}\"></md-progress-linear>\n</div></div><div>See more details...</div></div></ms-widget-front><ms-widget-back class=\"p-16 blue-grey-bg white-fg\">\n<div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget3.detail}}</div></ms-widget-back>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"h-170 p-16 deep-purple-bg white-fg\"><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"h4 font-weight-500 secondary-text\">{{vm.widget4.title}}</div><md-menu><md-button aria-label=\"more\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"column\" layout-align=\"space-between\" flex>\n<div class=\"md-display-1 pb-8\" layout=\"row\" layout-align=\"start center\"><span>{{vm.widget4.value | number}}</span>\n<md-icon md-font-icon=\"icon-trending-down\" class=\"s36 ml-16\"></md-icon></div><div>See more details...</div></div>\n</ms-widget-front><ms-widget-back class=\"p-16 deep-purple-bg white-fg\"><div class=\"flip-to-front\"><md-button \nclass=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\">\n</md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div class=\"pt-8 pb-8\" \nlayout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-1 pb-8\">{{vm.widget5.value}}</div><div \nclass=\"font-weight-500 secondary-text\">{{vm.widget5.title}}</div></div></ms-widget-front></ms-widget><ms-widget \nclass=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" \nlayout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"font-weight-500 secondary-text pb-8\">{{vm.widget6.title}}</div><div class=\"md-display-1\">{{vm.widget6.value}}\n</div></div></ms-widget-front></ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"row\" \nlayout-align=\"space-between center\" flex><div class=\"pl-8\" layout=\"column\" layout-align=\"center start\"><span \nclass=\"md-display-1 pb-8\">{{vm.widget7.value}}</span> <span class=\"font-weight-500 secondary-text\">{{vm.widget7.title}}\n</span></div><div><md-icon md-font-icon=\"icon-thumb-up\" class=\"s48 hint-text\"></md-icon></div></div></ms-widget-front>\n</ms-widget><ms-widget class=\"h-140\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 white-bg\" layout=\"row\" flex><div class=\"pt-8 pb-8\" layout=\"row\" layout-align=\"space-between center\" flex>\n<div><md-icon md-font-icon=\"icon-lock-unlocked\" class=\"s48 hint-text\"></md-icon></div><div class=\"pr-8\" \nlayout=\"column\" layout-align=\"center end\"><div class=\"md-display-1 pb-8\">{{vm.widget8.value}}</div><div \nclass=\"font-weight-500 secondary-text\">{{vm.widget8.title}}</div></div></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 deep-orange-bg white-fg\" layout=\"row\" flex><div \nlayout=\"column\" layout-align=\"center center\" flex><div class=\"md-display-3 pb-8\">{{vm.widget9.value}}</div><div \nclass=\"h3 font-weight-500\">{{vm.widget9.title}}</div></div><div class=\"background-image-center\"><md-icon \nmd-font-icon=\"icon-music-note\" class=\"s256 faint-text\"></md-icon></div></ms-widget-front></ms-widget><ms-widget \nclass=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 cyan-bg white-fg\" layout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-3 pb-8\">{{vm.widget10.value}}</div><div class=\"h3 font-weight-500\">{{vm.widget10.title}}</div></div>\n<div class=\"background-image-center\"><md-icon md-font-icon=\"icon-filmstrip\" class=\"s256 faint-text\"></md-icon></div>\n</ms-widget-front></ms-widget><ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front \nclass=\"p-16 teal-bg white-fg\" layout=\"row\" flex><div layout=\"column\" layout-align=\"center center\" flex><div \nclass=\"md-display-3 pb-8\">{{vm.widget11.value}}</div><div class=\"h3 font-weight-500\">{{vm.widget11.title}}</div></div>\n<div class=\"background-image-center\"><md-icon md-font-icon=\"icon-file-document\" class=\"s256 faint-text\"></md-icon>\n</div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 light-blue-bg\" layout=\"column\" flex><div class=\"pb-8\" layout=\"row\" layout-align=\"space-between center\"><div\n class=\"h4 secondary-text\"><md-icon md-font-icon=\"icon-arrow-left\" class=\"s16 mr-8\"></md-icon><span \nclass=\"font-weight-500\">{{vm.widget12.date}}</span><md-icon md-font-icon=\"icon-arrow-right\" class=\"s16 ml-8\"></md-icon>\n</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"white-fg\" layout=\"column\" layout-align=\"center center\" flex><div><md-icon \nmd-font-icon=\"{{vm.widget12.icon}}\" class=\"s96\"></md-icon></div><div class=\"pt-16\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"md-display-2\">{{vm.widget12.temperature}}&deg;</div><div class=\"pl-16\" \nlayout=\"column\"><div class=\"h1 text-semibold\">{{vm.widget12.event}}</div><div class=\"h4 secondary-text\">\n{{vm.widget12.location}}</div></div></div><div class=\"pt-32\" layout=\"row\" layout-align=\"center center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-windy\" class=\"s16\"></md-icon><span \nclass=\"pl-8\">22 km/h</span></div><div class=\"pl-16\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-compass\" class=\"s16\"></md-icon><span class=\"pl-8\">NW</span></div></div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 light-blue-bg\" layout=\"column\" flex><div class=\"flip-to-front\"><md-button \nclass=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\">\n</md-icon></md-button></div><div class=\"pt-16 pb-16 white-fg\"><span class=\"h1\">Next 5 days</span></div><div \nclass=\"pl-8 pr-8\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start center\" \nng-repeat=\"detail in vm.widget12.detail\"><div class=\"h4 pb-8 black-fg secondary-text\">{{detail.day}}</div><md-icon \nmd-font-icon=\"{{detail.icon}}\" class=\"s36 white-fg\"></md-icon><div class=\"h3 pt-8 white-fg\">{{detail.temperature}}&deg;\n</div></div></div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" \nflex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"column\" flex><div class=\"pb-8\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h4 secondary-text\"><md-icon md-font-icon=\"icon-arrow-left\" \nclass=\"s16 mr-8\"></md-icon><span class=\"font-weight-500\">{{vm.widget13.date}}</span><md-icon \nmd-font-icon=\"icon-arrow-right\" class=\"s16 ml-8\"></md-icon></div><md-menu><md-button aria-label=\"more\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"column\" layout-align=\"center center\" flex>\n<div><md-icon md-font-icon=\"{{vm.widget13.icon}}\" class=\"s96\"></md-icon></div><div class=\"pt-16\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"md-display-2\">{{vm.widget13.temperature}}&deg;</div><div class=\"pl-16\" \nlayout=\"column\"><div class=\"h1 text-semibold\">{{vm.widget13.event}}</div><div class=\"h4 secondary-text\">\n{{vm.widget13.location}}</div></div></div><div class=\"pt-32\" layout=\"row\" layout-align=\"center center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-windy\" class=\"s16\"></md-icon><span \nclass=\"pl-8\">22 km/h</span></div><div class=\"pl-16\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-compass\" class=\"s16\"></md-icon><span class=\"pl-8\">NW</span></div></div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 light-blue-bg\" layout=\"column\" flex><div class=\"flip-to-front\"><md-button \nclass=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\">\n</md-icon></md-button></div><div class=\"pt-16 pb-16 white-fg\"><span class=\"h1\">Next 5 days</span></div><div \nclass=\"pl-8 pr-8\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"start center\" \nng-repeat=\"detail in vm.widget13.detail\"><div class=\"h4 pb-8 black-fg secondary-text\">{{detail.day}}</div><md-icon \nmd-font-icon=\"{{detail.icon}}\" class=\"s36 white-fg\"></md-icon><div class=\"h3 pt-8 white-fg\">{{detail.temperature}}&deg;\n</div></div></div></ms-widget-back></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 pt-16 pb-8 md-accent-bg\"><div class=\"h3\">{{vm.widget14.title}}</div></div><md-tabs \nclass=\"md-accent no-radius\" md-dynamic-height><md-tab label=\"{{tab.label}}\" ng-repeat=\"tab in vm.widget14.tabs\"><div \nlayout=\"row\" layout-align=\"start center\" layout-wrap><div flex=\"100\" flex-gt-md=\"50\" ng-repeat=\"group in tab.groups\">\n<div class=\"h2 m-16 pb-16 border-bottom\">{{group.title}}</div><div class=\"p-16 pb-32\" ng-repeat=\"data in group.data\">\n<div class=\"pb-8\" layout=\"row\" layout-align=\"space-between start\"><span class=\"h3\">{{data.title}}</span> <span \nclass=\"h3 secondary-text font-weight-500\">{{data.value}}%</span></div><md-progress-linear \nclass=\"{{data.progressColor}}\" md-mode=\"determinate\" value=\"{{data.value}}\"></md-progress-linear></div></div></div>\n</md-tab></md-tabs></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget class=\"h-250\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 red-bg white-fg\" layout=\"column\" layout-align=\"space-between\" flex><div class=\"pb-16\"><div \nclass=\"h4 weight-500 pb-8\">{{vm.widget15.title}}</div><div layout=\"row\" layout-align=\"start center\"><div class=\"pr-8\">\n<md-icon md-font-icon=\"icon-alert\" class=\"s24 hint-text\"></md-icon></div><div class=\"h1 secondary-text\">\n{{vm.widget15.value}}%</div></div></div><div><c3chart class=\"c3 stroke-2\" bindto-id=\"cpu-usage\"><chart-column \nng-repeat=\"column in vm.widget15.chart.columns\" column-id=\"{{column.id}}\" column-name=\"{{column.name}}\" \ncolumn-color=\"{{column.color}}\" column-values=\"{{column.values}}\" column-type=\"{{column.type}}\"><chart-axis>\n<chart-axis-y show=\"false\"></chart-axis-y></chart-axis><chart-legend show-legend=\"false\"><chart-size \nchart-height=\"120\"></c3chart></div></ms-widget-front></ms-widget><ms-widget class=\"h-250\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 white-bg\" layout=\"column\" layout-align=\"space-between\" \nflex><div class=\"pb-16\"><div class=\"h4 weight-500 pb-8\">{{vm.widget16.title}}</div><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"h1 secondary-text\">{{vm.widget16.value}}</div><md-icon \nmd-font-icon=\"icon-trending-up\" class=\"mh-8\"></md-icon></div></div><div><c3chart class=\"c3 stroke-2\" bindto-id=\"stock\">\n<chart-column ng-repeat=\"column in vm.widget16.chart.columns\" column-id=\"{{column.id}}\" column-name=\"{{column.name}}\" \ncolumn-color=\"{{column.color}}\" column-values=\"{{column.values}}\" column-type=\"{{column.type}}\"><chart-axis>\n<chart-axis-x show=\"false\"></chart-axis-x><chart-axis-y show=\"false\"></chart-axis-y></chart-axis><chart-legend \nshow-legend=\"false\"><chart-size chart-height=\"120\"></c3chart></div></ms-widget-front></ms-widget><ms-widget \nclass=\"h-250\" layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"p-16 white-bg\" layout=\"column\" \nlayout-align=\"space-between\" flex><div class=\"pb-16\"><div class=\"h4 weight-500 pb-8\">{{vm.widget17.title}}</div><div \nclass=\"secondary-text\">{{vm.widget17.subtitle}}</div></div><div><c3chart class=\"c3 stroke-2\" bindto-id=\"io-rate\">\n<chart-column ng-repeat=\"column in vm.widget17.chart.columns\" column-id=\"{{column.id}}\" column-name=\"{{column.name}}\" \ncolumn-color=\"{{column.color}}\" column-values=\"{{column.values}}\" column-type=\"{{column.type}}\"><chart-axis>\n<chart-axis-y show=\"false\"></chart-axis-y></chart-axis><chart-size chart-height=\"120\"></c3chart></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nclass=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front class=\"p-16 white-bg\"><div layout=\"row\" \nlayout-align=\"space-between\"><div class=\"mr-16\"><div class=\"h4 weight-500 pb-8\">{{vm.widget18.title}}</div><div \nclass=\"h1 secondary-text\">{{vm.widget18.value | number}}</div><div class=\"pt-8\" layout=\"row\" \nlayout-align=\"start center\"><div>LW: {{vm.widget18.lastWeekValue | number}}</div><div class=\"text-boxed\">\n{{vm.widget18.lastWeekDiff}}</div></div></div><c3chart flex bindto-id=\"weekly-visitors\"><chart-column \nng-repeat=\"column in vm.widget18.chart.columns\" column-id=\"{{column.id}}\" column-name=\"{{column.name}}\" \ncolumn-color=\"{{column.color}}\" column-values=\"{{column.values}}\" column-type=\"{{column.type}}\"><chart-legend \nshow-legend=\"false\"><chart-bar width=\"10\"><chart-size chart-height=\"240\"></c3chart></div></ms-widget-front></ms-widget>\n<ms-widget class=\"h-300\" layout=\"column\" flex=\"100\" flex-gt-md=\"50\"><ms-widget-front \nclass=\"p-16 light-blue-bg white-fg\"><div layout=\"row\" layout-align=\"space-between\"><div class=\"mr-16\"><div \nclass=\"h1 weight-500 pb-8\">{{vm.widget19.title}}</div><div class=\"h4 secondary-text weight-500 pb-8\">\n{{vm.widget19.subtitle}}</div><div layout=\"row\" layout-align=\"start center\"><div class=\"md-display-1 pr-8\">\n{{vm.widget19.value}}</div><md-icon md-font-icon=\"icon-trending-up\" class=\"s24\"></md-icon></div></div><c3chart flex \nbindto-id=\"goog-nasdaq\"><chart-column ng-repeat=\"column in vm.widget19.chart.columns\" column-id=\"{{column.id}}\" \ncolumn-name=\"{{column.name}}\" column-color=\"{{column.color}}\" column-values=\"{{column.values}}\" \ncolumn-type=\"{{column.type}}\"><chart-legend show-legend=\"false\"><chart-bar width=\"10\"><chart-size chart-height=\"240\">\n</c3chart></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/ui/icons/icons.html","<div id=\"icons\" class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Icons</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"https://materialdesignicons.com/\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\" layout=\"column\">\n<md-input-container class=\"md-block\"><label>Search an icon</label><input ng-model=\"vm.searchText\"></md-input-container>\n<div id=\"icons-list\" class=\"card md-whiteframe-1dp\" layout=\"row\" layout-wrap><div class=\"item\" \nng-repeat=\"icon in vm.icons | filter:{properties: {name:vm.searchText}} track by icon.properties.id\" \nlayout-align=\"start center\"><i class=\"icon icon-{{::icon.properties.name}} s40\"></i><div \nclass=\"name secondary-text text-center\">icon-{{::icon.properties.name}}</div></div></div></div></div>");
$templateCache.put("app/main/ui/helper-classes/helper-classes.html","<div id=\"helper-classes\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Helper Classes</div></div></div><div class=\"content\" layout=\"column\"><md-tabs md-dynamic-height><md-tab \nlabel=\"Padding & Margin Helpers\"><div class=\"md-title\">Padding Helpers</div><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span>no-padding</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span class=\"no-padding\">No padding</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100\n</div><span>padding-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span class=\"padding-5\">5px padding</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100\n</div><span>p-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\">\n<span class=\"p-15\">15px padding</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96</div><span>\npadding-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"padding-8\">8px padding</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96</div><span>p-(8x)\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"p-32\">\n32px padding</span></hljs></div></div><div class=\"md-title\">Direction Specific Padding Helpers</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100</div><span>\npadding-top-(5x)</span> <span>padding-right-(5x)</span> <span>padding-bottom-(5x)</span> <span>padding-left-(5x)</span>\n <span>padding-horizontal-(5x)</span> <span>padding-vertical-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"padding-top-5\">5px from top</span> <span \nclass=\"padding-right-25\">25px from right</span> <span class=\"padding-bottom-10\">10px from bottom</span> <span \nclass=\"padding-left-20\">20px from left</span> <span class=\"padding-horizontal-5\">5px from left and right</span> <span \nclass=\"padding-vertical-5\">5px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100\n</div><span>pt-(5x)</span> <span>pr-(5x)</span> <span>pb-(5x)</span> <span>pl-(5x)</span> <span>ph-(5x)</span> <span>\npv-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"pt-5\">5px from top</span> <span class=\"pr-25\">25px from right</span> <span class=\"pb-10\">10px from bottom</span>\n <span class=\"pl-20\">20px from left</span> <span class=\"ph-5\">5px from left and right</span> <span class=\"pv-5\">\n5px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96</div><span>\npadding-top-(8x)</span> <span>padding-right-(8x)</span> <span>padding-bottom-(8x)</span> <span>padding-left-(8x)</span>\n <span>padding-horizontal-(8x)</span> <span>padding-vertical-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"padding-top-8\">8px from top</span> <span \nclass=\"padding-right-24\">24px from right</span> <span class=\"padding-bottom-16\">16px from bottom</span> <span \nclass=\"padding-left-8\">8px from left</span> <span class=\"padding-horizontal-8\">8px from left and right</span> <span \nclass=\"padding-vertical-8\">8px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96\n</div><span>pt-(8x)</span> <span>pr-(8x)</span> <span>pb-(8x)</span> <span>pl-(8x)</span> <span>ph-(8x)</span> <span>\npv-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"pt-8\">8px from top</span> <span class=\"pr-24\">24px from right</span> <span class=\"pb-16\">16px from bottom</span>\n <span class=\"pl-8\">8px from left</span> <span class=\"ph-8\">8px from left and right</span> <span class=\"pv-8\">\n8px from top and bottom</span></hljs></div></div><div class=\"md-title\">Margin Helpers</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span>no-margin</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"no-margin\">No margin</span></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption mb-16\">Multiples of 5, Max:100</div><span>margin-(5x)</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"margin-5\">5px margin</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption mb-16\">Multiples of 5, Max:100</div><span>m-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"m-15\">15px margin</span></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">\nMultiples of 8, Max:96</div><span>margin-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><span class=\"margin-8\">8px margin</span></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">\nMultiples of 8, Max:96</div><span>m-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><span class=\"m-32\">32px margin</span></hljs></div></div><div class=\"md-title\">\nDirection Specific Margin Helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">\nMultiples of 5, Max:100</div><span>margin-top-(5x)</span> <span>margin-right-(5x)</span> <span>margin-bottom-(5x)\n</span> <span>margin-left-(5x)</span> <span>margin-horizontal-(5x)</span> <span>margin-vertical-(5x)</span></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"margin-top-5\">5px from top\n</span> <span class=\"margin-right-25\">25px from right</span> <span class=\"margin-bottom-10\">10px from bottom</span> \n<span class=\"margin-left-20\">20px from left</span> <span class=\"margin-horizontal-5\">5px from left and right</span> \n<span class=\"margin-vertical-5\">5px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div\n class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:100\n</div><span>mt-(5x)</span> <span>mr-(5x)</span> <span>mb-(5x)</span> <span>ml-(5x)</span> <span>mh-(5x)</span> <span>\nmv-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"mt-5\">5px from top</span> <span class=\"mr-25\">25px from right</span> <span class=\"mb-10\">10px from bottom</span>\n <span class=\"ml-20\">20px from left</span> <span class=\"mh-5\">5px from left and right</span> <span class=\"mv-5\">\n5px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96</div><span>\nmargin-top-(8x)</span> <span>margin-right-(8x)</span> <span>margin-bottom-(8x)</span> <span>margin-left-(8x)</span> \n<span>margin-horizontal-(8x)</span> <span>margin-vertical-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"margin-top-8\">8px from top</span> <span \nclass=\"margin-right-24\">24px from right</span> <span class=\"margin-bottom-16\">16px from bottom</span> <span \nclass=\"margin-left-8\">8px from left</span> <span class=\"margin-horizontal-8\">8px from left and right</span> <span \nclass=\"margin-vertical-8\">8px from top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:96\n</div><span>mt-(8x)</span> <span>mr-(8x)</span> <span>mb-(8x)</span> <span>ml-(8x)</span> <span>mh-(8x)</span> <span>\nmv-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"mt-8\">8px from top</span> <span class=\"mr-24\">24px from right</span> <span class=\"mb-16\">16px from bottom</span>\n <span class=\"ml-8\">8px from left</span> <span class=\"mh-8\">8px from left and right</span> <span class=\"mv-8\">\n8px from top and bottom</span></hljs></div></div></md-tab><md-tab label=\"Width & Height Helpers\"><div class=\"md-title\">\nWidth Helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:500\n</div><span>width-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span class=\"width-5\">5px fixed width</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:500\n</div><span>w-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\">\n<span class=\"w-350\">350px fixed width</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:800</div><span>\nwidth-(8x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"width-8\">8px fixed width</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:800</div><span>w-(8x)\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"w-560\">\n560px fixed width</span></hljs></div></div><div class=\"md-title\">Height Helpers</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:500</div><span>\nheight-(5x)</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span \nclass=\"height-5\">5px fixed height</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 5, Max:500</div><span>h-(5x)\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"h-350\">\n350px fixed height</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:800</div><span>height-(8x)</span>\n</div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"height-8\">\n8px fixed height</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiples of 8, Max:800</div><span>h-(8x)</span></div>\n<hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"h-560\">\n560px fixed height</span></hljs></div></div></md-tab><md-tab label=\"Border Helpers\"><div class=\"md-title\">\nBorder Helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>border</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"border\">Border on all sides</span>\n</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><span>b</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\">\n<span class=\"b\">Border on all sides</span></hljs></div></div><div class=\"md-title\">Direction Specific Border Helpers\n</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span>border-top</span> <span>border-right</span> <span>border-bottom\n</span> <span>border-left</span> <span>border-horizontal</span> <span>border-vertical</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"border-top\">Border top</span> <span \nclass=\"border-right\">Border right</span> <span class=\"border-bottom\">Border bottom</span> <span class=\"border-left\">\nBorder left</span> <span class=\"border-horizontal\">Border left and right</span> <span class=\"border-vertical\">\nBorder top and bottom</span></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><span>bt</span> <span>br</span> <span>bb</span> <span>bl</span> <span>bh</span> <span>\nbv</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"bt\">\nBorder top</span> <span class=\"br\">Border right</span> <span class=\"bb\">Border bottom</span> <span class=\"bl\">\nBorder left</span> <span class=\"bh\">Border left and right</span> <span class=\"bv\">Border top and bottom</span></hljs>\n</div></div><div class=\"md-title\">Border Radius Helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption mb-16\">Multiples of 1, Max:12</div><span>brad-*</span></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"brad-2\">2px border radius</span> <span class=\"brad-5\">\n5px border radius</span></hljs></div></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/ui/theme-colors/theme-colors.html","<div id=\"theme-colors\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Theme Colors</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised md-warn reference-button\" ng-click=\"vm.createTheme($event);\"><md-icon md-font-icon=\"icon-palette\">\n</md-icon><span>Create Your Own Theme!</span></md-button></div></div><div class=\"content\"><md-tabs class=\"color-tabs\" \nmd-dynamic-height md-swipe-content md-stretch-tabs=\"always\"><md-tab label=\"Primary Color\"><md-content \nclass=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/primary/primary.html\'\"></md-content></md-tab><md-tab \nlabel=\"Accent Color\"><md-content class=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/accent/accent.html\'\">\n</md-content></md-tab><md-tab label=\"Warn Color\"><md-content class=\"color-tab\" \nng-include=\"\'app/main/ui/theme-colors/tabs/warn/warn.html\'\"></md-content></md-tab><md-tab label=\"Background Color\">\n<md-content class=\"color-tab\" ng-include=\"\'app/main/ui/theme-colors/tabs/background/background.html\'\"></md-content>\n</md-tab></md-tabs></div></div>");
$templateCache.put("app/main/ui/material-colors/material-colors.html","<div id=\"material-colors\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">USER INTERFACE</span></div><div \nclass=\"title\">Material Colors</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"https://www.google.com/design/spec/style/color.html#color-color-palette\" \ntarget=\"_blank\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div \nclass=\"content\"><md-tabs class=\"color-tabs\" md-dynamic-height md-swipe-content><md-tab \nng-repeat=\"(paletteName, palette) in vm.palettes\" \nmd-on-select=\"vm.selected = paletteName; vm.selectedPalette = palette\"><md-tab-label><span class=\"text-capitalize\">\n{{paletteName}}</span></md-tab-label></md-tab></md-tabs><md-content class=\"color-tab\"><div class=\"h3 pb-16\">\nFuse has classes for every single color from <a \nhref=\"https://www.google.com/design/spec/style/color.html#color-color-palette\" target=\"_blank\">\nMaterial Design Color Palette</a>\n for your convenient. You can use them with pretty much every element except Angular Material directives.</div><div \nclass=\"color-header colored-bg\" ng-class=\"\'md-\'+vm.selected+\'-bg\'\" layout=\"row\" layout-align=\"start start\" layout-wrap \nlayout-padding><div flex=\"100\"><h3 class=\"text-capitalize\">{{vm.selected}}</h3></div><div layout=\"row\" \nlayout-align=\"space-between center\" flex=\"100\"><div>500</div><div>\nrgb({{vm.selectedPalette[\'500\'].value[0]}},{{vm.selectedPalette[\'500\'].value[1]}},{{vm.selectedPalette[\'500\'].value[2]}})\n</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"colored-bg\" \nng-repeat=\"(hue, hueValue) in vm.selectedPalette\" flex=\"100\" layout=\"row\" layout-sm=\"column\" layout-padding \nng-class=\"vm.selected+\'-\'+hue+\'-bg\'\"><div flex>{{hue}}</div><div class=\"colored-bg\" \nng-class=\"\'md-\'+vm.selected+\'-\'+hue+\'-bg\'\" flex>.{{\'md-\'+vm.selected+\'-\'+hue+\'-bg\'}}</div><div flex>\n.{{vm.selected+\'-\'+hue+\'-bg\'}}</div><div class=\"fg-box white-bg md-whiteframe-2dp\" \nng-class=\"vm.selected+\'-\'+hue+\'-fg\'\">.{{vm.selected+\'-\'+hue+\'-fg\'}}</div></div></div></md-content></div></div>");
$templateCache.put("app/main/ui/typography/typography.html","<div id=\"typography\" class=\"page-layout simple tabbed doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">USER INTERFACE</span></div><div class=\"title\">Typography</div></div><div \nclass=\"content\"><md-tabs md-dynamic-height><md-tab label=\"Headings\"><div class=\"md-title\">Material design headings\n</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\" flex><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption secondary-text\">112px</div><span\n class=\"md-display-4\">Display 4</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><span class=\"md-display-4\">Display 4</span></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">56px</div><span class=\"md-display-3\">Display 3</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-display-3\">Display 3</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption secondary-text\">45px</div><span class=\"md-display-2\">Display 2</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-display-2\">Display 2</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption secondary-text\">34px</div><span class=\"md-display-1\">Display 1</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-display-1\">Display 1</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption secondary-text\">24px</div><span class=\"md-headline\">Headline</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-headline\">Headline</span></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div\n class=\"md-caption secondary-text\">20px</div><span class=\"md-title\">Title</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-title\">Title</span></hljs></div>\n<div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">16px</div><span class=\"md-subhead\">Subhead</span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span class=\"md-subhead\">Subhead</span></hljs>\n</div></div><div class=\"md-title\">Headings</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">24px</div><h1>Heading 1</h1></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h1>Heading 1</h1><div class=\"h1\">Heading 1</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">20px</div><h2>Heading 2</h2></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h2>Heading 2</h2><div class=\"h2\">Heading 2</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">16px</div><h3>Heading 3</h3></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h3>Heading 3</h3><div class=\"h3\">Heading 3</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">14px</div><h4>Heading 4</h4></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h4>Heading 4</h4><div class=\"h4\">Heading 4</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">13px</div><h5>Heading 5</h5></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h5>Heading 5</h5><div class=\"h5\">Heading 5</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption secondary-text\">12px</div><h6>Heading 6</h6></div><hljs lang=\"html\" class=\"source-code\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><h6>Heading 6</h6><div class=\"h6\">Heading 6</div></hljs></div></div>\n</md-tab><md-tab label=\"Inline Text Elements\"><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><abbr \ntitle=\"Cascaded Style Sheet\">CSS</abbr></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><abbr title=\"Cascaded Style Sheet\">CSS</abbr></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>\nThis is a <mark>marked</mark> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll>This is a <mark>marked</mark> text.</hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><del>\nThis is a deleted text.</del></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\" ms-scroll><del>This is a deleted text.</del></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><s>This is a strike-through text.</s></span>\n</div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><s>\nThis is a strike-through text.</s></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span><u>This is an underlined text.</u></span></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><u>This is an underlined text.</u></hljs>\n</div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\">\n<span><small>This is a small text.</small></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><small>This is a small text.</small></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><strong>\nThis is a strong text.</strong></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scrollx><strong>This is a strong text.</strong></hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span><em>\nThis is an italic text.</em></span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\" ms-scroll><em>This is an italic text.</em></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is a <span class=\"text-super\">super</span>\n text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>\nThis is a <span class=\"text-super\">super</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is a <span class=\"text-sub\">sub</span> text.\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>This is a \n<span class=\"text-sub\">sub</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is a <span class=\"text-capitalize\">capitalized</span> text.\n</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>This is a \n<span class=\"text-capitalized\">capitalized</span> text.</hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is an <span class=\"text-uppercase\">uppercase\n</span> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" \nms-scroll>This is an <span class=\"text-uppercase\">uppercase</span> text.</hljs></div><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><span>This is a <span \nclass=\"text-lowercase\">LOWERCASE</span> text.</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll>This is a <span class=\"text-lowercase\">LOWERCASE</span> text.</hljs></div>\n</div></md-tab><md-tab label=\"Blockquotes & Lists\"><div class=\"md-title\">Blockquotes</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p></blockquote></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p></blockquote></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe</footer>\n</blockquote></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>\n<blockquote><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe\n</footer></blockquote></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><blockquote class=\"reverse\"><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment.</p><footer>John Doe</footer>\n</blockquote></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll>\n<blockquote class=\"reverse\"><p>The bedding was hardly able to cover it and seemed ready to slide off any moment.</p>\n<footer>John Doe</footer></blockquote></hljs></div></div><div class=\"md-title\">Lists</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><ol><li>Ordered list item</li><li>Ordered list item<ol><li>\nOrdered list item</li><li>Ordered list item</li></ol></li><li>Ordered list item</li><li>Ordered list item</li></ol>\n</div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><ol><li>\nOrdered list item</li><li>Ordered list item<ol><li>Ordered list item</li><li>Ordered list item</li></ol></li><li>\nOrdered list item</li><li>Ordered list item</li></ol></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><ul><li>Unordered list item</li><li>Unordered list item\n<ul><li>Unordered list item</li><li>Unordered list item</li></ul></li><li>Unordered list item</li><li>\nUnordered list item</li></ul></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\" ms-scroll><ul><li>Unordered list item</li><li>Unordered list item<ul><li>Unordered list item</li><li>\nUnordered list item</li></ul></li><li>Unordered list item</li><li>Unordered list item</li></ul></hljs></div></div><div \nclass=\"md-title\">Definition lists</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><dl><dt>Definition term</dt>\n<dd>This is the definition description</dd><dt>Another definition term</dt><dd>\nThis is also another definition description</dd></dl></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><dl><dt>Definition term</dt><dd>This is the definition description</dd><dt>\nAnother definition term</dt><dd>This is also another definition description</dd></dl></hljs></div></div></md-tab>\n<md-tab label=\"Helpers\"><div class=\"md-title\">Font weight</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div\n layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"md-caption mb-16\">From 100 to 900</div><span class=\"font-weight-100\">font-weight: 100</span> <span>...</span> \n<span class=\"font-weight-900\">font-weight: 900</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><span class=\"font-weight-100\">100 font weight</span> ... <span \nclass=\"font-weight-900\">900 font weight</span></hljs></div></div><div class=\"md-title\">Font Size</div><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">Multiplies of 2, max: 120</div><span \nclass=\"font-size-20\">font-size: 20</span></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><span class=\"font-size-20\">font-size: 20</span></hljs></div></div><div \nclass=\"md-title\">Line Height</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"md-caption mb-16\">\nMultiplies of 2, max: 120</div><span>line-height: 2</span> <span>...</span> <span>line-height: 120</span></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><span class=\"line-height-2\">\n2px line height</span> ... <span class=\"line-height-120\">120px line height</span></hljs></div></div><div \nclass=\"md-title\">Other helpers</div><div class=\"card md-whiteframe-4dp\" layout=\"column\"><div layout=\"column\" \nlayout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"text-left\">\nLeft aligned text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" \nms-scroll><div class=\"text-left\">Left aligned text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"text-center\">Center aligned text</div>\n</div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><div \nclass=\"text-center\">Center aligned text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"text-right\">Right aligned text</div></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><div class=\"text-right\">\nRight aligned text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><p><span class=\"text-boxed\">Boxed text</span></p></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><p><span class=\"text-boxed\">Boxed text\n</span></p></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview md-grey-700-bg\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><p><span class=\"text-boxed-light\">Boxed text light</span></p></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><p><span class=\"text-boxed-light\">\nBoxed text light</span></p></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\"><p><span class=\"text-strike\">Strike-through text</span></p></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><p><span class=\"text-strike\">\nStrike-through text</span></p></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" \nlayout=\"column\" layout-align=\"center\" flex=\"50\"><div class=\"text-italic\">Italic text</div></div><hljs lang=\"html\" \nclass=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><div class=\"text-italic\">Italic text\n</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" \nflex=\"50\"><div class=\"text-semibold\">Semi-bold text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" \nlayout-align=\"center\" flex=\"50\" ms-scroll><div class=\"text-semibold\">Semi-bold text</div></hljs></div><div \nlayout=\"column\" layout-gt-md=\"row\"><div class=\"preview\" layout=\"column\" layout-align=\"center\" flex=\"50\"><div \nclass=\"text-bold\">Bold text</div></div><hljs lang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" \nflex=\"50\" ms-scroll><div class=\"text-bold\">Bold text</div></hljs></div><div layout=\"column\" layout-gt-md=\"row\"><div \nclass=\"preview\" layout=\"column\" layout-align=\"center\" flex><span class=\"text-truncate\">\nThis is a truncated text. It will be truncated if it\'s too long. Vivamus convallis dui porta massa.</span></div><hljs \nlang=\"html\" class=\"source-code\" layout=\"column\" layout-align=\"center\" flex=\"50\" ms-scroll><span class=\"text-truncate\">\nThis is a truncated text. It will be truncated if it\'s too long. Vivamus convallis dui porta massa.</span></hljs></div>\n</div></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/coming-soon/coming-soon.html","<div id=\"coming-soon\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"coming-soon-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"coming-soon-form\" class=\"md-whiteframe-8dp\"><div class=\"top\"><div\n class=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"COMINGSOON.TITLE\">\nHey! Thank you for checking out our app.</div><div class=\"subtitle\" translate=\"COMINGSOON.SUBTITLE\">\nIt’s not quite ready yet, but we are working hard and it will be ready in approximately:</div><timer \nend-time=\"vm.endTime\" layout=\"row\" layout-align=\"center center\" layout-wrap><div flex-xs=\"50\"><div class=\"value\">\n{{days}}</div><div class=\"type\" translate=\"COMINGSOON.DAYS\">days</div></div><div flex-xs=\"50\"><div class=\"value\">\n{{hours}}</div><div class=\"type\" translate=\"COMINGSOON.HOURS\">hours</div></div><div flex-xs=\"50\"><div class=\"value\">\n{{minutes}}</div><div class=\"type\" translate=\"COMINGSOON.MINUTES\">minutes</div></div><div flex-xs=\"50\"><div \nclass=\"value\">{{seconds}}</div><div class=\"type\" translate=\"COMINGSOON.SECONDS\">seconds</div></div></timer></div><form>\n<div class=\"message\" translate=\"COMINGSOON.MESSAGE\">\nIf you would like to be notified when the app is ready, you can subscribe to our e-mail list.</div><md-input-container \nflex md-no-float><input type=\"email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"COMINGSOON.EMAIL_ADRESS\"></md-input-container><md-button class=\"md-raised md-accent\" \naria-label=\"SUBSCRIBE\" translate=\"COMINGSOON.SUBSCRIBE\" translate-attr-aria-label=\"COMINGSOON.SUBSCRIBE\">SUBSCRIBE\n</md-button></form></div></div></div>");
$templateCache.put("app/main/pages/profile/profile.html","<div id=\"profile\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div class=\"user-info\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nclass=\"profile-image avatar huge\" src=\"assets/images/avatars/katherine.jpg\"><div class=\"name\">Katherine Wilson</div>\n</div><div class=\"actions\" layout=\"row\" layout-align=\"end center\"><md-button class=\"md-raised md-accent\" \naria-label=\"Follow\" translate=\"PROFILE.FOLLOW\" translate-attr-aria-label=\"PROFILE.FOLLOW\">Follow</md-button><md-button \nclass=\"md-raised md-primary\" translate=\"PROFILE.SEND_MESSAGE\" translate-attr-aria-label=\"PROFILE.SEND_MESSAGE\">\nSend Message</md-button></div></div><div class=\"content\" flex><md-tabs md-dynamic-height><md-tab><md-tab-label><span \ntranslate=\"PROFILE.TIMELINE\">Timeline</span></md-tab-label><md-tab-body><md-content class=\"timeline-tab\" \nng-include=\"\'app/main/pages/profile/tabs/timeline/timeline.html\'\"></md-content></md-tab-body></md-tab><md-tab>\n<md-tab-label><span translate=\"PROFILE.ABOUT\">About</span></md-tab-label><md-tab-body><md-content class=\"about-tab\" \nng-include=\"\'app/main/pages/profile/tabs/about/about.html\'\"></md-content></md-tab-body></md-tab><md-tab><md-tab-label>\n<span translate=\"PROFILE.PHOTOS_VIDEOS\">Photos & Videos</span></md-tab-label><md-tab-body><md-content \nclass=\"photos-videos-tab\" ng-include=\"\'app/main/pages/profile/tabs/photos-videos/photos-videos.html\'\"></md-content>\n</md-tab-body></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/maintenance/maintenance.html","<div id=\"maintenance\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"maintenance-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"maintenance-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"MAINTENANCE.TITLE\">\nClosed for scheduled maintenance!</div><div class=\"subtitle\" translate=\"MAINTENANCE.SUBTITLE\">\nWe\'re sorry for the inconvenience.<br>Please check back later.</div></div></div></div>");
$templateCache.put("app/toolbar/layouts/content-with-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><div class=\"toolbar-separator\"></div>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" \nsrc=\"assets/images/avatars/profile.jpg\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide-sm>\n1John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-sm></md-icon></div></md-button>\n<md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ui-sref=\"app.pages_profile\"><md-icon \nmd-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile</md-button></md-menu-item><md-menu-item \nclass=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon><md-button>Inbox\n</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu id=\"user-status-menu\"><md-button \nng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">{{vm.userStatus.title}}</md-button>\n<md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" ng-class=\"{\'selected\': status === vm.userStatus}\" \nng-repeat=\"status in vm.userStatusOptions\"><md-icon md-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-button \nid=\"quick-panel-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'quick-panel\')\" \naria-label=\"Toggle quick panel\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon \nmd-font-icon=\"icon-format-list-bulleted\" class=\"icon\"></md-icon></md-button></div></div>");
$templateCache.put("app/main/pages/timeline/timeline-left.html","<div id=\"timeline\" class=\"timeline-left\" ms-timeline=\"vm.timelineOptions\" ms-timeline-load-more=\"vm.loadNextPage()\">\n<div ms-timeline-item layout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" \nlayout-align-gt-md=\"center start\" ng-repeat=\"timelineItem in vm.timeline\"><div \nclass=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon md-font-icon=\"{{timelineItem.icon}}\"></md-icon></div>\n<div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">{{timelineItem.time}}</div><div class=\"event\">\n{{timelineItem.event}}</div></div><div class=\"timeline-card\" layout=\"row\" flex=\"50\"><ms-card \ntemplate=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div></div></div>");
$templateCache.put("app/main/pages/timeline/timeline-right.html","<div id=\"timeline\" class=\"timeline-right\" ms-timeline=\"vm.timelineOptions\" ms-timeline-load-more=\"vm.loadNextPage()\">\n<div ms-timeline-item layout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" \nlayout-align-gt-md=\"center start\" ng-repeat=\"timelineItem in vm.timeline\"><div \nclass=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon md-font-icon=\"{{timelineItem.icon}}\"></md-icon></div>\n<div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">{{timelineItem.time}}</div><div class=\"event\">\n{{timelineItem.event}}</div></div><div class=\"timeline-card\" layout=\"row\" flex=\"50\"><ms-card \ntemplate=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div></div></div>");
$templateCache.put("app/main/pages/timeline/timeline.html","<div id=\"timeline\" ms-timeline=\"vm.timelineOptions\" ms-timeline-load-more=\"vm.loadNextPage()\"><div ms-timeline-item \nlayout=\"column\" layout-align=\"center center\" layout-gt-md=\"row\" layout-align-gt-md=\"center start\" \nng-repeat=\"timelineItem in vm.timeline\"><div class=\"timeline-point md-accent-bg md-whiteframe-2dp\"><md-icon \nmd-font-icon=\"{{timelineItem.icon}}\"></md-icon></div><div class=\"timeline-detail\" flex=\"50\"><div class=\"time\">\n{{timelineItem.time}}</div><div class=\"event\">{{timelineItem.event}}</div></div><div class=\"timeline-card\" \nlayout=\"row\" flex=\"50\"><ms-card template=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card></div>\n</div></div>");
$templateCache.put("app/main/pages/search/search.html","<div id=\"search\" class=\"page-layout simple tabbed\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon search-icon\"></md-icon><input class=\"search-input\" ng-model=\"vm.search\" \ntype=\"text\" placeholder=\"Search..\" translate translate-attr-placeholder=\"SEARCH.SEARCH\" flex></div><md-menu \nclass=\"search-settings\" md-position-mode=\"target-right target\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Search settings\" translate translate-attr-aria-label=\"SEARCH.SEARCH_SETTINGS\">\n<md-icon md-menu-origin md-menu-align-target md-font-icon=\"icon-cog\" class=\"icon s16\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\">\n</md-icon><span translate=\"SEARCH.SETTINGS_1\">Settings 1</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\"></md-icon><span translate=\"SEARCH.SETTINGS_2\">Settings 2\n</span></md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"content\" flex><md-tabs \nmd-dynamic-height><md-tab label=\"Classic\"><md-content class=\"classic-tab\" \nng-include=\"\'app/main/pages/search/tabs/classic/classic.html\'\"></md-content></md-tab><md-tab label=\"Emails\"><md-content\n class=\"emails-tab\" ng-include=\"\'app/main/pages/search/tabs/emails/emails.html\'\"></md-content></md-tab><md-tab \nlabel=\"Users\"><md-content class=\"users-tab\" ng-include=\"\'app/main/pages/search/tabs/users/users.html\'\"></md-content>\n</md-tab><md-tab label=\"Contacts\"><md-content class=\"contacts-tab\" \nng-include=\"\'app/main/pages/search/tabs/contacts/contacts.html\'\"></md-content></md-tab></md-tabs></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div><div \nstyle=\"padding-left: 10px;padding-right: 10px; color: red;width: 200px;font-size: 17px;font-weight: 500; line-height: 1.42857143\">\n新增的合同、学生、家长不能删除</div><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><div \nng-disabled=\"!$root.message_default\" class=\"show-gt-sm\" style=\"color: #777777\">{{$root.message_default}}</div><div \nng-disabled=\"!$root.message_primary\" class=\"show-gt-sm\" style=\"color: #428bca\">{{$root.message_primary}}</div><div \nng-disabled=\"!$root.message_success\" class=\"show-gt-sm\" style=\"color: #5cb85c\">{{$root.message_success}}</div><div \nng-disabled=\"!$root.message_info\" class=\"show-gt-sm\" style=\"color: #5bc0de\">{{$root.message_info}}</div><div \nng-disabled=\"!$root.message_warning\" class=\"show-gt-sm\" style=\"color: #f0ad4e\">{{$root.message_warning}}</div><div \nng-disabled=\"!$root.message_danger\" class=\"show-gt-sm\" style=\"color: #d9534f\">{{$root.message_danger}}</div>\n<md-progress-circular id=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\">\n</md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"></div><span class=\"username\" hide show-gt-sm>{{vm.store_name}}</span><md-icon \nmd-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\">\n<md-menu-item class=\"md-indent\" ng-repeat=\"store in vm.stores\"><md-button style=\"padding: 0 15px 0 15px\" \nng-click=\"vm.switchStore($event,store)\">{{store.name}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\">\n<md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" ng-src=\"{{vm.current_user[\'avatar\']}}\" \nng-if=\"vm.current_user[\'avatar\']\"><md-icon md-font-icon ng-class=\"vm.userStatus.icon\" \nng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\"></md-icon></div><span class=\"username\" hide \nshow-gt-sm>{{vm.current_user[\'name\']}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs>\n</md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.store.system.setstore\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>门店设置\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_auth_lock\"><md-icon md-font-icon=\"icon-lock-outline\" class=\"icon\"></md-icon><md-button>锁屏幕\n</md-button></md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon=\"icon-logout\" class=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">退出</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><div class=\"toolbar-separator hide\"></div><ms-search-bar class=\"hidden hide\" \non-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div \nclass=\"toolbar-separator\"></div><md-menu id=\"language-menu1\" md-offset=\"0 72\" md-position-mode=\"target-right target\">\n<md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target>\n<div layout=\"row\" layout-align=\"center center\">读报</div></md-button><md-menu-content width=\"5\" \nid=\"language-menu-content\" class=\"p-16\" style=\"height: 600px\"><div class=\"secondary-text\"><div \nclass=\"pb-16 layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"text-boxed ng-binding\">{{vm.daily.date}}</div></div></div><div class=\"h4 weight-500 pb-16 ng-binding\"><md-icon \nmd-font-icon=\"icon-calendar\" class=\"s16 md-default-theme md-font material-icons icon-calendar\" aria-hidden=\"true\">\n</md-icon>&nbsp;昨日收入&nbsp;{{vm.daily.amount}}</div><div class=\"pb-16 ng-scope\"><div \nclass=\"h4 weight-500 pb-8 ng-binding\"><i class=\"icon icon-account-multiple s16\"></i>\n&nbsp;今天店内人员&nbsp;{{vm.daily.total}}</div><div class=\"secondary-text ng-binding pl-24\">老师：{{vm.daily.teacher_count}}\n<br>销售：{{vm.daily.xiaoshou_count}}<br>前台：{{vm.daily.qiantai_count}}<br>后勤：{{vm.daily.houqin_count}}</div></div><div \nclass=\"pb-24 ng-scope\"><div class=\"h4 weight-500 pb-8 ng-binding\"><md-icon md-font-icon=\"icon-heart-box\" \nclass=\"s16 md-default-theme md-font material-icons icon-heart-box\" aria-hidden=\"true\"></md-icon>\n&nbsp;今日共&nbsp;{{vm.daily.task_count}} 个体验</div><div class=\"secondary-text pl-24\"><div \nclass=\"pt-8 pb-8 layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"text-boxed ng-binding\">AM&nbsp;{{vm.daily.AM.length}}&nbsp;课时</div></div><div class=\"pb-8\" \nng-repeat=\"item in vm.daily.AM\">{{item.course.name}} {{item.count}} 人 ({{item.course.teacher_name}} <span \nng-if=\"item.course.assistant_name\">+</span>{{item.course.assistant_name}})</div><md-divider class=\"md-default-theme\">\n</md-divider><div class=\"pt-8 pb-8 layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"text-boxed ng-binding\">PM&nbsp;{{vm.daily.PM.length}}&nbsp;课时</div></div><div class=\"pb-8\" \nng-repeat=\"item in vm.daily.PM\">{{item.course.name}} {{item.count}} 人 ({{item.course.teacher_name}} <span \nng-if=\"item.course.assistant_name\">+</span>{{item.course.assistant_name}})</div><md-divider class=\"md-default-theme\">\n</md-divider><div class=\"pt-8 pb-8 layout-align-start-center layout-row\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"text-boxed ng-binding\">夜间&nbsp;{{vm.daily.NI.length}}&nbsp;课时</div></div><div class=\"pb-8\" \nng-repeat=\"item in vm.daily.NI\">{{item.course.name}} {{item.count}} 人 ({{item.course.teacher_name}} <span \nng-if=\"item.course.assistant_name\">+</span>{{item.course.assistant_name}})</div><md-divider class=\"md-default-theme\">\n</md-divider></div></div><div class=\"ng-scope\"><div class=\"h4 weight-500 pb-8 ng-binding\"><md-icon \nmd-font-icon=\"icon-comment-processing\" class=\"s16 md-default-theme md-font material-icons icon-comment-processing\" \naria-hidden=\"true\"></md-icon>&nbsp;今日注意事项</div><div class=\"md-resize-wrapper pb-8\"><textarea \nstyle=\"width: 100%;border-width: 0 0 1px 0;color: rgba(0,0,0,0.87);\n    border-color: rgba(0,0,0,0.12); border-radius: 0;border-style: solid\" \nrows=\"3\" ng-model=\"vm.remarks\"></textarea></div><md-card-actions layout=\"column\" layout-align=\"start\" \nclass=\"layout-align-start-stretch layout-column\"><md-button ng-click=\"vm.sendDialy()\">发送</md-button></md-card-actions>\n</div></md-menu-content></md-menu><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation/toolbar_orig.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-shortcuts></ms-shortcuts><div \nclass=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular \nid=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" class=\"md-accent\" md-diameter=\"32\"></md-progress-circular>\n<md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button class=\"user-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate translate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"avatar-wrapper\"></div><span class=\"username\" hide \nshow-gt-sm>{{vm.store_name}}</span><md-icon md-font-icon=\"icon-chevron-down\" class=\"icon s16\" hide-xs></md-icon></div>\n</md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" ng-repeat=\"store in vm.stores\"><md-button \nstyle=\"padding: 0 15px 0 15px\" ng-click=\"vm.switchStore($event,store)\">{{store.name}}</md-button></md-menu-item>\n</md-menu-content></md-menu></md-menu-bar><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\">\n<md-button class=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide show-gt-sm>3John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-xs></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/horizontal-navigation/toolbar.html","<div class=\"top-row\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n</div><div layout=\"row\" layout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" \nng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular>\n<ms-shortcuts></ms-shortcuts><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>2John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\">\n</ms-search-bar><md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button \nclass=\"language-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div \nlayout=\"row\" layout-align=\"center center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">{{vm.selectedLanguage.code}}</span>\n</div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\"><md-menu-item \nng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" aria-label=\"{{lang.title}}\" \ntranslate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" layout-align=\"start center\"><img class=\"flag\" \nng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span translate=\"{{lang.translation}}\">{{lang.title}}</span></span>\n</md-button></md-menu-item></md-menu-content></md-menu><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><md-button \nid=\"navigation-toggle\" class=\"md-icon-button\" ng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm \naria-label=\"Toggle navigation\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon \nmd-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><md-menu id=\"language-menu\" md-offset=\"0 72\" \nmd-position-mode=\"target-right target\"><md-button class=\"language-button\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" layout-align=\"center center\"><img \nclass=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span class=\"iso\">\n{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/toolbar/layouts/vertical-navigation-fullwidth-toolbar-2/toolbar.html","<div layout=\"row\" layout-align=\"start center\"><div layout=\"row\" layout-align=\"start center\" flex><div class=\"logo\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"logo-image\">F</span> <span class=\"logo-text\">FUSE</span></div>\n<div class=\"toolbar-separator\"></div><md-button id=\"navigation-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'navigation\')\" hide-gt-sm aria-label=\"Toggle navigation\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><md-button class=\"md-icon-button navigation-fold-toggle\" hide show-gt-sm \naria-label=\"Toggle navigation fold\" translate translate-attr-aria-label=\"TOOLBAR.TOGGLE_NAVIGATION_FOLD\" \nng-click=\"vm.toggleMsNavigationFolded()\"><md-icon class=\"s18\" md-font-icon=\"icon-backburger\"></md-icon></md-button>\n<ms-shortcuts></ms-shortcuts><div class=\"toolbar-separator\"></div></div><div layout=\"row\" layout-align=\"start center\">\n<md-progress-circular id=\"toolbar-progress\" ng-if=\"$root.loadingProgress\" class=\"md-accent\" md-mode=\"indeterminate\" \nmd-diameter=\"32\"></md-progress-circular><md-menu-bar id=\"user-menu\"><md-menu md-position-mode=\"left bottom\"><md-button \nclass=\"user-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"User settings\" translate \ntranslate-attr-aria-label=\"TOOLBAR.USER_SETTINGS\"><div layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"avatar-wrapper\"><img md-menu-align-target class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon status s16\">\n</md-icon></div><span class=\"username\" hide-sm>John Doe</span><md-icon md-font-icon=\"icon-chevron-down\" \nclass=\"icon s16\" hide-sm></md-icon></div></md-button><md-menu-content width=\"3\"><md-menu-item class=\"md-indent\" \nui-sref=\"app.pages_profile\"><md-icon md-font-icon=\"icon-account\" class=\"icon\"></md-icon><md-button>My Profile\n</md-button></md-menu-item><md-menu-item class=\"md-indent\" ui-sref=\"app.mail\"><md-icon md-font-icon=\"icon-email\" \nclass=\"icon\"></md-icon><md-button>Inbox</md-button></md-menu-item><md-menu-item class=\"md-indent\"><md-icon \nmd-font-icon ng-class=\"vm.userStatus.icon\" ng-style=\"{\'color\': vm.userStatus.color }\" class=\"icon\"></md-icon><md-menu \nid=\"user-status-menu\"><md-button ng-click=\"$mdOpenMenu()\" class=\"status\" ng-class=\"vm.userStatus.class\">\n{{vm.userStatus.title}}</md-button><md-menu-content width=\"2\"><md-menu-item class=\"status md-indent\" \nng-class=\"{\'selected\': status === vm.userStatus}\" ng-repeat=\"status in vm.userStatusOptions\"><md-icon \nmd-font-icon=\"{{status.icon}}\" ng-style=\"{\'color\': status.color }\" class=\"icon\"></md-icon><md-button \nng-click=\"vm.setUserStatus(status)\">{{status.title}}</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item class=\"md-indent\"><md-icon md-font-icon=\"icon-logout\" \nclass=\"icon\"></md-icon><md-button ng-click=\"vm.logout()\">Logout</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-bar><div class=\"toolbar-separator\"></div><ms-search-bar on-search=\"vm.search(query)\" \non-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar><div class=\"toolbar-separator\"></div>\n<md-menu id=\"language-menu\" md-offset=\"0 72\" md-position-mode=\"target-right target\"><md-button class=\"language-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"Language\" md-menu-origin md-menu-align-target><div layout=\"row\" \nlayout-align=\"center center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{vm.selectedLanguage.flag}}.png\"> <span \nclass=\"iso\">{{vm.selectedLanguage.code}}</span></div></md-button><md-menu-content width=\"3\" id=\"language-menu-content\">\n<md-menu-item ng-repeat=\"(iso, lang) in vm.languages\"><md-button ng-click=\"vm.changeLanguage(lang)\" \naria-label=\"{{lang.title}}\" translate translate-attr-aria-label=\"{{lang.title}}\"><span layout=\"row\" \nlayout-align=\"start center\"><img class=\"flag\" ng-src=\"assets/images/flags/{{lang.flag}}.png\"> <span \ntranslate=\"{{lang.translation}}\">{{lang.title}}</span></span></md-button></md-menu-item></md-menu-content></md-menu>\n<div class=\"toolbar-separator\"></div><md-button id=\"quick-panel-toggle\" class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'quick-panel\')\" aria-label=\"Toggle quick panel\" translate \ntranslate-attr-aria-label=\"TOOLBAR.TOGGLE_QUICK_PANEL\"><md-icon md-font-icon=\"icon-format-list-bulleted\" class=\"icon\">\n</md-icon></md-button></div></div>");
$templateCache.put("app/quick-panel/tabs/chat/chat-tab.html","<div class=\"main animate-slide-left\" ng-hide=\"vm.chatActive\"><md-list class=\"recent\"><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.RECENT\">Recent</span></md-subheader><md-list-item \nclass=\"contact md-3-line\" ng-repeat=\"contact in vm.contacts.recent\" ng-click=\"vm.toggleChat(contact)\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"last-message\">{{contact.lastMessage}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"all\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.START_NEW_CHAT\">Start New Chat</span></md-subheader><md-list-item class=\"contact\" \nng-repeat=\"contact in vm.contacts.all\" ng-click=\"vm.toggleChat(contact)\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar\" alt=\"{{contact.name}}\"><div class=\"status {{contact.status}}\"></div><div class=\"md-list-item-text\">\n<h3>{{contact.name}}</h3></div></md-list-item></md-list><md-divider></md-divider></div><div \nclass=\"chat animate-slide-right\" ng-show=\"vm.chatActive\" layout=\"column\"><md-toolbar class=\"md-accent\"><div \nclass=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" ng-click=\"vm.toggleChat()\" aria-label=\"Back\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><h4>\n<span>{{vm.chat.contact.name}}</span></h4></div><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-icon-button\" aria-label=\"Call\" translate translate-attr-aria-label=\"QUICKPANEL.CALL\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"More\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></div>\n</div></md-toolbar><md-content flex layout-paddings ms-scroll id=\"chat-dialog\"><div layout=\"row\" \nng-repeat=\"dialog in vm.chat.contact.dialog\" class=\"md-padding message-row\" ng-class=\"dialog.who\"><img \nng-if=\"dialog.who ===\'contact\'\" ng-src=\"{{vm.chat.contact.avatar}}\" class=\"avatar\" alt=\"{{vm.chat.contact.name}}\"> <img\n ng-if=\"dialog.who ===\'user\'\" class=\"avatar\" src=\"assets/images/avatars/profile.jpg\"><div class=\"bubble\" flex><div \nclass=\"message\">{{dialog.message}}</div><div class=\"time secondary-text\">{{dialog.time}}</div></div></div></md-content>\n<form ng-submit=\"vm.reply()\" layout=\"row\" class=\"reply\" layout-align=\"start center\"><textarea \nng-keyup=\"$event.keyCode == 13 ? vm.reply() : null\" flex ng-model=\"vm.replyMessage\" \nplaceholder=\"Type and hit enter to send message\" translate translate-attr-placeholder=\"QUICKPANEL.REPLY_PLACEHOLDER\">\n</textarea><md-button class=\"md-fab md-mini\" type=\"submit\" aria-label=\"Send message\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.SEND_MESSAGE\"><md-icon md-font-icon=\"icon-send\"></md-icon></md-button></form>\n</div>");
$templateCache.put("app/quick-panel/tabs/activity/activity-tab.html","<md-list class=\"friends\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.FRIENDS\">Friends</span>\n</md-subheader><md-list-item class=\"friend md-3-line\" ng-repeat=\"friend in vm.activities.friends\"><img \nng-src=\"{{friend.avatar}}\" class=\"md-avatar\" alt=\"{{friend.name}}\"><div class=\"status {{friend.status}}\"></div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div><div \nclass=\"md-list-item-text\"><h3 class=\"message\">{{friend.message}}</h3><p class=\"time\">{{friend.time}}</p></div>\n</md-list-item></md-list><md-divider></md-divider><md-list class=\"servers\"><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"QUICKPANEL.APP_SERVERS\">Application Servers</span></md-subheader><md-list-item class=\"server md-3-line\" \nng-repeat=\"server in vm.activities.servers\"><md-icon md-font-icon=\"icon-checkbox-blank-circle\" class=\"s16 status\" \nng-class=\"server.status\"></md-icon><div class=\"md-list-item-text\"><h3>{{server.location}}</h3><p>{{server.detail}}</p>\n</div></md-list-item></md-list><md-divider></md-divider><md-list class=\"stats\"><md-subheader class=\"md-no-sticky\"><span\n translate=\"QUICKPANEL.USER_STATS\">User Stats</span></md-subheader><md-list-item class=\"stat md-2-line\" \nng-repeat=\"stat in vm.activities.stats\"><div class=\"md-list-item-text\"><span>\n{{stat.title}} ({{stat.current}} / {{stat.total}})</span><md-progress-linear ng-class=\"stat.status\" \nmd-mode=\"determinate\" value=\"{{stat.percent}}\"></md-progress-linear></div></md-list-item></md-list>");
$templateCache.put("app/quick-panel/tabs/today/today-tab.html","<md-list class=\"date\"><md-subheader class=\"md-no-sticky\"><span translate=\"QUICKPANEL.TODAY\">Today</span></md-subheader>\n<md-list-item class=\"md-display-1 md-2-line\"><div class=\"secondary-text\"><div>{{vm.date | date:\'EEEE\'}}</div><div \nlayout=\"row\" layout-align=\"start start\"><span>{{vm.date | date:\'d\'}}</span> <span class=\"md-subhead\">th</span> <span>\n{{vm.date | date:\'MMMM\'}}</span></div></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.EVENTS\">Events</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"event in vm.events\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{event.title}}</h3><p>\n{{event.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader \nclass=\"md-no-sticky\"><span translate=\"QUICKPANEL.NOTES\">Notes</span></md-subheader><md-list-item class=\"md-2-line\" \nng-repeat=\"note in vm.notes\" ng-click=\"dummyFunction()\"><div class=\"md-list-item-text\"><h3>{{note.title}}</h3><p>\n{{note.detail}}</p></div></md-list-item></md-list><md-divider></md-divider><md-list><md-subheader class=\"md-no-sticky\">\n<span translate=\"QUICKPANEL.QUICK_SETTINGS\">Quick Settings</span></md-subheader><md-list-item><h3 \ntranslate=\"QUICKPANEL.NOTIFICATIONS\">Notifications</h3><md-switch class=\"md-secondary\" ng-model=\"vm.settings.notify\" \naria-label=\"Notifications\" translate translate-attr-aria-label=\"QUICKPANEL.NOTIFICATIONS\"></md-switch></md-list-item>\n<md-list-item><h3 translate=\"QUICKPANEL.CLOUD_SYNC\">Cloud Sync</h3><md-switch class=\"md-secondary\" \nng-model=\"vm.settings.cloud\" aria-label=\"Cloud Sync\" translate translate-attr-aria-label=\"QUICKPANEL.CLOUD_SYNC\">\n</md-switch></md-list-item><md-list-item><h3 translate=\"QUICKPANEL.RETRO_THRUSTERS\">Retro Thrusters</h3><md-switch \nclass=\"md-secondary md-warn\" ng-model=\"vm.settings.retro\" aria-label=\"Retro Thrusters\" translate \ntranslate-attr-aria-label=\"QUICKPANEL.RETRO_THRUSTERS\"></md-switch></md-list-item></md-list>");
$templateCache.put("app/navigation/layouts/vertical-navigation/navigation.html","<md-toolbar class=\"navigation-header md-whiteframe-1dp\" layout=\"row\" layout-align=\"space-between center\"><div \nclass=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-image\"></span> <span class=\"logo-text\">\n{{::vm.gs.appName}}</span></div><md-icon class=\"fold-toggle s18\" md-font-icon=\"icon-backburger\" hide show-gt-sm \nng-click=\"vm.toggleMsNavigationFolded()\"></md-icon></md-toolbar><ms-navigation class=\"scrollable\" folded=\"vm.folded\" \nms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/navigation/layouts/horizontal-navigation/navigation.html","<div layout=\"row\" layout-align=\"start center\"><ms-navigation-horizontal></ms-navigation-horizontal></div>");
$templateCache.put("app/navigation/layouts/vertical-navigation-fullwidth-toolbar-2/navigation.html","<ms-navigation class=\"scrollable\" folded=\"vm.folded\" ms-scroll=\"vm.msScrollOptions\"></ms-navigation>");
$templateCache.put("app/core/directives/ms-navigation/templates/horizontal.html","<div class=\"navigation-toggle\" hide-gt-sm><md-button class=\"md-icon-button\" ng-click=\"vm.toggleHorizontalMobileMenu()\" \naria-label=\"Toggle Mobile Navigation\"><md-icon md-font-icon=\"icon-menu\"></md-icon></md-button></div><ul \nclass=\"horizontal\"><li ng-repeat=\"node in vm.navigation\" ms-navigation-horizontal-node=\"node\" \nng-class=\"{\'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-horizontal-nested.html\'\"></li></ul><script \ntype=\"text/ng-template\" id=\"navigation-horizontal-nested.html\">\n<div ms-navigation-horizontal-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-horizontal-button\" ng-if=\"!node.uisref && node.title\"\n             ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-horizontal-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-class=\"{\'active md-accent-bg md-accent-fg\': vm.isActive}\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s18 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" style=\"background: {{node.badge.color}}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s18 arrow\" ng-if=\"vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-horizontal-node=\"node\"\n            ng-class=\"{\'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-horizontal-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/core/directives/ms-navigation/templates/vertical.html","<ul><li ng-repeat=\"node in vm.navigation\" ms-navigation-node=\"node\" \nng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\" ng-include=\"\'navigation-nested.html\'\"></li></ul>\n<script type=\"text/ng-template\" id=\"navigation-nested.html\">\n<div ms-navigation-item layout=\"row\" ng-if=\"!vm.isHidden()\">\n\n        <div class=\"ms-navigation-button\" ng-if=\"!node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </div>\n\n        <a class=\"ms-navigation-button\" ui-sref=\"{{node.uisref}}\" ui-sref-active=\"active md-accent-bg\"\n           ng-if=\"node.uisref && node.title\">\n            <i class=\"icon s16 {{node.icon}}\" ng-if=\"node.icon\"></i>\n            <span class=\"title\" translate=\"{{node.translate}}\" flex>{{node.title}}</span>\n            <span class=\"badge white-fg\" ng-style=\"{\'background\': node.badge.color}\" ng-if=\"node.badge\">{{node.badge.content}}</span>\n            <i class=\"icon-chevron-right s16 arrow\" ng-if=\"vm.collapsable && vm.hasChildren\"></i>\n        </a>\n\n    </div>\n\n    <ul ng-if=\"vm.hasChildren && !vm.isHidden()\">\n        <li ng-repeat=\"node in node.children\" ms-navigation-node=\"node\"\n            ng-class=\"{\'collapsed\': vm.collapsed, \'has-children\': vm.hasChildren}\"\n            ng-include=\"\'navigation-nested.html\'\"></li>\n    </ul>\n</script>");
$templateCache.put("app/main/apps/main-store/stores/_store_item.html","<div class=\"store\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.name\">{{card.name}}</div><div class=\"subtitle secondary-text mt-8 mb-8\" ng-if=\"card.address\">\n{{card.address}}</div><div class=\"text pt-16\" ng-if=\"card.phone\">{{card.phone}}</div><div \nclass=\"labels layout-wrap ng-scope layout-align-end-start layout-row\" layout=\"row\" \nng-if=\"card.current_store_id==card.id\" layout-wrap=\"\" layout-align=\"end start\"><div \nclass=\"label ng-binding ng-scope md-green-300-bg\" role=\"button\">激活</div></div></div></div>");
$templateCache.put("app/main/apps/main-store/stores/stores.html","<div class=\"content stores-page\"><div layout=\"row\" class=\"layout-wrap layout-row\"><div flex=\"33\" class=\"flex-33\" \nng-repeat=\"store in vm.stores\" layout=\"column\"><ms-card template=\"\'app/main/apps/main-store/stores/_store_item.html\'\" \nng-model=\"store\" ng-click=\"vm.is_cud ? vm.openStoretDialog($event, store) : \'\'\"></ms-card></div></div><md-button \nng-if=\"vm.is_cud\" class=\"md-accent md-raised md-hue-1\" id=\"add-course-button\" ng-click=\"vm.openStoretDialog($event)\" \naria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon md-font-icon=\"icon-store\">\n</md-icon>添加店铺</md-button></div>");
$templateCache.put("app/main/apps/dashboards/analytics/dashboard-analytics.html","<div id=\"dashboard-analytics\"><div id=\"widgets\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap>\n<ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"p-24 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget1.title}}</div><div \nclass=\"text-boxed green-600-bg white-fg\">{{vm.widget1.onlineUsers}} online users</div></div><div \nclass=\"pb-32 border-bottom\"><nvd3 class=\"h-400 remove-x-lines remove-opacity\" options=\"vm.widget1.bigChart.options\" \ndata=\"vm.widget1.bigChart.data\"></nvd3></div><div layout=\"row\" layout-align=\"start center\" layout-wrap><div \nclass=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div \nlayout=\"column\" flex><div class=\"h3 secondary-text pb-8\">{{vm.widget1.sessions.title}}</div><div \nclass=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.sessions.value}}</div><div><nvd3 class=\"h-40\" \noptions=\"vm.widget1.sessions.options\" data=\"vm.widget1.sessions.data\"></nvd3></div></div></div><div \nclass=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div \nlayout=\"column\" flex><div class=\"h3 secondary-text pb-8\">{{vm.widget1.pageviews.title}}</div><div \nclass=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.pageviews.value}}</div><div><nvd3 class=\"h-40\" \noptions=\"vm.widget1.pageviews.options\" data=\"vm.widget1.pageviews.data\"></nvd3></div></div></div><div \nclass=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div \nlayout=\"column\" flex><div class=\"h3 secondary-text pb-8\">{{vm.widget1.pagesSessions.title}}</div><div \nclass=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.pagesSessions.value}}</div><div><nvd3 class=\"h-40\" \noptions=\"vm.widget1.pagesSessions.options\" data=\"vm.widget1.pagesSessions.data\"></nvd3></div></div></div><div \nclass=\"p-24 grey-50-bg\" layout=\"row\" layout-align=\"start center\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><div \nlayout=\"column\" flex><div class=\"h3 secondary-text pb-8\">{{vm.widget1.avgSessionDuration.title}}</div><div \nclass=\"font-size-32 line-height-32 pb-16\">{{vm.widget1.avgSessionDuration.value}}</div><div><nvd3 class=\"h-40\" \noptions=\"vm.widget1.avgSessionDuration.options\" data=\"vm.widget1.avgSessionDuration.data\"></nvd3></div></div></div>\n</div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-md=\"65\"><ms-widget-front class=\"white-bg\"><div class=\"p-16\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget2.title}}</div><md-menu><md-button \naria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div>\n<ui-gmap-google-map center=\"vm.widget2.map.center\" zoom=\"vm.widget2.map.zoom\" options=\"vm.widget2.map.options\">\n<ui-gmap-markers models=\"vm.widget2.map.markers\" coords=\"\'coords\'\"><ui-gmap-windows show=\"show\"><div ng-non-bindable>\n{{sessions}}</div></ui-gmap-windows></ui-gmap-markers></ui-gmap-google-map></div></ms-widget-front></ms-widget>\n<ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-md=\"35\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget3.title}}</div>\n<div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget3.currentRange\" aria-label=\"Change range\">\n<md-option ng-repeat=\"(key, range) in vm.widget3.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div>\n<div class=\"ph-16 pv-20 border-bottom\" ng-repeat=\"page in vm.widget3.pages[vm.widget3.currentRange]\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" flex><span class=\"h4 pb-10\">{{page.path}}</span>\n<md-progress-linear class=\"md-accent\" md-mode=\"determinate\" value=\"{{page.value}}\"></md-progress-linear></div><div \nclass=\"pl-32 h3 font-weight-500 secondary-text\">{{page.value}}%</div></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 pt-16 pb-8 md-accent-bg\"><div class=\"h3\">{{vm.widget4.title}}</div>\n</div><md-tabs class=\"md-accent no-radius\" md-dynamic-height><md-tab label=\"{{tab.label}}\" \nng-repeat=\"tab in vm.widget4.tabs\"><div layout=\"row\" layout-align=\"start center\" layout-wrap><div flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\" ng-repeat=\"group in tab.groups\"><div class=\"h2 m-16 pb-16 border-bottom\">\n{{group.title}}</div><div class=\"p-16 pb-32\" ng-repeat=\"data in group.data\"><div class=\"pb-8\" layout=\"row\" \nlayout-align=\"space-between start\"><span class=\"h3\">{{data.title}}</span> <span \nclass=\"h3 secondary-text font-weight-500\">{{data.value}}%</span></div><md-progress-linear \nclass=\"{{data.progressColor}}\" md-mode=\"determinate\" value=\"{{data.value}}\"></md-progress-linear></div></div></div>\n</md-tab></md-tabs></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/apps/dashboards/project/dashboard-project.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">{{vm.store_name}}</span></div></div></div>\n<div class=\"content\"><md-tabs md-dynamic-height><md-tab label=\"首页\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><md-select \nclass=\"simplified font-size-16\" ng-model=\"vm.widget1.currentRange\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in vm.widget1.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\nDetails</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"light-blue-fg font-size-72 line-height-72\">\n{{vm.widget1.data.count[vm.widget1.currentRange]}}</div><div class=\"h3 secondary-text font-weight-500\">\n{{vm.widget1.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\">\n<span class=\"h4 secondary-text text-truncate\">{{vm.widget1.data.extra.label}}:</span> <span class=\"h4 ml-8\">\n{{vm.widget1.data.extra.count[vm.widget1.currentRange]}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">今日营业额</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">{{vm.data.amount}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget2.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget2.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.data.week_amount}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget3.title}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\nDetails</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"orange-fg font-size-72 line-height-72\">{{vm.widget3.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget3.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget3.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget3.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget4.title}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\nDetails</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">{{vm.widget4.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget4.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget4.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget4.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget4.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">今日课程</div><div \nclass=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget7.currentRange\" aria-label=\"Change range\"></md-select>\n</div></div><div class=\"p-16\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"event in vm.data.today_courses\"><div ng-if=\"vm.data.today_courses.length > 0\"><div class=\"h3\"><a \nui-sref=\"app.store.courses.detail({id:event.id})\">{{event.name}}</a></div><div><span class=\"secondary-text\">\n{{event.course_begintime}}~{{event.course_endtime}}</span> <span ng-if=\"event.location\">, {{event.location}}</span>\n</div></div></div><div class=\"p-16\" ng-if=\"vm.data.today_courses.length == 0\">暂无数据</div></ms-widget-front></ms-widget>\n<ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">未来生日</div><div \nclass=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget7.currentRange\" aria-label=\"Change range\"></md-select>\n</div></div><div class=\"p-16\" layout=\"row\" layout-align=\"space-between center\" ng-repeat=\"event in vm.data.customers\">\n<div ng-if=\"vm.data.customers.length > 0\"><div class=\"h3\"><a ui-sref=\"app.store.customers.detail({id:event.id})\">\n{{event.name}}</a></div><div><span class=\"secondary-text\">{{event.birthday}}</span> <span>\n, {{event.sex == 0 ? \'女\' : \'男\'}}</span></div></div></div><div class=\"p-16\" ng-if=\"vm.data.customers.length == 0\">暂无数据\n</div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">请假申请\n</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget7.currentRange\" aria-label=\"Change range\">\n<md-option ng-repeat=\"(key, range) in vm.widget7.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div>\n<div class=\"p-16\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"event in vm.widget7.schedule[vm.widget7.currentRange]\"><div><div class=\"h3\">{{event.title}}</div><div><span \nclass=\"secondary-text\">{{event.time}}</span> <span ng-if=\"event.location\">, {{event.location}}</span></div></div>\n<md-button class=\"md-icon-button\" aria-label=\"More information\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front \nclass=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n课程报名未审核</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget7.currentRange\" \naria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget7.ranges\" value=\"{{key}}\">{{range}}\n</md-option></md-select></div></div><div class=\"p-16\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"event in vm.widget7.schedule[vm.widget7.currentRange]\"><div><div class=\"h3\">{{event.title}}</div><div><span \nclass=\"secondary-text\">{{event.time}}</span> <span ng-if=\"event.location\">, {{event.location}}</span></div></div>\n<md-button class=\"md-icon-button\" aria-label=\"More information\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button></div></ms-widget-front></ms-widget></div></md-tab><md-tab label=\"近期开课信息\"><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"p-24 mb-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h2\">{{vm.widget11.title}}\n</div><div class=\"text-boxed red-bg white-fg m-0\">{{vm.widget11.table.rows.length}} members</div></div><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.widget11.dtOptions\"><thead><tr><th \nclass=\"secondary-text\" ng-repeat=\"column in ::vm.widget11.table.columns\"><div class=\"table-header\"><span \nclass=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in ::vm.widget11.table.rows\"><td ng-repeat=\"cell in row\"><img class=\"avatar\" ng-if=\"$index === 0\" \nng-src=\"assets/images/avatars/{{cell}}\"> <span ng-if=\"$index != 0\">{{cell}}</span></td></tr></tbody></table>\n</ms-widget-front></ms-widget></div></md-tab><md-tab label=\"会员统计\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"h3 p-16\">{{vm.widget8.title}}</div><md-divider></md-divider><div class=\"p-16\"><nvd3 class=\"h-400\" \noptions=\"vm.widget8.mainChart.options\" data=\"vm.widget8.mainChart.data\"></nvd3></div></ms-widget-front></ms-widget>\n<ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget9.title}}</div>\n<div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget9.currentRange\" \nng-change=\"vm.widget9.changeRange(vm.widget9.currentRange)\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in vm.widget6.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\"><div \nclass=\"p-8\"><div class=\"h4 secondary-text\">{{vm.widget9.weeklySpent.title}}</div><div \nclass=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$</span><span>\n{{vm.widget9.weeklySpent.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex><nvd3 class=\"h-50\" \nconfig=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" data=\"vm.widget9.weeklySpent.chartData\"></nvd3>\n</div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"space-between center\"><div class=\"p-8\"><div class=\"h4 secondary-text\">\n{{vm.widget9.totalSpent.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$\n</span><span>{{vm.widget9.totalSpent.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex><nvd3 \nclass=\"h-50\" config=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" \ndata=\"vm.widget9.totalSpent.chartData\"></nvd3></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\"><div class=\"p-8\"><div class=\"h4 secondary-text\">\n{{vm.widget9.remaining.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$\n</span><span>{{vm.widget9.remaining.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex><nvd3 \nclass=\"h-50\" config=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" data=\"vm.widget9.remaining.chartData\">\n</nvd3></div></div><div class=\"pv-24 mh-24 border-top\"><div class=\"h4 secondary-text\">{{vm.widget9.totalBudget.title}}\n</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$</span><span>\n{{vm.widget9.totalBudget.count}}</span></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"simple-table-container\" ms-responsive-table><div class=\"table-title\">{{vm.widget10.title}}</div><table \nclass=\"simple\"><thead><tr><th ng-repeat=\"column in vm.widget10.table.columns\">{{column.title}}</th></tr></thead><tbody>\n<tr ng-repeat=\"row in vm.widget10.table.rows\"><td ng-repeat=\"cell in row\"><span class=\"{{cell.classes}}\">\n{{cell.value}} </span><i ng-if=\"cell.icon\" class=\"icon {{cell.icon}}\"></i></td></tr></tbody></table></div>\n</ms-widget-front></ms-widget></div></md-tab></md-tabs></div></div><md-sidenav class=\"sidenav md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div class=\"widget-group\">\n<ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div class=\"pl-16 pr-8 pv-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">\n{{vm.nowWidget.now.weekDay}}, {{vm.nowWidget.now.hour}}:{{vm.nowWidget.now.minute}}:{{vm.nowWidget.now.second}}</div>\n<md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" md-menu-origin md-menu-align-target \naria-label=\"Options\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" \nclass=\"icon\"></md-icon>Refresh</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon>Settings</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"p-16 pb-24\" layout=\"column\" layout-align=\"center center\">\n<div class=\"h1 secondary-text\"><span>{{vm.nowWidget.now.month}}</span></div><div \nclass=\"font-size-72 line-height-88 secondary-text font-weight-400\">{{vm.nowWidget.now.day}}</div><div \nclass=\"h1 secondary-text\"><span>{{vm.nowWidget.now.year}}</span></div></div><md-divider></md-divider></ms-widget-front>\n</ms-widget><ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div class=\"pl-16 pr-8 pv-16\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h4\"><md-icon md-font-icon=\"icon-map-marker\" \nclass=\"icon mr-8\"></md-icon>{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].name}}</div><md-menu>\n<md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" md-menu-origin md-menu-align-target aria-label=\"Options\">\n<md-icon md-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" class=\"icon\"></md-icon>Refresh\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon \nmd-font-icon=\"icon-cog\" class=\"icon\"></md-icon>Settings</md-button></md-menu-item></md-menu-content></md-menu></div>\n<div class=\"p-16 pb-32\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"center center\">\n<md-icon md-font-icon=\"{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].icon}}\" class=\"icon s40 mr-16\">\n</md-icon><span class=\"md-display-2 font-weight-300 secondary-text\">\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].temp[vm.weatherWidget.tempUnit]}} </span><span \nclass=\"font-size-48 font-weight-300 hint-text text-super ml-8\">&deg;</span> <span \nclass=\"md-display-2 font-weight-300 hint-text\">{{vm.weatherWidget.tempUnit}}</span></div></div><div \nclass=\"grey-300-bg p-16\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-windy\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windSpeed[vm.weatherWidget.speedUnit]}} </span><span \nclass=\"secondary-text ml-5\">{{vm.weatherWidget.speedUnit}}</span></div><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-compass-outline\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windDirection}}</span></div><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-umbrella\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].rainProbability}}</span></div></div><div class=\"pv-16\">\n<div class=\"pv-16 ph-24\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"day in vm.weatherWidget.locations[vm.weatherWidget.currentLocation].next3Days\"><span class=\"h4\">{{day.name}}\n</span><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"mr-16\" md-font-icon=\"{{day.icon}}\" class=\"icon\">\n</md-icon><span class=\"h2\">{{day.temp[vm.weatherWidget.tempUnit]}}</span> <span \nclass=\"h2 font-weight-300 secondary-text text-super\">&deg;</span> <span class=\"h2 font-weight-300 secondary-text\">\n{{vm.weatherWidget.tempUnit}}</span></div></div></div><md-divider></md-divider></ms-widget-front></ms-widget></div>\n</md-sidenav></div>");
$templateCache.put("app/main/apps/dashboards/project/dashboard-project_orig.html","<div id=\"dashboard-project\" class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div layout=\"row\" \nlayout-align=\"space-between\"><div><span class=\"md-display-1 font-weight-300\">Welcome back, John!</span></div><div \nclass=\"toolbar\"><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div></div><div \nlayout=\"row\"><div class=\"selected-project\">{{vm.selectedProject.name}}</div><md-menu id=\"projects-menu\" \nmd-offset=\"0 48\"><md-button class=\"md-icon-button project-selector\" ng-click=\"$mdOpenMenu()\" \naria-label=\"Select project\" md-menu-origin md-menu-align-target><md-icon md-font-icon=\"icon-dots-horizontal\"></md-icon>\n</md-button><md-menu-content width=\"3\" class=\"md-background-bg\"><md-menu-item ng-repeat=\"project in vm.projects\">\n<md-button ng-click=\"vm.selectProject(project)\" aria-label=\"{{project.name}}\"><span \nng-class=\"{\'secondary-text\': vm.selectedProject == project}\">{{project.name}}</span></md-button></md-menu-item>\n</md-menu-content></md-menu></div></div><div class=\"content\"><md-tabs md-dynamic-height><md-tab label=\"Home\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"ph-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><md-select class=\"simplified font-size-16\" ng-model=\"vm.widget1.currentRange\" \naria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget1.ranges\" value=\"{{key}}\">{{range}}\n</md-option></md-select><md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"light-blue-fg font-size-72 line-height-72\">{{vm.widget1.data.count[vm.widget1.currentRange]}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget1.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget1.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget1.data.extra.count[vm.widget1.currentRange]}}</span></div></ms-widget-front>\n<ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget1.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget2.title}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\nDetails</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"red-fg font-size-72 line-height-72\">{{vm.widget2.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget2.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget2.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget2.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget3.title}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\nDetails</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"orange-fg font-size-72 line-height-72\">{{vm.widget3.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget3.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget3.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget3.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget4.title}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">\nDetails</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">\nRefresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"blue-grey-fg font-size-72 line-height-72\">{{vm.widget4.data.count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">{{vm.widget4.data.label}}</div></div><div class=\"p-16 grey-50-bg border-top\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">{{vm.widget4.data.extra.label}}:\n</span> <span class=\"h4 ml-8\">{{vm.widget4.data.extra.count}}</span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>\n{{vm.widget4.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-8 border-bottom\" \nlayout=\"row\" layout-align=\"space-between center\" layout-wrap><div class=\"pv-8 h3\">{{vm.widget5.title}}</div><div \nclass=\"pv-8\" layout=\"row\" layout-align=\"start center\" layout-align-sm=\"end\" flex-sm=\"100\"><md-button class=\"ph-16\" \nng-repeat=\"(key, range) in vm.widget5.ranges\" ng-click=\"vm.widget5.changeRange(key)\" \nng-disabled=\"vm.widget5.currentRange == key\">{{range}}</md-button></div></div><div layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"50\"><nvd3 \nclass=\"h-420 remove-x-lines\" config=\"vm.widget5.mainChart.config\" options=\"vm.widget5.mainChart.options\" \ndata=\"vm.widget5.mainChart.data\"></nvd3></div><div class=\"p-16\" layout=\"row\" flex=\"100\" flex-gt-sm=\"50\" layout-wrap>\n<div class=\"p-16\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" layout-align=\"center\" \nng-repeat=\"(name, widget) in vm.widget5.supporting.widgets\"><div class=\"h4 secondary-text\">{{widget.data.label}}</div>\n<div class=\"md-display-1\">{{widget.data.count[vm.widget5.currentRange]}}</div><nvd3 class=\"h-50\" \nconfig=\"vm.widget5.supporting.chart.config\" options=\"vm.widget5.supporting.chart.options\" data=\"widget.chart.data\">\n</nvd3></div></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget6.title}}</div>\n<div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget6.currentRange\" \nng-change=\"vm.widget6.changeRange(vm.widget6.currentRange)\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in vm.widget6.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div \nclass=\"p-16\"><nvd3 class=\"h-400\" config=\"vm.widget6.mainChart.config\" options=\"vm.widget6.mainChart.options\" \ndata=\"vm.widget6.mainChart.data\"></nvd3></div><div class=\"pv-8 mh-16 border-top\" layout=\"row\" \nlayout-align=\"start center\" layout-wrap><div class=\"pv-8 border-right\" layout=\"column\" layout-align=\"center center\" \nflex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">{{vm.widget6.footerLeft.count[vm.widget6.currentRange]}}</span> \n<span class=\"h4\">{{vm.widget6.footerLeft.title}}</span></div><div class=\"pv-8\" layout=\"column\" \nlayout-align=\"center center\" flex=\"100\" flex-gt-xs=\"50\"><span class=\"font-size-32\">\n{{vm.widget6.footerRight.count[vm.widget6.currentRange]}}</span> <span class=\"h4\">{{vm.widget6.footerRight.title}}\n</span></div></div></ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front\n class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n{{vm.widget7.title}}</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget7.currentRange\" \naria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.widget7.ranges\" value=\"{{key}}\">{{range}}\n</md-option></md-select></div></div><div class=\"p-16\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"event in vm.widget7.schedule[vm.widget7.currentRange]\"><div><div class=\"h3\">{{event.title}}</div><div><span \nclass=\"secondary-text\">{{event.time}}</span> <span ng-if=\"event.location\">, {{event.location}}</span></div></div>\n<md-button class=\"md-icon-button\" aria-label=\"More information\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button></div></ms-widget-front></ms-widget></div></md-tab><md-tab label=\"Budget Summary\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\">\n<ms-widget-front class=\"white-bg\"><div class=\"h3 p-16\">{{vm.widget8.title}}</div><md-divider></md-divider><div \nclass=\"p-16\"><nvd3 class=\"h-400\" options=\"vm.widget8.mainChart.options\" data=\"vm.widget8.mainChart.data\"></nvd3></div>\n</ms-widget-front></ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\">\n<div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget9.title}}\n</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget9.currentRange\" \nng-change=\"vm.widget9.changeRange(vm.widget9.currentRange)\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in vm.widget6.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div \nclass=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\"><div \nclass=\"p-8\"><div class=\"h4 secondary-text\">{{vm.widget9.weeklySpent.title}}</div><div \nclass=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$</span><span>\n{{vm.widget9.weeklySpent.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex><nvd3 class=\"h-50\" \nconfig=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" data=\"vm.widget9.weeklySpent.chartData\"></nvd3>\n</div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" layout-gt-xs=\"row\" \nlayout-align-gt-xs=\"space-between center\"><div class=\"p-8\"><div class=\"h4 secondary-text\">\n{{vm.widget9.totalSpent.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$\n</span><span>{{vm.widget9.totalSpent.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex><nvd3 \nclass=\"h-50\" config=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" \ndata=\"vm.widget9.totalSpent.chartData\"></nvd3></div></div><div class=\"p-16\" layout=\"column\" layout-align=\"center\" \nlayout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\"><div class=\"p-8\"><div class=\"h4 secondary-text\">\n{{vm.widget9.remaining.title}}</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$\n</span><span>{{vm.widget9.remaining.count[vm.widget9.currentRange]}}</span></div></div><div class=\"p-8\" flex><nvd3 \nclass=\"h-50\" config=\"vm.widget9.chart.config\" options=\"vm.widget9.chart.options\" data=\"vm.widget9.remaining.chartData\">\n</nvd3></div></div><div class=\"pv-24 mh-24 border-top\"><div class=\"h4 secondary-text\">{{vm.widget9.totalBudget.title}}\n</div><div class=\"pt-8 md-display-1 font-weight-300\"><span class=\"secondary-text\">$</span><span>\n{{vm.widget9.totalBudget.count}}</span></div></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" \nlayout=\"row\" flex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"simple-table-container\" ms-responsive-table><div class=\"table-title\">{{vm.widget10.title}}</div><table \nclass=\"simple\"><thead><tr><th ng-repeat=\"column in vm.widget10.table.columns\">{{column.title}}</th></tr></thead><tbody>\n<tr ng-repeat=\"row in vm.widget10.table.rows\"><td ng-repeat=\"cell in row\"><span class=\"{{cell.classes}}\">\n{{cell.value}} </span><i ng-if=\"cell.icon\" class=\"icon {{cell.icon}}\"></i></td></tr></tbody></table></div>\n</ms-widget-front></ms-widget></div></md-tab><md-tab label=\"Team Members\"><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget layout=\"row\" flex=\"100\"><ms-widget-front class=\"white-bg\"><div \nclass=\"p-24 mb-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h2\">{{vm.widget11.title}}\n</div><div class=\"text-boxed red-bg white-fg m-0\">{{vm.widget11.table.rows.length}} members</div></div><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.widget11.dtOptions\"><thead><tr><th \nclass=\"secondary-text\" ng-repeat=\"column in ::vm.widget11.table.columns\"><div class=\"table-header\"><span \nclass=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in ::vm.widget11.table.rows\"><td ng-repeat=\"cell in row\"><img class=\"avatar\" ng-if=\"$index === 0\" \nng-src=\"assets/images/avatars/{{cell}}\"> <span ng-if=\"$index != 0\">{{cell}}</span></td></tr></tbody></table>\n</ms-widget-front></ms-widget></div></md-tab></md-tabs></div></div><md-sidenav class=\"sidenav md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div class=\"widget-group\">\n<ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div class=\"pl-16 pr-8 pv-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">\n{{vm.nowWidget.now.weekDay}}, {{vm.nowWidget.now.hour}}:{{vm.nowWidget.now.minute}}:{{vm.nowWidget.now.second}}</div>\n<md-menu><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" md-menu-origin md-menu-align-target \naria-label=\"Options\"><md-icon md-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" \nclass=\"icon\"></md-icon>Refresh</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-cog\" class=\"icon\"></md-icon>Settings</md-button>\n</md-menu-item></md-menu-content></md-menu></div><div class=\"p-16 pb-24\" layout=\"column\" layout-align=\"center center\">\n<div class=\"h1 secondary-text\"><span>{{vm.nowWidget.now.month}}</span></div><div \nclass=\"font-size-72 line-height-88 secondary-text font-weight-400\">{{vm.nowWidget.now.day}}</div><div \nclass=\"h1 secondary-text\"><span>{{vm.nowWidget.now.year}}</span></div></div><md-divider></md-divider></ms-widget-front>\n</ms-widget><ms-widget flippable=\"false\" class=\"sidenav-widget\"><ms-widget-front><div class=\"pl-16 pr-8 pv-16\" \nlayout=\"row\" layout-align=\"space-between center\"><div class=\"h4\"><md-icon md-font-icon=\"icon-map-marker\" \nclass=\"icon mr-8\"></md-icon>{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].name}}</div><md-menu>\n<md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" md-menu-origin md-menu-align-target aria-label=\"Options\">\n<md-icon md-font-icon=\"icon-dots-vertical\" class=\"icon\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item>\n<md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon md-font-icon=\"icon-refresh\" class=\"icon\"></md-icon>Refresh\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.nowWidget.dummyFunction()\"><md-icon \nmd-font-icon=\"icon-cog\" class=\"icon\"></md-icon>Settings</md-button></md-menu-item></md-menu-content></md-menu></div>\n<div class=\"p-16 pb-32\" layout=\"column\" layout-align=\"center center\"><div layout=\"row\" layout-align=\"center center\">\n<md-icon md-font-icon=\"{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].icon}}\" class=\"icon s40 mr-16\">\n</md-icon><span class=\"md-display-2 font-weight-300 secondary-text\">\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].temp[vm.weatherWidget.tempUnit]}} </span><span \nclass=\"font-size-48 font-weight-300 hint-text text-super ml-8\">&deg;</span> <span \nclass=\"md-display-2 font-weight-300 hint-text\">{{vm.weatherWidget.tempUnit}}</span></div></div><div \nclass=\"grey-300-bg p-16\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-weather-windy\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windSpeed[vm.weatherWidget.speedUnit]}} </span><span \nclass=\"secondary-text ml-5\">{{vm.weatherWidget.speedUnit}}</span></div><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-compass-outline\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].windDirection}}</span></div><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-umbrella\" class=\"icon mr-8 s20\"></md-icon><span>\n{{vm.weatherWidget.locations[vm.weatherWidget.currentLocation].rainProbability}}</span></div></div><div class=\"pv-16\">\n<div class=\"pv-16 ph-24\" layout=\"row\" layout-align=\"space-between center\" \nng-repeat=\"day in vm.weatherWidget.locations[vm.weatherWidget.currentLocation].next3Days\"><span class=\"h4\">{{day.name}}\n</span><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"mr-16\" md-font-icon=\"{{day.icon}}\" class=\"icon\">\n</md-icon><span class=\"h2\">{{day.temp[vm.weatherWidget.tempUnit]}}</span> <span \nclass=\"h2 font-weight-300 secondary-text text-super\">&deg;</span> <span class=\"h2 font-weight-300 secondary-text\">\n{{vm.weatherWidget.tempUnit}}</span></div></div></div><md-divider></md-divider></ms-widget-front></ms-widget></div>\n</md-sidenav></div>");
$templateCache.put("app/main/apps/dashboards/server/dashboard-server.html","<div id=\"dashboard-server\"><div id=\"widgets\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg\"><div class=\"pb-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">{{vm.widget1.title}}</div><md-menu><md-button aria-label=\"more\" \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div><nvd3 class=\"h-320\" class=\"remove-x-lines\" \noptions=\"vm.widget1.chart.options\" data=\"vm.widget1.chart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 pink-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" \nmd-font-icon=\"icon-harddisk\"></md-icon><div class=\"h3\">{{vm.widget2.title}}</div></div><md-menu><md-button \naria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" \naria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"h2\">{{vm.widget2.value.used}}</div><div \nclass=\"h2 secondary-text pl-8\">/ {{vm.widget2.value.total}}</div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.widget2.value.percentage}}\"></md-progress-linear></ms-widget-front><ms-widget-back \nclass=\"p-16 pr-32 pink-400-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget2.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 blue-bg white-fg\"><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"m-0 mr-8\" md-font-icon=\"icon-server-network\"></md-icon><div class=\"h3\">{{vm.widget3.title}}</div></div><md-menu>\n<md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pb-24\" layout=\"row\" layout-align=\"start end\"><div class=\"h2\">{{vm.widget3.value.used}}</div><div \nclass=\"h2 pl-8 secondary-text\">/ {{vm.widget3.value.total}}</div></div><md-progress-linear md-mode=\"determinate\" \nvalue=\"{{vm.widget3.value.percentage}}\"></md-progress-linear></ms-widget-front><ms-widget-back \nclass=\"p-16 pr-32 blue-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget3.detail}}</div></ms-widget-back></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front class=\"p-16 teal-400-bg white-fg\"><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nclass=\"m-0 mr-8\" md-font-icon=\"icon-clock-fast\"></md-icon><div class=\"h3\">{{vm.widget4.title}}</div></div><md-menu>\n<md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pb-8 h1\">{{vm.widget4.value}}</div><div class=\"chart-fill-16\"><nvd3 \nclass=\"h-50 remove-opacity remove-line-stroke\" config=\"vm.widget4.chart.config\" options=\"vm.widget4.chart.options\" \ndata=\"vm.widget4.chart.data\"></nvd3></div></ms-widget-front><ms-widget-back class=\"p-16 pr-32 teal-400-bg white-fg\">\n<div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div>{{vm.widget4.detail}}</div></ms-widget-back>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"50\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"p-16 indigo-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon class=\"m-0 mr-8\" md-font-icon=\"icon-scale\"></md-icon><div class=\"h3\">\n{{vm.widget5.title}}</div></div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item>\n</md-menu-content></md-menu></div><div layout=\"column\" layout-align=\"space-between\" flex><div class=\"h1 pb-8\" \nlayout=\"row\" layout-align=\"start center\"><span>{{vm.widget5.value}}</span><md-icon md-font-icon=\"icon-trending-down\" \nclass=\"ml-16\"></md-icon></div><div class=\"secondary-text\">{{vm.widget5.footnote}}</div></div></ms-widget-front>\n<ms-widget-back class=\"p-16 pr-32 indigo-400-bg white-fg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" \nng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button>\n</div><div>{{vm.widget5.detail}}</div></ms-widget-back></ms-widget></div><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\"><ms-widget-front class=\"p-16 white-bg\"><div\n class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">{{vm.widget6.title}}</div><md-menu>\n<md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div><nvd3 class=\"h-140 remove-x-lines remove-opacity\" config=\"vm.widget6.chart.config\" \noptions=\"vm.widget6.chart.options\" data=\"vm.widget6.chart.data\"></nvd3></div></ms-widget-front></ms-widget></div><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" \nflex-gt-md=\"60\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">{{vm.widget7.title}}\n</span> <span class=\"ml-16 text-boxed pink-bg white-fg\">{{vm.widget7.table.rows.length}} processes</span></div>\n<md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><table class=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.widget7.dtOptions\"><thead><tr><th \nclass=\"secondary-text\" ng-repeat=\"column in ::vm.widget7.table.columns\"><div class=\"table-header\"><span \nclass=\"column-title\">{{column.title}}</span></div></th></tr></thead><tbody><tr \nng-repeat=\"row in ::vm.widget7.table.rows\"><td ng-repeat=\"cell in row\"><span class=\"{{cell.classes}}\">{{cell.value}}\n</span></td></tr></tbody></table></ms-widget-front></ms-widget><ms-widget flippable=\"false\" layout=\"row\" flex=\"100\" \nflex-gt-md=\"40\"><ms-widget-front class=\"white-bg\"><div class=\"ph-16 pv-24 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><span class=\"h3\">{{vm.widget8.title}}\n</span> <span class=\"ml-16 text-boxed blue-bg white-fg\">Showing last {{vm.widget8.activities.length}} activity</span>\n</div><md-menu><md-button aria-label=\"more\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"ph-16 pv-15 border-bottom\" layout=\"row\" layout-align=\"start center\" \nng-repeat=\"activity in vm.widget8.activities\"><div><i class=\"icon pr-16 mr-16 border-right\" \nng-class=\"{\'icon-arrow-down red-fg\':activity.type === \'Input\', \'icon-arrow-up green-fg\':activity.type === \'Output\'}\">\n</i></div><div class=\"h4 text-bold\" flex>{{activity.process}}</div><div class=\"h4 font-weight-500 secondary-text\">\n{{activity.value}}</div></div></ms-widget-front></ms-widget></div></div></div>");
$templateCache.put("app/main/apps/store/contracts/contract-detail.html","<div id=\"dashboard-server\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"35\" flex-gt-md=\"35\"><md-card id=\"baby-info\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div \nclass=\"user-info\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\">\n<div class=\"name\"><a ui-sref=\"app.store.customers.detail({id:vm.contract.customer_id})\">\n{{vm.contract.customer_name}}({{vm.contract.customer_sex}})</a></div></div></div><md-card-content><p>合同号：<span>\n{{vm.contract.contact_guid}}</span></p><p ng-if=\"vm.contract.plan_id\">教学计划：<span>{{vm.contract.plan_title}}</span></p>\n<p>卡类型：<span>{{vm.contract.card_type}}</span></p><p>卡&nbsp;&nbsp;项：<span>{{vm.contract.contract_type}}</span></p><p>\n支付类型：<span>{{vm.contract.pay_type}}<span style=\"color:red\">&nbsp;&nbsp;¥{{vm.contract.amount}}</span></span></p><p>\n合同状态：<span>{{vm.contract.status_name}}</span></p><p>更新时间：<span>{{vm.contract.update_time}}</span></p><div \nng-if=\"vm.is_cud\" class=\"pt-8\" layout=\"column\" layout-align=\"center\"><div layout=\"row\" layout-wrap flex=\"100\" \nlayout-align=\"center\"><div flex=\"50\" layout-align=\"start center\" class=\"ng-scope layout-align-start-center\"><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.openContractDialog($event, vm.contract)\">修改信息</md-button></div><div \nflex=\"50\" layout-align=\"start center\" class=\"ng-scope layout-align-start-center\"><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.createCoursesForContract($event, vm.contract)\">排课</md-button></div></div>\n</div></md-card-content></md-card></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"65\" \nflex-gt-md=\"65\"><ms-widget-front id=\"con-info\" class=\"white-bg\"><div class=\"p-16\" layout=\"row\" \nlayout-align=\"space-between center\"><div><div class=\"h3 mb-5\">销售人员：<span>{{vm.contract.consult_name}}</span></div>\n<span>签订日期：<span>{{vm.contract.sign_date | date:\'yyyy-MM-dd\'}}</span></span></div></div><div class=\"ph-16 pt-8\"><div \nlayout=\"row\" layout-wrap><div flex=\"50\" layout-align=\"start center\" class=\"ng-scope layout-align-start-center\"><div \nclass=\"h-10 w-10 mr-8 md-green-600-bg\" ng-class=\"\"></div><span class=\"title ng-binding\">\n合同开始时间: {{vm.contract.start_date}}</span></div><div flex layout-align=\"start center\" \nclass=\"ng-scope layout-align-start-center\"><div class=\"h-10 w-10 mr-8 md-orange-800-bg\" ng-class=\"\"></div><span \nclass=\"title ng-binding\">合同结束时间: {{vm.contract.end_date}}</span></div></div></div><div \nclass=\"widget-group ph-8 pb-8 pt-8\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"33\"><ms-widget-front class=\"p-16 pink-400-bg white-fg\"><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"h3\">剩余/可请假\n</div></div></div><div class=\"\" layout=\"row\" layout-align=\"start center\"><div class=\"h2\">\n{{vm.contract.can_leave_times - vm.contract.can_leave_times1}}次</div><div class=\"h2 secondary-text pl-8\">\n/{{vm.contract.can_leave_times}}次</div></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"33\" ng-repeat=\"item in vm.contract.ContractsHasCourses\"><ms-widget-front \nclass=\"p-16 teal-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"h3\">{{item.categories_name}}(余/总)</div></div></div><div class=\"\" \nlayout=\"row\" layout-align=\"start center\"><div class=\"h2\">{{item.course_number_remaining}}节</div><div \nclass=\"h2 secondary-text pl-8\">/ {{item.course_number}}节</div></div></ms-widget-front></ms-widget></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" flex=\"100\" flex-gt-xs=\"35\" flex-gt-md=\"35\" ng-if=\"vm.contract.kuadians\"><ms-widget-front \nid=\"course-number\" class=\"white-bg\"><div class=\"h3 p-16 ng-scope\">跨门店课数(总／余)</div><div class=\"pb-16\" \nstyle=\"min-height: 160px\"><div class=\"ph-16 pb-20 pt-8 border-bottom\" ng-repeat=\"item in vm.contract.kuadians\"><div>\n{{item.to_store_name}}<span style=\"float: right\">{{item.course_number}}节 / {{item.course_number_remaining}}节</span>\n</div></div></div></ms-widget-front></ms-widget><ms-widget flippable=\"false\" flex=\"100\" flex-gt-xs=\"65\" \nflex-gt-md=\"65\"><ms-widget-front id=\"course-info\" class=\"white-bg\"><div ng-cloak><md-content><md-tabs \nmd-dynamic-height md-border-bottom><md-tab label=\"计划课程\" ng-if=\"vm.contract.plan_id\"><md-content class=\"md-padding\"><div\n id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page datatable-page\" \nstyle=\"position: relative\"><md-table-container><table md-table class=\"md-data-table\"><thead md-head \nmd-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row><th md-column md-order-by=\"name\" decend-first \nstyle=\"padding-left: 15px!important\"><span class=\"column-title\">课程</span></th><th md-column md-order-by=\"course_time\" \ndecend-first><span class=\"\">日期</span></th><th md-column md-order-by=\"course_time\" decend-first><span class=\"\">老师</span>\n</th><th md-column md-order-by=\"status\" decend-first><span class=\"column-title\">状态</span></th></tr></thead><tbody><tr \nng-repeat=\"(signup_key,signup) in vm.signups.data\"><td md-cell style=\"padding-left: 15px!important\"><a \nhref=\"/store/courses/detail/{{signup.course.id}}\">{{signup.course.plan}} - {{signup.course.name}}</a></td><td md-cell>\n{{signup.course.course_time}} {{signup.course.course_begintime}} ~ {{signup.course.course_endtime}}</td><td md-cell>\n{{signup.course.teacher_name}}</td><td md-cell>{{signup.status_text}}</td></tr></tbody></table></md-table-container>\n</div></md-content></md-tab><md-tab label=\"修改记录\"><md-content class=\"md-padding\"><div id=\"simple-table\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page datatable-page\" style=\"position: relative\">\n<md-table-container><table md-table class=\"md-data-table\"><thead md-head md-order=\"vm.query.sort\" \nmd-on-reorder=\"vm.doSearch\"><tr md-row><th md-column md-order-by=\"customer_id\" decend-first \nstyle=\"padding-left: 15px!important\"><span class=\"column-title\">修改时间</span></th><th md-column md-order-by=\"type\" \ndecend-first><span class=\"\">修改内容</span></th><th md-column md-order-by=\"apply_time\" decend-first><span \nclass=\"column-title\">操作人</span></th></tr></thead><tbody><tr ng-repeat=\"item in vm.contractLogs\"><td md-cell \nstyle=\"padding-left: 15px!important\">{{ item.created_at }}</td><td md-cell>{{item.remark}}</td><td md-cell>\n{{item.user_name}}</td></tr></tbody></table></md-table-container></div></md-content></md-tab><md-tab label=\"合同附件\">\n<md-content class=\"md-padding\"><div layout=\"row\" layout-padding=\"5\" \nclass=\"page-layout simple fullwidth doc-page element-doc-page\"><div flex=\"25\" \nng-repeat=\"item in vm.contractsattachments\" ng-if=\"vm.contractsattachments\"><div \nng-if=\"[\'image/jpeg\',\'image/png\'].indexOf(item.file_type)!=-1\"><img ng-src=\"{{item.url}}?imageView/1/w/300/h/185\">\n</div><div ng-if=\"[\'image/jpeg\',\'image/png\'].indexOf(item.file_type)==-1\"><img \nng-src=\"http://oi13jvi1i.bkt.clouddn.com/contract/20170103/110718.jpg?imageView/1/w/300/h/185\"></div><div \nstyle=\"text-align: center\">{{item.file_name}}</div><div style=\"text-align: center\"><a target=\"_blank\" \nhref=\"{{item.url}}\">下载</a></div></div></div></md-content><md-input-container style=\"left:45%\"><div \nng-file-select=\"vm.onFileSelect($files)\" data-multiple=\"false\" onclick=\"this.value = null\" class=\"btn btn-upload\" \nstyle=\"text-align: center\"><md-button class=\"md-accent md-raised\" style=\"margin: auto; text-align: center\">上传合同附件\n</md-button></div></md-input-container></md-tab></md-tabs></md-content></div></ms-widget-front></ms-widget></div></div>\n<style>\n.md-data-table td{\n        padding: 10px 0px 10px 0px!important;\n    }\n    .md-data-table th{\n        padding: 10px 0px 10px 0px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/contracts/contracts.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\" \nclass=\"hide\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\">\n<md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" \nclass=\"s16 separator\"></md-icon><span class=\"parent\">合同管理</span></div><div class=\"title\" \nstyle=\"font-size: 24px!important\">{{vm.title}}</div></div><div class=\"search-input-wrapper\" layout=\"row\" \nlayout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label>\n<md-input-container md-no-float class=\"m-0\"><input placeholder=\"Search for anyone\" type=\"text\" \nng-model-options=\"{debounce : 1000}\" ng-model=\"vm.query.contact_guid\" translate ng-change=\"vm.doSearch()\" \ntranslate-attr-placeholder=\"合同号\"></md-input-container><md-input-container md-no-float class=\"m-0\" \nng-if=\"vm.contractFilterEnable.plan\"><input placeholder=\"Search for anyone\" type=\"text\" \nng-model-options=\"{debounce : 1000}\" ng-model=\"vm.query.plan_title\" translate ng-change=\"vm.doSearch()\" \ntranslate-attr-placeholder=\"课程计划\"></md-input-container><md-input-container md-no-float class=\"m-0\" \nng-if=\"vm.contractFilterEnable.name\"><input placeholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.query.name\" \ntranslate ng-change=\"vm.doSearch()\" translate-attr-placeholder=\"学生姓名\"></md-input-container><md-input-container \nmd-no-float class=\"m-0\" ng-if=\"vm.contractFilterEnable.consult\"><label translate=\"课程顾问\">课程顾问</label><md-select \nng-model=\"vm.query.consult_id\" ng-change=\"vm.doSearch()\"><md-option ng-repeat=\"user in vm.consults\" \nvalue=\"{{user.id}}\">{{user.name}}</md-option></md-select></md-input-container><md-input-container md-no-float \nclass=\"m-0\" ng-if=\"vm.contractFilterEnable.card_type\"><label translate=\"卡类型\">卡类型</label><md-select \nng-model=\"vm.query.card_type\" ng-change=\"vm.doSearch()\"><md-option ng-repeat=\"itme in vm.card_types\" \nvalue=\"{{itme.name}}\">{{itme.name}}</md-option></md-select></md-input-container><md-input-container md-no-float \nclass=\"m-0\" ng-if=\"vm.contractFilterEnable.contract_type\"><label translate=\"卡项\">卡项</label><md-select \nng-model=\"vm.query.contract_type_id\" ng-change=\"vm.doSearch()\"><md-option ng-repeat=\"itme in vm.contract_types\" \nvalue=\"{{itme.id}}\">{{itme.name}}</md-option></md-select></md-input-container><md-input-container md-no-float \nclass=\"m-0\" ng-if=\"vm.contractFilterEnable.pay_type\"><label translate=\"支付类型\">支付类型</label><md-select \nng-model=\"vm.query.pay_type\" ng-change=\"vm.doSearch()\"><md-option ng-repeat=\"item in vm.pay_types\" \nvalue=\"{{item.name}}\">{{item.name}}</md-option></md-select></md-input-container><md-input-container md-no-float \nclass=\"m-0\" ng-if=\"vm.contractFilterEnable.status\"><label translate=\"状态\">状态</label><md-select \nng-model=\"vm.query.status\" ng-change=\"vm.doSearch()\"><md-option ng-repeat=\"item in vm.contracts_status\" \nvalue=\"{{item.id}}\" ng-if=\"item.id>0\">{{item.name}}</md-option></md-select></md-input-container><md-input-container \nmd-no-float class=\"m-0\" ng-if=\"vm.contractFilterEnable.month\"><label translate=\"学生年龄\">学生年龄</label><md-select \nng-model=\"vm.query.month\" ng-change=\"vm.doSearch()\"><md-option ng-repeat=\"month in vm.months\" value=\"{{month.id}}\">\n{{month.id}}M</md-option></md-select></md-input-container><label translate=\"签订时间\">签订时间</label><md-datepicker flex \nmd-placeholder=\"签订日期\" ng-init=\"vm.query.sdate = \'\';\" ng-model=\"vm.query.sdate\" ng-change=\"vm.doSearch()\" \nng-model-options=\"{timezone:\'utc\'}\">{{vm.query.sdate}}</md-datepicker><md-datepicker flex md-placeholder=\"签订日期\" \nng-init=\"vm.query.edate = \'\';\" ng-model=\"vm.query.edate\" ng-change=\"vm.doSearch()\" ng-model-options=\"{timezone:\'utc\'}\">\n{{vm.query.edate}}</md-datepicker></div></div><div class=\"content white-bg\"><md-table-container><table md-table \nclass=\"md-data-table\"><thead md-head md-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row><th md-column \nmd-order-by=\"contact_guid\" decend-first><span class=\"column-title\">合同号<br>学习计划</span></th><th md-column \nmd-order-by=\"name\" decend-first><span class=\"column-title\">会员号<br>学生姓名</span></th><th md-column md-order-by=\"month\" \ndecend-first><span class=\"column-title\">学生生日<br>性别</span></th><th md-column md-order-by=\"contract_type\" decend-first>\n<span class=\"column-title\">卡类型<br>卡项</span></th><th md-column><span class=\"column-title\">课程总余</span></th><th md-column \nmd-order-by=\"pay_type\" decend-first><span class=\"column-title\">支付类型<br>支付金额</span></th><th md-column \nmd-order-by=\"sign_date\" decend-first><span class=\"column-title\">签订日期<br>销售顾问</span></th><th md-column \nmd-order-by=\"end_date\" decend-first><span class=\"column-title\">合同有效期</span></th><th md-column md-order-by=\"status\" \ndecend-first><span class=\"column-title\">状态</span><br><span class=\"column-title\">更新时间</span></th><th></th></tr></thead>\n<tbody><tr ng-repeat=\"contract in vm.contracts.data\" ui-sref=\"app.store.contracts.detail({id:contract.id})\" \nclass=\"pointer\"><td md-cell ui-sref=\"app.store.contracts.detail({id:contract.id})\">{{ contract.contact_guid }}<br>\n{{ contract.plan_title?contract.plan_title:\"无\" }}<br></td><td md-cell><a \nng-click=\"vm.openCustomer($event, contract.customer_id)\">{{contract.customer.member_id}}<br>\n{{ contract.customer_name }} <span ng-if=\"contract.customer_nickname\">({{contract.customer_nickname}})</span></a></td>\n<td md-cell>{{ contract.customer.birthday }}<br>{{ contract.customer_sex }}</td><td md-cell>{{ contract.card_type }}\n<br>{{ contract.contract_type }}</td><td md-cell><span ng-repeat=\"item in contract.ContractsHasCourses\">\n{{item.categories_name}}: <b style=\"color: #1e8f03\">{{item.course_number_remaining}}</b>/<b style=\"color: #ff0000\">\n{{item.course_number}}</b><br></span></td><td md-cell>{{ contract.pay_type }}<br>{{ contract.amount }}</td><td md-cell>\n{{ contract.sign_date | date:\'yyyy-MM-dd\' }}<br>{{ contract.consult_name }}</td><td md-cell>\n{{ contract.start_date | date:\'yyyy-MM-dd\' }}~<br>{{ contract.end_date | date:\'yyyy-MM-dd\' }}</td><td md-cell>\n{{ contract.status_name }}<br>{{ contract.update_time }}</td><td md-cell><a \nng-click=\"vm.openContractDialog($event, contract)\" ng-if=\"vm.is_cud\">修改</a> <a ng-if=\"contract.status==1\" \nng-click=\"vm.openYuyue($event, contract.id, contract.customer_id)\">约课</a> <a \nng-click=\"vm.updateStatus($event, contract)\" ng-if=\"contract.status==0\" ng-show=\"vm.is_cud\">还原</a> <a class=\"hide\" \nng-click=\"vm.openZcardDialog1($event, contract)\" ng-if=\"contract.status!=0\" ng-show=\"vm.is_cud\">转卡</a><br></td></tr>\n</tbody></table></md-table-container></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"footer white-bg\"><md-table-pagination md-limit=\"vm.query.limit\" md-page-select md-page=\"vm.query.page\" \nmd-total=\"{{vm.contracts._meta.totalCount}}\" md-on-paginate=\"vm.doSearch\"></md-table-pagination><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-if=\"vm.is_export\" class=\"md-raised reference-button\" type=\"button\" \nng-click=\"vm.exportContracts($event)\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>导出合同</span></md-button>\n<md-button ng-if=\"vm.is_cud\" class=\"md-fab md-mini md-accent md-icon-button mv-25\" id=\"add-course-button\" \nng-click=\"vm.openContractDialog($event)\" aria-label=\"add contact\" translate \ntranslate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></div>\n</div></div><style>\n.md-data-table td{\n        padding: 10px 0px 10px 0px!important;\n    }\n    .md-data-table th{\n        padding: 10px 0px 10px 0px!important;\n    }\n    md-input-container .md-errors-spacer{\n        min-height: 0px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/contracts/leaves.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">课程管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">请假列表</div></div>\n<div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input \nplaceholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.query.name\" translate ng-change=\"vm.doSearch()\" \ntranslate-attr-placeholder=\"学生姓名\"></md-input-container><md-input-container md-no-float class=\"m-0\"><label \ntranslate=\"学生年龄\">学生年龄</label><md-select ng-model=\"vm.query.month\" ng-change=\"vm.doSearch()\"><md-option \nng-repeat=\"month in vm.months\" value=\"{{month.id}}\">{{month.id}}M</md-option></md-select></md-input-container>\n<md-input-container md-no-float class=\"m-0\"><md-select ng-model=\"vm.query.status\" ng-change=\"vm.doSearch()\"><md-option \nng-repeat=\"item in vm.leave_status\" value=\"{{item.id}}\">{{item.text}}</md-option></md-select></md-input-container>\n<label translate=\"申请时间\">申请时间</label><md-datepicker flex md-placeholder=\"申请时间\" ng-init=\"vm.query.sdate = \'\';\" \nng-model=\"vm.query.sdate\" ng-change=\"vm.doSearch()\" ng-model-options=\"{timezone:\'utc\'}\">{{vm.query.sdate}}\n</md-datepicker><md-input-container md-no-float class=\"m-0\"><input id=\"search\" placeholder=\"Search for anyone\" \ntype=\"text\" ng-model=\"vm.query.day\" translate ng-change=\"vm.doSearch()\" translate-attr-placeholder=\"请假天数\">\n</md-input-container></div></div><div class=\"content white-bg\"><md-table-container><table md-table \nclass=\"md-data-table\"><thead md-head md-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row><th md-column \nmd-order-by=\"name\" decend-first style=\"padding-left: 15px!important\"><span class=\"column-title\">学生姓名</span></th><th \nmd-column md-order-by=\"month\" decend-first><span class=\"column-title\">月龄/性别</span></th><th md-column \nmd-order-by=\"month\" decend-first><span class=\"column-title\">学生生日</span></th><th md-column md-order-by=\"type\" \ndecend-first><span class=\"column-title\">类型</span></th><th md-column md-order-by=\"apply_time\" decend-first><span \nclass=\"column-title\">申请时间</span></th><th md-column md-order-by=\"day\" decend-first><span class=\"column-title\">请假时段\n</span></th><th md-column md-order-by=\"status\" decend-first><span class=\"column-title\">审批状态</span></th><th md-column \nmd-order-by=\"approval_time\" decend-first><span class=\"column-title\">审批时间</span></th><th md-column \nmd-order-by=\"approval_time\" decend-first><span class=\"column-title\"></span></th></tr></thead><tbody><tr \nng-repeat=\"leave in vm.leaves.data\"><td md-cell style=\"padding-left: 15px!important\"><a \nui-sref=\"app.store.customers.detail({id:leave.customer_id})\">{{ leave.customer_name }} <span \nng-if=\"leave.customer_nickname\">({{leave.customer_nickname}})</span><br>{{leave.customer.member_id}}</a></td><td \nmd-cell>{{ leave.customer_birthday }}M/{{ leave.customer_sex }}</td><td md-cell>{{ leave.customer.birthday }}</td><td \nmd-cell>{{ leave.type }}</td><td md-cell>{{ leave.apply_time }}</td><td md-cell>{{leave.day}}天假<br>\n{{ leave.qingjia_date }}</td><td md-cell>{{ leave.status_name }}</td><td md-cell><span ng-if=\"leave.approval_time\">\n{{ leave.approval_time }}</span> <span ng-if=\"!leave.approval_time\">--</span></td><td md-cell><span \nng-if=\"leave.status==2\" ng-show=\"vm.is_cud\"><a ng-click=\"vm.doShenpi($event, leave, 1)\">批准</a> <a \nng-click=\"vm.doShenpi($event, leave, 0)\">不批准</a> </span><span ng-if=\"leave.status!=2\" style=\"color: #ddd\">\n批准&nbsp;&nbsp;不批准</span></td></tr></tbody></table></md-table-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"footer white-bg\"><md-table-pagination md-limit=\"vm.query.limit\" \nmd-page-select md-page=\"vm.query.page\" md-total=\"{{vm.leaves._meta.totalCount}}\" md-on-paginate=\"vm.doSearch\">\n</md-table-pagination><div layout=\"row\" layout-align=\"end center\"></div></div></div><style>\n.md-data-table td{\n        padding: 10px 0px 10px 0px!important;\n    }\n    .md-data-table th{\n        padding: 10px 0px 10px 0px!important;\n    }\n    md-input-container .md-errors-spacer{\n        min-height: 0px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/contracts/signup.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">课程管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">课程列表</div></div>\n<div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.query.name\" translate ng-change=\"vm.doSearch()\" \ntranslate-attr-placeholder=\"课程名称\"></md-input-container><md-input-container md-no-float class=\"m-0\"><label \ntranslate=\"课程类型\">课程类型</label><md-select ng-model=\"vm.query.categories_id\" ng-change=\"vm.doSearch()\"><md-option \nng-repeat=\"item in vm.categories\" value=\"{{item.id}}\" ng-if=\"item.id!=5 && item.id!=6 && item.id!=7\">{{item.name}}\n</md-option></md-select></md-input-container><label translate=\"上课时间\">上课时间</label><md-datepicker flex \ntranslate-attr-placeholder=\"上课时间\" ng-init=\"vm.query.sdate=vm.StrToDate(vm.query.sdate);\" ng-model=\"vm.query.sdate\" \nng-change=\"vm.doSearch()\" ng-model-options=\"{timezone:\'utc\'}\">{{vm.query.sdate}}</md-datepicker><md-datepicker flex \nmd-placeholder=\"上课时间\" ng-init=\"vm.query.edate = vm.StrToDate(vm.query.edate);\" ng-model=\"vm.query.edate\" \nng-change=\"vm.doSearch()\" ng-model-options=\"{timezone:\'utc\'}\">{{vm.query.edate}}</md-datepicker></div></div><div \nclass=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><md-table-container><table md-table class=\"md-data-table\">\n<thead md-head md-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row><th md-column md-order-by=\"name\" \ndecend-first style=\"padding-left: 15px!important\"><span class=\"column-title\">课程名称<br>门店</span></th><th md-column \nmd-order-by=\"categories_id\" decend-first><span class=\"column-title\">类型</span></th><th md-column \nmd-order-by=\"course_time\" decend-first><span class=\"column-title\">上课时间</span></th><th md-column md-order-by=\"location\" \ndecend-first><span class=\"column-title\">上课地点</span></th><th md-column md-order-by=\"course_size\" decend-first><span \nclass=\"column-title\">人数</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"course in vm.courses.data\"><td md-cell \nstyle=\"padding-left: 15px!important\">{{ course.name }}<br>{{ course.store_name }}</td><td md-cell>\n{{ course.categories_name }}</td><td md-cell>{{ course.course_time }}<br>\n{{ course.course_begintime }}~{{ course.course_endtime }}</td><td md-cell>{{ course.location }}</td><td md-cell>\n预招：{{ course.course_size }}<br>预约：{{course.signup_count}}</td><td md-cell><span \nng-if=\"course.signup_count<course.course_size\"><a ng-click=\"vm.signup($event, course)\">预约</a> </span><span \nng-if=\"course.signup_count>=course.course_size\" style=\"color: #ddd\">已约满</span></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-limit=\"vm.query.limit\" md-page-select md-page=\"vm.query.page\" \nmd-total=\"{{vm.courses._meta.totalCount}}\" md-on-paginate=\"vm.doSearch\"></md-table-pagination></div></div></div><style>\n.md-data-table td{\n        padding: 10px 0px 10px 0px!important;\n    }\n    .md-data-table th{\n        padding: 10px 0px 10px 0px!important;\n    }\n    md-input-container .md-errors-spacer{\n        min-height: 0px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/calendar/calendar.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><md-sidenav style=\"max-width:60%;width:60%\" \nclass=\"sidenav settings-sidenav md-sidenav-right\" md-component-id=\"settings-sidenav\" ms-scroll ms-sidenav-helper>\n<md-content class=\"content\" layout-padding><div class=\"content white-bg\"><div layout=\"row\" layout-align=\"start center\" \nstyle=\"padding-top: 10px;padding-left: 10px\"><md-input-container md-no-float class=\"m-0\"><input type=\"text\" \nng-model=\"vm.query.name\" placeholder=\"课程名称\"></md-input-container><md-autocomplete flex=\"30\" \nmd-input-name=\"vm.customer_name\" ng-disabled=\"vm.isDisabled\" md-selected-item=\"vm.selectedItem\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchText)\" md-search-text=\"vm.searchText\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-items=\"item in vm.customesall\" md-no-cache=\"vm.noCache\" \nautocomplete=\"off\" md-item-text=\"item.display\" md-min-length=\"0\" placeholder=\"学生信息\" id=\"customer-auto\">\n<md-item-template><span md-highlight-text=\"vm.searchText\">{{item.display}}</span></md-item-template><md-not-found>\n没有您输入的学生信息</md-not-found></md-autocomplete></div><div layout=\"row\" layout-wrap=\"\" flex=\"\" style=\"padding-left: 10px\">\n<div flex=\"20\" ng-repeat=\"item in vm.teachers\" ng-if=\"item.status == 10 || (vm.is_del && item.status == 0)\">\n<md-checkbox style=\"margin: 10px 0 10px\" ng-click=\"vm.toggleSelectThread(item, $event)\"><span style=\"color: #333333\" \nng-class=\"{\'text-strike md-secondary-text\':checkItem.checked}\">{{item.name}}</span></md-checkbox></div></div><div \nlayout=\"row\" layout-align=\"start center\" style=\"padding-top: 0px\"><md-button type=\"submit\" \nng-click=\"vm.doSearchCourse()\" class=\"send-button md-accent md-raised\" md-no-float class=\"m-0\" aria-label=\"搜索\" \ntranslate=\"搜索\" translate-attr-aria-label=\"搜索\">SAVE</md-button><md-button type=\"submit\" ng-click=\"vm.doRes()\" \nclass=\"send-button md-accent md-raised\" md-no-float class=\"m-0\" aria-label=\"重置\" translate=\"重置\" \ntranslate-attr-aria-label=\"重置\">SAVE</md-button></div></div></md-content></md-sidenav><div class=\"header\" \nng-class=\"vm.currentMonthShort\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-top\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span \nclass=\"logo-text\" translate=\"CALENDAR.CALENDAR\">Calendar</span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" aria-label=\"Search\" translate \nng-click=\"vm.toggleSidenavPlans(\'settings-sidenav\')\" translate-attr-aria-label=\"CALENDAR.SEARCH\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span translate=\"CALENDAR.SEARCH\">Search</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.today()\" aria-label=\"Today\" translate \ntranslate-attr-aria-label=\"CALENDAR.TODAY\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.TODAY\">Today</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" translate translate-attr-aria-label=\"CALENDAR.DAY\">\n<md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span translate=\"CALENDAR.DAY\">Day</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"Week\" \ntranslate translate-attr-aria-label=\"CALENDAR.WEEK\"><md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.WEEK\">Week</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate translate-attr-aria-label=\"CALENDAR.MONTH\">\n<md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span translate=\"CALENDAR.MONTH\">Month</span>\n</md-tooltip></md-button></div></div><div class=\"header-bottom\" layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" aria-label=\"Previous\" translate \ntranslate-attr-aria-label=\"CALENDAR.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><div \nclass=\"title\">{{vm.calendarView.title}}</div><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.next()\" \naria-label=\"Next\" translate translate-attr-aria-label=\"CALENDAR.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\">\n</md-icon></md-button></div></div></div><div class=\"content\"><div id=\"calendarView\" \nui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\"></div></div></div><style>\n.md-data-table td{\n        padding: 10px 0px 10px 0px!important;\n    }\n    .md-data-table th{\n        padding: 10px 0px 10px 0px!important;\n    }\n    md-input-container .md-errors-spacer{\n        min-height: 0px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/courses/category.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">课程管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">课程分类</div></div>\n<div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.query.name\" translate ng-change=\"vm.doSearch()\" \ntranslate-attr-placeholder=\"分类名称\"></md-input-container></div></div><div class=\"content white-bg\"><md-table-container>\n<table md-table class=\"md-data-table\"><thead md-head md-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row>\n<th md-column md-order-by=\"name\" decend-first style=\"padding-left: 15px!important\"><span class=\"column-title\">分类名称\n</span></th><th md-column md-order-by=\"type\" decend-first><span class=\"column-title\">类型</span></th><th md-column \nmd-order-by=\"store_id\" decend-first><span class=\"column-title\">门店</span></th><th md-column></th></tr></thead><tbody><tr\n ng-repeat=\"categorie in vm.categories.data\"><td md-cell style=\"padding-left: 15px!important\">{{ categorie.name }}</td>\n<td md-cell>{{ categorie.type_name }}</td><td md-cell>{{ categorie.store_name }}</td><td md-cell \nng-click=\"vm.checkEdit(categorie.store_id) ? vm.openCategorieDialog($event, categorie) :\'\'\"><a \nng-if=\"vm.checkEdit(categorie.store_id)\" ng-show=\"vm.is_cud\">修改</a></td></tr></tbody></table></md-table-container>\n</div><div layout=\"row\" layout-align=\"space-between center\" class=\"footer white-bg\"><md-table-pagination \nmd-limit=\"vm.query.limit\" md-page-select md-page=\"vm.query.page\" md-total=\"{{vm.categories._meta.totalCount}}\" \nmd-on-paginate=\"vm.doSearch\"></md-table-pagination><div layout=\"row\" layout-align=\"end center\"><md-button \nng-if=\"vm.is_cud\" class=\"md-fab md-mini md-accent md-icon-button mv-25\" id=\"add-course-button\" \nng-click=\"vm.openCategorieDialog($event)\" aria-label=\"add contact\" translate \ntranslate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></div>\n</div></div><style>\n.md-data-table td{\n        padding: 10px 0px 10px 0px!important;\n    }\n    .md-data-table th{\n        padding: 10px 0px 10px 0px!important;\n    }\n    md-input-container .md-errors-spacer{\n        min-height: 0px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/courses/course-detail.html","<div id=\"dashboard-server\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"35\" flex-gt-md=\"35\"><md-card id=\"baby-info\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"column\" layout-align-gt-sm=\"space-between end\"><div \nclass=\"user-info\" layout=\"column\" layout-align=\"start start\" layout-gt-sm=\"column\" layout-align-gt-sm=\"start start\">\n<div class=\"name\" ng-if=\"vm.course.plan\" flex=\"100\">{{vm.course.plan}}</div><div class=\"name\" flex=\"100\">\n{{vm.course.name}}</div></div></div><md-card-content><p ng-if=\"vm.course.number\">固定课程号：<span>{{vm.course.number}}\n</span></p><p>最小开课人数：<span>{{vm.course.min_count}} &nbsp;&nbsp;{{vm.course.status_text}}</span></p><p>上课日期：<span>\n{{vm.course.course_time | date:\"yyyy-MM-dd\"}}</span></p><p>上课时间：<span>\n{{vm.course.course_begintime}}-{{vm.course.course_endtime}}</span></p><p>更新时间：<span>{{vm.course.update_time}}</span>\n</p><div ng-if=\"vm.is_cud\" ng-show=\"vm.course.status==1\" class=\"pt-8\" layout=\"column\" layout-align=\"center\"><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.openCourseDialog($event, vm.course)\">修改课程信息</md-button></div>\n</md-card-content></md-card></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"65\" \nflex-gt-md=\"65\"><ms-widget-front id=\"con-info\" class=\"white-bg\" layout-md=\"row\"><div \nclass=\"widget-group ph-16 pb-8 pt-16\" layout=\"row\" layout-wrap><div flex><div layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><img \nclass=\"md-avatar avatar contact-avatar\" ng-if=\"vm.course.teacher_avatar\" alt=\"{{vm.course.assistant_name}}\" \nng-src=\"{{ vm.course.teacher_avatar }}?imageView/2/w/64/h/64\"> <span>老师：<span>{{vm.course.teacher_name}}</span></span>\n</div></div><div flex><div layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"start center\"><img class=\"md-avatar avatar contact-avatar\" ng-if=\"vm.course.teacher_avatar\" \nalt=\"{{vm.course.assistant_name}}\" ng-src=\"{{ vm.course.assistant_avatar }}?imageView/2/w/64/h/64\"> <span>助理: <span>\n{{vm.course.assistant_name}}</span></span></div></div></div><div class=\"widget-group ph-8 pb-8 pt-8\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"33\">\n<ms-widget-front class=\"p-16 pink-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\">\n<div layout=\"row\" layout-align=\"start center\"><div class=\"h3\">预约/预招</div></div></div><div class=\"\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"h2\">{{vm.course.signup_count}}人</div><div class=\"h2 secondary-text pl-8\">\n/{{vm.course.course_size}}人</div></div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"33\"><ms-widget-front class=\"p-16 teal-400-bg white-fg\"><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"h3\">课程类别\n</div></div></div><div class=\"\" layout=\"row\" layout-align=\"start center\"><div class=\"h2\"></div><div \nclass=\"h2 secondary-text pl-8\">{{vm.course.categories_name}}</div></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"33\"><ms-widget-front \nclass=\"p-16 indigo-400-bg white-fg\"><div class=\"pb-24\" layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><div class=\"h3\">上课教室</div></div></div><div class=\"\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"h2\"></div><div class=\"h2 secondary-text pl-8\">{{vm.course.room}}</div></div>\n</ms-widget-front></ms-widget></div></ms-widget-front></ms-widget></div><div layout=\"row\" layout-wrap \nclass=\"ph-24 pv-8 beizhubg-block\"><div flex=\"10\" layout-align=\"start center\" \nclass=\"ng-scope layout-align-start-center mr-20\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" \nng-repeat=\"status in vm.signup_status\"><div class=\"h-10 w-10 mr-8 {{status.class}}\"></div><span \nclass=\"title ng-binding\">{{status.text}}</span></div></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget flippable=\"false\" flex=\"100\"><ms-widget-front id=\"course-info\" class=\"white-bg\"><div ng-cloak>\n<md-content><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"预约列表\"><md-content class=\"md-padding\"><div \nid=\"simple-table\" class=\"page-layout simple fullwidth datatable-page\" style=\"position: relative\"><md-table-container>\n<table md-table class=\"md-data-table\"><thead md-head md-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row>\n<th md-column md-order-by=\"customer_id\" decend-first style=\"padding-left: 15px!important\"><span class=\"column-title\">\n学生名称</span></th><th md-column md-order-by=\"type\" decend-first><span class=\"\">学生年龄/性别</span></th><th md-column \nmd-order-by=\"type\" decend-first><span class=\"\">学生生日</span></th><th md-column md-order-by=\"type\" decend-first><span \nclass=\"\">家长信息</span></th><th md-column md-order-by=\"apply_time\" decend-first><span class=\"column-title\">预约时间</span>\n</th><th md-column md-order-by=\"day\" decend-first><span class=\"column-title\">约课状态</span></th><th ng-if=\"vm.is_signup\">\n</th></tr></thead><tbody><tr ng-repeat=\"item in vm.signups\" class=\"{{item.status_class}}\"><td md-cell \nstyle=\"padding-left: 15px!important\"><a style=\"display: block\" \nui-sref=\"app.store.customers.detail({id:item.customer_id})\" \nng-if=\"item.customer_id && item.from_store_id==item.store_id\">{{item.customer_name}} <span \nng-if=\"item.customer_nickname\">({{item.customer_nickname}})</span><br>{{item.customer_member_id}} </a><span \nng-if=\"!item.customer_id\">{{item.customer_name}}</span> <span \nng-if=\"item.from_store_id!=item.store_id && item.from_store_id>0\">{{item.customer_name}}-跨店<br>\n{{item.customer_member_id}}</span></td><td md-cell>{{item.customer_birthday_month}}/{{item.customer_sex}}</td><td \nmd-cell>{{item.customer_birthday}}</td><td md-cell><p ng-if=\"!item.customer_id\">\n{{item.parent.relation}} {{item.parent.name}} {{item.parent.mobile}}</p><p ng-if=\"item.customer_id\" \nng-repeat=\"parent in item.parents\">{{parent.relation}} {{parent.name}} {{parent.mobile}}</p></td><td md-cell>\n{{ item.created_at}}</td><td md-cell>{{item.status_text}}</td><td md-cell ng-if=\"vm.is_signup\"><span \nng-if=\"item.status==6\" ng-show=\"vm.course.status==1\"><a ng-click=\"vm.updateStatus(item,0)\">预约</a>&nbsp;&nbsp; </span>\n<small ng-if=\"item.status==0\"><a ng-click=\"vm.updateStatus(item,1)\">批准</a> <a ng-click=\"vm.updateStatus(item,2)\">拒绝</a>\n </small><span ng-if=\"item.status==1\"><a ng-click=\"vm.updateStatus(item,4)\">签到</a>&nbsp;&nbsp; <a \nng-click=\"vm.updateStatus(item,5)\">旷课</a> <a ng-click=\"vm.updateStatus(item,3)\">取消</a> </span><span \nng-if=\"item.status==2\"><a ng-click=\"vm.updateStatus(item,1)\">重新批准</a>&nbsp;&nbsp; <span style=\"color: #ddd\">拒绝</span> \n</span><span ng-if=\"item.status==3\" style=\"color: #ddd\">签到&nbsp;&nbsp; 旷课</span> <a \nng-click=\"vm.signuploglist($event, item)\">查看记录</a></td></tr></tbody></table></md-table-container></div></md-content>\n</md-tab><md-tab label=\"修改记录\"><md-content class=\"md-padding\"><div \nclass=\"page-layout simple fullwidth doc-page element-doc-page datatable-page\" style=\"position: relative\">\n<md-table-container><table md-table class=\"md-data-table\"><thead md-head md-order=\"vm.query.sort\" \nmd-on-reorder=\"vm.doSearch\"><tr md-row><th md-column md-order-by=\"customer_id\" decend-first \nstyle=\"padding-left: 15px!important\"><span class=\"column-title\">修改时间</span></th><th md-column md-order-by=\"type\" \ndecend-first><span class=\"\">修改内容</span></th><th md-column md-order-by=\"apply_time\" decend-first><span \nclass=\"column-title\">操作人</span></th></tr></thead><tbody><tr ng-repeat=\"item in vm.coursesLogs\"><td md-cell \nstyle=\"padding-left: 15px!important\">{{ item.created_at }}</td><td md-cell>{{item.remark}}</td><td md-cell>\n{{item.user_name}}</td></tr></tbody></table></md-table-container></div></md-content></md-tab></md-tabs></md-content>\n</div></ms-widget-front></ms-widget></div></div><style>\n.md-data-table td{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\r\n    .md-data-table th{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/store/courses/courses.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content con-page course-list\" \nstyle=\"position: relative\"><div class=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div \nlayout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" \nstyle=\"margin-bottom:12px!important\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">课程管理</span></div><div \nclass=\"title\" style=\"font-size: 24px!important\">课程列表</div></div><div flex=\"80\"><div class=\"search-input-wrapper\" \nlayout=\"row\" layout-align=\"start center\"><md-input-container md-no-float class=\"m-0\" ng-if=\"false\"><input \nng-model=\"vm.query.number\" translate ng-change=\"vm.doSearch()\" translate-attr-placeholder=\"课程编号\"></md-input-container>\n<md-autocomplete flex=\"25\" md-input-name=\"vm.query.student\" ng-disabled=\"vm.isDisabled\" \nmd-selected-item=\"vm.selectedStudentItem\" md-search-text-change=\"vm.searchStudentTextChange(vm.searchStudentText)\" \nmd-search-text=\"vm.searchStudentText\" md-selected-item-change=\"vm.selectStudentChanged(item)\" \nmd-items=\"item in vm.customesall\" md-no-cache=\"vm.noCache\" autocomplete=\"off\" md-item-text=\"item.display\" \nmd-min-length=\"0\" placeholder=\"学生信息\" id=\"customer-auto\"><md-item-template><span md-highlight-text=\"vm.searchText\">\n{{item.display}}</span></md-item-template><md-not-found>没有您输入的学生信息</md-not-found></md-autocomplete><md-input-container \nflex=\"25\" md-no-float class=\"m-0\" ng-if=\"false\"><input type=\"text\" ng-model=\"vm.query.name\" translate \nng-change=\"vm.doSearch()\" translate-attr-placeholder=\"课程名称\"></md-input-container><md-input-container flex=\"25\" \nmd-no-float class=\"m-0\"><label translate=\"老师\">老师</label><md-select ng-model=\"vm.query.teacher_id\" \nng-change=\"vm.doSearch()\"><md-option value=\"\">所有</md-option><md-option ng-repeat=\"item in vm.teachers\" \nvalue=\"{{item.id}}\">{{item.name}}</md-option></md-select></md-input-container><md-input-container flex=\"25\" \nmd-no-float class=\"m-0\"><label translate=\"课程类型\">课程类型</label><md-select ng-model=\"vm.query.categories_id\" \nng-change=\"vm.doSearch()\"><md-option ng-repeat=\"item in vm.categories\" value=\"{{item.id}}\" \nng-if=\"item.id!=5 && item.id!=6 && item.id!=7\">{{item.name}}</md-option></md-select></md-input-container>\n<md-input-container flex=\"25\" md-no-float class=\"m-0\"><label translate=\"课程级别\">课程级别</label><md-select \nng-model=\"vm.query.type\" ng-change=\"vm.doSearch()\"><md-option ng-repeat=\"item in vm.jibei_types\" value=\"{{item.id}}\">\n{{item.name}}</md-option></md-select></md-input-container></div><div class=\"search-input-wrapper\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container md-no-float class=\"m-0\" flex=\"25\"><label translate=\"课程状态\">课程状态</label>\n<md-select ng-model=\"vm.query.status\" ng-change=\"vm.doSearch()\"><md-option ng-repeat=\"item in vm.courseStatus\" \nvalue=\"{{item.status}}\">{{item.name}}</md-option></md-select></md-input-container><label flex=\"25\" \nstyle=\"text-align: right\">上课时间</label><md-datepicker flex=\"25\" md-placeholder=\"上课时间\" \nng-init=\"vm.query.sdate=vm.StrToDate(vm.query.sdate);\" ng-model=\"vm.query.sdate\" ng-change=\"vm.doSearch()\" \nng-model-options=\"{timezone:\'utc\'}\">{{vm.query.sdate}}</md-datepicker><md-datepicker flex=\"25\" md-placeholder=\"上课时间\" \nng-init=\"vm.query.edate = vm.StrToDate(vm.query.edate);\" ng-model=\"vm.query.edate\" ng-change=\"vm.doSearch()\" \nng-model-options=\"{timezone:\'utc\'}\">{{vm.query.edate}}</md-datepicker></div></div></div><div class=\"content white-bg\">\n<div class=\"simple-table-container\"><md-table-container><table md-table class=\"md-data-table nowrap-table\"><thead \nmd-head md-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row><th md-column ng-if=\"vm.cols.date\" \nmd-order-by=\"course_time\"><span class=\"column-title\">上课日期/星期</span></th><th md-column ng-if=\"vm.cols.time\" \nmd-order-by=\"course_begintime\"><span class=\"column-title\">上课时间段</span></th><th md-column ng-if=\"vm.cols.teacherDate\" \nmd-order-by=\"course_time_zone\"><span class=\"column-title\">上课日期/星期</span></th><th md-column ng-if=\"vm.cols.teacherTime\" \nmd-order-by=\"course_begintime_zone\"><span class=\"column-title\">上课时间段</span></th><th md-column ng-if=\"vm.cols.plan\" \nmd-order-by=\"plan_id\" decend-first style=\"padding-left: 15px!important\"><span class=\"column-title\">所属计划</span></th><th \nmd-column ng-if=\"vm.cols.name\" md-order-by=\"name\"><span class=\"column-title\">课程名称</span></th><th md-column \nng-if=\"vm.cols.student\" md-order-by=\"studentsName\"><span class=\"column-title\">学生</span></th><th md-column \nng-if=\"vm.cols.teacher\" md-order-by=\"teacher_id\"><span class=\"column-title\">老师/助理</span></th><th md-column \nng-if=\"vm.cols.room\" md-order-by=\"room\"><span class=\"column-title\">上课教室</span></th><th md-column \nng-if=\"vm.cols.category\" md-order-by=\"categories_id\"><span class=\"column-title\">类型/级别</span></th><th md-column \nng-if=\"vm.cols.book\" md-order-by=\"course_size\"><span class=\"column-title\">预约/预招<br>最少开课人数</span></th><th md-column \nng-if=\"vm.cols.number\" md-order-by=\"number\"><span class=\"column-title\">固定课编号<br>固定课描述</span></th><th md-column \nng-if=\"vm.cols.status\" md-order-by=\"status\"><span class=\"column-title\">状态</span></th><th md-column \nng-if=\"vm.cols.updated\" md-order-by=\"updated_at\"><span class=\"column-title\">更新时间</span></th><th ng-if=\"vm.cols.action\">\n</th></tr></thead><tbody md-body><tr ng-repeat=\"course in vm.courses.data\" class=\"pointer\"><td md-cell \nng-if=\"vm.cols.date\">{{ course.course_time | date:\"yyyy-MM-dd\"}}/{{course.week}}</td><td md-cell ng-if=\"vm.cols.time\">\n{{ course.course_begintime }}~{{ course.course_endtime }}</td><td md-cell ng-if=\"vm.cols.teacherDate\">\n{{ course.course_time_zone | date:\"yyyy-MM-dd\"}}/{{course.week_zone}}</td><td md-cell ng-if=\"vm.cols.teacherTime\">\n{{ course.course_begintime_zone }}~{{ course.course_endtime_zone }}</td><td md-cell ng-if=\"vm.cols.plan\" \nui-sref=\"app.store.courses.detail({id:course.id})\" style=\"padding-left: 15px!important\">{{ course.plan }}</td><td \nmd-cell ng-if=\"vm.cols.name\" ui-sref=\"app.store.courses.detail({id:course.id})\">{{ course.name }}</td><td md-cell \nng-if=\"vm.cols.student\">{{ course.studentsName }}</td><td md-cell ng-if=\"vm.cols.teacher\">{{ course.teacher_name }}<br>\n{{ course.assistant_name }}</td><td md-cell ng-if=\"vm.cols.room\">{{ course.room }}</td><td md-cell \nng-if=\"vm.cols.category\">{{ course.categories_name }}<br>{{course.type_name}}</td><td md-cell ng-if=\"vm.cols.book\"><b \nstyle=\"color: #1e8f03\">{{ course.signup_count }}人</b>/<b style=\"color: #ff0000\">{{ course.course_size }}人</b><br>\n{{ course.min_count }}人</td><td md-cell ng-if=\"vm.cols.number\" style=\"padding-left: 15px!important\">{{ course.number }}\n<br>{{ course.content }}</td><td md-cell ng-if=\"vm.cols.category\">{{ course.status_text }}</td><td md-cell \nng-if=\"vm.cols.updated\">{{ course.update_time }}</td><td md-cell ng-if=\"vm.cols.action\"><a \nng-click=\"vm.openCourseDialog($event, course)\" ng-if=\"vm.is_cud\">修改</a> <a \nng-click=\"vm.openTiaokDialog($event, course)\">调课</a></td></tr></tbody></table></md-table-container></div></div><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"footer white-bg\"><md-table-pagination \nmd-limit=\"vm.query.limit\" md-page-select md-page=\"vm.query.page\" md-total=\"{{vm.courses._meta.totalCount}}\" \nmd-on-paginate=\"vm.doSearch\"></md-table-pagination><div layout=\"row\" layout-align=\"end center\"><md-checkbox \nng-model=\"vm.isShowTeacherTime\" ng-change=\"vm.timeTypeChanged($event)\">老师时间</md-checkbox><md-button ng-if=\"vm.is_cud\" \nclass=\"md-raised reference-button\" ng-file-select=\"vm.upload($files)\" type=\"file\" ng-model=\"vm.selectedFiles\" \nngf-multiple=\"false\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>导入课程</span></md-button><md-button \nclass=\"md-raised reference-button\" type=\"button\" ng-click=\"vm.exportCourses($event)\"><md-icon md-font-icon=\"icon-link\">\n</md-icon><span>导出课程</span></md-button><md-button ng-if=\"vm.is_cud\" \nclass=\"md-fab md-mini md-accent md-icon-button mv-25\" id=\"add-contact-button\" ng-click=\"vm.openCourseDialog($event)\" \naria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon></md-button></div></div></div><style>\n.md-data-table td{\n        padding: 0px 0px 0px 10px!important;\n    }\n    .md-data-table th{\n        padding: 0px 0px 0px 10px!important;\n    }\n    md-input-container .md-errors-spacer{\n        min-height: 0px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/courses/experiences.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div class=\"search-input-wrapper\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container md-no-float class=\"m-0\"><input placeholder=\"Search for anyone\" \ntype=\"text\" ng-model=\"vm.query.name\" translate ng-change=\"vm.doSearch()\" translate-attr-placeholder=\"学生姓名\">\n</md-input-container><md-input-container md-no-float class=\"m-0\"><input placeholder=\"Search for anyone\" type=\"text\" \nng-model=\"vm.query.mobile\" translate ng-change=\"vm.doSearch()\" translate-attr-placeholder=\"手机号\"></md-input-container>\n<md-input-container md-no-float class=\"m-0\"><input placeholder=\"Search for anyone\" type=\"text\" \nng-model=\"vm.query.parent\" translate ng-change=\"vm.doSearch()\" translate-attr-placeholder=\"家长\"></md-input-container>\n<md-input-container md-no-float class=\"m-0\"><input placeholder=\"Search for anyone\" type=\"text\" \nng-model=\"vm.query.source\" translate ng-change=\"vm.doSearch()\" translate-attr-placeholder=\"来源\"></md-input-container>\n<md-input-container md-no-float class=\"m-0\"><input placeholder=\"Search for anyone\" type=\"text\" \nng-model=\"vm.query.remarks\" translate ng-change=\"vm.doSearch()\" translate-attr-placeholder=\"备注\"></md-input-container>\n<md-input-container md-no-float class=\"m-0\"><md-select ng-model=\"vm.query.is_member\" ng-change=\"vm.doSearch()\">\n<md-option ng-repeat=\"item in vm.yonghu_arr\" value=\"{{item.id}}\">{{item.text}}</md-option></md-select>\n</md-input-container><md-input-container md-no-float class=\"m-0\"><md-select ng-model=\"vm.query.status\" \nng-change=\"vm.doSearch()\"><md-option ng-repeat=\"item in vm.status_arr\" value=\"{{item.id}}\">{{item.text}}</md-option>\n</md-select></md-input-container><md-input-container md-no-float class=\"m-0\"><md-select \nng-model=\"vm.query.task_status\" ng-change=\"vm.doSearch()\"><md-option ng-repeat=\"item in vm.signup_status\" \nvalue=\"{{item.id}}\">{{item.text}}</md-option></md-select></md-input-container></div><div class=\"search-input-wrapper\" \nlayout=\"row\" layout-align=\"start center\"><md-input-container md-no-float class=\"m-0\"><md-select \nng-model=\"vm.query.consult_id\" ng-change=\"vm.doSearch()\"><md-option ng-repeat=\"consult in vm.users\" \nvalue=\"{{consult.id}}\">{{consult.name}}</md-option></md-select></md-input-container><label translate=\"体验时间\">体验时间\n</label><md-datepicker flex md-placeholder=\"体验时间\" ng-init=\"vm.query.sdate=\'\';\" ng-model=\"vm.query.sdate\" \nng-change=\"vm.doSearch()\" ng-model-options=\"{timezone:\'utc\'}\" style=\"margin-left:0px\">{{vm.query.sdate}}\n</md-datepicker><md-datepicker flex md-placeholder=\"体验时间\" ng-init=\"vm.query.edate = \'\';\" ng-model=\"vm.query.edate\" \nng-change=\"vm.doSearch()\" ng-model-options=\"{timezone:\'utc\'}\" style=\"margin-left:0px\">{{vm.query.edate}}\n</md-datepicker></div></div><div class=\"content white-bg\"><md-table-container><table md-table class=\"md-data-table\">\n<thead md-head md-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row><th md-column md-order-by=\"name\" \ndecend-first style=\"padding-left: 15px!important\"><span class=\"column-title\">学生姓名<br>学生生日</span></th><th md-column \nmd-order-by=\"parent\"><span class=\"column-title\">家长姓名<br><span class=\"column-title\">性别</span></span></th><th md-column \nmd-order-by=\"location\"><span class=\"column-title\">课程名称<br>开课时间</span></th><th md-column md-order-by=\"task_status\">安排状态\n<br>约课状态</th><th md-column md-order-by=\"apply_time\"><span class=\"column-title\">申请时间</span><br><span \nclass=\"column-title\">期望体验时间</span></th><th md-column md-order-by=\"location\"><span class=\"column-title\">支付类型<br>支付金额\n</span></th><th md-column md-order-by=\"apply_time\"><span class=\"column-title\">来源</span><br><span class=\"column-title\">\n备注</span></th><th md-column md-order-by=\"consult_id\"><span class=\"column-title\">销售顾问<br>会员号</span></th><th></th></tr>\n</thead><tbody md-body><tr ng-repeat=\"experience in vm.experiences.data\"><td md-cell \nstyle=\"padding-left: 15px!important\">{{ experience.name }}<br>{{experience.birthday | date:\'yyyy-MM-dd\'}}</td><td \nmd-cell>{{ experience.parent }}<br>{{ experience.sex_text}}<md-tooltip md-direction=\"bottom\" \nstyle=\"top: 0px!important\">{{ experience.mobile }}</md-tooltip></td><td md-cell><a ng-if=\"experience.courses_id\" \nui-sref=\"app.store.courses.detail({id:experience.courses_id})\">{{ experience.courses_name}}<br>\n{{ experience.plan_time}} </a><span ng-if=\"!experience.courses_id\">--</span></td><td md-cell><span \nng-if=\"experience.status==1\">&nbsp;已安排</span> <span ng-if=\"experience.status!=1\">&nbsp;未安排</span><br><span \nclass=\"{{experience.task_status_class}}\">&nbsp;{{experience.task_status_text}}&nbsp;</span></td><td md-cell>\n{{ experience.apply_time}}<br>{{ experience.task_time}}</td><td \nstyle=\"color: rgba(0, 0, 0, 0.87);font-size: 13px;border-top: 1px rgba(0, 0, 0, 0.12) solid\"><md-select \nng-model=\"experience.pay_type\" ng-change=\"vm.updatePayType(experience.id, experience.pay_type)\" \nstyle=\"border-bottom: #ccc 1px solid;max-width:100px; margin: 0px 0 0px 0\"><md-option value=\"{{type.name}}\" \nng-repeat=\"type in vm.pay_types\">{{type.name}}</md-option></md-select><p style=\"margin-top:-5px\"></p><input \nng-model=\"experience.amount\" ng-change=\"vm.updateAmount(experience.id, experience.amount)\" style=\"max-width: 100px\">\n</td><td md-cell><input ng-model=\"experience.source\" ng-change=\"vm.updateSource(experience.id, experience.source)\"><br>\n<p style=\"margin-top:-5px\"></p><input ng-model=\"experience.remarks\" \nng-change=\"vm.updateRemarks(experience.id, experience.remarks)\"></td><td md-cell><md-select \nng-model=\"experience.consult_id\" ng-change=\"vm.updateConsult(experience.id, experience.consult_id)\" \nstyle=\"border-bottom: #ccc 2px solid\"><md-option ng-repeat=\"consult in vm.consults\" value=\"{{consult.id}}\">\n{{consult.name}}</md-option></md-select><p style=\"margin-top:-5px\"></p><a ng-if=\"experience.customer_id\" \nui-sref=\"app.store.customers.detail({id:experience.customer_id})\">&nbsp;{{ experience.member_id}}</a> <span \nng-if=\"!experience.customer_id\">&nbsp;&nbsp;--</span></td><td md-cell style=\"padding-left: 15px!important\"><a \nng-if=\"vm.is_cud\" ng-click=\"vm.openExperienceDialog($event, experience)\">修改</a> <small ng-if=\"experience.status==0\" \nng-show=\"vm.is_cud\"><a ui-sref=\"app.store.courses.signup({task_id:experience.id})\">安排课</a> </small><small \nng-if=\"experience.status==1\" ng-show=\"vm.is_cud\"><a ui-sref=\"app.store.courses.signup({task_id:experience.id})\">重新安排\n</a> </small><a ng-if=\"!experience.customer_id\" ui-sref=\"app.store.customers.wizard({task_id:experience.id})\" \nng-show=\"vm.is_cud\">升级为会员</a></td></tr></tbody></table></md-table-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"footer white-bg\"><md-table-pagination md-limit=\"vm.query.limit\" \nmd-page-select md-page=\"vm.query.page\" md-total=\"{{vm.experiences._meta.totalCount}}\" md-on-paginate=\"vm.doSearch\">\n</md-table-pagination><div layout=\"row\" layout-align=\"end center\"><md-button ng-if=\"vm.is_export\" \nclass=\"md-raised reference-button\" type=\"button\" ng-click=\"vm.exportExperiences($event)\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>导出体验</span></md-button><md-button ng-if=\"vm.is_cud\" \nclass=\"md-fab md-mini md-accent md-icon-button mv-25\" id=\"add-course-button\" \nng-click=\"vm.openExperienceDialog($event)\" aria-label=\"add contact\" translate \ntranslate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></div>\n</div></div><style>\n.md-data-table td{\n        padding: 5px 0px 5px 0px!important;\n    }\n    .md-data-table th{\n        padding: 0px 0px 0px 0px!important;\n    }\n    .md-icon-button + .md-datepicker-input-container {\n         margin-left: 0px;\n    }\n    .md-datepicker-input {\n        min-width: 90px;\n    }\n    md-input-container .md-errors-spacer{\n        min-height: 0px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/courses/jiake.html","<div class=\"page-layout simple fullwidth\"><md-sidenav style=\"max-width:60%;width:60%\" \nclass=\"sidenav settings-sidenav md-sidenav-right\" md-component-id=\"settings-sidenav\" ms-scroll ms-sidenav-helper>\n<md-content class=\"content\" layout-padding><div class=\"content white-bg\"><md-table-container><table md-table \nclass=\"md-data-table\"><thead md-head><tr md-row><th md-column decend-first style=\"padding-left: 15px!important\"><span \nclass=\"column-title\">固定课号</span></th><th md-column decend-first><span class=\"column-title\">课程名称</span></th><th \nmd-column decend-first><span class=\"column-title\">上课时间</span></th><th md-column decend-first><span \nclass=\"column-title\">教练</span></th><th md-column decend-first><span class=\"column-title\">固定位</span></th><th md-column \ndecend-first><span class=\"column-title\">监时位</span></th><th></th></tr></thead><tbody md-body><tr \nng-repeat=\"course in vm.courses\"><td md-cell style=\"padding-left: 10px!important\">{{course.number}}</td><td md-cell>\n{{ course.name }}</td><td md-cell>{{ course.course_time }}{{course.week}}<br>\n{{ course.course_begintime }}~{{ course.course_endtime }}</td><td md-cell>{{ course.teacher_name }}</td><td md-cell>\n<span>{{ course.signupshu.gudin.length }}人</span></td><td md-cell><span>{{ course.signupshu.linshi.length }}人</span>\n</td><td md-cell><md-button ng-click=\"vm.selectCourse(course)\" class=\"send-button md-accent md-raised\" md-no-float \nclass=\"m-0\" style=\"min-height:28px;line-height: 28px\"><span style=\"color: #fff!important\">选择</span></md-button></td>\n</tr></tbody></table></md-table-container></div></md-content></md-sidenav><div class=\"mt-5\"><div \nclass=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\" style=\"padding-left: 24px\"><div class=\"search-input-wrapper\" \nlayout=\"row\" layout-align=\"start center\"><md-input-container class=\"md-block md-input-container\" flex=\"80\"><label \ntranslate=\"固定课号\">固定课号</label><input name=\"name\" ng-model=\"vm.curr_course.number\" md-autofocus flex=\"100\" required \nng-model-options=\"{debounce : 500}\" ng-change=\"vm.numChange()\"><div ng-messages=\"vm.curr_course.number.$error\" \nng-show=\"vm.curr_course.number.$touched\" role=\"alert\"><div ng-message=\"required\"><span>固定课号必填</span></div></div>\n</md-input-container><md-button ng-click=\"vm.toggleSidenav(\'settings-sidenav\')\" \nclass=\"hide send-button md-accent md-raised\" md-no-float class=\"m-0\">查询课号</md-button><md-button \nng-click=\"vm.toggleSidenav(\'settings-sidenav\')\" class=\"send-button md-accent md-raised\" md-no-float class=\"m-0\" \nstyle=\"min-height:28px;line-height: 28px\">选择课号</md-button></div></div></div></div><div id=\"calendar\" \nclass=\"page-layout simple fullwidth\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"33\"><div class=\"content cdate white-bg\"><div \nclass=\"header-bottom p-8\" layout=\"row\" layout-align=\"center center\"><div class=\"title\">{{vm.calendarView.title}}</div>\n</div><div id=\"calendarView\" class=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" \ncalendar=\"main\"></div></div></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" \nflex-gt-md=\"33\"><div class=\"content cdate white-bg\"><div class=\"header-bottom p-8\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"title\">{{vm.calendarView1.title}}</div></div><div id=\"calendarView1\" \nclass=\"calendarView\" ui-calendar=\"vm.calendarUiConfig1.calendar\" ng-model=\"vm.events\" calendar=\"main\"></div></div>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"33\"><div \nclass=\"content cdate white-bg\"><div class=\"header-bottom p-8\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"title\">{{vm.calendarView2.title}}</div></div><div id=\"calendarView2\" class=\"calendarView\" \nui-calendar=\"vm.calendarUiConfig2.calendar\" ng-model=\"vm.events\" calendar=\"main\"></div></div></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"33\"><div class=\"content cdate white-bg\"><div \nclass=\"header-bottom p-8\" layout=\"row\" layout-align=\"center center\"><div class=\"title\">{{vm.calendarView3.title}}</div>\n</div><div id=\"calendarView3\" class=\"calendarView\" ui-calendar=\"vm.calendarUiConfig3.calendar\" ng-model=\"vm.events\" \ncalendar=\"main\"></div></div></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" \nflex-gt-md=\"33\"><div class=\"content cdate white-bg\"><div class=\"header-bottom p-8\" layout=\"row\" \nlayout-align=\"center center\"><div class=\"title\">{{vm.calendarView4.title}}</div></div><div id=\"calendarView4\" \nclass=\"calendarView\" ui-calendar=\"vm.calendarUiConfig4.calendar\" ng-model=\"vm.events\" calendar=\"main\"></div></div>\n</ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"33\"><div \nclass=\"content cdate white-bg\"><div class=\"header-bottom p-8\" layout=\"row\" layout-align=\"center center\"><div \nclass=\"title\">{{vm.calendarView5.title}}</div></div><div id=\"calendarView5\" class=\"calendarView\" \nui-calendar=\"vm.calendarUiConfig5.calendar\" ng-model=\"vm.events\" calendar=\"main\"></div></div></ms-widget></div></div>\n<div class=\"content click-courses\"><div class=\"simple-table-container\"><md-table-container><table md-table \nclass=\"md-data-table\"><thead class=\"grey-200-bg\" md-head md-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr \nmd-row><th md-column decend-first style=\"text-align: center\">日期</th><th md-column><md-select ng-model=\"vm.all_time\" \nng-change=\"vm.selTime()\" placeholder=\"选择时段\"><md-option ng-repeat=\"ctime in vm.course_time_arr\" value=\"{{ctime.name}}\">\n{{ctime.name}}</md-option></md-select><span class=\"quan\">全</span></th><th md-column decend-first \nstyle=\"text-align: center\">主教时区</th><th md-column style=\"min-width: 62px\"><md-input-container md-no-float class=\"m-0\" \nplaceholder=\"课时\" aria-label=\"\"><input ng-model=\"vm.all_kshi\" ng-change=\"vm.selKshi()\" placeholder=\"课时\" translate>\n</md-input-container><span class=\"quan\">全</span></th><th md-column><md-select ng-model=\"vm.all_room\" \nng-change=\"vm.selRoom()\" placeholder=\"选择教室\"><md-option ng-repeat=\"room in vm.rooms\" value=\"{{room.id}}\">{{room.name}}\n</md-option></md-select><span class=\"quan\">全</span></th><th md-column><md-select ng-model=\"vm.all_teacher\" \nng-change=\"vm.selTeacher()\" placeholder=\"选择主教\"><md-option ng-repeat=\"teacher in vm.teachers\" value=\"{{teacher.id}}\">\n{{teacher.name}}</md-option></md-select><span class=\"quan\">全</span></th><th md-column><md-select \nng-model=\"vm.all_zhuj\" ng-change=\"vm.selZhuj()\" placeholder=\"选择助教\"><md-option ng-repeat=\"assistant in vm.assistants\" \nvalue=\"{{assistant.id}}\">{{assistant.name}}</md-option></md-select><span class=\"quan\">全</span></th><th md-column>\n<md-button class=\"send-button md-accent md-raised\" style=\"min-width:30px;min-height:20px;line-height: 20px\" \ntype=\"button\" ng-click=\"vm.addItem()\"><span>添加</span></md-button></th></tr></thead><tbody md-body><tr \nng-repeat=\"item in vm.list\"><td md-cell style=\"padding-left: 10px!important\" ng-change=\"vm.changeDate(item)\" \nng-model=\"item.date\"><md-datepicker flex md-placeholder=\"上课时间\" ng-model=\"item.date\" \nng-model-options=\"{timezone:\'utc\'}\">{{item.date}}</md-datepicker></td><td md-cell><md-select ng-model=\"item.time\" \nplaceholder=\"选择时段\" ng-change=\"vm.changeDate(item)\"><md-option ng-repeat=\"ctime in vm.course_time_arr\" \nvalue=\"{{ctime.name}}\">{{ctime.name}}</md-option></md-select><div class=\"errors-info mt-5\" \nng-if=\"item.time_error == 1\">时段冲突</div></td><td md-cell>{{item.zeno_time}}</td><td md-cell><md-input-container \nmd-no-float class=\"m-0\" placeholder=\"选择课时\"><label translate=\"课时\" class=\"hide\">课时</label><input ng-model=\"item.kshi\" \nmd-placeholder=\"课时\" translate></md-input-container></td><td md-cell><md-select ng-model=\"item.room\" placeholder=\"选择教室\">\n<md-option ng-repeat=\"room in vm.rooms\" value=\"{{room.id}}\">{{room.name}}</md-option></md-select><div \nclass=\"errors-info mt-5\" ng-if=\"item.room_error == 1\">教室冲突</div></td><td md-cell><md-select ng-model=\"item.teacher\" \nplaceholder=\"选择主教\" ng-change=\"vm.changeDate(item)\"><md-option ng-repeat=\"teacher in vm.teachers\" \nvalue=\"{{teacher.id}}\">{{teacher.name}}</md-option></md-select><div class=\"errors-info mt-5\" \nng-if=\"item.teacher_error == 1\">主教冲突</div></td><td md-cell><md-select ng-model=\"item.zhuj\" placeholder=\"选择助教\">\n<md-option ng-repeat=\"assistant in vm.assistants\" value=\"{{assistant.id}}\">{{assistant.name}}</md-option></md-select>\n<div class=\"errors-info mt-5\" ng-if=\"item.zhuj_errorr == 1\">助教冲突</div></td><td md-cell><a \nng-click=\"vm.removeItem(item)\">删除</a></td></tr></tbody></table></md-table-container></div></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"footer white-bg pl-8 pv-5\" style=\"text-align: center!important\"><div \nlayout=\"row\" layout-align=\"end center\"><md-button class=\"send-button md-accent md-raised\" type=\"button\" \nng-click=\"vm.check($event)\" ng-disabled=\"!vm.curr_course.number || vm.list.length == 0\"><span>检测冲突</span></md-button>\n<md-button class=\"send-button md-accent md-raised\" type=\"button\" ng-click=\"vm.saveCourse($event)\" id=\"sub-btn\" \nng-disabled=\"!vm.curr_course.number || vm.list.length == 0\"><span>保存</span></md-button><div class=\"loading-threads\" \nlayout=\"column\" layout-align=\"center center\" ng-if=\"vm.loadingThreads\"><md-progress-circular class=\"md-accent\" \nmd-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular></div></div></div></div><style>\n.md-data-table td{\n        padding: 10px 0px 10px 0px!important;\n    }\n    .md-data-table th{\n        /*padding: 12px 0px 12px 0px!important;*/\n    }\n    .md-input-container .md-errors-spacer{\n        min-height: 0px!important;\n    }\n    table.md-table thead.md-head > tr.md-row {\n        height: inherit;\n    }\n    .fc table {\n        /* width: 40%; */\n        table-layout: fixed;\n        border-collapse: collapse;\n        border-spacing: 0;\n        font-size: 1em;\n    }\n    .fc-rigid{\n        height: 0px!important;\n    }\n    .fc table{\n        /*width: 300px;*/\n    }\n    .fc-row {\n        /*border-color: #fff!important;*/\n    }\n    .fc-basic-view .fc-body .fc-row {\n        min-height: 20px!important;\n    }\n    .fc th, .fc td {\n        border-style: none !important;\n        border-width: 0px !important;\n    }\n    .header-bottom{\n        /*max-width: 300px!important;*/\n        padding:4px 0 3px;\n    }\n    .fc-view{\n        padding-top: 0px!important;\n    }\n    .cdate{\n        /*float: left;*/\n        /*width: 320px;*/\n        border-radius: 4px;\n        /*box-shadow: 0 1px 3px 0 rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 2px 1px -1px rgba(0,0,0,.12);*/\n        border:1px solid;\n        border-color: rgba(0,0,0,0.12);\n    }\n    .click-courses{\n        padding:16px !important;\n        padding-top: 0 !important;\n    }\n    .click-courses .simple-table-container{\n        border:1px solid;\n        border-color: rgba(0,0,0,0.12);\n        border-radius: 4px;\n    }\n    /*.click-courses tbody{*/\n        /*padding:12px 0;*/\n    /*}*/\n    .click-courses md-select.md-table-select > .md-select-value{\n        border-bottom-width: 1px !important;\n        border-bottom-style: solid !important;\n        border-bottom-color: rgba(0,0,0,0.12) !important;\n    }\n    .click-courses table.md-table th.md-column:first-child, .click-courses table.md-table th.md-column:last-child{\n        padding-right: 12px !important;\n    }\n    .click-courses table.md-table th.md-column{\n        padding-right: 26px !important;\n        position: relative;\n    }\n    .click-courses table.md-table th.md-column span.quan{\n        height:20px;\n        position: absolute;\n        top:50%;\n        margin-top: -10px;\n        right: 10px;\n        line-height: 20px;\n        padding: 0 3px;\n        color: rgb(3,155,229);\n    }\n    .click-courses table.md-table th md-select {\n        margin: 12px 0;\n    }\n    .click-courses table.md-table td.md-cell{\n        padding-right: 12px !important;\n    }\n    .click-courses table.md-table th .md-button{\n        margin: 0 !important;\n    }\n    .click-courses md-input-container .md-errors-spacer{\n        min-height: 0 !important;\n    }\n    .click-courses .errors-info{\n        color: rgb(213,0,0);\n    }\n    #calendar{\n        flex-direction: row;\n        background-color: inherit;\n        padding:0 11px;\n     }\n    #calendar .ms-widget{\n        padding:0px 5px 10px;\n    }\n    #md-input-container .md-errors-spacer{\n        min-height: inherit;\n    }\n    .fc-unthemed .fc-today {\n        background: #fcf8e3;\n    }\n    .fc-ltr .fc-basic-view .fc-day-number {\n        text-align: center !important;\n    }\n    #calendar .content .calendarView.fc .fc-widget-header .fc-day-header {\n        text-align: center !important;\n        border: none;\n        font-weight: 500;\n        padding: 3px 0 2px !important;\n        /* background-color: #E3F2FD !important; */\n        /*background-color: #f0f0f0!important;*/\n        background-color: #F5F5F5 !important;\n    }\n    table.md-table:not(.md-row-select) td.md-cell:nth-child(n+2):nth-last-child(n+2), table.md-table:not(.md-row-select) th.md-column:nth-child(n+2):nth-last-child(n+2) {\n        padding: 0 0 0 0;\n    }\n    #calendar .content .calendarView.fc .fc-widget-content .fc-day-grid-container .fc-day-grid .fc-day-number{\n        padding:0 !important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/courses/paike.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><md-sidenav style=\"max-width:60%;width:60%\" \nclass=\"sidenav settings-sidenav md-sidenav-right\" md-component-id=\"settings-sidenav\" ms-scroll ms-sidenav-helper>\n<md-content class=\"content\" layout-padding><div layout=\"row\" layout-align=\"start center\" style=\"padding-top: 0px\">\n<md-input-container class=\"md-block\" flex=\"30\"><label translate=\"历史周期\">历史周期</label><md-select ng-model=\"vm.lsweek\">\n<md-option value=\"{{item.id}}\" ng-repeat=\"item in vm.sourceWeeks\">第{{item.id}}周{{item.sdate}}~{{item.edate}}\n</md-option></md-select></md-input-container><span><i class=\"icon icon-arrow-right s20\"></i></span> <span>复制</span> \n<span><i class=\"icon icon-arrow-right s20\"></i></span><md-input-container class=\"md-block\" flex=\"30\"><label \ntranslate=\"目标周期\">目标周期</label><md-select ng-model=\"vm.mbweek\"><md-option value=\"{{item.id}}\" \nng-repeat=\"item in vm.mbWeeks\">第{{item.id}}周{{item.sdate}}~{{item.edate}}</md-option></md-select></md-input-container>\n</div><label translate=\"复制约课会员\">复制约课会员</label><div layout-xs=\"column\" layout=\"row\"><md-checkbox ng-model=\"vm.gudin\" \naria-label=\"固定位\">固定位</md-checkbox><md-checkbox md-no-ink ng-model=\"vm.linshi\" aria-label=\"临时位\">临时位</md-checkbox></div>\n<div layout=\"row\" layout-align=\"start center\" style=\"padding-top: 0px\"><md-button type=\"submit\" \nng-click=\"vm.doSearchCourse()\" class=\"send-button md-accent md-raised\" md-no-float class=\"m-0\" aria-label=\"搜索\" \ntranslate=\"搜索\" translate-attr-aria-label=\"搜索\">SAVE</md-button><md-button type=\"submit\" ng-click=\"vm.doCopyCourse()\" \nclass=\"send-button md-accent md-raised\" md-no-float class=\"m-0\" aria-label=\"批量复制\" translate=\"批量复制\" \ntranslate-attr-aria-label=\"批量复制\">SAVE</md-button></div><div class=\"content white-bg\"><md-table-container><table \nmd-table class=\"md-data-table\"><thead md-head><tr md-row><th md-column decend-first \nstyle=\"padding-left: 10px!important\"><md-checkbox class=\"no-label\" \naria-label=\"{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 0\" ng-click=\"vm.toggleSelectThreads()\"></md-checkbox></th><th md-column \ndecend-first style=\"padding-left: 15px!important\"><span class=\"column-title\">课程名称</span></th><th md-column \ndecend-first><span class=\"column-title\">上课时间</span></th><th md-column decend-first><span class=\"column-title\">老师</span>\n</th><th md-column decend-first><span class=\"column-title\">固定位</span></th><th md-column decend-first><span \nclass=\"column-title\">监时位</span></th></tr></thead><tbody md-body><tr ng-repeat=\"course in vm.courses1\"><td md-cell \nstyle=\"padding-left: 10px!important\"><md-checkbox class=\"no-label\" ng-if=\"!course.is_copy\" \nng-checked=\"vm.isSelected(course)\" ng-click=\"vm.toggleSelectThread(course, $event)\" \naria-label=\"{{vm.isSelected(course) ? \'Deselect\' : \'Select\'}}\"></md-checkbox><span ng-if=\"course.is_copy\">已复制</span>\n</td><td md-cell>{{ course.name }}</td><td md-cell>{{ course.course_time }}{{course.week}}<br>\n{{ course.course_begintime }}~{{ course.course_endtime }}</td><td md-cell>{{ course.teacher_name }}</td><td md-cell>\n<span ng-if=\"vm.gudin\">{{ course.signupshu.gudin.length }}人</span> <span ng-if=\"!vm.gudin\">不复制</span></td><td md-cell>\n<span ng-if=\"vm.linshi\">{{ course.signupshu.linshi.length }}人</span> <span ng-if=\"!vm.linshi\">不复制</span></td></tr>\n</tbody></table></md-table-container></div></md-content></md-sidenav><div class=\"\" ng-class=\"vm.currentMonthShort\"><div\n class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between center\" layout-xs=\"column\" style=\"padding-left: 20px\"><div class=\"logo hide\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span \nclass=\"logo-text\" translate=\"CALENDAR.CALENDAR\">Calendar</span></div><div class=\"search-input-wrapper\" layout=\"row\" \nlayout-align=\"start center\"><md-input-container md-no-float style=\"margin-top:20px\"><label translate=\"年份\">年份</label>\n<md-select ng-model=\"vm.year\" ng-change=\"vm.doSearch()\"><md-option value=\"{{year.id}}\" ng-repeat=\"year in vm.years\">\n{{year.id}}</md-option></md-select></md-input-container><md-input-container md-no-float class=\"m-0\"><label \ntranslate=\"周\">周</label><md-select ng-model=\"vm.week\" ng-change=\"vm.doSearch()\"><md-option value=\"{{week.id}}\" \nng-repeat=\"week in vm.weeks\">第{{week.id}}周</md-option></md-select></md-input-container><md-button \nng-click=\"vm.toggleSidenav(\'settings-sidenav\')\" class=\"send-button md-accent md-raised\" md-no-float class=\"m-0\">复制排课\n</md-button></div><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button hide\" \naria-label=\"Search\" translate translate-attr-aria-label=\"CALENDAR.SEARCH\"><md-icon md-font-icon=\"icon-magnify\">\n</md-icon><md-tooltip><span translate=\"CALENDAR.SEARCH\">Search</span></md-tooltip></md-button><md-button \nclass=\"md-icon-button hide\" ng-click=\"vm.calendar.today()\" aria-label=\"Today\" translate \ntranslate-attr-aria-label=\"CALENDAR.TODAY\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.TODAY\">Today</span></md-tooltip></md-button><md-button class=\"md-icon-button hide\" \nng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" translate translate-attr-aria-label=\"CALENDAR.DAY\">\n<md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span translate=\"CALENDAR.DAY\">Day</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button hide\" ng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"Week\" \ntranslate translate-attr-aria-label=\"CALENDAR.WEEK\"><md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.WEEK\">Week</span></md-tooltip></md-button><md-button class=\"md-icon-button hide\" \nng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate translate-attr-aria-label=\"CALENDAR.MONTH\">\n<md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span translate=\"CALENDAR.MONTH\">Month</span>\n</md-tooltip></md-button></div></div><div class=\"header-bottom hide\" layout=\"row\" layout-align=\"center center\">\n<md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" aria-label=\"Previous\" translate \ntranslate-attr-aria-label=\"CALENDAR.PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button><div \nclass=\"title\">{{vm.calendarView.title}}</div><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.next()\" \naria-label=\"Next\" translate translate-attr-aria-label=\"CALENDAR.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\">\n</md-icon></md-button></div></div></div><div class=\"content\"><div id=\"calendarView\" \nui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\"></div></div></div><style>\n.md-data-table td{\n        padding: 10px 0px 10px 0px!important;\n    }\n    .md-data-table th{\n        padding: 10px 0px 10px 0px!important;\n    }\n    md-input-container .md-errors-spacer{\n        min-height: 0px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/courses/signup.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">课程管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">课程列表</div></div>\n<div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.query.name\" translate ng-change=\"vm.doSearch()\" \ntranslate-attr-placeholder=\"课程名称\"></md-input-container><label translate=\"上课时间\">上课时间</label><md-datepicker flex \ntranslate-attr-placeholder=\"上课时间\" ng-init=\"vm.query.sdate=vm.StrToDate(vm.query.sdate);\" ng-model=\"vm.query.sdate\" \nng-change=\"vm.doSearch()\" ng-model-options=\"{timezone:\'utc\'}\">{{vm.query.sdate}}</md-datepicker><md-datepicker flex \nmd-placeholder=\"上课时间\" ng-init=\"vm.query.edate = vm.StrToDate(vm.query.edate);\" ng-model=\"vm.query.edate\" \nng-change=\"vm.doSearch()\" ng-model-options=\"{timezone:\'utc\'}\">{{vm.query.edate}}</md-datepicker></div></div><div \nclass=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><md-table-container><table md-table class=\"md-data-table\">\n<thead md-head md-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row><th md-column \nmd-order-by=\"customer_name\" decend-first style=\"padding-left: 15px!important\"><span class=\"column-title\">课程名称<br>门店\n</span></th><th md-column md-order-by=\"customer_name\" decend-first><span class=\"column-title\">类型</span></th><th \nmd-column md-order-by=\"customer_name\" decend-first><span class=\"column-title\">上课时间</span></th><th md-column \nmd-order-by=\"customer_name\" decend-first><span class=\"column-title\">上课地点</span></th><th md-column \nmd-order-by=\"customer_name\" decend-first><span class=\"column-title\">人数</span></th><th></th></tr></thead><tbody><tr \nng-repeat=\"course in vm.courses.data\"><td md-cell style=\"padding-left: 15px!important\">{{ course.name }}<br>\n{{ course.store_name }}</td><td md-cell>{{ course.categories_name }}</td><td md-cell>{{ course.course_time }}<br>\n{{ course.course_begintime }}~{{ course.course_endtime }}</td><td md-cell>{{ course.location }}</td><td md-cell>\n预招：{{ course.course_size }}<br>预约：{{course.signup_count}}</td><td md-cell><span \nng-if=\"course.signup_count<course.course_size\"><a ng-click=\"vm.signup($event, course)\">预约</a> </span><span \nng-if=\"course.signup_count>=course.course_size\" style=\"color: #ddd\">已约满</span></td></tr></tbody></table>\n</md-table-container><md-table-pagination md-limit=\"vm.query.limit\" md-page-select md-page=\"vm.query.page\" \nmd-total=\"{{vm.courses._meta.totalCount}}\" md-on-paginate=\"vm.doSearch\"></md-table-pagination></div></div></div><style>\n.md-data-table td{\n        padding: 10px 0px 10px 0px!important;\n    }\n    .md-data-table th{\n        padding: 10px 0px 10px 0px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/courses/task.html","<div class=\"page-layout simple fullwidth datalist-content\"><md-sidenav style=\"max-width:60%;width:60%;z-index:100\" \nclass=\"sidenav settings-sidenav md-sidenav-right\" md-component-id=\"settings-sidenav\" ms-scroll ms-sidenav-helper>\n<md-content class=\"content\" layout-padding><div class=\"content white-bg\"><md-table-container><table md-table \nclass=\"md-data-table\"><thead md-head><tr md-row><th md-column decend-first style=\"padding-left: 15px!important\"><span \nclass=\"column-title\">教学计划</span></th><th md-column decend-first><span class=\"column-title\">计划描述</span></th><th \nmd-column decend-first><span class=\"column-title\">课数</span></th><th></th></tr></thead><tbody md-body><tr \nng-repeat=\"plan in vm.plans\"><td md-cell style=\"padding-left: 10px!important\">{{plan.title}}</td><td md-cell>\n{{ plan.desc }}</td><td md-cell>{{ plan.num }}</td><td md-cell><md-button \nng-click=\"vm.selectPlan(plan, \'settings-sidenav\')\" class=\"send-button md-accent md-raised\" md-no-float class=\"m-0\" \nstyle=\"min-height:28px;line-height: 28px\"><span style=\"color: #fff!important\">选择</span></md-button></td></tr></tbody>\n</table></md-table-container></div></md-content></md-sidenav><md-sidenav style=\"max-width:60%;width:60%;z-index:100\" \nclass=\"sidenav settings-sidenav md-sidenav-right\" md-component-id=\"spcourses-sidenav\" ms-scroll ms-sidenav-helper>\n<md-content class=\"content\" layout-padding><div class=\"content white-bg\"><span class=\"m-12 mat-title\">\n{{vm.curr_plan.title}}</span><md-progress-circular id=\"toolbar-progress\" ng-if=\"vm.isStuPlanCoursesLoading\" \nclass=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\"></md-progress-circular><md-table-container \nng-if=\"!vm.isStuPlanCoursesLoading\"><table md-table class=\"md-data-table\"><thead md-head><tr md-row><th md-column \ndecend-first style=\"padding-left: 15px!important\"><span class=\"column-title\">课程</span></th><th md-column decend-first>\n<span class=\"column-title\">时间</span></th></tr></thead><tbody md-body><tr ng-repeat=\"course in vm.stuPlanCourses\"><td \nmd-cell style=\"padding-left: 10px!important\">{{course.name}}</td><td md-cell>\n{{ course.course_time }} {{ course.course_begintime }}</td></tr></tbody></table></md-table-container></div>\n</md-content></md-sidenav><div><md-chips ng-model=\"vm.selectedVegetables\" md-autocomplete-snap \nmd-transform-chip=\"vm.transformChip($chip)\" md-require-match=\"vm.autocompleteDemoRequireMatch\"><md-autocomplete \nid=\"customer-auto\" md-selected-item=\"vm.selectedItem\" md-search-text-change=\"vm.querySearch(vm.searchText)\" \nmd-search-text=\"vm.searchText\" md-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.name\" \nmd-min-length=\"0\" placeholder=\"查找学生\"><span md-highlight-text=\"vm.searchText\">{{item.name}}</span></md-autocomplete>\n<md-chip-template><span><strong>{{$chip.name}}</strong> <em></em></span></md-chip-template></md-chips><div \nclass=\"header-content mt-5\" layout=\"column\" layout-align=\"space-between\"><div class=\"header-top\" layout=\"row\" \nlayout-align=\"space-between \" layout-xs=\"column\" style=\"padding-left: 24px\"><div class=\"search-input-wrapper\" \nlayout=\"row\" layout-align=\"start center\" flex=\"100\"><md-button ng-click=\"vm.toggleSidenavPlans(\'settings-sidenav\')\" \nclass=\"send-button md-accent md-raised\" md-no-float class=\"\">选择计划</md-button><md-input-container \nclass=\"md-block md-input-container\" flex=\"30\"><label translate=\"教学计划\">教学计划</label><input name=\"name\" \nng-model=\"vm.curr_plan.title\" md-autofocus flex=\"1000\" required ng-model-options=\"{debounce : 500}\" \nng-change=\"vm.planChange()\"><div ng-messages=\"vm.curr_plan.title.$error\" ng-show=\"vm.curr_plan.number.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>教学计划必填</span></div></div></md-input-container><md-input-container \nclass=\"md-block md-input-container\" flex=\"40\"><label translate=\"固定课号\">固定课号</label><input name=\"name\" \nng-model=\"vm.number\" md-autofocus flex=\"100\" required ng-model-options=\"{debounce : 500}\"><div \nng-messages=\"vm.number.$error\" ng-show=\"vm.number.$touched\" role=\"alert\"><div ng-message=\"required\"><span>固定课号必填</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"课程类型\">课程类型</label>\n<md-select ng-model=\"vm.categories_id\" required><md-option ng-repeat=\"categorie in vm.categories\" \nng-value=\"{{categorie.id}}\">{{categorie.name}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex=\"30\"><label translate=\"课程级别\">课程级别</label><md-select ng-model=\"vm.type\" required><md-option \nng-repeat=\"categorie in vm.jibei_types\" ng-value=\"{{categorie.id}}\">{{categorie.name}}</md-option></md-select>\n</md-input-container></div></div><div class=\"header-top\" layout=\"row\" layout-align=\"space-between \"><div id=\"calendar\" \nclass=\"page-layout simple fullwidth\"><div ui-date=\"vm.dateOptions\" name=\"DateOfSelect\" ng-model=\"vm.myDate\" \nid=\"taskplanDatePicker\"></div></div></div></div></div><div class=\"click-courses\" style=\"top:380px\"><div \nclass=\"simple-table-container\"><div class=\"paike-box\"><div class=\"paike-title\"><table md-table class=\"md-data-table\">\n<thead><tr><th style=\"width: 15%\">教学任务</th><th style=\"width: 15%; padding-left: 18px\">日期</th><th class=\"tit-quan\" \nstyle=\"width: 12%\"><md-select ng-model=\"vm.all_time\" ng-change=\"vm.selTime()\" placeholder=\"选择时段\"><md-option \nng-repeat=\"ctime in vm.course_time_arr\" value=\"{{ctime.name}}\">{{ctime.name}}</md-option></md-select><span \nclass=\"quan\">全</span></th><th style=\"width: 12%\">主教时区</th><th class=\"tit-quan\" style=\"width: 12%\"><md-select \nng-model=\"vm.all_room\" ng-change=\"vm.selRoom()\" placeholder=\"选择教室\"><md-option ng-repeat=\"room in vm.rooms\" \nvalue=\"{{room.id}}\">{{room.name}}</md-option></md-select><span class=\"quan\">全</span></th><th class=\"tit-quan\" \nstyle=\"width: 12%\"><md-select ng-model=\"vm.all_teacher\" ng-change=\"vm.selTeacher()\" placeholder=\"选择主教\"><md-option \nng-repeat=\"teacher in vm.teachers\" value=\"{{teacher.id}}\">{{teacher.name}}</md-option></md-select><span class=\"quan\">全\n</span></th><th class=\"tit-quan\" style=\"width: 12%\"><md-select ng-model=\"vm.all_zhuj\" ng-change=\"vm.selZhuj()\" \nplaceholder=\"选择助教\"><md-option ng-repeat=\"assistant in vm.assistants\" value=\"{{assistant.id}}\">{{assistant.name}}\n</md-option></md-select><span class=\"quan\">全</span></th><th class=\"btn-qulast hide\" style=\"width: 10%\"><md-button \nclass=\"send-button md-accent md-raised\" type=\"button\" ng-click=\"vm.addItem()\"><span>添加</span></md-button></th></tr>\n</thead></table></div><div class=\"paike-content\"><div class=\"\" ng-if=\"vm.isLoadingTasks\">加载中计划任务中.........</div><div \nclass=\"parent {{item.passed?\'passed\':\'not-pass\'}}\" ng-repeat=\"item in vm.list\" ng-if=\"!vm.isLoadingTasks\"><table \nmd-table class=\"md-data-table\"><tbody><tr><td style=\"width: 15%\"><textarea name=\"name\" ng-model=\"item.name\" required \nng-model-options=\"{debounce : 500}\"></textarea></td><td style=\"width: 15%\"><md-datepicker flex md-placeholder=\"上课时间\" \nng-change=\"vm.changeDate(item,1)\" ng-model=\"item.date\" ng-disabled=\"false&&item.passed\">{{item.date}}</md-datepicker>\n</td><td class=\"tit-quan\" style=\"width: 12%\"><md-select ng-model=\"item.time\" placeholder=\"选择时段\" \nng-change=\"vm.changeDate(item)\" ng-disabled=\"false&&item.passed\"><md-option ng-repeat=\"ctime in vm.course_time_arr\" \nvalue=\"{{ctime.name}}\">{{ctime.name}}</md-option></md-select><div class=\"errors-info mt-5\" \nng-if=\"item.time_error == 1\">时段冲突</div></td><td style=\"width: 12%\">{{item.zeno_time}}</td><td class=\"tit-quan\" \nstyle=\"width: 12%\"><md-select ng-model=\"item.room\" placeholder=\"选择教室\" ng-disabled=\"false&&item.passed\"><md-option \nng-repeat=\"room in vm.rooms\" value=\"{{room.id}}\">{{room.name}}</md-option></md-select><div class=\"errors-info mt-5\" \nng-if=\"item.room_error == 1\">教室冲突</div></td><td class=\"tit-quan\" style=\"width: 12%\"><md-select ng-model=\"item.teacher\" \nplaceholder=\"选择主教\" ng-change=\"vm.changeDate(item)\" ng-disabled=\"false&&item.passed\"><md-option \nng-repeat=\"teacher in vm.teachers\" value=\"{{teacher.id}}\">{{teacher.name}}</md-option></md-select><div \nclass=\"errors-info mt-5\" ng-if=\"item.teacher_error == 1\">主教冲突</div></td><td class=\"tit-quan\" style=\"width: 12%\">\n<md-select ng-model=\"item.zhuj\" placeholder=\"选择助教\" ng-disabled=\"false&&item.passed\"><md-option \nng-repeat=\"assistant in vm.assistants\" value=\"{{assistant.id}}\">{{assistant.name}}</md-option></md-select><div \nclass=\"errors-info mt-5\" ng-if=\"item.zhuj_errorr == 1\">助教冲突</div></td><td style=\"width: 10%\"><a \nng-click=\"vm.addChild($index)\" class=\"btn btn-add\">+</a> <a ng-click=\"vm.delTaskItem($index)\" class=\"btn btn-add\" \nng-if=\"true||!item.passed\">-</a></td></tr><tr ng-if=\"item.is_conflict\"><td colspan=\"6\" class=\"errors-info\">\n{{item.conflict_course}}</td></tr></tbody></table><div class=\"child\"><div \nclass=\"children {{child.passed?\'passed\':\'not-pass\'}}\" ng-repeat=\"child in item.childs\"><table md-table \nclass=\"md-data-table\"><tbody><tr><td style=\"width: 15%\"><textarea name=\"name\" ng-model=\"child.name\" required \nng-model-options=\"{debounce : 500}\"></textarea></td><td style=\"width: 15%\"><md-datepicker flex md-placeholder=\"上课时间\" \nng-change=\"vm.changeDate(child,1)\" ng-model=\"child.date\" ng-model=\"child.date\" ng-disabled=\"false&&child.passed\" \nng-model-options=\"{timezone:\'utc\'}\">{{child.date}}</md-datepicker></td><td class=\"tit-quan\" style=\"width: 12%\">\n<md-select ng-model=\"child.time\" placeholder=\"选择时段\" ng-change=\"vm.changeDate(child)\" ng-disabled=\"false&&child.passed\">\n<md-option ng-repeat=\"ctime in vm.course_time_arr\" value=\"{{ctime.name}}\">{{ctime.name}}</md-option></md-select><div \nclass=\"errors-info mt-5\" ng-if=\"child.time_error == 1\">时段冲突</div></td><td style=\"width: 12%\">{{item.zeno_time}}</td><td\n class=\"tit-quan\" style=\"width: 12%\"><md-select ng-model=\"child.room\" placeholder=\"选择教室\" \nng-disabled=\"false&&child.passed\"><md-option ng-repeat=\"room in vm.rooms\" value=\"{{room.id}}\">{{room.name}}</md-option>\n</md-select><div class=\"errors-info mt-5\" ng-if=\"child.room_error == 1\">教室冲突</div></td><td class=\"tit-quan\" \nstyle=\"width: 12%\"><md-select ng-model=\"child.teacher\" placeholder=\"选择主教\" ng-change=\"vm.changeDate(child)\" \nng-disabled=\"false&&child.passed\"><md-option ng-repeat=\"teacher in vm.teachers\" value=\"{{teacher.id}}\">{{teacher.name}}\n</md-option></md-select><div class=\"errors-info mt-5\" ng-if=\"child.teacher_error == 1\">主教冲突</div></td><td \nclass=\"tit-quan\" style=\"width: 12%\"><md-select ng-model=\"child.zhuj\" placeholder=\"选择助教\" \nng-disabled=\"false&&child.passed\"><md-option ng-repeat=\"assistant in vm.assistants\" value=\"{{assistant.id}}\">\n{{assistant.name}}</md-option></md-select><div class=\"errors-info mt-5\" ng-if=\"item.zhuj_errorr == 1\">助教冲突</div></td>\n<td style=\"width: 10%\"><a ng-click=\"vm.delChild(item,child)\" class=\"btn btn-add\" ng-if=\"true||!child.passed\">-</a></td>\n</tr><tr ng-if=\"child.is_conflict\"><td colspan=\"6\" class=\"errors-info\">{{child.conflict_course}}</td></tr></tbody>\n</table></div></div></div></div></div></div></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"footer white-bg\"><div layout=\"row\" layout-align=\"end center\"><md-button class=\"send-button md-accent md-raised\" \ntype=\"button\" ng-click=\"vm.check($event)\" \nng-disabled=\"!vm.number || vm.list.length == 0 ||vm.type == 0 || vm.categories_id == 0 || vm.checkingConfuse\"><span>\n检测冲突</span></md-button><md-button class=\"send-button md-accent md-raised\" type=\"button\" \nng-click=\"vm.saveCourse($event)\" id=\"sub-btn\" \nng-disabled=\"!vm.number || vm.list.length == 0 ||vm.type == 0 || vm.categories_id == 0 || vm.checkingConfuse || vm.savingTask\">\n<span>保存</span></md-button><div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" \nng-if=\"vm.loadingThreads\"><md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"32\">\n</md-progress-circular></div></div><div layout=\"row\" ng-if=\"false\"><md-button class=\"send-button md-accent md-raised\" \ntype=\"button\" ng-click=\"vm.fetchStudentPlanCourses($event,true)\" id=\"fsp-btn\" \nng-if=\"vm.selectedVegetables.length>0&&vm.curr_plan\"><span>查看学生当前计划课程</span></md-button></div></div></div><style>\n.bg-white{\n        background: white;\n    }\n    md-chips.md-default-theme .md-chips, md-chips .md-chips {\n        box-shadow: 0 1px rgba(0,0,0,0.12);\n        /*background: white;*/\n        padding-left:16px;\n    }\n    md-chips.md-default-theme .md-chips, md-chips .md-chips input{\n        font-size: 14px;\n        font-weight: 600;\n        padding:0 12px 8px;\n    }\n    .md-data-table td{\n        padding: 10px 0px 10px 0px!important;\n    }\n    .md-data-table th{\n        /*padding: 12px 0px 12px 0px!important;*/\n    }\n    .md-input-container .md-errors-spacer{\n        min-height: 0px!important;\n    }\n    table.md-table thead.md-head > tr.md-row {\n        height: inherit;\n    }\n    .fc table {\n        /* width: 40%; */\n        table-layout: fixed;\n        border-collapse: collapse;\n        border-spacing: 0;\n        font-size: 1em;\n    }\n    .fc-rigid{\n        height: 0px!important;\n    }\n    .fc table{\n        /*width: 300px;*/\n    }\n    .fc-row {\n        /*border-color: #fff!important;*/\n    }\n    .fc-basic-view .fc-body .fc-row {\n        min-height: 20px!important;\n    }\n    .fc th, .fc td {\n        border-style: none !important;\n        border-width: 0px !important;\n    }\n    .header-bottom{\n        /*max-width: 300px!important;*/\n        padding:4px 0 3px;\n    }\n    .fc-view{\n        padding-top: 0px!important;\n    }\n    .cdate{\n        /*float: left;*/\n        /*width: 320px;*/\n        border-radius: 4px;\n        /*box-shadow: 0 1px 3px 0 rgba(0,0,0,.2), 0 1px 1px 0 rgba(0,0,0,.14), 0 2px 1px -1px rgba(0,0,0,.12);*/\n        border:1px solid;\n        border-color: rgba(0,0,0,0.12);\n    }\n    .click-courses{\n        padding:12px 16px 16px !important;\n        /*padding-top: 0 !important;*/\n    }\n    .click-courses .simple-table-container{\n        border:1px solid;\n        border-color: rgba(0,0,0,0.12);\n        border-radius: 4px;\n    }\n    /*.click-courses tbody{*/\n    /*padding:12px 0;*/\n    /*}*/\n    .click-courses md-select.md-table-select > .md-select-value{\n        border-bottom-width: 1px !important;\n        border-bottom-style: solid !important;\n        border-bottom-color: rgba(0,0,0,0.12) !important;\n    }\n    .click-courses table.md-table th.md-column:first-child, .click-courses table.md-table th.md-column:last-child{\n        padding-right: 12px !important;\n    }\n    .click-courses table.md-table th.md-column{\n        padding-right: 26px !important;\n        position: relative;\n    }\n    .click-courses table.md-table th.md-column span.quan{\n        height:20px;\n        position: absolute;\n        top:50%;\n        margin-top: -10px;\n        right: 10px;\n        line-height: 20px;\n        padding: 0 3px;\n        color: rgb(3,155,229);\n    }\n    .click-courses table.md-table th md-select {\n        margin: 12px 0;\n    }\n    .click-courses table.md-table td.md-cell{\n        padding-right: 12px !important;\n    }\n    .click-courses table.md-table th .md-button{\n        margin: 0 !important;\n    }\n    .click-courses md-input-container .md-errors-spacer{\n        min-height: 0 !important;\n    }\n    .click-courses .errors-info{\n        color: rgb(213,0,0);\n    }\n    #calendar{\n        flex-direction: row;\n        background-color: inherit;\n        padding:0 16px;\n    }\n    /* 横向滑动 */\n    .ui-datepicker-multi .ui-datepicker-group{\n        float: initial;\n        margin-right:5px;\n    }\n    #calendar .ui-widget.ui-widget-content{\n        width: initial !important;\n        padding: .6em .6em .2em;\n        border: 1px solid rgba(0,0,0,0.12);\n        display: -webkit-box !important;\n        overflow-x: scroll;\n        -webkit-overflow-scrolling:touch;\n    }\n    .header-top ::-webkit-scrollbar {\n    height: 8px; }\n    \n\n    #calendar .ui-widget.ui-widget-content .ui-datepicker-row-break{\n        width: 10px;\n    }\n    #calendar .ms-widget{\n        padding:0px 5px 10px;\n    }\n    #md-input-container .md-errors-spacer{\n        min-height: inherit;\n    }\n    .fc-unthemed .fc-today {\n        background: #fcf8e3;\n    }\n    .fc-ltr .fc-basic-view .fc-day-number {\n        text-align: center !important;\n    }\n    #calendar .content .calendarView.fc .fc-widget-header .fc-day-header {\n        text-align: center !important;\n        border: none;\n        font-weight: 500;\n        padding: 3px 0 2px !important;\n        /* background-color: #E3F2FD !important; */\n        /*background-color: #f0f0f0!important;*/\n        background-color: #F5F5F5 !important;\n    }\n    table.md-table:not(.md-row-select) td.md-cell:nth-child(n+2):nth-last-child(n+2), table.md-table:not(.md-row-select) th.md-column:nth-child(n+2):nth-last-child(n+2) {\n        padding: 0 0 0 0;\n    }\n    #calendar .content .calendarView.fc .fc-widget-content .fc-day-grid-container .fc-day-grid .fc-day-number{\n        padding:0 !important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/customers/customer-contract-wizard.html","<div id=\"customer-wizard\" class=\"page-layout simple fullwidth\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\" ng-show=\"false\"><div layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" \nstyle=\"margin-bottom:12px!important\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">学生管理</span></div><div \nclass=\"title\" style=\"font-size: 24px!important\">学生列表</div></div></div><div class=\"content\"><div layout=\"row\">\n<ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab>\n<md-tab-label><span class=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" \nng-if=\"wizardStep1.$invalid\">1</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\">\n<i class=\"icon-check s16\"></i> </span><span class=\"ms-form-wizard-step-text\">学生信息</span></span></md-tab-label>\n<md-tab-body><form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate><div layout-xs=\"column\" \nlayout=\"row\"><div layout-xs=\"column\" layout=\"column\" flex=\"100\" flex-gt-xs=\"80\"><div layout-xs=\"column\" layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"25\"><label translate=\"会员号\">会员号</label><input name=\"member_id\" \nng-model=\"vm.customer.member_id\" required md-autofocus><div ng-messages=\"wizardStep1.member_id.$error\" \nng-show=\"wizardStep1.member_id.$touched\" role=\"alert\"><div ng-message=\"required\"><span>会员号必填</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"25\"><label translate=\"学生姓名\">学生姓名</label><input \nname=\"name\" ng-model=\"vm.customer.name\" required><div ng-messages=\"wizardStep1.name.$error\" \nng-show=\"wizardStep1.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>学生姓名必填</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"25\"><label translate=\"昵称\">昵称</label><input \nname=\"nickname\" ng-model=\"vm.customer.nickname\"><div ng-messages=\"wizardStep1.nickname.$error\" \nng-show=\"wizardStep1.nickname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>昵称必填</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"25\"><label translate=\"skype\">skype</label><input \nname=\"skype\" ng-model=\"vm.customer.skype\"></md-input-container></div><div layout-xs=\"column\" layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"25\"><label translate=\"email\">Email</label><input name=\"email\" type=\"email\" \nng-model=\"vm.customer.email\" required></md-input-container><md-input-container \nclass=\"md-block md-default-theme md-input-focused\" flex=\"25\"><label translate=\"性别\" style=\"font-size: 1.6rem\">性别</label>\n<md-radio-group name=\"sex\" ng-model=\"vm.customer.sex\" required><md-radio-button ng-value=\"1\" aria-label=\"男\">男\n</md-radio-button><md-radio-button ng-value=\"0\" aria-label=\"女\">女</md-radio-button></md-radio-group><div \nng-messages=\"wizardStep1.sex.$error\" ng-show=\"wizardStep1.sex.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\n性别必填</span></div></div></md-input-container><md-input-container class=\"md-block\" flex=\"25\"><label translate=\"生日\">生日\n</label><md-datepicker flex ng-init=\"birthday = vm.StrToDate(vm.customer.birthday);\" ng-model=\"birthday\" \nname=\"birthday\" ng-change=\"vm.customer.birthday = vm.DateToStr(birthday)\" ng-model-options=\"{timezone:\'utc\'}\" \nmd-placeholder=\"生日\">{{birthday}}</md-datepicker><div ng-messages=\"wizardStep1.birthday.$error\" \nng-show=\"wizardStep1.birthday.$touched\" role=\"alert\"><div ng-message=\"required\"><span>出生日期必填</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"25\"><label translate=\"课程顾问\">课程顾问</label><md-select \nng-model=\"vm.customer.consult_id\"><md-option ng-repeat=\"user in vm.users\" value=\"{{user.id}}\">{{user.name}}</md-option>\n</md-select></md-input-container></div></div><div layout-xs=\"column\" layout=\"column\" flex=\"25\" flex-gt-xs=\"25\" \nlayout-align=\"center center\" ng-file-select=\"vm.onFileSelect($files)\" data-multiple=\"false\" title=\"选择图片文件\" \nonclick=\"this.value = null\"><img ng-file-select=\"vm.onFileSelect($files)\" data-multiple=\"false\" title=\"选择图片文件\" \nonclick=\"this.value = null\" class=\"md-avatar avatar contact-avatar huge\" ng-if=\"vm.customer.avatar\" \nng-src=\"{{vm.customer.avatar}}?imageView/2/w/64/h/64\"><label translate=\"上传头像\">上传头像</label></div></div><div \nlayout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"100\"><label translate=\"备注\">备注</label>\n<textarea ng-model=\"vm.customer.remarks\" md-maxlength=\"150\" max-rows=\"5\"></textarea></md-input-container></div></form>\n</md-tab-body></md-tab><md-tab ng2-disabled=\"wizardStep1.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$invalid\">2\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">联系人</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" \nms-form-wizard-form novalidate><md-card md-theme=\"default\" md-theme-watch ng-repeat=\"parent in vm.parents\">\n<md-card-title><md-select ng-model=\"parent.relation\" flex=\"100\" ng-disabled=\"parent.was\"><md-option value=\"爸爸\">爸爸\n</md-option><md-option value=\"妈妈\">妈妈</md-option></md-select></md-card-title><md-card-content layout=\"column\" \nlayout-align=\"space-between\"><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"手机号\">\n手机号</label><input name=\"mobile[{{$index}}]\" ng-model=\"parent.mobile\" ng-blur=\"vm.mobileChanged(parent.mobile,$index)\" \nrequired md-autofocus><div ng-messages=\"wizardStep2.mobile[$index].$error\" \nng-show=\"wizardStep2.mobile[$index].$touched\" role=\"alert\"><div ng-message=\"required\"><span>手机号必填</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"登录账号\">登录账号</label><input \nname=\"username[{{$index}}]\" ng-model=\"parent.username\" required ng-disabled=\"parent.was\"><div \nng-messages=\"wizardStep2.username[$index].$error\" ng-show=\"wizardStep2.username[$index].$touched\" role=\"alert\"><div \nng-message=\"required\"><span>登录账号必填</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"30\"><label translate=\"姓名\">姓名</label><input name=\"name[{{$index}}]\" ng-model=\"parent.name\" required \nng-disabled=\"parent.was\"><div ng-messages=\"wizardStep2.name[$index].$error\" \nng-show=\"wizardStep2.name[$index].$touched\" role=\"alert\"><div ng-message=\"required\"><span>姓名必填</span></div></div>\n</md-input-container></div><div layout=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"邮箱\">邮箱\n</label><input name=\"email[{{$index}}]\" ng-model=\"parent.email\" ng-disabled=\"parent.was\"><div \nng-messages=\"wizardStep2.email[$index].$error\" ng-show=\"wizardStep2.email[$index].$touched\" role=\"alert\"><div \nng-message=\"required\"><span>邮箱必填</span></div></div></md-input-container><md-input-container class=\"md-block\" flex=\"30\">\n<label translate=\"微信号\">微信号</label><input name=\"wechat[{{$index}}]\" ng-model=\"parent.wechat\" ng-disabled=\"parent.was\">\n<div ng-messages=\"wizardStep2.wechat[$index].$error\" ng-show=\"wizardStep2.wechat[$index].$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"TODO.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"QQ号\">QQ号</label><input \nname=\"qq[{{$index}}]\" ng-model=\"parent.qq\" ng-disabled=\"parent.was\"><div ng-messages=\"wizardStep2.qq[$index].$error\" \nng-show=\"wizardStep2.qq[$index].$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TODO.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container></div>\n</md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.addOtherRelation();\" \nng-show=\"vm.parents.length==1\">添加另一个</md-button><md-button ng-click=\"vm.removeOtherRelation();\" \nng-show=\"vm.parents.length==2&&$index==1\">删除联系人</md-button></md-card-actions></md-card></form></md-tab-body></md-tab>\n<md-tab ng2-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\"><md-tab-label><span \nclass=\"ms-form-wizard-step-label\"><span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$invalid\">3\n</span> <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\"><i class=\"icon-check s16\"></i>\n </span><span class=\"ms-form-wizard-step-text\">合同</span></span></md-tab-label><md-tab-body><form name=\"wizardStep3\" \nms-form-wizard-form novalidate><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" \nclass=\"md-block\" flex=\"50\"><label translate=\"合同号\">合同号</label><input name=\"contact_guid\" \nng-model=\"vm.contract.contact_guid\" required md-autofocus><div ng-messages=\"wizardStep3.contact_guid.$error\" \nng-show=\"wizardStep3.contact_guid.$touched\" role=\"alert\"><div ng-message=\"required\"><span>合同号必填</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" class=\"md-block\" flex=\"50\"><md-autocomplete flex=\"100\" \nmd-input-name=\"vm.contract.plan_title\" ng-disabled=\"vm.isDisabled\" md-selected-item=\"vm.selectedPlanItem\" \nmd-search-text-change=\"vm.searchPlans(vm.searchPlanText)\" md-search-text=\"vm.searchPlanText\" \nmd-selected-item-change=\"vm.selectedPlanItemChange(item)\" md-items=\"item in vm.plansall\" md-no-cache=\"vm.noCache\" \nautocomplete=\"off\" md-item-text=\"item.display\" md-min-length=\"0\" placeholder=\"学习计划\" id=\"plans-auto\"><md-item-template>\n<span md-highlight-text=\"vm.searchText\">{{item.display}}</span></md-item-template><md-not-found>没有您输入的教学计划信息\n</md-not-found></md-autocomplete></md-input-container></div><div layout-xs=\"column\" layout=\"row\" \nstyle=\"padding-bottom:20px\"><div flex=\"100\" layout=\"column\"><div><fieldset class=\"standard\"><legend>课程分类</legend><div \nlayout=\"row\" layout-wrap=\"\" flex=\"\"><div flex=\"{{vm.countFlexSize(vm.course_categorys.length)}}\" \nng-repeat=\"item in vm.course_categorys\" \nstyle=\"{{$index == vm.course_categorys.length-1?\'\':\'padding-left: 5px;border-right-style: dotted;\'}} padding-left: 10px\">\n<md-checkbox ng-model=\"vm.contract.ContractsHasCourses[item.id].course_category_checkbox\" \nng-checked=\"vm.contractOptionsExists(item)\" ng-click=\"vm.contractOptionsToggle(item)\" style=\"margin: 10px 0 10px\"><span\n style=\"color: #333333\" ng-class=\"{\'text-strike md-secondary-text\':checkItem.checked}\">{{item.name}}</span>\n</md-checkbox><br><input style=\"width:90%\" class=\"input-bottom-border\" type=\"text\" \nng-model=\"vm.contract.ContractsHasCourses[item.id].course_number\" placeholder=\"请输入课程数\"></div></div></fieldset></div>\n</div></div><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"20\"><label translate=\"卡类型\">\n卡类型</label><md-select ng-model=\"vm.contract.card_type\" required><md-option value=\"{{card_type.name}}\" \nng-repeat=\"card_type in vm.card_types\">{{card_type.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"20\"><label translate=\"卡项\">卡项</label><md-select \nng-model=\"vm.contract.contract_type\" required><md-option value=\"{{type.name}}\" ng-repeat=\"type in vm.contract_types\">\n{{type.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"20\"><label>\n可请假次数(15天/次)</label><input name=\"can_leave_times\" ng-model=\"vm.contract.can_leave_times\" required><div \nng-messages=\"wizardStep3.can_leave_times.$error\" ng-show=\"wizardStep3.can_leave_times.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>可请假次数必填</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"20\"><label translate=\"支付类型\">支付类型</label><md-select ng-model=\"vm.contract.pay_type\" required><md-option \nvalue=\"{{type.name}}\" ng-repeat=\"type in vm.pay_types\">{{type.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"20\"><label translate=\"金额\">金额</label><input name=\"amount\" \nng-model=\"vm.contract.amount\" required><div ng-messages=\"wizardStep3.amount.$error\" \nng-show=\"wizardStep3.amount.$touched\" role=\"alert\"><div ng-message=\"required\"><span>金额必填</span></div></div>\n</md-input-container></div><div layout-xs=\"column\" layout=\"row\"><div flex=\"25\" class=\"date-container\"><label \ntranslate=\"签订日期\">合同签订日期</label><md-datepicker flex md-placeholder=\"签订日期\" \nng-init=\"sign_date = vm.StrToDate(vm.contract.sign_date);\" ng-model=\"sign_date\" \nng-change=\"vm.contract.sign_date = vm.DateToStr(sign_date)\" ng-model-options=\"{timezone:\'utc\'}\">{{sign_date}}\n</md-datepicker></div><div flex=\"25\" class=\"date-container\"><label translate=\"开始日期\">合同生效开始日期</label><md-datepicker \nflex md-placeholder=\"生效开始日期\" ng-init=\"start_date = vm.StrToDate(vm.contract.start_date);\" ng-model=\"start_date\" \nng-change=\"vm.contract.start_date = vm.DateToStr(start_date)\" ng-model-options=\"{timezone:\'utc\'}\">{{start_date}}\n</md-datepicker></div><div flex=\"25\" class=\"date-container\"><label translate=\"结束日期\">合同生效结束日期</label><md-datepicker \nflex md-placeholder=\"生效结束日期\" ng-init=\"end_date = vm.StrToDate(vm.contract.end_date);\" ng-model=\"end_date\" \nng-change=\"vm.contract.end_date = vm.DateToStr(end_date)\" ng-model-options=\"{timezone:\'utc\'}\">{{end_date}}\n</md-datepicker></div><md-input-container class=\"md-block\" flex=\"25\"><label translate=\"状态\">状态</label><md-select \nng-model=\"vm.contract.status\"><md-option value=\"{{item.id}}\" ng-repeat=\"item in vm.contracts_status\">{{item.name}}\n</md-option></md-select></md-input-container></div><div layout-xs=\"column\" layout=\"row\"></div><div layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"100\"><label translate=\"备注\">备注</label><textarea remarks=\"contractRemarks\" \nng-model=\"vm.contract.remarks\" md-maxlength=\"150\" max-rows=\"5\"></textarea></md-input-container></div></form>\n</md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\" ng-disabled=\"msWizard.isFirstStep()\">上一步</md-button><div\n class=\"steps\"><span ng-repeat=\"form in msWizard.forms\" \nng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span></div><md-button \nclass=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\" ng-hide=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.currentStepInvalid()\">下一步</md-button><md-button class=\"md-raised md-warn\" \nng-click=\"vm.sendForm(msWizard); \" ng-show=\"msWizard.isLastStep()\" \nng-disabled=\"msWizard.formsIncomplete()||vm.sending\">提交</md-button></div></ms-form-wizard></div></div></div>");
$templateCache.put("app/main/apps/store/customers/customer-detail.html","<div id=\"dashboard-server\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"35\" flex-gt-md=\"35\"><md-card id=\"baby-info\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div \nclass=\"user-info\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\">\n<img class=\"profile-image avatar huge\" ng-src=\"{{vm.customer.avatar}}?imageView/2/w/64/h/64\"><div class=\"name\">\n{{vm.customer.name}}</div><span class=\"sex\">（{{vm.customer.sex_text}}）</span></div></div><md-card-content><p>会员号: \n<span>{{vm.customer.member_id}}</span></p><p>昵称: <span>{{vm.customer.nickname}}</span></p><p>Skype: <span>\n{{vm.customer.skype?vm.customer.skype:\"无\"}}</span>&nbsp;&nbsp; Email: <span>{{vm.customer.email?vm.customer.email:\"无\"}}\n</span></p><p>生日: <span>{{vm.customer.birthday}}</span> &nbsp;&nbsp;&nbsp; 年级: <span>{{vm.customer.class}}</span></p><p\n ng-repeat=\"parent in vm.parents\" ng-click=\"vm.setMainContactor($event, parent)\">{{parent.relation}}：<span><a>\n{{parent.name}}</a></span>&nbsp;<span style=\"font-size: 12px\">({{parent.mobile}})&nbsp;&nbsp;({{parent.username}})\n</span><md-icon ng-if=\"vm.customer.main_contactor==parent.id\" md-font-icon class=\"icon-checkbox-marked-circle\" \nstyle=\"color: #4CAF50;font-size: 16px;width: 16px;height: 16px;min-width: 16px;min-height: 16px;line-height: 16px\" \nclass=\"icon status s16\"></md-icon></p><div class=\"pt-8\" layout=\"column\" layout-align=\"center\"><div layout=\"row\" \nlayout-wrap><div flex=\"33\" layout-align=\"start center\" class=\"ng-scope layout-align-start-center\"><md-button \nclass=\"md-primary md-raised\" ng-click=\"vm.openCustomerDialog($event, vm.customer)\" \nstyle=\"min-width: 110px;width: 110px\">修改学生</md-button></div><div flex=\"33\" layout-align=\"start center\" \nclass=\"ng-scope layout-align-start-center\"><md-button class=\"md-primary md-raised\" \nui-sref=\"app.store.customers.addparents({id:vm.customer.id})\" style=\"min-width: 110px;width: 110px\">\n{{vm.is_parents_new ? \'添加\' : \'修改\'}}联系人</md-button></div><div flex=\"33\" layout-align=\"start center\" \nclass=\"ng-scope layout-align-start-center\"><a class=\"md-primary md-raised\" \nhref=\"/store/courses/task/{{vm.customer.id}}\" style=\"min-width: 110px;width: 110px\"><md-button \nclass=\"md-primary md-raised\" style=\"min-width: 100px;width: 100px\">排课</md-button></a></div></div></div>\n</md-card-content></md-card></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" flex-gt-xs=\"65\" \nflex-gt-md=\"65\"><ms-widget-front id=\"con-info\" class=\"white-bg\" ng-repeat=\"contract in vm.contracts\"><div class=\"p-16\" \nlayout=\"row\" layout-align=\"space-between center\"><div><div class=\"h3 mb-5\">合同信息 <a \nhref=\"/store/contract/detail/{{contract.id}}\">\n[{{contract.contact_guid}} {{contract.plan_title?\" - \"+contract.plan_title:\"\"}}]</a></div><span>销售人员：<span>\n{{contract.consult_name}}</span></span></div><div class=\"text-boxed green-bg white-fg m-0\">\n&nbsp;{{contract.status_name}}&nbsp;</div></div><div class=\"ph-16 pt-8\"><div layout=\"row\" layout-wrap><div flex=\"50\" \nlayout-align=\"start center\" class=\"ng-scope layout-align-start-center\"><div class=\"h-10 w-10 mr-8 md-green-600-bg\" \nng-class=\"\"></div><span class=\"title ng-binding\">合同开始时间: {{contract.start_date}}</span></div><div flex \nlayout-align=\"start center\" class=\"ng-scope layout-align-start-center\"><div class=\"h-10 w-10 mr-8 md-orange-800-bg\" \nng-class=\"\"></div><span class=\"title ng-binding\">合同结束时间: {{contract.end_date}}</span></div></div></div><div \nclass=\"widget-group ph-8 pb-8 pt-8\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" \nflex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"33\"><ms-widget-front class=\"p-16 pink-400-bg white-fg\"><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"h3\">剩余/可请假\n</div></div></div><div class=\"\" layout=\"row\" layout-align=\"start center\"><div class=\"h2\">{{vm.customer.qingjia}}次</div>\n<div class=\"h2 secondary-text pl-8\">/{{contract.can_leave_times}}次</div></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"33\" \nng-repeat=\"item in contract.ContractsHasCourses\"><ms-widget-front class=\"p-16 teal-400-bg white-fg\"><div class=\"pb-24\" \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><div class=\"h3\">\n{{item.categories_name}}</div></div></div><div class=\"\" layout=\"row\" layout-align=\"start center\"><div class=\"h2\">\n{{item.course_number_remaining}}节</div><div class=\"h2 secondary-text pl-8\">/ {{item.course_number}}节</div></div>\n</ms-widget-front></ms-widget></div><div class=\"p-16\" layout=\"row\" layout-align=\"space-between center\"><a \nclass=\"md-primary md-raised\" href=\"/store/courses/task/{{vm.customer.id}}/{{contract.id}}\" \nstyle=\"min-width: 110px;width: 110px\"><md-button class=\"md-primary md-raised\" style=\"min-width: 100px;width: 100px\">\n合同排课</md-button></a></div></ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget class=\"left-box\" flippable=\"false\" flex=\"100\" flex-gt-xs=\"35\" flex-gt-md=\"35\"><ms-widget-front \nid=\"baby-actions\" class=\"white-bg\" ng-if=\"false\"><div class=\"h3 p-16\">Actions</div><div class=\"pt-8 pb-16 ph-16\" \nlayout=\"column\" layout-align=\"center\"><md-button class=\"md-primary md-raised\" \nng-click=\"vm.openCustomerDialog($event, vm.customer)\">编辑信息</md-button></div></ms-widget-front><ms-widget-front \nid=\"baby-jineng\" class=\"white-bg\" style=\"display:none\"><div class=\"h3 p-16\">技能</div><div class=\"pb-16\" layout=\"column\" \nlayout-align=\"center\"><div class=\"ph-16 pb-20 pt-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"column\" flex><span class=\"h4 pb-10\">基础能力</span><md-progress-linear class=\"md-accent\" md-mode=\"determinate\" \nvalue=\"{{vm.customer.rate.jichu*20}}\"></md-progress-linear></div><div class=\"pl-32 h3 font-weight-500 secondary-text\">\n{{vm.customer.rate.jichu}}</div></div><div class=\"ph-16 pb-20 pt-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" flex><span class=\"h4 pb-10\">蹬脚和划手</span><md-progress-linear \nclass=\"md-accent\" md-mode=\"determinate\" value=\"{{vm.customer.rate.djhs*20}}\"></md-progress-linear></div><div \nclass=\"pl-32 h3 font-weight-500 secondary-text\">{{vm.customer.rate.djhs}}</div></div><div \nclass=\"ph-16 pb-20 pt-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" flex><span\n class=\"h4 pb-10\">闭气反射</span><md-progress-linear class=\"md-accent\" md-mode=\"determinate\" \nvalue=\"{{vm.customer.rate.bqfs*20}}\"></md-progress-linear></div><div class=\"pl-32 h3 font-weight-500 secondary-text\">\n{{vm.customer.rate.bqfs}}</div></div><div class=\"ph-16 pb-20 pt-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" flex><span class=\"h4 pb-10\">潜水</span><md-progress-linear \nclass=\"md-accent\" md-mode=\"determinate\" value=\"{{vm.customer.rate.qs*20}}\"></md-progress-linear></div><div \nclass=\"pl-32 h3 font-weight-500 secondary-text\">{{vm.customer.rate.qs}}</div></div><div \nclass=\"ph-16 pb-20 pt-8 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"column\" flex><span\n class=\"h4 pb-10\">跳水</span><md-progress-linear class=\"md-accent\" md-mode=\"determinate\" \nvalue=\"{{vm.customer.rate.ts*20}}\"></md-progress-linear></div><div class=\"pl-32 h3 font-weight-500 secondary-text\">\n{{vm.customer.rate.ts}}</div></div><div class=\"ph-16 pb-20 pt-8 border-bottom\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"column\" flex><span class=\"h4 pb-10\">社交与环境适应</span><md-progress-linear \nclass=\"md-accent\" md-mode=\"determinate\" value=\"{{vm.customer.rate.sjhjsy*20}}\"></md-progress-linear></div><div \nclass=\"pl-32 h3 font-weight-500 secondary-text\">{{vm.customer.rate.sjhjsy}}</div></div></div></ms-widget-front>\n<ms-widget-front id=\"baby-leida\" class=\"white-bg\" style=\"display:none\"><div class=\"h3 p-16\">技能雷达图</div><div \nclass=\"pt-8 pb-16 ph-16\" layout=\"column\" layout-align=\"center\"><div class=\"card\"><canvas id=\"radar\" \nclass=\"chart chart-radar\" chart-data=\"vm.radarChart.data\" chart-labels=\"vm.radarChart.labels\"></canvas></div></div>\n</ms-widget-front></ms-widget><ms-widget flippable=\"false\" flex=\"100\" flex-gt-xs=\"65\" flex-gt-md=\"65\"><ms-widget-front \nid=\"course-info\" class=\"white-bg\"><div ng-cloak><md-content><md-tabs md-dynamic-height md-border-bottom><md-tab \nlabel=\"课程\"><md-content class=\"md-padding\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\">\n<md-select class=\"simplified\" ng-model=\"vm.selectedPlanFilter\" placeholder=\"教学计划\" ng-change=\"vm.doStatusSearch()\">\n<md-option value=\"\">全部</md-option><md-option ng-repeat=\"pItem in vm.contractPlans\" value=\"{{pItem.id}}\">{{pItem.title}}\n</md-option></md-select><md-select class=\"simplified\" ng-model=\"vm.orderBy\" placeholder=\"课程时间排序\" \nng-change=\"vm.doStatusSearch()\"><md-option value=\"+course_time\">顺序</md-option><md-option value=\"course_time\">倒序\n</md-option></md-select><div layout=\"row\" layout-align=\"start center\"><md-select class=\"simplified\" \nng-model=\"vm.selectedCourseStatus\" placeholder=\"课程状态\" ng-change=\"vm.doStatusSearch()\"><md-option value=\"-1\">全部\n</md-option><md-option ng-repeat=\"status in vm.signup_status\" value=\"{{status.id}}\">{{status.text}}</md-option>\n</md-select></div></div><div class=\"course-info-page\" ng-repeat=\"(signup_key,signup) in vm.signups.data\"><div \nclass=\"header pt-16 pb-16\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><div><img class=\"avatar mr-8\" \nng-src=\"{{signup.course.teacher_avatar}}?imageView/1/w/128/h/128\" alt=\"\"></div><div class=\"info\"><div class=\"title h3\" \nng-if=\"signup.course.plan\">{{signup.course.plan}}</div><div class=\"title h3\"><a \nhref=\"/store/courses/detail/{{signup.course.id}}\">{{signup.course.name}}</a>\n&nbsp;&nbsp;({{signup.course.categories_name}})</div><div class=\"subtitle secondary-text\">\n{{signup.course.course_time | date:\"yyyy-MM-dd EEEE\"}} {{signup.course.course_begintime}} ~ {{signup.course.course_endtime}}\n</div></div></div><div layout=\"row\" layout-align=\"start\">{{signup.status_text}}</div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item ng-if=\"vm.is_cud\"><div \nng-file-select=\"vm.onFileSelect($files, signup.course.id, signup_key)\" data-multiple=\"true\" title=\"选择图片文件\" \nonclick=\"this.value = null\" aria-label=\"Flip widget\">上传照片</div></md-menu-item><md-menu-item ng-if=\"signup.status==0\" \nng-show=\"vm.is_signup\"><md-button ng-click=\"vm.updateStatus(signup,1)\" aria-label=\"Refresh widget\">批准</md-button>\n</md-menu-item><md-menu-item ng-if=\"signup.status==0\" ng-show=\"vm.is_signup\"><md-button \nng-click=\"vm.updateStatus(signup,2)\" aria-label=\"Refresh widget\">拒绝</md-button></md-menu-item><md-menu-item \nng-if=\"signup.status==2\" ng-show=\"vm.is_signup\"><md-button ng-click=\"vm.updateStatus(signup,1)\" \naria-label=\"Refresh widget\">重新批准</md-button></md-menu-item><md-menu-item ng-if=\"signup.status==1\" \nng-show=\"vm.is_signup\"><md-button ng-click=\"vm.updateStatus(signup,4)\" aria-label=\"Refresh widget\">签到</md-button>\n</md-menu-item><md-menu-item ng-if=\"signup.status==1\" ng-show=\"vm.is_signup\"><md-button \nng-click=\"vm.updateStatus(signup,5)\" aria-label=\"Refresh widget\">旷课</md-button></md-menu-item></md-menu-content>\n</md-menu></div><div class=\"media photo-lie pl-48 pr-16 pb-8\" style=\"display:none\"><div layout=\"row\" flex=\"100\" \nlayout-wrap><div flippable=\"false\" flex=\"100\" flex-gt-xs=\"33\" flex-gt-md=\"25\" \nng-repeat=\"image in signup.course.images\"><img class=\"image\" ng-src=\"{{image.url}}?imageView/1/w/300/h/185\" alt=\"\">\n</div></div></div><div layout=\"row\" layout-align=\"start center\" class=\"course-wen pl-48\"><div \nclass=\"coach-button mr-30\"><div layout=\"row\" layout-align=\"start center\"><span>老师：</span>&nbsp;<span>\n{{signup.course.teacher_name}}</span></div></div><div class=\"assistant-button mr-30\"><div layout=\"row\" \nlayout-align=\"start center\"><span>助理：</span>&nbsp;<span>{{signup.course.assistant_name}}</span></div></div></div><div \nlayout=\"row\" class=\"course-pingfen pl-48 pt-16 pb-16\" ng-if=\"!signup.rate\"></div><div layout=\"row\" \nclass=\"course-pingfen pl-48 pt-16 pb-16\" ng-if=\"signup.rate\" style=\"display:none\"><div class=\"score-button mr-45\"><div \nlayout=\"row\" layout-align=\"start center\"><span>基础能力：</span>&nbsp;<span>{{signup.rate.jichu}}分</span></div></div><div \nclass=\"score-button mr-45\"><div layout=\"row\" layout-align=\"start center\"><span>蹬脚和划手：</span>&nbsp;<span>\n{{signup.rate.djhs}}分</span></div></div><div class=\"score-button mr-45\"><div layout=\"row\" layout-align=\"start center\">\n<span>闭气反射：</span>&nbsp;<span>{{signup.rate.bqfs}}分</span></div></div><div class=\"score-button mr-45\"><div \nlayout=\"row\" layout-align=\"start center\"><span>潜水：</span>&nbsp;<span>{{signup.rate.qs}}分</span></div></div><div \nclass=\"score-button mr-45\"><div layout=\"row\" layout-align=\"start center\"><span>跳水：</span>&nbsp;<span>\n{{signup.rate.ts}}分</span></div></div><div class=\"score-button mr-45\"><div layout=\"row\" layout-align=\"start center\">\n<span>社交与环境适应：</span>&nbsp;<span>{{signup.rate.sjhjsy}}分</span></div></div></div><md-divider class=\"ml-45 mr-15\" \nng-if=\"signup.rate.user\"></md-divider><div class=\"text coach-text p-16 pl-48\" ng-if=\"signup.rate.user\" \nstyle=\"display:none\"><div class=\"comment\" layout=\"row\"><img class=\"avatar mr-8\" \nng-src=\"{{signup.rate.user.avatar}}?imageView/2/w/64/h/64\" alt=\"\"><div flex layout=\"column\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"username h3 mr-5\">{{signup.rate.user.name}}</div><span class=\"time\">\n{{signup.rate.created_at}}</span></div><div class=\"message mt-5\">{{signup.rate.remark}}</div></div></div></div>\n<md-divider class=\"ml-45 mr-15\" ng-if=\"signup.parent\"></md-divider><div class=\"text parents-text p-16 pl-48\" \nng-if=\"signup.parent\" style=\"display:none\"><div class=\"comment\" layout=\"row\"><img class=\"avatar mr-8\" \nng-src=\"{{vm.customer.avatar}}?imageView/2/w/64/h/64\" alt=\"\"><div flex layout=\"column\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"username h3 mr-5\">{{vm.customer.name}}的{{signup.parent.relation}}</div><span \nclass=\"time\">{{signup.parent_time}}</span></div><div class=\"message mt-5\">{{signup.parent_remark}}</div></div></div>\n</div></div></md-content><md-table-pagination md-limit=\"vm.query1.limit\" md-page-select md-page=\"vm.query1.page\" \nmd-total=\"{{vm.signups._meta.totalCount}}\" md-on-paginate=\"vm.doStatusSearch\"></md-table-pagination></md-tab>\n<md-table-pagination md-limit=\"vm.query2.limit\" md-page-select md-page=\"vm.query2.page\" \nmd-total=\"{{vm.images._meta.totalCount}}\" md-on-paginate=\"vm.doSearch2\"></md-table-pagination></md-tabs></md-content>\n</div></ms-widget-front></ms-widget></div></div><style type=\"text/css\">\n.status-txt-color{\r\n        color: #333;\r\n    }\r\n    .status-txt-color1{\r\n        color: #059ee8;\r\n    }</style>");
$templateCache.put("app/main/apps/store/customers/customer-parents.html","<div id=\"customer-wizard\" class=\"page-layout simple fullwidth\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\" ng-show=\"false\"><div layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" \nstyle=\"margin-bottom:12px!important\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">学生管理</span></div><div \nclass=\"title\" style=\"font-size: 24px!important\">学生联系人</div></div></div><div class=\"content\"><div layout=\"row\">\n<ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\"><md-tab \nng2-disabled=\"wizardStep1.$invalid\"><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-text\">联系人</span></span></md-tab-label><md-tab-body><form name=\"wizardStep2\" \nms-form-wizard-form novalidate><md-card md-theme=\"default\" md-theme-watch ng-repeat=\"parent in vm.parents\">\n<md-card-title><md-select ng-model=\"parent.relation\" flex=\"100\" ng-disabled=\"parent.was\"><md-option value=\"爸爸\">爸爸\n</md-option><md-option value=\"妈妈\">妈妈</md-option><md-option value=\"MOXO\">MOXO</md-option></md-select></md-card-title>\n<md-card-content layout=\"column\" layout-align=\"space-between\"><div layout=\"row\"><md-input-container class=\"md-block\" \nflex=\"30\"><label translate=\"手机号\">手机号</label><input name=\"mobile[{{$index}}]\" ng-model=\"parent.mobile\" \nng-blur=\"vm.mobileChanged(parent.mobile,$index)\" required md-autofocus><div \nng-messages=\"wizardStep2.mobile[$index].$error\" ng-show=\"wizardStep2.mobile[$index].$touched\" role=\"alert\"><div \nng-message=\"required\"><span>手机号必填</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"30\"><label translate=\"登录账号\">登录账号</label><input name=\"username[{{$index}}]\" ng-model=\"parent.username\" required \nng-disabled=\"parent.was\"><div ng-messages=\"wizardStep2.username[$index].$error\" \nng-show=\"wizardStep2.username[$index].$touched\" role=\"alert\"><div ng-message=\"required\"><span>登录账号必填</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"姓名\">姓名</label><input \nname=\"name[{{$index}}]\" ng-model=\"parent.name\" required ng-disabled=\"parent.was\"><div \nng-messages=\"wizardStep2.name[$index].$error\" ng-show=\"wizardStep2.name[$index].$touched\" role=\"alert\"><div \nng-message=\"required\"><span>姓名必填</span></div></div></md-input-container></div><div layout=\"row\"><md-input-container \nclass=\"md-block\" flex=\"30\"><label translate=\"邮箱\">邮箱</label><input name=\"email[{{$index}}]\" ng-model=\"parent.email\" \nng-disabled=\"parent.was\"><div ng-messages=\"wizardStep2.email[$index].$error\" \nng-show=\"wizardStep2.email[$index].$touched\" role=\"alert\"><div ng-message=\"required\"><span>邮箱必填</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"微信号\">微信号</label><input \nname=\"wechat[{{$index}}]\" ng-model=\"parent.wechat\" ng-disabled=\"parent.was\"><div \nng-messages=\"wizardStep2.wechat[$index].$error\" ng-show=\"wizardStep2.wechat[$index].$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"TODO.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"QQ号\">QQ号</label><input \nname=\"qq[{{$index}}]\" ng-model=\"parent.qq\" ng-disabled=\"parent.was\"><div ng-messages=\"wizardStep2.qq[$index].$error\" \nng-show=\"wizardStep2.qq[$index].$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TODO.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container></div>\n</md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button ng-click=\"vm.addOtherRelation();\" \nng-show=\"vm.parents.length!=100\">添加另一个</md-button><md-button ng-click=\"vm.removeOtherRelation(parent.id,$index);\">删除联系人\n</md-button></md-card-actions></md-card></form></md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm(msWizard); \" \nng-show=\"msWizard.isLastStep()\" ng-disabled=\"msWizard.formsIncomplete()||vm.sending\">提交</md-button></div>\n</ms-form-wizard></div></div></div>");
$templateCache.put("app/main/apps/store/customers/customers.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">学生管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">学生列表</div></div>\n<div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label><md-icon md-font-icon=\"icon-magnify\">\n</md-icon></label><md-input-container md-no-float class=\"m-0\"><input placeholder=\"Search for anyone\" type=\"text\" \nng-model=\"vm.query.member_id\" translate ng-change=\"vm.doSearch()\" translate-attr-placeholder=\"会员号\">\n</md-input-container><md-input-container md-no-float class=\"m-0\"><input id=\"search-name\" \nplaceholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.query.name\" translate ng-change=\"vm.doSearch()\" \ntranslate-attr-placeholder=\"姓名\"></md-input-container><md-input-container md-no-float class=\"m-0\"><label translate=\"性别\">\n性别</label><md-select ng-model=\"vm.query.sex\" ng-change=\"vm.doSearch()\"><md-option ng-repeat=\"sex in vm.sexs\" \nvalue=\"{{sex.id}}\">{{sex.name}}</md-option></md-select></md-input-container><md-input-container md-no-float \nclass=\"m-0\"><label translate=\"课程顾问\">课程顾问</label><md-select ng-model=\"vm.query.consult_id\" ng-change=\"vm.doSearch()\">\n<md-option ng-repeat=\"user in vm.users\" value=\"{{user.id}}\">{{user.name}}</md-option></md-select></md-input-container>\n</div></div><div class=\"content white-bg\"><md-table-container><table md-table class=\"md-data-table\"><thead md-head \nmd-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row><th md-column decend-first \nstyle=\"padding-left: 15px!important\"><span class=\"column-title\">头象</span></th><th md-column md-order-by=\"member_id\" \ndecend-first><span class=\"column-title\">会员号<br>姓名</span></th><th md-column md-order-by=\"birthday\"><span \nclass=\"column-title\">生日</span></th><th md-column md-order-by=\"sex\"><span class=\"column-title\">性别<br>手机号</span></th><th \nmd-column md-order-by=\"sex\"><span class=\"column-title\">Skype<br>邮箱</span></th><th md-column md-order-by=\"class\"><span \nclass=\"column-title\">年级</span></th><th md-column md-order-by=\"main_contactor_id\"><span class=\"column-title\">主联系人<br>\n登录账号</span></th><th md-column md-order-by=\"consult_id\"><span class=\"column-title\">课程顾问</span></th><th md-column \nmd-order-by=\"updated_at\" decend-first><span class=\"column-title\">更新时间</span></th><th md-column decend-first></th></tr>\n</thead><tbody><tr ng-repeat=\"customer in vm.customers.data\" ui-sref=\"app.store.customers.detail({id:customer.id})\" \nclass=\"pointer\"><td md-cell><img class=\"md-avatar avatar contact-avatar\" ng-if=\"customer.avatar\" \nalt=\"{{customer.name}}\" ng-src=\"{{ customer.avatar }}?imageView/2/w/64/h/64\"></td><td md-cell>{{ customer.member_id }}\n<br>{{ customer.name }}<span ng-if=\"customer.nickname \">({{ customer.nickname }})</span></td><td md-cell>\n{{customer.birthday}}</td><td md-cell>{{ customer.sex_text }}<br>{{ customer.main_contactor_mobile }}</td><td md-cell>\n{{ customer.skype }}<br>{{ customer.email }}</td><td md-cell>{{ customer.class }}</td><td md-cell>\n{{ customer.main_contactor_name }}<br>{{ customer.main_contactor_username }}</td><td md-cell>\n{{ customer.consult_name }}</td><td md-cell>{{ customer.update_time }}</td><td md-cell \nstyle=\"padding: 0px 10px 0px 0px!important\"><a ng-if=\"vm.is_cud\" ng-show=\"customer.status=1\" \nng-click=\"vm.openCustomerDialog($event, customer)\">修改</a> <a ng-click=\"vm.addparents($event, customer.id)\">+联系人</a> <a \nng-click=\"vm.openZcardDialog($event, customer)\" ng-show=\"vm.is_cud\">转店</a> <a \nng-click=\"vm.openGudin($event, customer)\" ng-show=\"vm.is_cud\">固定课</a><br></td></tr></tbody></table>\n</md-table-container></div><div layout=\"row\" layout-align=\"space-between center\" class=\"footer white-bg\">\n<md-table-pagination md-limit=\"vm.query.limit\" md-page-select md-page=\"vm.query.page\" \nmd-total=\"{{vm.customers._meta.totalCount}}\" md-on-paginate=\"vm.doSearch\"></md-table-pagination><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-if=\"vm.is_cud\" class=\"md-fab md-mini md-accent md-icon-button mv-25\" \nid=\"add-contact-button\" ng-click=\"vm.openCustomerDialog($event)\" aria-label=\"add contact\" translate \ntranslate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></div>\n</div></div><style>\n.md-data-table td{\n        padding: 10px 0px 10px 0px!important;\n    }\n    .md-data-table th{\n        padding: 10px 0px 10px 0px!important;\n    }\n    md-input-container .md-errors-spacer{\n        min-height: 0px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/customers/parents.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">学生管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">联系人列表</div></div>\n<div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"登录账号\" type=\"text\" ng-model=\"vm.query.username\" translate ng-change=\"vm.doSearch()\" \ntranslate-attr-placeholder=\"登录账号\"></md-input-container><md-input-container md-no-float class=\"m-0\"><input \nplaceholder=\"姓名\" type=\"text\" ng-model=\"vm.query.name\" translate ng-change=\"vm.doSearch()\" \ntranslate-attr-placeholder=\"姓名\"></md-input-container><md-input-container md-no-float class=\"m-0\"><input \nplaceholder=\"手机号\" type=\"text\" ng-model=\"vm.query.mobile\" translate ng-change=\"vm.doSearch()\" \ntranslate-attr-placeholder=\"手机号\"></md-input-container></div></div><div class=\"content white-bg\"><md-table-container>\n<table md-table class=\"md-data-table\"><thead md-head md-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row>\n<th md-column decend-first><span class=\"column-title\"></span></th><th md-column md-order-by=\"username\" decend-first>\n<span class=\"column-title\">登录账号</span></th><th md-column md-order-by=\"name\" decend-first><span class=\"column-title\">姓名\n</span></th><th md-column md-order-by=\"mobile\" decend-first><span class=\"column-title\">手机号</span></th><th md-column \nmd-order-by=\"email\" decend-first><span class=\"column-title\">邮箱</span></th><th md-column md-order-by=\"relation\" \ndecend-first><span class=\"column-title\">关系</span></th><th md-column md-order-by=\"qq\" decend-first><span \nclass=\"column-title\">QQ</span></th><th md-column decend-first></th></tr></thead><tbody><tr \nng-repeat=\"parent in vm.parents.data\"><td><img class=\"md-avatar\" \nng-src=\"{{ parent.media.image.src }}?imageView/2/w/64/h/64\"></td><td md-cell>{{ parent.username }}</td><td md-cell>\n{{ parent.name }}</td><td md-cell>{{ parent.mobile }}</td><td md-cell>{{ parent.email }}</td><td md-cell>\n{{ parent.relation }}</td><td md-cell>{{ parent.qq }}</td><td md-cell><a ng-if=\"vm.is_cud\" \nng-click=\"vm.openParentDialog($event, parent)\">修改</a> <a ng-if=\"vm.is_cud\" \nng-click=\"vm.resetpwdParent($event, parent)\">重置密码</a> <a ng-if=\"parent.is_wechat\" \nng-click=\"vm.openWechatDialog($event, parent)\">绑定的微信</a></td></tr></tbody></table></md-table-container></div><div \nlayout=\"row\" layout-align=\"space-between center\" class=\"footer white-bg\"><md-table-pagination \nmd-limit=\"vm.query.limit\" md-page-select md-page=\"vm.query.page\" md-total=\"{{vm.parents._meta.totalCount}}\" \nmd-on-paginate=\"vm.doSearch\"></md-table-pagination></div></div><style>\n.md-data-table td{\n        padding: 10px 0px 10px 0px!important;\n    }\n    .md-data-table th{\n        padding: 10px 0px 10px 0px!important;\n    }\n    md-input-container .md-errors-spacer{\n        min-height: 0px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/dashboard/dashboard.html","<div id=\"dashboard-store\" class=\"page-layout simple right-sidenav ng-scope layout-row\" layout=\"row\"><div \nclass=\"center\" flex ms-scroll><div class=\"header md-accent-bg\" layout=\"column\" layout-align=\"space-between\"><div \nlayout=\"row\" layout-align=\"space-between\"><div class=\"layout-align-start-center layout-row\"><span class=\"pagetit-icon\">\n<md-icon md-font-icon=\"icon-store\" class=\"s24 md-default-theme md-font material-icons icon-store\" aria-hidden=\"true\">\n</md-icon></span><span class=\"pagetit-text\">{{vm.store_name}}</span></div></div></div><div class=\"content\"><div \nclass=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget ng-if=\"vm.is_amount\" flippable=\"true\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">今日营业额</div><div \nclass=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.amount_list.currentRange\" aria-label=\"Change range\"><md-option\n ng-repeat=\"(key, range) in vm.amount_list.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div><md-menu \nstyle=\"display: none\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"></md-button>\n<md-menu-content width=\"2\"><md-menu-item><md-button ng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh\n</md-button></md-menu-item></md-menu-content></md-menu></div><div class=\"pt-8 pb-32\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"red-fg font-size-50 line-height-72\">{{vm.data.amount}}</div><div \nclass=\"h3 secondary-text font-weight-500\">营业额</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">今日体验营业额:</span> <span class=\"h4 ml-8\">\n{{vm.data.task_amount}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div class=\"flip-to-front\">\n<md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" \nclass=\"s16\"></md-icon></md-button></div><div></div></ms-widget-back></ms-widget><ms-widget ng-if=\"vm.is_new_member\" \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div \nclass=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">今日消课额</div><md-menu>\n<md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\"></md-button><md-menu-content width=\"2\">\n<md-menu-item><md-button aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"orange-fg font-size-50 line-height-72\">\n{{vm.data.xk_amount}}</div><div class=\"h3 secondary-text font-weight-500\">消课额</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\"></span> <span class=\"h4 ml-8\"></span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div></div>\n</ms-widget-back></ms-widget><ms-widget ng-if=\"vm.is_new_member\" flippable=\"true\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"25\" flex-gt-md=\"25\"><ms-widget-front class=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"h3\">上周新增会员</div><md-menu><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu()\" aria-label=\"more\"></md-button><md-menu-content width=\"2\"><md-menu-item><md-button \nng-click=\"flipWidget()\" aria-label=\"Flip widget\">Details</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"refreshWidget()\" aria-label=\"Refresh widget\">Refresh</md-button></md-menu-item></md-menu-content></md-menu>\n</div><div class=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div \nclass=\"orange-fg font-size-50 line-height-72\">{{vm.data.new_customer_count}}</div><div \nclass=\"h3 secondary-text font-weight-500\">数量</div></div><div class=\"p-16 grey-50-bg border-top\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"h4 secondary-text text-truncate\">会员总数:</span> <span class=\"h4 ml-8\">\n{{vm.data.all_customer_count}}</span></div></ms-widget-front><ms-widget-back class=\"p-16 white-bg\"><div \nclass=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" aria-label=\"Flip widget\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div></div></ms-widget-back></ms-widget><ms-widget \nng-if=\"vm.is_birthday\" flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"25\" flex-gt-md=\"25\"><ms-widget-front \nclass=\"white-bg\"><div class=\"pl-16 pr-8 pv-16 h-55\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">\n过生日的学生</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.birthday_count.currentRange\" \nng-change=\"vm.birthdayCountChanage()\" aria-label=\"Change range\"><md-option \nng-repeat=\"(key, range) in vm.birthday_count.ranges\" value=\"{{key}}\">{{range}}</md-option></md-select></div></div><div \nclass=\"pt-8 pb-32\" layout=\"column\" layout-align=\"center center\"><div class=\"blue-grey-fg font-size-50 line-height-72\">\n{{vm.data.customer_count}}</div><div class=\"h3 secondary-text font-weight-500\">学生数量</div></div><div \nclass=\"p-16 grey-50-bg border-top\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"h4 secondary-text text-truncate\"></span> <span class=\"h4 ml-8\"></span></div></ms-widget-front><ms-widget-back \nclass=\"p-16 white-bg\"><div class=\"flip-to-front\"><md-button class=\"md-icon-button\" ng-click=\"flipWidget()\" \naria-label=\"Flip widget\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div><div></div>\n</ms-widget-back></ms-widget></div><div ng-if=\"vm.is_course\" class=\"widget-group widget-group-height\" layout=\"row\" \nflex=\"100\" layout-wrap><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget layout=\"column\" flex=\"100\">\n<ms-widget-front class=\"white-bg\"><div class=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\">\n<div class=\"h3\">今日课程</div><div class=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget7.currentRange\" \naria-label=\"Change range\"></md-select></div></div><div class=\"ybox ybox-2\"><md-list flex><md-list-item \nclass=\"md-3-line\" ng-repeat=\"event in vm.data.today_courses\" ng-if=\"vm.data.today_courses.length > 0\" \nui-sref=\"app.store.courses.detail({id:event.id})\"><md-icon md-font-icon=\"icon-book\" \nclass=\"md-default-theme icon-book md-avatar-icon\" aria-hidden=\"true\"></md-icon><div class=\"md-list-item-text\" \nlayout=\"column\"><h3>{{event.plan}} {{event.name}}&nbsp;&nbsp;&nbsp;{{event.teacher_name}}</h3><h4>学生：<span \nng-repeat=\"signup in event.signups\">{{signup}}，</span></h4><h4>时间：{{event.course_begintime}}-{{event.course_endtime}}\n</h4><p><span>地点：{{event.room}}</span><span>预约/预招：{{event.signup_count}}/{{event.course_size}}</span></p></div>\n</md-list-item><md-list-item class=\"md-3-line\" ng-if=\"vm.data.today_courses.length == 0\">暂无数据</md-list-item></md-list>\n</div></ms-widget-front></ms-widget></div><div layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget \nng-if=\"vm.is_expire_member\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">快到期会员</div><div \nclass=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget7.currentRange\" aria-label=\"Change range\"></md-select>\n</div></div><div class=\"ybox\"><md-list flex><md-list-item class=\"md-3-line\" ng-repeat=\"event in vm.data.contracts\" \nng-if=\"vm.data.contracts.length > 0\" ui-sref=\"app.store.contracts.detail({id:event.id})\"><img class=\"md-avatar\" \nalt=\"Min Li Chan\" src=\"{{event.customer.avatar}}\"><div class=\"md-list-item-text\" layout=\"column\"><h3>\n{{ event.customer_name }},{{ event.contact_guid }}</h3><h4>\n合同时间：{{ event.start_date | date:\'yyyy-MM-dd\' }}~{{ event.end_date | date:\'yyyy-MM-dd\' }}</h4><p><span>\n{{ event.card_type }}</span><span>{{ event.contract_type }}</span></p></div></md-list-item><md-list-item \nclass=\"md-3-line\" ng-if=\"vm.data.contracts.length == 0\">暂无数据</md-list-item></md-list></div></ms-widget-front>\n</ms-widget><ms-widget layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">过生日的学生</div><div \nclass=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.birthday.currentRange\" ng-change=\"vm.birthdayChanage()\" \naria-label=\"Change range\"><md-option ng-repeat=\"(key, range) in vm.birthday.ranges\" value=\"{{key}}\">{{range}}\n</md-option></md-select></div></div><div class=\"ybox\"><md-list flex><md-list-item class=\"md-3-line\" \nng-repeat=\"event in vm.data.customers\" ng-if=\"vm.data.customers.length > 0\" \nui-sref=\"app.store.customers.detail({id:event.id})\"><img class=\"md-avatar\" alt=\"Min Li Chan\" src=\"{{event.avatar}}\">\n<div class=\"md-list-item-text\" layout=\"column\"><h3>{{event.name}}<span ng-if=\"event.nickname\">({{event.nickname}})\n</span> {{event.member_id}}</h3><h4>生日：{{event.birthday}}</h4><p>\n信息：{{event.sex == 0 ? \'女\' : \'男\'}}，{{event.pname}} {{event.mobile}}</p></div></md-list-item><md-list-item \nclass=\"md-3-line\" ng-if=\"vm.data.customers.length == 0\">暂无数据</md-list-item></md-list></div></ms-widget-front>\n</ms-widget></div></div><div class=\"widget-group widget-group-height\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nng-if=\"vm.is_task\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\"><ms-widget-front class=\"white-bg\"><div \nclass=\"ph-16 border-bottom\" layout=\"row\" layout-align=\"space-between center\"><div class=\"h3\">今日体验用户</div><div \nclass=\"pv-16\"><md-select class=\"simplified\" ng-model=\"vm.widget7.currentRange\" aria-label=\"Change range\"></md-select>\n</div></div><div class=\"ybox\"><md-list flex><md-list-item class=\"md-3-line\" ng-repeat=\"event in vm.data.tasks\" \nng-if=\"vm.data.tasks.length > 0\" ui-sref=\"app.store.courses.detail({id:event.courses_id})\"><md-icon \nmd-font-icon=\"icon-heart\" class=\"md-default-theme icon-heart md-avatar-icon\" aria-hidden=\"true\"></md-icon><div \nclass=\"md-list-item-text\" layout=\"column\"><h3>{{event.name}}, {{event.sex == 0 ? \'女\' : \'男\'}}</h3><h4>\n联系人：{{event.parent}} {{event.mobile}}</h4><p><span>体验课程：{{event.courses_name}}</span><span>{{event.plan_time}}</span>\n</p></div></md-list-item><md-list-item class=\"md-3-line\" ng-if=\"vm.data.tasks.length == 0\">暂无数据</md-list-item>\n</md-list></div></ms-widget-front></ms-widget></div></div></div></div><style>\n.md-data-table td{\n        padding: 8px 0px 8px 0px!important;\n    }\n    .md-data-table th{\n        padding: 8px 0px 8px 0px!important;\n    }\n</style><script type=\"text/javascript\">\n$(function() {\n        $(\'.ybox\').mouseover(function (event) {\n            event.stopPropagation();\n            <!--$(\'body\').scrollstop();-->\n            <!--$(this).focus();-->\n            <!--});-->\n        });\n    });\n</script>");
$templateCache.put("app/main/apps/store/signups/report.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">报表管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">预约报名列表</div></div>\n<div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label><md-icon md-font-icon=\"icon-magnify\">\n</md-icon></label><md-input-container md-no-float class=\"m-0\"><md-select ng-model=\"vm.query.status\" \nng-change=\"vm.doSearch()\"><md-option ng-repeat=\"item in vm.signup_status\" value=\"{{item.id}}\">{{item.text}}</md-option>\n</md-select></md-input-container><label translate=\"上课时间\">上课时间</label><md-datepicker flex md-placeholder=\"上课时间\" \nng-init=\"vm.query.sdate=vm.StrToDate(vm.query.sdate);\" ng-model=\"vm.query.sdate\" ng-change=\"vm.doSearch()\" \nng-model-options=\"{timezone:\'utc\'}\">{{vm.query.sdate}}</md-datepicker><md-datepicker flex md-placeholder=\"上课时间\" \nng-init=\"vm.query.edate = vm.StrToDate(vm.query.edate);\" ng-model=\"vm.query.edate\" ng-change=\"vm.doSearch()\" \nng-model-options=\"{timezone:\'utc\'}\">{{vm.query.edate}}</md-datepicker></div></div><div class=\"content white-bg\">\n<md-table-container><table md-table class=\"md-data-table\"><thead md-head md-order=\"vm.query.sort\" \nmd-on-reorder=\"vm.doSearch\"><tr md-row><th md-column decend-first style=\"padding-left: 15px!important\"><span \nclass=\"column-title\">上课时间</span></th><th md-column><span class=\"column-title\">课程名称<br>上课地址</span></th><th md-column>\n<span class=\"column-title\">课程类型<br>课程级别</span></th><th md-column><span class=\"column-title\">主老师<br>助教</span></th><th \nmd-column><span class=\"column-title\">预约<br>预招</span></th><th md-column><span class=\"column-title\">学生姓名<br>会员号</span>\n</th><th md-column><span class=\"column-title\">学生生日<br>月龄/性别</span></th><th md-column><span class=\"column-title\">家长信息\n</span></th><th md-column md-order-by=\"status\" decend-first><span class=\"column-title\">预状态</span></th></tr></thead>\n<tbody><tr ng-repeat=\"item in vm.signups.data\"><td md-cell style=\"padding-left: 15px!important\">\n{{ item.course.course_time }}{{ item.week }}<br>{{ item.course.course_begintime }}~{{ item.course.course_endtime }}\n</td><td md-cell><a ui-sref=\"app.store.courses.detail({id:item.courses_id})\">{{ item.course.name }}<br>\n{{ item.course.location }}</a></td><td md-cell>{{ item.course.categories_name }}<br>{{ item.course.type_name }}</td><td\n md-cell>{{ item.course.teacher_name }}<br>{{ item.course.assistant_name }}</td><td md-cell><b style=\"color: #1e8f03\">\n{{ item.course.signup_count }}人</b><br><b style=\"color: #ff0000\">{{ item.course.course_size }}人</b></td><td md-cell><a \nstyle=\"display: block\" ui-sref=\"app.store.customers.detail({id:item.customer_id})\" ng-if=\"item.customer_id\">\n{{item.customer_name}} <span ng-if=\"item.customer_nickname\">({{item.customer_nickname}})</span><br>\n{{item.customer_member_id}} </a><span ng-if=\"!item.customer_id\">{{item.customer_name}}</span></td><td md-cell>\n{{item.customer_birthday}}<br>{{item.customer_birthday_month}}M/{{item.customer_sex}}</td><td md-cell><p \nng-if=\"!item.customer_id\">{{item.parent.relation}} {{item.parent.name}} {{item.parent.mobile}}</p><p \nng-if=\"item.customer_id\" ng-repeat=\"parent in item.parents\">{{parent.relation}} {{parent.name}} <b \nstyle=\"color: #ff0000\">{{parent.mobile}}</b></p></td><td md-cell>{{ item.status_text }}</td></tr></tbody></table>\n</md-table-container></div><div layout=\"row\" layout-align=\"space-between center\" class=\"footer white-bg\">\n<md-table-pagination md-limit=\"vm.query.limit\" md-page-select md-page=\"vm.query.page\" \nmd-total=\"{{vm.signups._meta.totalCount}}\" md-on-paginate=\"vm.doSearch\"></md-table-pagination><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-if=\"vm.is_export\" class=\"md-raised reference-button\" type=\"button\" \nng-click=\"vm.exportSignups($event)\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>导出</span></md-button></div></div>\n</div><style>\n.md-data-table td{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\r\n    .md-data-table th{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/store/signups/signups.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">报表管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">预约报名列表</div></div>\n<div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><md-select \nng-model=\"vm.query.status\" ng-change=\"vm.doSearch()\"><md-option ng-repeat=\"item in vm.signup_status\" \nvalue=\"{{item.id}}\">{{item.text}}</md-option></md-select></md-input-container><label translate=\"上课时间\">上课时间</label>\n<md-datepicker flex md-placeholder=\"签订日期\" ng-init=\"vm.query.sdate=vm.StrToDate(vm.query.sdate);\" \nng-model=\"vm.query.sdate\" ng-change=\"vm.doSearch()\" ng-model-options=\"{timezone:\'utc\'}\">{{vm.query.sdate}}\n</md-datepicker><md-datepicker flex md-placeholder=\"签订日期\" ng-init=\"vm.query.edate = vm.StrToDate(vm.query.edate);\" \nng-model=\"vm.query.edate\" ng-change=\"vm.doSearch()\" ng-model-options=\"{timezone:\'utc\'}\">{{vm.query.edate}}\n</md-datepicker></div></div><div class=\"content white-bg\"><md-table-container><table md-table class=\"md-data-table\">\n<thead md-head md-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row><th md-column decend-first \nstyle=\"padding-left: 15px!important\"><span class=\"column-title\">课程信息</span></th><th md-column \nstyle=\"padding-left: 15px!important\"><span class=\"column-title\">学生姓名<br>会员号</span></th><th md-column><span \nclass=\"column-title\">学生生日<br>月龄/性别</span></th><th md-column><span class=\"column-title\">家长信息</span></th><th md-column \nmd-order-by=\"created_at\"><span class=\"column-title\">约课状态<br>预约时间</span></th><th md-column ng-show=\"vm.is_cud\"><span \nclass=\"column-title\">管理</span></th></tr></thead><tbody><tr ng-repeat=\"item in vm.signups.data\" \nclass=\"{{item.status_class}}\"><td \nstyle=\"padding-left: 15px!important;background-color: #BBDEFB;{{ vm.signups.data[$index-1].courses_id==item.courses_id ? \'border-top: 0px rgba(0, 0, 0, 0) solid;\' : \'\'}}\" \nmd-cell><span ng-if=\"vm.signups.data[$index-1].courses_id==item.courses_id\"></span> <a style=\"color:#212121\" \nng-if=\"vm.signups.data[$index-1].courses_id!=item.courses_id\" ui-sref=\"app.store.courses.detail({id:item.courses_id})\">\n{{ item.course.course_time }} {{ item.course.course_begintime }} {{ item.week }}<br>{{ item.course.name }}<br>约/招 <b \nstyle=\"color: #1e8f03\">{{item.course.signup_count}}人</b> / <b style=\"color: #ff0000\">{{ item.course.course_size }}人</b>\n {{item.course.status_text}}<br>教/址 {{ item.course.teacher_name }} / {{ item.course.location }}</a></td><td md-cell \nstyle=\"padding-left: 15px!important\"><a style=\"display: block\" \nui-sref=\"app.store.customers.detail({id:item.customer_id})\" \nng-if=\"item.customer_id && item.from_store_id==item.store_id\">{{item.customer_name}} <span \nng-if=\"item.customer_nickname\">({{item.customer_nickname}})</span><br>{{item.customer_member_id}} </a><span \nng-if=\"!item.customer_id\">{{item.customer_name}}</span> <span \nng-if=\"item.from_store_id!=item.store_id && item.from_store_id>0\">{{item.customer_name}}-跨店<br>\n{{item.customer_member_id}}</span></td><td md-cell>{{item.customer_birthday}}<br>\n{{item.customer_birthday_month}}M/{{item.customer_sex}}</td><td md-cell><p ng-if=\"!item.customer_id\">\n{{item.parent.relation}} {{item.parent.name}} {{item.parent.mobile}}</p><p ng-if=\"item.customer_id\" \nng-repeat=\"parent in item.parents\">{{parent.relation}} {{parent.name}} <b>{{parent.mobile}}</b></p></td><td md-cell>\n{{ item.status_text }}<br>{{ item.created_at }}</td><td md-cell ng-show=\"vm.is_cud\"><span ng-if=\"item.status==6\"><a \nng-click=\"vm.updateStatus(item,0)\">预约</a>&nbsp;&nbsp; </span><span ng-if=\"item.status==0\"><a \nng-click=\"vm.updateStatus(item,1)\">批准</a>&nbsp;&nbsp; <a ng-click=\"vm.updateStatus(item,2)\">拒绝</a> </span><span \nng-if=\"item.status==1\"><a ng-click=\"vm.updateStatus(item,4)\">签到</a>&nbsp;&nbsp; <a ng-click=\"vm.updateStatus(item,5)\">\n旷课</a> <a ng-click=\"vm.updateStatus(item,3)\">取消</a> </span><span ng-if=\"item.status==2\"><a \nng-click=\"vm.updateStatus(item,1)\">重新批准</a>&nbsp;&nbsp; <span style=\"color: #ddd\">拒绝</span> </span><span \nng-if=\"item.status==3\" style=\"color: #ddd\">签到&nbsp;&nbsp; 旷课</span> <a ng-click=\"vm.loglist($event, item)\">查看记录</a>\n</td></tr></tbody></table></md-table-container></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"footer white-bg\"><md-table-pagination md-limit=\"vm.query.limit\" md-page-select md-page=\"vm.query.page\" \nmd-total=\"{{vm.signups._meta.totalCount}}\" md-on-paginate=\"vm.doSearch\"></md-table-pagination></div></div><style>\n.md-data-table td{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\r\n    .md-data-table th{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/store/plan/plan.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">计划管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">计划列表</div></div>\n<div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label><md-icon md-font-icon=\"icon-magnify\">\n</md-icon></label><md-input-container md-no-float class=\"m-0\"><input ng-model=\"vm.query.title\" translate \nng-change=\"vm.doSearch()\" translate-attr-placeholder=\"计划\"></md-input-container></div></div><div \nclass=\"content white-bg\"><md-table-container><table md-table class=\"md-data-table\"><thead md-head \nmd-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row><th md-column decend-first \nstyle=\"padding-left: 15px!important\"><span class=\"column-title\">计划</span></th><th md-column decend-first \nstyle=\"padding-left: 15px!important\"><span class=\"column-title\">计划编号</span></th><th md-column><span \nclass=\"column-title\">计划描述</span></th><th md-column><span class=\"column-title\">课数</span></th><th></th></tr></thead>\n<tbody><tr ng-repeat=\"item in vm.plans\" ui-sref=\"app.store.plans.detail({id:item.id})\" class=\"pointer\"><td md-cell>\n{{ item.title }}</td><td md-cell>{{ item.number }}</td><td md-cell>{{ item.desc }}</td><td md-cell>{{ item.num }}</td>\n<td md-cell><a ng-click=\"vm.openPlanDialog($event, item)\">修改</a> <a ng-click=\"vm.deletePlan($event, item)\">删除</a> <a \nng-click=\"vm.openPlantaskDialog($event,item)\">添加任务</a> <a ng-click=\"vm.importPlanDialog($event, item)\">导入</a></td></tr>\n</tbody></table></md-table-container></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"footer white-bg\"><md-table-pagination md-limit=\"vm.query.limit\" md-page-select md-page=\"vm.query.page\" \nmd-total=\"{{vm._meta.totalCount}}\" md-on-paginate=\"vm.doSearch\"></md-table-pagination><div layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-fab md-mini md-accent md-icon-button mv-25\" id=\"add-contact-button\" \nng-click=\"vm.openPlanDialog($event)\" aria-label=\"add contact\" translate \ntranslate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></div>\n</div></div><style>\n.md-data-table td{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\r\n    .md-data-table th{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/store/plan/plandetail.html","<div id=\"dashboard-server\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"35\" flex-gt-md=\"35\"><md-card id=\"baby-info\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div \nclass=\"user-info\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\">\n<div class=\"name\">{{vm.plan.title}}</div></div></div><md-card-content><p>课数：<span>\n{{vm.plan.num}} &nbsp;&nbsp;&nbsp;&nbsp;创建人：<span>{{vm.plan.createdby}}</span></span></p><p>创建时间：<span>\n{{vm.plan.created_time}}</span></p><p>更新时间：<span>{{vm.plan.update_time}}</span></p><div ng-show=\"vm.plan.status==1\" \nclass=\"pt-8\" layout=\"column\" layout-align=\"center\"><md-button class=\"md-primary md-raised\" \nng-click=\"vm.openPlanDialog($event, vm.plan)\">修改</md-button></div><div class=\"pt-8\" layout=\"column\" \nlayout-align=\"center\"><md-button class=\"md-primary md-raised\" ng-click=\"vm.openPlantaskDialog($event, vm.plan)\">添加任务\n</md-button></div></md-card-content></md-card></ms-widget><ms-widget flippable=\"false\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"65\" flex-gt-md=\"65\"><ms-widget-front id=\"con-info\" class=\"white-bg\" layout-md=\"row\"><div \nclass=\"widget-group ph-16 pb-8 pt-16\" layout=\"row\" layout-wrap><div flex><div layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><span>计划描述：<span>{{vm.plan.desc}}\n</span></span></div></div></div></ms-widget-front></ms-widget></div><div layout=\"row\" layout-wrap \nclass=\"ph-24 pv-8 beizhubg-block\"><div flex=\"10\" layout-align=\"start center\" \nclass=\"ng-scope layout-align-start-center mr-20\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" \nng-repeat=\"status in vm.signup_status\"><div class=\"h-10 w-10 mr-8 {{status.class}}\"></div><span \nclass=\"title ng-binding\">{{status.text}}</span></div></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" \nlayout-wrap><ms-widget flippable=\"false\" flex=\"100\"><ms-widget-front id=\"course-info\" class=\"white-bg\"><div ng-cloak>\n<md-content><md-tabs md-dynamic-height md-border-bottom><md-tab label=\"教学任务列表\"><md-content class=\"md-padding\"><div \nid=\"simple-table\" class=\"page-layout simple fullwidth datatable-page\" style=\"position: relative\"><md-table-container>\n<table md-table class=\"md-data-table\"><thead md-head><tr md-row><th md-column md-order-by=\"customer_id\" decend-first \nstyle=\"padding-left: 15px!important\"><span class=\"column-title\">任务</span></th><th md-column md-order-by=\"type\" \ndecend-first><span class=\"\">作务描述</span></th><th md-column md-order-by=\"type\" decend-first><span class=\"\">创建时间</span>\n</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in vm.tasks\"><td md-cell style=\"padding-left: 15px!important\">\n{{item.title}}</td><td md-cell>{{item.desc}}</td><td md-cell>{{item.created_time}}</td><td md-cell><a \nng-click=\"vm.openPlantaskDialog($event, vm.plan,item)\">修改</a> <a ng-click=\"vm.deleteTask($event, item)\">删除</a></td>\n</tr></tbody></table></md-table-container><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"footer white-bg\"><div layout=\"row\" layout-align=\"end right\"><md-button type=\"submit\" \nng-click=\"vm.deleteAllTask($event)\" class=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid\">清除所有任务\n</md-button></div></div></div></md-content></md-tab></md-tabs></md-content></div></ms-widget-front></ms-widget></div>\n</div><style>\n.md-data-table td{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\r\n    .md-data-table th{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/store/reports/amount-details.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"content white-bg\"><md-table-container><table md-table class=\"md-data-table\"><thead md-head><tr md-row><th \nmd-column decend-first style=\"padding-left: 15px!important\"><span class=\"column-title\">标题</span></th><th md-column \ndecend-first style=\"padding-left: 15px!important\"><span class=\"column-title\">金额</span></th><th md-column><span \nclass=\"column-title\">内容</span></th></tr></thead><tbody><tr ng-repeat=\"item in vm.lists\"><td md-cell>{{ item.title }}\n</td><td md-cell>{{ item.amount }}</td><td md-cell>{{ item.content }}</td></tr></tbody></table></md-table-container>\n</div></div><style>\n.md-data-table td{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\r\n    .md-data-table th{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/store/reports/amounts.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">营业额统计管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">营业额统计列表</div>\n</div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><md-select \nng-model=\"vm.query.type\" ng-change=\"vm.doSearch()\"><md-option ng-repeat=\"item in vm.types\" value=\"{{item.id}}\">\n{{item.text}}</md-option></md-select></md-input-container><label translate=\"时间\">时间</label><md-datepicker flex \nmd-placeholder=\"开始时间\" ng-init=\"vm.query.sdate=\'\'\" ng-model=\"vm.query.sdate\" ng-change=\"vm.doSearch()\" \nng-model-options=\"{timezone:\'utc\'}\">{{vm.query.sdate}}</md-datepicker><md-datepicker flex md-placeholder=\"结束时间\" \nng-init=\"vm.query.edate = \'\'\" ng-model=\"vm.query.edate\" ng-change=\"vm.doSearch()\" ng-model-options=\"{timezone:\'utc\'}\">\n{{vm.query.edate}}</md-datepicker></div></div><div class=\"content white-bg\"><md-table-container><table md-table \nclass=\"md-data-table\"><thead md-head md-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row><th md-column \ndecend-first style=\"padding-left: 15px!important\"><span class=\"column-title\">统计时间</span></th><th md-column \ndecend-first><span class=\"column-title\">营业额</span></th><th md-column decend-first><span class=\"column-title\">合同额</span>\n</th><th md-column decend-first><span class=\"column-title\">体验额</span></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.lists.data\" ui-sref=\"app.store.reports.amountdetails({date:item.date,type:item.type})\"><td \nmd-cell>{{ item.date }}</td><td md-cell>{{ item.amount }}</td><td md-cell>{{ item.turnover }}</td><td md-cell>\n{{ item.exp_amount }}</td></tr></tbody></table></md-table-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"footer white-bg\"><md-table-pagination md-limit=\"vm.query.limit\" \nmd-page-select md-page=\"vm.query.page\" md-total=\"{{vm.lists._meta.totalCount}}\" md-on-paginate=\"vm.doSearch\">\n</md-table-pagination><div layout=\"row\" layout-align=\"end center\"><md-button ng-if=\"vm.is_export\" \nclass=\"md-raised reference-button\" type=\"button\" ng-click=\"vm.exportAmounts($event)\"><md-icon md-font-icon=\"icon-link\">\n</md-icon><span>导出</span></md-button></div></div></div><style>\n.md-data-table td{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\r\n    .md-data-table th{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/store/reports/archive.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">营收额总统计</span></div><div class=\"title\" style=\"font-size: 24px!important\"></div></div><div\n class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><md-datepicker flex md-placeholder=\"开始时间\" \nng-init=\"vm.query.sdate=\'\'\" ng-model=\"vm.query.sdate\" ng-model-options=\"{timezone:\'utc\'}\">{{vm.query.sdate}}\n</md-datepicker><md-datepicker flex md-placeholder=\"结束时间\" ng-init=\"vm.query.edate = \'\'\" ng-model=\"vm.query.edate\" \nng-model-options=\"{timezone:\'utc\'}\">{{vm.query.edate}}</md-datepicker><button ng-click=\"vm.doSearch()\" \nclass=\"send-button md-accent md-raised md-button md-default-theme md-ink-ripple\" type=\"button\"><span class=\"ng-scope\">\n搜索</span></button></div></div><div class=\"content-new\"><div class=\"widget-group layout-wrap layout-row flex-100\" \nlayout=\"row\" flex=\"100\"><ms-widget flippable=\"false\" flex=\"100\" class=\"ms-widget ng-isolate-scope flex-100\">\n<ms-widget-front class=\"white-bg ms-widget-front ng-scope\"><div class=\"course-info-page ng-scope md-padding\"><div \nclass=\"header pt-8 pb-16 layout-align-space-between-center layout-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"layout-align-start-center layout-row\"><div class=\"tong-icons blue-400-bg mr-8\"><i \nclass=\"icon s20 icon-calendar\"></i></div><div class=\"info\"><div class=\"title h3 ng-binding\"><div \nclass=\"ng-binding md-default-theme blue-grey-900-fg font-size-28\">{{vm.res.amount}}</div></div><div \nclass=\"subtitle secondary-text ng-binding\">总业绩（收入）</div></div></div></div><div layout=\"row\" \nlayout-align=\"start center\" \nclass=\"course-wen pl-56 layout-align-start-center widget-group layout-wrap layout-row flex-100\"><div \nclass=\"room-button layout-column flex-gt-xs-33 flex-gt-md-33 flex-100\"><div layout=\"row\" layout-align=\"start center\">\n<span>营业收入：</span>&nbsp;<span>{{vm.res.ht_amount}}</span></div></div><div \nclass=\"coach-button layout-column flex-gt-xs-33 flex-gt-md-33 flex-100\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"layout-align-start-center layout-row\"><span>休验收入：</span>&nbsp;<span class=\"ng-binding\">{{vm.res.ty_amount}}\n</span></div></div><div class=\"room-button layout-column flex-gt-xs-33 flex-gt-md-33 flex-100\"><div layout=\"row\" \nlayout-align=\"start center\"><span>其他收入：</span>&nbsp;<span>{{vm.res.other_amount}}</span></div></div></div></div><div \nclass=\"course-info-page ng-scope md-padding\"><div \nclass=\"header pt-8 pb-16 layout-align-space-between-center layout-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"layout-align-start-center layout-row\"><div class=\"tong-icons red-400-bg mr-8\"><i \nclass=\"icon s20 icon-credit-card\"></i></div><div class=\"info\"><div class=\"title h3 ng-binding\"><div \nclass=\"ng-binding md-default-theme blue-grey-900-fg font-size-28\">{{vm.res.xk_amount}}</div></div><div \nclass=\"subtitle secondary-text ng-binding\">总卡耗（负债消耗）</div></div></div></div><div layout=\"row\" \nlayout-align=\"start center\" \nclass=\"course-wen pl-56 layout-align-start-center widget-group layout-wrap layout-row flex-100 hide\"><div \nclass=\"coach-button layout-column flex-gt-xs-33 flex-gt-md-33 flex-100\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"layout-align-start-center layout-row\"><span>POS：</span>&nbsp;<span class=\"ng-binding\">0.00</span></div></div>\n<div class=\"room-button layout-column flex-gt-xs-33 flex-gt-md-33 flex-100\"><div layout=\"row\" \nlayout-align=\"start center\"><span>现金：</span>&nbsp;<span>0.00</span></div></div><div \nclass=\"coach-button layout-column flex-gt-xs-33 flex-gt-md-33 flex-100\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"layout-align-start-center layout-row\"><span>POS：</span>&nbsp;<span class=\"ng-binding\">0.00</span></div></div>\n<div class=\"room-button layout-column flex-gt-xs-33 flex-gt-md-33 flex-100\"><div layout=\"row\" \nlayout-align=\"start center\"><span>现金：</span>&nbsp;<span>0.00</span></div></div><div \nclass=\"coach-button layout-column flex-gt-xs-33 flex-gt-md-33 flex-100\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"layout-align-start-center layout-row\"><span>POS：</span>&nbsp;<span class=\"ng-binding\">0.00</span></div></div>\n</div></div><div class=\"course-info-page ng-scope md-padding\"><div \nclass=\"header pt-8 pb-16 layout-align-space-between-center layout-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"layout-align-start-center layout-row\"><div class=\"tong-icons green-400-bg mr-8\"><i class=\"icon s20 icon-inbox\">\n</i></div><div class=\"info\"><div class=\"title h3 ng-binding\"><div \nclass=\"ng-binding md-default-theme blue-grey-900-fg font-size-28\">{{vm.res.ht_amount}}</div></div><div \nclass=\"subtitle secondary-text ng-binding\">营业收入（会员实际收入）</div></div></div></div><div layout=\"row\" \nlayout-align=\"start center\" \nclass=\"course-wen pl-56 layout-align-start-center widget-group layout-wrap layout-row flex-100\"><div \nclass=\"layout-column flex-gt-xs-50 flex-gt-md-50 flex-100\"><div \nclass=\"room-button layout-column flex-gt-xs-100 flex-gt-md-100 flex-100\" ng-repeat=\"item in vm.res.pay_list\"><div \nlayout=\"row\" layout-align=\"start center\"><span>{{item.pay_type}}：</span>&nbsp;<span>{{item.amount}}</span></div></div>\n</div><div class=\"layout-column flex-gt-xs-50 flex-gt-md-50 flex-100\"><div \nclass=\"coach-button layout-column flex-gt-xs-100 flex-gt-md-100 flex-100\"><div layout=\"row\" \nlayout-align=\"start center\" class=\"layout-align-start-center layout-row\" ng-repeat=\"item in vm.res.card_type_list\">\n<span>{{item.card_type}}：</span>&nbsp;<span>{{item.amount}}</span></div></div></div></div></div><div \nclass=\"course-info-page ng-scope md-padding\"><div \nclass=\"header pt-8 pb-16 layout-align-space-between-center layout-row\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\" \nclass=\"layout-align-start-center layout-row\"><div class=\"tong-icons orange-400-bg mr-8\"><i class=\"icon s20 icon-heart\">\n</i></div><div class=\"info\"><div class=\"title h3 ng-binding\"><div \nclass=\"ng-binding md-default-theme blue-grey-900-fg font-size-28\">{{vm.res.other_amount}}</div></div><div \nclass=\"subtitle secondary-text ng-binding\">其他收入</div></div></div></div><div layout=\"row\" layout-align=\"start center\" \nclass=\"course-wen pl-56 layout-align-start-center widget-group layout-wrap layout-row flex-100\"><div \nclass=\"room-button layout-column flex-gt-xs-33 flex-gt-md-33 flex-100\" ng-repeat=\"item in vm.res.others\"><div \nlayout=\"row\" layout-align=\"start center\"><span>{{item.sale_project}}：</span>&nbsp;<span>{{item.amount}}</span></div>\n</div></div></div></ms-widget-front></ms-widget></div></div></div><style>\n.md-data-table td{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\r\n    .md-data-table th{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\r\n    .content-new{\r\n        padding:12px;\r\n    }\r\n    .course-info-page {\r\n        border-bottom: 1px solid #e0e0e0;\r\n        margin-bottom: 0px;\r\n    }\r\n    .coach-button{\r\n        padding:5px 0px;\r\n    }\r\n    .tong-icons .icon {\r\n        color: rgba(255, 255, 255, 1);\r\n        /*margin: 0 16px 0 0;*/\r\n    }\r\n    .tong-icons {\r\n        border-radius: 2px;\r\n        padding:14px;\r\n        line-height:1;\r\n    }\n</style>");
$templateCache.put("app/main/apps/store/reports/incomes.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">其它收入管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">其它收入列表</div>\n</div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><label translate=\"时间\">时间</label><md-datepicker flex \nmd-placeholder=\"开始时间\" ng-init=\"vm.query.sdate=vm.StrToDate(vm.query.sdate);\" ng-model=\"vm.query.sdate\" \nng-change=\"vm.doSearch()\" ng-model-options=\"{timezone:\'utc\'}\">{{vm.query.sdate}}</md-datepicker><md-datepicker flex \nmd-placeholder=\"结束时间\" ng-init=\"vm.query.edate =vm.StrToDate(vm.query.edate);\" ng-model=\"vm.query.edate\" \nng-change=\"vm.doSearch()\" ng-model-options=\"{timezone:\'utc\'}\">{{vm.query.edate}}</md-datepicker></div></div><div \nclass=\"content white-bg\"><md-table-container><table md-table class=\"md-data-table\"><thead md-head \nmd-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row><th md-column decend-first \nstyle=\"padding-left: 15px!important\"><span class=\"column-title\">日期</span></th><th md-column><span class=\"column-title\">\n金额</span></th><th md-column><span class=\"column-title\">收款方式</span></th><th md-column><span class=\"column-title\">消费项目\n</span></th><th md-column><span class=\"column-title\">消费方</span></th><th md-column><span class=\"column-title\">备注</span>\n</th><th></th></tr></thead><tbody><tr ng-repeat=\"item in vm.incomes.data\"><td md-cell>{{ item.income_date }}</td><td \nmd-cell>{{ item.amount }}</td><td md-cell>{{ item.income_type }}</td><td md-cell>{{ item.sale_project }}</td><td \nmd-cell>{{ item.sale_fang }}</td><td md-cell>{{ item.remarks }}</td><td md-cell><a \nng-click=\"vm.openIncomeDialog($event, item)\" ng-if=\"vm.is_cud\">修改</a></td></tr></tbody></table></md-table-container>\n</div><div layout=\"row\" layout-align=\"space-between center\" class=\"footer white-bg\"><md-table-pagination \nmd-limit=\"vm.query.limit\" md-page-select md-page=\"vm.query.page\" md-total=\"{{vm.incomes._meta.totalCount}}\" \nmd-on-paginate=\"vm.doSearch\"></md-table-pagination><div layout=\"row\" layout-align=\"end center\"><md-button \nng-if=\"vm.is_export\" class=\"md-raised reference-button\" type=\"button\" ng-click=\"vm.exportIncomes($event)\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>导出</span></md-button><md-button ng-if=\"vm.is_cud\" \nclass=\"md-fab md-mini md-accent md-icon-button mv-25\" id=\"add-contact-button\" ng-click=\"vm.openIncomeDialog($event)\" \naria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon></md-button></div></div></div><style>\n.md-data-table td{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\r\n    .md-data-table th{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/store/reports/pays.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">支出管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">支出列表</div></div>\n<div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label><md-icon md-font-icon=\"icon-magnify\">\n</md-icon></label><label translate=\"时间\">时间</label><md-datepicker flex md-placeholder=\"开始时间\" \nng-init=\"vm.query.sdate=vm.StrToDate(vm.query.sdate);\" ng-model=\"vm.query.sdate\" ng-change=\"vm.doSearch()\" \nng-model-options=\"{timezone:\'utc\'}\">{{vm.query.sdate}}</md-datepicker><md-datepicker flex md-placeholder=\"结束时间\" \nng-init=\"vm.query.edate =vm.StrToDate(vm.query.edate);\" ng-model=\"vm.query.edate\" ng-change=\"vm.doSearch()\" \nng-model-options=\"{timezone:\'utc\'}\">{{vm.query.edate}}</md-datepicker></div></div><div class=\"content white-bg\">\n<md-table-container><table md-table class=\"md-data-table\"><thead md-head md-order=\"vm.query.sort\" \nmd-on-reorder=\"vm.doSearch\"><tr md-row><th md-column decend-first style=\"padding-left: 15px!important\"><span \nclass=\"column-title\">日期</span></th><th md-column><span class=\"column-title\">金额</span></th><th md-column><span \nclass=\"column-title\">付款方式</span></th><th md-column><span class=\"column-title\">收款方</span></th><th md-column><span \nclass=\"column-title\">备注</span></th><th></th></tr></thead><tbody><tr ng-repeat=\"item in vm.pays.data\"><td md-cell>\n{{ item.pay_date }}</td><td md-cell>{{ item.amount }}</td><td md-cell>{{ item.pay_type }}</td><td md-cell>\n{{ item.income_fang }}</td><td md-cell>{{ item.remarks }}</td><td md-cell><a ng-click=\"vm.openPayDialog($event, item)\" \nng-if=\"vm.is_cud\">修改</a></td></tr></tbody></table></md-table-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"footer white-bg\"><md-table-pagination md-limit=\"vm.query.limit\" \nmd-page-select md-page=\"vm.query.page\" md-total=\"{{vm.incomes._meta.totalCount}}\" md-on-paginate=\"vm.doSearch\">\n</md-table-pagination><div layout=\"row\" layout-align=\"end center\"><md-button ng-if=\"vm.is_export\" \nclass=\"md-raised reference-button\" type=\"button\" ng-click=\"vm.exportPays($event)\"><md-icon md-font-icon=\"icon-link\">\n</md-icon><span>导出</span></md-button><md-button ng-if=\"vm.is_cud\" \nclass=\"md-fab md-mini md-accent md-icon-button mv-25\" id=\"add-contact-button\" ng-click=\"vm.openPayDialog($event)\" \naria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon></md-button></div></div></div><style>\n.md-data-table td{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\r\n    .md-data-table th{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/store/reports/xiaoke-chart.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">营业额统计管理</span></div><div class=\"title\" style=\"font-size: 20px!important\">消课统计图表</div>\n</div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label class=\"lab active\" \nid=\"tag-today\" ng-click=\"vm.doDaySearch(\'today\')\">当天</label><label class=\"lab\" id=\"tag-yesterday\" \nng-click=\"vm.doDaySearch(\'yesterday\')\">昨天</label><label class=\"lab\" id=\"tag-last_week\" \nng-click=\"vm.doDaySearch(\'last_week\')\">上周</label><label class=\"lab\" id=\"tag-last_month\" \nng-click=\"vm.doDaySearch(\'last_month\')\">上月</label><label class=\"lab\" id=\"tag-month\" ng-click=\"vm.doDaySearch(\'month\')\">\n本月</label><label translate=\"时间\">时间</label><md-datepicker flex md-placeholder=\"开始时间\" ng-init=\"vm.query.sdate=\'\'\" \nng-model=\"vm.query.sdate\" ng-model-options=\"{timezone:\'utc\'}\">{{vm.query.sdate}}</md-datepicker><md-datepicker flex \nmd-placeholder=\"结束时间\" ng-init=\"vm.query.edate = \'\'\" ng-model=\"vm.query.edate\" ng-model-options=\"{timezone:\'utc\'}\">\n{{vm.query.edate}}</md-datepicker><button ng-click=\"vm.doSearch()\" \nclass=\"send-button md-accent md-raised md-button md-default-theme md-ink-ripple\" type=\"button\"><span class=\"ng-scope\">\n搜索</span></button></div></div><div class=\"content white-bg\" style=\"padding: 0\"><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"60\" flex-gt-md=\"60\">\n<ms-widget-front class=\"white-bg ms-widget-front ng-scope\"><div class=\"h3 p-16\">卡耗走势</div><div class=\"card p-16\">\n<chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.lineChart.data\" chartist-chart-type=\"Line\" \nchartist-chart-options=\"vm.lineChart.options\"></chartist></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"40\" flex-gt-md=\"40\"><ms-widget-front \nclass=\"white-bg ms-widget-front ng-scope\"><div class=\"h3 p-16\">本店跨出卡耗</div><div class=\"card p-16\"><nvd3 \noptions=\"vm.pieChart1.options\" data=\"vm.pieChart1.data\"></nvd3></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"60\" flex-gt-md=\"60\"><ms-widget-front \nclass=\"white-bg ms-widget-front ng-scope\"><div class=\"h3 p-16\">卡耗统计</div><div class=\"card p-16\"><chartist \nclass=\"ct-chart ct-golden-section\" chartist-data=\"vm.barChart.data\" chartist-chart-type=\"Bar\" \nchartist-chart-options=\"vm.barChart.options\" chartist-responsive-options=\"vm.barChart.responsiveOptions\"></chartist>\n</div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"40\" \nflex-gt-md=\"40\"><ms-widget-front class=\"white-bg ms-widget-front ng-scope\"><div class=\"h3 p-16\">跨入本店卡耗</div><div \nclass=\"card p-16\"><nvd3 options=\"vm.pieChart.options\" data=\"vm.pieChart.data\"></nvd3></div></ms-widget-front>\n</ms-widget></div></div></div><style>\n.md-data-table td{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\r\n    .md-data-table th{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\r\n    .search-input-wrapper .lab{\r\n        padding-right: 15px;\r\n        color: rgba(0, 0, 0, 0.54);\r\n        cursor: pointer;\r\n    }\r\n    .search-input-wrapper .lab.active{\r\n        padding-right: 15px;\r\n        font-weight: bold;\r\n        color: rgba(255,255,255,1);\r\n    }\r\n    .nv-legendWrap{\r\n        display: none;\r\n    }\r\n    .nv-pieChart{\r\n        padding-top: 0px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/store/reports/xiaokes.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">销课统计管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">销课统计列表</div>\n</div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0 hide\"><md-select \nng-model=\"vm.query.type\" ng-change=\"vm.doSearch()\"><md-option ng-repeat=\"item in vm.types\" value=\"{{item.id}}\">\n{{item.text}}</md-option></md-select></md-input-container><md-input-container md-no-float class=\"m-0\"><md-select \nng-model=\"vm.query.classify\" ng-change=\"vm.doSearch()\"><md-option ng-repeat=\"item in vm.classifys\" value=\"{{item.id}}\">\n{{item.text}}</md-option></md-select></md-input-container><label translate=\"时间\">时间</label><md-datepicker flex \nmd-placeholder=\"开始时间\" ng-init=\"vm.query.sdate=\'\'\" ng-model=\"vm.query.sdate\" ng-change=\"vm.doSearch()\" \nng-model-options=\"{timezone:\'utc\'}\">{{vm.query.sdate}}</md-datepicker><md-datepicker flex md-placeholder=\"结束时间\" \nng-init=\"vm.query.edate = \'\'\" ng-model=\"vm.query.edate\" ng-change=\"vm.doSearch()\" ng-model-options=\"{timezone:\'utc\'}\">\n{{vm.query.edate}}</md-datepicker></div></div><div class=\"content white-bg\"><md-table-container><table md-table \nclass=\"md-data-table\"><thead md-head md-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row><th md-column \ndecend-first style=\"padding-left: 15px!important\"><span class=\"column-title\">卡项</span></th><th md-column><span \nclass=\"column-title\">销课金额</span></th><th md-column><span class=\"column-title\">统计时间</span></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.xiaokes.data\"><td md-cell>{{ item.card_type }}</td><td md-cell>{{ item.amount }}</td><td md-cell>\n{{ item.date }}</td></tr></tbody></table></md-table-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"footer white-bg\"><md-table-pagination md-limit=\"vm.query.limit\" \nmd-page-select md-page=\"vm.query.page\" md-total=\"{{vm.xiaokes._meta.totalCount}}\" md-on-paginate=\"vm.doSearch\">\n</md-table-pagination><div layout=\"row\" layout-align=\"end center\"><md-button ng-if=\"vm.is_export\" \nclass=\"md-raised reference-button\" type=\"button\" ng-click=\"vm.exportXiaokes($event)\"><md-icon md-font-icon=\"icon-link\">\n</md-icon><span>导出</span></md-button></div></div></div><style>\n.md-data-table td{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\r\n    .md-data-table th{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/store/reports/zhong.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">营业额统计管理</span></div><div class=\"title\" style=\"font-size: 20px!important\">营业额统计列表</div>\n</div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label class=\"lab active\" \nid=\"tag-today\" ng-click=\"vm.doDaySearch(\'today\')\">当天</label><label class=\"lab\" id=\"tag-yesterday\" \nng-click=\"vm.doDaySearch(\'yesterday\')\">昨天</label><label class=\"lab\" id=\"tag-last_week\" \nng-click=\"vm.doDaySearch(\'last_week\')\">上周</label><label class=\"lab\" id=\"tag-last_month\" \nng-click=\"vm.doDaySearch(\'last_month\')\">上月</label><label class=\"lab\" id=\"tag-month\" ng-click=\"vm.doDaySearch(\'month\')\">\n本月</label><md-input-container md-no-float class=\"m-0\"><md-select ng-model=\"vm.query.type\"><md-option \nng-repeat=\"item in vm.types\" value=\"{{item.id}}\">{{item.text}}</md-option></md-select></md-input-container><label \ntranslate=\"时间\">时间</label><md-datepicker flex md-placeholder=\"开始时间\" ng-init=\"vm.query.sdate=\'\'\" \nng-model=\"vm.query.sdate\" ng-model-options=\"{timezone:\'utc\'}\">{{vm.query.sdate}}</md-datepicker><md-datepicker flex \nmd-placeholder=\"结束时间\" ng-init=\"vm.query.edate = \'\'\" ng-model=\"vm.query.edate\" ng-model-options=\"{timezone:\'utc\'}\">\n{{vm.query.edate}}</md-datepicker><button ng-click=\"vm.doSearch()\" \nclass=\"send-button md-accent md-raised md-button md-default-theme md-ink-ripple\" type=\"button\"><span class=\"ng-scope\">\n搜索</span></button></div></div><div class=\"content white-bg\" style=\"padding: 0\"><div class=\"widget-group\" layout=\"row\" \nflex=\"100\" layout-wrap><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"60\" flex-gt-md=\"60\">\n<ms-widget-front class=\"white-bg ms-widget-front ng-scope\"><div class=\"h3 p-16\">业绩收入</div><div class=\"card p-16\">\n<chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.lineChart.data\" chartist-chart-type=\"Line\" \nchartist-chart-options=\"vm.lineChart.options\"></chartist></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"40\" flex-gt-md=\"40\"><ms-widget-front \nclass=\"white-bg ms-widget-front ng-scope\"><div class=\"h3 p-16\">支付来源对比</div><div class=\"card p-16\"><nvd3 \noptions=\"vm.pieChart.options\" data=\"vm.pieChart.data\"></nvd3></div></ms-widget-front></ms-widget><ms-widget \nflippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"35\" flex-gt-md=\"35\"><ms-widget-front \nclass=\"white-bg ms-widget-front ng-scope\"><div class=\"h3 p-16\">卡类型</div><div class=\"card p-16\"><chartist \nclass=\"ct-chart ct-golden-section\" chartist-data=\"vm.barChart.data\" chartist-chart-type=\"Bar\" \nchartist-chart-options=\"vm.barChart.options\" chartist-responsive-options=\"vm.barChart.responsiveOptions\"></chartist>\n</div></ms-widget-front></ms-widget><ms-widget flippable=\"true\" layout=\"column\" flex=\"100\" flex-gt-xs=\"35\" \nflex-gt-md=\"35\"><ms-widget-front class=\"white-bg ms-widget-front ng-scope\"><div class=\"h3 p-16\">卡项</div><div \nclass=\"card p-16\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.barChart1.data\" \nchartist-chart-type=\"Bar\" chartist-chart-options=\"vm.barChart1.options\" \nchartist-responsive-options=\"vm.barChart1.responsiveOptions\"></chartist></div></ms-widget-front></ms-widget><ms-widget \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"30\" flex-gt-md=\"30\"><ms-widget-front class=\"white-bg\"><ms-widget-front \nclass=\"white-bg ms-widget-front ng-scope\"><div class=\"h3 p-16\">员工业绩</div><div class=\"card p-16\"><div class=\"ybox\"><div \nclass=\"p-16 list-row\" layout=\"row\" layout-align=\"space-between center\" ng-repeat=\"event in vm.res.users\" \nstyle=\"padding: 16px 16px 0px 16px\"><div ng-if=\"vm.res.users.length > 0\"><div class=\"h3\"></div><div><span \nclass=\"secondary-text\">{{event.uname}}</span> <span>&nbsp;&nbsp;&nbsp;</span> <span>{{event.amount}}</span></div></div>\n</div><div class=\"p-16 list-row\" style=\"padding: 16px 16px 0px 16px\"></div></div></div></ms-widget-front>\n</ms-widget-front></ms-widget></div></div></div><style>\n.md-data-table td{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\r\n    .md-data-table th{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\r\n    .search-input-wrapper .lab{\r\n        padding-right: 15px;\r\n        color: rgba(0, 0, 0, 0.54);\r\n        cursor: pointer;\r\n    }\r\n    .search-input-wrapper .lab.active{\r\n        padding-right: 15px;\r\n        font-weight: bold;\r\n        color: rgba(255,255,255,1);\r\n    }\r\n    .nv-legendWrap{\r\n        display: none;\r\n    }\r\n    .nv-pieChart{\r\n        padding-top: 0px;\r\n    }\n</style>");
$templateCache.put("app/main/apps/store/teachers/courses.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">课程管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">课程列表</div></div>\n<div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\" \nng-click=\"vm.toggleSidenav(\'settings-sidenav\')\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label><div \nclass=\"hide\"><md-checkbox ng-model=\"vm.is_del\" aria-label=\"显示禁用老师\" style=\"margin-bottom: 0px;!important\" \nng-change=\"vm.doSearch()\">显示禁用老师</md-checkbox><md-input-container md-no-float class=\"m-0\"><label translate=\"老师\">老师\n</label><md-select ng-model=\"vm.query.teacher_id\" ng-change=\"vm.doSearch()\"><md-option ng-repeat=\"item in vm.teachers\" \nvalue=\"{{item.id}}\" ng-if=\"item.status == 10 || (vm.is_del && item.status == 0)\">{{item.name}}</md-option></md-select>\n</md-input-container><label translate=\"上课时间\">上课时间</label><md-datepicker flex md-placeholder=\"上课时间\" \nng-init=\"vm.query.sdate=vm.StrToDate(vm.query.sdate);\" ng-model=\"vm.query.sdate\" ng-change=\"vm.doSearch()\" \nng-model-options=\"{timezone:\'utc\'}\">{{vm.query.sdate}}</md-datepicker><md-datepicker flex md-placeholder=\"上课时间\" \nng-init=\"vm.query.edate = vm.StrToDate(vm.query.edate);\" ng-model=\"vm.query.edate\" ng-change=\"vm.doSearch()\" \nng-model-options=\"{timezone:\'utc\'}\">{{vm.query.edate}}</md-datepicker></div></div></div><div class=\"content white-bg\">\n<md-sidenav style=\"max-width:40%;width:40%\" class=\"sidenav settings-sidenav md-sidenav-right\" \nmd-component-id=\"settings-sidenav\" ms-scroll ms-sidenav-helper><md-content class=\"content\" layout-padding><div \nclass=\"content white-bg\"><md-checkbox ng-model=\"vm.is_del\" aria-label=\"显示禁用老师\" style=\"margin-bottom: 0px;!important\" \nng-change=\"vm.doSearch()\">显示禁用老师</md-checkbox><br><label translate=\"上课时间\">上课时间</label><md-datepicker flex \nmd-placeholder=\"上课时间\" ng-init=\"vm.query.sdate=vm.StrToDate(vm.query.sdate);\" ng-model=\"vm.query.sdate\" \nng-change=\"vm.doSearch()\" ng-model-options=\"{timezone:\'utc\'}\">{{vm.query.sdate}}</md-datepicker><md-datepicker flex \nmd-placeholder=\"上课时间\" ng-init=\"vm.query.edate = vm.StrToDate(vm.query.edate);\" ng-model=\"vm.query.edate\" \nng-change=\"vm.doSearch()\" ng-model-options=\"{timezone:\'utc\'}\">{{vm.query.edate}}</md-datepicker><br><div layout=\"row\" \nlayout-wrap=\"\" flex=\"\"><div flex=\"20\" ng-repeat=\"item in vm.teachers\" \nng-if=\"item.status == 10 || (vm.is_del && item.status == 0)\"><md-checkbox style=\"margin: 10px 0 10px\" \nng-click=\"vm.toggleSelectThread(item, $event)\"><span style=\"color: #333333\" \nng-class=\"{\'text-strike md-secondary-text\':checkItem.checked}\">{{item.name}}</span></md-checkbox></div></div></div>\n</md-content></md-sidenav><md-table-container><table md-table class=\"md-data-table\"><thead md-head \nmd-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row><th md-column md-order-by=\"course_time\" decend-first \nstyle=\"padding-left: 15px!important\"><span class=\"column-title\">日期</span></th><th md-column \nmd-order-by=\"course_begintime\"><span class=\"column-title\">时间</span></th><th md-column md-order-by=\"teacher_id\"><span \nclass=\"column-title\">老师</span></th><th md-column md-order-by=\"teacher_id\"><span class=\"column-title\">课程</span></th><th \nmd-column><span class=\"column-title\">上课人数</span></th><th md-column><span class=\"column-title\">体验人数</span></th></tr>\n</thead><tbody md-body><tr ng-repeat=\"course in vm.courses.data\"><td md-cell style=\"padding-left: 15px!important\">\n{{ course.course_time }}({{course.week}})</td><td md-cell>{{ course.course_begintime }}~{{ course.course_endtime }}\n</td><td md-cell>{{ course.teacher_name }}</td><td md-cell>{{ course.name }}</td><td md-cell><b style=\"color: #1e8f03\">\n{{ course.shidao_count }}人</b></td><td md-cell><b style=\"color: #1e8f03\">{{ course.task_count }}人</b></td></tr></tbody>\n</table></md-table-container></div><div layout=\"row\" layout-align=\"space-between center\" class=\"footer white-bg\">\n<md-table-pagination md-limit=\"vm.query.limit\" md-page-select md-page=\"vm.query.page\" \nmd-total=\"{{vm.courses._meta.totalCount}}\" md-on-paginate=\"vm.doSearch\"></md-table-pagination><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-if=\"vm.is_export\" class=\"md-raised reference-button\" type=\"button\" \nng-click=\"vm.exportSignups($event)\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>导出</span></md-button></div></div>\n</div><style>\n.md-data-table td{\n        padding: 10px 0px 10px 0px!important;\n    }\n    .md-data-table th{\n        padding: 10px 0px 10px 0px!important;\n    }\n    md-input-container .md-errors-spacer{\n        min-height: 0px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/teachers/report.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">报表管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">老师绩效总结列表</div>\n</div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-checkbox ng-model=\"vm.is_del\" aria-label=\"显示禁用老师\" \nstyle=\"margin-bottom: 0px;!important\" ng-change=\"vm.doSearch()\">显示禁用老师</md-checkbox><md-datepicker flex \nng-init=\"vm.query.sdate=vm.StrToDate(vm.query.sdate);\" ng-model=\"vm.query.sdate\" ng-change=\"vm.doSearch()\" \nng-model-options=\"{timezone:\'utc\'}\">{{vm.query.sdate}}</md-datepicker><md-datepicker flex \nng-init=\"vm.query.edate = vm.StrToDate(vm.query.edate);\" ng-model=\"vm.query.edate\" ng-change=\"vm.doSearch()\" \nng-model-options=\"{timezone:\'utc\'}\">{{vm.query.edate}}</md-datepicker></div></div><div class=\"content white-bg\">\n<md-table-container><table md-table class=\"md-data-table\"><thead md-head><tr md-row><th md-column decend-first \nstyle=\"padding-left: 15px!important\"><span class=\"column-title\">老师</span></th><th md-column class=\"hide\"><span \nclass=\"column-title\">岗位类型</span></th><th md-column ng-repeat=\"field in vm.teachers.fields track by $index\"><span \nclass=\"column-title\">{{field}}</span></th></tr></thead><tbody><tr ng-repeat=\"item in vm.teachers.data\"><td md-cell \nstyle=\"padding-left: 15px!important\">{{ item.teacher_name }}</td><td md-cell class=\"hide\">{{ item.gangwei }}</td><td \nmd-cell ng-repeat=\"x in item.list track by $index\" ng-if=\"item.list\"><span style=\"margin-right: 15px\">{{x}}</span></td>\n</tr></tbody></table></md-table-container></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"footer white-bg\"><div class=\"md-table-pagination ng-isolate-scope\" style=\"height:56px\"></div><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-if=\"vm.is_export\" class=\"md-raised reference-button\" type=\"button\" \nng-click=\"vm.exportSignups($event)\"><md-icon md-font-icon=\"icon-link\"></md-icon><span>导出</span></md-button></div></div>\n</div><style>\n.md-data-table td{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\r\n    .md-data-table th{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\r\n    md-input-container .md-errors-spacer{\r\n        min-height: 0px!important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/store/teachers/teacher-detail.html","<div id=\"dashboard-server\"><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget flippable=\"false\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"35\" flex-gt-md=\"35\"><md-card id=\"baby-info\"><div class=\"header md-accent-bg\" \nlayout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"space-between end\"><div \nclass=\"user-info\" layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\">\n<img class=\"profile-image avatar huge\" ng-src=\"{{vm.teacher.avatar}}\"><div class=\"name\">{{vm.teacher.name}}</div><span \nclass=\"sex\">（{{vm.teacher.sex_text}}）</span></div></div></md-card></ms-widget><ms-widget flippable=\"false\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"65\" flex-gt-md=\"65\"><ms-widget-front id=\"con-info\" class=\"white-bg pt-16\" \nlayout-md=\"row\"><div class=\"widget-group ph-16 pb-16 pt-8\" layout=\"row\" layout-wrap><div flex><div layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><span>登录账号：<span>\n{{vm.teacher.username}}</span></span></div></div><div flex><div layout=\"column\" layout-align=\"center center\" \nlayout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><span>手机号：<span>{{vm.teacher.mobile}}</span></span></div></div>\n</div><div class=\"widget-group ph-16 pb-16 pt-8\" layout=\"row\" layout-wrap><div flex><div layout=\"column\" \nlayout-align=\"center center\" layout-gt-sm=\"row\" layout-align-gt-sm=\"start center\"><span>岗位类型: <span>{{vm.teacher.type}}\n</span></span></div></div><div flex><div layout=\"column\" layout-align=\"center center\" layout-gt-sm=\"row\" \nlayout-align-gt-sm=\"start center\"><span>邮箱: <span>{{vm.teacher.email}}</span></span></div></div></div>\n</ms-widget-front></ms-widget></div><div class=\"widget-group\" layout=\"row\" flex=\"100\" layout-wrap><ms-widget \nflippable=\"false\" flex=\"100\"><ms-widget-front id=\"course-info\" class=\"white-bg\"><div ng-cloak><md-content><md-tabs \nmd-dynamic-height md-border-bottom><md-tab label=\"报名中\"><md-table-container class=\"md-padding\"><table md-table \nclass=\"md-data-table\"><thead md-head><tr md-row><th md-column><span class=\"column-title\">Title</span></th><th \nmd-column><span class=\"column-title\">Date in US</span></th><th md-column><span class=\"column-title\">\nTime US ({{vm.teacher.timezone}})</span></th><th md-column><span class=\"column-title\">Date in China</span></th><th \nmd-column><span class=\"column-title\">Time China</span></th><th md-column><span class=\"column-title\">班级</span></th><th \nmd-column><span class=\"column-title\">上课教室</span></th><th md-column><span class=\"column-title\">主教</span></th></tr>\n</thead><tbody><tr ng-repeat=\"item in vm.courses1.data\"><td md-cell>{{item.name}} - {{item.categories_name}}</td><td \nmd-cell>{{item.course_time_zone | date:\"EEEE, MMMM d,yyyy\" }}</td><td md-cell>\n{{item.course_begintime_zone}} ~ {{item.course_endtime_zone}}</td><td md-cell>\n{{item.course_time | date:\"EEEE, MMMM d,yyyy\" }}</td><td md-cell>{{item.course_begintime}} ~ {{item.course_endtime}}\n</td><td md-cell><span ng-repeat=\"baby in item.signups\">{{baby.customer_nickname}} {{baby.customer_name}}</span></td>\n<td md-cell>{{item.room}}</td><td md-cell>{{vm.teacher.name}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"vm.query1.limit\" md-page-select md-page=\"vm.query1.page\" \nmd-total=\"{{vm.courses1._meta.totalCount}}\" md-on-paginate=\"vm.doSearch1\"></md-table-pagination></md-tab><md-tab \nlabel=\"开课中\"><md-table-container class=\"md-padding\"><table md-table class=\"md-data-table\"><thead md-head><tr md-row><th \nmd-column><span class=\"column-title\">Title</span></th><th md-column><span class=\"column-title\">Date in US</span></th>\n<th md-column><span class=\"column-title\">Time US ({{vm.teacher.timezone}})</span></th><th md-column><span \nclass=\"column-title\">Date in China</span></th><th md-column><span class=\"column-title\">Time China</span></th><th \nmd-column><span class=\"column-title\">班级</span></th><th md-column><span class=\"column-title\">上课教室</span></th><th \nmd-column><span class=\"column-title\">主教</span></th></tr></thead><tbody><tr ng-repeat=\"item in vm.courses2.data\"><td \nmd-cell>{{item.name}} - {{item.categories_name}}</td><td md-cell>{{item.course_time_zone | date:\"EEEE, MMMM d,yyyy\" }}\n</td><td md-cell>{{item.course_begintime_zone}} ~ {{item.course_endtime_zone}}</td><td md-cell>\n{{item.course_time | date:\"EEEE, MMMM d,yyyy\" }}</td><td md-cell>{{item.course_begintime}} ~ {{item.course_endtime}}\n</td><td md-cell><span ng-repeat=\"baby in item.signups\">{{baby.customer_nickname}} {{baby.customer_name}}</span></td>\n<td md-cell>{{item.room}}</td><td md-cell>{{vm.teacher.name}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"vm.query2.limit\" md-page-select md-page=\"vm.query2.page\" \nmd-total=\"{{vm.courses2._meta.totalCount}}\" md-on-paginate=\"vm.doSearch2\"></md-table-pagination></md-tab><md-tab \nlabel=\"已结束\"><md-table-container class=\"md-padding\"><table md-table class=\"md-data-table\"><thead md-head><tr md-row><th \nmd-column><span class=\"column-title\">Title</span></th><th md-column><span class=\"column-title\">Date in US</span></th>\n<th md-column><span class=\"column-title\">Time US ({{vm.teacher.timezone}})</span></th><th md-column><span \nclass=\"column-title\">Date in China</span></th><th md-column><span class=\"column-title\">Time China</span></th><th \nmd-column><span class=\"column-title\">班级</span></th><th md-column><span class=\"column-title\">上课教室</span></th><th \nmd-column><span class=\"column-title\">主教</span></th></tr></thead><tbody><tr ng-repeat=\"item in vm.courses3.data\"><td \nmd-cell>{{item.name}} - {{item.categories_name}}</td><td md-cell>{{item.course_time_zone | date:\"EEEE, MMMM d,yyyy\" }}\n</td><td md-cell>{{item.course_begintime_zone}} ~ {{item.course_endtime_zone}}</td><td md-cell>\n{{item.course_time | date:\"EEEE, MMMM d,yyyy\" }}</td><td md-cell>{{item.course_begintime}} ~ {{item.course_endtime}}\n</td><td md-cell><span ng-repeat=\"baby in item.signups\">{{baby.customer_nickname}} {{baby.customer_name}}</span></td>\n<td md-cell>{{item.room}}</td><td md-cell>{{vm.teacher.name}}</td></tr></tbody></table></md-table-container>\n<md-table-pagination md-limit=\"vm.query3.limit\" md-page-select md-page=\"vm.query3.page\" \nmd-total=\"{{vm.courses3._meta.totalCount}}\" md-on-paginate=\"vm.doSearch3\"></md-table-pagination></md-tab></md-tabs>\n</md-content></div></ms-widget-front></ms-widget></div></div><style class=\"ng-scope\">\n.md-data-table td{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\r\n    .md-data-table th{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\r\n    md-input-container .md-errors-spacer{\r\n        min-height: 0px!important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/store/teachers/teachers.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">老师管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">老师列表</div></div>\n<div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.query.username\" translate ng-change=\"vm.doSearch()\" \ntranslate-attr-placeholder=\"登录账号\"></md-input-container><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.query.name\" translate ng-change=\"vm.doSearch()\" \ntranslate-attr-placeholder=\"姓名\"></md-input-container><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.query.mobile\" translate ng-change=\"vm.doSearch()\" \ntranslate-attr-placeholder=\"手机号\"></md-input-container></div></div><div class=\"content white-bg\"><md-table-container>\n<table md-table class=\"md-data-table\"><thead md-head md-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row>\n<th md-column decend-first style=\"padding-left: 15px!important\"><span class=\"column-title\">头像</span></th><th md-column \nmd-order-by=\"username\" decend-first><span class=\"column-title\">登录账号</span></th><th md-column md-order-by=\"name\" \ndecend-first><span class=\"column-title\">姓名</span></th><th md-column md-order-by=\"mobile\" decend-first><span \nclass=\"column-title\">手机号</span></th><th md-column md-order-by=\"email\" decend-first><span class=\"column-title\">邮箱</span>\n</th><th md-column md-order-by=\"sex\" decend-first><span class=\"column-title\">性别</span></th><th md-column \nmd-order-by=\"sex\" decend-first><span class=\"column-title\">岗位类型</span></th><th md-column decend-first></th></tr></thead>\n<tbody><tr ng-repeat=\"teacher in vm.teachers.data\" ui-sref=\"app.store.teachers.detail({id:teacher.id})\" \nclass=\"pointer\"><td md-cell style=\"padding-left: 15px!important\" ui-sref=\"app.store.teachers.detail({id:teacher.id})\">\n<img class=\"md-avatar avatar contact-avatar\" ng-if=\"teacher.avatar\" alt=\"{{teacher.name}}\" \nng-src=\"{{teacher.avatar}}?imageView/2/w/64/h/64\"></td><td md-cell>{{ teacher.username }}</td><td md-cell>\n{{ teacher.name }}</td><td md-cell>{{ teacher.mobile }}</td><td md-cell>{{ teacher.email }}</td><td md-cell>\n{{ teacher.sex_text }}</td><td md-cell>{{ teacher.type }}</td><td md-cell><a ng-if=\"vm.is_cud\" \nng-click=\"vm.openTeacherDialog($event, teacher)\">修改</a> <a ng-if=\"vm.is_cud\" ng-click=\"vm.resetpwd($event, teacher)\">\n重置密码</a></td></tr></tbody></table></md-table-container></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"footer white-bg\"><md-table-pagination md-limit=\"vm.query.limit\" md-page-select md-page=\"vm.query.page\" \nmd-total=\"{{vm.teachers._meta.totalCount}}\" md-on-paginate=\"vm.doSearch\"></md-table-pagination><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-if=\"vm.is_cud\" class=\"md-fab md-mini md-accent md-icon-button mv-25\" \nid=\"add-contact-button\" ng-click=\"vm.openTeacherDialog($event)\" aria-label=\"add contact\" translate \ntranslate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></div>\n</div></div><style>\n.md-data-table td{\n        padding: 10px 0px 10px 0px!important;\n    }\n    .md-data-table th{\n        padding: 10px 0px 10px 0px!important;\n    }\n    md-input-container .md-errors-spacer{\n        min-height: 0px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/system/_content.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"content\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><div class=\"table-title\">分类列表</div><table class=\"simple\" \nms-responsive-table><thead><tr><th>名称</th><th class=\"text-right\">----</th></tr></thead><tfoot><tr><td></td></tr>\n</tfoot><tbody><tr ng-repeat=\"item in vm.categories\"><td class=\"name\">{{item.name}}</td><td class=\"text-right\">---</td>\n</tr></tbody></table></div></div><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-role-button\" \nng-click=\"vm.openRoleDialog($event)\" aria-label=\"add contact\" translate \ntranslate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/apps/store/system/_sidenav.html","<md-content ms-scroll class=\"content\" flex><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" \nng-repeat=\"item in vm.categoryTypes\" ng-click=\"vm.toggleSidenav(item.id)\" ng-class=\"{\'selected\':vm.isActive(item.id)}\">\n<div layout=\"row\" layout-align=\"start center\"><div class=\"h-10 w-10 mr-16\" ng-class=\"label.color\"></div><span \nclass=\"title\">{{item.name}}</span></div></md-button></div></md-content>");
$templateCache.put("app/main/apps/store/system/categories.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">系统管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">分类列表</div></div>\n<div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.query.name\" translate ng-change=\"vm.doSearch()\" \ntranslate-attr-placeholder=\"分类名称\"></md-input-container></div></div><div class=\"content\" md-background-bg layout=\"row\" \nlayout-align=\"start start\"><div class=\"navigation-simple\" flex=\"20\"><md-button class=\"item\" \nng-repeat=\"item in vm.categoryTypes\" ng-click=\"vm.toggleSidenav(item.id)\" ng-class=\"{\'selected\':vm.isActive(item.id)}\">\n<div layout=\"row\" layout-align=\"start center\"><div class=\"h-10 w-10 mr-16\" ng-class=\"label.color\"></div><span \nclass=\"title\">{{item.name}}</span></div></md-button></div><div class=\"main scrollable white-bg md-whiteframe-4dp\" \nms-scroll flex=\"80\"><md-table-container><table md-table class=\"md-data-table\"><thead md-head md-order=\"vm.query.sort\" \nmd-on-reorder=\"vm.doSearch\"><tr md-row><th md-column md-order-by=\"name\" decend-first \nstyle=\"padding-left: 15px!important\"><span class=\"column-title\">名称</span></th><th md-column md-order-by=\"name\" \ndecend-first><span class=\"column-title\">状态</span></th><th md-column md-order-by=\"name\" decend-first><span \nclass=\"column-title\">所属</span></th><th md-column></th></tr></thead><tbody><tr ng-repeat=\"item in vm.categories.data\">\n<td md-cell style=\"padding-left: 15px!important\">{{ item.name }}</td><td md-cell>{{ item.status_text }}</td><td \nmd-cell><span ng-if=\"item.store_id == 0\">全局</span><span ng-if=\"item.store_id > 0\">门店</span></td><td md-cell><a \nng-if=\"vm.checkEdit(categorie.store_id)\" ng-show=\"vm.is_cud\" \nng-click=\"vm.checkEdit(categorie.store_id) ? vm.openCategorieDialog($event, item) :\'\'\">修改</a> <a \nng-if=\"vm.type == 4 && vm.is_kd\" ng-click=\"vm.openKuadianialog($event, item)\">跨店设置</a></td></tr></tbody></table>\n</md-table-container></div></div><div layout=\"row\" layout-align=\"space-between center\" class=\"footer white-bg\">\n<md-table-pagination md-limit=\"vm.query.limit\" md-page-select md-page=\"vm.query.page\" \nmd-total=\"{{vm.categories._meta.totalCount}}\" md-on-paginate=\"vm.doSearch\"></md-table-pagination><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-if=\"vm.is_cud\" style=\"position: fixed;bottom: 8px;right: 8px;padding: 0\" \nclass=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" ng-click=\"vm.openCategorieDialog($event)\" \naria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon></md-button></div></div></div><style>\n.md-data-table td{\n        padding: 10px 0px 10px 0px!important;\n    }\n    .md-data-table th{\n        padding: 10px 0px 10px 0px!important;\n    }\n    md-input-container .md-errors-spacer{\n        min-height: 0px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/system/categories_main.html","<div class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/apps/store/system/_sidenav.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll><div \nclass=\"content md-background-bg\"><div ng-include=\"\'app/main/apps/store/system/_content.html\'\"></div></div></div></div>");
$templateCache.put("app/main/apps/store/system/config.html","<div id=\"customer-wizard\" class=\"page-layout simple fullwidth\" style=\"position: relative\"><div class=\"content\"><div \nlayout=\"row\"><ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nmd-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-text\">系统参数配制</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><div layout-xs=\"column\" layout=\"row\"><div layout-xs=\"column\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"100\"><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" \nflex=\"30\"><label>同时已报名课程数上限</label><input name=\"course_signup_sametime_max\" \nng-model=\"vm.configs.course_signup_sametime_max\" md-autofocus></md-input-container><md-input-container \nclass=\"md-block\" flex=\"30\"><label>预约备选人数上限</label><input name=\"option_num\" ng-model=\"vm.configs.option_num\" \nmd-autofocus></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label>单节课取消次数上限</label><input \nname=\"course_signup_max\" ng-model=\"vm.configs.course_signup_max\" md-autofocus></md-input-container></div><div \nlayout-xs=\"column\" layout=\"row\"></div><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" \nflex=\"30\"><label>开课前N小时内无法取消课程!</label><input name=\"course_cancel\" ng-model=\"vm.configs.course_cancel\" md-autofocus>\n</md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label>开课前N小时批课及开课提醒</label><input \nname=\"course_pizhun\" ng-model=\"vm.configs.course_pizhun\" md-autofocus></md-input-container><md-input-container \nclass=\"md-block\" flex=\"30\"><label>最小开课人数</label><input name=\"open_course_min\" ng-model=\"vm.configs.open_course_min\" \nmd-autofocus></md-input-container></div><div layout-xs=\"column\" layout=\"row\"></div><div layout-xs=\"column\" \nlayout=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label>家长N天内</label><input name=\"within_days\" \nng-model=\"vm.configs.within_days\" md-autofocus></md-input-container><md-input-container class=\"md-block\" flex=\"30\">\n<label>累计旷课X次</label><input name=\"kuangke_max\" ng-model=\"vm.configs.kuangke_max\" md-autofocus></md-input-container>\n<md-input-container class=\"md-block\" flex=\"30\"><label>冻结Y天</label><input name=\"frozen\" ng-model=\"vm.configs.frozen\" \nmd-autofocus></md-input-container></div><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" \nflex=\"30\"><label>课程报名提前截止时间(小时)</label><input name=\"course_signup_time\" ng-model=\"vm.configs.course_signup_time\" \nmd-autofocus></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label>合同到期前N天提醒(天)</label><input \nname=\"contract_expire_day\" ng-model=\"vm.configs.contract_expire_day\" md-autofocus></md-input-container>\n<md-input-container class=\"md-block\" flex=\"30\"><label>会员N天没来上课提醒(天)</label><input name=\"not_course_day\" \nng-model=\"vm.configs.not_course_day\" md-autofocus></md-input-container></div><div layout-xs=\"column\" layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"30\"><label>年卡超过N节</label><input name=\"course_signup_time\" \nng-model=\"vm.configs.course_jie\" md-autofocus></md-input-container><md-input-container class=\"md-block\" flex=\"30\">\n<label>每节按N成本计算</label><input name=\"contract_expire_day\" ng-model=\"vm.configs.course_cost\" md-autofocus>\n</md-input-container></div><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label>\n半年卡超过N节</label><input name=\"course_signup_time\" ng-model=\"vm.configs.course_jie_ban\" md-autofocus></md-input-container>\n<md-input-container class=\"md-block\" flex=\"30\"><label>每节按N成本计算</label><input name=\"contract_expire_day\" \nng-model=\"vm.configs.course_cost_ban\" md-autofocus></md-input-container></div><div layout-xs=\"column\" layout=\"row\" \nng-if=\"vm.current_user_name==\'root\'\"><md-input-container class=\"md-block\" flex=\"30\"><md-switch \nng-model=\"vm.configs.on_system\" aria-label=\"是否开启系统维护\">是否开启系统维护</md-switch></md-input-container><md-input-container \nclass=\"md-block\" flex=\"30\"><label>测试openid</label><input name=\"test_openid\" ng-model=\"vm.configs.test_openid\" \nmd-autofocus></md-input-container></div><div layout-xs=\"column\" layout=\"row\" ng-if=\"vm.current_user_name==\'root\'\">\n<md-input-container class=\"md-block\" flex=\"30\"><label>七牛空间名</label><input name=\"bucket\" ng-model=\"vm.configs.bucket\" \nmd-autofocus></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label>七牛空间域名</label><input \nname=\"uphost\" ng-model=\"vm.configs.uphost\" md-autofocus></md-input-container></div></div></div></form></md-tab-body>\n</md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"send-button md-accent md-raised\" type=\"submit\" ng-click=\"vm.saveConfigSettings()\" \nng-disabled=\"msWizard.formsIncomplete()||vm.sending\">保存</md-button></div></ms-form-wizard></div></div></div>");
$templateCache.put("app/main/apps/store/system/ctime.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">课程时间管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">课程时间管理</div>\n</div></div><div class=\"content white-bg\"><md-table-container><table md-table class=\"md-data-table\"><thead md-head \nmd-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row><th md-column decend-first \nstyle=\"padding-left: 15px!important\"><span class=\"column-title\">编号</span></th><th md-column decend-first \nstyle=\"padding-left: 15px!important\"><span class=\"column-title\">时间</span></th><th></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.ctime_list track by $index\" class=\"pointer\"><td md-cell>{{ $index + 1 }}</td><td md-cell>\n{{ item }}</td><td md-cell><a ng-click=\"vm.openCtimeDialog($event, item)\">修改</a> <a \nng-click=\"vm.deleteCtime($event, item)\">删除</a></td></tr></tbody></table></md-table-container></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"footer white-bg\"><md-table-pagination md-limit=\"vm.query.limit\" \nmd-page-select md-page=\"vm.query.page\" md-total=\"{{vm._meta.totalCount}}\" md-on-paginate=\"vm.doSearch\">\n</md-table-pagination><div layout=\"row\" layout-align=\"end center\"><md-button \nclass=\"md-fab md-mini md-accent md-icon-button mv-25\" id=\"add-contact-button\" ng-click=\"vm.openCtimeDialog($event)\" \naria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon \nmd-font-icon=\"icon-account-plus\"></md-icon></md-button></div></div></div><style>\n.md-data-table td{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\r\n    .md-data-table th{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/store/system/onduty.html","<div id=\"calendar\" class=\"page-layout simple fullwidth\" layout=\"column\"><div class=\"header\" \nng-class=\"vm.currentMonthShort\"><div class=\"header-content\" layout=\"column\" layout-align=\"space-between\"><div \nclass=\"header-top\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-calendar-today\"></md-icon></span><span \nclass=\"logo-text\" translate=\"CALENDAR.CALENDAR\">Calendar</span></div><div class=\"toolbar\" layout=\"row\" \nlayout-align=\"start center\"><md-button class=\"md-icon-button\" aria-label=\"Search\" translate \ntranslate-attr-aria-label=\"CALENDAR.SEARCH\"><md-icon md-font-icon=\"icon-magnify\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.SEARCH\">Search</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.today()\" aria-label=\"Today\" translate translate-attr-aria-label=\"CALENDAR.TODAY\"><md-icon \nmd-font-icon=\"icon-calendar-today\"></md-icon><md-tooltip><span translate=\"CALENDAR.TODAY\">Today</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'agendaDay\')\" aria-label=\"Day\" \ntranslate translate-attr-aria-label=\"CALENDAR.DAY\"><md-icon md-font-icon=\"icon-view-day\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.DAY\">Day</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.calendar.changeView(\'agendaWeek\')\" aria-label=\"Week\" translate translate-attr-aria-label=\"CALENDAR.WEEK\">\n<md-icon md-font-icon=\"icon-view-week\"></md-icon><md-tooltip><span translate=\"CALENDAR.WEEK\">Week</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.calendar.changeView(\'month\')\" aria-label=\"Month\" translate \ntranslate-attr-aria-label=\"CALENDAR.MONTH\"><md-icon md-font-icon=\"icon-view-module\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.MONTH\">Month</span></md-tooltip></md-button></div></div><div class=\"header-bottom\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-icon-button arrow\" ng-click=\"vm.calendar.prev()\" \naria-label=\"Previous\" translate translate-attr-aria-label=\"CALENDAR.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><div class=\"title\">{{vm.calendarView.title}}</div><md-button \nclass=\"md-icon-button arrow\" ng-click=\"vm.calendar.next()\" aria-label=\"Next\" translate \ntranslate-attr-aria-label=\"CALENDAR.NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div></div>\n<md-button class=\"add-event-button md-fab md-warn\" ng-click=\"vm.addEvent($event)\" aria-label=\"Add event\" translate \ntranslate-attr-aria-label=\"CALENDAR.ADD_EVENT\"><md-icon md-font-icon=\"icon-plus\"></md-icon></md-button></div><div \nclass=\"content\"><div id=\"calendarView\" ui-calendar=\"vm.calendarUiConfig.calendar\" ng-model=\"vm.events\" calendar=\"main\">\n</div></div></div>");
$templateCache.put("app/main/apps/store/system/roles.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon md-font-icon=\"icon-home\" class=\"s16\">\n</md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">系统管理</span>\n</div><div class=\"title\" style=\"font-size: 24px!important\">角色列表</div></div></div><div class=\"content\"><div \nclass=\"simple-table-container md-whiteframe-4dp\"><table class=\"simple\" ms-responsive-table><thead><tr><th>角色名称</th><th \nclass=\"text-right\">----</th></tr></thead><tfoot><tr><td></td></tr></tfoot><tbody><tr ng-repeat=\"role in vm.roles\"><td \nclass=\"name\">{{role.role}}</td><td class=\"text-right\">---</td></tr></tbody></table></div></div><md-button \nclass=\"md-fab md-accent md-icon-button\" id=\"add-role-button\" ng-click=\"vm.openRoleDialog($event)\" \naria-label=\"add contact\" translate translate-attr-aria-label=\"CONTACTS.ADD_CONTACT\" \nstyle=\"bottom: 8px;padding: 0;position: fixed; right: 8px\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon>\n</md-button></div>");
$templateCache.put("app/main/apps/store/system/room.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">房间管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">房间列表</div></div>\n</div><div class=\"content white-bg\"><md-table-container><table md-table class=\"md-data-table\"><thead md-head \nmd-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row><th md-column decend-first \nstyle=\"padding-left: 15px!important\"><span class=\"column-title\">编号</span></th><th md-column decend-first \nstyle=\"padding-left: 15px!important\"><span class=\"column-title\">房间</span></th><th></th></tr></thead><tbody><tr \nng-repeat=\"item in vm.rooms\" class=\"pointer\"><td md-cell>{{ $index + 1 }}</td><td md-cell>{{ item.name }}</td><td \nmd-cell><a ng-click=\"vm.openRoomDialog($event, item)\">修改</a> <a ng-click=\"vm.deleteRoom($event, item)\">删除</a></td></tr>\n</tbody></table></md-table-container></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"footer white-bg\"><md-table-pagination md-limit=\"vm.query.limit\" md-page-select md-page=\"vm.query.page\" \nmd-total=\"{{vm._meta.totalCount}}\" md-on-paginate=\"vm.doSearch\"></md-table-pagination><div layout=\"row\" \nlayout-align=\"end center\"><md-button class=\"md-fab md-mini md-accent md-icon-button mv-25\" id=\"add-contact-button\" \nng-click=\"vm.openRoomDialog($event)\" aria-label=\"add contact\" translate \ntranslate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></div>\n</div></div><style>\n.md-data-table td{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\r\n    .md-data-table th{\r\n        padding: 10px 0px 10px 0px!important;\r\n    }\n</style>");
$templateCache.put("app/main/apps/store/system/setstore.html","<div id=\"customer-wizard\" class=\"page-layout simple fullwidth\" style=\"position: relative\"><div class=\"content\"><div \nlayout=\"row\"><ms-form-wizard flex><md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" \nmd-center-tabs=\"true\"><md-tab><md-tab-label><span class=\"ms-form-wizard-step-label\"><span \nclass=\"ms-form-wizard-step-text\">上课地点</span></span></md-tab-label><md-tab-body><form name=\"wizardStep1\" \nclass=\"md-inline-form\" ms-form-wizard-form novalidate><div layout-xs=\"column\" layout=\"row\"><div layout-xs=\"column\" \nlayout=\"column\" flex=\"100\" flex-gt-xs=\"100\"><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" \nflex=\"100\"><label>配置上课地点可选值</label><input name=\"address_list\" ng-model=\"vm.store.settings.address_list\" md-autofocus>\n</md-input-container></div><div layout-xs=\"column\" layout=\"row\"><label>多个用,号隔开</label></div></div></div></form>\n</md-tab-body></md-tab></md-tabs><div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"send-button md-accent md-raised\" type=\"submit\" ng-click=\"vm.saveStoreSettings()\" \nng-disabled=\"msWizard.formsIncomplete()||vm.sending\">保存</md-button></div></ms-form-wizard></div></div></div>");
$templateCache.put("app/main/apps/store/system/sms-send-logs.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\" \nstyle=\"padding-top:35px!important;min-height: 76px!important;height: 76px!important;max-height: 76px!important\"><div \nlayout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" \nstyle=\"margin-bottom:12px!important\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">系统管理</span></div><div \nclass=\"title\" style=\"font-size: 24px!important\">短信发送日志</div></div><div class=\"search-input-wrapper\" layout=\"row\" \nlayout-align=\"start center\"><label for=\"search\"><md-icon md-font-icon=\"icon-magnify\"></md-icon></label>\n<md-input-container md-no-float class=\"m-0\"><input id=\"search\" placeholder=\"Search for anyone\" type=\"text\" \nng-model=\"vm.query.reciver_username\" translate ng-change=\"vm.doSearch()\" translate-attr-placeholder=\"接收人\">\n</md-input-container><md-input-container md-no-float class=\"m-0\"><input id=\"search\" placeholder=\"Search for anyone\" \ntype=\"text\" ng-model=\"vm.query.reciver_mobile\" translate ng-change=\"vm.doSearch()\" translate-attr-placeholder=\"接收手机号\">\n</md-input-container></div></div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><md-table-container>\n<table md-table class=\"md-data-table\"><thead md-head md-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row>\n<th md-column md-order-by=\"send_time\" decend-first style=\"padding-left: 15px!important\"><span class=\"column-title\">发送时间\n</span></th><th md-column md-order-by=\"reciver_username\" decend-first><span class=\"column-title\">接收人</span></th><th \nmd-column md-order-by=\"reciver_mobile\" decend-first><span class=\"column-title\">接收手机号</span></th><th md-column \nmd-order-by=\"content\" decend-first><span class=\"column-title\">短信内容</span></th><th md-column md-order-by=\"status\" \ndecend-first><span class=\"column-title\">到达状态</span></th><th></th></tr></thead><tbody md-body><tr \nng-repeat=\"item in vm.smssendlogs.data\"><td md-cell style=\"padding-left: 15px!important\">{{ item.send_time }}</td><td \nmd-cell>{{ item.reciver_username }}</td><td md-cell>{{ item.reciver_mobile }}</td><td md-cell>{{ item.content }}</td>\n<td md-cell>{{ item.status_text }}</td></tr></tbody></table></md-table-container></div></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"footer white-bg\"><md-table-pagination md-limit=\"vm.query.limit\" \nmd-page-select md-page=\"vm.query.page\" md-total=\"{{vm.smssendlogs._meta.totalCount}}\" md-on-paginate=\"vm.doSearch\">\n</md-table-pagination></div></div><style>\n.md-data-table td{\n        padding: 10px 0px 10px 0px!important;\n    }\n    .md-data-table th{\n        padding: 10px 0px 10px 0px!important;\n    }\n    md-input-container .md-errors-spacer{\n        min-height: 0px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/system/sms-templates.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">系统管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">短信模板</div></div>\n</div><div class=\"content\"><div class=\"white-bg md-whiteframe-4dp\"><md-table-container><table md-table \nclass=\"md-data-table\"><thead md-head><tr md-row><th md-column decend-first style=\"padding-left: 15px!important\"><span \nclass=\"column-title\">标题</span></th><th md-column decend-first><span class=\"column-title\">内容</span> <span \nstyle=\"color: red;margin-left: 15px;font-size: 16px\">短信剩余条数：{{vm.total}}</span></th><th></th></tr></thead><tbody \nmd-body><tr ng-repeat=\"item in vm.smstemplates.data\"><td md-cell style=\"padding-left: 15px!important\">{{ item.title }}\n</td><td md-cell>{{ item.content }}</td></tr></tbody></table></md-table-container></div></div></div><style>\n.md-data-table td{\n        padding: 10px 10px 10px 0px!important;\n    }\n    .md-data-table th{\n        padding: 10px 10px 10px 0px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/system/wechat-send-logs.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">系统管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">微信发送日志</div></div>\n<div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.query.parent_name\" translate ng-change=\"vm.doSearch()\" \ntranslate-attr-placeholder=\"家长姓名\"></md-input-container><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.query.customer_name\" translate ng-change=\"vm.doSearch()\" \ntranslate-attr-placeholder=\"学生姓名\"></md-input-container></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-table-container><table md-table class=\"md-data-table\"><thead md-head \nmd-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row><th md-column md-order-by=\"parent_name\" decend-first \nstyle=\"padding-left: 15px!important\"><span class=\"column-title\">家长姓名</span></th><th md-column \nmd-order-by=\"customer_name\" decend-first><span class=\"column-title\">学生姓名</span></th><th md-column \nmd-order-by=\"content\" decend-first><span class=\"column-title\">内容</span></th><th md-column md-order-by=\"remark\" \ndecend-first><span class=\"column-title\">备注</span></th><th md-column md-order-by=\"send_time\" decend-first><span \nclass=\"column-title\">发送时间</span></th><th md-column md-order-by=\"status\" decend-first><span class=\"column-title\">到达状态\n</span></th><th></th></tr></thead><tbody md-body><tr ng-repeat=\"item in vm.wechatsendlogs.data\"><td md-cell \nstyle=\"padding-left: 15px!important\">{{ item.parent_name }}</td><td md-cell>{{ item.customer_name }}</td><td md-cell>\n{{ item.content }}</td><td md-cell>{{ item.remark }}</td><td md-cell>{{ item.send_time }}</td><td md-cell>\n{{ item.status_text }}</td></tr></tbody></table></md-table-container></div></div><div layout=\"row\" \nlayout-align=\"space-between center\" class=\"footer white-bg\"><md-table-pagination md-limit=\"vm.query.limit\" \nmd-page-select md-page=\"vm.query.page\" md-total=\"{{vm.wechatsendlogs._meta.totalCount}}\" md-on-paginate=\"vm.doSearch\">\n</md-table-pagination></div></div><style>\n.md-data-table td{\n        padding: 10px 0px 10px 0px!important;\n    }\n    .md-data-table th{\n        padding: 10px 0px 10px 0px!important;\n    }\n    md-input-container .md-errors-spacer{\n        min-height: 0px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/system/wechat-temp.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">系统管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">微信发送日志</div></div>\n<div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.query.parent_name\" translate ng-change=\"vm.doSearch()\" \ntranslate-attr-placeholder=\"家长姓名\"></md-input-container><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.query.customer_name\" translate ng-change=\"vm.doSearch()\" \ntranslate-attr-placeholder=\"学生姓名\"></md-input-container></div></div><div class=\"content\"><div \nclass=\"white-bg md-whiteframe-4dp\"><md-table-container><table md-table class=\"md-data-table\"><thead md-head \nmd-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row><th md-column md-order-by=\"parent_name\" decend-first \nstyle=\"padding-left: 15px!important\"><span class=\"column-title\">模板用途</span></th><th md-column \nmd-order-by=\"customer_name\" decend-first><span class=\"column-title\">模板编号</span></th><th md-column \nmd-order-by=\"content\" decend-first><span class=\"column-title\">模板名称</span></th><th md-column md-order-by=\"remark\" \ndecend-first><span class=\"column-title\">发送内容</span></th><th md-column md-order-by=\"send_time\" decend-first><span \nclass=\"column-title\">状态</span></th><th md-column md-order-by=\"status\" decend-first><span class=\"column-title\">模板ID\n</span></th></tr></thead><tbody md-body><tr ng-repeat=\"item in vm.temps\"><td md-cell \nstyle=\"padding-left: 15px!important\"><span ng-bind-html=\"item.yongtu\"></span></td><td md-cell><span \nng-bind-html=\"item.number\"></span></td><td md-cell><span ng-bind-html=\"item.name\"></span></td><td md-cell><div \nstyle=\"background-color: #f5f5f5;border: 1px solid #e3e3e3;border-radius: 4px;padding: 19px\"><span \nng-bind-html=\"item.content\"></span></div></td><td md-cell><md-input-container class=\"md-block\" flex=\"30\"><md-switch \nng-model=\"item.status==1\"></md-switch></md-input-container></td><td md-cell><span ng-bind-html=\"item.id\"></span></td>\n</tr></tbody></table></md-table-container></div></div><div layout=\"row\" layout-align=\"space-between center\" \nclass=\"footer white-bg\"></div></div><style>\n.md-data-table td{\n        padding: 10px 0px 10px 0px!important;\n    }\n    .md-data-table th{\n        padding: 10px 0px 10px 0px!important;\n    }\n    md-input-container .md-errors-spacer{\n        min-height: 0px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/users/_msg.html","<div class=\"content\" style=\"color: #a94442\"><ul><li ng-repeat=\"v in vm.error_arr\">{{v.message}}</li></ul></div>");
$templateCache.put("app/main/apps/store/users/users.html","<div id=\"user-list\" class=\"page-layout simple fullwidth datalist-content\" style=\"position: relative\"><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\">\n<div class=\"breadcrumb\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:12px!important\"><md-icon \nmd-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon md-font-icon=\"icon-chevron-right\" class=\"s16 separator\">\n</md-icon><span class=\"parent\">用户管理</span></div><div class=\"title\" style=\"font-size: 24px!important\">用户列表</div></div>\n<div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\"><md-icon \nmd-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.query.username\" translate ng-change=\"vm.doSearch()\" \ntranslate-attr-placeholder=\"登录账号\"></md-input-container><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.query.name\" translate ng-change=\"vm.doSearch()\" \ntranslate-attr-placeholder=\"姓名\"></md-input-container><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.query.mobile\" translate ng-change=\"vm.doSearch()\" \ntranslate-attr-placeholder=\"手机号\"></md-input-container></div></div><md-sidenav \nclass=\"sidenav main-sidenav md-hue-2 m-24\" ms-scroll md-is-locked-open=\"true\" layout=\"column\" flex=\"100\" \nmd-component-id=\"sidenav\" ms-sidenav-helper><div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\">\n<span class=\"font-weight-500 font-size-16\">用户角色</span></div><md-divider></md-divider><div ms-scroll \nclass=\"content scrollable\"><md-list><md-list-item ng-click=\"vm.toggleSidenav(item.id)\" \nng-class=\"{\'selected\':vm.isActive(item.id)}\" ng-repeat=\"item in vm.roles\"><p>{{item.role}}</p></md-list-item></md-list>\n</div></md-sidenav><div class=\"content white-bg\"><md-table-container><table md-table class=\"md-data-table\"><thead \nmd-head md-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row><th md-column decend-first \nstyle=\"padding-left: 15px!important\"><span class=\"column-title\">头像</span></th><th md-column md-order-by=\"username\" \ndecend-first><span class=\"column-title\">登录账号</span></th><th md-column md-order-by=\"name\" decend-first><span \nclass=\"column-title\">姓名</span></th><th md-column md-order-by=\"sex\" decend-first><span class=\"column-title\">性别</span>\n</th><th md-column md-order-by=\"mobile\" decend-first><span class=\"column-title\">手机号</span></th><th md-column \nmd-order-by=\"email\" decend-first><span class=\"column-title\">邮箱</span></th><th></th></tr></thead><tbody><tr \nng-repeat=\"user in vm.users.data\"><td md-cell style=\"padding-left: 15px!important\"><img \nclass=\"md-avatar avatar contact-avatar\" ng-if=\"user.avatar\" alt=\"{{user.name}}\" \nng-src=\"{{user.avatar}}?imageView/2/w/64/h/64\"></td><td md-cell>{{ user.username }}</td><td md-cell>{{ user.name }}\n</td><td md-cell>{{ user.sex_text }}</td><td md-cell>{{ user.mobile }}</td><td md-cell>{{ user.email }}</td><td \nmd-cell><a ng-if=\"vm.is_cud\" ng-click=\"vm.openUserDialog($event, user)\">修改</a> <a ng-if=\"vm.is_cud\" \nng-click=\"vm.resetpwdDialog($event, user)\">重置密码</a> <a ng-if=\"vm.is_cud\" ng-click=\"vm.setstoreDialog($event, user)\">\n设置门店</a> <a ng-if=\"vm.is_cud\" ng-click=\"vm.setroleDialog($event, user)\">设置角色</a></td></tr></tbody></table>\n</md-table-container></div><div layout=\"row\" layout-align=\"space-between center\" class=\"footer white-bg\">\n<md-table-pagination md-limit=\"vm.query.limit\" md-page-select md-page=\"vm.query.page\" \nmd-total=\"{{vm.users._meta.totalCount}}\" md-on-paginate=\"vm.doSearch\"></md-table-pagination><div layout=\"row\" \nlayout-align=\"end center\"><md-button ng-if=\"vm.is_cud\" class=\"md-fab md-mini md-accent md-icon-button mv-25\" \nid=\"add-contact-button\" ng-click=\"vm.openUserDialog($event)\" aria-label=\"add contact\" translate \ntranslate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></div>\n</div></div><style>\n.md-data-table td{\n        padding: 10px 0px 10px 0px!important;\n    }\n    .md-data-table th{\n        padding: 10px 0px 10px 0px!important;\n    }\n    md-input-container .md-errors-spacer{\n        min-height: 0px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/users/users1.html","<div id=\"teachers\" class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" hide-gt-md ng-click=\"vm.toggleSidenav(\'sidenav\')\" aria-label=\"Toggle sidenav\" \ntranslate translate-attr-aria-label=\"CONTACTS.TOGGLE_SIDENAV\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon>\n</md-button><div class=\"logo\" layout=\"row\" layout-align=\"start center\"><span class=\"logo-icon\"><md-icon \nmd-font-icon=\"icon-account-box\" class=\"s24\"></md-icon></span><span class=\"logo-text\" translate=\"TEACHERS.TEACHERS\">老师\n</span></div></div><div class=\"search-input-wrapper\" layout=\"row\" layout-align=\"start center\"><label for=\"search\">\n<md-icon md-font-icon=\"icon-magnify\"></md-icon></label><md-input-container md-no-float class=\"m-0\"><input id=\"search\" \nplaceholder=\"Search for anyone\" type=\"text\" ng-model=\"vm.search\" translate \ntranslate-attr-placeholder=\"CONTACTS.SEARCH_FOR_ANYONE\"></md-input-container></div></div><md-sidenav class=\"sidenav\" \nflex=\"30\">ddddffsdf<div ng-include=\"\'app/main/apps/store/system/_sidenav.html\'\"></div>sdfsfsfsdf</md-sidenav><div \nclass=\"content\" md-background-bg flex=\"70\"><div class=\"main scrollable center\" ms-scroll flex><md-list \nclass=\"contacts-list\"><md-subheader class=\"md-no-sticky md-white-bg\"><div layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"list-title\" layout=\"row\" layout-align=\"start center\" \nng-hide=\"editGroupForm.$visible\"><span translate=\"共\">共</span><span ng-if=\"filteredUsers.length\" \nclass=\"secondary-text contacts-count\">({{filteredUsers.length}})</span></div><div class=\"edit-group-form\" \nng-show=\"vm.listType.name\" layout=\"row\" layout-align=\"start center\"><span ng-show=\"editGroupForm.$visible\" \neditable-text=\"vm.listType.name\" e-form=\"editGroupForm\" onaftersave=\"vm.editGroup()\"></span><md-button \nclass=\"md-icon-button edit-group-button\" ng-click=\"editGroupForm.$show()\" ng-hide=\"editGroupForm.$visible\" \naria-label=\"edit group name\" translate translate-attr-label=\"CONTACTS.EDIT_GROUP_NAME\"><md-icon \nmd-font-icon=\"icon-pencil s18\"></md-icon></md-button><md-button class=\"md-icon-button edit-group-button\" \nng-click=\"vm.deleteGroup($event)\" ng-hide=\"editGroupForm.$visible\" aria-label=\"delete group\" translate \ntranslate-attr-label=\"CONTACTS.DELETE_GROUP\"><md-icon md-font-icon=\"icon-delete s18\"></md-icon></md-button></div><div \nflex></div><md-menu><md-button class=\"md-icon-button\" aria-label=\"Sort\" translate \ntranslate-attr-aria-label=\"CONTACTS.SORT\"><md-icon md-font-icon=\"icon-sort-alphabetical\" \nng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.listOrder = \'username\';vm.listOrderAsc = false\" \nng-style=\"vm.listOrder === \'username\' && vm.listOrderAsc=== false && {\'font-weight\':\'500\'}\"><span \ntranslate=\"CONTACTS.FIRST_NAME\">用户名</span> <small translate=\"CONTACTS.A_TO_Z\">(A to Z)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.listOrder = \'name\'; vm.listOrderAsc = true\" \nng-style=\"vm.listOrder === \'name\' && vm.listOrderAsc=== true && {\'font-weight\':\'500\'}\"><span \ntranslate=\"CONTACTS.FIRST_NAME\">姓名</span> <small translate=\"CONTACTS.Z_TO_A\">(Z to A)</small></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.listOrder = \'email\';vm.listOrderAsc = false\" \nng-style=\"vm.listOrder === \'email\' && vm.listOrderAsc=== false && {\'font-weight\':\'500\'}\"><span \ntranslate=\"CONTACTS.LAST_NAME\">邮箱</span> <small translate=\"CONTACTS.A_TO_Z\">(A to Z)</small></md-button></md-menu-item>\n<md-menu-item><md-button ng-click=\"vm.listOrder = \'store_name\'; vm.listOrderAsc = true\" \nng-style=\"vm.listOrder === \'store_name\' && vm.listOrderAsc=== true && {\'font-weight\':\'500\'}\"><span \ntranslate=\"CONTACTS.LAST_NAME\">门店</span> <small translate=\"CONTACTS.Z_TO_A\">(Z to A)</small></md-button></md-menu-item>\n</md-menu-content></md-menu></div></md-subheader><md-list-item class=\"contact-item md-white-bg\" md-ink-ripple \nng-repeat=\"contact in vm.teachers | filter: vm.search | filter:query as filteredUsers track by contact.id\" \nng-click=\"vm.openTeacherDialog($event, contact)\" \nng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': filteredUsers.length - $index}\" \nng-class=\"{\'selected\': vm.isSelected(contact)}\"><img class=\"md-avatar\" ng-if=\"contact.avatar\" alt=\"{{contact.name}}\" \nng-src=\"{{contact.avatar}}\"><p class=\"job-title text-truncate show-gt-lg\">{{contact.name}}</p><p \nclass=\"text-truncate font-weight-600\">{{contact.username}}</p><p class=\"email text-truncate show-gt-sm\">\n{{contact.email}}</p><p class=\"phone text-truncate show-gt-md\">{{contact.mobile}}</p><p \nclass=\"company text-truncate show-gt-lg\">{{contact.sex == 0 ? \'女\' : \'男\'}}</p><p \nclass=\"company text-truncate show-gt-lg\">{{contact.store_name}}</p></md-list-item></md-list><md-list-item \nclass=\"no-results md-white-bg\" ng-show=\"filteredContacts.length === 0\"><p translate=\"CONTACTS.NO_RESULTS\">暂无数据...</p>\n</md-list-item></div></div><md-button class=\"md-fab md-accent md-icon-button\" id=\"add-contact-button\" \nng-click=\"vm.openTeacherDialog($event)\" aria-label=\"add contact\" translate \ntranslate-attr-aria-label=\"CONTACTS.ADD_CONTACT\"><md-icon md-font-icon=\"icon-account-plus\"></md-icon></md-button></div>");
$templateCache.put("app/main/components/charts/c3/c3.html","<div id=\"c3\" class=\"page-layout simple fullwidth doc-page chart-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">CHARTS</span></div><div \nclass=\"title\">C3.js</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"http://jettro.github.io/c3-angular-directive/\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div \nclass=\"md-title\">Line Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"line-chart\"><chart-column \ncolumn-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" column-type=\"line\">\n<chart-column column-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" column-values=\"50,20,10,40,15,25\" \ncolumn-type=\"line\"><chart-grid show-x=\"false\" show-y=\"true\"></chart-grid></c3chart></div><div class=\"md-title\">\nLine Area Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"line-area-chart\"><chart-column \ncolumn-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" column-type=\"area\">\n<chart-column column-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" column-values=\"50,20,10,40,15,25\" \ncolumn-type=\"area\"><chart-grid show-x=\"false\" show-y=\"true\"></chart-grid></c3chart></div><div class=\"md-title\">\nSpline Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"spline-chart\"><chart-column \ncolumn-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" column-type=\"spline\">\n<chart-column column-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" column-values=\"50,20,10,40,15,25\" \ncolumn-type=\"spline\"><chart-grid show-x=\"false\" show-y=\"true\"></chart-grid></c3chart></div><div class=\"md-title\">\nSpline Area Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"spline-area-chart\"><chart-column \ncolumn-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" \ncolumn-type=\"area-spline\"><chart-column column-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" \ncolumn-values=\"50,20,10,40,15,25\" column-type=\"area-spline\"><chart-grid show-x=\"false\" show-y=\"true\"></chart-grid>\n</c3chart></div><div class=\"md-title\">Step Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart \nbindto-id=\"step-chart\"><chart-column column-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" \ncolumn-values=\"30,200,100,400,150,250\" column-type=\"step\"><chart-column column-id=\"data 2\" column-name=\"Data 2\" \ncolumn-color=\"green\" column-values=\"50,20,10,40,15,25\" column-type=\"step\"><chart-grid show-x=\"false\" show-y=\"true\">\n</chart-grid></c3chart></div><div class=\"md-title\">Step Area Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart \nbindto-id=\"step-area-chart\"><chart-column column-id=\"data 1\" column-name=\"Data 1\" column-color=\"red\" \ncolumn-values=\"30,200,100,400,150,250\" column-type=\"area-step\"><chart-column column-id=\"data 2\" column-name=\"Data 2\" \ncolumn-color=\"green\" column-values=\"50,20,10,40,15,25\" column-type=\"area-step\"><chart-grid show-x=\"false\" \nshow-y=\"true\"></chart-grid></c3chart></div><div class=\"md-title\">Stacked Bar Chart</div><div \nclass=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"stacked-bar-plot1-chart\"><chart-column column-id=\"data 1\" \ncolumn-name=\"Data 1\" column-color=\"red\" column-values=\"30,200,100,400,150,250\" column-type=\"bar\"><chart-column \ncolumn-id=\"data 2\" column-name=\"Data 2\" column-color=\"green\" column-values=\"50,20,10,40,15,25\" column-type=\"bar\">\n<chart-group group-values=\"data 1,data 2\"></c3chart></div><div class=\"md-title\">Scatter Plot Chart</div><div \nclass=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"scatter-plot2-chart\"><chart-column column-id=\"Data 1 x\" \ncolumn-values=\"3.2, 3.2, 3.1, 2.3, 2.8, 2.8, 3.3, 2.4, 2.9, 2.7, 2.0, 3.0, 2.2, 2.9, 2.9, 3.1, 3.0, 2.7, 2.2, 2.5, 3.2, 2.8, 2.5, 2.8, 2.9, 3.0, 2.8, 3.0, 2.9, 2.6, 2.4, 2.4, 2.7, 2.7, 3.0, 3.4, 3.1, 2.3, 3.0, 2.5, 2.6, 3.0, 2.6, 2.3, 2.7, 3.0, 2.9, 2.9, 2.5, 2.8\">\n<chart-column column-id=\"Data 2 x\" \ncolumn-values=\"3.3, 2.7, 3.0, 2.9, 3.0, 3.0, 2.5, 2.9, 2.5, 3.6, 3.2, 2.7, 3.0, 2.5, 2.8, 3.2, 3.0, 3.8, 2.6, 2.2, 3.2, 2.8, 2.8, 2.7, 3.3, 3.2, 2.8, 3.0, 2.8, 3.0, 2.8, 3.8, 2.8, 2.8, 2.6, 3.0, 3.4, 3.1, 3.0, 3.1, 3.1, 3.1, 2.7, 3.2, 3.3, 3.0, 2.5, 3.0, 3.4, 3.0\">\n<chart-column column-id=\"Data 1\" \ncolumn-values=\"1.4, 1.5, 1.5, 1.3, 1.5, 1.3, 1.6, 1.0, 1.3, 1.4, 1.0, 1.5, 1.0, 1.4, 1.3, 1.4, 1.5, 1.0, 1.5, 1.1, 1.8, 1.3, 1.5, 1.2, 1.3, 1.4, 1.4, 1.7, 1.5, 1.0, 1.1, 1.0, 1.2, 1.6, 1.5, 1.6, 1.5, 1.3, 1.3, 1.3, 1.2, 1.4, 1.2, 1.0, 1.3, 1.2, 1.3, 1.3, 1.1, 1.3\" \ncolumn-type=\"scatter\"><chart-column column-id=\"Data 2\" \ncolumn-values=\"2.5, 1.9, 2.1, 1.8, 2.2, 2.1, 1.7, 1.8, 1.8, 2.5, 2.0, 1.9, 2.1, 2.0, 2.4, 2.3, 1.8, 2.2, 2.3, 1.5, 2.3, 2.0, 2.0, 1.8, 2.1, 1.8, 1.8, 1.8, 2.1, 1.6, 1.9, 2.0, 2.2, 1.5, 1.4, 2.3, 2.4, 1.8, 1.8, 2.1, 2.4, 2.3, 1.9, 2.3, 2.5, 2.3, 1.9, 2.0, 2.3, 1.8\" \ncolumn-type=\"scatter\"><chart-axes values-xs=\"Data 1:Data 1 x,Data 2:Data 2 x\"></c3chart></div><div class=\"md-title\">\nPie Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"pie-plot1-chart\"><chart-column \ncolumn-id=\"Data 1\" column-values=\"70\" column-type=\"pie\"><chart-column column-id=\"Data 2\" column-values=\"35\" \ncolumn-type=\"pie\"><chart-column column-id=\"Data 3\" column-values=\"60\" column-type=\"pie\"><chart-pie expand=\"true\">\n</c3chart></div><div class=\"md-title\">Donut Chart</div><div class=\"card md-whiteframe-4dp\"><c3chart \nbindto-id=\"donut-plot1-chart\"><chart-column column-id=\"Data 1\" column-values=\"70\" column-type=\"donut\"><chart-column \ncolumn-id=\"Data 2\" column-values=\"35\" column-type=\"donut\"><chart-column column-id=\"Data 3\" column-values=\"60\" \ncolumn-type=\"donut\"><chart-donut title=\"Donut\" width=\"60\"></c3chart></div><div class=\"md-title\">Gauge Chart</div><div \nclass=\"card md-whiteframe-4dp\"><c3chart bindto-id=\"gauge-plot1-chart\"><chart-column column-id=\"Data 1\" \ncolumn-values=\"70\" column-type=\"gauge\"><chart-gauge min=\"50\" max=\"75\" units=\" hours\" width=\"39\"></c3chart></div></div>\n</div>");
$templateCache.put("app/main/components/charts/chart-js/chart-js.html","<div id=\"chartJs\" class=\"page-layout simple fullwidth doc-page chart-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">CHARTS</span></div><div \nclass=\"title\">Chart.js</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"https://github.com/jtblin/angular-chart.js\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div \nclass=\"md-title\">Line Chart</div><div class=\"card md-whiteframe-4dp\"><canvas id=\"line\" class=\"chart chart-line\" \nchart-data=\"vm.lineChart.data\" chart-labels=\"vm.lineChart.labels\" chart-legend=\"true\" \nchart-series=\"vm.lineChart.series\"></canvas></div><div class=\"md-title\">Bar Chart</div><div \nclass=\"card md-whiteframe-4dp\"><canvas id=\"bar\" class=\"chart chart-bar\" chart-data=\"vm.barChart.data\" \nchart-labels=\"vm.barChart.labels\"></canvas></div><div class=\"md-title\">Doughnut Chart</div><div \nclass=\"card md-whiteframe-4dp\"><canvas id=\"doughnut\" class=\"chart chart-doughnut\" chart-data=\"vm.doughnutChart.data\" \nchart-labels=\"vm.doughnutChart.labels\"></canvas></div><div class=\"md-title\">Radar Chart</div><div \nclass=\"card md-whiteframe-4dp\"><canvas id=\"radar\" class=\"chart chart-radar\" chart-data=\"vm.radarChart.data\" \nchart-labels=\"vm.radarChart.labels\"></canvas></div><div class=\"md-title\">Pie Chart</div><div \nclass=\"card md-whiteframe-4dp\"><canvas id=\"pie\" class=\"chart chart-pie\" chart-data=\"vm.pieChart.data\" \nchart-labels=\"vm.pieChart.labels\"></canvas></div><div class=\"md-title\">Polar Area Chart</div><div \nclass=\"card md-whiteframe-4dp\"><canvas id=\"polar-area\" class=\"chart chart-polar-area\" chart-data=\"vm.polarChart.data\" \nchart-labels=\"vm.polarChart.labels\"></canvas></div></div></div>");
$templateCache.put("app/main/components/charts/chartist/chartist.html","<div id=\"chartist\" class=\"page-layout simple fullwidth doc-page chart-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">CHARTS</span></div><div \nclass=\"title\">Chartist</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"https://github.com/paradox41/angular-chartist.js\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div \nclass=\"md-title\">Line Chart</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" \nchartist-data=\"vm.lineChart.data\" chartist-chart-type=\"Line\" chartist-chart-options=\"vm.lineChart.options\"></chartist>\n</div><div class=\"md-title\">Line Area Chart</div><div class=\"card md-whiteframe-4dp\"><chartist \nclass=\"ct-chart ct-golden-section\" chartist-data=\"vm.lineAreaChart.data\" chartist-chart-type=\"Line\" \nchartist-chart-options=\"vm.lineAreaChart.options\"></chartist></div><div class=\"md-title\">\nBi-polar Line Chart With Area Only</div><div class=\"card md-whiteframe-4dp\"><chartist \nclass=\"ct-chart ct-golden-section\" chartist-data=\"vm.biPolarLineChart.data\" chartist-chart-type=\"Line\" \nchartist-chart-options=\"vm.biPolarLineChart.options\"></chartist></div><div class=\"md-title\">Bar Chart</div><div \nclass=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" chartist-data=\"vm.barChart.data\" \nchartist-chart-type=\"Bar\" chartist-chart-options=\"vm.barChart.options\" \nchartist-responsive-options=\"vm.barChart.responsiveOptions\"></chartist></div><div class=\"md-title\">Horizontal Bar Chart\n</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" \nchartist-data=\"vm.horizontalBarChart.data\" chartist-chart-type=\"Bar\" \nchartist-chart-options=\"vm.horizontalBarChart.options\"></chartist></div><div class=\"md-title\">Bi-polar Bar Chart</div>\n<div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" \nchartist-data=\"vm.biPolarBarChart.data\" chartist-chart-type=\"Bar\" chartist-chart-options=\"vm.biPolarBarChart.options\">\n</chartist></div><div class=\"md-title\">Stacked Bar Chart</div><div class=\"card md-whiteframe-4dp\"><chartist \nclass=\"ct-chart ct-golden-section\" chartist-data=\"vm.stackedBarChart.data\" chartist-chart-type=\"Bar\" \nchartist-chart-options=\"vm.stackedBarChart.options\" chartist-events=\"vm.stackedBarChart.events\"></chartist></div><div \nclass=\"md-title\">Doughnut Chart</div><div class=\"card md-whiteframe-4dp\"><chartist class=\"ct-chart ct-golden-section\" \nchartist-data=\"vm.donutChart.data\" chartist-chart-type=\"Pie\" chartist-chart-options=\"vm.donutChart.options\"></chartist>\n</div><div class=\"md-title\">Pie Chart</div><div class=\"card md-whiteframe-4dp\"><chartist \nclass=\"ct-chart ct-golden-section\" chartist-data=\"vm.pieChart.data\" chartist-chart-type=\"Pie\" \nchartist-chart-options=\"vm.pieChart.options\" chartist-responsive-options=\"vm.pieChart.responsiveOptions\"></chartist>\n</div><div class=\"md-title\">Gauge Chart</div><div class=\"card md-whiteframe-4dp\"><chartist \nclass=\"ct-chart ct-golden-section\" chartist-data=\"vm.gaugeChart.data\" chartist-chart-type=\"Pie\" \nchartist-chart-options=\"vm.gaugeChart.options\"></chartist></div></div></div>");
$templateCache.put("app/main/components/charts/nvd3/nvd3.html","<div id=\"nvd3\" class=\"page-layout simple fullwidth doc-page chart-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">CHARTS</span></div><div \nclass=\"title\">nvD3</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"http://krispo.github.io/angular-nvd3/#/\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div \nclass=\"md-title\">Line Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.lineChart.options\" \ndata=\"vm.lineChart.data\" class=\"with-3d-shadow with-transitions\"></nvd3></div><div class=\"md-title\">Stacked Area Chart\n</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.stackedAreaChart.options\" data=\"vm.stackedAreaChart.data\">\n</nvd3></div><div class=\"md-title\">Sparkline Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 \noptions=\"vm.sparklineChart.options\" data=\"vm.sparklineChart.data\"></nvd3></div><div class=\"md-title\">\nHistorical Bar Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.historicalBarChart.options\" \ndata=\"vm.historicalBarChart.data\"></nvd3></div><div class=\"md-title\">Multi Bar Horizontal Chart</div><div \nclass=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.multiBarHorizontalChart.options\" \ndata=\"vm.multiBarHorizontalChart.data\"></nvd3></div><div class=\"md-title\">Pie Chart</div><div \nclass=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.pieChart.options\" data=\"vm.pieChart.data\"></nvd3></div><div \nclass=\"md-title\">Donut Chart</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.donutChart.options\" \ndata=\"vm.donutChart.data\"></nvd3></div><div class=\"md-title\">Bullet Chart</div><div class=\"card md-whiteframe-4dp\">\n<nvd3 options=\"vm.bulletChart.options\" data=\"vm.bulletChart.data\"></nvd3></div><div class=\"md-title\">Scatter Chart\n</div><div class=\"card md-whiteframe-4dp\"><nvd3 options=\"vm.scatterChart.options\" data=\"vm.scatterChart.data\"></nvd3>\n</div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-card.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">COMPONENTS</span></div><div \nclass=\"title\">ms-card</div></div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><p>\n                <hljs language=\"html\" class=\"source-code\">\n                    <ms-card template=\"PATH_TO_TEMPLATE\" ng-model=\"CARD_MODEL_DATA\"></ms-card>\n                </hljs>\n                </p><span class=\"h2 pt-16\">Description:</span><p><b>ms-card</b>\n directive can be used for creating cards that follow Google\'s Material Design specifications. Currently it has 10 different pre-defined templates but you can always create your own templates and use them with the directive.\n</p><div class=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\"><thead><tr><th>Attribute</th><th>\nDescription</th></tr></thead><tbody><tr><td>template</td><td>\nThis attribute must be present in order to ms-card directive to work. It works similar to ng-include directive. You can either provide the path of the html template file or the variable that holds the path of the html template file.\n</td></tr><tr><td>ng-model</td><td>\nDirective uses ng-model to hold the card data. Data passed with using ng-model will be available in the template files within variable named card.\n</td></tr></tbody></table></div><span class=\"h2 pt-16\">Example:</span>\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-card template=\"\'app/card-templates/my-custom-template.html\'\" ng-model=\"vm.cardModel\"></ms-card>\n            </hljs>\n            <p>Above directive will use \n<span class=\"text-boxed\">my-custom-template.html</span> file as a template. And you will be able to access to the <span\n class=\"text-boxed\">vm.cardModel</span> object through card variable inside the template.</p><p>\nConsider the following object:\n                <hljs language=\"js\" class=\"source-code\">\n                    vm.cardModel = {\n                        title      : \'My Card\',\n                        description: \'My card description\'\n                    }\n                </hljs>\n                </p><p>It will be available in the template file as:\n\n                <hljs language=\"js\" class=\"source-code\">\n                    card = {\n                        title      : \'My Card\',\n                        description: \'My card description\'\n                    }\n                </hljs>\n                </p><p>So you will be able to access the title by doing\n                <hljs language=\"js\" class=\"source-code\">\n                    {{card.title}}\n                </hljs>\n                \n inside the template file.</p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-form-wizard.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-form-wizard</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><span class=\"h2 pt-16\">Description:</span><p>\nms-form-wizard directive is a helper directive that will help you to create form wizards. Combined with <b>md-tabs</b>\n and <b>form</b> elements, you will be able to create as much as steps you want.</p><span class=\"h2 pt-16\">Example:\n</span>\n            <hljs language=\"html\" class=\"source-code\">\n\n                <ms-form-wizard flex>\n                    <md-tabs md-dynamic-height md-selected=\"msWizard.selectedIndex\" md-center-tabs=\"true\">\n                        <md-tab>\n                            <md-tab-label>\n                            <span class=\"ms-form-wizard-step-label\">\n                                <span class=\"ms-form-wizard-step-number md-accent-bg\"\n                                      ng-if=\"wizardStep1.$invalid\">1</span>\n                                <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep1.$valid\">\n                                    <i class=\"icon-check s16\"></i>\n                                </span>\n                                <span class=\"ms-form-wizard-step-text\">Personal Information</span>\n                            </span>\n                            </md-tab-label>\n\n                            <md-tab-body>\n                                <form name=\"wizardStep1\" class=\"md-inline-form\" ms-form-wizard-form novalidate>\n                                    <div layout=\"column\" layout-gt-xs=\"row\" flex>\n                                        <md-input-container flex=\"100\" flex-gt-xs=\"50\">\n                                            <input type=\"text\" name=\"firstname\" ng-model=\"vm.formWizard.firstname\"\n                                                   placeholder=\"Firstname\"\n                                                   required>\n                                            <div ng-messages=\"wizardStep1.firstname.$error\"\n                                                 ng-show=\"wizardStep1.firstname.$touched\"\n                                                 role=\"alert\">\n                                                <div ng-message=\"required\">\n                                                    <span>Firstname field is required.</span>\n                                                </div>\n                                            </div>\n                                        </md-input-container>\n                                    </div>\n                                </form>\n                            </md-tab-body>\n                        </md-tab>\n\n                        <md-tab ng-disabled=\"wizardStep1.$invalid\">\n                            <md-tab-label>\n                            <span class=\"ms-form-wizard-step-label\">\n                                <span class=\"ms-form-wizard-step-number md-accent-bg\"\n                                      ng-if=\"wizardStep2.$invalid\">2</span>\n                                <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep2.$valid\">\n                                    <i class=\"icon-check s16\"></i>\n                                </span>\n                                <span class=\"ms-form-wizard-step-text\">Address</span>\n                            </span>\n                            </md-tab-label>\n\n                            <md-tab-body>\n                                <form name=\"wizardStep2\" ms-form-wizard-form novalidate>\n                                    <md-input-container class=\"md-block\">\n                                        <label>Address</label>\n                                    <textarea ng-model=\"vm.formWizard.address\" columns=\"1\" md-maxlength=\"150\"\n                                              rows=\"5\" required></textarea>\n                                        <div ng-messages=\"wizardStep2.address.$error\"\n                                             ng-show=\"wizardStep2.address.$touched\"\n                                             role=\"alert\" multiple>\n                                            <div ng-message=\"required\"><span>Address field is required.</span></div>\n                                            <div ng-message=\"md-maxlength\">\n                                                <span>Address can\'t be longer than 150 characters.</span>\n                                            </div>\n                                        </div>\n                                    </md-input-container>\n                                </form>\n                            </md-tab-body>\n                        </md-tab>\n\n                        <md-tab ng-disabled=\"wizardStep1.$invalid || wizardStep2.$invalid\">\n                            <md-tab-label>\n                            <span class=\"ms-form-wizard-step-label\">\n                                <span class=\"ms-form-wizard-step-number md-accent-bg\"\n                                      ng-if=\"wizardStep3.$invalid\">3</span>\n                                <span class=\"ms-form-wizard-step-number md-accent-bg\" ng-if=\"wizardStep3.$valid\">\n                                    <i class=\"icon-check s16\"></i>\n                                </span>\n                                <span class=\"ms-form-wizard-step-text\">Payment Method</span>\n                            </span>\n                            </md-tab-label>\n                            <md-tab-body>\n                                <form name=\"wizardStep3\" ms-form-wizard-form novalidate>\n                                    <md-input-container class=\"md-block\">\n                                        <input type=\"text\" name=\"cardholder\" ng-model=\"vm.formWizard.cardholder\"\n                                               placeholder=\"Card Holder\"\n                                               required>\n                                        <div ng-messages=\"wizardStep3.cardholder.$error\"\n                                             ng-show=\"wizardStep3.cardholder.$dirty\"\n                                             role=\"alert\">\n                                            <div ng-message=\"required\">\n                                                <span>Card holder field is required.</span>\n                                            </div>\n                                        </div>\n                                    </md-input-container>\n                                </form>\n                            </md-tab-body>\n                        </md-tab>\n                    </md-tabs>\n\n                    <div class=\"navigation\" flex layout=\"row\" layout-align=\"center center\">\n                        <md-button class=\"md-raised md-accent\" ng-click=\"msWizard.previousStep()\"\n                                   ng-disabled=\"msWizard.isFirstStep()\">\n                            Previous\n                        </md-button>\n                        <div class=\"steps\">\n                        <span ng-repeat=\"form in msWizard.forms\"\n                              ng-class=\"{\'selected md-accent-bg\':msWizard.selectedIndex === $index}\"></span>\n                        </div>\n                        <md-button class=\"md-raised md-accent\" ng-click=\"msWizard.nextStep()\"\n                                   ng-hide=\"msWizard.isLastStep()\"\n                                   ng-disabled=\"msWizard.currentStepInvalid()\">\n                            Next\n                        </md-button>\n                        <md-button class=\"md-raised md-warn\" ng-click=\"vm.sendForm(); msWizard.resetForm();\" ng-show=\"msWizard.isLastStep()\"\n                                   ng-disabled=\"msWizard.formsIncomplete()\">\n                            Send\n                        </md-button>\n                    </div>\n\n                </ms-form-wizard>\n\n            </hljs>\n            <p>For more detailed usage, we recommend you to check <b>Forms</b>\n page from our demo application.</p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-info-bar.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-info-bar</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-info-bar>\n                    <div layout=\"row\" layout-align=\"start center\">\n                        <div class=\"white-fg\" flex hide-xs>\n                            We use cookies to ensure that we give you the best experience on our website. If you\n                            continue without changing your settings, we\'ll assume that you are happy to receive all\n                            cookies from this website.\n                        </div>\n                        <md-button class=\" md-raised\" layout=\"row\" layout-align=\"center center\" target=\"_blank\"\n                                   href=\"#\">\n                            <md-icon md-font-icon=\"icon-cart\" class=\"mr-5 s18\"></md-icon>\n                            <span>Accept</span></md-button>\n                    </div>\n                </ms-info-bar>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-info-bar</b>\n is a helper directive that you can use to show information about your app. On close, its scope will be automatically destroyed.\n</p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-masonry.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-masonry</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><span class=\"h2 pt-16\">Description:</span><p><b>ms-masonry</b>\n is a directive that you can use to create Masonry layouts. You can use following options to configure the directive:\n</p>\n            <hljs language=\"js\" class=\"source-code\">\n                vm.masonryOptions = {\n                    columnCount     : 5,\n                    respectItemOrder: false,\n                    reLayoutDebounce: 400,\n                    responsive      : {\n                        md: 3,\n                        sm: 2,\n                        xs: 1\n                    }\n                }\n            </hljs>\n             <span class=\"h2 pt-16\">Options:</span><div \nclass=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\"><thead><tr><th>Options</th><th>Description\n</th></tr></thead><tbody><tr><td>columnCount</td><td>\n(integer) Column count defines the maximum column count of your masonry layout. ms-masonry will adjust the column count automatically based on \n<b>responsive</b> options and some other calculations.</td></tr><tr><td>respectItemOrder</td><td>\n(boolean) Defaults to false to allow classical masonry behaviour, setting it to true enforces that masonry items are kept in order, allowing consistent positioning.\n</td></tr><tr><td>reLayoutDebounce</td><td>\n(integer) Debounce amount in milliseconds before reLayout can happen. This will prevent reLayout action from happening too much if you are resizing your screen or the device rotation is being changed.\n</td></tr><tr><td>responsive</td><td>\n(object) You can define column counts for individual Angular Material media step definitions.</td></tr></tbody></table>\n</div><span class=\"h2 pt-16\">Example:</span><p>\n                <hljs language=\"js\" class=\"source-code\">\n                    <ms-masonry options=\"vm.masonryOptions\">\n                        <ms-masonry-item></ms-masonry-item>\n                        <ms-masonry-item></ms-masonry-item>\n                        <ms-masonry-item></ms-masonry-item>\n                        ...\n                    </ms-masonry>\n                </hljs>\n                </p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-material-color-picker.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-material-color-picker</div></div><div class=\"content\" layout=\"column\"><div \nclass=\"card md-whiteframe-4dp\" layout=\"column\"><span class=\"h2 pt-16\">Description:</span><p><b>ms-material-color-picker\n</b> directive allows you to pick any of the Material Design colors.</p><span class=\"h2 pt-16\">Options:</span><div \nclass=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\"><thead><tr><th>Options</th><th>Description\n</th></tr></thead><tbody><tr><td>ms-model-type</td><td>\n(string) Model type of the color picker. Can be either `class` or `obj`</td></tr><tr><td>ng-model (required)</td><td>\nValue that will be updated on color pick</td></tr></tbody></table></div><span class=\"h2 pt-16\">Example:</span><p>\nDepending on <b>ms-model-type</b>\n value, color picker will either update the model with the appropriate class name or the object:</p>\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-material-color-picker ms-model-type=\"obj\" ng-model=\"vm.color\"></ms-material-color-picker>\n            </hljs>\n            \n<p>\nYou can also use transclusion to trigger the picker. Like in the below example, you can add a button or any other element to trigger the picker:\n</p>\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-material-color-picker ms-model-type=\"obj\" ng-model=\"vm.color\">\n                    <md-button>Select a Color</md-button>\n                </ms-material-color-picker>\n            </hljs>\n            <p><b>$selectedColor</b>\n variable can be used within the color picker element to access the properties of the selected color:</p>\n\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-material-color-picker ms-model-type=\"obj\" ng-model=\"vm.color\">\n                    <md-button class=\"{{$selectedColor}}\">Select a Color</md-button>\n                </ms-material-color-picker>\n            </hljs>\n            </div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-nav.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-nav</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><p class=\"note\"><b>Note:</b> This directive is deprecated. Use <b>ms-navigation</b> instead.</p><span \nclass=\"h2 pt-16\">Description:</span><p>\nNavigation directive has couple other dependent directives. They all together used for creating the main navigation. \n<b>ms-nav</b> directive is compatible with Angular UI Router module.</p><span class=\"h2 pt-16\">Example:</span>\n\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-nav>\n\n                    <ms-nav-item ms-nav-title>\n                        <span>FUSE</span>\n                    </ms-nav-item>\n\n                    <ms-nav-item ms-nav-toggle>\n\n                        <a ms-nav-button md-ink-ripple>\n                            <i class=\"icon-tile-four s16\"></i>\n                            <span class=\"ms-nav-label\" translate=\"NAVIGATION.DASHBOARDS\">Dashboards</span>\n                            <i class=\"icon-chevron-down s16 arrow\"></i>\n                        </a>\n\n                        <ms-nav-toggle-items>\n                            <ms-nav-item>\n                                <a ms-nav-button ui-sref=\"app.dashboard-v1\" ui-sref-active=\"active\" md-ink-ripple>\n                                    <span class=\"ms-nav-label\">Dashboard v1</span>\n                                </a>\n                            </ms-nav-item>\n\n                            <ms-nav-item>\n                                <a ms-nav-button ui-sref=\"app.dashboard-v2\" ui-sref-active=\"active\" md-ink-ripple>\n                                    <span class=\"ms-nav-label\">Dashboard v2</span>\n                                </a>\n                            </ms-nav-item>\n                        </ms-nav-toggle-items>\n\n                    </ms-nav-item>\n\n                </ms-nav>\n            </hljs>\n            </div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-navigation.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-navigation</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><p>\n                <hljs language=\"js\" class=\"source-code\">\n                    msNavigationService.saveItem(\'NAVIGATION.ID\', {NAVIGATION_OPTIONS});\n                </hljs>\n                </p><span class=\"h2 pt-16\">Description:</span><p>\nSince version 1.2.0, Fuse no longer uses html based navigation. This way, you can add, update or remove navigation items at anytime from anywhere. To create navigation items, you can use Angular\'s \n<b>run</b> or <b>config</b> blocks as well as <b>services</b> and <b>controllers</b>.</p><p><b>ms-navigation</b>\n directive works parallel with <b>msNavigationService</b> and there are two main navigation styles: <b>Vertical</b>\n and <b>Horizontal</b>. The preferred style can be used by changing the layout of the template.</p><p>\nTo create a navigation item, you have to use either <b>msNavigationService</b> or <b>msNavigationServiceProvider</b>.\n</p><p class=\"mt-24\">Calling <b>saveItem</b> on <em>msNavigationService</em> or <em>msNavigationServiceProvider</em>\n will either create a menu item, or update an existing one. This way you can update any existing menu item at any times by simply referring to it by using its id.\n</p><span class=\"h2 pt-16\">Navigation Id:</span><p>\nNavigation id is a simple string that uses \"dot notation\" to create the hierarchy between the navigation items. For example, if you want to have a \"Post Blog\" navigation item under \"Blog\" navigation item, you should have \"blog.post-blog\" as the id of the navigation.\n</p><p>\nTo create a navigation item, you don\'t have to create its parent(s). If you create a navigation item by using \"dashboard.project\" id, the navigation item with the \"dashboard\" id will be automatically created for you. Then you can simply update the \"dashboard\" navigation item to change its options.\n</p><span class=\"h2 pt-16\">Navigation Options:</span><div class=\"simple-table-container md-whiteframe-1dp mv-16\"><table\n class=\"simple\"><thead><tr><th>Options</th><th>Description</th></tr></thead><tbody><tr><td>title</td><td>\n(string) Title of the navigation item</td></tr><tr><td>group</td><td>\n(bool) Determines if the navigation item is going to be used for grouping</td></tr><tr><td>icon</td><td>\n(string) Icon class name of the navigation item</td></tr><tr><td>state</td><td>\n(string) UI-Router state name for the navigation item to be linked</td></tr><tr><td>stateParams</td><td>\n(object) UI-Router state parameters</td></tr><tr><td>translate</td><td>\n(string) angular-translate translation object id (e.g. \"NAVIGATION.MAIL\")</td></tr><tr><td>class</td><td>\n(string) Custom class name(s) to be applied to the navigation item</td></tr><tr><td>badge</td><td>\n(object) Badge to show in navigation item</td></tr><tr><td>weight</td><td>\n(int) Determines the sort order of the navigation item</td></tr><tr><td>hidden</td><td>\n(function) Determines the visibility of the menu item. The function must return a <b>boolean</b> value.</td></tr>\n</tbody></table></div><span class=\"h2 pt-16\">Example:</span><p>To create a navigation item from <b>Run</b> or <b>Config\n</b> blocks, you must use <b>msNavigationServiceProvider</b>:</p>\n            <hljs language=\"js\" class=\"source-code\">\n                /** @ngInject */\n                function config(msNavigationServiceProvider)\n                {\n                    // Navigation\n                    msNavigationServiceProvider.saveItem(\'apps\', {\n                        title : \'APPS\',\n                        group : true,\n                        weight: 1\n                    });\n\n                    // Apps.Dashboards\n                    msNavigationServiceProvider.saveItem(\'apps.dashboards\', {\n                        title : \'Dashboards\',\n                        icon  : \'icon-tile-four\',\n                        class : \'navigation-dashboards\',\n                        weight: 1\n                    });\n\n                    // Apps.Dashboards.Project\n                    msNavigationServiceProvider.saveItem(\'apps.dashboards.project\', {\n                        title      : \'Project\',\n                        state      : \'app.dashboards_project\',\n                        stateParams: {\'id\': 1},\n                        badge      : {\n                            content: \'21\',\n                            color  : \'red\'\n                        },\n                        translate  : \'NAVIGATION.DASHBOARDS.PROJECT\',\n                        class      : \'navigation-dashboards project-dashboard\',\n                        weight     : 1\n                    });\n\n                    // Apps.Dashboards.Server\n                    msNavigationServiceProvider.saveItem(\'apps.dashboards.server\', {\n                        title      : \'Server\',\n                        state      : \'app.dashboards_server\',\n                        stateParams: {\'id\': 1},\n                        translate  : \'NAVIGATION.DASHBOARDS.SERVER\',\n                        class      : \'navigation-dashboards server-dashboard\',\n                        weight     : 2\n                    });\n\n                    // Apps.Dashboards.Analytics\n                    msNavigationServiceProvider.saveItem(\'apps.dashboards.analytics\', {\n                        title      : \'Analytics\',\n                        state      : \'app.dashboards_analytics\',\n                        stateParams: {\'id\': 1},\n                        translate  : \'NAVIGATION.DASHBOARDS.ANALYTICS\',\n                        class      : \'navigation-dashboards analytics-dashboard\',\n                        weight     : 3\n                    });\n                }\n            </hljs>\n            <p class=\"mt-24\">\nTo do the same thing in <b>services</b> and <b>controllers</b>, you must use <b>msNavigationService</b>:</p>\n\n            <hljs language=\"js\" class=\"source-code\">\n                /** @ngInject */\n                function TestController(msNavigationService)\n                {\n                    // Navigation\n                    msNavigationService.saveItem(\'apps\', {\n                        title : \'APPS\',\n                        group : true,\n                        weight: 1\n                    });\n\n                    // Apps.Dashboards\n                    msNavigationService.saveItem(\'apps.dashboards\', {\n                        title : \'Dashboards\',\n                        icon  : \'icon-tile-four\',\n                        class : \'navigation-dashboards\',\n                        weight: 1\n                    });\n\n                    // Apps.Dashboards.Project\n                    msNavigationService.saveItem(\'apps.dashboards.project\', {\n                        title      : \'Project\',\n                        state      : \'app.dashboards_project\',\n                        stateParams: {\'id\': 1},\n                        badge      : {\n                            content: \'21\',\n                            color  : \'red\'\n                        },\n                        translate  : \'NAVIGATION.DASHBOARDS.PROJECT\',\n                        class      : \'navigation-dashboards project-dashboard\',\n                        weight     : 1\n                    });\n\n                    // Apps.Dashboards.Server\n                    msNavigationService.saveItem(\'apps.dashboards.server\', {\n                        title      : \'Server\',\n                        state      : \'app.dashboards_server\',\n                        stateParams: {\'id\': 1},\n                        translate  : \'NAVIGATION.DASHBOARDS.SERVER\',\n                        class      : \'navigation-dashboards server-dashboard\',\n                        weight     : 2\n                    });\n\n                    // Apps.Dashboards.Analytics\n                    msNavigationService.saveItem(\'apps.dashboards.analytics\', {\n                        title      : \'Analytics\',\n                        state      : \'app.dashboards_analytics\',\n                        stateParams: {\'id\': 1},\n                        translate  : \'NAVIGATION.DASHBOARDS.ANALYTICS\',\n                        class      : \'navigation-dashboards analytics-dashboard\',\n                        weight     : 3\n                    });\n                }\n            </hljs>\n            <p class=\"mt-24\">\nYou can specify a hidden value within your navigation item configuration to have more control on its visibility. It accepts a function and that function must return a boolean value.\n</p><p>\nms-navigation will watch that function and whenever the AuthService.isAdmin value changes, the visibility of the navigation item will be updated automatically.\n</p>\n            <hljs language=\"js\" class=\"source-code\">\n                /** @ngInject */\n                function TestController(msNavigationService)\n                {\n                    // Navigation\n                    msNavigationService.saveItem(\'apps\', {\n                        title : \'APPS\',\n                        group : true,\n                        weight: 1\n                    });\n\n                    // Apps.Dashboards\n                    msNavigationService.saveItem(\'apps.dashboards\', {\n                        title : \'Dashboards\',\n                        icon  : \'icon-tile-four\',\n                        class : \'navigation-dashboards\',\n                        hidden: function ()\n                        {\n                            return AuthService.isAdmin; // must be a boolean value\n                        },\n                        weight: 1\n                    });\n                }\n            </hljs>\n            <p class=\"mt-24\">\nIf you wish to remove an item from the navigation at runtime, you can use deleteItem() method. It\'s available in both \n<b>msNavigationService</b> and <b>msNavigationServiceProvider</b>:</p>\n            <hljs language=\"js\" class=\"source-code\">\n                /** @ngInject */\n                function TestController(msNavigationService)\n                {\n                    // Delete the \'apps\' item\n                    msNavigationService.deleteItem(\'apps\');\n                }\n            </hljs>\n             <span class=\"h2 pt-16\">\nDirective:</span><p>To show the navigation, you can use <b>ms-navigation</b> element:</p>\n            <hljs lang=\"html\" class=\"source-code\">\n                <ms-navigation class=\"scrollable\" folded=\"vm.folded\" root=\"apps.dashboards\"></ms-navigation>\n            </hljs>\n            <div \nclass=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\"><thead><tr><th>Options</th><th>Description\n</th></tr></thead><tbody><tr><td>folded</td><td>(boolean) Sets the initial folded status of the navigation</td></tr>\n<tr><td>root</td><td>\n(string) You can specify the root item key in here to make navigation to show only certain navigation group. This might be useful if you are showing different menu groups to different users or using Fuse as both front and backend apps.\n</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-random-class.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-random-class</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <div ms-random-class=\"vm.colors\"></div>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-random-class</b>\n directive can be used for adding randomly selected class from an array. It\'s used mainly for generating random background colors in the template, but you can use it anywhere if you find it useful.\n</p><div class=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\"><thead><tr><th>Attribute</th><th>\nDescription</th></tr></thead><tbody><tr><td>ms-random-class</td><td>\n(Array) This attribute must be present in order to ms-random-class directive to work.</td></tr></tbody></table></div>\n<span class=\"h2 pt-16\">Example:</span>\n            <hljs language=\"js\" class=\"source-code\">\n                vm.colors = [\n                    \'yellow\',\n                    \'red\',\n                    \'blue\',\n                    \'orange\',\n                    \'green\'\n                ]\n            </hljs>\n            \n            <hljs language=\"html\" class=\"source-code\">\n                <div ms-random-class=\"vm.colors\"></div>\n            </hljs>\n            </div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-responsive-table.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-responsive-table</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <table class=\"simple\" ms-responsive-table>\n                    <!-- Table content -->\n                </table>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-responsive-table</b>\n directive is useful for making tables responsive. It will simply add a scrollable wrapper around the table to make them usable in smaller screens.\n</p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-scroll.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-scroll</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <div ms-scroll>\n                    <!-- Some long content -->\n                </div>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-scroll</b>\n directive can be used for adding custom scrollbars to the scrollable content. Fuse uses <a \nhref=\"https://github.com/noraesae/perfect-scrollbar\" target=\"_blank\">Perfect Scrollbar</a>\n as a custom scrollbar. You can also use this directive with <em>scrollable</em> helper class. <em>scrollable</em>\n class will make any content scrollable and then you can add custom scrollbars by adding <b>ms-scroll</b>\n directive to the same element:</p>\n            <hljs language=\"html\" class=\"source-code\">\n                <div class=\"scrollable\" ms-scroll>\n                    <!-- Some long content -->\n                </div>\n            </hljs>\n            </div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-search-bar.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-search-bar</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-search-bar></ms-search-bar>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-search-bar</b>\n is an autocomplete supported search bar directive. It has various options and events for you to use.</p><span \nclass=\"h2 pt-16\">Options:</span><div class=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\">\n<thead><tr><th>Options</th><th>Description</th></tr></thead><tbody><tr><td>debounce</td><td>\n(integer) Model update debounce. Can be used to stop triggering the on-search event for every keystroke.</td></tr><tr>\n<td>on-search</td><td>\n(function (query)) A callback function that will trigger on model update. Must return an Array or a Promise object that caries an Array. Has \'query\' parameter to access the search query.\n</td></tr><tr><td>on-result-click</td><td>\n(function (item)) A callback function that will trigger on search result click. Has \'item\' parameter to access the clicked item.\n</td></tr><tr><td>on-expand</td><td>(function) A callback function that will trigger when search bar expanded.</td>\n</tr><tr><td>on-collapse</td><td>(function) A callback function that will trigger when search bar collapsed.</td></tr>\n</tbody></table></div><span class=\"h2 pt-16\">Example:</span>\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-search-bar on-search=\"vm.search(query)\" on-result-click=\"vm.searchResultClick(item)\" debounce=\"300\"></ms-search-bar>\n            </hljs>\n            </div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-shortcuts.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-shortcuts</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><span class=\"h2 pt-16\">Description:</span><p><b>ms-shortcuts</b>\n is a directive that you can use to add shortcuts for navigation items. It works in parallel with <b>ms-navigation</b>\n directive to get its data. It has built in search, add and remove shortcut functions.</p><span class=\"h2 pt-16\">\nExample:</span>\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-shortcuts></ms-shortcuts>\n            </hljs>\n            </div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-sidenav-helper.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-sidenav-helper</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <md-sidenav class=\"sidenav\" md-component-id=\"main-sidenav\" ms-scroll ms-sidenav-helper>\n                    <!-- Sidenav Content -->\n                </md-sidenav>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-sidenav-helper</b>\n directive is required if you use sidenavs inside the page content. You can check out the <em>\napp/main/ui/layouts/simple/left-sidenav/left-sidenav.html</em> file for the simple usage.</p><p>\nSimply, this directive will add a class to the certain elements in order to page and the sidenav act correctly on all devices.\n</p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-splash-screen.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-splash-screen</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-splash-screen>\n                    <!-- Splash screen content -->\n                </ms-splash-screen>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-splash-screen</b>\n is a helper directive that helps splash screen to disappear.</p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-stepper.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-stepper</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\"><span class=\"h2 pt-16\">Description:</span><p><b>ms-stepper</b>\n is a form step directive that follows Google\'s Material Design specifications. It allows you to create stepped forms. Unlike \n<b>ms-form-wizard</b>\n, this directive doesn\'t use any other material elements, therefore it\'s a lot more flexible and easy to use:</p><span \nclass=\"h3 pt-16\">Horizontal Stepper:</span>\n            <hljs language=\"html\" class=\"source-code\">\n                <form name=\"stepper\" ms-horizontal-stepper ng-submit=\"vm.submitStepper()\" ng-model=\"vm.stepper\" novalidate>\n                    <!-- Step 1 -->\n                    <ms-horizontal-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'Personal Information\'\">\n                        <div ng-include=\"\'app/main/ui/forms/stepper-steps/step-1.html\'\"></div>\n                    </ms-horizontal-stepper-step>\n                    <!-- / Step 1 -->\n\n                    <!-- Step 2 -->\n                    <ms-horizontal-stepper-step ng-form=\"step2\" step=\"2\" step-title=\"\'Address\'\" optional-step>\n                        <div ng-include=\"\'app/main/ui/forms/stepper-steps/step-2.html\'\"></div>\n                    </ms-horizontal-stepper-step>\n                    <!-- / Step 2 -->\n\n                    <!-- Step 3 -->\n                    <ms-horizontal-stepper-step ng-form=\"step3\" step=\"3\" step-title=\"\'Payment Method\'\">\n                        <div ng-include=\"\'app/main/ui/forms/stepper-steps/step-3.html\'\"></div>\n                    </ms-horizontal-stepper-step>\n                    <!-- / Step 3 -->\n                </form>\n            </hljs>\n            <hr><span class=\"h3 pt-16\">Vertical Stepper:</span>\n\n            <hljs language=\"html\" class=\"source-code\">\n                <form name=\"stepper\" ms-vertical-stepper ng-submit=\"vm.submitStepper()\" ng-model=\"vm.stepper\" novalidate>\n                    <!-- Step 1 -->\n                    <ms-vertical-stepper-step ng-form=\"step1\" step=\"1\" step-title=\"\'Personal Information\'\">\n                        <div ng-include=\"\'app/main/ui/forms/stepper-steps/step-1.html\'\"></div>\n                    </ms-vertical-stepper-step>\n                    <!-- / Step 1 -->\n\n                    <!-- Step 2 -->\n                    <ms-vertical-stepper-step ng-form=\"step2\" step=\"2\" step-title=\"\'Address\'\" optional-step>\n                        <div ng-include=\"\'app/main/ui/forms/stepper-steps/step-2.html\'\"></div>\n                    </ms-vertical-stepper-step>\n                    <!-- / Step 2 -->\n\n                    <!-- Step 3 -->\n                    <ms-vertical-stepper-step ng-form=\"step3\" step=\"3\" step-title=\"\'Payment Method\'\">\n                        <div ng-include=\"\'app/main/ui/forms/stepper-steps/step-3.html\'\"></div>\n                    </ms-vertical-stepper-step>\n                    <!-- / Step 3 -->\n                </form>\n            </hljs>\n             <span class=\"h2 pt-16\">ms-*-stepper-step</span><p>This directive requires <b>ms-*-stepper</b>\n directive and it\'s used for creating individual steps. You can either directly wrap your forms with this directive, or you can use ng-include to include them.\n</p><span class=\"h2 pt-16\">ms-stepper-step Attributes</span><div \nclass=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\"><thead><tr><th>Attribute</th><th>\nDescription</th></tr></thead><tbody><tr><td>ng-form</td><td>\n(string) This attribute/directive is required for steps to work correctly. It requires a unique, string value. You can think this as the unique name of the step.\n</td></tr><tr><td>step [Optional]</td><td>\n(integer) Optional value for the step number. If you want to manually order your steps, you can use this attribute.\n</td></tr><tr><td>step-title</td><td>(string) Step title that will show up in the step navigation.</td></tr><tr><td>\noptional-step [Optional]</td><td>\nIf given, this attribute will make the step optional. Therefore, that step can be passed through without filling its input fields and it will not be included into the main form validity check.\n</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-timeline.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-timeline</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <div id=\"timeline\" ms-timeline ms-timeline-load-more=\"vm.loadNextPage()\">\n\n                    <!-- TIMELINE ITEM -->\n                    <div ms-timeline-item ng-repeat=\"timelineItem in vm.timeline\">\n\n                        <div class=\"timeline-card\">\n                            <!-- MS-CARD -->\n                            <ms-card template=\"timelineItem.card.template\" ng-model=\"timelineItem.card\"></ms-card>\n                            <!-- / MS-CARD -->\n                        </div>\n\n                        <div class=\"timeline-point md-accent-bg md-whiteframe-2dp\">\n                            <md-icon md-font-icon=\"{{timelineItem.icon}}\"></md-icon>\n                        </div>\n\n                        <div class=\"timeline-detail\">\n                            <div class=\"time\">\n                                {{timelineItem.time}}\n                            </div>\n                            <div class=\"event\">\n                                {{timelineItem.event}}\n                            </div>\n                        </div>\n                    </div>\n                    <!-- / TIMELINE ITEM -->\n\n                </div>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-timeline</b>\n directive is required for timeline. It will help loading and animating the timeline items properly. We highly recommend you to check \n<em>app/main/pages/timeline/timeline.html</em> and <em>app/main/pages/timeline/timeline.controller.js</em>\n to fully understand how to use it.</p></div></div></div>");
$templateCache.put("app/main/components/custom-directives/pages/ms-widget.html","<div class=\"page-layout simple fullwidth doc-page\" layout=\"column\"><div class=\"header md-accent-bg\" layout=\"column\" \nlayout-align=\"center start\"><div class=\"breadcrumb\"><span class=\"parent\">Custom Directives</span></div><div \nclass=\"title\">ms-widget</div></div><div class=\"content\" layout=\"column\"><div class=\"card md-whiteframe-4dp\" \nlayout=\"column\">\n            <hljs language=\"html\" class=\"source-code\">\n                <ms-widget flippable=\"true\">\n\n                    <ms-widget-front class=\"padding-16 md-white-bg\">\n                        <!-- Front content -->\n                    </ms-widget-front>\n\n                    <ms-widget-back class=\"padding-16 md-white-bg\">\n                        <!-- Back content -->\n                    </ms-widget-back>\n\n                </ms-widget>\n            </hljs>\n             <span class=\"h2 pt-16\">Description:</span><p><b>ms-widget</b>\n directive is a helper directive for creating widgets. When it used with helper classes such as padding, margin, height helpers, it\'s very easy to create custom widgets.\n</p><div class=\"simple-table-container md-whiteframe-1dp mv-16\"><table class=\"simple\"><thead><tr><th>Attribute</th><th>\nDescription</th></tr></thead><tbody><tr><td>flippable</td><td>\nIf it\'s true, widget will be flippable. If you don\'t want to make the widget flippable, you can make this attribute false and use only \n<b>&lt;ms-widget-front&gt;&lt;/ms-widget-front&gt;</b> wrapper to show widget content.</td></tr></tbody></table></div>\n</div></div></div>");
$templateCache.put("app/main/components/maps/tabs/custom-marker.html","<ui-gmap-google-map center=\"vm.customMarkerMap.center\" zoom=\"vm.customMarkerMap.zoom\"><ui-gmap-marker \ncoords=\"vm.customMarkerMap.marker.coords\" idkey=\"vm.customMarkerMap.marker.id\" \noptions=\"vm.customMarkerMap.marker.options\"></ui-gmap-marker></ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/info-window.html","<ui-gmap-google-map center=\"vm.simpleMarkerMap.center\" zoom=\"vm.simpleMarkerMap.zoom\"><ui-gmap-marker \ncoords=\"vm.simpleMarkerMap.marker.coords\" idkey=\"vm.simpleMarkerMap.marker.id\"><ui-gmap-window show=\"\'true\'\"><div \nng-non-bindable=\"\"><div id=\"siteNotice\"></div><h1 id=\"firstHeading\" class=\"firstHeading\">Uluru</h1><div \nid=\"bodyContent\"><p><b>Uluru</b>, also referred to as <b>Ayers Rock</b>\n, is a large sandstone rock formation in the southern part of the Northern Territory, central Australia.</p><p>\nAttribution: Uluru, <a href=\"//en.wikipedia.org/w/index.php?title=Uluru&amp;oldid=297882194\">\nhttp://en.wikipedia.org/w/index.php?title=Uluru</a> (last visited June 22, 2009).</p></div></div></ui-gmap-window>\n</ui-gmap-marker></ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/satellite.html","<ui-gmap-google-map center=\"vm.satelliteMap.center\" zoom=\"vm.satelliteMap.zoom\" options=\"vm.satelliteMap.options\">\n</ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/simple-marker.html","<ui-gmap-google-map center=\"vm.simpleMarkerMap.center\" zoom=\"vm.simpleMarkerMap.zoom\"><ui-gmap-marker \ncoords=\"vm.simpleMarkerMap.marker.coords\" idkey=\"vm.simpleMarkerMap.marker.id\"></ui-gmap-marker></ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/simple.html","<ui-gmap-google-map center=\"vm.simpleMap.center\" zoom=\"vm.simpleMap.zoom\"></ui-gmap-google-map>");
$templateCache.put("app/main/components/maps/tabs/terrain.html","<ui-gmap-google-map center=\"vm.terrainMap.center\" zoom=\"vm.terrainMap.zoom\" options=\"vm.terrainMap.options\">\n</ui-gmap-google-map>");
$templateCache.put("app/main/components/tables/datatable/datatable.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Tables</span></div><div \nclass=\"title\">Datatable</div></div><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-raised reference-button\" href=\"https://l-lin.github.io/angular-datatables\" target=\"_blank\"><md-icon \nmd-font-icon=\"icon-link\"></md-icon><span>Reference</span></md-button></div></div><div class=\"content\"><div \nclass=\"md-title mb-32\">Zero Configuration</div><div class=\"white-bg md-whiteframe-4dp\"><table \nclass=\"dataTable row-border hover\" datatable=\"ng\" dt-options=\"vm.dtOptions\"><thead><tr><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Name</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Position</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Office</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Age</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Start Date</span></div></th><th class=\"secondary-text\"><div \nclass=\"table-header\"><span class=\"column-title\">Salary</span></div></th></tr></thead><tbody><tr \nng-repeat=\"employee in ::vm.employees\"><td>{{ employee.name }}</td><td>{{ employee.position }}</td><td>\n{{ employee.office }}</td><td>{{ employee.age }}</td><td>{{ employee.startDate }}</td><td>{{ employee.salary }}</td>\n</tr></tbody></table></div></div></div>");
$templateCache.put("app/main/components/tables/simple-table/simple-table.html","<div id=\"simple-table\" class=\"page-layout simple fullwidth doc-page element-doc-page\"><div class=\"header md-accent-bg\" \nlayout=\"row\" layout-align=\"space-between\"><div layout=\"column\" layout-align=\"center start\"><div class=\"breadcrumb\" \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-home\" class=\"s16\"></md-icon><md-icon \nmd-font-icon=\"icon-chevron-right\" class=\"s16 separator\"></md-icon><span class=\"parent\">Tables</span></div><div \nclass=\"title\">Simple Table</div></div></div><div class=\"content\">\nTables are used to present raw data sets, and usually appear in desktop enterprise products.<p>Data sets may include:\n</p><ul><li>Three or more columns of data</li><li>A corresponding visualization</li><li>\nThe ability for users to query and manipulate data at scale</li></ul><div \nclass=\"simple-table-container md-whiteframe-4dp\"><div class=\"table-title\">Employees</div><table class=\"simple\" \nms-responsive-table><thead><tr><th>Name</th><th>Position</th><th>Office</th><th class=\"text-right\">Age</th><th \nclass=\"text-right\">Start Date</th><th class=\"text-right\">Salary</th></tr></thead><tfoot><tr><td></td></tr></tfoot>\n<tbody><tr ng-repeat=\"person in vm.employees\"><td class=\"name\">{{person.name}}</td><td class=\"position\">\n{{person.position}}</td><td class=\"office\">{{person.office}}</td><td class=\"age text-right\">{{person.age}}</td><td \nclass=\"start-date text-right\">{{person.startDate}}</td><td class=\"salary text-right\">{{person.salary | currency}}</td>\n</tr></tbody></table></div></div></div>");
$templateCache.put("app/main/components/material-docs/demo/docs-demo.tmpl.html","<div class=\"doc-demo-content doc-content\"><div flex layout=\"column\" style=\"z-index:1\"><div class=\"doc-description\" \nng-bind-html=\"demoCtrl.demoDescription.contents | toHtml\"></div><div ng-transclude></div><section \nclass=\"demo-container md-whiteframe-z1\" ng-class=\"{\'show-source\': demoCtrl.$showSource}\"><md-toolbar \nclass=\"demo-toolbar md-primary\"><div class=\"md-toolbar-tools\"><h3>{{demoCtrl.demoTitle}}</h3><span flex></span>\n<md-button class=\"md-icon-button\" aria-label=\"View Source\" ng-class=\"{ active: demoCtrl.$showSource }\" \nng-click=\"demoCtrl.$showSource = !demoCtrl.$showSource\"><md-tooltip md-autohide>View Source</md-tooltip><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/ic_code_24px.svg\"></md-icon></md-button></div></md-toolbar>\n<md-tabs class=\"demo-source-tabs md-primary\" md-dynamic-height ng-show=\"demoCtrl.$showSource\"><md-tab \nng-repeat=\"file in demoCtrl.orderedFiles\" label=\"{{file.name}}\"><md-content md-scroll-y class=\"demo-source-container\">\n<hljs class=\"no-header\" code=\"file.contentsPromise\" lang=\"{{file.fileType}}\" \nshould-interpolate=\"demoCtrl.interpolateCode\"></hljs></md-content></md-tab></md-tabs><demo-include \nfiles=\"demoCtrl.files\" module=\"demoCtrl.demoModule\" class=\"{{demoCtrl.demoId}}\"></demo-include></section></div></div>");
$templateCache.put("app/main/components/material-docs/layout/layout-alignment.tmpl.html","<div ng-controller=\"LayoutCtrl\" class=\"layout-content\" ng-cloak><p>The <code>layout-align</code>\n directive takes two words. The first word says how the children will be aligned in the layout\'s direction, and the second word says how the children will be aligned perpendicular to the layout\'s direction.\n</p><p>Only one value is required for this directive. For example, <code>layout=\"row\" layout-align=\"center\"</code>\n would make the elements center horizontally and use the default behavior vertically.</p><p><code>\nlayout=\"column\" layout-align=\"center end\"</code>\n would make children align along the center vertically and along the end (right) horizontally.</p><table \nclass=\"md-api-table\"><thead><tr><th>API</th><th>Sets child alignments within the layout container</th></tr></thead><tr>\n<td>layout-align</td><td>Sets default alignment unless overridden by another breakpoint.</td></tr><tr><td>\nlayout-align-xs</td><td>width &lt; <b>600</b>px</td></tr><tr><td>layout-align-gt-xs</td><td>width &gt;= <b>600</b>px\n</td></tr><tr><td>layout-align-sm</td><td><b>600</b>px &lt;= width &lt; <b>960</b>px</td></tr><tr><td>\nlayout-align-gt-sm</td><td>width &gt;= <b>960</b>px</td></tr><tr><td>layout-align-md</td><td><b>960</b>\npx &lt;= width &lt; <b>1280</b>px</td></tr><tr><td>layout-align-gt-md</td><td>width &gt;= <b>1280</b>px</td></tr><tr>\n<td>layout-align-lg</td><td><b>1280</b>px &lt;= width &lt; <b>1920</b>px</td></tr><tr><td>layout-align-gt-lg</td><td>\nwidth &gt;= <b>1920</b>px</td></tr><tr><td>layout-align-xl</td><td>width &gt;= <b>1920</b>px</td></tr></table><br><p>\nBelow is an interactive demo that lets you explore the visual results of the different settings:</p><div><docs-demo \ndemo-title=\'layout=\"{{layoutDemo.direction}}\" &nbsp; &nbsp; &nbsp; layout-align=\"{{layoutAlign()}}\"\' \nclass=\"small-demo colorNested\" interpolate-code=\"true\"><demo-file name=\"index.html\"><div \nlayout=\"{{layoutDemo.direction}}\" layout-align=\"{{layoutAlign()}}\"><div>one</div><div>two</div><div>three</div></div>\n</demo-file></docs-demo></div><div layout=\"column\" layout-gt-sm=\"row\" layout-align=\"space-around\"><div><md-subheader>\nLayout Direction</md-subheader><md-radio-group ng-model=\"layoutDemo.direction\"><md-radio-button value=\"row\">row\n</md-radio-button><md-radio-button value=\"column\">column</md-radio-button></md-radio-group></div><div><md-subheader>\nAlignment in Layout Direction ({{layoutDemo.direction == \'row\' ? \'horizontal\' : \'vertical\'}})</md-subheader>\n<md-radio-group ng-model=\"layoutDemo.mainAxis\"><md-radio-button value=\"\">none</md-radio-button><md-radio-button \nvalue=\"start\">start (default)</md-radio-button><md-radio-button value=\"center\">center</md-radio-button><md-radio-button\n value=\"end\">end</md-radio-button><md-radio-button value=\"space-around\">space-around</md-radio-button><md-radio-button \nvalue=\"space-between\">space-between</md-radio-button></md-radio-group></div><div><md-subheader>\nAlignment in Perpendicular Direction ({{layoutDemo.direction == \'column\' ? \'horizontal\' : \'vertical\'}})</md-subheader>\n<md-radio-group ng-model=\"layoutDemo.crossAxis\"><md-radio-button value=\"none\"><em>none</em></md-radio-button>\n<md-radio-button value=\"start\">start</md-radio-button><md-radio-button value=\"center\">center</md-radio-button>\n<md-radio-button value=\"end\">end</md-radio-button><md-radio-button value=\"stretch\">stretch (default)</md-radio-button>\n</md-radio-group></div></div></div>");
$templateCache.put("app/main/components/material-docs/layout/layout-children.tmpl.html","<div ng-controller=\"LayoutCtrl\" class=\"layout-content\" ng-cloak><h3>Children within a Layout Container</h3><p>\nTo customize the size and position of elements in a layout <b>container</b>, use the <code>flex</code>, <code>\nflex-order</code>, and <code>flex-offset</code> attributes on the container\'s <u>child</u> elements:</p><docs-demo \ndemo-title=\"Flex Directive\" class=\"small-demo colorNested\"><demo-file name=\"index.html\"><div layout=\"row\"><div \nflex=\"20\">[flex=\"20\"]</div><div flex=\"70\">[flex=\"70\"]</div><div flex hide-sm hide-xs>[flex]</div></div></demo-file>\n</docs-demo><p>Add the <code>flex</code>\n directive to a layout\'s child element and the element will flex (grow or shrink) to fit the area unused by other elements. \n<code>flex</code> defines how the element will adjust its size with respect to its <u>parent</u>\n container and the other elements within the container.</p><docs-demo demo-title=\"Flex Percent Values\" \nclass=\"small-demo colorNested-noPad\"><demo-file name=\"index.html\"><div layout=\"row\" layout-wrap><div flex=\"30\">\n[flex=\"30\"]</div><div flex=\"45\">[flex=\"45\"]</div><div flex=\"25\">[flex=\"25\"]</div><div flex=\"33\">[flex=\"33\"]</div><div \nflex=\"66\">[flex=\"66\"]</div><div flex=\"50\">[flex=\"50\"]</div><div flex>[flex]</div></div></demo-file></docs-demo><p>\nA layout child\'s <code>flex</code>\n directive can be given an integer value from 0-100. The element will stretch to the percentage of available space matching the value. Currently, the \n<code>flex</code> directive value is restricted to multiples of five, 33 or 66.</p><p>For example: <code>\nflex=\"5\", flex=\"20\", flex=\"33\", flex=\"50\", flex=\"66\", flex=\"75\", ... flex=\"100\"</code>.</p><docs-demo \ndemo-title=\"Responsive Flex Directives\" class=\"small-demo colorNested-noPad\"><demo-file name=\"index.html\"><div \nlayout=\"row\"><div flex-gt-sm=\"66\" flex=\"33\">flex 33% on mobile,<br>and 66% on gt-sm devices.</div><div flex-gt-sm=\"33\" \nflex=\"66\">flex 66% on mobile,<br>and 33% on gt-sm devices.</div></div></demo-file></docs-demo><p>See the <a \nhref=\"layout/options\">layout options page</a> for more information on responsive flex directives like <code>hide-sm\n</code> and <code>layout-wrap</code> used in the above examples.</p><br><hr><br><h3>Additional Flex Values</h3><p>\nThere are additional flex values provided by Angular Material to improve flexibility and to make the API easier to understand.\n</p><docs-demo demo-title=\"Other Flex Values\" class=\"small-demo colorNested-noPad\"><demo-file name=\"index.html\"><div \nlayout=\"row\" layout-wrap><div flex=\"none\">[flex=\"none\"]</div><div flex>[flex]</div><div flex=\"nogrow\">[flex=\"nogrow\"]\n</div><div flex=\"grow\">[flex=\"grow\"]</div><div flex=\"initial\">[flex=\"initial\"]</div><div flex=\"auto\">[flex=\"auto\"]\n</div><div flex=\"noshrink\">[flex=\"noshrink\"]</div><div flex=\"0\">[flex=\"0\"]</div></div></demo-file></docs-demo><table \nclass=\"md-api-table\"><tr><td>flex</td><td>Will grow and shrink as needed. Starts with a size of 0%. Same as <code>\nflex=\"0\"</code>.<br><br><b>Note:</b>\n There is a known bug with this attribute in IE11 when the parent container has no explicit height set. See our <a \nng-href=\"layout/tips#layout-column-0px-ie11\">Troubleshooting</a> page for more info.</td></tr><tr><td>flex=\"none\"</td>\n<td>Will not grow or shrink. Sized based on its <code>width</code> and <code>height</code> values.</td></tr><tr><td>\nflex=\"initial\"</td><td>Will shrink as needed. Starts with a size based on its <code>width</code> and <code>height\n</code> values.</td></tr><tr><td>flex=\"auto\"</td><td>Will grow and shrink as needed. Starts with a size based on its \n<code>width</code> and <code>height</code> values.</td></tr><tr><td>flex=\"grow\"</td><td>\nWill grow and shrink as needed. Starts with a size of 100%. Same as <code>flex=\"100\"</code>.</td></tr><tr><td>\nflex=\"nogrow\"</td><td>Will shrink as needed, but won\'t grow. Starts with a size based on its <code>width</code> and \n<code>height</code> values.</td></tr><tr><td>flex=\"noshrink\"</td><td>\nWill grow as needed, but won\'t shrink. Starts with a size based on its <code>width</code> and <code>height</code>\n values.</td></tr></table><br><hr><br><h3>Ordering HTML Elements</h3><p>Add the <code>flex-order</code>\n directive to a layout child to set its order position within the layout container. Any integer value from -20 to 20 is accepted.\n</p><docs-demo demo-title=\"Flex-Order Directive\" class=\"small-demo colorNested\"><demo-file name=\"index.html\"><div \nlayout=\"row\"><div flex flex-order=\"-1\"><p>[flex-order=\"-1\"]</p></div><div flex flex-order=\"1\" flex-order-gt-md=\"3\"><p \nhide-gt-md>[flex-order=\"1\"]</p><p hide show-gt-md>[flex-order-gt-md=\"3\"]</p></div><div flex flex-order=\"2\"><p>\n[flex-order=\"2\"]</p></div><div flex flex-order=\"3\" flex-order-gt-md=\"1\"><p hide-gt-md>[flex-order=\"3\"]</p><p hide \nshow-gt-md>[flex-order-gt-md=\"1\"]</p></div></div></demo-file></docs-demo><table class=\"md-api-table\"><thead><tr><th>API\n</th><th>Device <b>width</b> when breakpoint overrides default</th></tr></thead><tr><td>flex-order</td><td>\nSets default layout order unless overridden by another breakpoint.</td></tr><tr><td>flex-order-xs</td><td>width &lt; \n<b>600</b>px</td></tr><tr><td>flex-order-gt-xs</td><td>width &gt;= <b>600</b>px</td></tr><tr><td>flex-order-sm</td><td>\n<b>600</b>px &lt;= width &lt; <b>960</b>px</td></tr><tr><td>flex-order-gt-sm</td><td>width &gt;= <b>960</b>px</td></tr>\n<tr><td>flex-order-md</td><td><b>960</b>px &lt;= width &lt; <b>1280</b>px</td></tr><tr><td>flex-order-gt-md</td><td>\nwidth &gt;= <b>1280</b>px</td></tr><tr><td>flex-order-lg</td><td><b>1280</b>px &lt;= width &lt; <b>1920</b>px</td></tr>\n<tr><td>flex-order-gt-lg</td><td>width &gt;= <b>1920</b>px</td></tr><tr><td>flex-order-xl</td><td>width &gt;= <b>1920\n</b>px</td></tr></table><p>See the <a href=\"layout/options\">layout options page</a>\n for more information on directives like <code>hide</code>, <code>hide-gt-md</code>, and <code>show-gt-md</code>\n used in the above examples.</p><br><hr><br><h3>Add Offsets to the Preceding HTML Elements</h3><p>Add the <code>\nflex-offset</code>\n directive to a layout child to set its offset percentage within the layout container. Values must be multiples of \n<code>5</code> or <code>33</code> / <code>66</code>. These offsets establish a <code>margin-left</code>\n with respect to the preceding element or the containers left boundary.</p><p>When using <code>flex-offset</code>\n the margin-left offset is applied... regardless of your choice of <code>flex-order</code>. or if you use a <code>\nflex-direction: reverse</code>.</p><docs-demo demo-title=\"Flex-Offset Directive\" class=\"small-demo colorNested\">\n<demo-file name=\"index.html\"><div layout=\"row\"><div flex=\"66\" flex-offset=\"15\">[flex-offset=\"15\"] [flex=\"66\"]</div><div\n flex>[flex]</div></div></demo-file></docs-demo><table class=\"md-api-table\"><thead><tr><th>API</th><th>\nDevice width when breakpoint overrides default</th></tr></thead><tr><td>flex-offset</td><td>\nSets default margin-left offset (<b>%-based</b>) unless overridden by another breakpoint.</td></tr><tr><td>\nflex-offset-xs</td><td>width &lt; <b>600</b>px</td></tr><tr><td>flex-offset-gt-xs</td><td>width &gt;= <b>600</b>px</td>\n</tr><tr><td>flex-offset-sm</td><td><b>600</b>px &lt;= width &lt; <b>960</b>px</td></tr><tr><td>flex-offset-gt-sm</td>\n<td>width &gt;= <b>960</b>px</td></tr><tr><td>flex-offset-md</td><td><b>960</b>px &lt;= width &lt; <b>1280</b>px</td>\n</tr><tr><td>flex-offset-gt-md</td><td>width &gt;= <b>1280</b>px</td></tr><tr><td>flex-offset-lg</td><td><b>1280</b>\npx &lt;= width &lt; <b>1920</b>px</td></tr><tr><td>flex-offset-gt-lg</td><td>width &gt;= <b>1920</b>px</td></tr><tr>\n<td>flex-offset-xl</td><td>width &gt;= <b>1920</b>px</td></tr></table></div>");
$templateCache.put("app/main/components/material-docs/layout/layout-container.tmpl.html","<div ng-controller=\"LayoutCtrl\" class=\"layout-content\" ng-cloak><h3>Layout and Containers</h3><p>Use the <code>layout\n</code> directive on a container element to specify the layout direction for its children: horizontally in a row (\n<code>layout=\"row\"</code>) or vertically in a column (<code>layout=\"column\"</code>). Note that <code>row</code>\n is the default layout direction if you specify the <code>layout</code> directive without a value.</p><table><tr><td \nstyle=\"font-weight: bold; background-color: #DBEEF5\">row</td><td style=\"padding-left: 10px\">\nItems arranged horizontally. <code>max-height = 100%</code> and <code>max-width</code>\n is the width of the items in the container.</td></tr><tr><td style=\"font-weight: bold; background-color: #DBEEF5\">\ncolumn</td><td style=\"padding-left: 10px\">Items arranged vertically. <code>max-width = 100%</code> and <code>max-height\n</code> is the height of the items in the container.</td></tr></table><br><docs-demo demo-title=\"Layout Directive\" \nclass=\"small-demo colorNested\"><demo-file name=\"index.html\"><div layout=\"row\"><div flex>First item in row</div><div \nflex>Second item in row</div></div><div layout=\"column\"><div flex>First item in column</div><div flex>\nSecond item in column</div></div></demo-file></docs-demo><p>Note that <code>layout</code>\n only affects the flow direction for that container\'s <b>immediate</b> children.</p><hr><br><h3>\nLayouts and Responsive Breakpoints</h3><p>As discussed in the <a href=\"layout/introduction\">Layout Introduction page\n</a> you can make your layout change depending upon the device view size by using <b>breakpoint alias</b> suffixes.</p>\n<p>To make your layout automatically change depending upon the device screen size, use one to the following <code>\nlayout</code> APIs to set the layout direction for devices with view widths:</p><table class=\"md-api-table\"><thead><tr>\n<th>API</th><th>Device width when breakpoint overrides default</th></tr></thead><tr><td>layout</td><td>\nSets default layout direction unless overridden by another breakpoint.</td></tr><tr><td>layout-xs</td><td>width &lt; \n<b>600</b>px</td></tr><tr><td>layout-gt-xs</td><td>width &gt;= <b>600</b>px</td></tr><tr><td>layout-sm</td><td><b>600\n</b>px &lt;= width &lt; <b>960</b>px</td></tr><tr><td>layout-gt-sm</td><td>width &gt;= <b>960</b>px</td></tr><tr><td>\nlayout-md</td><td><b>960</b>px &lt;= width &lt; <b>1280</b>px</td></tr><tr><td>layout-gt-md</td><td>width &gt;= <b>1280\n</b>px</td></tr><tr><td>layout-lg</td><td><b>1280</b>px &lt;= width &lt; <b>1920</b>px</td></tr><tr><td>layout-gt-lg\n</td><td>width &gt;= <b>1920</b>px</td></tr><tr><td>layout-xl</td><td>width &gt;= <b>1920</b>px</td></tr></table><br>\n<p><a \nhref=\"https://camo.githubusercontent.com/ad81ae92f8b4285747ce4e48007bf3f104dd5630/687474703a2f2f6d6174657269616c2d64657369676e2e73746f726167652e676f6f676c65617069732e636f6d2f7075626c6973682f6d6174657269616c5f765f342f6d6174657269616c5f6578745f7075626c6973682f3042386f6c5631354a3761625053474678656d46695156527462316b2f6c61796f75745f61646170746976655f627265616b706f696e74735f30312e706e67\" \ntarget=\"_blank\" style=\"text-decoration: none;border: 0 none\"><img \nsrc=\"https://camo.githubusercontent.com/ad81ae92f8b4285747ce4e48007bf3f104dd5630/687474703a2f2f6d6174657269616c2d64657369676e2e73746f726167652e676f6f676c65617069732e636f6d2f7075626c6973682f6d6174657269616c5f765f342f6d6174657269616c5f6578745f7075626c6973682f3042386f6c5631354a3761625053474678656d46695156527462316b2f6c61796f75745f61646170746976655f627265616b706f696e74735f30312e706e67\" \nalt=\"\" style=\"max-width:100%;text-decoration: none;border: 0 none\"></a></p><p>\nFor the demo below, as you shrink your browser window width notice the flow direction changes to <code>column</code>\n for mobile devices (<code>xs</code>). And as you expand it will reset to <code>row</code> for <code>gt-sm</code>\n view sizes.</p><docs-demo demo-title=\"Responsive Layouts\" class=\"small-demo colorNested\"><demo-file name=\"index.html\">\n<div layout=\"row\" layout-xs=\"column\"><div flex>I\'m above on mobile, and to the left on larger devices.</div><div flex>\nI\'m below on mobile, and to the right on larger devices.</div></div></demo-file></docs-demo><p>See the <a \nhref=\"layout/options\">Layout Options page</a> for more options such as padding, alignments, etc.</p></div>");
$templateCache.put("app/main/components/material-docs/layout/layout-introduction.tmpl.html","<div ng-controller=\"LayoutCtrl\" class=\"layout-content\" ng-cloak><h3>Overview</h3><p>\nAngular Material\'s Layout features provide sugar to enable developers to more easily create modern, responsive layouts on top of CSS3 \n<a href=\"http://www.w3.org/TR/css3-flexbox/\">flexbox</a>\n. The layout API consists of a set of Angular directives that can be applied to any of your application\'s HTML content.\n</p><p>Using <b>HTML Directives</b> as the API provides an easy way to set a value (eg. <code>layout=\"row\"</code>\n) and helps with separation of concerns: Attributes define layout while CSS classes assign styling.</p><table \nclass=\"md-api-table\"><thead><tr><th>HTML Markup API</th><th>Allowed values (raw or interpolated)</th></tr></thead>\n<tbody><tr><td>layout</td><td><code>row | column</code></td></tr><tr><td>flex</td><td>\ninteger (increments of 5 for 0%->100%, 100%/3, 200%/3)</td></tr><tr><td>flex-order</td><td>\ninteger values from -20 to 20</td></tr><tr><td>flex-offset</td><td>\ninteger (increments of 5 for 0%->95%, 100%/3, 200%/3)</td></tr><tr><td>layout-align</td><td><code>\nstart|center|end|space-around|space-between</code> <code>start|center|end|stretch</code></td></tr><tr><td>layout-fill\n</td><td></td></tr><tr><td>layout-wrap</td><td></td></tr><tr><td>layout-nowrap</td><td></td></tr><tr><td>layout-margin\n</td><td></td></tr><tr><td>layout-padding</td><td></td></tr><tr><td>show</td><td></td></tr><tr><td>hide</td><td></td>\n</tr></tbody></table><p>And if we use Breakpoints as specified in Material Design:</p><p><a \nhref=\"https://camo.githubusercontent.com/ad81ae92f8b4285747ce4e48007bf3f104dd5630/687474703a2f2f6d6174657269616c2d64657369676e2e73746f726167652e676f6f676c65617069732e636f6d2f7075626c6973682f6d6174657269616c5f765f342f6d6174657269616c5f6578745f7075626c6973682f3042386f6c5631354a3761625053474678656d46695156527462316b2f6c61796f75745f61646170746976655f627265616b706f696e74735f30312e706e67\" \ntarget=\"_blank\"><img \nsrc=\"https://camo.githubusercontent.com/ad81ae92f8b4285747ce4e48007bf3f104dd5630/687474703a2f2f6d6174657269616c2d64657369676e2e73746f726167652e676f6f676c65617069732e636f6d2f7075626c6973682f6d6174657269616c5f765f342f6d6174657269616c5f6578745f7075626c6973682f3042386f6c5631354a3761625053474678656d46695156527462316b2f6c61796f75745f61646170746976655f627265616b706f696e74735f30312e706e67\" \nalt=\"\" style=\"max-width:100%\"></a></p><p>We can associate breakpoints with mediaQuery definitions using breakpoint \n<strong>alias(es)</strong>:</p><table class=\"md-api-table\"><thead><tr><th>Breakpoint</th><th>MediaQuery (pixel range)\n</th></tr></thead><tbody><tr><td>xs</td><td>\'(max-width: <b>599</b>px)\'</td></tr><tr><td>gt-xs</td><td>\'(min-width: <b>\n600</b>px)\'</td></tr><tr><td>sm</td><td>\'(min-width: <b>600</b>px) and (max-width: <b>959</b>px)\'</td></tr><tr><td>\ngt-sm</td><td>\'(min-width: <b>960</b>px)\'</td></tr><tr><td>md</td><td>\'(min-width: <b>960</b>px) and (max-width: <b>\n1279</b>px)\'</td></tr><tr><td>gt-md</td><td>\'(min-width: <b>1280</b>px)\'</td></tr><tr><td>lg</td><td>\'(min-width: <b>\n1280</b>px) and (max-width: <b>1919</b>px)\'</td></tr><tr><td>gt-lg</td><td>\'(min-width: <b>1920</b>px)\'</td></tr><tr>\n<td>xl</td><td>\'(min-width: <b>1920</b>px)\'</td></tr></tbody></table><br><hr><h3>API with Responsive Breakpoints</h3>\n<p>Now we can combine the breakpoint <code>alias</code>\n with the Layout API to easily support Responsive breakpoints with our simple Layout markup convention. The <code>alias\n</code> is simply used as <b>suffix</b> extensions to the Layout API keyword.<br>e.g.</p><p>\nThis notation results in, for example, the following table for the <code>layout</code> and <code>flex</code> APIs:</p>\n<table class=\"md-api-table\"><thead><tr><th>layout API</th><th>flex API</th><th>Activates when device</th></tr></thead>\n<tr><td>layout</td><td>flex</td><td>Sets default layout direction &amp; flex unless overridden by another breakpoint.\n</td></tr><tr><td>layout-xs</td><td>flex-xs</td><td>width &lt; <b>600</b>px</td></tr><tr><td>layout-gt-xs</td><td>\nflex-gt-xs</td><td>width &gt;= <b>600</b>px</td></tr><tr><td>layout-sm</td><td>flex-sm</td><td><b>600</b>\npx &lt;= width &lt; <b>960</b>px</td></tr><tr><td>layout-gt-sm</td><td>flex-gt-sm</td><td>width &gt;= <b>960</b>px</td>\n</tr><tr><td>layout-md</td><td>flex-md</td><td><b>960</b>px &lt;= width &lt; <b>1280</b>px</td></tr><tr><td>\nlayout-gt-md</td><td>flex-gt-md</td><td>width &gt;= <b>1280</b>px</td></tr><tr><td>layout-lg</td><td>flex-lg</td><td>\n<b>1280</b>px &lt;= width &lt; <b>1920</b>px</td></tr><tr><td>layout-gt-lg</td><td>flex-gt-lg</td><td>width &gt;= <b>\n1920</b>px</td></tr><tr><td>layout-xl</td><td>flex-xl</td><td>width &gt;= <b>1920</b>px</td></tr></table><p>\nBelow is an example usage of the Responsive Layout API:</p><hljs lang=\"html\"><div layout=\"column\" class=\"zero\"><div \nflex=\"33\" flex-md=\"{{ vm.box1Width }}\" class=\"one\"></div><div flex=\"33\" layout=\"{{ vm.direction }}\" layout-md=\"row\" \nclass=\"two\"><div flex=\"20\" flex-md=\"10\" hide-lg class=\"two_one\"></div><div flex=\"30px\" show hide-md=\"{{ vm.hideBox }}\" \nflex-md=\"25\" class=\"two_two\"></div><div flex=\"20\" flex-md=\"65\" class=\"two_three\"></div></div><div flex class=\"three\">\n</div></div></hljs><br><p>\nThis Layout API means it is much easier to set up and maintain flexbox layouts vs. defining everything via CSS. The developer uses the Layout HTML API to specify \n<b><i>intention</i></b> and the Layout engine handles all the issues of CSS flexbox styling.</p><p class=\"layout_note\">\nThe Layout engine will log console warnings when it encounters conflicts or known issues.</p><br><br><hr><br><h3>\nUnder-the-Hood</h3><p>Due to performance problems when using Attribute Selectors with <b>Internet Explorer</b>\n browsers; see the following for more details:</p><p>\nLayout directives dynamically generate class selectors at runtime. And the Layout CSS classNames and styles have each been predefined in the \n<code>angular-material.css</code> stylesheet.</p><p class=\"layout_note\">\nDevelopers should continue to use Layout directives in the HTML markup as the classes may change between releases.</p>\n<p>Let\'s see how this directive-to-className transformation works. Consider the simple use of the <code>layout</code>\n and <code>flex</code> directives (API):</p><hljs lang=\"html\"><div><div layout=\"row\"><div flex>First item in row</div>\n<div flex=\"20\">Second item in row</div></div><div layout=\"column\"><div flex=\"66\">First item in column</div><div \nflex=\"33\">Second item in column</div></div></div></hljs><p>At runtime, these attributes are transformed to CSS classes.\n</p><hljs lang=\"html\"><div><div class=\"ng-scope layout-row\"><div class=\"flex\">First item in row</div><div \nclass=\"flex-20\">Second item in row</div></div><div class=\"ng-scope layout-column\"><div class=\"flex-33\">\nFirst item in column</div><div class=\"flex-66\">Second item in column</div></div></div></hljs><p>\nUsing the style classes above defined in <code>angular-material.css</code></p><hljs lang=\"css\">\n.flex { -webkit-flex: 1 1 0%; -ms-flex: 1 1 0%; flex: 1 1 0%; box-sizing: border-box; } .flex-20 { -webkit-flex: 1 1 20%; -ms-flex: 1 1 20%; flex: 1 1 20%; max-width: 20%; max-height: 100%; box-sizing: border-box; } .layout-row .flex-33 { -webkit-flex: 1 1 calc(100% / 3); -ms-flex: 1 1 calc(100% / 3); flex: 1 1 calc(100% / 3); box-sizing: border-box; } .layout-row .flex-66 { -webkit-flex: 1 1 calc(200% / 3); -ms-flex: 1 1 calc(200% / 3); flex: 1 1 calc(200% / 3); box-sizing: border-box; } .layout-row .flex-33 { max-width: calc(100% / 3); max-height: 100%; } .layout-row .flex-66 { max-width: calc(200% / 3); max-height: 100%; } .layout-column .flex-33 { max-width: 100%; max-height: calc(100% / 3); } .layout-column .flex-66 { max-width: 100%; max-height: calc(200% / 3); }\n</hljs></div>");
$templateCache.put("app/main/components/material-docs/layout/layout-options.tmpl.html","<div ng-controller=\"LayoutCtrl\" class=\"layout-content layout-options\" ng-cloak><docs-demo \ndemo-title=\"Responsive Layout\" class=\"small-demo colorNested\"><demo-file name=\"index.html\"><div layout=\"row\" \nlayout-sm=\"column\"><div flex>I\'m above on mobile, and to the left on larger devices.</div><div flex>\nI\'m below on mobile, and to the right on larger devices.</div></div></demo-file></docs-demo><p>See the <a \nhref=\"layout/container\">Container Elements</a> page for a basic explanation of layout directives.<br>\nTo make your layout change depending upon the device screen size, there are other <code>layout</code>\n directives available:</p><table class=\"md-api-table\"><thead><tr><th>API</th><th>Activates when device</th></tr>\n</thead><tr><td>layout</td><td>Sets default layout direction unless overridden by another breakpoint.</td></tr><tr><td>\nlayout-xs</td><td>width &lt; <b>600</b>px</td></tr><tr><td>layout-gt-xs</td><td>width &gt;= <b>600</b>px</td></tr><tr>\n<td>layout-sm</td><td><b>600</b>px &lt;= width &lt; <b>960</b>px</td></tr><tr><td>layout-gt-sm</td><td>width &gt;= <b>\n960</b>px</td></tr><tr><td>layout-md</td><td><b>960</b>px &lt;= width &lt; <b>1280</b>px</td></tr><tr><td>layout-gt-md\n</td><td>width &gt;= <b>1280</b>px</td></tr><tr><td>layout-lg</td><td><b>1280</b>px &lt;= width &lt; <b>1920</b>px</td>\n</tr><tr><td>layout-gt-lg</td><td>width &gt;= <b>1920</b>px</td></tr><tr><td>layout-xl</td><td>width &gt;= <b>1920</b>\npx</td></tr></table><br><br><hr><br><h3>Layout Margin, Padding, Wrap and Fill</h3><br><docs-demo \ndemo-title=\"Layout Margin, Padding, and Fill\" class=\"small-demo colorNested-noPad\"><demo-file name=\"index.html\"><div \nlayout=\"row\" layout-margin><div flex>Parent layout and this element have margins.</div></div><div layout=\"row\" \nlayout-padding><div flex>Parent layout and this element have padding.</div></div><div layout=\"row\" layout-fill \nstyle=\"min-height: 224px\"><div flex>Parent layout is set to fill available space.</div></div><div layout=\"row\" \nlayout-padding layout-margin layout-fill style=\"min-height: 224px\"><div flex>I am using all three at once.</div></div>\n</demo-file></docs-demo><p><code>layout-margin</code> adds margin around each <code>flex</code>\n child. It also adds a margin to the layout container itself.<br><code>layout-padding</code> adds padding inside each \n<code>flex</code> child. It also adds padding to the layout container itself.<br><code>layout-fill</code>\n forces the layout element to fill its parent container.</p><p>Here is a non-trivial group of <code>flex</code>\n elements using <code>layout-wrap</code></p><docs-demo demo-title=\"Wrap\" class=\"small-demo colorNested-noPad\">\n<demo-file name=\"index.html\"><div layout=\"row\" layout-wrap><div flex=\"33\">[flex=33]</div><div flex=\"66\">[flex=66]</div>\n<div flex=\"66\">[flex=66]</div><div flex=\"33\">[flex=33]</div><div flex=\"33\">[flex=33]</div><div flex=\"33\">[flex=33]\n</div><div flex=\"33\">[flex=33]</div></div></demo-file></docs-demo><p><code>layout-wrap</code> allows <code>flex</code>\n children to wrap within the container if the elements use more than 100%.<br></p><br><br><hr><br><h3>Show &amp; Hide\n</h3><p>Use the <code>show</code> <code>hide</code>\n APIs to responsively show or hide elements. While these work similar to <code>ng-show</code> and <code>ng-hide</code>\n, these Angular Material Layout directives are mediaQuery-aware.</p><docs-demo demo-title=\"Hide and Show Directives\" \nclass=\"small-demo colorNested\"><demo-file name=\"index.html\"><div layout=\"row\"><div hide show-gt-sm flex>\nOnly show on gt-sm devices.</div><div hide-gt-sm flex>Shown on small and medium.<br>Hidden on gt-sm devices.</div><div \nshow hide-gt-md flex>Shown on small and medium size devices.<br>Hidden on gt-md devices.</div><div hide show-md flex>\nShown on medium size devices only.</div><div hide show-gt-lg flex>Shown on devices larger than 1200px wide only.</div>\n</div></demo-file></docs-demo><br><table class=\"md-api-table\"><thead><tr><th>hide (display: none)</th><th>\nshow (negates hide)</th><th>Activates when:</th></tr></thead><tr><td>hide-xs</td><td>show-xs</td><td>width &lt; <b>600\n</b>px</td></tr><tr><td>hide-gt-xs</td><td>show-gt-xs</td><td>width &gt;= <b>600</b>px</td></tr><tr><td>hide-sm</td>\n<td>show-sm</td><td><b>600</b>px &lt;= width &lt; <b>960</b>px</td></tr><tr><td>hide-gt-sm</td><td>show-gt-sm</td><td>\nwidth &gt;= <b>960</b>px</td></tr><tr><td>hide-md</td><td>show-md</td><td><b>960</b>px &lt;= width &lt; <b>1280</b>px\n</td></tr><tr><td>hide-gt-md</td><td>show-gt-md</td><td>width &gt;= <b>1280</b>px</td></tr><tr><td>hide-lg</td><td>\nshow-lg</td><td><b>1280</b>px &lt;= width &lt; <b>1920</b>px</td></tr><tr><td>hide-gt-lg</td><td>show-gt-lg</td><td>\nwidth &gt;= <b>1920</b>px</td></tr><tr><td>hide-xl</td><td>show-xl</td><td>width &gt;= <b>1920</b>px</td></tr></table>\n</div>");
$templateCache.put("app/main/components/material-docs/layout/layout-tips.tmpl.html","<style>ul.spaced li {\n    margin-bottom: 15px;\n  }</style><div ng-controller=\"LayoutTipsCtrl as tips\" \nclass=\"layout-content\"><h3>Overview</h3><p>The Angular Material Layout system uses the current <a \nhref=\"http://www.w3.org/TR/css3-flexbox/\">Flexbox</a>\n feature set. More importantly, it also adds syntactic sugar to allow developers to easily and quickly add Responsive features to HTML containers and elements.\n</p><p>\nAs you use the Layout features, you may encounter scenarios where the layouts do not render as expected; especially with IE 10 and 11 browsers. There may also be cases where you need to add custom HTML, CSS and Javascript to achieve your desired results.\n</p><br><hr><h3>Resources</h3><p>\nIf you are experiencing an issue in a particular browser, we highly recommend using the following resources for known issues and workarounds.\n</p><ul><li><a href=\"https://github.com/philipwalton/flexbugs#flexbugs\" target=\"_blank\">FlexBugs</a></li><li><a \nhref=\"https://philipwalton.github.io/solved-by-flexbox/\" target=\"_blank\">Solved by FlexBugs</a></li><li><a \nhref=\"http://philipwalton.com/articles/normalizing-cross-browser-flexbox-bugs/\" target=\"_blank\">\nNormalizing Cross-browser Flexbox Bugs</a></li><li style=\"margin-bottom: 20px\"><a \nhref=\"http://caniuse.com/#search=flex\" target=\"_blank\">Can I use flexbox...? ( see the <code>Known Issues</code> tab)\n</a></li><li><a href=\"https://groups.google.com/forum/#!forum/ngmaterial\">Angular Material Forum</a></li><li \nstyle=\"margin-top: 20px\"><a href=\"https://css-tricks.com/snippets/css/a-guide-to-flexbox/\" target=\"_blank\">\nA Complete Guide to Flexbox</a></li><li style=\"margin-bottom: 20px\"><a \nhref=\"https://scotch.io/tutorials/a-visual-guide-to-css3-flexbox-properties\" target=\"_blank\">\nA Visual Guide to CSS3 Flexbox Properties</a></li></ul><br><hr><h3>General Tips</h3><p>\nBelow, you will find solutions to some of the more common scenarios and problems that may arise when using Material\'s Layout system. The following sections offer general guidelines and tips when using the \n<code>flex</code> and <code>layout</code> directives within your own applications.</p><ul class=\"spaced\"><li>\nWhen building your application\'s Layout, it is usually best to start with a mobile version that looks and works correctly, and then apply styling for larger devices using the \n<code>flex-gt-*</code> or <code>hide-gt-*</code>\n attributes. This approach typically leads to less frustration than starting big and attempting to fix issues on smaller devices.\n</li><li>Some elements like <code>&lt;fieldset&gt;</code> and <code>&lt;button&gt;</code>\n do not always work correctly with flex. Additionally, some of the Angular Material components provide their own styles. If you are having difficulty with a specific element/component, but not others, try applying the flex attributes to a parent or child \n<code>&lt;div&gt;</code> of the element instead.</li><li>Some Flexbox properties such as <code>flex-direction</code> \n<u>cannot</u> be animated.</li><li>\nFlexbox can behave differently on different browsers. You should test as many as possible on a regular basis so that you can catch and fix layout issues more quickly.\n</li></ul><br><hr><h3>Layout Column</h3><p>In some scenarios <code>layout=\"column\"</code>\n and breakpoints (xs, gt-xs, xs, gt-sm, etc.) may not work as expected due to CSS specificity rules.</p><div \nclass=\"md-whiteframe-3dp\"><iframe height=\"700\" scrolling=\"no\" \nsrc=\"//codepen.io/team/AngularMaterial/embed/obgapg/?height=700&theme-id=21180&default-tab=result\" frameborder=\"no\" \nallowtransparency=\"true\" allowfullscreen=\"true\" style=\"width: 100%\">See the Pen <a \nhref=\"http://codepen.io/team/AngularMaterial/pen/obgapg/\">Card Layouts (corrected)</a> by Angular Material (<a \nhref=\"http://codepen.io/AngularMaterial\">@AngularMaterial</a>) on <a href=\"http://codepen.io\">CodePen</a>.</iframe>\n</div><p>This is easily fixed simply by inverting the layout logic so that the default is <code>layout=\'row\'</code>\n. To see how the layout changes, shrink the browser window its width is &lt; 600px;</p><br><hr><h3 \nid=\"layout-column-0px-ie11\">IE11 - Layout Column, 0px Height</h3><p>\nIn Internet Explorer 11, when you have a column layout with unspecified height and flex items inside, the browser can get confused and incorrectly calculate the height of each item (and thus the container) as \n<code>0px</code>, making the items overlap and not take up the proper amount of space.</p><p class=\"layout_note\"><b>\nNote:</b>\n The flex items below actually do have some height. This is because our doc-specific CSS provides a small bit of padding (\n<code>8px</code>). We felt that the extra padding made for a better demo of the actual issue.</p><docs-demo \ndemo-title=\"IE11 - Layout Column, 0px Height\" class=\"colorNested\"><demo-file name=\"index.html\"><div flex \nlayout=\"column\"><div flex>11111<br>11111<br>11111</div><div flex>22222<br>22222<br>22222</div><div flex>33333<br>33333\n<br>33333</div></div></demo-file></docs-demo><p>\nUnfortunately, there is no IE11 specific fix available, and the suggested workaround is to set the <code>flex-basis\n</code> property to <code>auto</code> instead of <code>0px</code> (which is the default setting).</p><p>\nYou can easily achieve this using the <code>flex=\"auto\"</code> attribute that the Layout system provides.</p><docs-demo\n demo-title=\"IE11 - Layout Column, 0px Height (Fix 1)\" class=\"colorNested\"><demo-file name=\"index.html\"><div flex \nlayout=\"column\"><div flex=\"auto\">11111<br>11111<br>11111</div><div flex=\"auto\">22222<br>22222<br>22222</div><div \nflex=\"auto\">33333<br>33333<br>33333</div></div></demo-file></docs-demo><p>\nAlternatively, you can manually set the height of the layout container (<code>400px</code> in the demo below).</p>\n<docs-demo demo-title=\"IE11 - Layout Column, 0px Height (Fix 2)\" class=\"colorNested\"><demo-file name=\"index.html\"><div \nflex layout=\"column\" style=\"height: 400px\"><div flex>11111<br>11111<br>11111</div><div flex>22222<br>22222<br>22222\n</div><div flex>33333<br>33333<br>33333</div></div></demo-file></docs-demo><br><hr><h3>Flex Element Heights</h3><p>\nFirefox currently has an issue calculating the proper height of flex containers whose children are flex, but have more content than can properly fit within the container.\n</p><p>This is particularly problematic if the <code>flex</code> children are <code>md-content</code>\n components as it will prevent the content from scrolling correctly, instead scrolling the entire body.</p><div \nclass=\"md-whiteframe-3dp\"><iframe height=\"376\" scrolling=\"no\" \nsrc=\"//codepen.io/team/AngularMaterial/embed/NxKBwW/?height=376&theme-id=0&default-tab=result\" frameborder=\"no\" \nallowtransparency=\"true\" allowfullscreen=\"true\" style=\"width: 100%\">See the Pen <a \nhref=\"http://codepen.io/team/AngularMaterial/pen/NxKBwW/\">Angular Material Basic App</a> by Angular Material (<a \nhref=\"http://codepen.io/AngularMaterial\">@AngularMaterial</a>) on <a href=\"http://codepen.io\">CodePen</a>.</iframe>\n</div><p>Notice in the above Codepen how we must set <code>overflow: auto</code> on the div with the <code>\nchange-my-css</code> class in order for Firefox to properly calculate the height and shrink to the available space.</p>\n</div>");
$templateCache.put("app/main/ui/page-layouts/blank/blank.html","<div class=\"page-layout blank\" layout=\"row\"><h2>Blank page</h2></div>");
$templateCache.put("app/main/ui/page-layouts/demo/demo-content.html","<div class=\"demo-content\"><img src=\"assets/images/etc/early-sunrise.jpg\" class=\"md-card-image\" alt=\"sunrise\"><h1>\nEarly Sunrise</h1><h4 class=\"secondary-text\">Demo Content</h4><p>\nOne morning, when Gregor Samsa woke from troubled dreams, he found himself transformed in his bed into a horrible vermin. He lay on his armour-like back, and if he lifted his head a little he could see his brown belly, slightly domed and divided by arches into stiff sections.\n</p><blockquote><p>\nThe bedding was hardly able to cover it and seemed ready to slide off any moment. His many legs, pitifully thin compared with the size of the rest of him, waved about helplessly as he looked. \"What\'s happened to me? \" he thought. It wasn\'t a dream.\n</p><footer>John Doe</footer></blockquote><p>\nHis room, a proper human room although a little too small, lay peacefully between its four familiar walls. A collection of textile samples lay spread out on the table - Samsa was a travelling salesman - and above it there hung a picture that he had recently cut out of an illustrated magazine and housed in a nice, gilded frame.\n</p><p>\nIt showed a lady fitted out with a fur hat and fur boa who sat upright, raising a heavy fur muff that covered the whole of her lower arm towards the viewer. Gregor then turned to look out the window at the dull weather. Drops of rain could be heard hitting the pane, which made him feel quite sad.\n</p><p>\n\"How about if I sleep a little bit longer and forget all this nonsense\", he thought, but that was something he was unable to do because he was used to sleeping on his right, and in his present state couldn\'t get into that position. However hard he threw himself onto his right, he always rolled back to where he was.\n</p><p>\nHe must have tried it a hundred times, shut his eyes so that he wouldn\'t have to look at the floundering legs, and only stopped when he began to feel a mild, dull pain there that he had never felt before. \"Oh, God\", he thought, \"what a strenuous career it is that I\'ve chosen!\n</p><p>\nTravelling day in and day out. Doing business like this takes much more effort than doing your own business at home, and on top of that there\'s the curse of travelling, worries about making train connections, bad and irregular food, contact with different people all the time so that you can never get to know anyone or become friendly with them.\n</p><p>\n\"He felt a slight itch up on his belly; pushed himself slowly up on his back towards the headboard so that he could lift his head better; found where the itch was, and saw that it was covered with lots of little white spots which he didn\'t know what to make of; and when he tried to feel the place with one of his legs he drew it quickly back because as soon as he touched it he was overcome by a cold shudder. He slid back into his former position.\n</p><p>\n\"Getting up early all the time\", he thought, \"it makes you stupid. You\'ve got to get enough sleep. Other travelling salesmen live a life of luxury. For instance, whenever I go back to the guest house during the morning to copy out the contract, these gentlemen are always still sitting there eating their breakfasts. I ought to just try that with my boss; I\'d get kicked out on the spot. But who knows, maybe that would be the best thing for me...\n</p></div>");
$templateCache.put("app/main/ui/page-layouts/demo/demo-sidenav.html","<div class=\"demo-sidenav\"><md-list><md-subheader class=\"md-no-sticky\">Sidenav Demo</md-subheader><md-list-item><p>\nSidenav Item 1</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 2</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 3</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 4</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 5</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 6</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 7</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 8</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 9</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 10</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 11</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 12</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 13</p></md-list-item><md-divider></md-divider><md-list-item><p>Sidenav Item 14</p></md-list-item>\n<md-divider></md-divider><md-list-item><p>Sidenav Item 15</p></md-list-item><md-divider></md-divider><md-list-item><p>\nSidenav Item 16</p></md-list-item></md-list></div>");
$templateCache.put("app/main/pages/auth/forgot-password/forgot-password.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\">找回密码</div><form name=\"forgotPasswordForm\" novalidate>\n<div style=\"color: rgb(213,0,0)\">{{vm.notice_message}}</div><md-input-container class=\"md-block\" md-no-float><input \ntype=\"text\" name=\"mobile\" ng-model=\"vm.form.mobile\" placeholder=\"手机号\" required><div \nng-messages=\"forgotPasswordForm.mobile.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span>手机号必填\n</span></div></div></md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"RESET MY PASSWORD\" ng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" \nng-click=\"vm.formSubmit()\">找回密码</md-button></form><div class=\"login\" layout=\"row\" layout-align=\"center center\"><a \nclass=\"link\" ui-sref=\"app.pages_auth_login\">返回登陆</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/forgot-password/forgot-password_orig.html","<div id=\"forgot-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"forgot-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"forgot-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"FORGOTPASSWORD.TITLE\">Recover your password\n</div><form name=\"forgotPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"email\" \nname=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"FORGOTPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"forgotPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"FORGOTPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"RESET MY PASSWORD\" \nng-disabled=\"forgotPasswordForm.$invalid || forgotPasswordForm.$pristine\" translate=\"FORGOTPASSWORD.SEND_RESET_LINK\" \ntranslate-attr-aria-label=\"FORGOTPASSWORD.SEND_RESET_LINK\">SEND RESET LINK</md-button></form><div class=\"login\" \nlayout=\"row\" layout-align=\"center center\"><a class=\"link\" ui-sref=\"app.pages_auth_login\" \ntranslate=\"FORGOTPASSWORD.GO_BACK\">Go back to login</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/lock/lock.html","<div id=\"lock\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"lock-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"lock-form\" class=\"md-whiteframe-8dp\"><div layout=\"row\" \nlayout-align=\"start center\" layout-sm=\"column\" layout-align-sm=\"center center\"><div class=\"avatar-container\"><img \nclass=\"avatar big\" ng-src=\"{{vm.current_user[\'avatar\']}}\"><md-icon md-font-icon=\"icon-lock\" \nclass=\"md-warn-fg s36 md-hue-2\"></md-icon></div><div flex layout=\"column\" layout-align=\"start\" \nlayout-align-sm=\"center center\"><div class=\"title\" translate=\"LOCK.TITLE\">屏幕已锁</div><div class=\"subtitle\" \ntranslate=\"LOCK.SUBTITLE\">因长时间不操作屏幕已经锁屏，请输入您的密码重新打开</div></div></div><form name=\"lockForm\" novalidate><div \nstyle=\"color: rgb(213,0,0)\" ng-if=\"vm.login_message\">{{vm.login_message}}</div><md-input-container class=\"md-block\" \nmd-no-float><input ng-model=\"vm.form.username\" placeholder=\"Username\" translate \ntranslate-attr-placeholder=\"LOCK.USERNAME\" disabled=\"disabled\"></md-input-container><md-input-container \nclass=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" \ntranslate translate-attr-placeholder=\"LOCK.PASSWORD\" required><div ng-messages=\"lockForm.password.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"LOCK.ERRORS.PASSWORD_REQUIRED\">请输入密码</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"UNLOCK\" \nng-disabled=\"lockForm.$invalid || lockForm.$pristine || vm.loading\" translate=\"LOCK.UNLOCK\" \ntranslate-attr-aria-label=\"LOCK.UNLOCK\" ng-click=\"vm.formSubmit()\">UNLOCK</md-button></form><div class=\"message\"><a \nui-sref=\"app.pages_auth_login\" class=\"md-accent-color\"><span translate=\"LOCK.ARE_YOU_NOT\">你不是</span><span>\n {{vm.current_user[\'name\']}}?</span></a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/login/login.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"></div><div \nclass=\"title\">K12Plus后台登录系统</div><form name=\"loginForm\" novalidate><div style=\"color: rgb(213,0,0)\">\n{{vm.login_message}}</div><md-input-container class=\"md-block\" md-no-float><input type=\"text\" name=\"username\" \nng-model=\"vm.form.username\" placeholder=\"帐号\" required><div ng-messages=\"loginForm.username.$error\" role=\"alert\" \nmultiple=\"multiple\"><div ng-message=\"required\"><span>登陆帐号信息必填.</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nplaceholder=\"密码\" required><div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span>\n登陆密码必填.</span></div></div></md-input-container><div class=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" \nlayout-align=\"space-between center\"><md-checkbox class=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\">\n<span>记住我?</span></md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\">\n忘记密码?</a></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"登录\" id=\"login-btn\" \nng-disabled=\"loginForm.$invalid || loginForm.$pristine\" ng-click=\"vm.formSubmit()\">登录</md-button><div layout=\"row\" \nlayout-align=\"start center\"><md-progress-circular id=\"toolbar-progress\" ng-disabled=\"!$root.loadingProgress\" \nclass=\"md-accent\" md-diameter=\"32\" style=\"margin-left:146px\"></md-progress-circular></div></form></div></div></div>");
$templateCache.put("app/main/pages/auth/login/login_orig.html","<div id=\"login\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"login-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"login-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>F\n</span></div><div class=\"title\" translate=\"LOGIN.TITLE\">Log in to your account</div><form name=\"loginForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" \nplaceholder=\"Email\" translate translate-attr-placeholder=\"LOGIN.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"LOGIN.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" ng-model=\"vm.form.password\" \nplaceholder=\"Password\" translate translate-attr-placeholder=\"LOGIN.PASSWORD\" required><div \nng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-xs=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN.REMEMBER_ME\">Remember Me</span>\n</md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" \ntranslate=\"LOGIN.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \ntranslate=\"LOGIN.LOG_IN\" translate-attr-aria-label=\"LOGIN.LOG_IN\">LOG IN</md-button></form><div class=\"separator\"><span\n class=\"text\" translate=\"LOGIN.OR\">OR</span></div><md-button class=\"md-raised google\"><div layout=\"row\" \nlayout-align=\"center center\"><span><md-icon md-font-icon=\"icon-google-plus\" class=\"s16\"></md-icon><span \ntranslate=\"LOGIN.WITH_GOOGLE\">Log in with Google</span></span></div></md-button><md-button class=\"md-raised facebook\">\n<div layout=\"row\" layout-align=\"center center\"><span><md-icon md-font-icon=\"icon-facebook\" class=\"s16\"></md-icon><span \ntranslate=\"LOGIN.WITH_FACEBOOK\">Log in with Facebook</span></span></div></md-button><div class=\"register\" layout=\"row\" \nlayout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"LOGIN.DONT_HAVE_ACCOUNT\">\nDon\'t have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_register\" translate=\"LOGIN.CREATE_ACCOUNT\">\nCreate an account</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/register/register.html","<div id=\"register\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"register-form-wrapper\" layout=\"column\" \nlayout-align=\"center center\"><div id=\"register-form\" class=\"md-whiteframe-8dp\"><div class=\"logo md-accent-bg\"><span>F\n</span></div><div class=\"title\" translate=\"REGISTER.TITLE\">Create an account</div><form name=\"registerForm\" novalidate>\n<md-input-container class=\"md-block\" md-no-float><input name=\"username\" ng-model=\"vm.form.username\" placeholder=\"Name\" \ntranslate translate-attr-placeholder=\"REGISTER.NAME\" required><div ng-messages=\"registerForm.username.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.USERNAME_REQUIRED\">Username field is required\n</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"email\" \nname=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"REGISTER.EMAIL\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"REGISTER.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"REGISTER.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"REGISTER.PASSWORD\" required><div ng-messages=\"registerForm.password.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" translate \ntranslate-attr-placeholder=\"REGISTER.PASSWORD_CONFIRM\" required><div ng-messages=\"registerForm.passwordConfirm.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER.ERRORS.PASSWORD_CONFIRM_REQUIRED\">\nPassword (Confirm) field is required</span></div></div></md-input-container><div class=\"terms\" layout=\"row\" \nlayout-align=\"center center\"><md-checkbox name=\"terms\" ng-model=\"data.cb1\" aria-label=\"I read and accept\" required>\n</md-checkbox><div layout=\"row\" layout-sm=\"column\" layout-align=\"start center\"><span translate=\"REGISTER.READ_ACCEPT\">\nI read and accept</span> <a href=\"#\" class=\"md-accent-color\" translate=\"REGISTER.TERMS_COND\">terms and conditions</a>\n</div></div><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER.CREATE_ACCOUNT\" \ntranslate-attr-aria-label=\"REGISTER.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button></form><div class=\"login\" \nlayout=\"row\" layout-xs=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"REGISTER.ALREADY_HAVE\">\nAlready have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_login\" translate=\"REGISTER.LOGIN\">Log in</a>\n</div></div></div></div>");
$templateCache.put("app/main/pages/auth/login-v2/login-v2.html","<div id=\"login-v2\" layout=\"row\" layout-align=\"start\"><div id=\"login-v2-intro\" flex hide show-gt-sm><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"LOGIN_V2.INTRO_TITLE\">Welcome to the FUSE!\n</div><div class=\"description\" translate=\"LOGIN_V2.INTRO_DESCRIPTION\">\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.\n</div></div><div id=\"login-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" ms-scroll><div \nid=\"login-v2-form\"><div class=\"logo md-accent-bg\" hide-gt-sm><span>F</span></div><div class=\"title\" \ntranslate=\"LOGIN_V2.TITLE\">Log in to your account</div><div class=\"description\" translate=\"LOGIN_V2.DESCRIPTION\">\nSed mollis velit facilisis facilisis viverra</div><form name=\"loginForm\" novalidate><md-input-container \nclass=\"md-block\" md-no-float><input type=\"email\" name=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email\" translate \ntranslate-attr-placeholder=\"LOGIN_V2.EMAIL\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"loginForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN_V2.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"LOGIN_V2.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" placeholder=\"Password\" translate translate-attr-placeholder=\"LOGIN_V2.PASSWORD\" required>\n<div ng-messages=\"loginForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"LOGIN_V2.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container><div \nclass=\"remember-forgot-password\" layout=\"row\" layout-sm=\"column\" layout-align=\"space-between center\"><md-checkbox \nclass=\"remember-me\" ng-model=\"data.cb1\" aria-label=\"Remember Me\"><span translate=\"LOGIN_V2.REMEMBER_ME\">Remember Me\n</span></md-checkbox><a ui-sref=\"app.pages_auth_forgot-password\" class=\"forgot-password md-accent-color\" \ntranslate=\"LOGIN_V2.FORGOT_PASSWORD\">Forgot Password?</a></div><md-button type=\"submit\" \nclass=\"md-raised md-accent submit-button\" aria-label=\"LOG IN\" ng-disabled=\"loginForm.$invalid || loginForm.$pristine\" \ntranslate=\"LOGIN_V2.LOG_IN\" translate-attr-aria-label=\"LOGIN_V2.LOG_IN\">LOG IN</md-button></form><div \nclass=\"separator\"><span class=\"text\" translate=\"LOGIN_V2.OR\">OR</span></div><div layout=\"column\" \nlayout-align=\"start center\"><md-button class=\"md-raised google\"><div layout=\"row\" layout-align=\"center center\"><span>\n<md-icon md-font-icon=\"icon-google-plus\" class=\"s16\"></md-icon><span translate=\"LOGIN_V2.WITH_GOOGLE\">\nLog in with Google</span></span></div></md-button><md-button class=\"md-raised facebook\"><div layout=\"row\" \nlayout-align=\"center center\"><span><md-icon md-font-icon=\"icon-facebook\" class=\"s16\"></md-icon><span \ntranslate=\"LOGIN_V2.WITH_FACEBOOK\">Log in with Facebook</span></span></div></md-button></div><div class=\"register\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"LOGIN_V2.DONT_HAVE_ACCOUNT\">\nDon\'t have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_register-v2\" translate=\"LOGIN_V2.CREATE_ACCOUNT\">\nCreate an account</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/register-v2/register-v2.html","<div id=\"register-v2\" layout=\"row\" layout-align=\"start\"><div id=\"register-v2-intro\" flex hide show-gt-sm><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"REGISTER_V2.INTRO_TITLE\">\nWelcome to the FUSE!</div><div class=\"description\" translate=\"REGISTER_V2.INTRO_DESCRIPTION\">\nLorem ipsum dolor sit amet, consectetur adipiscing elit. Vivamus ullamcorper nisl erat, vel convallis elit fermentum pellentesque. Sed mollis velit facilisis facilisis viverra.\n</div></div><div id=\"register-v2-form-wrapper\" class=\"flex-scrollable md-whiteframe-8dp\" layout=\"column\" flex \nms-scroll><div id=\"register-v2-form\"><div class=\"logo md-accent-bg\" hide-gt-sm><span>F</span></div><div class=\"title\" \ntranslate=\"REGISTER_V2.TITLE\">Create an account</div><div class=\"description\" translate=\"REGISTER_V2.DESCRIPTION\">\nSed mollis velit facilisis facilisis viverra</div><form name=\"registerForm\" novalidate><md-input-container \nclass=\"md-block\" md-no-float><input name=\"username\" ng-model=\"vm.form.username\" placeholder=\"Name\" translate \ntranslate-attr-placeholder=\"REGISTER_V2.NAME\" required><div ng-messages=\"registerForm.username.$error\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.USERNAME_REQUIRED\">Username field is required</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"email\" name=\"email\" \nng-model=\"vm.form.email\" placeholder=\"Email\" translate translate-attr-placeholder=\"REGISTER_V2.EMAIL\" \nng-pattern=\"/^.+@.+\\..+$/\" required><div ng-messages=\"registerForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div \nng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div \nng-message=\"pattern\"><span translate=\"REGISTER_V2.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span>\n</div></div></md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" \nname=\"password\" ng-model=\"vm.form.password\" placeholder=\"Password\" translate \ntranslate-attr-placeholder=\"REGISTER_V2.PASSWORD\" required><div ng-messages=\"registerForm.password.$error\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"REGISTER_V2.ERRORS.PASSWORD_REQUIRED\">\nPassword field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" md-no-float>\n<input type=\"password\" name=\"passwordConfirm\" ng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" \ntranslate translate-attr-placeholder=\"REGISTER_V2.PASSWORD_CONFIRM\" required><div \nng-messages=\"registerForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"REGISTER_V2.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div>\n</md-input-container><div class=\"terms\" layout=\"row\" layout-align=\"center center\"><md-checkbox name=\"terms\" \nng-model=\"data.cb1\" aria-label=\"I read and accept\" required></md-checkbox><div layout=\"row\" layout-sm=\"column\" \nlayout-align=\"start center\"><span translate=\"REGISTER_V2.READ_ACCEPT\">I read and accept</span> <a href=\"#\" \nclass=\"md-accent-color\" translate=\"REGISTER_V2.TERMS_COND\">terms and conditions</a></div></div><md-button \ntype=\"submit\" class=\"md-raised md-accent submit-button\" aria-label=\"CREATE MY ACCOUNT\" \nng-disabled=\"registerForm.$invalid || registerForm.$pristine\" translate=\"REGISTER_V2.CREATE_ACCOUNT\" \ntranslate-attr-aria-label=\"REGISTER_V2.CREATE_ACCOUNT\">CREATE MY ACCOUNT</md-button></form><div class=\"login\" \nlayout=\"row\" layout-sm=\"column\" layout-align=\"center center\"><span class=\"text\" translate=\"REGISTER_V2.ALREADY_HAVE\">\nAlready have an account?</span> <a class=\"link\" ui-sref=\"app.pages_auth_login-v2\" translate=\"REGISTER_V2.LOGIN\">Log in\n</a></div></div></div></div>");
$templateCache.put("app/main/pages/auth/reset-password/reset-password.html","<div id=\"reset-password\" class=\"flex-scrollable\" layout=\"column\" ms-scroll><div id=\"reset-password-form-wrapper\" \nlayout=\"column\" layout-align=\"center center\"><div id=\"reset-password-form\" class=\"md-whiteframe-8dp\"><div \nclass=\"logo md-accent-bg\"><span>F</span></div><div class=\"title\" translate=\"RESETPASSWORD.TITLE\">Reset your password\n</div><form name=\"resetPasswordForm\" novalidate><md-input-container class=\"md-block\" md-no-float><input type=\"email\" \nname=\"email\" ng-model=\"vm.form.email\" placeholder=\"Email address\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.EMAIL_ADRESS\" ng-pattern=\"/^.+@.+\\..+$/\" required><div \nng-messages=\"resetPasswordForm.email.$error\" role=\"alert\" multiple=\"multiple\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.EMAIL_REQUIRED\">Email field is required</span></div><div ng-message=\"pattern\"><span \ntranslate=\"RESETPASSWORD.ERRORS.EMAIL_MUST_VALID\">Email must be a valid e-mail address</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"password\" \nng-model=\"vm.form.password\" placeholder=\"Password\" translate translate-attr-placeholder=\"RESETPASSWORD.PASSWORD\" \nrequired><div ng-messages=\"registerForm.password.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_REQUIRED\">Password field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" md-no-float><input type=\"password\" name=\"passwordConfirm\" \nng-model=\"vm.form.passwordConfirm\" placeholder=\"Password (Confirm)\" translate \ntranslate-attr-placeholder=\"RESETPASSWORD.PASSWORD_CONFIRM\" required><div \nng-messages=\"resetPasswordForm.passwordConfirm.$error\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"RESETPASSWORD.ERRORS.PASSWORD_CONFIRM_REQUIRED\">Password (Confirm) field is required</span></div></div>\n</md-input-container><md-button type=\"submit\" class=\"md-raised md-accent submit-button\" \naria-label=\"UPDATE MY PASSWORD\" ng-disabled=\"resetPasswordForm.$invalid || resetPasswordForm.$pristine\" \ntranslate=\"RESETPASSWORD.UPDATE_PASSWORD\" translate-attr-aria-label=\"RESETPASSWORD.UPDATE_PASSWORD\">RESET MY PASSWORD\n</md-button></form></div></div></div>");
$templateCache.put("app/main/pages/errors/401/error-401.html","<div id=\"error-401\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\">访问拒绝</div><div class=\"message\">您没有权限访问此页面。</div><a \nclass=\"back-link md-accent-color\" href=\"/store/dashboard\">返回 dashboard</a></div></div>");
$templateCache.put("app/main/pages/errors/404/error-404.html","<div id=\"error-404\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR404.CODE\">404</div><div class=\"message\" \ntranslate=\"ERROR404.MESSAGE\">Sorry but we couldn’t find the page you are looking for</div><div \nclass=\"search md-whiteframe-1dp\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-magnify\" \nclass=\"icon s24\"></md-icon><input ng-model=\"vm.search\" type=\"text\" placeholder=\"Search for anything\" translate \ntranslate-attr-placeholder=\"ERROR404.SEARCH\" flex></div><a class=\"back-link md-accent-color\" href=\"/\" \ntranslate=\"ERROR404.GO_BACK\">Go back to dashboard</a></div></div>");
$templateCache.put("app/main/pages/errors/500/error-500.html","<div id=\"error-500\" layout=\"column\" layout-align=\"center center\"><div class=\"content\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"error-code\" translate=\"ERROR500.CODE\">500</div><div class=\"message\" \ntranslate=\"ERROR500.MESSAGE\">Well, you broke the internet!</div><div class=\"sub-message\" \ntranslate=\"ERROR500.SUBMESSAGE\">Just kidding, looks like we have an internal issue, please try again in couple minutes\n</div><a class=\"report-link md-accent-color\" href=\"/\" translate=\"ERROR500.REPORT\">Report this problem</a></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-10/template-10.html","<div class=\"template-10 p-16\"><div class=\"pb-16\" layout=\"row\" layout-align=\"space-between center\"><div class=\"info\">\n<div class=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle h2\" \nng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"media ml-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div><div \nclass=\"text\">{{card.text}}</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/chainstore/store.html","<div class=\"store\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.name\">{{card.name}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.address\">{{card.address}}</div>\n<div class=\"text pt-16\" ng-if=\"card.phone\">{{card.phone}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-1/template-1.html","<div class=\"template-1\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-2/template-2.html","<div class=\"template-2\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"text p-16\" ng-if=\"card.text\">{{card.text}}\n</div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-3/template-3.html","<div class=\"template-3 p-16 teal-bg white-fg\" layout=\"row\" layout-align=\"space-between\"><div layout=\"column\" \nlayout-align=\"space-between\"><div class=\"info\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}</div><div \nclass=\"subtitle h3 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div></div><div class=\"cta\"><md-button \nclass=\"m-0\">{{card.cta}}</md-button></div></div><div class=\"media pl-16\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-4/template-4.html","<div class=\"template-4\"><div class=\"info white-fg ph-16 pv-24\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"text\" ng-if=\"card.text\">{{card.text}}</div></div><div class=\"media\"><img class=\"image\" \nng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-5/template-5.html","<div class=\"template-5 p-16\" layout=\"row\" layout-align=\"space-between start\"><div class=\"info\"><div \nclass=\"title secondary-text\" ng-if=\"card.title\">{{card.title}}</div><div class=\"event h2\" ng-if=\"card.event\">\n{{card.event}}</div></div><div class=\"media ml-16\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-7/template-7.html","<div class=\"template-7\" layout=\"row\" layout-align=\"space-between\"><div class=\"info\" layout=\"column\" \nlayout-align=\"space-between\" layout-fill flex><div class=\"p-16\"><div class=\"title h1\" ng-if=\"card.title\">{{card.title}}\n</div><div class=\"subtitle h4 secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}</div><div class=\"text h4 pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div><div><md-divider></md-divider><div class=\"p-8\" layout=\"row\"><md-icon \nmd-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\">\n</md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" \nclass=\"mh-5\"></md-icon><md-icon md-font-icon=\"icon-star-outline\" class=\"mh-5\"></md-icon></div></div></div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-8/template-8.html","<div class=\"template-8\"><div class=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" \nalt=\"{{card.media.image.alt}}\" ng-show=\"card.media.image\"></div><div class=\"content pv-24 ph-16\"><div class=\"title h1\" \nng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">{{card.subtitle}}\n</div><div class=\"buttons pt-16\"><md-button class=\"m-0\">{{card.button1}}</md-button><md-button class=\"m-0 md-accent\">\n{{card.button2}}</md-button></div><div class=\"text pt-16\" ng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-card/templates/template-9/template-9.html","<div class=\"template-9\"><div class=\"header p-16\" layout=\"row\" layout-align=\"start center\"><div ng-if=\"card.avatar\"><img\n class=\"avatar mr-16\" ng-src=\"{{card.avatar.src}}\" alt=\"{{card.avatar.alt}}\"></div><div class=\"info\"><div \nclass=\"title\" ng-if=\"card.title\">{{card.title}}</div><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div></div></div><div class=\"text ph-16 pb-16\" ng-if=\"card.text\">{{card.text}}</div><div \nclass=\"media\"><img class=\"image\" ng-src=\"{{card.media.image.src}}\" alt=\"{{card.media.image.alt}}\" \nng-show=\"card.media.image\"></div><div class=\"buttons m-8\"><md-button class=\"md-icon-button mr-16\" \naria-label=\"Favorite\"><md-icon md-font-icon=\"icon-heart-outline\" class=\"s24\"></md-icon></md-button><md-button \nclass=\"md-icon-button\" aria-label=\"Share\"><md-icon md-font-icon=\"icon-share\" class=\"s24\"></md-icon></md-button></div>\n</div>");
$templateCache.put("app/core/directives/ms-card/templates/template-6/template-6.html","<div class=\"template-6\"><div class=\"content pv-24 ph-16\"><div class=\"subtitle secondary-text\" ng-if=\"card.subtitle\">\n{{card.subtitle}}</div><div class=\"title h2\" ng-if=\"card.title\">{{card.title}}</div><div class=\"text pt-8\" \nng-if=\"card.text\">{{card.text}}</div></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/horizontal/horizontal.html","<div class=\"ms-stepper-horizontal\"><div class=\"ms-stepper-navigation-wrapper\"><div class=\"ms-stepper-navigation\" \nlayout=\"row\" layout-align=\"center center\"><md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(step.stepNumber), \'valid\': MsStepper.isStepValid(step.stepNumber), \'disabled\': MsStepper.isStepDisabled(step.stepNumber), \'optional\': MsStepper.isStepOptional(step.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(step.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(step.stepNumber)\" \nng-repeat=\"step in MsStepper.steps | filter:MsStepper.filterHiddenStep\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"step md-accent-bg\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(step.stepNumber) || MsStepper.isStepOptional(step.stepNumber)\">{{$index + 1}} </span>\n<span ng-if=\"MsStepper.isStepValid(step.stepNumber) && !MsStepper.isStepOptional(step.stepNumber)\"><i \nclass=\"icon icon-check s18\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div class=\"title\" \ntranslate=\"{{step.stepTitleTranslate}}\">{{step.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(step.stepNumber)\">Optional</div></div></md-button></div></div><div \nclass=\"ms-stepper-steps\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" \nng-click=\"MsStepper.gotoPreviousStep()\">Back</md-button><div class=\"ms-stepper-dots\"><span \nng-repeat=\"step in MsStepper.steps\" ng-hide=\"MsStepper.isStepHidden(step.stepNumber)\" \nng-class=\"{\'selected md-accent-bg\':MsStepper.currentStepNumber === $index + 1}\"></span></div><md-button \nclass=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/vertical.html","<div class=\"ms-stepper-vertical\"><div class=\"ms-stepper-vertical-line\"></div><div class=\"ms-stepper-steps\" \nng-transclude></div></div>");
$templateCache.put("app/main/apps/calendar/dialogs/event-detail/event-detail-dialog.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{vm.calendarEvent.title}}</span> <span flex></span><md-button \nclass=\"edit-event-button md-fab md-warn\" ng-click=\"vm.editEvent(vm.calendarEvent)\" aria-label=\"Edit event\" translate \ntranslate-attr-aria-label=\"CALENDAR.EDIT_EVENT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" \nlayout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-clock\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\">{{vm.calendarEvent.start.format(\'MMMM Do YYYY, h:mm:ss a\')}} <span ng-if=\"vm.calendarEvent.end\">-</span>\n {{vm.calendarEvent.end.format(\'MMMM Do YYYY, h:mm:ss a\')}}</span> <span class=\"secondary-text\">\n{{vm.calendarEvent.repeat || \'Does not repeat\'}}</span></div></div><div class=\"event-detail-row\" layout=\"row\" \nlayout-align=\"start start\"><md-icon md-font-icon=\"icon-bell-ring-outline\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\" translate=\"CALENDAR.30_MIN_BEFORE\">30 minutes before</span> <span class=\"h4\" \ntranslate=\"CALENDAR.15_MIN_BEFORE\">15 minutes before</span> <span class=\"h4\" translate=\"CALENDAR.30_MIN_LATER\">\n30 minutes later</span></div></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><div layout=\"column\" flex><span class=\"h4\">Istanbul, Turkey</span></div></div>\n<div class=\"event-detail-row\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\"></md-icon>\n<div layout=\"row\" flex><img src=\"assets/images/avatars/alice.jpg\" class=\"avatar\" alt=\"alice\"> <img \nsrc=\"assets/images/avatars/joyce.jpg\" class=\"avatar\" alt=\"joyce\"> <img src=\"assets/images/avatars/vincent.jpg\" \nclass=\"avatar\" alt=\"vincent\"></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/calendar/dialogs/event-form/event-form-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><label translate=\"CALENDAR.TITLE\">Title</label><input name=\"title\" ng-model=\"vm.calendarEvent.title\" \nrequired md-autofocus><div ng-messages=\"eventForm.title.$error\" ng-show=\"eventForm.title.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"CALENDAR.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div>\n</md-input-container><md-list class=\"all-day\"><md-list-item><p translate=\"CALENDAR.ALL_DAY\">All Day</p><md-switch \nclass=\"md-secondary\" ng-model=\"vm.calendarEvent.allday\" aria-label=\"All day\" translate \ntranslate-attr-aria-label=\"CALENDAR.ALL_DAY\"></md-switch></md-list-item></md-list><div layout=\"row\" class=\"date-row\">\n<md-datepicker ng-model=\"vm.calendarEvent.start\" md-placeholder=\"Start Date\"></md-datepicker><md-input-container \nclass=\"no-errors-spacer\" flex md-no-float><input ng-model=\"vm.calendarEvent.startTime\" placeholder=\"Start Time\" \ntranslate translate-attr-placeholder=\"CALENDAR.START_TIME\"></md-input-container></div><div layout=\"row\" \nclass=\"date-row\"><md-datepicker ng-model=\"vm.calendarEvent.end\" md-placeholder=\"End Date\"></md-datepicker>\n<md-input-container class=\"no-errors-spacer\" flex md-no-float><input ng-model=\"vm.calendarEvent.endTime\" \nplaceholder=\"End Time\" translate translate-attr-placeholder=\"CALENDAR.END_TIME\"></md-input-container></div>\n<md-input-container class=\"md-block\" flex><label translate=\"CALENDAR.REPEAT\">Repeat</label><input \nng-model=\"vm.calendarEvent.repeat\"></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"CALENDAR.LOCATION\">Location</label><input ng-model=\"vm.calendarEvent.location\"></md-input-container><div \nclass=\"notifications\" layout=\"column\"><div class=\"title\" translate=\"CALENDAR.NOTIFICATIONS\">Notifications</div>\n<md-select ng-model=\"notification\" placeholder=\"Notification\" \nng-repeat=\"notification in vm.calendarEvent.notifications\"><md-option ng-repeat=\"opt in vm.notifications\" \nvalue=\"{{opt}}\">{{opt}}</md-option></md-select><md-button aria-label=\"+ Add Another Notification\" \ntranslate=\"CALENDAR.ADD_NOTIFICATION\" translate-attr-aria-label=\"CALENDAR.ADD_NOTIFICATION\">+ Add Another Notification\n</md-button></div><md-input-container flex class=\"md-block textarea-container\"><label translate=\"CALENDAR.NOTES\">Notes\n</label><textarea ng-model=\"vm.task.notes\" md-maxlength=\"250\" max-rows=\"4\"></textarea></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"vm.saveEvent()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\" translate=\"CALENDAR.SAVE\" \ntranslate-attr-aria-label=\"CALENDAR.SAVE\">SAVE</md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.removeEvent()\" aria-label=\"Delete\" translate translate-attr-aria-label=\"CALENDAR.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"CALENDAR.DELETE\">Delete</span></md-tooltip>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/chat/sidenavs/left/left-sidenav.html","<div ng-show=\"vm.leftSidenavView === \'contacts\'\" class=\"view contacts-view animate-slide-left\" \nng-include=\"\'app/main/apps/chat/sidenavs/left/views/contacts/contacts-view.html\'\" layout=\"column\" flex></div><div \nng-show=\"vm.leftSidenavView ===\'user\'\" class=\"view user-view animate-slide-left\" \nng-include=\"\'app/main/apps/chat/sidenavs/left/views/user/user-view.html\'\" layout=\"column\" flex></div><div \nng-hide=\"vm.leftSidenavView\" class=\"view chats-view animate-slide-right\" \nng-include=\"\'app/main/apps/chat/sidenavs/left/views/chats/chats-view.html\'\" layout=\"column\" flex></div>");
$templateCache.put("app/main/apps/chat/sidenavs/right/right-sidenav.html","<div class=\"view contact-view\" ng-include=\"\'app/main/apps/chat/sidenavs/right/views/contact/contact-view.html\'\" \nlayout=\"column\" flex></div>");
$templateCache.put("app/main/apps/contacts/sidenavs/main/main-sidenav.html","<div class=\"header md-padding\" layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{vm.user.avatar}}\" \nclass=\"md-avatar avatar mr-16\" alt=\"{{vm.user.name}}\"> <span class=\"font-weight-500 font-size-14\">{{vm.user.name}}\n</span></div><md-divider></md-divider><div ms-scroll class=\"content scrollable\"><md-list><md-list-item \nng-click=\"vm.filterChange(\'all\')\" ng-class=\"{\'selected\':vm.listType ===\'all\'}\"><p translate=\"CONTACTS.ALL_CONTACTS\">\nAll contacts</p></md-list-item><md-list-item ng-click=\"vm.filterChange(\'frequent\')\" \nng-class=\"{\'selected\':vm.listType ===\'frequent\'}\"><p translate=\"CONTACTS.FREQUENTLY_CONTACTED\">Frequently contacted</p>\n</md-list-item><md-list-item ng-click=\"vm.filterChange(\'starred\')\" ng-class=\"{\'selected\':vm.listType ===\'starred\'}\"><p \ntranslate=\"CONTACTS.STARRED_CONTACTS\">Starred contacts</p></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\">Groups</md-subheader><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" \nng-click=\"vm.filterChange(group)\" ng-class=\"{\'selected\':vm.listType.name === group.name}\"><p class=\"pl-8\">\n{{group.name}}</p></md-list-item><md-list-item class=\"new-group-form\" ng-show=\"newListForm.$visible\"><p class=\"pl-8\" \neditable-text=\"vm.newGroupName\" e-form=\"newListForm\" onaftersave=\"vm.addNewGroup()\"></p></md-list-item><md-list-item \nclass=\"\" ng-click=\"newListForm.$show()\" ng-hide=\"newListForm.$visible\"><p class=\"pl-8 md-accent-fg\" \ntranslate=\"CONTACTS.NEW_GROUP\">New Group</p></md-list-item></md-list></div>");
$templateCache.put("app/main/apps/contacts/dialogs/contact/contact-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" \nflex layout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{vm.contact.avatar}}\" class=\"md-avatar avatar contact-avatar huge\" alt=\"{{vm.contact.name}}\"><div \nclass=\"contact-name\">{{vm.contact.name}}</div></div></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" \nlayout=\"row\" layout-align=\"center center\"><div flex layout=\"row\" layout-align=\"center center\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleInArray(vm.contact.id, vm.user.starred)\" aria-label=\"Toggle starred\" \ntranslate translate-attr-aria-label=\"CONTACTS.TOGGLE_STARRED\"><md-icon \nng-if=\"vm.exists(vm.contact.id,vm.user.starred)\" md-font-icon=\"icon-star\" class=\"amber-fg\"></md-icon><md-icon \nng-if=\"!vm.exists(vm.contact.id,vm.user.starred)\" md-font-icon=\"icon-star-outline\"></md-icon></md-button><md-menu>\n<md-button class=\"md-icon-button\" aria-label=\"More\" translate translate-attr-aria-label=\"TODO.MORE\"><md-icon \nmd-font-icon=\"icon-account-multiple-plus\" ng-click=\"$mdOpenMenu($event)\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-list-item ng-if=\"vm.user.groups\" ng-repeat=\"group in vm.user.groups\" \nng-click=\"vm.toggleInArray(vm.contact.id,group.contactIds)\"><p class=\"pl-8\" \nng-style=\"vm.exists(vm.contact.id,group.contactIds) && {\'font-weight\':\'500\'}\">{{group.name}}</p></md-list-item>\n</md-menu-content></md-menu></div></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"CONTACTS.NAME_REQUIRED\">Name (required)</label><md-icon \nmd-font-icon=\"icon-account\" class=\"name\"></md-icon><input ng-model=\"vm.contact.name\" type=\"text\" ng-required \nmd-autofocus></md-input-container><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"CONTACTS.LAST_NAME\">Last name</label><md-icon></md-icon><input ng-model=\"vm.contact.lastName\" type=\"text\">\n</md-input-container><md-input-container class=\"md-icon-float md-block\"><label translate=\"CONTACTS.NICKNAME\">Nickname\n</label><md-icon></md-icon><input ng-model=\"vm.contact.nickname\" type=\"text\"></md-input-container><div \nng-if=\"!vm.allFields\" layout=\"row\" layout-align=\"center center\"><md-button class=\"md-accent\" \nng-click=\"vm.allFields = true\" translate=\"CONTACTS.SHOW_ALL_FIELDS\">Show All Fields</md-button></div><div \nng-if=\"vm.allFields\"><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-phone\"></md-icon><input \nng-model=\"vm.contact.phone\" type=\"text\" placeholder=\"Phone number\" translate \ntranslate-attr-placeholder=\"CONTACTS.PHONE_NUMBER\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-email\" class=\"email\"></md-icon><input ng-model=\"vm.contact.email\" type=\"email\" placeholder=\"Email\" \ntranslate translate-attr-placeholder=\"CONTACTS.EMAIL\"></md-input-container><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-domain\"></md-icon><input ng-model=\"vm.contact.company\" type=\"text\" placeholder=\"Company\" \ntranslate translate-attr-placeholder=\"CONTACTS.COMPANY\"></md-input-container><md-input-container class=\"md-block\">\n<md-icon md-font-icon=\"icon-worker\"></md-icon><input ng-model=\"vm.contact.jobTitle\" type=\"text\" \nplaceholder=\"Job title\" translate translate-attr-placeholder=\"CONTACTS.JOB_TITLE\"></md-input-container><md-datepicker \nclass=\"birthday-input\" ng-model=\"vm.contact.birthday\" md-placeholder=\"Birthday\" ng-required=\"false\"></md-datepicker>\n<md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-home\"></md-icon><input ng-model=\"vm.contact.address\" \ntype=\"text\" placeholder=\"Address\" translate translate-attr-placeholder=\"CONTACTS.ADDRESS\"></md-input-container><div \nlayout=\"row\" class=\"md-block textarea-wrapper\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-note\"></md-icon>\n<md-input-container flex><label translate translate-attr-placeholder=\"CONTACTS.NOTES\">Notes</label><textarea \nng-model=\"vm.contact.notes\" type=\"text\" max-rows=\"4\"></textarea></md-input-container></div><div layout=\"row\" \nlayout-align=\"center center\"><md-button class=\"md-accent\" ng-click=\"vm.allFields = false\" \ntranslate=\"CONTACTS.FEWER_FIELDS\">Fewer Fields</md-button></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-if=\"!vm.newContact\" ng-click=\"vm.saveContact()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"SAVE\" translate=\"CONTACTS.SAVE\" \ntranslate-attr-aria-label=\"CONTACTS.SAVE\">SAVE</md-button><md-button type=\"submit\" ng-if=\"vm.newContact\" \nng-click=\"vm.addNewContact()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"Add Task\" translate=\"CONTACTS.ADD_CONTACT\" \ntranslate-attr-aria-label=\"CONTACTS.ADD_CONTACT\">ADD CONTACT</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteContactConfirm($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CONTACTS.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CONTACTS.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/mail/sidenavs/main/main-sidenav.html","<div class=\"header\" layout=\"column\" layout-align=\"space-between start\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"logo-icon\"><md-icon md-font-icon=\"icon-email\" class=\"icon\"></md-icon></span>\n<span class=\"logo-text\" translate=\"MAIL.MAILBOX\">Mailbox</span></div><div class=\"account\"><div class=\"title\">John Doe\n</div><md-select class=\"account-selection simplified\" placeholder=\"Mail Selection\" ng-model=\"vm.selectedAccount\">\n<md-option ng-repeat=\"(provider, address) in vm.accounts\" value=\"{{provider}}\">{{address}}</md-option></md-select>\n</div></div><md-content ms-scroll class=\"content\" flex><div class=\"compose-button\"><md-button \nclass=\"md-accent md-raised\" aria-label=\"compose\" ng-click=\"vm.composeDialog($event)\" translate=\"MAIL.COMPOSE\">COMPOSE\n</md-button></div><div class=\"navigation-simple\" layout=\"column\"><md-button class=\"item\" aria-label=\"inbox\" \nng-repeat=\"folder in vm.folders\" ng-click=\"vm.loadFolder(folder.name)\" \nng-class=\"{\'selected\':vm.isFolderActive(folder.name)}\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"{{folder.icon}}\" class=\"s16\"></md-icon><span class=\"title\">{{folder.title}}</span></div></md-button><div \nclass=\"item subheader\" translate=\"MAIL.LABELS\">Labels</div><md-button class=\"item\" ng-repeat=\"label in vm.labels\" \nng-click=\"vm.loadLabel(label.name)\" ng-class=\"{\'selected\':vm.isLabelActive(label.name)}\"><div layout=\"row\" \nlayout-align=\"start center\"><div class=\"h-10 w-10 mr-16\" ng-class=\"label.color\"></div><span class=\"title\">\n{{label.title}}</span></div></md-button></div></md-content>");
$templateCache.put("app/main/apps/mail/dialogs/compose/compose-dialog.html","<md-dialog class=\"compose-dialog\" aria-label=\"New Message\"><form class=\"md-inline-form\"><md-toolbar \nclass=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\"><span \nclass=\"title\" translate=\"MAIL.NEW_MESSAGE\">New Message</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" tranlate translate-aria-label=\"MAIL.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><md-input-container \nclass=\"md-block\"><label translate=\"MAIL.FROM\">From</label><input ng-model=\"vm.form.from\" type=\"email\" \ndisabled=\"disabled\"></md-input-container><md-input-container class=\"md-block to\" \nng-class=\"{\'hidden-cc\': vm.hiddenCC, \'hidden-bcc\': vm.hiddenBCC}\"><label translate=\"MAIL.TO\">To</label><input \nng-model=\"vm.form.to\" type=\"email\" md-autofocus><div class=\"cc-bcc\" layout=\"row\" layout-align=\"start center\"><div \nclass=\"show-cc\" ng-show=\"vm.hiddenCC\" ng-click=\"vm.hiddenCC = false\">CC</div><div class=\"show-bcc\" \nng-show=\"vm.hiddenBCC\" ng-click=\"vm.hiddenBCC = false\">BCC</div></div></md-input-container><md-input-container \nclass=\"md-block\" ng-hide=\"vm.hiddenCC\"><label translate=\"MAIL.CC\">Cc</label><input ng-model=\"vm.form.cc\" type=\"email\">\n</md-input-container><md-input-container class=\"md-block\" ng-hide=\"vm.hiddenBCC\"><label translate=\"MAIL.BCC\">Bcc\n</label><input ng-model=\"vm.form.bcc\" type=\"t\"></md-input-container><md-input-container class=\"md-block\"><label \ntranslate=\"MAIL.SUBJECT\">Subject</label><input ng-model=\"vm.form.subject\" type=\"text\"></md-input-container>\n<text-angular ng-model=\"vm.form.message\"></text-angular><div class=\"attachment-list\"><div class=\"attachment\" \nlayout=\"row\" layout-align=\"space-between center\"><div><span class=\"filename\">attachment-2.doc</span> <span \nclass=\"size\">(12 Kb)</span></div><md-button class=\"md-icon-button\" aria-label=\"Delete attachment\" translate \ntranslate-attr-aria-label=\"MAIL.DELETE_ATTACHMENT\"><md-icon md-font-icon=\"icon-close\" class=\"s16\"></md-icon>\n</md-button></div><div class=\"attachment\" layout=\"row\" layout-align=\"space-between center\"><div><span class=\"filename\">\nattachment-1.jpg</span> <span class=\"size\">(350 Kb)</span></div><md-button class=\"md-icon-button\" \naria-label=\"Delete attachment\" translate translate-attr-aria-label=\"MAIL.DELETE_ATTACHMENT\"><md-icon \nmd-font-icon=\"icon-close\" class=\"s16\"></md-icon></md-button></div></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nng-click=\"vm.closeDialog()\" class=\"send-button md-accent md-raised\" aria-label=\"Send\" translate=\"MAIL.SEND\" \ntranslate-attr-aria-label=\"MAIL.SEND\">SEND</md-button><md-button class=\"md-icon-button\" aria-label=\"Attach file\" \ntranslate-attr-aria-label=\"MAIL.ATTACH_FILE\"><md-icon md-font-icon=\"icon-paperclip\"></md-icon><md-tooltip><span \ntranslate=\"MAIL.ATTACH_FILE\"></span></md-tooltip></md-button></div><div layout=\"row\"><md-button class=\"md-icon-button\" \naria-label=\"Delete\" translate-attr-aria-label=\"MAIL.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip>\n<span translate=\"MAIL.DELETE\"></span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/mail/views/classic/classic-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-checkbox class=\"no-label\" aria-label=\"{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 0\" ng-click=\"vm.toggleSelectThreads()\" ng-if=\"!vm.currentThread\"></md-checkbox>\n<md-menu class=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" \nng-click=\"$mdOpenMenu($event)\" aria-label=\"Filters\" translate translate-attr-aria-label=\"MAIL.FILTERS\"><md-icon \nmd-font-icon=\"icon-menu-down\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.selectThreads()\" aria-label=\"All\" translate=\"MAIL.ALL\" translate-attr-aria-label=\"MAIL.ALL\">All\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.deselectThreads()\" aria-label=\"None\" \ntranslate=\"MAIL.NONE\" translate-attr-aria-label=\"MAIL.NONE\">None</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'read\', true)\" aria-label=\"Read\" translate=\"MAIL.READ\" \ntranslate-attr-aria-label=\"MAIL.READ\">Read</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'read\', false)\" aria-label=\"Unread\" translate=\"MAIL.UNREAD\" \ntranslate-attr-aria-label=\"MAIL.UNREAD\">Unread</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'important\', true)\" aria-label=\"Important\" translate=\"MAIL.IMPORTANT\" \ntranslate-attr-aria-label=\"MAIL.IMPORTANT\">Important</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'important\', false)\" aria-label=\"Not Important\" translate=\"MAIL.NOT_IMPORTANT\" \ntranslate-attr-aria-label=\"MAIL.NOT_IMPORTANT\">Not Important</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'starred\', true)\" aria-label=\"Starred\" translate=\"MAIL.STARRED\" \ntranslate-attr-aria-label=\"MAIL.STARRED\">Starred</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'starred\', false)\" aria-label=\"Unstarred\" translate=\"MAIL.UNSTARRED\" \ntranslate-attr-aria-label=\"MAIL.UNSTARRED\">Unstarred</md-button></md-menu-item></md-menu-content></md-menu><md-button \nclass=\"md-icon-button close-thread\" aria-label=\"Back\" ng-click=\"vm.closeThread()\" ng-if=\"vm.currentThread\" translate \ntranslate-attr-aria-label=\"MAIL.BACK\"><md-icon md-font-icon=\"icon-keyboard-backspace\"></md-icon></md-button><div \nclass=\"action-buttons\" layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.selectedThreads.length > 0 || vm.currentThread\" hide show-gt-xs><div class=\"divider-vertical\"></div>\n<md-button class=\"md-icon-button\" aria-label=\"Archive\" translate translate-attr-aria-label=\"MAIL.ARCHIVE\"><md-icon \nmd-font-icon=\"icon-archive\"></md-icon><md-tooltip><span translate=\"MAIL.ARCHIVE\">Archive</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"Spam\" translate translate-attr-aria-label=\"MAIL.SPAM\">\n<md-icon md-font-icon=\"icon-alert-octagon\"></md-icon><md-tooltip><span translate=\"MAIL.SPAM\">Spam</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"Delete\" translate translate-attr-aria-label=\"MAIL.DELETE\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"MAIL.DELETE\">Delete</span></md-tooltip>\n</md-button><div class=\"divider-vertical\"></div><md-button class=\"md-icon-button\" aria-label=\"Move to\" translate \ntranslate-attr-aria-label=\"MAIL.MOVE_TO\"><md-icon md-font-icon=\"icon-folder\"></md-icon><md-tooltip><span \ntranslate=\"MAIL.MOVE_TO\">Move to</span></md-tooltip></md-button><md-menu><md-button class=\"md-icon-button\" \naria-label=\"Labels\" translate translate-attr-aria-label=\"MAIL.LABELS\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-label\"></md-icon><md-tooltip><span translate=\"MAIL.LABELS\">Labels</span></md-tooltip></md-button>\n<md-menu-content class=\"thread-labels-toggle-list\" width=\"3\"><md-list><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"MAIL.LABELS\">Labels</span></md-subheader><md-list-item ng-repeat=\"label in vm.labels\" \nng-click=\"vm.toggleLabel(label)\"><div layout=\"row\" layout-align=\"start center\"><div class=\"w-10 h-10 mr-16\" \nng-class=\"label.color\"></div><div>{{label.title}}</div></div><md-icon md-font-icon=\"icon-checkbox-blank-outline\" \nclass=\"md-secondary\" ng-if=\"vm.currentThread && !vm.isLabelExist(label)\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"md-accent md-secondary\" ng-if=\"vm.currentThread && vm.isLabelExist(label)\">\n</md-icon></md-list-item></md-list></md-menu-content></md-menu><div class=\"divider-vertical\"></div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"MAIL.MORE\" translate \ntranslate-attr-aria-label=\"MAIL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content\n width=\"3\"><md-menu-item><md-button ng-click=\"vm.setThreadStatus(\'read\', true)\"><span translate=\"MAIL.MARK_AS_READ\">\nMark as read</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setThreadStatus(\'read\', false)\">\n<span translate=\"MAIL.MARK_AS_UNREAD\">Mark as unread</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setThreadStatus(\'important\', true)\"><span translate=\"MAIL.MARK_AS_IMPORTANT\">Mark as important</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setThreadStatus(\'important\', false)\"><span \ntranslate=\"MAIL.MARK_AS_NOT_IMPORTANT\">Mark as not important</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setThreadStatus(\'starred\', true)\"><span translate=\"MAIL.ADD_STAR\">Add star</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.setThreadStatus(\'starred\', false)\"><span \ntranslate=\"MAIL.REMOVE_STAR\">Remove star</span></md-button></md-menu-item></md-menu-content></md-menu></div><md-menu \nclass=\"actions-menu\" ng-show=\"vm.selectedThreads.length > 0 || vm.currentThread\" hide-gt-xs><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Mail Actions\" translate \ntranslate-attr-aria-label=\"MAIL.ACTIONS\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Archive\" translate-attr-aria-label=\"MAIL.ARCHIVE\">\n<md-icon md-font-icon=\"icon-archive\"></md-icon><span translate=\"MAIL.ARCHIVE\">Archive</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Spam\" translate-attr-aria-label=\"MAIL.SPAM\"><md-icon \nmd-font-icon=\"icon-alert-octagon\"></md-icon><span translate=\"MAIL.SPAM\">Spam</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Delete\" translate-aria-label=\"MAIL.DELETE\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><span translate=\"MAIL.DELETE\">Delete</span></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Move To\" translate-attr-aria-label=\"MAIL.MOVE_TO\"><md-icon md-font-icon=\"icon-folder-move\"></md-icon><span \ntranslate=\"MAIL.MOVE_TO\">Move To</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Labels\" \ntranslate-attr-aria-label=\"MAIL.LABELS\"><md-icon md-font-icon=\"icon-label\"></md-icon><span translate=\"MAIL.LABELS\">\nLabels</span></md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"page-info\" hide-sm>1 - 100 of 980</span><md-button \nclass=\"md-icon-button arrow\" aria-label=\"Previous\" translate translate-attr-aria-label=\"MAIL.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span translate=\"MAIL.PREVIOUS\">Previous</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" translate translate-attr-aria-label=\"MAIL.NEXT\">\n<md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span translate=\"MAIL.NEXT\">Next</span></md-tooltip>\n</md-button><md-menu class=\"settings-menu\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" \naria-label=\"Settings\" translate translate-attr-aria-label=\"MAIL.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.changeView(\'classic\')\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView !== \'classic\'\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView === \'classic\'\"></md-icon><span \ntranslate=\"MAIL.CLASSIC_VIEW\">Classic View</span></md-button></md-menu-item><md-menu-item hide-xs><md-button \nng-click=\"vm.changeView(\'outlook\')\"><md-icon md-font-icon=\"icon-checkbox-blank-outline\" \nng-if=\"vm.currentView !== \'outlook\'\"></md-icon><md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" \nng-if=\"vm.currentView === \'outlook\'\"></md-icon><span translate=\"MAIL.OUTLOOK_VIEW\">Outlook View</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div class=\"content-wrapper\" layout=\"column\" flex><div \nclass=\"content thread-detail\" ng-if=\"vm.currentThread\" \nng-include=\"\'app/main/apps/mail/views/classic/detail/detail.html\'\" ms-scroll flex></div><div \nclass=\"content thread-list\" ng-if=\"!vm.currentThread\" ng-include=\"\'app/main/apps/mail/views/classic/list/list.html\'\" \nms-scroll flex></div></div>");
$templateCache.put("app/main/apps/mail/views/outlook/outlook-view.html","<div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-checkbox class=\"no-label\" aria-label=\"{{vm.selectedThreads.length > 0 ? \'Deselect All\' : \'Select All\'}}\" \nng-checked=\"vm.selectedThreads.length > 0\" ng-click=\"vm.toggleSelectThreads()\"></md-checkbox><md-menu \nclass=\"select-menu\" ng-if=\"!vm.currentThread\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" \naria-label=\"Filters\" translate translate-attr-aria-label=\"MAIL.FILTERS\"><md-icon md-font-icon=\"icon-menu-down\">\n</md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.selectThreads()\" \naria-label=\"All\" translate=\"MAIL.ALL\" translate-attr-aria-label=\"MAIL.ALL\">All</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"vm.deselectThreads()\" aria-label=\"None\" translate=\"MAIL.NONE\" \ntranslate-attr-aria-label=\"MAIL.NONE\">None</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'read\', true)\" aria-label=\"Read\" translate=\"MAIL.READ\" \ntranslate-attr-aria-label=\"MAIL.READ\">Read</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'read\', false)\" aria-label=\"Unread\" translate=\"MAIL.UNREAD\" \ntranslate-attr-aria-label=\"MAIL.UNREAD\">Unread</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'important\', true)\" aria-label=\"Important\" translate=\"MAIL.IMPORTANT\" \ntranslate-attr-aria-label=\"MAIL.IMPORTANT\">Important</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'important\', false)\" aria-label=\"Not Important\" translate=\"MAIL.NOT_IMPORTANT\" \ntranslate-attr-aria-label=\"MAIL.NOT_IMPORTANT\">Not Important</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'starred\', true)\" aria-label=\"Starred\" translate=\"MAIL.STARRED\" \ntranslate-attr-aria-label=\"MAIL.STARRED\">Starred</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.selectThreads(\'starred\', false)\" aria-label=\"Unstarred\" translate=\"MAIL.UNSTARRED\" \ntranslate-attr-aria-label=\"MAIL.UNSTARRED\">Unstarred</md-button></md-menu-item></md-menu-content></md-menu><div \nclass=\"action-buttons\" layout=\"row\" layout-align=\"start center\" \nng-show=\"vm.selectedThreads.length > 0 || vm.currentThread\" hide show-gt-xs><div class=\"divider-vertical\"></div>\n<md-button class=\"md-icon-button\" aria-label=\"Archive\" translate translate-attr-aria-label=\"MAIL.ARCHIVE\"><md-icon \nmd-font-icon=\"icon-archive\"></md-icon><md-tooltip><span translate=\"MAIL.ARCHIVE\">Archive</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"Spam\" translate translate-attr-aria-label=\"MAIL.SPAM\">\n<md-icon md-font-icon=\"icon-alert-octagon\"></md-icon><md-tooltip><span translate=\"MAIL.SPAM\">Spam</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"Delete\" translate translate-attr-aria-label=\"MAIL.DELETE\">\n<md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"MAIL.DELETE\">Delete</span></md-tooltip>\n</md-button><div class=\"divider-vertical\"></div><md-button class=\"md-icon-button\" aria-label=\"Move to\" translate \ntranslate-attr-aria-label=\"MAIL.MOVE_TO\"><md-icon md-font-icon=\"icon-folder\"></md-icon><md-tooltip><span \ntranslate=\"MAIL.MOVE_TO\">Move to</span></md-tooltip></md-button><md-menu><md-button class=\"md-icon-button\" \naria-label=\"Labels\" translate translate-attr-aria-label=\"MAIL.LABELS\" ng-click=\"$mdOpenMenu($event)\"><md-icon \nmd-font-icon=\"icon-label\"></md-icon><md-tooltip><span translate=\"MAIL.LABELS\">Labels</span></md-tooltip></md-button>\n<md-menu-content class=\"thread-labels-toggle-list\" width=\"3\"><md-list><md-subheader class=\"md-no-sticky\"><span \ntranslate=\"MAIL.LABELS\">Labels</span></md-subheader><md-list-item ng-repeat=\"label in vm.labels\" \nng-click=\"vm.toggleLabel(label)\"><div layout=\"row\" layout-align=\"start center\"><div class=\"w-10 h-10 mr-16\" \nng-class=\"label.color\"></div><div>{{label.title}}</div></div><md-icon md-font-icon=\"icon-checkbox-blank-outline\" \nclass=\"md-secondary\" ng-if=\"vm.currentThread && !vm.isLabelExist(label)\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"md-accent md-secondary\" ng-if=\"vm.currentThread && vm.isLabelExist(label)\">\n</md-icon></md-list-item></md-list></md-menu-content></md-menu><div class=\"divider-vertical\"></div><md-menu><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"MAIL.MORE\" translate \ntranslate-attr-aria-label=\"MAIL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content\n width=\"3\"><md-menu-item><md-button ng-click=\"vm.setThreadStatus(\'read\', true)\"><span translate=\"MAIL.MARK_AS_READ\">\nMark as read</span></md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setThreadStatus(\'read\', false)\">\n<span translate=\"MAIL.MARK_AS_UNREAD\">Mark as unread</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setThreadStatus(\'important\', true)\"><span translate=\"MAIL.MARK_AS_IMPORTANT\">Mark as important</span>\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"vm.setThreadStatus(\'important\', false)\"><span \ntranslate=\"MAIL.MARK_AS_NOT_IMPORTANT\">Mark as not important</span></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setThreadStatus(\'starred\', true)\"><span translate=\"MAIL.ADD_STAR\">Add star</span></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.setThreadStatus(\'starred\', false)\"><span \ntranslate=\"MAIL.REMOVE_STAR\">Remove star</span></md-button></md-menu-item></md-menu-content></md-menu></div><md-menu \nclass=\"actions-menu\" ng-show=\"vm.selectedThreads.length > 0 || vm.currentThread\" hide-gt-xs><md-button \nclass=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" aria-label=\"Mail Actions\" translate \ntranslate-attr-aria-label=\"MAIL.ACTIONS\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button>\n<md-menu-content width=\"3\"><md-menu-item><md-button aria-label=\"Archive\" translate-attr-aria-label=\"MAIL.ARCHIVE\">\n<md-icon md-font-icon=\"icon-archive\"></md-icon><span translate=\"MAIL.ARCHIVE\">Archive</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Spam\" translate-attr-aria-label=\"MAIL.SPAM\"><md-icon \nmd-font-icon=\"icon-alert-octagon\"></md-icon><span translate=\"MAIL.SPAM\">Spam</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Delete\" translate-aria-label=\"MAIL.DELETE\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon><span translate=\"MAIL.DELETE\">Delete</span></md-button></md-menu-item><md-menu-item><md-button \naria-label=\"Move To\" translate-attr-aria-label=\"MAIL.MOVE_TO\"><md-icon md-font-icon=\"icon-folder-move\"></md-icon><span \ntranslate=\"MAIL.MOVE_TO\">Move To</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Labels\" \ntranslate-attr-aria-label=\"MAIL.LABELS\"><md-icon md-font-icon=\"icon-label\"></md-icon><span translate=\"MAIL.LABELS\">\nLabels</span></md-button></md-menu-item></md-menu-content></md-menu></div><div layout=\"row\" \nlayout-align=\"start center\"><span class=\"page-info\" hide-sm>1 - 100 of 980</span><md-button \nclass=\"md-icon-button arrow\" aria-label=\"Previous\" translate translate-attr-aria-label=\"MAIL.PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon><md-tooltip><span translate=\"MAIL.PREVIOUS\">Previous</span></md-tooltip>\n</md-button><md-button class=\"md-icon-button arrow\" aria-label=\"Next\" translate translate-attr-aria-label=\"MAIL.NEXT\">\n<md-icon md-font-icon=\"icon-chevron-right\"></md-icon><md-tooltip><span translate=\"MAIL.NEXT\">Next</span></md-tooltip>\n</md-button><md-menu class=\"settings-menu\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" \naria-label=\"Settings\" translate translate-attr-aria-label=\"MAIL.SETTINGS\"><md-icon md-font-icon=\"icon-cog\"></md-icon>\n</md-button><md-menu-content width=\"3\"><md-menu-item><md-button ng-click=\"vm.changeView(\'classic\')\"><md-icon \nmd-font-icon=\"icon-checkbox-blank-outline\" ng-if=\"vm.currentView !== \'classic\'\"></md-icon><md-icon \nmd-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" ng-if=\"vm.currentView === \'classic\'\"></md-icon><span \ntranslate=\"MAIL.CLASSIC_VIEW\">Classic View</span></md-button></md-menu-item><md-menu-item hide-xs><md-button \nng-click=\"vm.changeView(\'outlook\')\"><md-icon md-font-icon=\"icon-checkbox-blank-outline\" \nng-if=\"vm.currentView !== \'outlook\'\"></md-icon><md-icon md-font-icon=\"icon-checkbox-marked\" class=\"md-accent\" \nng-if=\"vm.currentView === \'outlook\'\"></md-icon><span translate=\"MAIL.OUTLOOK_VIEW\">Outlook View</span></md-button>\n</md-menu-item></md-menu-content></md-menu></div></div><div class=\"content-wrapper\" layout=\"row\" flex><div \nclass=\"content thread-list\" ng-include=\"\'app/main/apps/mail/views/outlook/list/list.html\'\" ms-scroll flex=\"50\"></div>\n<div class=\"content thread-detail\" ng-include=\"\'app/main/apps/mail/views/outlook/detail/detail.html\'\" ms-scroll \nlayout=\"column\" flex=\"50\"></div></div>");
$templateCache.put("app/main/apps/notes/directives/ms-new-note/ms-new-note.html","<ms-note-form note-type=\"\'new\'\"></ms-note-form><div ms-new-note-button class=\"new-note-button\"><span \ntranslate=\"NOTES.TAKE_A_NOTE\">Take a note..</span></div>");
$templateCache.put("app/main/apps/notes/directives/ms-note-form/ms-note-form.html","<form ng-submit=\"MsNoteForm.submit()\" ng-class=\"MsNoteForm.note.color\"><div ng-if=\"MsNoteForm.note.image\" \nclass=\"image-wrapper\"><img class=\"md-card-image\" ng-src=\"{{MsNoteForm.note.image}}\"><md-button \nclass=\"md-fab md-mini delete-image-button\" ng-click=\"MsNoteForm.deleteImage()\" aria-label=\"delete image\" translate \ntranslate-attr-aria-label=\"NOTES.DELETE_IMAGE\"><md-icon md-font-icon=\"icon-delete\"></md-icon></md-button></div><input \ntype=\"text\" class=\"note-title-input\" placeholder=\"Title\" ng-model=\"MsNoteForm.note.title\" \nng-class=\"MsNoteForm.note.color\"><md-input-container md-no-float ng-class=\"MsNoteForm.note.color\"><textarea \ntype=\"text\" class=\"note-description-textarea\" placeholder=\"Take a note..\" translate \ntranslate-attr-placeholder=\"NOTES.TAKE_A_NOTE\" ng-model=\"MsNoteForm.note.description\">\n    </textarea>\n</md-input-container><md-list class=\"checklist\" ng-if=\"MsNoteForm.note.checklist.length > 0\"><md-divider></md-divider>\n<md-list-item ng-repeat=\"item in MsNoteForm.note.checklist\"><md-checkbox ng-model=\"item.checked\" \naria-label=\"toggle check\"></md-checkbox><p ng-class=\"{\'text-strike md-secondary-text\':item.checked}\">{{item.text}}</p>\n<md-icon ng-click=\"$event.preventDefault();$event.stopPropagation();MsNoteForm.deleteCheckItem(item)\" \nclass=\"md-secondary\" md-font-icon=\"icon-close-circle\" aria-label=\"remove\"></md-icon><md-divider></md-divider>\n</md-list-item></md-list><div class=\"checklist-form\" \nng-if=\"MsNoteForm.note.checklist.length > 0 || MsNoteForm.checkListForm\" layout=\"row\" layout-align=\"space-between end\">\n<md-input-container class=\"\" md-no-float flex><input id=\"new-checklist-item-input\" type=\"text\" placeholder=\"List item\" \nng-model=\"MsNoteForm.newCheckListItem\" \nng-keydown=\"$event.keyCode === 13 ? $event.preventDefault() + MsNoteForm.addChecklistItem():\'\';\"></md-input-container>\n<md-button class=\"md-icon-button\" ng-click=\"MsNoteForm.addChecklistItem()\" aria-label=\"add\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button></div><div class=\"labels\" ng-if=\"MsNoteForm.note.labels.length > 0\" \nlayout=\"row\" layout-wrap layout-align=\"end start\"><div class=\"label\" ng-repeat=\"labelId in MsNoteForm.note.labels\" \nng-class=\"MsNoteForm.labels.getById(labelId).color\">{{MsNoteForm.labels.getById(labelId).name}}</div></div><div \nng-if=\"MsNoteForm.type ===\'edit\'\" class=\"date text-right p-16\">{{MsNoteForm.note.time | altDate}}</div><div \nclass=\"footer\" layout-gt-xs=\"row\" layout-align-gt-xs=\"space-between center\" layout=\"column\" \nlayout-align=\"center center\"><div class=\"actions\" layout=\"row\" layout-align=\"center center\"><div id=\"image-uploader\" \nflow-init=\"MsNoteForm.ngFlowOptions\" flow-name=\"MsNoteForm.ngFlow.flow\" flow-files-submitted=\"MsNoteForm.upload()\" \nflow-file-success=\"MsNoteForm.imageSuccess($file, $message)\" flow-complete=\"MsNoteForm.uploadComplete()\" \nflow-file-added=\"!!{svg:1,png:1,gif:1,jpg:1,jpeg:1}[$file.getExtension()]\"><md-button flow-btn \nclass=\"add-img-button md-icon-button\" aria-label=\"Add image\" translate translate-attr-aria-label=\"NOTES.ADD_IMAGE\">\n<md-icon md-font-icon=\"icon-file-image-box\" class=\"s20\"></md-icon></md-button></div><md-button class=\"md-icon-button\" \naria-label=\"checklist\" ng-click=\"MsNoteForm.checklistFormToggle()\"><md-icon \nmd-font-icon=\"icon-checkbox-multiple-marked\" class=\"s20\"></md-icon></md-button><md-menu class=\"label-menu\"><md-button \nclass=\"md-icon-button\" aria-label=\"Label\" translate translate-attr-aria-label=\"NOTES.LABEL\" \nng-click=\"$mdOpenMenu($event)\"><md-icon md-menu-origin md-font-icon=\"icon-label\" class=\"s20\"></md-icon></md-button>\n<md-menu-content class=\"notes-labels-menu-content\" width=\"4\" ms-scroll><md-menu-item><md-input-container \nclass=\"no-errors-spacer\" md-no-float><input placeholder=\"Search labels...\" type=\"text\" \nng-model=\"MsNoteForm.labelSearchText\" autocomplete=\"off\" translate-attr-palceholder=\"NOTES.SEARCH_LABELS\">\n</md-input-container></md-menu-item><md-menu-item class=\"label\" \nng-repeat=\"label in MsNoteForm.labels | filter: MsNoteForm.labelSearchText\"><md-button class=\"label-toggle-button\" \nmd-prevent-menu-close ng-class=\"label.color\" ng-click=\"MsNoteForm.toggleInArray(label.id, MsNoteForm.note.labels)\" \naria-label=\"Toggle Label\" translate translate-attr-aria-label=\"NOTES.TOGGLE_LABEL\"><div layout=\"row\" \nlayout-align=\"space-between center\" flex><span>{{label.name}}</span> <i \nng-if=\"MsNoteForm.exists(label.id, MsNoteForm.note.labels)\" class=\"icon-check s16\"></i></div></md-button>\n</md-menu-item></md-menu-content></md-menu><md-button class=\"md-icon-button\" ng-click=\"MsNoteForm.toggleArchive()\" \naria-label=\"archive\"><md-icon md-font-icon=\"icon-archive\" class=\"s20\"></md-icon></md-button><ms-material-color-picker \nng-model=\"MsNoteForm.note.color\"><md-button class=\"md-icon-button\" aria-label=\"color\"><md-icon \nmd-font-icon=\"icon-palette\" class=\"s20\"></md-icon></md-button></ms-material-color-picker><md-datepicker \nclass=\"reminder\" ng-model=\"MsNoteForm.note.reminder\" md-placeholder=\"Add reminder\" ms-datepicker-fix></md-datepicker>\n</div><div layout=\"row\" layout-align=\"end center\"><md-button ng-if=\"MsNoteForm.type ===\'edit\'\" \nng-click=\"MsNoteForm.deleteNote()\" class=\"md-icon-button\" aria-label=\"delete note\"><md-icon md-font-icon=\"icon-delete\">\n</md-icon></md-button><md-button ng-if=\"MsNoteForm.type ===\'edit\'\" type=\"submit\" translate=\"NOTES.SAVE\" \nng-disabled=\"MsNoteForm.isNotValid()\">Save</md-button><md-button ng-if=\"MsNoteForm.type ===\'new\'\" type=\"submit\" \ntranslate=\"NOTES.ADD\" ng-disabled=\"MsNoteForm.isNotValid()\">Add</md-button></div></div></form>");
$templateCache.put("app/main/apps/notes/directives/ms-note-item/ms-note-item.html","<md-card ng-class=\"MsNoteItem.note.color\"><img ng-if=\"MsNoteItem.note.image\" class=\"md-card-image\" \nng-src=\"{{MsNoteItem.note.image}}\"><md-card-content><md-card-title ng-if=\"MsNoteItem.note.title\"><md-card-title-text>\n{{MsNoteItem.note.title}}</md-card-title-text></md-card-title><md-description ng-if=\"MsNoteItem.note.description\">\n<span>{{MsNoteItem.note.description}}</span></md-description><div ng-if=\"MsNoteItem.note.checklist.length > 0\" \nclass=\"checklist\"><div class=\"checklist-item\" ng-repeat=\"checkItem in  MsNoteItem.note.checklist\" layout=\"row\" \nlayout-align=\"start center\"><md-checkbox ng-model=\"checkItem.checked\" \nng-click=\"$event.preventDefault();$event.stopPropagation()\" aria-label=\"{{checkItem.text}}\"></md-checkbox><span \nclass=\"text-truncate\" ng-class=\"{\'text-strike md-secondary-text\':checkItem.checked}\" flex>{{checkItem.text}}</span>\n</div></div><div class=\"labels\" ng-if=\"MsNoteItem.note.labels.length > 0\" layout=\"row\" layout-wrap \nlayout-align=\"end start\"><div class=\"label\" ng-repeat=\"labelId in MsNoteItem.note.labels\" \nng-click=\"$event.preventDefault();$event.stopPropagation();vm.filterChange(vm.labels.getById(labelId))\" \nng-class=\"vm.labels.getById(labelId).color\">{{vm.labels.getById(labelId).name}}</div></div><div \nng-if=\"vm.noteListType ===\'reminders\' && MsNoteItem.note.reminder\" class=\"reminder secondary-text text-right\"><md-icon \nmd-font-icon=\"icon-bell\" class=\"s16 mr-8\"></md-icon><span>{{MsNoteItem.note.reminder | altDate}}</span></div>\n</md-card-content></md-card>");
$templateCache.put("app/main/apps/main-store/stores/dialogs/store-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label\n translate=\"名称\">名称</label><input name=\"name\" ng-model=\"vm.store.name\" required md-autofocus><div \nng-messages=\"taskForm.name.$error\" ng-show=\"taskForm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>名称必填\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"门店电话\">门店电话\n</label><input name=\"phone\" ng-model=\"vm.store.phone\" required><div ng-messages=\"taskForm.phone.$error\" \nng-show=\"taskForm.phone.$touched\" role=\"alert\"><div ng-message=\"required\"><span>门店电话必填</span></div></div>\n</md-input-container></div><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label>\n地址</label><input name=\"address\" ng-model=\"vm.store.address\" required><div ng-messages=\"taskForm.address.$error\" \nng-show=\"taskForm.address.$touched\" role=\"alert\"><div ng-message=\"required\"><span>地址必填</span></div></div>\n</md-input-container><md-autocomplete flex=\"30\" md-input-name=\"vm.store.city\" ng-disabled=\"vm.isDisabled\" \nmd-no-cache=\"noCache\" md-selected-item=\"vm.selectedItem\" md-search-text-change=\"vm.searchTextChange(vm.searchText)\" \nmd-search-text=\"vm.searchText\" md-selected-item-change=\"vm.selectedItemChange(item)\" \nmd-items=\"item in vm.querySearch(vm.searchText)\" md-item-text=\"item.display\" md-min-length=\"0\" placeholder=\"所在城市\">\n<md-item-template><span md-highlight-text=\"searchText\">{{item.display}}</span></md-item-template><md-not-found>没有您输入的城市\n</md-not-found></md-autocomplete></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-if=\"!vm.newStore\" ng-click=\"vm.saveStore()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"保存\" translate=\"保存\" translate-attr-aria-label=\"保存\">\nSAVE</md-button><md-button type=\"submit\" ng-if=\"vm.newStore\" ng-click=\"vm.addNewStore()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"添加\" \ntranslate=\"添加\" translate-attr-aria-label=\"添加\">ADD TASK</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/notes/sidenavs/main/main-sidenav.html","<div ms-scroll class=\"content\"><md-list><md-list-item ng-click=\"vm.filterChange(\'notes\')\" \nng-class=\"{\'selected\':vm.listType ===\'notes\'}\"><div layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-lightbulb\" class=\"mr-16\"></md-icon><span translate=\"NOTES.NOTES\">Notes</span></div></md-list-item>\n<md-list-item ng-click=\"vm.filterChange(\'reminders\')\" ng-class=\"{\'selected\':vm.listType ===\'reminders\'}\"><div \nlayout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-bell\" class=\"mr-16\"></md-icon><span \ntranslate=\"NOTES.REMINDERS\">Reminders</span></div></md-list-item><md-divider></md-divider><md-subheader \nclass=\"md-no-sticky\"><span translate=\"NOTES.LABELS\">Labels</span></md-subheader><md-list-item \nng-repeat=\"label in vm.labels\" ng-class=\"{\'selected\':vm.noteListType.name === label.name}\" class=\"label\" layout=\"row\" \nlayout-align=\"start center\" flex><ms-material-color-picker ng-model=\"label.color\"><md-icon class=\"mr-16\" \nmd-font-icon=\"icon-label\" ng-style=\"{color:$selectedColor.bgColorValue}\"></md-icon></ms-material-color-picker><span \nclass=\"label-name text-transclude\" flex ng-hide=\"editLabelForm.$visible\" ng-click=\"vm.filterChange(label)\">\n{{label.name}} </span><span flex editable-text=\"label.name\" e-form=\"editLabelForm\" ng-show=\"editLabelForm.$visible\">\n{{label.name}}</span><md-button class=\"md-icon-button\" ng-hide=\"editLabelForm.$visible\" \nng-click=\"editLabelForm.$show()\" aria-label=\"edit label\"><md-icon md-font-icon=\"icon-pencil\" class=\"s16\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-hide=\"editLabelForm.$visible\" \nng-click=\"vm.deleteLabel($event, label)\" aria-label=\"delete label\"><md-icon md-font-icon=\"icon-delete\" class=\"s16\">\n</md-icon></md-button></md-list-item><md-list-item class=\"new-label-form\" ng-show=\"newLabelForm.$visible\"><p \neditable-text=\"vm.newLabel.name\" e-form=\"newLabelForm\" onaftersave=\"vm.addNewLabel(vm.newLabel)\"></p></md-list-item>\n<md-list-item class=\"\" ng-click=\"newLabelForm.$show()\" ng-hide=\"newLabelForm.$visible\"><p class=\"md-accent-fg\" \ntranslate=\"NOTES.NEW_LABEL\">New Label</p></md-list-item><md-divider></md-divider><md-list-item \nng-click=\"vm.filterChange(\'archive\')\" ng-class=\"{\'selected\':vm.listType ===\'archive\'}\"><div layout=\"row\" \nlayout-align=\"start center\"><md-icon md-font-icon=\"icon-archive\" class=\"mr-16\"></md-icon><span \ntranslate=\"NOTES.ARCHIVE\">Archive</span></div></md-list-item></md-list></div>");
$templateCache.put("app/main/components/material-docs/partials/Theming/01_introduction.html","<div class=\"doc-content theming\"><p>\nMaterial Design is a visual language with specifications for innovative user experiences (UX) and user interface (UI) elements. Themes convey meaning through color, tones, and contrasts, similar to how Layouts convey meaning through keylines and alignments.\n</p><p>Theme <a href=\"http://www.google.com/design/spec/style/color.html#color-ui-color-palette\"><strong>color palettes\n</strong></a>\n, alphas, and shadows deliver a consistent tone to your application and a unified feel for all Angular Material UI components.\n</p><p>\nTheming allows changing the color of your Angular Material application. If you need more custom styling (such as layout changes including padding, margins, etc) you will need to either write CSS rules with custom selectors, or build a custom version of the \n<code>angular-material.css</code> file using SASS and custom variables.</p><blockquote><p><b>Note:</b>\n The Material Theming system provides the <a href=\"/api/service/$mdThemingProvider#setNonce\"><code>\n$mdThemingProvider.setNonce()</code></a> method to meet the requirements of a CSP-policy enabled application.</p>\n</blockquote><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/210413/4816236/bf7783dc-5edd-11e4-88ef-1f8b6e87e1d7.png\" \nalt=\"color palette\" style=\"max-width: 100%\"></p><h2 id=\"theming-approach\">Theming Approach</h2><p>\nAngular Material makes it easy to design an app which follows the Material style guide&#39;s suggested design patterns:\n</p><blockquote><p>\nLimit your selection of colors by choosing three color hues from the primary palette and one accent color from the secondary palette. The accent color may or may not need fallback options.\n</p></blockquote><p>This concept is central to how Angular Material approaches theming.</p><h2 id=\"important-terms\">\nImportant Terms</h2><h3 id=\"hues-shades\">Hues / Shades</h3><p>A hue/shade is a single color within a palette.</p><h3 \nid=\"palettes\">Palettes</h3><p>\nA palette is a collection of hues. By default, Angular Material ships with all palettes from the material design spec built in. Valid palettes include:\n</p><ul><li>red</li><li>pink</li><li>purple</li><li>deep-purple</li><li>indigo</li><li>blue</li><li>light-blue</li><li>\ncyan</li><li>teal</li><li>green</li><li>light-green</li><li>lime</li><li>yellow</li><li>amber</li><li>orange</li><li>\ndeep-orange</li><li>brown</li><li>grey</li><li>blue-grey</li></ul><h3 id=\"color-intentions\">Color Intentions</h3><p>\nA color intention is a mapping of a palette for a given intention within your application.</p><p>\nValid color intentions in Angular Material include:</p><ul><li><em>primary</em>\n - used to represent primary interface elements for a user</li><li><em>accent</em>\n - used to represent secondary interface elements for a user</li><li><em>warn</em>\n - used to represent interface elements that the user should be careful of</li></ul><h3 id=\"themes\">Themes</h3><p>\nA theme is a configuration of palettes used for specific color intentions. A theme also specifies a background color palette to be used for the application.\n</p></div>");
$templateCache.put("app/main/components/material-docs/partials/Theming/02_declarative_syntax.html","<div class=\"doc-content theming\"><p>\nTheming in angular material uses classes to apply an intention group to a given component. Most components in Angular Material support intention classes as expected, including:\n</p><ul><li>md-button</li><li>md-checkbox</li><li>md-progress-circular</li><li>md-progress-linear</li><li>\nmd-radio-button</li><li>md-slider</li><li>md-switch</li><li>md-tabs</li><li>md-input-container</li><li>md-toolbar</li>\n</ul><h3 id=\"specifying-intention-group\">Specifying intention group</h3><p>\nThe classes to apply the color intention for a given component are as follows: <code>md-primary</code>, <code>md-accent\n</code>, <code>md-warn</code>.</p><hljs lang=\"html\"><md-button class=\"md-primary\">Click me</md-button><md-button \nclass=\"md-accent\">or maybe me</md-button><md-button class=\"md-warn\">Careful</md-button></hljs><h3 \nid=\"differentiating-within-an-intention-group-\">Differentiating within an intention group.</h3><p>\nIf you need to slightly differentiate an element, you can specify an additional class of <code>md-hue-1</code>, <code>\nmd-hue-2</code>, or <code>md-hue-3</code>. Use these classes sparingly in your application to avoid overwhelming users.\n</p><hljs lang=\"html\"><md-button class=\"md-primary\">Click me</md-button><md-button class=\"md-primary md-hue-1\">Click me\n</md-button><md-button class=\"md-primary md-hue-2\">Click me</md-button></hljs></div>");
$templateCache.put("app/main/components/material-docs/partials/Theming/03_configuring_a_theme.html","<div class=\"doc-content theming\"><h2 id=\"configuring-a-theme\">Configuring a theme</h2><p>\nBy default your Angular Material application will use the default theme, a theme that is pre-configured with the following palettes for intention groups:\n</p><ul><li><em>primary</em> - indigo</li><li><em>accent</em> - pink</li><li><em>warn</em> - red</li><li><em>background\n</em> - grey (note that white is in this palette)</li></ul><p>Configuring of the default theme is done by using the \n<code>$mdThemingProvider</code> during application configuration.</p><h3 id=\"configuring-color-intentions\">\nConfiguring Color Intentions</h3><p>\nYou can specify a color palette for a given color intention by calling the appropriate configuration method (<code>\ntheme.primaryPalette</code>, <code>theme.accentPalette</code>, <code>theme.warnPalette</code>, <code>\ntheme.backgroundPalette</code>).</p><hljs lang=\"js\">\nangular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.theme(&#39;default&#39;) .primaryPalette(&#39;pink&#39;) .accentPalette(&#39;orange&#39;); });\n</hljs><h3 id=\"specifying-dark-themes\">Specifying Dark Themes</h3><p>You can mark a theme as dark by calling <code>\ntheme.dark()</code>.</p><hljs lang=\"js\">\nangular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.theme(&#39;default&#39;) .dark(); });\n</hljs><h3 id=\"specifying-custom-hues-for-color-intentions\">Specifying Custom Hues For Color Intentions</h3><p>\nYou can specify the hues from a palette that will be used by an intention group by default and for the <code>md-hue-1\n</code>, <code>md-hue-2</code>, <code>md-hue-3</code> classes.</p><p>By default, shades <code>500</code>, <code>300\n</code> <code>800</code> and <code>A100</code> are used for <code>primary</code> and <code>warn</code>\n intentions, while <code>A200</code>, <code>A100</code>, <code>A400</code> and <code>A700</code> are used for <code>\naccent</code>.</p><hljs lang=\"js\">\nangular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.theme(&#39;default&#39;) .primaryPalette(&#39;pink&#39;, { &#39;default&#39;: &#39;400&#39;, // by default use shade 400 from the pink palette for primary intentions &#39;hue-1&#39;: &#39;100&#39;, // use shade 100 for the \n<code>md-hue-1</code> class &#39;hue-2&#39;: &#39;600&#39;, // use shade 600 for the <code>md-hue-2</code>\n class &#39;hue-3&#39;: &#39;A100&#39; // use shade A100 for the <code>md-hue-3</code>\n class }) // If you specify less than all of the keys, it will inherit from the // default shades .accentPalette(&#39;purple&#39;, { &#39;default&#39;: &#39;200&#39; // use shade 200 for default, and keep all other shades the same }); });\n</hljs><h3 id=\"defining-custom-palettes\">Defining Custom Palettes</h3><p>\nAs mentioned before, Angular Material ships with the Material Design Spec&#39;s color palettes built in. In the event that you need to define a custom color palette, you can use \n<code>$mdThemingProvider</code>\n to define it, thereby making it available to your theme for use in its intention groups. Note that you must specify all hues in the definition map.\n</p><hljs lang=\"js\">\nangular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.definePalette(&#39;amazingPaletteName&#39;, { &#39;50&#39;: &#39;ffebee&#39;, &#39;100&#39;: &#39;ffcdd2&#39;, &#39;200&#39;: &#39;ef9a9a&#39;, &#39;300&#39;: &#39;e57373&#39;, &#39;400&#39;: &#39;ef5350&#39;, &#39;500&#39;: &#39;f44336&#39;, &#39;600&#39;: &#39;e53935&#39;, &#39;700&#39;: &#39;d32f2f&#39;, &#39;800&#39;: &#39;c62828&#39;, &#39;900&#39;: &#39;b71c1c&#39;, &#39;A100&#39;: &#39;ff8a80&#39;, &#39;A200&#39;: &#39;ff5252&#39;, &#39;A400&#39;: &#39;ff1744&#39;, &#39;A700&#39;: &#39;d50000&#39;, &#39;contrastDefaultColor&#39;: &#39;light&#39;, // whether, by default, text (contrast) // on this palette should be dark or light &#39;contrastDarkColors&#39;: [&#39;50&#39;, &#39;100&#39;, //hues which contrast should be &#39;dark&#39; by default &#39;200&#39;, &#39;300&#39;, &#39;400&#39;, &#39;A100&#39;], &#39;contrastLightColors&#39;: undefined // could also specify this if default was &#39;dark&#39; }); $mdThemingProvider.theme(&#39;default&#39;) .primaryPalette(&#39;amazingPaletteName&#39;) });\n</hljs><h3 id=\"extending-existing-palettes\">Extending Existing Palettes</h3><p>\nSometimes it is easier to extend an existing color palette to change a few properties than to define a whole new palette. You can use \n<code>$mdThemingProvider.extendPalette</code> to quickly extend an existing color palette.</p><hljs lang=\"js\">\nangular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { // Extend the red theme with a different color and make the contrast color black instead of white. // For example: raised button text will be black instead of white. var neonRedMap = $mdThemingProvider.extendPalette(&#39;red&#39;, { &#39;500&#39;: &#39;#ff0000&#39;, &#39;contrastDefaultColor&#39;: &#39;dark&#39; }); // Register the new color palette map with the name \n<code>neonRed</code>\n $mdThemingProvider.definePalette(&#39;neonRed&#39;, neonRedMap); // Use that theme for the primary intentions $mdThemingProvider.theme(&#39;default&#39;) .primaryPalette(&#39;neonRed&#39;); });\n</hljs><h3 id=\"disable-theming\">Disable Theming</h3><p>You can disable theming by calling <code>disableTheming()</code>\n.</p><hljs lang=\"js\">\nangular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.disableTheming(); });\n</hljs></div>");
$templateCache.put("app/main/components/material-docs/partials/Theming/04_multiple_themes.html","<div class=\"doc-content theming\"><p>In most applications, declaring multiple themes is <strong>not</strong>\n necessary. Instead, you should configure the <code>default</code>\n theme for your needs. If you need multiple themes in a single application, Angular Material does provide tools to make this possible.\n</p><h3 id=\"registering-another-theme\">Registering another theme</h3><p>Use the <code>$mdThemingProvider</code>\n to register a second theme within your application. By default all themes will inherit from the <code>default</code>\n theme. Once you have registered the second theme, you can configure it with the same chainable interface used on the default theme.\n</p><hljs lang=\"js\">\nangular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { $mdThemingProvider.theme(&#39;altTheme&#39;) .primaryPalette(&#39;purple&#39;) // specify primary color, all // other color intentions will be inherited // from default });\n</hljs><h3 id=\"using-another-theme\">Using another theme</h3><h4 id=\"via-the-provider\">Via the Provider</h4><p>\nYou can change the default theme to be used across your entire application using the provider:</p><hljs lang=\"js\">\n$mdThemingProvider.setDefaultTheme(&#39;altTheme&#39;);</hljs><h4 id=\"via-a-directive\">Via a Directive</h4><p>\nAngular Material also exposes the <code>md-theme</code>\n directive which will set the theme on an element and all child elements.</p><p>\nIn the following example, the application will use the <code>default</code> theme, while the second child <code>div\n</code> will use the <code>altTheme</code>. This allows you to theme different parts of your application differently.\n</p><hljs lang=\"html\"><div><md-button class=\"md-primary\">I will be blue (by default)</md-button><div \nmd-theme=\"altTheme\"><md-button class=\"md-primary\">I will be purple (altTheme)</md-button></div></div></hljs><h4 \nid=\"dynamic-themes\">Dynamic Themes</h4><p>By default, to save on performance, theming directives will <strong>not\n</strong> watch <code>md-theme</code>\n for changes. If you need themes to be dynamically modified, you will need to use the <code>md-theme-watch</code>\n directive.</p><hljs lang=\"html\"><div><md-button ng-click=\"dynamicTheme = \'default\'\">Default</md-button><md-button \nng-click=\"dynamicTheme = \'altTheme\'\">altTheme</md-button><div md-theme=\"{{ dynamicTheme }}\" md-theme-watch><md-button \nclass=\"md-primary\">I&#39;m dynamic</md-button></div></div></hljs><p>\nIf you need this behavior in your entire application (ie. on all <code>md-theme</code> directives) you can use the \n<code>$mdThemingProvider</code> to enable it.</p><hljs lang=\"js\">$mdThemingProvider.alwaysWatchTheme(true);</hljs><h4 \nid=\"lazy-generate-themes\">Lazy Generate Themes</h4><p>\nBy default, every theme is generated when defined. You can disable this in the configuration section using the <code>\n$mdThemingProvider</code>.</p><hljs lang=\"js\">\nangular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]) .config(function($mdThemingProvider) { //disable theme generation $mdThemingProvider.generateThemesOnDemand(true); //themes are still defined in config, but the css is not generated $mdThemingProvider.theme(&#39;altTheme&#39;) .primaryPalette(&#39;purple&#39;) .accentPalette(&#39;green&#39;); });\n</hljs><p>If you do this, you must generate the theme before using it using <code>$mdTheming</code>.</p><hljs \nlang=\"js\">//generate the predefined theme named altTheme $mdTheming.generateTheme(&#39;altTheme&#39;);</hljs><p>\nThe theme name that is passed in must match the name of the theme that was defined as part of the configuration block.\n</p></div>");
$templateCache.put("app/main/components/material-docs/partials/Theming/05_under_the_hood.html","<div class=\"doc-content theming\"><h3 id=\"under-the-hood\">Under the Hood</h3><p>\nAngular Material dynamically generates CSS for registered themes by injecting several <code>&lt;script&gt;</code>\n tags into the <code>&lt;head&gt;</code>\n section of the application at runtime. Here is how that process currently works:</p><ol><li><p>\nDuring the Angular Material build process, a function in <code>gulp/util.js</code> called <a \nhref=\"https://github.com/angular/material/blob/master/gulp/util.js#L187\">themeBuildStream()</a> compiles all <code>\n*-theme.scss</code> files from components into a single CSS string that is injected into the <code>material.core</code>\n module as a constant called <code>$MD_THEME_CSS</code>.</p></li><li><p>At runtime, a function in <code>\nsrc/core/services/theming/theming.js</code> called <a \nhref=\"https://github.com/angular/material/blob/master/src/core/services/theming/theming.js#L450\">generateThemes()</a>\n parses <code>$MD_THEME_CSS</code> to generate the <code>&lt;style&gt;</code> tags that are added to the <code>\n&lt;head&gt;</code> section of the application. A closure variable called <code>GENERATED</code>\n is used to keep track of the themes that have had their CSS generated.</p></li><li><p>\nFor each of the four (4) palettes (e.g. <code>primary</code>, <code>accent</code>, <code>warn</code> and <code>\nbackground</code>) <em>in each registered theme</em> (including the default theme), there are four (4) <code>\n&lt;style&gt;</code> tags added to the <code>&lt;head&gt;</code> section (e.g. <code>.md-primary</code>, <code>\n.md-primary.md-hue-1</code>, <code>.md-primary.md-hue-2</code>, <code>.md-primary.md-hue-3</code>\n). Each registered theme results in 16 <code>&lt;style&gt;</code> tags being generated.</p></li></ol></div>");
$templateCache.put("app/main/components/material-docs/partials/Theming/06_browser_color.html","<div class=\"doc-content theming\"><div class=\"layout_note\"><span>This feature is <strong>mobile</strong> only</span>\n</div><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/6004537/18006666/50519c7e-6ba9-11e6-905b-c3751c20549c.png\" \nalt=\"browser color\"></p><p>Enables browser header coloring with <a href=\"https://material.google.com/style/color.html\">\nMaterial Design Colors</a> and the theming system.</p><p>For more information, please visit:<br><a \nhref=\"https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color\">\nhttps://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color</a>.</p><p>\nBelow are usage examples for both the Angular configuration phase, and during runtime.</p><h3 id=\"config-phase\">\nConfig Phase</h3><hljs lang=\"js\">\nmyAppModule .config(function($mdThemingProvider) { // Enable browser color $mdThemingProvider.enableBrowserColor({ theme: &#39;myTheme&#39;, // Default is &#39;default&#39; palette: &#39;accent&#39;, // Default is &#39;primary&#39;, any basic material palette and extended palettes are available hue: &#39;200&#39; // Default is &#39;800&#39; }); });\n</hljs><h3 id=\"runtime\">Runtime</h3><hljs lang=\"js\">\nmyAppModule .controller(&#39;myCtrl&#39;, function($scope, $mdTheming) { var removeFunction = $mdTheming.setBrowserColor({ theme: &#39;myTheme&#39;, // Default is &#39;default&#39; palette: &#39;accent&#39;, // Default is &#39;primary&#39;, any basic material palette and extended palettes are available hue: &#39;200&#39; // Default is &#39;800&#39; }); $scope.$on(&#39;$destroy&#39;, function () { removeFunction(); // COMPLETELY removes the browser color }) })\n</hljs><p>For api reference please visit <a href=\"/api/service/$mdThemingProvider#enableBrowserColor\">\n$mdThemingProvider</a> documentation.</p></div>");
$templateCache.put("app/main/components/material-docs/partials/CSS/button.html","<div class=\"doc-content theming\"><h1 id=\"-lt-md-button-gt-\">&lt;md-button&gt;</h1><p>\nBelow is a snapshot of the Angular Material <strong>button</strong>\n component demos with the default themes and standard options:</p><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/210413/7947020/fafde934-093f-11e5-9584-27eb2deedd0f.png\" \nalt=\"buttonsdemo\"></p><p><br></p><h3 id=\"css-styles\">CSS Styles</h3><p>The base CSS class for all <code>\n&lt;md-button&gt;</code> components is <code>.md-button</code>:</p><hljs lang=\"css\">\n.md-button { padding: 0 6px 0 6px; margin: 6px 8px 6px 8px; min-width: 88px; border-radius: 3px; font-size: 14px; text-align: center; text-transform: uppercase; text-decoration:none; border: none; outline: none; }\n</hljs><p>When defining custom CSS overrides, developers should create their own CSS class. For example, to define a \n<code>.btn1</code> override to <strong>md-button</strong> use:</p><hljs lang=\"css\">\n.btn1 { // your custom overrides here }</hljs><hljs lang=\"html\"><md-button class=\"btn1\" ng-click=\"acceptOffer();\">\nAccept</md-button></hljs><p><br></p><h3 id=\"theme-requirements\">Theme Requirements</h3><p>\nAll Angular Material components have specific CSS rules constructed using the theme name and theme-class overrides. For the \n<strong>Default</strong> theme, however, these rules are added to the components styles using the <code>\n.md-default-theme</code> class. If, however, you have configured a custom theme called <code>companyX</code> that is \n<strong>NOT</strong> the default theme, then any CSS overrides <strong>must</strong>\n use fully-specified classname. For <code>&lt;md-button&gt;</code> the <strong>fully-specified classname</strong>\n will be <code>.md-button.md-companyX-theme.btn1</code>.</p><hljs lang=\"css\">\n.md-button.md-companyX-theme.btn1 { } .md-button.md-companyX-theme.md-primary.btn1 { } .md-button.md-companyX-theme.md-accent.btn1 { } .md-button.md-companyX-theme.md-warn.btn1 { }\n</hljs><p><br></p><h2 id=\"flat-buttons\">Flat Buttons</h2><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/210413/7945984/bda14884-0939-11e5-9196-131ded20ca77.png\" \nalt=\"mdbuttonflatdefault3\"></p><hljs lang=\"html\"><md-button>Button</md-button></hljs><hljs lang=\"css\">\n.md-button { color : currentColor; } .md-button:not([disabled]):hover { background-color: rgba(158, 158, 158, 0.2); } .md-button[disabled] { color : rgba(0, 0, 0, 0.26); background-color: transparent; }\n</hljs><p><br></p><h4 id=\"custom-css-overrides\">Custom CSS Overrides</h4><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/210413/7945987/c1b1c700-0939-11e5-879c-ba804ca03267.png\" \nalt=\"mdbuttonflatdefault_overrides2\"></p><hljs lang=\"html\"><md-button class=\"btn1\">Button</md-button></hljs><hljs \nlang=\"css\">\n.btn1 { color : rgb(49, 46, 46); background-color: rgba(255, 222, 121, 0.96); border-radius: 10px 0 0 10px; font-size: 16px; } .btn1:not([disabled]):hover { background-color: rgba(107, 103, 91, 0.96); color: white; } .btn1[disabled] { color : rgb(187, 187, 187); background-color: rgba(230, 230, 229, 0.96); }\n</hljs><p><br></p><h2 id=\"raised-buttons\">Raised Buttons</h2><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/1292882/7254163/fe898728-e849-11e4-943b-a9cd88ec9573.PNG\" \nalt=\"raisedbutton\"></p><p>Add the <code>.md-raised</code> class to create a raised button:</p><hljs lang=\"html\">\n<md-button class=\"md-raised\">Button</md-button></hljs><hljs lang=\"css\">\n.md-button.md-raised:not([disabled]) { box-shadow: 0 2px 5px 0 rgba(0, 0, 0, 0.26); }</hljs><p><br></p><h2 \nid=\"cornered-buttons\">Cornered buttons</h2><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/1292882/7254379/682592ac-e84b-11e4-8d33-78314cea8bda.PNG\" \nalt=\"corneredbutton\"></p><p>Add the <code>.md-cornered</code> class to create a button with corners:</p><hljs \nlang=\"html\"><md-button class=\"md-raised md-cornered\">Button</md-button></hljs><hljs lang=\"css\">\n.md-button.md-cornered { border-radius: 0; }</hljs><p><br></p><h2 id=\"default-fab-button\">Default FAB Button</h2><p>\n<img src=\"https://cloud.githubusercontent.com/assets/1292882/7254736/8fec7ee8-e84d-11e4-9cf9-58ea9221c3c2.PNG\" \nalt=\"floatingbutton\"></p><p>Add the <code>.md-fab</code> class in order to create a floating action button (aka FAB):\n</p><hljs lang=\"html\"><md-button class=\"md-fab\" aria-label=\"Eat cake\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/cake.svg\"></md-icon></md-button></hljs><hljs lang=\"css\">\n.md-button.md-fab { line-height: 5.6rem; min-width: 0; width: 5.6rem; height: 5.6rem; border-radius: 50%; }</hljs><p>\n<br></p><h2 id=\"mini-fab-button\">Mini FAB Button</h2><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/1292882/7273617/1fcca280-e8fe-11e4-9588-231a9e860be1.PNG\" \nalt=\"minibutton\"></p><p>Add the <code>.md-mini</code> class in order to create small, mini-FAB buttons:</p><hljs \nlang=\"html\"><md-button class=\"md-fab md-mini\" aria-label=\"Eat cake\"><md-icon \nmd-svg-src=\"assets/angular-material-assets/img/icons/cake.svg\"></md-icon></md-button></hljs><hljs lang=\"css\">\n.md-button.md-fab.md-mini { line-height: 4rem; width: 4rem; height: 4rem; }</hljs><p><br></p><h2 \nid=\"icon-button-using-svgs\">Icon button using SVGs</h2><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/1292882/7273908/d701bd8a-e900-11e4-84c7-44c580c7372d.PNG\" \nalt=\"iconbutton\"></p><p>Create icon buttons by adding the <code>.md-icon-button</code> class and the <code>\n&lt;md-icon ...&gt;</code> component:</p><hljs lang=\"html\"><md-button class=\"md-icon-button md-primary\" \naria-label=\"Settings\"><md-icon md-svg-icon=\"assets/angular-material-assets/img/icons/menu.svg\"></md-icon></md-button>\n</hljs><hljs lang=\"css\">\n.md-button.md-icon-button { margin: 0 0.6rem; height: 4.8rem; min-width: 0; line-height: 4.8rem; padding-left: 0; padding-right: 0; width: 4.8rem; }\n</hljs><p><br></p><h2 id=\"icon-button-using-font-icons\">Icon button using Font-icons</h2><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/1292882/7670414/f57721ba-fcab-11e4-9a22-67970063797c.PNG\" \nalt=\"fonticonbutton\"></p><p>Here is another example of a button with font icons:</p><hljs lang=\"html\"><md-button>\n<md-icon md-font-icon=\"icon-home\" ng-style=\"{color: \'green\', \'font-size\':\'36px\', height:\'36px\'}\"></md-icon></md-button>\n</hljs><p><br></p><h2 id=\"grouping-with-css-overrides\">Grouping with CSS Overrides</h2><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/210413/7961138/1b48bb16-09cb-11e5-9283-bdda28b8bb66.png\" \nalt=\"mdbuttongroup\"></p><p>Using the customization approaches documented above, we can easily create a mdButtonGroup:\n</p><hljs lang=\"html\"><section layout=\"row\" layout-align=\"center center\"><md-button class=\"groupX left\">Apple\n</md-button><md-button class=\"groupX middle\">Samsung</md-button><md-button class=\"groupX middle\">Sony</md-button>\n<md-button class=\"groupX right\">B&amp;O</md-button></section></hljs><hljs lang=\"css\">\n.groupX { font-size: 16px; margin: 20px 0; padding: 3px 15px 3px 15px; color: rgb(49, 46, 46); background-color: rgba(224, 224, 224, 0.96); text-transform: none; font-weight: 400; min-width:100px; } .md-button.left { border-radius: 10px 0 0 10px; } .md-button.middle { border-radius: 0; border-left: 1px solid rgba(230, 230, 230, 0.96); border-right: 1px solid rgba(230, 230, 230, 0.96); } .md-button.right { border-radius: 0 10px 10px 0; } .md-button:not([disabled]):hover { background-color: rgba(193, 193, 193, 0.96); color: rgba(44, 65, 164, 0.96); transition: 0.3s; }\n</hljs></div>");
$templateCache.put("app/main/components/material-docs/partials/CSS/checkbox.html","<div class=\"doc-content theming\"><h2>CSS Styles</h2><p>The css decalaration of the <code>&lt;md-checkbox&gt;</code>\n component is:</p><hljs lang=\"css\">\nmd-checkbox { margin: 8px; cursor: pointer; padding-left: 18px; padding-right: 0; line-height: 26px; min-width: 18px; min-height: 18px; }\n</hljs><p><br></p><h3>Ink color</h3><p>In order to change the color when the checkbox is checked:</p><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/1292882/8035909/b2130da0-0dfc-11e5-932f-4424d3b46d5b.PNG\" \nalt=\"greencheckbox\"></p><hljs lang=\"html\"><md-checkbox class=\"green\">Green Checkbox</md-checkbox></hljs><hljs \nlang=\"css\">md-checkbox.md-checked.green .md-icon { background-color: rgba(0, 255, 0, 0.87); }</hljs><p><br></p><h3>\nDisabled</h3><p>In order to change the color when a disabled checkbox is checked:</p><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/1292882/8036177/dc941a86-0dfe-11e5-8892-ac19ec6926fe.PNG\" \nalt=\"checkboxdisabledred\"><br></p><hljs lang=\"html\"><md-checkbox ng-disabled=\"true\" class=\"red\" ng-model=\"data.cb4\" \nng-init=\"data.cb4=true\">Checkbox: Disabled, Checked</md-checkbox></hljs><hljs lang=\"css\">\nmd-checkbox.md-checked[disabled].red .md-icon { background-color: rgba(255, 0, 0, 0.26); }</hljs><p><br></p><h3>Borders\n</h3><p>In order to add a custom border do the following:</p><img \nsrc=\"https://cloud.githubusercontent.com/assets/1292882/8037214/388dd40c-0e05-11e5-82a7-4bfa2541e968.PNG\" \nalt=\"checkboxcustomborder\"><br><br><hljs lang=\"html\"><div><md-checkbox ng-model=\"data.cb2\" aria-label=\"Checkbox 2\" \nng-true-value=\"\'yup\'\" ng-false-value=\"\'nope\'\">Default Border</md-checkbox></div><div><md-checkbox ng-model=\"data.cb2\" \naria-label=\"Checkbox 2\" ng-true-value=\"\'yup\'\" class=\"dotted\" ng-false-value=\"\'nope\'\">Custom Border</md-checkbox></div>\n</hljs><hljs lang=\"css\">md-checkbox.dotted .md-icon { border-width: 1px; border-style: dashed; }</hljs><br><h3>Bi-Di\n</h3><p>The mdCheckbox directive supports bi-directional specifiers in the <code>&lt;html dir=&quot;rtl&quot;&gt;\n</code> tag:</p><p><img \nsrc=\"https://cloud.githubusercontent.com/assets/1292882/8036091/fb40bcf6-0dfd-11e5-8319-25e68939d1a3.PNG\" \nalt=\"checkboxrtl\"></p></div>");
$templateCache.put("app/main/components/material-docs/partials/CSS/typography.html","<div class=\"doc-content theming\"><p>\nAngular Material provides typography CSS classes you can use to create visual consistency across your application.</p>\n<p style=\"text-align: center\"><a href=\"https://material.google.com/style/typography.html\">\nMaterial Design Typography Specification</a></p><section class=\"demo-container\"><md-toolbar class=\"demo-toolbar\"><div \nclass=\"md-toolbar-tools\"><h3>General Typography</h3></div></md-toolbar><div class=\"md-whiteframe-z1 docs-list\"><p>\nAngular Material uses the <a href=\"https://fonts.google.com/?selection.family=Roboto\">Roboto</a>\n font for all of its components.</p><p>The <code>Roboto</code> font will be <b>not</b>\n automatically loaded by Angular Material itself. The developer is responsible for loading all fonts used in their application. Shown below is a sample \n<i>link</i> markup used to load the <code>Roboto</code> font from a CDN.</p><hljs lang=\"html\"><link rel=\"stylesheet\" \nhref=\"https://fonts.googleapis.com/css?family=Roboto:300,400,500,700,400italic\"></hljs><h4 class=\"md-title\">Notes</h4>\n<p>When <code>Roboto</code> isn&#39;t loaded, then the typography will fallback to the following fonts:</p><ul><li>- \n<code>Helvetica Neue</code></li><li>- <code>sans-serif</code></li></ul></div></section><section class=\"demo-container\">\n<md-toolbar class=\"demo-toolbar\"><div class=\"md-toolbar-tools\"><h3>Heading Styles</h3></div></md-toolbar><div \nclass=\"md-whiteframe-z1 docs-list\"><p style=\"margin-top: 0\">To preserve <a \nhref=\"http://webaim.org/techniques/semanticstructure/\">semantic structures</a>, you should style the <code>&lt;h1&gt;\n</code> - <code>&lt;h6&gt;</code> heading tags with the styling classes shown below:</p><div layout=\"row\" \nclass=\"docs-descriptions\"><h4 class=\"md-body-1\" flex=\"25\" id=\"headings-selectors\">Selectors</h4><h4 class=\"md-body-1\" \nid=\"headings-output\">Output</h4></div><md-divider></md-divider><ul><li layout=\"column\" layout-gt-md=\"row\" \nlayout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>\n.md-display-4</code></span><h5 aria-describedby=\"headings-output\" class=\"md-display-4 docs-output\">Light 112px</h5>\n</li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" \naria-describedby=\"headings-selectors\"><code>.md-display-3</code></span><h5 aria-describedby=\"headings-output\" \nclass=\"md-display-3 docs-output\">Regular 56px</h5></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" \nclass=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>.md-display-2</code></span><h5 \naria-describedby=\"headings-output\" class=\"md-display-2 docs-output\">Regular 45px</h5></li><li layout=\"row\" \nlayout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>\n.md-display-1</code></span><h5 aria-describedby=\"headings-output\" class=\"md-display-1 docs-output\">Regular 34px</h5>\n</li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" \naria-describedby=\"headings-selectors\"><code>.md-headline</code></span><h5 aria-describedby=\"headings-output\" \nclass=\"md-headline docs-output\">Regular 24px</h5></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" \nclass=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>.md-title</code></span><h5 \naria-describedby=\"headings-output\" class=\"md-title docs-output\">Medium 20px</h5></li><li layout=\"row\" \nlayout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"headings-selectors\"><code>\n.md-subhead</code></span><h5 aria-describedby=\"headings-output\" class=\"md-subhead docs-output\">Regular 16px</h5></li>\n</ul><h4 class=\"md-title\">Example</h4><hljs lang=\"html\"><h1 class=\"md-display-3\">Headline</h1><h2 class=\"md-display-1\">\nHeadline</h2><h3 class=\"md-headline\">Headline</h3></hljs><br><span class=\"md-body-1\">Note: Base font size is <code>10px\n</code> for easy rem units (1.2rem = 12px). Body font size is <code>14px</code>. sp = scalable pixels.</span></div>\n</section><section class=\"demo-container\"><md-toolbar class=\"demo-toolbar\"><div class=\"md-toolbar-tools\"><h3>Body Copy\n</h3></div></md-toolbar><div class=\"md-whiteframe-z1 docs-list\"><div layout=\"row\" class=\"docs-descriptions\"><h4 \nclass=\"md-body-1\" flex=\"25\" id=\"body-selectors\">Selectors</h4><h4 class=\"md-body-1\" id=\"body-output\">Output</h4></div>\n<md-divider></md-divider><ul><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" \naria-describedby=\"body-selectors\"><code>.md-body-1</code><br></span><p class=\"docs-output md-body-1\" \naria-describedby=\"body-output\">Regular 14px</p></li><li layout=\"row\" layout-align=\"start center\"><span flex=\"25\" \nclass=\"docs-definition\" aria-describedby=\"body-selectors\"><code>.md-body-2</code></span><p \nclass=\"md-body-2 docs-output\" aria-describedby=\"body-output\">Medium 14px</p></li><li layout=\"row\" \nlayout-align=\"start center\"><span flex=\"25\" class=\"docs-definition\" aria-describedby=\"body-selectors\"><code>.md-button\n</code></span><div class=\"docs-output\" aria-describedby=\"body-output\"><md-button class=\"md-raised\" \nstyle=\"margin-left:0; margin-right:0\">Medium 14px</md-button></div></li><li layout=\"row\" layout-align=\"start center\">\n<span flex=\"25\" class=\"docs-definition\" aria-describedby=\"body-selectors\"><code>.md-caption</code><br></span><div \nclass=\"docs-output\" aria-describedby=\"body-output\"><small class=\"md-caption\">Regular 12px</small></div></li></ul><h4 \nclass=\"md-title\">Examples</h4><hljs lang=\"html\"><p class=\"md-body-2\">Body copy with medium weight.</p><md-button>Button\n</md-button><p class=\"md-body-1\">Regular body copy <small class=\"md-caption\">with small text</small>.</p><span \nclass=\"md-caption\">Caption</span></hljs></div></section></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-1.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Lastname</span> field to reveal the conditional step!\n</p><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"firstname\" ng-model=\"vm.verticalStepper.step1.firstname\" placeholder=\"Firstname\" required><div \nng-messages=\"verticalStep1.firstname.$error\" ng-show=\"verticalStep1.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.verticalStepper.step1.lastname\" \nplaceholder=\"Lastname\"><div ng-messages=\"verticalStep1.lastname.$error\" ng-show=\"verticalStep1.lastname.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.</span></div></div></md-input-container></div>\n</div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-2.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Birthplace</span>\n field to reveal another conditional step! Conditional step-ception!</p><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"birthplace\" \nng-model=\"vm.verticalStepper.step2.birthplace\" placeholder=\"Birthplace\"></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-3.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"ssn\" ng-model=\"vm.verticalStepper.step3.ssn\" \nplaceholder=\"Social Security Number\"></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-4.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><label>Address\n</label><textarea ng-model=\"vm.verticalStepper.step4.address\" md-maxlength=\"150\" max-rows=\"5\"></textarea><div \nng-messages=\"verticalStep4.address.$error\" ng-show=\"verticalStep4.address.$touched\" role=\"alert\"></div>\n</md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/vertical/step-5.html","<div class=\"md-inline-form\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"cardholder\" \nng-model=\"vm.verticalStepper.step5.cardholder\" placeholder=\"Card Holder\" required><div \nng-messages=\"step5.cardholder.$error\" role=\"alert\"><div ng-message=\"required\"><span>Card holder field is required.\n</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\"><md-input-container flex=\"100\" \nflex-gt-xs=\"33\"><input type=\"text\" name=\"cardnumber\" ng-model=\"vm.verticalStepper.step5.cardnumber\" \nplaceholder=\"Card Number\" required><div ng-messages=\"verticalStep5.cardnumber.$error\" role=\"alert\"><div \nng-message=\"required\"><span>Card number field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"CC2\" ng-model=\"vm.verticalStepper.step5.cc2\" placeholder=\"CC2\" \nmd-maxlength=\"3\" required><div ng-messages=\"verticalStep5.cc2.$error\" role=\"alert\" multipl><div ng-message=\"required\">\n<span>CC2 field is required.</span></div><div ng-message=\"md-maxlength\"><span>CC2 can\'t be longer than 3 characters.\n</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" \nname=\"expirationDate\" ng-model=\"vm.verticalStepper.step5.expirationDate\" placeholder=\"Expiration Date\" required><div \nng-messages=\"verticalStep5.expirationDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nExpiration date field is required.</span></div></div></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-1.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Lastname</span> field to reveal the conditional step!\n</p><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" \nname=\"firstname\" ng-model=\"vm.horizontalStepper.step1.firstname\" placeholder=\"Firstname\" required><div \nng-messages=\"horizontalStep1.firstname.$error\" ng-show=\"horizontalStep1.firstname.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>Firstname field is required.</span></div></div></md-input-container><md-input-container \nflex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"lastname\" ng-model=\"vm.horizontalStepper.step1.lastname\" \nplaceholder=\"Lastname\"><div ng-messages=\"horizontalStep1.lastname.$error\" ng-show=\"horizontalStep1.lastname.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>Lastname field is required.</span></div></div></md-input-container></div>\n</div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-2.html","<div class=\"md-inline-form\"><p>Fill the <span class=\"text-bold\">Birthplace</span>\n field to reveal another conditional step! Conditional step-ception!</p><div layout=\"column\" layout-gt-xs=\"row\" flex>\n<md-input-container flex=\"100\" flex-gt-xs=\"50\"><input type=\"text\" name=\"birthplace\" \nng-model=\"vm.horizontalStepper.step2.birthplace\" placeholder=\"Birthplace\"></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-3.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\" \nflex-gt-xs=\"50\"><input type=\"text\" name=\"ssn\" ng-model=\"vm.horizontalStepper.step3.ssn\" \nplaceholder=\"Social Security Number\"></md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-4.html","<div class=\"md-inline-form\"><div layout=\"column\" layout-gt-xs=\"row\" flex><md-input-container flex=\"100\"><label>Address\n</label><textarea ng-model=\"vm.horizontalStepper.step4.address\" md-maxlength=\"150\" max-rows=\"5\"></textarea><div \nng-messages=\"horizontalStep4.address.$error\" ng-show=\"horizontalStep4.address.$touched\" role=\"alert\"></div>\n</md-input-container></div></div>");
$templateCache.put("app/main/ui/forms/stepper-steps/horizontal/step-5.html","<div class=\"md-inline-form\"><md-input-container class=\"md-block\"><input type=\"text\" name=\"cardholder\" \nng-model=\"vm.horizontalStepper.step5.cardholder\" placeholder=\"Card Holder\" required><div \nng-messages=\"horizontalStep5.cardholder.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard holder field is required.</span></div></div></md-input-container><div layout=\"column\" layout-gt-xs=\"row\">\n<md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" name=\"cardnumber\" \nng-model=\"vm.horizontalStepper.step5.cardnumber\" placeholder=\"Card Number\" required><div \nng-messages=\"horizontalStep5.cardnumber.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nCard number field is required.</span></div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\">\n<input type=\"text\" name=\"CC2\" ng-model=\"vm.horizontalStepper.step5.cc2\" placeholder=\"CC2\" md-maxlength=\"3\" required>\n<div ng-messages=\"horizontalStep5.cc2.$error\" role=\"alert\" multipl><div ng-message=\"required\"><span>\nCC2 field is required.</span></div><div ng-message=\"md-maxlength\"><span>CC2 can\'t be longer than 3 characters.</span>\n</div></div></md-input-container><md-input-container flex=\"100\" flex-gt-xs=\"33\"><input type=\"text\" \nname=\"expirationDate\" ng-model=\"vm.horizontalStepper.step5.expirationDate\" placeholder=\"Expiration Date\" required><div \nng-messages=\"horizontalStep5.expirationDate.$error\" role=\"alert\"><div ng-message=\"required\"><span>\nExpiration date field is required.</span></div></div></md-input-container></div></div>");
$templateCache.put("app/main/ui/theme-colors/dialogs/custom-theme/custom-theme-dialog.html","<md-dialog class=\"custom-theme-dialog\" aria-label=\"Custom Theme\"><md-toolbar><div class=\"md-toolbar-tools\"><h2>\nCustom Theme Generator</h2><span flex></span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content><div \nlayout=\"row\" ng-repeat=\"type in [\'primary\', \'accent\', \'warn\', \'background\']\"><h3 class=\"type\">{{type}}</h3>\n<md-input-container><label>Palette</label><md-select ng-model=\"vm.theme[type].name\" \nng-style=\"{\'background-color\': vm.rgba(vm.palettes[vm.theme[type].name][\'500\'].value), \'color\': vm.rgba(vm.palettes[vm.theme[type].name][\'500\'].contrast, 1)}\">\n<md-option ng-value=\"palette\" ng-repeat=\"(palette, hues) in vm.palettes\" \nng-style=\"{\'background-color\': vm.rgba(hues[\'500\'].value), \'color\': vm.rgba(hues[\'500\'].contrast, 1)}\">{{palette}}\n</md-option></md-select></md-input-container><div layout=\"row\" \nng-repeat=\"hueType in [\'default\', \'hue-1\', \'hue-2\', \'hue-3\']\"><md-input-container><label>{{hueType}}</label><md-select \nng-model=\"vm.theme[type].hues[hueType]\" \nng-style=\"{\'background-color\': vm.rgba(vm.palettes[vm.theme[type].name][vm.theme[type].hues[hueType]].value), \'color\': vm.rgba(vm.palettes[vm.theme[type].name][vm.theme[type].hues[hueType]].contrast, 1)}\">\n<md-option ng-value=\"hue\" ng-repeat=\"(hue, opt) in vm.palettes[vm.theme[type].name]\" \nng-style=\"{\'background-color\': vm.rgba(opt.value), \'color\': vm.rgba(opt.contrast, 1)}\">{{hue}}</md-option></md-select>\n</md-input-container></div></div><md-divider></md-divider><div layout=\"row\"><p>\nTo make this theme permanent, copy the below code and add it into the \"fuseThemes\" object in \"core/theming/fuse-themes.constant.js\" file. You can also replace the \"CUSTOM_THEME_NAME\" with your theme name.\n</p></div><div layout=\"row\"><textarea readonly=\"readonly\" class=\"theme-object\">\"CUSTOM_THEME_NAME\" : {{vm.theme}}\n</textarea></div></md-dialog-content><md-dialog-actions layout=\"row\"><span flex></span><md-button \nclass=\"md-raised md-accent\" ng-click=\"vm.setTheme()\">Set Theme</md-button></md-dialog-actions></md-dialog>");
$templateCache.put("app/main/ui/theme-colors/tabs/accent/accent.html","<div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-accent-bg\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.accent.color}}</div><div flex>\n.md-accent-bg</div></div><div class=\"md-accent-bg\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div>\n<div flex>{{vm.themes.active.theme.accent.contrast1}}</div><div flex>.md-accent-bg</div></div><div \nclass=\"md-accent-bg\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>\nSecondary Text / Icon</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.accent.contrast2}}</div><div \nclass=\"secondary-text\" flex>.md-accent-bg .secondary-text</div></div><div class=\"md-accent-bg\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.accent.contrast3}}</div><div class=\"hint-text\" flex>\n.md-accent-bg .hint-text</div></div><div class=\"md-accent-bg\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding>\n<div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.accent.contrast4}}</div><div class=\"fade-text\" flex>.md-accent-bg .divider</div></div><div \nflex=\"100\" class=\"md-accent-fg\" layout=\"row\" layout-padding><div flex>As foreground color</div><div flex>\n{{vm.themes.active.theme.accent.color}}</div><div flex>.md-accent-fg</div></div></div><div class=\"color\" layout=\"row\" \nlayout-wrap layout-align=\"center center\"><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div\n flex>Hue 1</div><div flex>{{vm.themes.active.theme.accent.hue1.color}}</div><div flex>.md-accent-bg .md-hue-1</div>\n</div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.accent.hue1.contrast1}}</div><div flex>.md-accent-bg</div></div><div \nclass=\"md-accent-bg md-hue-1\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.accent.hue1.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-accent-bg .md-hue-1 .secondary-text</div></div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.accent.hue1.contrast3}}</div><div class=\"hint-text\" flex>.md-accent-bg .md-hue-1 .hint-text\n</div></div><div class=\"md-accent-bg md-hue-1\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.accent.hue1.contrast4}}</div><div class=\"fade-text\" flex>.md-accent-bg .md-hue-1 .divider\n</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-1\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.accent.hue1.color}}</div><div flex>.md-accent-fg</div></div></div><div \nclass=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-accent-bg md-hue-2\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Hue 2</div><div flex>{{vm.themes.active.theme.accent.hue2.color}}</div><div flex>\n.md-accent-bg .md-hue-2</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>\nPrimary Text</div><div flex>{{vm.themes.active.theme.accent.hue2.contrast1}}</div><div flex>.md-accent-bg</div></div>\n<div class=\"md-accent-bg md-hue-2\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.accent.hue2.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-accent-bg .md-hue-2 .secondary-text</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.accent.hue2.contrast3}}</div><div class=\"hint-text\" flex>.md-accent-bg .md-hue-2 .hint-text\n</div></div><div class=\"md-accent-bg md-hue-2\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.accent.hue2.contrast4}}</div><div class=\"fade-text\" flex>.md-accent-bg .md-hue-2 .divider\n</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-2\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.accent.hue2.color}}</div><div flex>.md-accent-fg</div></div></div><div \nclass=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-accent-bg md-hue-3\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Hue 3</div><div flex>{{vm.themes.active.theme.accent.hue3.color}}</div><div flex>\n.md-accent-bg .md-hue-3</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>\nPrimary Text</div><div flex>{{vm.themes.active.theme.accent.hue3.contrast1}}</div><div flex>.md-accent-bg</div></div>\n<div class=\"md-accent-bg md-hue-3\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.accent.hue3.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-accent-bg .md-hue-3 .secondary-text</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.accent.hue3.contrast3}}</div><div class=\"hint-text\" flex>.md-accent-bg .md-hue-3 .hint-text\n</div></div><div class=\"md-accent-bg md-hue-3\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.accent.hue3.contrast4}}</div><div class=\"fade-text\" flex>.md-accent-bg .md-hue-3 .divider\n</div></div><div flex=\"100\" class=\"md-accent-fg md-hue-3\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.accent.hue3.color}}</div><div flex>.md-accent-fg</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/background/background.html","<div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-background-bg\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.background.color}}</div><div \nflex>.md-background-bg</div></div><div class=\"md-background-bg\" flex=\"100\" layout=\"row\" layout-padding><div flex>\nPrimary Text</div><div flex>{{vm.themes.active.theme.background.contrast1}}</div><div flex>.md-background-bg</div>\n</div><div class=\"md-background-bg\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.background.contrast2}}</div><div class=\"secondary-text\" flex>.md-background-bg .secondary-text\n</div></div><div class=\"md-background-bg\" flex=\"100\" class=\"hint-text\" layout=\"row\" layout-padding><div \nclass=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.background.contrast3}}</div><div class=\"hint-text\" flex>.md-background-bg .hint-text</div>\n</div><div class=\"md-background-bg\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" flex>\nFade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.background.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-background-bg .divider</div></div><div flex=\"100\" class=\"md-primary-bg md-background-fg\" \nlayout=\"row\" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.background.color}}\n</div><div flex>.md-background-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap \nlayout-align=\"center center\"><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div flex>\nHue 1</div><div flex>{{vm.themes.active.theme.background.hue1.color}}</div><div flex>.md-background-bg .md-hue-1</div>\n</div><div class=\"md-background-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div \nflex>{{vm.themes.active.theme.background.hue1.contrast1}}</div><div flex>.md-background-bg</div></div><div \nclass=\"md-background-bg md-hue-1\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.background.hue1.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-background-bg .md-hue-1 .secondary-text</div></div><div class=\"md-background-bg md-hue-1\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.background.hue1.contrast3}}</div><div class=\"hint-text\" flex>\n.md-background-bg .md-hue-1 .hint-text</div></div><div class=\"md-background-bg md-hue-1\" flex=\"100\" class=\"divider\" \nlayout=\"row\" layout-padding><div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.background.hue1.contrast4}}</div><div class=\"fade-text\" flex>\n.md-background-bg .md-hue-1 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding><div \nflex class=\"md-background-fg md-hue-1\">As foreground color</div><div flex class=\"md-background-fg md-hue-1\">\n{{vm.themes.active.theme.background.hue1.color}}</div><div flex class=\"md-background-fg md-hue-1\">.md-background-fg\n</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div \nclass=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>Hue 2</div><div flex>\n{{vm.themes.active.theme.background.hue2.color}}</div><div flex>.md-background-bg .md-hue-2</div></div><div \nclass=\"md-background-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.background.hue2.contrast1}}</div><div flex>.md-background-bg</div></div><div \nclass=\"md-background-bg md-hue-2\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.background.hue2.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-background-bg .md-hue-2 .secondary-text</div></div><div class=\"md-background-bg md-hue-2\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.background.hue2.contrast3}}</div><div class=\"hint-text\" flex>\n.md-background-bg .md-hue-2 .hint-text</div></div><div class=\"md-background-bg md-hue-2\" flex=\"100\" class=\"divider\" \nlayout=\"row\" layout-padding><div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.background.hue2.contrast4}}</div><div class=\"fade-text\" flex>\n.md-background-bg .md-hue-2 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding><div \nflex class=\"md-background-fg md-hue-2\">As foreground color</div><div flex class=\"md-background-fg md-hue-2\">\n{{vm.themes.active.theme.background.hue2.color}}</div><div flex class=\"md-background-fg md-hue-2\">.md-background-fg\n</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div \nclass=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>Hue 3</div><div flex>\n{{vm.themes.active.theme.background.hue3.color}}</div><div flex>.md-background-bg .md-hue-3</div></div><div \nclass=\"md-background-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.background.hue3.contrast1}}</div><div flex>.md-background-bg</div></div><div \nclass=\"md-background-bg md-hue-3\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.background.hue3.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-background-bg .md-hue-3 .secondary-text</div></div><div class=\"md-background-bg md-hue-3\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.background.hue3.contrast3}}</div><div class=\"hint-text\" flex>\n.md-background-bg .md-hue-3 .hint-text</div></div><div class=\"md-background-bg md-hue-3\" flex=\"100\" class=\"divider\" \nlayout=\"row\" layout-padding><div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.background.hue3.contrast4}}</div><div class=\"fade-text\" flex>\n.md-background-bg .md-hue-3 .divider</div></div><div flex=\"100\" class=\"md-primary-bg\" layout=\"row\" layout-padding><div \nflex class=\"md-background-fg md-hue-3\">As foreground color</div><div flex class=\"md-background-fg md-hue-3\">\n{{vm.themes.active.theme.background.hue3.color}}</div><div flex class=\"md-background-fg md-hue-3\">.md-background-fg\n</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/warn/warn.html","<div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-warn-bg\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.warn.color}}</div><div flex>\n.md-warn-bg</div></div><div class=\"md-warn-bg\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div \nflex>{{vm.themes.active.theme.warn.contrast1}}</div><div flex>.md-warn-bg</div></div><div class=\"md-warn-bg\" \nflex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>Secondary Text / Icon\n</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.warn.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-warn-bg .secondary-text</div></div><div class=\"md-warn-bg\" flex=\"100\" class=\"hint-text\" layout=\"row\" \nlayout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.warn.contrast3}}</div><div class=\"hint-text\" flex>.md-warn-bg .hint-text</div></div><div \nclass=\"md-warn-bg\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" flex>\nFade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.warn.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-warn-bg .divider</div></div><div flex=\"100\" class=\"md-warn-fg\" layout=\"row\" layout-padding>\n<div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.color}}</div><div flex>.md-warn-fg</div>\n</div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-warn-bg md-hue-1\" \nflex=\"100\" layout=\"row\" layout-padding><div flex>Hue 1</div><div flex>{{vm.themes.active.theme.warn.hue1.color}}</div>\n<div flex>.md-warn-bg .md-hue-1</div></div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div\n flex>Primary Text</div><div flex>{{vm.themes.active.theme.warn.hue1.contrast1}}</div><div flex>.md-warn-bg</div></div>\n<div class=\"md-warn-bg md-hue-1\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.warn.hue1.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-warn-bg .md-hue-1 .secondary-text</div></div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.warn.hue1.contrast3}}</div><div class=\"hint-text\" flex>.md-warn-bg .md-hue-1 .hint-text</div>\n</div><div class=\"md-warn-bg md-hue-1\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" \nflex>Fade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.warn.hue1.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-warn-bg .md-hue-1 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-1\" \nlayout=\"row\" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.hue1.color}}\n</div><div flex>.md-warn-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\">\n<div class=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>Hue 2</div><div flex>\n{{vm.themes.active.theme.warn.hue2.color}}</div><div flex>.md-warn-bg .md-hue-2</div></div><div \nclass=\"md-warn-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.warn.hue2.contrast1}}</div><div flex>.md-warn-bg</div></div><div class=\"md-warn-bg md-hue-2\" \nflex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>Secondary Text / Icon\n</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.warn.hue2.contrast2}}</div><div class=\"secondary-text\" \nflex>.md-warn-bg .md-hue-2 .secondary-text</div></div><div class=\"md-warn-bg md-hue-2\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.warn.hue2.contrast3}}</div><div class=\"hint-text\" flex>.md-warn-bg .md-hue-2 .hint-text</div>\n</div><div class=\"md-warn-bg md-hue-2\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" \nflex>Fade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.warn.hue2.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-warn-bg .md-hue-2 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-2\" \nlayout=\"row\" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.hue2.color}}\n</div><div flex>.md-warn-fg</div></div></div><div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\">\n<div class=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>Hue 3</div><div flex>\n{{vm.themes.active.theme.warn.hue3.color}}</div><div flex>.md-warn-bg .md-hue-3</div></div><div \nclass=\"md-warn-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text</div><div flex>\n{{vm.themes.active.theme.warn.hue3.contrast1}}</div><div flex>.md-warn-bg</div></div><div class=\"md-warn-bg md-hue-3\" \nflex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>Secondary Text / Icon\n</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.warn.hue3.contrast2}}</div><div class=\"secondary-text\" \nflex>.md-warn-bg .md-hue-3 .secondary-text</div></div><div class=\"md-warn-bg md-hue-3\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.warn.hue3.contrast3}}</div><div class=\"hint-text\" flex>.md-warn-bg .md-hue-3 .hint-text</div>\n</div><div class=\"md-warn-bg md-hue-3\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div class=\"fade-text\" \nflex>Fade Text / Divider</div><div class=\"fade-text\" flex>{{vm.themes.active.theme.warn.hue3.contrast4}}</div><div \nclass=\"fade-text\" flex>.md-warn-bg .md-hue-3 .divider</div></div><div flex=\"100\" class=\"md-warn-fg md-hue-3\" \nlayout=\"row\" layout-padding><div flex>As foreground color</div><div flex>{{vm.themes.active.theme.warn.hue3.color}}\n</div><div flex>.md-warn-fg</div></div></div>");
$templateCache.put("app/main/ui/theme-colors/tabs/primary/primary.html","<div class=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-primary-bg\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Default</div><div flex>{{vm.themes.active.theme.primary.color}}</div><div flex>\n.md-primary-bg</div></div><div class=\"md-primary-bg\" flex=\"100\" layout=\"row\" layout-padding><div flex>Primary Text\n</div><div flex>{{vm.themes.active.theme.primary.contrast1}}</div><div flex>.md-primary-bg</div></div><div \nclass=\"md-primary-bg\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div class=\"secondary-text\" flex>\nSecondary Text / Icon</div><div class=\"secondary-text\" flex>{{vm.themes.active.theme.primary.contrast2}}</div><div \nclass=\"secondary-text\" flex>.md-primary-bg .secondary-text</div></div><div class=\"md-primary-bg\" flex=\"100\" \nclass=\"hint-text\" layout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div \nclass=\"hint-text\" flex>{{vm.themes.active.theme.primary.contrast3}}</div><div class=\"hint-text\" flex>\n.md-primary-bg .hint-text</div></div><div class=\"md-primary-bg\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding>\n<div class=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.primary.contrast4}}</div><div class=\"fade-text\" flex>.md-primary-bg .divider</div></div><div \nflex=\"100\" class=\"md-primary-fg\" layout=\"row\" layout-padding><div flex>As foreground color</div><div flex>\n{{vm.themes.active.theme.primary.color}}</div><div flex>.md-primary-fg</div></div></div><div class=\"color\" \nlayout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" \nlayout-padding><div flex>Hue 1</div><div flex>{{vm.themes.active.theme.primary.hue1.color}}</div><div flex>\n.md-primary-bg .md-hue-1</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" layout=\"row\" layout-padding><div \nflex>Primary Text</div><div flex>{{vm.themes.active.theme.primary.hue1.contrast1}}</div><div flex>.md-primary-bg</div>\n</div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.primary.hue1.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-primary-bg .md-hue-1 .secondary-text</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.primary.hue1.contrast3}}</div><div class=\"hint-text\" flex>.md-primary-bg .md-hue-1 .hint-text\n</div></div><div class=\"md-primary-bg md-hue-1\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.primary.hue1.contrast4}}</div><div class=\"fade-text\" flex>.md-primary-bg .md-hue-1 .divider\n</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-1\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.primary.hue1.color}}</div><div flex>.md-primary-fg</div></div></div><div \nclass=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-primary-bg md-hue-2\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Hue 2</div><div flex>{{vm.themes.active.theme.primary.hue2.color}}</div><div \nflex>.md-primary-bg .md-hue-2</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" layout=\"row\" layout-padding>\n<div flex>Primary Text</div><div flex>{{vm.themes.active.theme.primary.hue2.contrast1}}</div><div flex>.md-primary-bg\n</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.primary.hue2.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-primary-bg .md-hue-2 .secondary-text</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.primary.hue2.contrast3}}</div><div class=\"hint-text\" flex>.md-primary-bg .md-hue-2 .hint-text\n</div></div><div class=\"md-primary-bg md-hue-2\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.primary.hue2.contrast4}}</div><div class=\"fade-text\" flex>.md-primary-bg .md-hue-2 .divider\n</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-2\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.primary.hue2.color}}</div><div flex>.md-primary-fg</div></div></div><div \nclass=\"color\" layout=\"row\" layout-wrap layout-align=\"center center\"><div class=\"md-primary-bg md-hue-3\" flex=\"100\" \nlayout=\"row\" layout-padding><div flex>Hue 3</div><div flex>{{vm.themes.active.theme.primary.hue3.color}}</div><div \nflex>.md-primary-bg .md-hue-3</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" layout=\"row\" layout-padding>\n<div flex>Primary Text</div><div flex>{{vm.themes.active.theme.primary.hue3.contrast1}}</div><div flex>.md-primary-bg\n</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" class=\"secondary-text\" layout=\"row\" layout-padding><div \nclass=\"secondary-text\" flex>Secondary Text / Icon</div><div class=\"secondary-text\" flex>\n{{vm.themes.active.theme.primary.hue3.contrast2}}</div><div class=\"secondary-text\" flex>\n.md-primary-bg .md-hue-3 .secondary-text</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" class=\"hint-text\" \nlayout=\"row\" layout-padding><div class=\"hint-text\" flex>Hint Text / Disabled Text</div><div class=\"hint-text\" flex>\n{{vm.themes.active.theme.primary.hue3.contrast3}}</div><div class=\"hint-text\" flex>.md-primary-bg .md-hue-3 .hint-text\n</div></div><div class=\"md-primary-bg md-hue-3\" flex=\"100\" class=\"divider\" layout=\"row\" layout-padding><div \nclass=\"fade-text\" flex>Fade Text / Divider</div><div class=\"fade-text\" flex>\n{{vm.themes.active.theme.primary.hue3.contrast4}}</div><div class=\"fade-text\" flex>.md-primary-bg .md-hue-3 .divider\n</div></div><div flex=\"100\" class=\"md-primary-fg md-hue-3\" layout=\"row\" layout-padding><div flex>As foreground color\n</div><div flex>{{vm.themes.active.theme.primary.hue3.color}}</div><div flex>.md-primary-fg</div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/fullwidth/fullwidth.html","<div class=\"page-layout carded fullwidth\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\"><span class=\"h2 white-fg\">Fullwidth with independent scroll</span></div><div \nclass=\"content-card\" layout=\"column\" flex><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span>\nContent toolbar</span></div><md-content class=\"content\" flex ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/left-sidenav/left-sidenav.html","<div class=\"page-layout carded left-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><md-sidenav \nclass=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nclass=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" flex ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">\nLeft sidenav with independent scroll</span></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button><p>Content toolbar</p></div><md-content class=\"content\" flex ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/fullwidth-ii/fullwidth-ii.html","<div class=\"page-layout carded fullwidth single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\"><span class=\"h2 white-fg\">Fullwidth with page scroll</span></div><div \nclass=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><span>Content toolbar</span></div>\n<md-content class=\"content\" ms-scroll><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div>\n</md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/left-sidenav-ii/left-sidenav-ii.html","<div class=\"page-layout carded left-sidenav single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div>\n<md-sidenav class=\"sidenav\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav><div class=\"center\" \nflex><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">Left sidenav with page scroll</span></div></div>\n<div class=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle left sidenav\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><p>\nContent toolbar</p></div><md-content class=\"content\" ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/carded/right-sidenav/right-sidenav.html","<div class=\"page-layout carded right-sidenav\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div class=\"center\" \nlayout=\"column\" flex><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">\nRight sidenav with independent scroll</span></div></div><div class=\"content-card\" layout=\"column\" flex><div \nclass=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><p>Content toolbar</p><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle right pane\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content class=\"content\" flex ms-scroll>\n<div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div></div><md-sidenav \nclass=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" ms-scroll flex><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/carded/right-sidenav-ii/right-sidenav-ii.html","<div class=\"page-layout carded right-sidenav single-scroll\" layout=\"row\"><div class=\"top-bg md-accent-bg\"></div><div \nclass=\"center\" flex><div class=\"header\" layout=\"row\"><div><span class=\"h2 white-fg\">Right sidenav with page scroll\n</span></div></div><div class=\"content-card\"><div class=\"toolbar\" layout=\"row\" layout-align=\"space-between center\"><p>\nContent toolbar</p><md-button class=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md \naria-label=\"Toggle right pane\"><md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button></div><md-content \nclass=\"content\" ms-scroll><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-content></div>\n</div><md-sidenav class=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" \nms-scroll ms-sidenav-helper><div class=\"header\"><p>Sidenav header</p></div><md-content class=\"content\" ms-scroll><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/simple/fullwidth/fullwidth.html","<div class=\"page-layout simple fullwidth\"><div class=\"header md-accent-bg\"><span class=\"h2\">Fullwidth</span></div><div \nclass=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/left-sidenav-iii/left-sidenav-iii.html","<div class=\"page-layout simple left-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><span class=\"h2\">Inner Left Sidenav</span></div>\n<div class=\"content\" md-background-bg layout=\"row\" ms-scroll><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div class=\"header\"><p>\nSidenav header</p></div><md-content class=\"content\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav><div flex \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/left-sidenav/left-sidenav.html","<div class=\"page-layout simple left-sidenav\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"row\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button><div><span class=\"h2\">Left sidenav with independent scroll</span></div></div><div \nclass=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div>\n</div>");
$templateCache.put("app/main/ui/page-layouts/simple/left-sidenav-ii/left-sidenav-ii.html","<div class=\"page-layout simple left-sidenav single-scroll\" layout=\"row\"><md-sidenav class=\"sidenav\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav><div class=\"center\" flex ms-scroll>\n<div class=\"header md-accent-bg\" layout=\"row\"><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button><div><span class=\"h2\">Left sidenav with page scroll</span></div></div><div \nclass=\"content md-background-bg\"><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div>\n</div>");
$templateCache.put("app/main/ui/page-layouts/simple/right-sidenav/right-sidenav.html","<div class=\"page-layout simple right-sidenav\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div><span class=\"h2\">\nRight sidenav with independent scroll</span></div><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button></div><div class=\"content md-background-bg\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div><md-sidenav \nclass=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/simple/right-sidenav-iii/right-sidenav-iii.html","<div class=\"page-layout simple right-sidenav inner-sidenav\"><div class=\"header md-accent-bg\"><md-button \nclass=\"md-icon-button sidenav-toggle\" ng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\">\n<md-icon md-font-icon=\"icon-menu\" class=\"icon\"></md-icon></md-button><span class=\"h2\">Inner Right Sidenav</span></div>\n<div class=\"content\" md-background-bg layout=\"row\" ms-scroll><div flex \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div><md-sidenav class=\"sidenav md-sidenav-right\" \nmd-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll ms-sidenav-helper><div class=\"header\"><p>\nSidenav header</p></div><md-content class=\"content\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-content></md-sidenav></div></div>");
$templateCache.put("app/main/ui/page-layouts/simple/right-sidenav-ii/right-sidenav-ii.html","<div class=\"page-layout simple right-sidenav single-scroll\" layout=\"row\"><div class=\"center\" flex ms-scroll><div \nclass=\"header md-accent-bg\" layout=\"row\" layout-align=\"space-between\"><div><span class=\"h2\">\nRight sidenav with page scroll</span></div><md-button class=\"md-icon-button sidenav-toggle\" \nng-click=\"vm.toggleSidenav(\'sidenav\')\" hide-gt-md aria-label=\"Toggle sidenav\"><md-icon md-font-icon=\"icon-menu\" \nclass=\"icon\"></md-icon></md-button></div><div class=\"content md-background-bg\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></div></div><md-sidenav \nclass=\"sidenav md-sidenav-right\" md-is-locked-open=\"$mdMedia(\'gt-md\')\" md-component-id=\"sidenav\" ms-scroll \nms-sidenav-helper><div ng-include=\"\'app/main/ui/page-layouts/demo/demo-sidenav.html\'\"></div></md-sidenav></div>");
$templateCache.put("app/main/ui/page-layouts/simple/tabbed/tabbed.html","<div class=\"page-layout simple tabbed\" layout=\"column\"><div class=\"header md-accent-bg\"><span class=\"h2\">Tabbed</span>\n</div><div class=\"content\"><md-tabs md-dynamic-height><md-tab label=\"Tab 1\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-tab><md-tab label=\"Tab 2\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-tab><md-tab label=\"Tab 3\"><div \nng-include=\"\'app/main/ui/page-layouts/demo/demo-content.html\'\"></div></md-tab></md-tabs></div></div>");
$templateCache.put("app/main/pages/invoice/views/compact/compact.html","<div id=\"invoice\" class=\"compact page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\"><div class=\"invoice-date\">{{vm.invoice.date}}</div><div \nlayout=\"row\" layout-align=\"space-between stretch\"><div class=\"client\"><div class=\"invoice-number\" layout=\"row\" \nlayout-align=\"start center\"><span class=\"title\" translate=\"INVOICE.INVOICE\">INVOICE</span> <span class=\"number\">\n{{vm.invoice.number}}</span></div><div class=\"due-date\" layout=\"row\" layout-align=\"start center\"><span class=\"title\" \ntranslate=\"INVOICE.DUE_DATE\">DUE DATE</span> <span class=\"date\">{{vm.invoice.dueDate}}</span></div><div class=\"info\">\n<div class=\"title\">{{vm.invoice.client.title}}</div><div ng-if=\"vm.invoice.client.address\" class=\"address\">\n{{vm.invoice.client.address}}</div><div ng-if=\"vm.invoice.client.phone\" class=\"phone\">{{vm.invoice.client.phone}}</div>\n<div ng-if=\"vm.invoice.client.email\" class=\"email\">{{vm.invoice.client.email}}</div><div \nng-if=\"vm.invoice.client.website\" class=\"website\">{{vm.invoice.client.website}}</div></div></div><div \nclass=\"issuer md-accent-bg\" layout=\"row\" layout-align=\"start center\"><div class=\"logo\" layout=\"row\" \nlayout-align=\"center center\"><span>F</span></div><div class=\"info\"><div class=\"title\">{{vm.invoice.from.title}}</div>\n<div ng-if=\"vm.invoice.from.address\" class=\"address\">{{vm.invoice.from.address}}</div><div \nng-if=\"vm.invoice.from.phone\" class=\"phone\">{{vm.invoice.from.phone}}</div><div ng-if=\"vm.invoice.from.email\" \nclass=\"email\">{{vm.invoice.from.email}}</div><div ng-if=\"vm.invoice.from.website\" class=\"website\">\n{{vm.invoice.from.website}}</div></div></div></div></div><div class=\"content\"><table class=\"simple invoice-table\">\n<thead><th translate=\"INVOICE.SERVICE\">SERVICE</th><th translate=\"INVOICE.UNIT\">UNIT</th><th class=\"text-right\" \ntranslate=\"INVOICE.UNIT_PRICE\">UNIT PRICE</th><th class=\"text-right\" translate=\"INVOICE.QUANTITY\">QUANTITY</th><th \nclass=\"text-right\" translate=\"INVOICE.TOTAL\">TOTAL</th></thead><tbody><tr ng-repeat=\"service in vm.invoice.services\">\n<td><div class=\"title\">{{service.title}}</div></td><td>{{service.unit}}</td><td class=\"text-right\">\n{{service.unitPrice | currency}}</td><td class=\"text-right\">{{service.quantity}}</td><td class=\"text-right\">\n{{service.total | currency}}</td></tr><tr ng-repeat=\"service in vm.invoice.services\"><td><div class=\"title\">\n{{service.title}}</div></td><td>{{service.unit}}</td><td class=\"text-right\">{{service.unitPrice | currency}}</td><td \nclass=\"text-right\">{{service.quantity}}</td><td class=\"text-right\">{{service.total | currency}}</td></tr></tbody>\n</table><table class=\"simple invoice-table-footer\"><tbody><tr class=\"subtotal\"><td translate=\"INVOICE.SUBTOTAL\">\nSUBTOTAL</td><td>{{vm.invoice.subtotal | currency}}</td></tr><tr class=\"tax\"><td translate=\"INVOICE.TAX\">TAX</td><td>\n{{vm.invoice.tax | currency}}</td></tr><tr class=\"discount\"><td translate=\"INVOICE.DISCOUNT\">DISCOUNT</td><td>\n-{{vm.invoice.discount | currency}}</td></tr><tr class=\"total\"><td translate=\"INVOICE.TOTAL\">TOTAL</td><td>\n{{vm.invoice.total | currency}}</td></tr></tbody></table></div><div class=\"footer\"><div class=\"note\" \ntranslate=\"INVOICE.NOTE\">Please pay within 15 days. Thank you for your business.</div><div layout=\"row\" \nlayout-align=\"start start\"><div class=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>F</div></div>\n<div class=\"small-note\" translate=\"INVOICE.SMALL_NOTE\">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/pages/invoice/views/modern/modern.html","<div id=\"invoice\" class=\"modern page-layout blank\" layout=\"row\" ms-scroll><div class=\"invoice-container\"><div \nclass=\"card md-whiteframe-8dp\"><div class=\"header\" layout=\"row\" layout-align=\"space-between start\"><div class=\"ids\" \nlayout=\"column\"><div layout=\"row\" class=\"seller\" layout-align=\"start center\"><div class=\"logo md-accent-bg\" \nlayout=\"row\" layout-align=\"center center\"><div>F</div></div><div class=\"divider\"></div><div class=\"detail\"><div \nclass=\"title\">{{vm.invoice.from.title}}</div><div ng-if=\"vm.invoice.from.address\" class=\"address\">\n{{vm.invoice.from.address}}</div><div ng-if=\"vm.invoice.from.phone\" class=\"phone\"><span translate=\"INVOICE.PHONE\">Phone\n</span>: {{vm.invoice.from.phone}}</div><div ng-if=\"vm.invoice.from.email\" class=\"email\"><span \ntranslate=\"INVOICE.EMAIL\">Email</span>: {{vm.invoice.from.email}}</div><div ng-if=\"vm.invoice.from.website\" \nclass=\"website\"><span translate=\"INVOICE.WEB\">Web</span>: {{vm.invoice.from.website}}</div></div></div><div \nlayout=\"row\" class=\"client\" layout-align=\"start center\"><div class=\"label\" layout=\"row\" layout-align=\"end center\"><div \ntranslate=\"INVOICE.CLIENT\">CLIENT</div></div><div class=\"divider\"></div><div class=\"detail\"><div class=\"title\">\n{{vm.invoice.client.title}}</div><div ng-if=\"vm.invoice.client.address\" class=\"address\">{{vm.invoice.client.address}}\n</div><div ng-if=\"vm.invoice.client.phone\" class=\"phone\"><span translate=\"INVOICE.PHONE\">Phone</span>\n: {{vm.invoice.client.phone}}</div><div ng-if=\"vm.invoice.client.email\" class=\"email\"><span translate=\"INVOICE.EMAIL\">\nEmail</span>: {{vm.invoice.client.email}}</div><div ng-if=\"vm.invoice.client.website\" class=\"website\"><span \ntranslate=\"INVOICE.WEB\">Web</span>: {{vm.invoice.client.website}}</div></div></div></div><table class=\"summary\"><tr \nclass=\"code\"><td class=\"label\" translate=\"INVOICE.INVOICE\">INVOICE</td><td class=\"value\">{{vm.invoice.number}}</td>\n</tr><tr><td class=\"label\" translate=\"INVOICE.INVOICE_DATE\">INVOICE DATE</td><td class=\"value\">{{vm.invoice.date}}</td>\n</tr><tr><td class=\"label\" translate=\"INVOICE.DUE_DATE\">DUE DATE</td><td class=\"value\">{{vm.invoice.dueDate}}</td></tr>\n<tr><td class=\"label\" translate=\"INVOICE.TOTAL_DUE\">TOTAL DUE</td><td class=\"value\">{{vm.invoice.total | currency}}\n</td></tr></table></div><div class=\"content\"><table class=\"simple invoice-table\"><thead><th \ntranslate=\"INVOICE.SERVICE\">SERVICE</th><th translate=\"INVOICE.UNIT\">UNIT</th><th class=\"text-right\" \ntranslate=\"INVOICE.UNIT_PRICE\">UNIT PRICE</th><th class=\"text-right\" translate=\"INVOICE.QUANTITY\">QUANTITY</th><th \nclass=\"text-right\" translate=\"INVOICE.TOTAL\">TOTAL</th></thead><tbody><tr ng-repeat=\"service in vm.invoice.services\">\n<td><div class=\"title\">{{service.title}}</div><div class=\"detail\">{{service.detail}}</div></td><td>{{service.unit}}\n</td><td class=\"text-right\">{{service.unitPrice | currency}}</td><td class=\"text-right\">{{service.quantity}}</td><td \nclass=\"text-right\">{{service.total | currency}}</td></tr></tbody></table><table class=\"simple invoice-table-footer\">\n<tbody><tr class=\"subtotal\"><td translate=\"INVOICE.SUBTOTAL\">SUBTOTAL</td><td>{{vm.invoice.subtotal | currency}}</td>\n</tr><tr class=\"tax\"><td translate=\"INVOICE.TAX\">TAX</td><td>{{vm.invoice.tax | currency}}</td></tr><tr \nclass=\"discount\"><td translate=\"INVOICE.DISCOUNT\">DISCOUNT</td><td>-{{vm.invoice.discount | currency}}</td></tr><tr \nclass=\"total\"><td translate=\"INVOICE.TOTAL\">TOTAL</td><td>{{vm.invoice.total | currency}}</td></tr></tbody></table>\n</div><div class=\"footer\"><div class=\"note\" translate=\"INVOICE.NOTE\">\nPlease pay within 15 days. Thank you for your business.</div><div layout=\"row\" layout-align=\"start start\"><div \nclass=\"logo md-accent-bg\" layout=\"row\" layout-align=\"center center\"><div>F</div></div><div class=\"small-note\" \ntranslate=\"INVOICE.SMALL_NOTE\">\nIn condimentum malesuada efficitur. Mauris volutpat placerat auctor. Ut ac congue dolor. Quisque scelerisque lacus sed feugiat fermentum. Cras aliquet facilisis pellentesque. Nunc hendrerit quam at leo commodo, a suscipit tellus dapibus. Etiam at felis volutpat est mollis lacinia. Mauris placerat sem sit amet velit mollis, in porttitor ex finibus. Proin eu nibh id libero tincidunt lacinia et eget eros.\n</div></div></div></div><div class=\"page-break\"></div></div></div>");
$templateCache.put("app/main/pages/profile/tabs/about/about.html","<div layout=\"row\" layout-wrap><div class=\"about\" layout=\"column\" flex=\"100\" flex-gt-sm=\"50\" flex-gt-md=\"65\"><div \nclass=\"profile-box info-box general md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" \ntranslate=\"PROFILE.GENERAL_INFORMATION\">General Information</div></header><div class=\"content\"><div class=\"info-line\">\n<div class=\"title\" translate=\"PROFILE.GENDER\">Gender</div><div class=\"info\">{{vm.about.general.gender}}</div></div><div\n class=\"info-line\"><div class=\"title\" translate=\"PROFILE.BIRTHDAY\">Birthday</div><div class=\"info\">\n{{vm.about.general.birthday}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.LOCATIONS\">\nLocations</div><div class=\"info location\" ng-repeat=\"location in vm.about.general.locations\"><span>{{location}}</span>\n<md-icon md-font-icon=\"icon-map-marker\" class=\"s16\"></md-icon></div></div><div class=\"info-line\"><div class=\"title\" \ntranslate=\"PROFILE.ABOUT_ME\">About Me</div><div class=\"info\">{{vm.about.general.about}}</div></div></div></div><div \nclass=\"profile-box info-box work md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\"><div class=\"title\" \ntranslate=\"PROFILE.WORK\">Work</div></header><div class=\"content\"><div class=\"info-line\"><div class=\"title\" \ntranslate=\"PROFILE.OCCUPATION\">Occupation</div><div class=\"info\">{{vm.about.work.occupation}}</div></div><div \nclass=\"info-line\"><div class=\"title\" translate=\"PROFILE.SKILLS\">Skills</div><div class=\"info\">{{vm.about.work.skills}}\n</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.JOBS\">Jobs</div><table class=\"info jobs\"><tr \nclass=\"job\" ng-repeat=\"job in vm.about.work.jobs\"><td class=\"company\">{{job.company}}</td><td class=\"date\">{{job.date}}\n</td></tr></table></div></div></div><div class=\"profile-box info-box contact md-whiteframe-1dp\" layout=\"column\"><header\n class=\"md-accent-bg\"><div class=\"title\" translate=\"PROFILE.CONTACT\">Contact</div></header><div class=\"content\"><div \nclass=\"info-line\"><div class=\"title\" translate=\"PROFILE.ADDRESS\">Address</div><div class=\"info\">\n{{vm.about.contact.address}}</div></div><div class=\"info-line\"><div class=\"title\" translate=\"PROFILE.TEL\">Tel.</div>\n<div class=\"info\" ng-repeat=\"tel in vm.about.contact.tel\"><span>{{tel}}</span></div></div><div class=\"info-line\"><div \nclass=\"title\" translate=\"PROFILE.WEBSITE\">Website</div><div class=\"info\" \nng-repeat=\"website in vm.about.contact.websites\"><span>{{website}}</span></div></div><div class=\"info-line\"><div \nclass=\"title\" translate=\"PROFILE.EMAILS\">Emails</div><div class=\"info\" ng-repeat=\"email in vm.about.contact.emails\">\n<span>{{email}}</span></div></div></div></div></div><div class=\"about-sidebar\" layout=\"column\" flex=\"100\" \nflex-gt-sm=\"50\" flex-gt-md=\"35\"><div class=\"profile-box friends md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.FRIENDS\">\nFriends</div><div class=\"more secondary-text\"><span translate=\"PROFILE.SEE\">See</span> <span>454</span> <span \ntranslate=\"PROFILE.MORE\">More</span></div></header><div class=\"content\" layout=\"row\" layout-wrap><div class=\"friend\" \nflex=\"20\" ng-repeat=\"friend in vm.about.friends\"><img ng-src=\"{{friend.avatar}}\"></div></div></div><div \nclass=\"profile-box groups md-whiteframe-1dp\" layout=\"column\"><header class=\"md-accent-bg\" layout=\"row\" \nlayout-align=\"space-between center\"><div class=\"title\" translate=\"PROFILE.JOINED_GROUPS\">Joined Groups</div><div \nclass=\"more secondary-text\"><span translate=\"PROFILE.SEE\">See</span> <span>6</span> <span translate=\"PROFILE.MORE\">More\n</span></div></header><div class=\"content\"><div class=\"group\" ng-repeat=\"group in vm.about.groups\" layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><img ng-src=\"{{group.logo}}\" \nclass=\"logo\" alt=\"{{group.name}}\"><div><div class=\"name\">{{group.name}}</div><div class=\"category\">{{group.category}}\n</div><div class=\"members\">{{group.members}} people</div></div></div><md-button class=\"md-icon-button\" \naria-label=\"more\" translate translate-attr-aria-label=\"PROFILE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\">\n</md-icon></md-button></div></div></div></div></div>");
$templateCache.put("app/main/pages/profile/tabs/photos-videos/photos-videos.html","<div class=\"photos-videos\"><div class=\"period\" data-ng-repeat=\"period in vm.photosVideos\"><div class=\"period-title\">\n<span class=\"name\">{{period.name}}</span> <span class=\"info\">{{period.info}}</span></div><div class=\"period-media\" \nlayout=\"row\" layout-wrap><div class=\"media\" ng-repeat=\"media in period.media\"><img class=\"preview\" \nng-src=\"{{media.preview}}\" title=\"{{media.title}}\"><div class=\"title\">{{media.title}}</div></div></div></div></div>");
$templateCache.put("app/main/pages/profile/tabs/timeline/timeline.html","<div layout=\"row\" layout-wrap><div class=\"timeline\" layout=\"column\" flex=\"100\" flex-gt-sm=\"55\" flex-gt-md=\"65\" \nflex-order=\"2\" flex-order-gt-sm=\"1\"><div class=\"profile-box add-post md-whiteframe-1dp\"><div class=\"form\" flex>\n<textarea placeholder=\"Write something..\" translate translate-attr-placeholder=\"PROFILE.WRITE_SOMETHING\"></textarea>\n<footer layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \nclass=\"md-icon-button\" aria-label=\"insert photo\" translate translate-attr-aria-label=\"PROFILE.INSERT_PHOTO\"><md-icon \nmd-font-icon=\"icon-file-image-box\"></md-icon><md-tooltip><span translate=\"PROFILE.INSERT_PHOTO\">insert photo</span>\n</md-tooltip></md-button><md-button class=\"md-icon-button\" aria-label=\"add person\" translate \ntranslate-attr-aria-label=\"PROFILE.ADD_PERSON\"><md-icon md-font-icon=\"icon-person-plus\"></md-icon><md-tooltip><span \ntranslate=\"PROFILE.ADD_PERSON\">add person</span></md-tooltip></md-button><md-button class=\"md-icon-button\" \naria-label=\"add location\" translate translate-attr-aria-label=\"PROFILE.LOCATION\"><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><md-tooltip><span translate=\"PROFILE.LOCATION\">add location</span>\n</md-tooltip></md-button></div><md-button ng-click=\"\" class=\"post-button md-accent md-raised\" aria-label=\"POST\" \ntranslate=\"PROFILE.POST\" translate-attr-aria-label=\"PROFILE.POST\">POST</md-button></footer></div></div><md-divider>\n</md-divider><div class=\"timeline-item md-whiteframe-1dp\" ng-repeat=\"post in vm.posts\"><header layout=\"row\" \nlayout-align=\"space-between start\"><div class=\"user\" layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" \nng-src=\"{{post.user.avatar}}\"><div layout=\"column\"><div class=\"title\"><span class=\"username md-accent-color\">\n{{post.user.name}}</span> <span ng-if=\"post.type == \'post\'\" translate=\"PROFILE.TYPE_POST\">posted on your timeline\n</span> <span ng-if=\"post.type == \'something\'\" translate=\"PROFILE.TYPE_SOMETHING\">shared something with you</span> \n<span ng-if=\"post.type == \'video\'\" translate=\"PROFILE.TYPE_VIDEO\">shared a video with you</span> <span \nng-if=\"post.type == \'article\'\" translate=\"PROFILE.TYPE_ARTICLE\">shared an article with you</span></div><div \nclass=\"time\">{{post.time}}</div></div></div><md-button class=\"md-icon-button\" aria-label=\"more\" translate \ntranslate-attr-aria-label=\"PROFILE.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button></header><div\n class=\"content\"><div ng-if=\"post.message\" class=\"message\">{{post.message}}</div><div ng-if=\"post.media\" class=\"media\">\n<img ng-if=\"post.media.type === \'image\'\" ng-src=\"{{post.media.preview}}\"><div ng-if=\"post.media.type === \'video\'\" \nng-bind-html=\"post.media.embed | toTrusted\"></div></div><div ng-if=\"post.article\" layout=\"column\" class=\"article\"><div \nclass=\"media\"><img ng-src=\"{{post.article.media.preview}}\"></div><div class=\"title\">{{post.article.title}}</div><div \nclass=\"subtitle\">{{post.article.subtitle}}</div><div class=\"excerpt\">{{post.article.excerpt}}</div></div><div \nlayout=\"row\" layout-align=\"start center\"><md-button class=\"like-button\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-heart-outline\" class=\"s16\"></md-icon><span translate=\"PROFILE.LIKE\">Like</span>&nbsp;<span>\n({{post.like}})</span></div></md-button><md-button class=\"share-button\"><div layout=\"row\" layout-align=\"start center\">\n<md-icon md-font-icon=\"icon-share\" class=\"s16\"></md-icon><span translate=\"PROFILE.SHARE\">Share</span>&nbsp;<span>\n({{post.share}})</span></div></md-button></div></div><footer class=\"\" layout=\"column\" layout-align=\"start start\"><div \nng-if=\"post.comments\" class=\"comment-count\">{{post.comments.length}} comments<md-icon \nmd-font-icon=\"icon-keyboard_arrow_down\"></md-icon></div><div class=\"comment\" layout=\"row\" layout-fill \nng-repeat=\"comment in post.comments\"><img ng-src=\"{{comment.user.avatar}}\" class=\"avatar\"><div flex layout=\"column\">\n<div layout=\"row\" layout-align=\"start center\"><span class=\"username\">{{comment.user.name}}</span> <span class=\"time\">\n{{comment.time}}</span></div><div class=\"message\">{{comment.message}}</div><div class=\"actions\" layout=\"row\" \nlayout-align=\"space-between center\"><a href=\"#\" class=\"reply-button md-accent-color\" translate=\"PROFILE.REPLY\">Reply\n</a><md-icon flex md-font-icon=\"icon-flag\" class=\"report-button s16\"></md-icon></div></div></div><div class=\"reply\" \nlayout=\"row\" layout-fill><img src=\"assets/images/avatars/profile.jpg\" class=\"avatar\"><form flex><textarea \nplaceholder=\"Add a comment...\" translate translate-attr-placeholder=\"PROFILE.ADD_COMMENT\"></textarea><md-button \nng-click=\"\" class=\"post-comment-button md-accent md-raised\" aria-label=\"Post Comment\" translate=\"PROFILE.POST_COMMENT\" \ntranslate-aria-label=\"PROFILE.POST_COMMENT\">Post Comment</md-button></form></div></footer></div></div><div \nclass=\"timeline-sidebar\" layout=\"column\" flex=\"100\" flex-gt-sm=\"45\" flex-gt-md=\"35\" flex-order=\"1\" \nflex-order-gt-sm=\"2\"><div class=\"profile-box latest-activity md-whiteframe-1dp\" layout=\"column\"><header \nclass=\"md-accent-bg\" layout=\"row\" layout-align=\"space-between center\"><div class=\"title\" \ntranslate=\"PROFILE.LATEST_ACTIVITY\">Latest Activity</div><div class=\"more secondary-text\" translate=\"PROFILE.SEE_ALL\">\nSee All</div></header><div class=\"content\" layout=\"row\" layout-wrap><div class=\"activities\"><div class=\"activity\" \nlayout=\"row\" layout-align=\"start start\" ng-repeat=\"activity in vm.activities\"><img ng-src=\"{{activity.user.avatar}}\" \nclass=\"avatar\" alt=\"{{activity.user.name}}\"><div layout=\"column\"><div><span class=\"username md-accent-color\">\n{{activity.user.name}}</span> <span class=\"message\">{{activity.message}}</span></div><span class=\"time secondary-text\">\n{{activity.time}}</span></div></div></div></div></div></div></div>");
$templateCache.put("app/main/pages/search/tabs/emails/emails.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.EMAILS\">E-Mails</span> <span \nclass=\"secondary-text\"><span>87</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> \n<span>:</span> </span><span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span \ntranslate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" \ntranslate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div><div class=\"results\"><div class=\"result-item {{mail.status}}\" ng-repeat=\"mail in vm.mails | filter: vm.search\" \nmd-ink-ripple><div layout=\"row\" layout-align=\"start center\"><img class=\"avatar\" ng-if=\"mail.from.avatar\" \nalt=\"{{mail.from.name}}\" ng-src=\"{{mail.from.avatar}}\"><div class=\"avatar\" ng-if=\"!mail.from.avatar\" \nms-random-class=\"vm.colors\">{{mail.from.name[0]}}</div><div class=\"info\" flex layout=\"column\"><div \nclass=\"name text-truncate\">{{mail.from.name}}</div><div class=\"subject secondary-text text-truncate\">{{mail.subject}}\n</div><div class=\"message secondary-text text-truncate\">{{mail.message | htmlToPlaintext}}</div></div><div \nlayout=\"column\" layout-align=\"center end\"><div class=\"time secondary-text\">{{mail.time}}</div></div></div></div></div>\n<div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink ng-href=\"#\" \naria-label=\"Go to previous page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" \naria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to next page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/classic/classic.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><span class=\"result-count h3 secondary-text\"><span>54</span> <span \ntranslate=\"SEARCH.RESULTS\">Results</span></span><div class=\"pager\" layout=\"row\" layout-align=\"start center\"><span \nclass=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> <span>:</span> </span><span class=\"page-info\">\n<span>1</span> <span>-</span> <span>10</span> <span translate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button \nclass=\"md-icon-button\" aria-label=\"previous page\" translate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" \ntranslate translate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon>\n</md-button></div></div><div class=\"results\"><div class=\"result-item\" ng-repeat=\"item in vm.classic\"><div \nclass=\"title\">{{item.title}}</div><div class=\"url\">{{item.url}}</div><div class=\"excerpt\">{{item.excerpt}}</div></div>\n</div><div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink ng-href=\"#\" \naria-label=\"Go to previous page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" \naria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to next page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/contacts/contacts.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.CONTACTS\">Contacts</span> <span \nclass=\"secondary-text\"><span>13</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> \n<span>:</span> </span><span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span \ntranslate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" \ntranslate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div><table class=\"results simple clickable\" ms-responsive-table><thead><tr><th></th><th translate=\"SEARCH.NAME\">Name\n</th><th translate=\"SEARCH.POSITION\">Position</th><th translate=\"SEARCH.PHONE\">Phone</th><th translate=\"SEARCH.EMAIL\">\nEmail</th></tr></thead><tbody><tr class=\"result-item\" ng-repeat=\"contact in vm.contacts\"><td \nclass=\"text-left avatar-cell\" ng-if=\"contact.avatar\"><img class=\"avatar\" alt=\"{{contact.name}}\" \nng-src=\"{{contact.avatar}}\"></td><td class=\"text-left avatar-cell\" ng-if=\"!contact.avatar\"><div class=\"avatar\" \nms-random-class=\"vm.colors\">{{contact.name[0]}}</div></td><td class=\"name\">{{contact.name}}</td><td class=\"position\">\n{{contact.position}}</td><td class=\"phone\">{{contact.phone}}</td><td class=\"email\">{{contact.email}}</td></tr></tbody>\n</table><div class=\"simple-pagination\"><md-button class=\"pagination-item disabled\" md-no-ink ng-href=\"#\" \naria-label=\"Go to previous page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon \nmd-font-icon=\"icon-chevron-left\"></md-icon></md-button><md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" \naria-label=\"Go to page 1\"><span>1</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button class=\"pagination-item\" ng-href=\"#\" \naria-label=\"Go to next page\" translate translate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon \nmd-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/main/pages/search/tabs/users/users.html","<div class=\"result-info\" layout=\"row\" layout-align=\"space-between center\" layout-xs=\"column\" \nlayout-align-xs=\"start start\"><div><span class=\"md-title\" translate=\"SEARCH.USERS\">Users</span> <span \nclass=\"secondary-text\"><span>87</span> <span translate=\"SEARCH.RESULTS\">Results</span></span></div><div class=\"pager\" \nlayout=\"row\" layout-align=\"start center\"><span class=\"secondary-text\"><span translate=\"SEARCH.RESULTS\">Results</span> \n<span>:</span> </span><span class=\"page-info\"><span>1</span> <span>-</span> <span>10</span> <span \ntranslate=\"SEARCH.OF\">of</span> <span>100</span></span><md-button class=\"md-icon-button\" aria-label=\"previous page\" \ntranslate translate-attr-aria-label=\"SEARCH.PREVIOUS_PAGE\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" aria-label=\"next page\" translate \ntranslate-attr-aria-label=\"SEARCH.NEXT_PAGE\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>\n</div><table class=\"results simple clickable\" ms-responsive-table><thead><tr><th translate=\"SEARCH.NAME\">Name</th><th \ntranslate=\"SEARCH.POSITION\">Position</th><th translate=\"SEARCH.OFFICE\">Office</th><th class=\"text-right\" \ntranslate=\"SEARCH.AGE\">Age</th><th class=\"text-right\" translate=\"SEARCH.START_DATE\">Start Date</th><th \nclass=\"text-right\" translate=\"SEARCH.SALARY\">Salary</th><th class=\"text-left\" translate=\"SEARCH.EMAIL\">Email</th></tr>\n</thead><tbody><tr class=\"result-item user\" ng-repeat=\"user in vm.users\"><td class=\"name\">{{user.name}}</td><td \nclass=\"position\">{{user.position}}</td><td class=\"office\">{{user.office}}</td><td class=\"age text-right\">{{user.age}}\n</td><td class=\"start-date text-right\">{{user.startDate}}</td><td class=\"salary text-right\">{{user.salary | currency}}\n</td><td class=\"email text-left\">{{user.email}}</td></tr></tbody></table><div class=\"simple-pagination\"><md-button \nclass=\"pagination-item disabled\" md-no-ink ng-href=\"#\" aria-label=\"Go to previous page\" translate \ntranslate-attr-aria-label=\"SEARCH.GO_TO_PREVIOUS\"><md-icon md-font-icon=\"icon-chevron-left\"></md-icon></md-button>\n<md-button class=\"pagination-item active\" md-no-ink ng-href=\"#\" aria-label=\"Go to page 1\"><span>1</span></md-button>\n<md-button class=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 2\" hide-xs><span>2</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 3\" hide-xs><span>3</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 4\" hide-xs><span>4</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 5\" hide-xs><span>5</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 6\" hide-xs><span>6</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 7\" hide-xs><span>7</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 8\" hide-xs><span>8</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 9\" hide-xs><span>9</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to page 10\" hide-xs><span>10</span></md-button><md-button \nclass=\"pagination-item\" ng-href=\"#\" aria-label=\"Go to next page\" translate \ntranslate-attr-aria-label=\"SEARCH.GO_TO_NEXT\"><md-icon md-font-icon=\"icon-chevron-right\"></md-icon></md-button></div>");
$templateCache.put("app/core/directives/ms-stepper/templates/vertical/step/vertical-step.html","<md-button class=\"ms-stepper-navigation-item\" \nng-class=\"{\'current\': MsStepper.isStepCurrent(stepInfo.stepNumber), \'valid\': MsStepper.isStepValid(stepInfo.stepNumber), \'disabled\': MsStepper.isStepDisabled(stepInfo.stepNumber), \'optional\': MsStepper.isStepOptional(stepInfo.stepNumber)}\" \nng-click=\"MsStepper.gotoStep(stepInfo.stepNumber)\" ng-disabled=\"MsStepper.isStepDisabled(stepInfo.stepNumber)\" \nng-hide=\"MsStepper.isStepHidden(stepInfo.stepNumber)\" aria-label=\"Stepper navigation button\" layout=\"row\" \nlayout-align=\"start center\"><div class=\"step\" layout=\"row\" layout-align=\"center center\"><span \nng-if=\"!MsStepper.isStepValid(stepInfo.stepNumber) || MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-checkbox-blank-circle-outline s18 md-accent-fg\"></i> </span><span \nng-if=\"MsStepper.isStepValid(stepInfo.stepNumber) && !MsStepper.isStepOptional(stepInfo.stepNumber)\"><i \nclass=\"icon icon-check-circle s18 md-accent-fg\"></i></span></div><div layout=\"column\" layout-align=\"start start\"><div \nclass=\"title\" ng-if=\"stepInfo.stepTitleTranslate\">{{stepInfo.stepTitleTranslate | translate }}</div><div class=\"title\" \nng-if=\"!stepInfo.stepTitleTranslate\">{{stepInfo.stepTitle}}</div><div class=\"subtitle\" \nng-if=\"MsStepper.isStepOptional(stepInfo.stepNumber)\">Optional</div></div></md-button><div \nclass=\"ms-stepper-step-content\" ng-transclude></div><div class=\"ms-stepper-controls\" layout=\"row\" \nlayout-align=\"start center\" ng-show=\"MsStepper.isStepCurrent(stepInfo.stepNumber)\"><md-button \nclass=\"md-accent md-raised\" ng-disabled=\"MsStepper.isFirstStep()\" ng-click=\"MsStepper.gotoPreviousStep()\">Back\n</md-button><md-button class=\"md-accent md-raised\" ng-if=\"!MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isStepValid(MsStepper.currentStepNumber)\" ng-click=\"MsStepper.gotoNextStep()\">Next</md-button>\n<md-button type=\"submit\" class=\"md-accent md-raised\" ng-click=\"MsStepper.resetForm()\" ng-if=\"MsStepper.isLastStep()\" \nng-disabled=\"!MsStepper.isFormValid()\">Submit</md-button></div>");
$templateCache.put("app/main/apps/mail/views/classic/detail/detail.html","<div class=\"thread-header\" layout=\"row\" layout-align=\"space-between center\"><div><div class=\"subject\" flex>\n{{vm.currentThread.subject}}</div><div class=\"labels\"><div class=\"label\" \nng-repeat=\"labelId in vm.currentThread.labels\" ng-class=\"vm.getLabelColor(labelId)\">{{vm.getLabelTitle(labelId)}}</div>\n</div></div><div class=\"actions\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleThreadStatus(\'starred\')\" aria-label=\"Toggle starred\" translate \ntranslate-attr-toogle-starred=\"MAIL.TOGGLE_STARRED\"><md-icon ng-if=\"vm.currentThread.starred\" md-font-icon=\"icon-star\" \nclass=\"amber-fg\"></md-icon><md-icon ng-if=\"!vm.currentThread.starred\" md-font-icon=\"icon-star-outline\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.toggleThreadStatus(\'important\')\" \naria-label=\"Toggle important\" translate translate-attr-toogle-starred=\"MAIL.TOGGLE_IMPORTANT\"><md-icon \nng-if=\"vm.currentThread.important\" md-font-icon=\"icon-label\" class=\"amber-300-fg\"></md-icon><md-icon \nng-if=\"!vm.currentThread.important\" md-font-icon=\"icon-label-outline\"></md-icon></md-button></div></div><div \nclass=\"thread-content\"><div class=\"info\" layout=\"row\" layout-align=\"space-between start\"><div layout=\"column\" \nlayout-align=\"start start\"><div layout=\"row\" layout-align=\"start start\"><div><img ng-if=\"vm.currentThread.from.avatar\" \nalt=\"{{vm.currentThread.from.name}}\" ng-src=\"{{vm.currentThread.from.avatar}}\" class=\"avatar\"><div \nng-if=\"!vm.currentThread.from.avatar\" class=\"avatar\" ms-random-class=\"vm.colors\">{{vm.currentThread.from.name[0]}}\n</div></div><div layout=\"column\" layout-align=\"start start\"><div class=\"name\">{{vm.currentThread.from.name}}</div><div \nclass=\"to\" layout=\"row\" layout-align=\"start center\"><div class=\"to-text\" translate=\"MAIL.INFO.TO\">to</div><div>\n{{vm.currentThread.to[0].name}}</div></div></div></div><a class=\"toggle-details md-accent-color\" \nng-hide=\"vm.selectedMailShowDetails\" ng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\" \ntranslate=\"MAIL.SHOW_DETAILS\">Show Details </a><a class=\"toggle-details md-accent-color\" \nng-show=\"vm.selectedMailShowDetails\" ng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\" \ntranslate=\"MAIL.HIDE_DETAILS\">Hide Details</a><div ng-show=\"vm.selectedMailShowDetails\" class=\"details\" layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\"><span class=\"title\" translate=\"MAIL.DETAILS.FROM\">From:</span> <span \nclass=\"title\" translate=\"MAIL.DETAILS.TO\">To:</span> <span class=\"title\" translate=\"MAIL.DETAILS.DATE\">Date:</span>\n</div><div layout=\"column\"><span class=\"detail\">{{vm.currentThread.from.email}}</span> <span class=\"detail\">\n{{vm.currentThread.to[0].email}}</span> <span class=\"detail\">{{vm.currentThread.time}}</span></div></div></div>\n<md-menu><md-button aria-label=\"More\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" translate \ntranslate-aria-label=\"MAIL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button aria-label=\"Reply\" translate-aria-label=\"MAIL.REPLY\" \nng-click=\"vm.replyDialog($event)\"><md-icon md-font-icon=\"icon-reply\"></md-icon><span translate=\"MAIL.REPLY\">Reply\n</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Forward\" translate-aria-label=\"MAIL.FORWARD\">\n<md-icon md-font-icon=\"icon-forward\"></md-icon><span translate=\"MAIL.FORWARD\">Forward</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Print\" translate-aria-label=\"MAIL.PRINT\"><md-icon md-font-icon=\"icon-printer\">\n</md-icon><span translate=\"MAIL.PRINT\">Print</span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nng-bind-html=\"vm.currentThread.message\"></div></div><div ng-if=\"vm.currentThread.attachments\" \nclass=\"thread-attachments\"><div class=\"title\"><span translte=\"MAIL.ATTACHMENTS\">Attachments</span>\n ({{vm.currentThread.attachments.length}})</div><div class=\"attachment-list\" layout-wrap layout=\"row\"><div \nclass=\"attachment\" layout=\"column\" ng-repeat=\"attachment in vm.currentThread.attachments\"><img class=\"preview\" \nng-src=\"{{attachment.preview}}\"><div layout=\"column\"><a href=\"#\" class=\"md-accent-color link\" translate=\"MAIL.VIEW\">\nView</a> <a href=\"#\" class=\"md-accent-color link\" translate=\"MAIL.DOWNLOAD\">Download</a><div class=\"size\">\n({{attachment.size}})</div></div></div></div></div>");
$templateCache.put("app/main/apps/mail/views/classic/list/list.html","<div class=\"no-threads\" ng-if=\"vm.threads.length === 0\">There are no messages in \'{{vm.currentFilter.filter}}\'!</div>\n<div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" ng-if=\"!vm.threads && vm.loadingThreads\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div>\nLoading your mails...</div></div><div class=\"thread {{thread.status}}\" md-ink-ripple ng-if=\"!vm.loadingThreads\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" ng-click=\"vm.openThread(thread)\" \nng-class=\"{\'unread\': !thread.read, \'current-thread\': vm.currentThread === thread, \'selected\': vm.isSelected(thread)}\">\n<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(thread)\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"info\" flex layout=\"column\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><img \nclass=\"avatar\" ng-if=\"thread.from.avatar\" alt=\"{{thread.from.name}}\" ng-src=\"{{thread.from.avatar}}\"><div \nclass=\"avatar\" ng-if=\"!thread.from.avatar\" ms-random-class=\"vm.colors\">{{thread.from.name[0]}}</div><span \nclass=\"text-truncate\">{{thread.from.name}}</span><md-icon md-font-icon=\"icon-paperclip\" class=\"has-attachment s16\" \nng-if=\"thread.hasAttachments\"></md-icon></div><div class=\"subject text-truncate\">{{thread.subject}}</div><div \nclass=\"message text-truncate\">\n{{thread.message | htmlToPlaintext | limitTo:180}}{{thread.message.length > 180 ? \'...\' : \'\'}}<div class=\"labels\"><div \nclass=\"label\" ng-repeat=\"labelId in thread.labels\" ng-class=\"vm.getLabelColor(labelId)\">{{vm.getLabelTitle(labelId)}}\n</div></div></div></div><div layout=\"column\" layout-align=\"space-between end\"><div class=\"time\">{{thread.time}}</div>\n<div class=\"actions\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleThreadStatus(\'starred\', thread, $event)\" aria-label=\"Toggle starred\" translate \ntranslate-attr-aria-label=\"MAIL.TOGGLE_STARRED\"><md-icon ng-if=\"thread.starred\" md-font-icon=\"icon-star\" \nclass=\"amber-fg\"></md-icon><md-icon ng-if=\"!thread.starred\" md-font-icon=\"icon-star-outline\"></md-icon></md-button>\n<md-button class=\"md-icon-button\" ng-click=\"vm.toggleThreadStatus(\'important\', thread, $event)\" \naria-label=\"Toggle important\" translate translate-attr-aria-label=\"MAIL.TOGGLE_IMPORTANT\"><md-icon \nng-if=\"thread.important\" md-font-icon=\"icon-label\" class=\"amber-300-fg\"></md-icon><md-icon ng-if=\"!thread.important\" \nmd-font-icon=\"icon-label-outline\"></md-icon></md-button></div></div></div></div>");
$templateCache.put("app/main/apps/mail/views/outlook/detail/detail.html","<div ng-if=\"!vm.currentThread\" class=\"no-thread-selected\" layout=\"column\" layout-align=\"center center\" flex><md-icon \nmd-font-icon=\"icon-email\" class=\"s120 grey-400-fg\"></md-icon><span class=\"hint-text\" \ntranslate=\"MAIL.SELECT_MESSAGE_TO_READ\">Select a message to read</span></div><div ng-if=\"vm.currentThread\"><div \nclass=\"thread-header\" layout=\"row\" layout-align=\"space-between center\"><div><div class=\"subject\" flex>\n{{vm.currentThread.subject}}</div><div class=\"labels\"><div class=\"label\" \nng-repeat=\"labelId in vm.currentThread.labels\" ng-class=\"vm.getLabelColor(labelId)\">{{vm.getLabelTitle(labelId)}}</div>\n</div></div><div class=\"actions\" layout=\"row\" layout-align=\"start center\"><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleThreadStatus(\'starred\')\" aria-label=\"Toggle starred\" translate \ntranslate-attr-toogle-starred=\"MAIL.TOGGLE_STARRED\"><md-icon ng-if=\"vm.currentThread.starred\" md-font-icon=\"icon-star\" \nclass=\"amber-fg\"></md-icon><md-icon ng-if=\"!vm.currentThread.starred\" md-font-icon=\"icon-star-outline\"></md-icon>\n</md-button><md-button class=\"md-icon-button\" ng-click=\"vm.toggleThreadStatus(\'important\')\" \naria-label=\"Toggle important\" translate translate-attr-toogle-starred=\"MAIL.TOGGLE_IMPORTANT\"><md-icon \nng-if=\"vm.currentThread.important\" md-font-icon=\"icon-label\" class=\"amber-300-fg\"></md-icon><md-icon \nng-if=\"!vm.currentThread.important\" md-font-icon=\"icon-label-outline\"></md-icon></md-button></div></div><div \nclass=\"thread-content\"><div class=\"info\" layout=\"row\" layout-align=\"space-between start\"><div layout=\"column\" \nlayout-align=\"start start\"><div layout=\"row\" layout-align=\"start start\"><div><img ng-if=\"vm.currentThread.from.avatar\" \nalt=\"{{vm.currentThread.from.name}}\" ng-src=\"{{vm.currentThread.from.avatar}}\" class=\"avatar\"><div \nng-if=\"!vm.currentThread.from.avatar\" class=\"avatar\" ms-random-class=\"vm.colors\">{{vm.currentThread.from.name[0]}}\n</div></div><div layout=\"column\" layout-align=\"start start\"><div class=\"name\">{{vm.currentThread.from.name}}</div><div \nclass=\"to\" layout=\"row\" layout-align=\"start center\"><div class=\"to-text\" translate=\"MAIL.INFO.TO\">to</div><div>\n{{vm.currentThread.to[0].name}}</div></div></div></div><a class=\"toggle-details md-accent-color\" \nng-hide=\"vm.selectedMailShowDetails\" ng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\" \ntranslate=\"MAIL.SHOW_DETAILS\">Show Details </a><a class=\"toggle-details md-accent-color\" \nng-show=\"vm.selectedMailShowDetails\" ng-click=\"vm.selectedMailShowDetails = !vm.selectedMailShowDetails\" \ntranslate=\"MAIL.HIDE_DETAILS\">Hide Details</a><div ng-show=\"vm.selectedMailShowDetails\" class=\"details\" layout=\"row\" \nlayout-align=\"start start\"><div layout=\"column\"><span class=\"title\" translate=\"MAIL.DETAILS.FROM\">From:</span> <span \nclass=\"title\" translate=\"MAIL.DETAILS.TO\">To:</span> <span class=\"title\" translate=\"MAIL.DETAILS.DATE\">Date:</span>\n</div><div layout=\"column\"><span class=\"detail\">{{vm.currentThread.from.email}}</span> <span class=\"detail\">\n{{vm.currentThread.to[0].email}}</span> <span class=\"detail\">{{vm.currentThread.time}}</span></div></div></div>\n<md-menu><md-button aria-label=\"More\" class=\"md-icon-button\" ng-click=\"$mdOpenMenu($event)\" translate \ntranslate-aria-label=\"MAIL.MORE\"><md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content \nwidth=\"3\"><md-menu-item><md-button aria-label=\"Reply\" translate-aria-label=\"MAIL.REPLY\" \nng-click=\"vm.replyDialog($event)\"><md-icon md-font-icon=\"icon-reply\"></md-icon><span translate=\"MAIL.REPLY\">Reply\n</span></md-button></md-menu-item><md-menu-item><md-button aria-label=\"Forward\" translate-aria-label=\"MAIL.FORWARD\">\n<md-icon md-font-icon=\"icon-forward\"></md-icon><span translate=\"MAIL.FORWARD\">Forward</span></md-button></md-menu-item>\n<md-menu-item><md-button aria-label=\"Print\" translate-aria-label=\"MAIL.PRINT\"><md-icon md-font-icon=\"icon-printer\">\n</md-icon><span translate=\"MAIL.PRINT\">Print</span></md-button></md-menu-item></md-menu-content></md-menu></div><div \nng-bind-html=\"vm.currentThread.message\"></div></div><div ng-if=\"vm.currentThread.attachments\" \nclass=\"thread-attachments\"><div class=\"title\"><span translte=\"MAIL.ATTACHMENTS\">Attachments</span>\n ({{vm.currentThread.attachments.length}})</div><div class=\"attachment-list\" layout-wrap layout=\"row\"><div \nclass=\"attachment\" layout=\"column\" ng-repeat=\"attachment in vm.currentThread.attachments\"><img class=\"preview\" \nng-src=\"{{attachment.preview}}\"><div layout=\"column\"><a href=\"#\" class=\"md-accent-color link\" translate=\"MAIL.VIEW\">\nView</a> <a href=\"#\" class=\"md-accent-color link\" translate=\"MAIL.DOWNLOAD\">Download</a><div class=\"size\">\n({{attachment.size}})</div></div></div></div></div></div>");
$templateCache.put("app/main/apps/mail/views/outlook/list/list.html","<div class=\"no-threads\" ng-if=\"vm.threads.length === 0\">There are no messages in \'{{vm.currentFilter.filter}}\'!</div>\n<div class=\"loading-threads\" layout=\"column\" layout-align=\"center center\" ng-if=\"!vm.threads && vm.loadingThreads\">\n<md-progress-circular class=\"md-accent\" md-mode=\"indeterminate\" md-diameter=\"64\"></md-progress-circular><div>\nLoading your mails...</div></div><div class=\"thread {{thread.status}}\" md-ink-ripple ng-if=\"!vm.loadingThreads\" \nng-repeat=\"thread in vm.threads | filter: vm.search | filter: global.search\" ng-click=\"vm.openThread(thread)\" \nng-class=\"{\'unread\': !thread.read, \'current-thread\': vm.currentThread === thread, \'selected\': vm.isSelected(thread)}\">\n<div layout=\"row\" layout-align=\"start center\"><md-checkbox class=\"no-label\" ng-checked=\"vm.isSelected(thread)\" \nng-click=\"vm.toggleSelectThread(thread, $event)\" aria-label=\"{{vm.isSelected(thread) ? \'Deselect\' : \'Select\'}}\">\n</md-checkbox><div class=\"info\" flex layout=\"column\"><div class=\"name\" layout=\"row\" layout-align=\"start center\"><img \nclass=\"avatar\" ng-if=\"thread.from.avatar\" alt=\"{{thread.from.name}}\" ng-src=\"{{thread.from.avatar}}\"><div \nclass=\"avatar\" ng-if=\"!thread.from.avatar\" ms-random-class=\"vm.colors\">{{thread.from.name[0]}}</div><span \nclass=\"text-truncate\">{{thread.from.name}}</span><md-icon md-font-icon=\"icon-paperclip\" class=\"has-attachment s16\" \nng-if=\"thread.hasAttachments\"></md-icon></div><div class=\"subject text-truncate\">{{thread.subject}}</div><div \nclass=\"message text-truncate\">\n{{thread.message | htmlToPlaintext | limitTo:90}}{{thread.message.length > 90 ? \'...\' : \'\'}}<div class=\"labels\"><div \nclass=\"label\" ng-repeat=\"labelId in thread.labels\" ng-class=\"vm.getLabelColor(labelId)\">{{vm.getLabelTitle(labelId)}}\n</div></div></div></div><div layout=\"column\" layout-align=\"space-between end\"><div class=\"time\">{{thread.time}}</div>\n</div></div></div>");
$templateCache.put("app/main/apps/store/calendar/dialogs/event-detail/event-detail-dialog.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\"><span class=\"title\">{{vm.calendarEvent.title}}</span> <span flex></span><md-button \nclass=\"edit-event-button md-fab md-warn\" ng-click=\"vm.editEvent(vm.calendarEvent)\" aria-label=\"Edit event\" translate \ntranslate-attr-aria-label=\"CALENDAR.EDIT_EVENT\"><md-icon md-font-icon=\"icon-pencil\"></md-icon></md-button></div>\n</md-toolbar><div ng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\">\n</div><md-dialog-content ms-scroll><div class=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" \nlayout=\"row\" layout-align=\"start start\"><md-icon md-font-icon=\"icon-clock\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\">{{vm.calendarEvent.start.format(\'MMMM Do YYYY, h:mm:ss a\')}} <span ng-if=\"vm.calendarEvent.end\">-</span>\n {{vm.calendarEvent.end.format(\'MMMM Do YYYY, h:mm:ss a\')}}</span> <span class=\"secondary-text\">\n{{vm.calendarEvent.repeat || \'Does not repeat\'}}</span></div></div><div class=\"event-detail-row\" layout=\"row\" \nlayout-align=\"start start\"><md-icon md-font-icon=\"icon-bell-ring-outline\"></md-icon><div layout=\"column\" flex><span \nclass=\"h4\" translate=\"CALENDAR.30_MIN_BEFORE\">30 minutes before</span> <span class=\"h4\" \ntranslate=\"CALENDAR.15_MIN_BEFORE\">15 minutes before</span> <span class=\"h4\" translate=\"CALENDAR.30_MIN_LATER\">\n30 minutes later</span></div></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start start\"><md-icon \nmd-font-icon=\"icon-map-marker\"></md-icon><div layout=\"column\" flex><span class=\"h4\">Istanbul, Turkey</span></div></div>\n<div class=\"event-detail-row\" layout=\"row\" layout-align=\"start center\"><md-icon md-font-icon=\"icon-account\"></md-icon>\n<div layout=\"row\" flex><img src=\"assets/images/avatars/alice.jpg\" class=\"avatar\" alt=\"alice\"> <img \nsrc=\"assets/images/avatars/joyce.jpg\" class=\"avatar\" alt=\"joyce\"> <img src=\"assets/images/avatars/vincent.jpg\" \nclass=\"avatar\" alt=\"vincent\"></div></div></div></md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/store/calendar/dialogs/event-form/event-form-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.dialogTitle}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" \naria-label=\"Close dialog\" translate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon \nmd-font-icon=\"icon-close\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label translate=\"CALENDAR.TITLE\">Title</label><input\n name=\"title\" ng-model=\"vm.calendarEvent.title\" required md-autofocus><div ng-messages=\"eventForm.title.$error\" \nng-show=\"eventForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"CALENDAR.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container><md-list \nclass=\"all-day\"><md-list-item><p translate=\"CALENDAR.ALL_DAY\">All Day</p><md-switch class=\"md-secondary\" \nng-model=\"vm.calendarEvent.allday\" aria-label=\"All day\" translate translate-attr-aria-label=\"CALENDAR.ALL_DAY\">\n</md-switch></md-list-item></md-list><div layout=\"row\" class=\"date-row\"><md-datepicker \nng-model=\"vm.calendarEvent.start\" md-placeholder=\"Start Date\"></md-datepicker><md-input-container \nclass=\"no-errors-spacer\" flex md-no-float><input ng-model=\"vm.calendarEvent.startTime\" placeholder=\"Start Time\" \ntranslate translate-attr-placeholder=\"CALENDAR.START_TIME\"></md-input-container></div><div layout=\"row\" \nclass=\"date-row\"><md-datepicker ng-model=\"vm.calendarEvent.end\" md-placeholder=\"End Date\"></md-datepicker>\n<md-input-container class=\"no-errors-spacer\" flex md-no-float><input ng-model=\"vm.calendarEvent.endTime\" \nplaceholder=\"End Time\" translate translate-attr-placeholder=\"CALENDAR.END_TIME\"></md-input-container></div>\n<md-input-container class=\"md-block\" flex><label translate=\"CALENDAR.REPEAT\">Repeat</label><input \nng-model=\"vm.calendarEvent.repeat\"></md-input-container><md-input-container class=\"md-block\" flex><label \ntranslate=\"CALENDAR.LOCATION\">Location</label><input ng-model=\"vm.calendarEvent.location\"></md-input-container><div \nclass=\"notifications\" layout=\"column\"><div class=\"title\" translate=\"CALENDAR.NOTIFICATIONS\">Notifications</div>\n<md-select ng-model=\"notification\" placeholder=\"Notification\" \nng-repeat=\"notification in vm.calendarEvent.notifications\"><md-option ng-repeat=\"opt in vm.notifications\" \nvalue=\"{{opt}}\">{{opt}}</md-option></md-select><md-button aria-label=\"+ Add Another Notification\" \ntranslate=\"CALENDAR.ADD_NOTIFICATION\" translate-attr-aria-label=\"CALENDAR.ADD_NOTIFICATION\">+ Add Another Notification\n</md-button></div><md-input-container flex class=\"md-block textarea-container\"><label translate=\"CALENDAR.NOTES\">Notes\n</label><textarea ng-model=\"vm.task.notes\" md-maxlength=\"250\" max-rows=\"4\"></textarea></md-input-container>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><md-button \nng-click=\"vm.saveEvent()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\" translate=\"CALENDAR.SAVE\" \ntranslate-attr-aria-label=\"CALENDAR.SAVE\">SAVE</md-button><md-button class=\"md-icon-button\" \nng-click=\"vm.removeEvent()\" aria-label=\"Delete\" translate translate-attr-aria-label=\"CALENDAR.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"CALENDAR.DELETE\">Delete</span></md-tooltip>\n</md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/contracts/dialogs/contract/contract-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><div layout-xs=\"column\" layout=\"row\"><md-autocomplete flex=\"30\" \nmd-input-name=\"vm.contract.customer_name\" ng-disabled=\"vm.isDisabled\" md-selected-item=\"vm.selectedItem\" \nmd-search-text-change=\"vm.searchTextChange(vm.searchText)\" md-search-text=\"vm.searchText\" \nmd-selected-item-change=\"vm.selectedItemChange(item)\" md-items=\"item in vm.customesall\" md-no-cache=\"vm.noCache\" \nautocomplete=\"off\" md-item-text=\"item.display\" md-min-length=\"0\" placeholder=\"学生信息\" id=\"customer-auto\">\n<md-item-template><span md-highlight-text=\"vm.searchText\">{{item.display}}</span></md-item-template><md-not-found>\n没有您输入的学生信息</md-not-found></md-autocomplete><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"合同号\">合同号\n</label><input name=\"contact_guid\" ng-model=\"vm.contract.contact_guid\" required md-autofocus><div \nng-messages=\"taskForm.contact_guid.$error\" ng-show=\"taskForm.contact_guid.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>合同号必填</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"30\"><label>可请假次数(15天/次)</label><input name=\"can_leave_times\" ng-model=\"vm.contract.can_leave_times\" required><div\n ng-messages=\"taskForm.can_leave_times.$error\" ng-show=\"taskForm.can_leave_times.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>可请假次数必填</span></div></div></md-input-container></div><div layout-xs=\"column\" layout=\"row\">\n<md-autocomplete flex=\"100\" md-input-name=\"vm.contract.plan_title\" ng-disabled=\"vm.isDisabled\" \nmd-selected-item=\"vm.selectedPlanItem\" md-search-text-change=\"vm.searchPlans(vm.searchPlanText)\" \nmd-search-text=\"vm.searchPlanText\" md-selected-item-change=\"vm.selectedPlanItemChange(item)\" \nmd-items=\"item in vm.plansall\" md-no-cache=\"vm.noCache\" autocomplete=\"off\" md-item-text=\"item.display\" \nmd-min-length=\"0\" placeholder=\"学习计划\" id=\"plans-auto\"><md-item-template><span md-highlight-text=\"vm.searchText\">\n{{item.display}}</span></md-item-template><md-not-found>没有您输入的教学计划信息</md-not-found></md-autocomplete></div><div \nlayout-xs=\"column\" layout=\"row\" style=\"padding-bottom:20px\"><div flex=\"100\" layout=\"column\"><div><fieldset \nclass=\"standard\"><legend>课程分类</legend><div layout=\"row\" layout-wrap=\"\" flex=\"\"><div \nflex=\"{{vm.countFlexSize(vm.course_categorys.length)}}\" ng-repeat=\"item in vm.course_categorys\" \nstyle=\"{{$index == vm.course_categorys.length-1?\'\':\'padding-left: 5px;border-right-style: dotted;\'}} padding-left: 10px\">\n<md-checkbox ng-if=\"item.name!=\'活动课\'\" ng-model=\"vm.contract.ContractsHasCourses[item.id].course_category_checkbox\" \nng-checked=\"vm.exists(item, vm.selected)\" ng-click=\"vm.toggle(item, vm.selected)\" style=\"margin: 10px 0 10px\"><span \nstyle=\"color: #333333\" ng-class=\"{\'text-strike md-secondary-text\':checkItem.checked}\">{{item.name}}</span>\n</md-checkbox><br><input ng-if=\"item.name!=\'活动课\'\" class=\"input-bottom-border\" style=\"width:80px\" type=\"text\" \nng-model=\"vm.contract.ContractsHasCourses[item.id].course_number\" placeholder=\"课程数\"></div></div></fieldset></div></div>\n</div><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"卡类型\">卡类型\n</label><md-select ng-model=\"vm.contract.card_type_id\"><md-option value=\"{{card_type.id}}\" \nng-repeat=\"card_type in vm.card_types\">{{card_type.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\" flex=\"30\"><label translate=\"卡项\">卡项</label><md-select \nng-model=\"vm.contract.contract_type\"><md-option value=\"{{type.name}}\" ng-repeat=\"type in vm.contract_types\">\n{{type.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label \ntranslate=\"状态\">状态</label><md-select ng-model=\"vm.contract.status\"><md-option value=\"{{item.id}}\" \nng-repeat=\"item in vm.contracts_status\">{{item.name}}</md-option></md-select></md-input-container></div><div \nlayout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"支付类型\">支付类型</label>\n<md-select ng-model=\"vm.contract.pay_type_id\" required><md-option ng-value=\"type.id\" ng-repeat=\"type in vm.pay_types\">\n{{type.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label \ntranslate=\"金额\">金额</label><input name=\"amount\" ng-model=\"vm.contract.amount\" required><div \nng-messages=\"taskForm.amount.$error\" ng-show=\"taskForm.amount.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\n金额必填</span></div></div></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"销售顾问\">销售顾问\n</label><md-select ng-model=\"vm.contract.consult_id\"><md-option ng-repeat=\"consult in vm.consults\" \nvalue=\"{{consult.id}}\">{{consult.name}}</md-option></md-select></md-input-container></div><div layout-xs=\"column\" \nlayout=\"row\"><div flex class=\"date-container\" flex=\"30\"><label translate=\"签订日期\">合同签订日期</label><md-datepicker flex \nmd-placeholder=\"签订日期\" ng-model=\"vm.contract.sign_date\" ng-model-options=\"{timezone:\'utc\'}\">{{vm.contract.sign_date}}\n</md-datepicker></div><div flex class=\"date-container\" flex=\"30\"><label translate=\"开始日期\">合同生效开始日期</label><md-datepicker\n flex md-placeholder=\"生效开始日期\" ng-model=\"vm.contract.start_date\" ng-model-options=\"{timezone:\'utc\'}\">\n{{vm.contract.start_date}}</md-datepicker></div><div flex class=\"date-container\" flex=\"30\"><label translate=\"结束日期\">\n合同生效结束日期</label><md-datepicker flex md-placeholder=\"生效结束日期\" ng-model=\"vm.contract.end_date\" \nng-model-options=\"{timezone:\'utc\'}\">{{vm.contract.end_date}}</md-datepicker></div></div><div layout-xs=\"column\" \nlayout=\"row\"><md-input-container class=\"md-block\" flex=\"100\"><label translate=\"备注\">备注</label><textarea \nng-model=\"vm.contract.remarks\" md-maxlength=\"150\" max-rows=\"5\" style=\"height: 30px;min-height: 30px\"></textarea>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-if=\"!vm.newContract\" \nng-click=\"vm.saveContract()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"保存\" translate=\"保存\" translate-attr-aria-label=\"保存\">\nSAVE</md-button><md-button type=\"submit\" ng-if=\"vm.newContract\" ng-click=\"vm.addNewContract()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"添加\" \ntranslate=\"添加\" translate-attr-aria-label=\"添加\">ADD TASK</md-button></div><div layout=\"row\"><md-button ng-if=\"vm.is_cud\" \nclass=\"md-icon-button\" ng-click=\"vm.deleteContract($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"TODO.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span>删除</span>\n</md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/contracts/dialogs/signup/allow-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div layout-xs=\"column\" layout=\"row\" style=\"padding-bottom:20px; color: red\">{{vm.error.msg}}</div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-if=\"vm.is_allow\" ng-click=\"vm.save()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"确定预约\" translate=\"确定预约\" translate-attr-aria-label=\"确定预约\">SAVE\n</md-button></div><div layout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog($event)\" \naria-label=\"取消\" translate=\"取消\" translate-attr-aria-label=\"取消\"></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/contracts/dialogs/zcard/zcard-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label\n translate=\"转向门店\">转向门店</label><md-select ng-model=\"vm.to_store_id\" required><md-option value=\"{{store.id}}\" \nng-repeat=\"store in vm.stores\">{{store.name}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex=\"30\"><label>收款方</label><input name=\"can_leave_times\" ng-model=\"vm.pay.income_fang\" required><div \nng-messages=\"taskForm.income_fang.$error\" ng-show=\"taskForm.income_fang.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>收款方必填</span></div></div></md-input-container><div flex class=\"date-container\" flex=\"30\">\n<label translate=\"付款日期\">付款日期</label><md-datepicker flex md-placeholder=\"收款日期\" ng-model=\"vm.pay.pay_date\" \nng-model-options=\"{timezone:\'utc\'}\">{{pay_date}}</md-datepicker></div></div><div layout-xs=\"column\" layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"30\"><label translate=\"金额\">转卡金额</label><input name=\"amount\" \nng-model=\"vm.pay.amount\" required><div ng-messages=\"taskForm.amount.$error\" ng-show=\"taskForm.amount.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>金额必填</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex=\"30\"><label translate=\"付款方式\">付款方式</label><md-select ng-model=\"vm.pay.pay_type\" required>\n<md-option value=\"{{type.name}}\" ng-repeat=\"type in vm.pay_types\">{{type.name}}</md-option></md-select>\n</md-input-container></div><div layout-xs=\"column\" layout=\"column\" flex=\"30\" flex-gt-xs=\"30\" \nlayout-align=\"center center\" class=\"hide\" ng-file-select=\"vm.onFileSelect($files)\" data-multiple=\"false\" \ntitle=\"选择图片文件\" onclick=\"this.value = null\"><label translate=\"选择图片\">选择图片</label></div><div layout-xs=\"column\" \nlayout=\"row\"><md-input-container class=\"md-block\" flex=\"100\"><label translate=\"备注\">备注</label><textarea \nng-model=\"vm.pay.remarks\" md-maxlength=\"150\" max-rows=\"5\" style=\"height: 30px;min-height: 30px\"></textarea>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveZcard()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"保存\" \ntranslate=\"保存\" translate-attr-aria-label=\"保存\">SAVE</md-button></div><div layout=\"row\"><md-button type=\"submit\" \nng-click=\"vm.closeDialog($event)\" class=\"md-icon-button\" aria-label=\"取消\" translate=\"取消\" translate-attr-aria-label=\"取消\">\nSAVE</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/courses/dialogs/category/category-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label translate=\"名称\">名称</label><input name=\"name\" \nng-model=\"vm.categorie.name\" required md-autofocus><div ng-messages=\"taskForm.name.$error\" \nng-show=\"taskForm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"TODO.ERRORS.TITLE_REQUIRED\">\nTitle field is required</span></div></div></md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-if=\"!vm.newCategorie\" ng-click=\"vm.saveCategorie()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\">保存</md-button><md-button type=\"submit\" ng-if=\"vm.newCategorie\" \nng-click=\"vm.addNewCategorie()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\">添加</md-button></div><div layout=\"row\"><md-button \nng-if=\"vm.is_cud\" class=\"md-icon-button\" ng-click=\"vm.deleteCategorie($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"TODO.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"TODO.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/courses/dialogs/experience/experience-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><div layout-xs=\"column\" layout=\"row\" style=\"color: red\"><span \nng-if=\"vm.experience.skqk.yy>0\">已预约：{{vm.experience.skqk.yy}}</span> <span ng-if=\"vm.experience.skqk.ap>0\" \nstyle=\"margin-left: 10px\">已安排：{{vm.experience.skqk.ap}}</span> <span ng-if=\"vm.experience.skqk.pz>0\" \nstyle=\"margin-left: 10px\">已批准：{{vm.experience.skqk.pz}}</span> <span ng-if=\"vm.experience.skqk.sk>0\" \nstyle=\"margin-left: 10px\">已上课：{{vm.experience.skqk.sk}}</span> <span ng-if=\"vm.experience.skqk.kk>0\">\n旷课：{{vm.experience.skqk.kk}}</span></div><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" \nflex=\"30\"><label translate=\"家长电话\">家长电话</label><input name=\"mobile\" ng-model=\"vm.experience.mobile\" required \nmd-autofocus ng-blur=\"vm.checkMobile(vm.experience.mobile)\"><div ng-messages=\"taskForm.mobile.$error\" \nng-show=\"taskForm.mobile.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"家长电话必填\">家长电话必填</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"家长姓名\">家长姓名</label><input \nname=\"parent\" ng-model=\"vm.experience.parent\" required md-autofocus><div ng-messages=\"taskForm.parent.$error\" \nng-show=\"taskForm.parent.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"家长姓名必填\">家长姓名必填</span></div>\n</div></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"家长与学生的关系\">家长与学生的关系</label>\n<md-select ng-model=\"vm.experience.relation\"><md-option value=\"爸爸\">爸爸</md-option><md-option value=\"妈妈\">妈妈</md-option>\n</md-select></md-input-container></div><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" \nflex=\"30\"><label translate=\"学生姓名\">学生姓名</label><input name=\"name\" ng-model=\"vm.experience.name\" required md-autofocus>\n<div ng-messages=\"taskForm.name.$error\" ng-show=\"taskForm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"学生姓名必填\">学生姓名必填</span></div></div></md-input-container><md-input-container \nclass=\"md-block md-default-theme md-input-focused\" flex=\"30\"><label translate=\"学生性别\" style=\"font-size: 1.6rem\">学生性别\n</label><md-radio-group ng-model=\"vm.experience.sex\"><md-radio-button ng-value=\"1\" aria-label=\"男\">男</md-radio-button>\n<md-radio-button ng-value=\"0\" aria-label=\"女\">女</md-radio-button></md-radio-group></md-input-container><div flex \nclass=\"date-container\"><label translate=\"学生生日\">学生生日</label><md-datepicker flex md-placeholder=\"学生生日\" \nng-init=\"birthday = vm.StrToDate(vm.experience.birthday);\" ng-model=\"birthday\" \nng-change=\"vm.experience.birthday = vm.DateToStr(birthday)\" ng-model-options=\"{timezone:\'utc\'}\">{{birthday}}\n</md-datepicker></div></div><div layout-xs=\"column\" layout=\"row\"><div flex class=\"date-container\"><label \ntranslate=\"期望体验时间\">期望体验时间</label><md-datepicker flex md-placeholder=\"期望体验时间\" \nng-init=\"task_time = vm.StrToDate(vm.experience.task_time);\" ng-model=\"task_time\" \nng-change=\"task_time =  vm.DateToStr(task_time)\" ng-model-options=\"{timezone:\'utc\'}\">{{task_time}}</md-datepicker>\n</div></div><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label \ntranslate=\"销售顾问\">销售顾问</label><md-select ng-model=\"vm.experience.consult_id\"><md-option \nng-repeat=\"consult in vm.consults\" value=\"{{consult.id}}\">{{consult.name}}</md-option></md-select><div \nng-messages=\"taskForm.amount.$error\" ng-show=\"taskForm.consult_id.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>销售顾问必填</span></div></div></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label \ntranslate=\"支付类型\">支付类型</label><md-select ng-model=\"vm.experience.pay_type\"><md-option value=\"{{type.name}}\" \nng-repeat=\"type in vm.pay_types\">{{type.name}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex=\"30\"><label translate=\"金额\">金额</label><input name=\"amount\" ng-model=\"vm.experience.amount\"><div \nng-messages=\"taskForm.amount.$error\" ng-show=\"taskForm.amount.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\n金额必填</span></div></div></md-input-container></div><div layout-xs=\"column\" layout=\"row\"><md-input-container \nclass=\"md-block\" flex=\"100\"><label translate=\"来源\">来源</label><textarea ng-model=\"vm.experience.source\" max-rows=\"5\" \nstyle=\"height: 30px;min-height: 30px\"></textarea></md-input-container></div><div layout-xs=\"column\" layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"100\"><label translate=\"备注\">备注</label><textarea \nng-model=\"vm.experience.remarks\" md-maxlength=\"150\" max-rows=\"5\" style=\"height: 30px;min-height: 30px\"></textarea>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-if=\"!vm.newExperience\" \nng-click=\"vm.saveExperience()\" class=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid\" \naria-label=\"SAVE\" translate=\"保存\" translate-attr-aria-label=\"保存\">SAVE</md-button><md-button type=\"submit\" \nng-if=\"vm.newExperience\" ng-click=\"vm.addNewExperience()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"Add Task\" translate=\"添加\" \ntranslate-attr-aria-label=\"添加\">ADD TASK</md-button></div><div layout=\"row\"><md-button ng-if=\"vm.is_del\" \nclass=\"md-icon-button\" ng-click=\"vm.deleteExperience($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"TODO.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"删除\">\n删除</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/courses/dialogs/tiaok/tiaok-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div><div \nlayout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"上课时间\">上课时间</label>\n<md-datepicker flex ng-model=\"vm.course.course_time\" ng-model-options=\"{timezone:\'utc\'}\" md-placeholder=\"上课时间\">\n{{vm.course.course_time}}</md-datepicker></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label>\n开始时间点</label><md-select ng-model=\"vm.course.course_begintime\" required><md-option \nng-repeat=\"item in vm.course_begintime_arr\" value=\"{{item.name}}\">{{item.name}}</md-option></md-select>\n</md-input-container>~<md-input-container class=\"md-block\" flex=\"30\"><label>结束时间点</label><md-select \nng-model=\"vm.course.course_endtime\"><md-option ng-repeat=\"item in vm.course_endtime_arr\" value=\"{{item.name}}\">\n{{item.name}}</md-option></md-select></md-input-container></div><div layout-xs=\"column\" layout=\"row\" \nstyle=\"padding-bottom:20px\"><md-input-container class=\"md-block\" flex=\"30\"><md-checkbox ng-model=\"vm.check\" \nstyle=\"margin: 10px 0 10px\"><span style=\"color: #333333\" \nng-class=\"{\'text-strike md-secondary-text\':checkItem.checked}\">是否顺延课时</span></md-checkbox></md-input-container></div>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" ng-if=\"!vm.newCourse\" ng-click=\"vm.saveCourse()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid\">确定</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/courses/dialogs/course/course-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label\n translate=\"名称\">名称</label><input name=\"name\" ng-model=\"vm.course.name\" required md-autofocus><div \nng-messages=\"taskForm.name.$error\" ng-show=\"taskForm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>名称必填\n</span></div></div></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"课程类型\">课程类型\n</label><md-select ng-model=\"vm.course.categories_id\" required><md-option ng-repeat=\"categorie in vm.categories\" \nng-value=\"{{categorie.id}}\">{{categorie.name}}</md-option></md-select></md-input-container><md-input-container \nclass=\"md-block\" flex=\"30\"><label translate=\"课程级别\">课程级别</label><md-select ng-model=\"vm.course.type\" required><md-option\n ng-repeat=\"categorie in vm.jibei_types\" ng-value=\"{{categorie.id}}\">{{categorie.name}}</md-option></md-select>\n</md-input-container></div><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label \ntranslate=\"上课时间\">上课时间</label><md-datepicker flex ng-model=\"vm.course.course_time\" ng-model-options=\"{timezone:\'utc\'}\" \nmd-placeholder=\"上课时间\">{{vm.course.course_time}}</md-datepicker></md-input-container><md-input-container \nclass=\"md-block\" flex=\"30\"><label>开始时间点</label><md-select ng-model=\"vm.course.course_begintime\" required><md-option \nng-repeat=\"item in vm.course_begintime_arr\" value=\"{{item.name}}\">{{item.name}}</md-option></md-select>\n</md-input-container>~<md-input-container class=\"md-block\" flex=\"30\"><label>结束时间点</label><md-select \nng-model=\"vm.course.course_endtime\"><md-option ng-repeat=\"item in vm.course_endtime_arr\" value=\"{{item.name}}\">\n{{item.name}}</md-option></md-select></md-input-container></div><div layout-xs=\"column\" layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"30\"><label translate=\"预招人数\">预招人数</label><input name=\"course_size\" \nng-model=\"vm.course.course_size\" required><div ng-messages=\"taskForm.course_size.$error\" \nng-show=\"taskForm.course_size.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TODO.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\" flex=\"30\"><label translate=\"主老师\">主老师</label><md-select \nng-model=\"vm.course.teacher_id\" required><md-option ng-repeat=\"teacher in vm.teachers\" ng-value=\"teacher.id\">\n{{teacher.name}}</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label \ntranslate=\"助理\">助理</label><md-select ng-model=\"vm.course.assistant_id\"><md-option \nng-repeat=\"assistant in vm.assistants\" ng-value=\"{{assistant.id}}\">{{assistant.name}}</md-option></md-select>\n</md-input-container></div><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label \ntranslate=\"最小开课数\">最小开课数</label><input name=\"min_count\" ng-model=\"vm.course.min_count\" required><div \nng-messages=\"taskForm.min_count.$error\" ng-show=\"taskForm.min_count.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"TODO.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container>\n<md-autocomplete flex=\"30\" md-input-name=\"vm.course.room\" ng-disabled=\"vm.isDisabled\" \nmd-selected-item=\"vm.selectedItem\" md-search-text-change=\"vm.searchTextChange(vm.searchText)\" \nmd-search-text=\"vm.searchText\" md-selected-item-change=\"vm.selectedItemChange(item)\" md-items=\"item in vm.roomsall\" \nmd-no-cache=\"vm.noCache\" autocomplete=\"off\" md-item-text=\"item.display\" md-min-length=\"0\" placeholder=\"教室\" \nid=\"room-auto\"><md-item-template><span md-highlight-text=\"vm.searchText\">{{item.display}}</span></md-item-template>\n<md-not-found>没有您输入的教室信息</md-not-found></md-autocomplete></div><div layout-xs=\"column\" layout=\"row\"><md-input-container\n class=\"md-block\" flex=\"30\"><label translate=\"固定课程编号\">固定课程编号</label><input name=\"number\" ng-model=\"vm.course.number\">\n</md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"固定课程描述\">固定课程描述</label><input \nname=\"content\" ng-model=\"vm.course.content\"></md-input-container></div><div layout-xs=\"column\" layout=\"row\"><ul \nng-if=\"vm.hasConflict\" class=\"status error\"><li ng-if=\"vm.hasConflict.room\" class=\"status error\">\n房间冲突：{{vm.hasConflict.room}}</li><li ng-if=\"vm.hasConflict.teacher\" class=\"status error\">\n老师冲突：{{vm.hasConflict.teacher}}</li><li ng-if=\"vm.hasConflict.customer\" class=\"status error\">学生冲突:<label \nng-repeat=\"item in vm.hasConflict.customer\" class=\"status error\">{{item}}<br></label>{{item}}</li></ul></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-if=\"!vm.newCourse\" ng-click=\"vm.saveCourse()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid\">保存</md-button><md-button type=\"submit\" \nng-if=\"vm.newCourse\" ng-click=\"vm.addNewCourse()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\">添加</md-button></div><div layout=\"row\"><md-button \nng-if=\"vm.is_cud\" class=\"md-icon-button\" ng-click=\"vm.deleteCourse($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"TODO.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"TODO.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/customers/dialogs/customer/customer-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label\n translate=\"会员号\">会员号</label><input name=\"member_id\" ng-model=\"vm.customer.member_id\" required md-autofocus><div \nng-messages=\"taskForm.member_id.$error\" ng-show=\"taskForm.member_id.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>会员号必填</span></div></div></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label \ntranslate=\"学生姓名\">学生姓名</label><input name=\"name\" ng-model=\"vm.customer.name\" required><div \nng-messages=\"taskForm.name.$error\" ng-show=\"taskForm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\n学生姓名必填</span></div></div></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"昵称\">昵称\n</label><input name=\"nickname\" ng-model=\"vm.customer.nickname\"><div ng-messages=\"taskForm.nickname.$error\" \nng-show=\"taskForm.nickname.$touched\" role=\"alert\"><div ng-message=\"required\"><span>昵称必填</span></div></div>\n</md-input-container></div><div layout-xs=\"column\" layout=\"row\"><md-input-container \nclass=\"md-block md-default-theme md-input-focused\" flex=\"30\"><label translate=\"性别\" style=\"font-size: 1.6rem\">性别</label>\n<md-radio-group ng-model=\"vm.customer.sex\"><md-radio-button ng-value=\"1\" aria-label=\"男\">男</md-radio-button>\n<md-radio-button ng-value=\"0\" aria-label=\"女\">女</md-radio-button></md-radio-group></md-input-container>\n<md-input-container class=\"md-block\" flex=\"30\"><label translate=\"生日\">生日</label><md-datepicker flex \nng-model=\"vm.customer.birthday\" ng-model-options=\"{timezone:\'utc\'}\" md-placeholder=\"生日\">{{vm.customer.birthday}}\n</md-datepicker></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"课程顾问\">课程顾问\n</label><md-select ng-model=\"vm.customer.consult_id\"><md-option ng-repeat=\"user in vm.users\" value=\"{{user.id}}\">\n{{user.name}}</md-option></md-select></md-input-container></div><div layout-xs=\"column\" layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"30\"><label translate=\"skype\">skype</label><input name=\"skype\" \nng-model=\"vm.customer.skype\"></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"邮箱\">\n邮箱</label><input name=\"email\" type=\"email\" ng-model=\"vm.customer.email\" required email></md-input-container>\n<md-input-container class=\"md-block\" flex=\"40\"><label translate=\"年级\">年级</label><textarea ng-model=\"vm.customer.class\" \nmd-maxlength=\"150\" max-rows=\"5\" style=\"height: 30px;min-height: 30px\"></textarea></md-input-container></div><div \nlayout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"100\"><label translate=\"七牛上的视频url\">视频url\n</label><textarea ng-model=\"vm.customer.video_url\" md-maxlength=\"150\" max-rows=\"5\" \nstyle=\"height: 30px;min-height: 30px\"></textarea></md-input-container></div><div layout-xs=\"column\" layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"75\"><label translate=\"备注\">备注</label><textarea \nng-model=\"vm.customer.remarks\" md-maxlength=\"150\" max-rows=\"5\" style=\"height: 30px;min-height: 30px\"></textarea>\n</md-input-container><div layout-xs=\"column\" layout=\"column\" flex=\"100\" flex-gt-xs=\"20\" layout-align=\"center center\" \nng-file-select=\"vm.onFileSelect($files)\" data-multiple=\"false\" title=\"选择图片文件\" onclick=\"this.value = null\"><img \nng-file-select=\"vm.onFileSelect($files)\" data-multiple=\"false\" title=\"选择图片文件\" onclick=\"this.value = null\" \nclass=\"md-avatar avatar contact-avatar huge\" ng-if=\"vm.customer.avatar\" \nng-src=\"{{vm.customer.avatar}}?imageView/2/w/64/h/64\"><label translate=\"上传头像\">上传头像</label></div></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-if=\"!vm.newCustomer\" ng-click=\"vm.saveCustomer()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"SAVE\" \ntranslate=\"保存\" translate-attr-aria-label=\"保存\"></md-button><md-button type=\"submit\" ng-if=\"vm.newCustomer\" \nng-click=\"vm.addNewCustomer()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"Add Task\" translate=\"添加\" \ntranslate-attr-aria-label=\"添加\">添加</md-button></div><div layout=\"row\"><md-button ng-if=\"vm.is_cud\" \nclass=\"md-icon-button\" ng-click=\"vm.deleteCustomer($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"删除\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"删除\">删除</span>\n</md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/customers/dialogs/gudin/gudin-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width: 1200px;max-width: 1200px\"><form name=\"taskForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-input-container md-no-float class=\"m-0\">\n<md-select ng-model=\"vm.week\" ng-change=\"vm.doSearch()\"><md-option value=\"{{week.id}}\" ng-repeat=\"week in vm.weeks\">\n第{{week.id}}周{{week.sdate}}~{{week.edate}}</md-option></md-select></md-input-container><md-button \nclass=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\">\n</md-icon></md-button></div></md-toolbar><md-dialog-content ms-scroll><div layout-xs=\"column\" layout=\"row\" \nstyle=\"padding-bottom:20px\"><div flex=\"100\" layout=\"column\"><div><md-table-container><table md-table \nclass=\"md-data-table\"><thead md-head><tr md-row><th md-column md-order-by=\"name\" decend-first \nstyle=\"padding-left: 15px!important\"><span class=\"column-title\">固定编号</span></th><th md-column \nmd-order-by=\"course_size\"><span class=\"column-title\">描述</span></th></tr></thead><tbody md-body><tr \nng-repeat=\"course in vm.courses\"><td md-cell style=\"padding-left: 15px!important\"><md-checkbox \nng-if=\"course.signup_count<(course.course_size+course.beixuan_num)\" ng-model=\"vm.gudins[$index].number_checkbox\" \nng-checked=\"vm.exists(course, vm.selected)\" ng-click=\"vm.toggle(course, vm.selected, $index)\" \nstyle=\"margin: 10px 0 10px\"></md-checkbox><span style=\"color: #333333\" \nng-class=\"{\'text-strike md-secondary-text\':checkItem.checked}\">{{course.number}}</span></td><td md-cell>\n{{course.content}}</td></tr></tbody></table></md-table-container></div></div></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" ng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"保存\" translate=\"保存\" translate-attr-aria-label=\"保存\">\nSAVE</md-button></div><div layout=\"row\"><md-button type=\"submit\" ng-click=\"vm.closeDialog()\" \nclass=\"send-button md-accent md-raised\" aria-label=\"取消\" translate=\"取消\" translate-attr-aria-label=\"取消\">SAVE</md-button>\n</div></md-dialog-actions></form></md-dialog><style>\n.md-data-table td{\n        padding: 10px 0px 10px 10px!important;\n    }\n    .md-data-table th{\n        padding: 10px 0px 10px 10px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/customers/dialogs/parent/parent-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label translate=\"手机号\">手机号</label><input \nname=\"mobile\" ng-model=\"vm.parent.mobile\" ng-blur=\"vm.checkParent(vm.parent.mobile)\" required md-autofocus><div \nng-messages=\"taskForm.mobile.$error\" ng-show=\"taskForm.mobile.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\n手机号必填</span></div></div></md-input-container><md-input-container class=\"md-block\"><label translate=\"登录账号\">登录账号</label>\n<input name=\"username\" ng-model=\"vm.parent.username\" required ng-disabled=\"vm.is_parent\"><div \nng-messages=\"taskForm.username.$error\" ng-show=\"taskForm.username.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>登录账号必填</span></div></div></md-input-container><md-input-container class=\"md-block\"><label translate=\"姓名\">姓名\n</label><input name=\"name\" ng-model=\"vm.parent.name\" required ng-disabled=\"vm.is_parent\"><div \nng-messages=\"taskForm.name.$error\" ng-show=\"taskForm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>姓名必填\n</span></div></div></md-input-container><md-input-container class=\"md-block\"><label translate=\"邮箱\">邮箱</label><input \nname=\"email\" ng-model=\"vm.parent.email\" ng-disabled=\"vm.is_parent\"><div ng-messages=\"taskForm.email.$error\" \nng-show=\"taskForm.email.$touched\" role=\"alert\"><div ng-message=\"required\"><span>邮箱必填</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><label translate=\"关系\">关系</label><md-select \nng-model=\"vm.parent.relation\" ng-disabled=\"vm.is_parent\"><md-option value=\"爸爸\">爸爸</md-option><md-option value=\"妈妈\">妈妈\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\"><label translate=\"微信号\">微信号</label>\n<input name=\"wechat\" ng-model=\"vm.parent.wechat\" ng-disabled=\"vm.is_parent\"><div ng-messages=\"taskForm.wechat.$error\" \nng-show=\"taskForm.wechat.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TODO.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"QQ号\">QQ号</label><input name=\"qq\" ng-model=\"vm.parent.qq\" \nng-disabled=\"vm.is_parent\"><div ng-messages=\"taskForm.qq.$error\" ng-show=\"taskForm.qq.$touched\" role=\"alert\"><div \nng-message=\"required\"><span translate=\"TODO.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-if=\"vm.newParent\" ng-click=\"vm.addNewParent()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"Add Task\" \ntranslate=\"添加\" translate-attr-aria-label=\"添加\">添加</md-button><md-button type=\"submit\" ng-if=\"!vm.newParent\" \nng-click=\"vm.saveParent()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"编辑\" translate=\"编辑\" translate-attr-aria-label=\"编辑\">添加\n</md-button><md-button type=\"submit\" ng-if=\"vm.is_parent\" ng-click=\"vm.bindingParent(vm.parent)\" \nclass=\"send-button md-accent md-raised\" aria-label=\"绑定\" translate=\"绑定\" translate-attr-aria-label=\"绑定\">绑定</md-button>\n</div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/customers/dialogs/resetpwd/resetpwd-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\"><label translate=\"新密码\">新密码</label>\n<input name=\"password\" ng-model=\"vm.data.pwd\" required md-autofocus type=\"password\"><div \nng-messages=\"taskForm.pwd.$error\" ng-show=\"taskForm.pwd.$touched\" role=\"alert\"><div ng-message=\"required\"><span>新密码必填\n</span></div></div></md-input-container></div><div layout-xs=\"column\" layout=\"row\"><md-input-container \nclass=\"md-block\"><label translate=\"确认密码\">确认密码</label><input name=\"conf_password\" ng-model=\"vm.data.confpwd\" required \ntype=\"password\"><div ng-messages=\"taskForm.confpwd.$error\" ng-show=\"taskForm.confpwd.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>确认密码必填</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-click=\"vm.saveParent()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\">保存</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/customers/dialogs/zcard/zcard-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\" style=\"width: 1200px;max-width: 1200px\"><form name=\"taskForm\" \nclass=\"md-inline-form\" novalidate><md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\"><md-icon md-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div>\n</md-toolbar><div class=\"content white-bg\"><md-table-container><table md-table class=\"md-data-table\"><thead md-head \nmd-order=\"vm.query.sort\" md-on-reorder=\"vm.doSearch\"><tr md-row><th md-column md-order-by=\"contact_guid\" decend-first \nstyle=\"padding-left: 15px!important\"><span class=\"column-title\">合同号<br>请假总余</span></th><th md-column \nmd-order-by=\"customer_id\" decend-first><span class=\"column-title\">会员号<br>学生姓名</span></th><th md-column \nmd-order-by=\"customer.birthday\" decend-first><span class=\"column-title\">学生生日<br>月龄/性别</span></th><th md-column \nmd-order-by=\"contract_type\" decend-first><span class=\"column-title\">卡类型<br>卡项</span></th><th md-column><span \nclass=\"column-title\">课程总余</span></th><th md-column md-order-by=\"pay_type\" decend-first><span class=\"column-title\">支付类型\n<br>支付金额</span></th><th md-column md-order-by=\"sign_date\" decend-first><span class=\"column-title\">签订日期<br>销售顾问</span>\n</th><th md-column md-order-by=\"end_date\" decend-first><span class=\"column-title\">合同有效期</span></th><th md-column \nmd-order-by=\"status\" decend-first><span class=\"column-title\">状态</span><br><span class=\"column-title\">更新时间</span></th>\n</tr></thead><tbody><tr ng-repeat=\"contract in vm.contracts.data\" \nui-sref=\"app.store.contracts.detail({id:contract.id})\"><td md-cell \nui-sref=\"app.store.contracts.detail({id:contract.id})\" style=\"padding-left: 15px!important\">{{ contract.contact_guid }}\n<br><b style=\"color: #ff0000\">{{ contract.can_leave_times }}</b>/<b style=\"color: #1e8f03\">\n{{ contract.can_leave_times - contract.can_leave_times1 }}</b></td><td md-cell><a \nng-click=\"vm.openCustomer($event, contract.customer_id)\">{{contract.customer.member_id}}<br>\n{{ contract.customer_name }} <span ng-if=\"contract.customer_nickname\">({{contract.customer_nickname}})</span></a></td>\n<td md-cell>{{ contract.customer.birthday }}<br>{{ contract.customer_birthday }}/{{ contract.customer_sex }}</td><td \nmd-cell>{{ contract.card_type }}<br>{{ contract.contract_type }}</td><td md-cell><span \nng-repeat=\"item in contract.ContractsHasCourses\">{{item.categories_name}}: <b style=\"color: #ff0000\">\n{{item.course_number}}</b>/<b style=\"color: #1e8f03\">{{item.course_number_remaining}}</b><br></span></td><td md-cell>\n{{ contract.pay_type }}<br>{{ contract.amount }}</td><td md-cell>{{ contract.sign_date | date:\'yyyy-MM-dd\' }}<br>\n{{ contract.consult_name }}</td><td md-cell>{{ contract.start_date | date:\'yyyy-MM-dd\' }}~<br>\n{{ contract.end_date | date:\'yyyy-MM-dd\' }}</td><td md-cell>{{ contract.status_name }}<br>{{ contract.update_time }}\n</td></tr></tbody></table></md-table-container></div><md-dialog-content ms-scroll><div layout-xs=\"column\" layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"30\"><label translate=\"转向门店\">转向门店</label><md-select \nng-model=\"vm.to_store_id\" required><md-option value=\"{{store.id}}\" ng-repeat=\"store in vm.stores\">{{store.name}}\n</md-option></md-select></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label>收款方</label><input \nname=\"can_leave_times\" ng-model=\"vm.pay.income_fang\" required><div ng-messages=\"taskForm.income_fang.$error\" \nng-show=\"taskForm.income_fang.$touched\" role=\"alert\"><div ng-message=\"required\"><span>收款方必填</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"20\"><label translate=\"金额\">金额</label><input \nname=\"amount\" ng-model=\"vm.pay.amount\" required><div ng-messages=\"taskForm.amount.$error\" \nng-show=\"taskForm.amount.$touched\" role=\"alert\"><div ng-message=\"required\"><span>金额必填</span></div></div>\n</md-input-container><md-input-container class=\"md-block\" flex=\"20\"><label translate=\"付款方式\">付款方式</label><md-select \nng-model=\"vm.pay.pay_type\" required><md-option value=\"{{type.name}}\" ng-repeat=\"type in vm.pay_types\">{{type.name}}\n</md-option></md-select></md-input-container></div><div layout-xs=\"column\" layout=\"row\"><div flex \nclass=\"date-container\" flex=\"30\"><label translate=\"付款日期\">付款日期</label><md-datepicker flex md-placeholder=\"收款日期\" \nng-model=\"vm.pay.pay_date\" ng-model-options=\"{timezone:\'utc\'}\">{{pay_date}}</md-datepicker></div><md-input-container \nclass=\"md-block\" flex=\"70\"><label translate=\"备注\">备注</label><textarea ng-model=\"vm.pay.remarks\" md-maxlength=\"150\" \nmax-rows=\"5\" style=\"height: 30px;min-height: 30px\"></textarea></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" ng-click=\"vm.saveZcard()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"保存\" translate=\"保存\" translate-attr-aria-label=\"保存\">\nSAVE</md-button></div><div layout=\"row\"><md-button type=\"submit\" ng-click=\"vm.closeDialog($event)\" \nclass=\"md-icon-button\" aria-label=\"取消\" translate=\"取消\" translate-attr-aria-label=\"取消\">SAVE</md-button></div>\n</md-dialog-actions></form></md-dialog><style>\n.md-data-table td{\n        padding: 10px 0px 10px 0px!important;\n    }\n    .md-data-table th{\n        padding: 10px 0px 10px 0px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/customers/dialogs/wechat/wechat-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><div id=\"simple-table\" class=\"page-layout simple fullwidth\" style=\"position: relative\">\n<md-table-container><table md-table class=\"md-data-table\"><thead md-head md-order=\"vm.query.sort\" \nmd-on-reorder=\"vm.doSearch\"><tr md-row><th md-column decend-first></th><th md-column><span class=\"column-title\">昵称\n</span></th><th md-column decend-first><span class=\"\">性别</span></th><th md-column decend-first><span \nclass=\"column-title\">所在城市</span></th><th md-column decend-first><span class=\"column-title\">是否订阅该公众号</span></th><th>\n</th></tr></thead><tbody><tr ng-repeat=\"item in vm.wechats\"><td md-cell><img class=\"md-avatar avatar contact-avatar\" \nng-if=\"item.headimgurl\" alt=\"{{customer.nickname}}\" ng-src=\"{{ item.headimgurl }}\"></td><td md-cell>{{item.nickname}}\n</td><td md-cell>{{item.sex_text}}</td><td md-cell>{{item.province}}-{{item.city}}</td><td md-cell>\n{{item.subscribe_text}}</td><td md-cell><a ng-if=\"vm.is_cud\" ng-click=\"vm.saveWechat($event, item)\">取消绑定</a></td></tr>\n</tbody></table></md-table-container></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/store/signups/dialogs/logs/logs-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><div id=\"simple-table\" class=\"page-layout simple fullwidth\" style=\"position: relative\">\n<md-table-container><table md-table class=\"md-data-table\"><thead md-head><tr md-row><th md-column decend-first><span \nclass=\"column-title\">操作时间</span></th><th md-column><span class=\"\">操作内容</span></th><th md-column>操作人</th></tr></thead>\n<tbody><tr ng-repeat=\"item in vm.logs\" ng-if=\"item\"><td md-cell style=\"padding-left: 15px!important\">\n{{ item.created_at }}</td><td md-cell>{{item.remark}}</td><td md-cell>{{item.user_name}}<span ng-if=\"item.type==3\">(家长)\n</span></td></tr><tr ng-if=\"vm.logs.length==0\"><td>暂无记录</td><td></td><td></td></tr></tbody></table>\n</md-table-container></div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/store/plan/dialogs/task/task-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label\n translate=\"名称\">教学任务</label><input name=\"title\" ng-model=\"vm.task.title\" required md-autofocus><div \nng-messages=\"taskForm.name.$error\" ng-show=\"taskForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\n教学任务必填</span></div></div></md-input-container></div><div layout-xs=\"column\" layout=\"row\"><md-input-container \nclass=\"md-block\" flex=\"100\"><label translate=\"任务描述\">任务描述</label><textarea ng-model=\"vm.task.desc\" md-maxlength=\"150\" \nmax-rows=\"5\" style=\"height: 30px;min-height: 30px\"></textarea></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" ng-if=\"!vm.newTask\" ng-click=\"vm.saveTask()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid\">保存</md-button><md-button type=\"submit\" ng-if=\"vm.newTask\" ng-click=\"vm.addNewTask()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid || taskForm.$pristine\">添加</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/plan/dialogs/plan/plan-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"100\">\n<label translate=\"教学计划\">教学计划</label><input name=\"title\" ng-model=\"vm.plan.title\" required md-autofocus><div \nng-messages=\"taskForm.name.$error\" ng-show=\"taskForm.title.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\n教学计划必填</span></div></div></md-input-container></div><div layout-xs=\"column\" layout=\"row\"><md-input-container \nclass=\"md-block\" flex=\"100\"><label translate=\"计划编号\">计划编号</label><input name=\"num\" ng-model=\"vm.plan.number\" required>\n<div ng-messages=\"taskForm.number.$error\" ng-show=\"taskForm.number.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span translate=\"TODO.ERRORS.TITLE_REQUIRED\">计划编号必填</span></div></div></md-input-container></div><div \nlayout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"100\"><label translate=\"课数\">课数</label><input \nname=\"num\" ng-model=\"vm.plan.num\" required><div ng-messages=\"taskForm.num.$error\" ng-show=\"taskForm.num.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span translate=\"TODO.ERRORS.TITLE_REQUIRED\">num field is required</span></div>\n</div></md-input-container></div><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"100\">\n<label translate=\"计划描述\">计划描述</label><textarea ng-model=\"vm.plan.desc\" md-maxlength=\"150\" max-rows=\"5\" \nstyle=\"height: 30px;min-height: 30px\"></textarea></md-input-container></div><div layout-xs=\"column\" layout=\"row\"><div \nlayout-xs=\"column\" layout=\"column\" flex=\"100\" flex-gt-xs=\"20\" layout-align=\"center center\" \nng-file-select=\"vm.onFileSelect($files)\" data-multiple=\"false\" title=\"选择图片文件\" onclick=\"this.value = null\"><img \nng-file-select=\"vm.onFileSelect($files)\" data-multiple=\"false\" title=\"选择文件\" onclick=\"this.value = null\" \nclass=\"md-avatar avatar contact-avatar huge\" ng-if=\"vm.plan.cover\" ng-src=\"{{vm.plan.cover}}?imageView/2/w/64/h/64\">\n<label translate=\"上传头像\">上传封面</label></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-if=\"!vm.newPlan\" ng-click=\"vm.savePlan()\" class=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid\">保存\n</md-button><md-button type=\"submit\" ng-if=\"vm.newPlan\" ng-click=\"vm.addNewPlan()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid || taskForm.$pristine\">添加</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/plan/dialogs/plan/plan-import-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><div layout-xs=\"column\" layout=\"row\"><div layout-xs=\"column\" layout=\"column\" flex=\"100\" \nflex-gt-xs=\"20\" layout-align=\"center center\"><md-input-container style=\"left:45%\"><div \nng-file-select=\"vm.onFileSelect($files)\" data-multiple=\"false\" onclick=\"this.value = null\" class=\"btn btn-upload\" \nstyle=\"text-align: center\"><md-button class=\"md-accent md-raised\" style=\"margin: auto; text-align: center\">上传导入文件\n</md-button></div></md-input-container></div></div><div ng-if=\"vm.messageCode\" class=\"{{vm.messageCode}}\">\n{{vm.message}}</div></md-dialog-content></form></md-dialog>");
$templateCache.put("app/main/apps/store/reports/dialogs/income/income-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label\n translate=\"消费项目\">消费项目</label><input name=\"contact_guid\" ng-model=\"vm.income.sale_project\" required md-autofocus><div \nng-messages=\"taskForm.sale_project.$error\" ng-show=\"taskForm.sale_project.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>消费项目必填</span></div></div></md-input-container><md-input-container class=\"md-block\" \nflex=\"30\"><label>消费方</label><input name=\"can_leave_times\" ng-model=\"vm.income.sale_fang\" required><div \nng-messages=\"taskForm.sale_fang.$error\" ng-show=\"taskForm.sale_fang.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>消费方必填</span></div></div></md-input-container></div><div layout-xs=\"column\" layout=\"row\"><md-input-container \nclass=\"md-block\" flex=\"30\"><label translate=\"金额\">金额</label><input name=\"amount\" ng-model=\"vm.income.amount\" required>\n<div ng-messages=\"taskForm.amount.$error\" ng-show=\"taskForm.amount.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>金额必填</span></div></div></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label \ntranslate=\"收款方式\">收款方式</label><md-select ng-model=\"vm.income.income_type\" required><md-option value=\"{{type.name}}\" \nng-repeat=\"type in vm.pay_types\">{{type.name}}</md-option></md-select></md-input-container></div><div \nlayout-xs=\"column\" layout=\"row\"><div flex class=\"date-container\" flex=\"30\"><label translate=\"收款日期\">收款日期</label>\n<md-datepicker flex md-placeholder=\"收款日期\" ng-model=\"vm.income.income_date\" ng-model-options=\"{timezone:\'utc\'}\">\n{{vm.income.income_date}}</md-datepicker></div></div><div layout-xs=\"column\" layout=\"row\"><md-input-container \nclass=\"md-block\" flex=\"100\"><label translate=\"备注\">备注</label><textarea ng-model=\"vm.income.remarks\" md-maxlength=\"150\" \nmax-rows=\"5\" style=\"height: 30px;min-height: 30px\"></textarea></md-input-container></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" ng-if=\"!vm.newIncome\" ng-click=\"vm.saveIncome()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"保存\" translate=\"保存\" translate-attr-aria-label=\"保存\">\nSAVE</md-button><md-button type=\"submit\" ng-if=\"vm.newIncome\" ng-click=\"vm.addNewIncome()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"添加\" \ntranslate=\"添加\" translate-attr-aria-label=\"添加\">ADD TASK</md-button></div><div layout=\"row\"><md-button ng-if=\"vm.is_cud\" \nclass=\"md-icon-button\" ng-click=\"vm.deleteIncome($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"TODO.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span>删除</span>\n</md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/reports/dialogs/pay/pay-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"30\">\n<label>收款方</label><input name=\"can_leave_times\" ng-model=\"vm.pay.income_fang\" required><div \nng-messages=\"taskForm.income_fang.$error\" ng-show=\"taskForm.income_fang.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>收款方必填</span></div></div></md-input-container><div flex class=\"date-container\" flex=\"30\">\n<label translate=\"付款日期\">付款日期</label><md-datepicker flex md-placeholder=\"收款日期\" ng-model=\"vm.pay.pay_date\" \nng-model-options=\"{timezone:\'utc\'}\">{{pay_date}}</md-datepicker></div></div><div layout-xs=\"column\" layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"30\"><label translate=\"金额\">金额</label><input name=\"amount\" \nng-model=\"vm.pay.amount\" required><div ng-messages=\"taskForm.amount.$error\" ng-show=\"taskForm.amount.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>金额必填</span></div></div></md-input-container><md-input-container \nclass=\"md-block\" flex=\"30\"><label translate=\"付款方式\">付款方式</label><md-select ng-model=\"vm.pay.pay_type\" required>\n<md-option value=\"{{type.name}}\" ng-repeat=\"type in vm.pay_types\">{{type.name}}</md-option></md-select>\n</md-input-container></div><div layout-xs=\"column\" layout=\"column\" flex=\"30\" flex-gt-xs=\"30\" \nlayout-align=\"center center\" ng-file-select=\"vm.onFileSelect($files)\" data-multiple=\"false\" title=\"选择图片文件\" \nonclick=\"this.value = null\"><label translate=\"选择图片\">选择图片</label></div><div layout-xs=\"column\" layout=\"row\">\n<md-input-container class=\"md-block\" flex=\"100\"><label translate=\"备注\">备注</label><textarea ng-model=\"vm.pay.remarks\" \nmd-maxlength=\"150\" max-rows=\"5\" style=\"height: 30px;min-height: 30px\"></textarea></md-input-container></div>\n</md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-if=\"!vm.newPay\" ng-click=\"vm.savePay()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"保存\" \ntranslate=\"保存\" translate-attr-aria-label=\"保存\">SAVE</md-button><md-button type=\"submit\" ng-if=\"vm.newPay\" \nng-click=\"vm.addNewPay()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\" aria-label=\"添加\" translate=\"添加\" translate-attr-aria-label=\"添加\">\nADD TASK</md-button></div><div layout=\"row\"><md-button ng-if=\"vm.is_cud\" class=\"md-icon-button\" \nng-click=\"vm.deletePay($event)\" aria-label=\"Delete\" translate translate-attr-aria-label=\"TODO.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span>删除</span></md-tooltip></md-button></div></md-dialog-actions>\n</form></md-dialog>");
$templateCache.put("app/main/apps/store/teachers/dialogs/teacher/teacher-dialog.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><form name=\"contactForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-tall\" layout=\"column\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" layout=\"row\" \nlayout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" \nng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" translate translate-attr-aria-label=\"CONTACTS.CLOSE_DIALOG\">\n<md-icon md-font-icon=\"icon-close\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-middle\" \nflex layout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{vm.teacher.avatar}}\" class=\"md-avatar avatar contact-avatar huge\" alt=\"{{vm.teacher.name}}\"><div \nclass=\"contact-name\">{{vm.teacher.username}}</div></div></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><md-input-container class=\"md-icon-float md-block\" ng-if=\"vm.newTeacher\"><label \ntranslate=\"登录账号\">登录账号 (required)</label><md-icon md-font-icon=\"icon-account\" class=\"name\"></md-icon><input \nname=\"username\" ng-model=\"vm.teacher.username\" type=\"text\" ng-required md-autofocus><div \nng-messages=\"contactForm.username.$error\" ng-show=\"contactForm.username.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>登录账号必填</span></div></div></md-input-container><md-input-container \nclass=\"md-icon-float md-block\"><label translate=\"姓名\">姓名 (required)</label><md-icon md-font-icon=\"icon-account\" \nclass=\"name\"></md-icon><input name=\"name\" ng-model=\"vm.teacher.name\" type=\"text\" ng-required md-autofocus><div \nng-messages=\"contactForm.name.$error\" ng-show=\"contactForm.name.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>用户名必填</span></div></div></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-phone\"></md-icon><input name=\"mobile\" ng-model=\"vm.teacher.mobile\" type=\"text\" placeholder=\"手机号\" \ntranslate translate-attr-placeholder=\"手机号\"><div ng-messages=\"contactForm.mobile.$error\" \nng-show=\"contactForm.mobile.$touched\" role=\"alert\"><div ng-message=\"required\"><span>用户名必填</span></div></div>\n</md-input-container><md-input-container class=\"md-block\"><md-icon md-font-icon=\"icon-email\" class=\"email\"></md-icon>\n<input name=\"email\" ng-model=\"vm.teacher.email\" type=\"email\" placeholder=\"邮箱\" translate \ntranslate-attr-placeholder=\"邮箱\"></md-input-container><md-input-container class=\"md-block\"><md-icon \nmd-font-icon=\"icon-skype\" class=\"skype\"></md-icon><input name=\"skype\" ng-model=\"vm.teacher.skype\" type=\"skype\" \nplaceholder=\"skype\" translate translate-attr-placeholder=\"skype\"></md-input-container><md-input-container \nclass=\"md-block\"><label translate=\"岗位类型\">岗位类型</label><md-select ng-model=\"vm.teacher.type\" required><md-option \nng-repeat=\"item in vm.types\" value=\"{{item.name}}\">{{item.name}}</md-option></md-select></md-input-container>\n<md-input-container class=\"md-block\"><label translate=\"时区\">时区</label><md-select ng-model=\"vm.teacher.timezone\" \nrequired><md-option ng-repeat=\"item in vm.timezone\" ng-value=\"item\">{{item}}</md-option></md-select>\n</md-input-container><md-input-container \nclass=\"md-icon-float md-block md-icon-left md-default-theme md-input-has-value\"><label translate=\"性别\">性别</label>\n<md-icon></md-icon><md-radio-group ng-model=\"vm.teacher.sex\"><md-radio-button ng-value=\"1\" aria-label=\"男\">男\n</md-radio-button><md-radio-button ng-value=\"0\" aria-label=\"女\">女</md-radio-button></md-radio-group>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-if=\"!vm.newTeacher\" ng-click=\"vm.saveTeacher()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"SAVE\" \ntranslate=\"更新\" translate-attr-aria-label=\"更新\">更新</md-button><md-button type=\"submit\" ng-if=\"vm.newTeacher\" \nng-click=\"vm.addNewTeacher()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"Add Task\" translate=\"添加\" \ntranslate-attr-aria-label=\"添加\">添加</md-button></div><div layout=\"row\"><md-button class=\"md-icon-button\" \nng-click=\"vm.deleteTeacher($event)\" aria-label=\"删除\" translate translate-attr-aria-label=\"CONTACTS.DELETE\"><md-icon \nmd-font-icon=\"icon-delete\"></md-icon><md-tooltip><span translate=\"CONTACTS.DELETE\">DELETE</span></md-tooltip>\n</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/teachers/dialogs/teacher/teacher-resetpwd.html","<md-dialog class=\"contact-dialog\" aria-label=\"New Task\"><div class=\"md-toolbar-tools md-toolbar-tools-top\" \nlayout=\"row\" layout-align=\"space-between center\"><span class=\"title\">{{vm.title}}</span></div><form name=\"contactForm\" \nclass=\"md-inline-form\" novalidate><md-dialog-content ms-scroll><md-input-container class=\"md-icon-float md-block\">\n<label translate=\"新密码\">新密码</label><input name=\"pwd\" ng-model=\"vm.data.pwd\" type=\"password\" ng-required md-autofocus>\n<div ng-messages=\"contactForm.pwd.$error\" ng-show=\"contactForm.pwd.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>新密码必填</span></div></div></md-input-container><md-input-container class=\"md-icon-float md-block\"><label \ntranslate=\"确认密码\">确认密码 (required)</label><input name=\"name\" ng-model=\"vm.data.confpwd\" type=\"password\" ng-required \nmd-autofocus><div ng-messages=\"contactForm.confpwd.$error\" ng-show=\"contactForm.confpwd.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>确认密码必填</span></div></div></md-input-container></md-dialog-content><md-dialog-actions \nlayout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button \ntype=\"submit\" ng-click=\"vm.saveResetPwd()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"contactForm.$invalid || contactForm.$pristine\" aria-label=\"SAVE\" translate=\"保存\" \ntranslate-attr-aria-label=\"保存\">更新</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/system/dialogs/category/category-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label translate=\"名称\">名称</label><input name=\"name\" \nng-model=\"vm.categorie.name\" required md-autofocus><div ng-messages=\"taskForm.name.$error\" \nng-show=\"taskForm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span translate=\"TODO.ERRORS.TITLE_REQUIRED\">\nTitle field is required</span></div></div></md-input-container><md-input-container class=\"md-block\" \nng-if=\"vm.categorie.type==2\"><label translate=\"规则\">规则</label><input name=\"name\" ng-model=\"vm.categorie.rule\" required \nmd-autofocus placeholder=\"例如0-8\"><div ng-messages=\"taskForm.rule.$error\" ng-show=\"taskForm.rule.$touched\" role=\"alert\">\n<div ng-message=\"required\"><span translate=\"TODO.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div>\n</md-input-container></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div \nlayout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-if=\"!vm.newCategorie\" \nng-click=\"vm.saveCategorie()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\">保存</md-button><md-button type=\"submit\" ng-if=\"vm.newCategorie\" \nng-click=\"vm.addNewCategorie()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\">添加</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteCategorie($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"TODO.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"TODO.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/system/dialogs/ctime/ctime-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"20\"><label\n translate=\"开始小时\">开始小时</label><md-select ng-model=\"vm.startTime.hour\"><md-option value=\"{{hour}}\" \nng-repeat=\"hour in vm.hours\">{{hour}}</md-option></md-select></md-input-container>:<md-input-container \nclass=\"md-block\" flex=\"20\"><label translate=\"开始分钟\">开始分钟</label><md-select ng-model=\"vm.startTime.minute\"><md-option \nvalue=\"{{minute}}\" ng-repeat=\"minute in vm.minutes\">{{minute}}</md-option></md-select></md-input-container>~\n<md-input-container class=\"md-block\" flex=\"20\"><label translate=\"结束小时\">结束小时</label><md-select \nng-model=\"vm.endTime.hour\"><md-option value=\"{{hour}}\" ng-repeat=\"hour in vm.hours\">{{hour}}</md-option></md-select>\n</md-input-container>:<md-input-container class=\"md-block\" flex=\"20\"><label translate=\"结束分钟\">结束分钟</label><md-select \nng-model=\"vm.endTime.minute\"><md-option value=\"{{minute}}\" ng-repeat=\"minute in vm.minutes\">{{minute}}</md-option>\n</md-select></md-input-container></div><div layout-xs=\"column\" layout=\"row\"></div></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" ng-if=\"!vm.newCtime\" ng-click=\"vm.saveCtime()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid\">保存</md-button><md-button type=\"submit\" ng-if=\"vm.newCtime\" ng-click=\"vm.addNewCtime()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid || taskForm.$pristine\">添加</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/system/dialogs/event-detail/event-detail-dialog.html","<md-dialog class=\"event-detail-dialog\" aria-label=\"New Message\"><md-toolbar class=\"md-accent md-hue-2\"><div \nclass=\"md-toolbar-tools\"><span class=\"title\">店内人员：{{vm.calendarEvent.data.total}}人</span> <span flex></span></div>\n</md-toolbar><md-dialog-content ms-scroll><div class=\"event-details\" layout=\"column\"><div class=\"event-detail-row\" \nlayout=\"row\" layout-align=\"start start\" style=\"margin-bottom:10px\"><md-icon md-font-icon=\"icon-clock\"></md-icon><div \nlayout=\"column\" flex><span class=\"h4\">{{vm.calendarEvent.date}}</span><div flex=\"10\">后勤人数{{vm.calendarEvent.number}}人\n</div></div></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:0px\">\n<md-icon md-font-icon=\"icon-account\"></md-icon><h3>值班老师</h3></div><div class=\"event-detail-row\" layout=\"row\" \nlayout-align=\"start center\" style=\"margin-bottom:10px\"><div layout=\"row\" flex><div flex=\"10\" \nng-repeat=\"teacher in vm.calendarEvent.data.teachers\">{{teacher}}</div></div></div><div class=\"event-detail-row\" \nlayout=\"row\" layout-align=\"start center\" style=\"margin-bottom:0px\"><md-icon md-font-icon=\"icon-account\"></md-icon><h3>\n值班销售</h3></div><div class=\"event-detail-row\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:10px\"><div \nlayout=\"row\" flex><div flex=\"10\" ng-repeat=\"xiaoshou in vm.calendarEvent.data.xiaoshous\">{{xiaoshou}}</div></div></div>\n<div class=\"event-detail-row\" layout=\"row\" layout-align=\"start center\" style=\"margin-bottom:0px\"><md-icon \nmd-font-icon=\"icon-account\"></md-icon><h3>值班前台</h3></div><div class=\"event-detail-row\" layout=\"row\" \nlayout-align=\"start center\" style=\"margin-bottom:10px\"><div layout=\"row\" flex><div flex=\"10\" \nng-repeat=\"qiantai in vm.calendarEvent.data.qiantais\">{{qiantai}}</div></div></div><div class=\"event-detail-row\" \nlayout=\"row\" layout-align=\"start center\" style=\"margin-bottom:0px\"><h4>备注：{{vm.calendarEvent.remarks}}</h4></div></div>\n</md-dialog-content></md-dialog>");
$templateCache.put("app/main/apps/store/system/dialogs/event-form/event-form-dialog.html","<md-dialog class=\"event-form-dialog\" aria-label=\"New Message\"><form name=\"eventForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">值班表</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\" aria-label=\"Close dialog\" \ntranslate translate-attr-aria-label=\"CALENDAR.CLOSE_DIALOG\"><md-icon md-font-icon=\"icon-close\"></md-icon></md-button>\n</div></md-toolbar><md-dialog-content ms-scroll><div layout-xs=\"column\" layout=\"row\" style=\"padding-bottom:20px\"><div \nflex=\"100\" layout=\"column\"><div><fieldset class=\"standard\"><legend>值班老师</legend><div layout=\"row\" layout-wrap=\"\" \nflex=\"\"><div flex=\"25\" ng-repeat=\"item in vm.teachers\"><md-checkbox \nng-model=\"vm.onduty.teachers[item.id].teacher_checkbox\" style=\"margin: 10px 0 10px\"><span style=\"color: #333333\" \nng-class=\"{\'text-strike md-secondary-text\':checkItem.checked}\">{{item.name}}</span></md-checkbox><br></div></div>\n</fieldset></div></div></div><div layout-xs=\"column\" layout=\"row\" style=\"padding-bottom:20px\"><div flex=\"100\" \nlayout=\"column\"><div><fieldset class=\"standard\"><legend>值班销售</legend><div layout=\"row\" layout-wrap=\"\" flex=\"\"><div \nflex=\"25\" ng-repeat=\"item in vm.xiaoshous\"><md-checkbox ng-model=\"vm.onduty.xiaoshous[item.id].xiaoshou_checkbox\" \nstyle=\"margin: 10px 0 10px\"><span style=\"color: #333333\" \nng-class=\"{\'text-strike md-secondary-text\':checkItem.checked}\">{{item.name}}</span></md-checkbox><br></div></div>\n</fieldset></div></div></div><div layout-xs=\"column\" layout=\"row\" style=\"padding-bottom:20px\"><div flex=\"100\" \nlayout=\"column\"><div><fieldset class=\"standard\"><legend>值班前台</legend><div layout=\"row\" layout-wrap=\"\" flex=\"\"><div \nflex=\"25\" ng-repeat=\"item in vm.qiantais\"><md-checkbox ng-model=\"vm.onduty.qiantais[item.id].qiantai_checkbox\" \nstyle=\"margin: 10px 0 10px\"><span style=\"color: #333333\" \nng-class=\"{\'text-strike md-secondary-text\':checkItem.checked}\">{{item.name}}</span></md-checkbox><br></div></div>\n</fieldset></div></div></div><div layout=\"row\" class=\"date-row\"><md-input-container class=\"no-errors-spacer\" flex \nmd-no-float><input ng-model=\"vm.onduty.number\" placeholder=\"后勤人数\" translate translate-attr-placeholder=\"后勤人数\">\n</md-input-container></div><div layout=\"row\" class=\"date-row hide\"><md-input-container class=\"no-errors-spacer\" flex \nmd-no-float><input ng-model=\"vm.onduty.remarks\" placeholder=\"备注\" translate translate-attr-placeholder=\"备注\">\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\">\n<md-button ng-click=\"vm.saveEvent()\" class=\"save-button md-accent md-raised\" aria-label=\"SAVE\" \nng-disabled=\"eventForm.$invalid || eventForm.$pristine\" translate=\"保存\" translate-attr-aria-label=\"CALENDAR.SAVE\">SAVE\n</md-button><md-button class=\"hide md-icon-button\" ng-click=\"vm.removeEvent()\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"CALENDAR.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"CALENDAR.DELETE\">Delete</span></md-tooltip></md-button></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/system/dialogs/kuadian/kuadian-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><md-dialog-content \nms-scroll><div layout-xs=\"column\" layout=\"row\" style=\"padding-bottom:20px\"><div flex=\"100\" layout=\"column\"><div>\n<md-table-container><table md-table class=\"md-data-table\"><thead md-head><tr md-row><th md-column md-order-by=\"name\" \ndecend-first style=\"padding-left: 15px!important\"><span class=\"column-title\">门店</span></th><th md-column \nmd-order-by=\"course_time\" decend-first><span class=\"column-title\">课程数</span></th><th md-column \nmd-order-by=\"categories_id\" decend-first><span class=\"column-title\">单节价格</span></th><th></th></tr></thead><tbody \nmd-body><tr ng-repeat=\"item in vm.stores\"><td md-cell style=\"padding-left: 15px!important\"><md-checkbox \nng-model=\"vm.kuadians[item.id].store_checkbox\" ng-checked=\"vm.exists(item, vm.selected)\" \nng-click=\"vm.toggle(item, vm.selected)\" style=\"margin: 10px 0 10px\"></md-checkbox><span style=\"color: #333333\" \nng-class=\"{\'text-strike md-secondary-text\':checkItem.checked}\">{{item.name}}</span></td><td md-cell><md-input-container\n class=\"md-block\"><input name=\"name\" ng-model=\"vm.kuadians[item.id].num\" required md-autofocus><div \nng-messages=\"taskForm.num.$error\" ng-show=\"taskForm.rule.$touched\" role=\"alert\"><div ng-message=\"required\"><span \ntranslate=\"TODO.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container></td><td md-cell>\n<md-input-container class=\"md-block\"><input name=\"name\" ng-model=\"vm.kuadians[item.id].price\" required md-autofocus>\n<div ng-messages=\"taskForm.price.$error\" ng-show=\"taskForm.rule.$touched\" role=\"alert\"><div ng-message=\"required\"><span\n translate=\"TODO.ERRORS.TITLE_REQUIRED\">Title field is required</span></div></div></md-input-container></td></tr>\n</tbody></table></md-table-container></div></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-click=\"vm.save()\" class=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid || taskForm.$pristine\" \naria-label=\"保存\" translate=\"保存\" translate-attr-aria-label=\"保存\">SAVE</md-button></div><div layout=\"row\"><md-button \ntype=\"submit\" ng-click=\"vm.closeDialog()\" class=\"send-button md-accent md-raised\" aria-label=\"取消\" translate=\"取消\" \ntranslate-attr-aria-label=\"取消\">SAVE</md-button></div></md-dialog-actions></form></md-dialog><style>\n.md-data-table td{\n        padding: 10px 0px 10px 10px!important;\n    }\n    .md-data-table th{\n        padding: 10px 0px 10px 10px!important;\n    }\n</style>");
$templateCache.put("app/main/apps/store/system/dialogs/role/role-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><md-input-container class=\"md-block\"><label>名称</label><input name=\"role\" \nng-model=\"vm.role.role\" required md-autofocus><div ng-messages=\"taskForm.role.$error\" ng-show=\"taskForm.role.$touched\" \nrole=\"alert\"><div ng-message=\"required\"><span>名称必填</span></div></div></md-input-container></md-dialog-content>\n<md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\">\n<md-button type=\"submit\" ng-if=\"!vm.newRole\" ng-click=\"vm.saveRole()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\">保存</md-button><md-button type=\"submit\" ng-if=\"vm.newRole\" \nng-click=\"vm.addNewRole()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\">保存</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteRole($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"TODO.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"TODO.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/system/dialogs/room/room-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"100\">\n<label translate=\"房间\">房间</label><input name=\"title\" ng-model=\"vm.room.name\" required md-autofocus><div \nng-messages=\"taskForm.name.$error\" ng-show=\"taskForm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>房间必填\n</span></div></div></md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-if=\"!vm.newRoom\" ng-click=\"vm.saveRoom()\" class=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid\">保存\n</md-button><md-button type=\"submit\" ng-if=\"vm.newRoom\" ng-click=\"vm.addNewRoom()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid || taskForm.$pristine\">添加</md-button></div>\n</md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/users/dialogs/setrole/setrole-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><div layout-xs=\"column\" layout=\"row\" style=\"padding-bottom:20px\"><div flex=\"100\" \nlayout=\"column\"><div><div layout=\"row\" layout-wrap=\"\" flex=\"\"><div flex=\"25\" ng-repeat=\"item in vm.roles\"><md-checkbox \nng-model=\"vm.user.RoleHasUser[vm.store_id][item.id].user_role_checkbox\" ng-checked=\"vm.exists(item, vm.selected)\" \nng-click=\"vm.toggle(item, vm.selected)\" style=\"margin: 10px 0 10px\"><span style=\"color: #333333\" \nng-class=\"{\'text-strike md-secondary-text\':checkItem.checked}\">{{item.role}}</span></md-checkbox></div></div></div>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveUser()\" class=\"send-button md-accent md-raised\">\n保存</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/users/dialogs/resetpwd/resetpwd-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\"><label \ntranslate=\"新密码\">新密码</label><input name=\"password\" ng-model=\"vm.user.password\" required md-autofocus type=\"password\">\n<div ng-messages=\"taskForm.password.$error\" ng-show=\"taskForm.password.$touched\" role=\"alert\"><div \nng-message=\"required\"><span>新密码必填</span></div></div></md-input-container></div><div layout-xs=\"column\" layout=\"row\">\n<md-input-container class=\"md-block\"><label translate=\"确认密码\">确认密码</label><input name=\"conf_password\" \nng-model=\"vm.conf_password\" required type=\"password\"><div ng-messages=\"taskForm.conf_password.$error\" \nng-show=\"taskForm.conf_password.$touched\" role=\"alert\"><div ng-message=\"required\"><span>确认密码必填</span></div></div>\n</md-input-container></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div\n layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveUser()\" \nclass=\"send-button md-accent md-raised\" ng-disabled=\"taskForm.$invalid || taskForm.$pristine\">保存</md-button></div><div \nlayout=\"row\"><md-button class=\"md-icon-button\" ng-click=\"vm.deleteUser($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"TODO.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"TODO.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/users/dialogs/setstore/setstore-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><div layout-xs=\"column\" layout=\"row\" style=\"padding-bottom:20px\"><div flex=\"100\" \nlayout=\"column\"><div><div layout=\"row\" layout-wrap=\"\" flex=\"\"><div flex=\"25\" ng-repeat=\"item in vm.stores\"><md-checkbox\n ng-model=\"vm.user.StoreHasUser[item.id].user_store_checkbox\" ng-checked=\"vm.exists(item, vm.selected)\" \nng-click=\"vm.toggle(item, vm.selected)\" style=\"margin: 10px 0 10px\"><span style=\"color: #333333\" \nng-class=\"{\'text-strike md-secondary-text\':checkItem.checked}\">{{item.name}}</span></md-checkbox></div></div></div>\n</div></div></md-dialog-content><md-dialog-actions layout=\"row\" layout-align=\"space-between center\"><div layout=\"row\" \nlayout-align=\"start center\"><md-button type=\"submit\" ng-click=\"vm.saveUser()\" class=\"send-button md-accent md-raised\">\n保存</md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/apps/store/users/dialogs/user/user-dialog.html","<md-dialog class=\"task-dialog\" aria-label=\"New Task\"><form name=\"taskForm\" class=\"md-inline-form\" novalidate>\n<md-toolbar class=\"md-accent md-hue-2\"><div class=\"md-toolbar-tools\" layout=\"row\" layout-align=\"space-between center\">\n<span class=\"title\">{{vm.title}}</span><md-button class=\"md-icon-button\" ng-click=\"vm.closeDialog()\"><md-icon \nmd-font-icon=\"icon-close\" aria-label=\"Close dialog\"></md-icon></md-button></div></md-toolbar><div \nng-include=\"\'app/main/apps/store/users/_msg.html\'\" ng-model=\"vm.error_arr\" ng-if=\"vm.error_arr\"></div>\n<md-dialog-content ms-scroll><div layout-xs=\"column\" layout=\"row\"><md-input-container flex=\"30\" class=\"md-block\"><label\n translate=\"用户名\">用户名</label><input name=\"username\" ng-model=\"vm.user.username\" required md-autofocus><div \nng-messages=\"taskForm.username.$error\" ng-show=\"taskForm.username.$touched\" role=\"alert\"><div ng-message=\"required\">\n<span>用户名必填</span></div></div></md-input-container><md-input-container flex=\"30\" class=\"md-block\"><label \ntranslate=\"姓名\">姓名</label><input name=\"name\" ng-model=\"vm.user.name\" required><div ng-messages=\"taskForm.name.$error\" \nng-show=\"taskForm.name.$touched\" role=\"alert\"><div ng-message=\"required\"><span>姓名必填</span></div></div>\n</md-input-container><md-input-container flex=\"30\" \nclass=\"md-icon-float md-block md-icon-left md-default-theme md-input-has-value\"><label translate=\"性别\">性别</label>\n<md-icon></md-icon><md-radio-group ng-model=\"vm.user.sex\"><md-radio-button ng-value=\"1\" aria-label=\"男\">男\n</md-radio-button><md-radio-button ng-value=\"0\" aria-label=\"女\">女</md-radio-button></md-radio-group>\n</md-input-container></div><div layout-xs=\"column\" layout=\"row\"><md-input-container class=\"md-block\" flex=\"30\"><label \ntranslate=\"手机号\">手机号</label><input name=\"mobile\" ng-model=\"vm.user.mobile\" required><div \nng-messages=\"taskForm.mobile.$error\" ng-show=\"taskForm.mobile.$touched\" role=\"alert\"><div ng-message=\"required\"><span>\n手机号必填</span></div></div></md-input-container><md-input-container class=\"md-block\" flex=\"30\"><label translate=\"邮箱\">邮箱\n</label><input name=\"email\" ng-model=\"vm.user.email\"></md-input-container><md-input-container class=\"md-block\" \nflex=\"30\"><label translate=\"时区\">时区</label><md-select ng-model=\"vm.user.timezone\"><md-option \nng-repeat=\"item in vm.timezone\" ng-value=\"item\">{{item}}</md-option></md-select></md-input-container><div \nlayout-xs=\"column\" layout=\"column\" flex=\"30\" flex-gt-xs=\"30\" layout-align=\"center center\" \nng-file-select=\"vm.onFileSelect($files)\" data-multiple=\"false\" title=\"选择图片文件\" onclick=\"this.value = null\"><img \nng-file-select=\"vm.onFileSelect($files)\" data-multiple=\"false\" title=\"选择图片文件\" onclick=\"this.value = null\" \nclass=\"md-avatar avatar contact-avatar huge\" ng-if=\"vm.user.avatar\" ng-src=\"{{vm.user.avatar}}?imageView/2/w/64/h/64\">\n<label translate=\"上传头像\">上传头像</label></div></div></md-dialog-content><md-dialog-actions layout=\"row\" \nlayout-align=\"space-between center\"><div layout=\"row\" layout-align=\"start center\"><md-button type=\"submit\" \nng-if=\"!vm.newUser\" ng-click=\"vm.saveUser()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\">保存</md-button><md-button type=\"submit\" ng-if=\"vm.newUser\" \nng-click=\"vm.addNewUser()\" class=\"send-button md-accent md-raised\" \nng-disabled=\"taskForm.$invalid || taskForm.$pristine\">添加</md-button></div><div layout=\"row\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.deleteUser($event)\" aria-label=\"Delete\" translate \ntranslate-attr-aria-label=\"TODO.DELETE\"><md-icon md-font-icon=\"icon-delete\"></md-icon><md-tooltip><span \ntranslate=\"TODO.DELETE\">DELETE</span></md-tooltip></md-button></div></md-dialog-actions></form></md-dialog>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.autocomplete/index.html","<div class=\"doc-content\"><h1><code>material.components.autocomplete</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.bottomSheet/index.html","<div class=\"doc-content\"><h1><code>material.components.bottomSheet</code></h1><p>BottomSheet</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.button/index.html","<div class=\"doc-content\"><h1><code>material.components.button</code></h1><p>Button</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.checkbox/index.html","<div class=\"doc-content\"><h1><code>material.components.checkbox</code></h1><p>Checkbox module!</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.card/index.html","<div class=\"doc-content\"><h1><code>material.components.card</code></h1><p>Card components.</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.chips/index.html","<div class=\"doc-content\"><h1><code>material.components.chips</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.datepicker/index.html","<div class=\"doc-content\"><h1><code>material.components.datepicker</code></h1><p>Module for the datepicker component.\n</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.content/index.html","<div class=\"doc-content\"><h1><code>material.components.content</code></h1><p>Scrollable content</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.colors/index.html","<div class=\"doc-content\"><h1><code>material.components.colors</code></h1><p>Define $mdColors service and a <code>\nmd-colors=&quot;&quot;</code> attribute directive</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.dialog/index.html","<div class=\"doc-content\"><h1><code>material.components.dialog</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.divider/index.html","<div class=\"doc-content\"><h1><code>material.components.divider</code></h1><p>Divider module!</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabActions/index.html","<div class=\"doc-content\"><h1><code>material.components.fabActions</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabSpeedDial/index.html","<div class=\"doc-content\"><h1><code>material.components.fabSpeedDial</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.icon/index.html","<div class=\"doc-content\"><h1><code>material.components.icon</code></h1><p>Icon</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.gridList/index.html","<div class=\"doc-content\"><h1><code>material.components.gridList</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabToolbar/index.html","<div class=\"doc-content\"><h1><code>material.components.fabToolbar</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.input/index.html","<div class=\"doc-content\"><h1><code>material.components.input</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.list/index.html","<div class=\"doc-content\"><h1><code>material.components.list</code></h1><p>List module</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.menu-bar/index.html","<div class=\"doc-content\"><h1><code>material.components.menu-bar</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.menu/index.html","<div class=\"doc-content\"><h1><code>material.components.menu</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.panel/index.html","<div class=\"doc-content\"><h1><code>material.components.panel</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.navBar/index.html","<div class=\"doc-content\"><h1><code>material.components.navBar</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.progressLinear/index.html","<div class=\"doc-content\"><h1><code>material.components.progressLinear</code></h1><p>Linear Progress module!</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.progressCircular/index.html","<div class=\"doc-content\"><h1><code>material.components.progressCircular</code></h1><p>Module for a circular progressbar\n</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.select/index.html","<div class=\"doc-content\"><h1><code>material.components.select</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.radioButton/index.html","<div class=\"doc-content\"><h1><code>material.components.radioButton</code></h1><p>radioButton module!</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.showHide/index.html","<div class=\"doc-content\"><h1><code>material.components.showHide</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sidenav/index.html","<div class=\"doc-content\"><h1><code>material.components.sidenav</code></h1><p>A Sidenav QP component.</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.slider/index.html","<div class=\"doc-content\"><h1><code>material.components.slider</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sticky/index.html","<div class=\"doc-content\"><h1><code>material.components.sticky</code></h1><p>Sticky effects for md</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.subheader/index.html","<div class=\"doc-content\"><h1><code>material.components.subheader</code></h1><p>SubHeader module</p><p>\nSubheaders are special list tiles that delineate distinct sections of a list or grid list and are typically related to the current filtering or sorting criteria. Subheader tiles are either displayed inline with tiles or can be associated with content, for example, in an adjacent column.\n</p><p>\nUpon scrolling, subheaders remain pinned to the top of the screen and remain pinned until pushed on or off screen by the next subheader. @see \n<a href=\"https://www.google.com/design/spec/components/subheaders.html\">Material Design Specifications</a></p>\n<blockquote><p>To improve the visual grouping of content, use the system color for your subheaders.</p></blockquote>\n</div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.swipe/index.html","<div class=\"doc-content\"><h1><code>material.components.swipe</code></h1><p>Swipe module!</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.tabs/index.html","<div class=\"doc-content\"><h1><code>material.components.tabs</code></h1><p>Tabs, created with the <code>&lt;md-tabs&gt;\n</code> directive provide <em>tabbed</em>\n navigation with different styles. The Tabs component consists of clickable tabs that are aligned horizontally side-by-side.\n</p><p>Features include support for:</p><ul><li>static or dynamic tabs,</li><li>responsive designs,</li><li>\naccessibility support (ARIA),</li><li>tab pagination,</li><li>external or internal tab content,</li><li>\nfocus indicators and arrow-key navigations,</li><li>programmatic lookup and access to tab controllers, and</li><li>\ndynamic transitions through different tab contents.</li></ul></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.switch/index.html","<div class=\"doc-content\"><h1><code>material.components.switch</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.toolbar/index.html","<div class=\"doc-content\"><h1><code>material.components.toolbar</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.toast/index.html","<div class=\"doc-content\"><h1><code>material.components.toast</code></h1><p>Toast</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.virtualRepeat/index.html","<div class=\"doc-content\"><h1><code>material.components.virtualRepeat</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.tooltip/index.html","<div class=\"doc-content\"><h1><code>material.components.tooltip</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.whiteframe/index.html","<div class=\"doc-content\"><h1><code>material.components.whiteframe</code></h1></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.aria/index.html","<div class=\"doc-content\"><h1><code>material.core.aria</code></h1><p>Aria Expectations for ngMaterial components.</p>\n</div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.colorUtil/index.html","<div class=\"doc-content\"><h1><code>material.core.colorUtil</code></h1><p>Color Util</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.componentRegistry/index.html","<div class=\"doc-content\"><h1><code>material.core.componentRegistry</code></h1><p>\nA component instance registration service. Note: currently this as a private service in the SideNav component.</p>\n</div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.theming/index.html","<div class=\"doc-content\"><h1><code>material.core.theming</code></h1><p>Theming</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.ripple/index.html","<div class=\"doc-content\"><h1><code>material.core.ripple</code></h1><p>Ripple</p></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.util/index.html","<div class=\"doc-content\"><h1><code>material.core.util</code></h1><p>Util</p></div>");
$templateCache.put("app/main/apps/chat/sidenavs/left/views/contacts/contacts-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleLeftSidenavView(false)\" aria-label=\"back button\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button><h3><span translate=\"CHAT.CONTACTS\">CONTACTS</span></h3></div><div\n class=\"md-toolbar-tools md-toolbar-tools-bottom\"><div class=\"search-wrapper md-whiteframe-1dp\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex ng-model=\"vm.contactSearch\" type=\"text\" \nplaceholder=\"Search contact\" translate=\"\" translate-attr-placeholder=\"CHAT.CONTACTS_SEARCH_PLACEHOLDER\"></div></div>\n</div></md-toolbar><md-content flex ms-scroll><md-list class=\"contact-list\"><md-list-item class=\"contact md-3-line\" \nng-repeat=\"contact in vm.contacts  | filter: {name: vm.contactSearch} | orderBy: \'name\' :false | filter:query as filteredContact\" \nng-style=\"{\'transform\': \'translate3d(0px, \'+$index * 100+\'%, 0px)\', \'z-index\': filteredContact.length - $index}\" \nng-click=\"vm.getChat(contact.id)\"><div class=\"fist-letter md-accent-fg\" \nng-if=\"vm.contacts[$index].name.charAt(0) !== vm.contacts[$index-1].name.charAt(0)\">{{contact.name.charAt(0)}}</div>\n<div class=\"avatar-wrapper\"><img ng-src=\"{{contact.avatar}}\" class=\"md-avatar avatar\" alt=\"{{contact.name}}\"> <i \nclass=\"icon icon- s16 status\" ng-class=\"contact.status\"></i></div><div class=\"md-list-item-text\"><h3>{{contact.name}}\n</h3><p class=\"mood\">{{contact.mood}}</p></div></md-list-item></md-list><div ng-if=\"filteredContact.length <= 0\" \nclass=\"no-results-message\" translate=\"CHAT.NO_RESULTS\">No results..</div></md-content>");
$templateCache.put("app/main/apps/chat/sidenavs/left/views/user/user-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><md-button \nclass=\"md-icon-button\" ng-click=\"vm.toggleLeftSidenavView(false)\" aria-label=\"back\"><md-icon \nmd-font-icon=\"icon-arrow-left\"></md-icon></md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" flex \nlayout=\"column\" layout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{vm.user.avatar}}\" class=\"md-avatar avatar user-avatar huge\" alt=\"{{vm.user.name}}\"><div class=\"user-name\">\n{{vm.user.name}}</div></div></div></md-toolbar><md-content class=\"md-hue-2\" flex ms-scroll ms-padding><md-card>\n<md-card-title>Mood</md-card-title><md-card-content><span class=\"mood\" editable-textarea=\"vm.user.mood\" e-rows=\"7\" \ne-cols=\"40\">{{vm.user.mood || \'CHAT.ENTER_MOOD_MESSAGE\' | translate}}</span></md-card-content></md-card></md-content>");
$templateCache.put("app/main/apps/chat/sidenavs/right/views/contact/contact-view.html","<md-toolbar class=\"md-tall md-accent\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div \ntranslate=\"CHAT.CONTACT_INFO\">Contact Info</div><div flex></div><md-button class=\"md-icon-button\" \nng-click=\"vm.toggleSidenav(\'right-sidenav\')\" aria-label=\"back\"><md-icon md-font-icon=\"icon-close\"></md-icon>\n</md-button></div><div class=\"md-toolbar-tools md-toolbar-tools-bottom\" flex layout=\"column\" \nlayout-align=\"center center\"><div layout=\"column\" layout-align=\"center center\"><img \nng-src=\"{{vm.contacts.getById(vm.chatContactId).avatar}}\" class=\"md-avatar avatar contact-avatar huge\" \nalt=\"{{vm.contacts.getById(vm.chatContactId).name}}\"><div class=\"contact-name\">\n{{vm.contacts.getById(vm.chatContactId).name}}</div></div></div></md-toolbar><md-content class=\"md-hue-2\" flex \nms-scroll ms-padding><md-card><md-card-title translate=\"CHAT.MOOD\">Mood</md-card-title><md-card-content><span \nclass=\"mood\" ng-if=\"vm.contacts.getById(vm.chatContactId).mood\">{{vm.contacts.getById(vm.chatContactId).mood}}</span>\n</md-card-content></md-card></md-content>");
$templateCache.put("app/main/apps/chat/sidenavs/left/views/chats/chats-view.html","<md-toolbar class=\"md-tall\"><div class=\"md-toolbar-tools md-toolbar-tools-top\"><div class=\"avatar-wrapper\"><img \nng-click=\"vm.toggleLeftSidenavView(\'user\')\" ng-src=\"{{vm.user.avatar}}\" class=\"md-avatar avatar\" \nalt=\"{{vm.user.name}}\"><md-menu id=\"user-status-menu\"><i ng-click=\"$mdOpenMenu()\" class=\"icon icon- s16 status\" \nng-class=\"vm.user.status\"></i><md-menu-content><md-menu-item><md-button ng-click=\"vm.setUserStatus(\'online\')\"><div \nlayout=\"row\" layout-align=\"start center\"><i class=\"icon s16 status icon-checkbox-marked-circle mr-8 green-fg\"></i> \n<span translate=\"CHAT.STATUS_ONLINE\">Online</span></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setUserStatus(\'away\')\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon s16 status icon-clock mr-8 yellow-fg\"></i> <span translate=\"CHAT.STATUS_AWAY\">Away</span></div></md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"vm.setUserStatus(\'do-not-disturb\')\"><div layout=\"row\" \nlayout-align=\"start center\"><i class=\"icon s16 status icon-minus-circle mr-8 red-fg\"></i> <span \ntranslate=\"CHAT.STATUS_DO_NOT_DISTURB\">Do not disturb</span></div></md-button></md-menu-item><md-menu-item><md-button \nng-click=\"vm.setUserStatus(\'offline\')\"><div layout=\"row\" layout-align=\"start center\"><i \nclass=\"icon s16 status icon-checkbox-blank-circle-outline mr-8 green-fg\"></i> <span translate=\"CHAT.STATUS_OFFLINE\">\nOffline</span></div></md-button></md-menu-item></md-menu-content></md-menu></div><md-menu \nmd-position-mode=\"target-right target\"><md-button class=\"md-icon-button\" ng-click=\"$mdOpenMenu()\" aria-label=\"more\">\n<md-icon md-font-icon=\"icon-dots-vertical\"></md-icon></md-button><md-menu-content width=\"3\"><md-menu-item><md-button \nng-click=\"vm.toggleLeftSidenavView(\'user\')\" translate=\"CHAT.PROFILE\">Profile</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"\" translate=\"CHAT.LOGOUT\">Logout</md-button></md-menu-item></md-menu-content></md-menu></div><div \nclass=\"md-toolbar-tools md-toolbar-tools-bottom\"><div class=\"search-wrapper md-whiteframe-1dp\" layout=\"row\" \nlayout-align=\"start center\" flex><div class=\"search\" flex layout=\"row\" layout-align=\"start center\"><md-icon \nmd-font-icon=\"icon-magnify\" class=\"icon s18\"></md-icon><input flex ng-model=\"vm.chatSearch\" type=\"text\" \nplaceholder=\"Search or start new chat\" translate=\"\" translate-attr-placeholder=\"CHAT.CHAT_SEARCH_PLACEHOLDER\"></div>\n</div></div></md-toolbar><md-content flex ms-scroll><md-list class=\"chat-list\"><div \nng-show=\"vm.chatSearch && filteredChat.length > 0\" class=\"md-accent-fg subheader\" \nng-style=\"{\'transform\':\'translate3d(0px, 0px, 0px)\', \'z-index\': filteredChat.length + filteredContact.length }\" \ntranslate=\"CHAT.CHATS\">CHATS</div><md-list-item class=\"contact md-3-line\" \nng-style=\"{\'transform\': ( vm.chatSearch && filteredChat.length > 0 ) ?\'translate3d(0px, \'+($index + 1)* 100+\'%, 0px)\': \'translate3d(0px, \'+$index* 100+\'%, 0px)\', \'z-index\': filteredChat.length + filteredContact.length - $index}\" \nng-repeat=\"contact in vm.contacts  | filter: { lastMessage:{}} | filter: {name: vm.chatSearch}  |  orderBy: \'lastMessage.time\' :true | filter:query as filteredChat\" \nng-click=\"vm.getChat(contact.id)\" ng-class=\"{\'unread\':contact.unread}\"><div class=\"avatar-wrapper\"><img \nng-src=\"{{contact.avatar}}\" class=\"md-avatar avatar\" alt=\"{{contact.name}}\"> <i class=\"icon icon- s16 status\" \nng-class=\"contact.status\"></i></div><div class=\"md-list-item-text\"><h3 class=\"name\">{{contact.name}}</h3><p \nclass=\"last-message text-truncate\">{{contact.lastMessage.message}}</p></div><div layout=\"column\" \nlayout-align=\"center end\"><div class=\"last-message-time\">{{contact.lastMessage.time | altDate}}</div><div \nng-if=\"contact.unread\" class=\"md-accent-bg unread-message-count\">{{contact.unread}}</div></div><md-divider>\n</md-divider></md-list-item></md-list><md-list class=\"contact-list\"><div \nng-show=\"vm.chatSearch && filteredContact.length > 0\" class=\"md-accent-fg subheader\" \nng-style=\"{\'transform\': (filteredContact.length > 0 && filteredChat.length > 0 ) ? \'translate3d(0px, \'+(filteredChat.length +1) * 100+\'%, 0px)\':\'translate3d(0px, 0px, 0px)\', \'z-index\': filteredContact.length}\" \ntranslate=\"CHAT.CONTACTS\">CONTACTS</div><md-list-item class=\"contact md-3-line\" ng-show=\"vm.chatSearch\" \nng-style=\"{\'transform\': (filteredContact.length > 0 && filteredChat.length > 0 ) ?\'translate3d(0px, \'+(filteredChat.length + $index +2)* 100+\'%, 0px)\': \'translate3d(0px, \'+ ($index + 1)* 100+\'%, 0px)\', \'z-index\': filteredContact.length - $index}\" \nng-repeat=\"contact in vm.contacts  | filter: { lastMessage:null} | filter: {name: vm.chatSearch} | orderBy: \'name\' :false | filter:query as filteredContact\" \nng-click=\"vm.getChat(contact.id)\"><div class=\"avatar-wrapper\"><img ng-src=\"{{contact.avatar}}\" \nclass=\"md-avatar avatar\" alt=\"{{contact.name}}\"> <i class=\"icon icon- s16 status\" ng-class=\"contact.status\"></i></div>\n<div class=\"md-list-item-text\"><h3>{{contact.name}}</h3><p class=\"mood\">{{contact.mood}}</p></div><md-divider>\n</md-divider></md-list-item></md-list><div ng-hide=\"(filteredChat.length + filteredContact.length) > 0\" \nclass=\"no-results-message\" translate=\"CHAT.NO_RESULTS\">No results..</div></md-content><md-button \nclass=\"md-fab contacts-button\" ng-click=\"vm.toggleLeftSidenavView(\'contacts\')\" aria-label=\"contacts button\"><md-icon \nmd-font-icon=\"icon-plus\"></md-icon></md-button>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.autocomplete/directive/mdAutocomplete.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>&lt;md-autocomplete&gt;</code>\n is a special input component with a drop-down of all possible matches to a custom query. This component allows you to provide real-time suggestions as the user types in the input area.\n</p><p>\nTo start, you will need to specify the required parameters and provide a template for your results. The content inside \n<code>md-autocomplete</code> will be treated as a template.</p><p>\nIn more complex cases, you may want to include other content such as a message to display when no matches were found. You can do this by wrapping your template in \n<code>md-item-template</code> and adding a tag for <code>md-not-found</code>. An example of this is shown below.</p><p>\nTo reset the displayed value you must clear both values for <code>md-search-text</code> and <code>md-selected-item\n</code>.</p><h3 id=\"validation\">Validation</h3><p>You can use <code>ng-messages</code>\n to include validation the same way that you would normally validate; however, if you want to replicate a standard input with a floating label, you will have to do the following:\n</p><ul><li>Make sure that your template is wrapped in <code>md-item-template</code></li><li>Add your <code>ng-messages\n</code> code inside of <code>md-autocomplete</code></li><li>Add your validation properties to <code>md-autocomplete\n</code> (ie. <code>required</code>)</li><li>Add a <code>name</code> to <code>md-autocomplete</code>\n (to be used on the generated <code>input</code>)</li></ul><p>There is an example below of how this should look.</p><h3\n id=\"notes\">Notes</h3><p>The <code>md-autocomplete</code> uses the the <a \nng-href=\"api/directive/mdVirtualRepeatContainer\">VirtualRepeat</a>\n directive for displaying the results inside of the dropdown.<br></p><blockquote><p>\nWhen encountering issues regarding the item template please take a look at the <a \nng-href=\"api/directive/mdVirtualRepeatContainer\">VirtualRepeatContainer</a> documentation.</p></blockquote></div><div>\n<section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><h3 id=\"basic-example\">Basic Example</h3><hljs lang=\"html\">\n<md-autocomplete md-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-items=\"item in getMatches(searchText)\" \nmd-item-text=\"item.display\"><span md-highlight-text=\"searchText\">{{item.display}}</span></md-autocomplete></hljs><h3 \nid=\"example-with-not-found-message\">Example with &quot;not found&quot; message</h3><hljs lang=\"html\"><md-autocomplete \nmd-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-items=\"item in getMatches(searchText)\" \nmd-item-text=\"item.display\"><md-item-template><span md-highlight-text=\"searchText\">{{item.display}}</span>\n</md-item-template><md-not-found>No matches found.</md-not-found></md-autocomplete></hljs><p>\nIn this example, our code utilizes <code>md-item-template</code> and <code>md-not-found</code>\n to specify the different parts that make up our component.</p><h3 id=\"example-with-validation\">Example with validation\n</h3><hljs lang=\"html\"><form name=\"autocompleteForm\"><md-autocomplete required md-input-name=\"autocomplete\" \nmd-selected-item=\"selectedItem\" md-search-text=\"searchText\" md-items=\"item in getMatches(searchText)\" \nmd-item-text=\"item.display\"><md-item-template><span md-highlight-text=\"searchText\">{{item.display}}</span>\n</md-item-template><div ng-messages=\"autocompleteForm.autocomplete.$error\"><div ng-message=\"required\">\nThis field is required</div></div></md-autocomplete></form></hljs><p>In this example, our code utilizes <code>\nmd-item-template</code> and <code>ng-messages</code> to specify input validation for the field.</p></section><div \nclass=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* md-items</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nAn expression in the format of <code>item in items</code> to iterate over matches for your search.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-selected-item-change <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nAn expression to be run each time a new item is selected</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-search-text-change <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nAn expression to be run each time the search text updates</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-search-text <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nA model to bind the search query text to</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\nmd-selected-item <span hide show-sm><code class=\"api-type label type-hint type-hint-object\">object</code></span></td>\n<td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td \nclass=\"description\"><p>A model to bind the selected item to</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-item-text <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nAn expression that will convert your object to a single string.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">placeholder <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>Placeholder text that will be forwarded to the input.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-no-cache <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nDisables the internal caching that happens in autocomplete</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">ng-disabled <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></td><td class=\"description\"><p>Determines whether or not to disable the input field</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-require-match <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen set to true, the autocomplete will add a validator, which will evaluate to false, when no item is currently selected.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-min-length <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nSpecifies the minimum length of text before autocomplete will make suggestions</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-delay <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nSpecifies the amount of time (in milliseconds) to wait before looking for results</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-autofocus <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nIf true, the autocomplete will be automatically focused when a <code>$mdDialog</code>, <code>$mdBottomsheet</code> or \n<code>$mdSidenav</code>, which contains the autocomplete, is opening.<br><br>\nAlso the autocomplete will immediately focus the input element.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-no-asterisk <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></td><td class=\"description\"><p>When present, asterisk will not be appended to the floating label</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-autoselect <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nIf set to true, the first item will be automatically selected in the dropdown upon open.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-menu-class <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThis will be applied to the dropdown menu for styling</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-floating-label <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThis will add a floating label to autocomplete and wrap it in <code>md-input-container</code></p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-input-name <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThe name attribute given to the input element to be used with FormController</p></td></tr><tr class=\"api-params-item\">\n<td style=\"white-space: nowrap\">md-select-on-focus <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nWhen present the inputs text will be automatically selected on focus.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-input-id <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>An ID to be added to the input element</p></td></tr><tr class=\"api-params-item\">\n<td style=\"white-space: nowrap\">md-input-minlength <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nThe minimum length for the input&#39;s value for validation</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-input-maxlength <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nThe maximum length for the input&#39;s value for validation</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-select-on-match <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen set, autocomplete will automatically select exact the item if the search text is an exact match.<br><br>\nExact match means that there is only one match showing up.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-match-case-insensitive <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When set and using \n<code>md-select-on-match</code>, autocomplete will select on case-insensitive match</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-escape-options <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nOverride escape key logic. Default is <code>blur clear</code>.<br>Options: <code>blur | clear</code>, <code>none</code>\n</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.autocomplete/directive/mdHighlightText.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>md-highlight-text</code>\n directive allows you to specify text that should be highlighted within an element. Highlighted text will be wrapped in \n<code>&lt;span class=&quot;highlight&quot;&gt;&lt;/span&gt;</code>\n which can be styled through CSS. Please note that child elements may not be used with this directive.</p></div><div>\n<section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><input placeholder=\"Enter a search term...\" \nng-model=\"searchTerm\" type=\"text\"><ul><li ng-repeat=\"result in results\" md-highlight-text=\"searchTerm\">{{result.text}}\n</li></ul></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-highlight-text</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nA model to be searched for</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-highlight-flags \n<span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>A list of flags (loosely based on JavaScript RexExp flags).</p><h4 id=\"-supported-flags-\">\n<strong>Supported flags</strong>:</h4><ul><li><code>g</code>: Find all matches within the provided text</li><li><code>i\n</code>: Ignore case when searching for matches</li><li><code>$</code>\n: Only match if the text ends with the search term</li><li><code>^</code>\n: Only match if the text begins with the search term</li></ul></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.backdrop/directive/mdBackdrop.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>&lt;md-backdrop&gt;</code>\n is a backdrop element used by other components, such as dialog and bottom sheet. Apply class <code>opaque</code>\n to make the backdrop use the theme backdrop color.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage\n</h2><ul><li>as element:<pre><code>&lt;md-backdrop&gt;&#13;&#10;...&#13;&#10;&lt;/md-backdrop&gt;&#13;</code></pre>\n</li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.checkbox/directive/mdCheckbox.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The checkbox directive is used like the normal <a \nhref=\"https://docs.angularjs.org/api/ng/input/input%5Bcheckbox%5D\">angular checkbox</a>.</p><p>As per the <a \nhref=\"http://www.google.com/design/spec/style/color.html#color-color-schemes\">material design spec</a>\n the checkbox is in the accent color by default. The primary color palette may be used with the <code>md-primary</code>\n class.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-checkbox \nng-model=\"isChecked\" aria-label=\"Finished?\">Finished ?</md-checkbox><md-checkbox md-no-ink ng-model=\"hasInk\" \naria-label=\"No Ink Effects\">No Ink Effects</md-checkbox><md-checkbox ng-disabled=\"true\" ng-model=\"isDisabled\" \naria-label=\"Disabled\">Disabled</md-checkbox></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* ng-model</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nAssignable angular expression to data-bind to.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">name <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>Property name of the form under which the control is published.</p></td></tr><tr\n class=\"api-params-item\"><td style=\"white-space: nowrap\">ng-true-value <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nThe value to which the expression should be set when selected.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">ng-false-value <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nThe value to which the expression should be set when not selected.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">ng-change <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>\nAngular expression to be executed when input changes due to user interaction with the input element.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-no-ink <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nUse of attribute indicates use of ripple ink effects</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">aria-label <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>\nAdds label to checkbox for accessibility. Defaults to checkbox&#39;s text. If no default text is found, a warning will be logged.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-indeterminate <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nThis determines when the checkbox should be rendered as &#39;indeterminate&#39;. If a truthy expression or no value is passed in the checkbox renders in the md-indeterminate state. If falsy expression is passed in it just looks like a normal unchecked checkbox. The indeterminate, checked, and unchecked states are mutually exclusive. A box cannot be in any two states at the same time. Adding the &#39;md-indeterminate&#39; attribute overrides any checked/unchecked rendering logic. When using the &#39;md-indeterminate&#39; attribute use &#39;ng-checked&#39; to define rendering logic instead of using &#39;ng-model&#39;.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">ng-checked <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nIf this expression evaluates as truthy, the &#39;md-checked&#39; css class is added to the checkbox and it will appear checked.\n</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.button/directive/mdButton.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>&lt;md-button&gt;</code>\n is a button directive with optional ink ripples (default enabled).</p><p>If you supply a <code>href</code> or <code>\nng-href</code> attribute, it will become an <code>&lt;a&gt;</code> element. Otherwise, it will become a <code>\n&lt;button&gt;</code> element. As per the <a href=\"https://material.google.com/style/color.html#color-color-palette\">\nMaterial Design specifications</a>\n the FAB button background is filled with the accent color [by default]. The primary color palette may be used with the \n<code>md-primary</code> class.</p><p>\nDevelopers can also change the color palette of the button, by using the following classes</p><ul><li><code>md-primary\n</code></li><li><code>md-accent</code></li><li><code>md-warn</code></li></ul><p>See for example</p><hljs lang=\"html\">\n<md-button class=\"md-primary\">Primary Button</md-button></hljs><p>\nButton can be also raised, which means that they will use the current color palette to fill the button.</p><hljs \nlang=\"html\"><md-button class=\"md-accent md-raised\">Raised and Accent Button</md-button></hljs><p>\nIt is also possible to disable the focus effect on the button, by using the following markup.</p><hljs lang=\"html\">\n<md-button class=\"md-no-focus\">No Focus Style</md-button></hljs></div><div><section class=\"api-section\"><h2 id=\"Usage\">\nUsage</h2><p>Regular buttons:</p><hljs lang=\"html\"><md-button>Flat Button</md-button><md-button \nhref=\"http://google.com\">Flat link</md-button><md-button class=\"md-raised\">Raised Button</md-button><md-button \nng-disabled=\"true\">Disabled Button</md-button><md-button><md-icon md-svg-src=\"your/icon.svg\"></md-icon>Register Now\n</md-button></hljs><p>FAB buttons:</p><hljs lang=\"html\"><md-button class=\"md-fab\" aria-label=\"FAB\"><md-icon \nmd-svg-src=\"your/icon.svg\"></md-icon></md-button><md-button class=\"md-fab md-mini\" aria-label=\"Mini FAB\"><md-icon \nmd-svg-src=\"your/icon.svg\"></md-icon></md-button><md-button class=\"md-icon-button\" aria-label=\"Custom Icon Button\">\n<md-icon md-svg-icon=\"path/to/your.svg\"></md-icon></md-button></hljs></section><div class=\"api-param-section\"><h2>\nAttributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-no-ink <span hide \nshow-sm><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td \nclass=\"description\"><p>If present, disable ripple ink effects.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">ng-disabled <span hide show-sm><code class=\"api-type label type-hint type-hint-expression\">\nexpression</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nEn/Disable based on the expression</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\nmd-ripple-size <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>Overrides the default ripple size logic. Options: <code>full</code>, <code>partial</code>, \n<code>auto</code></p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">aria-label <span hide \nshow-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>\nAdds alternative text to button for accessibility, useful for icon buttons. If no default text is found, a warning will be logged.\n</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.card/directive/mdCard.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-card&gt;</code> directive is a container element used within <code>\n&lt;md-content&gt;</code> containers.</p><p>\nAn image included as a direct descendant will fill the card&#39;s width. If you want to avoid this, you can add the \n<code>md-image-no-fill</code> class to the parent element. The <code>&lt;md-card-content&gt;</code>\n container will wrap text content and provide padding. An <code>&lt;md-card-footer&gt;</code>\n element can be optionally included to put content flush against the bottom edge of the card.</p><p>\nAction buttons can be included in an <code>&lt;md-card-actions&gt;</code> element, similar to <code>\n&lt;md-dialog-actions&gt;</code>. You can then position buttons using layout attributes.</p><p>Card is built with:</p>\n<ul><li><code>&lt;md-card-header&gt;</code> - Header for the card, holds avatar, text and squared image<ul><li><code>\n&lt;md-card-avatar&gt;</code> - Card avatar<ul><li><code>md-user-avatar</code> - Class for user image</li><li><code>\n&lt;md-icon&gt;</code></li></ul></li><li><code>&lt;md-card-header-text&gt;</code>\n - Contains elements for the card description<ul><li><code>md-title</code> - Class for the card title</li><li><code>\nmd-subhead</code> - Class for the card sub header</li></ul></li></ul></li><li><code>&lt;img&gt;</code>\n - Image for the card</li><li><code>&lt;md-card-title&gt;</code> - Card content title<ul><li><code>\n&lt;md-card-title-text&gt;</code><ul><li><code>md-headline</code> - Class for the card content title</li><li><code>\nmd-subhead</code> - Class for the card content sub header</li></ul></li><li><code>&lt;md-card-title-media&gt;</code>\n - Squared image within the title<ul><li><code>md-media-sm</code> - Class for small image</li><li><code>md-media-md\n</code> - Class for medium image</li><li><code>md-media-lg</code> - Class for large image</li></ul></li></ul></li><li>\n<code>&lt;md-card-content&gt;</code> - Card content<ul><li><code>md-media-xl</code> - Class for extra large image</li>\n</ul></li><li><code>&lt;md-card-actions&gt;</code> - Card actions<ul><li><code>&lt;md-card-icon-actions&gt;</code>\n - Icon actions</li></ul></li></ul><p>\nCards have constant width and variable heights; where the maximum height is limited to what can fit within a single view on a platform, but it can temporarily expand as needed.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><h3 id=\"card-with-optional-footer\">\nCard with optional footer</h3><hljs lang=\"html\"><md-card><img src=\"card-image.png\" class=\"md-card-image\" \nalt=\"image caption\"><md-card-content><h2>Card headline</h2><p>Card content</p></md-card-content><md-card-footer>\nCard footer</md-card-footer></md-card></hljs><h3 id=\"card-with-actions\">Card with actions</h3><hljs lang=\"html\">\n<md-card><img src=\"card-image.png\" class=\"md-card-image\" alt=\"image caption\"><md-card-content><h2>Card headline</h2><p>\nCard content</p></md-card-content><md-card-actions layout=\"row\" layout-align=\"end center\"><md-button>Action 1\n</md-button><md-button>Action 2</md-button></md-card-actions></md-card></hljs><h3 \nid=\"card-with-header-image-title-actions-and-content\">Card with header, image, title actions and content</h3><hljs \nlang=\"html\"><md-card><md-card-header><md-card-avatar><img class=\"md-user-avatar\" src=\"avatar.png\"></md-card-avatar>\n<md-card-header-text><span class=\"md-title\">Title</span> <span class=\"md-subhead\">Sub header</span>\n</md-card-header-text></md-card-header><img ng-src=\"card-image.png\" class=\"md-card-image\" alt=\"image caption\">\n<md-card-title><md-card-title-text><span class=\"md-headline\">Card headline</span> <span class=\"md-subhead\">\nCard subheader</span></md-card-title-text></md-card-title><md-card-actions layout=\"row\" layout-align=\"start center\">\n<md-button>Action 1</md-button><md-button>Action 2</md-button><md-card-icon-actions><md-button class=\"md-icon-button\" \naria-label=\"icon\"><md-icon md-svg-icon=\"icon\"></md-icon></md-button></md-card-icon-actions></md-card-actions>\n<md-card-content><p>Card content</p></md-card-content></md-card></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.bottomSheet/service/$mdBottomSheet.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>$mdBottomSheet</code>\n opens a bottom sheet over the app and provides a simple promise API.</p><h2 id=\"restrictions\">Restrictions</h2><ul>\n<li>The bottom sheet&#39;s template must have an outer <code>&lt;md-bottom-sheet&gt;</code> element.</li><li>Add the \n<code>md-grid</code> class to the bottom sheet for a grid layout.</li><li>Add the <code>md-list</code>\n class to the bottom sheet for a list layout.</li></ul></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage\n</h2><hljs lang=\"html\"><div ng-controller=\"MyController\"><md-button ng-click=\"openBottomSheet()\">Open a Bottom Sheet!\n</md-button></div></hljs><hljs lang=\"js\">\nvar app = angular.module(&#39;app&#39;, [&#39;ngMaterial&#39;]); app.controller(&#39;MyController&#39;, function($scope, $mdBottomSheet) { $scope.openBottomSheet = function() { $mdBottomSheet.show({ template: &#39;\n<md-bottom-sheet>Hello!</md-bottom-sheet>&#39; }); }; });</hljs></section><section class=\"api-section\"><h2>Methods</h2>\n<br><ul class=\"methods\"><li id=\"show\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdBottomSheet.show(options);</code></h3><div class=\"service-desc\"><p>Show a bottom sheet with the specified options.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* options</b> <span \nhide show-sm><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td \nclass=\"description\"><p>An options object, with the following properties:</p><ul><li><code>templateUrl</code> - <code>\n{string=}</code>\n: The url of an html template file that will be used as the content of the bottom sheet. Restrictions: the template must have an outer \n<code>md-bottom-sheet</code> element.</li><li><code>template</code> - <code>{string=}</code>\n: Same as templateUrl, except this is an actual template string.</li><li><code>scope</code> - <code>{object=}</code>\n: the scope to link the template / controller to. If none is specified, it will create a new child scope. This scope will be destroyed when the bottom sheet is removed unless \n<code>preserveScope</code> is set to true.</li><li><code>preserveScope</code> - <code>{boolean=}</code>\n: whether to preserve the scope when the element is removed. Default is false</li><li><code>controller</code> - <code>\n{string=}</code>: The controller to associate with this bottom sheet.</li><li><code>locals</code> - <code>{string=}\n</code>\n: An object containing key/value pairs. The keys will be used as names of values to inject into the controller. For example, \n<code>locals: {three: 3}</code> would inject <code>three</code> into the controller with the value of 3.</li><li><code>\nclickOutsideToClose</code> - <code>{boolean=}</code>\n: Whether the user can click outside the bottom sheet to close it. Default true.</li><li><code>disableBackdrop</code>\n - <code>{boolean=}</code>: When set to true, the bottomsheet will not show a backdrop.</li><li><code>escapeToClose\n</code> - <code>{boolean=}</code>: Whether the user can press escape to close the bottom sheet. Default true.</li><li>\n<code>resolve</code> - <code>{object=}</code>\n: Similar to locals, except it takes promises as values and the bottom sheet will not open until the promises resolve.\n</li><li><code>controllerAs</code> - <code>{string=}</code>: An alias to assign the controller to on the scope.</li>\n<li><code>parent</code> - <code>{element=}</code>: The element to append the bottom sheet to. The <code>parent</code>\n may be a <code>function</code>, <code>string</code>, <code>object</code>\n, or null. Defaults to appending to the body of the root element (or the root element) of the application. e.g. angular.element(document.getElementById(&#39;content&#39;)) or &quot;#content&quot;\n</li><li><code>disableParentScroll</code> - <code>{boolean=}</code>\n: Whether to disable scrolling while the bottom sheet is open. Default true.</li></ul></td></tr></tbody></table><table \nclass=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-promise\">promise</code></td><td class=\"description\"><p>\nA promise that can be resolved with <code>$mdBottomSheet.hide()</code> or rejected with <code>$mdBottomSheet.cancel()\n</code>.</p></td></tr></tbody></table></div></li><li id=\"hide\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdBottomSheet.hide([response]);</code></h3><div class=\"service-desc\"><p>\nHide the existing bottom sheet and resolve the promise returned from <code>$mdBottomSheet.show()</code>\n. This call will close the most recently opened/current bottomsheet (if any).</p></div><div class=\"method-param-table\">\n<table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">response <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>\nAn argument for the resolved promise.</p></td></tr></tbody></table></div></li><li id=\"cancel\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdBottomSheet.cancel([response]);</code></h3><div \nclass=\"service-desc\"><p>Hide the existing bottom sheet and reject the promise returned from <code>$mdBottomSheet.show()\n</code>.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type\n</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">response <span\n hide show-sm><code class=\"api-type label type-hint type-hint-object\">*</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">*</code></td><td \nclass=\"description\"><p>An argument for the rejected promise.</p></td></tr></tbody></table></div></li></ul></section>\n</div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.datepicker/directive/mdCalendar.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>&lt;md-calendar&gt;</code>\n is a component that renders a calendar that can be used to select a date. It is a part of the <code>&lt;md-datepicker\n</code> pane, however it can also be used on it&#39;s own.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">\nUsage</h2><hljs lang=\"html\"><md-calendar ng-model=\"birthday\"></md-calendar></hljs></section><div \nclass=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* ng-model</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-date\">\nDate</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-date\">Date\n</code></td><td class=\"description\"><p>The component&#39;s model. Should be a Date object.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-min-date <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-date\">Date</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-date\">Date</code></td><td class=\"description\"><p>\nExpression representing the minimum date.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\nmd-max-date <span hide show-sm><code class=\"api-type label type-hint type-hint-date\">Date</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-date\">Date</code></td><td \nclass=\"description\"><p>Expression representing the maximum date.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-date-filter <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-function\">function(Date): boolean</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-function\">function(Date): boolean</code>\n</td><td class=\"description\"><p>Function expecting a date and returning a boolean whether it can be selected or not.\n</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.datepicker/directive/mdDatepicker.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>&lt;md-datepicker&gt;</code>\n is a component used to select a single date. For information on how to configure internationalization for the date picker, see \n<code>$mdDateLocaleProvider</code>.</p><p>This component supports <a \nhref=\"https://docs.angularjs.org/api/ngMessages/directive/ngMessages\">ngMessages</a>. Supported attributes are:</p><ul>\n<li><code>required</code>: whether a required date is not set.</li><li><code>mindate</code>\n: whether the selected date is before the minimum allowed date.</li><li><code>maxdate</code>\n: whether the selected date is after the maximum allowed date.</li><li><code>debounceInterval</code>\n: ms to delay input processing (since last debounce reset); default value 500ms</li></ul></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-datepicker ng-model=\"birthday\"></md-datepicker>\n</hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* ng-model</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-date\">Date</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-date\">Date</code></td><td class=\"description\"><p>\nThe component&#39;s model. Expects a JavaScript Date object.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">ng-model-options <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">Object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">Object</code></td><td class=\"description\"><p>\nAllows tuning of the way in which <code>ng-model</code> is being updated. Also allows for a timezone to be specified. \n<a href=\"https://docs.angularjs.org/api/ng/directive/ngModelOptions#usage\">Read more at the ngModelOptions docs.</a>\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">ng-change <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nExpression evaluated when the model value changes.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">ng-focus <span hide show-sm><code class=\"api-type label type-hint type-hint-expression\">\nexpression</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nExpression evaluated when the input is focused or the calendar is opened.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">ng-blur <span hide show-sm><code class=\"api-type label type-hint type-hint-expression\">\nexpression</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nExpression evaluated when focus is removed from the input or the calendar is closed.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-min-date <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-date\">Date</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-date\">Date</code></td><td class=\"description\"><p>\nExpression representing a min date (inclusive).</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-max-date <span hide show-sm><code class=\"api-type label type-hint type-hint-date\">Date\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-date\">Date</code>\n</td><td class=\"description\"><p>Expression representing a max date (inclusive).</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-date-filter <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-function\">function(Date): boolean</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-function\">function(Date): boolean</code>\n</td><td class=\"description\"><p>Function expecting a date and returning a boolean whether it can be selected or not.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-placeholder <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">String</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">String</code></td><td class=\"description\"><p>\nThe date input placeholder value.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\nmd-open-on-focus <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">String</code></span></td>\n<td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">String</code></td><td \nclass=\"description\"><p>When present, the calendar will be opened when the input is focused.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-is-open <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">Boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">Boolean</code></td><td class=\"description\"><p>\nExpression that can be used to open the datepicker&#39;s calendar on-demand.</p></td></tr><tr class=\"api-params-item\">\n<td style=\"white-space: nowrap\">md-current-view <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">String</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">String</code></td><td class=\"description\"><p>\nDefault open view of the calendar pane. Can be either &quot;month&quot; or &quot;year&quot;.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-hide-icons <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">String</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">String</code></td><td class=\"description\"><p>\nDetermines which datepicker icons should be hidden. Note that this may cause the datepicker to not align properly with other components. \n<strong>Use at your own risk.</strong> Possible values are:</p><ul><li><code>&quot;all&quot;</code> - Hides all icons.\n</li><li><code>&quot;calendar&quot;</code> - Only hides the calendar icon.</li><li><code>&quot;triangle&quot;</code>\n - Only hides the triangle icon.</li></ul></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\nng-disabled <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td \nclass=\"description\"><p>Whether the datepicker is disabled.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">ng-required <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></td><td class=\"description\"><p>Whether a value is required for the datepicker.</p></td></tr></tbody>\n</table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.colors/directive/mdColors.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>mdColors</code>\n directive will apply the theme-based color expression as RGBA CSS style values.</p><p>\nThe format will be similar to our color defining in the scss files:</p><h2 id=\"-theme-palette-hue-opacity-\"><code>\n[?theme]-[palette]-[?hue]-[?opacity]</code></h2><ul><li>[theme] - default value is the default theme</li><li>\n[palette] - can be either palette name or primary/accent/warn/background</li><li>\n[hue] - default is 500 (hue-x can be used with primary/accent/warn/background)</li><li><p>[opacity] - default is 1</p>\n<blockquote><p><code>?</code> indicates optional parameter</p></blockquote></li></ul></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div \nmd-colors=\"{background: \'myTheme-accent-900-0.43\'}\"><div \nmd-colors=\"{color: \'red-A100\', \'border-color\': \'primary-600\'}\"><span>Color demo</span></div></div></hljs><p><code>\nmdColors</code>\n directive will automatically watch for changes in the expression if it recognizes an interpolation expression or a function. For performance options, you can use \n<code>::</code> prefix to the <code>md-colors</code> expression to indicate a one-time data binding.</p><hljs \nlang=\"html\"><md-card md-colors=\"::{background: \'{{theme}}-primary-700\'}\"></md-card></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.datepicker/service/$mdDateLocaleProvider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>$mdDateLocaleProvider</code> is the provider that creates the <code>\n$mdDateLocale</code>\n service. This provider that allows the user to specify messages, formatters, and parsers for date internationalization. The \n<code>$mdDateLocale</code> service itself is consumed by Angular Material components that deal with dates.</p></div>\n<div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">\nmyAppModule.config(function($mdDateLocaleProvider) { // Example of a French localization. $mdDateLocaleProvider.months = [&#39;janvier&#39;, &#39;février&#39;, &#39;mars&#39;, ...]; $mdDateLocaleProvider.shortMonths = [&#39;janv&#39;, &#39;févr&#39;, &#39;mars&#39;, ...]; $mdDateLocaleProvider.days = [&#39;dimanche&#39;, &#39;lundi&#39;, &#39;mardi&#39;, ...]; $mdDateLocaleProvider.shortDays = [&#39;Di&#39;, &#39;Lu&#39;, &#39;Ma&#39;, ...]; // Can change week display to start on Monday. $mdDateLocaleProvider.firstDayOfWeek = 1; // Optional. $mdDateLocaleProvider.dates = [1, 2, 3, 4, 5, 6, ...]; // Example uses moment.js to parse and format dates. $mdDateLocaleProvider.parseDate = function(dateString) { var m = moment(dateString, &#39;L&#39;, true); return m.isValid() ? m.toDate() : new Date(NaN); }; $mdDateLocaleProvider.formatDate = function(date) { var m = moment(date); return m.isValid() ? m.format(&#39;L&#39;) : &#39;&#39;; }; $mdDateLocaleProvider.monthHeaderFormatter = function(date) { return myShortMonths[date.getMonth()] + &#39; &#39; + date.getFullYear(); }; // In addition to date display, date components also need localized messages // for aria-labels for screen-reader users. $mdDateLocaleProvider.weekNumberFormatter = function(weekNumber) { return &#39;Semaine &#39; + weekNumber; }; $mdDateLocaleProvider.msgCalendar = &#39;Calendrier&#39;; $mdDateLocaleProvider.msgOpenCalendar = &#39;Ouvrir le calendrier&#39;; // You can also set when your calendar begins and ends. $mdDateLocaleProvider.firstRenderableDate = new Date(1776, 6, 4); $mdDateLocaleProvider.lastRenderableDate = new Date(2012, 11, 21); });\n</hljs></section><section class=\"api-section\"><h2>Properties</h2><div class=\"api-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Property</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">months <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></td><td \nclass=\"description\"><p>Array of month names (in order).</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">shortMonths <span hide show-sm><code class=\"api-type label type-hint type-hint-array\">\nArray.&lt;string&gt;</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></td><td class=\"description\"><p>\nArray of abbreviated month names.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">days <span \nhide show-sm><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></td><td \nclass=\"description\"><p>Array of the days of the week (in order).</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">shortDays <span hide show-sm><code class=\"api-type label type-hint type-hint-array\">\nArray.&lt;string&gt;</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></td><td class=\"description\"><p>\nArray of abbreviated dayes of the week.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">dates \n<span hide show-sm><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></td><td \nclass=\"description\"><p>\nArray of dates of the month. Only necessary for locales using a numeral system other than [1, 2, 3...].</p></td></tr>\n<tr class=\"api-params-item\"><td style=\"white-space: nowrap\">firstDayOfWeek <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-array\">Array.&lt;string&gt;</code></td><td \nclass=\"description\"><p>The first day of the week. Sunday = 0, Monday = 1, etc.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">parseDate <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-function\">function(string): Date</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-function\">function(string): Date</code>\n</td><td class=\"description\"><p>Function to parse a date object from a string.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">formatDate <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-function\">function(Date): string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-function\">function(Date): string</code>\n</td><td class=\"description\"><p>Function to format a date object to a string.</p></td></tr><tr class=\"api-params-item\">\n<td style=\"white-space: nowrap\">monthHeaderFormatter <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-function\">function(Date): string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-function\">function(Date): string</code>\n</td><td class=\"description\"><p>Function that returns the label for a month given a date.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">monthFormatter <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-function\">function(Date): string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-function\">function(Date): string</code>\n</td><td class=\"description\"><p>Function that returns the full name of a month for a giben date.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">weekNumberFormatter <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-function\">function(number): string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-function\">function(number): string</code>\n</td><td class=\"description\"><p>Function that returns a label for a week given the week number.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">msgCalendar <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nTranslation of the label &quot;Calendar&quot; for the current locale.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">msgOpenCalendar <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>\nTranslation of the button label &quot;Open calendar&quot; for the current locale.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">firstRenderableDate <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-date\">Date</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-date\">Date</code></td><td class=\"description\"><p>\nThe date from which the datepicker calendar will begin rendering. Note that this will be ignored if a minimum date is set. Defaults to January 1st 1880.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">lastRenderableDate <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-date\">Date</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-date\">Date</code></td><td class=\"description\"><p>\nThe last date that will be rendered by the datepicker calendar. Note that this will be ignored if a maximum date is set. Defaults to January 1st 2130.\n</p></td></tr></tbody></table></div></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.content/directive/mdContent.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-content&gt;</code>\n directive is a container element useful for scrollable content. It achieves this by setting the CSS <code>overflow\n</code> property to <code>auto</code> so that content can properly scroll.</p><p>In general, <code>&lt;md-content&gt;\n</code>\n components are not designed to be nested inside one another. If possible, it is better to make them siblings. This often results in a better user experience as having nested scrollbars may confuse the user.\n</p><h2 id=\"troubleshooting\">Troubleshooting</h2><p>In some cases, you may wish to apply the <code>md-no-momentum\n</code>\n class to ensure that Safari&#39;s momentum scrolling is disabled. Momentum scrolling can cause flickering issues while scrolling SVG icons and some other components.\n</p><p>Additionally, we now also offer the <code>md-no-flicker</code>\n class which can be applied to any element and uses a Webkit-specific filter of <code>blur(0px)</code>\n that forces GPU rendering of all elements inside (which eliminates the flicker on iOS devices).</p><p><em><b>Note:</b>\n Forcing an element to render on the GPU can have unintended side-effects, especially related to the z-index of elements. Please use with caution and only on the elements needed.\n</em></p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>Add the <code>[layout-padding]</code>\n attribute to make the content padded.</p><hljs lang=\"html\"><md-content layout-padding>\nLorem ipsum dolor sit amet, ne quod novum mei.</md-content></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.dialog/directive/mdDialog.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>&lt;md-dialog&gt;</code>\n - The dialog&#39;s template must be inside this element.</p><p>Inside, use an <code>&lt;md-dialog-content&gt;</code>\n element for the dialog&#39;s content, and use an <code>&lt;md-dialog-actions&gt;</code>\n element for the dialog&#39;s actions.</p><h2 id=\"css\">CSS</h2><ul><li><code>.md-dialog-content</code>\n - class that sets the padding on the content as the spec file</li></ul><h2 id=\"notes\">Notes</h2><ul><li>\nIf you specify an <code>id</code> for the <code>&lt;md-dialog&gt;</code>, the <code>&lt;md-dialog-content&gt;</code>\n will have the same <code>id</code> prefixed with <code>dialogContent_</code>.</li></ul></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><h3 id=\"dialog-template\">Dialog template</h3><hljs lang=\"html\"><md-dialog \naria-label=\"List dialog\"><md-dialog-content><md-list><md-list-item ng-repeat=\"item in items\"><p>Number {{item}}</p>\n</md-list-item></md-list></md-dialog-content><md-dialog-actions><md-button ng-click=\"closeDialog()\" class=\"md-primary\">\nClose Dialog</md-button></md-dialog-actions></md-dialog></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.divider/directive/mdDivider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nDividers group and separate content within lists and page layouts using strong visual and spatial distinctions. This divider is a thin rule, lightweight enough to not distract the user from content.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-divider></md-divider>\n<md-divider md-inset></md-divider></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-inset <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nAdd this attribute to activate the inset divider style.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.dialog/service/$mdDialog.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>$mdDialog</code>\n opens a dialog over the app to inform users about critical information or require them to make decisions. There are two approaches for setup: a simple promise API and regular object syntax.\n</p><h2 id=\"restrictions\">Restrictions</h2><ul><li>The dialog is always given an isolate scope.</li><li>\nThe dialog&#39;s template must have an outer <code>&lt;md-dialog&gt;</code> element. Inside, use an <code>\n&lt;md-dialog-content&gt;</code> element for the dialog&#39;s content, and use an <code>&lt;md-dialog-actions&gt;\n</code> element for the dialog&#39;s actions.</li><li>\nDialogs must cover the entire application to keep interactions inside of them. Use the <code>parent</code>\n option to change where dialogs are appended.</li></ul><h2 id=\"sizing\">Sizing</h2><ul><li>\nComplex dialogs can be sized with <code>flex=&quot;percentage&quot;</code>, i.e. <code>flex=&quot;66&quot;</code>.</li>\n<li>Default max-width is 80% of the <code>rootElement</code> or <code>parent</code>.</li></ul><h2 id=\"css\">CSS</h2><ul>\n<li><code>.md-dialog-content</code> - class that sets the padding on the content as the spec file</li></ul></div><div>\n<section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div ng-app=\"demoApp\" \nng-controller=\"EmployeeController\"><div><md-button ng-click=\"showAlert()\" class=\"md-raised md-warn\">Employee Alert!\n</md-button></div><div><md-button ng-click=\"showDialog($event)\" class=\"md-raised\">Custom Dialog</md-button></div><div>\n<md-button ng-click=\"closeAlert()\" ng-disabled=\"!hasAlert()\" class=\"md-raised\">Close Alert</md-button></div><div>\n<md-button ng-click=\"showGreeting($event)\" class=\"md-raised md-primary\">Greet Employee</md-button></div></div></hljs>\n<h3 id=\"javascript-object-syntax\">JavaScript: object syntax</h3><hljs lang=\"js\">\n(function(angular, undefined){ &quot;use strict&quot;; angular .module(&#39;demoApp&#39;, [&#39;ngMaterial&#39;]) .controller(&#39;AppCtrl&#39;, AppController); function AppController($scope, $mdDialog) { var alert; $scope.showAlert = showAlert; $scope.showDialog = showDialog; $scope.items = [1, 2, 3]; // Internal method function showAlert() { alert = $mdDialog.alert({ title: &#39;Attention&#39;, textContent: &#39;This is an example of how easy dialogs can be!&#39;, ok: &#39;Close&#39; }); $mdDialog .show( alert ) .finally(function() { alert = undefined; }); } function showDialog($event) { var parentEl = angular.element(document.body); $mdDialog.show({ parent: parentEl, targetEvent: $event, template: &#39;\n<md-dialog aria-label=\"List dialog\">&#39; + &#39;<md-dialog-content>&#39;+ &#39;<md-list>&#39;+ &#39;<md-list-item \nng-repeat=\"item in items\">&#39;+ &#39;<p>Number {{item}}</p>&#39; + &#39;&#39;+ &#39;</md-list-item></md-list>\n&#39;+ &#39;</md-dialog-content>&#39; + &#39;<md-dialog-actions>&#39; + &#39;<md-button ng-click=\"closeDialog()\" \nclass=\"md-primary\">&#39; + &#39; Close Dialog&#39; + &#39;</md-button>&#39; + &#39;</md-dialog-actions>&#39; + &#39;\n</md-dialog>\n&#39;, locals: { items: $scope.items }, controller: DialogController }); function DialogController($scope, $mdDialog, items) { $scope.items = items; $scope.closeDialog = function() { $mdDialog.hide(); } } } } })(angular);\n</hljs><h3 id=\"pre-rendered-dialogs\">Pre-Rendered Dialogs</h3><p>By using the <code>contentElement</code>\n option, it is possible to use an already existing element in the DOM.</p><hljs lang=\"js\">\n$scope.showPrerenderedDialog = function() { $mdDialog.show({ contentElement: &#39;#myStaticDialog&#39;, parent: angular.element(document.body) }); };\n</hljs><p>When using a string as value, <code>$mdDialog</code>\n will automatically query the DOM for the specified CSS selector.</p><hljs lang=\"html\"><div style=\"visibility: hidden\">\n<div class=\"md-dialog-container\" id=\"myStaticDialog\"><md-dialog>This is a pre-rendered dialog.</md-dialog></div></div>\n</hljs><p><strong>Notice</strong>: It is important, to use the <code>.md-dialog-container</code>\n as the content element, otherwise the dialog will not show up.</p><p>It also possible to use a DOM element for the \n<code>contentElement</code> option.</p><ul><li><code>contentElement: document.querySelector(&#39;#myStaticDialog&#39;)\n</code></li><li><code>contentElement: angular.element(TEMPLATE)</code></li></ul><p>When using a <code>template</code>\n as content element, it will be not compiled upon open. This allows you to compile the element yourself and use it each time the dialog opens.\n</p><h3 id=\"custom-presets\">Custom Presets</h3><p>\nDevelopers are also able to create their own preset, which can be easily used without repeating their options each time.\n</p><hljs lang=\"js\">$mdDialogProvider.addPreset(&#39;testPreset&#39;, { options: function() { return { template: &#39;\n<md-dialog>&#39; + &#39;This is a custom preset&#39; + &#39;</md-dialog>\n&#39;, controllerAs: &#39;dialog&#39;, bindToController: true, clickOutsideToClose: true, escapeToClose: true }; } });\n</hljs><p>After you created your preset at config phase, you can easily access it.</p><hljs lang=\"js\">\n$mdDialog.show( $mdDialog.testPreset() );</hljs><h3 id=\"javascript-promise-api-syntax-custom-dialog-template\">\nJavaScript: promise API syntax, custom dialog template</h3><hljs lang=\"js\">\n(function(angular, undefined){ &quot;use strict&quot;; angular .module(&#39;demoApp&#39;, [&#39;ngMaterial&#39;]) .controller(&#39;EmployeeController&#39;, EmployeeEditor) .controller(&#39;GreetingController&#39;, GreetingController); // Fictitious Employee Editor to show how to use simple and complex dialogs. function EmployeeEditor($scope, $mdDialog) { var alert; $scope.showAlert = showAlert; $scope.closeAlert = closeAlert; $scope.showGreeting = showCustomGreeting; $scope.hasAlert = function() { return !!alert }; $scope.userName = $scope.userName || &#39;Bobby&#39;; // Dialog #1 - Show simple alert dialog and cache // reference to dialog instance function showAlert() { alert = $mdDialog.alert() .title(&#39;Attention, &#39; + $scope.userName) .textContent(&#39;This is an example of how easy dialogs can be!&#39;) .ok(&#39;Close&#39;); $mdDialog .show( alert ) .finally(function() { alert = undefined; }); } // Close the specified dialog instance and resolve with &#39;finished&#39; flag // Normally this is not needed, just use &#39;$mdDialog.hide()&#39; to close // the most recent dialog popup. function closeAlert() { $mdDialog.hide( alert, &quot;finished&quot; ); alert = undefined; } // Dialog #2 - Demonstrate more complex dialogs construction and popup. function showCustomGreeting($event) { $mdDialog.show({ targetEvent: $event, template: &#39;\n<md-dialog>&#39; + &#39;<md-dialog-content>Hello {{ employee }}!</md-dialog-content>&#39; + &#39;<md-dialog-actions>\n&#39; + &#39;<md-button ng-click=\"closeDialog()\" class=\"md-primary\">&#39; + &#39; Close Greeting&#39; + &#39;\n</md-button>&#39; + &#39;</md-dialog-actions>&#39; + &#39;</md-dialog>\n&#39;, controller: &#39;GreetingController&#39;, onComplete: afterShowAnimation, locals: { employee: $scope.userName } }); // When the &#39;enter&#39; animation finishes... function afterShowAnimation(scope, element, options) { // post-show code here: DOM element focus, etc. } } // Dialog #3 - Demonstrate use of ControllerAs and passing $scope to dialog // Here we used ng-controller=&quot;GreetingController as vm&quot; and // $scope.vm ===\n<controller instance>\nfunction showCustomGreeting() { $mdDialog.show({ clickOutsideToClose: true, scope: $scope, // use parent scope in template preserveScope: true, // do not forget this if use parent scope // Since GreetingController is instantiated with ControllerAs syntax // AND we are passing the parent &#39;$scope&#39; to the dialog, we MUST // use &#39;vm.\n<xxx>&#39; in the template markup template: &#39;<md-dialog>&#39; + &#39;<md-dialog-content>\n&#39; + &#39; Hi There {{vm.employee}}&#39; + &#39;</md-dialog-content>&#39; + &#39;</md-dialog>\n&#39;, controller: function DialogController($scope, $mdDialog) { $scope.closeDialog = function() { $mdDialog.hide(); } } }); } } // Greeting controller used with the more complex &#39;showCustomGreeting()&#39; custom dialog function GreetingController($scope, $mdDialog, employee) { // Assigned from construction \n<code>locals</code>\n options... $scope.employee = employee; $scope.closeDialog = function() { // Easily hides most recent dialog shown... // no specific instance reference is needed. $mdDialog.hide(); }; } })(angular);\n</xxx></controller></hljs></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li \nid=\"alert\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdDialog.alert();</code></h3><div \nclass=\"service-desc\"><p>Builds a preconfigured dialog with the specified message.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>an <code>\n$mdDialogPreset</code> with the chainable configuration methods:</p><ul><li>\n$mdDialogPreset#title(string) - Sets the alert title.</li><li>\n$mdDialogPreset#textContent(string) - Sets the alert message.</li><li>\n$mdDialogPreset#htmlContent(string) - Sets the alert message as HTML. Requires ngSanitize module to be loaded. HTML is not run through Angular&#39;s compiler.\n</li><li>$mdDialogPreset#ok(string) - Sets the alert &quot;Okay&quot; button text.</li><li>\n$mdDialogPreset#theme(string) - Sets the theme of the alert dialog.</li><li>\n$mdDialogPreset#targetEvent(DOMClickEvent=) - A click&#39;s event object. When passed in as an option, the location of the click will be used as the starting point for the opening animation of the the dialog.\n</li></ul></td></tr></tbody></table></div></li><li id=\"confirm\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdDialog.confirm();</code></h3><div class=\"service-desc\"><p>\nBuilds a preconfigured dialog with the specified message. You can call show and the promise returned will be resolved only if the user clicks the confirm action on the dialog.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th>\n</tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td \nclass=\"description\"><p>an <code>$mdDialogPreset</code> with the chainable configuration methods:</p><p>\nAdditionally, it supports the following methods:</p><ul><li>$mdDialogPreset#title(string) - Sets the confirm title.\n</li><li>$mdDialogPreset#textContent(string) - Sets the confirm message.</li><li>\n$mdDialogPreset#htmlContent(string) - Sets the confirm message as HTML. Requires ngSanitize module to be loaded. HTML is not run through Angular&#39;s compiler.\n</li><li>$mdDialogPreset#ok(string) - Sets the confirm &quot;Okay&quot; button text.</li><li>\n$mdDialogPreset#cancel(string) - Sets the confirm &quot;Cancel&quot; button text.</li><li>\n$mdDialogPreset#theme(string) - Sets the theme of the confirm dialog.</li><li>\n$mdDialogPreset#targetEvent(DOMClickEvent=) - A click&#39;s event object. When passed in as an option, the location of the click will be used as the starting point for the opening animation of the the dialog.\n</li></ul></td></tr></tbody></table></div></li><li id=\"prompt\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdDialog.prompt();</code></h3><div class=\"service-desc\"><p>\nBuilds a preconfigured dialog with the specified message and input box. You can call show and the promise returned will be resolved only if the user clicks the prompt action on the dialog, passing the input value as the first argument.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th>\n</tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td \nclass=\"description\"><p>an <code>$mdDialogPreset</code> with the chainable configuration methods:</p><p>\nAdditionally, it supports the following methods:</p><ul><li>$mdDialogPreset#title(string) - Sets the prompt title.</li>\n<li>$mdDialogPreset#textContent(string) - Sets the prompt message.</li><li>\n$mdDialogPreset#htmlContent(string) - Sets the prompt message as HTML. Requires ngSanitize module to be loaded. HTML is not run through Angular&#39;s compiler.\n</li><li>$mdDialogPreset#placeholder(string) - Sets the placeholder text for the input.</li><li>\n$mdDialogPreset#initialValue(string) - Sets the initial value for the prompt input.</li><li>\n$mdDialogPreset#ok(string) - Sets the prompt &quot;Okay&quot; button text.</li><li>\n$mdDialogPreset#cancel(string) - Sets the prompt &quot;Cancel&quot; button text.</li><li>\n$mdDialogPreset#theme(string) - Sets the theme of the prompt dialog.</li><li>\n$mdDialogPreset#targetEvent(DOMClickEvent=) - A click&#39;s event object. When passed in as an option, the location of the click will be used as the starting point for the opening animation of the the dialog.\n</li></ul></td></tr></tbody></table></div></li><li id=\"show\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdDialog.show(optionsOrPreset);</code></h3><div class=\"service-desc\"><p>\nShow a dialog with the specified options.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead>\n<tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* optionsOrPreset</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>Either provide an <code>\n$mdDialogPreset</code> returned from <code>alert()</code>, and <code>confirm()</code>\n, or an options object with the following properties:</p><ul><li><code>templateUrl</code> - <code>{string=}</code>\n: The url of a template that will be used as the content of the dialog.</li><li><code>template</code> - <code>{string=}\n</code>: HTML template to show in the dialog. This <strong>must</strong> be trusted HTML with respect to Angular&#39;s \n<a href=\"https://docs.angularjs.org/api/ng/service/$sce\">$sce service</a>. This template should <strong>never</strong>\n be constructed with any kind of user input or user data.</li><li><code>contentElement</code> - <code>{string|Element}\n</code>: Instead of using a template, which will be compiled each time a dialog opens, you can also use a DOM element.\n<br><ul><li>When specifying an element, which is present on the DOM, <code>$mdDialog</code>\n will temporary fetch the element into the dialog and restores it at the old DOM position upon close.</li><li>\nWhen specifying a string, the string be used as a CSS selector, to lookup for the element in the DOM.</li></ul></li>\n<li><code>autoWrap</code> - <code>{boolean=}</code>: Whether or not to automatically wrap the template with a <code>\n&lt;md-dialog&gt;</code>\n tag if one is not provided. Defaults to true. Can be disabled if you provide a custom dialog directive.</li><li><code>\ntargetEvent</code> - <code>{DOMClickEvent=}</code>\n: A click&#39;s event object. When passed in as an option, the location of the click will be used as the starting point for the opening animation of the the dialog.\n</li><li><code>openFrom</code> - <code>{string|Element|object}</code>\n: The query selector, DOM element or the Rect object that is used to determine the bounds (top, left, height, width) from which the Dialog will originate.\n</li><li><code>closeTo</code> - <code>{string|Element|object}</code>\n: The query selector, DOM element or the Rect object that is used to determine the bounds (top, left, height, width) to which the Dialog will target.\n</li><li><code>scope</code> - <code>{object=}</code>\n: the scope to link the template / controller to. If none is specified, it will create a new isolate scope. This scope will be destroyed when the dialog is removed unless \n<code>preserveScope</code> is set to true.</li><li><code>preserveScope</code> - <code>{boolean=}</code>\n: whether to preserve the scope when the element is removed. Default is false</li><li><code>disableParentScroll</code>\n - <code>{boolean=}</code>: Whether to disable scrolling while the dialog is open. Default true.</li><li><code>\nhasBackdrop</code> - <code>{boolean=}</code>\n: Whether there should be an opaque backdrop behind the dialog. Default true.</li><li><code>clickOutsideToClose</code>\n - <code>{boolean=}</code>: Whether the user can click outside the dialog to close it. Default false.</li><li><code>\nescapeToClose</code> - <code>{boolean=}</code>: Whether the user can press escape to close the dialog. Default true.\n</li><li><code>focusOnOpen</code> - <code>{boolean=}</code>\n: An option to override focus behavior on open. Only disable if focusing some other way, as focus management is required for dialogs to be accessible. Defaults to true.\n</li><li><code>controller</code> - <code>{function|string=}</code>\n: The controller to associate with the dialog. The controller will be injected with the local <code>$mdDialog</code>\n, which passes along a scope for the dialog.</li><li><code>locals</code> - <code>{object=}</code>\n: An object containing key/value pairs. The keys will be used as names of values to inject into the controller. For example, \n<code>locals: {three: 3}</code> would inject <code>three</code> into the controller, with the value 3. If <code>\nbindToController</code> is true, they will be copied to the controller instead.</li><li><code>bindToController</code>\n - <code>bool</code>: bind the locals to the controller, instead of passing them in.</li><li><code>resolve</code> - \n<code>{object=}</code>\n: Similar to locals, except it takes promises as values, and the dialog will not open until all of the promises resolve.\n</li><li><code>controllerAs</code> - <code>{string=}</code>: An alias to assign the controller to on the scope.</li>\n<li><code>parent</code> - <code>{element=}</code>\n: The element to append the dialog to. Defaults to appending to the root element of the application.</li><li><code>\nonShowing</code> - <code>function(scope, element)</code>\n: Callback function used to announce the show() action is starting.</li><li><code>onComplete</code> - <code>\nfunction(scope, element)</code>: Callback function used to announce when the show() action is finished.</li><li><code>\nonRemoving</code> - <code>function(element, removePromise)</code>\n: Callback function used to announce the close/hide() action is starting. This allows developers to run custom animations in parallel the close animations.\n</li><li><code>fullscreen</code> <code>{boolean=}</code>\n: An option to toggle whether the dialog should show in fullscreen or not. Defaults to <code>false</code>.</li></ul>\n</td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise</code></td><td class=\"description\"><p>\nA promise that can be resolved with <code>$mdDialog.hide()</code> or rejected with <code>$mdDialog.cancel()</code>.</p>\n</td></tr></tbody></table></div></li><li id=\"hide\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdDialog.hide([response]);</code></h3><div class=\"service-desc\"><p>\nHide an existing dialog and resolve the promise returned from <code>$mdDialog.show()</code>.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">response <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>\nAn argument for the resolved promise.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns\n</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise\n</code></td><td class=\"description\"><p>A promise that is resolved when the dialog has been closed.</p></td></tr>\n</tbody></table></div></li><li id=\"cancel\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdDialog.cancel([response]);</code></h3><div class=\"service-desc\"><p>\nHide an existing dialog and reject the promise returned from <code>$mdDialog.show()</code>.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">response <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>\nAn argument for the rejected promise.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns\n</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise\n</code></td><td class=\"description\"><p>A promise that is resolved when the dialog has been closed.</p></td></tr>\n</tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.chips/directive/mdChip.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>&lt;md-chip&gt;</code> is a component used within <code>&lt;md-chips&gt;\n</code> and is responsible for rendering individual chips.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">\nUsage</h2><hljs lang=\"html\"><md-chip>{{$chip}}</md-chip></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.chips/directive/mdChipRemove.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>Designates an element to be used as the delete button for a chip.<br>\nThis element is passed as a child of the <code>md-chips</code> element.</p><p>\nThe designated button will be just appended to the chip and removes the given chip on click.<br>\nBy default the button is not being styled by the <code>md-chips</code> component.</p></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-chips><button md-chip-remove=\"\"><md-icon \nmd-svg-icon=\"md-close\"></md-icon></button></md-chips></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.chips/directive/mdChips.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>&lt;md-chips&gt;</code>\n is an input component for building lists of strings or objects. The list items are displayed as &#39;chips&#39;. This component can make use of an \n<code>&lt;input&gt;</code> element or an <code>&lt;md-autocomplete&gt;</code> element.</p><h3 id=\"custom-templates\">\nCustom templates</h3><p>\nA custom template may be provided to render the content of each chip. This is achieved by specifying an <code>\n&lt;md-chip-template&gt;</code> element containing the custom content as a child of <code>&lt;md-chips&gt;</code>.</p>\n<p>Note: Any attributes on <code>&lt;md-chip-template&gt;</code>\n will be dropped as only the innerHTML is used for the chip template. The variables <code>$chip</code> and <code>$index\n</code> are available in the scope of <code>&lt;md-chip-template&gt;</code>\n, representing the chip object and its index in the list of chips, respectively. To override the chip delete control, include an element (ideally a button) with the attribute \n<code>md-chip-remove</code>\n. A click listener to remove the chip will be added automatically. The element is also placed as a sibling to the chip content (on which there are also click listeners) to avoid a nested ng-click situation.\n</p><p></p><h3>Pending Features</h3><p></p><ul style=\"padding-left:20px\"><ul>Style<li>\nColours for hover, press states (ripple?).</li></ul><ul>Validation<li>allow a validation callback</li><li>\nhilighting style for invalid chips</li></ul><ul>Item mutation<li>Support <code>&lt;md-chip-edit&gt;</code>\n template, show/hide the edit element on tap/click? double tap/double click?</li></ul><ul>\nTruncation and Disambiguation (?)<li>\nTruncate chip text where possible, but do not truncate entries such that two are indistinguishable.</li></ul><ul>\nDrag and Drop<li>Drag and drop chips between related <code>&lt;md-chips&gt;</code> elements.</li></ul></ul><p><span \nstyle=\"font-size:.8em;text-align:center\">\nWarning: This component is a WORK IN PROGRESS. If you use it now, it will probably break on you in the future. </span>\n</p><p>Sometimes developers want to limit the amount of possible chips.<br>\nYou can specify the maximum amount of chips by using the following markup.</p><hljs lang=\"html\"><md-chips \nng-model=\"myItems\" placeholder=\"Add an item\" md-max-chips=\"5\"></md-chips></hljs><p>\nIn some cases, you have an autocomplete inside of the <code>md-chips</code>.<br>\nWhen the maximum amount of chips has been reached, you can also disable the autocomplete selection.<br>\nHere is an example markup.</p><hljs lang=\"html\"><md-chips ng-model=\"myItems\" md-max-chips=\"5\"><md-autocomplete \nng-hide=\"myItems.length > 5\" ...></md-autocomplete></md-chips></hljs></div><div><section class=\"api-section\"><h2 \nid=\"Usage\">Usage</h2><hljs lang=\"html\"><md-chips ng-model=\"myItems\" placeholder=\"Add an item\" readonly=\"isReadOnly\">\n</md-chips></hljs><p></p><h3>Validation</h3>When using <a href=\"https://docs.angularjs.org/api/ngMessages\">ngMessages\n</a>, you can show errors based on our custom validators.<p></p><hljs lang=\"html\"><form name=\"userForm\"><md-chips \nname=\"fruits\" ng-model=\"myItems\" placeholder=\"Add an item\" md-max-chips=\"5\"></md-chips><div \nng-messages=\"userForm.fruits.$error\" ng-if=\"userForm.$dirty\"><div ng-message=\"md-max-chips\">\nYou reached the maximum amount of chips</div></div></form></hljs></section><div class=\"api-param-section\"><h2>\nAttributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* ng-model</b> <span\n hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code><code class=\"api-type label type-hint type-hint-object\">\nobject</code></td><td class=\"description\"><p>A model to bind the list of items to</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-transform-chip</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nAn expression of form <code>myFunction($chip)</code> that when called expects one of the following return values:</p>\n<ul><li>an object representing the <code>$chip</code> input string</li><li><code>undefined</code> to simply add the \n<code>$chip</code> input string, or</li><li><code>null</code> to prevent the chip from being appended</li></ul></td>\n</tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-require-match</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nIf true, and the chips template contains an autocomplete, only allow selection of pre-defined chips (i.e. you cannot add new ones).\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">placeholder <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nPlaceholder text that will be forwarded to the input.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">secondary-placeholder <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nPlaceholder text that will be forwarded to the input, displayed when there is at least one item in the list</p></td>\n</tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-removable <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nEnables or disables the deletion of chips through the removal icon or the Delete/Backspace key. Defaults to true.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">readonly <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nDisables list manipulation (deleting or adding list items), hiding the input and delete buttons. If no <code>ng-model\n</code> is provided, the chips will automatically be marked as readonly.<br><br>When <code>md-removable</code>\n is not defined, the <code>md-remove</code> behavior will be overwritten and disabled.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-enable-chip-edit <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nSet this to &quot;true&quot; to enable editing of chip contents. The user can go into edit mode with pressing &quot;space&quot;, &quot;enter&quot;, or double clicking on the chip. Chip edit is only supported for chips with basic template.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-max-chips <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nThe maximum number of chips allowed to add through user input.<br><br>The validation property <code>md-max-chips</code>\n can be used when the max chips amount is reached.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-add-on-blur <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></td><td class=\"description\"><p>\nWhen set to true, remaining text inside of the input will be converted into a new chip on blur.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-on-add <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nAn expression which will be called when a chip has been added.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-on-remove <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nAn expression which will be called when a chip has been removed.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-on-select <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nAn expression which will be called when a chip is selected.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">delete-hint <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>\nA string read by screen readers instructing users that pressing the delete key will remove the chip.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">delete-button-label <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nA label for the delete button. Also hidden and read by screen readers.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-separator-keys <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nAn array of key codes used to separate chips.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.chips/directive/mdContactChips.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>&lt;md-contact-chips&gt;</code> is an input component based on <code>md-chips\n</code> and makes use of an <code>md-autocomplete</code>\n element. The component allows the caller to supply a query expression which returns a list of possible contacts. The user can select one of these and add it to the list of chips.\n</p><p>You may also use the <code>md-highlight-text</code>\n directive along with its parameters to control the appearance of the matched text inside of the contacts&#39; autocomplete popup.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-contact-chips \nng-model=\"ctrl.contacts\" md-contacts=\"ctrl.querySearch($query)\" md-contact-name=\"name\" md-contact-image=\"image\" \nmd-contact-email=\"email\" placeholder=\"To\"></md-contact-chips></hljs></section><div class=\"api-param-section\"><h2>\nAttributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* ng-model</b> <span\n hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code><code class=\"api-type label type-hint type-hint-object\">\nobject</code></td><td class=\"description\"><p>A model to bind the list of items to</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-contacts</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nAn expression expected to return contacts matching the search test, <code>$query</code>\n. If this expression involves a promise, a loading bar is displayed while waiting for it to resolve.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-contact-name</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThe field name of the contact object representing the contact&#39;s name.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* md-contact-email</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThe field name of the contact object representing the contact&#39;s email address.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-contact-image</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThe field name of the contact object representing the contact&#39;s image.</p></td></tr><tr class=\"api-params-item\"><td\n style=\"white-space: nowrap\">placeholder <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>Placeholder text that will be forwarded to the input.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">secondary-placeholder <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nPlaceholder text that will be forwarded to the input, displayed when there is at least on item in the list</p></td>\n</tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">filter-selected <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nWhether to filter selected contacts from the list of suggestions shown in the autocomplete. This attribute has been removed but may come back.\n</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.colors/service/$mdColors.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nWith only defining themes, one couldn&#39;t get non ngMaterial elements colored with Material colors, <code>$mdColors\n</code>\n service is used by the md-color directive to convert the 1..n color expressions to RGBA values and will apply those values to element as CSS property values.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">\nangular.controller(&#39;myCtrl&#39;, function ($mdColors) { var color = $mdColors.getThemeColor(&#39;myTheme-red-200-0.5&#39;); ... });\n</hljs></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"applyThemeColors\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdColors.applyThemeColors(element, colorExpression);</code></h3><div class=\"service-desc\"><p>\nGets a color json object, keys are css properties and values are string of the wanted color Then calculate the rgba() values based on the theme color parts\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* element</b> <span \nhide show-sm><code class=\"api-type label type-hint type-hint-domelement\">DOMElement</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-domelement\">DOMElement</code></td><td \nclass=\"description\"><p>the element to apply the styles on.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* colorExpression</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>\njson object, keys are css properties and values are string of the wanted color, for example: <code>\n{color: &#39;red-A200-0.3&#39;}</code>.</p></td></tr></tbody></table></div></li><li id=\"getThemeColor\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdColors.getThemeColor(expression);</code></h3>\n<div class=\"service-desc\"><p>Get parsed color from expression</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* expression</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nstring of a color expression (for instance <code>&#39;red-700-0.8&#39;</code>)</p></td></tr></tbody></table><table \nclass=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\na css color expression (for instance <code>rgba(211, 47, 47, 0.8)</code>)</p></td></tr></tbody></table></div></li></ul>\n</section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabActions/directive/mdFabActions.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-fab-actions&gt;</code> directive is used inside of a <code>\n&lt;md-fab-speed-dial&gt;</code> or <code>&lt;md-fab-toolbar&gt;</code>\n directive to mark an element (or elements) as the actions and setup the proper event listeners.</p></div><div><section\n class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>See the <code>&lt;md-fab-speed-dial&gt;</code> or <code>\n&lt;md-fab-toolbar&gt;</code> directives for example usage.</p></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabSpeedDial/directive/mdFabSpeedDial.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-fab-speed-dial&gt;</code>\n directive is used to present a series of popup elements (usually <code>&lt;md-button&gt;</code>\ns) for quick access to common actions.</p><p>\nThere are currently two animations available by applying one of the following classes to the component:</p><ul><li>\n<code>md-fling</code>\n - The speed dial items appear from underneath the trigger and move into their appropriate positions.</li><li><code>\nmd-scale</code> - The speed dial items appear in their proper places by scaling from 0% to 100%.</li></ul><p>\nYou may also easily position the trigger by applying one one of the following classes to the <code>\n&lt;md-fab-speed-dial&gt;</code> element:</p><ul><li><code>md-fab-top-left</code></li><li><code>md-fab-top-right</code>\n</li><li><code>md-fab-bottom-left</code></li><li><code>md-fab-bottom-right</code></li></ul><p>These CSS classes use \n<code>position: absolute</code>, so you need to ensure that the container element also uses <code>position: absolute\n</code> or <code>position: relative</code> in order for them to work.</p><p>Additionally, you may use the standard \n<code>ng-mouseenter</code> and <code>ng-mouseleave</code>\n directives to open or close the speed dial. However, if you wish to allow users to hover over the empty space where the actions will appear, you must also add the \n<code>md-hover-full</code>\n class to the speed dial element. Without this, the hover effect will only occur on top of the trigger.</p><p>\nSee the demos for more information.</p><h2 id=\"troubleshooting\">Troubleshooting</h2><p>\nIf your speed dial shows the closing animation upon launch, you may need to use <code>ng-cloak</code>\n on the parent container to ensure that it is only visible once ready. We have plans to remove this necessity in the future.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-fab-speed-dial \nmd-direction=\"up\" class=\"md-fling\"><md-fab-trigger><md-button aria-label=\"Add...\"><md-icon \nicon=\"/assets/angular-material-assets/img/icons/plus.svg\"></md-icon></md-button></md-fab-trigger><md-fab-actions>\n<md-button aria-label=\"Add User\"><md-icon icon=\"/assets/angular-material-assets/img/icons/user.svg\"></md-icon>\n</md-button><md-button aria-label=\"Add Group\"><md-icon icon=\"/assets/angular-material-assets/img/icons/group.svg\">\n</md-icon></md-button></md-fab-actions></md-fab-speed-dial></hljs></section><div class=\"api-param-section\"><h2>\nAttributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-direction</b> \n<span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>From which direction you would like the speed dial to appear relative to the trigger element.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-open <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nProgrammatically control whether or not the speed-dial is visible.</p></td></tr></tbody></table></div></div></div>\n</div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.icon/directive/mdIcon.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>md-icon</code>\n directive makes it easier to use vector-based icons in your app (as opposed to raster-based icons types like PNG). The directive supports both icon fonts and SVG icons.\n</p><p>Icons should be considered view-only elements that should not be used directly as buttons; instead nest a <code>\n&lt;md-icon&gt;</code> inside a <code>md-button</code> to add hover and click features.</p><h3 id=\"icon-fonts\">\nIcon fonts</h3><p>\nIcon fonts are a technique in which you use a font where the glyphs in the font are your icons instead of text. Benefits include a straightforward way to bundle everything into a single HTTP request, simple scaling, easy color changing, and more.\n</p><p><code>md-icon</code>\n lets you consume an icon font by letting you reference specific icons in that font by name rather than character code.\n</p><h3 id=\"svg\">SVG</h3><p>For SVGs, the problem with using <code>&lt;img&gt;</code> or a CSS <code>background-image\n</code>\n is that you can&#39;t take advantage of some SVG features, such as styling specific parts of the icon with CSS or SVG animation.\n</p><p><code>md-icon</code> makes it easier to use SVG icons by <em>inlining</em> the SVG into an <code>&lt;svg&gt;\n</code>\n element in the document. The most straightforward way of referencing an SVG icon is via URL, just like a traditional \n<code>&lt;img&gt;</code>. <code>$mdIconProvider</code>, as a convenience, lets you <em>name</em>\n an icon so you can reference it by name instead of URL throughout your templates.</p><p>\nAdditionally, you may not want to make separate HTTP requests for every icon, so you can bundle your SVG icons together and pre-load them with $mdIconProvider as an icon set. An icon set can also be given a name, which acts as a namespace for individual icons, so you can reference them like \n<code>&quot;social:cake&quot;</code>.</p><p>\nWhen using SVGs, both external SVGs (via URLs) or sets of SVGs [from icon sets] can be easily loaded and used.When use font-icons, developers must following three (3) simple steps:\n</p><ol><li>Load the font library. e.g.<br><code>\n&lt;link href=&quot;https://fonts.googleapis.com/icon?family=Material+Icons&quot; rel=&quot;stylesheet&quot;&gt;</code>\n</li><li>Use either (a) font-icon class names or (b) font ligatures to render the font glyph by using its textual name\n</li><li>Use <code>&lt;md-icon md-font-icon=&quot;classname&quot; /&gt;</code> or<br>use <code>\n&lt;md-icon md-font-set=&quot;font library classname or alias&quot;&gt; textual_name &lt;/md-icon&gt;</code> or<br>use \n<code>\n&lt;md-icon md-font-set=&quot;font library classname or alias&quot;&gt; numerical_character_reference &lt;/md-icon&gt;\n</code></li></ol><p>Full details for these steps can be found:</p><ul><li><a \nhref=\"http://google.github.io/material-design-icons/\">http://google.github.io/material-design-icons/</a></li><li><a \nhref=\"http://google.github.io/material-design-icons/#icon-font-for-the-web\">\nhttp://google.github.io/material-design-icons/#icon-font-for-the-web</a></li></ul><p>The Material Design icon style \n<code>.material-icons</code> and the icon font references are published in Material Design Icons:</p><ul><li><a \nhref=\"https://design.google.com/icons/\">https://design.google.com/icons/</a></li><li><a \nhref=\"https://design.google.com/icons/#ic_accessibility\">https://design.google.com/icons/#ic_accessibility</a></li>\n</ul><p></p><h2 id=\"material_design_icons\">Material Design Icons</h2>\nUsing the Material Design Icon-Selector, developers can easily and quickly search for a Material Design font-icon and determine its textual name and character reference code. Click on any icon to see the slide-up information panel with details regarding a SVG download or information on the font-icon usage.\n<p></p><p><a href=\"https://www.google.com/design/icons/#ic_accessibility\" target=\"_blank\" style=\"border-bottom:none\">\n<img src=\"https://cloud.githubusercontent.com/assets/210413/7902490/fe8dd14c-0780-11e5-98fb-c821cc6475e6.png\" \naria-label=\"Material Design Icon-Selector\" style=\"max-width:75%;padding-left:10%\"> </a></p><p><span \nclass=\"image_caption\">Click on the image above to link to the <a \nhref=\"https://design.google.com/icons/#ic_accessibility\" target=\"_blank\">Material Design Icon-Selector</a>. </span></p>\n</div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>When using SVGs:</p><hljs lang=\"html\"><md-icon \nmd-svg-icon=\"social:android\" aria-label=\"android \"></md-icon><md-icon md-svg-src=\"/android.svg\" aria-label=\"android \">\n</md-icon><md-icon md-svg-src=\"{{ getAndroid() }}\" aria-label=\"android \"></md-icon></hljs><p>Use the <code>\n$mdIconProvider</code> to configure your application with svg iconsets.</p><hljs lang=\"js\">\nangular.module(&#39;appSvgIconSets&#39;, [&#39;ngMaterial&#39;]) .controller(&#39;DemoCtrl&#39;, function($scope) {}) .config(function($mdIconProvider) { $mdIconProvider .iconSet(&#39;social&#39;, &#39;assets/angular-material-assets/img/icons/sets/social-icons.svg&#39;, 24) .defaultIconSet(&#39;assets/angular-material-assets/img/icons/sets/core-icons.svg&#39;, 24); });\n</hljs><p>When using Font Icons with classnames:</p><hljs lang=\"html\"><md-icon md-font-icon=\"android\" \naria-label=\"android\"></md-icon><md-icon class=\"icon_home\" aria-label=\"Home\"></md-icon></hljs><p>\nWhen using Material Font Icons with ligatures:</p><hljs lang=\"html\"><md-icon>face</md-icon><md-icon \nmd-font-set=\"material-icons\">face</md-icon><md-icon>&#xE87C;</md-icon><md-icon class=\"material-icons md-light md-48\">\nface</md-icon></hljs><p>When using other Font-Icon libraries:</p><hljs lang=\"js\">\n// Specify a font-icon style alias angular.config(function($mdIconProvider) { $mdIconProvider.fontSet(&#39;md&#39;, &#39;material-icons&#39;); });\n</hljs><hljs lang=\"html\"><md-icon md-font-set=\"md\">favorite</md-icon></hljs></section><div class=\"api-param-section\">\n<h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th>\n<th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-font-icon\n</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>\nString name of CSS icon associated with the font-face will be used to render the icon. Requires the fonts and the named CSS styles to be preloaded.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-font-set</b> <span hide show-sm><code\n class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nCSS style name associated with the font library; which will be assigned as the class for the font-icon ligature. This value may also be an alias that is used to lookup the classname; internally use \n<code>$mdIconProvider.fontSet(&lt;alias&gt;)</code> to determine the style name.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-svg-src</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nString URL (or expression) used to load, cache, and display an external SVG.</p></td></tr><tr class=\"api-params-item\">\n<td style=\"white-space: nowrap\"><b>* md-svg-icon</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nmd-svg-icon String name used for lookup of the icon from the internal cache; interpolated strings or expressions may also be used. Specific set names can be used with the syntax \n<code>&lt;set name&gt;:&lt;icon name&gt;</code>.<br><br>\nTo use icon sets, developers are required to pre-register the sets using the <code>$mdIconProvider</code> service.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">aria-label <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nLabels icon for accessibility. If an empty string is provided, icon will be hidden from accessibility layer with <code>\naria-hidden=&quot;true&quot;</code>\n. If there&#39;s no aria-label on the icon nor a label on the parent element, a warning will be logged to the console.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">alt <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nLabels icon for accessibility. If an empty string is provided, icon will be hidden from accessibility layer with <code>\naria-hidden=&quot;true&quot;</code>\n. If there&#39;s no alt on the icon nor a label on the parent element, a warning will be logged to the console.</p>\n</td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.icon/service/$mdIcon.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>$mdIcon</code> service is a function used to lookup SVG icons.</p></div>\n<div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">\nfunction SomeDirective($mdIcon) { // See if the icon has already been loaded, if not // then lookup the icon from the registry cache, load and cache // it for future requests. // NOTE: ID queries require configuration with $mdIconProvider $mdIcon(&#39;android&#39;).then(function(iconEl) { element.append(iconEl); }); $mdIcon(&#39;work:chair&#39;).then(function(iconEl) { element.append(iconEl); }); // Load and cache the external SVG using a URL $mdIcon(&#39;assets/angular-material-assets/img/icons/android.svg&#39;).then(function(iconEl) { element.append(iconEl); }); };\n</hljs><blockquote><p><b>Note:</b> The <code>&lt;md-icon&gt;</code> directive internally uses the <code>$mdIcon</code>\n service to query, loaded, and instantiate SVG DOM elements.</p></blockquote></section><section class=\"api-section\">\n<div class=\"api-param-section\"><h2>Arguments</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr>\n<th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* id</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>\nQuery value for a unique Id or URL. If the argument is a URL, then the service will retrieve the icon element from its internal cache or load the icon and cache it first. If the value is not a URL-type string, then an ID lookup is performed. The Id may be a unique icon ID or may include an iconSet ID prefix.\n</p><p>For the <strong>id</strong>\n query to work properly, this means that all id-to-URL mappings must have been previously configured using the <code>\n$mdIconProvider</code>.</p></td></tr></tbody></table></div></div><section class=\"api-section\"></section><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody>\n<tr><td><code class=\"api-type label type-hint type-hint-angular\">angular.$q.Promise</code></td><td class=\"description\">\n<p>\nA promise that gets resolved to a clone of the initial SVG DOM element; which was created from the SVG markup in the SVG data file. If an error occurs (e.g. the icon cannot be found) the promise will get rejected.\n</p></td></tr></tbody></table></div></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.icon/service/$mdIconProvider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>$mdIconProvider</code>\n is used only to register icon IDs with URLs. These configuration features allow icons and icon sets to be pre-registered and associated with source URLs \n<strong>before</strong> the <code>&lt;md-icon /&gt;</code> directives are compiled.</p><p>\nIf using font-icons, the developer is responsible for loading the fonts.</p><p>\nIf using SVGs, loading of the actual svg files are deferred to on-demand requests and are loaded internally by the \n<code>$mdIcon</code> service using the <code>$templateRequest</code> service. When an SVG is requested by name/ID, the \n<code>$mdIcon</code>\n service searches its registry for the associated source URL; that URL is used to on-demand load and parse the SVG dynamically.\n</p><p>The <code>$templateRequest</code> service expects the icons source to be loaded over trusted URLs.<br>\nThis means, when loading icons from an external URL, you have to trust the URL in the <code>$sceDelegateProvider</code>\n.</p><hljs lang=\"js\">\napp.config(function($sceDelegateProvider) { $sceDelegateProvider.resourceUrlWhitelist([ // Adding &#39;self&#39; to the whitelist, will allow requests from the current origin. &#39;self&#39;, // Using double asterisks here, will allow all URLs to load. // We recommend to only specify the given domain you want to allow. &#39;**&#39; ]); });\n</hljs><p>Read more about the <a href=\"https://docs.angularjs.org/api/ng/provider/$sceDelegateProvider\">\n$sceDelegateProvider</a>.</p><p><strong>Notice:</strong>\n Most font-icons libraries do not support ligatures (for example <code>fontawesome</code>).<br>\nIn such cases you are not able to use the icon&#39;s ligature name - Like so:</p><hljs lang=\"html\"><md-icon \nmd-font-set=\"fa\">fa-bell</md-icon></hljs><p>You should instead use the given unicode, instead of the ligature name.</p>\n<p></p><p ng-hide=\"true\">##// Notice we can&#39;t use a hljs element here, because the characters will be escaped.</p>\n<p></p><pre><code class=\"lang-html\">&lt;md-icon md-font-set=&quot;fa&quot;&gt;&amp;#xf0f3&lt;/md-icon&gt;\n</code></pre>\n<p>All unicode ligatures are prefixed with the <code>&amp;#x</code> string.</p></div><div><section class=\"api-section\">\n<h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">\napp.config(function($mdIconProvider) { // Configure URLs for icons specified by [set:]id. $mdIconProvider .defaultFontSet( &#39;fa&#39; ) // This sets our default fontset className. .defaultIconSet(&#39;my/app/icons.svg&#39;) // Register a default set of SVG icons .iconSet(&#39;social&#39;, &#39;my/app/social.svg&#39;) // Register a named icon set of SVGs .icon(&#39;android&#39;, &#39;my/app/android.svg&#39;) // Register a specific icon (by name) .icon(&#39;work:chair&#39;, &#39;my/app/chair.svg&#39;); // Register icon in a specific set });\n</hljs><p>\nSVG icons and icon sets can be easily pre-loaded and cached using either (a) a build process or (b) a runtime <strong>\nstartup</strong> process (shown below):</p><hljs lang=\"js\">\napp.config(function($mdIconProvider) { // Register a default set of SVG icon definitions $mdIconProvider.defaultIconSet(&#39;my/app/icons.svg&#39;) }) .run(function($templateRequest){ // Pre-fetch icons sources by URL and cache in the $templateCache... // subsequent $templateRequest calls will look there first. var urls = [ &#39;imy/app/icons.svg&#39;, &#39;assets/angular-material-assets/img/icons/android.svg&#39;]; angular.forEach(urls, function(url) { $templateRequest(url); }); });\n</hljs><blockquote><p><b>Note:</b> The loaded SVG data is subsequently cached internally for future requests.</p>\n</blockquote></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"icon\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdIconProvider.icon(id, url, [viewBoxSize]);\n</code></h3><div class=\"service-desc\"><p>\nRegister a source URL for a specific icon name; the name may include optional &#39;icon set&#39; name prefix. These icons will later be retrieved from the cache using \n<code>$mdIcon( &lt;icon name&gt; )</code></p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead>\n<tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* id</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>Icon name/id used to register the icon</p></td></tr><tr class=\"api-params-item\">\n<td style=\"white-space: nowrap\"><b>* url</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nspecifies the external location for the data file. Used internally by <code>$templateRequest</code>\n to load the data or as part of the lookup in <code>$templateCache</code> if pre-loading was configured.</p></td></tr>\n<tr class=\"api-params-item\"><td style=\"white-space: nowrap\">viewBoxSize <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nSets the width and height the icon&#39;s viewBox. It is ignored for icons with an existing viewBox. Default size is 24.\n</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>an <code>\n$mdIconProvider</code> reference; used to support method call chains for the API</p></td></tr></tbody></table></div>\n</li><li id=\"iconSet\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdIconProvider.iconSet(id, url, [viewBoxSize]);</code></h3><div class=\"service-desc\"><p>\nRegister a source URL for a &#39;named&#39; set of icons; group of SVG definitions where each definition has an icon id. Individual icons can be subsequently retrieved from this cached set using \n<code>$mdIcon(&lt;icon set name&gt;:&lt;icon name&gt;)</code></p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* id</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nIcon name/id used to register the iconset</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>\n* url</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>specifies the external location for the data file. Used internally by <code>$templateRequest\n</code> to load the data or as part of the lookup in <code>$templateCache</code> if pre-loading was configured.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">viewBoxSize <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nSets the width and height of the viewBox of all icons in the set. It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size. Default value is 24.\n</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>an <code>\n$mdIconProvider</code> reference; used to support method call chains for the API</p></td></tr></tbody></table></div>\n</li><li id=\"defaultIconSet\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdIconProvider.defaultIconSet(url, [viewBoxSize]);</code></h3><div class=\"service-desc\"><p>\nRegister a source URL for the default &#39;named&#39; set of icons. Unless explicitly registered, subsequent lookups of icons will failover to search this &#39;default&#39; icon set. Icon can be retrieved from this cached, default set using \n<code>$mdIcon(&lt;name&gt;)</code></p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* url</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>specifies the external location for the data file. Used internally by <code>\n$templateRequest</code> to load the data or as part of the lookup in <code>$templateCache</code>\n if pre-loading was configured.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">viewBoxSize \n<span hide show-sm><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td \nclass=\"description\"><p>\nSets the width and height of the viewBox of all icons in the set. It is ignored for icons with an existing viewBox. All icons in the icon set should be the same size. Default value is 24.\n</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>an <code>\n$mdIconProvider</code> reference; used to support method call chains for the API</p></td></tr></tbody></table></div>\n</li><li id=\"defaultFontSet\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdIconProvider.defaultFontSet(name);</code></h3><div class=\"service-desc\"><p>\nWhen using Font-Icons, Angular Material assumes the the Material Design icons will be used and automatically configures the default font-set == &#39;material-icons&#39;. Note that the font-set references the font-icon library class style that should be applied to the \n<code>&lt;md-icon&gt;</code>.</p><p>Configuring the default means that the attributes <code>\nmd-font-set=&quot;material-icons&quot;</code> or <code>class=&quot;material-icons&quot;</code>\n do not need to be explicitly declared on the <code>&lt;md-icon&gt;</code> markup. For example:</p><p><code>\n&lt;md-icon&gt; face &lt;/md-icon&gt;</code> will render as <code>\n&lt;span class=&quot;material-icons&quot;&gt; face &lt;/span&gt;</code>, and</p><p><code>\n&lt;md-icon md-font-set=&quot;fa&quot;&gt; face &lt;/md-icon&gt;</code> will render as <code>\n&lt;span class=&quot;fa&quot;&gt; face &lt;/span&gt;</code></p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* name</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nof the font-library style that should be applied to the md-icon DOM element</p></td></tr></tbody></table></div></li><li\n id=\"fontSet\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdIconProvider.fontSet(alias, className);</code></h3><div class=\"service-desc\"><p>When using a font set for <code>\n&lt;md-icon&gt;</code> you must specify the correct font classname in the <code>md-font-set</code>\n attribute. If the fonset className is really long, your markup may become cluttered... an easy solution is to define an \n<code>alias</code> for your fontset:</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr>\n<th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* alias</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>of the specified fontset.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* className</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>of the fontset.</p></td>\n</tr></tbody></table></div></li><li id=\"defaultViewBoxSize\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdIconProvider.defaultViewBoxSize([viewBoxSize]);</code></h3><div class=\"service-desc\">\n<p>While <code>&lt;md-icon /&gt;</code>\n markup can also be style with sizing CSS, this method configures the default width <strong>and</strong>\n height used for all icons; unless overridden by specific CSS. The default sizing is (24px, 24px).</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">viewBoxSize <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nSets the width and height of the viewBox for an icon or an icon set. All icons in a set should be the same size. The default value is 24.\n</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>an <code>\n$mdIconProvider</code> reference; used to support method call chains for the API</p></td></tr></tbody></table></div>\n</li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.gridList/directive/mdGridList.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nGrid lists are an alternative to standard list views. Grid lists are distinct from grids used for layouts and other visual presentations.\n</p><p>\nA grid list is best suited to presenting a homogenous data type, typically images, and is optimized for visual comprehension and differentiating between like data types.\n</p><p>\nA grid list is a continuous element consisting of tessellated, regular subdivisions called cells that contain tiles (\n<code>md-grid-tile</code>).</p><p><img \nsrc=\"//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7OVlEaXZ5YmU1Xzg/components_grids_usage2.png\" \nstyle=\"width: 300px; height: auto; margin-right: 16px\" alt=\"Concept of grid explained visually\"> <img \nsrc=\"//material-design.storage.googleapis.com/publish/v_2/material_ext_publish/0Bx4BSt6jniD7VGhsOE5idWlJWXM/components_grids_usage3.png\" \nstyle=\"width: 300px; height: auto\" alt=\"Grid concepts legend\"></p><p>\nCells are arrayed vertically and horizontally within the grid.</p><p>\nTiles hold content and can span one or more cells vertically or horizontally.</p><h3 id=\"responsive-attributes\">\nResponsive Attributes</h3><p>The <code>md-grid-list</code>\n directive supports &quot;responsive&quot; attributes, which allow different <code>md-cols</code>, <code>md-gutter\n</code> and <code>md-row-height</code> values depending on the currently matching media query.</p><p>\nIn order to set a responsive attribute, first define the fallback value with the standard attribute name, then add additional attributes with the following convention: \n<code>{base-attribute-name}-{media-query-name}=&quot;{value}&quot;</code> (ie. <code>md-cols-lg=&quot;8&quot;</code>)\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>Basic:</p><hljs lang=\"html\"><md-grid-list \nmd-cols=\"5\" md-gutter=\"1em\" md-row-height=\"4:3\"><md-grid-tile></md-grid-tile></md-grid-list></hljs><p>\nFixed-height rows:</p><hljs lang=\"html\"><md-grid-list md-cols=\"4\" md-row-height=\"200px\" ...><md-grid-tile>\n</md-grid-tile></md-grid-list></hljs><p>Fit rows:</p><hljs lang=\"html\"><md-grid-list md-cols=\"4\" md-row-height=\"fit\" \nstyle=\"height: 400px\" ...><md-grid-tile></md-grid-tile></md-grid-list></hljs><p>Using responsive attributes:</p><hljs \nlang=\"html\"><md-grid-list md-cols-sm=\"2\" md-cols-md=\"4\" md-cols-lg=\"8\" md-cols-gt-lg=\"12\" ...><md-grid-tile>\n</md-grid-tile></md-grid-list></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-cols</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nNumber of columns in the grid.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>\n* md-row-height</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span>\n</td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>One of</p><ul><li>CSS length - Fixed height rows (eg. <code>8px</code> or <code>1rem</code>)\n</li><li><code>{width}:{height}</code> - Ratio of width to height (eg. <code>md-row-height=&quot;16:9&quot;</code>)\n</li><li><code>&quot;fit&quot;</code>\n - Height will be determined by subdividing the available height by the number of rows</li></ul></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-gutter <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThe amount of space between tiles in CSS units (default 1px)</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-on-layout <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nExpression to evaluate after layout. Event object is available as <code>$event</code>\n, and contains performance information.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.gridList/directive/mdGridTile.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>Tiles contain the content of an <code>md-grid-list</code>\n. They span one or more grid cells vertically or horizontally, and use <code>md-grid-tile-{footer,header}</code>\n to display secondary content.</p><h3 id=\"responsive-attributes\">Responsive Attributes</h3><p>The <code>md-grid-tile\n</code> directive supports &quot;responsive&quot; attributes, which allow different <code>md-rowspan</code> and <code>\nmd-colspan</code> values depending on the currently matching media query.</p><p>\nIn order to set a responsive attribute, first define the fallback value with the standard attribute name, then add additional attributes with the following convention: \n<code>{base-attribute-name}-{media-query-name}=&quot;{value}&quot;</code> (ie. <code>md-colspan-sm=&quot;4&quot;</code>\n)</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>With header:</p><hljs lang=\"html\">\n<md-grid-tile><md-grid-tile-header><h3>This is a header</h3></md-grid-tile-header></md-grid-tile></hljs><p>With footer:\n</p><hljs lang=\"html\"><md-grid-tile><md-grid-tile-footer><h3>This is a footer</h3></md-grid-tile-footer></md-grid-tile>\n</hljs><p>Spanning multiple rows/columns:</p><hljs lang=\"html\"><md-grid-tile md-colspan=\"2\" md-rowspan=\"3\">\n</md-grid-tile></hljs><p>Responsive attributes:</p><hljs lang=\"html\"><md-grid-tile md-colspan=\"1\" md-colspan-sm=\"3\" \nmd-colspan-md=\"5\"></md-grid-tile></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-colspan <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nThe number of columns to span (default 1). Cannot exceed the number of columns in the grid. Supports interpolation.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-rowspan <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nThe number of rows to span (default 1). Supports interpolation.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.fabToolbar/directive/mdFabToolbar.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-fab-toolbar&gt;</code>\n directive is used present a toolbar of elements (usually <code>&lt;md-button&gt;</code>\ns) for quick access to common actions when a floating action button is activated (via click or keyboard navigation).\n</p><p>You may also easily position the trigger by applying one one of the following classes to the <code>\n&lt;md-fab-toolbar&gt;</code> element:</p><ul><li><code>md-fab-top-left</code></li><li><code>md-fab-top-right</code>\n</li><li><code>md-fab-bottom-left</code></li><li><code>md-fab-bottom-right</code></li></ul><p>These CSS classes use \n<code>position: absolute</code>, so you need to ensure that the container element also uses <code>position: absolute\n</code> or <code>position: relative</code> in order for them to work.</p></div><div><section class=\"api-section\"><h2 \nid=\"Usage\">Usage</h2><hljs lang=\"html\"><md-fab-toolbar md-direction=\"left\"><md-fab-trigger><md-button \naria-label=\"Add...\"><md-icon icon=\"/assets/angular-material-assets/img/icons/plus.svg\"></md-icon></md-button>\n</md-fab-trigger><md-toolbar><md-fab-actions><md-button aria-label=\"Add User\"><md-icon \nicon=\"/assets/angular-material-assets/img/icons/user.svg\"></md-icon></md-button><md-button aria-label=\"Add Group\">\n<md-icon icon=\"/assets/angular-material-assets/img/icons/group.svg\"></md-icon></md-button></md-fab-actions>\n</md-toolbar></md-fab-toolbar></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-direction</b> <span hide show-sm>\n<code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nFrom which direction you would like the toolbar items to appear relative to the trigger element. Supports <code>left\n</code> and <code>right</code> directions.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\nmd-open <span hide show-sm><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td\n style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td \nclass=\"description\"><p>Programmatically control whether or not the toolbar is visible.</p></td></tr></tbody></table>\n</div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.input/directive/mdInput.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>You can use any <code>&lt;input&gt;</code> or <code>&lt;textarea&gt;</code>\n element as a child of an <code>&lt;md-input-container&gt;</code>\n. This allows you to build complex forms for data entry.</p><p>\nWhen the input is required and uses a floating label, then the label will automatically contain an asterisk (<code>*\n</code>).<br>This behavior can be disabled by using the <code>md-no-asterisk</code> attribute.</p></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-input-container><label>Color</label><input \ntype=\"text\" ng-model=\"color\" required md-maxlength=\"10\"></md-input-container></hljs><h3>With Errors</h3><p><code>\nmd-input-container</code> also supports errors using the standard <code>ng-messages</code>\n directives and animates the messages when they become visible using from the <code>ngEnter</code>/<code>ngLeave</code>\n events or the <code>ngShow</code>/<code>ngHide</code> events.</p><p>\nBy default, the messages will be hidden until the input is in an error state. This is based off of the <code>\nmd-is-error</code> expression of the <code>md-input-container</code>\n. This gives the user a chance to fill out the form before the errors become visible.</p><hljs lang=\"html\"><form \nname=\"colorForm\"><md-input-container><label>Favorite Color</label><input name=\"favoriteColor\" ng-model=\"favoriteColor\" \nrequired><div ng-messages=\"colorForm.favoriteColor.$error\"><div ng-message=\"required\">This is required!</div></div>\n</md-input-container></form></hljs><p>\nWe automatically disable this auto-hiding functionality if you provide any of the following visibility directives on the \n<code>ng-messages</code> container:</p><ul><li><code>ng-if</code></li><li><code>ng-show</code>/<code>ng-hide</code>\n</li><li><code>ng-switch-when</code>/<code>ng-switch-default</code></li></ul><p>\nYou can also disable this functionality manually by adding the <code>md-auto-hide=&quot;false&quot;</code>\n expression to the <code>ng-messages</code>\n container. This may be helpful if you always want to see the error messages or if you are building your own visibilty directive.\n</p><p><em><b>Note:</b> The <code>md-auto-hide</code>\n attribute is a static string that is only checked upon initialization of the <code>ng-messages</code>\n directive to see if it equals the string <code>false</code>.</em></p><hljs lang=\"html\"><form name=\"userForm\">\n<md-input-container><label>Last Name</label><input name=\"lastName\" ng-model=\"lastName\" required md-maxlength=\"10\" \nminlength=\"4\"><div ng-messages=\"userForm.lastName.$error\" ng-show=\"userForm.lastName.$dirty\"><div \nng-message=\"required\">This is required!</div><div ng-message=\"md-maxlength\">That&#39;s too long!</div><div \nng-message=\"minlength\">That&#39;s too short!</div></div></md-input-container><md-input-container><label>Biography\n</label><textarea name=\"bio\" ng-model=\"biography\" required md-maxlength=\"150\"></textarea><div \nng-messages=\"userForm.bio.$error\" ng-show=\"userForm.bio.$dirty\"><div ng-message=\"required\">This is required!</div><div \nng-message=\"md-maxlength\">That&#39;s too long!</div></div></md-input-container><md-input-container><input \naria-label=\"title\" ng-model=\"title\"></md-input-container><md-input-container><input placeholder=\"title\" \nng-model=\"title\"></md-input-container></form></hljs><h3>Notes</h3><ul><li>Requires <a \nhref=\"https://docs.angularjs.org/api/ngMessages\">ngMessages</a>.</li><li>Behaves like the <a \nhref=\"https://docs.angularjs.org/api/ng/directive/input\">AngularJS input directive</a>.</li></ul><p>The <code>md-input\n</code> and <code>md-input-container</code>\n directives use very specific positioning to achieve the error animation effects. Therefore, it is <em>not</em>\n advised to use the Layout system inside of the <code>&lt;md-input-container&gt;</code>\n tags. Instead, use relative or absolute positioning.</p><p></p><h3>Textarea directive</h3>The <code>textarea</code>\n element within a <code>md-input-container</code> has the following specific behavior:<p></p><ul><li>By default the \n<code>textarea</code> grows as the user types. This can be disabled via the <code>md-no-autogrow</code> attribute.</li>\n<li>If a <code>textarea</code> has the <code>rows</code> attribute, it will treat the <code>rows</code>\n as the minimum height and will continue growing as the user types. For example a textarea with <code>\nrows=&quot;3&quot;</code>\n will be 3 lines of text high initially. If no rows are specified, the directive defaults to 1.</li><li>\nThe textarea&#39;s height gets set on initialization, as well as while the user is typing. In certain situations (e.g. while animating) the directive might have been initialized, before the element got it&#39;s final height. In those cases, you can trigger a resize manually by broadcasting a \n<code>md-resize-textarea</code> event on the scope.</li><li>If you wan&#39;t a <code>textarea</code>\n to stop growing at a certain point, you can specify the <code>max-rows</code> attribute.</li><li>\nThe textarea&#39;s bottom border acts as a handle which users can drag, in order to resize the element vertically. Once the user has resized a \n<code>textarea</code>, the autogrowing functionality becomes disabled. If you don&#39;t want a <code>textarea</code>\n to be resizeable by the user, you can add the <code>md-no-resize</code> attribute.</li></ul></section><div \nclass=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-maxlength <span hide show-sm><code class=\"api-type label type-hint type-hint-number\">\nnumber</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number\n</code></td><td class=\"description\"><p>\nThe maximum number of characters allowed in this input. If this is specified, a character counter will be shown underneath the input.\n<br><br>The purpose of <strong><code>md-maxlength</code></strong>\n is exactly to show the max length counter text. If you don&#39;t want the counter text and only need &quot;plain&quot; validation, you can use the &quot;simple&quot; \n<code>ng-maxlength</code> or maxlength attributes.<br><br><strong>Note:</strong>\n Only valid for text/string inputs (not numeric).</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">aria-label <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>\nAria-label is required when no label is present. A warning message will be logged in the console if not present.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">placeholder <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nAn alternative approach to using aria-label when the label is not PRESENT. The placeholder text is copied to the aria-label attribute.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-no-autogrow <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen present, textareas will not grow automatically.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-no-asterisk <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></td><td class=\"description\"><p>\nWhen present, an asterisk will not be appended to the inputs floating label</p></td></tr><tr class=\"api-params-item\">\n<td style=\"white-space: nowrap\">md-no-resize <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nDisables the textarea resize handle.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">max-rows \n<span hide show-sm><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td \nclass=\"description\"><p>The maximum amount of rows for a textarea.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-detect-hidden <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen present, textareas will be sized properly when they are revealed after being hidden. This is off by default for performance reasons because it guarantees a reflow every digest cycle.\n</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.input/directive/mdInputContainer.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>&lt;md-input-container&gt;</code>\n is the parent of any input or textarea element.</p><p>\nInput and textarea elements will not behave properly unless the md-input-container parent is provided.</p><p>A single \n<code>&lt;md-input-container&gt;</code> should contain only one <code>&lt;input&gt;</code>\n element, otherwise it will throw an error.</p><p><b>Exception:</b> Hidden inputs (<code>\n&lt;input type=&quot;hidden&quot; /&gt;</code>\n) are ignored and will not throw an error, so you may combine these with other inputs.</p><p><b>Note:</b> When using \n<code>ngMessages</code> with your input element, make sure the message and container elements are <em>block</em>\n elements, otherwise animations applied to the messages will not look as intended. Either use a <code>div</code>\n and apply the <code>ng-message</code> and <code>ng-messages</code> classes respectively, or use the <code>md-block\n</code> class on your element.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\">\n<md-input-container><label>Username</label><input type=\"text\" ng-model=\"user.name\"></md-input-container>\n<md-input-container><label>Description</label><textarea ng-model=\"user.description\"></textarea></md-input-container>\n</hljs><p></p><h3>When disabling floating labels</h3><p></p><hljs lang=\"html\"><md-input-container md-no-float><input \ntype=\"text\" placeholder=\"Non-Floating Label\"></md-input-container></hljs></section><div class=\"api-param-section\"><h2>\nAttributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-is-error <span hide \nshow-sm><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td \nclass=\"description\"><p>\nWhen the given expression evaluates to true, the input container will go into error state. Defaults to erroring if the input has been touched and is invalid.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-no-float <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>When present, <code>\nplaceholder</code> attributes on the input will not be converted to floating labels.</p></td></tr></tbody></table>\n</div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.input/directive/mdSelectOnFocus.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>md-select-on-focus</code>\n directive allows you to automatically select the element&#39;s input text on focus.</p><p></p><h3>Notes</h3><p></p>\n<ul><li>The use of <code>md-select-on-focus</code> is restricted to <code>&lt;input&gt;</code> and <code>\n&lt;textarea&gt;</code> elements.</li></ul></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p></p><h3>\nUsing with an Input</h3><p></p><hljs lang=\"html\"><md-input-container><label>Auto Select</label><input type=\"text\" \nmd-select-on-focus></md-input-container></hljs><p></p><h3>Using with a Textarea</h3><p></p><hljs lang=\"html\">\n<md-input-container><label>Auto Select</label><textarea md-select-on-focus>This text will be selected on focus.\n</textarea></md-input-container></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.list/directive/mdList.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-list&gt;</code> directive is a list container for 1..n <code>\n&lt;md-list-item&gt;</code> tags.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs \nlang=\"html\"><md-list><md-list-item class=\"md-2-line\" ng-repeat=\"item in todos\"><md-checkbox ng-model=\"item.done\">\n</md-checkbox><div class=\"md-list-item-text\"><h3>{{item.title}}</h3><p>{{item.description}}</p></div></md-list-item>\n</md-list></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.list/directive/mdListItem.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>A <code>md-list-item</code>\n element can be used to represent some information in a row.<br></p></div><div><section class=\"api-section\"><h2 \nid=\"Usage\">Usage</h2><h3 id=\"single-row-item\">Single Row Item</h3><hljs lang=\"html\"><md-list-item><span>Single Row Item\n</span></md-list-item></hljs><h3 id=\"multiple-lines\">Multiple Lines</h3><p>\nBy using the following markup, you will be able to have two lines inside of one <code>md-list-item</code>.</p><hljs \nlang=\"html\"><md-list-item class=\"md-2-line\"><div class=\"md-list-item-text\" layout=\"column\"><p>First Line</p><p>\nSecond Line</p></div></md-list-item></hljs><p>It is also possible to have three lines inside of one list item.</p><hljs\n lang=\"html\"><md-list-item class=\"md-3-line\"><div class=\"md-list-item-text\" layout=\"column\"><p>First Line</p><p>\nSecond Line</p><p>Third Line</p></div></md-list-item></hljs><h3 id=\"secondary-items\">Secondary Items</h3><p>\nSecondary items are elements which will be aligned at the end of the <code>md-list-item</code>.</p><hljs lang=\"html\">\n<md-list-item><span>Single Row Item</span><md-button class=\"md-secondary\">Secondary Button</md-button></md-list-item>\n</hljs><p>It also possible to have multiple secondary items inside of one <code>md-list-item</code>.</p><hljs \nlang=\"html\"><md-list-item><span>Single Row Item</span><md-button class=\"md-secondary\">First Button</md-button>\n<md-button class=\"md-secondary\">Second Button</md-button></md-list-item></hljs><h3 id=\"proxy-item\">Proxy Item</h3><p>\nProxies are elements, which will execute their specific action on click<br>Currently supported proxy items are</p><ul>\n<li><code>md-checkbox</code> (Toggle)</li><li><code>md-switch</code> (Toggle)</li><li><code>md-menu</code> (Open)</li>\n</ul><p>This means, when using a supported proxy item inside of <code>md-list-item</code>\n, the list item will become clickable and executes the associated action of the proxy element on click.</p><hljs \nlang=\"html\"><md-list-item><span>First Line</span><md-checkbox class=\"md-secondary\"></md-checkbox></md-list-item></hljs>\n<p>The <code>md-checkbox</code> element will be automatically detected as a proxy element and will toggle on click.</p>\n<hljs lang=\"html\"><md-list-item><span>First Line</span><md-switch class=\"md-secondary\"></md-switch></md-list-item>\n</hljs><p>The recognized <code>md-switch</code> will toggle its state, when the user clicks on the <code>md-list-item\n</code>.</p><p>It is also possible to have a <code>md-menu</code> inside of a <code>md-list-item</code>.</p><hljs \nlang=\"html\"><md-list-item><p>Click anywhere to fire the secondary action</p><md-menu class=\"md-secondary\"><md-button \nclass=\"md-icon-button\"><md-icon md-svg-icon=\"communication:message\"></md-icon></md-button><md-menu-content width=\"4\">\n<md-menu-item><md-button>Redial</md-button></md-menu-item><md-menu-item><md-button>Check voicemail</md-button>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-button>Notifications</md-button></md-menu-item>\n</md-menu-content></md-menu></md-list-item></hljs><p>The menu will automatically open, when the users clicks on the \n<code>md-list-item</code>.<br></p><p>If the developer didn&#39;t specify any position mode on the menu, the <code>\nmd-list-item</code> will automatically detect the position mode and applies it to the <code>md-menu</code>.</p><h3 \nid=\"avatars\">Avatars</h3><p>Sometimes you may want to have some avatars inside of the <code>md-list-item</code>.<br>\nYou are able to create a optimized icon for the list item, by applying the <code>.md-avatar</code> class on the <code>\n&lt;img&gt;</code> element.</p><hljs lang=\"html\"><md-list-item><img src=\"my-avatar.png\" class=\"md-avatar\"> <span>\nAlan Turing</span></md-list-item></hljs><p>When using <code>&lt;md-icon&gt;</code> for an avater, you have to use the \n<code>.md-avatar-icon</code> class.</p><hljs lang=\"html\"><md-list-item><md-icon class=\"md-avatar-icon\" \nmd-svg-icon=\"avatars:timothy\"></md-icon><span>Timothy Kopra</span></md-list-item></hljs><p>In cases, you have a <code>\nmd-list-item</code>\n, which doesn&#39;t have any avatar, but you want to align it with the other avatar items, you have to use the <code>\n.md-offset</code> class.</p><hljs lang=\"html\"><md-list-item class=\"md-offset\"><span>Jon Doe</span></md-list-item>\n</hljs><h3 id=\"dom-modification\">DOM modification</h3><p>The <code>md-list-item</code>\n component automatically detects if the list item should be clickable.</p><hr><p>If the <code>md-list-item</code>\n is clickable, we wrap all content inside of a <code>&lt;div&gt;</code>\n and create an overlaying button, which will will execute the given actions (like <code>ng-href</code>, <code>ng-click\n</code>)</p><p>\nWe create an overlaying button, instead of wrapping all content inside of the button, because otherwise some elements may not be clickable inside of the button.\n</p><hr><p>When using a secondary item inside of your list item, the <code>md-list-item</code>\n component will automatically create a secondary container at the end of the <code>md-list-item</code>\n, which contains all secondary items.</p><p>\nThe secondary item container is not static, because otherwise the overflow will not work properly on the list item.</p>\n</section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.menu-bar/directive/mdMenuBar.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nMenu bars are containers that hold multiple menus. They change the behavior and appearence of the <code>md-menu</code>\n directive to behave similar to an operating system provided menu.</p></div><div><section class=\"api-section\"><h2 \nid=\"Usage\">Usage</h2><hljs lang=\"html\"><md-menu-bar><md-menu><button ng-click=\"$mdOpenMenu()\">File</button>\n<md-menu-content><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'share\', $event)\">Share...</md-button>\n</md-menu-item><md-menu-divider></md-menu-divider><md-menu-item><md-menu-item><md-menu><md-button \nng-click=\"$mdOpenMenu()\">New</md-button><md-menu-content><md-menu-item><md-button \nng-click=\"ctrl.sampleAction(\'New Document\', $event)\">Document</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"ctrl.sampleAction(\'New Spreadsheet\', $event)\">Spreadsheet</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"ctrl.sampleAction(\'New Presentation\', $event)\">Presentation</md-button></md-menu-item><md-menu-item>\n<md-button ng-click=\"ctrl.sampleAction(\'New Form\', $event)\">Form</md-button></md-menu-item><md-menu-item><md-button \nng-click=\"ctrl.sampleAction(\'New Drawing\', $event)\">Drawing</md-button></md-menu-item></md-menu-content></md-menu>\n</md-menu-item></md-menu-item></md-menu-content></md-menu></md-menu-bar></hljs><h2 id=\"menu-bar-controls\">\nMenu Bar Controls</h2><p>You may place <code>md-menu-items</code>\n that function as controls within menu bars. There are two modes that are exposed via the <code>type</code>\n attribute of the <code>md-menu-item</code>. <code>type=&quot;checkbox&quot;</code>\n will function as a boolean control for the <code>ng-model</code> attribute of the <code>md-menu-item</code>. <code>\ntype=&quot;radio&quot;</code> will function like a radio button, setting the <code>ngModel</code> to the <code>string\n</code> value of the <code>value</code> attribute. If you need non-string values, you can use <code>ng-value</code>\n to provide an expression (this is similar to how angular&#39;s native <code>input[type=radio]</code> works.</p><hljs \nlang=\"html\"><md-menu-bar><md-menu><button ng-click=\"$mdOpenMenu()\">Sample Menu</button><md-menu-content><md-menu-item \ntype=\"checkbox\" ng-model=\"settings.allowChanges\">Allow changes</md-menu-item><md-menu-divider></md-menu-divider>\n<md-menu-item type=\"radio\" ng-model=\"settings.mode\" ng-value=\"1\">Mode 1</md-menu-item><md-menu-item type=\"radio\" \nng-model=\"settings.mode\" ng-value=\"1\">Mode 2</md-menu-item><md-menu-item type=\"radio\" ng-model=\"settings.mode\" \nng-value=\"1\">Mode 3</md-menu-item></md-menu-content></md-menu></md-menu-bar></hljs><h3 id=\"nesting-menus\">Nesting Menus\n</h3><p>\nMenus may be nested within menu bars. This is commonly called cascading menus. To nest a menu place the nested menu inside the content of the \n<code>md-menu-item</code>.</p><hljs lang=\"html\"><md-menu-item><md-menu><button ng-click=\"$mdOpenMenu()\">New\n<md-menu-content><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Document\', $event)\">Document</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Spreadsheet\', $event)\">Spreadsheet</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Presentation\', $event)\">Presentation\n</md-button></md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Form\', $event)\">Form</md-button>\n</md-menu-item><md-menu-item><md-button ng-click=\"ctrl.sampleAction(\'New Drawing\', $event)\">Drawing</md-button>\n</md-menu-item></md-menu-content></button></md-menu></md-menu-item></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.panel/service/$mdPanel.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>$mdPanel</code>\n is a robust, low-level service for creating floating panels on the screen. It can be used to implement tooltips, dialogs, pop-ups, etc.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">\n(function(angular, undefined) { ‘use strict’; angular .module(&#39;demoApp&#39;, [&#39;ngMaterial&#39;]) .controller(&#39;DemoDialogController&#39;, DialogController); var panelRef; function showPanel($event) { var panelPosition = $mdPanel.newPanelPosition() .absolute() .top(&#39;50%&#39;) .left(&#39;50%&#39;); var panelAnimation = $mdPanel.newPanelAnimation() .targetEvent($event) .defaultAnimation(&#39;md-panel-animate-fly&#39;) .closeTo(&#39;.show-button&#39;); var config = { attachTo: angular.element(document.body), controller: DialogController, controllerAs: &#39;ctrl&#39;, position: panelPosition, animation: panelAnimation, targetEvent: $event, templateUrl: &#39;dialog-template.html&#39;, clickOutsideToClose: true, escapeToClose: true, focusOnOpen: true } $mdPanel.open(config) .then(function(result) { panelRef = result; }); } function DialogController(MdPanelRef, toppings) { var toppings; function closeDialog() { MdPanelRef &amp;&amp; MdPanelRef.close(); } } })(angular);\n</hljs></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"create\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdPanel.create([config]);</code></h3><div \nclass=\"service-desc\"><p>Creates a panel with the specified options.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">config <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">Object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">Object</code></td><td class=\"description\"><p>\nSpecific configuration object that may contain the following properties:</p><ul><li><code>id</code> - <code>{string=}\n</code>\n: An ID to track the panel by. When an ID is provided, the created panel is added to a tracked panels object. Any subsequent requests made to create a panel with that ID are ignored. This is useful in having the panel service not open multiple panels from the same user interaction when there is no backdrop and events are propagated. Defaults to an arbitrary string that is not tracked.\n</li><li><code>template</code> - <code>{string=}</code>: HTML template to show in the panel. This <strong>must</strong>\n be trusted HTML with respect to Angular’s <a href=\"https://docs.angularjs.org/api/ng/service/$sce\">$sce service</a>.\n</li><li><code>templateUrl</code> - <code>{string=}</code>: The URL that will be used as the content of the panel.</li>\n<li><code>controller</code> - <code>{(function|string)=}</code>\n: The controller to associate with the panel. The controller can inject a reference to the returned panelRef, which allows the panel to be closed, hidden, and shown. Any fields passed in through locals or resolve will be bound to the controller.\n</li><li><code>controllerAs</code> - <code>{string=}</code>: An alias to assign the controller to on the scope.</li>\n<li><code>bindToController</code> - <code>{boolean=}</code>\n: Binds locals to the controller instead of passing them in. Defaults to true, as this is a best practice.</li><li>\n<code>locals</code> - <code>{Object=}</code>\n: An object containing key/value pairs. The keys will be used as names of values to inject into the controller. For example, \n<code>locals: {three: 3}</code> would inject <code>three</code> into the controller, with the value 3.</li><li><code>\nresolve</code> - <code>{Object=}</code>\n: Similar to locals, except it takes promises as values. The panel will not open until all of the promises resolve.\n</li><li><code>attachTo</code> - <code>{(string|!angular.JQLite|!Element)=}</code>\n: The element to attach the panel to. Defaults to appending to the root element of the application.</li><li><code>\npropagateContainerEvents</code> - <code>{boolean=}</code>\n: Whether pointer or touch events should be allowed to propagate &#39;go through&#39; the container, aka the wrapper, of the panel. Defaults to false.\n</li><li><code>panelClass</code> - <code>{string=}</code>\n: A css class to apply to the panel element. This class should define any borders, box-shadow, etc. for the panel.</li>\n<li><code>zIndex</code> - <code>{number=}</code>: The z-index to place the panel at. Defaults to 80.</li><li><code>\nposition</code> - <code>{MdPanelPosition=}</code>\n: An MdPanelPosition object that specifies the alignment of the panel. For more information, see <code>MdPanelPosition\n</code>.</li><li><code>clickOutsideToClose</code> - <code>{boolean=}</code>\n: Whether the user can click outside the panel to close it. Defaults to false.</li><li><code>escapeToClose</code> - \n<code>{boolean=}</code>: Whether the user can press escape to close the panel. Defaults to false.</li><li><code>\ntrapFocus</code> - <code>{boolean=}</code>: Whether focus should be trapped within the panel. If <code>trapFocus</code>\n is true, the user will not be able to interact with the rest of the page until the panel is dismissed. Defaults to false.\n</li><li><code>focusOnOpen</code> - <code>{boolean=}</code>\n: An option to override focus behavior on open. Only disable if focusing some other way, as focus management is required for panels to be accessible. Defaults to true.\n</li><li><code>fullscreen</code> - <code>{boolean=}</code>: Whether the panel should be full screen. Applies the class \n<code>._md-panel-fullscreen</code> to the panel on open. Defaults to false.</li><li><code>animation</code> - <code>\n{MdPanelAnimation=}</code>\n: An MdPanelAnimation object that specifies the animation of the panel. For more information, see <code>\nMdPanelAnimation</code>.</li><li><code>hasBackdrop</code> - <code>{boolean=}</code>\n: Whether there should be an opaque backdrop behind the panel. Defaults to false.</li><li><code>disableParentScroll\n</code> - <code>{boolean=}</code>: Whether the user can scroll the page behind the panel. Defaults to false.</li><li>\n<code>onDomAdded</code> - <code>{function=}</code>\n: Callback function used to announce when the panel is added to the DOM.</li><li><code>onOpenComplete</code> - <code>\n{function=}</code>: Callback function used to announce when the open() action is finished.</li><li><code>onRemoving\n</code> - <code>{function=}</code>: Callback function used to announce the close/hide() action is starting.</li><li>\n<code>onDomRemoved</code> - <code>{function=}</code>\n: Callback function used to announce when the panel is removed from the DOM.</li><li><code>origin</code> - <code>\n{(string|!angular.JQLite|!Element)=}</code>\n: The element to focus on when the panel closes. This is commonly the element which triggered the opening of the panel. If you do not use \n<code>origin</code>, you need to control the focus manually.</li></ul></td></tr></tbody></table><table \nclass=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-mdpanelref\">MdPanelRef</code></td><td class=\"description\"><p>panelRef</p>\n</td></tr></tbody></table></div></li><li id=\"open\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdPanel.open([config]);</code></h3><div class=\"service-desc\"><p>\nCalls the create method above, then opens the panel. This is a shortcut for creating and then calling open manually. If custom methods need to be called when the panel is added to the DOM or opened, do not use this method. Instead create the panel, chain promises on the domAdded and openComplete methods, and call open from the returned panelRef.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">config <span hide \nshow-sm><code class=\"api-type label type-hint type-hint-object\">Object</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">Object</code></td><td \nclass=\"description\"><p>Specific configuration object that may contain the properties defined in <code>$mdPanel.create\n</code>.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr>\n</thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-object\">!angular.$q.Promise&lt;!MdPanelRef&gt;\n</code></td><td class=\"description\"><p>panelRef A promise that resolves to an instance of the panel.</p></td></tr>\n</tbody></table></div></li><li id=\"newPanelPosition\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdPanel.newPanelPosition();</code></h3><div class=\"service-desc\"><p>\nReturns a new instance of the MdPanelPosition object. Use this to create the position config object.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code></td><td \nclass=\"description\"><p>panelPosition</p></td></tr></tbody></table></div></li><li id=\"newPanelAnimation\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdPanel.newPanelAnimation();</code></h3><div \nclass=\"service-desc\"><p>\nReturns a new instance of the MdPanelAnimation object. Use this to create the animation config object.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelanimation\">MdPanelAnimation</code></td><td \nclass=\"description\"><p>panelAnimation</p></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.menu/directive/mdMenu.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nMenus are elements that open when clicked. They are useful for displaying additional options within the context of an action.\n</p><p>Every <code>md-menu</code>\n must specify exactly two child elements. The first element is what is left in the DOM and is used to open the menu. This element is called the trigger element. The trigger element&#39;s scope has access to \n<code>$mdOpenMenu($event)</code>\n which it may call to open the menu. By passing $event as argument, the corresponding event is stopped from propagating up the DOM-tree.\n</p><p>The second element is the <code>md-menu-content</code>\n element which represents the contents of the menu when it is open. Typically this will contain <code>md-menu-item\n</code>s, but you can do custom content as well.</p><hljs lang=\"html\"><md-menu><md-button \nng-click=\"$mdOpenMenu($event)\" class=\"md-icon-button\" aria-label=\"Open sample menu\"><md-icon md-svg-icon=\"call:phone\">\n</md-icon></md-button><md-menu-content><md-menu-item><md-button ng-click=\"doSomething()\">Do Something</md-button>\n</md-menu-item></md-menu-content></md-menu></hljs><h2 id=\"sizing-menus\">Sizing Menus</h2><p>\nThe width of the menu when it is open may be specified by specifying a <code>width</code> attribute on the <code>\nmd-menu-content</code> element. See the <a href=\"https://material.google.com/components/menus.html#menus-simple-menus\">\nMaterial Design Spec</a> for more information.</p><h2 id=\"aligning-menus\">Aligning Menus</h2><p>\nWhen a menu opens, it is important that the content aligns with the trigger element. Failure to align menus can result in jarring experiences for users as content suddenly shifts. To help with this, \n<code>md-menu</code> provides serveral APIs to help with alignment.</p><h3 id=\"target-mode\">Target Mode</h3><p>\nBy default, <code>md-menu</code> will attempt to align the <code>md-menu-content</code>\n by aligning designated child elements in both the trigger and the menu content.</p><p>\nTo specify the alignment element in the <code>trigger</code> you can use the <code>md-menu-origin</code>\n attribute on a child element. If no <code>md-menu-origin</code> is specified, the <code>md-menu</code>\n will be used as the origin element.</p><p>Similarly, the <code>md-menu-content</code> may specify a <code>\nmd-menu-align-target</code> for a <code>md-menu-item</code> to specify the node that it should try and align with.</p>\n<p>\nIn this example code, we specify an icon to be our origin element, and an icon in our menu content to be our alignment target. This ensures that both icons are aligned when the menu opens.\n</p><hljs lang=\"html\"><md-menu><md-button ng-click=\"$mdOpenMenu($event)\" class=\"md-icon-button\" \naria-label=\"Open some menu\"><md-icon md-menu-origin md-svg-icon=\"call:phone\"></md-icon></md-button><md-menu-content>\n<md-menu-item><md-button ng-click=\"doSomething()\" aria-label=\"Do something\"><md-icon md-menu-align-target \nmd-svg-icon=\"call:phone\"></md-icon>Do Something</md-button></md-menu-item></md-menu-content></md-menu></hljs><p>\nSometimes we want to specify alignment on the right side of an element, for example if we have a menu on the right side a toolbar, we want to right align our menu content.\n</p><p>We can specify the origin by using the <code>md-position-mode</code> attribute on both the <code>x</code> and \n<code>y</code> axis. Right now only the <code>x-axis</code>\n has more than one option. You may specify the default mode of <code>target target</code> or <code>target-right target\n</code> to specify a right-oriented alignment target. See the position section of the demos for more examples.</p><h3 \nid=\"menu-offsets\">Menu Offsets</h3><p>\nIt is sometimes unavoidable to need to have a deeper level of control for the positioning of a menu to ensure perfect alignment. \n<code>md-menu</code> provides the <code>md-offset</code>\n attribute to allow pixel level specificty of adjusting the exact positioning.</p><p>\nThis offset is provided in the format of <code>x y</code> or <code>n</code> where <code>n</code>\n will be used in both the <code>x</code> and <code>y</code> axis.</p><p>For example, to move a menu by <code>2px</code>\n from the top, we can use:</p><hljs lang=\"html\"><md-menu md-offset=\"2 0\"></md-menu></hljs><h3 id=\"auto-focus\">\nAuto Focus</h3><p>By default, when a menu opens, <code>md-menu</code> focuses the first button in the menu content.</p>\n<p>But sometimes you would like to focus another specific menu item instead of the first.<br>\nThis can be done by applying the <code>md-autofocus</code> directive on the given element.</p><hljs lang=\"html\">\n<md-menu-item><md-button md-autofocus ng-click=\"doSomething()\">Auto Focus</md-button></md-menu-item></hljs><h3 \nid=\"preventing-close\">Preventing close</h3><p>\nSometimes you would like to be able to click on a menu item without having the menu close. To do this, ngMaterial exposes the \n<code>md-prevent-menu-close</code>\n attribute which can be added to a button inside a menu to stop the menu from automatically closing. You can then close the menu programatically by injecting \n<code>$mdMenu</code> and calling <code>$mdMenu.hide()</code>.</p><hljs lang=\"html\"><md-menu-item><md-button \nng-click=\"doSomething()\" aria-label=\"Do something\" md-prevent-menu-close=\"md-prevent-menu-close\"><md-icon \nmd-menu-align-target md-svg-icon=\"call:phone\"></md-icon>Do Something</md-button></md-menu-item></hljs></div><div>\n<section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-menu><md-button \nng-click=\"$mdOpenMenu($event)\" class=\"md-icon-button\"><md-icon md-svg-icon=\"call:phone\"></md-icon></md-button>\n<md-menu-content><md-menu-item><md-button ng-click=\"doSomething()\">Do Something</md-button></md-menu-item>\n</md-menu-content></md-menu></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-position-mode</b> <span hide \nshow-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>The position mode in the form of <code>x</code>, <code>y</code>. Default value is <code>target\n</code>,<code>target</code>. Right now the <code>x</code> axis also suppports <code>target-right</code>.</p></td></tr>\n<tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-offset</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nAn offset to apply to the dropdown after positioning <code>x</code>, <code>y</code>. Default value is <code>0</code>,\n<code>0</code>.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.panel/type/MdPanelPosition.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>Object for configuring the position of the panel.</p></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><h4 id=\"centering-the-panel\">Centering the panel</h4><hljs lang=\"js\">\nnew MdPanelPosition().absolute().center();</hljs><h4 id=\"overlapping-the-panel-with-an-element\">\nOverlapping the panel with an element</h4><hljs lang=\"js\">\nnew MdPanelPosition() .relativeTo(someElement) .addPanelPosition( $mdPanel.xPosition.ALIGN_START, $mdPanel.yPosition.ALIGN_TOPS );\n</hljs><h4 id=\"aligning-the-panel-with-the-bottom-of-an-element\">Aligning the panel with the bottom of an element</h4>\n<hljs lang=\"js\">\nnew MdPanelPosition() .relativeTo(someElement) .addPanelPosition($mdPanel.xPosition.CENTER, $mdPanel.yPosition.BELOW);\n</hljs></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"absolute\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelPosition.absolute();</code></h3><div \nclass=\"service-desc\"><p>\nPositions the panel absolutely relative to the parent element. If the parent is document.body, this is equivalent to positioning the panel absolutely within the viewport.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th>\n</tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code>\n</td><td class=\"description\"></td></tr></tbody></table></div></li><li id=\"relativeTo\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelPosition.relativeTo(element);</code></h3>\n<div class=\"service-desc\"><p>Positions the panel relative to a specific element.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* element</b> <span hide show-sm>\n<code class=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-element\">Element</code><code \nclass=\"api-type label type-hint type-hint-angular\">angular.JQLite</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-element\">Element</code><code \nclass=\"api-type label type-hint type-hint-angular\">angular.JQLite</code></td><td class=\"description\"><p>\nQuery selector, DOM element, or angular element to position the panel with respect to.</p></td></tr></tbody></table>\n<table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code></td><td class=\"description\"></td>\n</tr></tbody></table></div></li><li id=\"top\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\nMdPanelPosition.top([top]);</code></h3><div class=\"service-desc\"><p>Sets the value of <code>top</code>\n for the panel. Clears any previously set vertical position.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">top <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Value of <code>top\n</code>. Defaults to &#39;0&#39;.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th>\n<th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelposition\">\nMdPanelPosition</code></td><td class=\"description\"></td></tr></tbody></table></div></li><li id=\"bottom\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelPosition.bottom([bottom]);</code></h3><div \nclass=\"service-desc\"><p>Sets the value of <code>bottom</code>\n for the panel. Clears any previously set vertical position.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">bottom <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Value of <code>bottom\n</code>. Defaults to &#39;0&#39;.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th>\n<th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelposition\">\nMdPanelPosition</code></td><td class=\"description\"></td></tr></tbody></table></div></li><li id=\"start\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelPosition.start([start]);</code></h3><div \nclass=\"service-desc\"><p>Sets the panel to the start of the page - <code>left</code> if <code>ltr</code> or <code>right\n</code> for <code>rtl</code>. Clears any previously set horizontal position.</p></div><div class=\"method-param-table\">\n<table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">start <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nValue of position. Defaults to &#39;0&#39;.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>\nReturns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code></td><td class=\"description\"></td>\n</tr></tbody></table></div></li><li id=\"end\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\nMdPanelPosition.end([end]);</code></h3><div class=\"service-desc\"><p>Sets the panel to the end of the page - <code>right\n</code> if <code>ltr</code> or <code>left</code> for <code>rtl</code>. Clears any previously set horizontal position.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">end <span hide show-sm>\n<code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nValue of position. Defaults to &#39;0&#39;.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>\nReturns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code></td><td class=\"description\"></td>\n</tr></tbody></table></div></li><li id=\"left\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\nMdPanelPosition.left([left]);</code></h3><div class=\"service-desc\"><p>Sets the value of <code>left</code>\n for the panel. Clears any previously set horizontal position.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">left <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Value of <code>left\n</code>. Defaults to &#39;0&#39;.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th>\n<th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelposition\">\nMdPanelPosition</code></td><td class=\"description\"></td></tr></tbody></table></div></li><li id=\"right\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelPosition.right([right]);</code></h3><div \nclass=\"service-desc\"><p>Sets the value of <code>right</code>\n for the panel. Clears any previously set horizontal position.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">right <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Value of <code>right\n</code>. Defaults to &#39;0&#39;.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th>\n<th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelposition\">\nMdPanelPosition</code></td><td class=\"description\"></td></tr></tbody></table></div></li><li id=\"centerHorizontally\"><h3\n class=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelPosition.centerHorizontally();</code></h3>\n<div class=\"service-desc\"><p>\nCenters the panel horizontally in the viewport. Clears any previously set horizontal position.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code></td><td \nclass=\"description\"></td></tr></tbody></table></div></li><li id=\"centerVertically\"><h3 class=\"method-function-syntax\">\n<code class=\"method-function-syntax\">MdPanelPosition.centerVertically();</code></h3><div class=\"service-desc\"><p>\nCenters the panel vertically in the viewport. Clears any previously set vertical position.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code></td><td \nclass=\"description\"></td></tr></tbody></table></div></li><li id=\"center\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">MdPanelPosition.center();</code></h3><div class=\"service-desc\"><p>\nCenters the panel horizontally and vertically in the viewport. This is equivalent to calling both <code>\ncenterHorizontally</code> and <code>centerVertically</code>\n. Clears any previously set horizontal and vertical positions.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code></td><td class=\"description\"></td>\n</tr></tbody></table></div></li><li id=\"addPanelPosition\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">MdPanelPosition.addPanelPosition(xPosition, yPosition);</code></h3><div \nclass=\"service-desc\"><p>\nSets the x and y position for the panel relative to another element. Can be called multiple times to specify an ordered list of panel positions. The first position which allows the panel to be completely on-screen will be chosen; the last position will be chose whether it is on-screen or not.\n</p><p>xPosition must be one of the following values available on $mdPanel.xPosition:</p><p>\nCENTER | ALIGN_START | ALIGN_END | OFFSET_START | OFFSET_END</p><hr><ul><li>*</li><li>PANEL *</li><li>*</li></ul><hr>\n<p>A B C D E</p><p>\nA: OFFSET_START (for LTR displays) B: ALIGN_START (for LTR displays) C: CENTER D: ALIGN_END (for LTR displays) E: OFFSET_END (for LTR displays)\n</p><p>yPosition must be one of the following values available on $mdPanel.yPosition:</p><p>\nCENTER | ALIGN_TOPS | ALIGN_BOTTOMS | ABOVE | BELOW</p><p>F G <strong><strong><strong>*</strong></strong></strong></p>\n<pre><code>*           *\n</code></pre><p>H <em>PANEL </em></p><pre><code>*           *\n</code></pre><p>I <strong>\n<strong><strong>*</strong></strong></strong> J</p><p>F: BELOW G: ALIGN_TOPS H: CENTER I: ALIGN_BOTTOMS J: ABOVE</p>\n</div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* xPosition</b> \n<span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* yPosition</b> <span \nhide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description\n</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition\n</code></td><td class=\"description\"></td></tr></tbody></table></div></li><li id=\"withOffsetX\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelPosition.withOffsetX(offsetX);</code></h3>\n<div class=\"service-desc\"><p>Sets the value of the offset in the x-direction.</p></div><div class=\"method-param-table\">\n<table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* offsetX</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"></td></tr></tbody></table>\n<table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code></td><td class=\"description\"></td>\n</tr></tbody></table></div></li><li id=\"withOffsetY\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">MdPanelPosition.withOffsetY(offsetY);</code></h3><div class=\"service-desc\"><p>\nSets the value of the offset in the y-direction.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\">\n<thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* offsetY</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"></td></tr></tbody></table>\n<table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code></td><td class=\"description\"></td>\n</tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.panel/type/MdPanelRef.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nA reference to a created panel. This reference contains a unique id for the panel, along with the following properties:\n</p><ul><li><code>id</code> - <code>{string}</code>\n: The unique id for the panel. This id is used to track when a panel was interacted with.</li><li><code>config</code>\n - <code>{!Object=}</code>: The entire config object that was used in create.</li><li><code>isAttached</code> - <code>\n{boolean}</code>: Whether the panel is attached to the DOM. Visibility to the user does not factor into isAttached.\n</li><li><code>panelContainer</code> - <code>{angular.JQLite}</code>\n: The wrapper element containing the panel. This property is added in order to have access to the <code>addClass</code>\n, <code>removeClass</code>, <code>toggleClass</code>, etc methods.</li><li><code>panelEl</code> - <code>\n{angular.JQLite}</code>: The panel element. This property is added in order to have access to the <code>addClass</code>\n, <code>removeClass</code>, <code>toggleClass</code>, etc methods.</li></ul></div><div><section class=\"api-section\">\n<h2>Methods</h2><br><ul class=\"methods\"><li id=\"open\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">MdPanelRef.open();</code></h3><div class=\"service-desc\"><p>Attaches and shows the panel.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th>\n</tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-angular\">angular.$q.Promise</code></td><td \nclass=\"description\"><p>A promise that is resolved when the panel is opened.</p></td></tr></tbody></table></div></li><li\n id=\"close\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelRef.close();</code></h3><div\n class=\"service-desc\"><p>Hides and detaches the panel. Note that this will <strong>not</strong>\n destroy the panel. If you don&#39;t intend on using the panel again, call the <a href=\"#destroy\">destroy</a>\n method afterwards.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th>\n<th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-angular\">\nangular.$q.Promise</code></td><td class=\"description\"><p>A promise that is resolved when the panel is closed.</p></td>\n</tr></tbody></table></div></li><li id=\"attach\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">MdPanelRef.attach();</code></h3><div class=\"service-desc\"><p>\nCreate the panel elements and attach them to the DOM. The panel will be hidden by default.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-angular\">angular.$q.Promise</code></td><td \nclass=\"description\"><p>A promise that is resolved when the panel is attached.</p></td></tr></tbody></table></div></li>\n<li id=\"detach\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelRef.detach();</code>\n</h3><div class=\"service-desc\"><p>Removes the panel from the DOM. This will NOT hide the panel before removing it.</p>\n</div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr>\n</thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-angular\">angular.$q.Promise</code></td><td \nclass=\"description\"><p>A promise that is resolved when the panel is detached.</p></td></tr></tbody></table></div></li>\n<li id=\"show\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelRef.show();</code></h3>\n<div class=\"service-desc\"><p>Shows the panel.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\">\n<thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-angular\">angular.$q.Promise</code></td><td class=\"description\"><p>\nA promise that is resolved when the panel has shown and animations are completed.</p></td></tr></tbody></table></div>\n</li><li id=\"hide\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelRef.hide();</code>\n</h3><div class=\"service-desc\"><p>Hides the panel.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-angular\">angular.$q.Promise</code></td><td class=\"description\"><p>\nA promise that is resolved when the panel has hidden and animations are completed.</p></td></tr></tbody></table></div>\n</li><li id=\"destroy\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">MdPanelRef.destroy();\n</code></h3><div class=\"service-desc\"><p>Destroys the panel. The panel cannot be opened again after this is called.</p>\n</div><div class=\"method-param-table\"></div></li><li id=\"addClass\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">MdPanelRef.addClass(newClass, toElement);</code></h3><div class=\"service-desc\"><p>\nAdds a class to the panel. DO NOT use this hide/show the panel.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* newClass</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>class to be added.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* toElement</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhether or not to add the class to the panel element instead of the container.</p></td></tr></tbody></table></div></li>\n<li id=\"removeClass\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\nMdPanelRef.removeClass(oldClass, fromElement);</code></h3><div class=\"service-desc\"><p>\nRemoves a class from the panel. DO NOT use this to hide/show the panel.</p></div><div class=\"method-param-table\"><table\n class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* oldClass</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Class to be removed.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* fromElement</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhether or not to remove the class from the panel element instead of the container.</p></td></tr></tbody></table></div>\n</li><li id=\"toggleClass\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\nMdPanelRef.toggleClass(toggleClass, onElement);</code></h3><div class=\"service-desc\"><p>\nToggles a class on the panel. DO NOT use this to hide/show the panel.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* toggleClass</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Class to be toggled.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* onElement</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhether or not to remove the class from the panel element instead of the container.</p></td></tr></tbody></table></div>\n</li><li id=\"updatePosition\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\nMdPanelRef.updatePosition(position);</code></h3><div class=\"service-desc\"><p>\nUpdates the position configuration of a panel. Use this to update the position of a panel that is open, without having to close and re-open the panel.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* position</b> <span\n hide show-sm><code class=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-mdpanelposition\">MdPanelPosition</code>\n</td><td class=\"description\"></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.progressLinear/directive/mdProgressLinear.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nThe linear progress directive is used to make loading content in your app as delightful and painless as possible by minimizing the amount of visual change a user sees before they can view and interact with content.\n</p><p>\nEach operation should only be represented by one activity indicator For example: one refresh operation should not display both a refresh bar and an activity circle.\n</p><p>\nFor operations where the percentage of the operation completed can be determined, use a determinate indicator. They give users a quick sense of how long an operation will take.\n</p><p>\nFor operations where the user is asked to wait a moment while something finishes up, and it’s not necessary to expose what&#39;s happening behind the scenes and how long it will take, use an indeterminate indicator.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-progress-linear \nmd-mode=\"determinate\" value=\"...\"></md-progress-linear><md-progress-linear md-mode=\"determinate\" ng-value=\"...\">\n</md-progress-linear><md-progress-linear md-mode=\"indeterminate\"></md-progress-linear><md-progress-linear \nmd-mode=\"buffer\" value=\"...\" md-buffer-value=\"...\"></md-progress-linear><md-progress-linear md-mode=\"query\">\n</md-progress-linear></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\">\n<table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* md-mode</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nSelect from one of four modes: determinate, indeterminate, buffer or query.</p><p>Note: if the <code>md-mode</code>\n value is set as undefined or specified as 1 of the four (4) valid modes, then <code>indeterminate</code>\n will be auto-applied as the mode.</p><p>Note: if not configured, the <code>md-mode=&quot;indeterminate&quot;</code>\n will be auto injected as an attribute. If <code>value=&quot;&quot;</code> is also specified, however, then <code>\nmd-mode=&quot;determinate&quot;</code> would be auto-injected instead.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">value <span hide show-sm><code class=\"api-type label type-hint type-hint-number\">number\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number\n</code></td><td class=\"description\"><p>\nIn determinate and buffer modes, this number represents the percentage of the primary progress bar. Default: 0</p></td>\n</tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-buffer-value <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nIn the buffer mode, this number represents the percentage of the secondary progress bar. Default: 0</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">ng-disabled <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nDetermines whether to disable the progress element.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.navBar/directive/mdNavBar.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-nav-bar&gt;</code>\n directive renders a list of material tabs that can be used for top-level page navigation. Unlike <code>&lt;md-tabs&gt;\n</code>, it has no concept of a tab body and no bar pagination.</p><p>\nBecause it deals with page navigation, certain routing concepts are built-in. Route changes via via ng-href, ui-sref, or ng-click events are supported. Alternatively, the user could simply watch currentNavItem for changes.\n</p><p>Accessibility functionality is implemented as a site navigator with a listbox, according to <a \nhref=\"https://www.w3.org/TR/wai-aria-practices/#Site_Navigator_Tabbed_Style\">\nhttps://www.w3.org/TR/wai-aria-practices/#Site_Navigator_Tabbed_Style</a></p></div><div><section class=\"api-section\">\n<h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-nav-bar md-selected-nav-item=\"currentNavItem\"><md-nav-item \nmd-nav-click=\"goto(\'page1\')\" name=\"page1\">Page One</md-nav-item><md-nav-item md-nav-sref=\"app.page2\" name=\"page2\">\nPage Two</md-nav-item><md-nav-item md-nav-href=\"#page3\" name=\"page3\">Page Three</md-nav-item></md-nav-bar></hljs><hljs \nlang=\"js\">\n(function() { ‘use strict’; $rootScope.$on(&#39;$routeChangeSuccess&#39;, function(event, current) { $scope.currentLink = getCurrentLinkFromRoute(current); }); });\n</hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">mdSelectedNavItem <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThe name of the current tab; this must match the name attribute of <code>&lt;md-nav-item&gt;</code></p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">navBarAriaLabel <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nAn aria-label for the nav-bar</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.navBar/directive/mdNavItem.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>&lt;md-nav-item&gt;</code> describes a page navigation link within the <code>\n&lt;md-nav-bar&gt;</code> component. It renders an md-button as the actual link.</p><p>\nExactly one of the mdNavClick, mdNavHref, mdNavSref attributes are required to be specified.</p></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>See <code>&lt;md-nav-bar&gt;</code> for usage.</p></section><div \nclass=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">mdNavClick <span hide show-sm><code class=\"api-type label type-hint type-hint-function\">\nFunction=</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-function\">\nFunction=</code></td><td class=\"description\"><p>\nFunction which will be called when the link is clicked to change the page. Renders as an <code>ng-click</code>.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">mdNavHref <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nurl to transition to when this link is clicked. Renders as an <code>ng-href</code>.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">mdNavSref <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nUi-router state to transition to when this link is clicked. Renders as a <code>ui-sref</code>.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">name <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThe name of this link. Used by the nav bar to know which link is currently selected.</p></td></tr></tbody></table>\n</div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.progressCircular/service/$mdProgressCircular.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>Allows the user to specify the default options for the <code>progressCircular</code>\n directive.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">\nmyAppModule.config(function($mdProgressCircularProvider) { // Example of changing the default progress options. $mdProgressCircularProvider.configure({ progressSize: 100, strokeWidth: 20, duration: 800 }); });\n</hljs></section><section class=\"api-section\"><h2>Properties</h2><div class=\"api-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Property</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* progressSize</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nDiameter of the progress circle in pixels.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>\n* strokeWidth</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-number\">number</code></span></td>\n<td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td \nclass=\"description\"><p>Width of the circle&#39;s stroke as a percentage of the circle&#39;s size.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* duration</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nLength of the circle animation in milliseconds.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* easeFn</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-function\">function</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-function\">function</code></td><td class=\"description\"><p>\nDefault easing animation function.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>\n* easingPresets</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-object\">object</code></span>\n</td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td \nclass=\"description\"><p>Collection of pre-defined easing functions.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* durationIndeterminate</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nDuration of the indeterminate animation.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>\n* startIndeterminate</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-number\">number</code>\n</span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number</code></td>\n<td class=\"description\"><p>Indeterminate animation start point.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* endIndeterminate</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nIndeterminate animation end point.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>\n* easeFnIndeterminate</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-function\">function</code>\n</span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-function\">function</code>\n</td><td class=\"description\"><p>Easing function to be used when animating between the indeterminate values.</p></td>\n</tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* configure</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-function\">function(object): object</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-function\">function(object): object</code>\n</td><td class=\"description\"><p>Used to modify the default options.</p></td></tr></tbody></table></div></section></div>\n</div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.progressCircular/directive/mdProgressCircular.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nThe circular progress directive is used to make loading content in your app as delightful and painless as possible by minimizing the amount of visual change a user sees before they can view and interact with content.\n</p><p>\nFor operations where the percentage of the operation completed can be determined, use a determinate indicator. They give users a quick sense of how long an operation will take.\n</p><p>\nFor operations where the user is asked to wait a moment while something finishes up, and it’s not necessary to expose what&#39;s happening behind the scenes and how long it will take, use an indeterminate indicator.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-progress-circular \nmd-mode=\"determinate\" value=\"...\"></md-progress-circular><md-progress-circular md-mode=\"determinate\" ng-value=\"...\">\n</md-progress-circular><md-progress-circular md-mode=\"determinate\" value=\"...\" md-diameter=\"100\">\n</md-progress-circular><md-progress-circular md-mode=\"indeterminate\"></md-progress-circular></hljs></section><div \nclass=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* md-mode</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nSelect from one of two modes: <strong>&#39;determinate&#39;</strong> and <strong>&#39;indeterminate&#39;</strong>.</p>\n<p>Note: if the <code>md-mode</code> value is set as undefined or specified as not 1 of the two (2) valid modes, then \n<strong>&#39;indeterminate&#39;</strong> will be auto-applied as the mode.</p><p>Note: if not configured, the <code>\nmd-mode=&quot;indeterminate&quot;</code> will be auto injected as an attribute. If <code>value=&quot;&quot;</code>\n is also specified, however, then <code>md-mode=&quot;determinate&quot;</code> would be auto-injected instead.</p></td>\n</tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">value <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nIn determinate mode, this number represents the percentage of the circular progress. Default: 0</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-diameter <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nThis specifies the diameter of the circular progress. The value should be a pixel-size value (eg &#39;100&#39;). If this attribute is not present then a default value of &#39;50px&#39; is assumed.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">ng-disabled <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nDetermines whether to disable the progress element.</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.select/directive/mdSelect.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>Displays a select box, bound to an ng-model.</p><p>\nWhen the select is required and uses a floating label, then the label will automatically contain an asterisk (<code>*\n</code>). This behavior can be disabled by using the <code>md-no-asterisk</code> attribute.</p><p>\nBy default, the select will display with an underline to match other form elements. This can be disabled by applying the \n<code>md-no-underline</code> CSS class.</p><h3 id=\"option-params\">Option Params</h3><p>When applied, <code>\nmd-option-empty</code>\n will mark the option as &quot;empty&quot; allowing the option to clear the select and put it back in it&#39;s default state. You may supply this attribute on any option you wish, however, it is automatically applied to an option whose \n<code>value</code> or <code>ng-value</code> are not defined.</p><p><strong>Automatically Applied</strong></p><ul><li>\n<code>&lt;md-option&gt;</code></li><li><code>&lt;md-option value&gt;</code></li><li><code>\n&lt;md-option value=&quot;&quot;&gt;</code></li><li><code>&lt;md-option ng-value&gt;</code></li><li><code>\n&lt;md-option ng-value=&quot;&quot;&gt;</code></li></ul><p><strong>NOT Automatically Applied</strong></p><ul><li><code>\n&lt;md-option ng-value=&quot;1&quot;&gt;</code></li><li><code>&lt;md-option ng-value=&quot;&#39;&#39;&quot;&gt;</code>\n</li><li><code>&lt;md-option ng-value=&quot;undefined&quot;&gt;</code></li><li><code>\n&lt;md-option value=&quot;undefined&quot;&gt;</code> (this evaluates to the string <code>&quot;undefined&quot;</code>)\n</li><li><code ng-non-bindable>&lt;md-option ng-value=&quot;{{someValueThatMightBeUndefined}}&quot;&gt;</code></li>\n</ul><p><strong>Note:</strong> A value of <code>undefined</code> <strong><em>is considered a valid value</em></strong>\n (and does not auto-apply this attribute) since you may wish this to be your &quot;Not Available&quot; or &quot;None&quot; option.\n</p><p><strong>Note:</strong> Using the <code>value</code> attribute (as opposed to <code>ng-value</code>\n) always evaluates to a string, so <code>value=&quot;null&quot;</code> will require the test <code>\nng-if=&quot;myValue != &#39;null&#39;&quot;</code> rather than <code>ng-if=&quot;!myValue&quot;</code>.</p></div><div>\n<section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p>\nWith a placeholder (label and aria-label are added dynamically)</p><hljs lang=\"html\"><md-input-container><md-select \nng-model=\"someModel\" placeholder=\"Select a state\"><md-option ng-value=\"opt\" ng-repeat=\"opt in neighborhoods2\">{{ opt }}\n</md-option></md-select></md-input-container></hljs><p>With an explicit label</p><hljs lang=\"html\"><md-input-container>\n<label>State</label><md-select ng-model=\"someModel\"><md-option ng-value=\"opt\" ng-repeat=\"opt in neighborhoods2\">\n{{ opt }}</md-option></md-select></md-input-container></hljs><p>With a select-header</p><p>\nWhen a developer needs to put more than just a text label in the md-select-menu, they should use the md-select-header. The user can put custom HTML inside of the header and style it to their liking. One common use case of this would be a sticky search bar.\n</p><p>When using the md-select-header the labels that would previously be added to the OptGroupDirective are ignored.\n</p><hljs lang=\"html\"><md-input-container><md-select ng-model=\"someModel\"><md-select-header><span>Neighborhoods -\n</span></md-select-header><md-option ng-value=\"opt\" ng-repeat=\"opt in neighborhoods2\">{{ opt }}</md-option></md-select>\n</md-input-container></hljs><h2 id=\"selects-and-object-equality\">Selects and object equality</h2><p>When using a <code>\nmd-select</code>\n to pick from a list of objects, it is important to realize how javascript handles equality. Consider the following example:\n</p><hljs lang=\"js\">\nangular.controller(&#39;MyCtrl&#39;, function($scope) { $scope.users = [ { id: 1, name: &#39;Bob&#39; }, { id: 2, name: &#39;Alice&#39; }, { id: 3, name: &#39;Steve&#39; } ]; $scope.selectedUser = { id: 1, name: &#39;Bob&#39; }; });\n</hljs><hljs lang=\"html\"><div ng-controller=\"MyCtrl\"><md-select ng-model=\"selectedUser\"><md-option ng-value=\"user\" \nng-repeat=\"user in users\">{{ user.name }}</md-option></md-select></div></hljs><p>\nAt first one might expect that the select should be populated with &quot;Bob&quot; as the selected user. However, this is not true. To determine whether something is selected, \n<code>ngModelController</code> is looking at whether <code>$scope.selectedUser == (any user in $scope.users);</code>;\n</p><p>Javascript&#39;s <code>==</code>\n operator does not check for deep equality (ie. that all properties on the object are the same), but instead whether the objects are \n<em>the same object in memory</em>\n. In this case, we have two instances of identical objects, but they exist in memory as unique entities. Because of this, the select will have no value populated for a selected user.\n</p><p>To get around this, <code>ngModelController</code> provides a <code>track by</code>\n option that allows us to specify a different expression which will be used for the equality operator. As such, we can update our \n<code>html</code> to make use of this by specifying the <code>\nng-model-options=&quot;{trackBy: &#39;$value.id&#39;}&quot;</code> on the <code>md-select</code>\n element. This converts our equality expression to be <code>\n$scope.selectedUser.id == (any id in $scope.users.map(function(u) { return u.id; }));</code>\n which results in Bob being selected as desired.</p><p>Working HTML:</p><hljs lang=\"html\"><div ng-controller=\"MyCtrl\">\n<md-select ng-model=\"selectedUser\" ng-model-options=\"{trackBy: \'$value.id\'}\"><md-option ng-value=\"user\" \nng-repeat=\"user in users\">{{ user.name }}</md-option></md-select></div></hljs></section><div class=\"api-param-section\">\n<h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th>\n<th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* ng-model</b> \n<span hide show-sm><code class=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td \nclass=\"description\"><p>The model!</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">multiple \n<span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td \nclass=\"description\"><p>Whether it&#39;s multiple.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-on-close <span hide show-sm><code class=\"api-type label type-hint type-hint-expression\">\nexpression</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nExpression to be evaluated when the select is closed.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-on-open <span hide show-sm><code class=\"api-type label type-hint type-hint-expression\">\nexpression</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nExpression to be evaluated when opening the select. Will hide the select options and show a spinner until the evaluated promise resolves.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-selected-text <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nExpression to be evaluated that will return a string to be displayed as a placeholder in the select input box when it is closed.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">placeholder <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>Placeholder hint text.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-no-asterisk <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen set to true, an asterisk will not be appended to the floating label. <strong>Note:</strong>\n This attribute is only evaluated once; it is not watched.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">aria-label <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>\nOptional label for accessibility. Only necessary if no placeholder or explicit label is present.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-container-class <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nClass list to get applied to the <code>.md-select-menu-container</code> element (for custom styling).</p></td></tr>\n</tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.radioButton/directive/mdRadioButton.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-radio-button&gt;</code>\ndirective is the child directive required to be used within <code>&lt;md-radio-group&gt;</code> elements.</p><p>\nWhile similar to the <code>&lt;input type=&quot;radio&quot; ng-model=&quot;&quot; value=&quot;&quot;&gt;</code>\n directive, the <code>&lt;md-radio-button&gt;</code>\n directive provides ink effects, ARIA support, and supports use within named radio groups.</p></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-radio-button value=\"1\" aria-label=\"Label 1\">Label 1\n</md-radio-button><md-radio-button ng-model=\"color\" ng-value=\"specialValue\" aria-label=\"Green\">Green</md-radio-button>\n</hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* ngModel</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nAssignable angular expression to data-bind to.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* ngValue</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nAngular expression which sets the value to which the expression should be set when selected.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* value</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThe value to which the expression should be set when selected.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">ngChange <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>\nAngular expression to be executed when input changes due to user interaction with the input element.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">name <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nProperty name of the form under which the control is published.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">aria-label <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>\nAdds label to radio button for accessibility. Defaults to radio button&#39;s text. If no text content is available, a warning will be logged.\n</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.radioButton/directive/mdRadioGroup.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-radio-group&gt;</code>\n directive identifies a grouping container for the 1..n grouped radio buttons; specified using nested <code>\n&lt;md-radio-button&gt;</code> tags.</p><p>As per the <a \nhref=\"http://www.google.com/design/spec/style/color.html#color-ui-color-application\">material design spec</a>\n the radio button is in the accent color by default. The primary color palette may be used with the <code>md-primary\n</code> class.</p><p>Note: <code>&lt;md-radio-group&gt;</code> and <code>&lt;md-radio-button&gt;</code>\n handle tabindex differently than the native <code>&lt;input type=&#39;radio&#39;&gt;</code>\n controls. Whereas the native controls force the user to tab through all the radio buttons, <code>\n&lt;md-radio-group&gt;</code> is focusable, and by default the <code>&lt;md-radio-button&gt;</code>s are not.</p></div>\n<div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-radio-group ng-model=\"selected\">\n<md-radio-button ng-repeat=\"d in colorOptions\" ng-value=\"d.value\" aria-label=\"{{ d.label }}\">{{ d.label }}\n</md-radio-button></md-radio-group></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* ng-model</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nAssignable angular expression to data-bind to.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-no-ink <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></td><td class=\"description\"><p>Use of attribute indicates flag to disable ink ripple effects.</p></td>\n</tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sidenav/directive/mdSidenav.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>A Sidenav component that can be opened and closed programatically.</p><p>\nBy default, upon opening it will slide out on top of the main content area.</p><p>\nFor keyboard and screen reader accessibility, focus is sent to the sidenav wrapper by default. It can be overridden with the \n<code>md-autofocus</code> directive on the child element you want focused.</p></div><div><section class=\"api-section\">\n<h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div layout=\"row\" ng-controller=\"MyController\"><md-sidenav \nmd-component-id=\"left\" class=\"md-sidenav-left\">Left Nav!</md-sidenav><md-content>Center Content<md-button \nng-click=\"openLeftMenu()\">Open Left Menu</md-button></md-content><md-sidenav md-component-id=\"right\" \nmd-is-locked-open=\"$mdMedia(\'min-width: 333px\')\" class=\"md-sidenav-right\"><form><md-input-container><label \nfor=\"testInput\">Test input</label><input id=\"testInput\" type=\"text\" ng-model=\"data\" md-autofocus></md-input-container>\n</form></md-sidenav></div></hljs><hljs lang=\"js\">\nvar app = angular.module(&#39;myApp&#39;, [&#39;ngMaterial&#39;]); app.controller(&#39;MyController&#39;, function($scope, $mdSidenav) { $scope.openLeftMenu = function() { $mdSidenav(&#39;left&#39;).toggle(); }; });\n</hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-is-open <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nA model bound to whether the sidenav is opened.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-disable-backdrop <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen present in the markup, the sidenav will not show a backdrop.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-component-id <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>componentId to use with $mdSidenav service.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-is-locked-open <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nWhen this expression evaluates to true, the sidenav &#39;locks open&#39;: it falls into the content&#39;s flow instead of appearing over it. This overrides the \n<code>md-is-open</code> attribute.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\nmd-disable-scroll-target <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code>\n</span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td>\n<td class=\"description\"><p>\nSelector, pointing to an element, whose scrolling will be disabled when the sidenav is opened. By default this is the sidenav&#39;s direct parent.\n</p><p>\nThe $mdMedia() service is exposed to the is-locked-open attribute, which can be given a media query or one of the \n<code>sm</code>, <code>gt-sm</code>, <code>md</code>, <code>gt-md</code>, <code>lg</code> or <code>gt-lg</code>\n presets. Examples:</p><ul><li><code>&lt;md-sidenav md-is-locked-open=&quot;shouldLockOpen&quot;&gt;&lt;/md-sidenav&gt;\n</code></li><li><code>\n&lt;md-sidenav md-is-locked-open=&quot;$mdMedia(&#39;min-width: 1000px&#39;)&quot;&gt;&lt;/md-sidenav&gt;</code></li>\n<li><code>&lt;md-sidenav md-is-locked-open=&quot;$mdMedia(&#39;sm&#39;)&quot;&gt;&lt;/md-sidenav&gt;</code>\n (locks open on small screens)</li></ul></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sidenav/directive/mdSidenavFocus.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>mdSidenavFocus</code>\n provides a way to specify the focused element when a sidenav opens. This is completely optional, as the sidenav itself is focused by default.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-sidenav><form>\n<md-input-container><label for=\"testInput\">Label</label><input id=\"testInput\" type=\"text\" md-sidenav-focus>\n</md-input-container></form></md-sidenav></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sidenav/service/$mdSidenav.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>$mdSidenav</code>\n makes it easy to interact with multiple sidenavs in an app. When looking up a sidenav instance, you can either look it up synchronously or wait for it to be initializied asynchronously. This is done by passing the second argument to \n<code>$mdSidenav</code>.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">\n// Async lookup for sidenav instance; will resolve when the instance is available $mdSidenav(componentId, true).then(function(instance) { $log.debug( componentId + &quot;is now ready&quot; ); }); // Sync lookup for sidenav instance; this will resolve immediately. $mdSidenav(componentId).then(function(instance) { $log.debug( componentId + &quot;is now ready&quot; ); }); // Async toggle the given sidenav; // when instance is known ready and lazy lookup is not needed. $mdSidenav(componentId) .toggle() .then(function(){ $log.debug(&#39;toggled&#39;); }); // Async open the given sidenav $mdSidenav(componentId) .open() .then(function(){ $log.debug(&#39;opened&#39;); }); // Async close the given sidenav $mdSidenav(componentId) .close() .then(function(){ $log.debug(&#39;closed&#39;); }); // Sync check to see if the specified sidenav is set to be open $mdSidenav(componentId).isOpen(); // Sync check to whether given sidenav is locked open // If this is true, the sidenav will be open regardless of close() $mdSidenav(componentId).isLockedOpen(); // On close callback to handle close, backdrop click or escape key pressed // Callback happens BEFORE the close action occurs. $mdSidenav(componentId).onClose(function () { $log.debug(&#39;closing&#39;); });\n</hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.slider/directive/mdSlider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-slider&gt;</code>\n component allows the user to choose from a range of values.</p><p>As per the <a \nhref=\"http://www.google.com/design/spec/style/color.html#color-ui-color-application\">material design spec</a>\n the slider is in the accent color by default. The primary color palette may be used with the <code>md-primary</code>\n class.</p><p>\nIt has two modes: &#39;normal&#39; mode, where the user slides between a wide range of values, and &#39;discrete&#39; mode, where the user slides between only a few select values.\n</p><p>To enable discrete mode, add the <code>md-discrete</code> attribute to a slider, and use the <code>step</code>\n attribute to change the distance between values the user is allowed to pick.</p></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><p></p><h4>Normal Mode</h4><p></p><hljs lang=\"html\"><md-slider \nng-model=\"myValue\" min=\"5\" max=\"500\"></md-slider></hljs><h4>Discrete Mode</h4><hljs lang=\"html\"><md-slider md-discrete \nng-model=\"myDiscreteValue\" step=\"10\" min=\"10\" max=\"130\"></md-slider></hljs><h4>Invert Mode</h4><hljs lang=\"html\">\n<md-slider md-invert ng-model=\"myValue\" step=\"10\" min=\"10\" max=\"130\"></md-slider></hljs></section><div \nclass=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-discrete <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></td><td class=\"description\"><p>Whether to enable discrete mode.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-invert <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhether to enable invert mode.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">step <span \nhide show-sm><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td \nclass=\"description\"><p>The distance between values the user is allowed to pick. Default 1.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">min <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nThe minimum value the user is allowed to pick. Default 0.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">max <span hide show-sm><code class=\"api-type label type-hint type-hint-number\">number\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number\n</code></td><td class=\"description\"><p>The maximum value the user is allowed to pick. Default 100.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">round <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nThe amount of numbers after the decimal point, maximum is 6 to prevent scientific notation. Default 3.</p></td></tr>\n</tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.slider/directive/mdSliderContainer.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-slider-container&gt;</code>\n contains slider with two other elements.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><p></p>\n<h4>Normal Mode</h4><p></p><hljs lang=\"html\"></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.sticky/service/$mdSticky.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>$mdSticky</code>service provides a mixin to make elements sticky.</p><p>\nWhenever the current browser supports stickiness natively, the <code>$mdSticky</code>\n service will just use the native browser stickiness.</p><p>By default the <code>$mdSticky</code>\n service compiles the cloned element, when not specified through the <code>elementClone</code>\n parameter, in the same scope as the actual element lives.</p><p></p><h3>Notes</h3>\nWhen using an element which is containing a compiled directive, which changed its DOM structure during compilation, you should compile the clone yourself using the plain template.\n<br><br>See the right usage below:<p></p><hljs lang=\"js\">\nangular.module(&#39;myModule&#39;) .directive(&#39;stickySelect&#39;, function($mdSticky, $compile) { var SELECT_TEMPLATE = &#39;\n<md-select ng-model=\"selected\">&#39; + &#39;<md-option>Option 1</md-option>&#39; + &#39;</md-select>\n&#39;; return { restrict: &#39;E&#39;, replace: true, template: SELECT_TEMPLATE, link: function(scope,element) { $mdSticky(scope, element, $compile(SELECT_TEMPLATE)(scope)); } }; });\n</hljs></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">\nangular.module(&#39;myModule&#39;) .directive(&#39;stickyText&#39;, function($mdSticky, $compile) { return { restrict: &#39;E&#39;, template: &#39;\n<span>Sticky Text</span>&#39;, link: function(scope,element) { $mdSticky(scope, element); } }; });</hljs></section>\n<section class=\"api-section\"><section class=\"api-section\"></section><div class=\"api-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td></td><td \nclass=\"description\"><p>A <code>$mdSticky</code> function that takes three arguments:</p><ul><li><code>scope</code></li>\n<li><code>element</code>: The element that will be &#39;sticky&#39;</li><li><code>elementClone</code>\n: A clone of the element, that will be shown when the user starts scrolling past the original element. If not provided, it will use the result of \n<code>element.clone()</code> and compiles it in the given scope.</li></ul></td></tr></tbody></table></div></section>\n</div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.subheader/directive/mdSubheader.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>md-subheader</code> directive creates a sticky subheader for a section.\n</p><p>Developers are able to disable the stickiness of the subheader by using the following markup</p><hljs \nlang=\"html\"><md-subheader class=\"md-no-sticky\">Not Sticky</md-subheader></hljs><h3 id=\"notes\">Notes</h3><ul><li>The \n<code>md-subheader</code> directive uses the <a ng-href=\"api/service/$mdSticky\">$mdSticky</a>\n service to make the subheader sticky.</li></ul><blockquote><p>\nWhenever the current browser doesn&#39;t support stickiness natively, the subheader will be compiled twice to create a sticky clone of the subheader.\n</p></blockquote></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-subheader>\nOnline Friends</md-subheader></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.swipe/directive/mdSwipeDown.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nThe md-swipe-down directive allows you to specify custom behavior when an element is swiped down.</p></div><div>\n<section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div md-swipe-down=\"onSwipDown()\">\nSwipe me down!</div></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.swipe/directive/mdSwipeLeft.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nThe md-swipe-left directive allows you to specify custom behavior when an element is swiped left.</p></div><div>\n<section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div md-swipe-left=\"onSwipeLeft()\">\nSwipe me left!</div></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.swipe/directive/mdSwipeRight.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nThe md-swipe-right directive allows you to specify custom behavior when an element is swiped right.</p></div><div>\n<section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div md-swipe-right=\"onSwipeRight()\">\nSwipe me right!</div></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.swipe/directive/mdSwipeUp.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nThe md-swipe-up directive allows you to specify custom behavior when an element is swiped up.</p></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div md-swipe-up=\"onSwipeUp()\">Swipe me up!</div></hljs>\n</section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.tabs/directive/mdTab.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>Use the <code>&lt;md-tab&gt;</code> a nested directive used within <code>\n&lt;md-tabs&gt;</code> to specify a tab with a <strong>label</strong> and optional <em>view content</em>.</p><p>If the \n<code>label</code> attribute is not specified, then an optional <code>&lt;md-tab-label&gt;</code>\n tag can be used to specify more complex tab header markup. If neither the <strong>label</strong> nor the <strong>\nmd-tab-label</strong> are specified, then the nested markup of the <code>&lt;md-tab&gt;</code>\n is used as the tab header markup.</p><p>Please note that if you use <code>&lt;md-tab-label&gt;</code>, your content \n<strong>MUST</strong> be wrapped in the <code>&lt;md-tab-body&gt;</code>\n tag. This is to define a clear separation between the tab content and the tab label.</p><p>\nThis container is used by the TabsController to show/hide the active tab&#39;s content view. This synchronization is automatically managed by the internal TabsController whenever the tab selection changes. Selection changes can be initiated via data binding changes, programmatic invocation, or user gestures.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-tab label=\"\" ng-disabled \nmd-on-select=\"\" md-on-deselect=\"\"><h3>My Tab content</h3></md-tab><md-tab><md-tab-label><h3>My Tab content</h3>\n</md-tab-label><md-tab-body><p>\nSed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritatis et quasi architecto beatae vitae dicta sunt explicabo. Nemo enim ipsam voluptatem quia voluptas sit aspernatur aut odit aut fugit, sed quia consequuntur magni dolores eos qui ratione voluptatem sequi nesciunt.\n</p></md-tab-body></md-tab></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">label <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nOptional attribute to specify a simple string as the tab label</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">ng-disabled <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></td><td class=\"description\"><p>If present and expression evaluates to truthy, disabled tab selection.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-on-deselect <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nExpression to be evaluated after the tab has been de-selected.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-on-select <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nExpression to be evaluated after the tab has been selected.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-active <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></td><td class=\"description\"><p>\nWhen true, sets the active tab. Note: There can only be one active tab at a time.</p></td></tr></tbody></table></div>\n</div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.tabs/directive/mdTabs.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>&lt;md-tabs&gt;</code> directive serves as the container for 1..n <code>\n&lt;md-tab&gt;</code> child directives to produces a Tabs components. In turn, the nested <code>&lt;md-tab&gt;</code>\n directive is used to specify a tab label for the <strong>header button</strong>\n and a [optional] tab view content that will be associated with each tab button.</p><p>\nBelow is the markup for its simplest usage:</p><hljs lang=\"html\"><md-tabs><md-tab label=\"Tab #1\"></md-tab><md-tab \nlabel=\"Tab #2\"></md-tab><md-tab label=\"Tab #3\"></md-tab></md-tabs></hljs><p>Tabs supports three (3) usage scenarios:\n</p><ol><li>Tabs (buttons only)</li><li>Tabs with internal view content</li><li>Tabs with external view content</li>\n</ol><p><strong>Tab-only</strong>\n support is useful when tab buttons are used for custom navigation regardless of any other components, content, or views.\n</p><p><i><b>Note:</b> If you are using the Tabs component for page-level navigation, please take a look at the <a \nng-href=\"./api/directive/mdNavBar\">NavBar component</a> instead as it can handle this case a bit more natively.</i></p>\n<p><strong>Tabs with internal views</strong>\n are the traditional usages where each tab has associated view content and the view switching is managed internally by the Tabs component.\n</p><p><strong>Tabs with external view content</strong>\n is often useful when content associated with each tab is independently managed and data-binding notifications announce tab selection changes.\n</p><p>Additional features also include:</p><ul><li>Content can include any markup.</li><li>\nIf a tab is disabled while active/selected, then the next tab will be auto-selected.</li></ul><h3 \nid=\"explanation-of-tab-stretching\">Explanation of tab stretching</h3><p>\nInitially, tabs will have an inherent size. This size will either be defined by how much space is needed to accommodate their text or set by the user through CSS. Calculations will be based on this size.\n</p><p>\nOn mobile devices, tabs will be expanded to fill the available horizontal space. When this happens, all tabs will become the same size.\n</p><p>On desktops, by default, stretching will never occur.</p><p>This default behavior can be overridden through the \n<code>md-stretch-tabs</code> attribute. Here is a table showing when stretching will occur:</p><table><thead><tr><th>\n<code>md-stretch-tabs</code></th><th>mobile</th><th>desktop</th></tr></thead><tbody><tr><td><code>auto</code></td><td>\nstretched</td><td>---</td></tr><tr><td><code>always</code></td><td>stretched</td><td>stretched</td></tr><tr><td><code>\nnever</code></td><td>---</td><td>---</td></tr></tbody></table></div><div><section class=\"api-section\"><h2 id=\"Usage\">\nUsage</h2><hljs lang=\"html\"><md-tabs md-selected=\"selectedIndex\"><img \nng-src=\"assets/angular-material-assets/img/angular.png\" class=\"centered\"><md-tab \nng-repeat=\"tab in tabs | orderBy:predicate:reversed\" md-on-select=\"onTabSelected(tab)\" \nmd-on-deselect=\"announceDeselected(tab)\" ng-disabled=\"tab.disabled\"><md-tab-label>{{tab.title}} <img \nsrc=\"assets/angular-material-assets/img/removeTab.png\" ng-click=\"removeTab(tab)\" class=\"delete\"></md-tab-label>\n<md-tab-body>{{tab.content}}</md-tab-body></md-tab></md-tabs></hljs></section><div class=\"api-param-section\"><h2>\nAttributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-selected <span hide \nshow-sm><code class=\"api-type label type-hint type-hint-integer\">integer</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-integer\">integer</code></td><td \nclass=\"description\"><p>Index of the active/selected tab</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-no-ink <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">\nboolean</code></td><td class=\"description\"><p>If present, disables ink ripple effects.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-no-ink-bar <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nIf present, disables the selection ink bar.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\nmd-align-tabs <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>Attribute to indicate position of tab buttons: <code>bottom</code> or <code>top</code>\n; default is <code>top</code></p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-stretch-tabs \n<span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>Attribute to indicate whether or not to stretch tabs: <code>auto</code>, <code>always</code>\n, or <code>never</code>; default is <code>auto</code></p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-dynamic-height <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen enabled, the tab wrapper will resize based on the contents of the selected tab</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-border-bottom <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nIf present, shows a solid <code>1px</code> border between the tabs and their content</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-center-tabs <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen enabled, tabs will be centered provided there is no need for pagination</p></td></tr><tr class=\"api-params-item\">\n<td style=\"white-space: nowrap\">md-no-pagination <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen enabled, pagination will remain off</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">\nmd-swipe-content <span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td>\n<td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td \nclass=\"description\"><p>When enabled, swipe gestures will be enabled for the content area to jump between tabs</p></td>\n</tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-enable-disconnect <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen enabled, scopes will be disconnected for tabs that are not being displayed. This provides a performance boost, but may also cause unexpected issues and is not recommended for most users.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-autoselect <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen present, any tabs added after the initial load will be automatically selected</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-no-select-click <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen enabled, click events will not be fired when selecting tabs</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.switch/directive/mdSwitch.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\">\n<md-switch ng-model=\"isActive\" aria-label=\"Finished?\">Finished ?</md-switch><md-switch md-no-ink ng-model=\"hasInk\" \naria-label=\"No Ink Effects\">No Ink Effects</md-switch><md-switch ng-disabled=\"true\" ng-model=\"isDisabled\" \naria-label=\"Disabled\">Disabled</md-switch></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* ng-model</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nAssignable angular expression to data-bind to.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">name <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>Property name of the form under which the control is published.</p></td></tr><tr\n class=\"api-params-item\"><td style=\"white-space: nowrap\">ng-true-value <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nThe value to which the expression should be set when selected.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">ng-false-value <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nThe value to which the expression should be set when not selected.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">ng-change <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>\nAngular expression to be executed when input changes due to user interaction with the input element.</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">ng-disabled <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nEn/Disable based on the expression.</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-no-ink \n<span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td \nclass=\"description\"><p>Use of attribute indicates use of ripple ink effects.</p></td></tr><tr class=\"api-params-item\">\n<td style=\"white-space: nowrap\">aria-label <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>\nPublish the button label used by screen-readers for accessibility. Defaults to the switch&#39;s text.</p></td></tr>\n</tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.toolbar/directive/mdToolbar.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>md-toolbar</code> is used to place a toolbar in your app.</p><p>\nToolbars are usually used above a content area to display the title of the current page, and show relevant action buttons for that page.\n</p><p>You can change the height of the toolbar by adding either the <code>md-medium-tall</code> or <code>md-tall\n</code> class to the toolbar.</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\">\n<div layout=\"column\" layout-fill><md-toolbar><div class=\"md-toolbar-tools\"><span>My App&#39;s Title</span><span flex>\n</span><md-button>Right Bar Button</md-button></div></md-toolbar><md-content>Hello!</md-content></div></hljs></section>\n<div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr>\n<th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-scroll-shrink <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhether the header should shrink away as the user scrolls down, and reveal itself as the user scrolls up.</p><p><em>\n<strong>Note (1):</strong> for scrollShrink to work, the toolbar must be a sibling of a <code>md-content</code>\n element, placed before it. See the scroll shrink demo.</em></p><p><em><strong>Note (2):</strong> The <code>\nmd-scroll-shrink</code> attribute is only parsed on component initialization, it does not watch for scope changes.</em>\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-shrink-speed-factor <span hide show-sm>\n<code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nHow much to change the speed of the toolbar&#39;s shrinking by. For example, if 0.25 is given then the toolbar will shrink at one fourth the rate at which the user scrolls down. Default 0.5.\n</p></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.toast/service/$mdToast.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>$mdToast</code>\n is a service to build a toast notification on any position on the screen with an optional duration, and provides a simple promise API.\n</p><p>The toast will be always positioned at the <code>bottom</code>, when the screen size is between <code>600px\n</code> and <code>959px</code> (<code>sm</code> breakpoint)</p><h2 id=\"restrictions-on-custom-toasts\">\nRestrictions on custom toasts</h2><ul><li>The toast&#39;s template must have an outer <code>&lt;md-toast&gt;</code>\n element.</li><li>For a toast action, use element with class <code>md-action</code>.</li><li>Add the class <code>\nmd-capsule</code> for curved corners.</li></ul><h3 id=\"custom-presets\">Custom Presets</h3><p>\nDevelopers are also able to create their own preset, which can be easily used without repeating their options each time.\n</p><hljs lang=\"js\">$mdToastProvider.addPreset(&#39;testPreset&#39;, { options: function() { return { template: &#39;\n<md-toast>&#39; + &#39;<div class=\"md-toast-content\">&#39; + &#39;This is a custom preset&#39; + &#39;</div>\n&#39; + &#39;</md-toast>&#39;, controllerAs: &#39;toast&#39;, bindToController: true }; } });</hljs><p>\nAfter you created your preset at config phase, you can easily access it.</p><hljs lang=\"js\">\n$mdToast.show( $mdToast.testPreset() );</hljs><h2 id=\"parent-container-notes\">Parent container notes</h2><p>\nThe toast is positioned using absolute positioning relative to its first non-static parent container. Thus, if the requested parent container uses static positioning, we will temporarily set its positioning to \n<code>relative</code> while the toast is visible and reset it when the toast is hidden.</p><p>\nBecause of this, it is usually best to ensure that the parent container has a fixed height and prevents scrolling by setting the \n<code>overflow: hidden;</code>\n style. Since the position is based off of the parent&#39;s height, the toast may be mispositioned if you allow the parent to scroll.\n</p><p>\nYou can, however, have a scrollable element inside of the container; just make sure the container itself does not scroll.\n</p><hljs lang=\"html\"><div layout-fill id=\"toast-container\"><md-content>I can have lots of content and scroll!\n</md-content></div></hljs></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><div \nng-controller=\"MyController\"><md-button ng-click=\"openToast()\">Open a Toast!</md-button></div></hljs><hljs lang=\"js\">\nvar app = angular.module(&#39;app&#39;, [&#39;ngMaterial&#39;]); app.controller(&#39;MyController&#39;, function($scope, $mdToast) { $scope.openToast = function($event) { $mdToast.show($mdToast.simple().textContent(&#39;Hello!&#39;)); // Could also do $mdToast.showSimple(&#39;Hello&#39;); }; });\n</hljs></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"showSimple\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdToast.showSimple(message);</code></h3><div \nclass=\"service-desc\"><p>Convenience method which builds and shows a simple toast.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* message</b> <span hide show-sm>\n<code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThe message to display inside the toast</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns\n</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise\n</code></td><td class=\"description\"><p>A promise that can be resolved with <code>$mdToast.hide()</code>\n or rejected with <code>$mdToast.cancel()</code>.</p></td></tr></tbody></table></div></li><li id=\"simple\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdToast.simple();</code></h3><div \nclass=\"service-desc\"><p>Builds a preconfigured toast.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>a <code>$mdToastPreset</code>\n with the following chainable configuration methods.</p><p><em><strong>Note:</strong>\n These configuration methods are provided in addition to the methods provided by the <code>build()</code> and <code>\nshow()</code> methods below.</em></p><table class=\"md-api-table methods\"><thead><tr><th>Method</th><th>Description</th>\n</tr></thead><tbody><tr><td><code>.textContent(string)</code></td><td>Sets the toast content to the specified string\n</td></tr><tr><td><code>.action(string)</code></td><td>Adds an action button.<br>\nIf clicked, the promise (returned from <code>show()</code>) will resolve with the value <code>&#39;ok&#39;</code>\n; otherwise, it is resolved with <code>true</code> after a <code>hideDelay</code> timeout</td></tr><tr><td><code>\n.highlightAction(boolean)</code></td><td>Whether or not the action button will have an additional highlight class.<br>\nBy default the <code>accent</code> color will be applied to the action button.</td></tr><tr><td><code>\n.highlightClass(string)</code></td><td>If set, the given class will be applied to the highlighted action button.<br>\nThis allows you to specify the highlight color easily. Highlight classes are <code>md-primary</code>, <code>md-warn\n</code> and <code>md-accent</code></td></tr><tr><td><code>.capsule(boolean)</code></td><td>Whether or not to add the \n<code>md-capsule</code> class to the toast to provide rounded corners</td></tr><tr><td><code>.theme(string)</code></td>\n<td>Sets the theme on the toast to the requested theme. Default is <code>$mdThemingProvider</code>&#39;s default.</td>\n</tr><tr><td><code>.toastClass(string)</code></td><td>Sets a class on the toast element</td></tr></tbody></table></td>\n</tr></tbody></table></div></li><li id=\"updateTextContent\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdToast.updateTextContent();</code></h3><div class=\"service-desc\"><p>\nUpdates the content of an existing toast. Useful for updating things like counts, etc.</p></div><div \nclass=\"method-param-table\"></div></li><li id=\"build\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdToast.build();</code></h3><div class=\"service-desc\"><p>Creates a custom <code>\n$mdToastPreset</code> that you can configure.</p></div><div class=\"method-param-table\"><table class=\"md-api-table\">\n<thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-obj\">obj</code></td><td class=\"description\"><p>a <code>$mdToastPreset</code>\n with the chainable configuration methods for shows&#39; options (see below).</p></td></tr></tbody></table></div></li>\n<li id=\"show\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdToast.show(optionsOrPreset);\n</code></h3><div class=\"service-desc\"><p>Shows the toast.</p></div><div class=\"method-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* optionsOrPreset</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>Either provide an <code>\n$mdToastPreset</code> returned from <code>simple()</code> and <code>build()</code>\n, or an options object with the following properties:</p><ul><li><code>templateUrl</code> - <code>{string=}</code>\n: The url of an html template file that will be used as the content of the toast. Restrictions: the template must have an outer \n<code>md-toast</code> element.</li><li><code>template</code> - <code>{string=}</code>\n: Same as templateUrl, except this is an actual template string.</li><li><code>autoWrap</code> - <code>{boolean=}\n</code>: Whether or not to automatically wrap the template content with a <code>\n&lt;div class=&quot;md-toast-content&quot;&gt;</code>\n if one is not provided. Defaults to true. Can be disabled if you provide a custom toast directive.</li><li><code>scope\n</code> - <code>{object=}</code>\n: the scope to link the template / controller to. If none is specified, it will create a new child scope. This scope will be destroyed when the toast is removed unless \n<code>preserveScope</code> is set to true.</li><li><code>preserveScope</code> - <code>{boolean=}</code>\n: whether to preserve the scope when the element is removed. Default is false</li><li><code>hideDelay</code> - <code>\n{number=}</code>\n: How many milliseconds the toast should stay active before automatically closing. Set to 0 or false to have the toast stay open until closed manually. Default: 3000.\n</li><li><code>position</code> - <code>{string=}</code>: Sets the position of the toast.<br>\nAvailable: any combination of <code>&#39;bottom&#39;</code>, <code>&#39;left&#39;</code>, <code>&#39;top&#39;</code>, \n<code>&#39;right&#39;</code>, <code>&#39;end&#39;</code> and <code>&#39;start&#39;</code>. The properties <code>\n&#39;end&#39;</code> and <code>&#39;start&#39;</code> are dynamic and can be used for RTL support.<br>\nDefault combination: <code>&#39;bottom left&#39;</code>.</li><li><code>toastClass</code> - <code>{string=}</code>\n: A class to set on the toast element.</li><li><code>controller</code> - <code>{string=}</code>\n: The controller to associate with this toast. The controller will be injected the local <code>$mdToast.hide( )</code>\n, which is a function used to hide the toast.</li><li><code>locals</code> - <code>{string=}</code>\n: An object containing key/value pairs. The keys will be used as names of values to inject into the controller. For example, \n<code>locals: {three: 3}</code> would inject <code>three</code> into the controller with the value of 3.</li><li><code>\nbindToController</code> - <code>bool</code>: bind the locals to the controller, instead of passing them in.</li><li>\n<code>resolve</code> - <code>{object=}</code>\n: Similar to locals, except it takes promises as values and the toast will not open until the promises resolve.</li>\n<li><code>controllerAs</code> - <code>{string=}</code>: An alias to assign the controller to on the scope.</li><li>\n<code>parent</code> - <code>{element=}</code>\n: The element to append the toast to. Defaults to appending to the root element of the application.</li></ul></td></tr>\n</tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td>\n<code class=\"api-type label type-hint type-hint-promise\">promise</code></td><td class=\"description\"><p>\nA promise that can be resolved with <code>$mdToast.hide()</code> or rejected with <code>$mdToast.cancel()</code>. \n<code>$mdToast.hide()</code>\n will resolve either with a Boolean value == &#39;true&#39; or the value passed as an argument to <code>$mdToast.hide()\n</code>. And <code>$mdToast.cancel()</code> will resolve the promise with a Boolean value == &#39;false&#39;</p></td>\n</tr></tbody></table></div></li><li id=\"hide\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdToast.hide([response]);</code></h3><div class=\"service-desc\"><p>\nHide an existing toast and resolve the promise returned from <code>$mdToast.show()</code>.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">response <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>\nAn argument for the resolved promise.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns\n</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise\n</code></td><td class=\"description\"><p>\na promise that is called when the existing element is removed from the DOM. The promise is resolved with either a Boolean value == &#39;true&#39; or the value passed as the argument to \n<code>.hide()</code>.</p></td></tr></tbody></table></div></li><li id=\"cancel\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdToast.cancel([response]);</code></h3><div class=\"service-desc\"><p><code>DEPRECATED\n</code>\n - The promise returned from opening a toast is used only to notify about the closing of the toast. As such, there isn&#39;t any reason to also allow that promise to be rejected, since it&#39;s not clear what the difference between resolve and reject would be.\n</p><p>Hide the existing toast and reject the promise returned from <code>$mdToast.show()</code>.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">response <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">*</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">*</code></td><td class=\"description\"><p>\nAn argument for the rejected promise.</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns\n</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-promise\">promise\n</code></td><td class=\"description\"><p>\na promise that is called when the existing element is removed from the DOM The promise is resolved with a Boolean value == &#39;false&#39;.\n</p></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.virtualRepeat/directive/mdVirtualRepeat.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>md-virtual-repeat</code>\n specifies an element to repeat using virtual scrolling.</p><p>\nVirtual repeat is a limited substitute for ng-repeat that renders only enough dom nodes to fill the container and recycling them as the user scrolls. Arrays, but not objects are supported for iteration. Track by, as alias, and (key, value) syntax are not supported.\n</p><blockquote><p><b>Note:</b> Please also review the <a ng-href=\"api/directive/mdVirtualRepeatContainer\">\nVirtualRepeatContainer</a> documentation for more information.</p></blockquote></div><div><section class=\"api-section\">\n<h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-virtual-repeat-container><div md-virtual-repeat=\"i in items\">\nHello {{i}}!</div></md-virtual-repeat-container><md-virtual-repeat-container md-orient-horizontal><div \nmd-virtual-repeat=\"i in items\" md-item-size=\"20\">Hello {{i}}!</div></md-virtual-repeat-container></hljs></section><div \nclass=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-item-size <span hide show-sm><code class=\"api-type label type-hint type-hint-number\">\nnumber</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number\n</code></td><td class=\"description\"><p>\nThe height or width of the repeated elements (which must be identical for each element). Optional. Will attempt to read the size from the dom if missing, but still assumes that all repeated nodes have same height or width.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-extra-name <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nEvaluates to an additional name to which the current iterated item can be assigned on the repeated scope (needed for use in \n<code>md-autocomplete</code>).</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-on-demand \n<span hide show-sm><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td \nclass=\"description\"><p>\nWhen present, treats the md-virtual-repeat argument as an object that can fetch rows rather than an array.</p><p>\n<strong>NOTE:</strong> This object must implement the following interface with two (2) methods:</p><ul><li><code>\ngetItemAtIndex: function(index) [object]</code>\n The item at that index or null if it is not yet loaded (it should start downloading the item in that case).</li><li>\n<code>getLength: function() [number]</code>\n The data length to which the repeater container should be sized. Ideally, when the count is known, this method should return it. Otherwise, return a higher number than the currently loaded items to produce an infinite-scroll behavior.\n</li></ul></td></tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.virtualRepeat/directive/mdVirtualRepeatContainer.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>md-virtual-repeat-container</code>\n provides the scroll container for md-virtual-repeat.</p><p>\nVirtualRepeat is a limited substitute for ng-repeat that renders only enough DOM nodes to fill the container and recycling them as the user scrolls.\n</p><p>\nOnce an element is not visible anymore, the VirtualRepeat recycles it and will reuse it for another visible item by replacing the previous dataset with the new one.\n</p><h3 id=\"common-issues\">Common Issues</h3><blockquote><p>\nWhen having one-time bindings inside of the view template, the VirtualRepeat will not properly update the bindings for new items, since the view will be recycled.\n</p></blockquote><h3 id=\"notes\">Notes</h3><blockquote><p>The VirtualRepeat is a similar implementation to the Android \n<a href=\"https://developer.android.com/reference/android/support/v7/widget/RecyclerView.html\">RecyclerView</a></p>\n</blockquote><blockquote><p>Please also review the <a ng-href=\"api/directive/mdVirtualRepeat\">VirtualRepeat</a>\n documentation for more information.</p></blockquote></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2>\n<hljs lang=\"html\"><md-virtual-repeat-container md-top-index=\"topIndex\"><div md-virtual-repeat=\"i in items\" \nmd-item-size=\"20\">Hello {{i}}!</div></md-virtual-repeat-container></hljs></section><div class=\"api-param-section\"><h2>\nAttributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-top-index <span \nhide show-sm><code class=\"api-type label type-hint type-hint-number\">number</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number</code></td><td \nclass=\"description\"><p>\nBinds the index of the item that is at the top of the scroll container to $scope. It can both read and set the scroll position.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-orient-horizontal <span hide show-sm><code\n class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhether the container should scroll horizontally (defaults to orientation and scrolling vertically).</p></td></tr><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-auto-shrink <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhen present, the container will shrink to fit the number of items when that number is less than its original size.</p>\n</td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-auto-shrink-min <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-number\">number</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-number\">number</code></td><td class=\"description\"><p>\nMinimum number of items that md-auto-shrink will shrink to (default: 0).</p></td></tr></tbody></table></div></div>\n</div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.tooltip/directive/mdTooltip.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nTooltips are used to describe elements that are interactive and primarily graphical (not textual).</p><p>Place a <code>\n&lt;md-tooltip&gt;</code> as a child of the element it describes.</p><p>\nA tooltip will activate when the user focuses, hovers over, or touches the parent.</p></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"html\"><md-button class=\"md-fab md-accent\" aria-label=\"Play\">\n<md-tooltip>Play Music</md-tooltip><md-icon icon=\"assets/angular-material-assets/img/icons/ic_play_arrow_24px.svg\">\n</md-icon></md-button></hljs></section><div class=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\">\n<table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">md-visible <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-expression\">expression</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-expression\">expression</code></td><td class=\"description\"><p>\nBoolean bound to whether the tooltip is currently visible.</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">md-delay <span hide show-sm><code class=\"api-type label type-hint type-hint-number\">number\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-number\">number\n</code></td><td class=\"description\"><p>\nHow many milliseconds to wait to show the tooltip after the user focuses, hovers, or touches the parent. Defaults to 0ms on non-touch devices and 75ms on touch.\n</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">md-autohide <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nIf present or provided with a boolean value, the tooltip will hide on mouse leave, regardless of focus</p></td></tr><tr\n class=\"api-params-item\"><td style=\"white-space: nowrap\">md-direction <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nWhich direction would you like the tooltip to go? Supports left, right, top, and bottom. Defaults to bottom.</p></td>\n</tr></tbody></table></div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core/service/$mdButtonInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nProvides ripple effects for md-button. See $mdInkRipple service for all possible configuration options.</p></div><div>\n<section class=\"api-section\"><div class=\"api-param-section\"><h2>Arguments</h2><div class=\"api-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">scope <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>\nScope within the current context</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">element <span\n hide show-sm><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td \nclass=\"description\"><p>The element the ripple effect should be applied to</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">options <span hide show-sm><code class=\"api-type label type-hint type-hint-object\">object\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object\n</code></td><td class=\"description\"><p>(Optional) Configuration options to override the default ripple configuration\n</p></td></tr></tbody></table></div></div><section class=\"api-section\"></section></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core/service/$mdCheckboxInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nProvides ripple effects for md-checkbox. See $mdInkRipple service for all possible configuration options.</p></div>\n<div><section class=\"api-section\"><div class=\"api-param-section\"><h2>Arguments</h2><div class=\"api-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">scope <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>\nScope within the current context</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">element <span\n hide show-sm><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td \nclass=\"description\"><p>The element the ripple effect should be applied to</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">options <span hide show-sm><code class=\"api-type label type-hint type-hint-object\">object\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object\n</code></td><td class=\"description\"><p>(Optional) Configuration options to override the defaultripple configuration</p>\n</td></tr></tbody></table></div></div><section class=\"api-section\"></section></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core/service/$mdListInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nProvides ripple effects for md-list. See $mdInkRipple service for all possible configuration options.</p></div><div>\n<section class=\"api-section\"><div class=\"api-param-section\"><h2>Arguments</h2><div class=\"api-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">scope <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>\nScope within the current context</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">element <span\n hide show-sm><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td \nclass=\"description\"><p>The element the ripple effect should be applied to</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">options <span hide show-sm><code class=\"api-type label type-hint type-hint-object\">object\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object\n</code></td><td class=\"description\"><p>(Optional) Configuration options to override the defaultripple configuration</p>\n</td></tr></tbody></table></div></div><section class=\"api-section\"></section></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core/service/$mdMedia.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>$mdMedia</code>\n is used to evaluate whether a given media query is true or false given the current device&#39;s screen / window size. The media query will be re-evaluated on resize, allowing you to register a watch.\n</p><p><code>$mdMedia</code> also has pre-programmed support for media queries that match the layout breakpoints:</p>\n<table class=\"md-api-table\"><thead><tr><th>Breakpoint</th><th>mediaQuery</th></tr></thead><tbody><tr><td>xs</td><td>\n(max-width: 599px)</td></tr><tr><td>gt-xs</td><td>(min-width: 600px)</td></tr><tr><td>sm</td><td>\n(min-width: 600px) and (max-width: 959px)</td></tr><tr><td>gt-sm</td><td>(min-width: 960px)</td></tr><tr><td>md</td>\n<td>(min-width: 960px) and (max-width: 1279px)</td></tr><tr><td>gt-md</td><td>(min-width: 1280px)</td></tr><tr><td>lg\n</td><td>(min-width: 1280px) and (max-width: 1919px)</td></tr><tr><td>gt-lg</td><td>(min-width: 1920px)</td></tr><tr>\n<td>xl</td><td>(min-width: 1920px)</td></tr><tr><td>landscape</td><td>landscape</td></tr><tr><td>portrait</td><td>\nportrait</td></tr><tr><td>print</td><td>print</td></tr></tbody></table><p>See Material Design&#39;s <a \nhref=\"https://material.google.com/layout/responsive-ui.html\">Layout - Adaptive UI</a> for more details.</p><p><a \nhref=\"https://www.google.com/design/spec/layout/adaptive-ui.html\"><img \nsrc=\"https://material-design.storage.googleapis.com/publish/material_v_4/material_ext_publish/0B8olV15J7abPSGFxemFiQVRtb1k/layout_adaptive_breakpoints_01.png\" \nwidth=\"100%\" height=\"100%\"></a></p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">\napp.controller(&#39;MyController&#39;, function($mdMedia, $scope) { $scope.$watch(function() { return $mdMedia(&#39;lg&#39;); }, function(big) { $scope.bigScreen = big; }); $scope.screenIsSmall = $mdMedia(&#39;sm&#39;); $scope.customQuery = $mdMedia(&#39;(min-width: 1234px)&#39;); $scope.anotherCustom = $mdMedia(&#39;max-width: 300px&#39;); });\n</hljs></section><section class=\"api-section\"><section class=\"api-section\"></section><div class=\"api-param-table\">\n<table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\na boolean representing whether or not the given media query is true or false.</p></td></tr></tbody></table></div>\n</section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core/service/$mdTabInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nProvides ripple effects for md-tabs. See $mdInkRipple service for all possible configuration options.</p></div><div>\n<section class=\"api-section\"><div class=\"api-param-section\"><h2>Arguments</h2><div class=\"api-param-table\"><table \nclass=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr \nclass=\"api-params-item\"><td style=\"white-space: nowrap\">scope <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>\nScope within the current context</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">element <span\n hide show-sm><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td \nclass=\"description\"><p>The element the ripple effect should be applied to</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">options <span hide show-sm><code class=\"api-type label type-hint type-hint-object\">object\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object\n</code></td><td class=\"description\"><p>(Optional) Configuration options to override the defaultripple configuration</p>\n</td></tr></tbody></table></div></div><section class=\"api-section\"></section></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.components.whiteframe/directive/mdWhiteframe.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The md-whiteframe directive allows you to apply an elevation shadow to an element.\n</p><p>The attribute values needs to be a number between 1 and 24 or -1. When set to -1 no style is applied.</p><h3 \nid=\"notes\">Notes</h3><ul><li>If there is no value specified it defaults to 4dp.</li><li>\nIf the value is not valid it defaults to 4dp.</li></ul></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage\n</h2><hljs lang=\"html\"><div md-whiteframe=\"3\"><span>Elevation of 3dp</span></div></hljs><hljs lang=\"html\"><div \nmd-whiteframe=\"-1\"><span>No elevation shadow applied</span></div></hljs><hljs lang=\"html\"><div ng-init=\"elevation = 5\" \nmd-whiteframe=\"{{elevation}}\"><span>Elevation of 5dp with an interpolated value</span></div></hljs></section></div>\n</div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.aria/service/$mdAriaProvider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>Modify options of the <code>$mdAria</code>\n service, which will be used by most of the Angular Material components.</p><p>You are able to disable <code>$mdAria\n</code> warnings, by using the following markup.</p><hljs lang=\"js\">\napp.config(function($mdAriaProvider) { // Globally disables all ARIA warnings. $mdAriaProvider.disableWarnings(); });\n</hljs></div><div><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"disableWarnings\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdAriaProvider.disableWarnings();</code></h3><div \nclass=\"service-desc\"><p>Disables all ARIA warnings generated by Angular Material.</p></div><div \nclass=\"method-param-table\"></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.gestures/service/$mdGestureProvider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nIn some scenarios on Mobile devices (without jQuery), the click events should NOT be hijacked. <code>$mdGestureProvider\n</code> is used to configure the Gesture module to ignore or skip click hijacking on mobile devices.</p><hljs \nlang=\"js\">\napp.config(function($mdGestureProvider) { // For mobile devices without jQuery loaded, do not // intercept click events during the capture phase. $mdGestureProvider.skipClickHijack(); });\n</hljs></div><div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.meta/service/$$mdMeta.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>A provider and a service that simplifies meta tags access</p><p>\nNote: This is intended only for use with dynamic meta tags such as browser color and title. Tags that are only processed when the page is rendered (such as \n<code>charset</code>, and <code>http-equiv</code>) will not work since <code>$$mdMeta</code>\n adds the tags after the page has already been loaded.</p><pre><code class=\"lang-js\">\napp.config(function($$mdMetaProvider) {\n  var removeMeta = $$mdMetaProvider.setMeta(&#39;meta-name&#39;, &#39;content&#39;);\n  var metaValue  = $$mdMetaProvider.getMeta(&#39;meta-name&#39;); // -&gt; &#39;content&#39;\n\n  removeMeta();\n});\n\napp.controller(&#39;myController&#39;, function($$mdMeta) {\n  var removeMeta = $$mdMeta.setMeta(&#39;meta-name&#39;, &#39;content&#39;);\n  var metaValue  = $$mdMeta.getMeta(&#39;meta-name&#39;); // -&gt; &#39;content&#39;\n\n  removeMeta();\n});\n\n</code></pre></div><div><section class=\"api-section\"><section class=\"api-section\"></section><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody>\n<tr><td><code class=\"api-type label type-hint type-hint-object\">$$mdMeta.$service</code></td><td class=\"description\">\n</td></tr></tbody></table></div></section><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li \nid=\"setMeta\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$$mdMeta.setMeta(name, content);\n</code></h3><div class=\"service-desc\"><p>\nCreates meta element with the &#39;name&#39; and &#39;content&#39; attributes, if the meta tag is already created than we replace the &#39;content&#39; value\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* name</b> <span \nhide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>meta tag &#39;name&#39; attribute value</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* content</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nmeta tag &#39;content&#39; attribute value</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>\nReturns</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-function\">\nfunction</code></td><td class=\"description\"><p>remove function</p></td></tr></tbody></table></div></li><li \nid=\"getMeta\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">$$mdMeta.getMeta(name);</code>\n</h3><div class=\"service-desc\"><p>Gets the &#39;content&#39; attribute value of the wanted meta element</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* name</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nmeta tag &#39;name&#39; attribute value</p></td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns\n</th><th>Description</th></tr></thead><tbody><tr><td><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>content attribute value</p></td></tr></tbody></table></div></li></ul></section>\n</div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.theming/service/$mdThemingProvider.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>Provider to configure the <code>$mdTheming</code> service.</p><h3 \nid=\"default-theme\">Default Theme</h3><p>The <code>$mdThemingProvider</code>\n uses by default the following theme configuration:</p><ul><li>Primary Palette: <code>Primary</code></li><li>\nAccent Palette: <code>Pink</code></li><li>Warn Palette: <code>Deep-Orange</code></li><li>Background Palette: <code>Grey\n</code></li></ul><p>If you don&#39;t want to use the <code>md-theme</code>\n directive on the elements itself, you may want to overwrite the default theme.<br>\nThis can be done by using the following markup.</p><hljs lang=\"js\">\nmyAppModule.config(function($mdThemingProvider) { $mdThemingProvider .theme(&#39;default&#39;) .primaryPalette(&#39;blue&#39;) .accentPalette(&#39;teal&#39;) .warnPalette(&#39;red&#39;) .backgroundPalette(&#39;grey&#39;); });\n</hljs><h3 id=\"dynamic-themes\">Dynamic Themes</h3><p>By default, if you change a theme at runtime, the <code>$mdTheming\n</code> service will not detect those changes.<br>\nIf you have an application, which changes its theme on runtime, you have to enable theme watching.</p><hljs lang=\"js\">\nmyAppModule.config(function($mdThemingProvider) { // Enable theme watching. $mdThemingProvider.alwaysWatchTheme(true); });\n</hljs><h3 id=\"custom-theme-styles\">Custom Theme Styles</h3><p>\nSometimes you may want to use your own theme styles for some custom components.<br>\nYou are able to register your own styles by using the following markup.</p><hljs lang=\"js\">\nmyAppModule.config(function($mdThemingProvider) { // Register our custom stylesheet into the theming provider. $mdThemingProvider.registerStyles(STYLESHEET); });\n</hljs><p>The <code>registerStyles</code>\n method only accepts strings as value, so you&#39;re actually not able to load an external stylesheet file into the \n<code>$mdThemingProvider</code>.</p><p>\nIf it&#39;s necessary to load an external stylesheet, we suggest using a bundler, which supports including raw content, like \n<a href=\"https://github.com/webpack/raw-loader\">raw-loader</a> for <code>webpack</code>.</p><hljs lang=\"js\">\nmyAppModule.config(function($mdThemingProvider) { // Register your custom stylesheet into the theming provider. $mdThemingProvider.registerStyles(require(&#39;../styles/my-component.theme.css&#39;)); });\n</hljs><h3 id=\"browser-color\">Browser color</h3><p>Enables browser header coloring for more info please visit: <a \nhref=\"https://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color\">\nhttps://developers.google.com/web/fundamentals/design-and-ui/browser-customization/theme-color</a></p><p>\nOptions parameter:<br><code>theme</code> - A defined theme via <code>$mdThemeProvider</code>\n to use the palettes from. Default is <code>default</code> theme.<br><code>palette</code>\n - Can be any one of the basic material design palettes, extended defined palettes and &#39;primary&#39;, &#39;accent&#39;, &#39;background&#39; and &#39;warn&#39;. Default is \n<code>primary</code>.<br><code>hue</code> - The hue from the selected palette. Default is <code>800</code><br></p><hljs\n lang=\"js\">\nmyAppModule.config(function($mdThemingProvider) { // Enable browser color $mdThemingProvider.enableBrowserColor({ theme: &#39;myTheme&#39;, // Default is &#39;default&#39; palette: &#39;accent&#39;, // Default is &#39;primary&#39;, any basic material palette and extended palettes are available hue: &#39;200&#39; // Default is &#39;800&#39; }); });\n</hljs></div><div><section class=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"registerStyles\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdThemingProvider.registerStyles(styles);</code>\n</h3><div class=\"service-desc\"></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* styles</b> <span hide show-sm><code class=\"api-type label type-hint type-hint-string\">\nstring</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string\n</code></td><td class=\"description\"><p>The styles to be appended to Angular Material&#39;s built in theme css.</p></td>\n</tr></tbody></table></div></li><li id=\"setNonce\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdThemingProvider.setNonce(nonceValue);</code></h3><div class=\"service-desc\"></div><div\n class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* nonceValue</b> <span hide show-sm>\n<code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code></td><td class=\"description\"><p>\nThe nonce to be added as an attribute to the theme style tags. Setting a value allows the use of CSP policy without using the unsafe-inline directive.\n</p></td></tr></tbody></table></div></li><li id=\"setDefaultTheme\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdThemingProvider.setDefaultTheme(themeName);</code></h3><div class=\"service-desc\">\n</div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* themeName</b> \n<span hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code></td><td \nclass=\"description\"><p>Default theme name to be applied to elements. Default value is <code>default</code>.</p></td>\n</tr></tbody></table></div></li><li id=\"alwaysWatchTheme\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdThemingProvider.alwaysWatchTheme(watch);</code></h3><div class=\"service-desc\"></div>\n<div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description\n</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* watch</b> <span hide show-sm>\n<code class=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\">\n<code class=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>\nWhether or not to always watch themes for changes and re-apply classes when they change. Default is <code>false</code>\n. Enabling can reduce performance.</p></td></tr></tbody></table></div></li><li id=\"enableBrowserColor\"><h3 \nclass=\"method-function-syntax\"><code class=\"method-function-syntax\">$mdThemingProvider.enableBrowserColor([options]);\n</code></h3><div class=\"service-desc\"></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">options <span hide show-sm><code class=\"api-type label type-hint type-hint-object\">Object\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">Object\n</code></td><td class=\"description\"><p>Options object for the browser color<br><code>theme</code>\n - A defined theme via <code>$mdThemeProvider</code> to use the palettes from. Default is <code>default</code> theme.\n<br><code>palette</code>\n - Can be any one of the basic material design palettes, extended defined palettes and &#39;primary&#39;, &#39;accent&#39;, &#39;background&#39; and &#39;warn&#39;. Default is \n<code>primary</code>.<br><code>hue</code> - The hue from the selected palette. Default is <code>800</code><br></p></td>\n</tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody>\n<tr><td><code class=\"api-type label type-hint type-hint-function\">Function</code></td><td class=\"description\"><p>\nremove function of the browser color</p></td></tr></tbody></table></div></li></ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.ripple/directive/mdInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>The <code>md-ink-ripple</code>\n directive allows you to specify the ripple color or id a ripple is allowed.</p></div><div><section \nclass=\"api-section\"><h2 id=\"Usage\">Usage</h2><h3 id=\"string-values\">String values</h3><hljs lang=\"html\"><any \nmd-ink-ripple=\"#FF0000\">Ripples in red</any><any md-ink-ripple=\"false\">Not rippling</any></hljs><h3 \nid=\"interpolated-values\">Interpolated values</h3><hljs lang=\"html\"><any md-ink-ripple=\"{{ randomColor() }}\">\nRipples with the return value of &#39;randomColor&#39; function</any><any md-ink-ripple=\"{{ canRipple() }}\">\nRipples if &#39;canRipple&#39; function return value is not &#39;false&#39; or &#39;0&#39;</any></hljs></section><div \nclass=\"api-param-section\"><h2>Attributes</h2><div class=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>\nParameter</th><th>Type</th><th>Description</th></tr></thead><tbody><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\"><b>* md-ink-ripple</b> <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-boolean\">boolean</code></td><td class=\"description\"><p>A color string <code>\n#FF0000</code> or boolean (<code>false</code> or <code>0</code>) for preventing ripple</p></td></tr></tbody></table>\n</div></div></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.ripple/service/$mdInkRipple.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>$mdInkRipple</code> is a service for adding ripples to any element</p></div>\n<div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><hljs lang=\"js\">\napp.factory(&#39;$myElementInkRipple&#39;, function($mdInkRipple) { return { attach: function (scope, element, options) { return $mdInkRipple.attach(scope, element, angular.extend({ center: false, dimBackground: true }, options)); } }; }); app.controller(&#39;myController&#39;, function ($scope, $element, $myElementInkRipple) { $scope.onClick = function (ev) { $myElementInkRipple.attach($scope, angular.element(ev.target), { center: true }); } });\n</hljs><h3 id=\"disabling-ripples-globally\">Disabling ripples globally</h3><p>\nIf you want to disable ink ripples globally, for all components, you can call the <code>disableInkRipple</code>\n method in your app&#39;s config.</p><p><hljs lang=\"js\">\napp.config(function ($mdInkRippleProvider) { $mdInkRippleProvider.disableInkRipple(); });</hljs></p></section><section \nclass=\"api-section\"><h2>Methods</h2><br><ul class=\"methods\"><li id=\"attach\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">$mdInkRipple.attach([scope], [element], [options]);</code></h3><div \nclass=\"service-desc\"><p>Attaching given scope, element and options to inkRipple controller</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">scope <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-object\">object</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-object\">object</code></td><td class=\"description\"><p>\nScope within the current context</p></td></tr><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">element <span\n hide show-sm><code class=\"api-type label type-hint type-hint-object\">object</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object</code></td><td \nclass=\"description\"><p>The element the ripple effect should be applied to</p></td></tr><tr class=\"api-params-item\"><td \nstyle=\"white-space: nowrap\">options <span hide show-sm><code class=\"api-type label type-hint type-hint-object\">object\n</code></span></td><td style=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-object\">object\n</code></td><td class=\"description\"><p>(Optional) Configuration options to override the defaultRipple configuration</p>\n<ul><li><code>center</code> - Whether the ripple should start from the center of the container element</li><li><code>\ndimBackground</code> - Whether the background should be dimmed with the ripple color</li><li><code>colorElement</code>\n - The element the ripple should take its color from, defined by css property <code>color</code></li><li><code>\nfitRipple</code> - Whether the ripple should fill the element</li></ul></td></tr></tbody></table></div></li><li \nid=\"disableInkRipple\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\n$mdInkRipple.disableInkRipple();</code></h3><div class=\"service-desc\"><p>\nA config-time method that, when called, disables ripples globally.</p></div><div class=\"method-param-table\"></div></li>\n</ul></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/material.core.util/directive/mdAutofocus.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p><code>[md-autofocus]</code>\n provides an optional way to identify the focused element when a <code>$mdDialog</code>, <code>$mdBottomSheet</code>, \n<code>$mdMenu</code> or <code>$mdSidenav</code> opens or upon page load for input-like elements.</p><p>\nWhen one of these opens, it will find the first nested element with the <code>[md-autofocus]</code>\n attribute directive and optional expression. An expression may be specified as the directive value to enable conditional activation of the autofocus.\n</p></div><div><section class=\"api-section\"><h2 id=\"Usage\">Usage</h2><h3 id=\"dialog\">Dialog</h3><hljs lang=\"html\">\n<md-dialog><form><md-input-container><label for=\"testInput\">Label</label><input id=\"testInput\" type=\"text\" \nmd-autofocus></md-input-container></form></md-dialog></hljs><h3 id=\"bottomsheet\">Bottomsheet</h3><hljs lang=\"html\">\n<md-bottom-sheet class=\"md-list md-has-header\"><md-subheader>Comment Actions</md-subheader><md-list><md-list-item \nng-repeat=\"item in items\"><md-button md-autofocus=\"$index == 2\"><md-icon md-svg-src=\"{{item.icon}}\"></md-icon><span \nclass=\"md-inline-list-icon-label\">{{ item.name }}</span></md-button></md-list-item></md-list></md-bottom-sheet></hljs>\n<h3 id=\"autocomplete\">Autocomplete</h3><hljs lang=\"html\"><md-autocomplete md-autofocus md-selected-item=\"selectedItem\" \nmd-search-text=\"searchText\" md-items=\"item in getMatches(searchText)\" md-item-text=\"item.display\"><span \nmd-highlight-text=\"searchText\">{{item.display}}</span></md-autocomplete></hljs><h3 id=\"sidenav\">Sidenav</h3><hljs \nlang=\"html\"><div layout=\"row\" ng-controller=\"MyController\"><md-sidenav md-component-id=\"left\" class=\"md-sidenav-left\">\nLeft Nav!</md-sidenav><md-content>Center Content<md-button ng-click=\"openLeftMenu()\">Open Left Menu</md-button>\n</md-content><md-sidenav md-component-id=\"right\" md-is-locked-open=\"$mdMedia(\'min-width: 333px\')\" \nclass=\"md-sidenav-right\"><form><md-input-container><label for=\"testInput\">Test input</label><input id=\"testInput\" \ntype=\"text\" ng-model=\"data\" md-autofocus></md-input-container></form></md-sidenav></div></hljs></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/src/service/$mdTheming.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>Service that makes an element apply theming related classes to itself.</p><pre><code\n class=\"lang-js\">\napp.directive(&#39;myFancyDirective&#39;, function($mdTheming) {\n  return {\n    restrict: &#39;e&#39;,\n    link: function(scope, el, attrs) {\n      $mdTheming(el);\n    }\n  };\n});\n\n</code></pre></div><div><section class=\"api-section\"><div class=\"api-param-section\"><h2>Arguments</h2><div \nclass=\"api-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th></tr>\n</thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\">element <span hide show-sm><code \nclass=\"api-type label type-hint type-hint-el\">el</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-el\">el</code></td><td class=\"description\"><p>to apply theming to</p></td>\n</tr></tbody></table></div></div><section class=\"api-section\"></section></section></div></div>");
$templateCache.put("app/main/components/material-docs/partials/api/src/object/MdPanelAnimation.html","<div class=\"doc-content\"><header class=\"api-profile-header\"><h2 class=\"md-display-1\">\n{{currentDoc.name}} API Documentation</h2></header><div layout=\"row\" class=\"api-options-bar with-icon\"></div><div \nclass=\"api-profile-description\"><p>\nAnimation configuration object. To use, create an MdPanelAnimation with the desired properties, then pass the object as part of $mdPanel creation.\n</p><p>Example:</p><p>\nvar panelAnimation = new MdPanelAnimation() .openFrom(myButtonEl) .closeTo(&#39;.my-button&#39;) .withAnimation($mdPanel.animation.SCALE);\n</p><p>$mdPanel.create({ animation: panelAnimation });</p></div><div><section class=\"api-section\"><h2>Methods</h2><br>\n<ul class=\"methods\"><li id=\"openFrom\"><h3 class=\"method-function-syntax\"><code class=\"method-function-syntax\">\nMdPanelAnimation.openFrom();</code></h3><div class=\"service-desc\"><p>Specifies where to start the open animation. \n<code>openFrom</code>\n accepts a click event object, query selector, DOM element, or a Rect object that is used to determine the bounds. When passed a click event, the location of the click will be used as the position to start the animation.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* </b><span hide \nshow-sm><code class=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-element\">Element</code><code \nclass=\"api-type label type-hint type-hint-event\">Event</code><code class=\"api-type label type-hint type-hint-object\">\n{top: number, left: number}</code></span></td><td style=\"white-space: nowrap\"><code \nclass=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-element\">Element</code><code \nclass=\"api-type label type-hint type-hint-event\">Event</code><code class=\"api-type label type-hint type-hint-object\">\n{top: number, left: number}</code></td><td class=\"description\"></td></tr></tbody></table><table class=\"md-api-table\">\n<thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody><tr><td><code \nclass=\"api-type label type-hint type-hint-mdpanelanimation\">MdPanelAnimation</code></td><td class=\"description\"></td>\n</tr></tbody></table></div></li><li id=\"closeTo\"><h3 class=\"method-function-syntax\"><code \nclass=\"method-function-syntax\">MdPanelAnimation.closeTo();</code></h3><div class=\"service-desc\"><p>\nSpecifies where to animate the panel close. <code>closeTo</code>\n accepts a query selector, DOM element, or a Rect object that is used to determine the bounds.</p></div><div \nclass=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>Description</th>\n</tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* </b><span hide show-sm><code \nclass=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-element\">Element</code><code \nclass=\"api-type label type-hint type-hint-object\">{top: number, left: number}</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-element\">Element</code><code \nclass=\"api-type label type-hint type-hint-object\">{top: number, left: number}</code></td><td class=\"description\"></td>\n</tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead><tbody>\n<tr><td><code class=\"api-type label type-hint type-hint-mdpanelanimation\">MdPanelAnimation</code></td><td \nclass=\"description\"></td></tr></tbody></table></div></li><li id=\"withAnimation\"><h3 class=\"method-function-syntax\">\n<code class=\"method-function-syntax\">MdPanelAnimation.withAnimation(cssClass);</code></h3><div class=\"service-desc\"><p>\nSpecifies the animation class.</p><p>\nThere are several default animations that can be used: ($mdPanel.animation) SLIDE: The panel slides in and out from the specified elements. It will not fade in or out. SCALE: The panel scales in and out. Slide and fade are included in this animation. FADE: The panel fades in and out.\n</p><p>\nCustom classes will by default fade in and out unless &quot;transition: opacity 1ms&quot; is added to the to custom class.\n</p></div><div class=\"method-param-table\"><table class=\"md-api-table\"><thead><tr><th>Parameter</th><th>Type</th><th>\nDescription</th></tr></thead><tbody><tr class=\"api-params-item\"><td style=\"white-space: nowrap\"><b>* cssClass</b> <span\n hide show-sm><code class=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-object\">{open: string, close: string}</code></span></td><td \nstyle=\"white-space: nowrap\"><code class=\"api-type label type-hint type-hint-string\">string</code><code \nclass=\"api-type label type-hint type-hint-object\">{open: string, close: string}</code></td><td class=\"description\">\n</td></tr></tbody></table><table class=\"md-api-table\"><thead><tr><th>Returns</th><th>Description</th></tr></thead>\n<tbody><tr><td><code class=\"api-type label type-hint type-hint-mdpanelanimation\">MdPanelAnimation</code></td><td \nclass=\"description\"></td></tr></tbody></table></div></li></ul></section></div></div>");}]);